import Ie, { useRef as Ch, useContext as Eh, useState as qe, useMemo as Q, useEffect as on, useDebugValue as t6, createElement as ZE, useCallback as Ne, createContext as QE, cloneElement as eD } from "react";
import { Scope as nD } from "react-shadow-scope";
import { QueryClient as tD, QueryClientProvider as sD, useMutation as aD, useQuery as Dh } from "@tanstack/react-query";
import { chainRegistryChainToKeplr as rm } from "@chain-registry/keplr";
import { WalletType as ze, GrazProvider as oD, getWallet as od, useAccount as z8, useActiveWalletType as rD, useDisconnect as iD, connect as $m } from "graz";
import { chains as Bh, assets as Fh } from "@initia/initia-registry";
import { defineChain as q8, http as xe, createClient as cD, custom as dD, walletActions as mD, isAddress as hD, createPublicClient as pD } from "viem";
import { createConfig as lD, WagmiProvider as gD, useAccount as im, useConnectors as S8, useConnect as uD } from "wagmi";
import T8, { useModal as _D } from "@ebay/nice-modal-react";
import * as Nd from "@radix-ui/react-dialog";
import { ErrorBoundary as qd } from "react-error-boundary";
import { atom as me, useAtom as Ae, useSetAtom as pe, useAtomValue as re } from "jotai";
import { SkipClient as yD } from "@skip-go/client";
import { atomWithQuery as ic, atomWithMutation as bD } from "jotai-tanstack-query";
import { BackpackWalletAdapter as vD } from "@solana/wallet-adapter-backpack";
import { CoinbaseWalletAdapter as fD } from "@solana/wallet-adapter-coinbase";
import { LedgerWalletAdapter as wD } from "@solana/wallet-adapter-ledger";
import { PhantomWalletAdapter as xD } from "@solana/wallet-adapter-phantom";
import { SolflareWalletAdapter as kD } from "@solana/wallet-adapter-solflare";
import { TrustWalletAdapter as AD } from "@solana/wallet-adapter-trust";
import cd from "pluralize";
import { atomEffect as R8 } from "jotai-effect";
import jD from "rc-virtual-list";
import { PublicKey as s6 } from "@solana/web3.js";
import { createPenumbraClient as CD } from "@penumbra-zone/client";
import { ViewService as ED } from "@penumbra-zone/protobuf";
import { matchSorter as a6 } from "match-sorter";
function DD(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var O8 = { exports: {} }, Re = O8.exports = {}, En, Dn;
function Jm() {
  throw new Error("setTimeout has not been defined");
}
function Zm() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? En = setTimeout : En = Jm;
  } catch {
    En = Jm;
  }
  try {
    typeof clearTimeout == "function" ? Dn = clearTimeout : Dn = Zm;
  } catch {
    Dn = Zm;
  }
})();
function M8(e) {
  if (En === setTimeout)
    return setTimeout(e, 0);
  if ((En === Jm || !En) && setTimeout)
    return En = setTimeout, setTimeout(e, 0);
  try {
    return En(e, 0);
  } catch {
    try {
      return En.call(null, e, 0);
    } catch {
      return En.call(this, e, 0);
    }
  }
}
function BD(e) {
  if (Dn === clearTimeout)
    return clearTimeout(e);
  if ((Dn === Zm || !Dn) && clearTimeout)
    return Dn = clearTimeout, clearTimeout(e);
  try {
    return Dn(e);
  } catch {
    try {
      return Dn.call(null, e);
    } catch {
      return Dn.call(this, e);
    }
  }
}
var oo = [], fc = !1, Ro, Sd = -1;
function FD() {
  !fc || !Ro || (fc = !1, Ro.length ? oo = Ro.concat(oo) : Sd = -1, oo.length && I8());
}
function I8() {
  if (!fc) {
    var e = M8(FD);
    fc = !0;
    for (var n = oo.length; n; ) {
      for (Ro = oo, oo = []; ++Sd < n; )
        Ro && Ro[Sd].run();
      Sd = -1, n = oo.length;
    }
    Ro = null, fc = !1, BD(e);
  }
}
Re.nextTick = function(e) {
  var n = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var t = 1; t < arguments.length; t++)
      n[t - 1] = arguments[t];
  oo.push(new N8(e, n)), oo.length === 1 && !fc && M8(I8);
};
function N8(e, n) {
  this.fun = e, this.array = n;
}
N8.prototype.run = function() {
  this.fun.apply(null, this.array);
};
Re.title = "browser";
Re.browser = !0;
Re.env = {};
Re.argv = [];
Re.version = "";
Re.versions = {};
function po() {
}
Re.on = po;
Re.addListener = po;
Re.once = po;
Re.off = po;
Re.removeListener = po;
Re.removeAllListeners = po;
Re.emit = po;
Re.prependListener = po;
Re.prependOnceListener = po;
Re.listeners = function(e) {
  return [];
};
Re.binding = function(e) {
  throw new Error("process.binding is not supported");
};
Re.cwd = function() {
  return "/";
};
Re.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
Re.umask = function() {
  return 0;
};
var $D = O8.exports;
const ie = /* @__PURE__ */ DD($D);
var r = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function zD(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Qm = { exports: {} }, Kc = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var o6;
function qD() {
  if (o6) return Kc;
  o6 = 1;
  var e = Ie, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(d, m, h) {
    var p, _ = {}, y = null, w = null;
    h !== void 0 && (y = "" + h), m.key !== void 0 && (y = "" + m.key), m.ref !== void 0 && (w = m.ref);
    for (p in m) s.call(m, p) && !o.hasOwnProperty(p) && (_[p] = m[p]);
    if (d && d.defaultProps) for (p in m = d.defaultProps, m) _[p] === void 0 && (_[p] = m[p]);
    return { $$typeof: n, type: d, key: y, ref: w, props: _, _owner: a.current };
  }
  return Kc.Fragment = t, Kc.jsx = i, Kc.jsxs = i, Kc;
}
var Xc = {}, r6;
function SD() {
  return r6 || (r6 = 1, ie.env.NODE_ENV !== "production" && function() {
    var e = Ie, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), d = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), w = Symbol.for("react.offscreen"), q = Symbol.iterator, k = "@@iterator";
    function B(j) {
      if (j === null || typeof j != "object")
        return null;
      var L = q && j[q] || j[k];
      return typeof L == "function" ? L : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(j) {
      {
        for (var L = arguments.length, K = new Array(L > 1 ? L - 1 : 0), se = 1; se < L; se++)
          K[se - 1] = arguments[se];
        b("error", j, K);
      }
    }
    function b(j, L, K) {
      {
        var se = v.ReactDebugCurrentFrame, _e = se.getStackAddendum();
        _e !== "" && (L += "%s", K = K.concat([_e]));
        var we = K.map(function(ge) {
          return String(ge);
        });
        we.unshift("Warning: " + L), Function.prototype.apply.call(console[j], console, we);
      }
    }
    var O = !1, D = !1, M = !1, N = !1, l = !1, u;
    u = Symbol.for("react.module.reference");
    function f(j) {
      return !!(typeof j == "string" || typeof j == "function" || j === s || j === o || l || j === a || j === h || j === p || N || j === w || O || D || M || typeof j == "object" && j !== null && (j.$$typeof === y || j.$$typeof === _ || j.$$typeof === i || j.$$typeof === d || j.$$typeof === m || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      j.$$typeof === u || j.getModuleId !== void 0));
    }
    function S(j, L, K) {
      var se = j.displayName;
      if (se)
        return se;
      var _e = L.displayName || L.name || "";
      return _e !== "" ? K + "(" + _e + ")" : K;
    }
    function x(j) {
      return j.displayName || "Context";
    }
    function C(j) {
      if (j == null)
        return null;
      if (typeof j.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof j == "function")
        return j.displayName || j.name || null;
      if (typeof j == "string")
        return j;
      switch (j) {
        case s:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case h:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof j == "object")
        switch (j.$$typeof) {
          case d:
            var L = j;
            return x(L) + ".Consumer";
          case i:
            var K = j;
            return x(K._context) + ".Provider";
          case m:
            return S(j, j.render, "ForwardRef");
          case _:
            var se = j.displayName || null;
            return se !== null ? se : C(j.type) || "Memo";
          case y: {
            var _e = j, we = _e._payload, ge = _e._init;
            try {
              return C(ge(we));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, A = 0, E, T, R, P, V, X, Z;
    function ue() {
    }
    ue.__reactDisabledLog = !0;
    function ve() {
      {
        if (A === 0) {
          E = console.log, T = console.info, R = console.warn, P = console.error, V = console.group, X = console.groupCollapsed, Z = console.groupEnd;
          var j = {
            configurable: !0,
            enumerable: !0,
            value: ue,
            writable: !0
          };
          Object.defineProperties(console, {
            info: j,
            log: j,
            warn: j,
            error: j,
            group: j,
            groupCollapsed: j,
            groupEnd: j
          });
        }
        A++;
      }
    }
    function G() {
      {
        if (A--, A === 0) {
          var j = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, j, {
              value: E
            }),
            info: F({}, j, {
              value: T
            }),
            warn: F({}, j, {
              value: R
            }),
            error: F({}, j, {
              value: P
            }),
            group: F({}, j, {
              value: V
            }),
            groupCollapsed: F({}, j, {
              value: X
            }),
            groupEnd: F({}, j, {
              value: Z
            })
          });
        }
        A < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ne = v.ReactCurrentDispatcher, le;
    function $e(j, L, K) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (_e) {
            var se = _e.stack.trim().match(/\n( *(at )?)/);
            le = se && se[1] || "";
          }
        return `
` + le + j;
      }
    }
    var Ce = !1, cn;
    {
      var Ve = typeof WeakMap == "function" ? WeakMap : Map;
      cn = new Ve();
    }
    function Ge(j, L) {
      if (!j || Ce)
        return "";
      {
        var K = cn.get(j);
        if (K !== void 0)
          return K;
      }
      var se;
      Ce = !0;
      var _e = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var we;
      we = ne.current, ne.current = null, ve();
      try {
        if (L) {
          var ge = function() {
            throw Error();
          };
          if (Object.defineProperty(ge.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ge, []);
            } catch (nn) {
              se = nn;
            }
            Reflect.construct(j, [], ge);
          } else {
            try {
              ge.call();
            } catch (nn) {
              se = nn;
            }
            j.call(ge.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (nn) {
            se = nn;
          }
          j();
        }
      } catch (nn) {
        if (nn && se && typeof nn.stack == "string") {
          for (var he = nn.stack.split(`
`), Ze = se.stack.split(`
`), Se = he.length - 1, Oe = Ze.length - 1; Se >= 1 && Oe >= 0 && he[Se] !== Ze[Oe]; )
            Oe--;
          for (; Se >= 1 && Oe >= 0; Se--, Oe--)
            if (he[Se] !== Ze[Oe]) {
              if (Se !== 1 || Oe !== 1)
                do
                  if (Se--, Oe--, Oe < 0 || he[Se] !== Ze[Oe]) {
                    var dn = `
` + he[Se].replace(" at new ", " at ");
                    return j.displayName && dn.includes("<anonymous>") && (dn = dn.replace("<anonymous>", j.displayName)), typeof j == "function" && cn.set(j, dn), dn;
                  }
                while (Se >= 1 && Oe >= 0);
              break;
            }
        }
      } finally {
        Ce = !1, ne.current = we, G(), Error.prepareStackTrace = _e;
      }
      var lc = j ? j.displayName || j.name : "", zo = lc ? $e(lc) : "";
      return typeof j == "function" && cn.set(j, zo), zo;
    }
    function en(j, L, K) {
      return Ge(j, !1);
    }
    function Ke(j) {
      var L = j.prototype;
      return !!(L && L.isReactComponent);
    }
    function fe(j, L, K) {
      if (j == null)
        return "";
      if (typeof j == "function")
        return Ge(j, Ke(j));
      if (typeof j == "string")
        return $e(j);
      switch (j) {
        case h:
          return $e("Suspense");
        case p:
          return $e("SuspenseList");
      }
      if (typeof j == "object")
        switch (j.$$typeof) {
          case m:
            return en(j.render);
          case _:
            return fe(j.type, L, K);
          case y: {
            var se = j, _e = se._payload, we = se._init;
            try {
              return fe(we(_e), L, K);
            } catch {
            }
          }
        }
      return "";
    }
    var Vc = Object.prototype.hasOwnProperty, H5 = {}, L5 = v.ReactDebugCurrentFrame;
    function vd(j) {
      if (j) {
        var L = j._owner, K = fe(j.type, j._source, L ? L.type : null);
        L5.setExtraStackFrame(K);
      } else
        L5.setExtraStackFrame(null);
    }
    function FE(j, L, K, se, _e) {
      {
        var we = Function.call.bind(Vc);
        for (var ge in j)
          if (we(j, ge)) {
            var he = void 0;
            try {
              if (typeof j[ge] != "function") {
                var Ze = Error((se || "React class") + ": " + K + " type `" + ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof j[ge] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ze.name = "Invariant Violation", Ze;
              }
              he = j[ge](L, ge, se, K, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Se) {
              he = Se;
            }
            he && !(he instanceof Error) && (vd(_e), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", se || "React class", K, ge, typeof he), vd(null)), he instanceof Error && !(he.message in H5) && (H5[he.message] = !0, vd(_e), g("Failed %s type: %s", K, he.message), vd(null));
          }
      }
    }
    var $E = Array.isArray;
    function jm(j) {
      return $E(j);
    }
    function zE(j) {
      {
        var L = typeof Symbol == "function" && Symbol.toStringTag, K = L && j[Symbol.toStringTag] || j.constructor.name || "Object";
        return K;
      }
    }
    function qE(j) {
      try {
        return W5(j), !1;
      } catch {
        return !0;
      }
    }
    function W5(j) {
      return "" + j;
    }
    function V5(j) {
      if (qE(j))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", zE(j)), W5(j);
    }
    var Gc = v.ReactCurrentOwner, SE = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, G5, K5, Cm;
    Cm = {};
    function TE(j) {
      if (Vc.call(j, "ref")) {
        var L = Object.getOwnPropertyDescriptor(j, "ref").get;
        if (L && L.isReactWarning)
          return !1;
      }
      return j.ref !== void 0;
    }
    function RE(j) {
      if (Vc.call(j, "key")) {
        var L = Object.getOwnPropertyDescriptor(j, "key").get;
        if (L && L.isReactWarning)
          return !1;
      }
      return j.key !== void 0;
    }
    function OE(j, L) {
      if (typeof j.ref == "string" && Gc.current && L && Gc.current.stateNode !== L) {
        var K = C(Gc.current.type);
        Cm[K] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', C(Gc.current.type), j.ref), Cm[K] = !0);
      }
    }
    function ME(j, L) {
      {
        var K = function() {
          G5 || (G5 = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
        };
        K.isReactWarning = !0, Object.defineProperty(j, "key", {
          get: K,
          configurable: !0
        });
      }
    }
    function IE(j, L) {
      {
        var K = function() {
          K5 || (K5 = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
        };
        K.isReactWarning = !0, Object.defineProperty(j, "ref", {
          get: K,
          configurable: !0
        });
      }
    }
    var NE = function(j, L, K, se, _e, we, ge) {
      var he = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: j,
        key: L,
        ref: K,
        props: ge,
        // Record the component responsible for creating this element.
        _owner: we
      };
      return he._store = {}, Object.defineProperty(he._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(he, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: se
      }), Object.defineProperty(he, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _e
      }), Object.freeze && (Object.freeze(he.props), Object.freeze(he)), he;
    };
    function PE(j, L, K, se, _e) {
      {
        var we, ge = {}, he = null, Ze = null;
        K !== void 0 && (V5(K), he = "" + K), RE(L) && (V5(L.key), he = "" + L.key), TE(L) && (Ze = L.ref, OE(L, _e));
        for (we in L)
          Vc.call(L, we) && !SE.hasOwnProperty(we) && (ge[we] = L[we]);
        if (j && j.defaultProps) {
          var Se = j.defaultProps;
          for (we in Se)
            ge[we] === void 0 && (ge[we] = Se[we]);
        }
        if (he || Ze) {
          var Oe = typeof j == "function" ? j.displayName || j.name || "Unknown" : j;
          he && ME(ge, Oe), Ze && IE(ge, Oe);
        }
        return NE(j, he, Ze, _e, se, Gc.current, ge);
      }
    }
    var Em = v.ReactCurrentOwner, X5 = v.ReactDebugCurrentFrame;
    function pc(j) {
      if (j) {
        var L = j._owner, K = fe(j.type, j._source, L ? L.type : null);
        X5.setExtraStackFrame(K);
      } else
        X5.setExtraStackFrame(null);
    }
    var Dm;
    Dm = !1;
    function Bm(j) {
      return typeof j == "object" && j !== null && j.$$typeof === n;
    }
    function Y5() {
      {
        if (Em.current) {
          var j = C(Em.current.type);
          if (j)
            return `

Check the render method of \`` + j + "`.";
        }
        return "";
      }
    }
    function UE(j) {
      return "";
    }
    var J5 = {};
    function HE(j) {
      {
        var L = Y5();
        if (!L) {
          var K = typeof j == "string" ? j : j.displayName || j.name;
          K && (L = `

Check the top-level render call using <` + K + ">.");
        }
        return L;
      }
    }
    function Z5(j, L) {
      {
        if (!j._store || j._store.validated || j.key != null)
          return;
        j._store.validated = !0;
        var K = HE(L);
        if (J5[K])
          return;
        J5[K] = !0;
        var se = "";
        j && j._owner && j._owner !== Em.current && (se = " It was passed a child from " + C(j._owner.type) + "."), pc(j), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', K, se), pc(null);
      }
    }
    function Q5(j, L) {
      {
        if (typeof j != "object")
          return;
        if (jm(j))
          for (var K = 0; K < j.length; K++) {
            var se = j[K];
            Bm(se) && Z5(se, L);
          }
        else if (Bm(j))
          j._store && (j._store.validated = !0);
        else if (j) {
          var _e = B(j);
          if (typeof _e == "function" && _e !== j.entries)
            for (var we = _e.call(j), ge; !(ge = we.next()).done; )
              Bm(ge.value) && Z5(ge.value, L);
        }
      }
    }
    function LE(j) {
      {
        var L = j.type;
        if (L == null || typeof L == "string")
          return;
        var K;
        if (typeof L == "function")
          K = L.propTypes;
        else if (typeof L == "object" && (L.$$typeof === m || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        L.$$typeof === _))
          K = L.propTypes;
        else
          return;
        if (K) {
          var se = C(L);
          FE(K, j.props, "prop", se, j);
        } else if (L.PropTypes !== void 0 && !Dm) {
          Dm = !0;
          var _e = C(L);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _e || "Unknown");
        }
        typeof L.getDefaultProps == "function" && !L.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function WE(j) {
      {
        for (var L = Object.keys(j.props), K = 0; K < L.length; K++) {
          var se = L[K];
          if (se !== "children" && se !== "key") {
            pc(j), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", se), pc(null);
            break;
          }
        }
        j.ref !== null && (pc(j), g("Invalid attribute `ref` supplied to `React.Fragment`."), pc(null));
      }
    }
    var e6 = {};
    function n6(j, L, K, se, _e, we) {
      {
        var ge = f(j);
        if (!ge) {
          var he = "";
          (j === void 0 || typeof j == "object" && j !== null && Object.keys(j).length === 0) && (he += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ze = UE();
          Ze ? he += Ze : he += Y5();
          var Se;
          j === null ? Se = "null" : jm(j) ? Se = "array" : j !== void 0 && j.$$typeof === n ? (Se = "<" + (C(j.type) || "Unknown") + " />", he = " Did you accidentally export a JSX literal instead of a component?") : Se = typeof j, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Se, he);
        }
        var Oe = PE(j, L, K, _e, we);
        if (Oe == null)
          return Oe;
        if (ge) {
          var dn = L.children;
          if (dn !== void 0)
            if (se)
              if (jm(dn)) {
                for (var lc = 0; lc < dn.length; lc++)
                  Q5(dn[lc], j);
                Object.freeze && Object.freeze(dn);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Q5(dn, j);
        }
        if (Vc.call(L, "key")) {
          var zo = C(j), nn = Object.keys(L).filter(function(JE) {
            return JE !== "key";
          }), Fm = nn.length > 0 ? "{key: someKey, " + nn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!e6[zo + Fm]) {
            var YE = nn.length > 0 ? "{" + nn.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Fm, zo, YE, zo), e6[zo + Fm] = !0;
          }
        }
        return j === s ? WE(Oe) : LE(Oe), Oe;
      }
    }
    function VE(j, L, K) {
      return n6(j, L, K, !0);
    }
    function GE(j, L, K) {
      return n6(j, L, K, !1);
    }
    var KE = GE, XE = VE;
    Xc.Fragment = s, Xc.jsx = KE, Xc.jsxs = XE;
  }()), Xc;
}
ie.env.NODE_ENV === "production" ? Qm.exports = qD() : Qm.exports = SD();
var c = Qm.exports, Le = function() {
  return Le = Object.assign || function(n) {
    for (var t, s = 1, a = arguments.length; s < a; s++) {
      t = arguments[s];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, Le.apply(this, arguments);
};
function Co(e, n, t) {
  if (t || arguments.length === 2) for (var s = 0, a = n.length, o; s < a; s++)
    (o || !(s in n)) && (o || (o = Array.prototype.slice.call(n, 0, s)), o[s] = n[s]);
  return e.concat(o || Array.prototype.slice.call(n));
}
function TD(e) {
  var n = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return n[t] === void 0 && (n[t] = e(t)), n[t];
  };
}
var RD = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, P8 = /* @__PURE__ */ TD(
  function(e) {
    return RD.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), OD = function(n, t, s, a) {
  var o = s ? s.call(a, n, t) : void 0;
  if (o !== void 0)
    return !!o;
  if (n === t)
    return !0;
  if (typeof n != "object" || !n || typeof t != "object" || !t)
    return !1;
  var i = Object.keys(n), d = Object.keys(t);
  if (i.length !== d.length)
    return !1;
  for (var m = Object.prototype.hasOwnProperty.bind(t), h = 0; h < i.length; h++) {
    var p = i[h];
    if (!m(p))
      return !1;
    var _ = n[p], y = t[p];
    if (o = s ? s.call(a, _, y, p) : void 0, o === !1 || o === void 0 && _ !== y)
      return !1;
  }
  return !0;
};
const MD = /* @__PURE__ */ zD(OD);
var ke = "-ms-", dd = "-moz-", ye = "-webkit-", U8 = "comm", cm = "rule", $h = "decl", ID = "@import", H8 = "@keyframes", ND = "@layer", L8 = Math.abs, zh = String.fromCharCode, eh = Object.assign;
function PD(e, n) {
  return He(e, 0) ^ 45 ? (((n << 2 ^ He(e, 0)) << 2 ^ He(e, 1)) << 2 ^ He(e, 2)) << 2 ^ He(e, 3) : 0;
}
function W8(e) {
  return e.trim();
}
function ao(e, n) {
  return (e = n.exec(e)) ? e[0] : e;
}
function de(e, n, t) {
  return e.replace(n, t);
}
function Td(e, n, t) {
  return e.indexOf(n, t);
}
function He(e, n) {
  return e.charCodeAt(n) | 0;
}
function kc(e, n, t) {
  return e.slice(n, t);
}
function Bn(e) {
  return e.length;
}
function V8(e) {
  return e.length;
}
function rd(e, n) {
  return n.push(e), e;
}
function UD(e, n) {
  return e.map(n).join("");
}
function i6(e, n) {
  return e.filter(function(t) {
    return !ao(t, n);
  });
}
var dm = 1, Ac = 1, G8 = 0, bn = 0, Me = 0, Mc = "";
function mm(e, n, t, s, a, o, i, d) {
  return { value: e, root: n, parent: t, type: s, props: a, children: o, line: dm, column: Ac, length: i, return: "", siblings: d };
}
function vo(e, n) {
  return eh(mm("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, n);
}
function gc(e) {
  for (; e.root; )
    e = vo(e.root, { children: [e] });
  rd(e, e.siblings);
}
function HD() {
  return Me;
}
function LD() {
  return Me = bn > 0 ? He(Mc, --bn) : 0, Ac--, Me === 10 && (Ac = 1, dm--), Me;
}
function kn() {
  return Me = bn < G8 ? He(Mc, bn++) : 0, Ac++, Me === 10 && (Ac = 1, dm++), Me;
}
function Mo() {
  return He(Mc, bn);
}
function Rd() {
  return bn;
}
function hm(e, n) {
  return kc(Mc, e, n);
}
function nh(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function WD(e) {
  return dm = Ac = 1, G8 = Bn(Mc = e), bn = 0, [];
}
function VD(e) {
  return Mc = "", e;
}
function zm(e) {
  return W8(hm(bn - 1, th(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function GD(e) {
  for (; (Me = Mo()) && Me < 33; )
    kn();
  return nh(e) > 2 || nh(Me) > 3 ? "" : " ";
}
function KD(e, n) {
  for (; --n && kn() && !(Me < 48 || Me > 102 || Me > 57 && Me < 65 || Me > 70 && Me < 97); )
    ;
  return hm(e, Rd() + (n < 6 && Mo() == 32 && kn() == 32));
}
function th(e) {
  for (; kn(); )
    switch (Me) {
      case e:
        return bn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && th(Me);
        break;
      case 40:
        e === 41 && th(e);
        break;
      case 92:
        kn();
        break;
    }
  return bn;
}
function XD(e, n) {
  for (; kn() && e + Me !== 57; )
    if (e + Me === 84 && Mo() === 47)
      break;
  return "/*" + hm(n, bn - 1) + "*" + zh(e === 47 ? e : kn());
}
function YD(e) {
  for (; !nh(Mo()); )
    kn();
  return hm(e, bn);
}
function JD(e) {
  return VD(Od("", null, null, null, [""], e = WD(e), 0, [0], e));
}
function Od(e, n, t, s, a, o, i, d, m) {
  for (var h = 0, p = 0, _ = i, y = 0, w = 0, q = 0, k = 1, B = 1, v = 1, g = 0, b = "", O = a, D = o, M = s, N = b; B; )
    switch (q = g, g = kn()) {
      case 40:
        if (q != 108 && He(N, _ - 1) == 58) {
          Td(N += de(zm(g), "&", "&\f"), "&\f", L8(h ? d[h - 1] : 0)) != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        N += zm(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        N += GD(q);
        break;
      case 92:
        N += KD(Rd() - 1, 7);
        continue;
      case 47:
        switch (Mo()) {
          case 42:
          case 47:
            rd(ZD(XD(kn(), Rd()), n, t, m), m);
            break;
          default:
            N += "/";
        }
        break;
      case 123 * k:
        d[h++] = Bn(N) * v;
      case 125 * k:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            B = 0;
          case 59 + p:
            v == -1 && (N = de(N, /\f/g, "")), w > 0 && Bn(N) - _ && rd(w > 32 ? d6(N + ";", s, t, _ - 1, m) : d6(de(N, " ", "") + ";", s, t, _ - 2, m), m);
            break;
          case 59:
            N += ";";
          default:
            if (rd(M = c6(N, n, t, h, p, a, d, b, O = [], D = [], _, o), o), g === 123)
              if (p === 0)
                Od(N, n, M, M, O, o, _, d, D);
              else
                switch (y === 99 && He(N, 3) === 110 ? 100 : y) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Od(e, M, M, s && rd(c6(e, M, M, 0, 0, a, d, b, a, O = [], _, D), D), a, D, _, d, s ? O : D);
                    break;
                  default:
                    Od(N, M, M, M, [""], D, 0, d, D);
                }
        }
        h = p = w = 0, k = v = 1, b = N = "", _ = i;
        break;
      case 58:
        _ = 1 + Bn(N), w = q;
      default:
        if (k < 1) {
          if (g == 123)
            --k;
          else if (g == 125 && k++ == 0 && LD() == 125)
            continue;
        }
        switch (N += zh(g), g * k) {
          case 38:
            v = p > 0 ? 1 : (N += "\f", -1);
            break;
          case 44:
            d[h++] = (Bn(N) - 1) * v, v = 1;
            break;
          case 64:
            Mo() === 45 && (N += zm(kn())), y = Mo(), p = _ = Bn(b = N += YD(Rd())), g++;
            break;
          case 45:
            q === 45 && Bn(N) == 2 && (k = 0);
        }
    }
  return o;
}
function c6(e, n, t, s, a, o, i, d, m, h, p, _) {
  for (var y = a - 1, w = a === 0 ? o : [""], q = V8(w), k = 0, B = 0, v = 0; k < s; ++k)
    for (var g = 0, b = kc(e, y + 1, y = L8(B = i[k])), O = e; g < q; ++g)
      (O = W8(B > 0 ? w[g] + " " + b : de(b, /&\f/g, w[g]))) && (m[v++] = O);
  return mm(e, n, t, a === 0 ? cm : d, m, h, p, _);
}
function ZD(e, n, t, s) {
  return mm(e, n, t, U8, zh(HD()), kc(e, 2, -2), 0, s);
}
function d6(e, n, t, s, a) {
  return mm(e, n, t, $h, kc(e, 0, s), kc(e, s + 1, -1), s, a);
}
function K8(e, n, t) {
  switch (PD(e, n)) {
    case 5103:
      return ye + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return ye + e + e;
    case 4789:
      return dd + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return ye + e + dd + e + ke + e + e;
    case 5936:
      switch (He(e, n + 11)) {
        case 114:
          return ye + e + ke + de(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return ye + e + ke + de(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return ye + e + ke + de(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    case 6828:
    case 4268:
    case 2903:
      return ye + e + ke + e + e;
    case 6165:
      return ye + e + ke + "flex-" + e + e;
    case 5187:
      return ye + e + de(e, /(\w+).+(:[^]+)/, ye + "box-$1$2" + ke + "flex-$1$2") + e;
    case 5443:
      return ye + e + ke + "flex-item-" + de(e, /flex-|-self/g, "") + (ao(e, /flex-|baseline/) ? "" : ke + "grid-row-" + de(e, /flex-|-self/g, "")) + e;
    case 4675:
      return ye + e + ke + "flex-line-pack" + de(e, /align-content|flex-|-self/g, "") + e;
    case 5548:
      return ye + e + ke + de(e, "shrink", "negative") + e;
    case 5292:
      return ye + e + ke + de(e, "basis", "preferred-size") + e;
    case 6060:
      return ye + "box-" + de(e, "-grow", "") + ye + e + ke + de(e, "grow", "positive") + e;
    case 4554:
      return ye + de(e, /([^-])(transform)/g, "$1" + ye + "$2") + e;
    case 6187:
      return de(de(de(e, /(zoom-|grab)/, ye + "$1"), /(image-set)/, ye + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return de(e, /(image-set\([^]*)/, ye + "$1$`$1");
    case 4968:
      return de(de(e, /(.+:)(flex-)?(.*)/, ye + "box-pack:$3" + ke + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + ye + e + e;
    case 4200:
      if (!ao(e, /flex-|baseline/)) return ke + "grid-column-align" + kc(e, n) + e;
      break;
    case 2592:
    case 3360:
      return ke + de(e, "template-", "") + e;
    case 4384:
    case 3616:
      return t && t.some(function(s, a) {
        return n = a, ao(s.props, /grid-\w+-end/);
      }) ? ~Td(e + (t = t[n].value), "span", 0) ? e : ke + de(e, "-start", "") + e + ke + "grid-row-span:" + (~Td(t, "span", 0) ? ao(t, /\d+/) : +ao(t, /\d+/) - +ao(e, /\d+/)) + ";" : ke + de(e, "-start", "") + e;
    case 4896:
    case 4128:
      return t && t.some(function(s) {
        return ao(s.props, /grid-\w+-start/);
      }) ? e : ke + de(de(e, "-end", "-span"), "span ", "") + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return de(e, /(.+)-inline(.+)/, ye + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Bn(e) - 1 - n > 6)
        switch (He(e, n + 1)) {
          case 109:
            if (He(e, n + 4) !== 45)
              break;
          case 102:
            return de(e, /(.+:)(.+)-([^]+)/, "$1" + ye + "$2-$3$1" + dd + (He(e, n + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Td(e, "stretch", 0) ? K8(de(e, "stretch", "fill-available"), n, t) + e : e;
        }
      break;
    case 5152:
    case 5920:
      return de(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(s, a, o, i, d, m, h) {
        return ke + a + ":" + o + h + (i ? ke + a + "-span:" + (d ? m : +m - +o) + h : "") + e;
      });
    case 4949:
      if (He(e, n + 6) === 121)
        return de(e, ":", ":" + ye) + e;
      break;
    case 6444:
      switch (He(e, He(e, 14) === 45 ? 18 : 11)) {
        case 120:
          return de(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + ye + (He(e, 14) === 45 ? "inline-" : "") + "box$3$1" + ye + "$2$3$1" + ke + "$2box$3") + e;
        case 100:
          return de(e, ":", ":" + ke) + e;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return de(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function Pd(e, n) {
  for (var t = "", s = 0; s < e.length; s++)
    t += n(e[s], s, e, n) || "";
  return t;
}
function QD(e, n, t, s) {
  switch (e.type) {
    case ND:
      if (e.children.length) break;
    case ID:
    case $h:
      return e.return = e.return || e.value;
    case U8:
      return "";
    case H8:
      return e.return = e.value + "{" + Pd(e.children, s) + "}";
    case cm:
      if (!Bn(e.value = e.props.join(","))) return "";
  }
  return Bn(t = Pd(e.children, s)) ? e.return = e.value + "{" + t + "}" : "";
}
function eB(e) {
  var n = V8(e);
  return function(t, s, a, o) {
    for (var i = "", d = 0; d < n; d++)
      i += e[d](t, s, a, o) || "";
    return i;
  };
}
function nB(e) {
  return function(n) {
    n.root || (n = n.return) && e(n);
  };
}
function tB(e, n, t, s) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case $h:
        e.return = K8(e.value, e.length, t);
        return;
      case H8:
        return Pd([vo(e, { value: de(e.value, "@", "@" + ye) })], s);
      case cm:
        if (e.length)
          return UD(t = e.props, function(a) {
            switch (ao(a, s = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                gc(vo(e, { props: [de(a, /:(read-\w+)/, ":" + dd + "$1")] })), gc(vo(e, { props: [a] })), eh(e, { props: i6(t, s) });
                break;
              case "::placeholder":
                gc(vo(e, { props: [de(a, /:(plac\w+)/, ":" + ye + "input-$1")] })), gc(vo(e, { props: [de(a, /:(plac\w+)/, ":" + dd + "$1")] })), gc(vo(e, { props: [de(a, /:(plac\w+)/, ke + "input-$1")] })), gc(vo(e, { props: [a] })), eh(e, { props: i6(t, s) });
                break;
            }
            return "";
          });
    }
}
var sB = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Io = typeof ie < "u" && ie.env !== void 0 && (ie.env.REACT_APP_SC_ATTR || ie.env.SC_ATTR) || "data-styled", X8 = "active", Y8 = "data-styled-version", pm = "6.1.13", qh = `/*!sc*/
`, Ud = typeof window < "u" && "HTMLElement" in window, aB = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof ie < "u" && ie.env !== void 0 && ie.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && ie.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? ie.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && ie.env.REACT_APP_SC_DISABLE_SPEEDY : typeof ie < "u" && ie.env !== void 0 && ie.env.SC_DISABLE_SPEEDY !== void 0 && ie.env.SC_DISABLE_SPEEDY !== "" ? ie.env.SC_DISABLE_SPEEDY !== "false" && ie.env.SC_DISABLE_SPEEDY : ie.env.NODE_ENV !== "production"), oB = {}, m6 = /invalid hook call/i, fd = /* @__PURE__ */ new Set(), J8 = function(e, n) {
  if (ie.env.NODE_ENV !== "production") {
    var t = n ? ' with the id of "'.concat(n, '"') : "", s = "The component ".concat(e).concat(t, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, a = console.error;
    try {
      var o = !0;
      console.error = function(i) {
        for (var d = [], m = 1; m < arguments.length; m++) d[m - 1] = arguments[m];
        m6.test(i) ? (o = !1, fd.delete(s)) : a.apply(void 0, Co([i], d, !1));
      }, Ch(), o && !fd.has(s) && (console.warn(s), fd.add(s));
    } catch (i) {
      m6.test(i.message) && fd.delete(s);
    } finally {
      console.error = a;
    }
  }
}, lm = Object.freeze([]), jc = Object.freeze({});
function Z8(e, n, t) {
  return t === void 0 && (t = jc), e.theme !== t.theme && e.theme || n || t.theme;
}
var sh = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), rB = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, iB = /(^-|-$)/g;
function h6(e) {
  return e.replace(rB, "-").replace(iB, "");
}
var cB = /(a)(d)/gi, wd = 52, p6 = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function ah(e) {
  var n, t = "";
  for (n = Math.abs(e); n > wd; n = n / wd | 0) t = p6(n % wd) + t;
  return (p6(n % wd) + t).replace(cB, "$1-$2");
}
var qm, Q8 = 5381, To = function(e, n) {
  for (var t = n.length; t; ) e = 33 * e ^ n.charCodeAt(--t);
  return e;
}, e9 = function(e) {
  return To(Q8, e);
};
function Sh(e) {
  return ah(e9(e) >>> 0);
}
function n9(e) {
  return ie.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function Sm(e) {
  return typeof e == "string" && (ie.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var t9 = typeof Symbol == "function" && Symbol.for, s9 = t9 ? Symbol.for("react.memo") : 60115, dB = t9 ? Symbol.for("react.forward_ref") : 60112, mB = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, hB = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, a9 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, pB = ((qm = {})[dB] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, qm[s9] = a9, qm);
function l6(e) {
  return ("type" in (n = e) && n.type.$$typeof) === s9 ? a9 : "$$typeof" in e ? pB[e.$$typeof] : mB;
  var n;
}
var lB = Object.defineProperty, gB = Object.getOwnPropertyNames, g6 = Object.getOwnPropertySymbols, uB = Object.getOwnPropertyDescriptor, _B = Object.getPrototypeOf, u6 = Object.prototype;
function o9(e, n, t) {
  if (typeof n != "string") {
    if (u6) {
      var s = _B(n);
      s && s !== u6 && o9(e, s, t);
    }
    var a = gB(n);
    g6 && (a = a.concat(g6(n)));
    for (var o = l6(e), i = l6(n), d = 0; d < a.length; ++d) {
      var m = a[d];
      if (!(m in hB || t && t[m] || i && m in i || o && m in o)) {
        var h = uB(n, m);
        try {
          lB(e, m, h);
        } catch {
        }
      }
    }
  }
  return e;
}
function No(e) {
  return typeof e == "function";
}
function Th(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function Oo(e, n) {
  return e && n ? "".concat(e, " ").concat(n) : e || n || "";
}
function Hd(e, n) {
  if (e.length === 0) return "";
  for (var t = e[0], s = 1; s < e.length; s++) t += e[s];
  return t;
}
function Cc(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function oh(e, n, t) {
  if (t === void 0 && (t = !1), !t && !Cc(e) && !Array.isArray(e)) return n;
  if (Array.isArray(n)) for (var s = 0; s < n.length; s++) e[s] = oh(e[s], n[s]);
  else if (Cc(n)) for (var s in n) e[s] = oh(e[s], n[s]);
  return e;
}
function Rh(e, n) {
  Object.defineProperty(e, "toString", { value: n });
}
var yB = ie.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function bB() {
  for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
  for (var t = e[0], s = [], a = 1, o = e.length; a < o; a += 1) s.push(e[a]);
  return s.forEach(function(i) {
    t = t.replace(/%[a-z]/, i);
  }), t;
}
function $n(e) {
  for (var n = [], t = 1; t < arguments.length; t++) n[t - 1] = arguments[t];
  return ie.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : "")) : new Error(bB.apply(void 0, Co([yB[e]], n, !1)).trim());
}
var vB = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  return e.prototype.indexOfGroup = function(n) {
    for (var t = 0, s = 0; s < n; s++) t += this.groupSizes[s];
    return t;
  }, e.prototype.insertRules = function(n, t) {
    if (n >= this.groupSizes.length) {
      for (var s = this.groupSizes, a = s.length, o = a; n >= o; ) if ((o <<= 1) < 0) throw $n(16, "".concat(n));
      this.groupSizes = new Uint32Array(o), this.groupSizes.set(s), this.length = o;
      for (var i = a; i < o; i++) this.groupSizes[i] = 0;
    }
    for (var d = this.indexOfGroup(n + 1), m = (i = 0, t.length); i < m; i++) this.tag.insertRule(d, t[i]) && (this.groupSizes[n]++, d++);
  }, e.prototype.clearGroup = function(n) {
    if (n < this.length) {
      var t = this.groupSizes[n], s = this.indexOfGroup(n), a = s + t;
      this.groupSizes[n] = 0;
      for (var o = s; o < a; o++) this.tag.deleteRule(s);
    }
  }, e.prototype.getGroup = function(n) {
    var t = "";
    if (n >= this.length || this.groupSizes[n] === 0) return t;
    for (var s = this.groupSizes[n], a = this.indexOfGroup(n), o = a + s, i = a; i < o; i++) t += "".concat(this.tag.getRule(i)).concat(qh);
    return t;
  }, e;
}(), fB = 1 << 30, Md = /* @__PURE__ */ new Map(), Ld = /* @__PURE__ */ new Map(), Id = 1, xd = function(e) {
  if (Md.has(e)) return Md.get(e);
  for (; Ld.has(Id); ) Id++;
  var n = Id++;
  if (ie.env.NODE_ENV !== "production" && ((0 | n) < 0 || n > fB)) throw $n(16, "".concat(n));
  return Md.set(e, n), Ld.set(n, e), n;
}, wB = function(e, n) {
  Id = n + 1, Md.set(e, n), Ld.set(n, e);
}, xB = "style[".concat(Io, "][").concat(Y8, '="').concat(pm, '"]'), kB = new RegExp("^".concat(Io, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), AB = function(e, n, t) {
  for (var s, a = t.split(","), o = 0, i = a.length; o < i; o++) (s = a[o]) && e.registerName(n, s);
}, jB = function(e, n) {
  for (var t, s = ((t = n.textContent) !== null && t !== void 0 ? t : "").split(qh), a = [], o = 0, i = s.length; o < i; o++) {
    var d = s[o].trim();
    if (d) {
      var m = d.match(kB);
      if (m) {
        var h = 0 | parseInt(m[1], 10), p = m[2];
        h !== 0 && (wB(p, h), AB(e, p, m[3]), e.getTag().insertRules(h, a)), a.length = 0;
      } else a.push(d);
    }
  }
}, _6 = function(e) {
  for (var n = document.querySelectorAll(xB), t = 0, s = n.length; t < s; t++) {
    var a = n[t];
    a && a.getAttribute(Io) !== X8 && (jB(e, a), a.parentNode && a.parentNode.removeChild(a));
  }
};
function CB() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var r9 = function(e) {
  var n = document.head, t = e || n, s = document.createElement("style"), a = function(d) {
    var m = Array.from(d.querySelectorAll("style[".concat(Io, "]")));
    return m[m.length - 1];
  }(t), o = a !== void 0 ? a.nextSibling : null;
  s.setAttribute(Io, X8), s.setAttribute(Y8, pm);
  var i = CB();
  return i && s.setAttribute("nonce", i), t.insertBefore(s, o), s;
}, EB = function() {
  function e(n) {
    this.element = r9(n), this.element.appendChild(document.createTextNode("")), this.sheet = function(t) {
      if (t.sheet) return t.sheet;
      for (var s = document.styleSheets, a = 0, o = s.length; a < o; a++) {
        var i = s[a];
        if (i.ownerNode === t) return i;
      }
      throw $n(17);
    }(this.element), this.length = 0;
  }
  return e.prototype.insertRule = function(n, t) {
    try {
      return this.sheet.insertRule(t, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, e.prototype.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, e.prototype.getRule = function(n) {
    var t = this.sheet.cssRules[n];
    return t && t.cssText ? t.cssText : "";
  }, e;
}(), DB = function() {
  function e(n) {
    this.element = r9(n), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e.prototype.insertRule = function(n, t) {
    if (n <= this.length && n >= 0) {
      var s = document.createTextNode(t);
      return this.element.insertBefore(s, this.nodes[n] || null), this.length++, !0;
    }
    return !1;
  }, e.prototype.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, e.prototype.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), BB = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  return e.prototype.insertRule = function(n, t) {
    return n <= this.length && (this.rules.splice(n, 0, t), this.length++, !0);
  }, e.prototype.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, e.prototype.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), y6 = Ud, FB = { isServer: !Ud, useCSSOMInjection: !aB }, Wd = function() {
  function e(n, t, s) {
    n === void 0 && (n = jc), t === void 0 && (t = {});
    var a = this;
    this.options = Le(Le({}, FB), n), this.gs = t, this.names = new Map(s), this.server = !!n.isServer, !this.server && Ud && y6 && (y6 = !1, _6(this)), Rh(this, function() {
      return function(o) {
        for (var i = o.getTag(), d = i.length, m = "", h = function(_) {
          var y = function(v) {
            return Ld.get(v);
          }(_);
          if (y === void 0) return "continue";
          var w = o.names.get(y), q = i.getGroup(_);
          if (w === void 0 || !w.size || q.length === 0) return "continue";
          var k = "".concat(Io, ".g").concat(_, '[id="').concat(y, '"]'), B = "";
          w !== void 0 && w.forEach(function(v) {
            v.length > 0 && (B += "".concat(v, ","));
          }), m += "".concat(q).concat(k, '{content:"').concat(B, '"}').concat(qh);
        }, p = 0; p < d; p++) h(p);
        return m;
      }(a);
    });
  }
  return e.registerId = function(n) {
    return xd(n);
  }, e.prototype.rehydrate = function() {
    !this.server && Ud && _6(this);
  }, e.prototype.reconstructWithOptions = function(n, t) {
    return t === void 0 && (t = !0), new e(Le(Le({}, this.options), n), this.gs, t && this.names || void 0);
  }, e.prototype.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, e.prototype.getTag = function() {
    return this.tag || (this.tag = (n = function(t) {
      var s = t.useCSSOMInjection, a = t.target;
      return t.isServer ? new BB(a) : s ? new EB(a) : new DB(a);
    }(this.options), new vB(n)));
    var n;
  }, e.prototype.hasNameForId = function(n, t) {
    return this.names.has(n) && this.names.get(n).has(t);
  }, e.prototype.registerName = function(n, t) {
    if (xd(n), this.names.has(n)) this.names.get(n).add(t);
    else {
      var s = /* @__PURE__ */ new Set();
      s.add(t), this.names.set(n, s);
    }
  }, e.prototype.insertRules = function(n, t, s) {
    this.registerName(n, t), this.getTag().insertRules(xd(n), s);
  }, e.prototype.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, e.prototype.clearRules = function(n) {
    this.getTag().clearGroup(xd(n)), this.clearNames(n);
  }, e.prototype.clearTag = function() {
    this.tag = void 0;
  }, e;
}(), $B = /&/g, zB = /^\s*\/\/.*$/gm;
function i9(e, n) {
  return e.map(function(t) {
    return t.type === "rule" && (t.value = "".concat(n, " ").concat(t.value), t.value = t.value.replaceAll(",", ",".concat(n, " ")), t.props = t.props.map(function(s) {
      return "".concat(n, " ").concat(s);
    })), Array.isArray(t.children) && t.type !== "@keyframes" && (t.children = i9(t.children, n)), t;
  });
}
function c9(e) {
  var n, t, s, a = e === void 0 ? jc : e, o = a.options, i = o === void 0 ? jc : o, d = a.plugins, m = d === void 0 ? lm : d, h = function(y, w, q) {
    return q.startsWith(t) && q.endsWith(t) && q.replaceAll(t, "").length > 0 ? ".".concat(n) : y;
  }, p = m.slice();
  p.push(function(y) {
    y.type === cm && y.value.includes("&") && (y.props[0] = y.props[0].replace($B, t).replace(s, h));
  }), i.prefix && p.push(tB), p.push(QD);
  var _ = function(y, w, q, k) {
    w === void 0 && (w = ""), q === void 0 && (q = ""), k === void 0 && (k = "&"), n = k, t = w, s = new RegExp("\\".concat(t, "\\b"), "g");
    var B = y.replace(zB, ""), v = JD(q || w ? "".concat(q, " ").concat(w, " { ").concat(B, " }") : B);
    i.namespace && (v = i9(v, i.namespace));
    var g = [];
    return Pd(v, eB(p.concat(nB(function(b) {
      return g.push(b);
    })))), g;
  };
  return _.hash = m.length ? m.reduce(function(y, w) {
    return w.name || $n(15), To(y, w.name);
  }, Q8).toString() : "", _;
}
var qB = new Wd(), rh = c9(), Oh = Ie.createContext({ shouldForwardProp: void 0, styleSheet: qB, stylis: rh });
Oh.Consumer;
var SB = Ie.createContext(void 0);
function Vd() {
  return Eh(Oh);
}
function TB(e) {
  var n = qe(e.stylisPlugins), t = n[0], s = n[1], a = Vd().styleSheet, o = Q(function() {
    var m = a;
    return e.sheet ? m = e.sheet : e.target && (m = m.reconstructWithOptions({ target: e.target }, !1)), e.disableCSSOMInjection && (m = m.reconstructWithOptions({ useCSSOMInjection: !1 })), m;
  }, [e.disableCSSOMInjection, e.sheet, e.target, a]), i = Q(function() {
    return c9({ options: { namespace: e.namespace, prefix: e.enableVendorPrefixes }, plugins: t });
  }, [e.enableVendorPrefixes, e.namespace, t]);
  on(function() {
    MD(t, e.stylisPlugins) || s(e.stylisPlugins);
  }, [e.stylisPlugins]);
  var d = Q(function() {
    return { shouldForwardProp: e.shouldForwardProp, styleSheet: o, stylis: i };
  }, [e.shouldForwardProp, o, i]);
  return Ie.createElement(Oh.Provider, { value: d }, Ie.createElement(SB.Provider, { value: i }, e.children));
}
var ih = function() {
  function e(n, t) {
    var s = this;
    this.inject = function(a, o) {
      o === void 0 && (o = rh);
      var i = s.name + o.hash;
      a.hasNameForId(s.id, i) || a.insertRules(s.id, i, o(s.rules, i, "@keyframes"));
    }, this.name = n, this.id = "sc-keyframes-".concat(n), this.rules = t, Rh(this, function() {
      throw $n(12, String(s.name));
    });
  }
  return e.prototype.getName = function(n) {
    return n === void 0 && (n = rh), this.name + n.hash;
  }, e;
}(), RB = function(e) {
  return e >= "A" && e <= "Z";
};
function b6(e) {
  for (var n = "", t = 0; t < e.length; t++) {
    var s = e[t];
    if (t === 1 && s === "-" && e[0] === "-") return e;
    RB(s) ? n += "-" + s.toLowerCase() : n += s;
  }
  return n.startsWith("ms-") ? "-" + n : n;
}
var d9 = function(e) {
  return e == null || e === !1 || e === "";
}, m9 = function(e) {
  var n, t, s = [];
  for (var a in e) {
    var o = e[a];
    e.hasOwnProperty(a) && !d9(o) && (Array.isArray(o) && o.isCss || No(o) ? s.push("".concat(b6(a), ":"), o, ";") : Cc(o) ? s.push.apply(s, Co(Co(["".concat(a, " {")], m9(o), !1), ["}"], !1)) : s.push("".concat(b6(a), ": ").concat((n = a, (t = o) == null || typeof t == "boolean" || t === "" ? "" : typeof t != "number" || t === 0 || n in sB || n.startsWith("--") ? String(t).trim() : "".concat(t, "px")), ";")));
  }
  return s;
};
function wo(e, n, t, s) {
  if (d9(e)) return [];
  if (Th(e)) return [".".concat(e.styledComponentId)];
  if (No(e)) {
    if (!No(o = e) || o.prototype && o.prototype.isReactComponent || !n) return [e];
    var a = e(n);
    return ie.env.NODE_ENV === "production" || typeof a != "object" || Array.isArray(a) || a instanceof ih || Cc(a) || a === null || console.error("".concat(n9(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), wo(a, n, t, s);
  }
  var o;
  return e instanceof ih ? t ? (e.inject(t, s), [e.getName(s)]) : [e] : Cc(e) ? m9(e) : Array.isArray(e) ? Array.prototype.concat.apply(lm, e.map(function(i) {
    return wo(i, n, t, s);
  })) : [e.toString()];
}
function h9(e) {
  for (var n = 0; n < e.length; n += 1) {
    var t = e[n];
    if (No(t) && !Th(t)) return !1;
  }
  return !0;
}
var OB = e9(pm), MB = function() {
  function e(n, t, s) {
    this.rules = n, this.staticRulesId = "", this.isStatic = ie.env.NODE_ENV === "production" && (s === void 0 || s.isStatic) && h9(n), this.componentId = t, this.baseHash = To(OB, t), this.baseStyle = s, Wd.registerId(t);
  }
  return e.prototype.generateAndInjectStyles = function(n, t, s) {
    var a = this.baseStyle ? this.baseStyle.generateAndInjectStyles(n, t, s) : "";
    if (this.isStatic && !s.hash) if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) a = Oo(a, this.staticRulesId);
    else {
      var o = Hd(wo(this.rules, n, t, s)), i = ah(To(this.baseHash, o) >>> 0);
      if (!t.hasNameForId(this.componentId, i)) {
        var d = s(o, ".".concat(i), void 0, this.componentId);
        t.insertRules(this.componentId, i, d);
      }
      a = Oo(a, i), this.staticRulesId = i;
    }
    else {
      for (var m = To(this.baseHash, s.hash), h = "", p = 0; p < this.rules.length; p++) {
        var _ = this.rules[p];
        if (typeof _ == "string") h += _, ie.env.NODE_ENV !== "production" && (m = To(m, _));
        else if (_) {
          var y = Hd(wo(_, n, t, s));
          m = To(m, y + p), h += y;
        }
      }
      if (h) {
        var w = ah(m >>> 0);
        t.hasNameForId(this.componentId, w) || t.insertRules(this.componentId, w, s(h, ".".concat(w), void 0, this.componentId)), a = Oo(a, w);
      }
    }
    return a;
  }, e;
}(), Ec = Ie.createContext(void 0);
Ec.Consumer;
function je() {
  var e = Eh(Ec);
  if (!e) throw $n(18);
  return e;
}
function IB(e) {
  var n = Ie.useContext(Ec), t = Q(function() {
    return function(s, a) {
      if (!s) throw $n(14);
      if (No(s)) {
        var o = s(a);
        if (ie.env.NODE_ENV !== "production" && (o === null || Array.isArray(o) || typeof o != "object")) throw $n(7);
        return o;
      }
      if (Array.isArray(s) || typeof s != "object") throw $n(8);
      return a ? Le(Le({}, a), s) : s;
    }(e.theme, n);
  }, [e.theme, n]);
  return e.children ? Ie.createElement(Ec.Provider, { value: t }, e.children) : null;
}
var Tm = {}, v6 = /* @__PURE__ */ new Set();
function NB(e, n, t) {
  var s = Th(e), a = e, o = !Sm(e), i = n.attrs, d = i === void 0 ? lm : i, m = n.componentId, h = m === void 0 ? function(O, D) {
    var M = typeof O != "string" ? "sc" : h6(O);
    Tm[M] = (Tm[M] || 0) + 1;
    var N = "".concat(M, "-").concat(Sh(pm + M + Tm[M]));
    return D ? "".concat(D, "-").concat(N) : N;
  }(n.displayName, n.parentComponentId) : m, p = n.displayName, _ = p === void 0 ? function(O) {
    return Sm(O) ? "styled.".concat(O) : "Styled(".concat(n9(O), ")");
  }(e) : p, y = n.displayName && n.componentId ? "".concat(h6(n.displayName), "-").concat(n.componentId) : n.componentId || h, w = s && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, q = n.shouldForwardProp;
  if (s && a.shouldForwardProp) {
    var k = a.shouldForwardProp;
    if (n.shouldForwardProp) {
      var B = n.shouldForwardProp;
      q = function(O, D) {
        return k(O, D) && B(O, D);
      };
    } else q = k;
  }
  var v = new MB(t, y, s ? a.componentStyle : void 0);
  function g(O, D) {
    return function(M, N, l) {
      var u = M.attrs, f = M.componentStyle, S = M.defaultProps, x = M.foldedComponentIds, C = M.styledComponentId, F = M.target, A = Ie.useContext(Ec), E = Vd(), T = M.shouldForwardProp || E.shouldForwardProp;
      ie.env.NODE_ENV !== "production" && t6(C);
      var R = Z8(N, A, S) || jc, P = function(G, ne, le) {
        for (var $e, Ce = Le(Le({}, ne), { className: void 0, theme: le }), cn = 0; cn < G.length; cn += 1) {
          var Ve = No($e = G[cn]) ? $e(Ce) : $e;
          for (var Ge in Ve) Ce[Ge] = Ge === "className" ? Oo(Ce[Ge], Ve[Ge]) : Ge === "style" ? Le(Le({}, Ce[Ge]), Ve[Ge]) : Ve[Ge];
        }
        return ne.className && (Ce.className = Oo(Ce.className, ne.className)), Ce;
      }(u, N, R), V = P.as || F, X = {};
      for (var Z in P) P[Z] === void 0 || Z[0] === "$" || Z === "as" || Z === "theme" && P.theme === R || (Z === "forwardedAs" ? X.as = P.forwardedAs : T && !T(Z, V) || (X[Z] = P[Z], T || ie.env.NODE_ENV !== "development" || P8(Z) || v6.has(Z) || !sh.has(V) || (v6.add(Z), console.warn('styled-components: it looks like an unknown prop "'.concat(Z, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var ue = function(G, ne) {
        var le = Vd(), $e = G.generateAndInjectStyles(ne, le.styleSheet, le.stylis);
        return ie.env.NODE_ENV !== "production" && t6($e), $e;
      }(f, P);
      ie.env.NODE_ENV !== "production" && M.warnTooManyClasses && M.warnTooManyClasses(ue);
      var ve = Oo(x, C);
      return ue && (ve += " " + ue), P.className && (ve += " " + P.className), X[Sm(V) && !sh.has(V) ? "class" : "className"] = ve, X.ref = l, ZE(V, X);
    }(b, O, D);
  }
  g.displayName = _;
  var b = Ie.forwardRef(g);
  return b.attrs = w, b.componentStyle = v, b.displayName = _, b.shouldForwardProp = q, b.foldedComponentIds = s ? Oo(a.foldedComponentIds, a.styledComponentId) : "", b.styledComponentId = y, b.target = s ? a.target : e, Object.defineProperty(b, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(O) {
    this._foldedDefaultProps = s ? function(D) {
      for (var M = [], N = 1; N < arguments.length; N++) M[N - 1] = arguments[N];
      for (var l = 0, u = M; l < u.length; l++) oh(D, u[l], !0);
      return D;
    }({}, a.defaultProps, O) : O;
  } }), ie.env.NODE_ENV !== "production" && (J8(_, y), b.warnTooManyClasses = /* @__PURE__ */ function(O, D) {
    var M = {}, N = !1;
    return function(l) {
      if (!N && (M[l] = !0, Object.keys(M).length >= 200)) {
        var u = D ? ' with the id of "'.concat(D, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(O).concat(u, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), N = !0, M = {};
      }
    };
  }(_, y)), Rh(b, function() {
    return ".".concat(b.styledComponentId);
  }), o && o9(b, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), b;
}
function f6(e, n) {
  for (var t = [e[0]], s = 0, a = n.length; s < a; s += 1) t.push(n[s], e[s + 1]);
  return t;
}
var w6 = function(e) {
  return Object.assign(e, { isCss: !0 });
};
function Ye(e) {
  for (var n = [], t = 1; t < arguments.length; t++) n[t - 1] = arguments[t];
  if (No(e) || Cc(e)) return w6(wo(f6(lm, Co([e], n, !0))));
  var s = e;
  return n.length === 0 && s.length === 1 && typeof s[0] == "string" ? wo(s) : w6(wo(f6(s, n)));
}
function ch(e, n, t) {
  if (t === void 0 && (t = jc), !n) throw $n(1, n);
  var s = function(a) {
    for (var o = [], i = 1; i < arguments.length; i++) o[i - 1] = arguments[i];
    return e(n, t, Ye.apply(void 0, Co([a], o, !1)));
  };
  return s.attrs = function(a) {
    return ch(e, n, Le(Le({}, t), { attrs: Array.prototype.concat(t.attrs, a).filter(Boolean) }));
  }, s.withConfig = function(a) {
    return ch(e, n, Le(Le({}, t), a));
  }, s;
}
var p9 = function(e) {
  return ch(NB, e);
}, W = p9;
sh.forEach(function(e) {
  W[e] = p9(e);
});
var PB = function() {
  function e(n, t) {
    this.rules = n, this.componentId = t, this.isStatic = h9(n), Wd.registerId(this.componentId + 1);
  }
  return e.prototype.createStyles = function(n, t, s, a) {
    var o = a(Hd(wo(this.rules, t, s, a)), ""), i = this.componentId + n;
    s.insertRules(i, i, o);
  }, e.prototype.removeStyles = function(n, t) {
    t.clearRules(this.componentId + n);
  }, e.prototype.renderStyles = function(n, t, s, a) {
    n > 2 && Wd.registerId(this.componentId + n), this.removeStyles(n, s), this.createStyles(n, t, s, a);
  }, e;
}();
function UB(e) {
  for (var n = [], t = 1; t < arguments.length; t++) n[t - 1] = arguments[t];
  var s = Ye.apply(void 0, Co([e], n, !1)), a = "sc-global-".concat(Sh(JSON.stringify(s))), o = new PB(s, a);
  ie.env.NODE_ENV !== "production" && J8(a);
  var i = function(m) {
    var h = Vd(), p = Ie.useContext(Ec), _ = Ie.useRef(h.styleSheet.allocateGSInstance(a)).current;
    return ie.env.NODE_ENV !== "production" && Ie.Children.count(m.children) && console.warn("The global style component ".concat(a, " was given child JSX. createGlobalStyle does not render children.")), ie.env.NODE_ENV !== "production" && s.some(function(y) {
      return typeof y == "string" && y.indexOf("@import") !== -1;
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), h.styleSheet.server && d(_, m, h.styleSheet, p, h.stylis), Ie.useLayoutEffect(function() {
      if (!h.styleSheet.server) return d(_, m, h.styleSheet, p, h.stylis), function() {
        return o.removeStyles(_, h.styleSheet);
      };
    }, [_, m, h.styleSheet, p, h.stylis]), null;
  };
  function d(m, h, p, _, y) {
    if (o.isStatic) o.renderStyles(m, oB, p, y);
    else {
      var w = Le(Le({}, h), { theme: Z8(h, _, i.defaultProps) });
      o.renderStyles(m, w, p, y);
    }
  }
  return Ie.memo(i);
}
function Ic(e) {
  for (var n = [], t = 1; t < arguments.length; t++) n[t - 1] = arguments[t];
  ie.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  var s = Hd(Ye.apply(void 0, Co([e], n, !1))), a = Sh(s);
  return new ih(a, s);
}
ie.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var kd = "__sc-".concat(Io, "__");
ie.env.NODE_ENV !== "production" && ie.env.NODE_ENV !== "test" && typeof window < "u" && (window[kd] || (window[kd] = 0), window[kd] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[kd] += 1);
const _n = (e) => {
  const n = Math.max(0, Math.min(100, e));
  return Math.round(n / 100 * 255).toString(16).padStart(2, "0").toUpperCase();
}, Mh = (e) => {
  const n = document.createElement("canvas").getContext("2d");
  return n ? (n.fillStyle = e, n.fillStyle) : e;
}, Ih = (e) => {
  e = Mh(e);
  const n = parseInt(e.slice(1, 3), 16), t = parseInt(e.slice(3, 5), 16), s = parseInt(e.slice(5, 7), 16);
  return (Math.sqrt(0.299 * (n * n) + 0.587 * (t * t) + 0.114 * (s * s)) > 127.5 ? "light" : "dark") === "light" ? "black" : "white";
}, Nh = {
  brandColor: "#ff66ff",
  primary: {
    background: {
      normal: "#000",
      transparent: "#000000" + _n(90)
    },
    text: {
      normal: "#fff",
      lowContrast: "#ffffff" + _n(50),
      ultraLowContrast: "#ffffff" + _n(20)
    },
    ghostButtonHover: "#000000" + _n(40)
  },
  secondary: {
    background: {
      normal: "#141414",
      transparent: "#252525" + _n(70),
      hover: "#4A4A4A"
    }
  },
  success: {
    text: "#6fde00"
  },
  warning: {
    background: "#411f00",
    text: "#ff7a00"
  },
  error: {
    background: "#430000",
    text: "#ff1616"
  }
}, b3e = {
  brandColor: "#ff66ff",
  primary: {
    background: {
      normal: "#ffffff",
      transparent: "#ffffff" + _n(95)
    },
    text: {
      normal: "#000000",
      lowContrast: "#000000" + _n(45),
      ultraLowContrast: "#000000" + _n(10)
    },
    ghostButtonHover: "#ffffff" + _n(90)
  },
  secondary: {
    background: {
      normal: "#f1f1f1",
      transparent: "#eeeeee" + _n(90),
      hover: "#e0e0e0"
    }
  },
  success: {
    text: "#6bcf07"
  },
  warning: {
    background: "#ffe2c8",
    text: "#ef7404"
  },
  error: {
    background: "#ffcbcb",
    text: "#ef1e1e"
  }
};
var xo = {}, Ph = {}, zn = {}, Uh = {};
Object.defineProperty(Uh, "__esModule", { value: !0 });
const HB = {
  $schema: "../../assetlist.schema.json",
  chain_name: "ethereum",
  assets: [
    {
      description: "Ethereum is a decentralized blockchain platform for running smart contracts and dApps, with Ether (ETH) as its native cryptocurrency, enabling a versatile ecosystem beyond just digital currency.",
      extended_description: `Ethereum, symbolized as ETH, is a groundbreaking cryptocurrency and blockchain platform introduced in 2015 by a team led by Vitalik Buterin. Unlike Bitcoin, which primarily serves as a digital currency, Ethereum is designed to be a decentralized platform for running smart contracts and decentralized applications (dApps). These smart contracts are self-executing contracts with the terms directly written into code, enabling trustless and automated transactions without intermediaries. Ethereum's blockchain can host a wide variety of applications, from financial services to gaming, making it a versatile and powerful tool in the world of blockchain technology.

One of the most notable features of Ethereum is its native cryptocurrency, Ether (ETH), which is used to pay for transaction fees and computational services on the network. Ethereum has also been the backbone for the explosive growth of decentralized finance (DeFi), which seeks to recreate traditional financial systems with blockchain-based alternatives. Additionally, Ethereum is undergoing a significant upgrade known as Ethereum 2.0, which aims to improve scalability, security, and energy efficiency through a shift from proof-of-work (PoW) to proof-of-stake (PoS) consensus mechanisms. This transition is expected to enhance the network's performance and reduce its environmental impact, further solidifying Ethereum's position as a leading platform in the blockchain ecosystem.`,
      denom_units: [
        {
          denom: "wei",
          exponent: 0
        },
        {
          denom: "gwei",
          exponent: 9
        },
        {
          denom: "eth",
          exponent: 18,
          aliases: ["ether"]
        }
      ],
      type_asset: "evm-base",
      base: "wei",
      name: "Ether",
      display: "eth",
      symbol: "ETH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg"
      },
      coingecko_id: "ethereum",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg",
        theme: {
          primary_color_hex: "#303030"
        }
      }]
    },
    {
      description: "Aave is an Open Source and Non-Custodial protocol to earn interest on deposits & borrow assets. It also features access to highly innovative flash loans, which let developers borrow instantly and easily; no collateral needed. With 16 different assets, 5 of which are stablecoins.",
      type_asset: "erc20",
      address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
      denom_units: [{
        denom: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
        exponent: 0,
        aliases: ["aave-wei"]
      }, {
        denom: "aave",
        exponent: 18
      }],
      base: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
      name: "Aave",
      display: "aave",
      symbol: "AAVE",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/aave.svg"
      },
      coingecko_id: "aave",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/aave.svg"
      }]
    },
    {
      description: "ApeCoin found new expression in web3 through art, gaming, entertainment, and events. APE is a token made to support what’s next, controlled, and built on by the community. It will serve as a decentralized protocol layer for community-led initiatives that drive culture forward into the metaverse.",
      type_asset: "erc20",
      address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
      denom_units: [{
        denom: "0x4d224452801aced8b2f0aebe155379bb5d594381",
        exponent: 0,
        aliases: ["ape-wei"]
      }, {
        denom: "ape",
        exponent: 18
      }],
      base: "0x4d224452801aced8b2f0aebe155379bb5d594381",
      name: "ApeCoin",
      display: "ape",
      symbol: "APE",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ape.svg"
      },
      coingecko_id: "apecoin",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ape.svg"
      }]
    },
    {
      description: "Axie Infinity is a Pokémon-inspired digital pet universe where anyone can earn tokens through skilled gameplay and contributions to the ecosystem. Players can battle, collect, raise, and build a land-based kingdom for their pets (known as Axies).",
      type_asset: "erc20",
      address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
      denom_units: [{
        denom: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
        exponent: 0,
        aliases: ["axs-wei"]
      }, {
        denom: "axs",
        exponent: 18
      }],
      base: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
      name: "Axie Infinity Shard",
      display: "axs",
      symbol: "AXS",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/axs.svg"
      },
      coingecko_id: "axie-infinity",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/axs.svg"
      }]
    },
    {
      description: "Multi-Collateral Dai, brings a lot of new and exciting features, such as support for new CDP collateral types and Dai Savings Rate.",
      type_asset: "erc20",
      address: "0x6b175474e89094c44da98b954eedeac495271d0f",
      denom_units: [{
        denom: "0x6b175474e89094c44da98b954eedeac495271d0f",
        exponent: 0,
        aliases: ["dai-wei"]
      }, {
        denom: "dai",
        exponent: 18
      }],
      base: "0x6b175474e89094c44da98b954eedeac495271d0f",
      name: "Dai Stablecoin",
      display: "dai",
      symbol: "DAI",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "MakerDAO"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      },
      coingecko_id: "dai",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      }]
    },
    {
      description: "sDAI is a liquid representation of DAI deposited in the Dai savings rate contract.",
      type_asset: "erc20",
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      denom_units: [{
        denom: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
        exponent: 0,
        aliases: ["sdai-wei"]
      }, {
        denom: "sdai",
        exponent: 18
      }],
      base: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      name: "Savings Dai",
      display: "sdai",
      symbol: "sDAI",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f"
        },
        provider: "MakerDAO"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sdai.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sdai.svg"
      },
      coingecko_id: "dai",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sdai.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sdai.svg",
        theme: {
          primary_color_hex: "#7ec231"
        }
      }]
    },
    {
      description: "Frax is a fractional-algorithmic stablecoin protocol. It aims to provide a highly scalable, decentralized, algorithmic money in place of fixed-supply assets like BTC. Additionally, FXS is the value accrual and governance token of the entire Frax ecosystem.",
      type_asset: "erc20",
      address: "0x853d955acef822db058eb8505911ed77f175b99e",
      denom_units: [{
        denom: "0x853d955acef822db058eb8505911ed77f175b99e",
        exponent: 0,
        aliases: ["frax-wei"]
      }, {
        denom: "frax",
        exponent: 18
      }],
      base: "0x853d955acef822db058eb8505911ed77f175b99e",
      name: "Frax",
      display: "frax",
      symbol: "FRAX",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "Frax Protocol"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg"
      },
      coingecko_id: "frax",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg"
      }]
    },
    {
      description: "A blockchain-based middleware, acting as a bridge between cryptocurrency smart contracts, data feeds, APIs and traditional bank account payments.",
      type_asset: "erc20",
      address: "0x514910771af9ca656af840dff83e8264ecf986ca",
      denom_units: [{
        denom: "0x514910771af9ca656af840dff83e8264ecf986ca",
        exponent: 0,
        aliases: ["link-wei"]
      }, {
        denom: "link",
        exponent: 18
      }],
      base: "0x514910771af9ca656af840dff83e8264ecf986ca",
      name: "Chainlink",
      display: "link",
      symbol: "LINK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.svg"
      },
      coingecko_id: "chainlink",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.svg",
        theme: {
          primary_color_hex: "#2c5cdc"
        }
      }]
    },
    {
      description: "Maker is a decentralized finance (DeFi) platform on the Ethereum blockchain that facilitates the creation of the stablecoin DAI, which is pegged to the US dollar.",
      extended_description: "Maker is a leading DeFi platform on Ethereum, known for its stablecoin DAI, which is soft-pegged to the US dollar. Users can generate DAI by locking collateral such as ETH in Maker Vaults. The Maker Protocol, governed by the MKR token holders, ensures the stability and security of DAI through decentralized governance mechanisms. MKR tokens are used for voting on governance proposals and for recapitalizing the system if necessary. Maker has become a cornerstone of the DeFi ecosystem, providing a reliable and decentralized stablecoin for various financial applications.",
      type_asset: "erc20",
      address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
      denom_units: [{
        denom: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
        exponent: 0,
        aliases: ["mkr-wei"]
      }, {
        denom: "mkr",
        exponent: 18
      }],
      base: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
      name: "Maker",
      display: "mkr",
      symbol: "MKR",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/mkr.svg"
      },
      coingecko_id: "maker",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/mkr.svg"
      }]
    },
    {
      description: "RAI is a non-pegged, ETH-backed stable asset. It is useful as more 'stable' collateral for other DeFi protocols (compared to ETH or BTC) or as a stable asset with an embedded interest rate.",
      type_asset: "erc20",
      address: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919",
      denom_units: [{
        denom: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919",
        exponent: 0,
        aliases: ["rai-wei"]
      }, {
        denom: "rai",
        exponent: 18
      }],
      base: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919",
      name: "Rai Reflex Index",
      display: "rai",
      symbol: "RAI",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "RAI Finance"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/rai.svg"
      },
      coingecko_id: "rai",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/rai.svg"
      }]
    },
    {
      description: "SHIBA INU is a 100% decentralized community experiment with it claims that 1/2 the tokens have been sent to Vitalik and the other half were locked to a Uniswap pool and the keys burned.",
      type_asset: "erc20",
      address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
      denom_units: [{
        denom: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
        exponent: 0,
        aliases: ["shib-wei"]
      }, {
        denom: "shib",
        exponent: 18
      }],
      base: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
      name: "Shiba Inu",
      display: "shib",
      symbol: "SHIB",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/shib.svg"
      },
      coingecko_id: "shiba-inu",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/shib.svg",
        theme: {
          primary_color_hex: "#FFA409",
          background_color_hex: "#00000000"
        }
      }]
    },
    {
      description: "stETH is a token that represents staked ether in Lido, combining the value of initial deposit + staking rewards. stETH tokens are pegged 1:1 to the ETH staked with Lido and can be used as one would use ether, allowing users to earn Eth2 staking rewards whilst benefiting from Defi yields.",
      type_asset: "erc20",
      address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
      denom_units: [{
        denom: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
        exponent: 0,
        aliases: ["steth-wei"]
      }, {
        denom: "steth",
        exponent: 18
      }],
      base: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
      name: "Lido Staked Ether",
      display: "steth",
      symbol: "stETH",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "Lido"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/steth.svg"
      },
      coingecko_id: "staked-ether",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/steth.svg"
      }]
    },
    {
      description: "wstETH is a wrapped version of stETH. As some DeFi protocols require a constant balance mechanism for tokens, wstETH keeps your balance of stETH fixed and uses an underlying share system to reflect your earned staking rewards.",
      type_asset: "erc20",
      address: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0",
      denom_units: [{
        denom: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0",
        exponent: 0,
        aliases: ["wsteth-wei"]
      }, {
        denom: "wsteth",
        exponent: 18
      }],
      base: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0",
      name: "Wrapped Lido Staked Ether",
      display: "wsteth",
      symbol: "wstETH",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84"
        },
        provider: "Lido"
      }],
      coingecko_id: "wrapped-steth",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }]
    },
    {
      description: "Frax Ether is a liquid ETH staking derivative designed to uniquely leverage the Frax Finance ecosystem. frxETH acts as a stablecoin loosely pegged to ETH, leveraging Frax's winning playbook on stablecoins and onboarding ETH into the Frax ecosystem.",
      type_asset: "erc20",
      address: "0x5e8422345238f34275888049021821e8e08caa1f",
      denom_units: [{
        denom: "0x5e8422345238f34275888049021821e8e08caa1f",
        exponent: 0,
        aliases: ["frxeth-wei"]
      }, {
        denom: "frxeth",
        exponent: 18
      }],
      base: "0x5e8422345238f34275888049021821e8e08caa1f",
      name: "Frax Ether",
      display: "frxeth",
      symbol: "frxETH",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "Frax"
      }],
      coingecko_id: "frax-ether",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frxeth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frxeth.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frxeth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frxeth.svg"
      }
    },
    {
      description: "sfrxETH is the version of frxETH which accrues staking yield. All profit generated from Frax Ether validators is distributed to sfrxETH holders. By exchanging frxETH for sfrxETH, one becomes eligible for staking yield, which is redeemed upon converting sfrxETH back to frxETH.",
      type_asset: "erc20",
      address: "0xac3e018457b222d93114458476f3e3416abbe38f",
      denom_units: [{
        denom: "0xac3e018457b222d93114458476f3e3416abbe38f",
        exponent: 0,
        aliases: ["sfrxeth-wei"]
      }, {
        denom: "sfrxeth",
        exponent: 18
      }],
      base: "0xac3e018457b222d93114458476f3e3416abbe38f",
      name: "Staked Frax Ether",
      display: "sfrxeth",
      symbol: "sfrxETH",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x5e8422345238f34275888049021821e8e08caa1f"
        },
        provider: "Frax"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrxeth.svg"
      },
      coingecko_id: "staked-frax-ether",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrxeth.svg"
      }]
    },
    {
      description: "Rocket Pool is a decentralised Ethereum Proof of Stake pool.",
      type_asset: "erc20",
      address: "0xae78736cd615f374d3085123a210448e74fc6393",
      denom_units: [{
        denom: "0xae78736cd615f374d3085123a210448e74fc6393",
        exponent: 0,
        aliases: ["reth-wei"]
      }, {
        denom: "reth",
        exponent: 18
      }],
      base: "0xae78736cd615f374d3085123a210448e74fc6393",
      name: "Rocket Pool Ether",
      display: "reth",
      symbol: "rETH",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "Rocket Pool"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/reth.png"
      },
      coingecko_id: "rocket-pool-eth",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/reth.png",
        theme: {
          primary_color_hex: "#fba487"
        }
      }]
    },
    {
      description: "Coinbase Wrapped Staked ETH (“cbETH”) is a utility token and liquid representation of ETH staked through Coinbase. cbETH gives customers the option to sell, transfer, or otherwise use their staked ETH in dapps while it remains locked by the Ethereum protocol.",
      type_asset: "erc20",
      address: "0xbe9895146f7af43049ca1c1ae358b0541ea49704",
      denom_units: [{
        denom: "0xbe9895146f7af43049ca1c1ae358b0541ea49704",
        exponent: 0,
        aliases: ["cbeth-wei"]
      }, {
        denom: "cbeth",
        exponent: 18
      }],
      base: "0xbe9895146f7af43049ca1c1ae358b0541ea49704",
      name: "Coinbase Wrapped Staked ETH",
      display: "cbeth",
      symbol: "cbETH",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "Coinbase"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/cbeth.png"
      },
      coingecko_id: "coinbase-wrapped-staked-eth",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/cbeth.png",
        theme: {
          primary_color_hex: "#c9dbfc"
        }
      }]
    },
    {
      description: "UNI token served as governance token for Uniswap protocol with 1 billion UNI have been minted at genesis. 60% of the UNI genesis supply is allocated to Uniswap community members and remaining for team, investors and advisors.",
      type_asset: "erc20",
      address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
      denom_units: [{
        denom: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
        exponent: 0,
        aliases: ["uni-wei"]
      }, {
        denom: "uni",
        exponent: 18
      }],
      base: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
      name: "Uniswap",
      display: "uni",
      symbol: "UNI",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/uni.svg"
      },
      coingecko_id: "uniswap",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/uni.svg"
      }]
    },
    {
      description: "USDC (USD Coin) is a stablecoin fully backed by US dollars, providing a transparent and regulated digital dollar solution.",
      extended_description: "USD Coin (USDC) was launched in 2018 as a joint effort between Coinbase and Circle. USDC is a fully reserved stablecoin, meaning each token is backed 1:1 by US dollars held in reserve. This structure is designed to provide transparency and trust, reinforced by regular audits from reputable third-party firms. Initially built on the Ethereum blockchain, USDC has expanded to support multiple blockchain networks, including Algorand, Solana, and more. It is widely used in DeFi protocols, as collateral, and for international transactions, offering a stable and compliant digital dollar solution.",
      type_asset: "erc20",
      address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
      denom_units: [{
        denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      base: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
      name: "USDC",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "Circle"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      coingecko_id: "usd-coin",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "USDT (Tether) is a stablecoin that is pegged to the US dollar, designed to provide stability and liquidity within the cryptocurrency market.",
      extended_description: "Tether (USDT) is a pioneering stablecoin introduced in 2014 by Tether Limited. It aims to provide stability and liquidity by maintaining a 1:1 value ratio with the US dollar. USDT operates across multiple blockchain platforms, including Ethereum, Tron, and others, enhancing its accessibility and interoperability. It is widely used for trading, hedging against market volatility, and facilitating quick transfers between exchanges. Despite facing scrutiny over its transparency and backing reserves, USDT remains a cornerstone in the crypto market, offering a stable digital asset that bridges traditional finance and cryptocurrencies.",
      type_asset: "erc20",
      address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
      denom_units: [{
        denom: "0xdac17f958d2ee523a2206206994597c13d831ec7",
        exponent: 0,
        aliases: ["uusdt"]
      }, {
        denom: "usdt",
        exponent: 6
      }],
      base: "0xdac17f958d2ee523a2206206994597c13d831ec7",
      name: "Tether USD",
      display: "usdt",
      symbol: "USDT",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "Tether"
      }],
      coingecko_id: "tether",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt_logomark.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt_logomark.svg",
        theme: {
          circle: !1,
          primary_color_hex: "#50AF95",
          background_color_hex: "#00000000"
        }
      }],
      socials: {
        website: "https://tether.to/",
        twitter: "https://x.com/Tether_to"
      }
    },
    {
      description: "Wrapped Bitcoin (WBTC) is an ERC20 token backed 1:1 with Bitcoin. Completely transparent. 100% verifiable. Community led.",
      type_asset: "erc20",
      address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
      denom_units: [{
        denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
        exponent: 0,
        aliases: ["wbtc-satoshi"]
      }, {
        denom: "wbtc",
        exponent: 8
      }],
      base: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
      name: "Wrapped Bitcoin",
      display: "wbtc",
      symbol: "WBTC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "bitcoin",
          base_denom: "sat"
        },
        provider: "BitGo, Kyber, and Ren"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg"
      },
      coingecko_id: "wrapped-bitcoin",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg",
        theme: {
          primary_color_hex: "#f39444"
        }
      }]
    },
    {
      description: "wETH is 'wrapped ETH'",
      type_asset: "erc20",
      address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
      denom_units: [{
        denom: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
        exponent: 0,
        aliases: ["weth-wei"]
      }, {
        denom: "weth",
        exponent: 18
      }],
      base: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
      name: "Wrapped Ether",
      display: "weth",
      symbol: "WETH",
      traces: [{
        type: "wrapped",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "Ethereum"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      },
      coingecko_id: "weth",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }]
    },
    {
      description: "Chain is a cloud blockchain protocol that enables organizations to build better financial services from the ground up powered by Sequence and Chain Core.",
      type_asset: "erc20",
      address: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
      denom_units: [{
        denom: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
        exponent: 0,
        aliases: ["xcn-wei"]
      }, {
        denom: "xcn",
        exponent: 18
      }],
      base: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
      name: "Chain",
      display: "xcn",
      symbol: "XCN",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/xcn.svg"
      },
      coingecko_id: "chain-2",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/xcn.svg"
      }]
    },
    {
      description: "Binance USD (BUSD) is a dollar-backed stablecoin issued and custodied by Paxos Trust Company, and regulated by the New York State Department of Financial Services. BUSD is available directly for sale 1:1 with USD on Paxos.com and will be listed for trading on Binance.",
      type_asset: "erc20",
      address: "0x4fabb145d64652a948d72533023f6e7a623c7c53",
      denom_units: [{
        denom: "0x4fabb145d64652a948d72533023f6e7a623c7c53",
        exponent: 0,
        aliases: ["busd-wei"]
      }, {
        denom: "busd",
        exponent: 18
      }],
      base: "0x4fabb145d64652a948d72533023f6e7a623c7c53",
      name: "Binance USD",
      display: "busd",
      symbol: "BUSD",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "Binance"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.svg"
      },
      coingecko_id: "binance-usd",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.svg",
        theme: {
          primary_color_hex: "#f3bb0c"
        }
      }]
    },
    {
      description: "Pepe is a community based memecoin with one mission: to make memecoins great again. Made to honor the iconic meme we all know and love, Pepe is here to take reign as the most memeable memecoin in existence, fueled purely by memetic power. Pepe is for the people.",
      type_asset: "erc20",
      address: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
      denom_units: [{
        denom: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
        exponent: 0,
        aliases: ["pepe-wei"]
      }, {
        denom: "pepe",
        exponent: 18
      }],
      base: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
      name: "Pepe",
      display: "pepe",
      symbol: "PEPE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.svg"
      },
      coingecko_id: "pepe",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.svg",
        theme: {
          primary_color_hex: "#cc3233"
        }
      }],
      keywords: ["meme"]
    },
    {
      description: "Maximize ETH yield through leveraged staking across Aave, Compound and Morpho and liquidity provision of ETH liquid staking tokens on Uniswap V3.",
      type_asset: "erc20",
      address: "0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec",
      denom_units: [{
        denom: "0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec",
        exponent: 0
      }, {
        denom: "YieldETH",
        exponent: 18
      }],
      base: "0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec",
      name: "Real Yield ETH",
      display: "YieldETH",
      symbol: "YieldETH",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "Seven Seas & DeFine Logic Labs"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.svg"
      },
      coingecko_id: "yieldeth-sommelier",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.svg",
        theme: {
          primary_color_hex: "#14448c"
        }
      }]
    },
    {
      description: "TBTC replaces centralized intermediaries with a randomly selected group of nodes on the Threshold Network. This group of independent nodes works together to secure your deposited Bitcoin through threshold cryptography. TBTC allows anyone to use Bitcoin in the expanding DeFi and Web3 universe.",
      denom_units: [{
        denom: "0x18084fba666a33d37592fa2633fd49a74dd93a88",
        exponent: 0,
        aliases: []
      }, {
        denom: "tBTC",
        exponent: 18,
        aliases: []
      }],
      type_asset: "erc20",
      address: "0x18084fba666a33d37592fa2633fd49a74dd93a88",
      base: "0x18084fba666a33d37592fa2633fd49a74dd93a88",
      display: "tBTC",
      name: "tBTC v2",
      symbol: "tBTC",
      traces: [{
        type: "wrapped",
        counterparty: {
          chain_name: "bitcoin",
          base_denom: "sat"
        },
        provider: "Threshold Network"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/tbtc.svg"
      },
      coingecko_id: "tbtc",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/tbtc.svg"
      }]
    },
    {
      description: "pSTAKE is a liquid staking protocol unlocking the liquidity of staked assets. Stakers of PoS tokens can stake their assets while maintaining the liquidity of these assets. Users earn staking rewards + receive 1:1 pegged staked representative tokens which can be used to generate additional yield.",
      denom_units: [{
        denom: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
        exponent: 0,
        aliases: []
      }, {
        denom: "pstake",
        exponent: 18,
        aliases: []
      }],
      type_asset: "erc20",
      address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
      base: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
      display: "pstake",
      name: "pSTAKE Finance",
      symbol: "PSTAKE",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "persistence",
          base_denom: "uxprt"
        },
        provider: "Persistence"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.svg"
      },
      coingecko_id: "pstake-finance",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.svg",
        theme: {
          primary_color_hex: "#050505"
        }
      }]
    },
    {
      description: "The OCC token acts as the fuel for the OccamRazer launchpad and it is indirectly used as well on the DAO governance layer.",
      type_asset: "erc20",
      address: "0x2F109021aFe75B949429fe30523Ee7C0D5B27207",
      denom_units: [{
        denom: "0x2F109021aFe75B949429fe30523Ee7C0D5B27207",
        exponent: 0,
        aliases: []
      }, {
        denom: "occ",
        exponent: 18
      }],
      base: "0x2F109021aFe75B949429fe30523Ee7C0D5B27207",
      name: "OccamFi",
      display: "occ",
      symbol: "OCC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/occamfi.png"
      },
      coingecko_id: "occamfi",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/occamfi.png",
        theme: {
          primary_color_hex: "#313648"
        }
      }]
    },
    {
      description: "The PAGE token is used for actions in the PageDAO NFT literary ecosystem and for DAO governance.",
      type_asset: "erc20",
      address: "0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e",
      denom_units: [{
        denom: "0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e",
        exponent: 0,
        aliases: []
      }, {
        denom: "page",
        exponent: 8
      }],
      base: "0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e",
      name: "Page",
      display: "page",
      symbol: "PAGE",
      coingecko_id: "page",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.svg",
        theme: {
          primary_color_hex: "#ebb324"
        }
      }]
    },
    {
      description: "Gelotto blends gaming, DEFI, and fun Dapps in a unique Web3 ecosystem. Join us to become part of the house, earning from all Gelotto products. Our main goal? To bring the masses into Web3 with open, accessible, and enjoyable Dapps.",
      type_asset: "erc20",
      address: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2",
      denom_units: [{
        denom: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2",
        exponent: 0,
        aliases: []
      }, {
        denom: "glto",
        exponent: 6
      }],
      base: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2",
      name: "Gelotto",
      display: "glto",
      symbol: "GLTO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg",
        theme: {
          primary_color_hex: "#501cad"
        }
      }]
    },
    {
      type_asset: "erc20",
      address: "0x78a0A62Fba6Fb21A83FE8a3433d44C73a4017A6f",
      denom_units: [{
        denom: "0x78a0A62Fba6Fb21A83FE8a3433d44C73a4017A6f",
        exponent: 0,
        aliases: []
      }, {
        denom: "ox",
        exponent: 18
      }],
      base: "0x78a0A62Fba6Fb21A83FE8a3433d44C73a4017A6f",
      name: "Open Exchange Token",
      display: "ox",
      symbol: "OX",
      coingecko_id: "open-exchange-token",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ox.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ox.svg"
      }]
    },
    {
      description: "BEAST: Battle, Breed, and Customize unique creatures powered by Ethereum & Cosmos",
      extended_description: "A monster breeding & battling game with a twist. Each game interaction burns $BEAST tokens, adding a strategic depth to breeding, battling, and customization. Dive into a world where every move counts!",
      type_asset: "erc20",
      address: "0xA4426666addBE8c4985377d36683D17FB40c31Be",
      denom_units: [{
        denom: "0xA4426666addBE8c4985377d36683D17FB40c31Be",
        exponent: 0,
        aliases: []
      }, {
        denom: "beast",
        exponent: 6
      }],
      base: "0xA4426666addBE8c4985377d36683D17FB40c31Be",
      name: "Gelotto BEAST",
      display: "beast",
      symbol: "BEAST",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/beast.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/beast.png",
        theme: {
          primary_color_hex: "#21172b"
        }
      }]
    },
    {
      description: "PUNDIX token is the native token that functions within the Pundi X ecosystem, including PundiX Chain and XPOS.",
      extended_description: `PUNDIX token is the native token that functions within the Pundi X ecosystem, including PundiX Chain and XPOS. PUNDIX has several core use cases, including:
- Payment for goods and services from merchants through XPOS
- Gas Fee on PundiX Chain
- Listing tokens in the XPOS
- Merchant payments for loyalty programs and ads`,
      type_asset: "erc20",
      address: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
      denom_units: [{
        denom: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
        exponent: 0
      }, {
        denom: "PUNDIX",
        exponent: 18
      }],
      base: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
      name: "Pundi X Token",
      display: "PUNDIX",
      symbol: "PUNDIX",
      coingecko_id: "pundi-x-2",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-token-logo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-token-logo.svg",
        theme: {
          primary_color_hex: "#f1d20c"
        }
      }],
      socials: {
        website: "https://pundix.com",
        twitter: "https://x.com/PundiXLabs"
      }
    },
    {
      description: "Staked FRAX (sFRAX) is an ERC4626 staking vault that distributes part of the Frax Protocol yield weekly to stakers denominated in FRAX stablecoins.",
      type_asset: "erc20",
      address: "0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32",
      denom_units: [{
        denom: "0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32",
        exponent: 0,
        aliases: ["sfrax-wei"]
      }, {
        denom: "sfrax",
        exponent: 18
      }],
      base: "0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32",
      name: "Staked FRAX",
      display: "sfrax",
      symbol: "sFRAX",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x853d955acef822db058eb8505911ed77f175b99e"
        },
        provider: "Frax"
      }],
      coingecko_id: "staked-frax",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrax.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrax.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrax.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrax.svg"
      }
    },
    {
      description: "FXS is the value accrual and governance token of the entire Frax ecosystem. Frax is a fractional-algorithmic stablecoin protocol. It aims to provide a highly scalable, decentralized, algorithmic money in place of fixed-supply assets like BTC.",
      type_asset: "erc20",
      address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
      denom_units: [{
        denom: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
        exponent: 0,
        aliases: ["fxs-wei"]
      }, {
        denom: "fxs",
        exponent: 18
      }],
      base: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
      name: "Frax Share",
      display: "fxs",
      symbol: "FXS",
      coingecko_id: "frax-share",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/fxs.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/fxs.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/fxs.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/fxs.svg"
      }
    },
    {
      description: "PAX Gold (PAXG) tokens each represent one fine troy ounce of an LBMA-certified, London Good Delivery physical gold bar, secured in Brink’s vaults.",
      type_asset: "erc20",
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      denom_units: [{
        denom: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
        exponent: 0,
        aliases: ["paxg-wei"]
      }, {
        denom: "paxg",
        exponent: 18
      }],
      base: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      name: "Paxos Gold",
      display: "paxg",
      symbol: "PAXG",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "comex",
          base_denom: "XAU"
        },
        provider: "Paxos"
      }],
      coingecko_id: "pax-gold",
      socials: {
        website: "https://www.paxos.com/paxgold/",
        twitter: "https://twitter.com/paxosglobal"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/paxg.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/paxg.svg",
        theme: {
          primary_color_hex: "#ebe60e"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/paxg.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/paxg.svg"
      }
    },
    {
      description: "CRV is the governance token for Curve Finance.",
      type_asset: "erc20",
      address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
      denom_units: [{
        denom: "0xd533a949740bb3306d119cc777fa900ba034cd52",
        exponent: 0,
        aliases: ["crv-wei"]
      }, {
        denom: "crv",
        exponent: 18
      }],
      base: "0xd533a949740bb3306d119cc777fa900ba034cd52",
      name: "Curve DAO",
      display: "crv",
      symbol: "CRV",
      coingecko_id: "curve-dao-token",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/crv.png",
        theme: {
          primary_color_hex: "#1fcbdb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/crv.png"
      }
    },
    {
      description: "A collateralized-debt-position (CDP) stablecoin by Curve DAO.",
      type_asset: "erc20",
      address: "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e",
      denom_units: [{
        denom: "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e",
        exponent: 0,
        aliases: ["crvusd-wei"]
      }, {
        denom: "crvusd",
        exponent: 18
      }],
      base: "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e",
      name: "crvUSD",
      display: "crvusd",
      symbol: "crvUSD",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "Curve Finance"
      }],
      coingecko_id: "crvusd",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/crvusd.png",
        theme: {
          primary_color_hex: "#d6e3d9"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/crvusd.png"
      }
    },
    {
      description: "pxETH is built on top of the Pirex platform and forms the foundation of the Dinero protocol.",
      type_asset: "erc20",
      address: "0x04c154b66cb340f3ae24111cc767e0184ed00cc6",
      denom_units: [{
        denom: "0x04c154b66cb340f3ae24111cc767e0184ed00cc6",
        exponent: 0,
        aliases: ["pxeth-wei"]
      }, {
        denom: "pxeth",
        exponent: 18
      }],
      base: "0x04c154b66cb340f3ae24111cc767e0184ed00cc6",
      name: "Dinero Staked ETH",
      display: "pxeth",
      symbol: "pxETH",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "Dinero"
      }],
      coingecko_id: "dinero-staked-eth",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pxeth.png",
        theme: {
          primary_color_hex: "#c3cbd2"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pxeth.png"
      }
    },
    {
      description: "eETH is a natively restaked liquid staking token on Ethereum.",
      type_asset: "erc20",
      address: "0x35fa164735182de50811e8e2e824cfb9b6118ac2",
      denom_units: [{
        denom: "0x35fa164735182de50811e8e2e824cfb9b6118ac2",
        exponent: 0,
        aliases: ["eeth-wei"]
      }, {
        denom: "eeth",
        exponent: 18
      }],
      base: "0x35fa164735182de50811e8e2e824cfb9b6118ac2",
      name: "ether.fi Staked ETH",
      display: "eeth",
      symbol: "eETH",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "EtherFi"
      }],
      coingecko_id: "ether-fi-staked-eth",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eeth.png",
        theme: {
          primary_color_hex: "#5045b7"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eeth.png"
      }
    },
    {
      description: "The native governance token of Ethena.",
      type_asset: "erc20",
      address: "0x57e114b691db790c35207b2e685d4a43181e6061",
      denom_units: [{
        denom: "0x57e114b691db790c35207b2e685d4a43181e6061",
        exponent: 0,
        aliases: ["ena-wei"]
      }, {
        denom: "ena",
        exponent: 18
      }],
      base: "0x57e114b691db790c35207b2e685d4a43181e6061",
      name: "Ethena",
      display: "ena",
      symbol: "ENA",
      coingecko_id: "ethena",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ena.png",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ena.png"
      }
    },
    {
      description: "Ethena USDe is a synthetic dollar protocol built on Ethereum.",
      type_asset: "erc20",
      address: "0x4c9edd5852cd905f086c759e8383e09bff1e68b3",
      denom_units: [{
        denom: "0x4c9edd5852cd905f086c759e8383e09bff1e68b3",
        exponent: 0,
        aliases: ["usde-wei"]
      }, {
        denom: "usde",
        exponent: 18
      }],
      base: "0x4c9edd5852cd905f086c759e8383e09bff1e68b3",
      name: "Ethena USDe",
      display: "usde",
      symbol: "USDe",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "Ethena"
      }],
      coingecko_id: "ethena-usde",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usde.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usde.png"
      }
    },
    {
      description: "A Liquid Restaking Token (LRT) and Strategy Manager for EigenLayer.",
      type_asset: "erc20",
      address: "0xbf5495efe5db9ce00f80364c8b423567e58d2110",
      denom_units: [{
        denom: "0xbf5495efe5db9ce00f80364c8b423567e58d2110",
        exponent: 0,
        aliases: ["ezeth-wei"]
      }, {
        denom: "ezeth",
        exponent: 18
      }],
      base: "0xbf5495efe5db9ce00f80364c8b423567e58d2110",
      name: "Renzo Restaked ETH",
      display: "ezeth",
      symbol: "ezETH",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "Renzo"
      }],
      coingecko_id: "renzo-restaked-eth",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ezeth.png",
        theme: {
          primary_color_hex: "#9bcf2c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ezeth.png"
      }
    },
    {
      description: "Ankr is a Web3 decentralized infrastructure provider that helps developers, dapps, and stakers easily interact with multiple blockchains. It allows you to create DApps using API and RPC, staking on Ankr Earn, and use customized blockchain solutions for businesses.",
      type_asset: "erc20",
      address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
      denom_units: [{
        denom: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
        exponent: 0,
        aliases: ["ankr-wei"]
      }, {
        denom: "ankr",
        exponent: 18
      }],
      base: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
      name: "Ankr Network",
      display: "ankr",
      symbol: "ANKR",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ankr.svg"
      }],
      coingecko_id: "ankr",
      socials: {
        website: "https://www.ankr.com",
        twitter: "https://x.com/ankr"
      }
    },
    {
      description: "YUM is the Cacao Swap token, powering decentralised rails.",
      type_asset: "erc20",
      address: "0xcE682c89C63d2850Cb2ca898E44D6c7c30d897a6",
      denom_units: [{
        denom: "0xcE682c89C63d2850Cb2ca898E44D6c7c30d897a6",
        exponent: 0,
        aliases: ["yum-wei"]
      }, {
        denom: "yum",
        exponent: 18
      }],
      base: "0xcE682c89C63d2850Cb2ca898E44D6c7c30d897a6",
      name: "Yum",
      display: "yum",
      symbol: "YUM",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yum.png",
        theme: {
          primary_color_hex: "#33a6e7"
        }
      }],
      socials: {
        website: "https://cacaoswap.app",
        twitter: "https://x.com/CacaoSwap"
      }
    },
    {
      description: "Avail is a web3 infrastructure layer that allows modular execution layers to scale and interoperate in a trust minimized way.",
      type_asset: "erc20",
      address: "0xEeB4d8400AEefafC1B2953e0094134A887C76Bd8",
      denom_units: [{
        denom: "0xEeB4d8400AEefafC1B2953e0094134A887C76Bd8",
        exponent: 0,
        aliases: ["avail-wei", "avail"]
      }, {
        denom: "AVAIL",
        exponent: 18
      }],
      base: "0xEeB4d8400AEefafC1B2953e0094134A887C76Bd8",
      name: "Avail",
      display: "AVAIL",
      symbol: "AVAIL",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "avail",
          base_denom: "avail"
        },
        provider: "Avail Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "avail",
          base_denom: "avail"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avail/images/avail.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avail/images/avail.png",
        theme: {
          circle: !1,
          primary_color_hex: "#2B80D7"
        }
      }]
    },
    {
      description: "EURe is a Euro-backed stablecoin issued by Monerium.",
      extended_description: "EURe is the first authorized and regulated stablecoin in Europe. It is collateralized by Euro-denominated deposits held in segregated accounts. EURe is issued by Monerium, the first Electronic Money Institution (EMI) to become compliant under the EU's MiCA regulations.",
      type_asset: "erc20",
      address: "0x3231Cb76718CDeF2155FC47b5286d82e6eDA273f",
      denom_units: [{
        denom: "0x3231Cb76718CDeF2155FC47b5286d82e6eDA273f",
        exponent: 0,
        aliases: ["eure-wei", "ueure"]
      }, {
        denom: "eure",
        exponent: 18
      }],
      base: "0x3231Cb76718CDeF2155FC47b5286d82e6eDA273f",
      name: "Monerium EUR emoney",
      display: "eure",
      symbol: "EURe",
      coingecko_id: "monerium-eur-money",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "EUR"
        },
        provider: "Monerium"
      }],
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eure.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eure.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#0095D7",
          background_color_hex: "#FFFFFF"
        }
      }],
      socials: {
        webiste: "https://monerium.com/",
        twitter: "https://x.com/monerium"
      }
    }
  ]
};
Uh.default = HB;
var Hh = {};
Object.defineProperty(Hh, "__esModule", { value: !0 });
const LB = {
  $schema: "../../chain.schema.json",
  chain_name: "ethereum",
  status: "live",
  website: "https://ethereum.org/",
  network_type: "mainnet",
  pretty_name: "Ethereum Mainnet",
  chain_type: "eip155",
  chain_id: "1",
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "wei",
      fixed_min_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "wei"
    }]
  },
  explorers: [{
    kind: "Etherscan",
    url: "https://etherscan.io/",
    tx_page: "https://etherscan.io/tx/${txHash}"
  }],
  images: [{
    image_sync: {
      chain_name: "ethereum",
      base_denom: "wei"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg",
    theme: {
      primary_color_hex: "#303030"
    }
  }]
};
Hh.default = LB;
var Lh = {};
Object.defineProperty(Lh, "__esModule", { value: !0 });
const WB = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "composable",
    client_id: "08-wasm-159",
    connection_id: "connection-70"
  },
  chain_2: {
    chain_name: "ethereum",
    client_id: "07-tendermint-11",
    connection_id: "connection-10"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-52",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
Lh.default = WB;
var Wh = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(zn, "__esModule", { value: !0 });
zn.ibc = zn.chain = zn.assets = void 0;
const VB = Wh(Uh), GB = Wh(Hh), KB = Wh(Lh);
zn.assets = VB.default;
zn.chain = GB.default;
zn.ibc = KB.default;
var Po = {}, Vh = {};
Object.defineProperty(Vh, "__esModule", { value: !0 });
const XB = {
  $schema: "../../assetlist.schema.json",
  chain_name: "rootstock",
  assets: [{
    description: "Pegged 1:1 to Bitcoin, RBTC allows you to interact with DeFi protocols and dApps on the Rootstock network. Use RBTC for minting, swaps, gas fees, and more.",
    extended_description: "The longest running and leading Bitcoin sidechain. Deploy dApps and EVM-compatible smart contracts secured by the world’s most accessible, decentralized and secure blockchain.",
    denom_units: [{
      denom: "sat",
      exponent: 0
    }, {
      denom: "rbtc",
      exponent: 18
    }],
    type_asset: "evm-base",
    base: "sat",
    display: "rbtc",
    symbol: "RBTC",
    name: "Rootstock Smart Bitcoin",
    traces: [{
      type: "synthetic",
      counterparty: {
        chain_name: "bitcoin",
        base_denom: "sat"
      },
      provider: "Rootstock"
    }],
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/rootstock/images/rbtc.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/rootstock/images/rbtc.png",
      theme: {
        circle: !1,
        primary_color_hex: "#FF9931",
        background_color_hex: "#00000000"
      }
    }],
    coingecko_id: "rootstock",
    socials: {
      website: "https://rootstock.io/",
      twitter: "https://twitter.com/rootstock_io"
    }
  }, {
    description: "The wrapped version of RBTC.",
    denom_units: [{
      denom: "0x542FDA317318eBf1d3DeAF76E0B632741a7e677d",
      exponent: 0
    }, {
      denom: "wrbtc",
      exponent: 18
    }],
    type_asset: "erc20",
    name: "Wrapped BTC",
    symbol: "WRBTC",
    display: "wrbtc",
    base: "0x542FDA317318eBf1d3DeAF76E0B632741a7e677d",
    address: "0x542FDA317318eBf1d3DeAF76E0B632741a7e677d",
    traces: [{
      type: "wrapped",
      counterparty: {
        chain_name: "rootstock",
        base_denom: "sat"
      },
      provider: "Rootstock"
    }]
  }]
};
Vh.default = XB;
var Gh = {};
Object.defineProperty(Gh, "__esModule", { value: !0 });
const YB = {
  $schema: "../../chain.schema.json",
  chain_name: "rootstock",
  status: "live",
  website: "https://rootstock.io/",
  network_type: "mainnet",
  pretty_name: "Rootstock",
  chain_type: "eip155",
  chain_id: "30",
  slip44: 137,
  fees: {
    fee_tokens: [{
      denom: "sat"
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "sat"
    }]
  },
  description: "The longest running and leading Bitcoin sidechain. Deploy dApps and EVM-compatible smart contracts secured by the world’s most accessible, decentralized and secure blockchain.",
  explorers: [{
    kind: "Rootstock Explorer",
    url: "https://explorer.rootstock.io/",
    tx_page: "https://explorer.rootstock.io/tx/${txHash}"
  }],
  images: [{
    image_sync: {
      chain_name: "rootstock",
      base_denom: "sat"
    },
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/rootstock/images/rbtc.svg",
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/rootstock/images/rbtc.png",
    theme: {
      circle: !1,
      primary_color_hex: "#FF9931",
      background_color_hex: "#00000000"
    }
  }]
};
Gh.default = YB;
var l9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Po, "__esModule", { value: !0 });
Po.chain = Po.assets = void 0;
const JB = l9(Vh), ZB = l9(Gh);
Po.assets = JB.default;
Po.chain = ZB.default;
var qn = {}, Kh = {};
Object.defineProperty(Kh, "__esModule", { value: !0 });
const QB = {
  $schema: "../../assetlist.schema.json",
  chain_name: "solana",
  assets: [
    {
      description: "Solana is a high-performance blockchain platform known for its fast transaction speeds, low costs, and scalability, ideal for decentralized applications and crypto projects.",
      extended_description: "Solana is renowned for its high transaction throughput, achieved through its unique Proof of History (PoH) consensus mechanism combined with Proof of Stake (PoS). This architecture allows Solana to support a wide range of decentralized applications (dApps) and crypto projects without compromising on security or decentralization. The native token, SOL, is used for transaction fees, staking, and governance, playing a vital role in the ecosystem. Solana's robust infrastructure has attracted numerous projects, solidifying its position as a leading blockchain platform.",
      denom_units: [{
        denom: "Lamport",
        exponent: 0
      }, {
        denom: "SOL",
        exponent: 9
      }],
      type_asset: "svm-base",
      base: "Lamport",
      name: "Solana",
      display: "SOL",
      symbol: "SOL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg"
      },
      coingecko_id: "solana",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        theme: {
          circle: !0,
          background_color_hex: "#000000"
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol.svg",
        theme: {
          circle: !1,
          background_color_hex: "#00000000"
        }
      }]
    },
    {
      type_asset: "erc20",
      address: "So11111111111111111111111111111111111111112",
      denom_units: [{
        denom: "So11111111111111111111111111111111111111112",
        exponent: 0
      }, {
        denom: "wsol",
        exponent: 9
      }],
      base: "So11111111111111111111111111111111111111112",
      name: "Wrapped SOL",
      display: "wsol",
      symbol: "WSOL",
      traces: [{
        type: "wrapped",
        counterparty: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        provider: "Solana"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg"
      },
      coingecko_id: "wrapped-solana",
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        theme: {
          circle: !0,
          background_color_hex: "#000000"
        }
      }]
    },
    {
      description: "The Official Bonk Inu token",
      type_asset: "erc20",
      address: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263",
      denom_units: [{
        denom: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263",
        exponent: 0
      }, {
        denom: "bonk",
        exponent: 5
      }],
      base: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263",
      name: "Bonk",
      display: "bonk",
      symbol: "BONK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bonk.png"
      },
      coingecko_id: "bonk",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bonk.png",
        theme: {
          primary_color_hex: "#ee950a"
        }
      }]
    },
    {
      description: `Pyth is a protocol that allows market participants to publish pricing information on-chain for others to use. The protocol is an interaction between three parties:
-Publishers submit pricing information to Pyth's oracle program. Pyth has multiple data publishers for every product to improve the accuracy and robustness of the system.
-Pyth's oracle program combines publishers' data to produce a single aggregate price and confidence interval.
Consumers read the price information produced by the oracle program.

Pyth's oracle program runs simultaneously on both Solana mainnet and Pythnet. Each instance of the program is responsible for its own set of price feeds. Solana Price Feeds are available for use by Solana protocols. In this case, since the oracle program itself runs on Solana, the resulting prices are immediately available to consumers without requiring any additional work. Pythnet Price Feeds are available on 12+ blockchains. The prices constructed on Pythnet are transferred cross-chain to reach consumers on these blockchains.

In both cases, the critical component of the system is the oracle program that combines the data from each individual publisher. This program maintains a number of different Solana accounts that list the products on Pyth and their current price data. Publishers publish their price and confidence by interacting with the oracle program on every slot. The program stores this information in its accounts. The first price update in a slot additionally triggers price aggregation, which combines the price data from the previous slot into a single aggregate price and confidence interval. This aggregate price is written to the Solana account where it is readable by other on-chain programs and available for transmission to other blockchains.`,
      type_asset: "erc20",
      address: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3",
      denom_units: [{
        denom: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3",
        exponent: 0
      }, {
        denom: "pyth",
        exponent: 6
      }],
      base: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3",
      name: "Pyth Network",
      display: "pyth",
      symbol: "PYTH",
      coingecko_id: "pyth-network",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pyth.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pyth.svg"
      }
    },
    {
      description: "USDC is a fully collateralized US Dollar stablecoin developed by CENTRE, the open source project with Circle being the first of several forthcoming issuers.",
      type_asset: "erc20",
      address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
      denom_units: [{
        denom: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
        exponent: 0
      }, {
        denom: "usdc",
        exponent: 6
      }],
      base: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
      name: "USD Coin",
      display: "usdc",
      symbol: "USDC",
      coingecko_id: "usd-coin",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        provider: "Circle"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "BSKT tracks the top assets across the crypto ecosystem",
      type_asset: "erc20",
      address: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
      denom_units: [{
        denom: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
        exponent: 0
      }, {
        denom: "bskt",
        exponent: 5
      }],
      base: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
      name: "Basket",
      display: "bskt",
      symbol: "BSKT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bskt.png"
      },
      coingecko_id: "basket",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bskt.png",
        theme: {
          primary_color_hex: "#485573"
        }
      }],
      socials: {
        website: "https://www.bskt.fi/",
        twitter: "https://twitter.com/bsktfi"
      }
    },
    {
      description: "W is the native token powering the Wormhole interoperability platform.",
      extended_description: `Wormhole token (W) serves as the governance token of the Wormhole protocol, empowering token holders to steer the protocol's direction through on-chain governance via a dedicated decentralized autonomous organization (DAO).

Wormhole was founded by Jump Crypto, the building arm of Jump Trading Group. Initially launched in 2021, the protocol first debuted as a token bridge, allowing the transfer of tokens between blockchains, most notably between Solana and Ethereum. Wormhole later evolved, with Wormhole V2, to take on a more general approach, turning into an interoperability layer on which chains and decentralized applications could easily build on.

Wormhole V2 is a general messaging protocol, enabling different blockchains to communicate with one another. This technology could be used for a variety of use cases, including transfer of tokens between chains, enabling cross-chain governance for protocols that operated across chains as well as transfers of NFTs across chains, which could be utilized for multi-chain games. Wormhole V2 also saw the protocol expand its services to include Osmosis.

To date, the protocol has processed over $40 billion worth of value transfer across the blockchains supported, and over 1 billion messages sent. It supports over 30 blockchains, including most of the leading networks, and has a thriving ecosystem of over 200 applications built using Wormhole's technology.

In November 2023, Jump and Wormhole announced their intention to split ways. Following the separation, Wormhole announced that it raised $225 million, valuing the company at $2.5 billion. Investors include Brevan Howard, Coinbase Ventures, Multicoin Capital, Jump Crypto and more.`,
      type_asset: "erc20",
      address: "85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ",
      denom_units: [{
        denom: "85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ",
        exponent: 0
      }, {
        denom: "w",
        exponent: 6
      }],
      base: "85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ",
      name: "Wormhole Token",
      display: "w",
      symbol: "W",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/w.png"
      },
      coingecko_id: "wormhole",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/w.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      socials: {
        website: "https://wormhole.com/",
        twitter: "https://twitter.com/wormhole"
      }
    },
    {
      description: "mSOL represents staked SOL in the Marinade stake pool.",
      extended_description: "mSOL is a liquid staking token that you receive when you stake SOL on the Marinade protocol. These mSOL tokens represent your staked SOL tokens in Marinade's stake pool.",
      type_asset: "erc20",
      address: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
      denom_units: [{
        denom: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
        exponent: 0
      }, {
        denom: "msol",
        exponent: 9
      }],
      base: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
      name: "Marinade Staked SOL",
      display: "msol",
      symbol: "mSOL",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        provider: "Marinade"
      }],
      coingecko_id: "msol",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/msol.png",
        theme: {
          primary_color_hex: "#cbebe3"
        }
      }],
      socials: {
        website: "https://marinade.finance/",
        twitter: "https://twitter.com/MarinadeFinance"
      }
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using Jito.",
      extended_description: "The Jito stake pool enables users to stake their Solana tokens in exchange for JitoSOL, allowing them to simultaneously earn from staking rewards and MEV rewards.",
      type_asset: "erc20",
      address: "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn",
      denom_units: [{
        denom: "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn",
        exponent: 0
      }, {
        denom: "jitosol",
        exponent: 9
      }],
      base: "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn",
      name: "Jito Staked SOL",
      display: "jitosol",
      symbol: "jitoSOL",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        provider: "Jito"
      }],
      coingecko_id: "jito-staked-sol",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/jitosol.png",
        theme: {
          primary_color_hex: "#5bb384"
        }
      }],
      socials: {
        website: "https://jito.network/",
        twitter: "https://twitter.com/jito_foundation"
      }
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using the BlazeStake protocol.",
      extended_description: "BlazeStake is a non-custodial Solana stake pool protocol that allows users to stake their SOL tokens and receive bSOL tokens in return.",
      type_asset: "erc20",
      address: "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
      denom_units: [{
        denom: "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
        exponent: 0
      }, {
        denom: "bsol",
        exponent: 9
      }],
      base: "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
      name: "BlazeStake Staked SOL",
      display: "bsol",
      symbol: "bSOL",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        provider: "BlazeStake"
      }],
      coingecko_id: "blazestake-staked-sol",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bsol.png",
        theme: {
          primary_color_hex: "#21c3cc"
        }
      }],
      socials: {
        website: "https://stake.solblaze.org/",
        twitter: "https://twitter.com/solblaze_org"
      }
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using the MarginFi protocol.",
      type_asset: "erc20",
      address: "LSTxxxnJzKDFSLr4dUkPcmCf5VyryEqzPLz5j4bpxFp",
      denom_units: [{
        denom: "LSTxxxnJzKDFSLr4dUkPcmCf5VyryEqzPLz5j4bpxFp",
        exponent: 0
      }, {
        denom: "lst",
        exponent: 9
      }],
      base: "LSTxxxnJzKDFSLr4dUkPcmCf5VyryEqzPLz5j4bpxFp",
      name: "Liquid Staking Token",
      display: "lst",
      symbol: "LST",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        provider: "MarginFi"
      }],
      coingecko_id: "liquid-staking-token",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/lst.png",
        theme: {
          primary_color_hex: "#dbdbdb"
        }
      }],
      socials: {
        website: "https://www.marginfi.com/",
        twitter: "https://twitter.com/marginfi"
      }
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using the Edgevana protocol.",
      extended_description: "edgeSOL represents ownership of staked SOL that's delegated to the top validators running on Edgevana.",
      type_asset: "erc20",
      address: "edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt",
      denom_units: [{
        denom: "edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt",
        exponent: 0
      }, {
        denom: "edgesol",
        exponent: 9
      }],
      base: "edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt",
      name: "Edgevana Staked SOL",
      display: "edgesol",
      symbol: "edgeSOL",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        provider: "Edgevana"
      }],
      coingecko_id: "edgevana-staked-sol",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/edgesol.png",
        theme: {
          primary_color_hex: "#146cfc"
        }
      }],
      socials: {
        website: "https://edgevana.com/",
        twitter: "https://twitter.com/edgevana"
      }
    },
    {
      description: "A liquid staked token that represents SOL staked to Helius's validator.",
      extended_description: "hSOL is a liquid representiation of staked SOL tokens to Helius, minted via Sanctum.",
      type_asset: "erc20",
      address: "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A",
      denom_units: [{
        denom: "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A",
        exponent: 0
      }, {
        denom: "hsol",
        exponent: 9
      }],
      base: "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A",
      name: "Helius Staked SOL",
      display: "hsol",
      symbol: "hSOL",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        provider: "Helius"
      }],
      coingecko_id: "helius-staked-sol",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/hsol.png",
        theme: {
          primary_color_hex: "#e5502a"
        }
      }],
      socials: {
        website: "https://helius.dev/",
        twitter: "https://twitter.com/heliuslabs"
      }
    },
    {
      description: "A liquid staked token that represents SOL staked to Jupiter's validator.",
      extended_description: "JupSOL is a liquid staking token that represents SOL staked to the Jupiter validator, via Sanctum.",
      type_asset: "erc20",
      address: "jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v",
      denom_units: [{
        denom: "jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v",
        exponent: 0
      }, {
        denom: "jupsol",
        exponent: 9
      }],
      base: "jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v",
      name: "Jupiter Staked SOL",
      display: "jupsol",
      symbol: "jupSOL",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        provider: "Jupiter"
      }],
      coingecko_id: "jupiter-staked-sol",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/jupsol.png",
        theme: {
          primary_color_hex: "#85d79e"
        }
      }],
      socials: {
        website: "https://jup.ag/",
        twitter: "https://twitter.com/JupiterExchange"
      }
    },
    {
      description: "dogwifhat is a meme coin that operates on Solana.",
      type_asset: "erc20",
      address: "EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm",
      denom_units: [{
        denom: "EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm",
        exponent: 0
      }, {
        denom: "wif",
        exponent: 6
      }],
      base: "EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm",
      name: "dogwifhat",
      display: "wif",
      symbol: "WIF",
      coingecko_id: "dogwifcoin",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/wif.png",
        theme: {
          primary_color_hex: "#a29482"
        }
      }],
      socials: {
        website: "https://dogwifcoin.org/",
        twitter: "https://twitter.com/dogwifcoin"
      }
    },
    {
      description: "Tether, issued natively on Solana.",
      extended_description: "Tether USD (Native Solana), USDT is a native asset to Solana issued by Tether.",
      type_asset: "erc20",
      address: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
      denom_units: [{
        denom: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      base: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
      name: "Tether",
      display: "usdt",
      symbol: "USDT",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        provider: "Tether"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      coingecko_id: "tether",
      socials: {
        website: "https://Tether.to/",
        twitter: "https://twitter.com/tether_to"
      }
    },
    {
      address: "ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump",
      base: "ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump",
      description: "Whinecoin is an experimental memecoin by the Sommelier Finance team.",
      extended_description: "Whinecoin is an experimental memecoin by the Sommelier Finance team. Funds in the dev wallet are reserved for airdrops and liquidity for Solana and Cosmos pools. There is no team allocation.",
      name: "WHINEcoin",
      display: "whine",
      symbol: "WHINE",
      type_asset: "erc20",
      denom_units: [{
        denom: "ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump",
        exponent: 0
      }, {
        denom: "whine",
        exponent: 6
      }],
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/whine.png",
        theme: {
          primary_color_hex: "#FFFFFF",
          background_color_hex: "#FFFFFF",
          circle: !1
        }
      }],
      socials: {
        website: "https://whinecoin.com/",
        twitter: "https://twitter.com/whinecoin"
      }
    },
    {
      description: "Pepe Bruce Jenner",
      extended_description: "$PBJ is the culture coin for Solana, eat dis!",
      type_asset: "erc20",
      address: "ANu4Wuq86WzRU8tykszQUJ66eQzFNfkwap2HcQ5UaFaU",
      denom_units: [{
        denom: "ANu4Wuq86WzRU8tykszQUJ66eQzFNfkwap2HcQ5UaFaU",
        exponent: 0
      }, {
        denom: "pbj",
        exponent: 5
      }],
      base: "ANu4Wuq86WzRU8tykszQUJ66eQzFNfkwap2HcQ5UaFaU",
      name: "Pepe Bruce Jenner",
      display: "pbj",
      symbol: "PBJ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pbj.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pbj.png",
        theme: {
          primary_color_hex: "#488000",
          background_color_hex: "#ee0000"
        }
      }],
      socials: {
        website: "https://sandwichswap.io/",
        twitter: "https://twitter.com/pepebjenner_sol"
      },
      keywords: [
        "meme",
        "pump.fun",
        "pumpdotfun",
        "pepe"
      ]
    },
    {
      description: "Unicorn",
      type_asset: "erc20",
      address: "UwU8RVXB69Y6Dcju6cN2Qef6fykkq6UUNpB15rZku6Z",
      denom_units: [{
        denom: "UwU8RVXB69Y6Dcju6cN2Qef6fykkq6UUNpB15rZku6Z",
        exponent: 0
      }, {
        denom: "unicorn",
        exponent: 6
      }],
      base: "UwU8RVXB69Y6Dcju6cN2Qef6fykkq6UUNpB15rZku6Z",
      name: "Unicorn",
      display: "unicorn",
      symbol: "UWU",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "unicorn",
          base_denom: "uwunicorn"
        },
        provider: "Unicorn"
      }],
      images: [{
        image_sync: {
          chain_name: "unicorn",
          base_denom: "uwunicorn"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unicorn/images/uwu.png",
        theme: {
          primary_color_hex: "#D44CE6"
        }
      }],
      socials: {
        website: "https://unicorn.meme/",
        twitter: "https://x.com/unicornandmemes"
      },
      keywords: ["meme"]
    }
  ]
};
Kh.default = QB;
var Xh = {};
Object.defineProperty(Xh, "__esModule", { value: !0 });
const eF = {
  $schema: "../../chain.schema.json",
  chain_name: "solana",
  chain_type: "solana",
  status: "live",
  website: "https://solana.com/",
  network_type: "mainnet",
  pretty_name: "Solana Mainnet Beta",
  slip44: 501,
  fees: {
    fee_tokens: [{
      denom: "Lamport",
      fixed_min_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "Lamport"
    }]
  },
  explorers: [{
    kind: "Solana Explorer",
    url: "https://explorer.solana.com/",
    tx_page: "https://explorer.solana.com/tx/${txHash}"
  }],
  images: [{
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol.svg",
    theme: {
      circle: !1,
      background_color_hex: "#00000000"
    }
  }]
};
Xh.default = eF;
var Yh = {};
Object.defineProperty(Yh, "__esModule", { value: !0 });
const nF = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "composable",
    client_id: "08-wasm-215",
    connection_id: "connection-3"
  },
  chain_2: {
    chain_name: "solana",
    client_id: "07-tendermint-1",
    connection_id: "connection-108"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-71",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
Yh.default = nF;
var Jh = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(qn, "__esModule", { value: !0 });
qn.ibc = qn.chain = qn.assets = void 0;
const tF = Jh(Kh), sF = Jh(Xh), aF = Jh(Yh);
qn.assets = tF.default;
qn.chain = sF.default;
qn.ibc = aF.default;
var Uo = {}, Zh = {};
Object.defineProperty(Zh, "__esModule", { value: !0 });
const oF = {
  $schema: "../../assetlist.schema.json",
  chain_name: "ton",
  assets: [{
    description: "Toncoin ($TON) is the native cryptocurrency of the TON (The Open Network) blockchain.",
    extended_description: "TON (The Open Network) is a decentralized layer-1 blockchain designed for scalability, speed, and efficiency. It was originally conceived by the creators of Telegram but was later handed over to an open-source community to maintain and expand.",
    denom_units: [{
      denom: "nanoton",
      exponent: 0,
      aliases: ["nanoTon"]
    }, {
      denom: "ton",
      exponent: 9
    }],
    type_asset: "unknown",
    base: "nanoton",
    name: "Toncoin",
    display: "ton",
    symbol: "TON",
    coingecko_id: "the-open-network",
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.png",
      theme: {
        circle: !0,
        primary_color_hex: "#0088CC",
        background_color_hex: "#0088CC"
      }
    }],
    socials: {
      website: "https://ton.tg/",
      twitter: "https://x.com/ton_blockchain"
    }
  }]
};
Zh.default = oF;
var Qh = {};
Object.defineProperty(Qh, "__esModule", { value: !0 });
const rF = {
  $schema: "../../chain.schema.json",
  chain_name: "ton",
  chain_type: "unknown",
  status: "live",
  website: "https://ton.tg/",
  network_type: "mainnet",
  pretty_name: "TON (The Open Network)",
  slip44: 607,
  fees: {
    fee_tokens: [{
      denom: "nanoton",
      fixed_min_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "nanoton"
    }]
  },
  explorers: [{
    kind: "Tonscan",
    url: "https://tonscan.org/",
    tx_page: "https://tonscan.org/tx/${txHash}"
  }],
  images: [{
    image_sync: {
      chain_name: "ton",
      base_denom: "nanoton"
    },
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.svg",
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.png",
    theme: {
      circle: !0,
      primary_color_hex: "#0088CC",
      background_color_hex: "#0088CC"
    }
  }]
};
Qh.default = rF;
var g9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Uo, "__esModule", { value: !0 });
Uo.chain = Uo.assets = void 0;
const iF = g9(Zh), cF = g9(Qh);
Uo.assets = iF.default;
Uo.chain = cF.default;
var Ho = {}, ep = {};
Object.defineProperty(ep, "__esModule", { value: !0 });
const dF = {
  $schema: "../../assetlist.schema.json",
  chain_name: "tron",
  assets: [{
    description: "TRONIX is the mainnet native token of the TRON Protocol issued by TRON DAO, known as TRX.",
    extended_description: "Tron is a blockchain-based decentralized operating system much like Ethereum that aims to advance the decentralization of the Internet and its infrastructure. At its core, Tron is a smart contract platform that offers high throughput, high scalability, and high availability for all Decentralized Applications (DApps) in the TRON ecosystem. The Tron blockchain is built around the usability of its native token, Tronix (TRX).",
    denom_units: [{
      denom: "sun",
      exponent: 0
    }, {
      denom: "trx",
      exponent: 6
    }],
    type_asset: "unknown",
    base: "sun",
    name: "Tronix",
    display: "trx",
    symbol: "TRX",
    coingecko_id: "tron",
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.png",
      theme: {
        circle: !0,
        primary_color_hex: "#FF060A",
        background_color_hex: "#FF060A"
      }
    }],
    socials: {
      website: "https://tron.network/",
      twitter: "https://x.com/trondao"
    }
  }, {
    description: "USDT is the official stablecoin issued by Tether on the TRON network.",
    address: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
    denom_units: [{
      denom: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
      exponent: 0
    }, {
      denom: "usdt",
      exponent: 6
    }],
    type_asset: "erc20",
    base: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
    name: "Tether USD",
    display: "usdt",
    symbol: "USDT",
    coingecko_id: "tether",
    traces: [{
      type: "additional-mintage",
      counterparty: {
        chain_name: "ethereum",
        base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
      },
      provider: "Tether"
    }],
    images: [{
      image_sync: {
        chain_name: "ethereum",
        base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
      },
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
      theme: {
        circle: !0,
        primary_color_hex: "#009393",
        background_color_hex: "#009393"
      }
    }, {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt_logomark.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt_logomark.svg",
      theme: {
        circle: !1,
        primary_color_hex: "#50AF95",
        background_color_hex: "#00000000"
      }
    }],
    socials: {
      website: "https://tether.to/",
      twitter: "https://x.com/Tether_to"
    }
  }]
};
ep.default = dF;
var np = {};
Object.defineProperty(np, "__esModule", { value: !0 });
const mF = {
  $schema: "../../chain.schema.json",
  chain_name: "tron",
  chain_type: "unknown",
  status: "live",
  website: "https://tron.network/",
  network_type: "mainnet",
  pretty_name: "Tron",
  slip44: 195,
  fees: {
    fee_tokens: [{
      denom: "sun",
      fixed_min_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "sun"
    }]
  },
  explorers: [{
    kind: "TRONSCAN",
    url: "https://tronscan.org/",
    tx_page: "https://tronscan.org/#/transaction//${txHash}"
  }],
  images: [{
    image_sync: {
      chain_name: "tron",
      base_denom: "sun"
    },
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.svg",
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.png",
    theme: {
      circle: !0,
      primary_color_hex: "#FF060A",
      background_color_hex: "#FF060A"
    }
  }]
};
np.default = mF;
var u9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ho, "__esModule", { value: !0 });
Ho.chain = Ho.assets = void 0;
const hF = u9(ep), pF = u9(np);
Ho.assets = hF.default;
Ho.chain = pF.default;
var Sn = {}, tp = {};
Object.defineProperty(tp, "__esModule", { value: !0 });
const lF = {
  $schema: "../assetlist.schema.json",
  chain_name: "8ball",
  assets: [{
    description: "The native staking token of 8ball.",
    denom_units: [{
      denom: "uebl",
      exponent: 0
    }, {
      denom: "ebl",
      exponent: 6
    }],
    base: "uebl",
    name: "8ball",
    display: "ebl",
    symbol: "EBL",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.svg",
      theme: {
        primary_color_hex: "#dbdbdb"
      }
    }]
  }]
};
tp.default = lF;
var sp = {};
Object.defineProperty(sp, "__esModule", { value: !0 });
const gF = {
  $schema: "../chain.schema.json",
  chain_name: "8ball",
  status: "killed",
  website: "https://8ball.info/",
  network_type: "mainnet",
  pretty_name: "8ball",
  chain_type: "cosmos",
  chain_id: "eightball-1",
  bech32_prefix: "8ball",
  daemon_name: "8ball",
  node_home: "$HOME/.8ball",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uebl",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uebl"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46.7",
    cosmwasm_enabled: !0
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.8ball.info/",
      provider: "8ball"
    }, {
      address: "https://rpc.8ball.nodestake.top",
      provider: "NodeStake"
    }],
    rest: [
      {
        address: "https://rest.8ball.info",
        provider: "8ball"
      },
      {
        address: "https://api.8ball.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://api-8ball.nodine.id/",
        provider: "Nodine.ID"
      }
    ],
    grpc: [{
      address: "grpc.8ball.nodestake.top:443",
      provider: "NodeStake"
    }, {
      address: "https://grpc.8ball.nodexcapital.com:443",
      provider: "NodeX Validator"
    }]
  },
  explorers: [
    {
      url: "https://explorer.8ball.info/",
      tx_page: "https://explorer.8ball.info/8ball/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/8ball",
      tx_page: "https://ping.pub/8ball/tx/${txHash}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/8ball/",
      tx_page: "https://explorer.nodestake.top/8ball/tx/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/8ball",
      tx_page: "https://explorer.tcnetwork.io/8ball/transaction/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.co.id/8ball",
      tx_page: "https://explorer.co.id/8ball/tx/${txHash}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodexcapital.com/8ball",
      tx_page: "https://explorer.nodexcapital.com/8ball/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.svg",
    theme: {
      primary_color_hex: "#dbdbdb"
    }
  }]
};
sp.default = gF;
var ap = {};
Object.defineProperty(ap, "__esModule", { value: !0 });
const uF = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "8ball",
    client_id: "07-tendermint-2",
    connection_id: "connection-18"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2668",
    connection_id: "connection-2163"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-16",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-641",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
ap.default = uF;
var op = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Sn, "__esModule", { value: !0 });
Sn.ibc = Sn.chain = Sn.assets = void 0;
const _F = op(tp), yF = op(sp), bF = op(ap);
Sn.assets = _F.default;
Sn.chain = yF.default;
Sn.ibc = bF.default;
var Tn = {}, rp = {};
Object.defineProperty(rp, "__esModule", { value: !0 });
const vF = {
  $schema: "../assetlist.schema.json",
  chain_name: "acrechain",
  assets: [
    {
      description: "The native EVM, governance and staking token of the Acrechain",
      denom_units: [{
        denom: "aacre",
        exponent: 0
      }, {
        denom: "acre",
        exponent: 18
      }],
      base: "aacre",
      name: "Acre",
      display: "acre",
      symbol: "ACRE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.svg"
      },
      coingecko_id: "arable-protocol",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.svg",
        theme: {
          primary_color_hex: "#4aa29e"
        }
      }],
      socials: {
        website: "https://arable.finance/",
        twitter: "https://twitter.com/ArableProtocol"
      }
    },
    {
      description: "Overcollateralized stable coin for Arable derivatives v1",
      denom_units: [{
        denom: "erc20/0x2Cbea61fdfDFA520Ee99700F104D5b75ADf50B0c",
        exponent: 0
      }, {
        denom: "arusd",
        exponent: 18
      }],
      base: "erc20/0x2Cbea61fdfDFA520Ee99700F104D5b75ADf50B0c",
      name: "Arable USD",
      display: "arusd",
      symbol: "arUSD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/arusd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/arusd.svg"
      },
      coingecko_id: "arable-usd",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/arusd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/arusd.svg",
        theme: {
          primary_color_hex: "#77b64f"
        }
      }],
      socials: {
        website: "https://arable.finance/",
        twitter: "https://twitter.com/ArableProtocol"
      }
    },
    {
      description: "Ciento Exchange Token",
      denom_units: [{
        denom: "erc20/0xAE6D3334989a22A65228732446731438672418F2",
        exponent: 0
      }, {
        denom: "cnto",
        exponent: 18
      }],
      base: "erc20/0xAE6D3334989a22A65228732446731438672418F2",
      name: "Ciento Token",
      display: "cnto",
      symbol: "CNTO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/cnto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/cnto.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/cnto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/cnto.svg",
        theme: {
          primary_color_hex: "#ecc53b"
        }
      }]
    }
  ]
};
rp.default = vF;
var ip = {};
Object.defineProperty(ip, "__esModule", { value: !0 });
const fF = {
  $schema: "../chain.schema.json",
  chain_name: "acrechain",
  status: "live",
  network_type: "mainnet",
  website: "https://arable.finance/",
  pretty_name: "Acrechain",
  chain_type: "cosmos",
  chain_id: "acre_9052-1",
  bech32_prefix: "acre",
  node_home: "$HOME/.acred",
  daemon_name: "acred",
  key_algos: ["ethsecp256k1"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aacre",
      fixed_min_gas_price: 25e7,
      low_gas_price: 2e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aacre"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.acre.nodestake.top",
        provider: "nodestake"
      },
      {
        address: "https://rpc-acre.synergynodes.com",
        provider: "Synergy Nodes"
      },
      {
        address: "https://acrechain-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc.acre.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://mainnet-acre-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://acred-rpc.staketab.org:443",
        provider: "Staketab"
      }
    ],
    rest: [
      {
        address: "https://lcd-acre.synergynodes.com",
        provider: "Synergy Nodes"
      },
      {
        address: "https://acrechain-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest.acre.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://mainnet-acre-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://acred-rest.staketab.org",
        provider: "Staketab"
      }
    ],
    grpc: [
      {
        address: "grpc.acre.nodestake.top:443",
        provider: "Nodestake"
      },
      {
        address: "acrechain-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "acre-grpc.genznodes.dev:27090",
        provider: "genznodes"
      },
      {
        address: "services.staketab.com:9008",
        provider: "Staketab"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://jsonrpc-acre.d-stake.xyz",
        provider: "D-stake"
      },
      {
        address: "https://rpc2-acre.synergynodes.com",
        provider: "Synergy Nodes"
      },
      {
        address: "https://jsonrpc.acre.nodestake.top",
        provider: "Nodestake"
      },
      {
        address: "https://acre-rpc-evm.genznodes.dev/",
        provider: "genznodes"
      },
      {
        address: "https://evm-acre.sr20de.xyz/",
        provider: "Sr20de"
      },
      {
        address: "https://evm.acrescan.com/",
        provider: "Anonstake"
      },
      {
        address: "https://json-rpc.acre.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://mainnet-acre-evm.konsortech.xyz",
        provider: "KonsorTech"
      }
    ]
  },
  explorers: [
    {
      kind: "blockscout",
      url: "https://acrescout.mindheartsoul.org",
      tx_page: "https://acrescout.mindheartsoul.org/tx/${txHash}"
    },
    {
      kind: "blockscout",
      url: "https://acrescan.com",
      tx_page: "https://acrescan.com/tx/${txHash}"
    },
    {
      kind: "blockscout",
      url: "https://acreblockexplorer.jet-node.com",
      tx_page: "https://acreblockexplorer.jet-node.com/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.nodestake.top/acre",
      tx_page: "https://explorer.nodestake.top/acre/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://cosmosrun.info/acre-mainnet",
      tx_page: "https://cosmosrun.info/acre-mainnet/tx/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/acre",
      tx_page: "https://explorer.tcnetwork.io/acre/transaction/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.svg",
    theme: {
      primary_color_hex: "#4aa29e"
    }
  }]
};
ip.default = fF;
var cp = {};
Object.defineProperty(cp, "__esModule", { value: !0 });
const wF = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "axelar",
      client_id: "07-tendermint-78",
      connection_id: "connection-65"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1002",
      connection_id: "connection-701"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-457",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-18",
      connection_id: "connection-16"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-97",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-40",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-201",
      connection_id: "connection-175"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-106",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-8",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-61",
      connection_id: "connection-41"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-47",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-12",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "oraichain",
      client_id: "07-tendermint-74",
      connection_id: "connection-42"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2316",
      connection_id: "connection-1814"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-490",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-3",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-222",
      connection_id: "connection-156"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-121",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-14",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-70",
      connection_id: "connection-48"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-13",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-172",
      connection_id: "connection-99"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-69",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-11",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-101",
      connection_id: "connection-89"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-77",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
cp.default = wF;
var dp = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Tn, "__esModule", { value: !0 });
Tn.ibc = Tn.chain = Tn.assets = void 0;
const xF = dp(rp), kF = dp(ip), AF = dp(cp);
Tn.assets = xF.default;
Tn.chain = kF.default;
Tn.ibc = AF.default;
var Rn = {}, mp = {};
Object.defineProperty(mp, "__esModule", { value: !0 });
const jF = {
  $schema: "../assetlist.schema.json",
  chain_name: "agoric",
  assets: [{
    description: "Agoric is a smart contract platform that uses JavaScript to enable developers to build secure and scalable decentralized applications (dApps) easily.",
    extended_description: "Agoric leverages the popular JavaScript programming language to provide a secure and scalable platform for building decentralized applications (dApps). By using a familiar language, Agoric aims to lower the entry barriers for developers and promote the widespread adoption of blockchain technology. The platform's native token, BLD, is used for staking, securing the network, and governance. Agoric's innovative approach focuses on enabling rapid development and deployment of dApps, fostering a robust ecosystem of interoperable blockchain applications.",
    denom_units: [{
      denom: "ubld",
      exponent: 0
    }, {
      denom: "bld",
      exponent: 6
    }],
    base: "ubld",
    name: "Agoric",
    display: "bld",
    symbol: "BLD",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/bld.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/bld.svg"
    },
    coingecko_id: "agoric",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/bld.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/bld.svg",
      theme: {
        primary_color_hex: "#c42b44"
      }
    }],
    socials: {
      website: "https://agoric.com/",
      twitter: "https://twitter.com/agoric"
    }
  }, {
    description: "IST is the stable token used by the Agoric chain for execution fees and commerce.",
    denom_units: [{
      denom: "uist",
      exponent: 0
    }, {
      denom: "ist",
      exponent: 6
    }],
    base: "uist",
    name: "Inter Stable Token",
    display: "ist",
    symbol: "IST",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.svg"
    },
    coingecko_id: "inter-stable-token",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.svg",
      theme: {
        primary_color_hex: "#d485e2"
      }
    }]
  }]
};
mp.default = jF;
var hp = {};
Object.defineProperty(hp, "__esModule", { value: !0 });
const CF = {
  $schema: "../chain.schema.json",
  chain_name: "agoric",
  status: "live",
  network_type: "mainnet",
  website: "https://agoric.com/",
  pretty_name: "Agoric",
  chain_type: "cosmos",
  chain_id: "agoric-3",
  bech32_prefix: "agoric",
  daemon_name: "agd",
  node_home: "$HOME/.agoric",
  slip44: 564,
  alternative_slip44s: [118],
  fees: {
    fee_tokens: [{
      denom: "ubld",
      low_gas_price: 0.03,
      average_gas_price: 0.05,
      high_gas_price: 0.07
    }, {
      denom: "uist",
      low_gas_price: 34e-4,
      average_gas_price: 7e-3,
      high_gas_price: 0.02
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ubld"
    }]
  },
  codebase: {
    cosmos_sdk_version: "agoric-labs/cosmos-sdk v0.46.16-alpha.agoric.2.4",
    cosmwasm_enabled: !1
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/Agoric-logo-color.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/Agoric-logo-color.svg"
  },
  description: "The Agoric platform makes it safe and seamless to build decentralized apps using your existing JavaScript knowledge.",
  apis: {
    rpc: [
      {
        address: "https://main.rpc.agoric.net:443"
      },
      {
        address: "https://agoric-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc.agoric.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://agoric.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://agoric-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc-agoric-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://agoric-rpc.0base.dev",
        provider: "0base.vc"
      },
      {
        address: "https://agoric-rpc.stakeangle.com",
        provider: "StakeAngle"
      },
      {
        address: "https://agoric-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://rpc.agoric.stakewith.us",
        provider: "StakeWithUs"
      },
      {
        address: "https://rpc-agoric-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "https://agoric-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://rpc.agoric.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    rest: [
      {
        address: "https://main.api.agoric.net:443"
      },
      {
        address: "https://api.agoric.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://agoric-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://agoric.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://agoric-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://api-agoric-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://agoric-rest.0base.dev",
        provider: "0base.vc"
      },
      {
        address: "https://agoric-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://agoric.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.agoric.stakewith.us",
        provider: "StakeWithUs"
      },
      {
        address: "https://api-agoric-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "https://agoric-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://lcd.agoric.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    grpc: [
      {
        address: "grpc.agoric.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "agoric-grpc.polkachu.com:14490",
        provider: "Polkachu"
      },
      {
        address: "agoric-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "agoric.grpc.kjnodes.com:12790",
        provider: "kjnodes"
      },
      {
        address: "grpc-agoric-01.stakeflow.io:2202",
        provider: "Stakeflow"
      },
      {
        address: "agoric.mellifera.network:9090",
        provider: "MELLIFERA"
      },
      {
        address: "agoric-grpc.w3coins.io:14490",
        provider: "w3coins"
      },
      {
        address: "https://grpc.agoric.stakewith.us",
        provider: "StakeWithUs"
      },
      {
        address: "grpc-agoric-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "agoric-grpc.stakeandrelax.net:14490",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://grpc.agoric.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ]
  },
  explorers: [
    {
      kind: "explorers.guru",
      url: "https://agoric.explorers.guru",
      tx_page: "https://agoric.explorers.guru/transaction/${txHash}",
      account_page: "https://agoric.explorers.guru/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/agoric/",
      tx_page: "https://atomscan.com/agoric/transactions/${txHash}",
      account_page: "https://atomscan.com/agoric/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/agoric",
      account_page: "https://stakeflow.io/agoric/accounts/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Agoric",
      tx_page: "https://explorer.stavr.tech/Agoric/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Agoric/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/Agoric-logo-color.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/Agoric-logo-color.svg",
    theme: {
      primary_color_hex: "#bc2c44"
    }
  }]
};
hp.default = CF;
var pp = {};
Object.defineProperty(pp, "__esModule", { value: !0 });
const EF = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-75",
      connection_id: "connection-69"
    },
    chain_2: {
      chain_name: "archway",
      client_id: "07-tendermint-23",
      connection_id: "connection-21"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-60",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-11",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "axelar",
      client_id: "07-tendermint-69",
      connection_id: "connection-51"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-70",
      connection_id: "connection-64"
    },
    chain_2: {
      chain_name: "composable",
      client_id: "07-tendermint-51",
      connection_id: "connection-20"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-55",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-6",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-927",
      connection_id: "connection-649"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-405",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-19",
      connection_id: "connection-14"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-72",
      connection_id: "connection-66"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-116",
      connection_id: "connection-70"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-85",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-4",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-173",
      connection_id: "connection-154"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-91",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-78",
      connection_id: "connection-73"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-147",
      connection_id: "connection-182"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-133",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-20",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-94",
      connection_id: "connection-64"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-77",
      connection_id: "connection-72"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-32",
      connection_id: "connection-40"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-73",
      connection_id: "connection-67"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-47",
      connection_id: "connection-40"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-58",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2109",
      connection_id: "connection-1649"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-320",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-93",
      connection_id: "connection-91"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-167",
      connection_id: "connection-210"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-72",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-202",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-17",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-111",
      connection_id: "connection-80"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-74",
      connection_id: "connection-68"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-129",
      connection_id: "connection-118"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-59",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-148",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-18",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-152",
      connection_id: "connection-101"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
pp.default = EF;
var lp = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Rn, "__esModule", { value: !0 });
Rn.ibc = Rn.chain = Rn.assets = void 0;
const DF = lp(mp), BF = lp(hp), FF = lp(pp);
Rn.assets = DF.default;
Rn.chain = BF.default;
Rn.ibc = FF.default;
var On = {}, gp = {};
Object.defineProperty(gp, "__esModule", { value: !0 });
const $F = {
  $schema: "../assetlist.schema.json",
  chain_name: "aioz",
  assets: [{
    description: "The native staking and governance token of the AIOZ Network.",
    denom_units: [
      {
        denom: "attoaioz",
        exponent: 0
      },
      {
        denom: "nanoaioz",
        exponent: 9
      },
      {
        denom: "aioz",
        exponent: 18
      }
    ],
    base: "attoaioz",
    name: "AIOZ",
    display: "aioz",
    symbol: "AIOZ",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.svg"
    },
    coingecko_id: "aioz-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.svg",
      theme: {
        primary_color_hex: "#24241c"
      }
    }],
    socials: {
      website: "https://aioz.network/",
      twitter: "https://twitter.com/AIOZNetwork"
    }
  }]
};
gp.default = $F;
var up = {};
Object.defineProperty(up, "__esModule", { value: !0 });
const zF = {
  $schema: "../chain.schema.json",
  chain_name: "aioz",
  status: "live",
  network_type: "mainnet",
  website: "https://aioz.network/",
  pretty_name: "AIOZ Network",
  chain_type: "cosmos",
  chain_id: "aioz_168-1",
  bech32_prefix: "aioz",
  daemon_name: "aiozd",
  node_home: "$HOME/.aioz",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "attoaioz",
      fixed_min_gas_price: 7e9,
      low_gas_price: 7e9,
      average_gas_price: 7e9,
      high_gas_price: 1e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "attoaioz"
    }],
    lock_duration: {
      time: "2419200s"
    }
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.svg"
  },
  description: `AIOZ Network is a DePIN for Web3 AI, Storage and Streaming.

AIOZ empowers a faster, secure and decentralized future.

Powered by a global network of DePINs, AIOZ rewards you for sharing your computational resources for storing, transcoding, and streaming digital media content and powering decentralized AI computation.`,
  apis: {
    "evm-http-jsonrpc": [{
      address: "https://eth-dataseed.aioz.network",
      provider: "AIOZ Network"
    }],
    rpc: [{
      address: "https://rpc-dataseed.aioz.network:443",
      provider: "AIOZ Network"
    }],
    rest: [{
      address: "https://lcd-dataseed.aioz.network",
      provider: "AIOZ Network"
    }],
    grpc: [{
      address: "grpc-dataseed.aioz.network:443",
      provider: "AIOZ Network"
    }]
  },
  explorers: [{
    kind: "aioz",
    url: "https://explorer.aioz.network",
    tx_page: "https://explorer.aioz.network/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.svg",
    theme: {
      primary_color_hex: "#24241c"
    }
  }]
};
up.default = zF;
var _p = {};
Object.defineProperty(_p, "__esModule", { value: !0 });
const qF = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "aioz",
    client_id: "07-tendermint-1",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "cosmoshub",
    client_id: "07-tendermint-1121",
    connection_id: "connection-808"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-567",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "aioz",
    client_id: "07-tendermint-2",
    connection_id: "connection-1"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2785",
    connection_id: "connection-2285"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-779",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
_p.default = qF;
var yp = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(On, "__esModule", { value: !0 });
On.ibc = On.chain = On.assets = void 0;
const SF = yp(gp), TF = yp(up), RF = yp(_p);
On.assets = SF.default;
On.chain = TF.default;
On.ibc = RF.default;
var Mn = {}, bp = {};
Object.defineProperty(bp, "__esModule", { value: !0 });
const OF = {
  $schema: "../assetlist.schema.json",
  chain_name: "akash",
  assets: [{
    description: "Akash Network is a decentralized cloud computing marketplace that connects users with unused computing resources, offering a cost-effective alternative to traditional cloud providers.",
    extended_description: `Akash Network is revolutionizing the cloud computing industry with its decentralized marketplace that leverages underutilized computing resources. By connecting users with providers offering unused computational capacity, Akash provides a more affordable and flexible alternative to conventional cloud services. This decentralized approach not only reduces costs but also enhances security and resilience, as data and applications are distributed across multiple nodes rather than centralized servers.

The Akash Network utilizes its native token, AKT, to facilitate transactions and incentivize participants within the ecosystem. Users can pay for cloud services using AKT, while providers earn AKT by offering their computing resources. The network's open-source nature and compatibility with major cloud platforms further enhance its appeal, enabling seamless integration and broad adoption. Akash Network's innovative model is poised to disrupt the traditional cloud computing landscape, offering a decentralized, efficient, and cost-effective solution for developers and enterprises.`,
    denom_units: [{
      denom: "uakt",
      exponent: 0
    }, {
      denom: "akt",
      exponent: 6
    }],
    base: "uakt",
    name: "Akash Network",
    display: "akt",
    symbol: "AKT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
    },
    coingecko_id: "akash-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg",
      theme: {
        primary_color_hex: "#bc342c"
      }
    }],
    socials: {
      website: "https://akash.network/",
      twitter: "https://twitter.com/akashnet_"
    }
  }, {
    description: "Tether USDt on Akash",
    denom_units: [{
      denom: "ibc/05DB6975261B805B6F6A157A4386C627F8A70BF8118D411655EFEDCA82BFABA5",
      exponent: 0
    }, {
      denom: "usdt",
      exponent: 6
    }],
    type_asset: "ics20",
    base: "ibc/05DB6975261B805B6F6A157A4386C627F8A70BF8118D411655EFEDCA82BFABA5",
    name: "Tether USDt",
    display: "usdt",
    symbol: "USDt",
    traces: [{
      type: "ibc",
      counterparty: {
        chain_name: "kava",
        base_denom: "erc20/tether/usdt",
        channel_id: "channel-5"
      },
      chain: {
        channel_id: "channel-37",
        path: "transfer/channel-37/erc20/tether/usdt"
      }
    }],
    images: [{
      image_sync: {
        chain_name: "kava",
        base_denom: "erc20/tether/usdt"
      },
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
      theme: {
        circle: !0,
        primary_color_hex: "#009393",
        background_color_hex: "#009393"
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
    }
  }]
};
bp.default = OF;
var vp = {};
Object.defineProperty(vp, "__esModule", { value: !0 });
const MF = {
  $schema: "../chain.schema.json",
  chain_name: "akash",
  status: "live",
  network_type: "mainnet",
  website: "https://akash.network/",
  pretty_name: "Akash",
  chain_type: "cosmos",
  chain_id: "akashnet-2",
  bech32_prefix: "akash",
  daemon_name: "akash",
  node_home: "$HOME/.akash",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uakt",
      fixed_min_gas_price: 25e-5,
      low_gas_price: 25e-5,
      average_gas_price: 25e-4,
      high_gas_price: 0.025
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uakt"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.45.16"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
  },
  description: "Akash is open-source Supercloud that lets users buy and sell computing resources securely and efficiently. Purpose-built for public utility.",
  apis: {
    rpc: [
      {
        address: "https://rpc.akash.forbole.com:443",
        provider: "forbole"
      },
      {
        address: "https://rpc-akash.ecostake.com:443",
        provider: "ecostake"
      },
      {
        address: "https://rpc.lavenderfive.com:443/akash",
        provider: "Lavender.Five Nodes"
      },
      {
        address: "https://akash-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-akash.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://rpc-akash-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "http://akash.c29r3.xyz:80/rpc",
        provider: "c29r3"
      },
      {
        address: "https://akash-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://akash-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://rpc-akash-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://akash-mainnet-rpc.cosmonautstakes.com:443",
        provider: "Cosmonaut Stakes"
      },
      {
        address: "https://akash-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://akash-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://akash-rpc.validatornode.com",
        provider: "ValidatorNode"
      },
      {
        address: "https://rpc-akash.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://public.stakewolle.com/cosmos/akash/rpc",
        provider: "Stakewolle"
      },
      {
        address: "https://akash.declab.pro:26601",
        provider: "Decloud Nodes Lab"
      }
    ],
    rest: [
      {
        address: "https://api.akash.forbole.com:443",
        provider: "forbole"
      },
      {
        address: "https://rest-akash.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://rest.lavenderfive.com:443/akash",
        provider: "Lavender.Five Nodes"
      },
      {
        address: "https://akash-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://api-akash.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://api-akash-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "https://akash.c29r3.xyz:443/api",
        provider: "c29r3"
      },
      {
        address: "https://akash-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://akash-api.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://api-akash-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://akash-mainnet-rest.cosmonautstakes.com:443",
        provider: "Cosmonaut Stakes"
      },
      {
        address: "https://akash-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://akash-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://akash-api.validatornode.com",
        provider: "ValidatorNode"
      },
      {
        address: "https://api-akash.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://public.stakewolle.com/cosmos/akash/rest",
        provider: "Stakewolle"
      },
      {
        address: "https://akash.declab.pro:443",
        provider: "Decloud Nodes Lab"
      }
    ],
    grpc: [
      {
        address: "grpc-akash-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "akash.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "akash-grpc.polkachu.com:12890",
        provider: "Polkachu"
      },
      {
        address: "akash-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-akash.cosmos-spaces.cloud:1110",
        provider: "Cosmos Spaces"
      },
      {
        address: "grpc-akash-01.stakeflow.io:1502",
        provider: "Stakeflow"
      },
      {
        address: "akash-grpc.w3coins.io:12890",
        provider: "w3coins"
      },
      {
        address: "akash-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://akash.declab.pro:9001",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "grpc-akash.whispernode.com:443",
        provider: "WhisperNode 🤐"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/akash",
      tx_page: "https://ezstaking.app/akash/txs/${txHash}",
      account_page: "https://ezstaking.app/akash/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/akash",
      tx_page: "https://www.mintscan.io/akash/transactions/${txHash}",
      account_page: "https://www.mintscan.io/akash/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/akash-network",
      tx_page: "https://ping.pub/akash-network/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/akash",
      tx_page: "https://atomscan.com/akash/transactions/${txHash}",
      account_page: "https://atomscan.com/akash/accounts/${accountAddress}"
    },
    {
      kind: "cloudmos",
      url: "https://cloudmos.io/blocks",
      tx_page: "https://cloudmos.io/transactions/${txHash}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/akash",
      account_page: "https://stakeflow.io/akash/accounts/${accountAddress}"
    },
    {
      kind: "ValidatorNode",
      url: "https://explorer.validatornode.com/akash-network",
      tx_page: "https://explorer.validatornode.com/akash-network/tx/${txHash}"
    },
    {
      kind: "Decloud Nodes Lab",
      url: "https://explorer.declab.pro/Akash",
      tx_page: "https://explorer.declab.pro/Akash/tx/${txHash}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/akash",
      tx_page: "https://mainnet.whispernode.com/akash/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/akash/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg",
    theme: {
      primary_color_hex: "#bc342c"
    }
  }]
};
vp.default = MF;
var fp = {};
Object.defineProperty(fp, "__esModule", { value: !0 });
const IF = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-166",
      connection_id: "connection-146"
    },
    chain_2: {
      chain_name: "archway",
      client_id: "07-tendermint-26",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-109",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-53",
      connection_id: "connection-29"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-385",
      connection_id: "connection-339"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-184",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-132",
      connection_id: "connection-107"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-80",
      connection_id: "connection-71"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-70",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-44",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-48",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-65",
      connection_id: "connection-38"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-183",
      connection_id: "connection-171"
    },
    chain_2: {
      chain_name: "doravota",
      client_id: "07-tendermint-17",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-125",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-44",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-23",
      connection_id: "connection-16"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-84",
      connection_id: "connection-58"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-80",
      connection_id: "connection-47"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-35",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-126",
      connection_id: "connection-103"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-103",
      connection_id: "connection-72"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-119",
      connection_id: "connection-93"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-42",
      connection_id: "connection-35"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-18",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-0",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-188",
      connection_id: "connection-174"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-169",
      connection_id: "connection-214"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-127",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-213",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-47",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-20",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-102",
      connection_id: "connection-69"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-47",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-43",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-45",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-42",
      connection_id: "connection-27"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-61",
      connection_id: "connection-36"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-11",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-59",
      connection_id: "connection-35"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-29",
      connection_id: "connection-18"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-173",
      connection_id: "connection-159"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-387",
      connection_id: "connection-364"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-273",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
fp.default = IF;
var wp = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Mn, "__esModule", { value: !0 });
Mn.ibc = Mn.chain = Mn.assets = void 0;
const NF = wp(bp), PF = wp(vp), UF = wp(fp);
Mn.assets = NF.default;
Mn.chain = PF.default;
Mn.ibc = UF.default;
var Lo = {}, xp = {};
Object.defineProperty(xp, "__esModule", { value: !0 });
const HF = {
  $schema: "../assetlist.schema.json",
  chain_name: "akiro",
  assets: [{
    description: "AKIRO meme token",
    denom_units: [{
      denom: "uakiro",
      exponent: 0
    }, {
      denom: "akiro",
      exponent: 6
    }],
    base: "uakiro",
    name: "AKIRO",
    display: "akiro",
    symbol: "AKIRO",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akiro/images/akiro.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akiro/images/akiro.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akiro/images/akiro.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akiro/images/akiro.svg",
      theme: {
        primary_color_hex: "#f7f0e1"
      }
    }]
  }]
};
xp.default = HF;
var kp = {};
Object.defineProperty(kp, "__esModule", { value: !0 });
const LF = {
  $schema: "../chain.schema.json",
  chain_name: "akiro",
  status: "killed",
  network_type: "mainnet",
  pretty_name: "Akiro",
  chain_type: "cosmos",
  chain_id: "akiro-1",
  bech32_prefix: "akiro",
  daemon_name: "akirod",
  node_home: "$HOME/.akiro",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uakiro",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.035,
      high_gas_price: 0.045
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uakiro"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akiro/images/akiro.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akiro/images/akiro.svg"
  },
  apis: {
    rpc: [{
      address: "http://213.199.36.82:26657",
      provider: "AKIRO"
    }, {
      address: "https://rpc-akiro.d-stake.xyz",
      provider: "D-Stake"
    }],
    rest: [{
      address: "http://213.199.36.82:1317",
      provider: "AKIRO"
    }, {
      address: "https://api-akiro.d-stake.xyz",
      provider: "D-Stake"
    }],
    grpc: [{
      address: "http://213.199.36.82:9090",
      provider: "AKIRO"
    }, {
      address: "https://grpc-akiro.d-stake.xyz",
      provider: "D-Stake"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://ping.pub/akiro",
    tx_page: "https://ping.pub/akiro/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akiro/images/akiro.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akiro/images/akiro.svg",
    theme: {
      primary_color_hex: "#f7f0e1"
    }
  }]
};
kp.default = LF;
var _9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Lo, "__esModule", { value: !0 });
Lo.chain = Lo.assets = void 0;
const WF = _9(xp), VF = _9(kp);
Lo.assets = WF.default;
Lo.chain = VF.default;
var Wo = {}, Ap = {};
Object.defineProperty(Ap, "__esModule", { value: !0 });
const GF = {
  chain_name: "althea",
  $schema: "../assetlist.schema.json",
  assets: [{
    description: "Althea native token",
    denom_units: [{
      denom: "aalthea",
      exponent: 0
    }, {
      denom: "althea",
      exponent: 18
    }],
    base: "aalthea",
    name: "Althea Token",
    display: "althea",
    symbol: "ALTHEA",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/althea/images/althea.png",
      theme: {
        primary_color_hex: "#0474dc"
      }
    }, {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/althea/images/althea.svg"
    }]
  }]
};
Ap.default = GF;
var jp = {};
Object.defineProperty(jp, "__esModule", { value: !0 });
const KF = {
  $schema: "../chain.schema.json",
  chain_name: "althea",
  status: "live",
  network_type: "mainnet",
  website: "https://althea.net/",
  pretty_name: "Althea",
  chain_type: "cosmos",
  chain_id: "althea_258432-1",
  bech32_prefix: "althea",
  daemon_name: "althea",
  node_home: "$HOME/.althea",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "aalthea",
      fixed_min_gas_price: 1e11,
      low_gas_price: 1e11,
      average_gas_price: 1e11,
      high_gas_price: 3e11
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aalthea"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/althea/images/althea.png"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/althea/images/althea.png",
    theme: {
      primary_color_hex: "#0474dc"
    }
  }, {
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/althea/images/althea.svg"
  }],
  codebase: {},
  apis: {
    rest: [
      {
        address: "https://nodes.chandrastation.com/api/althea/",
        provider: "Chandra Station"
      },
      {
        address: "https://althea.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rest.lavenderfive.com:443/althea",
        provider: "Lavender.Five Nodes 🐝"
      }
    ],
    rpc: [
      {
        address: "https://nodes.chandrastation.com/rpc/althea/",
        provider: "Chandra Station"
      },
      {
        address: "https://althea.rpc.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.lavenderfive.com:443/althea",
        provider: "Lavender.Five Nodes 🐝"
      }
    ],
    grpc: [{
      address: "althea.lavenderfive.com:443",
      provider: "Lavender.Five Nodes 🐝"
    }]
  }
};
jp.default = KF;
var y9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Wo, "__esModule", { value: !0 });
Wo.chain = Wo.assets = void 0;
const XF = y9(Ap), YF = y9(jp);
Wo.assets = XF.default;
Wo.chain = YF.default;
var In = {}, Cp = {};
Object.defineProperty(Cp, "__esModule", { value: !0 });
const JF = {
  $schema: "../assetlist.schema.json",
  chain_name: "andromeda",
  assets: [{
    description: "The native staking and governance token of Andromeda",
    denom_units: [{
      denom: "uandr",
      exponent: 0
    }, {
      denom: "andr",
      exponent: 6
    }],
    coingecko_id: "andromeda-2",
    base: "uandr",
    name: "Andr",
    display: "andr",
    symbol: "ANDR",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/andromeda/images/andromeda-logo.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/andromeda/images/andromeda-logo.png",
      theme: {
        primary_color_hex: "#040404"
      }
    }]
  }]
};
Cp.default = JF;
var Ep = {};
Object.defineProperty(Ep, "__esModule", { value: !0 });
const ZF = {
  $schema: "../chain.schema.json",
  chain_name: "andromeda",
  chain_type: "cosmos",
  chain_id: "andromeda-1",
  pre_fork_chain_name: "andromeda1",
  pretty_name: "Andromeda",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "andr",
  daemon_name: "andromedad",
  node_home: "$HOME/.andromeda",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uandr",
      low_gas_price: 0.03,
      average_gas_price: 0.05,
      high_gas_price: 0.075
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uandr"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.47.8",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.41.0"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.andromeda-1.andromeda.aviaone.com",
        provider: "AviaOne 🟢"
      },
      {
        address: "https://andromeda.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://andromeda.rpc.nodex.one",
        provider: "nodex"
      },
      {
        address: "https://andro.rpc.m.stavr.tech/",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.lavenderfive.com:443/andromeda",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://andromeda-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://andromeda-rpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "https://andromeda-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://andromeda-rpc.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://andromeda.rpc.kjnodes.com",
        provider: "kjnodes.com 🦄"
      },
      {
        address: "andromeda-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "rpc-andromeda.blockval.io",
        provider: "Blockval"
      },
      {
        address: "https://andromeda.rpc.liveraven.net",
        provider: "LiveRaveN"
      }
    ],
    rest: [
      {
        address: "https://api.andromeda-1.andromeda.aviaone.com",
        provider: "AviaOne 🟢"
      },
      {
        address: "https://andromeda.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://andromeda.api.nodex.one",
        provider: "nodex"
      },
      {
        address: "https://andro.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rest.lavenderfive.com:443/andromeda",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://andromeda-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://andromeda-rest.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "https://andromeda-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://andromeda-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://andromeda.api.kjnodes.com",
        provider: "kjnodes.com 🦄"
      },
      {
        address: "andromeda-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "api-andromeda.blockval.io",
        provider: "Blockval"
      },
      {
        address: "https://andromeda.api.liveraven.net",
        provider: "LiveRaveN"
      }
    ],
    grpc: [
      {
        address: "andromeda.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://grpc.andromeda-1.andromeda.aviaone.com:9108",
        provider: "AviaOne 🟢"
      },
      {
        address: "andromeda.grpc.kjnodes.com:443",
        provider: "kjnodes"
      },
      {
        address: "andromeda-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://andromeda.grpc.nodex.one:443",
        provider: "nodex"
      },
      {
        address: "http://andromedad.grpc.t.stavr.tech:132",
        provider: "🔥STAVR🔥"
      },
      {
        address: "andromeda-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "andromeda-grpc.genznodes.dev:27090",
        provider: "genznodes"
      },
      {
        address: "andromeda.grpc.kjnodes.com:443",
        provider: "kjnodes.com 🦄"
      },
      {
        address: "andromeda-grpc.noders.services:34090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "grpc-andromeda.blockval.io:443",
        provider: "Blockval"
      },
      {
        address: "andromeda.grpc.liveraven.net:443",
        provider: "LiveRaveN"
      }
    ]
  },
  explorers: [
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/Andromeda-Mainnet",
      tx_page: "https://explorer.stavr.tech/Andromeda-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Andromeda-Mainnet/account/${accountAddress}"
    },
    {
      kind: "exploreme.pro",
      url: "https://andromeda.exploreme.pro",
      tx_page: "https://andromeda.exploreme.pro/transaction/${txHash}",
      account_page: "https://andromeda.exploreme.pro/account/${accountAddress}"
    },
    {
      kind: "Cosmotracker",
      url: "https://cosmotracker.com/andromeda",
      tx_page: "https://cosmotracker.com/andromeda/tx/${txHash}",
      account_page: "https://cosmotracker.com/andromeda/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/andromeda",
      tx_page: "https://ping.pub/andromeda/tx/${txHash}"
    },
    {
      kind: "AviaOne Explorer 🟢",
      url: "https://mainnet.explorer.aviaone.com/andromeda",
      tx_page: "https://mainnet.explorer.aviaone.com/andromeda/tx/${txHash}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/andromeda/images/andromeda-logo.png"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/andromeda/images/andromeda-logo.png",
    theme: {
      primary_color_hex: "#040404"
    }
  }]
};
Ep.default = ZF;
var Dp = {};
Object.defineProperty(Dp, "__esModule", { value: !0 });
const QF = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "archway",
      client_id: "07-tendermint-58",
      connection_id: "connection-68"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-97",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-16",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-250",
      connection_id: "connection-244"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-213",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-164",
      connection_id: "connection-127"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-123",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-17",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "kyve",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      fee_version: "ics29-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-19",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3250",
      connection_id: "connection-2735"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-81924",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-176",
      connection_id: "connection-133"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-97",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-15",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-409",
      connection_id: "connection-413"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-351",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Dp.default = QF;
var Bp = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(In, "__esModule", { value: !0 });
In.ibc = In.chain = In.assets = void 0;
const e$ = Bp(Cp), n$ = Bp(Ep), t$ = Bp(Dp);
In.assets = e$.default;
In.chain = n$.default;
In.ibc = t$.default;
var Nn = {}, Fp = {};
Object.defineProperty(Fp, "__esModule", { value: !0 });
const s$ = {
  $schema: "../assetlist.schema.json",
  chain_name: "archway",
  assets: [
    {
      description: "Archway is a smart contract platform in the Cosmos ecosystem designed to reward developers by providing them with a share of transaction fees generated by their applications.",
      extended_description: "Archway aims to incentivize developers by sharing a portion of the transaction fees generated by their decentralized applications (dApps) built on the platform. This innovative approach helps align the interests of developers with the network's growth and sustainability. Archway's native token, ARCH, is used for staking, governance, and distributing rewards to developers. By leveraging the Cosmos SDK, Archway ensures interoperability and scalability, allowing developers to build and deploy efficient and high-performance dApps.",
      denom_units: [
        {
          denom: "aarch",
          exponent: 0
        },
        {
          denom: "uarch",
          exponent: 12
        },
        {
          denom: "arch",
          exponent: 18
        }
      ],
      base: "aarch",
      name: "Archway",
      display: "arch",
      symbol: "ARCH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.svg"
      },
      coingecko_id: "archway",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.svg",
        theme: {
          primary_color_hex: "#fc4c04"
        }
      }],
      socials: {
        website: "https://archway.io/",
        twitter: "https://twitter.com/archwayHQ"
      }
    },
    {
      description: "ERIS liquid staked ARCH",
      type_asset: "cw20",
      address: "archway1fwurjg7ah4v7hhs6xsc3wutqpvmahrfhns285s0lt34tgfdhplxq6m8xg5",
      denom_units: [{
        denom: "cw20:archway1fwurjg7ah4v7hhs6xsc3wutqpvmahrfhns285s0lt34tgfdhplxq6m8xg5",
        exponent: 0
      }, {
        denom: "ampARCH",
        exponent: 6
      }],
      base: "cw20:archway1fwurjg7ah4v7hhs6xsc3wutqpvmahrfhns285s0lt34tgfdhplxq6m8xg5",
      name: "ERIS Amplified ARCH",
      display: "ampARCH",
      symbol: "ampARCH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/amparch.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/amparch.png",
        theme: {
          primary_color_hex: "#5c84cc"
        }
      }]
    },
    {
      description: "The first memecoin on osmosis.",
      denom_units: [{
        denom: "ibc/D2BCFE34F35AF2968C8E1F84557D8A2058BB56F739EB553206EFC2AD8C6EDAF0",
        exponent: 0
      }, {
        denom: "WOSMO",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D2BCFE34F35AF2968C8E1F84557D8A2058BB56F739EB553206EFC2AD8C6EDAF0",
      name: "Wosmo",
      display: "WOSMO",
      symbol: "WOSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-1429",
          path: "transfer/channel-1429/factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png",
        theme: {
          primary_color_hex: "#edd5ee"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png"
      }
    },
    {
      description: "The native token of Vidulum",
      denom_units: [{
        denom: "ibc/1BCF1FCAFE3568E234787EDFDA12460BD8931B17FE6A729DCD60FAD845558DA1",
        exponent: 0,
        aliases: ["uvdl"]
      }, {
        denom: "vdl",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1BCF1FCAFE3568E234787EDFDA12460BD8931B17FE6A729DCD60FAD845558DA1",
      name: "Vidulum",
      display: "vdl",
      symbol: "VDL",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "vidulum",
          base_denom: "uvdl",
          channel_id: "channel-24"
        },
        chain: {
          channel_id: "channel-110",
          path: "transfer/channel-110/uvdl"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg"
      },
      images: [{
        image_sync: {
          chain_name: "vidulum",
          base_denom: "uvdl"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg",
        theme: {
          primary_color_hex: "#3454bc"
        }
      }]
    },
    {
      description: "Astrovault AXV",
      type_asset: "cw20",
      address: "archway1ecjefhcf8r60wtfnhwefrxhj9caeqa90fj58cqsaafqveawn6cjs5znd2n",
      denom_units: [{
        denom: "cw20:archway1ecjefhcf8r60wtfnhwefrxhj9caeqa90fj58cqsaafqveawn6cjs5znd2n",
        exponent: 0
      }, {
        denom: "AXV",
        exponent: 6
      }],
      base: "cw20:archway1ecjefhcf8r60wtfnhwefrxhj9caeqa90fj58cqsaafqveawn6cjs5znd2n",
      name: "Astrovault AXV",
      display: "AXV",
      symbol: "AXV",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/axv.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/axv.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/axv.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/axv.svg",
        theme: {
          primary_color_hex: "#141434"
        }
      }],
      coingecko_id: "astrovault"
    },
    {
      description: "Wrapped ARCH",
      type_asset: "cw20",
      address: "archway1msc3fa4e2mh73y760qmjd3wfkzr98nl26f36xgt2xnhuw6ay3scs42zeue",
      denom_units: [{
        denom: "cw20:archway1msc3fa4e2mh73y760qmjd3wfkzr98nl26f36xgt2xnhuw6ay3scs42zeue",
        exponent: 0
      }, {
        denom: "wARCH",
        exponent: 18
      }],
      base: "cw20:archway1msc3fa4e2mh73y760qmjd3wfkzr98nl26f36xgt2xnhuw6ay3scs42zeue",
      name: "Wrapped ARCH",
      display: "wARCH",
      symbol: "wARCH",
      traces: [{
        type: "wrapped",
        counterparty: {
          chain_name: "archway",
          base_denom: "aarch"
        },
        provider: "Archway"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.svg",
        theme: {
          primary_color_hex: "#000000"
        }
      }]
    },
    {
      description: "Circle's USDC Noble on Archway ",
      denom_units: [{
        denom: "ibc/43897B9739BD63E3A08A88191999C632E052724AB96BD4C74AE31375C991F48D",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/43897B9739BD63E3A08A88191999C632E052724AB96BD4C74AE31375C991F48D",
      name: "USDC (Noble)",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "noble",
          base_denom: "uusdc",
          channel_id: "channel-12"
        },
        chain: {
          channel_id: "channel-29",
          path: "transfer/channel-29/uusdc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    }
  ]
};
Fp.default = s$;
var $p = {};
Object.defineProperty($p, "__esModule", { value: !0 });
const a$ = {
  $schema: "../chain.schema.json",
  chain_name: "archway",
  status: "live",
  network_type: "mainnet",
  website: "https://archway.io/",
  pretty_name: "Archway",
  chain_type: "cosmos",
  chain_id: "archway-1",
  bech32_prefix: "archway",
  daemon_name: "archwayd",
  node_home: "$HOME/.archway",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "aarch",
      fixed_min_gas_price: 14e10,
      low_gas_price: 196e9,
      average_gas_price: 2254e8,
      high_gas_price: 2548e8
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aarch"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.47.11",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.45.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/archway.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/archway.svg"
  },
  description: "An incentivized L1 blockchain that allows developers to capture the value their dapps create, enabling sustainable economic models.",
  apis: {
    rpc: [
      {
        address: "https://rpc.mainnet.archway.io",
        provider: "Archway Foundation"
      },
      {
        address: "https://archway-mainnet-archive.allthatnode.com:26657",
        provider: "All That Node"
      },
      {
        address: "https://m-archway.rpc.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://rpc-1.archway.nodes.guru",
        provider: "Nodes.Guru"
      },
      {
        address: "https://archway.rpc.silknodes.io/",
        provider: "Silk Nodes"
      },
      {
        address: "https://archway.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://rpc-archway.cryptech.com.ua",
        provider: "cryptech"
      },
      {
        address: "https://rpc.archway.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rpc-archway.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://archway-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://m-archway.rpc.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://rpc.lavenderfive.com:443/archway",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-archway.mms.team",
        provider: "MMS"
      },
      {
        address: "https://rpc-archway.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://rpc.archway.lgns.net",
        provider: "Luganodes"
      },
      {
        address: "https://archway-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://archway-rpc.0base.dev",
        provider: "0base.vc"
      },
      {
        address: "https://archway-mainnet.rpc.l0vd.com",
        provider: "L0vd.com"
      },
      {
        address: "https://archway-rpc.openbitlab.com",
        provider: "openbitlab"
      },
      {
        address: "https://rpc-archway.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://rpc-archway.mainnet.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "https://rpc.archway.stakeup.tech",
        provider: "StakeUp"
      },
      {
        address: "https://archway-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://rpc.archway.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://rpc-archway.luckyfriday.io/",
        provider: "GlobalStake"
      },
      {
        address: "https://archway-rpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [
      {
        address: "https://api.mainnet.archway.io",
        provider: "Archway Foundation"
      },
      {
        address: "https://archway-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://m-archway.api.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://api-1.archway.nodes.guru",
        provider: "Nodes.Guru"
      },
      {
        address: "https://archway.api.silknodes.io/",
        provider: "Silk Nodes"
      },
      {
        address: "https://archway.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://api-archway.cryptech.com.ua",
        provider: "cryptech"
      },
      {
        address: "https://api.archway.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rest-archway.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://rest.lavenderfive.com:443/archway",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api-archway.mms.team",
        provider: "MMS"
      },
      {
        address: "https://api-archway.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://rest.archway.lgns.net",
        provider: "Luganodes"
      },
      {
        address: "https://archway-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://archway-rest.0base.dev",
        provider: "0base.vc"
      },
      {
        address: "https://archway-mainnet.api.l0vd.com",
        provider: "L0vd.com"
      },
      {
        address: "https://archway-api.openbitlab.com",
        provider: "openbitlab"
      },
      {
        address: "https://api-archway.mainnet.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "https://api.archway.stakeup.tech",
        provider: "StakeUp"
      },
      {
        address: "https://archway-mainnet-archive.allthatnode.com:1317",
        provider: "All That Node"
      },
      {
        address: "https://archway-api.tienthuattoan.ventures",
        provider: "TienThuatToan"
      },
      {
        address: "https://archway-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://lcd.archway.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://archway-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "grpc.mainnet.archway.io:443",
        provider: "Archway Foundation"
      },
      {
        address: "grpc-1.archway.nodes.guru:10690",
        provider: "Nodes.Guru"
      },
      {
        address: "archway.grpc.kjnodes.com:15690",
        provider: "kjnodes"
      },
      {
        address: "https://grpc-archway.cryptech.com.ua",
        provider: "cryptech"
      },
      {
        address: "https://grpc.archway.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "grpc-archway.theamsolutions.info:443",
        provider: "AM Solutions"
      },
      {
        address: "archway.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "archway.grpc.nodersteam.com:9090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "grpc-archway.mms.team:443",
        provider: "MMS"
      },
      {
        address: "grpc-archway.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "grpc.archway.lgns.net:443",
        provider: "Luganodes"
      },
      {
        address: "archway-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "archway-grpc.huginn.tech:4090",
        provider: "Huginn"
      },
      {
        address: "archway-mainnet.grpc.l0vd.com:80",
        provider: "L0vd.com"
      },
      {
        address: "archway-grpc.openbitlab.com:443",
        provider: "openbitlab"
      },
      {
        address: "grpc-archway.mainnet.validatrium.club:27490",
        provider: "Validatrium"
      },
      {
        address: "grpc.archway.stakeup.tech:443",
        provider: "StakeUp"
      },
      {
        address: "grpc-archway-mainnet.testnet-pride.com:9096",
        provider: "TestnetPride"
      },
      {
        address: "archway-grpc.tienthuattoan.ventures:9290",
        provider: "TienThuatToan"
      },
      {
        address: "archway-grpc.stakeandrelax.net:11590",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://grpc.archway.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "archway-grpc.noders.services:13090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "Nodes Guru",
      url: "https://archway.explorers.guru/",
      tx_page: "https://archway.explorers.guru/transaction/${txHash}",
      account_page: "https://archway.explorers.guru/account/${accountAddress}"
    },
    {
      kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
      url: "https://exp.utsa.tech/archway",
      tx_page: "https://exp.utsa.tech/archway/tx/${txHash}",
      account_page: "https://exp.utsa.tech/archway/account/${accountAddress}"
    },
    {
      kind: "Mintscan",
      url: "https://mintscan.io/archway/",
      tx_page: "https://mintscan.io/archway/transactions/${txHash}",
      account_page: "https://mintscan.io/archway/accounts/${accountAddress}"
    },
    {
      kind: "Silk Nodes",
      url: "https://explorer.silknodes.io/archway",
      tx_page: "https://explorer.silknodes.io/archway/tx/${txHash}",
      account_page: "https://explorer.silknodes.io/archway/account/${accountAddress}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/archway/",
      tx_page: "https://explorer.nodestake.top/archway/txs/${txHash}",
      account_page: "https://explorer.nodestake.top/archway/account/${accountAddress}"
    },
    {
      kind: "Exploreme",
      url: "https://archway.exploreme.pro/",
      tx_page: "https://archway.exploreme.pro/transaction/${txHash}",
      account_page: "https://archway.exploreme.pro/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/archway",
      tx_page: "https://ping.pub/archway/tx/${txHash}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/archway",
      tx_page: "https://ezstaking.app/archway/txs/${txHash}",
      account_page: "https://ezstaking.app/archway/account/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/archway",
      tx_page: "https://mainnet.whispernode.com/archway/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/archway/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/archway.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/archway.svg",
    theme: {
      primary_color_hex: "#fc4c04"
    }
  }]
};
$p.default = a$;
var zp = {};
Object.defineProperty(zp, "__esModule", { value: !0 });
const o$ = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-75",
      connection_id: "connection-69"
    },
    chain_2: {
      chain_name: "archway",
      client_id: "07-tendermint-23",
      connection_id: "connection-21"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-60",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-166",
      connection_id: "connection-146"
    },
    chain_2: {
      chain_name: "archway",
      client_id: "07-tendermint-26",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-109",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "archway",
      client_id: "07-tendermint-58",
      connection_id: "connection-68"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-97",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-16",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "axelar",
      client_id: "07-tendermint-160",
      connection_id: "connection-145"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-111",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-114",
      connection_id: "connection-107"
    },
    chain_2: {
      chain_name: "beezee",
      client_id: "07-tendermint-8",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-147",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-37",
      connection_id: "connection-40"
    },
    chain_2: {
      chain_name: "bitcanna",
      client_id: "07-tendermint-83",
      connection_id: "connection-74"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-35",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-92",
      connection_id: "connection-90"
    },
    chain_2: {
      chain_name: "bitsong",
      client_id: "07-tendermint-80",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-124",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-75",
      connection_id: "connection-79"
    },
    chain_2: {
      chain_name: "composable",
      client_id: "07-tendermint-143",
      connection_id: "connection-63"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-108",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1152",
      connection_id: "connection-873"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-623",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-38",
      connection_id: "connection-41"
    },
    chain_2: {
      chain_name: "decentr",
      client_id: "07-tendermint-21",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-113",
      connection_id: "connection-106"
    },
    chain_2: {
      chain_name: "doravota",
      client_id: "07-tendermint-22",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-146",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-91",
      connection_id: "connection-89"
    },
    chain_2: {
      chain_name: "dymension",
      client_id: "07-tendermint-39",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-123",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-45",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-40",
      connection_id: "connection-43"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-424",
      connection_id: "connection-406"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-145",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-17",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "jackal",
      client_id: "07-tendermint-61",
      connection_id: "connection-50"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }],
    operators: [{
      chain_1: {
        address: "archway16l5ls4ajah6hethh374tpgn42r5q4sqeuw8udj"
      },
      chain_2: {
        address: "jkl134a4es94hjqqej732cymf0w3988zh3c4yuqtf8"
      },
      memo: "by AM Solutions | https://www.theamsolutions.info",
      name: "AM Solutions",
      discord_handle: "AlexeyM#5409"
    }, {
      chain_1: {
        address: "archway1nms20r7jzaa4ms9exv90ckl2xfn0rd3rmqh7zm"
      },
      chain_2: {
        address: "jkl1nms20r7jzaa4ms9exv90ckl2xfn0rd3rh49t3n"
      },
      memo: "Relayed by NodeStake",
      name: "NodeStake",
      discord_handle: "nodestake"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-18",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-387",
      connection_id: "connection-379"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-290",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-12",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-144",
      connection_id: "connection-110"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-99",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-51",
      connection_id: "connection-58"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-62",
      connection_id: "connection-43"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-28",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-17",
      connection_id: "connection-26"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-22",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "nois",
      client_id: "07-tendermint-15",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-19",
        port_id: "wasm.archway10f3aasgsnpv84ymjyld50jayc4ecu267sdpjamauwm8nvxlzex9qj4dkwr"
      },
      chain_2: {
        channel_id: "channel-22",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-39",
      connection_id: "connection-42"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-49",
      connection_id: "connection-43"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-32",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2850",
      connection_id: "connection-2362"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-1",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-1429",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live"
        }
      },
      {
        chain_1: {
          channel_id: "*",
          port_id: "wasm.*"
        },
        chain_2: {
          channel_id: "*",
          port_id: "icahost"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live"
        }
      },
      {
        chain_1: {
          channel_id: "*",
          port_id: "wasm.*"
        },
        chain_2: {
          channel_id: "*",
          port_id: "icqhost"
        },
        ordering: "unordered",
        version: "icq-1",
        tags: {
          status: "live"
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-82",
      connection_id: "connection-83"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-561",
      connection_id: "connection-486"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-112",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-36",
      connection_id: "connection-39"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-83",
      connection_id: "connection-58"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-55",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "qwoyn",
      client_id: "07-tendermint-8",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "astrovault"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-24",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-169",
      connection_id: "connection-119"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-84",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-42",
      connection_id: "connection-47"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-384",
      connection_id: "connection-360"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-265",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-6",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-228",
      connection_id: "connection-190"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-97",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-80",
      connection_id: "connection-81"
    },
    chain_2: {
      chain_name: "vidulum",
      client_id: "07-tendermint-49",
      connection_id: "connection-46"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-110",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
zp.default = o$;
var qp = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Nn, "__esModule", { value: !0 });
Nn.ibc = Nn.chain = Nn.assets = void 0;
const r$ = qp(Fp), i$ = qp($p), c$ = qp(zp);
Nn.assets = r$.default;
Nn.chain = i$.default;
Nn.ibc = c$.default;
var Pn = {}, Sp = {};
Object.defineProperty(Sp, "__esModule", { value: !0 });
const d$ = {
  $schema: "../assetlist.schema.json",
  chain_name: "arkh",
  assets: [{
    description: "The native token of Arkhadian",
    denom_units: [{
      denom: "arkh",
      exponent: 0
    }, {
      denom: "ARKH",
      exponent: 6
    }],
    base: "arkh",
    name: "Arkh",
    display: "ARKH",
    symbol: "ARKH",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.svg",
      theme: {
        primary_color_hex: "#bdbb82"
      }
    }],
    socials: {
      website: "https://arkhadian.io/",
      twitter: "https://twitter.com/ArkhadianSas"
    }
  }]
};
Sp.default = d$;
var Tp = {};
Object.defineProperty(Tp, "__esModule", { value: !0 });
const m$ = {
  $schema: "../chain.schema.json",
  chain_name: "arkh",
  status: "live",
  network_type: "mainnet",
  website: "https://arkhadian.com/",
  pretty_name: "Arkhadian",
  chain_type: "cosmos",
  chain_id: "arkh",
  bech32_prefix: "arkh",
  daemon_name: "arkhd",
  node_home: "$HOME/.arkh",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "arkh",
      fixed_min_gas_price: 0.01,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "arkh"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.svg"
  },
  apis: {
    rpc: [{
      address: "https://asc-dataseed.arkhadian.com/",
      provider: "arkhnetwork"
    }, {
      address: "https://arkh_mainnet_rpc.chain.whenmoonwhenlambo.money",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }],
    rest: [{
      address: "https://asc-blockchain-api.arkhadian.com/",
      provider: "arkhnetwork"
    }, {
      address: "https://arkh_mainnet_api.chain.whenmoonwhenlambo.money",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }],
    grpc: [{
      address: "grpc.arkh.nodestake.top:443",
      provider: "NodeStake"
    }, {
      address: "https://grpc.arkh.nodexcapital.com:443",
      provider: "NodeX Validator"
    }]
  },
  explorers: [
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/arkh",
      tx_page: "https://explorer.nodestake.top/arkh/tx/${txHash}"
    },
    {
      kind: "Kynraze Explorer",
      url: "https://explorer.kynraze.com/arkhadian",
      tx_page: "https://explorer.kynraze.com/arkhadian/tx/${txHash}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodexcapital.com/arkhadian",
      tx_page: "https://explorer.nodexcapital.com/arkhadian/tx/${txHash}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/arkhadian",
      tx_page: "https://explorer.whenmoonwhenlambo.money/arkhadian/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/arkhadian/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.svg",
    theme: {
      primary_color_hex: "#bdbb82"
    }
  }]
};
Tp.default = m$;
var Rp = {};
Object.defineProperty(Rp, "__esModule", { value: !0 });
const h$ = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "arkh",
    client_id: "07-tendermint-34",
    connection_id: "connection-27"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2697",
    connection_id: "connection-2235"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-12",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-648",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Rp.default = h$;
var Op = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Pn, "__esModule", { value: !0 });
Pn.ibc = Pn.chain = Pn.assets = void 0;
const p$ = Op(Sp), l$ = Op(Tp), g$ = Op(Rp);
Pn.assets = p$.default;
Pn.chain = l$.default;
Pn.ibc = g$.default;
var Un = {}, Mp = {};
Object.defineProperty(Mp, "__esModule", { value: !0 });
const u$ = {
  $schema: "../assetlist.schema.json",
  chain_name: "assetmantle",
  assets: [{
    description: "The native token of Asset Mantle",
    denom_units: [{
      denom: "umntl",
      exponent: 0
    }, {
      denom: "mntl",
      exponent: 6
    }],
    base: "umntl",
    name: "AssetMantle",
    display: "mntl",
    symbol: "MNTL",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/mntl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/mntl.svg"
    },
    coingecko_id: "assetmantle",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/mntl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/mntl.svg",
      theme: {
        primary_color_hex: "#edb548"
      }
    }],
    socials: {
      website: "https://www.assetmantle.one/",
      twitter: "https://twitter.com/AssetMantle"
    }
  }]
};
Mp.default = u$;
var Ip = {};
Object.defineProperty(Ip, "__esModule", { value: !0 });
const _$ = {
  $schema: "../chain.schema.json",
  chain_name: "assetmantle",
  status: "live",
  network_type: "mainnet",
  website: "https://assetmantle.one/",
  pretty_name: "AssetMantle",
  chain_type: "cosmos",
  chain_id: "mantle-1",
  bech32_prefix: "mantle",
  daemon_name: "mantleNode",
  node_home: "$HOME/.mantleNode",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "umntl",
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "umntl"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/AM_Logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/AM_Logo_Dark.svg"
  },
  description: "AssetMantle’s suite of products is focused on the NFT ecosystem, helping you up your game with digital asset ownership.",
  apis: {
    rpc: [
      {
        address: "https://rpc.assetmantle.one",
        provider: "AssetMantle"
      },
      {
        address: "https://rpc-assetmantle.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://assetmantle-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc.assetmantle.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rpc-assetmantle-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc.mantle.paranorm.pro:443",
        provider: "paranorm"
      },
      {
        address: "https://assetmantle-rpc.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://assetmantle-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://rest.assetmantle.one",
        provider: "AssetMantle"
      },
      {
        address: "https://rest-assetmantle.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://api.assetmantle.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://api-assetmantle-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "https://assetmantle-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://api.mantle.paranorm.pro:443",
        provider: "paranorm"
      },
      {
        address: "https://assetmantle-rest.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://assetmantle-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "grpc.assetmantle.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "grpc-assetmantle-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "assetmantle-grpc.polkachu.com:14690",
        provider: "Polkachu"
      },
      {
        address: "assetmantle-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "assetmantle-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/assetmantle",
      tx_page: "https://ezstaking.app/assetmantle/txs/${txHash}",
      account_page: "https://ezstaking.app/assetmantle/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/asset-mantle",
      tx_page: "https://www.mintscan.io/asset-mantle/transactions/${txHash}",
      account_page: "https://www.mintscan.io/asset-mantle/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.postcapitalist.io/AssetMantle",
      tx_page: "https://explorer.postcapitalist.io/AssetMantle/tx/${txHash}"
    },
    {
      kind: "other",
      url: "https://explorer.assetmantle.one",
      tx_page: "https://explorer.assetmantle.one/transactions/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://assetmantle.explorers.guru",
      tx_page: "https://assetmantle.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/assetmantle",
      tx_page: "https://atomscan.com/assetmantle/transactions/${txHash}",
      account_page: "https://atomscan.com/assetmantle/accounts/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/assetmantle",
      tx_page: "https://mainnet.whispernode.com/assetmantle/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/assetmantle/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/AM_Logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/AM_Logo_Dark.svg",
    theme: {
      primary_color_hex: "#f6b620"
    }
  }]
};
Ip.default = _$;
var Np = {};
Object.defineProperty(Np, "__esModule", { value: !0 });
const y$ = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "assetmantle",
      client_id: "07-tendermint-22",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-167",
      connection_id: "connection-113"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-83",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "assetmantle",
      client_id: "07-tendermint-50",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-104",
      connection_id: "connection-73"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "assetmantle",
      client_id: "07-tendermint-42",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "okexchain",
      client_id: "07-tendermint-92",
      connection_id: "connection-35"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "assetmantle",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1923",
      connection_id: "connection-1498"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-232",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
Np.default = y$;
var Pp = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Un, "__esModule", { value: !0 });
Un.ibc = Un.chain = Un.assets = void 0;
const b$ = Pp(Mp), v$ = Pp(Ip), f$ = Pp(Np);
Un.assets = b$.default;
Un.chain = v$.default;
Un.ibc = f$.default;
var Hn = {}, Up = {};
Object.defineProperty(Up, "__esModule", { value: !0 });
const w$ = {
  $schema: "../assetlist.schema.json",
  chain_name: "aura",
  assets: [{
    description: "The native token of Aura Network",
    denom_units: [{
      denom: "uaura",
      exponent: 0
    }, {
      denom: "aura",
      exponent: 6
    }],
    base: "uaura",
    name: "Aura",
    display: "aura",
    symbol: "AURA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.svg"
    },
    coingecko_id: "aura-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.svg",
      theme: {
        primary_color_hex: "#a7c8d4"
      }
    }]
  }]
};
Up.default = w$;
var Hp = {};
Object.defineProperty(Hp, "__esModule", { value: !0 });
const x$ = {
  $schema: "../chain.schema.json",
  chain_name: "aura",
  status: "live",
  network_type: "mainnet",
  website: "https://aura.network/",
  pretty_name: "Aura Network",
  chain_type: "cosmos",
  chain_id: "aura_6322-2",
  bech32_prefix: "aura",
  daemon_name: "aurad",
  node_home: "$HOME/.aura",
  pre_fork_chain_name: "aura1",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uaura",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 1e-3,
      average_gas_price: 2e-3,
      high_gas_price: 25e-4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uaura"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {
    cosmos_sdk_version: "evmos/cosmos-sdk v0.47.12-evmos",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.42.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.aura.network/",
        provider: "Aura Network Foundation"
      },
      {
        address: "https://m-aura.rpc.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "http://aura.rpc.m.stavr.tech:11047",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://aura-rpc.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://aura.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://mainnet-aura-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://rpc.lavenderfive.com:443/aura",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://aura-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://rpc.aura.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://rpc.aura.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://rpc-aura.mms.team",
        provider: "MMS"
      },
      {
        address: "https://aura-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://aura-rpc.palamar.io",
        provider: "Palamar"
      },
      {
        address: "https://aura.rpc.srv.stakr.space",
        provider: "STAKR.space"
      },
      {
        address: "https://aura-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://aura-rpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [
      {
        address: "https://lcd.aura.network/",
        provider: "Aura Network Foundation"
      },
      {
        address: "https://m-aura.api.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://aura.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://aura-api.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://aura.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://mainnet-aura-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://aura-api.tienthuattoan.ventures",
        provider: "TienThuatToan"
      },
      {
        address: "https://rest.lavenderfive.com:443/aura",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://aura-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://api.aura.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://api.aura.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://api-aura.mms.team",
        provider: "MMS"
      },
      {
        address: "https://aura-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://aura-api.palamar.io",
        provider: "Palamar"
      },
      {
        address: "https://aura.api.srv.stakr.space",
        provider: "STAKR.space"
      },
      {
        address: "https://aura-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://aura-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "https://grpc.aura.network",
        provider: "Aura Network Foundation"
      },
      {
        address: "auranetwork-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://grpc.aura.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "aura.mainnet.grpc.nodersteam.com:9100/",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://aura-grpc.ramuchi.tech:15000",
        provider: "ramuchi.tech"
      },
      {
        address: "http://aura.grpc.m.stavr.tech:9901",
        provider: "🔥STAVR🔥"
      },
      {
        address: "aura.grpc.kjnodes.com:11790",
        provider: "kjnodes"
      },
      {
        address: "aura-grpc.tienthuattoan.ventures:9090",
        provider: "TienThuatToan"
      },
      {
        address: "aura.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "services.staketab.com:9021",
        provider: "Staketab"
      },
      {
        address: "grpc.aura.silentvalidator.com:443",
        provider: "silent"
      },
      {
        address: "grpc-aura.mms.team:443",
        provider: "MMS"
      },
      {
        address: "aura-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "grpc.aura.safeblock.space:9090",
        provider: "Safe Block"
      },
      {
        address: "aura-grpc.palamar.io:443",
        provider: "Palamar"
      },
      {
        address: "aura.grpc.srv.stakr.space:19090",
        provider: "STAKR.space"
      },
      {
        address: "aura-grpc.noders.services:17090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "aurascan",
      url: "https://aurascan.io",
      tx_page: "https://aurascan.io/tx/${txHash}",
      account_page: "https://aurascan.io/address/${accountAddress}"
    },
    {
      kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀 Explorer",
      url: "https://exp.utsa.tech/aura",
      tx_page: "https://exp.utsa.tech/aura/tx/${txHash}",
      account_page: "https://exp.utsa.tech/aura/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/Aura-Mainnet",
      tx_page: "https://explorer.stavr.tech/aura-mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/aura-mainnet/account/${accountAddress}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/aura",
      tx_page: "https://explorer.nodestake.top/aura/tx/${txHash}",
      account_page: "https://explorer.nodestake.top/aura/account/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/aura",
      tx_page: "https://explorer.tcnetwork.io/aura/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/aura/account/${accountAddress}"
    },
    {
      kind: "Stake-Take",
      url: "https://explorer.stake-take.com/aura",
      tx_page: "https://explorer.stake-take.com/aura/tx/${txHash}",
      account_page: "https://explorer.stake-take.com/aura/account/${accountAddress}"
    },
    {
      kind: "Safe Block",
      url: "https://explorer.safeblock.space/aura",
      tx_page: "https://explorer.safeblock.space/aura/tx/${txHash}",
      account_page: "https://explorer.safeblock.space/aura/account/${accountAddress}"
    },
    {
      kind: "STAKR.space explorer",
      url: "https://explorer.stakr.space/aura/",
      tx_page: "https://explorer.stakr.space/aura/tx/${txHash}",
      account_page: "https://explorer.stakr.space/aura/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.svg",
    theme: {
      primary_color_hex: "#a7c8d4"
    }
  }]
};
Hp.default = x$;
var Lp = {};
Object.defineProperty(Lp, "__esModule", { value: !0 });
const k$ = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-17",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "axelar",
      client_id: "07-tendermint-152",
      connection_id: "connection-137"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-104",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-24",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1158",
      connection_id: "connection-880"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-646",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-26",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-133",
      connection_id: "connection-168"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-124",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-43",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-66",
      connection_id: "connection-63"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-13",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "nois",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-8",
        port_id: "wasm.aura1r3zgdsn3dcze07a4r60rxxx7ppvkxfshn9np0pwtkgarrld0786s72jtjt"
      },
      chain_2: {
        channel_id: "channel-35",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-47",
      connection_id: "connection-33"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3054",
      connection_id: "connection-2551"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11304",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-48",
      connection_id: "connection-47"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-339",
      connection_id: "connection-288"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-270",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-24",
        port_id: "wasm.aura1y3244guwexyvn6yx6kqkj5s0f56lzfdnuja3culygnuwxgrxyuqsaz4xvv"
      },
      chain_2: {
        channel_id: "channel-271",
        port_id: "wasm.stars1r0a8ygvnjfaegy4n5z9325e0ew9uy2s7rn4vt7qf4ltv49fj4tnsk6pvtv"
      },
      ordering: "unordered",
      version: "ics721-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Lp.default = k$;
var Wp = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Hn, "__esModule", { value: !0 });
Hn.ibc = Hn.chain = Hn.assets = void 0;
const A$ = Wp(Up), j$ = Wp(Hp), C$ = Wp(Lp);
Hn.assets = A$.default;
Hn.chain = j$.default;
Hn.ibc = C$.default;
var Vo = {}, Vp = {};
Object.defineProperty(Vp, "__esModule", { value: !0 });
const E$ = {
  $schema: "../assetlist.schema.json",
  chain_name: "aura1",
  assets: [{
    description: "The native token of Aura Network",
    denom_units: [{
      denom: "uaura",
      exponent: 0
    }, {
      denom: "aura",
      exponent: 6
    }],
    base: "uaura",
    name: "Aura",
    display: "aura",
    symbol: "AURA",
    traces: [{
      type: "additional-mintage",
      counterparty: {
        chain_name: "aura",
        base_denom: "uaura"
      },
      provider: "Aura"
    }],
    coingecko_id: "aura-network",
    images: [{
      image_sync: {
        chain_name: "aura",
        base_denom: "uaura"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.svg",
      theme: {
        primary_color_hex: "#a7c8d4"
      }
    }]
  }]
};
Vp.default = E$;
var Gp = {};
Object.defineProperty(Gp, "__esModule", { value: !0 });
const D$ = {
  $schema: "../chain.schema.json",
  chain_name: "aura1",
  status: "killed",
  network_type: "mainnet",
  website: "https://aura.network/",
  pretty_name: "Aura Network",
  chain_type: "cosmos",
  chain_id: "xstaxy-1",
  bech32_prefix: "aura",
  daemon_name: "aurad",
  node_home: "$HOME/.aura",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uaura",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 1e-3,
      average_gas_price: 2e-3,
      high_gas_price: 25e-4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uaura"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.47.5",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.42.0"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.aura.network/",
        provider: "Aura Network Foundation"
      },
      {
        address: "https://m-aura.rpc.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "http://aura.rpc.m.stavr.tech:11047",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://aura-rpc.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://aura.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://mainnet-aura-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://aura-rpc.tienthuattoan.ventures",
        provider: "TienThuatToan"
      },
      {
        address: "https://rpc.lavenderfive.com:443/aura",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://aura-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://rpc.aura.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://rpc.aura.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://rpc-aura.mms.team",
        provider: "MMS"
      },
      {
        address: "https://aura-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://aura-rpc.palamar.io",
        provider: "Palamar"
      },
      {
        address: "https://aura.rpc.srv.stakr.space",
        provider: "STAKR.space"
      },
      {
        address: "https://aura-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://aura-rpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [
      {
        address: "https://lcd.aura.network/",
        provider: "Aura Network Foundation"
      },
      {
        address: "https://m-aura.api.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://aura.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://aura-api.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://aura.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://mainnet-aura-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://aura-api.tienthuattoan.ventures",
        provider: "TienThuatToan"
      },
      {
        address: "https://rest.lavenderfive.com:443/aura",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://aura-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://api.aura.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://api.aura.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://api-aura.mms.team",
        provider: "MMS"
      },
      {
        address: "https://aura-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://aura-api.palamar.io",
        provider: "Palamar"
      },
      {
        address: "https://aura.api.srv.stakr.space",
        provider: "STAKR.space"
      },
      {
        address: "https://aura-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://aura-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "https://grpc.aura.network",
        provider: "Aura Network Foundation"
      },
      {
        address: "auranetwork-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://grpc.aura.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "aura.mainnet.grpc.nodersteam.com:9100/",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://aura-grpc.ramuchi.tech:15000",
        provider: "ramuchi.tech"
      },
      {
        address: "http://aura.grpc.m.stavr.tech:9901",
        provider: "🔥STAVR🔥"
      },
      {
        address: "aura.grpc.kjnodes.com:11790",
        provider: "kjnodes"
      },
      {
        address: "aura-grpc.tienthuattoan.ventures:9090",
        provider: "TienThuatToan"
      },
      {
        address: "aura.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "services.staketab.com:9021",
        provider: "Staketab"
      },
      {
        address: "grpc.aura.silentvalidator.com:443",
        provider: "silent"
      },
      {
        address: "grpc-aura.mms.team:443",
        provider: "MMS"
      },
      {
        address: "aura-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "grpc.aura.safeblock.space:9090",
        provider: "Safe Block"
      },
      {
        address: "aura-grpc.palamar.io:443",
        provider: "Palamar"
      },
      {
        address: "aura.grpc.srv.stakr.space:19090",
        provider: "STAKR.space"
      },
      {
        address: "aura-grpc.noders.services:17090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "aurascan",
      url: "https://aurascan.io",
      tx_page: "https://aurascan.io/transaction/${txHash}",
      account_page: "https://aurascan.io/account/${accountAddress}"
    },
    {
      kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀 Explorer",
      url: "https://exp.utsa.tech/aura",
      tx_page: "https://exp.utsa.tech/aura/tx/${txHash}",
      account_page: "https://exp.utsa.tech/aura/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/Aura-Mainnet",
      tx_page: "https://explorer.stavr.tech/aura-mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/aura-mainnet/account/${accountAddress}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/aura",
      tx_page: "https://explorer.nodestake.top/aura/tx/${txHash}",
      account_page: "https://explorer.nodestake.top/aura/account/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/aura",
      tx_page: "https://explorer.tcnetwork.io/aura/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/aura/account/${accountAddress}"
    },
    {
      kind: "Stake-Take",
      url: "https://explorer.stake-take.com/aura",
      tx_page: "https://explorer.stake-take.com/aura/tx/${txHash}",
      account_page: "https://explorer.stake-take.com/aura/account/${accountAddress}"
    },
    {
      kind: "Safe Block",
      url: "https://explorer.safeblock.space/aura",
      tx_page: "https://explorer.safeblock.space/aura/tx/${txHash}",
      account_page: "https://explorer.safeblock.space/aura/account/${accountAddress}"
    },
    {
      kind: "STAKR.space explorer",
      url: "https://explorer.stakr.space/aura/",
      tx_page: "https://explorer.stakr.space/aura/tx/${txHash}",
      account_page: "https://explorer.stakr.space/aura/account/${accountAddress}"
    }
  ],
  images: [{
    image_sync: {
      chain_name: "aura"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.svg",
    theme: {
      primary_color_hex: "#a7c8d4"
    }
  }]
};
Gp.default = D$;
var b9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Vo, "__esModule", { value: !0 });
Vo.chain = Vo.assets = void 0;
const B$ = b9(Vp), F$ = b9(Gp);
Vo.assets = B$.default;
Vo.chain = F$.default;
var Ln = {}, Kp = {};
Object.defineProperty(Kp, "__esModule", { value: !0 });
const $$ = {
  $schema: "../assetlist.schema.json",
  chain_name: "axelar",
  assets: [
    {
      description: "Axelar is a decentralized interoperability network connecting multiple blockchain ecosystems, enabling seamless cross-chain communication and value transfer.",
      extended_description: `Axelar is a decentralized interoperability network connecting diverse blockchain ecosystems, facilitating seamless cross-chain communication and value transfer. By providing a unified platform for different blockchains to interact, Axelar enhances the connectivity and functionality of the blockchain space. The network employs advanced cryptographic protocols and consensus mechanisms to ensure the security and reliability of cross-chain transactions.

The Axelar Network's native token, AXL, is used for transaction fees, incentivizing network validators, and governance. By staking AXL, users can secure the network and earn rewards while influencing key decisions regarding the platform's development. Axelar's focus on interoperability extends to supporting various blockchain protocols, enabling developers to build applications operating across multiple chains. This capability is crucial for the growth of decentralized finance (DeFi) and other blockchain-based solutions, making Axelar vital to the evolving blockchain ecosystem.`,
      denom_units: [{
        denom: "uaxl",
        exponent: 0
      }, {
        denom: "axl",
        exponent: 6
      }],
      base: "uaxl",
      name: "Axelar",
      display: "axl",
      symbol: "AXL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg"
      },
      coingecko_id: "axelar",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      socials: {
        website: "https://axelar.network/",
        twitter: "https://twitter.com/axelarnetwork"
      }
    },
    {
      description: "Circle's stablecoin on Axelar",
      denom_units: [{
        denom: "uusdc",
        exponent: 0
      }, {
        denom: "usdc",
        exponent: 6
      }],
      base: "uusdc",
      name: "USD Coin",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg"
      },
      coingecko_id: "axlusdc",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
        theme: {
          primary_color_hex: "#2474cc"
        }
      }]
    },
    {
      description: "Frax's fractional-algorithmic stablecoin on Axelar",
      denom_units: [{
        denom: "frax-wei",
        exponent: 0
      }, {
        denom: "frax",
        exponent: 18
      }],
      base: "frax-wei",
      name: "Frax",
      display: "frax",
      symbol: "FRAX",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x853d955acef822db058eb8505911ed77f175b99e"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x853d955acef822db058eb8505911ed77f175b99e"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg"
      }]
    },
    {
      description: "Dai stablecoin on Axelar",
      denom_units: [{
        denom: "dai-wei",
        exponent: 0
      }, {
        denom: "dai",
        exponent: 18
      }],
      base: "dai-wei",
      name: "Dai Stablecoin",
      display: "dai",
      symbol: "DAI",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/dai.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/dai.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/dai.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/dai.svg",
        theme: {
          primary_color_hex: "#f4ac34"
        }
      }]
    },
    {
      description: "Tether's USD stablecoin on Axelar",
      denom_units: [{
        denom: "uusdt",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      base: "uusdt",
      name: "Tether USD",
      display: "usdt",
      symbol: "USDT",
      coingecko_id: "axelar-usdt",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdt.svg",
        theme: {
          primary_color_hex: "#54ac94"
        }
      }]
    },
    {
      description: "Wrapped Ether on Axelar",
      denom_units: [{
        denom: "weth-wei",
        exponent: 0
      }, {
        denom: "weth",
        exponent: 18
      }],
      base: "weth-wei",
      name: "Wrapped Ether",
      display: "weth",
      symbol: "WETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/weth.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/weth.png",
        theme: {
          primary_color_hex: "#3a3444"
        }
      }]
    },
    {
      description: "Wrapped Bitcoin on Axelar",
      denom_units: [{
        denom: "wbtc-satoshi",
        exponent: 0
      }, {
        denom: "wbtc",
        exponent: 8
      }],
      base: "wbtc-satoshi",
      name: "Wrapped Bitcoin",
      display: "wbtc",
      symbol: "WBTC",
      coingecko_id: "axlwbtc",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/wbtc.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/wbtc.png",
        theme: {
          primary_color_hex: "#41394d"
        }
      }]
    },
    {
      description: "Aave on Axelar",
      denom_units: [{
        denom: "aave-wei",
        exponent: 0
      }, {
        denom: "aave",
        exponent: 18
      }],
      base: "aave-wei",
      name: "Aave",
      display: "aave",
      symbol: "AAVE",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/aave.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/aave.svg"
      }]
    },
    {
      description: "ApeCoin on Axelar",
      denom_units: [{
        denom: "ape-wei",
        exponent: 0
      }, {
        denom: "ape",
        exponent: 18
      }],
      base: "ape-wei",
      name: "ApeCoin",
      display: "ape",
      symbol: "APE",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x4d224452801aced8b2f0aebe155379bb5d594381"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ape.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x4d224452801aced8b2f0aebe155379bb5d594381"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ape.svg"
      }]
    },
    {
      description: "Axie Infinity Shard on Axelar",
      denom_units: [{
        denom: "axs-wei",
        exponent: 0
      }, {
        denom: "axs",
        exponent: 18
      }],
      base: "axs-wei",
      name: "Axie Infinity Shard",
      display: "axs",
      symbol: "AXS",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/axs.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/axs.svg"
      }]
    },
    {
      description: "Chainlink on Axelar",
      denom_units: [{
        denom: "link-wei",
        exponent: 0
      }, {
        denom: "link",
        exponent: 18
      }],
      base: "link-wei",
      name: "Chainlink",
      display: "link",
      symbol: "LINK",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x514910771af9ca656af840dff83e8264ecf986ca"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x514910771af9ca656af840dff83e8264ecf986ca"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.svg",
        theme: {
          primary_color_hex: "#2c5cdc"
        }
      }]
    },
    {
      description: "Maker on Axelar",
      denom_units: [{
        denom: "mkr-wei",
        exponent: 0
      }, {
        denom: "mkr",
        exponent: 18
      }],
      base: "mkr-wei",
      name: "Maker",
      display: "mkr",
      symbol: "MKR",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/mkr.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/mkr.svg"
      }]
    },
    {
      description: "Rai Reflex Index on Axelar",
      denom_units: [{
        denom: "rai-wei",
        exponent: 0
      }, {
        denom: "rai",
        exponent: 18
      }],
      base: "rai-wei",
      name: "Rai Reflex Index",
      display: "rai",
      symbol: "RAI",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/rai.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/rai.svg"
      }]
    },
    {
      description: "Shiba Inu on Axelar",
      denom_units: [{
        denom: "shib-wei",
        exponent: 0
      }, {
        denom: "shib",
        exponent: 18
      }],
      base: "shib-wei",
      name: "Shiba Inu",
      display: "shib",
      symbol: "SHIB",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/shib.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/shib.svg",
        theme: {
          primary_color_hex: "#FFA409",
          background_color_hex: "#00000000"
        }
      }]
    },
    {
      description: "Lido Staked Ether on Axelar",
      denom_units: [{
        denom: "steth-wei",
        exponent: 0
      }, {
        denom: "steth",
        exponent: 18
      }],
      base: "steth-wei",
      name: "Lido Staked Ether",
      display: "steth",
      symbol: "stETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/steth.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/steth.svg"
      }]
    },
    {
      description: "Uniswap on Axelar",
      denom_units: [{
        denom: "uni-wei",
        exponent: 0
      }, {
        denom: "uni",
        exponent: 18
      }],
      base: "uni-wei",
      name: "Uniswap",
      display: "uni",
      symbol: "UNI",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/uni.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/uni.svg"
      }]
    },
    {
      description: "Chain on Axelar",
      denom_units: [{
        denom: "xcn-wei",
        exponent: 0
      }, {
        denom: "xcn",
        exponent: 18
      }],
      base: "xcn-wei",
      name: "Chain",
      display: "xcn",
      symbol: "XCN",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/xcn.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/xcn.svg"
      }]
    },
    {
      description: "Wrapped Polkadot on Axelar",
      denom_units: [{
        denom: "dot-planck",
        exponent: 0
      }, {
        denom: "dot",
        exponent: 10
      }],
      base: "dot-planck",
      name: "Wrapped Polkadot",
      display: "dot",
      symbol: "DOT",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "moonbeam",
          base_denom: "0xffffffff1fcacbd218edc0eba20fc2308c778080"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg"
      },
      images: [{
        image_sync: {
          chain_name: "moonbeam",
          base_denom: "0xffffffff1fcacbd218edc0eba20fc2308c778080"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg",
        theme: {
          primary_color_hex: "#e4047c"
        }
      }]
    },
    {
      description: "Wrapped Moonbeam on Axelar",
      denom_units: [{
        denom: "wglmr-wei",
        exponent: 0
      }, {
        denom: "wglmr",
        exponent: 18
      }],
      base: "wglmr-wei",
      name: "Wrapped Moonbeam",
      display: "wglmr",
      symbol: "WGLMR",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "moonbeam",
          base_denom: "0xacc15dc74880c9944775448304b263d191c6077f"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/moonbeam/images/glmr.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/moonbeam/images/glmr.svg"
      },
      images: [{
        image_sync: {
          chain_name: "moonbeam",
          base_denom: "0xacc15dc74880c9944775448304b263d191c6077f"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/moonbeam/images/glmr.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/moonbeam/images/glmr.svg",
        theme: {
          primary_color_hex: "#e4147c"
        }
      }]
    },
    {
      description: "Wrapped Matic on Axelar",
      denom_units: [{
        denom: "wmatic-wei",
        exponent: 0
      }, {
        denom: "wmatic",
        exponent: 18
      }],
      base: "wmatic-wei",
      name: "Wrapped Matic",
      display: "wmatic",
      symbol: "WMATIC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "polygon",
          base_denom: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polygon/images/wmatic.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polygon/images/wmatic.svg"
      },
      images: [{
        image_sync: {
          chain_name: "polygon",
          base_denom: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polygon/images/wmatic.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polygon/images/wmatic.svg",
        theme: {
          primary_color_hex: "#2b93fb"
        }
      }]
    },
    {
      description: "Wrapped BNB on Axelar",
      denom_units: [{
        denom: "wbnb-wei",
        exponent: 0
      }, {
        denom: "wbnb",
        exponent: 18
      }],
      base: "wbnb-wei",
      name: "Wrapped BNB",
      display: "wbnb",
      symbol: "WBNB",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "binancesmartchain",
          base_denom: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/wbnb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/wbnb.svg"
      },
      images: [{
        image_sync: {
          chain_name: "binancesmartchain",
          base_denom: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/wbnb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/wbnb.svg",
        theme: {
          primary_color_hex: "#f3bb0c"
        }
      }]
    },
    {
      description: "Binance USD on Axelar.",
      denom_units: [{
        denom: "busd-wei",
        exponent: 0
      }, {
        denom: "busd",
        exponent: 18
      }],
      base: "busd-wei",
      name: "Binance USD",
      display: "busd",
      symbol: "BUSD",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x4fabb145d64652a948d72533023f6e7a623c7c53"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x4fabb145d64652a948d72533023f6e7a623c7c53"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.svg",
        theme: {
          primary_color_hex: "#f3bb0c"
        }
      }]
    },
    {
      description: "Wrapped AVAX on Axelar.",
      denom_units: [{
        denom: "wavax-wei",
        exponent: 0
      }, {
        denom: "avax",
        exponent: 18
      }],
      base: "wavax-wei",
      name: "Wrapped AVAX",
      display: "avax",
      symbol: "WAVAX",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "avalanche",
          base_denom: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/wavax.svg"
      },
      images: [{
        image_sync: {
          chain_name: "avalanche",
          base_denom: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/wavax.svg"
      }]
    },
    {
      description: "Wrapped FTM on Axelar.",
      denom_units: [{
        denom: "wftm-wei",
        exponent: 0
      }, {
        denom: "ftm",
        exponent: 18
      }],
      base: "wftm-wei",
      name: "Wrapped FTM",
      display: "ftm",
      symbol: "WFTM",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "fantom",
          base_denom: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/fantom/images/ftm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/fantom/images/ftm.svg"
      },
      images: [{
        image_sync: {
          chain_name: "fantom",
          base_denom: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/fantom/images/ftm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/fantom/images/ftm.svg",
        theme: {
          primary_color_hex: "#1c6cfc"
        }
      }]
    },
    {
      description: "Circle's stablecoin from Polygon on Axelar",
      denom_units: [{
        denom: "polygon-uusdc",
        exponent: 0
      }, {
        denom: "polygon-usdc",
        exponent: 6
      }],
      base: "polygon-uusdc",
      name: "USD Coin from Polygon",
      display: "polygon-usdc",
      symbol: "USDC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "polygon",
          base_denom: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
        theme: {
          primary_color_hex: "#2474cc"
        }
      }]
    },
    {
      description: "Circle's stablecoin from Avalanche on Axelar",
      denom_units: [{
        denom: "avalanche-uusdc",
        exponent: 0
      }, {
        denom: "avalanche-usdc",
        exponent: 6
      }],
      base: "avalanche-uusdc",
      name: "USD Coin from Avalanche",
      display: "avalanche-usdc",
      symbol: "USDC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "avalanche",
          base_denom: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
        theme: {
          primary_color_hex: "#2474cc"
        }
      }]
    },
    {
      description: "Wrapped FIL on Axelar",
      denom_units: [{
        denom: "wfil-wei",
        exponent: 0
      }, {
        denom: "fil",
        exponent: 18
      }],
      base: "wfil-wei",
      name: "Wrapped FIL from Filecoin",
      display: "fil",
      symbol: "axlFIL",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "filecoin",
          base_denom: "0x60E1773636CF5E4A227d9AC24F20fEca034ee25A"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/filecoin/images/wfil.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/filecoin/images/wfil.svg"
      },
      images: [{
        image_sync: {
          chain_name: "filecoin",
          base_denom: "0x60E1773636CF5E4A227d9AC24F20fEca034ee25A"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/filecoin/images/wfil.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/filecoin/images/wfil.svg",
        theme: {
          primary_color_hex: "#0694fc"
        }
      }]
    },
    {
      description: "Arbitrum on Axelar",
      denom_units: [{
        denom: "arb-wei",
        exponent: 0
      }, {
        denom: "arb",
        exponent: 18
      }],
      base: "arb-wei",
      name: "Arbitrum",
      display: "arb",
      symbol: "ARB",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "arbitrum",
          base_denom: "0x912CE59144191C1204E64559FE8253a0e49E6548"
        },
        provider: "Axelar"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/arbitrum/images/arb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/arbitrum/images/arb.svg"
      },
      images: [{
        image_sync: {
          chain_name: "arbitrum",
          base_denom: "0x912CE59144191C1204E64559FE8253a0e49E6548"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/arbitrum/images/arb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/arbitrum/images/arb.svg",
        theme: {
          primary_color_hex: "#253545"
        }
      }]
    },
    {
      denom_units: [{
        denom: "pepe-wei",
        exponent: 0,
        aliases: ["0x6982508145454Ce325dDbE47a25d4ec3d2311933"]
      }, {
        denom: "pepe",
        exponent: 18
      }],
      base: "pepe-wei",
      name: "Pepe",
      display: "pepe",
      symbol: "PEPE",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x6982508145454Ce325dDbE47a25d4ec3d2311933"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x6982508145454Ce325dDbE47a25d4ec3d2311933"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.svg",
        theme: {
          primary_color_hex: "#cc3233"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.svg"
      }
    },
    {
      denom_units: [{
        denom: "cbeth-wei",
        exponent: 0,
        aliases: ["0xbe9895146f7af43049ca1c1ae358b0541ea49704"]
      }, {
        denom: "cbeth",
        exponent: 18
      }],
      base: "cbeth-wei",
      name: "Coinbase Wrapped Staked ETH",
      display: "cbeth",
      symbol: "cbETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xbe9895146f7af43049ca1c1ae358b0541ea49704"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xbe9895146f7af43049ca1c1ae358b0541ea49704"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/cbeth.png",
        theme: {
          primary_color_hex: "#c9dbfc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/cbeth.png"
      }
    },
    {
      denom_units: [{
        denom: "reth-wei",
        exponent: 0,
        aliases: ["0xae78736cd615f374d3085123a210448e74fc6393"]
      }, {
        denom: "reth",
        exponent: 18
      }],
      base: "reth-wei",
      name: "Rocket Pool Ether",
      display: "reth",
      symbol: "rETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xae78736cd615f374d3085123a210448e74fc6393"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xae78736cd615f374d3085123a210448e74fc6393"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/reth.png",
        theme: {
          primary_color_hex: "#fba487"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/reth.png"
      }
    },
    {
      denom_units: [{
        denom: "sfrxeth-wei",
        exponent: 0,
        aliases: ["0xac3e018457b222d93114458476f3e3416abbe38f"]
      }, {
        denom: "sfrxeth",
        exponent: 18
      }],
      base: "sfrxeth-wei",
      name: "Staked Frax Ether",
      display: "sfrxeth",
      symbol: "sfrxETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xac3e018457b222d93114458476f3e3416abbe38f"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xac3e018457b222d93114458476f3e3416abbe38f"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrxeth.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrxeth.svg"
      }
    },
    {
      denom_units: [{
        denom: "wsteth-wei",
        exponent: 0,
        aliases: ["0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0"]
      }, {
        denom: "wsteth",
        exponent: 18
      }],
      base: "wsteth-wei",
      name: "Wrapped Lido Staked Ether",
      display: "wsteth",
      symbol: "wstETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }
    },
    {
      denom_units: [{
        denom: "yieldeth-wei",
        exponent: 0,
        aliases: ["0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec"]
      }, {
        denom: "YieldETH",
        exponent: 18
      }],
      base: "yieldeth-wei",
      name: "Real Yield Eth",
      display: "YieldETH",
      symbol: "YieldETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.svg",
        theme: {
          primary_color_hex: "#14448c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.svg"
      }
    },
    {
      denom_units: [{
        denom: "ox-wei",
        exponent: 0,
        aliases: ["0x78a0A62Fba6Fb21A83FE8a3433d44C73a4017A6f"]
      }, {
        denom: "ox",
        exponent: 18
      }],
      base: "ox-wei",
      name: "Open Exchange Token",
      display: "ox",
      symbol: "OX",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x78a0A62Fba6Fb21A83FE8a3433d44C73a4017A6f"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x78a0A62Fba6Fb21A83FE8a3433d44C73a4017A6f"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ox.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ox.svg"
      }
    },
    {
      type_asset: "sdk.coin",
      denom_units: [{
        denom: "yum-wei",
        exponent: 0,
        aliases: ["0xcE682c89C63d2850Cb2ca898E44D6c7c30d897a6"]
      }, {
        denom: "yum",
        exponent: 18
      }],
      base: "yum-wei",
      name: "Axelar Wrapped YUM",
      display: "yum",
      symbol: "YUM.axl",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xcE682c89C63d2850Cb2ca898E44D6c7c30d897a6"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xcE682c89C63d2850Cb2ca898E44D6c7c30d897a6"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yum.png",
        theme: {
          primary_color_hex: "#33a6e7"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yum.png"
      }
    },
    {
      type_asset: "sdk.coin",
      denom_units: [{
        denom: "arbitrum-weth-wei",
        exponent: 0
      }, {
        denom: "arbitrum-weth",
        exponent: 18
      }],
      base: "arbitrum-weth-wei",
      name: "Arbitrum axlETH",
      display: "arbitrum-weth",
      symbol: "axlETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "arbitrum",
          base_denom: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "arbitrum",
          base_denom: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }]
    },
    {
      type_asset: "sdk.coin",
      denom_units: [{
        denom: "base-weth-wei",
        exponent: 0
      }, {
        denom: "base-weth",
        exponent: 18
      }],
      base: "base-weth-wei",
      name: "Base axlETH",
      display: "base-weth",
      symbol: "axlETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "base",
          base_denom: "0x4200000000000000000000000000000000000006"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "base",
          base_denom: "0x4200000000000000000000000000000000000006"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }]
    },
    {
      type_asset: "sdk.coin",
      denom_units: [{
        denom: "polygon-weth-wei",
        exponent: 0
      }, {
        denom: "polygon-weth",
        exponent: 18
      }],
      base: "polygon-weth-wei",
      name: "Polygon axlETH",
      display: "polygon-weth",
      symbol: "axlETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "polygon",
          base_denom: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "polygon",
          base_denom: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }]
    },
    {
      type_asset: "sdk.coin",
      denom_units: [{
        denom: "op-wei",
        exponent: 0,
        aliases: ["0x4200000000000000000000000000000000000042"]
      }, {
        denom: "op",
        exponent: 18
      }],
      base: "op-wei",
      name: "Optimism",
      display: "op",
      symbol: "OP",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "optimism",
          base_denom: "0x4200000000000000000000000000000000000042"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "optimism",
          base_denom: "0x4200000000000000000000000000000000000042"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/optimism/images/op.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/optimism/images/op.png",
        theme: {
          primary_color_hex: "#fc0424"
        }
      }]
    }
  ]
};
Kp.default = $$;
var Xp = {};
Object.defineProperty(Xp, "__esModule", { value: !0 });
const z$ = {
  $schema: "../chain.schema.json",
  chain_name: "axelar",
  chain_type: "cosmos",
  chain_id: "axelar-dojo-1",
  pretty_name: "Axelar",
  status: "live",
  network_type: "mainnet",
  website: "https://axelar.network/",
  bech32_prefix: "axelar",
  daemon_name: "axelard",
  node_home: "$HOME/.axelar",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uaxl",
      fixed_min_gas_price: 7e-3,
      low_gas_price: 7e-3,
      average_gas_price: 7e-3,
      high_gas_price: 0.01
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uaxl"
    }]
  },
  codebase: {
    cosmos_sdk_version: "axelarnetwork/cosmos-sdk v0.45.17-0.20240321205000-47c0c80e20ca",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.33.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg"
  },
  description: "Axelar delivers secure cross-chain communication for Web3. Our infrastructure enables dApp users to interact with any asset or application, on any chain, with one click.",
  apis: {
    "grpc-web": [{
      address: "axelar-grpcweb.chainode.tech",
      provider: "Chainode"
    }, {
      address: "axelar-grpcweb.quantnode.tech:9091",
      provider: "Quantnode"
    }],
    rpc: [
      {
        address: "https://rpc-axelar.imperator.co:443",
        provider: "Imperator.co"
      },
      {
        address: "https://axelar-rpc.quickapi.com:443",
        provider: "chainlayer"
      },
      {
        address: "https://rpc-axelar.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://axelar-rpc.pops.one:443",
        provider: "p-ops"
      },
      {
        address: "https://axelar-rpc.qubelabs.io:443",
        provider: "Qubelabs"
      },
      {
        address: "https://rpc-1.axelar.nodes.guru:443",
        provider: "nodes.guru"
      },
      {
        address: "https://rpc-axelar-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://axelar-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://axelar.rpc.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://rpc.axelar.bh.rocks",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://axelar-rpc.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "https://rpc-axelar.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://axelar-rpc.quantnode.tech/",
        provider: "QuantNode"
      },
      {
        address: "https://axelar-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://axelar-rpc.rockrpc.net/",
        provider: "RockawayX Infra"
      },
      {
        address: "https://axelar-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rpc-axelar-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://axelar-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://axelar-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://axelar-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://axelar.drpc.org",
        provider: "dRPC"
      }
    ],
    rest: [
      {
        address: "https://lcd-axelar.imperator.co:443",
        provider: "Imperator.co"
      },
      {
        address: "https://axelar-lcd.quickapi.com:443",
        provider: "chainlayer"
      },
      {
        address: "https://api-axelar.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://axelar-lcd.qubelabs.io:443",
        provider: "Qubelabs"
      },
      {
        address: "https://api-1.axelar.nodes.guru:443",
        provider: "nodes.guru"
      },
      {
        address: "https://api-axelar-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://axelar-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://axelar.rest.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://api.axelar.bh.rocks",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://axelar-api.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "https://lcd-axelar.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://axelar-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://axelar-lcd.quantnode.tech/",
        provider: "QuantNode"
      },
      {
        address: "https://axelar-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://api-axelar-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://axelar-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://axelar-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://axelar-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "axelar-grpc.qubelabs.io:9092",
        provider: "Qubelabs"
      },
      {
        address: "axelar-grpc.quantnode.tech:9090",
        provider: "Quantnode"
      },
      {
        address: "services.staketab.com:9080",
        provider: "Staketab"
      },
      {
        address: "grpc-axelar.cosmos-spaces.cloud:1590",
        provider: "Cosmos Spaces"
      },
      {
        address: "grpc-axelar-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "axelar-grpc.polkachu.com:15190",
        provider: "Polkachu"
      },
      {
        address: "axelar.grpc.stakin-nodes.com:443",
        provider: "Stakin"
      },
      {
        address: "axelar-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-axelar-01.stakeflow.io:1602",
        provider: "Stakeflow"
      },
      {
        address: "axelar-grpc.w3coins.io:15190",
        provider: "w3coins"
      },
      {
        address: "grpc-axelar.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "axelar-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "axelarscan",
      url: "https://axelarscan.io",
      tx_page: "https://axelarscan.io/tx/${txHash}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/axelar",
      tx_page: "https://www.mintscan.io/axelar/transactions/${txHash}",
      account_page: "https://www.mintscan.io/axelar/accounts/${accountAddress}"
    },
    {
      kind: "explorers.guru",
      url: "https://axelar.explorers.guru",
      tx_page: "https://axelar.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/axelar",
      tx_page: "https://atomscan.com/axelar/transactions/${txHash}",
      account_page: "https://atomscan.com/axelar/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/axelar",
      account_page: "https://stakeflow.io/axelar/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/axelar",
      tx_page: "https://ezstaking.app/axelar/txs/${txHash}",
      account_page: "https://ezstaking.app/axelar/account/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/axelar",
      tx_page: "https://mainnet.whispernode.com/axelar/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/axelar/account/${accountAddress}"
    }
  ],
  images: [{
    image_sync: {
      chain_name: "axelar",
      base_denom: "uaxl"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg",
    theme: {
      primary_color_hex: "#040404"
    }
  }, {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axelar-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axelar-chain-logo.svg",
    theme: {
      primary_color_hex: "#040404",
      circle: !1
    }
  }]
};
Xp.default = z$;
var Yp = {};
Object.defineProperty(Yp, "__esModule", { value: !0 });
const q$ = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "axelar",
      client_id: "07-tendermint-78",
      connection_id: "connection-65"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-11",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "axelar",
      client_id: "07-tendermint-69",
      connection_id: "connection-51"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-16",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "axelar",
      client_id: "07-tendermint-160",
      connection_id: "connection-145"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-111",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-17",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "axelar",
      client_id: "07-tendermint-152",
      connection_id: "connection-137"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-104",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-207",
      connection_id: "connection-188"
    },
    chain_2: {
      chain_name: "bitsong",
      client_id: "07-tendermint-81",
      connection_id: "connection-56"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-145",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-185",
      connection_id: "connection-163"
    },
    chain_2: {
      chain_name: "celestia",
      client_id: "07-tendermint-9",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-125",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-203",
      connection_id: "connection-183"
    },
    chain_2: {
      chain_name: "chain4energy",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-141",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-187",
      connection_id: "connection-165"
    },
    chain_2: {
      chain_name: "composable",
      client_id: "07-tendermint-140",
      connection_id: "connection-58"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-127",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics-20",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-179",
      connection_id: "connection-157"
    },
    chain_2: {
      chain_name: "coreum",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-120",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-622",
      connection_id: "connection-481"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-293",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-31",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-197",
      connection_id: "connection-180"
    },
    chain_2: {
      chain_name: "dymension",
      client_id: "07-tendermint-7",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-138",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-158",
      connection_id: "connection-142"
    },
    chain_2: {
      chain_name: "empowerchain",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-109",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-50",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-69",
      connection_id: "connection-27"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-188",
      connection_id: "connection-166"
    },
    chain_2: {
      chain_name: "fxcore",
      client_id: "07-tendermint-24",
      connection_id: "connection-23"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-128",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-162",
      connection_id: "connection-148"
    },
    chain_2: {
      chain_name: "haqq",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-113",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-168",
      connection_id: "connection-150"
    },
    chain_2: {
      chain_name: "impacthub",
      client_id: "07-tendermint-54",
      connection_id: "connection-40"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-114",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-37",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-113",
      connection_id: "connection-93"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-84",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-69",
      connection_id: "connection-178"
    },
    chain_2: {
      chain_name: "jackal",
      client_id: "07-tendermint-69",
      connection_id: "connection-57"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-137",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-25",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-150",
      connection_id: "connection-97"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-71",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-42",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-11",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-118",
      connection_id: "connection-107"
    },
    chain_2: {
      chain_name: "kyve",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-75",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-225",
      connection_id: "connection-210"
    },
    chain_2: {
      chain_name: "lava",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-156",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-180",
      connection_id: "connection-158"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-101",
      connection_id: "connection-80"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-121",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-53",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-123",
      connection_id: "connection-110"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-78",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-200",
      connection_id: "connection-181"
    },
    chain_2: {
      chain_name: "nibiru",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-139",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-205",
      connection_id: "connection-186"
    },
    chain_2: {
      chain_name: "nolus",
      client_id: "07-tendermint-17",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-143",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10177",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-150",
      connection_id: "connection-135"
    },
    chain_2: {
      chain_name: "odin",
      client_id: "07-tendermint-66",
      connection_id: "connection-151"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-102",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-122",
      connection_id: "connection-109"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-44",
      connection_id: "connection-37"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-77",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-23",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1862",
      connection_id: "connection-1453"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-208",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-175",
      connection_id: "connection-153"
    },
    chain_2: {
      chain_name: "provenance",
      client_id: "07-tendermint-35",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-224",
      connection_id: "connection-209"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-155",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-208",
      connection_id: "connection-189"
    },
    chain_2: {
      chain_name: "saga",
      client_id: "07-tendermint-11",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-146",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-40",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-44",
      connection_id: "connection-26"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }, {
      chain_1: {
        channel_id: "channel-69",
        port_id: "transfer",
        client_id: "07-tendermint-103",
        connection_id: "connection-89"
      },
      chain_2: {
        channel_id: "channel-61",
        port_id: "wasm.secret1yxjmepvyl2c25vnt53cr2dpn8amknwausxee83",
        client_id: "07-tendermint-120",
        connection_id: "connection-93"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-151",
      connection_id: "connection-136"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-8",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-103",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-226",
      connection_id: "connection-211"
    },
    chain_2: {
      chain_name: "self",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-157",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-210",
      connection_id: "connection-191"
    },
    chain_2: {
      chain_name: "shido",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-148",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-109",
      connection_id: "connection-96"
    },
    chain_2: {
      chain_name: "sommelier",
      client_id: "07-tendermint-13",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-72",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics-20",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-229",
      connection_id: "connection-219"
    },
    chain_2: {
      chain_name: "source",
      client_id: "07-tendermint-17",
      connection_id: "connection-17"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-160",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-93",
      connection_id: "connection-78"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-75",
      connection_id: "connection-60"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-69",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-39",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-7",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-64",
      connection_id: "connection-43"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-63",
      connection_id: "connection-44"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
Yp.default = q$;
var Jp = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ln, "__esModule", { value: !0 });
Ln.ibc = Ln.chain = Ln.assets = void 0;
const S$ = Jp(Kp), T$ = Jp(Xp), R$ = Jp(Yp);
Ln.assets = S$.default;
Ln.chain = T$.default;
Ln.ibc = R$.default;
var Wn = {}, Zp = {};
Object.defineProperty(Zp, "__esModule", { value: !0 });
const O$ = {
  $schema: "../assetlist.schema.json",
  chain_name: "bandchain",
  assets: [{
    description: "The native token of BandChain",
    denom_units: [{
      denom: "uband",
      exponent: 0
    }, {
      denom: "band",
      exponent: 6
    }],
    base: "uband",
    display: "band",
    name: "Band Protocol",
    symbol: "BAND",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.svg"
    },
    coingecko_id: "band-protocol",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.svg",
      theme: {
        primary_color_hex: "#4424e4"
      }
    }],
    socials: {
      website: "https://www.bandprotocol.com/",
      twitter: "https://twitter.com/BandProtocol"
    }
  }]
};
Zp.default = O$;
var Qp = {};
Object.defineProperty(Qp, "__esModule", { value: !0 });
const M$ = {
  $schema: "../chain.schema.json",
  chain_name: "bandchain",
  status: "live",
  network_type: "mainnet",
  website: "https://bandprotocol.com/",
  pretty_name: "Band Protocol",
  chain_type: "cosmos",
  chain_id: "laozi-mainnet",
  daemon_name: "bandd",
  node_home: "$HOME/.band",
  bech32_prefix: "band",
  slip44: 494,
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "uband",
      fixed_min_gas_price: 25e-4,
      low_gas_price: 25e-4,
      average_gas_price: 3e-3,
      high_gas_price: 5e-3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uband"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.45.16"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.svg"
  },
  description: "Band Protocol is a cross-chain data oracle platform that aggregates and connects real-world data and APIs to smart contracts.",
  apis: {
    rpc: [
      {
        address: "http://rpc.laozi1.bandchain.org:80",
        provider: "bandprotocol"
      },
      {
        address: "https://rpc-bandchain-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://band-rpc.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://bandchain-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://band.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-band-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://rpc-band.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://band-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://bandprotocol-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://public.stakewolle.com/cosmos/bandchain/rpc",
        provider: "Stakewolle"
      },
      {
        address: "https://rpc.band.bronbro.io/",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://rpc.band.roomit.xyz/",
        provider: "Roomit"
      },
      {
        address: "https://band-rpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [
      {
        address: "https://laozi1.bandchain.org/api",
        provider: "bandprotocol"
      },
      {
        address: "https://api-bandchain-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://band-api.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://api-band.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://band.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://bandchain-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://api-band-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://band-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://bandprotocol-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://public.stakewolle.com/cosmos/bandchain/rest",
        provider: "Stakewolle"
      },
      {
        address: "https://lcd.band.bronbro.io/",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://api.band.roomit.xyz/",
        provider: "Roomit"
      },
      {
        address: "https://band-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "grpc-bandchain-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "bandchain-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-band.cosmos-spaces.cloud:2240",
        provider: "Cosmos Spaces"
      },
      {
        address: "grpc-band-01.stakeflow.io:2502",
        provider: "Stakeflow"
      },
      {
        address: "band-grpc.w3coins.io:22990",
        provider: "w3coins"
      },
      {
        address: "http://band.grpc.m.stavr.tech:7803",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://grpc-band.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "band.grpc.kjnodes.com:443",
        provider: "kjnodes"
      },
      {
        address: "grpc.band.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "grpc.band.roomit.xyz:8443",
        provider: "Roomit"
      },
      {
        address: "band-grpc.noders.services:30090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "cosmoscan",
      url: "https://cosmoscan.io",
      tx_page: "https://cosmoscan.io/tx/${txHash}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/band",
      tx_page: "https://www.mintscan.io/band/transactions/${txHash}",
      account_page: "https://www.mintscan.io/band/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/band-protocol",
      tx_page: "https://ping.pub/band-protocol/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Band-Mainnet",
      tx_page: "https://explorer.stavr.tech/Band-Mainnet/tx/${txHash}"
    },
    {
      kind: "Nodeist Explorer",
      url: "https://exp.nodeist.net/band",
      tx_page: "https://exp.nodeist.net/band/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/band-protocol",
      tx_page: "https://atomscan.com/band-protocol/transactions/${txHash}",
      account_page: "https://atomscan.com/band-protocol/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/band-protocol",
      account_page: "https://stakeflow.io/band-protocol/accounts/${accountAddress}"
    },
    {
      kind: "Roomit Explorer",
      url: "https://explorer.tendermint.roomit.xyz/band-mainnet",
      account_page: "https://explorer.tendermint.roomit.xyz/band-mainnet/accounts/${accountAddress}"
    },
    {
      kind: "kjnodes Explorer",
      url: "https://explorer.kjnodes.com/band",
      tx_page: "https://explorer.kjnodes.com/band/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.svg",
    theme: {
      primary_color_hex: "#4424e4"
    }
  }]
};
Qp.default = M$;
var el = {};
Object.defineProperty(el, "__esModule", { value: !0 });
const I$ = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bandchain",
      client_id: "07-tendermint-124",
      connection_id: "connection-107"
    },
    chain_2: {
      chain_name: "comdex",
      client_id: "07-tendermint-81",
      connection_id: "connection-48"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-96",
        port_id: "oracle"
      },
      chain_2: {
        channel_id: "channel-43",
        port_id: "bandoracleV1"
      },
      ordering: "unordered",
      version: "bandchain-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bandchain",
      client_id: "07-tendermint-162",
      connection_id: "connection-141"
    },
    chain_2: {
      chain_name: "coreum",
      client_id: "07-tendermint-33",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-159",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bandchain",
      client_id: "07-tendermint-94",
      connection_id: "connection-91"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1743",
      connection_id: "connection-1345"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-83",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-148",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bandchain",
      client_id: "07-tendermint-169",
      connection_id: "connection-150"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-146",
      connection_id: "connection-146"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-161",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-258",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
el.default = I$;
var nl = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Wn, "__esModule", { value: !0 });
Wn.ibc = Wn.chain = Wn.assets = void 0;
const N$ = nl(Zp), P$ = nl(Qp), U$ = nl(el);
Wn.assets = N$.default;
Wn.chain = P$.default;
Wn.ibc = U$.default;
var Vn = {}, tl = {};
Object.defineProperty(tl, "__esModule", { value: !0 });
const H$ = {
  $schema: "../assetlist.schema.json",
  chain_name: "beezee",
  assets: [
    {
      description: "BeeZee native blockchain",
      denom_units: [{
        denom: "ubze",
        exponent: 0
      }, {
        denom: "bze",
        exponent: 6
      }],
      base: "ubze",
      name: "BeeZee",
      display: "bze",
      symbol: "BZE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.svg"
      },
      coingecko_id: "bzedge",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.svg",
        theme: {
          primary_color_hex: "#079fd7"
        }
      }]
    },
    {
      description: "Vidulum App Token",
      denom_units: [{
        denom: "factory/bze13gzq40che93tgfm9kzmkpjamah5nj0j73pyhqk/uvdl",
        exponent: 0
      }, {
        denom: "vdl",
        exponent: 6
      }],
      base: "factory/bze13gzq40che93tgfm9kzmkpjamah5nj0j73pyhqk/uvdl",
      name: "Vidulum",
      display: "vdl",
      symbol: "VDL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg"
      },
      coingecko_id: "vidulum",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg",
        theme: {
          primary_color_hex: "#3454bc"
        }
      }]
    },
    {
      description: "OSMO from Osmosis",
      denom_units: [{
        denom: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
        exponent: 0,
        aliases: ["uosmo"]
      }, {
        denom: "osmo",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
      name: "Osmosis",
      display: "osmo",
      symbol: "OSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo",
          channel_id: "channel-340"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/uosmo"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      }
    },
    {
      description: "Crypto2Mars Community Token",
      denom_units: [{
        denom: "factory/bze15pqjgk4la0mfphwddce00d05n3th3u66n3ptcv/2MARS",
        exponent: 0
      }, {
        denom: "C2M",
        exponent: 6
      }],
      base: "factory/bze15pqjgk4la0mfphwddce00d05n3th3u66n3ptcv/2MARS",
      name: "Crypto2Mars",
      display: "C2M",
      symbol: "C2M",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/c2m.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/c2m.png",
        theme: {
          primary_color_hex: "#FEFEFE"
        }
      }]
    },
    {
      description: "The native token of Archway network",
      denom_units: [
        {
          denom: "ibc/C00D101A3572A5374E23F11944463D1325319E255D7C824B33AF2F927F532348",
          exponent: 0,
          aliases: ["aarch"]
        },
        {
          denom: "uarch",
          exponent: 12
        },
        {
          denom: "arch",
          exponent: 18
        }
      ],
      type_asset: "ics20",
      base: "ibc/C00D101A3572A5374E23F11944463D1325319E255D7C824B33AF2F927F532348",
      name: "Archway",
      display: "arch",
      symbol: "ARCH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "archway",
          base_denom: "aarch",
          channel_id: "channel-147"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/aarch"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.svg"
      },
      images: [{
        image_sync: {
          chain_name: "archway",
          base_denom: "aarch"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.svg",
        theme: {
          primary_color_hex: "#fc4c04"
        }
      }]
    },
    {
      description: "USDC from Noble",
      denom_units: [{
        denom: "ibc/6490A7EAB61059BFC1CDDEB05917DD70BDF3A611654162A1A47DB930D40D8AF4",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/6490A7EAB61059BFC1CDDEB05917DD70BDF3A611654162A1A47DB930D40D8AF4",
      name: "USDC",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "noble",
          base_denom: "uusdc",
          channel_id: "channel-95"
        },
        chain: {
          channel_id: "channel-3",
          path: "transfer/channel-3/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }
    }
  ]
};
tl.default = H$;
var sl = {};
Object.defineProperty(sl, "__esModule", { value: !0 });
const L$ = {
  $schema: "../chain.schema.json",
  chain_name: "beezee",
  status: "live",
  network_type: "mainnet",
  pretty_name: "BeeZee",
  chain_type: "cosmos",
  chain_id: "beezee-1",
  bech32_prefix: "bze",
  daemon_name: "bzed",
  node_home: "$HOME/.bze",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ubze",
      fixed_min_gas_price: 0.01,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ubze"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.getbze.com",
        provider: "AlphaTeam"
      },
      {
        address: "https://rpc-1.getbze.com",
        provider: "AlphaTeam"
      },
      {
        address: "https://rpc-2.getbze.com",
        provider: "AlphaTeam"
      },
      {
        address: "https://beezee_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://rest.getbze.com",
        provider: "AlphaTeam"
      },
      {
        address: "https://rest-1.getbze.com",
        provider: "AlphaTeam"
      },
      {
        address: "https://rest-2.getbze.com",
        provider: "AlphaTeam"
      },
      {
        address: "https://beezee_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "grpc.getbze.com:9099",
        provider: "AlphaTeam"
      },
      {
        address: "grpc-1.getbze.com:9099",
        provider: "AlphaTeam"
      },
      {
        address: "grpc-2.getbze.com:9099",
        provider: "AlphaTeam"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/beezee",
      tx_page: "https://ping.pub/beezee/tx/${txHash}",
      account_page: "https://ping.pub/beezee/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.getbze.com/beezee",
      tx_page: "https://explorer.getbze.com/beezee/tx/${txHash}",
      account_page: "https://explorer.getbze.com/beezee/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/beezee",
      tx_page: "https://atomscan.com/beezee/transactions/${txHash}",
      account_page: "https://atomscan.com/beezee/accounts/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/beezee",
      tx_page: "https://explorer.whenmoonwhenlambo.money/beezee/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/beezee/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.svg",
    theme: {
      primary_color_hex: "#079fd7"
    }
  }]
};
sl.default = L$;
var al = {};
Object.defineProperty(al, "__esModule", { value: !0 });
const W$ = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-114",
      connection_id: "connection-107"
    },
    chain_2: {
      chain_name: "beezee",
      client_id: "07-tendermint-8",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-147",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "beezee",
      client_id: "07-tendermint-9",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-112",
      connection_id: "connection-107"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-95",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "beezee",
      client_id: "07-tendermint-2",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2154",
      connection_id: "connection-1672"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-340",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
al.default = W$;
var ol = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Vn, "__esModule", { value: !0 });
Vn.ibc = Vn.chain = Vn.assets = void 0;
const V$ = ol(tl), G$ = ol(sl), K$ = ol(al);
Vn.assets = V$.default;
Vn.chain = G$.default;
Vn.ibc = K$.default;
var Go = {}, rl = {};
Object.defineProperty(rl, "__esModule", { value: !0 });
const X$ = {
  $schema: "../assetlist.schema.json",
  chain_name: "bitbadges",
  assets: [{
    description: "$BADGE is the native in-app credits token for BitBadges, a platform for creating and sharing digital badges.",
    denom_units: [{
      denom: "ubadge",
      exponent: 0
    }, {
      denom: "badge",
      exponent: 9
    }],
    base: "ubadge",
    name: "BitBadges Credits",
    display: "badge",
    symbol: "BADGE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitbadges/images/bitbadgeslogo.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitbadges/images/bitbadgeslogo.png"
    }],
    socials: {
      website: "https://bitbadges.io/",
      twitter: "https://twitter.com/bitbadges_io"
    }
  }, {
    description: "The native staking denom for the BitBadges blockchain.",
    denom_units: [{
      denom: "ustake",
      exponent: 0
    }, {
      denom: "stake",
      exponent: 9
    }],
    base: "ustake",
    name: "BitBadges Staking",
    display: "stake",
    symbol: "STAKE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitbadges/images/bitbadgeslogo.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitbadges/images/bitbadgeslogo.png"
    }],
    socials: {
      website: "https://bitbadges.io/",
      twitter: "https://twitter.com/bitbadges_io"
    }
  }]
};
rl.default = X$;
var il = {};
Object.defineProperty(il, "__esModule", { value: !0 });
const Y$ = {
  $schema: "../chain.schema.json",
  chain_name: "bitbadges",
  status: "live",
  chain_type: "cosmos",
  network_type: "mainnet",
  website: "https://bitbadges.io/",
  pretty_name: "BitBadges",
  chain_id: "bitbadges-1",
  bech32_prefix: "cosmos",
  daemon_name: "bitbadgeschaind",
  node_home: "$HOME/.bitbadgeschaind",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ubadge",
      fixed_min_gas_price: 0,
      low_gas_price: 25e-5,
      average_gas_price: 25e-4,
      high_gas_price: 0.025
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ustake"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.50.8"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitbadges/images/bitbadgeslogo.png"
  },
  description: "BitBadges is the all-in-one, multi-chain platform for building your digital identity.",
  apis: {
    rpc: [{
      address: "http://134.122.12.165:26657",
      provider: "bitbadges"
    }],
    rest: [{
      address: "http://134.122.12.165:1317",
      provider: "bitbadges"
    }],
    grpc: []
  },
  explorers: [{
    kind: "mintscan",
    url: "https://www.mintscan.io/bitbadges",
    tx_page: "https://www.mintscan.io/bitbadges/transactions/${txHash}",
    account_page: "https://www.mintscan.io/bitbadges/accounts/${accountAddress}"
  }, {
    kind: "ping.pub",
    url: "https://explorer.bitbadges.io/BitBadges%20Mainnet",
    tx_page: "https://explorer.bitbadges.io/BitBadges%20Mainnet/txs/${txHash}",
    account_page: "https://explorer.bitbadges.io/BitBadBitBadges%20Mainnetges/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitbadges/images/bitbadgeslogo.png"
  }]
};
il.default = Y$;
var v9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Go, "__esModule", { value: !0 });
Go.chain = Go.assets = void 0;
const J$ = v9(rl), Z$ = v9(il);
Go.assets = J$.default;
Go.chain = Z$.default;
var Gn = {}, cl = {};
Object.defineProperty(cl, "__esModule", { value: !0 });
const Q$ = {
  $schema: "../assetlist.schema.json",
  chain_name: "bitcanna",
  assets: [{
    description: "The BCNA coin is the transactional token within the BitCanna network, serving the legal cannabis industry through its payment network, supply chain and trust network.",
    denom_units: [{
      denom: "ubcna",
      exponent: 0
    }, {
      denom: "bcna",
      exponent: 6
    }],
    base: "ubcna",
    display: "bcna",
    name: "BitCanna",
    symbol: "BCNA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.svg"
    },
    coingecko_id: "bitcanna",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.svg",
      theme: {
        primary_color_hex: "#3cc494"
      }
    }],
    socials: {
      website: "http://www.bitcanna.io/",
      twitter: "https://twitter.com/BitCannaGlobal"
    }
  }]
};
cl.default = Q$;
var dl = {};
Object.defineProperty(dl, "__esModule", { value: !0 });
const ez = {
  $schema: "../chain.schema.json",
  chain_name: "bitcanna",
  status: "live",
  network_type: "mainnet",
  website: "https://www.bitcanna.io/",
  pretty_name: "BitCanna",
  chain_type: "cosmos",
  chain_id: "bitcanna-1",
  bech32_prefix: "bcna",
  daemon_name: "bcnad",
  node_home: "$HOME/.bcna",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ubcna",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 1e-3,
      average_gas_price: 25e-4,
      high_gas_price: 0.01
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ubcna"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.11"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.bitcanna.io/",
        provider: "bitcanna"
      },
      {
        address: "https://bcna-rpc.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://bitcanna-rpc.panthea.eu/",
        provider: "Panthea EU"
      },
      {
        address: "https://rpc.bitcanna.sgtstake.com/",
        provider: "SGTstake"
      },
      {
        address: "https://bitcanna.rpc.m.anode.team/",
        provider: "AlxVoy ⚡ ANODE.TEAM"
      },
      {
        address: "https://bitcanna.rpc.m.stavr.tech/",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-bcna.kjinc.io/",
        provider: "KJINC.io"
      },
      {
        address: "https://mainnet-bitcanna-rpc.konsortech.xyz/",
        provider: "KonsorTech"
      },
      {
        address: "https://bitcanna.rpc.kjnodes.com/",
        provider: "kjnodes"
      },
      {
        address: "https://bitcanna-rpc.genznodes.dev/",
        provider: "genznodes"
      },
      {
        address: "https://rpc.bitcanna-1.bitcanna.aviaone.com/",
        provider: "AVIAONE 🟢"
      },
      {
        address: "https://rpc.bitcanna-mainnet.hexnodes.one/",
        provider: "Hexnodes"
      },
      {
        address: "https://rpc.bitcanna.citizenweb3.com/",
        provider: "Citizen Web3"
      },
      {
        address: "https://bitcanna-mainnet.rpc.l0vd.com/",
        provider: "L0vd.com"
      },
      {
        address: "https://bitcanna-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc.bitcanna.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://bitcanna.nodejumper.io:443",
        provider: "NODEJUMPER"
      },
      {
        address: "https://rpc.bitcanna.indonode.net/",
        provider: "Indonode"
      },
      {
        address: "https://rpc-bitcanna.mms.team:443",
        provider: "MMS"
      },
      {
        address: "https://bitcanna-rpc.validatornode.com",
        provider: "ValidatorNode"
      },
      {
        address: "https://bitcanna.rpc.nodex.one",
        provider: "NodeX Emperor ⚡ Bitcanna"
      },
      {
        address: "https://bcna.rpc.arcturian.tech/",
        provider: "Arcturian Tech"
      },
      {
        address: "https://rpc.bitcanna.bh.rocks",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://bitcanna-rpc.bluestake.net",
        provider: "BlueStake"
      },
      {
        address: "https://rpc-bitcanna.cryptech.com.ua",
        provider: "CrypTech"
      },
      {
        address: "https://bitcanna-rpc.kalia.network/",
        provider: "Kalia Network"
      },
      {
        address: "https://bitcanna.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️"
      },
      {
        address: "https://bitcanna_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "grpc.bitcanna.io:443",
        provider: "bitcanna"
      },
      {
        address: "bitcanna.grpc.m.stavr.tech:9081",
        provider: "🔥STAVR🔥"
      },
      {
        address: "grpc.bitcanna-mainnet.hexnodes.one:27090",
        provider: "HexNodes"
      },
      {
        address: "grpc.bitcanna-1.bitcanna.aviaone.com:9102",
        provider: "AVIAONE 🟢"
      },
      {
        address: "bitcanna-mainnet.grpc.l0vd.com:80",
        provider: "L0vd.com"
      },
      {
        address: "bitcanna.grpc.kjnodes.com:14290",
        provider: "kjnodes"
      },
      {
        address: "bitcanna-grpc.polkachu.com:13090",
        provider: "Polkachu"
      },
      {
        address: "grpc-bitcanna.mms.team:443",
        provider: "MMS"
      },
      {
        address: "grpc.bitcanna.safeblock.space:9090",
        provider: "Safe Block"
      },
      {
        address: "mainnet-bitcanna-grpc.konsortech.xyz:27090",
        provider: "KonsorTech"
      },
      {
        address: "bitcanna.grpc.m.anode.team:443",
        provider: "AlxVoy ⚡ ANODE.TEAM"
      },
      {
        address: "grpc-bcna.kjinc.io:443",
        provider: "KJINC.io"
      },
      {
        address: "bitcanna.grpc.nodex.one:443",
        provider: "NodeX Emperor ⚡ Bitcanna"
      },
      {
        address: "grpc.bitcanna.bh.rocks:42090",
        provider: "BlockHunters 🎯"
      },
      {
        address: "grpc.bitcanna.indonode.net:11090",
        provider: "Indonode"
      },
      {
        address: "bitcanna-grpc.panthea.eu:16710",
        provider: "Panthea EU"
      },
      {
        address: "bitcanna-grpc.validatornode.com:443",
        provider: "ValidatorNode"
      },
      {
        address: "grpc-bitcanna.cryptech.com.ua:443",
        provider: "CrypTech"
      },
      {
        address: "bitcanna-grpc.kalia.network:443",
        provider: "Kalia Network"
      },
      {
        address: "bitcanna.grpc.nodeshub.online:13090",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️"
      }
    ],
    rest: [
      {
        address: "https://lcd.bitcanna.io",
        provider: "bitcanna"
      },
      {
        address: "https://bitcanna-api.panthea.eu",
        provider: "Panthea EU"
      },
      {
        address: "https://api.bitcanna.sgtstake.com/",
        provider: "SGTstake"
      },
      {
        address: "https://bitcanna.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://bcna-api.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://bitcanna.api.m.anode.team",
        provider: "AlxVoy ⚡ ANODE.TEAM"
      },
      {
        address: "https://api-bcna.kjinc.io/",
        provider: "KJINC.io"
      },
      {
        address: "https://mainnet-bitcanna-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://bitcanna.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://bitcanna-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://api.bitcanna-1.bitcanna.aviaone.com",
        provider: "AVIAONE 🟢"
      },
      {
        address: "https://lcd.bitcanna-mainnet.hexnodes.one",
        provider: "Hexnodes"
      },
      {
        address: "https://bitcanna-mainnet.api.l0vd.com",
        provider: "L0vd.com"
      },
      {
        address: "https://bitcanna-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://api.bitcanna.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://bitcanna.nodejumper.io:1317",
        provider: "NODEJUMPER"
      },
      {
        address: "https://api-bitcanna.mms.team:443",
        provider: "MMS"
      },
      {
        address: "https://bitcanna-api.validatornode.com",
        provider: "ValidatorNode"
      },
      {
        address: "https://bitcanna.api.nodex.one",
        provider: "NodeX Emperor ⚡ Bitcanna"
      },
      {
        address: "https://bcna.api.arcturian.tech/",
        provider: "Arcturian Tech"
      },
      {
        address: "https://api.bitcanna.bh.rocks",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://api.bitcanna.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://bitcanna-api.bluestake.net",
        provider: "BlueStake"
      },
      {
        address: "https://api-bitcanna.cryptech.com.ua",
        provider: "CrypTech"
      },
      {
        address: "https://bitcanna-api.kalia.network",
        provider: "Kalia Network"
      },
      {
        address: "https://api.bitcanna.citizenweb3.com",
        provider: "Citizen Web3"
      },
      {
        address: "https://bitcanna.api.nodeshub.online",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️"
      },
      {
        address: "https://bitcanna_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ]
  },
  explorers: [
    {
      kind: "EZStaking Tools",
      url: "https://app.ezstaking.io/bitcanna",
      tx_page: "https://ezstaking.tools/bitcanna/txs/${txHash}",
      account_page: "https://ezstaking.tools/bitcanna/account/${accountAddress}"
    },
    {
      kind: "forbole",
      url: "https://explorer.bitcanna.io",
      tx_page: "https://explorer.bitcanna.io/transactions/${txHash}",
      account_page: "https://explorer.bitcanna.io/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/bitcanna",
      tx_page: "https://ping.pub/bitcanna/tx/${txHash}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/bitcanna/",
      tx_page: "https://www.mintscan.io/bitcanna/txs/${txHash}",
      account_page: "https://www.mintscan.io/bitcanna/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/Bitcanna",
      tx_page: "https://explorer.stavr.tech/Bitcanna/txs/${txHash}",
      account_page: "https://explorer.stavr.tech/Bitcanna/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/bitcanna",
      tx_page: "https://atomscan.com/bitcanna/transactions/${txHash}"
    },
    {
      kind: "ValidatorNode Explorer",
      url: "https://explorer.validatornode.com/bitcanna",
      tx_page: "https://explorer.validatornode.com/bitcanna/tx/${txHash}"
    },
    {
      kind: "Safe Block Explorer Pruned",
      url: "https://explorer.safeblock.space/bitcanna",
      tx_page: "https://explorer.safeblock.space/bitcanna/tx/${txHash}"
    },
    {
      kind: "AlxVoy ⚡ ANODE.TEAM",
      url: "https://main.anode.team/bitcanna",
      tx_page: "https://main.anode.team/bitcanna/tx/${txHash}"
    },
    {
      kind: "kjnodes",
      url: "https://explorer.kjnodes.com/bitcanna",
      tx_page: "https://explorer.kjnodes.com/bitcanna/tx/${txHash}"
    },
    {
      kind: "L0vd.com ❤️",
      url: "https://explorers.l0vd.com/bitcanna-mainnet",
      tx_page: "https://explorers.l0vd.com/bitcanna-mainnet/tx/${txHash}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodex.one/bitcanna",
      tx_page: "https://explorer.nodex.one/bitcanna/tx/${txHash}"
    },
    {
      kind: "Moonbys Dashboard",
      url: "https://explorer.moonbys.com",
      tx_page: "https://explorer.moonbys.com/${txHash}"
    },
    {
      kind: "BlockHunters 🎯",
      url: "https://scan.bh.rocks/bitcanna",
      tx_page: "https://scan.bh.rocks/bitcanna/tx/${txHash}"
    },
    {
      kind: "Indonode",
      url: "https://explorer.indonode.net/bitcanna",
      tx_page: "https://explorer.indonode.net/bitcanna/tx/${txHash}"
    },
    {
      kind: "CrypTech Explorer",
      url: "https://explorers.cryptech.com.ua/bitcanna",
      tx_page: "https://explorers.cryptech.com.ua/bitcanna/txs/${txHash}"
    },
    {
      kind: "Kalia Network",
      url: "https://explorer.kalia.network/bitcanna",
      tx_page: "https://explorer.kalia.network/bitcanna/tx/${txHash}",
      account_page: "https://explorer.kalia.network/bitcanna/account/${accountAddress}"
    },
    {
      kind: "AviaOne Explorer 🟢",
      url: "https://mainnet.explorer.aviaone.com/bitcanna",
      tx_page: "https://mainnet.explorer.aviaone.com/bitcanna/tx/${txHash}",
      account_page: "https://mainnet.explorer.aviaone.com/bitcanna/account/${accountAddress}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️",
      url: "https://explorer.nodeshub.online/bitcanna/",
      tx_page: "https://explorer.nodeshub.online/bitcanna/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/bitcanna/accounts/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/bitcanna",
      tx_page: "https://explorer.whenmoonwhenlambo.money/bitcanna/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/bitcanna/account/${accountAddress}"
    },
    {
      kind: "AviaOne Explorer 🟢",
      url: "https://mainnet.explorer.aviaone.com/bitcanna",
      tx_page: "https://mainnet.explorer.aviaone.com/bitcanna/tx/${txHash}",
      account_page: "https://mainnet.explorer.aviaone.com/bitcanna/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.svg",
    theme: {
      primary_color_hex: "#3cc494"
    }
  }]
};
dl.default = ez;
var ml = {};
Object.defineProperty(ml, "__esModule", { value: !0 });
const nz = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-37",
      connection_id: "connection-40"
    },
    chain_2: {
      chain_name: "bitcanna",
      client_id: "07-tendermint-83",
      connection_id: "connection-74"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-35",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitcanna",
      client_id: "07-tendermint-0",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "bitsong",
      client_id: "07-tendermint-1237",
      connection_id: "connection-1132"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitcanna",
      client_id: "07-tendermint-4",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-490",
      connection_id: "connection-399"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-232",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitcanna",
      client_id: "07-tendermint-12",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-110",
      connection_id: "connection-70"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitcanna",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1499",
      connection_id: "connection-1167"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
ml.default = nz;
var hl = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Gn, "__esModule", { value: !0 });
Gn.ibc = Gn.chain = Gn.assets = void 0;
const tz = hl(cl), sz = hl(dl), az = hl(ml);
Gn.assets = tz.default;
Gn.chain = sz.default;
Gn.ibc = az.default;
var Kn = {}, pl = {};
Object.defineProperty(pl, "__esModule", { value: !0 });
const oz = {
  $schema: "../assetlist.schema.json",
  chain_name: "bitsong",
  assets: [
    {
      description: "BitSong Native Token",
      denom_units: [{
        denom: "ubtsg",
        exponent: 0
      }, {
        denom: "btsg",
        exponent: 6
      }],
      base: "ubtsg",
      name: "BitSong",
      display: "btsg",
      symbol: "BTSG",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.svg"
      },
      type_asset: "sdk.coin",
      coingecko_id: "bitsong",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.svg",
        theme: {
          primary_color_hex: "#c8307f"
        }
      }],
      socials: {
        website: "https://bitsong.io/",
        twitter: "https://twitter.com/BitSongOfficial"
      }
    },
    {
      description: "Adam Clay a BitSong Music FanToken",
      denom_units: [{
        denom: "ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09",
        exponent: 0
      }, {
        denom: "clay",
        exponent: 6
      }],
      base: "ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09",
      name: "Adam Clay FanToken",
      display: "clay",
      symbol: "CLAY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09.png",
        theme: {
          primary_color_hex: "#e8e5e7"
        }
      }]
    },
    {
      description: "Nicola Fasano a BitSong Music FanToken",
      denom_units: [{
        denom: "ft25B30C386CDDEBD1413D5AE1180956AE9EB3B9F7",
        exponent: 0
      }, {
        denom: "fasano",
        exponent: 6
      }],
      base: "ft25B30C386CDDEBD1413D5AE1180956AE9EB3B9F7",
      name: "Nicola Fasano Fantoken",
      display: "fasano",
      symbol: "FASANO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft25B30C386CDDEBD1413D5AE1180956AE9EB3B9F7.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft25B30C386CDDEBD1413D5AE1180956AE9EB3B9F7.png",
        theme: {
          primary_color_hex: "#c3a59e"
        }
      }]
    },
    {
      description: "Delta 9 a BitSong Music FanToken",
      denom_units: [{
        denom: "ft575B10B0CEE2C164D9ED6A96313496F164A9607C",
        exponent: 0
      }, {
        denom: "d9x",
        exponent: 6
      }],
      base: "ft575B10B0CEE2C164D9ED6A96313496F164A9607C",
      name: "Delta 9 Fantoken",
      display: "d9x",
      symbol: "D9X",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft575B10B0CEE2C164D9ED6A96313496F164A9607C.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft575B10B0CEE2C164D9ED6A96313496F164A9607C.png",
        theme: {
          primary_color_hex: "#0d0d0d"
        }
      }]
    },
    {
      description: "FONTI a BitSong Music FanToken",
      denom_units: [{
        denom: "ft56664FC98A2CF5F4FBAC3566D1A11D891AD88305",
        exponent: 0
      }, {
        denom: "fonti",
        exponent: 6
      }],
      base: "ft56664FC98A2CF5F4FBAC3566D1A11D891AD88305",
      name: "FONTI Fantoken",
      display: "fonti",
      symbol: "FONTI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft56664FC98A2CF5F4FBAC3566D1A11D891AD88305.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft56664FC98A2CF5F4FBAC3566D1A11D891AD88305.png",
        theme: {
          primary_color_hex: "#1c2536"
        }
      }]
    },
    {
      description: "BlackJack a BitSong Music FanToken",
      denom_units: [{
        denom: "ft52EEB0EE509AC546ED92EAC8591F731F213DDD16",
        exponent: 0
      }, {
        denom: "bjks",
        exponent: 6
      }],
      base: "ft52EEB0EE509AC546ED92EAC8591F731F213DDD16",
      name: "BlackJack Fantoken",
      display: "bjks",
      symbol: "BJKS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft52EEB0EE509AC546ED92EAC8591F731F213DDD16.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft52EEB0EE509AC546ED92EAC8591F731F213DDD16.png",
        theme: {
          primary_color_hex: "#f5f5f5"
        }
      }]
    },
    {
      description: "Rawanne a BitSong Music FanToken",
      denom_units: [{
        denom: "ftE4903ECC861CA45F2C2BC7EAB8255D2E6E87A33A",
        exponent: 0
      }, {
        denom: "rwne",
        exponent: 6
      }],
      base: "ftE4903ECC861CA45F2C2BC7EAB8255D2E6E87A33A",
      name: "Rawanne Fantoken",
      display: "rwne",
      symbol: "RWNE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ftE4903ECC861CA45F2C2BC7EAB8255D2E6E87A33A.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ftE4903ECC861CA45F2C2BC7EAB8255D2E6E87A33A.png",
        theme: {
          primary_color_hex: "#1a1521"
        }
      }]
    },
    {
      description: "Enmoda a BitSong Music FanToken",
      denom_units: [{
        denom: "ft85AE1716C5E39EA6D64BBD7898C3899A7B500626",
        exponent: 0
      }, {
        denom: "enmoda",
        exponent: 6
      }],
      base: "ft85AE1716C5E39EA6D64BBD7898C3899A7B500626",
      name: "Enmoda Fantoken",
      display: "enmoda",
      symbol: "ENMODA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft85AE1716C5E39EA6D64BBD7898C3899A7B500626.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft85AE1716C5E39EA6D64BBD7898C3899A7B500626.png",
        theme: {
          primary_color_hex: "#161616"
        }
      }]
    },
    {
      description: "404Deep Records a BitSong Music FanToken",
      denom_units: [{
        denom: "ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A",
        exponent: 0
      }, {
        denom: "404dr",
        exponent: 6
      }],
      base: "ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A",
      name: "404Deep Records Fantoken",
      display: "404dr",
      symbol: "404DR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A.png",
        theme: {
          primary_color_hex: "#cfb1b3"
        }
      }]
    },
    {
      description: "N43 a BitSong Music FanToken",
      denom_units: [{
        denom: "ft387C1C279D962ED80C09C1D592A92C4275FD7C5D",
        exponent: 0
      }, {
        denom: "n43",
        exponent: 6
      }],
      base: "ft387C1C279D962ED80C09C1D592A92C4275FD7C5D",
      name: "N43 Fantoken",
      display: "n43",
      symbol: "N43",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft387C1C279D962ED80C09C1D592A92C4275FD7C5D.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft387C1C279D962ED80C09C1D592A92C4275FD7C5D.png",
        theme: {
          primary_color_hex: "#0a0a0a"
        }
      }]
    },
    {
      description: "Puro Lobo a BitSong Music FanToken",
      denom_units: [{
        denom: "ft24C9FA4F10B0F235F4A815B15FC774E046A2B2EB",
        exponent: 0
      }, {
        denom: "lobo",
        exponent: 6
      }],
      base: "ft24C9FA4F10B0F235F4A815B15FC774E046A2B2EB",
      name: "Puro Lobo Fantoken",
      display: "lobo",
      symbol: "LOBO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft24C9FA4F10B0F235F4A815B15FC774E046A2B2EB.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft24C9FA4F10B0F235F4A815B15FC774E046A2B2EB.png",
        theme: {
          primary_color_hex: "#b8b6b6"
        }
      }]
    },
    {
      description: "Vibranium a BitSong Music FanToken",
      denom_units: [{
        denom: "ft7020C2A8E984EEBCBB383E91CD6FBB067BB2272B",
        exponent: 0
      }, {
        denom: "vibra",
        exponent: 6
      }],
      base: "ft7020C2A8E984EEBCBB383E91CD6FBB067BB2272B",
      name: "Vibranium Fantoken",
      display: "vibra",
      symbol: "VIBRA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft7020C2A8E984EEBCBB383E91CD6FBB067BB2272B.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft7020C2A8E984EEBCBB383E91CD6FBB067BB2272B.png",
        theme: {
          primary_color_hex: "#0f0c27"
        }
      }]
    },
    {
      description: "Karina a BitSong Music FanToken",
      denom_units: [{
        denom: "ft2DD67F5D99E9A141142B48474FA7B6B3FF00A3FE",
        exponent: 0
      }, {
        denom: "karina",
        exponent: 6
      }],
      base: "ft2DD67F5D99E9A141142B48474FA7B6B3FF00A3FE",
      name: "Karina Fantoken",
      display: "karina",
      symbol: "KARINA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft2DD67F5D99E9A141142B48474FA7B6B3FF00A3FE.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft2DD67F5D99E9A141142B48474FA7B6B3FF00A3FE.png",
        theme: {
          primary_color_hex: "#21283c"
        }
      }]
    },
    {
      description: "Luca Testa a BitSong Music FanToken",
      denom_units: [{
        denom: "ft4B030260D99E3ABE2B604EA2B33BAF3C085CDA12",
        exponent: 0
      }, {
        denom: "testa",
        exponent: 6
      }],
      base: "ft4B030260D99E3ABE2B604EA2B33BAF3C085CDA12",
      name: "Luca Testa Fantoken",
      display: "testa",
      symbol: "TESTA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft4B030260D99E3ABE2B604EA2B33BAF3C085CDA12.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft4B030260D99E3ABE2B604EA2B33BAF3C085CDA12.png",
        theme: {
          primary_color_hex: "#151515"
        }
      }]
    },
    {
      description: "Carolina Marquez a BitSong Music FanToken",
      denom_units: [{
        denom: "ftD4B6290EDEE1EC7B97AB5A1DC6C177EFD08ADCC3",
        exponent: 0
      }, {
        denom: "cmqz",
        exponent: 6
      }],
      base: "ftD4B6290EDEE1EC7B97AB5A1DC6C177EFD08ADCC3",
      name: "Carolina Marquez Fantoken",
      display: "cmqz",
      symbol: "CMQZ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ftD4B6290EDEE1EC7B97AB5A1DC6C177EFD08ADCC3.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ftD4B6290EDEE1EC7B97AB5A1DC6C177EFD08ADCC3.png",
        theme: {
          primary_color_hex: "#847760"
        }
      }]
    },
    {
      deprecated: !0,
      description: "[Redacted] a BitSong Music FanToken",
      denom_units: [{
        denom: "ft347B1612A2B7659913679CF6CD45B8B130C50A00",
        exponent: 0
      }, {
        denom: "ft347B1612A2B7659913679CF6CD45B8B130C50A00/6",
        exponent: 6
      }],
      base: "ft347B1612A2B7659913679CF6CD45B8B130C50A00",
      name: "[Redacted] Fantoken (ft3...A00)",
      display: "ft347B1612A2B7659913679CF6CD45B8B130C50A00/6",
      symbol: "LDON"
    }
  ]
};
pl.default = oz;
var ll = {};
Object.defineProperty(ll, "__esModule", { value: !0 });
const rz = {
  $schema: "../chain.schema.json",
  chain_name: "bitsong",
  status: "live",
  network_type: "mainnet",
  website: "https://bitsong.io/",
  pretty_name: "BitSong",
  chain_type: "cosmos",
  chain_id: "bitsong-2b",
  bech32_prefix: "bitsong",
  slip44: 639,
  daemon_name: "bitsongd",
  node_home: "$HOME/.bitsongd",
  codebase: {
    cosmos_sdk_version: "v0.45.16",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.33.0"
  },
  fees: {
    fee_tokens: [{
      denom: "ubtsg",
      fixed_min_gas_price: 0,
      low_gas_price: 3,
      average_gas_price: 10,
      high_gas_price: 20
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ubtsg"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.svg"
  },
  description: "Artists, Fans, Managers and Labels in One Single Holistic Ecosystem: $BTSG. Earn real-time royalties, discover exclusive content, mint and trade Fantokens, buy & sell NFTs.",
  apis: {
    rpc: [
      {
        address: "https://rpc-bitsong-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc.explorebitsong.com",
        provider: "stake.systems"
      },
      {
        address: "https://bitsong-rpc.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "https://rpc.bitsong.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://rpc.bitsong.quokkastake.io",
        provider: "🐹 Quokka Stake"
      },
      {
        address: "https://rpc-bitsong.starsquid.io",
        provider: "Starsquid"
      },
      {
        address: "https://rpc-bitsong.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "http://bitsong.statesync.nodersteam.com:11657",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://rpc.bitsong.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://bitsong.tdrsys.com:2053",
        provider: "TdrSys"
      },
      {
        address: "https://bitsong-rpc.panthea.eu",
        provider: "Panthea EU"
      },
      {
        address: "https://rpc.bitsong.mathnodes.com",
        provider: "MathNodes"
      },
      {
        address: "https://bitsong-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://bitsong-rpc.bluestake.net:443",
        provider: "BlueStake 🚀"
      },
      {
        address: "https://bitsong.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      }
    ],
    rest: [
      {
        address: "https://api-bitsong-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://lcd.explorebitsong.com/",
        provider: "stake.systems"
      },
      {
        address: "https://bitsong-api.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "https://api.bitsong.quokkastake.io",
        provider: "🐹 Quokka Stake"
      },
      {
        address: "http://bitsong.api.nodersteam.com:11017",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://api-bitsong.starsquid.io",
        provider: "Starsquid"
      },
      {
        address: "https://rest-bitsong.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://api.bitsong.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://bitsong.tdrsys.com",
        provider: "TdrSys"
      },
      {
        address: "https://bitsong-api.panthea.eu",
        provider: "Panthea EU"
      },
      {
        address: "https://api.bitsong.mathnodes.com",
        provider: "MathNodes"
      },
      {
        address: "https://bitsong-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://bitsong.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://bitsong-api.bluestake.net",
        provider: "BlueStake 🚀"
      }
    ],
    grpc: [
      {
        address: "grpc-bitsong-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "bitsong.grpc.nodersteam.com:9111/",
        provider: "[NODERS]TEAM"
      },
      {
        address: "grpc.bitsong.safeblock.space:9090",
        provider: "Safe Block"
      },
      {
        address: "bitsong-grpc.panthea.eu:16750",
        provider: "Panthea EU"
      },
      {
        address: "grpc.bitsong.mathnodes.com:9092",
        provider: "MathNodes"
      },
      {
        address: "bitsong-grpc.noders.services:20090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "bitsong.grpc.m.stavr.tech:9988",
        provider: "🔥STAVR🔥"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/bitsong",
      tx_page: "https://ezstaking.app/bitsong/txs/${txHash}",
      account_page: "https://ezstaking.app/bitsong/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/bitsong",
      tx_page: "https://ping.pub/bitsong/tx/${txHash}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/bitsong",
      tx_page: "https://www.mintscan.io/bitsong/transactions/${txHash}",
      account_page: "https://www.mintscan.io/bitsong/accounts/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/bitsong",
      tx_page: "https://atomscan.com/bitsong/transactions/${txHash}",
      account_page: "https://atomscan.com/bitsong/accounts/${accountAddress}"
    },
    {
      kind: "Safe Block",
      url: "https://explorer.safeblok.space/bitsong",
      tx_page: "https://explorer.safeblock.space/bitsong/tx/${txHash}",
      account_page: "https://explorer.safeblock.space/bitsong/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Bitsong",
      tx_page: "https://explorer.stavr.tech/Bitsong/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Bitsong/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.svg",
    theme: {
      primary_color_hex: "#c8307f"
    }
  }]
};
ll.default = rz;
var gl = {};
Object.defineProperty(gl, "__esModule", { value: !0 });
const iz = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-92",
      connection_id: "connection-90"
    },
    chain_2: {
      chain_name: "bitsong",
      client_id: "07-tendermint-80",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-124",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-207",
      connection_id: "connection-188"
    },
    chain_2: {
      chain_name: "bitsong",
      client_id: "07-tendermint-81",
      connection_id: "connection-56"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-145",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitcanna",
      client_id: "07-tendermint-0",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "bitsong",
      client_id: "07-tendermint-1237",
      connection_id: "connection-1132"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitsong",
      client_id: "07-tendermint-1",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-481",
      connection_id: "connection-395"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-229",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitsong",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-33",
      connection_id: "connection-26"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitsong",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1551",
      connection_id: "connection-1216"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-73",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
gl.default = iz;
var ul = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Kn, "__esModule", { value: !0 });
Kn.ibc = Kn.chain = Kn.assets = void 0;
const cz = ul(pl), dz = ul(ll), mz = ul(gl);
Kn.assets = cz.default;
Kn.chain = dz.default;
Kn.ibc = mz.default;
var Ko = {}, _l = {};
Object.defineProperty(_l, "__esModule", { value: !0 });
const hz = {
  $schema: "../assetlist.schema.json",
  chain_name: "blockx",
  assets: [{
    description: "BlockX Native Token",
    denom_units: [{
      denom: "abcx",
      exponent: 0
    }, {
      denom: "bcx",
      exponent: 18
    }],
    base: "abcx",
    name: "BCX",
    display: "bcx",
    symbol: "BCX",
    type_asset: "sdk.coin",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/blockx/images/blockx.png"
    }],
    socials: {
      website: "https://www.blockxnet.com/"
    }
  }]
};
_l.default = hz;
var yl = {};
Object.defineProperty(yl, "__esModule", { value: !0 });
const pz = {
  $schema: "../chain.schema.json",
  chain_name: "blockx",
  status: "live",
  network_type: "mainnet",
  website: "https://www.blockxnet.com/",
  pretty_name: "BlockX",
  chain_type: "cosmos",
  chain_id: "blockx_19191-1",
  bech32_prefix: "blockx",
  node_home: "$HOME/.blockxd",
  daemon_name: "blockxd",
  key_algos: ["ethsecp256k1"],
  staking: {
    staking_tokens: [{
      denom: "abcx"
    }]
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/blockx/images/blockx.png"
  }],
  slip44: 118
};
yl.default = pz;
var f9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ko, "__esModule", { value: !0 });
Ko.chain = Ko.assets = void 0;
const lz = f9(_l), gz = f9(yl);
Ko.assets = lz.default;
Ko.chain = gz.default;
var Xo = {}, bl = {};
Object.defineProperty(bl, "__esModule", { value: !0 });
const uz = {
  $schema: "../assetlist.schema.json",
  chain_name: "bluechip",
  assets: [{
    description: "The native staking token of BlueChip.",
    denom_units: [{
      denom: "ubluechip",
      exponent: 0
    }, {
      denom: "bcp",
      exponent: 6
    }],
    base: "ubluechip",
    name: "blue chip",
    display: "bcp",
    symbol: "BCP",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluechip/images/bluechip.png",
      theme: {
        primary_color_hex: "#0c94d3"
      }
    }]
  }]
};
bl.default = uz;
var vl = {};
Object.defineProperty(vl, "__esModule", { value: !0 });
const _z = {
  $schema: "../chain.schema.json",
  chain_name: "bluechip",
  status: "live",
  website: "https://www.bluechip.link",
  network_type: "mainnet",
  pretty_name: "BlueChip",
  chain_type: "cosmos",
  chain_id: "bluechip-2",
  bech32_prefix: "bcp",
  daemon_name: "bluechipd",
  node_home: "$HOME/.bluechip",
  slip44: 118,
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "ubluechip",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ubluechip"
    }]
  },
  description: "Stake to the BlueChip chain, interact with the creator pools, and subscribe through the creator subscription contracts.",
  codebase: {
    cosmos_sdk_version: "0.47.11",
    cosmwasm_enabled: !0
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluechip/images/bluechip.png",
    theme: {
      primary_color_hex: "#0c94d3"
    }
  }]
};
vl.default = _z;
var w9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Xo, "__esModule", { value: !0 });
Xo.chain = Xo.assets = void 0;
const yz = w9(bl), bz = w9(vl);
Xo.assets = yz.default;
Xo.chain = bz.default;
var Xn = {}, fl = {};
Object.defineProperty(fl, "__esModule", { value: !0 });
const vz = {
  $schema: "../assetlist.schema.json",
  chain_name: "bluzelle",
  assets: [
    {
      description: "The native token of Bluzelle",
      denom_units: [{
        denom: "ubnt",
        exponent: 0
      }, {
        denom: "bnt",
        exponent: 6,
        aliases: ["blz"]
      }],
      base: "ubnt",
      name: "Bluzelle",
      display: "bnt",
      symbol: "BLZ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.svg"
      },
      coingecko_id: "bluzelle",
      keywords: ["bluzelle", "game"],
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.svg",
        theme: {
          primary_color_hex: "#708ffc"
        }
      }],
      socials: {
        website: "http://bluzelle.com/",
        twitter: "https://twitter.com/BluzelleHQ"
      }
    },
    {
      description: "The ELT token of Bluzelle's Gamma 4 Gaming Ecosystem",
      denom_units: [{
        denom: "uelt",
        exponent: 0
      }, {
        denom: "elt",
        exponent: 6
      }],
      base: "uelt",
      name: "ELT",
      display: "elt",
      symbol: "ELT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/elt.png"
      },
      keywords: ["elt"],
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/elt.png",
        theme: {
          primary_color_hex: "#0c3ab5"
        }
      }]
    },
    {
      description: "The game token of Bluzelle's Gamma 4 Gaming Ecosystem",
      denom_units: [{
        denom: "ug4",
        exponent: 0
      }, {
        denom: "g4",
        exponent: 6
      }],
      base: "ug4",
      name: "G4",
      display: "g4",
      symbol: "G4",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/g4.png"
      },
      keywords: ["g4"],
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/g4.png",
        theme: {
          primary_color_hex: "#ee8828"
        }
      }]
    }
  ]
};
fl.default = vz;
var wl = {};
Object.defineProperty(wl, "__esModule", { value: !0 });
const fz = {
  $schema: "../chain.schema.json",
  chain_name: "bluzelle",
  status: "live",
  network_type: "mainnet",
  website: "https://bluzelle.com/",
  pretty_name: "Bluzelle",
  chain_type: "cosmos",
  chain_id: "bluzelle-9",
  bech32_prefix: "bluzelle",
  daemon_name: "curiumd",
  node_home: "$HOME/.curium",
  key_algos: ["secp256k1"],
  slip44: 483,
  fees: {
    fee_tokens: [{
      denom: "ubnt",
      fixed_min_gas_price: 2e-3,
      low_gas_price: 2e-3,
      average_gas_price: 2e-3,
      high_gas_price: 0.025
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ubnt"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.45.11"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://a.client.sentry.net.bluzelle.com:26657",
        provider: "Bluzelle"
      },
      {
        address: "https://b.client.sentry.net.bluzelle.com:26657",
        provider: "Bluzelle"
      },
      {
        address: "https://c.client.sentry.net.bluzelle.com:26657",
        provider: "Bluzelle"
      },
      {
        address: "https://bluzelle_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://a.client.sentry.net.bluzelle.com:1317",
        provider: "Bluzelle"
      },
      {
        address: "https://b.client.sentry.net.bluzelle.com:1317",
        provider: "Bluzelle"
      },
      {
        address: "https://c.client.sentry.net.bluzelle.com:1317",
        provider: "Bluzelle"
      },
      {
        address: "https://bluzelle-api.genznodes.dev/",
        provider: "genznodes"
      },
      {
        address: "https://bluzelle_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "a.client.sentry.net.bluzelle.com:9090",
        provider: "Bluzelle"
      },
      {
        address: "b.client.sentry.net.bluzelle.com:9090",
        provider: "Bluzelle"
      },
      {
        address: "c.client.sentry.net.bluzelle.com:9090",
        provider: "Bluzelle"
      },
      {
        address: "bluzelle-grpc.genznodes.dev:34090",
        provider: "genznodes"
      },
      {
        address: "https://grpc-curium.nodine.id:443",
        provider: "Nodine.ID"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.explorer.net.bluzelle.com/bluzelle",
      tx_page: "https://ping.explorer.net.bluzelle.com/bluzelle/tx/${txHash}",
      account_page: "https://ping.explorer.net.bluzelle.com/bluzelle/account/${accountAddress}"
    },
    {
      kind: "big dipper",
      url: "https://bd.explorer.net.bluzelle.com",
      tx_page: "https://bd.explorer.net.bluzelle.com/transactions/${txHash}",
      account_page: "https://bd.explorer.net.bluzelle.com/accounts/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/bluzelle",
      tx_page: "https://explorer.tcnetwork.io/bluzelle/transaction/${txHash}"
    },
    {
      kind: "Nodine.ID",
      url: "https://explorer.co.id/bluzelle",
      tx_page: "https://explorer.co.id/bluzelle/transaction/${txHash}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/bluzelle",
      tx_page: "https://explorer.whenmoonwhenlambo.money/bluzelle/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/bluzelle/account/${accountAddress}"
    }
  ],
  keywords: [
    "bluzelle",
    "game",
    "gamma4",
    "nft"
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.svg",
    theme: {
      primary_color_hex: "#708ffc"
    }
  }]
};
wl.default = fz;
var xl = {};
Object.defineProperty(xl, "__esModule", { value: !0 });
const wz = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "bluzelle",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2754",
    connection_id: "connection-2273"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-763",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
xl.default = wz;
var kl = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Xn, "__esModule", { value: !0 });
Xn.ibc = Xn.chain = Xn.assets = void 0;
const xz = kl(fl), kz = kl(wl), Az = kl(xl);
Xn.assets = xz.default;
Xn.chain = kz.default;
Xn.ibc = Az.default;
var Yn = {}, Al = {};
Object.defineProperty(Al, "__esModule", { value: !0 });
const jz = {
  $schema: "../assetlist.schema.json",
  chain_name: "bostrom",
  assets: [
    {
      description: "The staking token of Bostrom",
      denom_units: [{
        denom: "boot",
        exponent: 0,
        aliases: ["boot"]
      }],
      base: "boot",
      name: "Bostrom",
      display: "boot",
      symbol: "BOOT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.svg"
      },
      coingecko_id: "bostrom",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.svg",
        theme: {
          primary_color_hex: "#4cea4e"
        }
      }]
    },
    {
      description: "The liquid staking token of Bostrom",
      denom_units: [{
        denom: "hydrogen",
        exponent: 0,
        aliases: ["hydrogen"]
      }],
      base: "hydrogen",
      name: "Bostrom Hydrogen",
      display: "hydrogen",
      symbol: "HYDROGEN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/hydrogen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/hydrogen.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/hydrogen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/hydrogen.svg",
        theme: {
          primary_color_hex: "#ffffff"
        }
      }]
    },
    {
      description: "The resource token of Bostrom",
      denom_units: [{
        denom: "milliampere",
        exponent: 0,
        aliases: ["milliampere"]
      }, {
        denom: "ampere",
        exponent: 3,
        aliases: ["ampere"]
      }],
      base: "milliampere",
      name: "Bostrom Ampere",
      display: "ampere",
      symbol: "A",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/ampere.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/ampere.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/ampere.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/ampere.svg",
        theme: {
          primary_color_hex: "#f4ecce"
        }
      }]
    },
    {
      description: "The resource token of Bostrom",
      denom_units: [{
        denom: "millivolt",
        exponent: 0,
        aliases: ["millivolt"]
      }, {
        denom: "volt",
        exponent: 3,
        aliases: ["volt"]
      }],
      base: "millivolt",
      name: "Bostrom Volt",
      display: "volt",
      symbol: "V",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/volt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/volt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/volt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/volt.svg",
        theme: {
          primary_color_hex: "#fba809"
        }
      }]
    },
    {
      description: "The staking token of Cyber",
      denom_units: [{
        denom: "tocyb",
        exponent: 0,
        aliases: ["tocyb"]
      }],
      base: "tocyb",
      name: "Bostrom Tocyb",
      display: "tocyb",
      symbol: "TOCYB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/tocyb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/tocyb.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/tocyb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/tocyb.svg",
        theme: {
          primary_color_hex: "#1e8fa9"
        }
      }]
    }
  ]
};
Al.default = jz;
var jl = {};
Object.defineProperty(jl, "__esModule", { value: !0 });
const Cz = {
  $schema: "../chain.schema.json",
  chain_name: "bostrom",
  status: "live",
  network_type: "mainnet",
  pretty_name: "bostrom",
  chain_type: "cosmos",
  chain_id: "bostrom",
  bech32_prefix: "bostrom",
  daemon_name: "cyber",
  node_home: "$HOME/.cyber",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "boot",
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0.01
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "boot"
    }]
  },
  codebase: {
    cosmwasm_enabled: !0
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.bostrom.cybernode.ai",
        provider: "cybercongress"
      },
      {
        address: "https://rpc-cyber-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc.cyber.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    rest: [
      {
        address: "https://lcd.bostrom.cybernode.ai",
        provider: "cybercongress"
      },
      {
        address: "https://api-cyber-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://lcd.cyber.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    grpc: [{
      address: "grpc-cyber-ia.cosmosia.notional.ventures:443",
      provider: "Notional"
    }, {
      address: "https://grpc.cyber.bronbro.io:443",
      provider: "Bro_n_Bro"
    }]
  },
  explorers: [
    {
      kind: "cyb",
      url: "https://cyb.ai/",
      tx_page: "https://cyb.ai/network/bostrom/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/bostrom",
      tx_page: "https://ping.pub/bostrom/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/bostrom",
      tx_page: "https://atomscan.com/bostrom/transactions/${txHash}",
      account_page: "https://atomscan.com/bostrom/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.svg",
    theme: {
      primary_color_hex: "#4cea4e"
    }
  }]
};
jl.default = Cz;
var Cl = {};
Object.defineProperty(Cl, "__esModule", { value: !0 });
const Ez = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "bostrom",
    client_id: "07-tendermint-15",
    connection_id: "connection-10"
  },
  chain_2: {
    chain_name: "cosmoshub",
    client_id: "07-tendermint-764",
    connection_id: "connection-553"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-8",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-341",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "bostrom",
    client_id: "07-tendermint-5",
    connection_id: "connection-2"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1597",
    connection_id: "connection-1255"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-95",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Cl.default = Ez;
var El = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Yn, "__esModule", { value: !0 });
Yn.ibc = Yn.chain = Yn.assets = void 0;
const Dz = El(Al), Bz = El(jl), Fz = El(Cl);
Yn.assets = Dz.default;
Yn.chain = Bz.default;
Yn.ibc = Fz.default;
var Jn = {}, Dl = {};
Object.defineProperty(Dl, "__esModule", { value: !0 });
const $z = {
  $schema: "../assetlist.schema.json",
  chain_name: "canto",
  assets: [{
    description: "Canto is a Layer-1 blockchain built to deliver on the promise of DeFi",
    denom_units: [{
      denom: "acanto",
      exponent: 0
    }, {
      denom: "canto",
      exponent: 18
    }],
    base: "acanto",
    name: "Canto",
    display: "canto",
    symbol: "CANTO",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.svg"
    },
    coingecko_id: "canto",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.svg",
      theme: {
        primary_color_hex: "#1c1f1f"
      }
    }],
    socials: {
      website: "https://canto.io/",
      twitter: "https://twitter.com/CantoPublic"
    }
  }, {
    description: "Tether USDt on Canto",
    denom_units: [{
      denom: "ibc/FAFF3F7B2FE30447544A27910DF77069763CF25472BFCF63A9E7C81F0AD545AC",
      exponent: 0
    }, {
      denom: "usdt",
      exponent: 6
    }],
    type_asset: "ics20",
    base: "ibc/FAFF3F7B2FE30447544A27910DF77069763CF25472BFCF63A9E7C81F0AD545AC",
    name: "Tether USDt",
    display: "usdt",
    symbol: "USDt",
    traces: [{
      type: "ibc",
      counterparty: {
        chain_name: "kava",
        base_denom: "erc20/tether/usdt",
        channel_id: "channel-87"
      },
      chain: {
        channel_id: "channel-13",
        path: "transfer/channel-13/erc20/tether/usdt"
      }
    }],
    images: [{
      image_sync: {
        chain_name: "kava",
        base_denom: "erc20/tether/usdt"
      },
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
      theme: {
        circle: !0,
        primary_color_hex: "#009393",
        background_color_hex: "#009393"
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
    }
  }]
};
Dl.default = $z;
var Bl = {};
Object.defineProperty(Bl, "__esModule", { value: !0 });
const zz = {
  $schema: "../chain.schema.json",
  chain_name: "canto",
  status: "live",
  network_type: "mainnet",
  website: "https://canto.io/",
  pretty_name: "Canto",
  chain_type: "cosmos",
  chain_id: "canto_7700-1",
  bech32_prefix: "canto",
  node_home: "$HOME/.cantod",
  daemon_name: "cantod",
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "acanto",
      fixed_min_gas_price: 1e12,
      low_gas_price: 1e12,
      average_gas_price: 2e12,
      high_gas_price: 3e12
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "acanto"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.canto.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://canto-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc.canto.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://canto.gravitychain.io:26657",
        provider: "Althea"
      },
      {
        address: "https://canto-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc-canto.kewrnode.com",
        provider: "Kewr Node"
      }
    ],
    rest: [
      {
        address: "https://api.canto.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://canto-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://api.canto.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://canto-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest-canto.kewrnode.com",
        provider: "Kewr Node"
      }
    ],
    grpc: [
      {
        address: "canto-grpc.polkachu.com:15590",
        provider: "Polkachu"
      },
      {
        address: "grpc.canto.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "https://grpc.canto.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://canto.gravitychain.io:9090",
        provider: "Althea"
      },
      {
        address: "canto-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://canto.neobase.one/",
        provider: "NeoBase"
      },
      {
        address: "https://canto.evm.chandrastation.com",
        provider: "Chandra Station"
      },
      {
        address: "https://canto.slingshot.finance",
        provider: "Slingshot"
      },
      {
        address: "https://jsonrpc.canto.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://evm-rpc.canto.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://canto.gravitychain.io:8545",
        provider: "althea"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://cosmos-explorers.neobase.one/canto",
      tx_page: "https://cosmos-explorers.neobase.one/canto/tx/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/canto",
      tx_page: "https://explorer.tcnetwork.io/canto/transaction/${txHash}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/canto",
      tx_page: "https://ezstaking.app/canto/txs/${txHash}",
      account_page: "https://ezstaking.app/canto/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Canto-Mainnet",
      tx_page: "https://explorer.stavr.tech/Canto-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Canto-Mainnet/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.svg",
    theme: {
      primary_color_hex: "#1c1f1f"
    }
  }]
};
Bl.default = zz;
var Fl = {};
Object.defineProperty(Fl, "__esModule", { value: !0 });
const qz = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "canto",
      client_id: "07-tendermint-10",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "carbon",
      client_id: "07-tendermint-40",
      connection_id: "connection-23"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "canto",
      client_id: "07-tendermint-38",
      connection_id: "connection-32"
    },
    chain_2: {
      chain_name: "composable",
      client_id: "07-tendermint-50",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "canto",
      client_id: "07-tendermint-0",
      connection_id: "07-tendermint-0"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-156",
      connection_id: "connection-150"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "canto",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2481",
      connection_id: "connection-2017"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-550",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "canto",
      client_id: "07-tendermint-24",
      connection_id: "connection-16"
    },
    chain_2: {
      chain_name: "sommelier",
      client_id: "07-tendermint-10",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Fl.default = qz;
var $l = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Jn, "__esModule", { value: !0 });
Jn.ibc = Jn.chain = Jn.assets = void 0;
const Sz = $l(Dl), Tz = $l(Bl), Rz = $l(Fl);
Jn.assets = Sz.default;
Jn.chain = Tz.default;
Jn.ibc = Rz.default;
var Zn = {}, zl = {};
Object.defineProperty(zl, "__esModule", { value: !0 });
const Oz = {
  $schema: "../assetlist.schema.json",
  chain_name: "carbon",
  assets: [
    {
      description: "The native governance token of Carbon",
      denom_units: [{
        denom: "swth",
        exponent: 0
      }, {
        denom: "dswth",
        exponent: 8,
        aliases: ["SWTH"]
      }],
      type_asset: "sdk.coin",
      base: "swth",
      name: "Carbon",
      display: "dswth",
      symbol: "SWTH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.svg"
      },
      coingecko_id: "switcheo",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.svg",
        theme: {
          primary_color_hex: "#a5edf2"
        }
      }]
    },
    {
      description: "The native stablecoin of Carbon",
      denom_units: [{
        denom: "usc",
        exponent: 0
      }, {
        denom: "dusc",
        exponent: 8,
        aliases: ["USC"]
      }],
      type_asset: "sdk.coin",
      base: "usc",
      name: "Carbon USD Coin",
      display: "dusc",
      symbol: "USC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/usc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/usc.svg"
      },
      coingecko_id: "carbon-usd",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/usc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/usc.svg",
        theme: {
          primary_color_hex: "#053e4f"
        }
      }]
    },
    {
      description: "BNB token on Carbon",
      denom_units: [{
        denom: "bnb.1.6.773edb",
        exponent: 0
      }, {
        denom: "bnb",
        exponent: 18,
        aliases: ["BNB"]
      }],
      base: "bnb.1.6.773edb",
      name: "Binance Coin",
      display: "bnb",
      symbol: "BNB",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "binancesmartchain",
          base_denom: "wei",
          contract: "0xb5D4f343412dC8efb6ff599d790074D0f1e8D430"
        },
        chain: {
          contract: "0xb5D4f343412dC8efb6ff599d790074D0f1e8D430"
        },
        provider: "PolyNetwork"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/bnb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/bnb.svg"
      },
      images: [{
        image_sync: {
          chain_name: "binancesmartchain",
          base_denom: "wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/bnb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/bnb.svg",
        theme: {
          primary_color_hex: "#f3bb0c"
        }
      }]
    },
    {
      description: "bNEO token on Carbon",
      denom_units: [{
        denom: "bneo.1.14.e2e5f6",
        exponent: 0
      }, {
        denom: "bneo",
        exponent: 8,
        aliases: ["bNEO"]
      }],
      base: "bneo.1.14.e2e5f6",
      name: "BurgerNEO",
      display: "bneo",
      symbol: "bNEO",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "neo",
          base_denom: "0x48c40d4666f93408be1bef038b6722404d9a4c2a",
          contract: "0x8eb3bdf5ed4ac1516d316c6b1b207a3cf5eb7567"
        },
        chain: {
          contract: "0x8eb3bdf5ed4ac1516d316c6b1b207a3cf5eb7567"
        },
        provider: "PolyNetwork"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/bneo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/bneo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/bneo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/bneo.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "BUSD (BEP-20) token on Carbon",
      denom_units: [{
        denom: "busd.1.6.754a80",
        exponent: 0
      }, {
        denom: "busd",
        exponent: 18,
        aliases: ["BUSD"]
      }],
      base: "busd.1.6.754a80",
      name: "BUSD (BEP-20)",
      display: "busd",
      symbol: "BUSD",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "binancesmartchain",
          base_denom: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
          contract: "0xb5D4f343412dC8efb6ff599d790074D0f1e8D430"
        },
        chain: {
          contract: "0xb5D4f343412dC8efb6ff599d790074D0f1e8D430"
        },
        provider: "PolyNetwork"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.png"
      },
      images: [{
        image_sync: {
          chain_name: "binancesmartchain",
          base_denom: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.png",
        theme: {
          primary_color_hex: "#f3bb0c"
        }
      }]
    },
    {
      description: "Carbon Wrapped GLP on Carbon",
      denom_units: [{
        denom: "cglp.1.19.1698d3",
        exponent: 0
      }, {
        denom: "cglp",
        exponent: 18,
        aliases: ["CGLP"]
      }],
      base: "cglp.1.19.1698d3",
      name: "Carbon Wrapped GLP",
      display: "cglp",
      symbol: "CGLP",
      traces: [{
        type: "wrapped",
        counterparty: {
          chain_name: "arbitrum",
          base_denom: "0xab19bdaeb37242fa0f30486195f45b9cf5361b78",
          contract: "0xb1e6f8820826491fcc5519f84ff4e2bdbb6e3cad"
        },
        chain: {
          contract: "0xb1e6f8820826491fcc5519f84ff4e2bdbb6e3cad"
        },
        provider: "PolyNetwork"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/cglp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/cglp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/cglp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/cglp.svg",
        theme: {
          primary_color_hex: "#070707"
        }
      }]
    },
    {
      description: "Grouped USD on Carbon",
      denom_units: [{
        denom: "cgt/1",
        exponent: 0
      }, {
        denom: "usd",
        exponent: 18,
        aliases: ["USD"]
      }],
      base: "cgt/1",
      name: "Carbon Grouped USD",
      display: "usd",
      symbol: "USD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/carbon-grouped-usd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/carbon-grouped-usd.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/carbon-grouped-usd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/carbon-grouped-usd.svg",
        theme: {
          primary_color_hex: "#043d4d"
        }
      }]
    },
    {
      description: "ETH (Arbitrum) token on Carbon",
      denom_units: [{
        denom: "eth.1.19.c3b805",
        exponent: 0
      }, {
        denom: "eth",
        exponent: 18,
        aliases: ["ETH"]
      }],
      base: "eth.1.19.c3b805",
      name: "Ethereum (Arbitrum)",
      display: "eth",
      symbol: "ETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "arbitrum",
          base_denom: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
          contract: "0xb1e6f8820826491fcc5519f84ff4e2bdbb6e3cad"
        },
        chain: {
          contract: "0xb1e6f8820826491fcc5519f84ff4e2bdbb6e3cad"
        },
        provider: "PolyNetwork"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth.svg"
      }]
    },
    {
      description: "ETH (ERC20) token on Carbon",
      denom_units: [{
        denom: "eth.1.2.942d87",
        exponent: 0
      }, {
        denom: "eth",
        exponent: 18,
        aliases: ["ETH"]
      }],
      base: "eth.1.2.942d87",
      name: "Ethereum (ERC20)",
      display: "eth",
      symbol: "ETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei",
          contract: "0x9a016ce184a22dbf6c17daa59eb7d3140dbd1c54"
        },
        chain: {
          contract: "0x9a016ce184a22dbf6c17daa59eb7d3140dbd1c54"
        },
        provider: "PolyNetwork"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth.svg"
      }]
    },
    {
      description: "STARS token on Carbon",
      denom_units: [{
        denom: "ibc/07FA7831E1920D0C87C9388F86B0108677F6ED0C9DE7E4063F05ED675192405C",
        exponent: 0
      }, {
        denom: "stars",
        exponent: 6,
        aliases: ["STARS"]
      }],
      type_asset: "ics20",
      base: "ibc/07FA7831E1920D0C87C9388F86B0108677F6ED0C9DE7E4063F05ED675192405C",
      name: "Stargaze Staking Coin",
      display: "stars",
      symbol: "STARS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "ustars",
          channel_id: "channel-123"
        },
        chain: {
          channel_id: "channel-15",
          path: "transfer/channel-15/ustars"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stargaze",
          base_denom: "ustars"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg",
        theme: {
          primary_color_hex: "#db2777"
        }
      }]
    },
    {
      description: "LUNA token on Carbon",
      denom_units: [{
        denom: "ibc/2B58B8C147E8718EECCB3713271DF46DEE8A3A00A27242628604E31C2F370EF5",
        exponent: 0
      }, {
        denom: "luna",
        exponent: 6,
        aliases: ["LUNA"]
      }],
      type_asset: "ics20",
      base: "ibc/2B58B8C147E8718EECCB3713271DF46DEE8A3A00A27242628604E31C2F370EF5",
      name: "Terra Staking Coin",
      display: "luna",
      symbol: "LUNA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "terra2",
          base_denom: "uluna",
          channel_id: "channel-36"
        },
        chain: {
          channel_id: "channel-12",
          path: "transfer/channel-12/uluna"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg"
      },
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "uluna"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg",
        theme: {
          primary_color_hex: "#f4de6f"
        }
      }]
    },
    {
      description: "TIA token on Carbon",
      denom_units: [{
        denom: "ibc/6C349F0EB135C5FA99301758F35B87DB88403D690E5E314AB080401FEE4066E5",
        exponent: 0,
        aliases: ["utia"]
      }, {
        denom: "tia",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/6C349F0EB135C5FA99301758F35B87DB88403D690E5E314AB080401FEE4066E5",
      name: "Celestia TIA",
      display: "tia",
      symbol: "TIA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877",
          channel_id: "channel-188"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-6994/utia"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "celestia",
          base_denom: "utia"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg",
        theme: {
          primary_color_hex: "#7c2cfb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg"
      }
    },
    {
      description: "MilkTIA token on Carbon",
      denom_units: [{
        denom: "ibc/16065EE5282C5217685C8F084FC44864C25C706AC37356B0D62811D50B96920F",
        exponent: 0,
        aliases: ["umilkTIA"]
      }, {
        denom: "milkTIA",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/16065EE5282C5217685C8F084FC44864C25C706AC37356B0D62811D50B96920F",
      name: "milkTIA",
      display: "milkTIA",
      symbol: "milkTIA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1f5vfcph2dvfeqcqkhetwv75fda69z7e5c2dldm3kvgj23crkv6wqcn47a0/umilkTIA",
          channel_id: "channel-188"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/factory/osmo1f5vfcph2dvfeqcqkhetwv75fda69z7e5c2dldm3kvgj23crkv6wqcn47a0/umilkTIA"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.svg"
      },
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1f5vfcph2dvfeqcqkhetwv75fda69z7e5c2dldm3kvgj23crkv6wqcn47a0/umilkTIA"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.svg",
        theme: {
          primary_color_hex: "#d18dfc"
        }
      }]
    },
    {
      description: "STRD token on Carbon",
      denom_units: [{
        denom: "ibc/3552CECB7BCE1891DB6070D37EC6E954C972B1400141308FCD85FD148BD06DE5",
        exponent: 0
      }, {
        denom: "strd",
        exponent: 6,
        aliases: ["STRD"]
      }],
      type_asset: "ics20",
      base: "ibc/3552CECB7BCE1891DB6070D37EC6E954C972B1400141308FCD85FD148BD06DE5",
      name: "Stride",
      display: "strd",
      symbol: "STRD",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "ustrd",
          channel_id: "channel-47"
        },
        chain: {
          channel_id: "channel-8",
          path: "transfer/channel-8/ustrd"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "ustrd"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg",
        theme: {
          primary_color_hex: "#e4047c"
        }
      }]
    },
    {
      description: "EVMOS token on Carbon",
      denom_units: [{
        denom: "ibc/35E771B8682D828173F4B795F6C307780F96DC64D6F914FAE4CC9B4666F66364",
        exponent: 0
      }, {
        denom: "evmos",
        exponent: 18,
        aliases: ["EVMOS"]
      }],
      type_asset: "ics20",
      base: "ibc/35E771B8682D828173F4B795F6C307780F96DC64D6F914FAE4CC9B4666F66364",
      name: "Evmos",
      display: "evmos",
      symbol: "EVMOS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "evmos",
          base_denom: "aevmos",
          channel_id: "channel-23"
        },
        chain: {
          channel_id: "channel-6",
          path: "transfer/channel-6/aevmos"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg"
      },
      images: [{
        image_sync: {
          chain_name: "evmos",
          base_denom: "aevmos"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg",
        theme: {
          primary_color_hex: "#ec4c34"
        }
      }]
    },
    {
      description: "IRIS token on Carbon",
      denom_units: [{
        denom: "ibc/4E06CF24FEBFB3F5AF645377DCC0B70AA6183BAF6B918B8B6243FCDEB7D38118",
        exponent: 0
      }, {
        denom: "iris",
        exponent: 6,
        aliases: ["IRIS"]
      }],
      type_asset: "ics20",
      base: "ibc/4E06CF24FEBFB3F5AF645377DCC0B70AA6183BAF6B918B8B6243FCDEB7D38118",
      name: "IRIS Hub Staking Coin",
      display: "iris",
      symbol: "IRIS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "irisnet",
          base_denom: "uiris",
          channel_id: "channel-68"
        },
        chain: {
          channel_id: "channel-28",
          path: "transfer/channel-28/uiris"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.svg"
      },
      images: [{
        image_sync: {
          chain_name: "irisnet",
          base_denom: "uiris"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.svg",
        theme: {
          primary_color_hex: "#5664ad"
        }
      }]
    },
    {
      description: "KUJI token on Carbon",
      denom_units: [{
        denom: "ibc/662914D0C1CEBCB070C68F061D035E8B10A07C79AB286E7342C85F3BE74612C5",
        exponent: 0
      }, {
        denom: "kuji",
        exponent: 6,
        aliases: ["KUJI"]
      }],
      type_asset: "ics20",
      base: "ibc/662914D0C1CEBCB070C68F061D035E8B10A07C79AB286E7342C85F3BE74612C5",
      name: "Kujira",
      display: "kuji",
      symbol: "KUJI",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kujira",
          base_denom: "ukuji",
          channel_id: "channel-46"
        },
        chain: {
          channel_id: "channel-9",
          path: "transfer/channel-9/ukuji"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kujira",
          base_denom: "ukuji"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.svg",
        theme: {
          primary_color_hex: "#e33b34"
        }
      }]
    },
    {
      description: "stOSMO token on Carbon",
      denom_units: [{
        denom: "ibc/75249A18DEFBEFE55F83B1C70CAD234DF164F174C6BC51682EE92C2C81C18C93",
        exponent: 0
      }, {
        denom: "stosmo",
        exponent: 6,
        aliases: ["stOSMO"]
      }],
      type_asset: "ics20",
      base: "ibc/75249A18DEFBEFE55F83B1C70CAD234DF164F174C6BC51682EE92C2C81C18C93",
      name: "Stride Staked OSMO",
      display: "stosmo",
      symbol: "stOSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stuosmo",
          channel_id: "channel-47"
        },
        chain: {
          channel_id: "channel-8",
          path: "transfer/channel-8/stuosmo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stuosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "CANTO token on Carbon",
      denom_units: [{
        denom: "ibc/92E974290AF9E2BC3AEEEC35305C8FD76AC5A22A74CF8D91270FDF5A1C41E861",
        exponent: 0
      }, {
        denom: "canto",
        exponent: 18,
        aliases: ["CANTO"]
      }],
      type_asset: "ics20",
      base: "ibc/92E974290AF9E2BC3AEEEC35305C8FD76AC5A22A74CF8D91270FDF5A1C41E861",
      name: "Canto",
      display: "canto",
      symbol: "CANTO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "canto",
          base_denom: "acanto",
          channel_id: "channel-6"
        },
        chain: {
          channel_id: "channel-18",
          path: "transfer/channel-18/acanto"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.svg"
      },
      images: [{
        image_sync: {
          chain_name: "canto",
          base_denom: "acanto"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.svg",
        theme: {
          primary_color_hex: "#1c1f1f"
        }
      }]
    },
    {
      description: "Cosmos governance token on Carbon",
      denom_units: [{
        denom: "ibc/A4DB47A9D3CF9A068D454513891B526702455D3EF08FB9EB558C561F9DC2B701",
        exponent: 0
      }, {
        denom: "atom",
        exponent: 6,
        aliases: ["ATOM"]
      }],
      type_asset: "ics20",
      base: "ibc/A4DB47A9D3CF9A068D454513891B526702455D3EF08FB9EB558C561F9DC2B701",
      name: "Cosmos",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-342"
        },
        chain: {
          channel_id: "channel-3",
          path: "transfer/channel-3/uatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }]
    },
    {
      description: "stATOM token on Carbon",
      denom_units: [{
        denom: "ibc/B7864B03E1B9FD4F049243E92ABD691586F682137037A9F3FCA5222815620B3C",
        exponent: 0
      }, {
        denom: "statom",
        exponent: 6,
        aliases: ["stATOM"]
      }],
      type_asset: "ics20",
      base: "ibc/B7864B03E1B9FD4F049243E92ABD691586F682137037A9F3FCA5222815620B3C",
      name: "Stride Staked ATOM",
      display: "statom",
      symbol: "stATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stuatom",
          channel_id: "channel-47"
        },
        chain: {
          channel_id: "channel-8",
          path: "transfer/channel-8/stuatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stuatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "OSMO token on Carbon",
      denom_units: [{
        denom: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
        exponent: 0
      }, {
        denom: "osmo",
        exponent: 6,
        aliases: ["OSMO"]
      }],
      type_asset: "ics20",
      base: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
      name: "Osmosis",
      display: "osmo",
      symbol: "OSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo",
          channel_id: "channel-188"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/uosmo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }]
    },
    {
      description: "USDC (ERC20) token on Carbon",
      denom_units: [{
        denom: "usdc.1.2.343151",
        exponent: 0
      }, {
        denom: "usdc",
        exponent: 6,
        aliases: ["USDC"]
      }],
      base: "usdc.1.2.343151",
      name: "Circle USD",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          contract: "0x9a016ce184a22dbf6c17daa59eb7d3140dbd1c54"
        },
        chain: {
          contract: "0x9a016ce184a22dbf6c17daa59eb7d3140dbd1c54"
        },
        provider: "PolyNetwork"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "USD Coin (BEP-20) token on Carbon",
      denom_units: [{
        denom: "usdc.1.6.53ff75",
        exponent: 0
      }, {
        denom: "usdc",
        exponent: 18,
        aliases: ["USDC"]
      }],
      base: "usdc.1.6.53ff75",
      name: "USD Coin (BEP-20)",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "binancesmartchain",
          base_denom: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
          contract: "0xb5D4f343412dC8efb6ff599d790074D0f1e8D430"
        },
        chain: {
          contract: "0xb5D4f343412dC8efb6ff599d790074D0f1e8D430"
        },
        provider: "PolyNetwork"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "binancesmartchain",
          base_denom: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }]
    },
    {
      description: "ZIL token on Carbon",
      denom_units: [{
        denom: "zil.1.18.1a4a06",
        exponent: 0
      }, {
        denom: "zil",
        exponent: 12,
        aliases: ["ZIL"]
      }],
      base: "zil.1.18.1a4a06",
      name: "Zilliqa",
      display: "zil",
      symbol: "ZIL",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "zilliqa",
          base_denom: "wei",
          contract: "0xd73c6b871b4d0e130d64581993b745fc938a5be7"
        },
        chain: {
          contract: "0xd73c6b871b4d0e130d64581993b745fc938a5be7"
        },
        provider: "PolyNetwork"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/zil.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/zil.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/zil.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/zil.svg",
        theme: {
          primary_color_hex: "#2cccc4"
        }
      }]
    }
  ]
};
zl.default = Oz;
var ql = {};
Object.defineProperty(ql, "__esModule", { value: !0 });
const Mz = {
  $schema: "../chain.schema.json",
  chain_name: "carbon",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Carbon",
  chain_type: "cosmos",
  chain_id: "carbon-1",
  bech32_prefix: "swth",
  daemon_name: "carbond",
  website: "https://www.carbon.network/",
  node_home: "$HOME/.carbon",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [
      {
        denom: "swth",
        fixed_min_gas_price: 1,
        low_gas_price: 1,
        average_gas_price: 1,
        high_gas_price: 1,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "usc",
        fixed_min_gas_price: 0,
        low_gas_price: 1e-4,
        average_gas_price: 1e-4,
        high_gas_price: 1e-4,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "bnb.1.6.773edb",
        fixed_min_gas_price: 0,
        low_gas_price: 1e6,
        average_gas_price: 1e6,
        high_gas_price: 1e6,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "bneo.1.14.e2e5f6",
        fixed_min_gas_price: 0,
        low_gas_price: 15e-4,
        average_gas_price: 15e-4,
        high_gas_price: 15e-4,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "busd.1.6.754a80",
        fixed_min_gas_price: 0,
        low_gas_price: 1e8,
        average_gas_price: 1e8,
        high_gas_price: 1e8,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "cglp.1.19.1698d3",
        fixed_min_gas_price: 0,
        low_gas_price: 1e8,
        average_gas_price: 1e8,
        high_gas_price: 1e8,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "cgt/1",
        fixed_min_gas_price: 0,
        low_gas_price: 1e8,
        average_gas_price: 1e8,
        high_gas_price: 1e8,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "eth.1.19.c3b805",
        fixed_min_gas_price: 0,
        low_gas_price: 1e5,
        average_gas_price: 1e5,
        high_gas_price: 1e5,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "eth.1.2.942d87",
        fixed_min_gas_price: 0,
        low_gas_price: 1e5,
        average_gas_price: 1e5,
        high_gas_price: 1e5,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/07FA7831E1920D0C87C9388F86B0108677F6ED0C9DE7E4063F05ED675192405C",
        fixed_min_gas_price: 0,
        low_gas_price: 35e-4,
        average_gas_price: 35e-4,
        high_gas_price: 35e-4,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/16065EE5282C5217685C8F084FC44864C25C706AC37356B0D62811D50B96920F",
        fixed_min_gas_price: 0,
        low_gas_price: 75e-7,
        average_gas_price: 75e-7,
        high_gas_price: 75e-7,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/2B58B8C147E8718EECCB3713271DF46DEE8A3A00A27242628604E31C2F370EF5",
        fixed_min_gas_price: 0,
        low_gas_price: 5e-5,
        average_gas_price: 5e-5,
        high_gas_price: 5e-5,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/3552CECB7BCE1891DB6070D37EC6E954C972B1400141308FCD85FD148BD06DE5",
        fixed_min_gas_price: 0,
        low_gas_price: 32e-5,
        average_gas_price: 32e-5,
        high_gas_price: 32e-5,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/35E771B8682D828173F4B795F6C307780F96DC64D6F914FAE4CC9B4666F66364",
        fixed_min_gas_price: 0,
        low_gas_price: 3e8,
        average_gas_price: 3e8,
        high_gas_price: 3e8,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/4E06CF24FEBFB3F5AF645377DCC0B70AA6183BAF6B918B8B6243FCDEB7D38118",
        fixed_min_gas_price: 0,
        low_gas_price: 6e-4,
        average_gas_price: 6e-4,
        high_gas_price: 6e-4,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/662914D0C1CEBCB070C68F061D035E8B10A07C79AB286E7342C85F3BE74612C5",
        fixed_min_gas_price: 0,
        low_gas_price: 15e-5,
        average_gas_price: 15e-5,
        high_gas_price: 15e-5,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/6C349F0EB135C5FA99301758F35B87DB88403D690E5E314AB080401FEE4066E5",
        fixed_min_gas_price: 0,
        low_gas_price: 75e-7,
        average_gas_price: 75e-7,
        high_gas_price: 75e-7,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/75249A18DEFBEFE55F83B1C70CAD234DF164F174C6BC51682EE92C2C81C18C93",
        fixed_min_gas_price: 0,
        low_gas_price: 15e-5,
        average_gas_price: 15e-5,
        high_gas_price: 15e-5,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/92E974290AF9E2BC3AEEEC35305C8FD76AC5A22A74CF8D91270FDF5A1C41E861",
        fixed_min_gas_price: 0,
        low_gas_price: 2e8,
        average_gas_price: 2e8,
        high_gas_price: 2e8,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/A4DB47A9D3CF9A068D454513891B526702455D3EF08FB9EB558C561F9DC2B701",
        fixed_min_gas_price: 0,
        low_gas_price: 1e-5,
        average_gas_price: 1e-5,
        high_gas_price: 1e-5,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/B7864B03E1B9FD4F049243E92ABD691586F682137037A9F3FCA5222815620B3C",
        fixed_min_gas_price: 0,
        low_gas_price: 1e-5,
        average_gas_price: 1e-5,
        high_gas_price: 1e-5,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
        fixed_min_gas_price: 0,
        low_gas_price: 15e-5,
        average_gas_price: 15e-5,
        high_gas_price: 15e-5,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "usdc.1.2.343151",
        fixed_min_gas_price: 0,
        low_gas_price: 1e-4,
        average_gas_price: 1e-4,
        high_gas_price: 1e-4,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "usdc.1.6.53ff75",
        fixed_min_gas_price: 0,
        low_gas_price: 1e8,
        average_gas_price: 1e8,
        high_gas_price: 1e8,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      },
      {
        denom: "zil.1.18.1a4a06",
        fixed_min_gas_price: 0,
        low_gas_price: 6e3,
        average_gas_price: 6e3,
        high_gas_price: 6e3,
        gas_costs: {
          cosmos_send: 1e7,
          ibc_transfer: 1e7
        }
      }
    ]
  },
  staking: {
    staking_tokens: [{
      denom: "swth"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://tm-api.carbon.network",
        provider: "switcheo-labs"
      },
      {
        address: "https://rpc.lavenderfive.com:443/carbon",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://carbon-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc.carbon.blockhunters.org",
        provider: "BlockHunters"
      }
    ],
    rest: [
      {
        address: "https://api.carbon.network",
        provider: "switcheo-labs"
      },
      {
        address: "https://rest.lavenderfive.com:443/carbon",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://carbon-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest.carbon.blockhunters.org",
        provider: "BlockHunters"
      }
    ],
    grpc: [{
      address: "carbon.lavenderfive.com:443",
      provider: "Lavender.Five Nodes 🐝"
    }, {
      address: "carbon-mainnet-grpc.autostake.com:443",
      provider: "AutoStake 🛡️ Slash Protected"
    }]
  },
  explorers: [
    {
      kind: "carbonscan",
      url: "https://scan.carbon.network",
      tx_page: "https://scan.carbon.network/transaction/${txHash}?net=main"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/carbon",
      tx_page: "https://ping.pub/carbon/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/carbon",
      tx_page: "https://atomscan.com/carbon/transactions/${txHash}",
      account_page: "https://atomscan.com/carbon/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.svg",
    theme: {
      primary_color_hex: "#a5edf2"
    }
  }]
};
ql.default = Mz;
var Sl = {};
Object.defineProperty(Sl, "__esModule", { value: !0 });
const Iz = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "canto",
      client_id: "07-tendermint-10",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "carbon",
      client_id: "07-tendermint-40",
      connection_id: "connection-23"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-6",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-765",
      connection_id: "connection-554"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-342",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-11",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-73",
      connection_id: "connection-29"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-53",
      connection_id: "connection-30"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-151",
      connection_id: "connection-114"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-28",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-68",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-16",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-60",
      connection_id: "connection-40"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-3",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1808",
      connection_id: "connection-1412"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-188",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-36",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-224",
      connection_id: "connection-158"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-123",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-13",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-40",
      connection_id: "connection-27"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-47",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-33",
      connection_id: "connection-16"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-66",
      connection_id: "connection-54"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }, {
      chain_1: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Sl.default = Iz;
var Tl = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Zn, "__esModule", { value: !0 });
Zn.ibc = Zn.chain = Zn.assets = void 0;
const Nz = Tl(zl), Pz = Tl(ql), Uz = Tl(Sl);
Zn.assets = Nz.default;
Zn.chain = Pz.default;
Zn.ibc = Uz.default;
var Qn = {}, Rl = {};
Object.defineProperty(Rl, "__esModule", { value: !0 });
const Hz = {
  $schema: "../assetlist.schema.json",
  chain_name: "celestia",
  assets: [{
    description: "Celestia is a modular blockchain network focused on data availability, allowing developers to deploy their own customizable blockchains with ease.",
    extended_description: `Celestia is a pioneering blockchain platform that aims to address the scalability and interoperability challenges faced by current blockchain networks. It introduces a modular architecture that separates consensus and data availability from execution, allowing developers to create highly customizable and scalable blockchains. By decoupling these functions, Celestia enables independent blockchains to interact seamlessly while maintaining high throughput and security.

Celestia's unique approach includes a consensus and data availability layer that supports multiple execution environments, facilitating a diverse range of decentralized applications (dApps). This design allows for greater flexibility and efficiency, as developers can choose the best execution environment for their specific use case. Celestia's focus on modularity and interoperability has the potential to significantly enhance the blockchain ecosystem by enabling more scalable and adaptable solutions.`,
    denom_units: [{
      denom: "utia",
      exponent: 0
    }, {
      denom: "tia",
      exponent: 6
    }],
    base: "utia",
    name: "Celestia",
    display: "tia",
    symbol: "TIA",
    coingecko_id: "celestia",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg",
      theme: {
        primary_color_hex: "#7c2cfb"
      }
    }],
    socials: {
      website: "https://celestia.org/",
      twitter: "https://twitter.com/CelestiaOrg"
    }
  }]
};
Rl.default = Hz;
var Ol = {};
Object.defineProperty(Ol, "__esModule", { value: !0 });
const Lz = {
  $schema: "../chain.schema.json",
  chain_name: "celestia",
  chain_type: "cosmos",
  chain_id: "celestia",
  pretty_name: "Celestia",
  status: "live",
  network_type: "mainnet",
  website: "https://celestia.org/",
  bech32_prefix: "celestia",
  daemon_name: "celestia-appd",
  node_home: "$HOME/.celestia-app",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utia",
      fixed_min_gas_price: 2e-3,
      low_gas_price: 0.01,
      average_gas_price: 0.02,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "utia"
    }]
  },
  codebase: {
    cosmos_sdk_version: "celestiaorg/cosmos-sdk v1.24.1-sdk-v0.46.16"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg"
  },
  description: "Celestia is a modular data availability network that securely scales with the number of users, making it easy for anyone to launch their own blockchain.",
  apis: {
    rpc: [
      {
        address: "https://public-celestia-rpc.numia.xyz",
        provider: "Numia"
      },
      {
        address: "https://celestia-rpc.mesa.newmetric.xyz",
        provider: "Newmetric"
      },
      {
        address: "https://rpc.lunaroasis.net",
        provider: "Lunar Oasis"
      },
      {
        address: "https://rpc.celestia.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rpc.lavenderfive.com:443/celestia",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-celestia-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://rpc-celestia.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "http://celestia.rpc.nodersteam.com:29657",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://celestia.rpc.interchain.validao.xyz",
        provider: "ValiDAO"
      },
      {
        address: "https://celestia-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://celestia.rpc.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://celestia.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://celestia-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-celestia.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://celestia-rpc.enigma-validator.com",
        provider: "Enigma"
      },
      {
        address: "https://rpc-celestia.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://celestia-mainnet-rpc.autostake.com:443",
        provider: "AutoStake | Delegate for StakeDrops"
      },
      {
        address: "https://rpc.celestia.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://celestia-rpc.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://rpc-celestia-full.avril14th.org",
        provider: "Avril 14th"
      },
      {
        address: "https://rpc.freshstaking.com/celestia",
        provider: "FreshSTAKING"
      },
      {
        address: "https://celestia.cumulo.org.es/",
        provider: "Cumulo"
      },
      {
        address: "https://celestia-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://rpc.celestia-app.bronbro.io",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://celestia-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://rpc.celestia.citizenweb3.com",
        provider: "Citizen Web3"
      },
      {
        address: "https://celestia-mainnet-rpc.itrocket.net",
        provider: "🚀 itrocket 🚀"
      },
      {
        address: "https://rpc.celestia.mainnet.dteam.tech:443",
        provider: "DTEAM"
      }
    ],
    rest: [
      {
        address: "https://public-celestia-lcd.numia.xyz",
        provider: "Numia"
      },
      {
        address: "https://celestia-rest.mesa.newmetric.xyz",
        provider: "Newmetric"
      },
      {
        address: "http://celestia.rpc.nodersteam.com:1617",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://api.lunaroasis.net",
        provider: "Lunar Oasis"
      },
      {
        address: "https://api.celestia.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rest.lavenderfive.com:443/celestia",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api-celestia-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://api-celestia.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://celestia.rest.interchain.validao.xyz",
        provider: "ValiDAO"
      },
      {
        address: "https://celestia-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://celestia.rest.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://celestia.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://api-celestia.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://celestia-lcd.enigma-validator.com",
        provider: "Enigma"
      },
      {
        address: "https://rest-celestia.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://api.celestia.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://celestia-api.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://celestia-mainnet-lcd.autostake.com:443",
        provider: "AutoStake | Delegate for StakeDrops"
      },
      {
        address: "https://api-celestia-full.avril14th.org",
        provider: "Avril 14th"
      },
      {
        address: "https://celestia.api.cumulo.org.es",
        provider: "Cumulo"
      },
      {
        address: "https://celestia-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://lcd.celestia-app.bronbro.io",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://celestia-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://celestia-mainnet-api.itrocket.net",
        provider: "🚀 itrocket 🚀"
      },
      {
        address: "https://api.celestia.mainnet.dteam.tech:443",
        provider: "DTEAM"
      }
    ],
    grpc: [
      {
        address: "https://grpc.celestia.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "celestia-mainnet-grpc.autostake.com:443",
        provider: "AutoStake | Delegate for StakeDrops"
      },
      {
        address: "celestia.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "celestia.grpc.nodersteam.com:9690",
        provider: "[NODERS]TEAM"
      },
      {
        address: "grpc-celestia-01.stakeflow.io:15002",
        provider: "Stakeflow"
      },
      {
        address: "grpc-celestia.cosmos-spaces.cloud:443",
        provider: "Cosmos Spaces"
      },
      {
        address: "celestia.grpc.interchain.validao.xyz:443",
        provider: "ValiDAO"
      },
      {
        address: "celestia-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "celestia.grpc.stakin-nodes.com:443",
        provider: "Stakin"
      },
      {
        address: "celestia.grpc.kjnodes.com:443",
        provider: "kjnodes"
      },
      {
        address: "grpc-celestia.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "grpc-celestia.theamsolutions.info:443",
        provider: "AM Solutions"
      },
      {
        address: "grpc.celestia.validatus.com",
        provider: "Validatus"
      },
      {
        address: "celestia-grpc.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "grpc-celestia-full.avril14th.org",
        provider: "Avril 14th"
      },
      {
        address: "celestia.grpc.cumulo.org.es",
        provider: "Cumulo"
      },
      {
        address: "https://celestia-grpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "grpc.celestia-app.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "celestia-grpc.noders.services:11090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "celestia-mainnet-grpc.itrocket.net:40090",
        provider: "🚀 itrocket 🚀"
      },
      {
        address: "grpc.celestia.mainnet.dteam.tech:28090",
        provider: "DTEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "Mintscan",
      url: "https://mintscan.io/celestia",
      tx_page: "https://mintscan.io/celestia/txs/${txHash}",
      account_page: "https://mintscan.io/celestia/address/${accountAddress}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.top/celestia/",
      tx_page: "https://explorer.nodestake.top/celestia/txs/${txHash}",
      account_page: "https://explorer.nodestake.top/celestia/account/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/celestia",
      tx_page: "https://stakeflow.io/celestia/transactions/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/celestia",
      tx_page: "https://explorer.tcnetwork.io/celestia/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/celestia/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Celestia-Mainnet",
      tx_page: "https://explorer.stavr.tech/Celestia-Mainnet/transaction/${txHash}",
      account_page: "https://explorer.stavr.tech/Celestia-Mainnet/account/${accountAddress}"
    },
    {
      kind: "AM Solutions",
      url: "https://explorer.theamsolutions.info/celestia-main",
      tx_page: "https://explorer.theamsolutions.info/celestia-main/transaction/${txHash}",
      account_page: "https://explorer.theamsolutions.info/celestia-main/account/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/celestia",
      tx_page: "https://ezstaking.app/celestia/txs/${txHash}",
      account_page: "https://ezstaking.app/celestia/account/${accountAddress}"
    },
    {
      kind: "🚀 itrocket 🚀",
      url: "https://mainnet.itrocket.net/celestia",
      tx_page: "https://mainnet.itrocket.net/celestia/transaction/${txHash}",
      account_page: "https://mainnet.itrocket.net/celestia/account/${accountAddress}"
    },
    {
      kind: "DTEAM | Explorer",
      url: "https://explorer.mainnet.dteam.tech/celestia",
      tx_page: "https://explorer.mainnet.dteam.tech/celestia/transaction/${txHash}",
      account_page: "https://explorer.mainnet.dteam.tech/celestia/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg",
    theme: {
      primary_color_hex: "#7c2cfb"
    }
  }]
};
Ol.default = Lz;
var Ml = {};
Object.defineProperty(Ml, "__esModule", { value: !0 });
const Wz = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-185",
      connection_id: "connection-163"
    },
    chain_2: {
      chain_name: "celestia",
      client_id: "07-tendermint-9",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-125",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-35",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "composable",
      client_id: "07-tendermint-138",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-82",
      connection_id: "connection-52"
    },
    chain_2: {
      chain_name: "dymension",
      client_id: "07-tendermint-6",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-79",
      connection_id: "connection-49"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-134",
      connection_id: "connection-80"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-106",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-28",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-226",
      connection_id: "connection-210"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-152",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-49",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-158",
      connection_id: "connection-198"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-140",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-29",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-48",
      connection_id: "connection-36"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-35",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-10",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3012",
      connection_id: "connection-2503"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6994",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-88",
      connection_id: "connection-57"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-52",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-174",
      connection_id: "connection-131"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-91",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-86",
      connection_id: "connection-56"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-359",
      connection_id: "connection-296"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-291",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-0",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-137",
      connection_id: "connection-125"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-162",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-53",
      connection_id: "connection-16"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-391",
      connection_id: "connection-381"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-300",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-58",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-245",
      connection_id: "connection-209"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-119",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
Ml.default = Wz;
var Il = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qn, "__esModule", { value: !0 });
Qn.ibc = Qn.chain = Qn.assets = void 0;
const Vz = Il(Rl), Gz = Il(Ol), Kz = Il(Ml);
Qn.assets = Vz.default;
Qn.chain = Gz.default;
Qn.ibc = Kz.default;
var et = {}, Nl = {};
Object.defineProperty(Nl, "__esModule", { value: !0 });
const Xz = {
  $schema: "../assetlist.schema.json",
  chain_name: "cerberus",
  assets: [{
    description: "The native token of Cerberus Chain",
    denom_units: [{
      denom: "ucrbrus",
      exponent: 0
    }, {
      denom: "crbrus",
      exponent: 6
    }],
    base: "ucrbrus",
    name: "Cerberus",
    display: "crbrus",
    symbol: "CRBRUS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.svg"
    },
    coingecko_id: "cerberus-2",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.svg",
      theme: {
        primary_color_hex: "#c6c6c9"
      }
    }]
  }]
};
Nl.default = Xz;
var Pl = {};
Object.defineProperty(Pl, "__esModule", { value: !0 });
const Yz = {
  $schema: "../chain.schema.json",
  chain_name: "cerberus",
  status: "killed",
  network_type: "mainnet",
  website: "https://cerberus.zone/",
  pretty_name: "Cerberus",
  chain_type: "cosmos",
  chain_id: "cerberus-chain-1",
  bech32_prefix: "cerberus",
  daemon_name: "cerberusd",
  node_home: "$HOME/.cerberus",
  slip44: 118,
  codebase: {},
  fees: {
    fee_tokens: [{
      denom: "ucrbrus",
      fixed_min_gas_price: 0,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ucrbrus"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.svg"
  },
  apis: {
    rpc: [],
    rest: [],
    grpc: [{
      address: "grpc-cerberus-ia.cosmosia.notional.ventures:443",
      provider: "Notional"
    }, {
      address: "cerberus-grpc.polkachu.com:13890",
      provider: "Polkachu"
    }]
  },
  explorers: [
    {
      kind: "skynetexplorers",
      url: "https://skynetexplorers.com/cerberus",
      tx_page: "https://skynetexplorers.com/cerberus/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/cerberus",
      tx_page: "https://ping.pub/cerberus/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/cerberus",
      tx_page: "https://atomscan.com/cerberus/transactions/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/cerberus",
      tx_page: "https://explorer.tcnetwork.io/cerberus/transaction/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.svg",
    theme: {
      primary_color_hex: "#c6c6c9"
    }
  }]
};
Pl.default = Yz;
var Ul = {};
Object.defineProperty(Ul, "__esModule", { value: !0 });
const Jz = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cerberus",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1875",
    connection_id: "connection-1460"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-212",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Ul.default = Jz;
var Hl = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(et, "__esModule", { value: !0 });
et.ibc = et.chain = et.assets = void 0;
const Zz = Hl(Nl), Qz = Hl(Pl), eq = Hl(Ul);
et.assets = Zz.default;
et.chain = Qz.default;
et.ibc = eq.default;
var nt = {}, Ll = {};
Object.defineProperty(Ll, "__esModule", { value: !0 });
const nq = {
  $schema: "../assetlist.schema.json",
  chain_name: "chain4energy",
  assets: [{
    description: "The native token of Chain4Energy",
    extended_description: "C4E is a DePIN L1 Blockchain platform, designed to support a variety of innovative energy and e-mobility applications by creating a decentralized and democratized community-powered ecosystem.",
    denom_units: [{
      denom: "uc4e",
      exponent: 0
    }, {
      denom: "c4e",
      exponent: 6
    }],
    base: "uc4e",
    name: "Chain4Energy",
    display: "c4e",
    symbol: "C4E",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chain4energy/images/c4e.png"
    },
    coingecko_id: "chain4energy",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chain4energy/images/c4e.png",
      theme: {
        primary_color_hex: "#24344c"
      }
    }],
    socials: {
      website: "https://c4e.io/",
      twitter: "https://twitter.com/Chain4Energy"
    }
  }]
};
Ll.default = nq;
var Wl = {};
Object.defineProperty(Wl, "__esModule", { value: !0 });
const tq = {
  $schema: "../chain.schema.json",
  chain_name: "chain4energy",
  status: "live",
  network_type: "mainnet",
  website: "https://c4e.io/",
  pretty_name: "C4E",
  chain_type: "cosmos",
  chain_id: "perun-1",
  bech32_prefix: "c4e",
  daemon_name: "c4ed",
  node_home: "$HOME/.c4e-chain",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uc4e",
      fixed_min_gas_price: 0,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uc4e"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chain4energy/images/c4e.png"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.c4e.io/",
        provider: "C4E"
      },
      {
        address: "https://rpc.c4e.mainnet.dteam.tech:443",
        provider: "DTEAM"
      },
      {
        address: "https://rpc.c4e.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://c4e.rpc.bccnodes.com",
        provider: "BccNodes"
      },
      {
        address: "https://chain4energy-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://c4e.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-c4e.takeshi.team",
        provider: "TAKESHI"
      },
      {
        address: "https://rpc-c4e.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://rpc.cros-nest.com/chain4energy",
        provider: "Crosnest"
      },
      {
        address: "https://rpc.c4e.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://c4e-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://rpc.c4e.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "http://rpc.c4e.stakeup.tech",
        provider: "StakeUp"
      },
      {
        address: "https://chain4energy-rpc.stakeangle.com",
        provider: "StakeAngle"
      },
      {
        address: "https://c4e-rpc.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://rpc-c4e.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://c4e.rpc.m.anode.team",
        provider: "AlxVoy ⚡ ANODE.TEAM"
      },
      {
        address: "http://185.245.182.192:46657",
        provider: "Meerlabs"
      },
      {
        address: "http://89.117.58.109:26657",
        provider: "medes"
      },
      {
        address: "http://c4e.rpc.node75.org:26957",
        provider: "Pro-nodes75"
      },
      {
        address: "http://164.68.125.243:26657",
        provider: "Smt Network"
      },
      {
        address: "https://c4e-rpc.antrixy.org/",
        provider: "Antrix Validators"
      },
      {
        address: "https://c4e.doubletop.tech/",
        provider: "DOUBLETOP"
      },
      {
        address: "https://c4e-rpc.kalia.network:443",
        provider: "Kalia Network"
      },
      {
        address: "http://38.242.220.64:16657",
        provider: "mahof"
      },
      {
        address: "http://209.182.239.169:46657",
        provider: "SECARD"
      },
      {
        address: "https://rpc.c4e.validatus.com:443",
        provider: "Validatus"
      },
      {
        address: "https://rpc-m-c4e.apeironnodes.com:443",
        provider: "Apeiron Nodes"
      },
      {
        address: "http://rpc-c4e.cryptech.com.ua:443",
        provider: "Cryptech"
      },
      {
        address: "http://37.60.240.43:46657",
        provider: "NakoTurk"
      },
      {
        address: "https://chain4energy_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://lcd.c4e.io/",
        provider: "C4E"
      },
      {
        address: "https://api.c4e.mainnet.dteam.tech:443",
        provider: "DTEAM"
      },
      {
        address: "https://api.c4e.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://c4e.lcd.bccnodes.com",
        provider: "BccNodes"
      },
      {
        address: "https://chain4energy-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://c4e.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-c4e.takeshi.team",
        provider: "TAKESHI"
      },
      {
        address: "https://api-c4e.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://rest.cros-nest.com/chain4energy",
        provider: "Crosnest"
      },
      {
        address: "https://api.c4e.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://c4e-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://api.c4e.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "http://api.c4e.stakeup.tech",
        provider: "StakeUp"
      },
      {
        address: "http://chain4energy-rpc.stakeangle.com:1317",
        provider: "StakeAngle"
      },
      {
        address: "https://c4e-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://api-c4e.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://c4e.api.m.anode.team",
        provider: "AlxVoy ⚡ ANODE.TEAM"
      },
      {
        address: "http://c4e.api.node75.org:1397",
        provider: "Pro-nodes75"
      },
      {
        address: "http://164.68.125.243:1319",
        provider: "Smt Network"
      },
      {
        address: "https://c4e-rest.antrixy.org/",
        provider: "Antrix Validators"
      },
      {
        address: "https://c4e-api.kalia.network:443",
        provider: "Kalia Network"
      },
      {
        address: "http://38.242.220.64:11317",
        provider: "mahof"
      },
      {
        address: "http://209.182.239.169:1417",
        provider: "SECARD"
      },
      {
        address: "https://api.c4e.validatus.com:443",
        provider: "Validatus"
      },
      {
        address: "https://api-c4e.cryptech.com.ua:443",
        provider: "CrypTech"
      },
      {
        address: "https://lcd-m-c4e.apeironnodes.com",
        provider: "Apeiron Nodes"
      },
      {
        address: "https://chain4energy_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "grpc.c4e.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "grpc.c4e.mainnet.dteam.tech:30090",
        provider: "DTEAM"
      },
      {
        address: "c4e.grpc.bccnodes.com:443",
        provider: "BccNodes"
      },
      {
        address: "chain4energy-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "c4e.grpc.bccnodes.com:443",
        provider: "BccNodes"
      },
      {
        address: "grpc-c4e.takeshi.team:443",
        provider: "TAKESHI"
      },
      {
        address: "grpc-c4e.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "http://c4e.grpc.m.stavr.tech:7029",
        provider: "🔥STAVR🔥"
      },
      {
        address: "c4e-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "grpc.c4e.silentvalidator.com:443",
        provider: "silent"
      },
      {
        address: "http://chain4energy-rpc.stakeangle.com:1317",
        provider: "StakeAngle"
      },
      {
        address: "c4e-grpc.genznodes.dev:52090",
        provider: "genznodes"
      },
      {
        address: "https://grpc-c4e.theamsolutions.info:9391",
        provider: "AM Solutions"
      },
      {
        address: "https://c4e.grpc.m.anode.team",
        provider: "AlxVoy ⚡ ANODE.TEAM"
      },
      {
        address: "https://c4e-grpc.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "http://185.245.182.192:1318",
        provider: "Meerlabs"
      },
      {
        address: "grpc-c4e.stakerun.com:1190",
        provider: "StakeRun"
      },
      {
        address: "https://c4e-grpc.antrixy.org/",
        provider: "Antirx Validators"
      },
      {
        address: "https://c4e.doubletop.tech:443",
        provider: "DOUBLETOP"
      },
      {
        address: "c4e-grpc.kalia.network:3090",
        provider: "Kalia Network"
      },
      {
        address: "https://c4e.grpc.skynodejs.net",
        provider: "skynodejs"
      },
      {
        address: "http://38.242.220.64:19090",
        provider: "mahof"
      },
      {
        address: "http://209.182.239.169:9190",
        provider: "SECARD"
      },
      {
        address: "https://grpc.c4e.validatus.com:443",
        provider: "Validatus"
      },
      {
        address: "https://grpc-c4e.cryptech.com.ua:443",
        provider: "Cryptech"
      },
      {
        address: "http://207.180.208.47:46657",
        provider: "NakoTurk"
      }
    ]
  },
  explorers: [
    {
      kind: "explorer",
      url: "https://explorer.apeironnodes.com/chain4energy",
      tx_page: "https://explorer.apeironnodes.com/chain4energy/transactions/${txHash}"
    },
    {
      kind: "DTEAM | Explorer",
      url: "https://explorer.mainnet.dteam.tech/chain4energy",
      tx_page: "https://explorer.mainnet.dteam.tech/chain4energytransactions/${txHash}"
    },
    {
      kind: "explorer",
      url: "https://explorer.ppnv.space/c4e",
      tx_page: "https://explorer.ppnv.space/c4e/transactions/${txHash}"
    },
    {
      kind: "explorer",
      url: "https://explorer.c4e.io/",
      tx_page: "https://explorer.c4e.io/transactions/${txHash}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/chain4energy",
      tx_page: "https://explorer.nodestake.top/chain4energy/transactions/${txHash}"
    },
    {
      kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀 Explorer",
      url: "https://exp.utsa.tech/c4e",
      tx_page: "https://exp.utsa.tech/c4e/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/c4e",
      tx_page: "https://explorer.stavr.tech/c4e/tx/${txHash}"
    },
    {
      kind: "BccNodes Explorer",
      url: "https://explorer.bccnodes.com/chain4energy",
      tx_page: "https://explorer.bccnodes.com/chain4energy/transactions/${txHash}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodexcapital.com/c4e",
      tx_page: "https://explorer.nodexcapital.com/c4e/transactions/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/chain4energy",
      tx_page: "https://atomscan.com/chain4energy/transactions/${txHash}",
      account_page: "https://atomscan.com/chain4energy/accounts/${accountAddress}"
    },
    {
      kind: "AM Solutions Explorer",
      url: "https://explorer.theamsolutions.info/c4e-main/staking",
      tx_page: "https://explorer.theamsolutions.info/c4e-main/transactions/${txHash}"
    },
    {
      kind: "AlxVoy ⚡ ANODE.TEAM Explorer",
      url: "https://main.anode.team/c4e",
      tx_page: "https://main.anode.team/c4e/tx/${txHash}"
    },
    {
      kind: "ScanRun",
      url: "https://scanrun.io/c4e",
      tx_page: "https://scanrun.io/c4e/transactions/${txHash}"
    },
    {
      kind: "Cryptech",
      url: "https://explorers.cryptech.com.ua/chain4energy",
      tx_page: "https://explorers.cryptech.com.ua/chain4energy/tx/${txHash}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/chain4energy",
      tx_page: "https://explorer.whenmoonwhenlambo.money/chain4energy/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/chain4energy/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chain4energy/images/c4e.png",
    theme: {
      primary_color_hex: "#24344c"
    }
  }]
};
Wl.default = tq;
var Vl = {};
Object.defineProperty(Vl, "__esModule", { value: !0 });
const sq = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "axelar",
    client_id: "07-tendermint-203",
    connection_id: "connection-183"
  },
  chain_2: {
    chain_name: "chain4energy",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-141",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "chain4energy",
    client_id: "07-tendermint-2",
    connection_id: "connection-2"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3107",
    connection_id: "connection-2586"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-22172",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Vl.default = sq;
var Gl = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(nt, "__esModule", { value: !0 });
nt.ibc = nt.chain = nt.assets = void 0;
const aq = Gl(Ll), oq = Gl(Wl), rq = Gl(Vl);
nt.assets = aq.default;
nt.chain = oq.default;
nt.ibc = rq.default;
var tt = {}, Kl = {};
Object.defineProperty(Kl, "__esModule", { value: !0 });
const iq = {
  $schema: "../assetlist.schema.json",
  chain_name: "cheqd",
  assets: [{
    description: "Native token for the cheqd network",
    denom_units: [{
      denom: "ncheq",
      exponent: 0
    }, {
      denom: "cheq",
      exponent: 9
    }],
    base: "ncheq",
    display: "cheq",
    name: "cheqd",
    symbol: "CHEQ",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.svg"
    },
    coingecko_id: "cheqd-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.svg",
      theme: {
        primary_color_hex: "#fc5f04"
      }
    }]
  }]
};
Kl.default = iq;
var Xl = {};
Object.defineProperty(Xl, "__esModule", { value: !0 });
const cq = {
  $schema: "../chain.schema.json",
  chain_name: "cheqd",
  status: "live",
  network_type: "mainnet",
  website: "https://www.cheqd.io/",
  pretty_name: "Cheqd",
  chain_type: "cosmos",
  chain_id: "cheqd-mainnet-1",
  bech32_prefix: "cheqd",
  daemon_name: "cheqd-noded",
  node_home: "$HOME/.cheqdnode",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ncheq",
      fixed_min_gas_price: 25,
      low_gas_price: 50,
      average_gas_price: 75,
      high_gas_price: 100
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ncheq"
    }]
  },
  codebase: {
    cosmos_sdk_version: "cheqd/cosmos-sdk v0.47.10-height-mismatch"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.cheqd.net",
        provider: "cheqd"
      },
      {
        address: "https://rpc.lavenderfive.com:443/cheqd",
        provider: "Lavender.Five Nodes"
      },
      {
        address: "https://cheqd.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-cheqd-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc.cheqd.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rpc-cheqd.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://cheqd-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc-cheqd.blockval.io",
        provider: "Blockval"
      },
      {
        address: "https://public.stakewolle.com/cosmos/cheqd/rpc",
        provider: "Stakewolle"
      },
      {
        address: "https://cheq-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://cheqd-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://api.cheqd.net",
        provider: "cheqd"
      },
      {
        address: "https://rest.lavenderfive.com:443/cheqd",
        provider: "Lavender.Five Nodes"
      },
      {
        address: "https://cheqd.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-cheqd-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://cheqd-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://api.cheqd.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://lcd-cheqd.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://api-cheqd.blockval.io",
        provider: "Blockval"
      },
      {
        address: "https://public.stakewolle.com/cosmos/cheqd/rest",
        provider: "Stakewolle"
      },
      {
        address: "https://cheq-api.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://cheqd-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "grpc.cheqd.net:443",
        provider: "cheqd"
      },
      {
        address: "cheqd.grpc.m.stavr.tech:9337",
        provider: "🔥STAVR🔥"
      },
      {
        address: "cheqd.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "cheqd-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-cheqd-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "grpc.cheqd.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "grpc-cheqd.blockval.io:9290",
        provider: "Blockval"
      },
      {
        address: "cheqd-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "bigdipper",
      url: "https://explorer.cheqd.io",
      tx_page: "https://explorer.cheqd.io/transactions/${txHash}",
      account_page: "https://explorer.cheqd.io/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/cheqd",
      tx_page: "https://ping.pub/cheqd/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Cheqd-Mainnet",
      tx_page: "https://explorer.stavr.tech/Cheqd-Mainnet/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/cheqd",
      tx_page: "https://atomscan.com/cheqd/transactions/${txHash}",
      account_page: "https://atomscan.com/cheqd/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/cheqd",
      tx_page: "https://ezstaking.app/cheqd/txs/${txHash}",
      account_page: "https://ezstaking.app/cheqd/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://look.chillvalidation.com/cheqd",
      tx_page: "https://look.chillvalidation.com/cheqd/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.wildsage.io/cheqd",
      tx_page: "https://ping.wildsage.io/cheqd/tx/${txHash}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/cheqd",
      tx_page: "https://mainnet.whispernode.com/cheqd/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/cheqd/account/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.svg"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.svg",
    theme: {
      primary_color_hex: "#fc5f04"
    }
  }]
};
Xl.default = cq;
var Yl = {};
Object.defineProperty(Yl, "__esModule", { value: !0 });
const dq = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cheqd",
      client_id: "07-tendermint-13",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-64",
      connection_id: "connection-74"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-43",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cheqd",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1615",
      connection_id: "connection-1268"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-108",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cheqd",
      client_id: "07-tendermint-85",
      connection_id: "connection-63"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-196",
      connection_id: "connection-191"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-141",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      fee_version: "ics29-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cheqd",
      client_id: "07-tendermint-83",
      connection_id: "connection-61"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-392",
      connection_id: "connection-382"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-301",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Yl.default = dq;
var Jl = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(tt, "__esModule", { value: !0 });
tt.ibc = tt.chain = tt.assets = void 0;
const mq = Jl(Kl), hq = Jl(Xl), pq = Jl(Yl);
tt.assets = mq.default;
tt.chain = hq.default;
tt.ibc = pq.default;
var st = {}, Zl = {};
Object.defineProperty(Zl, "__esModule", { value: !0 });
const lq = {
  $schema: "../assetlist.schema.json",
  chain_name: "chihuahua",
  assets: [
    {
      description: "Chihuahua is a community-driven blockchain project focused on creating a fun and engaging ecosystem with an emphasis on social interactions and community building.",
      extended_description: "Chihuahua aims to foster a vibrant and interactive community through its blockchain platform, which emphasizes social engagement and entertainment. The native token, HUAHUA, is used for various activities within the ecosystem, including rewards, staking, and governance. Chihuahua's unique approach combines blockchain technology with community engagement, offering a dynamic and enjoyable environment for its users.",
      denom_units: [{
        denom: "uhuahua",
        exponent: 0
      }, {
        denom: "huahua",
        exponent: 6
      }],
      base: "uhuahua",
      name: "Chihuahua",
      display: "huahua",
      symbol: "HUAHUA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.svg"
      },
      coingecko_id: "chihuahua-token",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.svg",
        theme: {
          primary_color_hex: "#343434"
        }
      }]
    },
    {
      description: "Puppy",
      denom_units: [{
        denom: "cw20:chihuahua1yl8z39ugle8s02fpwkhh293509q5xcpalmdzc4amvchz8nkexrmsy95gef",
        exponent: 0
      }, {
        denom: "puppy",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "chihuahua1yl8z39ugle8s02fpwkhh293509q5xcpalmdzc4amvchz8nkexrmsy95gef",
      base: "cw20:chihuahua1yl8z39ugle8s02fpwkhh293509q5xcpalmdzc4amvchz8nkexrmsy95gef",
      name: "Puppy",
      display: "puppy",
      symbol: "PUPPY",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/puppyhuahua_logo.png",
        theme: {
          primary_color_hex: "#100e0d"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/puppyhuahua_logo.png"
      }
    },
    {
      description: "has a hat",
      extended_description: "Chihuahuawifhat is the biggest cult of the Chihuahua chain aiming to take over Cosmos. The token is $BADDOG and we're not playing around.",
      denom_units: [{
        denom: "factory/chihuahua1x4q2vkrz4dfgd9hcw0p5m2f2nuv2uqmt9xr8k2/achihuahuawifhat",
        exponent: 0
      }, {
        denom: "achihuahuawifhat",
        exponent: 6
      }],
      base: "factory/chihuahua1x4q2vkrz4dfgd9hcw0p5m2f2nuv2uqmt9xr8k2/achihuahuawifhat",
      name: "Chihuahuawifhat",
      display: "achihuahuawifhat",
      symbol: "BADDOG",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/baddog.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/baddog.png",
        theme: {
          primary_color_hex: "#F7E3C0",
          background_color_hex: "#F7E3C0",
          circle: !0
        }
      }],
      socials: {
        website: "https://baddog.lol/",
        twitter: "https://x.com/chihuahuawifhat"
      }
    },
    {
      description: "Woof",
      denom_units: [{
        denom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uwoof",
        exponent: 0
      }, {
        denom: "WOOF",
        exponent: 6
      }],
      base: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uwoof",
      name: "WOOF",
      display: "WOOF",
      symbol: "WOOF",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/woof.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/woof.png",
        theme: {
          primary_color_hex: "#d9905f"
        }
      }]
    },
    {
      description: "Tacos",
      denom_units: [{
        denom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/utacos",
        exponent: 0
      }, {
        denom: "TACOS",
        exponent: 6
      }],
      base: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/utacos",
      name: "TACOS",
      display: "TACOS",
      symbol: "TACOS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/tacos.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/tacos.png",
        theme: {
          primary_color_hex: "#f3bb5b"
        }
      }]
    },
    {
      description: "Weed",
      denom_units: [{
        denom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uweed",
        exponent: 0
      }, {
        denom: "WEED",
        exponent: 6
      }],
      base: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uweed",
      name: "WEED",
      display: "WEED",
      symbol: "WEED",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/weed.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/weed.png",
        theme: {
          primary_color_hex: "#43b333"
        }
      }]
    },
    {
      description: "Bulldog",
      denom_units: [{
        denom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/ubdog",
        exponent: 0
      }, {
        denom: "BDOG",
        exponent: 6
      }],
      base: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/ubdog",
      name: "BDOG",
      display: "BDOG",
      symbol: "BDOG",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/bdog.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/bdog.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "CaneCorso",
      denom_units: [{
        denom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/ucorso",
        exponent: 0
      }, {
        denom: "CORSO",
        exponent: 6
      }],
      base: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/ucorso",
      name: "CORSO",
      display: "CORSO",
      symbol: "CORSO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/corso.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/corso.png",
        theme: {
          primary_color_hex: "#d9d2d2"
        }
      }]
    },
    {
      description: "BackBone Labs Liquid Staked HUAHUA",
      denom_units: [{
        denom: "cw20:chihuahua1jz5n4aynhpxx7clf2m8hrv9dp5nz83k67fgaxhy4p9dfwl6zssrq3ymr6w",
        exponent: 0
      }, {
        denom: "bHUAHUA",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "chihuahua1jz5n4aynhpxx7clf2m8hrv9dp5nz83k67fgaxhy4p9dfwl6zssrq3ymr6w",
      base: "cw20:chihuahua1jz5n4aynhpxx7clf2m8hrv9dp5nz83k67fgaxhy4p9dfwl6zssrq3ymr6w",
      name: "BackBone Labs Liquid Staked HUAHUA",
      display: "bHUAHUA",
      symbol: "bHUAHUA",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/bhuahua.png",
        theme: {
          primary_color_hex: "#f2bd3a"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/bhuahua.png"
      },
      coingecko_id: "backbone-labs-staked-huahua"
    },
    {
      description: "ashHUAHUA - Burned HUAHUA",
      extended_description: "ashHUAHUA - receipt token recieved when burning HUAHUA via ASH DAOs Furnace",
      denom_units: [{
        denom: "factory/chihuahua1hplyuj2hzxd75q8686g9vm3uzrrny9ggvt8aza2csupgdp98vg2sp0e3h0/uhuahua.ash",
        exponent: 0
      }, {
        denom: "ashHUAHUA",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "chihuahua1hplyuj2hzxd75q8686g9vm3uzrrny9ggvt8aza2csupgdp98vg2sp0e3h0",
      base: "factory/chihuahua1hplyuj2hzxd75q8686g9vm3uzrrny9ggvt8aza2csupgdp98vg2sp0e3h0/uhuahua.ash",
      name: "Burned HUAHUA",
      display: "ashHUAHUA",
      symbol: "ashHUAHUA",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/ashhuahua.png",
        theme: {
          primary_color_hex: "#f46c0f"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/ashhuahua.png"
      }
    },
    {
      denom_units: [{
        denom: "ibc/7D01429FF7542DBC41C261793B480B63FE7A83260C751989CC268BC7E852EB99",
        exponent: 0,
        aliases: ["factory/migaloo1nsskhvvh0msm7d5ke2kfg24a8d4jecsnxd28s27h0uz5kf9ap60shlqmcl/ampGASH"]
      }, {
        denom: "ampGASH",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/7D01429FF7542DBC41C261793B480B63FE7A83260C751989CC268BC7E852EB99",
      name: "ampGASH",
      display: "ampGASH",
      symbol: "ampGASH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1nsskhvvh0msm7d5ke2kfg24a8d4jecsnxd28s27h0uz5kf9ap60shlqmcl/ampGASH",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-39",
          path: "transfer/channel-39/factory/migaloo1nsskhvvh0msm7d5ke2kfg24a8d4jecsnxd28s27h0uz5kf9ap60shlqmcl/ampGASH"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1nsskhvvh0msm7d5ke2kfg24a8d4jecsnxd28s27h0uz5kf9ap60shlqmcl/ampGASH"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ampgash.png",
        theme: {
          primary_color_hex: "#374455"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ampgash.png"
      }
    },
    {
      denom_units: [{
        denom: "ibc/DBBDE1753EFA93F09C468DB5E384861BB741D4AA73E9C7032D139BB2C99FDD65",
        exponent: 0,
        aliases: ["factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy"]
      }, {
        denom: "GUPPY",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/DBBDE1753EFA93F09C468DB5E384861BB741D4AA73E9C7032D139BB2C99FDD65",
      name: "GUPPY",
      display: "GUPPY",
      symbol: "GUPPY",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-39",
          path: "transfer/channel-39/factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/guppy.png",
        theme: {
          primary_color_hex: "#d9966e"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/guppy.png"
      }
    }
  ]
};
Zl.default = lq;
var Ql = {};
Object.defineProperty(Ql, "__esModule", { value: !0 });
const gq = {
  $schema: "../chain.schema.json",
  chain_name: "chihuahua",
  status: "live",
  network_type: "mainnet",
  website: "https://chihuahua.wtf/",
  pretty_name: "Chihuahua",
  chain_type: "cosmos",
  chain_id: "chihuahua-1",
  bech32_prefix: "chihuahua",
  daemon_name: "chihuahuad",
  node_home: "$HOME/.chihuahuad",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uhuahua",
      fixed_min_gas_price: 0,
      low_gas_price: 500,
      average_gas_price: 1250,
      high_gas_price: 2e3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uhuahua"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.8",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.41.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.chihuahua.wtf",
        provider: "Chihuahua"
      },
      {
        address: "https://rpc-chihuahua.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://chihua.rpc.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://chihuahua-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-chihuahua-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "https://rpc.lavenderfive.com:443/chihuahua",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc.huahua.bh.rocks",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://chihuahua-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://rpc-chihuahua.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://chihuahua-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://chihuahua-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc.chihuahua.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://chihuahua-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://chihuahua.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      }
    ],
    rest: [
      {
        address: "https://api.chihuahua.wtf",
        provider: "Chihuahua"
      },
      {
        address: "https://rest-chihuahua.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://chihua.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-chihuahua-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "https://chihuahua-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rest.lavenderfive.com:443/chihuahua",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://chihuahua-api.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://api-chihuahua.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://chihuahua-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://chihuahua-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://api.chihuahua.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://chihuahua-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://chihuahua.api.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      }
    ],
    grpc: [
      {
        address: "grpc-chihuahua-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "chihuahua-grpc.polkachu.com:12990",
        provider: "Polkachu"
      },
      {
        address: "chihuahua.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "chihua.grpc.m.stavr.tech:108",
        provider: "🔥STAVR🔥"
      },
      {
        address: "grpc-chihuahua.cosmos-spaces.cloud:2290",
        provider: "Cosmos Spaces"
      },
      {
        address: "chihuahua-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "chihuahua-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "grpc.chihuahua.validatus.com:443",
        provider: "Validatus"
      },
      {
        address: "chihuahua.grpc.nodeshub.online",
        provider: "Nodes Hub"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/chihuahua",
      tx_page: "https://ping.pub/chihuahua/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Chihua-Mainnet",
      tx_page: "https://explorer.stavr.tech/Chihua-Mainnet/tx/${txHash}"
    },
    {
      kind: "mintscan",
      url: "https://mintscan.io/chihuahua",
      tx_page: "https://mintscan.io/chihuahua/transactions/${txHash}",
      account_page: "https://www.mintscan.io/chihuahua/accounts/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/chihuahua",
      tx_page: "https://atomscan.com/chihuahua/transactions/${txHash}",
      account_page: "https://atomscan.com/chihuahua/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/chihuahua",
      tx_page: "https://ezstaking.app/chihuahua/txs/${txHash}",
      account_page: "https://ezstaking.app/chihuahua/account/${accountAddress}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
      url: "https://explorer.nodeshub.online/chihuahua/",
      tx_page: "https://explorer.nodeshub.online/chihuahua/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/chihuahua/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.svg",
    theme: {
      primary_color_hex: "#343434"
    }
  }]
};
Ql.default = gq;
var eg = {};
Object.defineProperty(eg, "__esModule", { value: !0 });
const uq = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-54",
      connection_id: "connection-30"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-79",
      connection_id: "connection-46"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-28",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-126",
      connection_id: "connection-81"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-21",
      connection_id: "connection-21"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-39",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-191",
      connection_id: "connection-127"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-74",
      connection_id: "connection-53"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-76",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-77",
        port_id: "wasm.chihuahua1jwkag4yvhyj9fuddtkygvavya8hmdjuzmgxwg9vp3lw9twv6lrcq9mgl52"
      },
      chain_2: {
        channel_id: "channel-52",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-85",
      connection_id: "connection-54"
    },
    chain_2: {
      chain_name: "okexchain",
      client_id: "07-tendermint-5",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-45",
      connection_id: "connection-25"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1666",
      connection_id: "connection-1278"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-113",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-73",
        port_id: "wasm.chihuahua1jwkag4yvhyj9fuddtkygvavya8hmdjuzmgxwg9vp3lw9twv6lrcq9mgl52"
      },
      chain_2: {
        channel_id: "channel-11348",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-207",
      connection_id: "connection-137"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-168",
      connection_id: "connection-212"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-94",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-203",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-70",
      connection_id: "connection-38"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-27",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-86",
      connection_id: "connection-55"
    },
    chain_2: {
      chain_name: "stafihub",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
eg.default = uq;
var ng = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(st, "__esModule", { value: !0 });
st.ibc = st.chain = st.assets = void 0;
const _q = ng(Zl), yq = ng(Ql), bq = ng(eg);
st.assets = _q.default;
st.chain = yq.default;
st.ibc = bq.default;
var Yo = {}, tg = {};
Object.defineProperty(tg, "__esModule", { value: !0 });
const vq = {
  $schema: "../assetlist.schema.json",
  chain_name: "chimba",
  assets: [{
    description: "The first blokchain in colombia",
    denom_units: [{
      denom: "ucmba",
      exponent: 0
    }, {
      denom: "chimba",
      exponent: 6
    }],
    base: "ucmba",
    name: "Chimba",
    display: "chimba",
    symbol: "CMBA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.svg",
      theme: {
        primary_color_hex: "#5454a4"
      }
    }]
  }]
};
tg.default = vq;
var sg = {};
Object.defineProperty(sg, "__esModule", { value: !0 });
const fq = {
  $schema: "../chain.schema.json",
  chain_name: "chimba",
  status: "live",
  network_type: "mainnet",
  website: "https://chimba.ooo/",
  pretty_name: "Chimba",
  chain_type: "cosmos",
  chain_id: "chimba",
  bech32_prefix: "chimba",
  daemon_name: "chimbad",
  node_home: "$HOME/.chimbad",
  fees: {
    fee_tokens: [{
      denom: "ucmba",
      fixed_min_gas_price: 0.25,
      low_gas_price: 1,
      average_gas_price: 5,
      high_gas_price: 10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ucmba"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.mainnet.chimba.ooo",
      provider: "chimba"
    }],
    rest: [{
      address: "https://mainnet.chimba.ooo",
      provider: "chimba"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://explorer.chimba.ooo/",
    tx_page: "https://explorer.chimba.ooo/transactions/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.svg",
    theme: {
      primary_color_hex: "#5454a4"
    }
  }],
  slip44: 118
};
sg.default = fq;
var x9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Yo, "__esModule", { value: !0 });
Yo.chain = Yo.assets = void 0;
const wq = x9(tg), xq = x9(sg);
Yo.assets = wq.default;
Yo.chain = xq.default;
var Jo = {}, ag = {};
Object.defineProperty(ag, "__esModule", { value: !0 });
const kq = {
  $schema: "../assetlist.schema.json",
  chain_name: "chronicnetwork",
  assets: [{
    description: "The CHT coin is the governance token within the Chronic Chain network, aimed to serve the entire cannabis community through its payment network, supply chain and trust network.",
    denom_units: [{
      denom: "ucht",
      exponent: 0
    }, {
      denom: "cht",
      exponent: 6
    }],
    base: "ucht",
    display: "cht",
    name: "Chronic Token",
    symbol: "CHT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chronicnetwork/images/cht.png"
    },
    coingecko_id: "cht",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chronicnetwork/images/cht.png",
      theme: {
        primary_color_hex: "#1eb975"
      }
    }]
  }, {
    description: "The CGAS coin is the transactional token within the Chronic Chain network, aimed to serve the entire cannabis community through its payment network, supply chain and trust network.",
    denom_units: [{
      denom: "ucgas",
      exponent: 0
    }, {
      denom: "cgas",
      exponent: 6
    }],
    base: "ucgas",
    display: "cgas",
    name: "Chronic Gas",
    symbol: "CGAS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chronicnetwork/images/cgas.png"
    },
    coingecko_id: "cgas",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chronicnetwork/images/cgas.png",
      theme: {
        primary_color_hex: "#ecb368"
      }
    }]
  }]
};
ag.default = kq;
var og = {};
Object.defineProperty(og, "__esModule", { value: !0 });
const Aq = {
  $schema: "../chain.schema.json",
  chain_name: "chronicnetwork",
  status: "killed",
  network_type: "mainnet",
  pretty_name: "Chronic Chain",
  chain_type: "cosmos",
  chain_id: "morocco-1",
  bech32_prefix: "chronic",
  daemon_name: "chtd",
  node_home: "$HOME/.cht",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ucgas",
      fixed_min_gas_price: 1e-3
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc-chronic.zenchainlabs.io/",
      provider: "ZenChainLabs"
    }],
    rest: [{
      address: "https://api-chronic.zenchainlabs.io/",
      provider: "ZenChainLabs"
    }]
  },
  explorers: [
    {
      kind: "skynetexplorers",
      url: "https://www.skynetexplorers.com/chronic-token"
    },
    {
      kind: "Zenscan.io",
      url: "https://www.chronic.zenscan.io"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/chronicnetwork",
      tx_page: "https://atomscan.com/chronicnetwork/transactions/${txHash}",
      account_page: "https://atomscan.com/chronicnetwork/accounts/${accountAddress}"
    }
  ]
};
og.default = Aq;
var k9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Jo, "__esModule", { value: !0 });
Jo.chain = Jo.assets = void 0;
const jq = k9(ag), Cq = k9(og);
Jo.assets = jq.default;
Jo.chain = Cq.default;
var at = {}, rg = {};
Object.defineProperty(rg, "__esModule", { value: !0 });
const Eq = {
  $schema: "../assetlist.schema.json",
  chain_name: "cifer",
  assets: [{
    description: "Cifer Blockchain Network Built for Decentralized Machine Learning.",
    denom_units: [{
      denom: "ucif",
      exponent: 0
    }, {
      denom: "cif",
      exponent: 6
    }],
    base: "ucif",
    name: "Cifer",
    display: "cif",
    symbol: "CIF",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.svg",
      theme: {
        primary_color_hex: "#af49b7"
      }
    }],
    socials: {
      website: "http://cifer.ai/",
      twitter: "https://twitter.com/cifer_ai"
    }
  }]
};
rg.default = Eq;
var ig = {};
Object.defineProperty(ig, "__esModule", { value: !0 });
const Dq = {
  $schema: "../chain.schema.json",
  chain_name: "cifer",
  status: "live",
  network_type: "mainnet",
  website: "https://cifer.ai/",
  pretty_name: "Cifer",
  chain_type: "cosmos",
  chain_id: "cifer-2",
  bech32_prefix: "cife",
  daemon_name: "ciferd",
  node_home: "$HOME/.ciferd",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ucif",
      fixed_min_gas_price: 25e-4,
      low_gas_price: 1,
      average_gas_price: 5,
      high_gas_price: 10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ucif"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.svg"
  },
  apis: {
    rpc: [{
      address: "http://34.128.114.243:26657",
      provider: "Cifer"
    }],
    rest: [{
      address: "https://api.cifer.ai",
      provider: "Cifer"
    }],
    grpc: [{
      address: "http://34.128.114.243:9090",
      provider: "Cifer"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://explorer.cifer.ai/",
    tx_page: "https://explorer.cifer.ai/transactions/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.svg",
    theme: {
      primary_color_hex: "#af49b7"
    }
  }]
};
ig.default = Dq;
var cg = {};
Object.defineProperty(cg, "__esModule", { value: !0 });
const Bq = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cifer",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "cosmoshub",
    client_id: "07-tendermint-1301",
    connection_id: "connection-1035"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-831",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cifer",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3184",
    connection_id: "connection-2646"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-39205",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
cg.default = Bq;
var dg = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(at, "__esModule", { value: !0 });
at.ibc = at.chain = at.assets = void 0;
const Fq = dg(rg), $q = dg(ig), zq = dg(cg);
at.assets = Fq.default;
at.chain = $q.default;
at.ibc = zq.default;
var Zo = {}, mg = {};
Object.defineProperty(mg, "__esModule", { value: !0 });
const qq = {
  $schema: "../assetlist.schema.json",
  chain_name: "cifer1",
  assets: [{
    description: "Decentralized Federated Learning",
    denom_units: [{
      denom: "ucif",
      exponent: 0
    }, {
      denom: "cif",
      exponent: 6
    }],
    base: "ucif",
    name: "Cifer",
    display: "cif",
    symbol: "CIF",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.svg",
      theme: {
        primary_color_hex: "#af49b7"
      }
    }]
  }]
};
mg.default = qq;
var hg = {};
Object.defineProperty(hg, "__esModule", { value: !0 });
const Sq = {
  $schema: "../chain.schema.json",
  chain_name: "cifer1",
  status: "killed",
  network_type: "mainnet",
  website: "https://cifer.ai/",
  pretty_name: "Cifer",
  chain_type: "cosmos",
  chain_id: "cifer-1",
  bech32_prefix: "cife",
  daemon_name: "ciferd",
  node_home: "$HOME/.ciferd",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ucif",
      fixed_min_gas_price: 25e-4,
      low_gas_price: 1,
      average_gas_price: 5,
      high_gas_price: 10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ucif"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.svg"
  },
  apis: {
    rpc: [{
      address: "https://cif_node.cifer.ai/",
      provider: "Cifer"
    }],
    rest: [{
      address: "https://api.cifer.ai",
      provider: "Cifer"
    }],
    grpc: [{
      address: "http://grpc.cifer.ai",
      provider: "Cifer"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://explorer.cifer.ai/",
    tx_page: "https://explorer.cifer.ai/transactions/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.svg",
    theme: {
      primary_color_hex: "#af49b7"
    }
  }]
};
hg.default = Sq;
var A9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Zo, "__esModule", { value: !0 });
Zo.chain = Zo.assets = void 0;
const Tq = A9(mg), Rq = A9(hg);
Zo.assets = Tq.default;
Zo.chain = Rq.default;
var Qo = {}, pg = {};
Object.defineProperty(pg, "__esModule", { value: !0 });
const Oq = {
  $schema: "../assetlist.schema.json",
  chain_name: "cnhostables",
  assets: [{
    description: "CNHO Stables Network is designed to facilitate the real world asset in Cosmos ecosystem. Starting from non USD stablecoins and  stocks to real estates, the goal is to provide a new tool for the under development regions to invest in the future and pay globally. The native token is CNHO, pegged 1:1 on CNH.",
    denom_units: [{
      denom: "ucnho",
      exponent: 0
    }, {
      denom: "CNHO",
      exponent: 6
    }],
    base: "ucnho",
    name: "CNHO Stables",
    display: "CNHO",
    symbol: "CNHO",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cnhostables/images/chain.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cnhostables/images/chain.svg"
    },
    keywords: ["CNHO"],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cnhostables/images/chain.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cnhostables/images/chain.svg",
      theme: {
        primary_color_hex: "#708ffc"
      }
    }],
    socials: {
      website: "https://cnho.io/",
      twitter: "https://twitter.com/cnho_io"
    }
  }]
};
pg.default = Oq;
var lg = {};
Object.defineProperty(lg, "__esModule", { value: !0 });
const Mq = {
  $schema: "../chain.schema.json",
  chain_name: "cnhostables",
  status: "live",
  network_type: "mainnet",
  website: "https://cnho.io/",
  pretty_name: "CNHO Stables",
  chain_type: "cosmos",
  chain_id: "cnho_stables-1",
  bech32_prefix: "cnho",
  daemon_name: "cnho",
  node_home: "$HOME/.cnho",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ucnho",
      fixed_min_gas_price: 5e-6,
      low_gas_price: 1e-6,
      average_gas_price: 1e-5,
      high_gas_price: 0.025
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ucnho"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.46.7",
    cosmwasm_enabled: !1
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cnhostables/images/chain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cnhostables/images/chain.svg"
  },
  description: "CNHO Stables Network is designed to facilitate the real world asset in Cosmos ecosystem.",
  apis: {
    rpc: [{
      address: "https://rpc.cnho.io",
      provider: "CNHO Stables"
    }, {
      address: "https://cnhostables_mainnet_rpc.chain.whenmoonwhenlambo.money",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }],
    rest: [{
      address: "https://api.cnho.io",
      provider: "CNHO Stables"
    }, {
      address: "https://cnhostables_mainnet_api.chain.whenmoonwhenlambo.money",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }],
    grpc: [{
      address: "159.138.232.248:9090",
      provider: "CNHO Stables"
    }]
  },
  explorers: [{
    url: "https://explorer.cnho.io",
    tx_page: "https://explorer.cnho.io/transaction/${txHash}",
    account_page: "https://explorer.cnho.io/account/${accountAddress}"
  }, {
    kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
    url: "https://explorer.whenmoonwhenlambo.money/cnhostables",
    tx_page: "https://explorer.whenmoonwhenlambo.money/cnhostables/tx/${txHash}",
    account_page: "https://explorer.whenmoonwhenlambo.money/cnhostables/account/${accountAddress}"
  }],
  keywords: ["CNHO"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cnhostables/images/chain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cnhostables/images/chain.svg",
    theme: {
      primary_color_hex: "#708ffc"
    }
  }]
};
lg.default = Mq;
var j9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qo, "__esModule", { value: !0 });
Qo.chain = Qo.assets = void 0;
const Iq = j9(pg), Nq = j9(lg);
Qo.assets = Iq.default;
Qo.chain = Nq.default;
var ot = {}, gg = {};
Object.defineProperty(gg, "__esModule", { value: !0 });
const Pq = {
  $schema: "../assetlist.schema.json",
  chain_name: "comdex",
  assets: [
    {
      description: "Native Token of Comdex Protocol",
      denom_units: [{
        denom: "ucmdx",
        exponent: 0
      }, {
        denom: "cmdx",
        exponent: 6
      }],
      base: "ucmdx",
      name: "Comdex",
      display: "cmdx",
      symbol: "CMDX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.svg"
      },
      coingecko_id: "comdex",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.svg",
        theme: {
          primary_color_hex: "#fc4454"
        }
      }]
    },
    {
      description: "Governance Token of Harbor protocol on Comdex network",
      denom_units: [{
        denom: "uharbor",
        exponent: 0
      }, {
        denom: "harbor",
        exponent: 6
      }],
      base: "uharbor",
      name: "Harbor",
      display: "harbor",
      symbol: "HARBOR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/harbor.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/harbor.svg"
      },
      coingecko_id: "harbor-2",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/harbor.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/harbor.svg",
        theme: {
          primary_color_hex: "#645ca4"
        }
      }]
    },
    {
      description: "Stable Token of Harbor protocol on Comdex network",
      denom_units: [{
        denom: "ucmst",
        exponent: 0
      }, {
        denom: "cmst",
        exponent: 6
      }],
      base: "ucmst",
      name: "CMST",
      display: "cmst",
      symbol: "CMST",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmst.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmst.svg"
      },
      coingecko_id: "composite",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmst.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmst.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    }
  ]
};
gg.default = Pq;
var ug = {};
Object.defineProperty(ug, "__esModule", { value: !0 });
const Uq = {
  $schema: "../chain.schema.json",
  chain_name: "comdex",
  status: "live",
  network_type: "mainnet",
  website: "https://comdex.one/",
  pretty_name: "Comdex",
  chain_type: "cosmos",
  chain_id: "comdex-1",
  bech32_prefix: "comdex",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ucmdx",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ucmdx"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.9",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.45.0"
  },
  daemon_name: "comdex",
  node_home: "$HOME/.comdex",
  key_algos: ["secp256k1"],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.comdex.one",
        provider: "comdex"
      },
      {
        address: "https://comdex-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://comdex.rpc.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.comdex.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://rpc.lavenderfive.com:443/comdex",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-comdex.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://comdex-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://comdex-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://comdex-rpc.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://comdex-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc-comdex-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://comdex-rpc.validatornode.com",
        provider: "ValidatorNode"
      },
      {
        address: "https://rpc-comdex.blockval.io",
        provider: "Blockval"
      },
      {
        address: "https://comdex-rpc.bluestake.net:443",
        provider: "BlueStake 🚀"
      }
    ],
    rest: [
      {
        address: "https://rest.comdex.one",
        provider: "comdex"
      },
      {
        address: "https://api.comdex.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://comdex-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://comdex.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rest.lavenderfive.com:443/comdex",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api-comdex.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://comdex-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://comdex-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://comdex-rest.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://comdex-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://api-comdex-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://comdex-api.validatornode.com",
        provider: "ValidatorNode"
      },
      {
        address: "https://api-comdex.blockval.io",
        provider: "Blockval"
      },
      {
        address: "https://comdex-api.bluestake.net",
        provider: "BlueStake 🚀"
      }
    ],
    grpc: [
      {
        address: "grpc-comdex-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "comdex.grpcui.chaintools.host:443",
        provider: "ChainTools"
      },
      {
        address: "comdex-grpc.polkachu.com:13190",
        provider: "Polkachu"
      },
      {
        address: "comdex.grpc.m.stavr.tech:104",
        provider: "🔥STAVR🔥"
      },
      {
        address: "grpc-comdex.cosmos-spaces.cloud:2300",
        provider: "Cosmos Spaces"
      },
      {
        address: "comdex.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "comdex-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "comdex-grpc.w3coins.io:13190",
        provider: "w3coins"
      },
      {
        address: "comdex-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "grpc-comdex-01.stakeflow.io:10002",
        provider: "Stakeflow"
      },
      {
        address: "comdex-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "https://grpc-comdex.blockval.io:443",
        provider: "Blockval"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/comdex",
      tx_page: "https://ezstaking.app/comdex/txs/${txHash}",
      account_page: "https://ezstaking.app/comdex/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/comdex",
      tx_page: "https://www.mintscan.io/comdex/transactions/${txHash}",
      account_page: "https://www.mintscan.io/comdex/accounts/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Comdex-Mainnet",
      tx_page: "https://explorer.stavr.tech/Comdex-Mainnet/txs/${txHash}",
      account_page: "https://explorer.stavr.tech/Comdex-Mainnet/accounts/${accountAddress}"
    },
    {
      kind: "aneka",
      url: "https://comdex.aneka.io/",
      tx_page: "https://comdex.aneka.io/txs/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/comdex",
      tx_page: "https://ping.pub/comdex/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/comdex",
      tx_page: "https://atomscan.com/comdex/transactions/${txHash}",
      account_page: "https://atomscan.com/comdex/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/comdex",
      account_page: "https://stakeflow.io/comdex/accounts/${accountAddress}"
    },
    {
      kind: "ValidatorNode",
      url: "https://explorer.validatornode.com/comdex",
      tx_page: "https://explorer.validatornode.com/comdex/tx/${txHash}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/comdex",
      tx_page: "https://mainnet.whispernode.com/comdex/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/comdex/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.svg",
    theme: {
      primary_color_hex: "#fc4454"
    }
  }]
};
ug.default = Uq;
var _g = {};
Object.defineProperty(_g, "__esModule", { value: !0 });
const Hq = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bandchain",
      client_id: "07-tendermint-124",
      connection_id: "connection-107"
    },
    chain_2: {
      chain_name: "comdex",
      client_id: "07-tendermint-81",
      connection_id: "connection-48"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-96",
        port_id: "oracle"
      },
      chain_2: {
        channel_id: "channel-43",
        port_id: "bandoracleV1"
      },
      ordering: "unordered",
      version: "bandchain-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-108",
      connection_id: "connection-54"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-32",
      connection_id: "connection-33"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-30",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-92",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-52",
      connection_id: "connection-34"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-20",
      connection_id: "connection-15"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-31",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-139",
      connection_id: "connection-71"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-25",
      connection_id: "connection-24"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1587",
      connection_id: "connection-1243"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-87",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-123",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-94",
      connection_id: "connection-75"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-71",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-142",
      connection_id: "connection-74"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-125",
      connection_id: "connection-95"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-83",
      connection_id: "connection-50"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-41",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-45",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-117",
      connection_id: "connection-56"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-70",
      connection_id: "connection-59"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-39",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
_g.default = Hq;
var yg = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ot, "__esModule", { value: !0 });
ot.ibc = ot.chain = ot.assets = void 0;
const Lq = yg(gg), Wq = yg(ug), Vq = yg(_g);
ot.assets = Lq.default;
ot.chain = Wq.default;
ot.ibc = Vq.default;
var er = {}, bg = {};
Object.defineProperty(bg, "__esModule", { value: !0 });
const Gq = {
  $schema: "../assetlist.schema.json",
  chain_name: "commercionetwork",
  assets: [{
    description: "The native token of Commercio.network",
    denom_units: [{
      denom: "ucommercio",
      exponent: 0,
      aliases: []
    }, {
      denom: "commercio",
      exponent: 6,
      aliases: []
    }],
    base: "ucommercio",
    display: "commercio",
    name: "Commercio",
    symbol: "COM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/com.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/com.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/com.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/com.svg",
      theme: {
        primary_color_hex: "#41a68c"
      }
    }]
  }, {
    description: "The cash credit token of Commercio.network",
    denom_units: [{
      denom: "uccc",
      exponent: 0,
      aliases: []
    }, {
      denom: "ccc",
      exponent: 6,
      aliases: []
    }],
    base: "uccc",
    display: "ccc",
    name: "Commercio Cash Credit",
    symbol: "CCC",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/ccc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/ccc.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/ccc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/ccc.svg",
      theme: {
        primary_color_hex: "#fbb804"
      }
    }]
  }]
};
bg.default = Gq;
var vg = {};
Object.defineProperty(vg, "__esModule", { value: !0 });
const Kq = {
  $schema: "../chain.schema.json",
  chain_name: "commercionetwork",
  chain_type: "cosmos",
  chain_id: "commercio-3",
  pretty_name: "Commercio.network",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "did:com:",
  daemon_name: "commercionetworkd",
  node_home: "$HOME/.commercionetwork",
  key_algos: ["secp256k1"],
  slip44: 701,
  fees: {
    fee_tokens: [{
      denom: "ucommercio"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/com.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/com.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc-mainnet.commercio.network"
    }],
    rest: [{
      address: "https://lcd-mainnet.commercio.network"
    }]
  },
  explorers: [{
    kind: "almerico",
    url: "https://mainnet.commercio.network",
    tx_page: "https://mainnet.commercio.network/transactions/detail/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/com.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/commercionetwork/images/com.svg",
    theme: {
      primary_color_hex: "#41a68c"
    }
  }]
};
vg.default = Kq;
var C9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(er, "__esModule", { value: !0 });
er.chain = er.assets = void 0;
const Xq = C9(bg), Yq = C9(vg);
er.assets = Xq.default;
er.chain = Yq.default;
var rt = {}, fg = {};
Object.defineProperty(fg, "__esModule", { value: !0 });
const Jq = {
  $schema: "../assetlist.schema.json",
  chain_name: "composable",
  assets: [
    {
      description: "Picasso is a blockchain project within the IBC ecosystem that focuses on providing modular and interoperable solutions for decentralized finance (DeFi) and other blockchain applications.",
      extended_description: "Picasso is part of the IBC network and aims to offer modular, interoperable solutions tailored for DeFi and other blockchain applications. Picasso enables IBC-based bridging between Cosmos, Solana, Ethereum, and Polkadot. Picasso's commitment to innovation and interoperability makes it a significant player in the evolving blockchain landscape, providing tools and infrastructure that cater to diverse blockchain use cases.",
      denom_units: [{
        denom: "ppica",
        exponent: 0
      }, {
        denom: "pica",
        exponent: 12
      }],
      base: "ppica",
      name: "Pica",
      display: "pica",
      symbol: "PICA",
      coingecko_id: "picasso",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "picasso",
          base_denom: "ppica"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "picasso",
          base_denom: "ppica"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/composable/images/pica.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/composable/images/pica.svg"
      },
      socials: {
        website: "https://picasso.network/",
        twitter: "https://twitter.com/picasso_network"
      }
    },
    {
      description: "The native staking and governance token of Kusama Relay Chain.",
      denom_units: [{
        denom: "ibc/EE9046745AEC0E8302CB7ED9D5AD67F528FB3B7AE044B247FB0FB293DBDA35E9",
        exponent: 0,
        aliases: ["4"]
      }, {
        denom: "ksm",
        exponent: 12
      }],
      type_asset: "ics20",
      base: "ibc/EE9046745AEC0E8302CB7ED9D5AD67F528FB3B7AE044B247FB0FB293DBDA35E9",
      name: "KSM",
      display: "ksm",
      symbol: "KSM",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "picasso",
          base_denom: "4",
          channel_id: "channel-17"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/4"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "picasso",
          base_denom: "4"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/kusama/images/ksm.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/kusama/images/ksm.svg"
      }
    },
    {
      description: "The native staking and governance token of Polkadot Relay Chain.",
      denom_units: [{
        denom: "ibc/3CC19CEC7E5A3E90E78A5A9ECC5A0E2F8F826A375CF1E096F4515CF09DA3E366",
        exponent: 0,
        aliases: ["79228162514264337593543950342"]
      }, {
        denom: "dot",
        exponent: 10
      }],
      type_asset: "ics20",
      base: "ibc/3CC19CEC7E5A3E90E78A5A9ECC5A0E2F8F826A375CF1E096F4515CF09DA3E366",
      name: "DOT",
      display: "dot",
      symbol: "DOT",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "picasso",
          base_denom: "79228162514264337593543950342",
          channel_id: "channel-17"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/transfer/channel-15/79228162514264337593543950342"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "picasso",
          base_denom: "79228162514264337593543950342"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.png",
        theme: {
          primary_color_hex: "#e4047c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg"
      }
    },
    {
      description: "USDT issued by the Kusama Asset Hub.",
      denom_units: [{
        denom: "ibc/F3EC9F834E57DF704FA3AEAF14E8391C2E58397FE56960AD70E67562990D8265",
        exponent: 0,
        aliases: ["130"]
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F3EC9F834E57DF704FA3AEAF14E8391C2E58397FE56960AD70E67562990D8265",
      name: "USDT",
      display: "usdt",
      symbol: "USDT",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "picasso",
          base_denom: "130",
          channel_id: "channel-17"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/130"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "picasso",
          base_denom: "130"
        }
      }]
    },
    {
      description: "The native fee, staking and governance token of the Tinkernet Parachain.",
      denom_units: [{
        denom: "ibc/C58E5D2571042137CB68B1B9851C4E7211C05F7C2C79E21E0966AF0F063961F8",
        exponent: 0,
        aliases: ["2125"]
      }, {
        denom: "tnkr",
        exponent: 12
      }],
      type_asset: "ics20",
      base: "ibc/C58E5D2571042137CB68B1B9851C4E7211C05F7C2C79E21E0966AF0F063961F8",
      name: "TNKR",
      display: "tnkr",
      symbol: "TNKR",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "picasso",
          base_denom: "2125",
          channel_id: "channel-17"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/2125"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "picasso",
          base_denom: "2125"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tinkernet/images/tnkr.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tinkernet/images/tnkr.svg"
      }
    },
    {
      description: "The native token of Ethereum, bridged via IBC.",
      extended_description: "Ether is the native token of the Ethereum blockchain. It powers a wide range of decentralized applications and smart contracts on the platform. This specific version has been bridged through Picasso's implementation of IBC on Ethereum.",
      denom_units: [{
        denom: "ibc/F9D075D4079FC56A9C49B601E54A45292C319D8B0E8CC0F8439041130AA7166C",
        exponent: 0,
        aliases: ["wei"]
      }, {
        denom: "eth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/F9D075D4079FC56A9C49B601E54A45292C319D8B0E8CC0F8439041130AA7166C",
      name: "Ethereum",
      display: "eth",
      symbol: "ETH",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/wei"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        theme: {
          primary_color_hex: "#303030"
        }
      }],
      socials: {
        website: "https://ethereum.org/",
        twitter: "https://twitter.com/ethereum"
      }
    },
    {
      description: "A stablecoin issued by Maker Protocol.",
      extended_description: "DAI, a stablecoin issued by the Maker Protocol, maintains a value pegged to the US dollar. This specific version has been bridged through Picasso's implementation of IBC on Ethereum.",
      denom_units: [{
        denom: "ibc/A342F6F8D1CDE1D934C50E8EAFF91E813D971E1BFEED7E557F1674E01004A533",
        exponent: 0,
        aliases: ["dai-wei"]
      }, {
        denom: "dai",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/A342F6F8D1CDE1D934C50E8EAFF91E813D971E1BFEED7E557F1674E01004A533",
      name: "Dai",
      display: "dai",
      symbol: "DAI",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x6b175474e89094c44da98b954eedeac495271d0f"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      }],
      socials: {
        website: "https://makerdao.com/",
        twitter: "https://twitter.com/MakerDAO"
      }
    },
    {
      description: "The governance token of the Frax ecosystem.",
      extended_description: "Frax Shares is the governance and utility token of the Frax Protocol. It plays a crucial role in maintaining the stability of the FRAX stablecoin. Holders of FXS can participate in governance decisions and benefit from the protocol's growth and revenue, as the token captures fees.",
      denom_units: [{
        denom: "ibc/5F9BE030FC355733EC79307409FA98398BBFC747C9430B326C144A74F6808B29",
        exponent: 0,
        aliases: ["fxs-wei"]
      }, {
        denom: "fxs",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/5F9BE030FC355733EC79307409FA98398BBFC747C9430B326C144A74F6808B29",
      name: "Frax Shares",
      display: "fxs",
      symbol: "FXS",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/fxs.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/fxs.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/fxs.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/fxs.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      socials: {
        website: "https://www.frax.com/",
        twitter: "https://twitter.com/fraxfinance"
      }
    },
    {
      description: "The first fractional-algorithmic stablecoin by Frax Finance.",
      extended_description: "FRAX is a stablecoin designed to maintain a stable value to a peg of the US dollar. It is issued by the Frax Protocol, which employs a hybrid approach combining algorithmic mechanisms with collateral backing.",
      denom_units: [{
        denom: "ibc/4F20D68B51ED559F99C3CD658383E91F45486D884BF546E7B25337A058562CDB",
        exponent: 0,
        aliases: ["frax-wei"]
      }, {
        denom: "frax",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/4F20D68B51ED559F99C3CD658383E91F45486D884BF546E7B25337A058562CDB",
      name: "Frax",
      display: "frax",
      symbol: "FRAX",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x853d955acef822db058eb8505911ed77f175b99e",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x853d955acef822db058eb8505911ed77f175b99e"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x853d955acef822db058eb8505911ed77f175b99e"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg"
      }],
      socials: {
        website: "https://www.frax.com/",
        twitter: "https://twitter.com/fraxfinance"
      }
    },
    {
      description: "A liquid ETH staking derivative designed to leverage the Frax ecosystem.",
      extended_description: "FrxETH is a stablecoin that is loosely pegged to ETH, meaning that 1 frxETH always represents 1 ETH.",
      denom_units: [{
        denom: "ibc/458032E654E41DB91EF98F13E2CE4F9E0FE86BA3E0CDBEC074A854E9F5229A90",
        exponent: 0,
        aliases: ["frxeth-wei"]
      }, {
        denom: "frxeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/458032E654E41DB91EF98F13E2CE4F9E0FE86BA3E0CDBEC074A854E9F5229A90",
      name: "Frax Ether",
      display: "frxeth",
      symbol: "frxETH",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x5e8422345238f34275888049021821e8e08caa1f",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x5e8422345238f34275888049021821e8e08caa1f"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frxeth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frxeth.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x5e8422345238f34275888049021821e8e08caa1f"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frxeth.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frxeth.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      socials: {
        website: "https://www.frax.com/",
        twitter: "https://twitter.com/fraxfinance"
      }
    },
    {
      description: "A Liquid Staking Derivative designed to accrue the staking yield of the Frax ETH validators.",
      extended_description: "SFRXETH is a ERC-4626 vault designed to accrue the staking yield of the Frax ETH validators. It allows users to earn staking yield on their frxETH, a type of Frax Ether.",
      denom_units: [{
        denom: "ibc/4E0ECE7819D77B0F2B49F5C34B5E594A02D2BA8B1B0F103208F847B53EBFB69A",
        exponent: 0,
        aliases: ["sfrxeth-wei"]
      }, {
        denom: "sfrxeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/4E0ECE7819D77B0F2B49F5C34B5E594A02D2BA8B1B0F103208F847B53EBFB69A",
      name: "Frax Staked Ether",
      display: "sfrxeth",
      symbol: "sfrxETH",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xac3e018457b222d93114458476f3e3416abbe38f",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0xac3e018457b222d93114458476f3e3416abbe38f"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrxeth.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xac3e018457b222d93114458476f3e3416abbe38f"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrxeth.svg"
      }],
      socials: {
        website: "https://www.frax.com/",
        twitter: "https://twitter.com/fraxfinance"
      }
    },
    {
      description: "An ERC4626 staking vault that distributes part of the Frax Protocol yield weekly to stakers denominated in FRAX stablecoins. ",
      extended_description: "Staked FRAX (sFRAX) is an ERC4626 staking vault that distributes part of the Frax Protocol yield weekly to stakers denominated in FRAX stablecoins. The sFRAX token represents pro rata deposits within the vault and is always withdrawable for FRAX stablecoins at the pro rata rate at all times.",
      denom_units: [{
        denom: "ibc/5BD7F23FE150D9CF3BCC944DB829380BCC51A4022A131151C4D13B3AFAC2D1D9",
        exponent: 0,
        aliases: ["sfrax-wei"]
      }, {
        denom: "sfrax",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/5BD7F23FE150D9CF3BCC944DB829380BCC51A4022A131151C4D13B3AFAC2D1D9",
      name: "Staked FRAX",
      display: "sfrax",
      symbol: "sFRAX",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrax.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrax.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrax.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrax.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      socials: {
        website: "https://www.frax.com/",
        twitter: "https://twitter.com/fraxfinance"
      }
    },
    {
      description: "A stablecoin issued by Tether that is pegged 1:1 to the USD.",
      extended_description: "USDT, or Tether, is a widely used stablecoin pegged to the US dollar, designed to maintain a stable value and facilitate transactions. This specific version has been bridged through Picasso's implementation of IBC on Ethereum.",
      denom_units: [{
        denom: "ibc/37CC704EA53E96AB09A9C31D79142DE7DB252420F3AB18015F9870AE219947BD",
        exponent: 0,
        aliases: ["uusdt"]
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/37CC704EA53E96AB09A9C31D79142DE7DB252420F3AB18015F9870AE219947BD",
      name: "Tether (Ethereum)",
      display: "usdt",
      symbol: "USDT",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      socials: {
        website: "https://www.tether.to/",
        twitter: "https://twitter.com/Tether_to"
      }
    },
    {
      description: "CRV is the governance token for Curve Finance.",
      denom_units: [{
        denom: "ibc/52C8C6197989684F891076F228F20CD1659AB6E1776E3B85E65CBBEC67DA5DED",
        exponent: 0,
        aliases: ["crv-wei"]
      }, {
        denom: "crv",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/52C8C6197989684F891076F228F20CD1659AB6E1776E3B85E65CBBEC67DA5DED",
      name: "Curve DAO",
      display: "crv",
      symbol: "CRV",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xd533a949740bb3306d119cc777fa900ba034cd52",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0xd533a949740bb3306d119cc777fa900ba034cd52"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/crv.png"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xd533a949740bb3306d119cc777fa900ba034cd52"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/crv.png",
        theme: {
          primary_color_hex: "#1fcbdb"
        }
      }]
    },
    {
      description: "An ERC-20 token issued Ethereum that represents Bitcoin.",
      denom_units: [{
        denom: "ibc/1507315B0C337368B85A7EC67C3956C508E1106EBD96336B1B092F7B2815B3E5",
        exponent: 0,
        aliases: ["wbtc-satoshi"]
      }, {
        denom: "wbtc",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/1507315B0C337368B85A7EC67C3956C508E1106EBD96336B1B092F7B2815B3E5",
      name: "Wrapped Bitcoin",
      display: "wbtc",
      symbol: "wBTC",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        theme: {
          primary_color_hex: "#f39444"
        }
      }]
    },
    {
      description: "A token that represents staked ether in Lido.",
      denom_units: [{
        denom: "ibc/74F65FE91F672BC2524C039B3CD0211F6D370071209552533DF26D57743D5FFD",
        exponent: 0,
        aliases: ["steth-wei"]
      }, {
        denom: "steth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/74F65FE91F672BC2524C039B3CD0211F6D370071209552533DF26D57743D5FFD",
      name: "Lido Staked Ether",
      display: "steth",
      symbol: "stETH",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/steth.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/steth.svg"
      }]
    },
    {
      description: "Rocket Pool protocol's liquid staking token.",
      denom_units: [{
        denom: "ibc/207E7F34DFEBF714CED4900C1FD85BAF200230BF431EE8133EB26B98CB535EDC",
        exponent: 0,
        aliases: ["reth-wei"]
      }, {
        denom: "reth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/207E7F34DFEBF714CED4900C1FD85BAF200230BF431EE8133EB26B98CB535EDC",
      name: "Rocket Pool ETH",
      display: "reth",
      symbol: "rETH",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xae78736cd615f374d3085123a210448e74fc6393",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0xae78736cd615f374d3085123a210448e74fc6393"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/reth.png"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xae78736cd615f374d3085123a210448e74fc6393"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/reth.png",
        theme: {
          primary_color_hex: "#fba487"
        }
      }]
    },
    {
      description: "A collateralized-debt-position (CDP) stablecoin by Curve DAO.",
      denom_units: [{
        denom: "ibc/C9D79BE8E3E75CA2DFDC722C77D7B179C39A4802D59019C790A825FDE34B724A",
        exponent: 0,
        aliases: ["crvusd-wei"]
      }, {
        denom: "crvusd",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/C9D79BE8E3E75CA2DFDC722C77D7B179C39A4802D59019C790A825FDE34B724A",
      name: "crvUSD",
      display: "crvusd",
      symbol: "crvUSD",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0xf939e0a03fb07f59a73314e73794be0e57ac1b4e"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/crvusd.png"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/crvusd.png",
        theme: {
          primary_color_hex: "#d6e3d9"
        }
      }]
    },
    {
      description: "pxETH is built on top of the Pirex platform and forms the foundation of the Dinero protocol.",
      denom_units: [{
        denom: "ibc/36EF1EA47A09689C81D848B08E5240FA9FF13B17DB7DCF48B77D4D0D9B152821",
        exponent: 0,
        aliases: ["pxeth-wei"]
      }, {
        denom: "pxeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/36EF1EA47A09689C81D848B08E5240FA9FF13B17DB7DCF48B77D4D0D9B152821",
      name: "Dinero Staked ETH",
      display: "pxeth",
      symbol: "pxETH",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x04c154b66cb340f3ae24111cc767e0184ed00cc6",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x04c154b66cb340f3ae24111cc767e0184ed00cc6"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pxeth.png"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x04c154b66cb340f3ae24111cc767e0184ed00cc6"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pxeth.png",
        theme: {
          primary_color_hex: "#c3cbd2"
        }
      }]
    },
    {
      description: "eETH is a natively restaked liquid staking token on Ethereum.",
      denom_units: [{
        denom: "ibc/34C23BA6BAA2EAE0199D85AD1E2E214F76B0BFAD42BF75542D15F71264EEB05B",
        exponent: 0,
        aliases: ["eeth-wei"]
      }, {
        denom: "eeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/34C23BA6BAA2EAE0199D85AD1E2E214F76B0BFAD42BF75542D15F71264EEB05B",
      name: "ether.fi Staked ETH",
      display: "eeth",
      symbol: "eETH",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x35fa164735182de50811e8e2e824cfb9b6118ac2",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x35fa164735182de50811e8e2e824cfb9b6118ac2"
        },
        provider: "Picasso"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eeth.png"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x35fa164735182de50811e8e2e824cfb9b6118ac2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eeth.png",
        theme: {
          primary_color_hex: "#5045b7"
        }
      }]
    },
    {
      description: "The native governance token of Ethena.",
      denom_units: [{
        denom: "ibc/B089810D5A6316AD5E9C7808733DC4AB11C7BA3033221D28711FC7206BACB929",
        exponent: 0,
        aliases: ["ena-wei"]
      }, {
        denom: "ena",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/B089810D5A6316AD5E9C7808733DC4AB11C7BA3033221D28711FC7206BACB929",
      name: "Ethena",
      display: "ena",
      symbol: "ENA",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x57e114b691db790c35207b2e685d4a43181e6061",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x57e114b691db790c35207b2e685d4a43181e6061"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x57e114b691db790c35207b2e685d4a43181e6061"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ena.png",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }]
    },
    {
      description: "Ethena USDe is a synthetic dollar protocol built on Ethereum.",
      denom_units: [{
        denom: "ibc/FFD9EB71B4480ED4D73F7370A2AEBDB48447A0AAE27265F8060A957F0FF71983",
        exponent: 0,
        aliases: ["usde-wei"]
      }, {
        denom: "usde",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/FFD9EB71B4480ED4D73F7370A2AEBDB48447A0AAE27265F8060A957F0FF71983",
      name: "Ethena USDe",
      display: "usde",
      symbol: "USDe",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x4c9edd5852cd905f086c759e8383e09bff1e68b3",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x4c9edd5852cd905f086c759e8383e09bff1e68b3"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x4c9edd5852cd905f086c759e8383e09bff1e68b3"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usde.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "A Liquid Restaking Token (LRT) and Strategy Manager for EigenLayer.",
      denom_units: [{
        denom: "ibc/E317539F148285AAC77E7614101CBE94E20EDF169B233A5E0C867112972F9041",
        exponent: 0,
        aliases: ["ezeth-wei"]
      }, {
        denom: "ezeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/E317539F148285AAC77E7614101CBE94E20EDF169B233A5E0C867112972F9041",
      name: "Renzo Restaked ETH",
      display: "ezeth",
      symbol: "ezETH",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xbf5495efe5db9ce00f80364c8b423567e58d2110",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0xbf5495efe5db9ce00f80364c8b423567e58d2110"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xbf5495efe5db9ce00f80364c8b423567e58d2110"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ezeth.png",
        theme: {
          primary_color_hex: "#9bcf2c"
        }
      }]
    },
    {
      description: "PEPE is a deflationary memecoin launched on Ethereum. ",
      denom_units: [{
        denom: "ibc/6367C5AF2E2477FB13DD0C8CB0027FEDDF5AE947EE84C69FB75003E604E29D05",
        exponent: 0,
        aliases: ["pepe-wei"]
      }, {
        denom: "pepe",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/6367C5AF2E2477FB13DD0C8CB0027FEDDF5AE947EE84C69FB75003E604E29D05",
      name: "Pepe",
      display: "pepe",
      symbol: "PEPE",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x6982508145454ce325ddbe47a25d4ec3d2311933"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x6982508145454Ce325dDbE47a25d4ec3d2311933"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.png",
        theme: {
          primary_color_hex: "#cc3233"
        }
      }]
    },
    {
      description: "SOL is the native cryptocurrency of the Solana blockchain.",
      denom_units: [{
        denom: "ibc/2CC39C8141F257EBBA250F65B9D0F31DC8D153C225E51EC192DE6E3F65D43F0C",
        exponent: 0,
        aliases: ["Lamport"]
      }, {
        denom: "wsol",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/2CC39C8141F257EBBA250F65B9D0F31DC8D153C225E51EC192DE6E3F65D43F0C",
      name: "Wrapped Solana",
      display: "wsol",
      symbol: "wSOL",
      traces: [{
        type: "wrapped",
        counterparty: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        provider: "Solana"
      }, {
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "So11111111111111111111111111111111111111112",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/So11111111111111111111111111111111111111112"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "So11111111111111111111111111111111111111112"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        theme: {
          circle: !0,
          background_color_hex: "#000000"
        }
      }]
    },
    {
      description: "mSOL represents staked SOL in the Marinade stake pool.",
      denom_units: [{
        denom: "ibc/C280CB39B97E7CD33A0BF149CFD392C2A3F95FF896AFF89CFF2FA181479BED8D",
        exponent: 0
      }, {
        denom: "msol",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/C280CB39B97E7CD33A0BF149CFD392C2A3F95FF896AFF89CFF2FA181479BED8D",
      name: "Marinade Staked SOL",
      display: "msol",
      symbol: "mSOL",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/msol.png",
        theme: {
          primary_color_hex: "#cbebe3"
        }
      }]
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using Jito.",
      denom_units: [{
        denom: "ibc/91A2FE07F8BDFC0552B1C9972FCCBF2CFD067DDE5F496D81E5132CE57762B0F2",
        exponent: 0
      }, {
        denom: "jitosol",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/91A2FE07F8BDFC0552B1C9972FCCBF2CFD067DDE5F496D81E5132CE57762B0F2",
      name: "Jito Staked SOL",
      display: "jitosol",
      symbol: "jitoSOL",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/jitosol.png",
        theme: {
          primary_color_hex: "#5bb384"
        }
      }]
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using the BlazeStake protocol.",
      denom_units: [{
        denom: "ibc/F52A71607B3AA7BBA8A222A9176E9939E92AB3656A094289CD218907D45DB716",
        exponent: 0
      }, {
        denom: "bsol",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/F52A71607B3AA7BBA8A222A9176E9939E92AB3656A094289CD218907D45DB716",
      name: "BlazeStake Staked SOL",
      display: "bsol",
      symbol: "bSOL",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bsol.png",
        theme: {
          primary_color_hex: "#21c3cc"
        }
      }]
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using the MarginFi protocol.",
      denom_units: [{
        denom: "ibc/55F5B582483FEFA5422794292B079B4D49A5BAB9881E7C801F9F271F1D234F1D",
        exponent: 0
      }, {
        denom: "lst",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/55F5B582483FEFA5422794292B079B4D49A5BAB9881E7C801F9F271F1D234F1D",
      name: "Liquid Staking Token",
      display: "lst",
      symbol: "LST",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "LSTxxxnJzKDFSLr4dUkPcmCf5VyryEqzPLz5j4bpxFp",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/LSTxxxnJzKDFSLr4dUkPcmCf5VyryEqzPLz5j4bpxFp"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/msol.png",
        theme: {
          primary_color_hex: "#cbebe3"
        }
      }]
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using the Edgevana protocol.",
      denom_units: [{
        denom: "ibc/BADB5950C4A81AC201696EBCB33CD295137FA86F0AA620CDDE946D3700E0208C",
        exponent: 0
      }, {
        denom: "edgesol",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/BADB5950C4A81AC201696EBCB33CD295137FA86F0AA620CDDE946D3700E0208C",
      name: "Edgevana Staked SOL",
      display: "edgesol",
      symbol: "edgeSOL",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/edgesol.png",
        theme: {
          primary_color_hex: "#146cfc"
        }
      }]
    },
    {
      description: "A liquid staked token that represents SOL staked to Helius's validator.",
      denom_units: [{
        denom: "ibc/531C52D572698BCBA29F44D959E73CD2148EE6542A3118F9E56621A28E1FF4C6",
        exponent: 0
      }, {
        denom: "hsol",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/531C52D572698BCBA29F44D959E73CD2148EE6542A3118F9E56621A28E1FF4C6",
      name: "Helius Staked SOL",
      display: "hsol",
      symbol: "hSOL",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/hsol.png",
        theme: {
          primary_color_hex: "#e5502a"
        }
      }]
    },
    {
      description: "A liquid staked token that represents SOL staked to Jupiter's validator.",
      denom_units: [{
        denom: "ibc/6976998E24F1CFC373A9F799C9CE901F5EC32C3E33B2B09384A05774D9339626",
        exponent: 0
      }, {
        denom: "jupsol",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/6976998E24F1CFC373A9F799C9CE901F5EC32C3E33B2B09384A05774D9339626",
      name: "Jupiter Staked SOL",
      display: "jupsol",
      symbol: "jupSOL",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/jupsol.png",
        theme: {
          primary_color_hex: "#85d79e"
        }
      }]
    },
    {
      description: "dogwifhat is a meme coin that operates on Solana.",
      denom_units: [{
        denom: "ibc/BA34EAA22BBDA46C228DC70E4ED7E42A0867D5B051D625F953CC7B1CEF58C071",
        exponent: 0
      }, {
        denom: "wif",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/BA34EAA22BBDA46C228DC70E4ED7E42A0867D5B051D625F953CC7B1CEF58C071",
      name: "dogwifhat",
      display: "wif",
      symbol: "WIF",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/wif.png",
        theme: {
          primary_color_hex: "#a29482"
        }
      }]
    },
    {
      description: "Tether, issued natively on Solana.",
      denom_units: [{
        denom: "ibc/D105950618E47CA2AEC314282BC401625025F80A4F812808DEEBB1941C685575",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D105950618E47CA2AEC314282BC401625025F80A4F812808DEEBB1941C685575",
      name: "Tether",
      display: "usdt",
      symbol: "USDT",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }]
    },
    {
      description: "Whinecoin is an experimental memecoin by the Sommelier Finance team.",
      denom_units: [{
        denom: "ibc/9D5DA3720001F91DD76B8F609A93F96688EC8185B54BF9A1A1450EB34FF2D912",
        exponent: 0,
        aliases: ["ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump"]
      }, {
        denom: "whine",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9D5DA3720001F91DD76B8F609A93F96688EC8185B54BF9A1A1450EB34FF2D912",
      name: "WHINEcoin",
      display: "whine",
      symbol: "WHINE",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/whine.png",
        theme: {
          primary_color_hex: "#FFFFFF",
          background_color_hex: "#FFFFFF",
          circle: !1
        }
      }]
    },
    {
      description: "Unicorn from Solana via Picasso IBC",
      denom_units: [{
        denom: "ibc/586C150919550F6106711C7557DAAAEAB765DDF05648BAC0D96487AE90394BA1",
        exponent: 0,
        aliases: ["UwU8RVXB69Y6Dcju6cN2Qef6fykkq6UUNpB15rZku6Z"]
      }, {
        denom: "unicorn",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/586C150919550F6106711C7557DAAAEAB765DDF05648BAC0D96487AE90394BA1",
      name: "Unicorn",
      display: "unicorn",
      symbol: "UWU",
      traces: [{
        type: "ibc-bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "UwU8RVXB69Y6Dcju6cN2Qef6fykkq6UUNpB15rZku6Z",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/UwU8RVXB69Y6Dcju6cN2Qef6fykkq6UUNpB15rZku6Z"
        },
        provider: "Picasso"
      }],
      images: [{
        image_sync: {
          chain_name: "unicorn",
          base_denom: "uwunicorn"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unicorn/images/uwu.png",
        theme: {
          primary_color_hex: "#D44CE6"
        }
      }]
    }
  ]
};
fg.default = Jq;
var wg = {};
Object.defineProperty(wg, "__esModule", { value: !0 });
const Zq = {
  $schema: "../chain.schema.json",
  chain_name: "composable",
  chain_type: "cosmos",
  chain_id: "centauri-1",
  website: "https://www.picasso.xyz/",
  pretty_name: "Picasso",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "pica",
  daemon_name: "picad",
  node_home: "$HOME/.banksy",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ppica",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ppica"
    }]
  },
  codebase: {
    cosmos_sdk_version: "rust-ninja/cosmos-sdk v0.47.5-patch-validators-trim-tag"
  },
  logo_URIs: {
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/composable/images/pica.svg"
  },
  description: "Picasso is a DeFi infrastructure-focused Layer 1 protocol that leads the industry in building the trust-minimized interoperability solution -Cross-Ecosystem IBC. Complementary to the interoperability work, Picasso is building the first Generalized Restaking Layer starting with deployment on Solana, and expand support for all IBC connected ecosystems.",
  apis: {
    rpc: [
      {
        address: "https://rpc-composable-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "https://composable-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://picasso-rpc.cogwheel.zone:443",
        provider: "Cogwheel ⚙️"
      },
      {
        address: "https://rpc.lavenderfive.com:443/picasso",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://composable-rpc.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://picasso-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://composable.rpc.stakevillage.net:443",
        provider: "Stake Village"
      },
      {
        address: "https://picasso-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://rpc.centauri.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://composable.rpc.moonbridge.team",
        provider: "Moonbridge"
      },
      {
        address: "https://rpc.composable.citizenweb3.com:443",
        provider: "Citizen Web3"
      },
      {
        address: "https://composable.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      }
    ],
    rest: [
      {
        address: "https://api-composable-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "https://composable-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://picasso-api.cogwheel.zone:443",
        provider: "Cogwheel ⚙️"
      },
      {
        address: "https://rest.lavenderfive.com:443/picasso",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://composable-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://picasso-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://composable.api.stakevillage.net",
        provider: "Stake Village"
      },
      {
        address: "https://picasso-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://lcd.centauri.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://composable.api.moonbridge.team",
        provider: "Moonbridge"
      },
      {
        address: "https://composable.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      }
    ],
    grpc: [
      {
        address: "https://grpc-composable-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "grpc.composable.nodestake.top:9090",
        provider: "NodeStake"
      },
      {
        address: "composable-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-centauri.cosmos-spaces.cloud:1120",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://picasso-grpc.cogwheel.zone:443",
        provider: "Cogwheel ⚙️"
      },
      {
        address: "picasso.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "composable-grpc.genznodes.dev:53090",
        provider: "genznodes"
      },
      {
        address: "picasso-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "grpc-composable.vinjan.xyz:36090",
        provider: "vinjan"
      },
      {
        address: "composable.grpc.skynodejs.net",
        provider: "skynodejs"
      },
      {
        address: "composable.grpc.stakevillage.net:16190",
        provider: "Stake Village"
      },
      {
        address: "picasso-rpc.stakeandrelax.net:22290",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "grpc.composable.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://grpc.centauri.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://composable.grpc.moonbridge.team",
        provider: "Moonbridge"
      },
      {
        address: "composable.grpc.m.stavr.tech:9907",
        provider: "🔥STAVR🔥"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/composable",
      tx_page: "https://ping.pub/composable/tx/${txHash}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/composable",
      tx_page: "https://explorer.nodestake.top/composable/tx/${txHash}"
    },
    {
      kind: "Stake Village",
      url: "https://exp.stakevillage.net/composable",
      tx_page: "https://exp.stakevillage.net/composable/tx/${txHash}",
      account_page: "https://exp.stakevillage.net/composable/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Composable-Mainnet",
      tx_page: "https://explorer.stavr.tech/Composable-Mainnet/tx/${txHash}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/picasso",
      tx_page: "https://mainnet.whispernode.com/picasso/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/picasso/account/${accountAddress}"
    }
  ],
  images: [{
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/composable/images/pica.svg"
  }]
};
wg.default = Zq;
var xg = {};
Object.defineProperty(xg, "__esModule", { value: !0 });
const Qq = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-70",
      connection_id: "connection-64"
    },
    chain_2: {
      chain_name: "composable",
      client_id: "07-tendermint-51",
      connection_id: "connection-20"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-55",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-75",
      connection_id: "connection-79"
    },
    chain_2: {
      chain_name: "composable",
      client_id: "07-tendermint-143",
      connection_id: "connection-63"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-108",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-187",
      connection_id: "connection-165"
    },
    chain_2: {
      chain_name: "composable",
      client_id: "07-tendermint-140",
      connection_id: "connection-58"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-127",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics-20",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "canto",
      client_id: "07-tendermint-38",
      connection_id: "connection-32"
    },
    chain_2: {
      chain_name: "composable",
      client_id: "07-tendermint-50",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-35",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "composable",
      client_id: "07-tendermint-138",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1150",
      connection_id: "connection-871"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-617",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-46",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-112",
      connection_id: "connection-98"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "08-wasm-159",
      connection_id: "connection-70"
    },
    chain_2: {
      chain_name: "ethereum",
      client_id: "07-tendermint-11",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-52",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-26",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-111",
      connection_id: "connection-66"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-82",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-123",
      connection_id: "connection-45"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-207",
      connection_id: "connection-191"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-145",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-30",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-382",
      connection_id: "connection-376"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-280",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-110",
      connection_id: "connection-43"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-147",
      connection_id: "connection-112"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-101",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-66",
      connection_id: "connection-28"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-29",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2846",
      connection_id: "connection-2358"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1279",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "08-wasm-5",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "picasso",
      client_id: "07-tendermint-32",
      connection_id: "connection-26"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-31",
      connection_id: "connection-16"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-78",
      connection_id: "connection-53"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-94",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-52",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-166",
      connection_id: "connection-116"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-80",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-26",
        port_id: "transfer",
        client_id: "07-tendermint-52",
        connection_id: "connection-21"
      },
      chain_2: {
        channel_id: "channel-83",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
        client_id: "07-tendermint-166",
        connection_id: "connection-116"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "08-wasm-215",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "solana",
      client_id: "07-tendermint-1",
      connection_id: "connection-108"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-71",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-25",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-279",
      connection_id: "connection-207"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-184",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-14",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-126",
      connection_id: "connection-116"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-134",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
xg.default = Qq;
var kg = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(rt, "__esModule", { value: !0 });
rt.ibc = rt.chain = rt.assets = void 0;
const eS = kg(fg), nS = kg(wg), tS = kg(xg);
rt.assets = eS.default;
rt.chain = nS.default;
rt.ibc = tS.default;
var it = {}, Ag = {};
Object.defineProperty(Ag, "__esModule", { value: !0 });
const sS = {
  $schema: "../assetlist.schema.json",
  chain_name: "conscious",
  assets: [{
    description: "Cvn is a Layer-1 blockchain built to deliver on the promise of DeFi",
    extended_description: "Conscious Network is a public chain infrastructure that deeply integrates AI. It is based on a multi-layer blockchain network architecture consisting of Layer 1 and L2 Rollup, and introduces decentralized storage protocols to build a scalable Web3 AI infrastructure.",
    denom_units: [{
      denom: "acvnt",
      exponent: 0
    }, {
      denom: "cvnt",
      exponent: 18
    }],
    base: "acvnt",
    name: "Cvn",
    display: "cvnt",
    symbol: "CVN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.svg"
    },
    coingecko_id: "consciousdao",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.svg",
      theme: {
        primary_color_hex: "#047e04"
      }
    }],
    socials: {
      website: "https://cvn.io",
      twitter: "https://twitter.com/conscious_chain"
    }
  }]
};
Ag.default = sS;
var jg = {};
Object.defineProperty(jg, "__esModule", { value: !0 });
const aS = {
  $schema: "../chain.schema.json",
  chain_name: "conscious",
  status: "live",
  network_type: "mainnet",
  website: "https://cvn.io/",
  pretty_name: "ConsciousDAO",
  chain_type: "cosmos",
  chain_id: "cvn_2032-1",
  bech32_prefix: "cvn",
  node_home: "$HOME/.cvnd",
  daemon_name: "cvnd",
  key_algos: ["ethsecp256k1"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "acvnt",
      fixed_min_gas_price: 1e8,
      low_gas_price: 1e8,
      average_gas_price: 2e8,
      high_gas_price: 3e8
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "acvnt"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.cvn.io/",
      provider: "cvn.io"
    }, {
      address: "https://conscious_mainnet_rpc.chain.whenmoonwhenlambo.money/",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }],
    rest: [{
      address: "https://api.cvn.io",
      provider: "cvn.io"
    }, {
      address: "https://conscious_mainnet_api.chain.whenmoonwhenlambo.money/",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }],
    grpc: [{
      address: "https://grpc.cvn.io",
      provider: "cvn.io"
    }],
    "evm-http-jsonrpc": [
      {
        address: "https://node.cvn.io/",
        provider: "cvn"
      },
      {
        address: "https://node.consciousdao.io/",
        provider: "consciousdao"
      },
      {
        address: "https://conscious_mainnet_evm.chain.whenmoonwhenlambo.money/",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ]
  },
  explorers: [{
    kind: "blockscout",
    url: "https://explore.consciousdao.com/",
    tx_page: "https://explore.consciousdao.com/tx/${txHash}"
  }, {
    kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
    url: "https://explorer.whenmoonwhenlambo.money/conscious",
    tx_page: "https://explorer.whenmoonwhenlambo.money/conscious/tx/${txHash}",
    account_page: "https://explorer.whenmoonwhenlambo.money/conscious/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.svg",
    theme: {
      primary_color_hex: "#047e04"
    }
  }]
};
jg.default = aS;
var Cg = {};
Object.defineProperty(Cg, "__esModule", { value: !0 });
const oS = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "conscious",
    client_id: "07-tendermint-12",
    connection_id: "connection-9"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3199",
    connection_id: "connection-2656"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-6",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-73971",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Cg.default = oS;
var Eg = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(it, "__esModule", { value: !0 });
it.ibc = it.chain = it.assets = void 0;
const rS = Eg(Ag), iS = Eg(jg), cS = Eg(Cg);
it.assets = rS.default;
it.chain = iS.default;
it.ibc = cS.default;
var ct = {}, Dg = {};
Object.defineProperty(Dg, "__esModule", { value: !0 });
const dS = {
  $schema: "../assetlist.schema.json",
  chain_name: "coreum",
  assets: [{
    description: "The native token of Coreum",
    denom_units: [{
      denom: "ucore",
      exponent: 0
    }, {
      denom: "core",
      exponent: 6
    }],
    base: "ucore",
    name: "Coreum",
    display: "core",
    symbol: "COREUM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.svg"
    },
    coingecko_id: "coreum",
    keywords: [
      "dex",
      "staking",
      "wasm",
      "assets",
      "nft",
      "XRPL"
    ],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.svg",
      theme: {
        primary_color_hex: "#24d494"
      }
    }],
    socials: {
      website: "https://www.coreum.com/",
      twitter: "https://twitter.com/CoreumOfficial"
    }
  }, {
    description: "XRP bridged from XRPL",
    denom_units: [{
      denom: "drop-core1zhs909jp9yktml6qqx9f0ptcq2xnhhj99cja03j3lfcsp2pgm86studdrz",
      exponent: 0,
      aliases: ["drop"]
    }, {
      denom: "xrp",
      exponent: 6
    }],
    base: "drop-core1zhs909jp9yktml6qqx9f0ptcq2xnhhj99cja03j3lfcsp2pgm86studdrz",
    name: "Ripple",
    display: "xrp",
    symbol: "XRP",
    traces: [{
      type: "bridge",
      counterparty: {
        chain_name: "xrpl",
        base_denom: "drop"
      },
      provider: "Coreum"
    }],
    images: [{
      image_sync: {
        chain_name: "xrpl",
        base_denom: "drop"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/xrpl/images/xrp.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/xrpl/images/xrp.svg",
      theme: {
        primary_color_hex: "#040404"
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/xrpl/images/xrp.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/xrpl/images/xrp.svg"
    }
  }]
};
Dg.default = dS;
var Bg = {};
Object.defineProperty(Bg, "__esModule", { value: !0 });
const mS = {
  $schema: "../chain.schema.json",
  chain_name: "coreum",
  status: "live",
  network_type: "mainnet",
  website: "https://www.coreum.com",
  pretty_name: "Coreum",
  chain_type: "cosmos",
  chain_id: "coreum-mainnet-1",
  bech32_prefix: "core",
  daemon_name: "cored",
  node_home: "$HOME/.core/coreum-mainnet-1",
  key_algos: ["secp256k1"],
  slip44: 990,
  fees: {
    fee_tokens: [{
      denom: "ucore",
      fixed_min_gas_price: 0.03125,
      low_gas_price: 0.0625,
      average_gas_price: 0.0625,
      high_gas_price: 62.5
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ucore"
    }],
    lock_duration: {
      time: "168h"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.47",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.44"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png",
    theme: {
      primary_color_hex: "#25d695"
    }
  }, {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.svg",
    theme: {
      primary_color_hex: "#24d494"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png"
  },
  apis: {
    rpc: [
      {
        address: "https://full-node.mainnet-1.coreum.dev:26657",
        provider: "Coreum Foundation"
      },
      {
        address: "https://full-node-californium.mainnet-1.coreum.dev:26657",
        provider: "Coreum Foundation"
      },
      {
        address: "https://full-node-curium.mainnet-1.coreum.dev:26657",
        provider: "Coreum Foundation"
      },
      {
        address: "https://full-node-uranium.mainnet-1.coreum.dev:26657",
        provider: "Coreum Foundation"
      },
      {
        address: "https://rpc-coreum.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://coreum.rpc.silknodes.io",
        provider: "Silk Nodes"
      },
      {
        address: "https://coreum-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc.m.core.solonation.io",
        provider: "#SoloNation"
      },
      {
        address: "https://coreum-rpc.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://coreum-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://public.stakewolle.com/cosmos/coreum/rpc",
        provider: "Stakewolle"
      }
    ],
    grpc: [
      {
        address: "https://full-node.mainnet-1.coreum.dev:9090",
        provider: "Coreum Foundation"
      },
      {
        address: "https://full-node-californium.mainnet-1.coreum.dev:9090",
        provider: "Coreum Foundation"
      },
      {
        address: "https://full-node-curium.mainnet-1.coreum.dev:9090",
        provider: "Coreum Foundation"
      },
      {
        address: "https://full-node-uranium.mainnet-1.coreum.dev:9090",
        provider: "Coreum Foundation"
      },
      {
        address: "https://grpc.coreum.nodexcapital.com:444",
        provider: "NodeX Validator"
      },
      {
        address: "coreum-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "coreum-grpc.genznodes.dev:35090",
        provider: "genznodes"
      }
    ],
    rest: [
      {
        address: "https://rest-coreum.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://coreum.api.silknodes.io",
        provider: "Silk Nodes"
      },
      {
        address: "https://full-node.mainnet-1.coreum.dev:1317",
        provider: "Coreum"
      },
      {
        address: "https://coreum-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://api.m.core.solonation.io",
        provider: "#SoloNation"
      },
      {
        address: "https://coreum-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://coreum-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://public.stakewolle.com/cosmos/coreum/rest",
        provider: "Stakewolle"
      }
    ]
  },
  explorers: [
    {
      kind: "Coreum",
      url: "https://explorer.coreum.com/coreum",
      tx_page: "https://explorer.coreum.com/coreum/transactions/${txHash}",
      account_page: "https://explorer.coreum.com/coreum/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/coreum",
      tx_page: "https://www.mintscan.io/coreum/transactions/${txHash}",
      account_page: "https://www.mintscan.io/coreum/accounts/${accountAddress}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodexcapital.com/coreum",
      tx_page: "https://explorer.nodexcapital.com/coreum/txs/${txHash}",
      account_page: "https://explorer.nodexcapital.com/coreum/account/${accountAddress}"
    },
    {
      kind: "Silk Nodes",
      url: "https://explorer.silknodes.io/coreum",
      tx_page: "https://explorer.silknodes.io/coreum/tx/${txHash}",
      account_page: "https://explorer.silknodes.io/coreum/account/${accountAddress}"
    },
    {
      kind: "#SoloNation",
      url: "https://explorer.solonation.io/core-main",
      tx_page: "https://explorer.solonation.io/core-main/tx/${txHash}",
      account_page: "https://explorer.solonation.io/core-main/account/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/coreum",
      tx_page: "https://explorer.tcnetwork.io/coreum/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/coreum/account/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/coreum",
      tx_page: "https://ezstaking.app/coreum/txs/${txHash}",
      account_page: "https://ezstaking.app/coreum/account/${accountAddress}"
    }
  ],
  keywords: [
    "dex",
    "staking",
    "wasm",
    "assets",
    "nft",
    "XRPL"
  ]
};
Bg.default = mS;
var Fg = {};
Object.defineProperty(Fg, "__esModule", { value: !0 });
const hS = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-179",
      connection_id: "connection-157"
    },
    chain_2: {
      chain_name: "coreum",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-120",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bandchain",
      client_id: "07-tendermint-162",
      connection_id: "connection-141"
    },
    chain_2: {
      chain_name: "coreum",
      client_id: "07-tendermint-33",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-159",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-11",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1162",
      connection_id: "connection-884"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-660",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-12",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "doravota",
      client_id: "07-tendermint-12",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-38",
      connection_id: "connection-26"
    },
    chain_2: {
      chain_name: "dydx",
      client_id: "07-tendermint-14",
      connection_id: "connection-20"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-117",
      connection_id: "connection-71"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-87",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-8",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-421",
      connection_id: "connection-399"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-142",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-29",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-160",
      connection_id: "connection-200"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-142",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-28",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-163",
      connection_id: "connection-126"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-122",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-32",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-71",
      connection_id: "connection-72"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2929",
      connection_id: "connection-2426"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2188",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-40",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-186",
      connection_id: "connection-138"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-101",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Fg.default = hS;
var $g = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ct, "__esModule", { value: !0 });
ct.ibc = ct.chain = ct.assets = void 0;
const pS = $g(Dg), lS = $g(Bg), gS = $g(Fg);
ct.assets = pS.default;
ct.chain = lS.default;
ct.ibc = gS.default;
var dt = {}, zg = {};
Object.defineProperty(zg, "__esModule", { value: !0 });
const uS = {
  $schema: "../assetlist.schema.json",
  chain_name: "cosmoshub",
  assets: [
    {
      description: "ATOM is the native cryptocurrency of the Cosmos network, designed to facilitate interoperability between multiple blockchains through its innovative hub-and-spoke model.",
      extended_description: `ATOM, the native cryptocurrency of the Cosmos network, is essential for achieving the project's goal of creating an 'Internet of Blockchains.' Launched in 2019, Cosmos aims to solve the scalability, usability, and interoperability issues prevalent in existing blockchain ecosystems. The Cosmos Hub, the central blockchain of the network, uses ATOM for transaction fees, staking, and governance. By staking ATOM, users can earn rewards and participate in governance, influencing decisions on network upgrades and changes.

Cosmos leverages the Tendermint consensus algorithm to achieve high transaction throughput and fast finality. Its Inter-Blockchain Communication (IBC) protocol enables seamless data and value transfer between different blockchains, fostering a highly interconnected and collaborative ecosystem. The flexibility and scalability offered by Cosmos have attracted numerous projects, enhancing its utility and adoption. ATOM's role in securing the network and facilitating governance underscores its importance in the broader blockchain landscape.`,
      denom_units: [{
        denom: "uatom",
        exponent: 0
      }, {
        denom: "atom",
        exponent: 6
      }],
      base: "uatom",
      name: "Cosmos Hub Atom",
      display: "atom",
      symbol: "ATOM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      },
      coingecko_id: "cosmos",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }],
      socials: {
        website: "https://cosmos.network",
        twitter: "https://twitter.com/cosmoshub"
      }
    },
    {
      description: "Tether USDt on the Cosmos Hub",
      denom_units: [{
        denom: "ibc/F04D72CF9B5D9C849BB278B691CDFA2241813327430EC9CDC83F8F4CA4CDC2B0",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F04D72CF9B5D9C849BB278B691CDFA2241813327430EC9CDC83F8F4CA4CDC2B0",
      name: "Tether USDt",
      display: "usdt",
      symbol: "USDt",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-277",
          path: "transfer/channel-277/erc20/tether/usdt"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    },
    {
      description: "FX on Cosmos Hub",
      denom_units: [{
        denom: "ibc/4925E6ABA571A44D2BE0286D2D29AF42A294D0FF2BB16490149A1B26EAD33729",
        exponent: 0,
        aliases: ["FX"]
      }],
      type_asset: "ics20",
      base: "ibc/4925E6ABA571A44D2BE0286D2D29AF42A294D0FF2BB16490149A1B26EAD33729",
      name: "Function X",
      display: "FX",
      symbol: "FX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "fxcore",
          base_denom: "FX",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-585",
          path: "transfer/channel-585/FX"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "fxcore",
          base_denom: "FX"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.svg",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.svg"
      }
    }
  ]
};
zg.default = uS;
var qg = {};
Object.defineProperty(qg, "__esModule", { value: !0 });
const _S = {
  $schema: "../chain.schema.json",
  chain_name: "cosmoshub",
  chain_type: "cosmos",
  chain_id: "cosmoshub-4",
  website: "https://cosmos.network/",
  pretty_name: "Cosmos Hub",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "cosmos",
  daemon_name: "gaiad",
  node_home: "$HOME/.gaia",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uatom",
      fixed_min_gas_price: 5e-3,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uatom"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.50.9-lsm",
    cosmwasm_version: "v0.51.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
  },
  description: `In a nutshell, Cosmos Hub bills itself as a project that solves some of the hardest problems facing the blockchain industry. It aims to offer an antidote to slow, expensive, unscalable and environmentally harmful proof-of-work protocols, like those used by Bitcoin, by offering an ecosystem of connected blockchains.

The project’s other goals include making blockchain technology less complex and difficult for developers thanks to a modular framework that demystifies decentralized apps. Last but not least, an Inter-blockchain Communication protocol makes it easier for blockchain networks to communicate with each other — preventing fragmentation in the industry.

Cosmos Hub's origins can be dated back to 2014, when Tendermint, a core contributor to the network, was founded. In 2016, a white paper for Cosmos was published — and a token sale was held the following year. ATOM tokens are earned through a hybrid proof-of-stake algorithm, and they help to keep the Cosmos Hub, the project’s flagship blockchain, secure. This cryptocurrency also has a role in the network’s governance.`,
  apis: {
    rpc: [
      {
        address: "https://cosmoshub.tendermintrpc.lava.build:443",
        provider: "Lava"
      },
      {
        address: "https://cosmos-rpc.quickapi.com:443",
        provider: "Chainlayer"
      },
      {
        address: "https://cosmos-rpc.onivalidator.com",
        provider: "Oni Validator ⛩️"
      },
      {
        address: "https://rpc-cosmoshub.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://rpc.lavenderfive.com:443/cosmoshub",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-cosmoshub.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://go.getblock.io/17515cb3ec0e43b7817f182e5de6066a",
        provider: "GetBlock RPC Nodes"
      },
      {
        address: "https://rpc-cosmoshub.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://rpc-cosmoshub.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://cosmos-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://cosmos-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://rpc-cosmoshub-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc-cosmoshub.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://rpc.cosmos.dragonstake.io",
        provider: "DragonStake"
      },
      {
        address: "https://cosmoshub.rpc.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://rpc.cosmos.bh.rocks",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://cosmos-rpc.rockrpc.net",
        provider: "RockawayX Infra"
      },
      {
        address: "http://rpc-cosmoshub.freshstaking.com:26657",
        provider: "FreshSTAKING"
      },
      {
        address: "https://cosmos-rpc.easy2stake.com/",
        provider: "Easy 2 Stake"
      },
      {
        address: "https://rpc.cosmos.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://cosmos.rpc.silknodes.io",
        provider: "Silk Nodes"
      },
      {
        address: "https://cosmos-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://cosmoshub.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://rpc.cosmoshub.goldenratiostaking.net",
        provider: "Golden Ratio Staking"
      },
      {
        address: "https://rpc-cosmos-hub-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://cosmos-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://rpc-cosmoshub.mms.team",
        provider: "MMS"
      },
      {
        address: "https://cosmos-rpc.tienthuattoan.com",
        provider: "TTT 🇻🇳"
      },
      {
        address: "https://community.nuxian-node.ch:6797/gaia/trpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://cosmos-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://cosmoshub-rpc.cosmosrescue.dev",
        provider: "cosmosrescue"
      },
      {
        address: "https://cosmos.interstellar-lounge.org",
        provider: "Interstellar Lounge 🍸"
      },
      {
        address: "https://public.stakewolle.com/cosmos/cosmoshub/rpc",
        provider: "Stakewolle"
      },
      {
        address: "https://rpc-cosmos.kewrnode.com",
        provider: "Kewr Node"
      },
      {
        address: "https://rpc.cosmoshub-4.citizenweb3.com",
        provider: "Citizen Web3"
      },
      {
        address: "https://cosmos-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://cosmos-hub.drpc.org",
        provider: "dRPC"
      }
    ],
    rest: [
      {
        address: "https://cosmoshub.lava.build:443",
        provider: "Lava"
      },
      {
        address: "https://cosmos-lcd.quickapi.com:443",
        provider: "Chainlayer"
      },
      {
        address: "https://rest.cosmoshub.goldenratiostaking.net",
        provider: "Golden Ratio Staking"
      },
      {
        address: "https://rest.lavenderfive.com:443/cosmoshub",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api-cosmoshub.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://api-cosmoshub.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://api-cosmoshub-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://cosmos-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://lcd.cosmos.dragonstake.io",
        provider: "DragonStake"
      },
      {
        address: "https://cosmoshub.rest.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://rest-cosmoshub.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://rest-cosmoshub.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://lcd-cosmoshub.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://cosmos-lcd.easy2stake.com",
        provider: "Easy 2 Stake"
      },
      {
        address: "https://api.cosmos.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://cosmos.api.silknodes.io",
        provider: "Silk Nodes"
      },
      {
        address: "https://cosmos-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://cosmoshub.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://api-cosmos-hub-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://cosmos-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://api-cosmoshub.mms.team",
        provider: "MMS"
      },
      {
        address: "https://cosmos-api.tienthuattoan.ventures",
        provider: "TienThuatToan"
      },
      {
        address: "https://community.nuxian-node.ch:6797/gaia/crpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://cosmos-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://cosmoshub-api.cosmosrescue.dev",
        provider: "cosmosrescue"
      },
      {
        address: "https://cosmos-rest.interstellar-lounge.org",
        provider: "Interstellar Lounge 🍸"
      },
      {
        address: "https://public.stakewolle.com/cosmos/cosmoshub/rest",
        provider: "Stakewolle"
      },
      {
        address: "https://rest-cosmos.kewrnode.com",
        provider: "Kewr Node"
      },
      {
        address: "https://cosmos-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      }
    ],
    grpc: [
      {
        address: "cosmoshub.grpc.lava.build",
        provider: "Lava"
      },
      {
        address: "cosmoshub.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "grpc-cosmoshub-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "cosmos-grpc.polkachu.com:14990",
        provider: "Polkachu"
      },
      {
        address: "grpc.cosmos.interbloc.org:443",
        provider: "Interbloc"
      },
      {
        address: "services.staketab.com:9030",
        provider: "Staketab"
      },
      {
        address: "grpc.cosmos.dragonstake.io:443",
        provider: "DragonStake"
      },
      {
        address: "cosmoshub.grpc.stakin-nodes.com:443",
        provider: "Stakin"
      },
      {
        address: "https://grpc.cosmos.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "cosmos-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "grpc-cosmoshub.cosmos-spaces.cloud:3910",
        provider: "Cosmos Spaces"
      },
      {
        address: "cosmoshub.grpc.kjnodes.com:11390",
        provider: "kjnodes"
      },
      {
        address: "grpc-cosmos-hub-01.stakeflow.io:9090",
        provider: "Stakeflow"
      },
      {
        address: "grpc-cosmoshub.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "cosmos-grpc.w3coins.io:14990",
        provider: "w3coins"
      },
      {
        address: "grpc-cosmoshub.mms.team:443",
        provider: "MMS"
      },
      {
        address: "cosmos-grpc.tienthuattoan.ventures:9090",
        provider: "TienThuatToan"
      },
      {
        address: "cosmoshub-mainnet.grpc.l0vd.com:80",
        provider: "L0vd.com ❤️"
      },
      {
        address: "https://grpc-cosmos.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "cosmos-grpc.stakeandrelax.net:15090",
        provider: "Stake&Relax 🦥"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/cosmos",
      tx_page: "https://www.mintscan.io/cosmos/transactions/${txHash}",
      account_page: "https://www.mintscan.io/cosmos/accounts/${accountAddress}",
      validator_page: "https://www.mintscan.io/cosmos/validators/${validatorAddress}",
      proposal_page: "https://www.mintscan.io/cosmos/proposals/${proposalId}",
      block_page: "https://www.mintscan.io/cosmos/blocks/${blockHeight}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/cosmoshub",
      tx_page: "https://ezstaking.app/cosmoshub/txs/${txHash}",
      account_page: "https://ezstaking.app/cosmoshub/account/${accountAddress}",
      validator_page: "https://ezstaking.app/cosmoshub/validators/${validatorAddress}",
      proposal_page: "https://ezstaking.app/cosmoshub/proposals/${proposalId}",
      block_page: "https://ezstaking.app/cosmoshub/blocks/${blockHeight}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/cosmos",
      tx_page: "https://ping.pub/cosmos/tx/${txHash}",
      account_page: "https://ping.pub/cosmos/account/${accountAddress}",
      validator_page: "https://ping.pub/cosmos/staking/${validatorAddress}",
      proposal_page: "https://ping.pub/cosmos/gov/${proposalId}",
      block_page: "https://ping.pub/cosmos/block/${blockHeight}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com",
      tx_page: "https://atomscan.com/transactions/${txHash}",
      account_page: "https://atomscan.com/accounts/${accountAddress}",
      validator_page: "https://atomscan.com/validators/${validatorAddress}",
      proposal_page: "https://atomscan.com/votes/${proposalId}",
      block_page: "https://atomscan.com/blocks/${blockHeight}"
    },
    {
      kind: "unichain",
      url: "https://unicha.in/cosmos",
      tx_page: "https://unicha.in/cosmos/transaction/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/cosmoshub",
      tx_page: "https://explorer.tcnetwork.io/cosmoshub/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/cosmoshub/account/${accountAddress}",
      validator_page: "https://explorer.tcnetwork.io/cosmoshub/validator/${validatorAddress}",
      proposal_page: "https://explorer.tcnetwork.io/cosmoshub/proposal/${proposalId}",
      block_page: "https://explorer.tcnetwork.io/cosmoshub/block/${blockHeight}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/cosmos",
      account_page: "https://stakeflow.io/cosmos/accounts/${accountAddress}",
      validator_page: "https://stakeflow.io/cosmos/validators/${validatorAddress}"
    },
    {
      kind: "Nodeist Explorer",
      url: "https://exp.nodeist.net/cosmos"
    },
    {
      kind: "Inbloc",
      url: "https://inbloc.org",
      tx_page: "https://inbloc.org/transactions/${txHash}",
      account_page: "https://inbloc.org/account/${accountAddress}",
      validator_page: "https://inbloc.org/cosmos/validator/${validatorAddress}",
      proposal_page: "https://inbloc.org/cosmos/proposal/${proposalId}",
      block_page: "https://inbloc.org/cosmos/blocks/${blockHeight}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/cosmos",
      tx_page: "https://mainnet.whispernode.com/cosmos/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/cosmos/account/${accountAddress}",
      validator_page: "https://mainnet.whispernode.com/cosmos/staking/${validatorAddress}",
      proposal_page: "https://mainnet.whispernode.com/cosmos/gov/${proposalId}",
      block_page: "https://mainnet.whispernode.com/cosmos/block/${blockHeight}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
    theme: {
      primary_color_hex: "#272d45"
    }
  }]
};
qg.default = _S;
var Sg = {};
Object.defineProperty(Sg, "__esModule", { value: !0 });
const yS = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1002",
      connection_id: "connection-701"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-457",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-6",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-927",
      connection_id: "connection-649"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-405",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aioz",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1121",
      connection_id: "connection-808"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-567",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-53",
      connection_id: "connection-29"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-385",
      connection_id: "connection-339"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-184",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1152",
      connection_id: "connection-873"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-623",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-24",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1158",
      connection_id: "connection-880"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-646",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-622",
      connection_id: "connection-481"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-293",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitcanna",
      client_id: "07-tendermint-4",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-490",
      connection_id: "connection-399"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-232",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitsong",
      client_id: "07-tendermint-1",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-481",
      connection_id: "connection-395"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-229",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bostrom",
      client_id: "07-tendermint-15",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-764",
      connection_id: "connection-553"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-341",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-6",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-765",
      connection_id: "connection-554"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-342",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cifer",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1301",
      connection_id: "connection-1035"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-831",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1150",
      connection_id: "connection-871"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-617",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-11",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1162",
      connection_id: "connection-884"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-660",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-724",
      connection_id: "connection-538"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-3",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-326",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-389",
      connection_id: "connection-342"
    },
    chain_2: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-735",
      connection_id: "connection-220"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-187",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1191",
      connection_id: "connection-920"
    },
    chain_2: {
      chain_name: "doravota",
      client_id: "07-tendermint-14",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-750",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1205",
      connection_id: "connection-933"
    },
    chain_2: {
      chain_name: "dymension",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-794",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-432",
      connection_id: "connection-365"
    },
    chain_2: {
      chain_name: "emoney",
      client_id: "07-tendermint-8",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-202",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1151",
      connection_id: "connection-872"
    },
    chain_2: {
      chain_name: "empowerchain",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-621",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-620",
      connection_id: "connection-480"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-292",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1141",
      connection_id: "connection-829"
    },
    chain_2: {
      chain_name: "fxcore",
      client_id: "07-tendermint-13",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-585",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1153",
      connection_id: "connection-874"
    },
    chain_2: {
      chain_name: "haqq",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-632",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-434",
      connection_id: "connection-368"
    },
    chain_2: {
      chain_name: "impacthub",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-204",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-470",
      connection_id: "connection-388"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-5",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-220",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-384",
      connection_id: "connection-338"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-31",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-182",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1307",
      connection_id: "connection-1041"
    },
    chain_2: {
      chain_name: "joltify",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-866",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-439",
      connection_id: "connection-372"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-207",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-557",
      connection_id: "connection-460"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-277",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-475",
      connection_id: "connection-392"
    },
    chain_2: {
      chain_name: "kichain",
      client_id: "07-tendermint-6",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-223",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-769",
      connection_id: "connection-555"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-343",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1318",
      connection_id: "connection-1050"
    },
    chain_2: {
      chain_name: "lava",
      client_id: "07-tendermint-7",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-969",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-468",
      connection_id: "connection-386"
    },
    chain_2: {
      chain_name: "likecoin",
      client_id: "07-tendermint-24",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-217",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1120",
      connection_id: "connection-807"
    },
    chain_2: {
      chain_name: "lumnetwork",
      client_id: "07-tendermint-21",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-566",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1119",
      connection_id: "connection-809"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-569",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1116",
      connection_id: "connection-790"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-4",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-536",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-656",
      connection_id: "connection-501"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-23",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-306",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-651",
      connection_id: "connection-497"
    },
    chain_2: {
      chain_name: "oraichain",
      client_id: "07-tendermint-47",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-301",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "oraidex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-259",
      connection_id: "connection-257"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-141",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-391",
      connection_id: "connection-344"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-36",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-190",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-994",
      connection_id: "connection-693"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-5",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-446",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-926",
      connection_id: "connection-648"
    },
    chain_2: {
      chain_name: "point",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-404",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1304",
      connection_id: "connection-1038"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-859",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-0",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-863",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-8",
          port_id: "icacontroller-reward-uatom"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-861",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-9",
          port_id: "icacontroller-sweep-uatom"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-891",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-20",
          port_id: "icacontroller-delegation-uatom"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1018",
      connection_id: "connection-709"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-467",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1157",
      connection_id: "connection-879"
    },
    chain_2: {
      chain_name: "realio",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-645",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-386",
      connection_id: "connection-340"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-27",
      connection_id: "connection-24"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-185",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-492",
      connection_id: "connection-401"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-235",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1140",
      connection_id: "connection-827"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-3",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-584",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1310",
      connection_id: "connection-1043"
    },
    chain_2: {
      chain_name: "self",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-892",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-388",
      connection_id: "connection-341"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-58",
      connection_id: "connection-33"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-186",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-395",
      connection_id: "connection-347"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-192",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-892",
      connection_id: "connection-618"
    },
    chain_2: {
      chain_name: "stafihub",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-369",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1188",
      connection_id: "connection-918"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-320",
      connection_id: "connection-256"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-730",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-239",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-326",
      connection_id: "connection-300"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-158",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-913",
      connection_id: "connection-635"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-391",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-962",
      connection_id: "connection-1710"
    },
    chain_2: {
      chain_name: "teritori",
      client_id: "07-tendermint-32",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-431",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-760",
      connection_id: "connection-551"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-0",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-339",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-611",
      connection_id: "connection-473"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-9",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-288",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1115",
      connection_id: "connection-788"
    },
    chain_2: {
      chain_name: "uptick",
      client_id: "07-tendermint-3",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-535",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  }
];
Sg.default = yS;
var Tg = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(dt, "__esModule", { value: !0 });
dt.ibc = dt.chain = dt.assets = void 0;
const bS = Tg(zg), vS = Tg(qg), fS = Tg(Sg);
dt.assets = bS.default;
dt.chain = vS.default;
dt.ibc = fS.default;
var nr = {}, Rg = {};
Object.defineProperty(Rg, "__esModule", { value: !0 });
const wS = {
  $schema: "../assetlist.schema.json",
  chain_name: "coss",
  assets: [
    {
      description: "The native staking and governance token of the COSS.",
      denom_units: [{
        denom: "ucgas",
        exponent: 0
      }, {
        denom: "cgas",
        exponent: 6
      }],
      base: "ucgas",
      name: "CGAS",
      display: "cgas",
      symbol: "CGAS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/cgas.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/cgas.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/cgas.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/cgas.svg",
        theme: {
          primary_color_hex: "#7c7c7c"
        }
      }]
    },
    {
      description: "The inscription token of the COSS.",
      denom_units: [{
        denom: "ucoss",
        exponent: 0
      }, {
        denom: "coss",
        exponent: 6
      }],
      base: "ucoss",
      name: "COSS",
      display: "coss",
      symbol: "COSS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/coss.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/coss.svg"
      },
      coingecko_id: "coss-2",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/coss.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/coss.svg",
        theme: {
          primary_color_hex: "#876317"
        }
      }]
    },
    {
      description: "The inscription token of the CIAS.",
      denom_units: [{
        denom: "ucias",
        exponent: 0
      }, {
        denom: "cias",
        exponent: 6
      }],
      base: "ucias",
      name: "CIAS",
      display: "cias",
      symbol: "CIAS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/cias.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/cias.svg"
      },
      coingecko_id: "cias",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/cias.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/cias.svg",
        theme: {
          primary_color_hex: "#4f3280"
        }
      }]
    }
  ]
};
Rg.default = wS;
var Og = {};
Object.defineProperty(Og, "__esModule", { value: !0 });
const xS = {
  $schema: "../chain.schema.json",
  chain_name: "coss",
  chain_type: "cosmos",
  chain_id: "coss-1",
  website: "https://coss.ink/",
  pretty_name: "COSS",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "coss",
  daemon_name: "cossd",
  node_home: "$HOME/.coss",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [
      {
        denom: "ucoss",
        fixed_min_gas_price: 0.025,
        low_gas_price: 0.025,
        average_gas_price: 0.03,
        high_gas_price: 0.04
      },
      {
        denom: "ucgas",
        fixed_min_gas_price: 0.025,
        low_gas_price: 0.025,
        average_gas_price: 0.03,
        high_gas_price: 0.04
      },
      {
        denom: "ucias",
        fixed_min_gas_price: 0.025,
        low_gas_price: 0.025,
        average_gas_price: 0.03,
        high_gas_price: 0.04
      }
    ]
  },
  staking: {
    staking_tokens: [{
      denom: "ucgas"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/coss.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/coss.svg"
  },
  apis: {
    rpc: [{
      address: "https://coss-rpc.coss.ink",
      provider: "StellarGuardian"
    }, {
      address: "https://coss-rpc.cias.network",
      provider: "CelestialPhoenix"
    }],
    rest: [{
      address: "https://coss-rest.coss.ink",
      provider: "StellarGuardian"
    }, {
      address: "https://coss-rest.cias.network",
      provider: "CelestialPhoenix"
    }]
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/coss.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coss/images/coss.svg",
    theme: {
      primary_color_hex: "#876317"
    }
  }]
};
Og.default = xS;
var E9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(nr, "__esModule", { value: !0 });
nr.chain = nr.assets = void 0;
const kS = E9(Rg), AS = E9(Og);
nr.assets = kS.default;
nr.chain = AS.default;
var mt = {}, Mg = {};
Object.defineProperty(Mg, "__esModule", { value: !0 });
const jS = {
  $schema: "../assetlist.schema.json",
  chain_name: "crescent",
  assets: [{
    description: "The native token of Crescent",
    denom_units: [{
      denom: "ucre",
      exponent: 0
    }, {
      denom: "cre",
      exponent: 6
    }],
    base: "ucre",
    name: "Crescent",
    display: "cre",
    symbol: "CRE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.svg"
    },
    coingecko_id: "crescent-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.svg",
      theme: {
        primary_color_hex: "#3c2832"
      }
    }]
  }, {
    description: "The bonded token of Crescent",
    denom_units: [{
      denom: "ubcre",
      exponent: 0
    }, {
      denom: "bcre",
      exponent: 6
    }],
    base: "ubcre",
    name: "Bonded Crescent",
    display: "bcre",
    symbol: "bCRE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/bcre.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/bcre.svg"
    },
    coingecko_id: "liquid-staking-crescent",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/bcre.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/bcre.svg",
      theme: {
        primary_color_hex: "#df969f"
      }
    }]
  }]
};
Mg.default = jS;
var Ig = {};
Object.defineProperty(Ig, "__esModule", { value: !0 });
const CS = {
  $schema: "../chain.schema.json",
  chain_name: "crescent",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Crescent",
  chain_type: "cosmos",
  chain_id: "crescent-1",
  bech32_prefix: "cre",
  daemon_name: "crescentd",
  node_home: "$HOME/.crescent",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ucre",
      fixed_min_gas_price: 0,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ucre"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://mainnet.crescent.network:26657",
        provider: "crescent"
      },
      {
        address: "https://crescent-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-crescent.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://crescent.rpc.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://crescent-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc-crescent.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://rpc-crescent-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://crescent-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://rpc.crescent.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    rest: [
      {
        address: "https://mainnet.crescent.network:1317",
        provider: "crescent"
      },
      {
        address: "https://api-crescent.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://crescent-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://crescent.rest.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://api-crescent.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://crescent-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://api-crescent-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://crescent-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://lcd.crescent.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    grpc: [
      {
        address: "crescent-grpc.polkachu.com:14590",
        provider: "Polkachu"
      },
      {
        address: "crescent.grpc.stakin-nodes.com:443",
        provider: "Stakin"
      },
      {
        address: "crescent-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-crescent.cosmos-spaces.cloud:2270",
        provider: "Cosmos Spaces"
      },
      {
        address: "grpc-crescent-01.stakeflow.io:1402",
        provider: "Stakeflow"
      },
      {
        address: "crescent-grpc.w3coins.io:14590",
        provider: "w3coins"
      },
      {
        address: "https://grpc.crescent.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/crescent",
      tx_page: "https://ezstaking.app/crescent/txs/${txHash}",
      account_page: "https://ezstaking.app/crescent/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/crescent",
      tx_page: "https://ping.pub/crescent/tx/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://crescent.explorers.guru",
      tx_page: "https://crescent.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/crescent",
      tx_page: "https://atomscan.com/crescent/transactions/${txHash}",
      account_page: "https://atomscan.com/crescent/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/crescent",
      account_page: "https://stakeflow.io/crescent/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.svg",
    theme: {
      primary_color_hex: "#3c2832"
    }
  }]
};
Ig.default = CS;
var Ng = {};
Object.defineProperty(Ng, "__esModule", { value: !0 });
const ES = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-19",
      connection_id: "connection-14"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-132",
      connection_id: "connection-107"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-80",
      connection_id: "connection-71"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-70",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-44",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-31",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-108",
      connection_id: "connection-54"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-32",
      connection_id: "connection-33"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-46",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-112",
      connection_id: "connection-98"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-724",
      connection_id: "connection-538"
    },
    chain_2: {
      chain_name: "crescent",
      client_id: "07-tendermint-3",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-326",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-77",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-1153",
      connection_id: "connection-277"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-40",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-12",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-38",
      connection_id: "connection-15"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-4",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-100",
      connection_id: "connection-102"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-26",
      connection_id: "connection-29"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-132",
      connection_id: "connection-105"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-90",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-67",
      connection_id: "connection-61"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-86",
      connection_id: "connection-70"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-111",
      connection_id: "connection-97"
    },
    chain_2: {
      chain_name: "jackal",
      client_id: "07-tendermint-56",
      connection_id: "connection-46"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-5",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-160",
      connection_id: "connection-107"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-81",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-78",
      connection_id: "connection-68"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-105",
      connection_id: "connection-75"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-67",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-53",
      connection_id: "connection-52"
    },
    chain_2: {
      chain_name: "mars",
      client_id: "07-tendermint-14",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-35",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-68",
      connection_id: "connection-63"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-44",
      connection_id: "connection-46"
    },
    chain_2: {
      chain_name: "okexchain",
      client_id: "07-tendermint-116",
      connection_id: "connection-78"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-31",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-17",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2083",
      connection_id: "connection-1624"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-297",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-42",
      connection_id: "connection-41"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-88",
      connection_id: "connection-72"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-68",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-18",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-53",
      connection_id: "connection-31"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent",
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-24",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-180",
      connection_id: "connection-114"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-38",
      connection_id: "connection-39"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-44",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-101",
      connection_id: "connection-70"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-36",
      connection_id: "connection-37"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-68",
      connection_id: "connection-57"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-56",
      connection_id: "connection-53"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-170",
      connection_id: "connection-110"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  }
];
Ng.default = ES;
var Pg = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(mt, "__esModule", { value: !0 });
mt.ibc = mt.chain = mt.assets = void 0;
const DS = Pg(Mg), BS = Pg(Ig), FS = Pg(Ng);
mt.assets = DS.default;
mt.chain = BS.default;
mt.ibc = FS.default;
var ht = {}, Ug = {};
Object.defineProperty(Ug, "__esModule", { value: !0 });
const $S = {
  $schema: "../assetlist.schema.json",
  chain_name: "cronos",
  assets: [{
    description: "Cronos is a blockchain platform developed by Crypto.com, designed to support DeFi, NFTs, and decentralized applications with fast and low-cost transactions.",
    extended_description: "Cronos is a blockchain platform developed by Crypto.com to facilitate the creation and operation of decentralized applications (dApps), decentralized finance (DeFi) protocols, and non-fungible tokens (NFTs). By utilizing the Tendermint consensus engine and the Cosmos SDK, Cronos offers fast and low-cost transactions while ensuring high security and scalability. The platform is EVM-compatible, allowing developers to easily port their Ethereum-based dApps to Cronos. The native token, CRO, is used for transaction fees, staking, and governance, providing incentives for users to contribute to the network's security and participate in its governance. Cronos aims to accelerate the adoption of DeFi and NFTs by providing a robust and efficient blockchain infrastructure.",
    denom_units: [{
      denom: "basecro",
      exponent: 0
    }, {
      denom: "cro",
      exponent: 18
    }],
    base: "basecro",
    name: "Cronos",
    display: "cro",
    symbol: "CRO",
    traces: [{
      type: "additional-mintage",
      counterparty: {
        chain_name: "cryptoorgchain",
        base_denom: "basecro"
      },
      provider: "Cronos"
    }],
    images: [{
      image_sync: {
        chain_name: "cryptoorgchain",
        base_denom: "basecro"
      },
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg"
    }],
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg"
    }
  }, {
    description: "Tether USDt on Cronos",
    denom_units: [{
      denom: "ibc/9106F2626880DF7FAD30621F355423B2A7523D8E2274475F009644D708A90682",
      exponent: 0
    }, {
      denom: "usdt",
      exponent: 6
    }],
    type_asset: "ics20",
    base: "ibc/9106F2626880DF7FAD30621F355423B2A7523D8E2274475F009644D708A90682",
    name: "Tether USDt",
    display: "usdt",
    symbol: "USDt",
    traces: [{
      type: "ibc",
      counterparty: {
        chain_name: "kava",
        base_denom: "erc20/tether/usdt",
        channel_id: "channel-125"
      },
      chain: {
        channel_id: "channel-11",
        path: "transfer/channel-11/erc20/tether/usdt"
      }
    }],
    images: [{
      image_sync: {
        chain_name: "kava",
        base_denom: "erc20/tether/usdt"
      },
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
      theme: {
        circle: !0,
        primary_color_hex: "#009393",
        background_color_hex: "#009393"
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
    }
  }]
};
Ug.default = $S;
var Hg = {};
Object.defineProperty(Hg, "__esModule", { value: !0 });
const zS = {
  $schema: "../chain.schema.json",
  chain_name: "cronos",
  status: "live",
  network_type: "mainnet",
  website: "https://cronos.org",
  pretty_name: "Cronos",
  chain_type: "cosmos",
  chain_id: "cronosmainnet_25-1",
  bech32_prefix: "crc",
  daemon_name: "cronosd",
  node_home: "$HOME/.cronos",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "basecro"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cronos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.cronos.org/",
        provider: "cronos.org"
      },
      {
        address: "https://cronos-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://cronos.drpc.org",
        provider: "dRPC"
      }
    ],
    rest: [{
      address: "https://rest.cronos.org/",
      provider: "cronos.org"
    }, {
      address: "https://cronos-rest.publicnode.com",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }],
    grpc: [{
      address: "grpc.cronos.org:443",
      provider: "cronos.org"
    }, {
      address: "cronos-grpc.publicnode.com:443",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }],
    "evm-http-jsonrpc": [{
      address: "https://evm.cronos.org/",
      provider: "cronos.org"
    }, {
      address: "https://cronos-evm.publicnode.com",
      provider: "Allnodes.com ⚡️ Nodes & Staking"
    }]
  },
  explorers: [
    {
      kind: "cronoscan",
      url: "https://cronoscan.com",
      tx_page: "https://cronoscan.com/tx/${txHash}"
    },
    {
      kind: "crypto.org",
      url: "https://cronos.org/explorer",
      tx_page: "https://cronos.org/explorer/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/cronos",
      tx_page: "https://ping.pub/cronos/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cronos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg",
    theme: {
      primary_color_hex: "#0c2c71"
    }
  }]
};
Hg.default = zS;
var Lg = {};
Object.defineProperty(Lg, "__esModule", { value: !0 });
const qS = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cronos",
    client_id: "07-tendermint-33",
    connection_id: "connection-17"
  },
  chain_2: {
    chain_name: "kava",
    client_id: "07-tendermint-134",
    connection_id: "connection-169"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-11",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-125",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
Lg.default = qS;
var Wg = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ht, "__esModule", { value: !0 });
ht.ibc = ht.chain = ht.assets = void 0;
const SS = Wg(Ug), TS = Wg(Hg), RS = Wg(Lg);
ht.assets = SS.default;
ht.chain = TS.default;
ht.ibc = RS.default;
var pt = {}, Vg = {};
Object.defineProperty(Vg, "__esModule", { value: !0 });
const OS = {
  $schema: "../assetlist.schema.json",
  chain_name: "cryptoorgchain",
  assets: [
    {
      description: "CRO is the native token of the Crypto.org Chain, referred to as Native CRO.",
      denom_units: [{
        denom: "basecro",
        exponent: 0
      }, {
        denom: "cro",
        exponent: 8
      }],
      base: "basecro",
      name: "Cronos",
      display: "cro",
      symbol: "CRO",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg"
      },
      coingecko_id: "crypto-com-chain",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg"
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cronos.png",
        theme: {
          primary_color_hex: "#0c2c71"
        }
      }],
      socials: {
        website: "https://cronos.org/",
        twitter: "https://twitter.com/cronos_chain"
      }
    },
    {
      description: "Synthetic XLM pegged 1:1 by Crypto.com",
      denom_units: [{
        denom: "baseXLM",
        exponent: 0,
        aliases: ["stroop"]
      }, {
        denom: "lumen",
        exponent: 7
      }],
      base: "baseXLM",
      name: "Lumen (XLM) pegged token",
      display: "lumen",
      symbol: "XLM",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "stellar",
          base_denom: "stroop"
        },
        provider: "Crypto.com"
      }],
      images: [{
        image_sync: {
          chain_name: "stellar",
          base_denom: "stroop"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/stellar/images/xlm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/stellar/images/xlm.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/stellar/images/xlm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/stellar/images/xlm.svg"
      }
    },
    {
      description: "The native token of Stellar network, transferred via Solo Machine.",
      denom_units: [{
        denom: "ibc/34A1D4BF5FFCDB912F64FE71D54426D56970F873F1279983B69C713B3A62D10D",
        exponent: 0,
        aliases: ["stroop"]
      }, {
        denom: "lumen",
        exponent: 7
      }],
      base: "ibc/34A1D4BF5FFCDB912F64FE71D54426D56970F873F1279983B69C713B3A62D10D",
      name: "Lumen (Solo Machine)",
      display: "lumen",
      symbol: "XLM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cryptoorgchain",
          base_denom: "baseXLM",
          channel_id: "channel-JEnb"
        },
        chain: {
          channel_id: "channel-46",
          path: "transfer/channel-46/baseXLM"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "stellar",
          base_denom: "stroop"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/stellar/images/xlm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/stellar/images/xlm.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/stellar/images/xlm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/stellar/images/xlm.svg"
      }
    }
  ]
};
Vg.default = OS;
var Gg = {};
Object.defineProperty(Gg, "__esModule", { value: !0 });
const MS = {
  $schema: "../chain.schema.json",
  chain_name: "cryptoorgchain",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Cronos POS Chain",
  chain_type: "cosmos",
  chain_id: "crypto-org-chain-mainnet-1",
  bech32_prefix: "cro",
  website: "https://cronos-pos.org/",
  daemon_name: "chain-maind",
  node_home: "$HOME/.chain-maind",
  slip44: 394,
  alternative_slip44s: [118],
  fees: {
    fee_tokens: [{
      denom: "basecro",
      low_gas_price: 0.025,
      average_gas_price: 0.03,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "basecro"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cryptoorgchain/images/cronos.png"
  },
  description: "Cronos PoS Chain is a public, open-source and permissionless blockchain - a fully decentralized network with high speed and low fees, designed to be a public good that helps drive mass adoption of blockchain technology through use cases like Payments, DeFi and NFTs.",
  apis: {
    rpc: [
      {
        address: "https://rpc.mainnet.crypto.org/",
        provider: "cronos.org"
      },
      {
        address: "https://rpc-cryptoorgchain-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc-cryptoorgchain.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://cryptocom-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://cryptocom-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://rpc-cryptoorg.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://cro-chain-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://rest.mainnet.crypto.org/",
        provider: "cronos.org"
      },
      {
        address: "https://api-cryptoorgchain-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://cryptocom-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rest-cryptoorgchain.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://cryptocom-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://api-cryptoorg.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://cro-chain-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "grpc.mainnet.crypto.org:443",
        provider: "cronos.org"
      },
      {
        address: "grpc-cryptoorgchain-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "cryptocom-grpc.polkachu.com:20290",
        provider: "Polkachu"
      },
      {
        address: "cryptocom-grpc.w3coins.io:20290",
        provider: "w3coins"
      },
      {
        address: "grpc-cryptoorg.cosmos-spaces.cloud:1160",
        provider: "Cosmos Spaces"
      },
      {
        address: "cro-chain-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/crypto-org",
      tx_page: "https://www.mintscan.io/crypto-org/transactions/${txHash}",
      account_page: "https://www.mintscan.io/crypto-org/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/crypto-org",
      tx_page: "https://ezstaking.app/crypto-org/txs/${txHash}",
      account_page: "https://ezstaking.app/crypto-org/account/${accountAddress}"
    },
    {
      kind: "cronos.org",
      url: "https://cronos-pos.org/explorer",
      tx_page: "https://cronos-pos.org/explorer/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/crypto-com-chain",
      tx_page: "https://ping.pub/crypto-com-chain/tx/${txHash}"
    }
  ],
  images: [
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cryptoorgchain/images/cronos.png",
      theme: {
        primary_color_hex: "#0c2c71"
      }
    },
    {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cryptoorgchain/images/Cronos_POS_Chain_Colour.svg"
    },
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cronos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg",
      theme: {
        primary_color_hex: "#0c2c71"
      }
    }
  ]
};
Gg.default = MS;
var Kg = {};
Object.defineProperty(Kg, "__esModule", { value: !0 });
const IS = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-48",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-65",
      connection_id: "connection-38"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-389",
      connection_id: "connection-342"
    },
    chain_2: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-735",
      connection_id: "connection-220"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-187",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-77",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-1153",
      connection_id: "connection-277"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-40",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-1136",
      connection_id: "connection-260"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-85",
      connection_id: "connection-43"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-31",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-650",
      connection_id: "connection-197"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-32",
      connection_id: "connection-23"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-33",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-4",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-61",
      connection_id: "connection-34"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-24",
      connection_id: "connection-17"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-732",
      connection_id: "connection-218"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-28",
      connection_id: "connection-26"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-63",
      connection_id: "connection-36"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-43",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-1103",
      connection_id: "connection-239"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-20",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-66",
      connection_id: "connection-39"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-16",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  }
];
Kg.default = IS;
var Xg = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(pt, "__esModule", { value: !0 });
pt.ibc = pt.chain = pt.assets = void 0;
const NS = Xg(Vg), PS = Xg(Gg), US = Xg(Kg);
pt.assets = NS.default;
pt.chain = PS.default;
pt.ibc = US.default;
var lt = {}, Yg = {};
Object.defineProperty(Yg, "__esModule", { value: !0 });
const HS = {
  $schema: "../assetlist.schema.json",
  chain_name: "cudos",
  assets: [{
    description: "The native token of the Cudos blockchain",
    denom_units: [{
      denom: "acudos",
      exponent: 0,
      aliases: ["attocudos"]
    }, {
      denom: "cudos",
      exponent: 18
    }],
    base: "acudos",
    name: "Cudos",
    display: "cudos",
    symbol: "CUDOS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.svg"
    },
    coingecko_id: "cudos",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.svg",
      theme: {
        primary_color_hex: "#5d95ec"
      }
    }],
    socials: {
      website: "http://www.cudos.org",
      twitter: "https://twitter.com/CUDOS_"
    }
  }]
};
Yg.default = HS;
var Jg = {};
Object.defineProperty(Jg, "__esModule", { value: !0 });
const LS = {
  $schema: "../chain.schema.json",
  chain_name: "cudos",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Cudos",
  chain_type: "cosmos",
  chain_id: "cudos-1",
  bech32_prefix: "cudos",
  daemon_name: "cudos-noded",
  website: "https://www.cudos.org/",
  node_home: "$HOME/cudos-data",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "acudos",
      low_gas_price: 5e12,
      average_gas_price: 1e13,
      high_gas_price: 2e13
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "acudos"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.svg"
  },
  apis: {
    rpc: [
      {
        address: "http://mainnet-full-node-01.hosts.cudos.org:26657",
        provider: "cudo"
      },
      {
        address: "https://mainnet-full-node-02.hosts.cudos.org:36657",
        provider: "cudo"
      },
      {
        address: "https://cudos-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://cudos-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc.lavenderfive.com:443/cudos",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://cudos-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "http://mainnet-full-node-01.hosts.cudos.org:1317",
        provider: "cudo"
      },
      {
        address: "https://mainnet-full-node-02.hosts.cudos.org:31317",
        provider: "cudo"
      },
      {
        address: "https://cudos-api.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://cudos-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest.lavenderfive.com:443/cudos",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://cudos-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "mainnet-full-node-01.hosts.cudos.org:9090",
        provider: "cudo"
      },
      {
        address: "cudos-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "cudos.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "cudos-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "bigdipper",
      url: "https://explorer.cudos.org/",
      tx_page: "https://explorer.cudos.org/transactions/${txHash}",
      account_page: "https://explorer.cudos.org/accounts/${accountAddress}"
    },
    {
      kind: "cudos-dashboard",
      url: "https://dashboard.cudos.org/",
      tx_page: "https://explorer.cudos.org/transactions/${txHash}",
      account_page: "https://explorer.cudos.org/accounts/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/cudos",
      tx_page: "https://www.mintscan.io/cudos/transactions/${txHash}",
      account_page: "https://www.mintscan.io/cudos/accounts/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/cudos",
      tx_page: "https://atomscan.com/cudos/transactions/${txHash}",
      account_page: "https://atomscan.com/cudos/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/cudos",
      tx_page: "https://ezstaking.app/cudos/txs/${txHash}",
      account_page: "https://ezstaking.app/cudos/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.svg",
    theme: {
      primary_color_hex: "#5d95ec"
    }
  }]
};
Jg.default = LS;
var Zg = {};
Object.defineProperty(Zg, "__esModule", { value: !0 });
const WS = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cudos",
    client_id: "07-tendermint-2084",
    connection_id: "connection-1626"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-298",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Zg.default = WS;
var Qg = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(lt, "__esModule", { value: !0 });
lt.ibc = lt.chain = lt.assets = void 0;
const VS = Qg(Yg), GS = Qg(Jg), KS = Qg(Zg);
lt.assets = VS.default;
lt.chain = GS.default;
lt.ibc = KS.default;
var gt = {}, eu = {};
Object.defineProperty(eu, "__esModule", { value: !0 });
const XS = {
  $schema: "../assetlist.schema.json",
  chain_name: "decentr",
  assets: [{
    description: "The native token of Decentr",
    denom_units: [{
      denom: "udec",
      exponent: 0
    }, {
      denom: "dec",
      exponent: 6
    }],
    base: "udec",
    name: "Decentr",
    display: "dec",
    symbol: "DEC",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.svg"
    },
    coingecko_id: "decentr",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.svg",
      theme: {
        primary_color_hex: "#4678e9"
      }
    }]
  }]
};
eu.default = XS;
var nu = {};
Object.defineProperty(nu, "__esModule", { value: !0 });
const YS = {
  $schema: "../chain.schema.json",
  chain_name: "decentr",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Decentr",
  chain_type: "cosmos",
  chain_id: "mainnet-3",
  bech32_prefix: "decentr",
  daemon_name: "decentrd",
  node_home: "$HOME/.decentr",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "udec",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.025
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "udec"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://poseidon.mainnet.decentr.xyz",
        provider: "decentr"
      },
      {
        address: "https://rpc.decentr.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://decentr.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://decentr-rpc.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rpc-dcntr.nodine.id/",
        provider: "Nodine.ID"
      },
      {
        address: "https://rpc-decentr.mms.team/",
        provider: "MMS"
      }
    ],
    rest: [
      {
        address: "https://rest.mainnet.decentr.xyz",
        provider: "decentr"
      },
      {
        address: "https://decentr.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.decentr.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://decentr-api.ibs.team/",
        provider: "Inter Blockchain Services"
      }
    ],
    grpc: [
      {
        address: "https://grpc-decentr.sxlzptprjkt.xyz:443",
        provider: "sxlzptprjkt | VALIDATOR"
      },
      {
        address: "decentr.grpc.m.stavr.tech:2060",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://grpc.decentr.hexnodes.co",
        provider: "Hexnodes"
      },
      {
        address: "https://grpc.decentr.nodexcapital.com:443",
        provider: "NodeX Validator"
      },
      {
        address: "grpc-decentr.mms.team:443",
        provider: "MMS"
      }
    ]
  },
  explorers: [
    {
      kind: "decentr.net",
      url: "https://explorer.decentr.net",
      tx_page: "https://explorer.decentr.net/transactions/${txHash}?networkId=mainnet"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/decentr/",
      tx_page: "https://ping.pub/decentr/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Decentr-Mainnet",
      tx_page: "https://explorer.stavr.tech/Decentr-Mainnet/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/decentr",
      tx_page: "https://atomscan.com/decentr/transactions/${txHash}",
      account_page: "https://atomscan.com/decentr/accounts/${accountAddress}"
    },
    {
      kind: "Nodine.ID",
      url: "https://explorer.co.id/decentr",
      tx_page: "https://explorer.co.id/decentr/tx/${txHash}"
    },
    {
      kind: "THE EXPLORER",
      url: "https://explorer.sxlzptprjkt.xyz/decentr",
      tx_page: "https://explorer.sxlzptprjkt.xyz/decentr/tx/${txHash}"
    },
    {
      kind: "hexskrt EXPLORER",
      url: "https://explorer.hexskrt.net/decentr",
      tx_page: "https://explorer.hexskrt.net/decentr/tx/${txHash}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodexcapital.com/decentr",
      tx_page: "https://explorer.nodexcapital.com/decentr/tx/${txHash}"
    },
    {
      kind: "Explorer ComunityNode",
      url: "https://explorer.comunitynode.my.id/decentr",
      tx_page: "https://explorer.comunitynode.my.id/decentr/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.svg",
    theme: {
      primary_color_hex: "#4678e9"
    }
  }]
};
nu.default = YS;
var tu = {};
Object.defineProperty(tu, "__esModule", { value: !0 });
const JS = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-38",
      connection_id: "connection-41"
    },
    chain_2: {
      chain_name: "decentr",
      client_id: "07-tendermint-21",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "decentr",
      client_id: "07-tendermint-6",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1798",
      connection_id: "connection-1403"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-181",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "decentr",
      client_id: "07-tendermint-13",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-103",
      connection_id: "connection-81"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-55",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "decentr",
      client_id: "07-tendermint-26",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-395",
      connection_id: "connection-385"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-315",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
tu.default = JS;
var su = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(gt, "__esModule", { value: !0 });
gt.ibc = gt.chain = gt.assets = void 0;
const ZS = su(eu), QS = su(nu), eT = su(tu);
gt.assets = ZS.default;
gt.chain = QS.default;
gt.ibc = eT.default;
var ut = {}, au = {};
Object.defineProperty(au, "__esModule", { value: !0 });
const nT = {
  $schema: "../assetlist.schema.json",
  chain_name: "desmos",
  assets: [{
    description: "The native token of Desmos",
    denom_units: [{
      denom: "udsm",
      exponent: 0
    }, {
      denom: "dsm",
      exponent: 6
    }],
    base: "udsm",
    name: "Desmos",
    display: "dsm",
    symbol: "DSM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.svg"
    },
    coingecko_id: "desmos",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.svg",
      theme: {
        primary_color_hex: "#fb804e"
      }
    }]
  }]
};
au.default = nT;
var ou = {};
Object.defineProperty(ou, "__esModule", { value: !0 });
const tT = {
  $schema: "../chain.schema.json",
  chain_name: "desmos",
  status: "live",
  network_type: "mainnet",
  website: "https://desmos.network/",
  pretty_name: "Desmos",
  chain_type: "cosmos",
  chain_id: "desmos-mainnet",
  bech32_prefix: "desmos",
  daemon_name: "desmos",
  node_home: "$HOME/.desmos",
  key_algos: ["secp256k1"],
  slip44: 852,
  fees: {
    fee_tokens: [{
      denom: "udsm",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 0.01,
      average_gas_price: 0.03,
      high_gas_price: 0.05
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "udsm"
    }]
  },
  codebase: {
    cosmos_sdk_version: "desmos-labs/cosmos-sdk v0.47.10-desmos",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.45.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.mainnet.desmos.network",
        provider: "desmos"
      },
      {
        address: "https://desmos-rpc.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://desmos-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://rpc.desmos.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://rpc.desmos.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://desmos.declab.pro:26613",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://desmos-rpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [
      {
        address: "https://api.mainnet.desmos.network",
        provider: "desmos"
      },
      {
        address: "https://desmos-api.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://desmos-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://rest.desmos.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://lcd.desmos.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://vidulum.declab.pro:443",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://desmos-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "https://grpc-desmos.explorer.co.id",
        provider: "Nodine.ID"
      },
      {
        address: "services.staketab.com:9043",
        provider: "Staketab"
      },
      {
        address: "desmos.grpc.nodersteam.com:9121",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://grpc-desmos.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://grpc.desmos.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://vidulum.declab.pro:9009",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "desmos-grpc.noders.services:27090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/desmos",
      tx_page: "https://ezstaking.app/desmos/txs/${txHash}",
      account_page: "https://ezstaking.app/desmos/account/${accountAddress}"
    },
    {
      kind: "bigdipper",
      url: "https://bigdipper.live/desmos",
      tx_page: "https://bigdipper.live/desmos/transactions/${txHash}",
      account_page: "https://bigdipper.live/desmos/accounts/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/desmos",
      tx_page: "https://www.mintscan.io/desmos/transactions/${txHash}",
      account_page: "https://www.mintscan.io/desmos/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/desmos",
      tx_page: "https://ping.pub/desmos/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/desmos",
      tx_page: "https://atomscan.com/desmos/transactions/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/desmos",
      tx_page: "https://explorer.tcnetwork.io/desmos/transaction/${txHash}"
    },
    {
      kind: "Decloud Nodes Lab",
      url: "https://explorer.declab.pro/Desmos",
      tx_page: "https://explorer.declab.pro/Desmos/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.svg",
    theme: {
      primary_color_hex: "#fb804e"
    }
  }]
};
ou.default = tT;
var ru = {};
Object.defineProperty(ru, "__esModule", { value: !0 });
const sT = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "desmos",
    client_id: "07-tendermint-6",
    connection_id: "connection-4"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1726",
    connection_id: "connection-1315"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-135",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
ru.default = sT;
var iu = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ut, "__esModule", { value: !0 });
ut.ibc = ut.chain = ut.assets = void 0;
const aT = iu(au), oT = iu(ou), rT = iu(ru);
ut.assets = aT.default;
ut.chain = oT.default;
ut.ibc = rT.default;
var _t = {}, cu = {};
Object.defineProperty(cu, "__esModule", { value: !0 });
const iT = {
  $schema: "../assetlist.schema.json",
  chain_name: "dhealth",
  assets: [{
    description: "The native token of dHealth",
    extended_description: "dHealth Network is an Operating System for Web3 Healthcare. It provides Web3 components such as Decentralised Digital Identity, Digital Payment, and user-controlled data access to support dApps and business models at the intersection of healthcare and blockchain technology.",
    denom_units: [{
      denom: "udhp",
      exponent: 0
    }, {
      denom: "dhp",
      exponent: 6
    }],
    base: "udhp",
    name: "Digital Health Point",
    display: "dhp",
    symbol: "DHP",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.svg"
    },
    coingecko_id: "dhealth",
    socials: {
      website: "https://dhealth.com",
      twitter: "https://twitter.com/dhealth_network"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.svg",
      theme: {
        primary_color_hex: "#140c7c"
      }
    }]
  }]
};
cu.default = iT;
var du = {};
Object.defineProperty(du, "__esModule", { value: !0 });
const cT = {
  $schema: "../chain.schema.json",
  chain_name: "dhealth",
  status: "live",
  network_type: "mainnet",
  website: "https://dhealth.com/",
  pretty_name: "dHealth",
  chain_type: "cosmos",
  chain_id: "dhealth",
  bech32_prefix: "dh",
  daemon_name: "dhealthd",
  node_home: "$HOME/.dhealth",
  key_algos: ["secp256k1"],
  slip44: 10111,
  fees: {
    fee_tokens: [{
      denom: "udhp",
      fixed_min_gas_price: 0.01,
      low_gas_price: 0.025,
      average_gas_price: 0.03,
      high_gas_price: 0.035
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "udhp"
    }]
  },
  codebase: {
    cosmos_sdk_version: "cosmos/cosmos-sdk v0.47.4",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.41.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.dhealth.com",
        provider: "dhealth"
      },
      {
        address: "https://rpc.dhealth.nodestake.org",
        provider: "NodeStake"
      },
      {
        address: "https://dhealth.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️"
      }
    ],
    rest: [
      {
        address: "https://lcd.dhealth.com",
        provider: "dhealth"
      },
      {
        address: "https://api.dhealth.nodestake.org",
        provider: "NodeStake"
      },
      {
        address: "https://dhealth.api.nodeshub.online",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️"
      }
    ],
    grpc: [
      {
        address: "https://grpc.dhealth.com:443",
        provider: "dhealth"
      },
      {
        address: "https://grpc.dhealth.nodestake.org:443",
        provider: "NodeStake"
      },
      {
        address: "dhealth.grpc.nodeshub.online",
        provider: "Nodes Hub"
      }
    ]
  },
  explorers: [{
    kind: "nodestake",
    url: "https://explorer.nodestake.org/dhealth",
    tx_page: "https://explorer.nodestake.org/dhealth/tx/${txHash}",
    account_page: "https://explorer.nodestake.org/dhealth/account/${accountAddress}"
  }, {
    kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️",
    url: "https://explorer.nodeshub.online/dhealth/",
    tx_page: "https://explorer.nodeshub.online/dhealth/tx/${txHash}",
    account_page: "https://explorer.nodeshub.online/dhealth/accounts/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.svg",
    theme: {
      primary_color_hex: "#140c7c"
    }
  }]
};
du.default = cT;
var mu = {};
Object.defineProperty(mu, "__esModule", { value: !0 });
const dT = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "dhealth",
    client_id: "07-tendermint-4",
    connection_id: "connection-9"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3205",
    connection_id: "connection-2662"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-4",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-75030",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
mu.default = dT;
var hu = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(_t, "__esModule", { value: !0 });
_t.ibc = _t.chain = _t.assets = void 0;
const mT = hu(cu), hT = hu(du), pT = hu(mu);
_t.assets = mT.default;
_t.chain = hT.default;
_t.ibc = pT.default;
var yt = {}, pu = {};
Object.defineProperty(pu, "__esModule", { value: !0 });
const lT = {
  $schema: "../assetlist.schema.json",
  chain_name: "dig",
  assets: [{
    description: "Native token of Dig Chain",
    denom_units: [{
      denom: "udig",
      exponent: 0
    }, {
      denom: "dig",
      exponent: 6
    }],
    base: "udig",
    name: "Dig Chain",
    display: "dig",
    symbol: "DIG",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dig/images/dig.png"
    },
    coingecko_id: "dig-chain",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dig/images/dig.png",
      theme: {
        primary_color_hex: "#1b1433"
      }
    }]
  }]
};
pu.default = lT;
var lu = {};
Object.defineProperty(lu, "__esModule", { value: !0 });
const gT = {
  $schema: "../chain.schema.json",
  chain_name: "dig",
  status: "live",
  network_type: "mainnet",
  website: "https://digchain.org/",
  pretty_name: "Dig Chain",
  chain_type: "cosmos",
  chain_id: "dig-1",
  bech32_prefix: "dig",
  daemon_name: "digd",
  node_home: "$HOME/.dig",
  key_algos: ["secp256k1", "ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "udig",
      low_gas_price: 0.025,
      average_gas_price: 0.03,
      high_gas_price: 0.035
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "udig"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dig/images/dig.png"
  },
  apis: {
    rpc: [{
      address: "https://rpc-1-dig.notional.ventures"
    }, {
      address: "https://rpc-dig-ia.cosmosia.notional.ventures/",
      provider: "Notional"
    }],
    rest: [{
      address: "https://api-1-dig.notional.ventures"
    }, {
      address: "https://api-dig-ia.cosmosia.notional.ventures/",
      provider: "Notional"
    }],
    grpc: [{
      address: "grpc-dig-ia.cosmosia.notional.ventures:443",
      provider: "Notional"
    }]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/dig",
      tx_page: "https://ping.pub/dig/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/dig",
      tx_page: "https://atomscan.com/dig/transactions/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/dig",
      tx_page: "https://explorer.tcnetwork.io/dig/transaction/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dig/images/dig.png",
    theme: {
      primary_color_hex: "#1b1433"
    }
  }]
};
lu.default = gT;
var gu = {};
Object.defineProperty(gu, "__esModule", { value: !0 });
const uT = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "dig",
    client_id: "07-tendermint-17",
    connection_id: "connection-10"
  },
  chain_2: {
    chain_name: "juno",
    client_id: "07-tendermint-100",
    connection_id: "connection-62"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-37",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "dig",
    client_id: "07-tendermint-13",
    connection_id: "connection-8"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1714",
    connection_id: "connection-1304"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-128",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
gu.default = uT;
var uu = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(yt, "__esModule", { value: !0 });
yt.ibc = yt.chain = yt.assets = void 0;
const _T = uu(pu), yT = uu(lu), bT = uu(gu);
yt.assets = _T.default;
yt.chain = yT.default;
yt.ibc = bT.default;
var bt = {}, _u = {};
Object.defineProperty(_u, "__esModule", { value: !0 });
const vT = {
  $schema: "../assetlist.schema.json",
  chain_name: "doravota",
  assets: [{
    description: "The native staking and governance token of the Theta testnet version of the Dora Vota.",
    denom_units: [{
      denom: "peaka",
      exponent: 0
    }, {
      denom: "DORA",
      exponent: 18
    }],
    base: "peaka",
    name: "Dora Vota",
    display: "DORA",
    symbol: "DORA",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/doravota/images/dora.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/doravota/images/dora.svg"
    }, {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/doravota/images/doravota.png",
      theme: {
        primary_color_hex: "#fba214"
      }
    }]
  }]
};
_u.default = vT;
var yu = {};
Object.defineProperty(yu, "__esModule", { value: !0 });
const fT = {
  $schema: "../chain.schema.json",
  chain_name: "doravota",
  chain_type: "cosmos",
  chain_id: "vota-ash",
  pretty_name: "Dora Vota",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "dora",
  daemon_name: "dorad",
  node_home: "$HOME/.dora",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "peaka",
      fixed_min_gas_price: 1e11,
      low_gas_price: 1e11,
      average_gas_price: 1e11,
      high_gas_price: 1e11
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "peaka"
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://vota-rpc.dorafactory.org/",
        provider: "dorafactory"
      },
      {
        address: "https://m-dora.rpc.utsa.tech",
        provider: "lesnik | UTSA"
      },
      {
        address: "https://dora-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://vota-rest.dorafactory.org",
        provider: "dorafactory"
      },
      {
        address: "https://m-dora.api.utsa.tech",
        provider: "lesnik | UTSA"
      },
      {
        address: "https://dora-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [{
      address: "vota-grpc.dorafactory.org:443",
      provider: "dorafactory"
    }, {
      address: "dora-grpc.publicnode.com:443",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }]
  },
  explorers: [{
    kind: "Dora Vota Ping Pub",
    url: "https://vota-explorer.dorafactory.org",
    tx_page: "https://vota-explorer.dorafactory.org/doravota/tx/${txHash}"
  }, {
    kind: "lesnik | UTSA Ping Pub",
    url: "https://exp.utsa.tech/dora/staking",
    tx_page: "https://exp.utsa.tech/dora/tx/${txHash}"
  }]
};
yu.default = fT;
var bu = {};
Object.defineProperty(bu, "__esModule", { value: !0 });
const wT = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-183",
      connection_id: "connection-171"
    },
    chain_2: {
      chain_name: "doravota",
      client_id: "07-tendermint-17",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-125",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-113",
      connection_id: "connection-106"
    },
    chain_2: {
      chain_name: "doravota",
      client_id: "07-tendermint-22",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-146",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-12",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "doravota",
      client_id: "07-tendermint-12",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1191",
      connection_id: "connection-920"
    },
    chain_2: {
      chain_name: "doravota",
      client_id: "07-tendermint-14",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-750",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-16",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "dydx",
      client_id: "07-tendermint-15",
      connection_id: "connection-21"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-15",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-245",
      connection_id: "connection-239"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-182",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-23",
      connection_id: "connection-29"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-111",
      connection_id: "connection-106"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-94",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-13",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "nolus",
      client_id: "07-tendermint-14",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4092",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-0",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2959",
      connection_id: "connection-2454"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2694",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-21",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-109",
      connection_id: "connection-153"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
bu.default = wT;
var vu = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(bt, "__esModule", { value: !0 });
bt.ibc = bt.chain = bt.assets = void 0;
const xT = vu(_u), kT = vu(yu), AT = vu(bu);
bt.assets = xT.default;
bt.chain = kT.default;
bt.ibc = AT.default;
var vt = {}, fu = {};
Object.defineProperty(fu, "__esModule", { value: !0 });
const jT = {
  $schema: "../assetlist.schema.json",
  chain_name: "dydx",
  assets: [{
    description: "DYDX is a decentralized trading platform focused on derivatives and perpetual contracts, offering a secure and efficient trading experience without intermediaries.",
    extended_description: `DYDX is a leading decentralized trading platform specializing in derivatives and perpetual contracts. It enables users to trade with leverage, providing a sophisticated and efficient trading environment without intermediaries. Built on the Ethereum blockchain, DYDX uses smart contracts to ensure transaction security and transparency, giving users full control over their funds and trades.

The DYDX platform's native token, DYDX, is integral to its ecosystem, used for governance, staking, and fee discounts, incentivizing active participation. DYDX offers a wide range of trading pairs and supports advanced trading features like margin trading and lending. Combining the benefits of decentralized finance with traditional trading platform functionality, DYDX is paving the way for a more open and inclusive financial system.`,
    denom_units: [{
      denom: "adydx",
      exponent: 0
    }, {
      denom: "dydx",
      exponent: 18
    }],
    base: "adydx",
    name: "dYdX",
    display: "dydx",
    symbol: "DYDX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg"
    },
    coingecko_id: "dydx-chain",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
      theme: {
        primary_color_hex: "#21212f"
      }
    }, {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx-circle.svg",
      theme: {
        circle: !0
      }
    }],
    socials: {
      website: "https://dydx.trade/",
      twitter: "https://twitter.com/dYdX"
    }
  }, {
    description: "Noble USDC on dYdX Protocol.",
    denom_units: [{
      denom: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
      exponent: 0
    }, {
      denom: "usdc",
      exponent: 6
    }],
    type_asset: "ics20",
    base: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
    name: "Noble USDC",
    display: "usdc",
    symbol: "USDC",
    traces: [{
      type: "ibc",
      counterparty: {
        chain_name: "noble",
        base_denom: "uusdc",
        channel_id: "channel-33"
      },
      chain: {
        channel_id: "channel-0",
        path: "transfer/channel-0/uusdc"
      }
    }],
    images: [{
      image_sync: {
        chain_name: "noble",
        base_denom: "uusdc"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
      theme: {
        circle: !0,
        primary_color_hex: "#2775CA"
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
    }
  }]
};
fu.default = jT;
var wu = {};
Object.defineProperty(wu, "__esModule", { value: !0 });
const CT = {
  $schema: "../chain.schema.json",
  chain_name: "dydx",
  status: "live",
  website: "https://dydx.trade/",
  network_type: "mainnet",
  pretty_name: "dYdX Protocol",
  chain_type: "cosmos",
  chain_id: "dydx-mainnet-1",
  bech32_prefix: "dydx",
  daemon_name: "dydxprotocold",
  node_home: "$HOME/.dydxprotocol",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "adydx",
      fixed_min_gas_price: 125e8,
      low_gas_price: 125e8,
      average_gas_price: 125e8,
      high_gas_price: 2e10
    }, {
      denom: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "adydx"
    }]
  },
  codebase: {
    cosmos_sdk_version: "dydxprotocol/cosmos-sdk v0.50.6-0.20240606183841-18966898625f"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg"
  },
  description: "Our goal is to build open source code that can power a first class product and trading experience.",
  apis: {
    rpc: [
      {
        address: "https://dydx-rpc.kingnodes.com:443",
        provider: "Kingnodes 👑"
      },
      {
        address: "https://dydx-dao-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://dydx-mainnet-full-rpc.public.blastapi.io",
        provider: "Bware Labs"
      },
      {
        address: "https://rpc.lavenderfive.com:443/dydx",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://dydx-mainnet-rpc.autostake.com:443",
        provider: "AutoStake | StakeDrops"
      },
      {
        address: "https://rpc-dydx.ecostake.com:443",
        provider: "ecostake"
      },
      {
        address: "https://rpc.dydx.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "https://rpc-dydx.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://dydx-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc-dydx.cros-nest.com:443",
        provider: "Crosnest"
      },
      {
        address: "https://dydx-rpc.enigma-validator.com",
        provider: "Enigma"
      },
      {
        address: "https://community.nuxian-node.ch:6797/dydx/trpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://dydx-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://dydx.interstellar-lounge.org",
        provider: "Interstellar Lounge 🍸"
      }
    ],
    rest: [
      {
        address: "https://community.nuxian-node.ch:6797/dydx/crpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://dydx-dao-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://dydx-mainnet-full-lcd.public.blastapi.io",
        provider: "Bware Labs"
      },
      {
        address: "https://dydx-rest.kingnodes.com:443",
        provider: "Kingnodes 👑"
      },
      {
        address: "https://rest.lavenderfive.com:443/dydx",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://dydx-mainnet-lcd.autostake.com:443",
        provider: "AutoStake | StakeDrops"
      },
      {
        address: "https://rest-dydx.ecostake.com:443",
        provider: "ecostake"
      },
      {
        address: "https://api-dydx.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://api.dydx.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "https://dydx-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rest-dydx.cros-nest.com:443",
        provider: "Crosnest"
      },
      {
        address: "https://dydx-lcd.enigma-validator.com",
        provider: "Enigma"
      },
      {
        address: "https://dydx-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://dydx-rest.interstellar-lounge.org",
        provider: "Interstellar Lounge 🍸"
      }
    ],
    grpc: [
      {
        address: "dydx-dao-grpc-1.polkachu.com:23890",
        provider: "Polkachu (1)"
      },
      {
        address: "dydx-dao-grpc-2.polkachu.com:23890",
        provider: "Polkachu (2)"
      },
      {
        address: "dydx-dao-grpc-3.polkachu.com:23890",
        provider: "Polkachu (3)"
      },
      {
        address: "dydx-dao-grpc-4.polkachu.com:23890",
        provider: "Polkachu (4)"
      },
      {
        address: "dydx-dao-grpc-5.polkachu.com:23890",
        provider: "Polkachu (5)"
      },
      {
        address: "dydx-mainnet-full-grpc.public.blastapi.io:443",
        provider: "Bware Labs"
      },
      {
        address: "https://dydx-grpc.kingnodes.com:443",
        provider: "Kingnodes 👑"
      },
      {
        address: "dydx.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "dydx-mainnet-grpc.autostake.com:443",
        provider: "AutoStake | StakeDrops"
      },
      {
        address: "https://grpc.dydx.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "dydx.grpc.kjnodes.com:443",
        provider: "kjnodes"
      },
      {
        address: "grpc-dydx.cosmos-spaces.cloud:4990",
        provider: "Cosmos Spaces"
      },
      {
        address: "dydx-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "dydx-grpc.noders.services:37090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/dydx",
      tx_page: "https://www.mintscan.io/dydx/txs/${txHash}",
      account_page: "https://www.mintscan.io/dydx/account/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/dydx",
      tx_page: "https://ezstaking.app/dydx/txs/${txHash}",
      account_page: "https://ezstaking.app/dydx/account/${accountAddress}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.top/dydx/",
      tx_page: "https://explorer.nodestake.top/dydx/txs/${txHash}",
      account_page: "https://explorer.nodestake.top/dydx/account/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/dydx",
      tx_page: "https://explorer.tcnetwork.io/dydx/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/dydx/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
    theme: {
      primary_color_hex: "#21212f"
    }
  }]
};
wu.default = CT;
var xu = {};
Object.defineProperty(xu, "__esModule", { value: !0 });
const ET = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-38",
      connection_id: "connection-26"
    },
    chain_2: {
      chain_name: "dydx",
      client_id: "07-tendermint-14",
      connection_id: "connection-20"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-16",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "dydx",
      client_id: "07-tendermint-15",
      connection_id: "connection-21"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-17",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-135",
      connection_id: "connection-81"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-107",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-7",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-154",
      connection_id: "connection-195"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-137",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-5",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-158",
      connection_id: "connection-122"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-118",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-11",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-72",
      connection_id: "connection-51"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-48",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-59",
      connection_id: "connection-57"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-3",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3009",
      connection_id: "connection-2500"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6787",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-4",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-159",
      connection_id: "connection-197"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-131",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-29",
      connection_id: "connection-34"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-71",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-133",
      connection_id: "connection-123"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-160",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-9",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-390",
      connection_id: "connection-380"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-299",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-8",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-244",
      connection_id: "connection-208"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-118",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
xu.default = ET;
var ku = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(vt, "__esModule", { value: !0 });
vt.ibc = vt.chain = vt.assets = void 0;
const DT = ku(fu), BT = ku(wu), FT = ku(xu);
vt.assets = DT.default;
vt.chain = BT.default;
vt.ibc = FT.default;
var ft = {}, Au = {};
Object.defineProperty(Au, "__esModule", { value: !0 });
const $T = {
  $schema: "../assetlist.schema.json",
  chain_name: "dymension",
  assets: [
    {
      description: "The native governance and staking token of the Dymension Hub",
      denom_units: [{
        denom: "adym",
        exponent: 0
      }, {
        denom: "dym",
        exponent: 18
      }],
      type_asset: "sdk.coin",
      base: "adym",
      name: "Dymension",
      display: "dym",
      symbol: "DYM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.svg"
      },
      coingecko_id: "dymension",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.svg",
        theme: {
          primary_color_hex: "#f4e4d4"
        }
      }],
      socials: {
        website: "https://portal.dymension.xyz",
        twitter: "https://twitter.com/dymension"
      }
    },
    {
      description: "The native token of Nim Network.",
      extended_description: "Nim Network is a highly-adoptable AI Gaming chain that will provide the ultimate ecosystem for exploration and development of games at the intersection of Web3 and AI.",
      denom_units: [{
        denom: "ibc/FB53D1684F155CBB86D9CE917807E42B59209EBE3AD3A92E15EF66586C073942",
        exponent: 0,
        aliases: ["anim"]
      }, {
        denom: "nim",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/FB53D1684F155CBB86D9CE917807E42B59209EBE3AD3A92E15EF66586C073942",
      name: "Nim Network",
      display: "nim",
      symbol: "NIM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nim",
          base_denom: "anim",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-49",
          path: "transfer/channel-49/anim"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "nim",
          base_denom: "anim"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.svg",
        theme: {
          primary_color_hex: "#519cea"
        }
      }],
      socials: {
        website: "https://nim.network/",
        twitter: "https://twitter.com/nim_network"
      },
      keywords: ["gaming", "AI"],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.svg"
      }
    },
    {
      description: "The native token of Mande Network.",
      extended_description: "Mande network is an open on-chain reputation layer on Web3",
      denom_units: [{
        denom: "ibc/5A26C8DC8DA66F4DD94326E67F94510188F5F7AFE2DB3933A0C823670E56EABF",
        exponent: 0,
        aliases: ["amand"]
      }, {
        denom: "mand",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/5A26C8DC8DA66F4DD94326E67F94510188F5F7AFE2DB3933A0C823670E56EABF",
      name: "Mande Network",
      display: "mand",
      symbol: "MAND",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "mande",
          base_denom: "amand",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-51",
          path: "transfer/channel-51/amand"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "mande",
          base_denom: "amand"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.svg",
        theme: {
          primary_color_hex: "#274cbf"
        }
      }],
      socials: {
        website: "https://mande.network/",
        twitter: "https://twitter.com/MandeNetwork"
      },
      keywords: ["credibility", "identity"],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.svg"
      }
    }
  ]
};
Au.default = $T;
var ju = {};
Object.defineProperty(ju, "__esModule", { value: !0 });
const zT = {
  $schema: "../chain.schema.json",
  chain_name: "dymension",
  status: "live",
  network_type: "mainnet",
  website: "https://portal.dymension.xyz",
  pretty_name: "Dymension Hub",
  chain_type: "cosmos",
  chain_id: "dymension_1100-1",
  bech32_prefix: "dym",
  slip44: 60,
  node_home: "$HOME/.dymension",
  daemon_name: "dymd",
  fees: {
    fee_tokens: [{
      denom: "adym",
      fixed_min_gas_price: 5e9,
      low_gas_price: 5e9,
      average_gas_price: 5e9,
      high_gas_price: 2e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "adym"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.svg"
  },
  description: "Dymension is a network of easily deployable and lightning fast modular blockchains called RollApps.",
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.svg",
    theme: {
      primary_color_hex: "#f4e4d4"
    }
  }],
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://dym-m-rpc.agoranodes.com",
        provider: "AgoraNodes"
      },
      {
        address: "https://rpc.dymension.nodestake.org",
        provider: "NodeStake"
      },
      {
        address: "http://dymension.mainnet.rpc.noders.team:42657",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://dymension-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc.lavenderfive.com:443/dymension",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://dymension-rpc.kynraze.com",
        provider: "Kynraze"
      },
      {
        address: "https://m-dymension.rpc.utsa.tech",
        provider: "lesnik | UTSA"
      },
      {
        address: "https://rpc-dymension.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "https://dym.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://dym.rpc-archive.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.dymension.hexnodes.co",
        provider: "Hexnodes"
      },
      {
        address: "https://dymension.rpc.kjnodes.com:443",
        provider: "kjnodes.com 🦄"
      },
      {
        address: "https://dymension-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://dymension-rpc.takeshi.team",
        provider: "TAKESHI"
      },
      {
        address: "https://dymension-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc.dymension.silentvalidator.com:443",
        provider: "silent"
      },
      {
        address: "https://rpc-dymension.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://community.nuxian-node.ch:6797/dymension/trpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://dymension-rpc.enigma-validator.com",
        provider: "Enigma"
      },
      {
        address: "https://dymension-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://dymension.nodejumper.io:443",
        provider: "NODEJUMPER"
      },
      {
        address: "https://rpc-dymension.hoodrun.io:443",
        provider: "HoodRun"
      },
      {
        address: "https://dymension.0xwave.com:2053",
        provider: "Wave"
      },
      {
        address: "https://archive.rpc.dym.cumulo.com.es:443",
        provider: "Cumulo"
      },
      {
        address: "https://rpc.dymension.posthuman.digital",
        provider: "posthuman"
      },
      {
        address: "https://rpc.dymension.node75.org",
        provider: "Pro-Nodes75"
      },
      {
        address: "https://rpc.dymension.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://dymension-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://rpc.mainnet.dymension.aviaone.com",
        provider: "AVIAONE 🟢"
      },
      {
        address: "https://rpc.archive.dymension.mainnet.dteam.tech:443",
        provider: "DTEAM"
      },
      {
        address: "https://dymension.drpc.org",
        provider: "dRPC"
      }
    ],
    rest: [
      {
        address: "https://dym-m-api.agoranodes.com",
        provider: "AgoraNodes"
      },
      {
        address: "https://api.dymension.nodestake.org",
        provider: "NodeStake"
      },
      {
        address: "http://dymension.mainnet.api.noders.team:42317",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://dymension-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest.lavenderfive.com:443/dymension",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://dymension-api.kynraze.com",
        provider: "Kynraze"
      },
      {
        address: "https://m-dymension.api.utsa.tech",
        provider: "lesnik | UTSA"
      },
      {
        address: "https://api-dymension.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "https://dymension.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://dym.api-archive.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://lcd.dymension.hexnodes.co",
        provider: "Hexnodes"
      },
      {
        address: "https://dymension.api.kjnodes.com:443",
        provider: "kjnodes.com 🦄"
      },
      {
        address: "https://dymension-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://dymension-api.takeshi.team",
        provider: "TAKESHI"
      },
      {
        address: "https://dymension-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://api.dymension.silentvalidator.com:443",
        provider: "silent"
      },
      {
        address: "https://api-dymension.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://community.nuxian-node.ch:6797/dymension/crpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://dymension-lcd.enigma-validator.com",
        provider: "Enigma"
      },
      {
        address: "https://dymension-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://dymension.nodejumper.io:1317",
        provider: "NODEJUMPER"
      },
      {
        address: "https://lcd-dymension.hoodrun.io",
        provider: "HoodRun"
      },
      {
        address: "https://dymension.0xwave.com",
        provider: "Wave"
      },
      {
        address: "https://api.dym.cumulo.com.es",
        provider: "Cumulo"
      },
      {
        address: "https://rest.dymension.posthuman.digital",
        provider: "posthuman"
      },
      {
        address: "https://api.dymension.node75.org",
        provider: "Pro-Nodes75"
      },
      {
        address: "https://lcd.dymension.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://dymension-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://api.mainnet.dymension.aviaone.com",
        provider: "AVIAONE 🟢"
      },
      {
        address: "https://api.archive.dymension.mainnet.dteam.tech:443",
        provider: "DTEAM"
      }
    ],
    grpc: [
      {
        address: "https://dym-m-grpc.agoranodes.com",
        provider: "AgoraNodes"
      },
      {
        address: "grpc.dymension.nodestake.org:443",
        provider: "NodeStake"
      },
      {
        address: "dymension-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "dymension.mainnet.grpc.noders.team:42090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "dymension.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "dymension-grpc.kynraze.com:77",
        provider: "Kynraze"
      },
      {
        address: "https://grpc-dymension.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "dymension.grpc.m.stavr.tech:7119",
        provider: "🔥STAVR🔥"
      },
      {
        address: "dymension.grpc.kjnodes.com:443",
        provider: "kjnodes.com 🦄"
      },
      {
        address: "http://dymension-grpc.stakeandrelax.net:20590",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://dymension-grpc.takeshi.team",
        provider: "TAKESHI"
      },
      {
        address: "dymension-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "grpc.dymension.silentvalidator.com:443",
        provider: "silent"
      },
      {
        address: "https://grpc-dymension.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "dymension.nodejumper.io:9090",
        provider: "NODEJUMPER"
      },
      {
        address: "grpc-dymension.hoodrun.io:9095",
        provider: "HoodRun"
      },
      {
        address: "https://dymension.0xwave.com:2083",
        provider: "Wave"
      },
      {
        address: "grpc.dym.cumulo.com.es:443",
        provider: "Cumulo"
      },
      {
        address: "https://grpc.dymension.posthuman.digital",
        provider: "posthuman"
      },
      {
        address: "https://grpc.dymension.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "dymension-grpc.noders.services:12090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://grpc.mainnet.dymension.aviaone.com:9092",
        provider: "AVIAONE 🟢"
      },
      {
        address: "grpc.archive.dymension.mainnet.dteam.tech:29090",
        provider: "DTEAM"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://dym-m-json.agoranodes.com",
        provider: "AgoraNodes"
      },
      {
        address: "https://dymension-jsonrpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://evm-dymension.hoodrun.io:8547",
        provider: "HoodRun"
      },
      {
        address: "https://dymension.0xwave.com:2087",
        provider: "Wave"
      },
      {
        address: "https://evm-rpc.dym.cumulo.com.es:443",
        provider: "Cumulo"
      },
      {
        address: "https://evm-rpc.dymension.node75.org",
        provider: "Pro-Nodes75"
      },
      {
        address: "https://evm-rpc.dymension.posthuman.digital",
        provider: "posthuman"
      },
      {
        address: "https://dymension-jsonrpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://evm.archive.dymension.mainnet.dteam.tech:443",
        provider: "DTEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/dymension",
      tx_page: "https://www.mintscan.io/dymension/tx/${txHash}",
      account_page: "https://www.mintscan.io/dymension/account/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/dymension",
      tx_page: "https://ezstaking.app/dymension/txs/${txHash}",
      account_page: "https://ezstaking.app/dymension/account/${accountAddress}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.org/dymension",
      tx_page: "https://explorer.nodestake.org/dymension/tx/${txHash}",
      account_page: "https://explorer.nodestake.org/dymension/account/${accountAddress}"
    },
    {
      kind: "Kynraze",
      url: "https://explorer.kynraze.com/dymension",
      tx_page: "https://explorer.kynraze.com/dymension/tx/${txHash}",
      account_page: "https://explorer.kynraze.com/dymension/account/${accountAddress}"
    },
    {
      kind: "Nodeist Explorer",
      url: "https://explorer.ist/dymension",
      tx_page: "https://explorer.ist/dymension/tx/${txHash}",
      account_page: "https://explorer.ist/dymension/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Dymension-Mainnet",
      tx_page: "https://explorer.stavr.tech/Dymension-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Dymension-Mainnet/account/${accountAddress}"
    },
    {
      kind: "HoodScan",
      url: "https://hoodscan.io/dymension",
      tx_page: "https://hoodscan.io/dymension/transactions/${txHash}",
      account_page: "https://hoodscan.io/dymension/accounts/${accountAddress}"
    },
    {
      kind: "posthuman",
      url: "https://explorer.posthuman.digital/dymension",
      tx_page: "https://explorer.posthuman.digital/dymension/tx/${txHash}",
      account_page: "https://explorer.posthuman.digital/dymension/account/${accountAddress}"
    },
    {
      kind: "AVIAONE 🟢",
      url: "https://mainnet.explorer.aviaone.com/dymension",
      tx_page: "https://mainnet.explorer.aviaone.com/dymension/tx/${txHash}",
      account_page: "https://mainnet.explorer.aviaone.com/dymension/account/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/dymension",
      tx_page: "https://mainnet.whispernode.com/dymension/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/dymension/account/${accountAddress}"
    },
    {
      kind: "DTEAM | Explorer",
      url: "https://explorer.mainnet.dteam.tech/dymension",
      tx_page: "https://explorer.mainnet.dteam.tech/dymension/tx/${txHash}",
      account_page: "https://explorer.mainnet.dteam.tech/dymension/account/${accountAddress}"
    }
  ]
};
ju.default = zT;
var Cu = {};
Object.defineProperty(Cu, "__esModule", { value: !0 });
const qT = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-91",
      connection_id: "connection-89"
    },
    chain_2: {
      chain_name: "dymension",
      client_id: "07-tendermint-39",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-123",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-45",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-197",
      connection_id: "connection-180"
    },
    chain_2: {
      chain_name: "dymension",
      client_id: "07-tendermint-7",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-138",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-82",
      connection_id: "connection-52"
    },
    chain_2: {
      chain_name: "dymension",
      client_id: "07-tendermint-6",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1205",
      connection_id: "connection-933"
    },
    chain_2: {
      chain_name: "dymension",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-794",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-31",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-138",
      connection_id: "connection-85"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-109",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-162",
      connection_id: "connection-203"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-144",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-17",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-169",
      connection_id: "connection-132"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-160",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-50",
      connection_id: "connection-36"
    },
    chain_2: {
      chain_name: "mande",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-16",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-82",
      connection_id: "connection-61"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-675",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-44",
      connection_id: "connection-34"
    },
    chain_2: {
      chain_name: "nim",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-14",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-79",
      connection_id: "connection-80"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3086",
      connection_id: "connection-2566"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-19774",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-29",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-194",
      connection_id: "connection-189"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-35",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-130",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-140",
      connection_id: "connection-131"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-197",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Cu.default = qT;
var Eu = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ft, "__esModule", { value: !0 });
ft.ibc = ft.chain = ft.assets = void 0;
const ST = Eu(Au), TT = Eu(ju), RT = Eu(Cu);
ft.assets = ST.default;
ft.chain = TT.default;
ft.ibc = RT.default;
var wt = {}, Du = {};
Object.defineProperty(Du, "__esModule", { value: !0 });
const OT = {
  $schema: "../assetlist.schema.json",
  chain_name: "dyson",
  assets: [
    {
      description: "The native staking and governance token of the Dyson Protocol",
      denom_units: [{
        denom: "dys",
        exponent: 0
      }],
      base: "dys",
      name: "Dys",
      display: "dys",
      symbol: "DYS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B",
        exponent: 0,
        aliases: ["uosmo"]
      }, {
        denom: "osmo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B",
      name: "Osmosis",
      display: "osmo",
      description: "The native token of Osmosis",
      symbol: "OSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo",
          channel_id: "channel-526"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/uosmo"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/9BF31153F7E37F687C75A2F310E7A4DB6E0512B065F709B5EB69FE828133AFAC",
        exponent: 0,
        aliases: ["wbtc-satoshi"]
      }, {
        denom: "wbtc",
        exponent: 8
      }],
      type_asset: "ics20",
      base: "ibc/9BF31153F7E37F687C75A2F310E7A4DB6E0512B065F709B5EB69FE828133AFAC",
      name: "Wrapped Bitcoin",
      display: "wbtc",
      symbol: "WBTC",
      description: "Wrapped Bitcoin on Axelar on Osmosis",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F",
          channel_id: "channel-526"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/transfer/channel-208/wbtc-satoshi"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.svg",
        theme: {
          primary_color_hex: "#312b3a"
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/wbtc.png",
        theme: {
          primary_color_hex: "#41394d"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/13DF61376C08483555C6D4C9203612086A1B23218EB5EBDBE609EEC7EFF2D82D",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      description: "Circle's stablecoin on Axelar on Osmosis",
      base: "ibc/13DF61376C08483555C6D4C9203612086A1B23218EB5EBDBE609EEC7EFF2D82D",
      name: "USD Coin",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858",
          channel_id: "channel-526"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/transfer/channel-208/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.svg",
        theme: {
          primary_color_hex: "#2474cb"
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
        theme: {
          primary_color_hex: "#2474cc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.svg"
      }
    }
  ]
};
Du.default = OT;
var Bu = {};
Object.defineProperty(Bu, "__esModule", { value: !0 });
const MT = {
  $schema: "../chain.schema.json",
  chain_name: "dyson",
  website: "https://dysonprotocol.com/",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Dyson Protocol",
  chain_type: "cosmos",
  chain_id: "dyson-mainnet-01",
  bech32_prefix: "dys",
  node_home: "$HOME/.dyson",
  daemon_name: "dysond",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "dys",
      low_gas_price: 1e-4,
      average_gas_price: 2e-4,
      high_gas_price: 3e-4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "dys"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dyson.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dyson.svg"
  },
  apis: {
    rpc: [{
      address: "https://dys-tm.dysonprotocol.com:443",
      provider: "dysonprotocol"
    }, {
      address: "https://dyson-rpc.cogwheel.zone:443",
      provider: "cogwheel"
    }],
    rest: [{
      address: "https://dys-api.dysonprotocol.com:443",
      provider: "dysonprotocol"
    }, {
      address: "https://dyson-api.cogwheel.zone:443",
      provider: "cogwheel"
    }],
    grpc: [{
      address: "dys-grpc.dyson.lol:443",
      provider: "lol"
    }, {
      address: "https://dyson-grpc.cogwheel.zone:443",
      provider: "cogwheel"
    }]
  },
  explorers: [{
    kind: "dysonprotocol",
    url: "https://explorer.dys.dysonprotocol.com/dyson/",
    tx_page: "https://explorer.dys.dysonprotocol.com/dyson/tx/${txHash}",
    account_page: "https://explorer.dys.dysonprotocol.com/dyson/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dyson.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dyson.svg"
  }]
};
Bu.default = MT;
var Fu = {};
Object.defineProperty(Fu, "__esModule", { value: !0 });
const IT = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "dyson",
    client_id: "07-tendermint-2",
    connection_id: "connection-5"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2407",
    connection_id: "connection-1895"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-526",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Fu.default = IT;
var $u = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(wt, "__esModule", { value: !0 });
wt.ibc = wt.chain = wt.assets = void 0;
const NT = $u(Du), PT = $u(Bu), UT = $u(Fu);
wt.assets = NT.default;
wt.chain = PT.default;
wt.ibc = UT.default;
var xt = {}, zu = {};
Object.defineProperty(zu, "__esModule", { value: !0 });
const HT = {
  $schema: "../assetlist.schema.json",
  chain_name: "echelon",
  assets: [{
    description: "Echelon - a scalable EVM on Cosmos, built on Proof-of-Stake with fast-finality that prioritizes interoperability and novel economics",
    denom_units: [{
      denom: "aechelon",
      exponent: 0
    }, {
      denom: "echelon",
      exponent: 18
    }],
    base: "aechelon",
    name: "Echelon",
    display: "echelon",
    symbol: "ECH",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/echelon/images/ech.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/echelon/images/ech.svg"
    }]
  }]
};
zu.default = HT;
var qu = {};
Object.defineProperty(qu, "__esModule", { value: !0 });
const LT = {
  $schema: "../chain.schema.json",
  chain_name: "echelon",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Echelon",
  chain_type: "cosmos",
  chain_id: "echelon_3000-3",
  bech32_prefix: "echelon",
  node_home: "$HOME/.echelond",
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aechelon",
      low_gas_price: 1e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aechelon"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/echelon/images/logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/echelon/images/echelon.svg"
  },
  apis: {
    rpc: [{
      address: "https://ech01trpc.mindheartsoul.org",
      provider: "Mind Heart Soul"
    }, {
      address: "https://rpc.echjoker.lol",
      provider: "⚡ Echelon Joker ⚛ 🃏"
    }],
    rest: [{
      address: "https://ech01api.mindheartsoul.org",
      provider: "Mind Heart Soul"
    }, {
      address: "https://api.echjoker.lol",
      provider: "⚡ Echelon Joker ⚛ 🃏"
    }],
    grpc: [],
    "evm-http-jsonrpc": [{
      address: "https://ech01jrpc.mindheartsoul.org",
      provider: "Mind Heart Soul"
    }, {
      address: "https://jrpc.echjoker.lol",
      provider: "⚡ Echelon Joker ⚛ 🃏"
    }]
  },
  explorers: [
    {
      kind: "echelon",
      url: "https://app.ech.network/explorer",
      tx_page: "https://app.ech.network/explorer/tx/${txHash}"
    },
    {
      kind: "blockscout",
      url: "https://scout.ech.network",
      tx_page: "https://scout.ech.network/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/echelon",
      tx_page: "https://ping.pub/echelon/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/echelon",
      tx_page: "https://atomscan.com/echelon/transactions/${txHash}",
      account_page: "https://atomscan.com/echelon/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/echelon/images/logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/echelon/images/echelon.svg",
    theme: {
      primary_color_hex: "#b1f49a"
    }
  }]
};
qu.default = LT;
var Su = {};
Object.defineProperty(Su, "__esModule", { value: !0 });
const WT = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "echelon",
    client_id: "07-tendermint-107",
    connection_id: "connection-29"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2268",
    connection_id: "connection-1760"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-11",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-403",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Su.default = WT;
var Tu = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(xt, "__esModule", { value: !0 });
xt.ibc = xt.chain = xt.assets = void 0;
const VT = Tu(zu), GT = Tu(qu), KT = Tu(Su);
xt.assets = VT.default;
xt.chain = GT.default;
xt.ibc = KT.default;
var kt = {}, Ru = {};
Object.defineProperty(Ru, "__esModule", { value: !0 });
const XT = {
  $schema: "../assetlist.schema.json",
  chain_name: "emoney",
  assets: [
    {
      description: "e-Money NGM staking token. In addition to earning staking rewards the token is bought back and burned based on e-Money stablecoin inflation.",
      denom_units: [{
        denom: "ungm",
        exponent: 0
      }, {
        denom: "ngm",
        exponent: 6
      }],
      base: "ungm",
      name: "e-Money",
      display: "ngm",
      symbol: "NGM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.svg"
      },
      coingecko_id: "e-money",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.svg",
        theme: {
          primary_color_hex: "#caf2ea"
        }
      }]
    },
    {
      description: "e-Money EUR stablecoin. Audited and backed by fiat EUR deposits and government bonds.",
      denom_units: [{
        denom: "eeur",
        exponent: 0
      }, {
        denom: "eur",
        exponent: 6
      }],
      base: "eeur",
      name: "e-Money EUR",
      display: "eur",
      symbol: "EEUR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.svg"
      },
      coingecko_id: "e-money-eur",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.svg",
        theme: {
          primary_color_hex: "#f4c808"
        }
      }]
    },
    {
      description: "e-Money CHF stablecoin. Audited and backed by fiat CHF deposits and government bonds.",
      denom_units: [{
        denom: "echf",
        exponent: 0
      }, {
        denom: "chf",
        exponent: 6
      }],
      base: "echf",
      name: "e-Money CHF",
      display: "chf",
      symbol: "ECHF",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/echf.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/echf.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/echf.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/echf.svg",
        theme: {
          primary_color_hex: "#db2b1c"
        }
      }]
    },
    {
      description: "e-Money NOK stablecoin. Audited and backed by fiat NOK deposits and government bonds.",
      denom_units: [{
        denom: "enok",
        exponent: 0
      }, {
        denom: "nok",
        exponent: 6
      }],
      base: "enok",
      name: "e-Money NOK",
      display: "nok",
      symbol: "ENOK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/enok.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/enok.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/enok.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/enok.svg",
        theme: {
          primary_color_hex: "#cb142d"
        }
      }]
    },
    {
      description: "e-Money DKK stablecoin. Audited and backed by fiat DKK deposits and government bonds.",
      denom_units: [{
        denom: "edkk",
        exponent: 0
      }, {
        denom: "dkk",
        exponent: 6
      }],
      base: "edkk",
      name: "e-Money DKK",
      display: "dkk",
      symbol: "EDKK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/edkk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/edkk.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/edkk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/edkk.svg",
        theme: {
          primary_color_hex: "#ac0c34"
        }
      }]
    },
    {
      description: "e-Money SEK stablecoin. Audited and backed by fiat SEK deposits and government bonds.",
      denom_units: [{
        denom: "esek",
        exponent: 0
      }, {
        denom: "sek",
        exponent: 6
      }],
      base: "esek",
      name: "e-Money SEK",
      display: "sek",
      symbol: "ESEK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/esek.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/esek.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/esek.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/esek.svg",
        theme: {
          primary_color_hex: "#045493"
        }
      }]
    }
  ]
};
Ru.default = XT;
var Ou = {};
Object.defineProperty(Ou, "__esModule", { value: !0 });
const YT = {
  $schema: "../chain.schema.json",
  chain_name: "emoney",
  status: "live",
  network_type: "mainnet",
  pretty_name: "e-Money",
  chain_type: "cosmos",
  chain_id: "emoney-3",
  bech32_prefix: "emoney",
  daemon_name: "emd",
  node_home: "$HOME/.emd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [
      {
        denom: "ungm",
        low_gas_price: 1,
        average_gas_price: 1,
        high_gas_price: 1
      },
      {
        denom: "eeur",
        low_gas_price: 1,
        average_gas_price: 1,
        high_gas_price: 1
      },
      {
        denom: "echf",
        low_gas_price: 1,
        average_gas_price: 1,
        high_gas_price: 1
      },
      {
        denom: "enok",
        low_gas_price: 1,
        average_gas_price: 1,
        high_gas_price: 1
      },
      {
        denom: "esek",
        low_gas_price: 1,
        average_gas_price: 1,
        high_gas_price: 1
      },
      {
        denom: "edkk",
        low_gas_price: 1,
        average_gas_price: 1,
        high_gas_price: 1
      }
    ]
  },
  staking: {
    staking_tokens: [{
      denom: "ungm"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://emoney.validator.network",
        provider: "e-Money"
      },
      {
        address: "https://rpc-emoney-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc.emoney.bh.rocks",
        provider: "BlockHunters 🎯"
      }
    ],
    rest: [
      {
        address: "https://emoney.validator.network/api/",
        provider: "e-Money"
      },
      {
        address: "https://api-emoney-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://api.emoney.bh.rocks",
        provider: "BlockHunters 🎯"
      }
    ],
    grpc: [{
      address: "grpc-emoney-ia.cosmosia.notional.ventures:443",
      provider: "Notional"
    }, {
      address: "emoney-mainnet-grpc.autostake.com:443",
      provider: "AutoStake 🛡️ Slash Protected"
    }]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/emoney",
      tx_page: "https://ezstaking.app/emoney/txs/${txHash}",
      account_page: "https://ezstaking.app/emoney/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/e-money",
      tx_page: "https://ping.pub/e-money/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/emoney",
      tx_page: "https://atomscan.com/emoney/transactions/${txHash}",
      account_page: "https://atomscan.com/emoney/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.svg",
    theme: {
      primary_color_hex: "#caf2ea"
    }
  }]
};
Ou.default = YT;
var Mu = {};
Object.defineProperty(Mu, "__esModule", { value: !0 });
const JT = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-432",
      connection_id: "connection-365"
    },
    chain_2: {
      chain_name: "emoney",
      client_id: "07-tendermint-8",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-202",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "emoney",
      client_id: "07-tendermint-10",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-46",
      connection_id: "connection-34"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "emoney",
      client_id: "07-tendermint-51",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-24",
      connection_id: "connection-16"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "emoney",
      client_id: "07-tendermint-7",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1447",
      connection_id: "connection-1132"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
Mu.default = JT;
var Iu = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(kt, "__esModule", { value: !0 });
kt.ibc = kt.chain = kt.assets = void 0;
const ZT = Iu(Ru), QT = Iu(Ou), eR = Iu(Mu);
kt.assets = ZT.default;
kt.chain = QT.default;
kt.ibc = eR.default;
var At = {}, Nu = {};
Object.defineProperty(Nu, "__esModule", { value: !0 });
const nR = {
  $schema: "../assetlist.schema.json",
  chain_name: "empowerchain",
  assets: [{
    description: "The native staking and governance token of Empower.",
    denom_units: [{
      denom: "umpwr",
      exponent: 0
    }, {
      denom: "mpwr",
      exponent: 6
    }],
    base: "umpwr",
    name: "MPWR",
    display: "mpwr",
    symbol: "MPWR",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/empowerchain/images/mpwr.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/empowerchain/images/mpwr.svg",
      theme: {
        primary_color_hex: "#00e33a",
        background_color_hex: "#00e33a",
        circle: !0
      }
    }, {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/empowerchain/images/mpwr.png",
      theme: {
        primary_color_hex: "#00e33a",
        background_color_hex: "#00e33a",
        circle: !1
      }
    }]
  }]
};
Nu.default = nR;
var Pu = {};
Object.defineProperty(Pu, "__esModule", { value: !0 });
const tR = {
  $schema: "../chain.schema.json",
  chain_name: "empowerchain",
  chain_type: "cosmos",
  chain_id: "empowerchain-1",
  pretty_name: "EmpowerChain",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "empower",
  daemon_name: "empowerd",
  node_home: "$HOME/.empowerchain",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "umpwr",
      fixed_min_gas_price: 0,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "umpwr"
    }]
  },
  codebase: {
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.45"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc-empowerchain.ecostake.com:443",
        provider: "ecostake"
      },
      {
        address: "https://empowerchain-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://empower.rpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "http://empw.rpc.m.stavr.tech:22057",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-empowerchain.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "https://empower-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://rpc-empower.vinjan.xyz:443",
        provider: "vinjan"
      },
      {
        address: "https://rpc.empower.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://mainnet-empower-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://empower.rpc.stakevillage.net:443",
        provider: "Stake Village"
      },
      {
        address: "https://rpc.empowerchain.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://empower.declab.pro:26607",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://empower-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://empower-rpc.bluestake.net:443",
        provider: "BlueStake 🚀"
      }
    ],
    rest: [
      {
        address: "https://rest-empowerchain.ecostake.com:443",
        provider: "ecostake"
      },
      {
        address: "https://empowerchain-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://empower.api.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://empw.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://empower-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://api-empower.vinjan.xyz:443",
        provider: "vinjan"
      },
      {
        address: "https://api.empower.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://mainnet-empower-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://empower.api.stakevillage.net",
        provider: "Stake Village"
      },
      {
        address: "https://lcd.empowerchain.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://empower.declab.pro:443",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://empower-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://empower-api.bluestake.net",
        provider: "BlueStake 🚀"
      }
    ],
    grpc: [
      {
        address: "empowerchain-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://empower.grpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "empower-grpc.w3coins.io:17390",
        provider: "w3coins"
      },
      {
        address: "grpc-empowerchain.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "http://empw.grpc.m.stavr.tech:9141",
        provider: "🔥STAVR🔥"
      },
      {
        address: "grpc-empower.vinjan.xyz",
        provider: "vinjan"
      },
      {
        address: "https://grpc.empower.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "empower.grpc.stakevillage.net:16890",
        provider: "Stake Village"
      },
      {
        address: "https://grpc.empowerchain.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://empower.declab.pro:9005",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "empower-grpc.noders.services:25090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Empower-Mainnet",
      tx_page: "https://explorer.stavr.tech/Empower-Mainnet/txs/${txHash}",
      account_page: "https://explorer.stavr.tech/Empower-Mainnet/account/${accountAddress}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/empower",
      tx_page: "https://explorer.nodestake.top/empower/tx/${txHash}",
      account_page: "https://explorer.nodestake.top/empower/account/{$accountAddress}"
    },
    {
      kind: "Stake Village",
      url: "https://exp.stakevillage.net/empower",
      tx_page: "https://exp.stakevillage.net/empower/tx/${txHash}",
      account_page: "https://exp.stakevillage.net/empower/account/${accountAddress}"
    },
    {
      kind: "Decloud Nodes Lab",
      url: "https://explorer.declab.pro/Empower",
      tx_page: "https://explorer.declab.pro/Empower/tx/${txHash}",
      account_page: "https://explorer.declab.pro/Empower/account/{$accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/empowerchain",
      tx_page: "https://mainnet.whispernode.com/empowerchain/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/empowerchain/account/${accountAddress}"
    }
  ],
  images: [{
    image_sync: {
      chain_name: "empowerchain",
      base_denom: "umpwr"
    },
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/empowerchain/images/mpwr.svg",
    theme: {
      primary_color_hex: "#00e33a",
      background_color_hex: "#00e33a",
      circle: !0
    }
  }, {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/empowerchain/images/mpwr.png",
    theme: {
      primary_color_hex: "#00e33a",
      background_color_hex: "#00e33a",
      circle: !1
    }
  }]
};
Pu.default = tR;
var Uu = {};
Object.defineProperty(Uu, "__esModule", { value: !0 });
const sR = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-158",
      connection_id: "connection-142"
    },
    chain_2: {
      chain_name: "empowerchain",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-109",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1151",
      connection_id: "connection-872"
    },
    chain_2: {
      chain_name: "empowerchain",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-621",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "empowerchain",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2848",
      connection_id: "connection-2360"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1411",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Uu.default = sR;
var Hu = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(At, "__esModule", { value: !0 });
At.ibc = At.chain = At.assets = void 0;
const aR = Hu(Nu), oR = Hu(Pu), rR = Hu(Uu);
At.assets = aR.default;
At.chain = oR.default;
At.ibc = rR.default;
var tr = {}, Lu = {};
Object.defineProperty(Lu, "__esModule", { value: !0 });
const iR = {
  $schema: "../assetlist.schema.json",
  chain_name: "ethos",
  assets: [{
    description: "The native token of Ethos",
    denom_units: [{
      denom: "aRYT",
      exponent: 0
    }, {
      denom: "RYT",
      exponent: 18
    }],
    base: "aRYT",
    name: "RYT",
    display: "RYT",
    symbol: "RYT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ethos/images/ethos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ethos/images/ethos.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ethos/images/ethos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ethos/images/ethos.svg",
      theme: {
        primary_color_hex: "#848484"
      }
    }]
  }]
};
Lu.default = iR;
var Wu = {};
Object.defineProperty(Wu, "__esModule", { value: !0 });
const cR = {
  $schema: "../chain.schema.json",
  chain_name: "ethos",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Ethos",
  chain_type: "cosmos",
  chain_id: "ethos_7003-1",
  bech32_prefix: "ethos",
  daemon_name: "ethosd",
  node_home: "$HOME/.ethos",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aRYT"
    }]
  },
  apis: {
    rpc: [{
      address: "https://ethos-rpc.provable.dev:443/",
      provider: "laurel.provable"
    }],
    rest: [{
      address: "https://ethos.provable.dev/rest/",
      provider: "laurel.provable"
    }],
    grpc: [{
      address: "ethos-grpc.provable.dev:443",
      provider: "laurel.provable"
    }],
    "evm-http-jsonrpc": [{
      address: "https://ethos-evm.provable.dev/",
      provider: "laurel.provable"
    }]
  },
  explorers: [],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ethos/images/ethos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ethos/images/ethos.svg"
  },
  codebase: {},
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ethos/images/ethos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ethos/images/ethos.svg",
    theme: {
      primary_color_hex: "#848484"
    }
  }]
};
Wu.default = cR;
var D9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(tr, "__esModule", { value: !0 });
tr.chain = tr.assets = void 0;
const dR = D9(Lu), mR = D9(Wu);
tr.assets = dR.default;
tr.chain = mR.default;
var jt = {}, Vu = {};
Object.defineProperty(Vu, "__esModule", { value: !0 });
const hR = {
  $schema: "../assetlist.schema.json",
  chain_name: "evmos",
  assets: [
    {
      description: "The native EVM, governance and staking token of the Evmos Hub",
      denom_units: [{
        denom: "aevmos",
        exponent: 0
      }, {
        denom: "evmos",
        exponent: 18
      }],
      base: "aevmos",
      name: "Evmos",
      display: "evmos",
      symbol: "EVMOS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg"
      },
      coingecko_id: "evmos",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg",
        theme: {
          primary_color_hex: "#ec4c34"
        }
      }],
      socials: {
        website: "https://evmos.org/",
        twitter: "https://twitter.com/EvmosOrg"
      }
    },
    {
      description: "Tether USDt on Evmos",
      denom_units: [{
        denom: "ibc/95F4898F70B1E3765715808C57E955034419200A7BB6DDECBEAA5FD3AA3DF7D5",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/95F4898F70B1E3765715808C57E955034419200A7BB6DDECBEAA5FD3AA3DF7D5",
      name: "Tether USDt",
      display: "usdt",
      symbol: "USDt",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt",
          channel_id: "channel-117"
        },
        chain: {
          channel_id: "channel-83",
          path: "transfer/channel-83/erc20/tether/usdt"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    },
    {
      description: "The token of Neokingdom DAO.",
      extended_description: "Neokingdom DAO wants to make employment fairer, by facilitating both web3 and real-world businesses to operate as Decentralized Autonomous Organizations (DAOs).",
      denom_units: [{
        denom: "erc20/0x655ecB57432CC1370f65e5dc2309588b71b473A9",
        exponent: 0
      }, {
        denom: "neok",
        exponent: 18
      }],
      base: "erc20/0x655ecB57432CC1370f65e5dc2309588b71b473A9",
      name: "Neokingdom DAO",
      display: "neok",
      symbol: "NEOK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/neok.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/neok.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/neok.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/neok.svg",
        theme: {
          primary_color_hex: "#7f0f70"
        }
      }],
      socials: {
        website: "https://www.neokingdom.org/",
        twitter: "https://twitter.com/NEOKingdomDAO"
      }
    },
    {
      description: "The legacy token of Teledisko DAO.",
      denom_units: [{
        denom: "erc20/0x1cFc8f1FE8D5668BAFF2724547EcDbd6f013a280",
        exponent: 0
      }, {
        denom: "berlin-legacy",
        exponent: 18
      }],
      base: "erc20/0x1cFc8f1FE8D5668BAFF2724547EcDbd6f013a280",
      name: "Teledisko DAO - Legacy",
      display: "berlin-legacy",
      symbol: "BERLIN-legacy",
      type_asset: "erc20",
      address: "0x1cFc8f1FE8D5668BAFF2724547EcDbd6f013a280",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/berlin.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/berlin.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/berlin.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/berlin.svg",
        theme: {
          primary_color_hex: "#bbce1a"
        }
      }]
    },
    {
      description: "The token of Crowdpunk DAO",
      denom_units: [{
        denom: "erc20/0xfbf4318d24a93753f11d365a6dcf8b830e98ab0f",
        exponent: 0
      }, {
        denom: "crowdp",
        exponent: 18
      }],
      base: "erc20/0xfbf4318d24a93753f11d365a6dcf8b830e98ab0f",
      name: "Crowdpunk DAO",
      display: "crowdp",
      address: "0xfbf4318d24a93753f11d365a6dcf8b830e98ab0f",
      symbol: "CROWDP",
      type_asset: "erc20",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.svg",
        theme: {
          primary_color_hex: "#04fbfb"
        }
      }]
    }
  ]
};
Vu.default = hR;
var Gu = {};
Object.defineProperty(Gu, "__esModule", { value: !0 });
const pR = {
  $schema: "../chain.schema.json",
  chain_name: "evmos",
  status: "live",
  network_type: "mainnet",
  website: "https://evmos.org/",
  pretty_name: "Evmos",
  chain_type: "cosmos",
  chain_id: "evmos_9001-2",
  bech32_prefix: "evmos",
  node_home: "$HOME/.evmosd",
  daemon_name: "evmosd",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aevmos",
      fixed_min_gas_price: 25e7,
      low_gas_price: 2e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aevmos"
    }]
  },
  codebase: {
    cosmos_sdk_version: "evmos/cosmos-sdk v0.47.12-evmos.2"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg"
  },
  description: "Developers use Evmos as the Ethereum Canary Chain to deploy applications of the future. Get all the functionalities of Ethereum with the power of IBC and Interchain composability.",
  apis: {
    rpc: [
      {
        address: "https://rpc-evmos.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://rpc.lavenderfive.com:443/evmos",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://tendermint.bd.evmos.org:26657",
        provider: "Blockdaemon"
      },
      {
        address: "https://rpc-evmos-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "https://rpc.evmos.testnet.run",
        provider: "TestNetRun"
      },
      {
        address: "https://rpc.evmos.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rpc.evmos.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://evmos-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc.evmos.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://rpc.evmos.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://evmos.rpc.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://rpc-evmos.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://evmos-rpc.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "https://evmos-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc-evmos-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://evmos-rpc.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://rpc-evmos.validavia.me",
        provider: "Validavia"
      },
      {
        address: "https://evmos-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://evmos-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://evmos.rpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://evmos-rpc.antrixy.org/",
        provider: "Antrix Validators"
      },
      {
        address: "https://evmos-mainnet.rpc.stakevillage.net:443",
        provider: "Stake Village"
      },
      {
        address: "https://rpc.evmos.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://rpc.evmos.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://rpc.evmos.citizenweb3.com:443",
        provider: "Citizen Web3"
      },
      {
        address: "https://evmos.drpc.org",
        provider: "dRPC"
      }
    ],
    rest: [
      {
        address: "https://rest.bd.evmos.org:1317",
        provider: "Blockdaemon"
      },
      {
        address: "https://rest.lavenderfive.com:443/evmos",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api-evmos-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://api.evmos.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://evmos-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://api.evmos.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://rest.evmos.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://evmos.rest.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://rest-evmos.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://evmos-api.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "https://rest-evmos.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://evmos-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://api-evmos-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://evmos-api.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://lcd-evmos.validavia.me",
        provider: "Validavia"
      },
      {
        address: "https://evmos-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://evmos-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://evmos.api.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://evmos-rest.antrixy.org/",
        provider: "Antrix Validators"
      },
      {
        address: "https://evmos-mainnet.api.stakevillage.net",
        provider: "Stake Village"
      },
      {
        address: "https://api.evmos.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://lcd.evmos.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    grpc: [
      {
        address: "grpc.bd.evmos.org:9090",
        provider: "evmos.org"
      },
      {
        address: "grpc-evmos-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "evmos.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "grpc.evmos.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "grpc-evmos.cosmos-spaces.cloud:1190",
        provider: "Cosmos Spaces"
      },
      {
        address: "evmos.grpcui.chaintools.host:443",
        provider: "ChainTools"
      },
      {
        address: "evmos-grpc.polkachu.com:13490",
        provider: "Polkachu"
      },
      {
        address: "evmos.grpc.stakin-nodes.com:443",
        provider: "Stakin"
      },
      {
        address: "evmos-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "evmos-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "grpc-evmos-01.stakeflow.io:1702",
        provider: "Stakeflow"
      },
      {
        address: "https://evmos-grpc.theamsolutions.info ",
        provider: "AM Solutions"
      },
      {
        address: "evmos-grpc.w3coins.io:13490",
        provider: "w3coins"
      },
      {
        address: "grpc-evmos.mms.team:443",
        provider: "MMS"
      },
      {
        address: "evmos-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "evmos.grpc.liveraven.net:443",
        provider: "LiveRaveN"
      },
      {
        address: "https://evmos-grpc.antrixy.org/",
        provider: "Antrix Validators"
      },
      {
        address: "evmos-mainnet.grpc.stakevillage.net:16990",
        provider: "Stake Village"
      },
      {
        address: "grpc.evmos.validatus.com:443",
        provider: "Validatus"
      },
      {
        address: "https://grpc.evmos.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://eth.bd.evmos.org:8545",
        provider: "Blockdaemon"
      },
      {
        address: "https://jsonrpc-evmos-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://evmos-json-rpc.stakely.io",
        provider: "Stakely"
      },
      {
        address: "https://jsonrpc.evmos.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://json-rpc.evmos.bh.rocks",
        provider: "BlockHunters"
      },
      {
        address: "https://evmos-json-rpc.agoranodes.com",
        provider: "AgoraNodes"
      },
      {
        address: "https://evm-rpc.evmos.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://json-rpc.evmos.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://evmosevm.rpc.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://evmos-evm.publicnode.com",
        provider: "Allnodes.com ⚡️ Nodes & Staking"
      },
      {
        address: "https://evmos-jsonrpc.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://jsonrpc-evmos.mms.team",
        provider: "MMS"
      },
      {
        address: "https://evmos-jsonrpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://evmos.jsonrpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://evmos.json.antrixy.org",
        provider: "Antrix Validators"
      },
      {
        address: "https://evmos-mainnet.jsonrpc.stakevillage.net",
        provider: "Stake Village"
      },
      {
        address: "https://json-rpc.evmos.validatus.com",
        provider: "Validatus"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/evmos",
      tx_page: "https://ezstaking.app/evmos/txs/${txHash}",
      account_page: "https://ezstaking.app/evmos/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/evmos",
      tx_page: "https://www.mintscan.io/evmos/transactions/${txHash}",
      account_page: "https://www.mintscan.io/evmos/accounts/${accountAddress}"
    },
    {
      kind: "blockscout",
      url: "https://evm.evmos.org",
      tx_page: "https://evm.evmos.org/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/evmos",
      tx_page: "https://ping.pub/evmos/tx/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://evmos.explorers.guru",
      tx_page: "https://evmos.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/evmos",
      tx_page: "https://atomscan.com/evmos/transactions/${txHash}",
      account_page: "https://atomscan.com/evmos/accounts/${accountAddress}"
    },
    {
      kind: "tcnetwork",
      url: "https://evmos.tcnetwork.io",
      tx_page: "https://evmos.tcnetwork.io/transaction/${txHash}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/evmos",
      account_page: "https://stakeflow.io/evmos/accounts/${accountAddress}"
    },
    {
      kind: "Stake Village",
      url: "https://exp.stakevillage.net/evmos",
      tx_page: "https://exp.stakevillage.net/evmos/tx/${txHash}",
      account_page: "https://exp.stakevillage.net/evmos/accounts/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/evmos",
      tx_page: "https://explorer.stavr.tech/evmos/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/evmos/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg",
    theme: {
      primary_color_hex: "#ec4c34"
    }
  }]
};
Gu.default = pR;
var Ku = {};
Object.defineProperty(Ku, "__esModule", { value: !0 });
const lR = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-18",
      connection_id: "connection-16"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-97",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-40",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-72",
      connection_id: "connection-66"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-116",
      connection_id: "connection-70"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-85",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-50",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-69",
      connection_id: "connection-27"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-11",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-73",
      connection_id: "connection-29"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-79",
      connection_id: "connection-49"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-134",
      connection_id: "connection-80"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-106",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-26",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-111",
      connection_id: "connection-66"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-82",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-117",
      connection_id: "connection-71"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-87",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-620",
      connection_id: "connection-480"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-292",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-12",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-38",
      connection_id: "connection-15"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-1136",
      connection_id: "connection-260"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-85",
      connection_id: "connection-43"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-31",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-17",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-135",
      connection_id: "connection-81"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-107",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-31",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "evmos",
      client_id: "07-tendermint-138",
      connection_id: "connection-85"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-109",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-119",
      connection_id: "connection-77"
    },
    chain_2: {
      chain_name: "gateway",
      client_id: "07-tendermint-10",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-94",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-17",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-108",
      connection_id: "connection-106"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-19",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-112",
      connection_id: "connection-92"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-83",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-113",
      connection_id: "connection-67"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-120",
      connection_id: "connection-157"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-83",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-117",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-53",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-25",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-106",
      connection_id: "connection-63"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-12",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1840",
      connection_id: "connection-1440"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-204",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-50",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-42",
      connection_id: "connection-24"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-41",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-173",
      connection_id: "connection-104"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-77",
      connection_id: "connection-33"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-8",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-88",
      connection_id: "connection-46"
    },
    chain_2: {
      chain_name: "tgrade",
      client_id: "07-tendermint-8",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Ku.default = lR;
var Xu = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(jt, "__esModule", { value: !0 });
jt.ibc = jt.chain = jt.assets = void 0;
const gR = Xu(Vu), uR = Xu(Gu), _R = Xu(Ku);
jt.assets = gR.default;
jt.chain = uR.default;
jt.ibc = _R.default;
var Ct = {}, Yu = {};
Object.defineProperty(Yu, "__esModule", { value: !0 });
const yR = {
  $schema: "../assetlist.schema.json",
  chain_name: "fetchhub",
  assets: [{
    description: "The native staking and governance token of the Fetch Hub.",
    denom_units: [{
      denom: "afet",
      exponent: 0
    }, {
      denom: "fet",
      exponent: 18
    }],
    base: "afet",
    name: "fetch-ai",
    display: "fet",
    symbol: "FET",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.svg"
    },
    coingecko_id: "fetch-ai",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.svg",
      theme: {
        primary_color_hex: "#1c2444"
      }
    }]
  }, {
    description: "The MOBX coin rewards the use of eco-friendly micromobility transportation.",
    denom_units: [{
      denom: "nanomobx",
      exponent: 0
    }, {
      denom: "mobx",
      exponent: 9
    }],
    base: "nanomobx",
    name: "MOBIX",
    display: "mobx",
    symbol: "MOBX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/mobx.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/mobx.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/mobx.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/mobx.svg",
      theme: {
        primary_color_hex: "#04ae9b"
      }
    }]
  }]
};
Yu.default = yR;
var Ju = {};
Object.defineProperty(Ju, "__esModule", { value: !0 });
const bR = {
  $schema: "../chain.schema.json",
  chain_name: "fetchhub",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Fetch.ai",
  chain_type: "cosmos",
  chain_id: "fetchhub-4",
  bech32_prefix: "fetch",
  daemon_name: "fetchd",
  node_home: "$HOME/.fetchd",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "afet",
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.035
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "afet"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc-fetchhub.fetch.ai:443",
        provider: "fetch.ai"
      },
      {
        address: "https://rpc-fetchhub-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://fetch-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://fetchai-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://fetch-rpc.antrixy.org",
        provider: "Antrix"
      },
      {
        address: "https://rpc-fetch.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://fetchhub-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://fetch-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://fetch-rpc.cosmosrescue.com",
        provider: "cosmosrescue"
      },
      {
        address: "https://fetch-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://fetch-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://fetch-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://public.stakewolle.com/cosmos/fetchhub/rpc",
        provider: "Stakewolle"
      },
      {
        address: "https://fetch.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      },
      {
        address: "https://rpc.fetchhub-4.fetch.aviaone.com",
        provider: "AVIAONE 🟢"
      },
      {
        address: "https://fetchai-rpc.bluestake.net:443",
        provider: "BlueStake 🚀"
      }
    ],
    rest: [
      {
        address: "https://rest-fetchhub.fetch.ai",
        provider: "fetch.ai"
      },
      {
        address: "https://api-fetchhub-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://fetch-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://fetchai-api.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://fetch-rest.antrixy.org",
        provider: "Antrix"
      },
      {
        address: "https://fetchhub-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest-fetch.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://fetch-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://fetch-api.cosmosrescue.com",
        provider: "cosmosrescue"
      },
      {
        address: "https://fetch-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://fetch-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://fetch-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://public.stakewolle.com/cosmos/fetchhub/rest",
        provider: "Stakewolle"
      },
      {
        address: "https://fetch.api.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      },
      {
        address: "https://api.fetchhub-4.fetch.aviaone.com/",
        provider: "AVIAONE 🟢"
      },
      {
        address: "https://fetchai-api.bluestake.net",
        provider: "BlueStake 🚀"
      }
    ],
    grpc: [
      {
        address: "grpc-fetchhub.fetch.ai:443",
        provider: "fetch.ai"
      },
      {
        address: "grpc-fetchhub-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "fetch-grpc.polkachu.com:15290",
        provider: "Polkachu"
      },
      {
        address: "fetchhub-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "fetch-grpc.teasel.org:443",
        provider: "𝗧𝗲𝗮𝘀𝗲𝗹"
      },
      {
        address: "fetch-grpc.antrixy.org:443",
        provider: "Antrix"
      },
      {
        address: "fetch-grpc.cosmosrescue.com:9090",
        provider: "cosmosrescue"
      },
      {
        address: "fetch-grpc.w3coins.io:15290",
        provider: "w3coins"
      },
      {
        address: "fetch-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "fetch.grpc.nodeshub.online",
        provider: "Nodes Hub"
      },
      {
        address: "grpc.fetchhub-4.fetch.aviaone.com:9094",
        provider: "AVIAONE 🟢"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/fetchai",
      tx_page: "https://www.mintscan.io/fetchai/transactions/${txHash}",
      account_page: "https://www.mintscan.io/fetchai/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/fetchhub",
      tx_page: "https://ezstaking.app/fetchhub/txs/${txHash}",
      account_page: "https://ezstaking.app/fetchhub/account/${accountAddress}"
    },
    {
      kind: "bigdipper",
      url: "https://explore-fetchhub.fetch.ai",
      tx_page: "https://explore-fetchhub.fetch.ai/transactions/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/fetchhub",
      tx_page: "https://ping.pub/fetchhub/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/fetchai",
      tx_page: "https://atomscan.com/fetchai/transactions/${txHash}",
      account_page: "https://atomscan.com/fetchai/accounts/${accountAddress}"
    },
    {
      kind: "bigdipper",
      url: "https://fetch-explorer.teasel.org",
      tx_page: "https://fetch-explorer.teasel.org/transactions/${txHash}"
    },
    {
      kind: "azoyalabs",
      url: "https://fetchstation.azoyalabs.com/mainnet",
      tx_page: "https://fetchstation.azoyalabs.com/mainnet/explorer/transactions/${txHash}",
      account_page: "https://fetchstation.azoyalabs.com/mainnet/explorer/address/${accountAddress}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
      url: "https://explorer.nodeshub.online/fetchhub/",
      tx_page: "https://explorer.nodeshub.online/fetchhub/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/fetchhub/accounts/${accountAddress}"
    },
    {
      kind: "Blockchain Explorer by AVIAONE 🟢",
      url: "https://mainnet.explorer.aviaone.com/fetchhub",
      tx_page: "https://mainnet.explorer.aviaone.com/fetchhub/tx/${txHash}",
      account_page: "https://mainnet.explorer.aviaone.com/fetchhub/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.svg",
    theme: {
      primary_color_hex: "#1c2444"
    }
  }]
};
Ju.default = bR;
var Zu = {};
Object.defineProperty(Zu, "__esModule", { value: !0 });
const vR = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "fetchhub",
    client_id: "07-tendermint-10",
    connection_id: "connection-10"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1913",
    connection_id: "connection-1490"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-10",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-229",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Zu.default = vR;
var Qu = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ct, "__esModule", { value: !0 });
Ct.ibc = Ct.chain = Ct.assets = void 0;
const fR = Qu(Yu), wR = Qu(Ju), xR = Qu(Zu);
Ct.assets = fR.default;
Ct.chain = wR.default;
Ct.ibc = xR.default;
var sr = {}, e_ = {};
Object.defineProperty(e_, "__esModule", { value: !0 });
const kR = {
  $schema: "../assetlist.schema.json",
  chain_name: "finschia",
  assets: [{
    description: "The native token of Finschia",
    denom_units: [{
      denom: "cony",
      exponent: 0
    }, {
      denom: "fnsa",
      exponent: 6
    }],
    type_asset: "sdk.coin",
    base: "cony",
    name: "Finschia",
    display: "fnsa",
    symbol: "FNSA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.svg",
      theme: {
        primary_color_hex: "#040404"
      }
    }],
    coingecko_id: "link",
    keywords: ["staking"]
  }]
};
e_.default = kR;
var n_ = {};
Object.defineProperty(n_, "__esModule", { value: !0 });
const AR = {
  $schema: "../chain.schema.json",
  chain_name: "finschia",
  chain_type: "cosmos",
  chain_id: "finschia-2",
  website: "https://www.finschia.io/",
  pretty_name: "Finschia",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "link",
  daemon_name: "fnsad",
  node_home: "$HOME/.finschia",
  key_algos: ["secp256k1"],
  slip44: 438,
  fees: {
    fee_tokens: [{
      denom: "cony",
      fixed_min_gas_price: 0.015,
      low_gas_price: 0.015,
      average_gas_price: 0.015,
      high_gas_price: 0.015
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "cony"
    }],
    lock_duration: {
      time: "604800s"
    }
  },
  codebase: {
    cosmos_sdk_version: "github.com/Finschia/finschia-sdk@v0.48.1",
    cosmwasm_enabled: !0,
    cosmwasm_version: "github.com/Finschia/wasmd@v0.2.0"
  },
  description: "Finschia (formerly LINE Blockchain Mainnet) aims to build a sustainable token model and create token demand to become a blockchain with 1 billion users.",
  apis: {
    rpc: [{
      address: "https://finschia-rpc.finschia.io"
    }],
    rest: [{
      address: "https://finschia-api.finschia.io"
    }],
    grpc: [{
      address: "finschia-grpc.finschia.io:443"
    }]
  },
  explorers: [{
    kind: "mintscan",
    url: "https://www.mintscan.io/finschia",
    tx_page: "https://www.mintscan.io/finschia/tx/${txHash}",
    account_page: "https://www.mintscan.io/finschia/address/${accountAddress}"
  }, {
    kind: "ezstaking",
    url: "https://ezstaking.app/finschia",
    tx_page: "https://ezstaking.app/finschia/txs/${txHash}",
    account_page: "https://ezstaking.app/finschia/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.svg",
    theme: {
      primary_color_hex: "#040404"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.svg"
  }
};
n_.default = AR;
var B9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(sr, "__esModule", { value: !0 });
sr.chain = sr.assets = void 0;
const jR = B9(e_), CR = B9(n_);
sr.assets = jR.default;
sr.chain = CR.default;
var Et = {}, t_ = {};
Object.defineProperty(t_, "__esModule", { value: !0 });
const ER = {
  $schema: "../assetlist.schema.json",
  chain_name: "firmachain",
  assets: [{
    description: "FIRMACHAIN adds a signing and verifying e-contract function to the blockchain. Unlocking new limits of electronic contracts with blockchain technology, FIRMACHAIN seeks to resolve all the social and legal issues (contracts, notarial, etc.) with written contracts through the use of electronic contracts based on FIRMACHAIN’s data blockchain.",
    denom_units: [{
      denom: "ufct",
      exponent: 0
    }, {
      denom: "fct",
      exponent: 6
    }],
    base: "ufct",
    name: "FIRMACHAIN",
    display: "fct",
    symbol: "FCT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.svg"
    },
    coingecko_id: "firmachain",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.svg",
      theme: {
        primary_color_hex: "#1c1c1c"
      }
    }]
  }]
};
t_.default = ER;
var s_ = {};
Object.defineProperty(s_, "__esModule", { value: !0 });
const DR = {
  $schema: "../chain.schema.json",
  chain_name: "firmachain",
  status: "live",
  network_type: "mainnet",
  website: "https://firmachain.org/",
  pretty_name: "FIRMACHAIN",
  chain_type: "cosmos",
  chain_id: "colosseum-1",
  bech32_prefix: "firma",
  slip44: 7777777,
  daemon_name: "firmachaind",
  node_home: "$HOME/.firmachain",
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "ufct",
      fixed_min_gas_price: 0.1,
      low_gas_price: 0.1,
      average_gas_price: 0.15,
      high_gas_price: 0.2
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ufct"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://lcd-mainnet.firmachain.dev:26657",
        provider: "FirmaChain"
      },
      {
        address: "https://firma.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.firmachain.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://rpc.lavenderfive.com:443/firmachain",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://firmachain-rpc.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://firmachain.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      },
      {
        address: "https://firmachain_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://lcd-mainnet.firmachain.dev:1317",
        provider: "FirmaChain"
      },
      {
        address: "https://firma.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.firmachain.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://rest.lavenderfive.com:443/firmachain",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://firmachain-api.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://firmachain.api.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      },
      {
        address: "https://firmachain_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "firmachain.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "firma.grpc.m.stavr.tech:2030",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://firmachain-grpc.ramuchi.tech:1390",
        provider: "ramuchi.tech"
      },
      {
        address: "firmachain.grpc.nodeshub.online",
        provider: "Nodes Hub"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/firmachain",
      tx_page: "https://ezstaking.app/firmachain/txs/${txHash}",
      account_page: "https://ezstaking.app/firmachain/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Firmachain-M",
      tx_page: "https://explorer.stavr.tech/Firmachain-M/txs/${txHash}",
      account_page: "https://explorer.stavr.tech/Firmachain-M/account/${accountAddress}"
    },
    {
      kind: "bigdipper",
      url: "https://explorer.firmachain.dev",
      tx_page: "https://explorer.firmachain.dev/transactions/${txHash}"
    },
    {
      kind: "explorer.ChainTools",
      url: "https://explorer.chaintools.tech/firmachain",
      tx_page: "https://explorer.chaintools.tech/firmachain/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/firmachain",
      tx_page: "https://atomscan.com/firmachain/transactions/${txHash}",
      account_page: "https://atomscan.com/firmachain/accounts/${accountAddress}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
      url: "https://explorer.nodeshub.online/firmachain/",
      tx_page: "https://explorer.nodeshub.online/firmachain/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/firmachain/accounts/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/firmachain",
      tx_page: "https://explorer.whenmoonwhenlambo.money/firmachain/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/firmachain/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.svg",
    theme: {
      primary_color_hex: "#1c1c1c"
    }
  }]
};
s_.default = DR;
var a_ = {};
Object.defineProperty(a_, "__esModule", { value: !0 });
const BR = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "firmachain",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3236",
    connection_id: "connection-2723"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-79241",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
a_.default = BR;
var o_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Et, "__esModule", { value: !0 });
Et.ibc = Et.chain = Et.assets = void 0;
const FR = o_(t_), $R = o_(s_), zR = o_(a_);
Et.assets = FR.default;
Et.chain = $R.default;
Et.ibc = zR.default;
var Dt = {}, r_ = {};
Object.defineProperty(r_, "__esModule", { value: !0 });
const qR = {
  $schema: "../assetlist.schema.json",
  chain_name: "furya",
  assets: [{
    description: "The native token of Furya",
    denom_units: [{
      denom: "ufury",
      exponent: 0
    }, {
      denom: "fury",
      exponent: 6
    }],
    base: "ufury",
    name: "Furya",
    display: "fury",
    symbol: "FURY",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.svg",
      theme: {
        primary_color_hex: "#040404"
      }
    }],
    coingecko_id: "fanfury",
    keywords: ["gaming", "staking"],
    socials: {
      twitter: "https://twitter.com/furyachain"
    }
  }]
};
r_.default = qR;
var i_ = {};
Object.defineProperty(i_, "__esModule", { value: !0 });
const SR = {
  $schema: "../chain.schema.json",
  chain_name: "furya",
  status: "live",
  network_type: "mainnet",
  website: "https://furya.xyz/",
  pretty_name: "furya",
  chain_type: "cosmos",
  chain_id: "furya-1",
  daemon_name: "furyad",
  node_home: "$HOME/.furyad",
  bech32_prefix: "furya",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ufury",
      low_gas_price: 0.1,
      average_gas_price: 0.25,
      high_gas_price: 0.5
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ufury"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/chain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/chain.svg"
  },
  apis: {
    rpc: [{
      address: "https://furya-rpc.synergynodes.com",
      provider: "synergynodes"
    }, {
      address: "https://furya.rpc.nodeshub.online:443",
      provider: "nodeshub"
    }],
    rest: [{
      address: "https://furya.api.nodeshub.online",
      provider: "synergynodes"
    }, {
      address: "https://furya.api.nodeshub.online:443",
      provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
    }],
    grpc: [{
      address: "https://furya.grpc.nodeshub.online",
      provider: "Nodes Hub"
    }]
  },
  explorers: [{
    kind: "Furya Explorer",
    url: "https://explorer.furya.network/furya-1/",
    tx_page: "https://explorer.furya.network/furya-1/tx/${txHash}",
    account_page: "https://explorer.furya.network/furya-1/account/${accountAddress}"
  }, {
    kind: "Nodeshub Explorer",
    url: "https://explorer.nodeshub.online/furya",
    tx_page: "https://explorer.nodeshub.online/furya/txs/${txHash}",
    account_page: "https://explorer.nodeshub.online/furya/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/chain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/chain.svg",
    theme: {
      primary_color_hex: "#040404"
    }
  }]
};
i_.default = SR;
var c_ = {};
Object.defineProperty(c_, "__esModule", { value: !0 });
const TR = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "furya",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-501",
      connection_id: "connection-505"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-417",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "furya",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-160",
      connection_id: "connection-123"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-119",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "furya",
      client_id: "07-tendermint-5",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-67",
      connection_id: "connection-64"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "furya",
      client_id: "07-tendermint-10",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3201",
      connection_id: "connection-2658"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-74222",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "furya",
      client_id: "07-tendermint-14",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-422",
      connection_id: "connection-436"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-495",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
c_.default = TR;
var d_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Dt, "__esModule", { value: !0 });
Dt.ibc = Dt.chain = Dt.assets = void 0;
const RR = d_(r_), OR = d_(i_), MR = d_(c_);
Dt.assets = RR.default;
Dt.chain = OR.default;
Dt.ibc = MR.default;
var Bt = {}, m_ = {};
Object.defineProperty(m_, "__esModule", { value: !0 });
const IR = {
  $schema: "../assetlist.schema.json",
  chain_name: "fxcore",
  assets: [{
    description: "The native staking token of the Function X",
    extended_description: "FX coin is the native token on the Function X ecosystem. It is currently utilized as a governance token as well as a gas token on f(x)Core and f(x)EVM. The subnets that are built on the Function X ecosystem can also choose to utilize FX as their gas token.",
    denom_units: [{
      denom: "FX",
      exponent: 0
    }, {
      denom: "WFX",
      exponent: 18
    }],
    base: "FX",
    name: "Function X",
    display: "WFX",
    symbol: "FX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.svg"
    },
    coingecko_id: "fx-coin",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.svg",
      theme: {
        primary_color_hex: "#1c1c1c"
      }
    }],
    socials: {
      website: "https://functionx.io",
      twitter: "https://x.com/functionx_io"
    }
  }, {
    description: "The cross chain token of the Function X",
    extended_description: `PUNDIX token is the native token that functions within the Pundi X ecosystem, including PundiX Chain and XPOS. PUNDIX has several core use cases, including:
- Payment for goods and services from merchants through XPOS
- Gas Fee on PundiX Chain
- Listing tokens in the XPOS
- Merchant payments for loyalty programs and ads`,
    denom_units: [{
      denom: "eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
      exponent: 0
    }, {
      denom: "PUNDIX",
      exponent: 18
    }],
    base: "eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
    display: "PUNDIX",
    name: "Pundi X Token",
    symbol: "PUNDIX",
    traces: [{
      type: "bridge",
      counterparty: {
        chain_name: "ethereum",
        base_denom: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
        contract: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"
      },
      provider: "Function X"
    }],
    images: [{
      image_sync: {
        chain_name: "ethereum",
        base_denom: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-token-logo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-token-logo.svg",
      theme: {
        primary_color_hex: "#f1d20c"
      }
    }],
    socials: {
      website: "https://pundix.com",
      twitter: "https://x.com/PundiXLabs"
    }
  }]
};
m_.default = IR;
var h_ = {};
Object.defineProperty(h_, "__esModule", { value: !0 });
const NR = {
  $schema: "../chain.schema.json",
  chain_name: "fxcore",
  chain_type: "cosmos",
  chain_id: "fxcore",
  website: "https://functionx.io",
  pretty_name: "f(x)Core",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "fx",
  daemon_name: "fxcored",
  node_home: "$HOME/.fxcore",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "FX",
      fixed_min_gas_price: 4e12,
      low_gas_price: 4e12,
      average_gas_price: 42e11,
      high_gas_price: 5e12
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "FX"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.13"
  },
  apis: {
    rpc: [{
      address: "https://fx-json.functionx.io",
      provider: "Function X"
    }, {
      address: "https://functionx.rpc.nodeshub.online:443",
      provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
    }],
    rest: [{
      address: "https://fx-rest.functionx.io",
      provider: "Function X"
    }, {
      address: "https://functionx.api.nodeshub.online:443",
      provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
    }],
    grpc: [
      {
        address: "https://fx-grpc.functionx.io",
        provider: "Function X"
      },
      {
        address: "https://fx-grpc.portfolio-x.xyz:9090",
        provider: "Portfolio X"
      },
      {
        address: "functionx.grpc.nodeshub.online",
        provider: "Nodes Hub"
      }
    ],
    "evm-http-jsonrpc": [{
      address: "https://fx-web3.functionx.io",
      provider: "Function X"
    }]
  },
  explorers: [
    {
      kind: "starscan",
      url: "https://starscan.io",
      tx_page: "https://starscan.io/fxcore/tx/${txHash}",
      account_page: "https://starscan.io/fxcore/address/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/fx",
      tx_page: "https://explorer.tcnetwork.io/fx/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/fx/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/fxcore",
      tx_page: "https://ping.pub/fxcore/tx/${txHash}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
      url: "https://explorer.nodeshub.online/fxcore/",
      tx_page: "https://explorer.nodeshub.online/fxcore/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/fxcore/accounts/${accountAddress}"
    }
  ]
};
h_.default = NR;
var p_ = {};
Object.defineProperty(p_, "__esModule", { value: !0 });
const PR = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-188",
      connection_id: "connection-166"
    },
    chain_2: {
      chain_name: "fxcore",
      client_id: "07-tendermint-24",
      connection_id: "connection-23"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-128",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1141",
      connection_id: "connection-829"
    },
    chain_2: {
      chain_name: "fxcore",
      client_id: "07-tendermint-13",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-585",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "fxcore",
      client_id: "07-tendermint-23",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2961",
      connection_id: "connection-2456"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2716",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "fxcore",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "pundix",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
p_.default = PR;
var l_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Bt, "__esModule", { value: !0 });
Bt.ibc = Bt.chain = Bt.assets = void 0;
const UR = l_(m_), HR = l_(h_), LR = l_(p_);
Bt.assets = UR.default;
Bt.chain = HR.default;
Bt.ibc = LR.default;
var Ft = {}, g_ = {};
Object.defineProperty(g_, "__esModule", { value: !0 });
const WR = {
  $schema: "../assetlist.schema.json",
  chain_name: "galaxy",
  assets: [{
    description: "GLX is the staking token of the Galaxy Chain",
    denom_units: [{
      denom: "uglx",
      exponent: 0
    }, {
      denom: "glx",
      exponent: 6
    }],
    base: "uglx",
    name: "Galaxy",
    display: "glx",
    symbol: "GLX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.svg",
      theme: {
        primary_color_hex: "#5e3be6"
      }
    }]
  }]
};
g_.default = WR;
var u_ = {};
Object.defineProperty(u_, "__esModule", { value: !0 });
const VR = {
  $schema: "../chain.schema.json",
  chain_name: "galaxy",
  status: "live",
  network_type: "mainnet",
  website: "https://galaxychain.zone/",
  pretty_name: "Galaxy",
  chain_type: "cosmos",
  chain_id: "galaxy-1",
  bech32_prefix: "galaxy",
  daemon_name: "galaxyd",
  node_home: "$HOME/.galaxy",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uglx",
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.035
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uglx"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.svg"
  },
  apis: {
    rpc: [],
    rest: [],
    grpc: []
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://explorer.postcapitalist.io/Galaxy",
    tx_page: "https://explorer.postcapitalist.io/Galaxy/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.svg",
    theme: {
      primary_color_hex: "#5e3be6"
    }
  }]
};
u_.default = VR;
var __ = {};
Object.defineProperty(__, "__esModule", { value: !0 });
const GR = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "galaxy",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1928",
    connection_id: "connection-1500"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-236",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
__.default = GR;
var y_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ft, "__esModule", { value: !0 });
Ft.ibc = Ft.chain = Ft.assets = void 0;
const KR = y_(g_), XR = y_(u_), YR = y_(__);
Ft.assets = KR.default;
Ft.chain = XR.default;
Ft.ibc = YR.default;
var $t = {}, b_ = {};
Object.defineProperty(b_, "__esModule", { value: !0 });
const JR = {
  $schema: "../assetlist.schema.json",
  chain_name: "gateway",
  assets: [
    {
      description: "The native fee token of Gateway.",
      denom_units: [{
        denom: "utest",
        exponent: 0
      }, {
        denom: "test",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "utest",
      name: "Test",
      display: "test",
      symbol: "TEST"
    },
    {
      description: "the native staking token of Gateway.",
      denom_units: [{
        denom: "uworm",
        exponent: 0
      }, {
        denom: "worm",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "uworm",
      name: "Worm",
      display: "worm",
      symbol: "WORM"
    },
    {
      description: "Sui (Wormhole), SUI, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh",
        exponent: 0
      }, {
        denom: "wormhole/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh/8",
        exponent: 8
      }],
      address: "wormhole19hlynxzedrlqv99v6qscww7d3crhl86qtd0vprpltg5g9xx6jk9q6ya33y",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh",
      display: "wormhole/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh/8",
      name: "Sui (Wormhole)",
      symbol: "SUI",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "sui",
          base_denom: "0x2::sui::SUI"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "sui",
          base_denom: "0x2::sui::SUI"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/sui/images/sui.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/sui/images/sui.svg"
      }
    },
    {
      description: "Wrapped Ether (Wormhole), WETH, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp",
        exponent: 0
      }, {
        denom: "wormhole/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp/8",
        exponent: 8
      }],
      address: "wormhole18csycs4vm6varkp00apuqlsm7v4twg8jsljk8wfdd7cghr7g4rtslwqndm",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp",
      display: "wormhole/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp/8",
      name: "Wrapped Ether (Wormhole)",
      symbol: "WETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"
        },
        provider: "Wormhole"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg",
        theme: {
          primary_color_hex: "#303030"
        }
      }]
    },
    {
      description: "Wrapped liquid staked Ether 2.0 (Wormhole), wstETH, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5TSQTEhJ5Q6r1YqCmCxTRSPiV2pGx5rZUQf6g2XH4e1b",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5TSQTEhJ5Q6r1YqCmCxTRSPiV2pGx5rZUQf6g2XH4e1b",
        exponent: 0
      }, {
        denom: "wormhole/5TSQTEhJ5Q6r1YqCmCxTRSPiV2pGx5rZUQf6g2XH4e1b/8",
        exponent: 8
      }],
      address: "wormhole1gg6f95cymcfrfzhpek7cf5wl53t5kng52cd2m0krgdlu8k58vd8qezy8pt",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5TSQTEhJ5Q6r1YqCmCxTRSPiV2pGx5rZUQf6g2XH4e1b",
      display: "wormhole/5TSQTEhJ5Q6r1YqCmCxTRSPiV2pGx5rZUQf6g2XH4e1b/8",
      name: "Wrapped liquid staked Ether 2.0 (Wormhole)",
      symbol: "wstETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }
    },
    {
      description: "Aptos Coin (Wormhole), APT, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r",
        exponent: 0
      }, {
        denom: "wormhole/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r/8",
        exponent: 8
      }],
      address: "wormhole1f9sxjn0qu8xylcpzlvnhrefnatndqxnrajfrnr5h97hegnmsdqhsh6juc0",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r",
      display: "wormhole/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r/8",
      name: "Aptos Coin (Wormhole)",
      symbol: "APT",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "aptos",
          base_denom: "0x1::aptos_coin::AptosCoin"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "aptos",
          base_denom: "0x1::aptos_coin::AptosCoin"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/aptos/images/aptos.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/aptos/images/aptos.svg"
      }
    },
    {
      description: "Tether USD (Wormhole), USDT, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi",
        exponent: 0
      }, {
        denom: "wormhole/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi/6",
        exponent: 6
      }],
      address: "wormhole1w27ekqvvtzfanfxnkw4jx2f8gdfeqwd3drkee3e64xat6phwjg0savgmhw",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi",
      display: "wormhole/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi/6",
      name: "Tether USD (Wormhole)",
      symbol: "USDT",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    },
    {
      description: "Wrapped SOL (Wormhole), SOL, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA",
        exponent: 0
      }, {
        denom: "wormhole/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA/8",
        exponent: 8
      }],
      address: "wormhole1wn625s4jcmvk0szpl85rj5azkfc6suyvf75q6vrddscjdphtve8sca0pvl",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA",
      display: "wormhole/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA/8",
      name: "Wrapped SOL (Wormhole)",
      symbol: "SOL",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "So11111111111111111111111111111111111111112"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "So11111111111111111111111111111111111111112"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        theme: {
          circle: !0,
          background_color_hex: "#000000"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg"
      }
    },
    {
      description: "Bonk (Wormhole), Bonk, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR",
        exponent: 0
      }, {
        denom: "wormhole/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR/5",
        exponent: 5
      }],
      address: "wormhole10qt8wg0n7z740ssvf3urmvgtjhxpyp74hxqvqt7z226gykuus7eq9mpu8u",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR",
      display: "wormhole/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR/5",
      name: "Bonk (Wormhole)",
      symbol: "Bonk",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bonk.png",
        theme: {
          primary_color_hex: "#ee950a"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bonk.png"
      }
    },
    {
      description: "Wrapped BTC (Wormhole), WBTC, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/BGkuAcga2WArUghF8L6kt6uCAhAzrxmn1QcbQqi5r5bd",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/BGkuAcga2WArUghF8L6kt6uCAhAzrxmn1QcbQqi5r5bd",
        exponent: 0
      }, {
        denom: "wormhole/BGkuAcga2WArUghF8L6kt6uCAhAzrxmn1QcbQqi5r5bd/8",
        exponent: 8
      }],
      address: "wormhole1nz0r0au8aj6dc00wmm3ufy4g4k86rjzlr8wkf92cktdlps5lgfcqxnx9yk",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/BGkuAcga2WArUghF8L6kt6uCAhAzrxmn1QcbQqi5r5bd",
      display: "wormhole/BGkuAcga2WArUghF8L6kt6uCAhAzrxmn1QcbQqi5r5bd/8",
      name: "Wrapped BTC (Wormhole)",
      symbol: "WBTC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg",
        theme: {
          primary_color_hex: "#f39444"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg"
      }
    },
    {
      description: "tBTC v2 (Wormhole), tBTC, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/BhqTYfQogyt7jX7cx7x8uHEQP1x9fdtdBZtK4Swghgpw",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/BhqTYfQogyt7jX7cx7x8uHEQP1x9fdtdBZtK4Swghgpw",
        exponent: 0
      }, {
        denom: "wormhole/BhqTYfQogyt7jX7cx7x8uHEQP1x9fdtdBZtK4Swghgpw/8",
        exponent: 8
      }],
      address: "wormhole1nu9wf9dw384attnpu0pwfet5fajn05w2ex4r07mghvk3xcwrt2yq5uutp5",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/BhqTYfQogyt7jX7cx7x8uHEQP1x9fdtdBZtK4Swghgpw",
      display: "wormhole/BhqTYfQogyt7jX7cx7x8uHEQP1x9fdtdBZtK4Swghgpw/8",
      name: "tBTC v2 (Wormhole)",
      symbol: "tBTC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x18084fba666a33d37592fa2633fd49a74dd93a88"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x18084fba666a33d37592fa2633fd49a74dd93a88"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/tbtc.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/tbtc.svg"
      }
    },
    {
      description: "Dai Stablecoin (Wormhole), DAI, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/EKiMEqDnPKokFGcSXDvGMk6Gt1BJ6BC7BDZzTmEpWLH1",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/EKiMEqDnPKokFGcSXDvGMk6Gt1BJ6BC7BDZzTmEpWLH1",
        exponent: 0
      }, {
        denom: "wormhole/EKiMEqDnPKokFGcSXDvGMk6Gt1BJ6BC7BDZzTmEpWLH1/8",
        exponent: 8
      }],
      address: "wormhole1chejx4qqtvwxy6684yrsmf6pylancxqhk3vsmtleg5ta3zrffljqfscg87",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/EKiMEqDnPKokFGcSXDvGMk6Gt1BJ6BC7BDZzTmEpWLH1",
      display: "wormhole/EKiMEqDnPKokFGcSXDvGMk6Gt1BJ6BC7BDZzTmEpWLH1/8",
      name: "Dai Stablecoin (Wormhole)",
      symbol: "DAI",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      }
    },
    {
      description: "USD Coin (Wormhole), USDC, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt",
        exponent: 0
      }, {
        denom: "wormhole/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt/6",
        exponent: 6
      }],
      address: "wormhole1utjx3594tlvfw4375esgu72wa4sdgf0q7x4ye27husf5kvuzp5rsr72gdq",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt",
      display: "wormhole/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt/6",
      name: "USD Coin (Wormhole)",
      symbol: "USDC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }
    },
    {
      description: "Avalanche USD Coin (Wormhole), Avalanche USDC, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4",
        exponent: 0
      }, {
        denom: "wormhole/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4/6",
        exponent: 6
      }],
      address: "wormhole1utjx3594tlvfw4375esgu72wa4sdgf0q7x4ye27husf5kvuzp5rsr72gdq",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4",
      display: "wormhole/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4/6",
      name: "Avalanche USD Coin (Wormhole)",
      symbol: "avalanche.USDC.wh",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "avalanche",
          base_denom: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "avalanche",
          base_denom: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }
    },
    {
      description: "Pyth Network (Wormhole), PYTH, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy",
        exponent: 0,
        aliases: ["HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3"]
      }, {
        denom: "wormhole/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy/6",
        exponent: 6,
        aliases: ["pyth"]
      }],
      address: "wormhole1utjx3594tlvfw4375esgu72wa4sdgf0q7x4ye27husf5kvuzp5rsr72gdq",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy",
      display: "wormhole/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy/6",
      name: "Pyth Network",
      symbol: "PYTH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pyth.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pyth.svg"
      }
    },
    {
      description: "Solana USD Coin (Wormhole), Solana USDC, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3",
        exponent: 0
      }, {
        denom: "wormhole/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3/6",
        exponent: 6
      }],
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3",
      display: "wormhole/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3/6",
      name: "Solana USD Coin (Wormhole)",
      symbol: "solana.USDC.wh",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }
    },
    {
      description: "Basket (Wormhole), BSKT, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst",
        exponent: 0,
        aliases: ["6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA", "wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst"]
      }, {
        denom: "wormhole/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst/5",
        exponent: 5,
        aliases: ["bskt"]
      }],
      address: "wormhole15rantn6k68twp4wmsljtk9uu9a0e5rt7g66fdfkvrsr24hj6je7qat93e6",
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst",
      display: "wormhole/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst/5",
      name: "Basket",
      symbol: "BSKT",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bskt.png",
        theme: {
          primary_color_hex: "#485573"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bskt.png"
      }
    },
    {
      description: "W is the native token powering the Wormhole interoperability platform.",
      type_asset: "sdk.coin",
      address: "wormhole1zecpd6puhcpgqgkjtwr59cc8cj3v89c5jkx0vr26fcclhhv7pmfqsuurzm",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/2Wb6ueMFc9WLc2eyYVha6qnwHKbwzUXdooXsg6XXVvos",
        exponent: 0
      }, {
        denom: "w",
        exponent: 6
      }],
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/2Wb6ueMFc9WLc2eyYVha6qnwHKbwzUXdooXsg6XXVvos",
      name: "Wormhole Token",
      display: "w",
      symbol: "W",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ"
        },
        provider: "Wormhole"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/w.png"
      },
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/w.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Pepe Bruce Jenner",
      extended_description: "$PBJ is the culture coin for Solana, eat dis!",
      denom_units: [{
        denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP",
        exponent: 0,
        aliases: ["ANu4Wuq86WzRU8tykszQUJ66eQzFNfkwap2HcQ5UaFaU", "wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP"]
      }, {
        denom: "wormhole/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP/6",
        exponent: 6,
        aliases: ["pbj", "PBJ"]
      }],
      base: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP",
      display: "wormhole/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP/6",
      name: "Pepe Bruce Jenner",
      symbol: "PBJ",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "ANu4Wuq86WzRU8tykszQUJ66eQzFNfkwap2HcQ5UaFaU"
        },
        provider: "Wormhole"
      }],
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "ANu4Wuq86WzRU8tykszQUJ66eQzFNfkwap2HcQ5UaFaU"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pbj.png",
        theme: {
          primary_color_hex: "#488000",
          background_color_hex: "#ee0000"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pbj.png"
      }
    }
  ]
};
b_.default = JR;
var v_ = {};
Object.defineProperty(v_, "__esModule", { value: !0 });
const ZR = {
  $schema: "../chain.schema.json",
  chain_name: "gateway",
  status: "live",
  network_type: "mainnet",
  website: "https://wormhole.com",
  pretty_name: "Wormhole Gateway",
  chain_type: "cosmos",
  chain_id: "wormchain",
  bech32_prefix: "wormhole",
  daemon_name: "wormchaind",
  node_home: "$HOME/.wormchaind",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utest",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0
    }]
  },
  codebase: {
    cosmos_sdk_version: "github.com/wormhole-foundation/cosmos-sdk@v0.45.9-wormhole-2",
    cosmwasm_enabled: !0,
    cosmwasm_version: "github.com/wormhole-foundation/wasmd@v0.30.0-wormchain-2"
  },
  images: [{
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gateway/images/wormhole_icon.svg",
    theme: {
      background_color_hex: "#231b3b",
      primary_color_hex: "#231b3b",
      circle: !1
    }
  }, {
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gateway/images/wormhole_circle.svg",
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gateway/images/wormhole_circle.png",
    theme: {
      background_color_hex: "#231b3b",
      primary_color_hex: "#231b3b",
      circle: !0
    }
  }],
  logo_URIs: {
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gateway/images/wormhole_icon.svg"
  },
  apis: {
    rpc: [{
      address: "https://tncnt-eu-wormchain-main-01.rpc.p2p.world/",
      provider: "P2P"
    }, {
      address: "https://wormchain-rpc.quickapi.com/",
      provider: "ChainLayer"
    }],
    rest: [{
      address: "https://tncnt-eu-wormchain-main-01.rpc.p2p.world/lcd/",
      provider: "P2P"
    }, {
      address: "https://wormchain-lcd.quickapi.com/",
      provider: "ChainLayer"
    }],
    grpc: [{
      address: "tncnt-eu-wormchain-main-01-grpc.rpc.p2p.world:80",
      provider: "P2P"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://bigdipper.live/wormhole",
    tx_page: "https://bigdipper.live/wormhole/transactions/${txHash}",
    account_page: "https://bigdipper.live/wormhole/accounts/${accountAddress}"
  }],
  keywords: ["bridge"]
};
v_.default = ZR;
var f_ = {};
Object.defineProperty(f_, "__esModule", { value: !0 });
const QR = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-119",
      connection_id: "connection-77"
    },
    chain_2: {
      chain_name: "gateway",
      client_id: "07-tendermint-10",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-94",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gateway",
      client_id: "07-tendermint-18",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-248",
      connection_id: "connection-241"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-183",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gateway",
      client_id: "07-tendermint-13",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-153",
      connection_id: "connection-117"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-113",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gateway",
      client_id: "07-tendermint-8",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2927",
      connection_id: "connection-2424"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2186",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gateway",
      client_id: "07-tendermint-16",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-354",
      connection_id: "connection-290"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-278",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
f_.default = QR;
var w_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty($t, "__esModule", { value: !0 });
$t.ibc = $t.chain = $t.assets = void 0;
const eO = w_(b_), nO = w_(v_), tO = w_(f_);
$t.assets = eO.default;
$t.chain = nO.default;
$t.ibc = tO.default;
var zt = {}, x_ = {};
Object.defineProperty(x_, "__esModule", { value: !0 });
const sO = {
  $schema: "../assetlist.schema.json",
  chain_name: "genesisl1",
  assets: [{
    description: "L1 coin is the GenesisL1 blockchain utility, governance and EVM token",
    denom_units: [{
      denom: "el1",
      exponent: 0
    }, {
      denom: "l1",
      exponent: 18
    }],
    base: "el1",
    name: "GenesisL1",
    display: "l1",
    symbol: "L1",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.svg",
      theme: {
        primary_color_hex: "#040404"
      }
    }]
  }]
};
x_.default = sO;
var k_ = {};
Object.defineProperty(k_, "__esModule", { value: !0 });
const aO = {
  $schema: "../chain.schema.json",
  chain_name: "genesisl1",
  status: "live",
  network_type: "mainnet",
  pretty_name: "GenesisL1",
  chain_type: "cosmos",
  chain_id: "genesis_29-2",
  bech32_prefix: "genesis",
  daemon_name: "genesisd",
  node_home: "$HOME/.genesis",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "el1",
      low_gas_price: 51e9,
      average_gas_price: 52e9,
      high_gas_price: 53e9
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "el1"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46.15"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.svg"
  },
  apis: {
    rpc: [{
      address: "https://26657.genesisl1.org",
      provider: "GenesisL1"
    }],
    rest: [{
      address: "https://api.genesisl1.org",
      provider: "GenesisL1"
    }, {
      address: "https://1317.genesisl1.org",
      provider: "GenesisL1"
    }],
    "evm-http-jsonrpc": [{
      address: "https://rpc.genesisl1.org",
      provider: "GenesisL1"
    }]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/genesisL1",
      tx_page: "https://ping.pub/genesisL1/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://exp.utsa.tech/genesis",
      tx_page: "https://exp.utsa.tech/genesis/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Genesisl1",
      tx_page: "https://explorer.stavr.tech/Genesisl1/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Genesisl1/accounts/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/genesisl1",
      tx_page: "https://atomscan.com/genesisl1/transactions/${txHash}",
      account_page: "https://atomscan.com/genesisl1/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.svg",
    theme: {
      primary_color_hex: "#040404"
    }
  }]
};
k_.default = aO;
var A_ = {};
Object.defineProperty(A_, "__esModule", { value: !0 });
const oO = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "genesisl1",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1983",
    connection_id: "connection-1539"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-253",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
A_.default = oO;
var j_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(zt, "__esModule", { value: !0 });
zt.ibc = zt.chain = zt.assets = void 0;
const rO = j_(x_), iO = j_(k_), cO = j_(A_);
zt.assets = rO.default;
zt.chain = iO.default;
zt.ibc = cO.default;
var qt = {}, C_ = {};
Object.defineProperty(C_, "__esModule", { value: !0 });
const dO = {
  $schema: "../assetlist.schema.json",
  chain_name: "gitopia",
  assets: [{
    description: "The native token of Gitopia",
    denom_units: [{
      denom: "ulore",
      exponent: 0
    }, {
      denom: "LORE",
      exponent: 6
    }],
    base: "ulore",
    name: "LORE",
    display: "LORE",
    symbol: "LORE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/lore.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/lore.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/lore.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/lore.svg",
      theme: {
        primary_color_hex: "#2c173c"
      }
    }, {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/gitopia.png",
      theme: {
        primary_color_hex: "#2e154d"
      }
    }],
    coingecko_id: "gitopia",
    socials: {
      website: "https://gitopia.com/",
      twitter: "https://twitter.com/gitopiaDAO"
    }
  }]
};
C_.default = dO;
var E_ = {};
Object.defineProperty(E_, "__esModule", { value: !0 });
const mO = {
  $schema: "../chain.schema.json",
  chain_name: "gitopia",
  status: "live",
  website: "https://gitopia.com/",
  network_type: "mainnet",
  pretty_name: "Gitopia",
  chain_type: "cosmos",
  chain_id: "gitopia",
  bech32_prefix: "gitopia",
  daemon_name: "gitopiad",
  node_home: "$HOME/.gitopia",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ulore",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 12e-4,
      average_gas_price: 16e-4,
      high_gas_price: 24e-4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ulore"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.47.13"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/gitopia.png",
    theme: {
      primary_color_hex: "#2e154d"
    }
  }],
  description: "Gitopia is the next-generation Code Collaboration Platform fuelled by a decentralized network and interactive token economy. It is designed to optimize the open-source software development process through collaboration, transparency, and incentivization.",
  apis: {
    rpc: [
      {
        address: "https://gitopia-rpc.polkachu.com:443",
        provider: "polkachu"
      },
      {
        address: "https://rpc.lavenderfive.com:443/gitopia",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc.gitopia.nodestake.top:443",
        provider: "nodestake"
      },
      {
        address: "https://gitopia-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://gitopia-rpc.ibs.team:443",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://m-gitopia.rpc.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "http://gitopia.rpc.m.stavr.tech:51057",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://gitopia-rpc.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://gitopia.rpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://gitopia-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://rpc.gitopia.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://gitopia-rpc.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://rpc-gitopia.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://gitopia.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://rpc.gitopia.sgtstake.com",
        provider: "SGTstake"
      },
      {
        address: "https://mainnet-gitopia-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://rpc.gitopia.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://gitopia.rpc.moonbridge.team",
        provider: "Moonbridge"
      },
      {
        address: "https://gitopia-rpc.stakeangle.com",
        provider: "StakeAngle"
      },
      {
        address: "https://gitopia.rpc.m.anode.team",
        provider: "AlxVoy ⚡ ANODE.TEAM"
      },
      {
        address: "https://gitopia.rpc.stakevillage.net",
        provider: "Stake Village"
      },
      {
        address: "https://gitopia-rpc.enigma-validator.com/",
        provider: "Enigma"
      },
      {
        address: "https://rpc.gitopia.tcnetwork.io/",
        provider: "TC Network"
      },
      {
        address: "https://gitopia.nodejumper.io:443",
        provider: "NODEJUMPER"
      },
      {
        address: "https://rpc.gitopia.stakeup.tech/",
        provider: "StakeUp"
      },
      {
        address: "https://gitopia-mainnet.rpc.l0vd.com:443",
        provider: "L0vd.com ❤️"
      },
      {
        address: "https://gitopia-rpc.tothemars.network:443",
        provider: "ToTheMars"
      },
      {
        address: "https://gitopia.declab.pro:26625",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://gitopia-rpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [
      {
        address: "https://gitopia-api.polkachu.com:443",
        provider: "polkachu"
      },
      {
        address: "https://rest.lavenderfive.com:443/gitopia",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api.gitopia.nodestake.top:443",
        provider: "nodestake"
      },
      {
        address: "https://gitopia-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://gitopia-mainnet-lcd.autostake.com:443",
        provider: "autostake"
      },
      {
        address: "https://gitopia-api.ibs.team:443",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://m-gitopia.api.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://gitopia.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://gitopia-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://gitopia.api.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://gitopia-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://api.gitopia.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://gitopia-api.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://api-gitopia.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://gitopia.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://api.gitopia.sgtstake.com/",
        provider: "SGTstake"
      },
      {
        address: "https://mainnet-gitopia-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://api.gitopia.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://gitopia.api.moonbridge.team",
        provider: "Moonbridge"
      },
      {
        address: "http://gitopia-rpc.stakeangle.com:41317",
        provider: "StakeAngle"
      },
      {
        address: "https://gitopia.api.m.anode.team",
        provider: "AlxVoy ⚡ ANODE.TEAM"
      },
      {
        address: "https://gitopia.api.stakevillage.net",
        provider: "Stake Village"
      },
      {
        address: "https://gitopia-lcd.enigma-validator.com/",
        provider: "Enigma"
      },
      {
        address: "https://rest.gitopia.tcnetwork.io/",
        provider: "TC Network"
      },
      {
        address: "https://gitopia.nodejumper.io:1317",
        provider: "NODEJUMPER"
      },
      {
        address: "https://api.gitopia.stakeup.tech/",
        provider: "StakeUp"
      },
      {
        address: "https://gitopia-mainnet.api.l0vd.com:443",
        provider: "L0vd.com ❤️"
      },
      {
        address: "https://gitopia-api.tothemars.network:443",
        provider: "ToTheMars"
      },
      {
        address: "https://gitopia.declab.pro:443",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://gitopia-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "grpc.gitopia.indonode.net:26090",
        provider: "indonode"
      },
      {
        address: "gitopia.grpc.nodersteam.com:9201",
        provider: "[NODERS]TEAM"
      },
      {
        address: "gitopia-grpc.polkachu.com:11390",
        provider: "polkachu"
      },
      {
        address: "services.staketab.com:9410",
        provider: "Staketab"
      },
      {
        address: "gitopia.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://grpc.gitopia.nodestake.top:443",
        provider: "nodestake"
      },
      {
        address: "https://grpc-gitopia.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "http://gitopia.grpc.m.stavr.tech:5123",
        provider: "🔥STAVR🔥"
      },
      {
        address: "gitopia-grpc.genznodes.dev:33090",
        provider: "genznodes"
      },
      {
        address: "https://grpc.gitopia.hexnodes.co:16090",
        provider: "Hexnodes"
      },
      {
        address: "https://gitopia.grpc.liveraven.net:443",
        provider: "LiveRaveN"
      },
      {
        address: "https://grpc.gitopia.indonode.net:26090",
        provider: "Indonode"
      },
      {
        address: "gitopia-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "grpc.gitopia.silentvalidator.com:443",
        provider: "silent"
      },
      {
        address: "https://gitopia-grpc.ramuchi.tech:16001",
        provider: "ramuchi.tech"
      },
      {
        address: "grpc-gitopia.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "gitopia.grpc.kjnodes.com:14190",
        provider: "kjnodes"
      },
      {
        address: "grpc.gitopia.roomit.xyz:8443",
        provider: "Roomit"
      },
      {
        address: "https://gitopia.grpc.moonbridge.team",
        provider: "Moonbridge"
      },
      {
        address: "http://gitopia-rpc.stakeangle.com:41390",
        provider: "StakeAngle"
      },
      {
        address: "https://gitopia.grpc.m.anode.team",
        provider: "AlxVoy ⚡ ANODE.TEAM"
      },
      {
        address: "https://grpc.gitopia.sbgid.com",
        provider: "kokos"
      },
      {
        address: "mainnet-gitopia-grpc.konsortech.xyz:38090",
        provider: "KonsorTech"
      },
      {
        address: "gitopia.grpc.stakevillage.net:14190",
        provider: "Stake Village"
      },
      {
        address: "gitopia.nodejumper.io:9090",
        provider: "NODEJUMPER"
      },
      {
        address: "grpc.gitopia.stakeup.tech:443",
        provider: "StakeUp"
      },
      {
        address: "gitopia-mainnet.grpc.l0vd.com:80",
        provider: "L0vd.com ❤️"
      },
      {
        address: "gitopia-grpc.tothemars.network:21190",
        provider: "ToTheMars"
      },
      {
        address: "https://gitopia.declab.pro:9017",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "gitopia-grpc.noders.services:19090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/gitopia",
      tx_page: "https://ping.pub/gitopia/tx/${txHash}",
      account_page: "https://ping.pub/gitopia/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Gitopia-M",
      tx_page: "https://explorer.stavr.tech/Gitopia-M/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Gitopia-M/account/${accountAddress}"
    },
    {
      kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
      url: "https://exp.utsa.tech/gitopia",
      tx_page: "https://exp.utsa.tech/gitopia/tx/${txHash}",
      account_page: "https://exp.utsa.tech/gitopia/account/${accountAddress}"
    },
    {
      kind: "Nodeist",
      url: "https://exp.nodeist.net/gitopia",
      tx_page: "https://exp.nodeist.net/gitopia/tx/${txHash}",
      account_page: "https://exp.nodeist.net/gitopia/account/${accountAddress}"
    },
    {
      kind: "Stake-Take",
      url: "https://explorer.stake-take.com/gitopia",
      tx_page: "https://explorer.stake-take.com/gitopia/tx/${txHash}",
      account_page: "https://explorer.stake-take.com/gitopia/account/${accountAddress}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodexcapital.com/gitopia",
      tx_page: "https://explorer.nodexcapital.com/gitopia/tx/${txHash}",
      account_page: "https://explorer.nodexcapital.com/gitopia/account/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/gitopia",
      tx_page: "https://explorer.tcnetwork.io/gitopia/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/gitopia/account/${accountAddress}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.top/gitopia",
      tx_page: "https://explorer.nodestake.top/gitopia/tx/${txHash}",
      account_page: "https://explorer.nodestake.top/gitopia/account/${accountAddress}"
    },
    {
      kind: "Roomit",
      url: "https://explorer.tendermint.roomit.xyz/gitopia-mainnet",
      tx_page: "https://explorer.tendermint.roomit.xyz/gitopia-mainnet/transaction/${txHash}",
      account_page: "https://explorer.tendermint.roomit.xyz/gitopia-mainnet/account/${accountAddress}"
    },
    {
      kind: "Moonbridge",
      url: "https://explorer.moonbridge.team/gitopia",
      tx_page: "https://explorer.moonbridge.team/gitopia/tx/${txHash}",
      account_page: "https://explorer.moonbridge.team/gitopia/account/${accountAddress}"
    },
    {
      kind: "KonsorTech",
      url: "https://explorer.konsortech.xyz/gitopia",
      tx_page: "https://explorer.konsortech.xyz/gitopia/tx/${txHash}",
      account_page: "https://explorer.konsortech.xyz/gitopia/account/${accountAddress}"
    },
    {
      kind: "Stake Village",
      url: "https://exp.stakevillage.net/gitopia",
      tx_page: "https://exp.stakevillage.net/gitopia/tx/${txHash}",
      account_page: "https://exp.stakevillage.net/gitopia/account/${accountAddress}"
    },
    {
      kind: "AlxVoy ⚡ ANODE.TEAM",
      url: "https://main.anode.team/gitopia",
      tx_page: "https://main.anode.team/gitopia/tx/${txHash}",
      account_page: "https://main.anode.team/gitopia/account/${accountAddress}"
    },
    {
      kind: "L0vd.com ❤️",
      url: "https://chain-services.l0vd.com/mainnets/gitopia",
      tx_page: "https://chain-services.l0vd.com/mainnets/gitopia/tx/${txHash}",
      account_page: "https://chain-services.l0vd.com/mainnets/gitopia/account/${accountAddress}"
    },
    {
      kind: "ToTheMars",
      url: "https://explorer.tothemars.network/gitopia",
      tx_page: "https://explorer.tothemars.network/gitopia/tx/${txHash}",
      account_page: "https://explorer.tothemars.network/gitopia/account/${accountAddress}"
    },
    {
      kind: "Decloud Nodes Lab",
      url: "https://explorer.declab.pro/Gitopia",
      tx_page: "https://explorer.declab.pro/Gitopia/tx/${txHash}",
      account_page: "https://explorer.declab.pro/Gitopia/account/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/gitopia",
      tx_page: "https://mainnet.whispernode.com/gitopia/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/gitopia/account/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/gitopia.png"
  }
};
E_.default = mO;
var D_ = {};
Object.defineProperty(D_, "__esModule", { value: !0 });
const hO = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "gitopia",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2787",
    connection_id: "connection-2287"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-781",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
D_.default = hO;
var B_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(qt, "__esModule", { value: !0 });
qt.ibc = qt.chain = qt.assets = void 0;
const pO = B_(C_), lO = B_(E_), gO = B_(D_);
qt.assets = pO.default;
qt.chain = lO.default;
qt.ibc = gO.default;
var ar = {}, F_ = {};
Object.defineProperty(F_, "__esModule", { value: !0 });
const uO = {
  $schema: "../assetlist.schema.json",
  chain_name: "govgen",
  assets: [{
    description: "The native staking and governance token of GovGen",
    denom_units: [{
      denom: "ugovgen",
      exponent: 0
    }, {
      denom: "govgen",
      exponent: 6
    }],
    base: "ugovgen",
    name: "GovGen",
    display: "govgen",
    symbol: "GOVGEN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/govgen/images/govgen.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/govgen/images/govgen.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/govgen/images/govgen.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/govgen/images/govgen.svg",
      theme: {
        primary_color_hex: "#65d6d4"
      }
    }]
  }]
};
F_.default = uO;
var $_ = {};
Object.defineProperty($_, "__esModule", { value: !0 });
const _O = {
  $schema: "../chain.schema.json",
  chain_name: "govgen",
  chain_type: "cosmos",
  chain_id: "govgen-1",
  website: "https://govgen.io/",
  pretty_name: "GovGen",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "govgen",
  daemon_name: "govgend",
  node_home: "$HOME/.govgen",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ugovgen",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 6e-3,
      average_gas_price: 6e-3,
      high_gas_price: 9e-3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ugovgen"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.45.16"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/govgen/images/govgen.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/govgen/images/govgen.svg"
  },
  description: "GovGen is a governance-only chain separate from the proposed AtomOne hub chain. GovGen aims to gauge the sentiment of those who voted “NO” or “NO_WITH_VETO” on Cosmos Hub proposal 848 regarding the potential future of AtomOne. Through the native, non-transferable GOVGEN governance-only token, this community can come together to discuss, debate, submit proposals, and help shape the future of AtomOne in a fully decentralized community-driven initiative.",
  apis: {
    rpc: [
      {
        address: "https://rpc.govgen.io:443",
        provider: "AllInBits"
      },
      {
        address: "https://rpc-govgen.sg-1.online/",
        provider: "SG-1"
      },
      {
        address: "https://govgen.rpc.nodeshub.online:443",
        provider: "Nodes Hub"
      },
      {
        address: "https://govgen-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc.govgen.posthuman.digital:443",
        provider: "posthuman"
      },
      {
        address: "https://rpc-govgen.kewrnode.com/",
        provider: "Kewr Node"
      }
    ],
    rest: [
      {
        address: "https://api.govgen.io/",
        provider: "AllInBits"
      },
      {
        address: "https://api-govgen.sg-1.online/",
        provider: "SG-1"
      },
      {
        address: "https://govgen.api.nodeshub.online/",
        provider: "Nodes Hub"
      },
      {
        address: "https://govgen-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rest.govgen.posthuman.digital:443",
        provider: "posthuman"
      },
      {
        address: "https://rest-govgen.kewrnode.com/",
        provider: "Kewr Node"
      }
    ],
    grpc: [
      {
        address: "govgen-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://govgen.grpc.nodeshub.online:443",
        provider: "Nodes Hub"
      },
      {
        address: "https://grpc.govgen.posthuman.digital:443",
        provider: "posthuman"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://explorer.govgen.io/",
      tx_page: "https://explorer.govgen.io/govgen/tx/${txHash}",
      account_page: "https://explorer.govgen.io/govgen/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.nodeshub.online/govgen",
      tx_page: "https://explorer.nodeshub.online/govgen/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/govgen/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.equinoxdao.xyz/govgen",
      tx_page: "https://explorer.equinoxdao.xyz/govgen/tx/${txHash}",
      account_page: "https://explorer.equinoxdao.xyz/govgen/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://test.explorer.ist/govgen",
      tx_page: "https://test.explorer.ist/govgen/tx/${txHash}",
      account_page: "https://test.explorer.ist/govgen/account/${accountAddress}"
    },
    {
      kind: "posthuman",
      url: "https://explorer.posthuman.digital/govgen",
      tx_page: "https://explorer.posthuman.digital/govgen/tx/${txHash}",
      account_page: "https://explorer.posthuman.digital/govgen/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/govgen/images/govgen.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/govgen/images/govgen.svg",
    theme: {
      primary_color_hex: "#65d6d4"
    }
  }]
};
$_.default = _O;
var F9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ar, "__esModule", { value: !0 });
ar.chain = ar.assets = void 0;
const yO = F9(F_), bO = F9($_);
ar.assets = yO.default;
ar.chain = bO.default;
var St = {}, z_ = {};
Object.defineProperty(z_, "__esModule", { value: !0 });
const vO = {
  $schema: "../assetlist.schema.json",
  chain_name: "gravitybridge",
  assets: [
    {
      description: "The native token of Gravity Bridge",
      denom_units: [{
        denom: "ugraviton",
        exponent: 0
      }, {
        denom: "graviton",
        exponent: 6
      }],
      base: "ugraviton",
      name: "Graviton",
      display: "graviton",
      symbol: "GRAV",
      coingecko_id: "graviton",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.svg",
        theme: {
          primary_color_hex: "#042ca4"
        }
      }],
      socials: {
        website: "https://www.gravitybridge.net/",
        twitter: "https://twitter.com/gravity_bridge"
      }
    },
    {
      description: "pSTAKE is a liquid staking protocol unlocking the liquidity of staked assets.",
      denom_units: [{
        denom: "gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
        exponent: 0
      }, {
        denom: "pstake",
        exponent: 18
      }],
      base: "gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
      name: "pSTAKE Finance",
      display: "pstake",
      symbol: "PSTAKE",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "persistence",
          base_denom: "uxprt"
        },
        provider: "Persistence"
      }, {
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006"
        },
        provider: "Gravity Bridge"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.svg",
        theme: {
          primary_color_hex: "#050505"
        }
      }]
    },
    {
      description: "Gravity Bridge WETH",
      denom_units: [{
        denom: "gravity0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        exponent: 0
      }, {
        denom: "gweth",
        exponent: 18
      }],
      base: "gravity0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      name: "Wrapped Ethereum",
      display: "gweth",
      symbol: "WETH",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      },
      traces: [{
        type: "wrapped",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "Ethereum"
      }, {
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"
        },
        provider: "Gravity Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }]
    },
    {
      description: "Gravity Bridge USDC",
      denom_units: [{
        denom: "gravity0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        exponent: 0
      }, {
        denom: "gusdc",
        exponent: 6
      }],
      base: "gravity0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      name: "USD Coin",
      display: "gusdc",
      symbol: "USDC",
      coingecko_id: "gravity-bridge-usdc",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "Circle"
      }, {
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        provider: "Gravity Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "Gravity Bridge USDT",
      denom_units: [{
        denom: "gravity0xdAC17F958D2ee523a2206206994597C13D831ec7",
        exponent: 0
      }, {
        denom: "gusdt",
        exponent: 6
      }],
      base: "gravity0xdAC17F958D2ee523a2206206994597C13D831ec7",
      name: "Tether USD",
      display: "gusdt",
      symbol: "USDT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      },
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "Tether"
      }, {
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        provider: "Gravity Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }]
    },
    {
      description: "Gravity Bridge WBTC",
      denom_units: [{
        denom: "gravity0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        exponent: 0
      }, {
        denom: "gwbtc",
        exponent: 8
      }],
      base: "gravity0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      name: "Wrapped Bitcoin",
      display: "gwbtc",
      symbol: "WBTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg"
      },
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "bitcoin",
          base_denom: "sat"
        },
        provider: "BitGo, Kyber, and Ren"
      }, {
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        },
        provider: "Gravity Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg",
        theme: {
          primary_color_hex: "#f39444"
        }
      }]
    },
    {
      description: "Gravity Bridge DAI",
      denom_units: [{
        denom: "gravity0x6B175474E89094C44Da98b954EedeAC495271d0F",
        exponent: 0
      }, {
        denom: "gdai",
        exponent: 18
      }],
      base: "gravity0x6B175474E89094C44Da98b954EedeAC495271d0F",
      name: "Dai Stablecoin",
      display: "gdai",
      symbol: "DAI",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      },
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "MakerDAO"
      }, {
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f"
        },
        provider: "Gravity Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      }]
    },
    {
      description: "Gravity Bridge sDAI",
      denom_units: [{
        denom: "gravity0x83F20F44975D03b1b09e64809B757c47f942BEeA",
        exponent: 0
      }, {
        denom: "gsdai",
        exponent: 18
      }],
      base: "gravity0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      name: "Savings Dai",
      display: "gsdai",
      symbol: "sDAI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sdai.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sdai.svg"
      },
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x83F20F44975D03b1b09e64809B757c47f942BEeA"
        },
        provider: "Gravity Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x83F20F44975D03b1b09e64809B757c47f942BEeA"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sdai.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sdai.svg",
        theme: {
          primary_color_hex: "#7ec231"
        }
      }]
    },
    {
      description: "Gravity Bridge OCC",
      denom_units: [{
        denom: "gravity0x2F109021aFe75B949429fe30523Ee7C0D5B27207",
        exponent: 0
      }, {
        denom: "gocc",
        exponent: 18
      }],
      base: "gravity0x2F109021aFe75B949429fe30523Ee7C0D5B27207",
      name: "OccamFi",
      display: "gocc",
      symbol: "OCC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/occamfi.png"
      },
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x2F109021aFe75B949429fe30523Ee7C0D5B27207"
        },
        provider: "Gravity Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x2F109021aFe75B949429fe30523Ee7C0D5B27207"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/occamfi.png",
        theme: {
          primary_color_hex: "#313648"
        }
      }]
    },
    {
      description: "The PAGE token is used for actions in the PageDAO NFT literary ecosystem and for DAO governance.",
      denom_units: [{
        denom: "gravity0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e",
        exponent: 0
      }, {
        denom: "page",
        exponent: 8
      }],
      base: "gravity0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e",
      name: "Page",
      display: "page",
      symbol: "PAGE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.svg"
      },
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e"
        },
        provider: "Gravity Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.svg",
        theme: {
          primary_color_hex: "#ebb324"
        }
      }]
    },
    {
      description: "Gravity Bridge Paxos Gold",
      denom_units: [{
        denom: "gravity0x45804880De22913dAFE09f4980848ECE6EcbAf78",
        exponent: 0
      }, {
        denom: "gpaxg",
        exponent: 18
      }],
      base: "gravity0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      name: "Paxos Gold",
      display: "gpaxg",
      symbol: "PAXG",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/paxg.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/paxg.svg"
      },
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x45804880De22913dAFE09f4980848ECE6EcbAf78"
        },
        provider: "Gravity Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x45804880De22913dAFE09f4980848ECE6EcbAf78"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/paxg.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/paxg.svg",
        theme: {
          primary_color_hex: "#ebe60e"
        }
      }]
    }
  ]
};
z_.default = vO;
var q_ = {};
Object.defineProperty(q_, "__esModule", { value: !0 });
const fO = {
  $schema: "../chain.schema.json",
  chain_name: "gravitybridge",
  status: "live",
  network_type: "mainnet",
  website: "https://www.gravitybridge.net/",
  pretty_name: "Gravity Bridge",
  chain_type: "cosmos",
  chain_id: "gravity-bridge-3",
  bech32_prefix: "gravity",
  daemon_name: "gravity",
  node_home: "$HOME/.gravity",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [
      {
        denom: "ugraviton",
        fixed_min_gas_price: 0,
        low_gas_price: 0,
        average_gas_price: 0,
        high_gas_price: 0.035
      },
      {
        denom: "gravity0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        low_gas_price: 2e-4,
        average_gas_price: 5e-4,
        high_gas_price: 8e-4
      },
      {
        denom: "gravity0xdAC17F958D2ee523a2206206994597C13D831ec7",
        low_gas_price: 2e-4,
        average_gas_price: 5e-4,
        high_gas_price: 8e-4
      }
    ]
  },
  staking: {
    staking_tokens: [{
      denom: "ugraviton"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.svg"
  },
  description: "An open, decentralized bridge that unlocks the power of interoperability & liquidity between blockchain ecosystems.",
  apis: {
    rpc: [
      {
        address: "https://gravitychain.io:26657",
        provider: "althea"
      },
      {
        address: "http://gravity-bridge-1-08.nodes.amhost.net:26657",
        provider: "amhost"
      },
      {
        address: "https://gravity-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-gravitybridge-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc.lavenderfive.com:443/gravitybridge",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc.gravity.bh.rocks/",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://gravity-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://gravity-rpc.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://rpc-gravity-bridge-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://gravity-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://gravity-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://rpc.g-bridge.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://rpc.gravity-bridge-3.gravity.aviaone.com:443",
        provider: "AviaOne 🟢"
      }
    ],
    rest: [
      {
        address: "https://gravitychain.io:1317",
        provider: "althea"
      },
      {
        address: "https://api-gravitybridge-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://gravity-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rest.lavenderfive.com:443/gravitybridge",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api.gravity.bh.rocks/",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://gravity-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://gravity-api.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://api-gravity-bridge-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://gravity-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://gravity-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://lcd.g-bridge.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://api.gravity-bridge-3.gravity.aviaone.com",
        provider: "AviaOne 🟢"
      }
    ],
    grpc: [
      {
        address: "gravity-bridge-1-08.nodes.amhost.net:9090",
        provider: "amhost"
      },
      {
        address: "grpc-gravitybridge-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "gravity-grpc.polkachu.com:14290",
        provider: "Polkachu"
      },
      {
        address: "gravitybridge.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://gravity-grpc.ramuchi.tech:10090",
        provider: "ramuchi.tech"
      },
      {
        address: "grpc-gravity-bridge-01.stakeflow.io:1302",
        provider: "Stakeflow"
      },
      {
        address: "services.staketab.com:9017",
        provider: "Staketab"
      },
      {
        address: "gravity-grpc.w3coins.io:14290",
        provider: "w3coins"
      },
      {
        address: "https://grpc.g-bridge.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "grpc.gravity-bridge-3.gravity.aviaone.com:9200",
        provider: "AviaOne 🟢"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/gravitybridge",
      tx_page: "https://ezstaking.app/gravitybridge/txs/${txHash}",
      account_page: "https://ezstaking.app/gravitybridge/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/gravity-bridge",
      tx_page: "https://www.mintscan.io/gravity-bridge/transactions/${txHash}",
      account_page: "https://www.mintscan.io/gravity-bridge/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/gravity-bridge",
      tx_page: "https://ping.pub/gravity-bridge/tx/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://gravity.explorers.guru",
      tx_page: "https://gravity.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/gravity-bridge",
      tx_page: "https://atomscan.com/gravity-bridge/transactions/${txHash}",
      account_page: "https://atomscan.com/gravity-bridge/accounts/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/gravitybridge",
      tx_page: "https://explorer.tcnetwork.io/gravitybridge/transaction/${txHash}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/gravity-bridge",
      account_page: "https://stakeflow.io/gravity-bridge/accounts/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/GravityBridge",
      tx_page: "https://explorer.stavr.tech/GravityBridge/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/GravityBridge/accounts/${accountAddress}"
    },
    {
      kind: "AviaOne 🟢",
      url: "https://mainnet.explorer.aviaone.com/gravity-bridge",
      tx_page: "https://mainnet.explorer.aviaone.com/gravity-bridge/tx/${txHash}",
      account_page: "https://mainnet.explorer.aviaone.com/gravity-bridge/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.svg",
    theme: {
      primary_color_hex: "#042ca4"
    }
  }]
};
q_.default = fO;
var S_ = {};
Object.defineProperty(S_, "__esModule", { value: !0 });
const wO = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-201",
      connection_id: "connection-175"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-106",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-4",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-173",
      connection_id: "connection-154"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-91",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-40",
      connection_id: "connection-43"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-424",
      connection_id: "connection-406"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-145",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "canto",
      client_id: "07-tendermint-0",
      connection_id: "07-tendermint-0"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-156",
      connection_id: "connection-150"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cheqd",
      client_id: "07-tendermint-13",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-64",
      connection_id: "connection-74"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-43",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-8",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-421",
      connection_id: "connection-399"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-142",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-4",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-100",
      connection_id: "connection-102"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-17",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-108",
      connection_id: "connection-106"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-192",
      connection_id: "connection-163"
    },
    chain_2: {
      chain_name: "haqq",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-100",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-225",
      connection_id: "connection-189"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-69",
      connection_id: "connection-45"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-107",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-33",
      connection_id: "connection-44"
    },
    chain_2: {
      chain_name: "nyx",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-13",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1737",
      connection_id: "connection-1340"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-144",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-39",
      connection_id: "connection-50"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-51",
      connection_id: "connection-49"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-195",
      connection_id: "connection-165"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-102",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-140",
      connection_id: "connection-139"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-40",
      connection_id: "connection-23"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-79",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-150",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-148",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-190",
      connection_id: "connection-161"
    },
    chain_2: {
      chain_name: "unification",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-98",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
S_.default = wO;
var T_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(St, "__esModule", { value: !0 });
St.ibc = St.chain = St.assets = void 0;
const xO = T_(z_), kO = T_(q_), AO = T_(S_);
St.assets = xO.default;
St.chain = kO.default;
St.ibc = AO.default;
var Tt = {}, R_ = {};
Object.defineProperty(R_, "__esModule", { value: !0 });
const jO = {
  $schema: "../assetlist.schema.json",
  chain_name: "haqq",
  assets: [{
    description: "The native EVM, governance and staking token of the Haqq Network",
    denom_units: [{
      denom: "aISLM",
      exponent: 0
    }, {
      denom: "ISLM",
      exponent: 18
    }],
    base: "aISLM",
    name: "Islamic Coin",
    display: "ISLM",
    symbol: "ISLM",
    coingecko_id: "islamic-coin",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/islm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/islm.svg"
    },
    socials: {
      website: "https://islamiccoin.net",
      twitter: "https://x.com/1slamic_coin"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/islm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/islm.svg",
      theme: {
        primary_color_hex: "#04cd80"
      }
    }]
  }, {
    description: "Deenar gold-backed stablecoin",
    extended_description: "Deenar Gold (DEEN) is a 1:1 gold-backed halal stablecoin with the ability to physically deliver gold. 1 DEEN = 1 gram of gold.",
    denom_units: [{
      denom: "erc20/0x4FEBDDe47Ab9a76200e57eFcC80b212a07b3e6cE",
      exponent: 0
    }, {
      denom: "DEEN",
      exponent: 6
    }],
    base: "erc20/0x4FEBDDe47Ab9a76200e57eFcC80b212a07b3e6cE",
    name: "Deenar",
    display: "DEEN",
    address: "0x4FEBDDe47Ab9a76200e57eFcC80b212a07b3e6cE",
    symbol: "DEEN",
    type_asset: "erc20",
    traces: [{
      type: "synthetic",
      counterparty: {
        chain_name: "comex",
        base_denom: "XAU"
      },
      provider: "Deenar"
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/deen.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/deen.svg"
    },
    coingecko_id: "deenar-gold",
    socials: {
      website: "https://deenar.com",
      twitter: "https://x.com/DeenarGold"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/deen.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/deen.svg",
      theme: {
        primary_color_hex: "#ffbc05",
        circle: !0
      }
    }]
  }]
};
R_.default = jO;
var O_ = {};
Object.defineProperty(O_, "__esModule", { value: !0 });
const CO = {
  $schema: "../chain.schema.json",
  chain_name: "haqq",
  status: "live",
  network_type: "mainnet",
  website: "https://haqq.network/",
  pretty_name: "Haqq Network",
  chain_type: "cosmos",
  chain_id: "haqq_11235-1",
  bech32_prefix: "haqq",
  node_home: "$HOME/.haqqd",
  daemon_name: "haqqd",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aISLM",
      fixed_min_gas_price: 25e7,
      low_gas_price: 2e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aISLM"
    }]
  },
  codebase: {
    cosmos_sdk_version: "evmos/cosmos-sdk v0.47.12-evmos.2"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/haqq.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/haqq.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.tm.haqq.network",
        provider: "Haqq"
      },
      {
        address: "https://rpc.haqq.sh",
        provider: "kioqq"
      },
      {
        address: "https://rpc.haqq.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://haqq-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc.lavenderfive.com:443/haqq",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-haqq.sr20de.xyz:443",
        provider: "Sr20de"
      },
      {
        address: "https://haqq-rpc.palamar.io",
        provider: "Palamar"
      },
      {
        address: "https://haqq-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://haqq.drpc.org",
        provider: "dRPC"
      }
    ],
    rest: [
      {
        address: "https://rest.cosmos.haqq.network",
        provider: "Haqq"
      },
      {
        address: "https://sdk.haqq.sh",
        provider: "kioqq"
      },
      {
        address: "https://api.haqq.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://haqq-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rest.lavenderfive.com:443/haqq",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://mainnet-haqq-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://api-haqq.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://haqq-api.palamar.io",
        provider: "Palamar"
      },
      {
        address: "https://haqq-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "https://grpc.cosmos.haqq.network",
        provider: "Haqq"
      },
      {
        address: "grpc.haqq.sh:443",
        provider: "kioqq"
      },
      {
        address: "haqq.grpc.nodersteam.com:9191",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://grpc.haqq.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "haqq-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "haqq.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "mainnet-haqq-grpc.konsortech.xyz:11090",
        provider: "KonsorTech"
      },
      {
        address: "https://grpc-haqq.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "haqq-grpc.palamar.io:443",
        provider: "Palamar"
      },
      {
        address: "haqq-grpc.noders.services:14090",
        provider: "[NODERS]TEAM"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://rpc.eth.haqq.network",
        provider: "Haqq"
      },
      {
        address: "https://evm.haqq.sh",
        provider: "kioqq"
      },
      {
        address: "https://jsonrpc.haqq.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://haqq-evm.publicnode.com",
        provider: "Allnodes.com ⚡️ Nodes & Staking"
      },
      {
        address: "https://jsonrpc.lavenderfive.com:443/haqq",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://mainnet-haqq-evm.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://evm-haqq.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://haqq-jsonrpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "blockscout",
      url: "https://explorer.haqq.network",
      tx_page: "https://explorer.haqq.network/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/haqq",
      tx_page: "https://ping.pub/haqq/tx/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://haqq.explorers.guru",
      tx_page: "https://haqq.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/haqq",
      tx_page: "https://explorer.nodestake.top/haqq/tx/${txHash}"
    },
    {
      kind: "KonsorTech Explorer",
      url: "https://explorer.konsortech.xyz/haqq",
      tx_page: "https://explorer.konsortech.xyz/haqq/tx/${txHash}"
    },
    {
      kind: "Palamar Explorer",
      url: "https://explorer.palamar.io/haqq",
      tx_page: "https://explorer.palamar.io/haqq/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/haqq.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/haqq.svg",
    theme: {
      primary_color_hex: "#b9744f"
    }
  }]
};
O_.default = CO;
var M_ = {};
Object.defineProperty(M_, "__esModule", { value: !0 });
const EO = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-162",
      connection_id: "connection-148"
    },
    chain_2: {
      chain_name: "haqq",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-113",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1153",
      connection_id: "connection-874"
    },
    chain_2: {
      chain_name: "haqq",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-632",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-192",
      connection_id: "connection-163"
    },
    chain_2: {
      chain_name: "haqq",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-100",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "haqq",
      client_id: "07-tendermint-5",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-149",
      connection_id: "connection-193"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-135",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "haqq",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-58",
      connection_id: "connection-56"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-32",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "haqq",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2871",
      connection_id: "connection-2388"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1575",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "haqq",
      client_id: "07-tendermint-6",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-143",
      connection_id: "connection-143"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-240",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
M_.default = EO;
var I_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Tt, "__esModule", { value: !0 });
Tt.ibc = Tt.chain = Tt.assets = void 0;
const DO = I_(R_), BO = I_(O_), FO = I_(M_);
Tt.assets = DO.default;
Tt.chain = BO.default;
Tt.ibc = FO.default;
var or = {}, N_ = {};
Object.defineProperty(N_, "__esModule", { value: !0 });
const $O = {
  $schema: "../assetlist.schema.json",
  chain_name: "heli",
  assets: [{
    description: "The native token of HeliChain",
    denom_units: [{
      denom: "uheli",
      exponent: 0
    }, {
      denom: "heli",
      exponent: 6
    }],
    base: "uheli",
    name: "Heli",
    display: "heli",
    symbol: "HELI",
    coingecko_id: "helichain",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/heli/images/heli.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/heli/images/heli.svg",
      theme: {
        primary_color_hex: "#fccc24"
      }
    }]
  }]
};
N_.default = $O;
var P_ = {};
Object.defineProperty(P_, "__esModule", { value: !0 });
const zO = {
  $schema: "../chain.schema.json",
  chain_name: "heli",
  status: "live",
  network_type: "mainnet",
  website: "https://helichain.com/",
  pretty_name: "HeliChain",
  chain_type: "cosmos",
  chain_id: "helichain",
  bech32_prefix: "heli",
  daemon_name: "helichaind",
  node_home: "$HOME/.helichain",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uheli",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 1e-3,
      average_gas_price: 2e-3,
      high_gas_price: 25e-4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uheli"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.47.4",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.41.0"
  },
  apis: {
    rpc: [{
      address: "https://rpc.helichain.com/",
      provider: "HeliChain"
    }],
    rest: [{
      address: "https://lcd.helichain.com/",
      provider: "HeliChain"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://explorer.helichain.com/Helichain",
    tx_page: "https://explorer.helichain.com/Helichain/tx/${txHash}",
    account_page: "https://explorer.helichain.com/Helichain/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/heli/images/heli.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/heli/images/heli.svg",
    theme: {
      primary_color_hex: "#fccc24"
    }
  }]
};
P_.default = zO;
var $9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(or, "__esModule", { value: !0 });
or.chain = or.assets = void 0;
const qO = $9(N_), SO = $9(P_);
or.assets = qO.default;
or.chain = SO.default;
var rr = {}, U_ = {};
Object.defineProperty(U_, "__esModule", { value: !0 });
const TO = {
  $schema: "../assetlist.schema.json",
  chain_name: "highbury",
  assets: [
    {
      description: "The native staking and governance token of the Blackfury ecosystem",
      denom_units: [{
        denom: "ufury",
        exponent: 0
      }, {
        denom: "fury",
        exponent: 6
      }],
      base: "ufury",
      name: "Fury",
      display: "fury",
      symbol: "FURY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/fury.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/fury.svg"
      },
      coingecko_id: "fanfury",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/fury.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/fury.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Governance token of Jinx Wallet and Fury Lend Protocol",
      denom_units: [{
        denom: "jinx",
        exponent: 0
      }, {
        denom: "JINX",
        exponent: 6
      }],
      base: "jinx",
      name: "Jinx",
      display: "JINX",
      symbol: "JINX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/jinx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/jinx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/jinx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/jinx.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Governance token of Fury Swap Protocol",
      denom_units: [{
        denom: "jinxy",
        exponent: 0
      }, {
        denom: "JINXY",
        exponent: 6
      }],
      base: "jinxy",
      name: "Jinxy",
      display: "JINXY",
      symbol: "JINXy",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/jinxy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/jinxy.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/jinxy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/jinxy.svg",
        theme: {
          primary_color_hex: "#090909"
        }
      }]
    }
  ]
};
U_.default = TO;
var H_ = {};
Object.defineProperty(H_, "__esModule", { value: !0 });
const RO = {
  $schema: "../chain.schema.json",
  chain_name: "highbury",
  status: "live",
  network_type: "mainnet",
  website: "https://www.fury.black/",
  pretty_name: "Highbury",
  chain_type: "cosmos",
  chain_id: "highbury_710-1",
  bech32_prefix: "fury",
  daemon_name: "fury",
  node_home: "$HOME/.fury",
  slip44: 459,
  alternative_slip44s: [710],
  fees: {
    fee_tokens: [{
      denom: "ufury",
      low_gas_price: 0.05,
      average_gas_price: 0.1,
      high_gas_price: 0.25
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ufury"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/fury.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/fury.svg"
  },
  apis: {
    rpc: [{
      address: "https://gridiron.furya.io",
      provider: "fanfury"
    }],
    rest: [{
      address: "https://api-mainnet.furya.io/",
      provider: "fanfury"
    }],
    grpc: [{
      address: "api-mainnet.furya.io:9090",
      provider: "fanfury"
    }],
    "evm-http-jsonrpc": [{
      address: "https://rest.furya.io/",
      provider: "fanfury"
    }]
  },
  explorers: [{
    kind: "pingpub",
    url: "https://explorer.furya.wtf/",
    tx_page: "https://www.explorer.furya.wtf//txs/${txHash}",
    account_page: "https://explorer.furya.wtf//account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/fury.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/highbury/images/fury.svg",
    theme: {
      primary_color_hex: "#040404"
    }
  }]
};
H_.default = RO;
var z9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(rr, "__esModule", { value: !0 });
rr.chain = rr.assets = void 0;
const OO = z9(U_), MO = z9(H_);
rr.assets = OO.default;
rr.chain = MO.default;
var Rt = {}, L_ = {};
Object.defineProperty(L_, "__esModule", { value: !0 });
const IO = {
  $schema: "../assetlist.schema.json",
  chain_name: "humans",
  assets: [{
    description: "The native staking and governance token of Humans.ai.",
    denom_units: [{
      denom: "aheart",
      exponent: 0
    }, {
      denom: "heart",
      exponent: 18
    }],
    base: "aheart",
    name: "HEART",
    display: "heart",
    symbol: "HEART",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.svg"
    },
    coingecko_id: "humans-ai",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.svg",
      theme: {
        dark_mode: !0,
        primary_color_hex: "#f3f3f3"
      }
    }],
    socials: {
      website: "https://humans.ai/",
      twitter: "https://twitter.com/humansdotai"
    }
  }]
};
L_.default = IO;
var W_ = {};
Object.defineProperty(W_, "__esModule", { value: !0 });
const NO = {
  $schema: "../chain.schema.json",
  chain_name: "humans",
  status: "live",
  network_type: "mainnet",
  website: "https://humans.ai/",
  pretty_name: "Humans.ai",
  chain_type: "cosmos",
  chain_id: "humans_1089-1",
  bech32_prefix: "human",
  node_home: "$HOME/.humansd",
  daemon_name: "humansd",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aheart",
      fixed_min_gas_price: 25e7,
      low_gas_price: 8e10,
      average_gas_price: 1e11,
      high_gas_price: 16e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aheart"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46.11"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.humans.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://humans.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://humans.rpc.nodeshub.online",
        provider: "NodesHub"
      },
      {
        address: "https://humans-mainnet-rpc.itrocket.net",
        provider: "itrocket"
      },
      {
        address: "https://humans-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://rpc-humansai.thenop.io:443",
        provider: "TheNOP.io"
      },
      {
        address: "https://humans-rpc.stakeangle.com/",
        provider: "StakeAngle"
      },
      {
        address: "https://humans-rpc.anyvalid.com:26627",
        provider: "AnyValid"
      },
      {
        address: "https://mainnet-humans-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "http://65.21.46.90:5657",
        provider: "PPNV Service"
      },
      {
        address: "https://rpc.humans-mainnet.stake-take.com/",
        provider: "Stake-Take"
      },
      {
        address: "https://rpc.humans.posthuman.digital",
        provider: "posthuman"
      },
      {
        address: "https://humans-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://humans-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    rest: [
      {
        address: "https://api.humans.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://humans.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://humans.api.nodeshub.online",
        provider: "NodesHub"
      },
      {
        address: "https://humans-mainnet-api.itrocket.net",
        provider: "itrocket"
      },
      {
        address: "https://humans-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://api-humansai.thenop.io:443",
        provider: "TheNOP.io"
      },
      {
        address: "http://humans-rpc.stakeangle.com:41417",
        provider: "StakeAngle"
      },
      {
        address: "https://mainnet-humans-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "http://65.21.46.90:5317",
        provider: "PPNV Service"
      },
      {
        address: "https://api.humans-mainnet.stake-take.com/",
        provider: "Stake-Take"
      },
      {
        address: "https://rest.humans.posthuman.digital",
        provider: "posthuman"
      },
      {
        address: "https://humans-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://humans-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    grpc: [
      {
        address: "https://grpc.humans.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "https://humans.grpc.kjnodes.com/",
        provider: "kjnodes"
      },
      {
        address: "https://grpc-humans.nodeist.net/",
        provider: "Nodeist"
      },
      {
        address: "humans-mainnet-grpc.itrocket.net:17090",
        provider: "itrocket"
      },
      {
        address: "http://humans-rpc.stakeangle.com:41490/",
        provider: "Staketab"
      },
      {
        address: "humans.grpc.nodersteam.com:9221",
        provider: "[NODERS]TEAM"
      },
      {
        address: "http://65.21.46.90:5090",
        provider: "PPNV Service"
      },
      {
        address: "https://grpc-humans.cosmos-spaces.cloud:1190",
        provider: "StakePool"
      },
      {
        address: "humans-grpc.noders.services:21090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "humans-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://jsonrpc.humans.nodestake.top/",
        provider: "NodeStake"
      },
      {
        address: "https://humans-mainnet-evm.itrocket.net",
        provider: "itrocket"
      },
      {
        address: "https://humans-evm-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://evm.humans.stakepool.dev.br",
        provider: "Stakepool"
      },
      {
        address: "https://mainnet-humans-evm.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://evm.humans.posthuman.digital",
        provider: "posthuman"
      },
      {
        address: "https://humans-jsonrpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://mintscan.io/humans",
      tx_page: "https://www.mintscan.io/humans/tx/${txHash}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/humans",
      tx_page: "https://ezstaking.app/humans/txs/${txHash}",
      account_page: "https://ezstaking.app/humans/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/humans",
      tx_page: "https://ping.pub/humans/tx/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://humans.explorers.guru",
      tx_page: "https://humans.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "exploreme",
      url: "https://humansai.exploreme.pro/",
      tx_page: "https://humans.exploreme.pro/transaction/${txHash}"
    },
    {
      kind: "itrocket",
      url: "https://mainnet.itrocket.net/humans/staking",
      tx_page: "https://mainnet.itrocket.net/humans/tx/${txHash}",
      account_page: "https://mainnet.itrocket.net/humans/account/${accountAddress}"
    },
    {
      kind: "posthuman",
      url: "https://explorer.posthuman.digital/humans",
      tx_page: "https://explorer.posthuman.digital/humans/tx/${txHash}",
      account_page: "https://explorer.posthuman.digital/humans/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.svg",
    theme: {
      primary_color_hex: "#f3f3f3"
    }
  }]
};
W_.default = NO;
var V_ = {};
Object.defineProperty(V_, "__esModule", { value: !0 });
const PO = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "humans",
    client_id: "07-tendermint-13",
    connection_id: "connection-4"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3091",
    connection_id: "connection-2570"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-4",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-20082",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
V_.default = PO;
var G_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Rt, "__esModule", { value: !0 });
Rt.ibc = Rt.chain = Rt.assets = void 0;
const UO = G_(L_), HO = G_(W_), LO = G_(V_);
Rt.assets = UO.default;
Rt.chain = HO.default;
Rt.ibc = LO.default;
var ir = {}, K_ = {};
Object.defineProperty(K_, "__esModule", { value: !0 });
const WO = {
  $schema: "../assetlist.schema.json",
  chain_name: "idep",
  assets: [{
    description: "The native token of IDEP chain",
    denom_units: [{
      denom: "IDEP",
      exponent: 6,
      aliases: []
    }, {
      denom: "idep",
      exponent: 0,
      aliases: []
    }],
    base: "idep",
    name: "IDEP",
    display: "IDEP",
    symbol: "IDEP",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/idep/images/idep.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/idep/images/idep.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/idep/images/idep.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/idep/images/idep.svg",
      theme: {
        primary_color_hex: "#c5b4cf"
      }
    }]
  }]
};
K_.default = WO;
var X_ = {};
Object.defineProperty(X_, "__esModule", { value: !0 });
const VO = {
  $schema: "../chain.schema.json",
  chain_name: "idep",
  status: "live",
  network_type: "mainnet",
  website: "https://www.idep.network/",
  pretty_name: "IDEP",
  chain_type: "cosmos",
  chain_id: "Antora",
  bech32_prefix: "idep",
  daemon_name: "idep",
  node_home: "$HOME/.ion",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "idep",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/idep/images/idep.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/idep/images/idep.svg"
  },
  apis: {
    rpc: [],
    rest: [],
    grpc: [{
      address: "idep.lavenderfive.com:443",
      provider: "Lavender.Five Nodes 🐝"
    }]
  },
  explorers: [
    {
      kind: "chadscan",
      url: "https://chadscan.com",
      tx_page: "https://chadscan.com/transactions/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/idep",
      tx_page: "https://atomscan.com/idep/transactions/${txHash}",
      account_page: "https://atomscan.com/idep/accounts/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/idep",
      tx_page: "https://explorer.tcnetwork.io/idep/transaction/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/idep/images/idep.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/idep/images/idep.svg",
    theme: {
      primary_color_hex: "#c5b4cf"
    }
  }]
};
X_.default = VO;
var q9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ir, "__esModule", { value: !0 });
ir.chain = ir.assets = void 0;
const GO = q9(K_), KO = q9(X_);
ir.assets = GO.default;
ir.chain = KO.default;
var Ot = {}, Y_ = {};
Object.defineProperty(Y_, "__esModule", { value: !0 });
const XO = {
  $schema: "../assetlist.schema.json",
  chain_name: "impacthub",
  assets: [{
    description: "The native token of IXO Chain",
    denom_units: [{
      denom: "uixo",
      exponent: 0
    }, {
      denom: "ixo",
      exponent: 6
    }],
    base: "uixo",
    name: "IXO",
    display: "ixo",
    symbol: "IXO",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg"
    },
    coingecko_id: "ixo",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg",
      theme: {
        primary_color_hex: "#2c4484"
      }
    }]
  }]
};
Y_.default = XO;
var J_ = {};
Object.defineProperty(J_, "__esModule", { value: !0 });
const YO = {
  $schema: "../chain.schema.json",
  chain_name: "impacthub",
  status: "live",
  network_type: "mainnet",
  website: "https://www.ixo.world/",
  pretty_name: "Impacts Hub",
  chain_type: "cosmos",
  chain_id: "ixo-5",
  bech32_prefix: "ixo",
  daemon_name: "ixod",
  node_home: "$HOME/.ixod",
  key_algos: ["secp256k1", "ed25519"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uixo",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uixo"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.45.16"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://proxies.sifchain.finance/api/impacthub-3/rpc",
        provider: "sifchain"
      },
      {
        address: "https://impacthub.ixo.world/rpc/",
        provider: "ixoworld"
      },
      {
        address: "https://ixo.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-ixo-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc.lavenderfive.com:443/impacthub",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://ixo-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://ixo-rpc.bluestake.net:443",
        provider: "BlueStake 🚀"
      },
      {
        address: "https://impacthub_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://proxies.sifchain.finance/api/impacthub-3/rest",
        provider: "sifchain"
      },
      {
        address: "https://impacthub.ixo.world/rest/",
        provider: "ixoworld"
      },
      {
        address: "https://ixo.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-ixo-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rest.lavenderfive.com:443/impacthub",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://ixo-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://ixo-api.bluestake.net",
        provider: "BlueStake 🚀"
      },
      {
        address: "https://impacthub_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "grpc-ixo-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "ixo.grpc.m.stavr.tech:2010",
        provider: "🔥STAVR🔥"
      },
      {
        address: "impacthub.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/ixo",
      tx_page: "https://ezstaking.app/ixo/txs/${txHash}",
      account_page: "https://ezstaking.app/ixo/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/IXO-Mainnet",
      tx_page: "https://explorer.stavr.tech/IXO-Mainnet/txs/${txHash}",
      account_page: "https://explorer.stavr.tech/IXO-Mainnet/account/${accountAddress}"
    },
    {
      kind: "bigdipper",
      url: "https://blockscan.ixo.world",
      tx_page: "https://blockscan.ixo.world/transactions/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/ixo",
      tx_page: "https://ping.pub/ixo/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/ixo",
      tx_page: "https://atomscan.com/ixo/transactions/${txHash}",
      account_page: "https://atomscan.com/ixo/accounts/${accountAddress}"
    },
    {
      kind: "Mintscan",
      url: "https://www.mintscan.io/ixo",
      tx_page: "https://www.mintscan.io/ixo/transactions/${txHash}",
      account_page: "https://www.mintscan.io/ixo/accounts/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/ixo",
      tx_page: "https://explorer.whenmoonwhenlambo.money/ixo/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/ixo/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg",
    theme: {
      primary_color_hex: "#2c4484"
    }
  }]
};
J_.default = YO;
var Z_ = {};
Object.defineProperty(Z_, "__esModule", { value: !0 });
const JO = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-168",
      connection_id: "connection-150"
    },
    chain_2: {
      chain_name: "impacthub",
      client_id: "07-tendermint-54",
      connection_id: "connection-40"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-114",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-434",
      connection_id: "connection-368"
    },
    chain_2: {
      chain_name: "impacthub",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-204",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "impacthub",
      client_id: "07-tendermint-59",
      connection_id: "connection-43"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-20",
      connection_id: "connection-29"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "impacthub",
      client_id: "07-tendermint-12",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1451",
      connection_id: "connection-1137"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "impacthub",
      client_id: "07-tendermint-25",
      connection_id: "connection-25"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-39",
      connection_id: "connection-18"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  }
];
Z_.default = JO;
var Q_ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ot, "__esModule", { value: !0 });
Ot.ibc = Ot.chain = Ot.assets = void 0;
const ZO = Q_(Y_), QO = Q_(J_), eM = Q_(Z_);
Ot.assets = ZO.default;
Ot.chain = QO.default;
Ot.ibc = eM.default;
var Mt = {}, e0 = {};
Object.defineProperty(e0, "__esModule", { value: !0 });
const nM = {
  $schema: "../assetlist.schema.json",
  chain_name: "imversed",
  assets: [{
    description: "The native EVM, governance and staking token of the Imversed",
    denom_units: [{
      denom: "aimv",
      exponent: 0
    }, {
      denom: "imv",
      exponent: 18
    }],
    base: "aimv",
    name: "IMV",
    display: "imv",
    symbol: "IMV",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.svg"
    },
    coingecko_id: "imv",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.svg",
      theme: {
        primary_color_hex: "#4c54e4"
      }
    }]
  }]
};
e0.default = nM;
var n0 = {};
Object.defineProperty(n0, "__esModule", { value: !0 });
const tM = {
  $schema: "../chain.schema.json",
  chain_name: "imversed",
  status: "live",
  network_type: "mainnet",
  website: "https://imversed.network/",
  pretty_name: "Imversed",
  chain_type: "cosmos",
  chain_id: "imversed_5555555-1",
  bech32_prefix: "imv",
  daemon_name: "imversed",
  node_home: "$HOME/.imversed",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aimv",
      fixed_min_gas_price: 25e7,
      low_gas_price: 2e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aimv"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.svg"
  },
  apis: {
    rpc: [],
    rest: [],
    grpc: [{
      address: "grpc.imversed.network:443",
      provider: "imversed"
    }],
    "evm-http-jsonrpc": [{
      address: "https://jsonrpc.imversed.network:443",
      provider: "imversed"
    }]
  },
  explorers: [{
    kind: "blockscout",
    url: "https://txe.imversed.network/",
    tx_page: "https://txe.imversed.network/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.svg",
    theme: {
      primary_color_hex: "#4c54e4"
    }
  }]
};
n0.default = tM;
var t0 = {};
Object.defineProperty(t0, "__esModule", { value: !0 });
const sM = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "imversed",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2366",
    connection_id: "connection-1866"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-517",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
t0.default = sM;
var s0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Mt, "__esModule", { value: !0 });
Mt.ibc = Mt.chain = Mt.assets = void 0;
const aM = s0(e0), oM = s0(n0), rM = s0(t0);
Mt.assets = aM.default;
Mt.chain = oM.default;
Mt.ibc = rM.default;
var It = {}, a0 = {};
Object.defineProperty(a0, "__esModule", { value: !0 });
const iM = {
  $schema: "../assetlist.schema.json",
  chain_name: "injective",
  assets: [
    {
      description: "Injective is a decentralized exchange protocol that enables fast, secure, and fully decentralized trading of derivatives, futures, and spot markets.",
      extended_description: `Injective Protocol is a cutting-edge decentralized exchange (DEX) platform facilitating fully decentralized trading of derivatives, futures, and spot markets. Built on the Cosmos SDK, Injective leverages layer-2 scaling solutions for high-speed transactions with low fees, ensuring an efficient trading experience. The platform's design eliminates intermediaries, giving users complete control over their assets and trades.

The Injective ecosystem is powered by its native token, INJ, used for governance, staking, and fee reduction. By staking INJ, users can participate in network governance, influencing key decisions and protocol upgrades. Injective's features include cross-chain trading, allowing seamless asset trading across different blockchains, and a decentralized order book for transparency and security. Injective transforms the DeFi space with a comprehensive, decentralized solution for trading various financial instruments.`,
      denom_units: [{
        denom: "inj",
        exponent: 0
      }, {
        denom: "INJ",
        exponent: 18
      }],
      base: "inj",
      name: "Injective",
      display: "INJ",
      symbol: "INJ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg"
      },
      coingecko_id: "injective-protocol",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg",
        theme: {
          primary_color_hex: "#04a2fc"
        }
      }],
      socials: {
        website: "https://injective.com/",
        twitter: "https://twitter.com/Injective_"
      }
    },
    {
      description: "Tether USDt on Injective",
      denom_units: [{
        denom: "ibc/4ABBEF4C8926DDDB320AE5188CFD63267ABBCEFC0583E4AE05D6E5AA2401DDAB",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4ABBEF4C8926DDDB320AE5188CFD63267ABBCEFC0583E4AE05D6E5AA2401DDAB",
      name: "Tether USDt",
      display: "usdt",
      symbol: "USDTkv",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt",
          channel_id: "channel-122"
        },
        chain: {
          channel_id: "channel-143",
          path: "transfer/channel-143/erc20/tether/usdt"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    },
    {
      description: "Tether USDt from Ethereum via Peggy bridge.",
      denom_units: [{
        denom: "peggy0xdAC17F958D2ee523a2206206994597C13D831ec7",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "peggy0xdAC17F958D2ee523a2206206994597C13D831ec7",
      name: "Tether USDT",
      display: "usdt",
      symbol: "USDT",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        provider: "Peggy"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    },
    {
      description: "ERIS liquid staked INJ",
      denom_units: [{
        denom: "factory/inj1cdwt8g7nxgtg2k4fn8sj363mh9ahkw2qt0vrnc/ampINJ",
        exponent: 0
      }, {
        denom: "ampINJ",
        exponent: 6
      }],
      base: "factory/inj1cdwt8g7nxgtg2k4fn8sj363mh9ahkw2qt0vrnc/ampINJ",
      name: "ERIS Amplified INJ",
      display: "ampINJ",
      symbol: "ampINJ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/ampinj.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/ampinj.png",
        theme: {
          primary_color_hex: "#5480cc"
        }
      }]
    },
    {
      description: "$AUTISM exists to celebrate autism as a superior biological tech stack for a changing world",
      denom_units: [{
        denom: "factory/inj14lf8xm6fcvlggpa7guxzjqwjmtr24gnvf56hvz/autism",
        exponent: 0
      }, {
        denom: "autism",
        exponent: 6
      }],
      base: "factory/inj14lf8xm6fcvlggpa7guxzjqwjmtr24gnvf56hvz/autism",
      name: "Autism",
      display: "autism",
      symbol: "AUTISM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/autism.png"
      },
      coingecko_id: "autism",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/autism.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "BackBone Labs Liquid Staked Injective",
      denom_units: [{
        denom: "factory/inj1dxp690rd86xltejgfq2fa7f2nxtgmm5cer3hvu/bINJ",
        exponent: 0
      }, {
        denom: "bINJ",
        exponent: 18
      }],
      base: "factory/inj1dxp690rd86xltejgfq2fa7f2nxtgmm5cer3hvu/bINJ",
      name: "BackBone Labs Liquid Staked Injective",
      display: "bINJ",
      symbol: "bINJ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/binj.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/binj.png",
        theme: {
          primary_color_hex: "#04a2fc"
        }
      }]
    },
    {
      description: "The first meme coin on Injective. It’s a dog, but he has nunchucks",
      extended_description: "$NINJA is the premier meme coin on Injective. There is no formal roadmap and no promises made, but NINJAs are builders and masters of surprise. For all intents and purposes, the coin is completely useless, until it's not. And the dog, he has nunchucks.",
      denom_units: [{
        denom: "factory/inj1xtel2knkt8hmc9dnzpjz6kdmacgcfmlv5f308w/ninja",
        exponent: 0
      }, {
        denom: "NINJA",
        exponent: 6
      }],
      base: "factory/inj1xtel2knkt8hmc9dnzpjz6kdmacgcfmlv5f308w/ninja",
      name: "Dog wif nunchucks",
      display: "NINJA",
      symbol: "NINJA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/ninja.png"
      },
      coingecko_id: "dog-wif-nuchucks",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/ninja.png",
        theme: {
          primary_color_hex: "#00468E",
          background_color_hex: "#00468E",
          circle: !0
        }
      }],
      socials: {
        website: "https://www.dogwifnunchucks.com/",
        twitter: "https://x.com/dogwifnunchucks"
      }
    },
    {
      description: "The $WGMI Token - We Gonna Make It. Are you ready?",
      denom_units: [{
        denom: "factory/inj1rmjzj9fn47kdmfk4f3z39qr6czexxe0yjyc546/WGMI",
        exponent: 0
      }, {
        denom: "WGMI",
        exponent: 6
      }],
      base: "factory/inj1rmjzj9fn47kdmfk4f3z39qr6czexxe0yjyc546/WGMI",
      name: "WGMI",
      display: "WGMI",
      symbol: "WGMI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/wgmi.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/wgmi.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The first memecoin on osmosis.",
      denom_units: [{
        denom: "ibc/DD648F5D3CDA56D0D8D8820CF703D246B9FC4007725D8B38D23A21FF1A1477E3",
        exponent: 0
      }, {
        denom: "WOSMO",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/DD648F5D3CDA56D0D8D8820CF703D246B9FC4007725D8B38D23A21FF1A1477E3",
      name: "Wosmo",
      display: "WOSMO",
      symbol: "WOSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO",
          channel_id: "channel-122"
        },
        chain: {
          channel_id: "channel-8",
          path: "transfer/channel-8/factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png",
        theme: {
          primary_color_hex: "#edd5ee"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png"
      }
    },
    {
      description: "GLTO-ERC20 on injective",
      denom_units: [{
        denom: "peggy0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2",
        exponent: 0
      }, {
        denom: "glto",
        exponent: 6
      }],
      base: "peggy0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2",
      name: "Gelotto",
      display: "glto",
      symbol: "GLTO",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2"
        },
        provider: "Peggy"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg",
        theme: {
          primary_color_hex: "#501cad"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg"
      },
      socials: {
        website: "https://gelotto.io/",
        twitter: "https://twitter.com/Gelotto2"
      }
    },
    {
      description: "Hava Coin is the lifeblood of the Cosmos & Injective networks, rewarding builders and welcoming supporters.",
      denom_units: [{
        denom: "factory/inj1h0ypsdtjfcjynqu3m75z2zwwz5mmrj8rtk2g52/uhava",
        exponent: 0
      }, {
        denom: "hava",
        exponent: 6
      }],
      base: "factory/inj1h0ypsdtjfcjynqu3m75z2zwwz5mmrj8rtk2g52/uhava",
      name: "Hava Coin",
      display: "hava",
      symbol: "HAVA",
      coingecko_id: "hava-coin",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/hava.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/hava.png",
        theme: {
          primary_color_hex: "#eacea5"
        }
      }],
      socials: {
        website: "https://havacoin.xyz/",
        twitter: "https://twitter.com/Hava_Coin"
      }
    },
    {
      description: "A clan of 11y bad kids crafting chaos on the Cosmos eco. One bad memecoin to rule them all  $BADKID. Airdropped to Badkids NFT holders and $STARS stakers. It's so bad, your wallet's throwing a tantrum for it.",
      denom_units: [{
        denom: "ibc/A0C5AD197FECAF6636F589071338DC7ECD6B0809CD3A5AB131EAAA5395E7E5E8",
        exponent: 0
      }, {
        denom: "BADKID",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/A0C5AD197FECAF6636F589071338DC7ECD6B0809CD3A5AB131EAAA5395E7E5E8",
      name: "Badkid",
      display: "BADKID",
      symbol: "BADKID",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo10n8rv8npx870l69248hnp6djy6pll2yuzzn9x8/BADKID",
          channel_id: "channel-122"
        },
        chain: {
          channel_id: "channel-8",
          path: "transfer/channel-8/factory/osmo10n8rv8npx870l69248hnp6djy6pll2yuzzn9x8/BADKID"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo10n8rv8npx870l69248hnp6djy6pll2yuzzn9x8/BADKID"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/badkid.png",
        theme: {
          primary_color_hex: "#57443f"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/badkid.png"
      }
    },
    {
      description: "The second meme coin on Injective.",
      denom_units: [{
        denom: "inj1sudjgsyhufqu95yp7rqad3g78ws8g6htf32h88",
        exponent: 0
      }, {
        denom: "NINPO",
        exponent: 6
      }],
      base: "inj1sudjgsyhufqu95yp7rqad3g78ws8g6htf32h88",
      name: "Ninpo",
      display: "NINPO",
      symbol: "NINPO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/ninpo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/ninpo.png",
        theme: {
          primary_color_hex: "#31292a"
        }
      }]
    },
    {
      description: "JUDO is a very futuristic meme token.",
      denom_units: [{
        denom: "inj16ukv8g2jcmml7gykxn5ws8ykhxjkugl4zhft5h",
        exponent: 0
      }, {
        denom: "JUDO",
        exponent: 6
      }],
      base: "inj16ukv8g2jcmml7gykxn5ws8ykhxjkugl4zhft5h",
      name: "Judo",
      display: "JUDO",
      symbol: "JUDO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/judo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/judo.png",
        theme: {
          primary_color_hex: "#18120f"
        }
      }]
    },
    {
      description: "BEAST-ERC20 on injective",
      denom_units: [{
        denom: "peggy0xA4426666addBE8c4985377d36683D17FB40c31Be",
        exponent: 0
      }, {
        denom: "beast",
        exponent: 6
      }],
      base: "peggy0xA4426666addBE8c4985377d36683D17FB40c31Be",
      name: "Gelotto BEAST",
      display: "beast",
      symbol: "BEAST",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xA4426666addBE8c4985377d36683D17FB40c31Be"
        },
        provider: "Peggy"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xA4426666addBE8c4985377d36683D17FB40c31Be"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/beast.png",
        theme: {
          primary_color_hex: "#21172b"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/beast.png"
      },
      socials: {
        website: "https://gelotto.io/",
        twitter: "https://twitter.com/Gelotto2"
      }
    },
    {
      description: "Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.",
      denom_units: [{
        denom: "ibc/063F4461F7317CFF10F50AB044E44932D22AAD84FA7107082744946E6DB7B7A8",
        exponent: 0,
        aliases: ["uastro"]
      }, {
        denom: "astro",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/063F4461F7317CFF10F50AB044E44932D22AAD84FA7107082744946E6DB7B7A8",
      name: "Astroport token",
      display: "astro",
      symbol: "ASTRO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro",
          channel_id: "channel-60"
        },
        chain: {
          channel_id: "channel-177",
          path: "transfer/channel-177/factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg",
        theme: {
          primary_color_hex: "#4056e9"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg"
      }
    },
    {
      description: "A receipt token for lent INJ issued by the Neptune Protocol.",
      denom_units: [{
        denom: "inj1rmzufd7h09sqfrre5dtvu5d09ta7c0t4jzkr2f",
        exponent: 0
      }, {
        denom: "nINJ",
        exponent: 18
      }],
      base: "inj1rmzufd7h09sqfrre5dtvu5d09ta7c0t4jzkr2f",
      name: "Neptune Receipt INJ",
      display: "nINJ",
      symbol: "nINJ",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/ninj.png",
        theme: {
          primary_color_hex: "#293a6f"
        }
      }]
    },
    {
      description: "A receipt token for lent ATOM issued by the Neptune Protocol.",
      denom_units: [{
        denom: "inj16jf4qkcarp3lan4wl2qkrelf4kduvvujwg0780",
        exponent: 0
      }, {
        denom: "nATOM",
        exponent: 6
      }],
      base: "inj16jf4qkcarp3lan4wl2qkrelf4kduvvujwg0780",
      name: "Neptune Receipt ATOM",
      display: "nATOM",
      symbol: "nATOM",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/natom.png",
        theme: {
          primary_color_hex: "#272f4b"
        }
      }]
    },
    {
      description: "A receipt token for lent WETH issued by the Neptune Protocol.",
      denom_units: [{
        denom: "inj1kehk5nvreklhylx22p3x0yjydfsz9fv3fvg5xt",
        exponent: 0
      }, {
        denom: "nWETH",
        exponent: 18
      }],
      base: "inj1kehk5nvreklhylx22p3x0yjydfsz9fv3fvg5xt",
      name: "Neptune Receipt WETH",
      display: "nWETH",
      symbol: "nWETH",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/nweth.png",
        theme: {
          primary_color_hex: "#2a303f"
        }
      }]
    },
    {
      description: "A receipt token for lent USDT issued by the Neptune Protocol.",
      denom_units: [{
        denom: "inj1cy9hes20vww2yr6crvs75gxy5hpycya2hmjg9s",
        exponent: 0
      }, {
        denom: "nUSDT",
        exponent: 6
      }],
      base: "inj1cy9hes20vww2yr6crvs75gxy5hpycya2hmjg9s",
      name: "Neptune Receipt USDT",
      display: "nUSDT",
      symbol: "nUSDT",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/nusdt.png",
        theme: {
          primary_color_hex: "#54ac94"
        }
      }]
    },
    {
      description: "A receipt token for lent TIA issued by the Neptune Protocol.",
      denom_units: [{
        denom: "inj1fzquxxxam59z6fzewy2hvvreeh3m04x83zg4vv",
        exponent: 0
      }, {
        denom: "nTIA",
        exponent: 6
      }],
      base: "inj1fzquxxxam59z6fzewy2hvvreeh3m04x83zg4vv",
      name: "Neptune Receipt TIA",
      display: "nTIA",
      symbol: "nTIA",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/ntia.png",
        theme: {
          primary_color_hex: "#7931f9"
        }
      }]
    },
    {
      description: "Ninja Blaze Token",
      denom_units: [{
        denom: "ibc/1011E4D6D4800DA9B8F21D7C207C0B0C18E54E614A8576037F066B775210709D",
        exponent: 0,
        aliases: ["uNBZ"]
      }, {
        denom: "NBZ",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1011E4D6D4800DA9B8F21D7C207C0B0C18E54E614A8576037F066B775210709D",
      name: "Ninja Blaze Token",
      display: "NBZ",
      symbol: "NBZ",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1a6ydq8urdj0gkvjw9e9e5y9r5ce2qegm9m4xufpt96kcm60kmuass0mqq4/nbz",
          channel_id: "channel-60"
        },
        chain: {
          channel_id: "channel-177",
          path: "transfer/channel-177/factory/neutron1a6ydq8urdj0gkvjw9e9e5y9r5ce2qegm9m4xufpt96kcm60kmuass0mqq4/nbz"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1a6ydq8urdj0gkvjw9e9e5y9r5ce2qegm9m4xufpt96kcm60kmuass0mqq4/nbz"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/NBZ.png",
        theme: {
          primary_color_hex: "#9890f9"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/NBZ.png"
      }
    },
    {
      description: "Talis governance token",
      denom_units: [{
        denom: "factory/inj1maeyvxfamtn8lfyxpjca8kuvauuf2qeu6gtxm3/Talis",
        exponent: 0
      }, {
        denom: "Talis",
        exponent: 6
      }],
      base: "factory/inj1maeyvxfamtn8lfyxpjca8kuvauuf2qeu6gtxm3/Talis",
      name: "Talis Token",
      display: "Talis",
      symbol: "TALIS",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/talis.png",
        theme: {
          primary_color_hex: "#0c0f17"
        }
      }],
      socials: {
        website: "https://talis.art/",
        twitter: "https://twitter.com/ProtocolTalis"
      }
    },
    {
      description: "Talis revenue sharing token",
      denom_units: [{
        denom: "factory/inj1maeyvxfamtn8lfyxpjca8kuvauuf2qeu6gtxm3/xTalis",
        exponent: 0
      }, {
        denom: "xTalis",
        exponent: 6
      }],
      base: "factory/inj1maeyvxfamtn8lfyxpjca8kuvauuf2qeu6gtxm3/xTalis",
      name: "xTalis Token",
      display: "xTalis",
      symbol: "XTALIS",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/xtalis.png",
        theme: {
          primary_color_hex: "#eaf0df"
        }
      }],
      socials: {
        website: "https://talis.art/",
        twitter: "https://twitter.com/ProtocolTalis"
      }
    },
    {
      description: "USDC is a fully collateralized US Dollar stablecoin developed by CENTRE, the open source project with Circle being the first of several forthcoming issuers.",
      denom_units: [{
        denom: "ibc/2CBC2EA121AE42563B08028466F37B600F2D7D4282342DE938283CC3FB2BC00E",
        exponent: 0,
        aliases: ["microusdc", "uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2CBC2EA121AE42563B08028466F37B600F2D7D4282342DE938283CC3FB2BC00E",
      name: "USDC",
      display: "usdc",
      symbol: "USDC",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "additional-mintage",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
          },
          provider: "Circle"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "noble",
            base_denom: "uusdc",
            channel_id: "channel-31"
          },
          chain: {
            channel_id: "channel-148",
            path: "transfer/channel-148/uusdc"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }]
    },
    {
      description: "The most degenerate NFT on Injective. Gravedigger collection for $bINJ. Giving power back to the community.",
      denom_units: [{
        denom: "factory/inj1a6xdezq7a94qwamec6n6cnup02nvewvjtz6h6e/SYN",
        exponent: 0
      }, {
        denom: "SYN",
        exponent: 6
      }],
      base: "factory/inj1a6xdezq7a94qwamec6n6cnup02nvewvjtz6h6e/SYN",
      name: "Syndicate",
      display: "SYN",
      symbol: "SYN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/syn.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/syn.png",
        theme: {
          primary_color_hex: "#04a2fc"
        }
      }]
    },
    {
      description: "SYN burn Derivative; minted when SYN is burned via The Furnace",
      denom_units: [{
        denom: "factory/inj1ej2f3lmpxj4djsmmuxvnfuvplrut7zmwrq7zj8/syn.ash",
        exponent: 0
      }, {
        denom: "ashSYN",
        exponent: 6
      }],
      base: "factory/inj1ej2f3lmpxj4djsmmuxvnfuvplrut7zmwrq7zj8/syn.ash",
      name: "ASH Syndicate",
      display: "ashSYN",
      symbol: "ashSYN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/syn.ash.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/syn.ash.png"
      }]
    },
    {
      description: "Cosmo is the best currency in the universe.",
      extended_description: "We aim to build a decentralized community by leveraging cutting-edge technologies.",
      denom_units: [{
        denom: "factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO",
        exponent: 0
      }, {
        denom: "COSMO",
        exponent: 6
      }],
      base: "factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO",
      name: "Cosmo",
      display: "COSMO",
      symbol: "COSMO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/cosmo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/cosmo.png",
        theme: {
          primary_color_hex: "#343169"
        }
      }],
      socials: {
        website: "https://github.com/raphaellafar/Cosmo",
        twitter: "https://x.com/CosmoClub84"
      }
    },
    {
      description: "The Representative factory token for Trump Kemistry",
      denom_units: [{
        denom: "ibc/5339B0D20986A7C20C2548ED9D6B8DE47BB64E03ABFD051B7792E713036EA20C",
        exponent: 0
      }, {
        denom: "XTRUMP",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/5339B0D20986A7C20C2548ED9D6B8DE47BB64E03ABFD051B7792E713036EA20C",
      name: "XTRUMP",
      display: "XTRUMP",
      symbol: "XTRUMP",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP",
          channel_id: "channel-122"
        },
        chain: {
          channel_id: "channel-8",
          path: "transfer/channel-8/factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/XTRUMP.png",
        theme: {
          primary_color_hex: "#b02b27"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/XTRUMP.png"
      }
    },
    {
      description: "CW20 DRUGS meme coin",
      denom_units: [{
        denom: "cw20:inj19vy83ne9tzta2yqynj8yg7dq9ghca6yqn9hyej",
        exponent: 0
      }, {
        denom: "DRUGS",
        exponent: 18
      }],
      type_asset: "cw20",
      address: "inj19vy83ne9tzta2yqynj8yg7dq9ghca6yqn9hyej",
      base: "cw20:inj19vy83ne9tzta2yqynj8yg7dq9ghca6yqn9hyej",
      name: "cw20 DRUGS",
      display: "DRUGS",
      symbol: "DRUGS",
      traces: [{
        type: "legacy-mintage",
        counterparty: {
          chain_name: "injective",
          base_denom: "factory/inj1sklcy2px26jj73ffs2f7fmxw77zsts66prrqxr/DRUGS"
        },
        provider: "Drugs"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/cw20drugs.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/cw20drugs.png"
      }]
    },
    {
      description: "Distributing happiness, is a serious business",
      denom_units: [{
        denom: "factory/inj1sklcy2px26jj73ffs2f7fmxw77zsts66prrqxr/DRUGS",
        exponent: 0
      }, {
        denom: "DRUGS",
        exponent: 9
      }],
      base: "factory/inj1sklcy2px26jj73ffs2f7fmxw77zsts66prrqxr/DRUGS",
      name: "DRUGS",
      display: "DRUGS",
      symbol: "DRUGS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/drugs.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/drugs.png"
      }]
    }
  ]
};
a0.default = iM;
var o0 = {};
Object.defineProperty(o0, "__esModule", { value: !0 });
const cM = {
  $schema: "../chain.schema.json",
  chain_name: "injective",
  status: "live",
  network_type: "mainnet",
  website: "https://injective.com/",
  pretty_name: "Injective",
  chain_type: "cosmos",
  chain_id: "injective-1",
  bech32_prefix: "inj",
  extra_codecs: ["injective"],
  slip44: 60,
  daemon_name: "injectived",
  node_home: "$HOME/.injectived",
  fees: {
    fee_tokens: [{
      denom: "inj",
      fixed_min_gas_price: 16e7,
      low_gas_price: 5e8,
      average_gas_price: 7e8,
      high_gas_price: 9e8
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "inj"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg"
  },
  description: "Injective’s mission is to create a truly free and inclusive financial system through decentralization.",
  apis: {
    rpc: [
      {
        address: "https://6d0ff611-9009-4bd1-a7a7-acec7c70d454.injective-1.mesa-rpc.newmetric.xyz",
        provider: "NewMetric"
      },
      {
        address: "https://rpc.injective.goldenratiostaking.net",
        provider: "Golden Ratio Staking"
      },
      {
        address: "https://injective-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc.lavenderfive.com:443/injective",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-injective-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://injective-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc-injective.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://rpc-injective-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://injective-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://injective-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://public.stakewolle.com/cosmos/injective/rpc",
        provider: "Stakewolle"
      },
      {
        address: "https://rpc.injective.bronbro.io/",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://injective-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://rpc-injective.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://rpc-injective.kewrnode.com",
        provider: "Kewr Node"
      }
    ],
    rest: [
      {
        address: "https://6d0ff611-9009-4bd1-a7a7-acec7c70d454.injective-1.mesa-rest.newmetric.xyz",
        provider: "NewMetric"
      },
      {
        address: "https://api-injective-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://injective-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rest.lavenderfive.com:443/injective",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://lcd-injective.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://api-injective-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://rest.injective.goldenratiostaking.net",
        provider: "Golden Ratio Staking"
      },
      {
        address: "https://injective-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "injective-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://injective-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://public.stakewolle.com/cosmos/injective/rest",
        provider: "Stakewolle"
      },
      {
        address: "https://lcd.injective.bronbro.io/",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://injective-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://rest-injective.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://rest-injective.kewrnode.com",
        provider: "Kewr Node"
      }
    ],
    grpc: [
      {
        address: "6d0ff611-9009-4bd1-a7a7-acec7c70d454.injective-1.mesa-grpc.newmetric.xyz:80",
        provider: "NewMetric"
      },
      {
        address: "grpc-injective-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "injective.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "injective-grpc.polkachu.com:14390",
        provider: "Polkachu"
      },
      {
        address: "injective-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-injective.cosmos-spaces.cloud:9900",
        provider: "Cosmos Spaces"
      },
      {
        address: "grpc.injective.posthuman.digital:80",
        provider: "POSTHUMAN ꝏ DVS"
      },
      {
        address: "grpc-injective.architectnodes.com:1443",
        provider: "Architect Nodes"
      },
      {
        address: "grpc-injective-01.stakeflow.io:2102",
        provider: "Stakeflow"
      },
      {
        address: "injective-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "injective-grpc.w3coins.io:14390",
        provider: "w3coins"
      },
      {
        address: "grpc-injective.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "grpc.injective.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "injective-grpc.noders.services:33090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/injective",
      tx_page: "https://ezstaking.app/injective/txs/${txHash}",
      account_page: "https://ezstaking.app/injective/account/${accountAddress}"
    },
    {
      kind: "injectiveprotocol",
      url: "https://explorer.injective.network/",
      tx_page: "https://explorer.injective.network/transaction/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/injective",
      tx_page: "https://ping.pub/injective/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/injective",
      tx_page: "https://atomscan.com/injective/transactions/${txHash}",
      account_page: "https://atomscan.com/injective/accounts/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/injective",
      tx_page: "https://www.mintscan.io/injective/transactions/${txHash}",
      account_page: "https://www.mintscan.io/injective/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/injective",
      account_page: "https://stakeflow.io/injective/accounts/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/injective",
      tx_page: "https://mainnet.whispernode.com/injective/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/injective/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg",
    theme: {
      primary_color_hex: "#04a2fc"
    }
  }]
};
o0.default = cM;
var r0 = {};
Object.defineProperty(r0, "__esModule", { value: !0 });
const dM = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-16",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-250",
      connection_id: "connection-244"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-213",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-37",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-113",
      connection_id: "connection-93"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-84",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-28",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-226",
      connection_id: "connection-210"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-152",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-123",
      connection_id: "connection-45"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-207",
      connection_id: "connection-191"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-145",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-470",
      connection_id: "connection-388"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-5",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-220",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-26",
      connection_id: "connection-29"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-132",
      connection_id: "connection-105"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-90",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-15",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-245",
      connection_id: "connection-239"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-182",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-19",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-112",
      connection_id: "connection-92"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-83",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gateway",
      client_id: "07-tendermint-18",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "injective",
      client_id: "07-tendermint-248",
      connection_id: "connection-241"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-183",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-205",
      connection_id: "connection-189"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-130",
      connection_id: "connection-166"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-143",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-122",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-144",
      connection_id: "connection-116"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-77",
      connection_id: "connection-53"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-98",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-54",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-154",
      connection_id: "connection-123"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-5",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-102",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-233",
      connection_id: "connection-220"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-78",
      connection_id: "connection-58"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-177",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-60",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-212",
      connection_id: "connection-195"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-57",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-148",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-31",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-201",
      connection_id: "connection-184"
    },
    chain_2: {
      chain_name: "nois",
      client_id: "07-tendermint-13",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-138",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-140",
        port_id: "wasm.inj1w9g3sk7lk8k0pdtctygupt6f3te7x4thvzz57a"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-253",
      connection_id: "connection-245"
    },
    chain_2: {
      chain_name: "odin",
      client_id: "07-tendermint-122",
      connection_id: "connection-85"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-214",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-211",
      connection_id: "connection-194"
    },
    chain_2: {
      chain_name: "oraichain",
      client_id: "07-tendermint-105",
      connection_id: "connection-82"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-147",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-146",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "oraidex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-19",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1703",
      connection_id: "connection-1298"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-122",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-110",
      connection_id: "connection-91"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-57",
      connection_id: "connection-53"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-82",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-267",
      connection_id: "connection-268"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-284",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-1",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-285",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-10",
          port_id: "icacontroller-delegation-inj"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-286",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-11",
          port_id: "icacontroller-reward-inj"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-287",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-12",
          port_id: "icacontroller-sweep-inj"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-126",
      connection_id: "connection-101"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-49",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-135",
      connection_id: "connection-108"
    },
    chain_2: {
      chain_name: "sommelier",
      client_id: "07-tendermint-4",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-93",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-131",
      connection_id: "connection-103"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-89",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-216",
      connection_id: "connection-202"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-369",
      connection_id: "connection-311"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-151",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-255",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-229",
      connection_id: "connection-217"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-243",
      connection_id: "connection-206"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-159",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-197",
      connection_id: "connection-182"
    },
    chain_2: {
      chain_name: "xpla",
      client_id: "07-tendermint-6",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-137",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
r0.default = dM;
var i0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(It, "__esModule", { value: !0 });
It.ibc = It.chain = It.assets = void 0;
const mM = i0(a0), hM = i0(o0), pM = i0(r0);
It.assets = mM.default;
It.chain = hM.default;
It.ibc = pM.default;
var Nt = {}, c0 = {};
Object.defineProperty(c0, "__esModule", { value: !0 });
const lM = {
  $schema: "../assetlist.schema.json",
  chain_name: "irisnet",
  assets: [{
    description: "The IRIS token is the native governance token for the IrisNet chain.",
    denom_units: [{
      denom: "uiris",
      exponent: 0
    }, {
      denom: "iris",
      exponent: 6
    }],
    base: "uiris",
    name: "IRISnet",
    display: "iris",
    symbol: "IRIS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.svg"
    },
    coingecko_id: "iris-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.svg",
      theme: {
        primary_color_hex: "#5664ad"
      }
    }]
  }]
};
c0.default = lM;
var d0 = {};
Object.defineProperty(d0, "__esModule", { value: !0 });
const gM = {
  $schema: "../chain.schema.json",
  chain_name: "irisnet",
  status: "live",
  network_type: "mainnet",
  pretty_name: "IRISnet",
  chain_type: "cosmos",
  chain_id: "irishub-1",
  bech32_prefix: "iaa",
  daemon_name: "iris",
  node_home: "$HOME/.iris",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uiris",
      low_gas_price: 0.2,
      average_gas_price: 0.3,
      high_gas_price: 0.4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uiris"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc-irisnet-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc-irisnet-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://irisnet-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://iris-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://iris-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://mainnet-iris-rpc.konsortech.xyz",
        provider: "KonsorTech"
      }
    ],
    rest: [
      {
        address: "https://api-irisnet-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://api-irisnet-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://irisnet-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://iris-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://iris-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://mainnet-iris-api.konsortech.xyz",
        provider: "KonsorTech"
      }
    ],
    grpc: [
      {
        address: "grpc-irisnet-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "grpc-irisnet-01.stakeflow.io:1902",
        provider: "Stakeflow"
      },
      {
        address: "irisnet-grpc.w3coins.io:22690",
        provider: "w3coins"
      },
      {
        address: "iris-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "iris.grpc.kjnodes.com:443",
        provider: "kjnodes"
      },
      {
        address: "https://grpc-irisnet.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "iris-mainnet.grpc.l0vd.com:80",
        provider: "L0vd.com ❤️"
      },
      {
        address: "mainnet-iris.konsortech.xyz:30090",
        provider: "KonsorTech"
      }
    ],
    "evm-http-jsonrpc": [{
      address: "https://iris-evm.publicnode.com",
      provider: "Allnodes.com ⚡️ Nodes & Staking"
    }, {
      address: "https://mainnet-iris-evm.konsortech.xyz",
      provider: "KonsorTech"
    }]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/irisnet",
      tx_page: "https://ezstaking.app/irisnet/txs/${txHash}",
      account_page: "https://ezstaking.app/irisnet/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/iris",
      tx_page: "https://www.mintscan.io/iris/transactions/${txHash}",
      account_page: "https://www.mintscan.io/iris/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/iris-network",
      tx_page: "https://ping.pub/iris-network/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/iris-network",
      tx_page: "https://atomscan.com/iris-network/transactions/${txHash}",
      account_page: "https://atomscan.com/iris-network/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/irisnet",
      account_page: "https://stakeflow.io/irisnet/accounts/${accountAddress}"
    },
    {
      kind: "Nodeist Explorer",
      url: "https://exp.nodeist.net/iris",
      tx_page: "https://exp.nodeist.net/iris/tx/${txHash}"
    },
    {
      kind: "L0vd.com ❤️",
      url: "https://explorers.l0vd.com/iris-mainnet",
      tx_page: "https://explorers.l0vd.com/iris-mainnet/tx/${txHash}"
    },
    {
      kind: "KonsorTech",
      url: "https://explorer.konsortech.xyz/iris",
      tx_page: "https://explorer.konsortech.xyz/iris/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.svg",
    theme: {
      primary_color_hex: "#5664ad"
    }
  }]
};
d0.default = gM;
var m0 = {};
Object.defineProperty(m0, "__esModule", { value: !0 });
const uM = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-44",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-23",
      connection_id: "connection-16"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-53",
      connection_id: "connection-30"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-151",
      connection_id: "connection-114"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-28",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-68",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-384",
      connection_id: "connection-338"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-31",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-182",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-67",
      connection_id: "connection-61"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-86",
      connection_id: "connection-70"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-650",
      connection_id: "connection-197"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-32",
      connection_id: "connection-23"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "emoney",
      client_id: "07-tendermint-10",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "irisnet",
      client_id: "07-tendermint-46",
      connection_id: "connection-34"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-5",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-5",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-34",
      connection_id: "connection-25"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-31",
      connection_id: "connection-25"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-35",
      connection_id: "connection-26"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-25",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-36",
      connection_id: "connection-28"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-54",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-42",
      connection_id: "connection-30"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-19",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-63",
      connection_id: "connection-44"
    },
    chain_2: {
      chain_name: "stafihub",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-44",
      connection_id: "connection-32"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-41",
      connection_id: "connection-27"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-93",
      connection_id: "connection-72"
    },
    chain_2: {
      chain_name: "uptick",
      client_id: "07-tendermint-8",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-39",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  }
];
m0.default = uM;
var h0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Nt, "__esModule", { value: !0 });
Nt.ibc = Nt.chain = Nt.assets = void 0;
const _M = h0(c0), yM = h0(d0), bM = h0(m0);
Nt.assets = _M.default;
Nt.chain = yM.default;
Nt.ibc = bM.default;
var Pt = {}, p0 = {};
Object.defineProperty(p0, "__esModule", { value: !0 });
const vM = {
  $schema: "../assetlist.schema.json",
  chain_name: "jackal",
  assets: [{
    description: "Jackal Network is a decentralized storage platform that aims to provide secure, private, and efficient data storage solutions on the blockchain.",
    extended_description: "Jackal Network is a decentralized storage platform designed to offer secure, private, and efficient data storage solutions using blockchain technology. By leveraging a distributed network of nodes, Jackal Network ensures data redundancy and security, protecting against data loss and unauthorized access. The platform uses advanced encryption techniques to maintain data privacy while allowing users to share and access their data seamlessly. Jackal Network's native token is used for paying storage fees, staking, and participating in network governance, incentivizing users to contribute to the network's security and reliability.",
    denom_units: [{
      denom: "ujkl",
      exponent: 0
    }, {
      denom: "jkl",
      exponent: 6
    }],
    base: "ujkl",
    name: "Jackal",
    display: "jkl",
    symbol: "JKL",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.svg"
    },
    coingecko_id: "jackal-protocol",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.svg",
      theme: {
        primary_color_hex: "#dbdbcb"
      }
    }]
  }]
};
p0.default = vM;
var l0 = {};
Object.defineProperty(l0, "__esModule", { value: !0 });
const fM = {
  $schema: "../chain.schema.json",
  chain_name: "jackal",
  chain_type: "cosmos",
  chain_id: "jackal-1",
  website: "https://jackalprotocol.com",
  pretty_name: "Jackal",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "jkl",
  daemon_name: "canined",
  node_home: "$HOME/.canine",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ujkl",
      fixed_min_gas_price: 0,
      low_gas_price: 2e-3,
      average_gas_price: 2e-3,
      high_gas_price: 0.02
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ujkl"
    }]
  },
  codebase: {
    cosmwasm_enabled: !0
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.svg"
  },
  apis: {
    wss: [{
      address: "wss://jackal-rpc.agoranodes.com",
      provider: "AgoraNodes"
    }],
    rpc: [
      {
        address: "https://rpc.jackalprotocol.com",
        provider: "Jackal Labs"
      },
      {
        address: "https://rpc.lavenderfive.com:443/jackal",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "http://jkl.rpc.m.stavr.tech:11127",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://jackal.rpc.bccnodes.com",
        provider: "BccNodes"
      },
      {
        address: "https://rpc.jackal.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rpc-jackal.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "https://jackal-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://m-jackal.rpc.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://rpc-jackal.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://jackal-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://jackal.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://jackal.rpc.silknodes.io",
        provider: "Silk Nodes"
      },
      {
        address: "https://jackal.rpc.skynodejs.net",
        provider: "skynodejs"
      },
      {
        address: "https://public.stakewolle.com/cosmos/jackal/rpc",
        provider: "Stakewolle"
      },
      {
        address: "https://rpc.jackal.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://rpc.jackal.mathnodes.com",
        provider: "MathNodes"
      },
      {
        address: "https://jackal-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://jackal-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://jackal_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://api.jackalprotocol.com",
        provider: "Jackal Labs"
      },
      {
        address: "https://rest.lavenderfive.com:443/jackal",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://jkl.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.jackal.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://api-jackal.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "https://jackal-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://m-jackal.api.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://jackal-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://lcd-jackal.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://jackal.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://jackal.api.silknodes.io",
        provider: "Silk Nodes"
      },
      {
        address: "https://jackal.api.skynodejs.net",
        provider: "skynodejs"
      },
      {
        address: "https://public.stakewolle.com/cosmos/jackal/rest",
        provider: "Stakewolle"
      },
      {
        address: "https://api.jackal.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://api.jackal.mathnodes.com",
        provider: "MathNodes"
      },
      {
        address: "https://jackal-api.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://jackal-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://jackal_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "grpc.jackalprotocol.com:443",
        provider: "Jackal Labs"
      },
      {
        address: "jackal.grpc.bccnodes.com:9490",
        provider: "BccNodes"
      },
      {
        address: "jackal.grpc.nodersteam.com:9990",
        provider: "[NODERS]TEAM"
      },
      {
        address: "jackal.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "grpc.jackal.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "jackal-grpc.polkachu.com:17590",
        provider: "Polkachu"
      },
      {
        address: "http://jkl.grpc.m.stavr.tech:5013",
        provider: "🔥STAVR🔥"
      },
      {
        address: "jackal-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "jackal.grpc.kjnodes.com:13790",
        provider: "kjnodes"
      },
      {
        address: "https://jackal.grpc.skynodejs.net",
        provider: "skynodejs"
      },
      {
        address: "grpc.jackal.silentvalidator.com:443",
        provider: "silent"
      },
      {
        address: "jackal-grpc.noders.services:26090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/jackal",
      tx_page: "https://ping.pub/jackal/tx/${txHash}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.top/jackal",
      tx_page: "https://explorer.nodestake.top/jackal/tx/${txHash}"
    },
    {
      kind: "BccNodes",
      url: "https://explorer.bccnodes.com/jackal",
      tx_page: "https://explorer.bccnodes.com/jackal/tx/${txHash}"
    },
    {
      kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
      url: "https://exp.utsa.tech/jackal",
      tx_page: "https://exp.utsa.tech/jackal/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/jackal",
      tx_page: "https://explorer.stavr.tech/jackal/tx/${txHash}"
    },
    {
      kind: "Nodeist Explorer",
      url: "https://exp.nodeist.net/jackal",
      tx_page: "https://exp.nodeist.net/jackal/tx/${txHash}"
    },
    {
      kind: "Big Dipper",
      url: "https://bigdipper.live/jackal",
      tx_page: "https://bigdipper.live/jackal/transactions/${txHash}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/jackal",
      tx_page: "https://mainnet.whispernode.com/jackal/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/jackal/account/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/jackal",
      tx_page: "https://explorer.whenmoonwhenlambo.money/jackal/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/jackal/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.svg",
    theme: {
      primary_color_hex: "#dbdbcb"
    }
  }]
};
l0.default = fM;
var g0 = {};
Object.defineProperty(g0, "__esModule", { value: !0 });
const wM = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-17",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "jackal",
      client_id: "07-tendermint-61",
      connection_id: "connection-50"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }],
    operators: [{
      chain_1: {
        address: "archway16l5ls4ajah6hethh374tpgn42r5q4sqeuw8udj"
      },
      chain_2: {
        address: "jkl134a4es94hjqqej732cymf0w3988zh3c4yuqtf8"
      },
      memo: "by AM Solutions | https://www.theamsolutions.info",
      name: "AM Solutions",
      discord_handle: "AlexeyM#5409"
    }, {
      chain_1: {
        address: "archway1nms20r7jzaa4ms9exv90ckl2xfn0rd3rmqh7zm"
      },
      chain_2: {
        address: "jkl1nms20r7jzaa4ms9exv90ckl2xfn0rd3rh49t3n"
      },
      memo: "Relayed by NodeStake",
      name: "NodeStake",
      discord_handle: "nodestake"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-69",
      connection_id: "connection-178"
    },
    chain_2: {
      chain_name: "jackal",
      client_id: "07-tendermint-69",
      connection_id: "connection-57"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-137",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-111",
      connection_id: "connection-97"
    },
    chain_2: {
      chain_name: "jackal",
      client_id: "07-tendermint-56",
      connection_id: "connection-46"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "jackal",
      client_id: "07-tendermint-57",
      connection_id: "connection-47"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-139",
      connection_id: "connection-105"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-39",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-94",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "jackal",
      client_id: "07-tendermint-2",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2273",
      connection_id: "connection-1762"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-412",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "jackal",
      client_id: "07-tendermint-6",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-124",
      connection_id: "connection-94"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
g0.default = wM;
var u0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Pt, "__esModule", { value: !0 });
Pt.ibc = Pt.chain = Pt.assets = void 0;
const xM = u0(p0), kM = u0(l0), AM = u0(g0);
Pt.assets = xM.default;
Pt.chain = kM.default;
Pt.ibc = AM.default;
var Ut = {}, _0 = {};
Object.defineProperty(_0, "__esModule", { value: !0 });
const jM = {
  $schema: "../assetlist.schema.json",
  chain_name: "joltify",
  assets: [
    {
      description: "The native staking and governance token of Joltify",
      extended_description: "Joltify is the First EVM compatible game-changing L1 Public Chain built on the Cosmos SDK for Real-World Assets (RWA) and Beyond.",
      denom_units: [{
        denom: "ujolt",
        exponent: 0
      }, {
        denom: "jolt",
        exponent: 6
      }],
      base: "ujolt",
      name: "Joltify",
      display: "jolt",
      symbol: "JOLT",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/joltify/images/jolt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/joltify/images/jolt.svg",
        theme: {
          primary_color_hex: "#2dfb71"
        }
      }],
      coingecko_id: "joltify",
      keywords: ["staking"],
      socials: {
        website: "https://www.joltify.io/",
        twitter: "https://twitter.com/joltify_finance"
      }
    },
    {
      description: "The native staking and governance token of the Cosmos Hub.",
      denom_units: [{
        denom: "ibc/9117A26BA81E29FA4F78F57DC2BD90CD3D26848101BA880445F119B22A1E254E",
        exponent: 0,
        aliases: ["uatom"]
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9117A26BA81E29FA4F78F57DC2BD90CD3D26848101BA880445F119B22A1E254E",
      name: "Cosmos Hub",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-866"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }]
    },
    {
      description: "USDC is a fully collateralized US Dollar stablecoin developed by CENTRE, the open source project with Circle being the first of several forthcoming issuers.",
      denom_units: [{
        denom: "ibc/65D0BEC6DAD96C7F5043D1E54E54B6BB5D5B3AEC3FF6CEBB75B9E059F3580EA3",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/65D0BEC6DAD96C7F5043D1E54E54B6BB5D5B3AEC3FF6CEBB75B9E059F3580EA3",
      name: "USDC",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "noble",
          base_denom: "uusdc",
          channel_id: "channel-81"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    }
  ]
};
_0.default = jM;
var y0 = {};
Object.defineProperty(y0, "__esModule", { value: !0 });
const CM = {
  $schema: "../chain.schema.json",
  chain_name: "joltify",
  status: "live",
  network_type: "mainnet",
  website: "https://www.joltify.io/",
  pretty_name: "Joltify",
  chain_type: "cosmos",
  chain_id: "joltify_1729-1",
  bech32_prefix: "jolt",
  daemon_name: "jolt",
  node_home: "$HOME/.joltify",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ujolt",
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ujolt"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.5",
    cosmwasm_enabled: !1
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/joltify/images/jolt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/joltify/images/jolt.svg",
    theme: {
      primary_color_hex: "#2dfb71"
    }
  }],
  description: "Joltify is the First EVM compatible game-changing L1 Public Chain built on the Cosmos SDK for Real-World Assets (RWA) and Beyond.",
  apis: {
    rpc: [{
      address: "https://rpc.joltify.io",
      provider: "joltify"
    }, {
      address: "https://joltify_mainnet_rpc.chain.whenmoonwhenlambo.money",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }],
    rest: [{
      address: "https://lcd.joltify.io/",
      provider: "joltify"
    }, {
      address: "https://joltify_mainnet_api.chain.whenmoonwhenlambo.money",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }],
    grpc: [{
      address: "grpc.joltify.io:443",
      provider: "joltify"
    }],
    "evm-http-jsonrpc": [{
      address: "https://evm.joltify.io/",
      provider: "joltify"
    }, {
      address: "https://joltify_mainnet_evm.chain.whenmoonwhenlambo.money",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }]
  },
  explorers: [{
    kind: "big dipper",
    url: "https://explorer.joltify.io/joltify",
    tx_page: "https://explorer.joltify.io/joltify/transactions/${txHash}",
    account_page: "https://explorer.joltify.io/joltify/accounts/${accountAddress}"
  }, {
    kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
    url: "https://explorer.whenmoonwhenlambo.money/joltify",
    tx_page: "https://explorer.whenmoonwhenlambo.money/joltify/tx/${txHash}",
    account_page: "https://explorer.whenmoonwhenlambo.money/joltify/account/${accountAddress}"
  }],
  keywords: ["rwa", "lending"]
};
y0.default = CM;
var b0 = {};
Object.defineProperty(b0, "__esModule", { value: !0 });
const EM = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cosmoshub",
    client_id: "07-tendermint-1307",
    connection_id: "connection-1041"
  },
  chain_2: {
    chain_name: "joltify",
    client_id: "07-tendermint-3",
    connection_id: "connection-2"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-866",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "joltify",
    client_id: "07-tendermint-4",
    connection_id: "connection-1"
  },
  chain_2: {
    chain_name: "noble",
    client_id: "07-tendermint-102",
    connection_id: "connection-94"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-81",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
b0.default = EM;
var v0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ut, "__esModule", { value: !0 });
Ut.ibc = Ut.chain = Ut.assets = void 0;
const DM = v0(_0), BM = v0(y0), FM = v0(b0);
Ut.assets = DM.default;
Ut.chain = BM.default;
Ut.ibc = FM.default;
var Ht = {}, f0 = {};
Object.defineProperty(f0, "__esModule", { value: !0 });
const $M = {
  $schema: "../assetlist.schema.json",
  chain_name: "juno",
  assets: [
    {
      description: "The native token of JUNO Chain",
      denom_units: [{
        denom: "ujuno",
        exponent: 0
      }, {
        denom: "juno",
        exponent: 6
      }],
      base: "ujuno",
      name: "Juno",
      display: "juno",
      symbol: "JUNO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.svg"
      },
      coingecko_id: "juno-network",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.svg",
        theme: {
          primary_color_hex: "#fa7b7b"
        }
      }],
      socials: {
        website: "https://junonetwork.io/",
        twitter: "https://twitter.com/JunoNetwork"
      }
    },
    {
      denom_units: [{
        denom: "ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9",
        exponent: 0
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9",
      name: "ATOM on Juno",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-207"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      }
    },
    {
      description: "The native token cw20 for Neta on Juno Chain",
      type_asset: "cw20",
      address: "juno168ctmpyppk90d34p3jjy658zf5a5l3w8wk35wht6ccqj4mr0yv8s4j5awr",
      denom_units: [{
        denom: "cw20:juno168ctmpyppk90d34p3jjy658zf5a5l3w8wk35wht6ccqj4mr0yv8s4j5awr",
        exponent: 0
      }, {
        denom: "neta",
        exponent: 6
      }],
      base: "cw20:juno168ctmpyppk90d34p3jjy658zf5a5l3w8wk35wht6ccqj4mr0yv8s4j5awr",
      name: "Neta",
      display: "neta",
      symbol: "NETA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/neta.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/neta.svg"
      },
      coingecko_id: "neta",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/neta.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/neta.svg",
        theme: {
          primary_color_hex: "#f87b7b"
        }
      }]
    },
    {
      description: "The native token cw20 for Marble DAO on Juno Chain",
      type_asset: "cw20",
      address: "juno1g2g7ucurum66d42g8k5twk34yegdq8c82858gz0tq2fc75zy7khssgnhjl",
      denom_units: [{
        denom: "cw20:juno1g2g7ucurum66d42g8k5twk34yegdq8c82858gz0tq2fc75zy7khssgnhjl",
        exponent: 0
      }, {
        denom: "marble",
        exponent: 3
      }],
      base: "cw20:juno1g2g7ucurum66d42g8k5twk34yegdq8c82858gz0tq2fc75zy7khssgnhjl",
      name: "Marble",
      display: "marble",
      symbol: "MARBLE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/marble.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/marble.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/marble.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/marble.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Hope Galaxy is an NFT collection based on its own native Token $HOPE, a cw20 token on Juno chain.",
      type_asset: "cw20",
      address: "juno1re3x67ppxap48ygndmrc7har2cnc7tcxtm9nplcas4v0gc3wnmvs3s807z",
      denom_units: [{
        denom: "cw20:juno1re3x67ppxap48ygndmrc7har2cnc7tcxtm9nplcas4v0gc3wnmvs3s807z",
        exponent: 0
      }, {
        denom: "hope",
        exponent: 6
      }],
      base: "cw20:juno1re3x67ppxap48ygndmrc7har2cnc7tcxtm9nplcas4v0gc3wnmvs3s807z",
      name: "Hope Galaxy",
      display: "hope",
      symbol: "HOPE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hope.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hope.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hope.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hope.svg",
        theme: {
          primary_color_hex: "#e2877e"
        }
      }]
    },
    {
      description: "Racoon aims to simplify accessibility to AI, NFTs and Gambling on the Cosmos Ecosystem",
      type_asset: "cw20",
      address: "juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa",
      denom_units: [{
        denom: "cw20:juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa",
        exponent: 0
      }, {
        denom: "rac",
        exponent: 6
      }],
      base: "cw20:juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa",
      name: "Racoon",
      display: "rac",
      symbol: "RAC",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/urac"
        },
        provider: "Racoon"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/rac.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/rac.svg"
      },
      coingecko_id: "racoon",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/rac.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/rac.svg",
        theme: {
          primary_color_hex: "#070f0e"
        }
      }]
    },
    {
      description: "The native token of Marble DEX on Juno Chain",
      type_asset: "cw20",
      address: "juno1y9rf7ql6ffwkv02hsgd4yruz23pn4w97p75e2slsnkm0mnamhzysvqnxaq",
      denom_units: [{
        denom: "cw20:juno1y9rf7ql6ffwkv02hsgd4yruz23pn4w97p75e2slsnkm0mnamhzysvqnxaq",
        exponent: 0
      }, {
        denom: "block",
        exponent: 6
      }],
      base: "cw20:juno1y9rf7ql6ffwkv02hsgd4yruz23pn4w97p75e2slsnkm0mnamhzysvqnxaq",
      name: "Block",
      display: "block",
      symbol: "BLOCK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/block.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/block.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/block.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/block.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The DAO token to build consensus among Hong Kong People",
      type_asset: "cw20",
      address: "juno1tdjwrqmnztn2j3sj2ln9xnyps5hs48q3ddwjrz7jpv6mskappjys5czd49",
      denom_units: [{
        denom: "cw20:juno1tdjwrqmnztn2j3sj2ln9xnyps5hs48q3ddwjrz7jpv6mskappjys5czd49",
        exponent: 0,
        aliases: ["dhk"]
      }],
      base: "cw20:juno1tdjwrqmnztn2j3sj2ln9xnyps5hs48q3ddwjrz7jpv6mskappjys5czd49",
      name: "DHK",
      display: "dhk",
      symbol: "DHK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dhk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dhk.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dhk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dhk.svg",
        theme: {
          primary_color_hex: "#fae204"
        }
      }]
    },
    {
      description: "Token governance for Junoswap",
      type_asset: "cw20",
      address: "juno15u3dt79t6sxxa3x3kpkhzsy56edaa5a66wvt3kxmukqjz2sx0hes5sn38g",
      denom_units: [{
        denom: "cw20:juno15u3dt79t6sxxa3x3kpkhzsy56edaa5a66wvt3kxmukqjz2sx0hes5sn38g",
        exponent: 0
      }, {
        denom: "raw",
        exponent: 6
      }],
      base: "cw20:juno15u3dt79t6sxxa3x3kpkhzsy56edaa5a66wvt3kxmukqjz2sx0hes5sn38g",
      name: "JunoSwap",
      display: "raw",
      symbol: "RAW",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/raw.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/raw.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/raw.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/raw.svg",
        theme: {
          primary_color_hex: "#f07c92"
        }
      }]
    },
    {
      description: "Profit sharing token for Another.Software validator. Hold and receive dividends from Another.Software validator commissions!",
      type_asset: "cw20",
      address: "juno17wzaxtfdw5em7lc94yed4ylgjme63eh73lm3lutp2rhcxttyvpwsypjm4w",
      denom_units: [{
        denom: "cw20:juno17wzaxtfdw5em7lc94yed4ylgjme63eh73lm3lutp2rhcxttyvpwsypjm4w",
        exponent: 0
      }, {
        denom: "asvt",
        exponent: 6
      }],
      base: "cw20:juno17wzaxtfdw5em7lc94yed4ylgjme63eh73lm3lutp2rhcxttyvpwsypjm4w",
      name: "Another.Software Validator Token",
      display: "asvt",
      symbol: "ASVT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/asvt.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/asvt.png",
        theme: {
          primary_color_hex: "#402e5d"
        }
      }]
    },
    {
      description: "IBC HNS is HNS, coin of Handshake, decentralized root namesystem, but wrapped to cosmos for IBC support by Another.Software through Juno network.",
      type_asset: "cw20",
      address: "juno1ur4jx0sxchdevahep7fwq28yk4tqsrhshdtylz46yka3uf6kky5qllqp4k",
      denom_units: [{
        denom: "cw20:juno1ur4jx0sxchdevahep7fwq28yk4tqsrhshdtylz46yka3uf6kky5qllqp4k",
        exponent: 0
      }, {
        denom: "hns",
        exponent: 6
      }],
      base: "cw20:juno1ur4jx0sxchdevahep7fwq28yk4tqsrhshdtylz46yka3uf6kky5qllqp4k",
      name: "IBC HNS (Handshake)",
      display: "hns",
      symbol: "HNS",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hns.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hns.svg"
      }]
    },
    {
      description: "DAO dedicated to building tools on the Juno Network",
      type_asset: "cw20",
      address: "juno1n7n7d5088qlzlj37e9mgmkhx6dfgtvt02hqxq66lcap4dxnzdhwqfmgng3",
      denom_units: [{
        denom: "cw20:juno1n7n7d5088qlzlj37e9mgmkhx6dfgtvt02hqxq66lcap4dxnzdhwqfmgng3",
        exponent: 0
      }, {
        denom: "joe",
        exponent: 6
      }],
      base: "cw20:juno1n7n7d5088qlzlj37e9mgmkhx6dfgtvt02hqxq66lcap4dxnzdhwqfmgng3",
      name: "JoeDAO",
      display: "joe",
      symbol: "JOE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/joe.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/joe.png",
        theme: {
          primary_color_hex: "#f3baaf"
        }
      }]
    },
    {
      description: "Governance Token for Digital Land Acquisition DAO",
      type_asset: "cw20",
      address: "juno1sfwye65qxcfsc837gu5qcprcz7w49gkv3wnat04764ld76hy3arqs779tr",
      denom_units: [{
        denom: "cw20:juno1sfwye65qxcfsc837gu5qcprcz7w49gkv3wnat04764ld76hy3arqs779tr",
        exponent: 0
      }, {
        denom: "dla",
        exponent: 6
      }],
      base: "cw20:juno1sfwye65qxcfsc837gu5qcprcz7w49gkv3wnat04764ld76hy3arqs779tr",
      name: "Digital Land Acquisition DAO",
      display: "dla",
      symbol: "DLA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dla.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dla.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dla.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dla.svg",
        theme: {
          primary_color_hex: "#263a70"
        }
      }]
    },
    {
      description: "DeFi gaming platform built on Juno",
      type_asset: "cw20",
      address: "juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se",
      denom_units: [{
        denom: "cw20:juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se",
        exponent: 0
      }, {
        denom: "glto",
        exponent: 6
      }],
      base: "cw20:juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se",
      name: "Gelotto",
      display: "glto",
      symbol: "GLTO",
      traces: [{
        type: "legacy-mintage",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2"
        },
        provider: "Gelotto"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg",
        theme: {
          primary_color_hex: "#501cad"
        }
      }]
    },
    {
      description: "Gelotto Year 1 Grand Prize Token",
      type_asset: "cw20",
      address: "juno1gz8cf86zr4vw9cjcyyv432vgdaecvr9n254d3uwwkx9rermekddsxzageh",
      denom_units: [{
        denom: "cw20:juno1gz8cf86zr4vw9cjcyyv432vgdaecvr9n254d3uwwkx9rermekddsxzageh",
        exponent: 0
      }, {
        denom: "gkey",
        exponent: 6
      }],
      base: "cw20:juno1gz8cf86zr4vw9cjcyyv432vgdaecvr9n254d3uwwkx9rermekddsxzageh",
      name: "GKey",
      display: "gkey",
      symbol: "GKEY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/gkey.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/gkey.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/gkey.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/gkey.svg",
        theme: {
          primary_color_hex: "#521caf"
        }
      }]
    },
    {
      description: "The native token cw20 for BlackHole on Juno Chain",
      type_asset: "cw20",
      address: "juno1t46z6hg8vvsena7sue0vg6w85ljar3cundplkre9sz0skeqkap9sxyyy6m",
      denom_units: [{
        denom: "cw20:juno1t46z6hg8vvsena7sue0vg6w85ljar3cundplkre9sz0skeqkap9sxyyy6m",
        exponent: 0
      }, {
        denom: "hole",
        exponent: 6
      }],
      base: "cw20:juno1t46z6hg8vvsena7sue0vg6w85ljar3cundplkre9sz0skeqkap9sxyyy6m",
      name: "BlackHole",
      display: "hole",
      symbol: "HOLE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hole.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hole.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hole.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hole.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Staking derivative seJUNO for staked JUNO",
      type_asset: "cw20",
      address: "juno1dd0k0um5rqncfueza62w9sentdfh3ec4nw4aq4lk5hkjl63vljqscth9gv",
      denom_units: [{
        denom: "cw20:juno1dd0k0um5rqncfueza62w9sentdfh3ec4nw4aq4lk5hkjl63vljqscth9gv",
        exponent: 0
      }, {
        denom: "sejuno",
        exponent: 6
      }],
      base: "cw20:juno1dd0k0um5rqncfueza62w9sentdfh3ec4nw4aq4lk5hkjl63vljqscth9gv",
      name: "StakeEasy seJUNO",
      display: "sejuno",
      symbol: "SEJUNO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sejuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sejuno.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sejuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sejuno.svg",
        theme: {
          primary_color_hex: "#26363f"
        }
      }]
    },
    {
      description: "Staking derivative bJUNO for staked JUNO",
      type_asset: "cw20",
      address: "juno1wwnhkagvcd3tjz6f8vsdsw5plqnw8qy2aj3rrhqr2axvktzv9q2qz8jxn3",
      denom_units: [{
        denom: "cw20:juno1wwnhkagvcd3tjz6f8vsdsw5plqnw8qy2aj3rrhqr2axvktzv9q2qz8jxn3",
        exponent: 0
      }, {
        denom: "bjuno",
        exponent: 6
      }],
      base: "cw20:juno1wwnhkagvcd3tjz6f8vsdsw5plqnw8qy2aj3rrhqr2axvktzv9q2qz8jxn3",
      name: "StakeEasy bJUNO",
      display: "bjuno",
      symbol: "BJUNO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bjuno.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bjuno.svg",
        theme: {
          primary_color_hex: "#254454"
        }
      }]
    },
    {
      description: "Solarbank DAO Governance Token for speeding up the shift to renewable and green energy",
      type_asset: "cw20",
      address: "juno159q8t5g02744lxq8lfmcn6f78qqulq9wn3y9w7lxjgkz4e0a6kvsfvapse",
      denom_units: [{
        denom: "cw20:juno159q8t5g02744lxq8lfmcn6f78qqulq9wn3y9w7lxjgkz4e0a6kvsfvapse",
        exponent: 0
      }, {
        denom: "solar",
        exponent: 6
      }],
      base: "cw20:juno159q8t5g02744lxq8lfmcn6f78qqulq9wn3y9w7lxjgkz4e0a6kvsfvapse",
      name: "Solarbank DAO",
      display: "solar",
      symbol: "SOLAR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/solar.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/solar.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/solar.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/solar.svg",
        theme: {
          primary_color_hex: "#1c1c1b"
        }
      }]
    },
    {
      description: "StakeEasy governance token",
      type_asset: "cw20",
      address: "juno19rqljkh95gh40s7qdx40ksx3zq5tm4qsmsrdz9smw668x9zdr3lqtg33mf",
      denom_units: [{
        denom: "cw20:juno19rqljkh95gh40s7qdx40ksx3zq5tm4qsmsrdz9smw668x9zdr3lqtg33mf",
        exponent: 0
      }, {
        denom: "seasy",
        exponent: 6
      }],
      base: "cw20:juno19rqljkh95gh40s7qdx40ksx3zq5tm4qsmsrdz9smw668x9zdr3lqtg33mf",
      name: "StakeEasy SEASY",
      display: "seasy",
      symbol: "SEASY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/seasy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/seasy.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/seasy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/seasy.svg",
        theme: {
          primary_color_hex: "#2d2c2d"
        }
      }]
    },
    {
      description: "The native token cw20 for MuseDAO on Juno Chain",
      type_asset: "cw20",
      address: "juno1p8x807f6h222ur0vssqy3qk6mcpa40gw2pchquz5atl935t7kvyq894ne3",
      denom_units: [{
        denom: "cw20:juno1p8x807f6h222ur0vssqy3qk6mcpa40gw2pchquz5atl935t7kvyq894ne3",
        exponent: 0
      }, {
        denom: "muse",
        exponent: 6
      }],
      base: "cw20:juno1p8x807f6h222ur0vssqy3qk6mcpa40gw2pchquz5atl935t7kvyq894ne3",
      name: "MuseDAO",
      display: "muse",
      symbol: "MUSE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/muse.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/muse.png",
        theme: {
          primary_color_hex: "#32255f"
        }
      }]
    },
    {
      description: "The native token cw20 for Loop Finance on Juno Chain",
      type_asset: "cw20",
      address: "juno1qsrercqegvs4ye0yqg93knv73ye5dc3prqwd6jcdcuj8ggp6w0us66deup",
      denom_units: [{
        denom: "cw20:juno1qsrercqegvs4ye0yqg93knv73ye5dc3prqwd6jcdcuj8ggp6w0us66deup",
        exponent: 0
      }, {
        denom: "loop",
        exponent: 6
      }],
      base: "cw20:juno1qsrercqegvs4ye0yqg93knv73ye5dc3prqwd6jcdcuj8ggp6w0us66deup",
      name: "Loop Finance",
      display: "loop",
      symbol: "LOOP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/loop.png"
      },
      coingecko_id: "loop",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/loop.png",
        theme: {
          primary_color_hex: "#2d2c45"
        }
      }]
    },
    {
      description: "The deprecated cw20 token for Fanfury on Juno Chain",
      type_asset: "cw20",
      address: "juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz",
      denom_units: [{
        denom: "cw20:juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz",
        exponent: 0
      }, {
        denom: "fury",
        exponent: 6
      }],
      base: "cw20:juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz",
      name: "FURY.legacy",
      display: "fury",
      symbol: "FURY.legacy",
      traces: [{
        type: "legacy-mintage",
        counterparty: {
          chain_name: "furya",
          base_denom: "ufury"
        },
        provider: "Fanfury"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/fanfury.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/fanfury.png",
        theme: {
          primary_color_hex: "#14045c"
        }
      }]
    },
    {
      description: "The native token cw20 for PHMN on Juno Chain",
      extended_description: "$PHMN is the governance token of a distributed validator. Similar to PoS chains, each holder possesses voting rights proportionate to the number of locked tokens. PHMN holders can govern the POSTHUMAN validator via DAODAO. For instance, decisions such as diversifying the treasury, updating the validator's commission rate, or exiting the network are determined by the PHMN community.",
      type_asset: "cw20",
      address: "juno1rws84uz7969aaa7pej303udhlkt3j9ca0l3egpcae98jwak9quzq8szn2l",
      denom_units: [{
        denom: "cw20:juno1rws84uz7969aaa7pej303udhlkt3j9ca0l3egpcae98jwak9quzq8szn2l",
        exponent: 0
      }, {
        denom: "phmn",
        exponent: 6
      }],
      base: "cw20:juno1rws84uz7969aaa7pej303udhlkt3j9ca0l3egpcae98jwak9quzq8szn2l",
      name: "POSTHUMAN",
      display: "phmn",
      symbol: "PHMN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/phmn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/phmn.svg"
      },
      coingecko_id: "posthuman",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/phmn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/phmn.svg",
        theme: {
          primary_color_hex: "#bbc2c6"
        }
      }],
      socials: {
        website: "https://posthuman.digital/",
        twitter: "https://twitter.com/POSTHUMAN_DVS"
      }
    },
    {
      description: "The native token cw20 for Hopers on Juno Chain",
      type_asset: "cw20",
      address: "juno1u45shlp0q4gcckvsj06ss4xuvsu0z24a0d0vr9ce6r24pht4e5xq7q995n",
      denom_units: [{
        denom: "cw20:juno1u45shlp0q4gcckvsj06ss4xuvsu0z24a0d0vr9ce6r24pht4e5xq7q995n",
        exponent: 0
      }, {
        denom: "hopers",
        exponent: 6
      }],
      base: "cw20:juno1u45shlp0q4gcckvsj06ss4xuvsu0z24a0d0vr9ce6r24pht4e5xq7q995n",
      name: "Hopers",
      display: "hopers",
      symbol: "HOPERS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hopers.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hopers.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hopers.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hopers.svg",
        theme: {
          primary_color_hex: "#08d890"
        }
      }]
    },
    {
      description: "RED",
      type_asset: "cw20",
      address: "juno1g647t78y2ulqlm3lss8rs3d0spzd0teuwhdvnqn92tr79yltk9dq2h24za",
      denom_units: [{
        denom: "cw20:juno1g647t78y2ulqlm3lss8rs3d0spzd0teuwhdvnqn92tr79yltk9dq2h24za",
        exponent: 0
      }, {
        denom: "red",
        exponent: 6
      }],
      base: "cw20:juno1g647t78y2ulqlm3lss8rs3d0spzd0teuwhdvnqn92tr79yltk9dq2h24za",
      name: "Red",
      display: "red",
      symbol: "RED",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/red.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/red.png",
        theme: {
          primary_color_hex: "#e40404"
        }
      }]
    },
    {
      description: "BLUE",
      type_asset: "cw20",
      address: "juno14q8kk464fafql2fwmlsgvgcdl6h2csqpzv4hr025fmcvgjahpess32k0j7",
      denom_units: [{
        denom: "cw20:juno14q8kk464fafql2fwmlsgvgcdl6h2csqpzv4hr025fmcvgjahpess32k0j7",
        exponent: 0
      }, {
        denom: "blue",
        exponent: 6
      }],
      base: "cw20:juno14q8kk464fafql2fwmlsgvgcdl6h2csqpzv4hr025fmcvgjahpess32k0j7",
      name: "Blue",
      display: "blue",
      symbol: "BLUE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/blue.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/blue.png",
        theme: {
          primary_color_hex: "#041ce4"
        }
      }]
    },
    {
      description: "WYND DAO Governance Token",
      type_asset: "cw20",
      address: "juno1mkw83sv6c7sjdvsaplrzc8yaes9l42p4mhy0ssuxjnyzl87c9eps7ce3m9",
      denom_units: [{
        denom: "cw20:juno1mkw83sv6c7sjdvsaplrzc8yaes9l42p4mhy0ssuxjnyzl87c9eps7ce3m9",
        exponent: 0
      }, {
        denom: "wynd",
        exponent: 6
      }],
      base: "cw20:juno1mkw83sv6c7sjdvsaplrzc8yaes9l42p4mhy0ssuxjnyzl87c9eps7ce3m9",
      name: "Wynd DAO Governance Token",
      display: "wynd",
      symbol: "WYND",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wynd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wynd.svg"
      },
      coingecko_id: "wynd",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wynd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wynd.svg",
        theme: {
          primary_color_hex: "#6bcc95"
        }
      }]
    },
    {
      description: "Bored APE IBC club token",
      type_asset: "cw20",
      address: "juno1s2dp05rspeuzzpzyzdchk262szehrtfpz847uvf98cnwh53ulx4qg20qwj",
      denom_units: [{
        denom: "cw20:juno1s2dp05rspeuzzpzyzdchk262szehrtfpz847uvf98cnwh53ulx4qg20qwj",
        exponent: 0
      }, {
        denom: "banana",
        exponent: 6
      }],
      base: "cw20:juno1s2dp05rspeuzzpzyzdchk262szehrtfpz847uvf98cnwh53ulx4qg20qwj",
      name: "Banana Token",
      display: "banana",
      symbol: "BANANA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/banana.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/banana.png",
        theme: {
          primary_color_hex: "#046fc6"
        }
      }]
    },
    {
      description: "nRide Token",
      extended_description: "nRide is developing a uber-like ride-hailing protocol, leveraging cosmwasm smart-contracts for payment, driver registration and text-messaging between the rider and the driver, to create a trustless public transportation environment for any cab or taxi company to use.",
      type_asset: "cw20",
      address: "juno1qmlchtmjpvu0cr7u0tad2pq8838h6farrrjzp39eqa9xswg7teussrswlq",
      denom_units: [{
        denom: "cw20:juno1qmlchtmjpvu0cr7u0tad2pq8838h6farrrjzp39eqa9xswg7teussrswlq",
        exponent: 0
      }, {
        denom: "nride",
        exponent: 6
      }],
      base: "cw20:juno1qmlchtmjpvu0cr7u0tad2pq8838h6farrrjzp39eqa9xswg7teussrswlq",
      name: "nRide Token",
      display: "nride",
      symbol: "NRIDE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/nride.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/nride.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/nride.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/nride.svg",
        theme: {
          primary_color_hex: "#050505"
        }
      }],
      socials: {
        website: "https://www.nride.com",
        twitter: "https://twitter.com/nRide12"
      }
    },
    {
      description: "Signal Art and Gaming on Juno",
      type_asset: "cw20",
      address: "juno14lycavan8gvpjn97aapzvwmsj8kyrvf644p05r0hu79namyj3ens87650k",
      denom_units: [{
        denom: "cw20:juno14lycavan8gvpjn97aapzvwmsj8kyrvf644p05r0hu79namyj3ens87650k",
        exponent: 0
      }, {
        denom: "sgnl",
        exponent: 6
      }],
      base: "cw20:juno14lycavan8gvpjn97aapzvwmsj8kyrvf644p05r0hu79namyj3ens87650k",
      name: "Signal",
      display: "sgnl",
      symbol: "SGNL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sgnl.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sgnl.png",
        theme: {
          primary_color_hex: "#c5c2c2"
        }
      }]
    },
    {
      description: "Governance and utility token for the Junø Apes NFT platform on Juno",
      type_asset: "cw20",
      address: "juno1zkwveux7y6fmsr88atf3cyffx96p0c96qr8tgcsj7vfnhx7sal3s3zu3ps",
      denom_units: [{
        denom: "cw20:juno1zkwveux7y6fmsr88atf3cyffx96p0c96qr8tgcsj7vfnhx7sal3s3zu3ps",
        exponent: 0
      }, {
        denom: "jape",
        exponent: 6
      }],
      base: "cw20:juno1zkwveux7y6fmsr88atf3cyffx96p0c96qr8tgcsj7vfnhx7sal3s3zu3ps",
      name: "Junø Apes",
      display: "jape",
      symbol: "JAPE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/jape.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/jape.png",
        theme: {
          primary_color_hex: "#ee8179"
        }
      }]
    },
    {
      description: "A community meme token with a fantasy fiction storyline and comic based NFTs on Juno",
      type_asset: "cw20",
      address: "juno12wxyvtqe76x2a5jj6ckp2hfq8v32m6rvyyxwwufl2tksqvkt7whqczv6pa",
      denom_units: [{
        denom: "cw20:juno12wxyvtqe76x2a5jj6ckp2hfq8v32m6rvyyxwwufl2tksqvkt7whqczv6pa",
        exponent: 0
      }, {
        denom: "catom",
        exponent: 6
      }],
      base: "cw20:juno12wxyvtqe76x2a5jj6ckp2hfq8v32m6rvyyxwwufl2tksqvkt7whqczv6pa",
      name: "Catom",
      display: "catom",
      symbol: "CATOM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/catom.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/catom.png",
        theme: {
          primary_color_hex: "#25221f"
        }
      }]
    },
    {
      description: "Utility token of Howl.social, an on chain micro-blogging platform on Juno",
      type_asset: "cw20",
      address: "juno1g0wuyu2f49ncf94r65278puxzclf5arse9f3kvffxyv4se4vgdmsk4dvqz",
      denom_units: [{
        denom: "cw20:juno1g0wuyu2f49ncf94r65278puxzclf5arse9f3kvffxyv4se4vgdmsk4dvqz",
        exponent: 0
      }, {
        denom: "howl",
        exponent: 6
      }],
      base: "cw20:juno1g0wuyu2f49ncf94r65278puxzclf5arse9f3kvffxyv4se4vgdmsk4dvqz",
      name: "Howl",
      display: "howl",
      symbol: "HOWL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/howl.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/howl.png",
        theme: {
          primary_color_hex: "#e30d2c"
        }
      }]
    },
    {
      description: "Inspired by Bonk. A community project to celebrate the settlers of JunoNetwork.",
      type_asset: "cw20",
      address: "juno1u8cr3hcjvfkzxcaacv9q75uw9hwjmn8pucc93pmy6yvkzz79kh3qncca8x",
      denom_units: [{
        denom: "cw20:juno1u8cr3hcjvfkzxcaacv9q75uw9hwjmn8pucc93pmy6yvkzz79kh3qncca8x",
        exponent: 0
      }, {
        denom: "fox",
        exponent: 6
      }],
      base: "cw20:juno1u8cr3hcjvfkzxcaacv9q75uw9hwjmn8pucc93pmy6yvkzz79kh3qncca8x",
      name: "Juno Fox",
      display: "fox",
      symbol: "FOX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/fox.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/fox.png",
        theme: {
          primary_color_hex: "#ee5f06"
        }
      }]
    },
    {
      description: "Evmos Guardians governance token.",
      type_asset: "cw20",
      address: "juno1xekkh27punj0uxruv3gvuydyt856fax0nu750xns99t2qcxp7xmsqwhfma",
      denom_units: [{
        denom: "cw20:juno1xekkh27punj0uxruv3gvuydyt856fax0nu750xns99t2qcxp7xmsqwhfma",
        exponent: 0
      }, {
        denom: "grdn",
        exponent: 6
      }],
      base: "cw20:juno1xekkh27punj0uxruv3gvuydyt856fax0nu750xns99t2qcxp7xmsqwhfma",
      name: "Guardian",
      display: "grdn",
      symbol: "GRDN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/guardian.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/guardian.png",
        theme: {
          primary_color_hex: "#07d7ac"
        }
      }]
    },
    {
      description: "Mini Punks Token",
      type_asset: "cw20",
      address: "juno166heaxlyntd33a5euh4rrz26svhean4klzw594esmd02l4atan6sazy2my",
      denom_units: [{
        denom: "cw20:juno166heaxlyntd33a5euh4rrz26svhean4klzw594esmd02l4atan6sazy2my",
        exponent: 0
      }, {
        denom: "mnpu",
        exponent: 6
      }],
      base: "cw20:juno166heaxlyntd33a5euh4rrz26svhean4klzw594esmd02l4atan6sazy2my",
      name: "Mini Punks",
      display: "mnpu",
      symbol: "MNPU",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mnpu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mnpu.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mnpu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mnpu.svg",
        theme: {
          primary_color_hex: "#dadbce"
        }
      }]
    },
    {
      description: "Kleomedes Token",
      extended_description: `Kleomedes is an infrastructure provider that self-hosts nodes that validate IBC networks. We are active in supporting the chains we validate through providing infrastructure support in the form of RPC endpoints and relayers.

As a DAO, we have a community of delegators who are active in the discussion of governance on all the chains we validate. We are one of the only validators in the Cosmos Ecosystem that places 100% of profits under the control of DAO governance.

We support innovation in the Cosmos Ecosystem by funding and supporting projects that we believe, support the growth and decentralization of the networks we validate.`,
      type_asset: "cw20",
      address: "juno10gthz5ufgrpuk5cscve2f0hjp56wgp90psqxcrqlg4m9mcu9dh8q4864xy",
      denom_units: [{
        denom: "cw20:juno10gthz5ufgrpuk5cscve2f0hjp56wgp90psqxcrqlg4m9mcu9dh8q4864xy",
        exponent: 0
      }, {
        denom: "kleo",
        exponent: 6
      }],
      base: "cw20:juno10gthz5ufgrpuk5cscve2f0hjp56wgp90psqxcrqlg4m9mcu9dh8q4864xy",
      name: "Kleomedes",
      display: "kleo",
      symbol: "KLEO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/kleomedes.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/kleomedes.png",
        theme: {
          primary_color_hex: "#240454"
        }
      }]
    },
    {
      description: "Sikoba Governance Token",
      type_asset: "cw20",
      address: "juno1qqwf3lkfjhp77yja7gmg3y95pda0e5xctqrdhf3wvwdd79flagvqfgrgxp",
      denom_units: [{
        denom: "cw20:juno1qqwf3lkfjhp77yja7gmg3y95pda0e5xctqrdhf3wvwdd79flagvqfgrgxp",
        exponent: 0
      }, {
        denom: "sikoba",
        exponent: 6
      }],
      base: "cw20:juno1qqwf3lkfjhp77yja7gmg3y95pda0e5xctqrdhf3wvwdd79flagvqfgrgxp",
      name: "Sikoba Token",
      display: "sikoba",
      symbol: "SKOJ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sikoba.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sikoba.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sikoba.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sikoba.svg",
        theme: {
          primary_color_hex: "#fbfbfb"
        }
      }]
    },
    {
      description: "Shiba Cosmos",
      type_asset: "cw20",
      address: "juno1x5qt47rw84c4k6xvvywtrd40p8gxjt8wnmlahlqg07qevah3f8lqwxfs7z",
      denom_units: [{
        denom: "cw20:juno1x5qt47rw84c4k6xvvywtrd40p8gxjt8wnmlahlqg07qevah3f8lqwxfs7z",
        exponent: 0
      }, {
        denom: "shibac",
        exponent: 6
      }],
      base: "cw20:juno1x5qt47rw84c4k6xvvywtrd40p8gxjt8wnmlahlqg07qevah3f8lqwxfs7z",
      name: "ShibaCosmos",
      display: "shibac",
      symbol: "SHIBAC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/shibacosmos.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/shibacosmos.png",
        theme: {
          primary_color_hex: "#eea95d"
        }
      }]
    },
    {
      description: "Celestims",
      type_asset: "cw20",
      address: "juno1ngww7zxak55fql42wmyqrr4rhzpne24hhs4p3w4cwhcdgqgr3hxsmzl9zg",
      denom_units: [{
        denom: "cw20:juno1ngww7zxak55fql42wmyqrr4rhzpne24hhs4p3w4cwhcdgqgr3hxsmzl9zg",
        exponent: 0
      }, {
        denom: "clst",
        exponent: 6
      }],
      base: "cw20:juno1ngww7zxak55fql42wmyqrr4rhzpne24hhs4p3w4cwhcdgqgr3hxsmzl9zg",
      name: "Celestims",
      display: "clst",
      symbol: "CLST",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/celestims.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/celestims.png",
        theme: {
          primary_color_hex: "#0b1d33"
        }
      }]
    },
    {
      description: "A revolutionary DAO created to bring clean drinking water to men, women, and children worldwide. We hope you join us on our journey!",
      type_asset: "cw20",
      address: "juno1m4h8q4p305wgy7vkux0w6e5ylhqll3s6pmadhxkhqtuwd5wlxhxs8xklsw",
      denom_units: [{
        denom: "cw20:juno1m4h8q4p305wgy7vkux0w6e5ylhqll3s6pmadhxkhqtuwd5wlxhxs8xklsw",
        exponent: 0
      }, {
        denom: "watr",
        exponent: 6
      }],
      base: "cw20:juno1m4h8q4p305wgy7vkux0w6e5ylhqll3s6pmadhxkhqtuwd5wlxhxs8xklsw",
      name: "WATR",
      display: "watr",
      symbol: "WATR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/watr.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/watr.png",
        theme: {
          primary_color_hex: "#38b5c5"
        }
      }]
    },
    {
      description: "An innovative DAO dedicated to housing the most vulnerable",
      type_asset: "cw20",
      address: "juno1ju8k8sqwsqu5k6umrypmtyqu2wqcpnrkf4w4mntvl0javt4nma7s8lzgss",
      denom_units: [{
        denom: "cw20:juno1ju8k8sqwsqu5k6umrypmtyqu2wqcpnrkf4w4mntvl0javt4nma7s8lzgss",
        exponent: 0
      }, {
        denom: "casa",
        exponent: 6
      }],
      base: "cw20:juno1ju8k8sqwsqu5k6umrypmtyqu2wqcpnrkf4w4mntvl0javt4nma7s8lzgss",
      name: "Casa",
      display: "casa",
      symbol: "CASA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/casa.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/casa.png",
        theme: {
          primary_color_hex: "#04040c"
        }
      }]
    },
    {
      description: "Social Impact DAO providing showers, meals, and vehicles to the homeless",
      type_asset: "cw20",
      address: "juno1j4ux0f6gt7e82z7jdpm25v4g2gts880ap64rdwa49989wzhd0dfqed6vqm",
      denom_units: [{
        denom: "cw20:juno1j4ux0f6gt7e82z7jdpm25v4g2gts880ap64rdwa49989wzhd0dfqed6vqm",
        exponent: 0
      }, {
        denom: "summit",
        exponent: 6
      }],
      base: "cw20:juno1j4ux0f6gt7e82z7jdpm25v4g2gts880ap64rdwa49989wzhd0dfqed6vqm",
      name: "Summit",
      display: "summit",
      symbol: "SUMMIT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/summit.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/summit.png",
        theme: {
          primary_color_hex: "#cbdb44"
        }
      }]
    },
    {
      description: "Social Impact DAO dedicated to combatting food insecurity and malnutrition",
      type_asset: "cw20",
      address: "juno13ca2g36ng6etcfhr9qxx352uw2n5e92np54thfkm3w3nzlhsgvwsjaqlyq",
      denom_units: [{
        denom: "cw20:juno13ca2g36ng6etcfhr9qxx352uw2n5e92np54thfkm3w3nzlhsgvwsjaqlyq",
        exponent: 0
      }, {
        denom: "manna",
        exponent: 6
      }],
      base: "cw20:juno13ca2g36ng6etcfhr9qxx352uw2n5e92np54thfkm3w3nzlhsgvwsjaqlyq",
      name: "Manna",
      display: "manna",
      symbol: "MANNA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/manna.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/manna.png",
        theme: {
          primary_color_hex: "#299544"
        }
      }]
    },
    {
      description: "Social Impact DAO focused on youth empowerment",
      type_asset: "cw20",
      address: "juno12etxwkxvms0uy9ak8g3pyq6a53myukufdnx82pakzmjmpm77a0ksr9gs5v",
      denom_units: [{
        denom: "cw20:juno12etxwkxvms0uy9ak8g3pyq6a53myukufdnx82pakzmjmpm77a0ksr9gs5v",
        exponent: 0
      }, {
        denom: "empwr",
        exponent: 6
      }],
      base: "cw20:juno12etxwkxvms0uy9ak8g3pyq6a53myukufdnx82pakzmjmpm77a0ksr9gs5v",
      name: "EMPWR",
      display: "empwr",
      symbol: "EMPWR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/empwr.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/empwr.png",
        theme: {
          primary_color_hex: "#5561aa"
        }
      }]
    },
    {
      description: "Join us in fighting against world hunger",
      type_asset: "cw20",
      address: "juno1525fuspletvzykpgr2atxpymu9le4mghd7qq4a4u23uwqzc2f3fq7fmafd",
      denom_units: [{
        denom: "cw20:juno1525fuspletvzykpgr2atxpymu9le4mghd7qq4a4u23uwqzc2f3fq7fmafd",
        exponent: 0
      }, {
        denom: "middle",
        exponent: 6
      }],
      base: "cw20:juno1525fuspletvzykpgr2atxpymu9le4mghd7qq4a4u23uwqzc2f3fq7fmafd",
      name: "Middle",
      display: "middle",
      symbol: "MIDDLE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/middle.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/middle.png",
        theme: {
          primary_color_hex: "#04040c"
        }
      }]
    },
    {
      description: "Social Impact DAO taking a wholistic approach to helping abused and mentally ill women and children",
      type_asset: "cw20",
      address: "juno17703kcxtsg37hryxnestejyyycuv5yyvnghp2e7w0kqvafnnyetsgzq62w",
      denom_units: [{
        denom: "cw20:juno17703kcxtsg37hryxnestejyyycuv5yyvnghp2e7w0kqvafnnyetsgzq62w",
        exponent: 0
      }, {
        denom: "sunset",
        exponent: 6
      }],
      base: "cw20:juno17703kcxtsg37hryxnestejyyycuv5yyvnghp2e7w0kqvafnnyetsgzq62w",
      name: "Sunset",
      display: "sunset",
      symbol: "SUNSET",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sunset.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sunset.png",
        theme: {
          primary_color_hex: "#e0372c"
        }
      }]
    },
    {
      description: "Social Impact DAO dedicated to helping restore and protect our environment",
      type_asset: "cw20",
      address: "juno1uu3rxu7w7fpfj4sl4xpxppgymk57mzdzn6kg7492jdxh5dwk7d2qq9429e",
      denom_units: [{
        denom: "cw20:juno1uu3rxu7w7fpfj4sl4xpxppgymk57mzdzn6kg7492jdxh5dwk7d2qq9429e",
        exponent: 0
      }, {
        denom: "tree",
        exponent: 6
      }],
      base: "cw20:juno1uu3rxu7w7fpfj4sl4xpxppgymk57mzdzn6kg7492jdxh5dwk7d2qq9429e",
      name: "Living Tree",
      display: "tree",
      symbol: "TREE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/livingtree.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/livingtree.png",
        theme: {
          primary_color_hex: "#469743"
        }
      }]
    },
    {
      description: "Evmos Guardians' Invaders DAO token.",
      type_asset: "cw20",
      address: "juno1jwdy7v4egw36pd84aeks3ww6n8k7zhsumd4ac8q5lts83ppxueus4626e8",
      denom_units: [{
        denom: "cw20:juno1jwdy7v4egw36pd84aeks3ww6n8k7zhsumd4ac8q5lts83ppxueus4626e8",
        exponent: 0
      }, {
        denom: "invdrs",
        exponent: 6
      }],
      base: "cw20:juno1jwdy7v4egw36pd84aeks3ww6n8k7zhsumd4ac8q5lts83ppxueus4626e8",
      name: "Invaders",
      display: "invdrs",
      symbol: "INVDRS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/invdrs.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/invdrs.png",
        theme: {
          primary_color_hex: "#04ccab"
        }
      }]
    },
    {
      description: "Apemos",
      type_asset: "cw20",
      address: "juno1jrr0tuuzxrrwcg6hgeqhw5wqpck2y55734e7zcrp745aardlp0qqg8jz06",
      denom_units: [{
        denom: "cw20:juno1jrr0tuuzxrrwcg6hgeqhw5wqpck2y55734e7zcrp745aardlp0qqg8jz06",
        exponent: 0
      }, {
        denom: "apemos",
        exponent: 6
      }],
      base: "cw20:juno1jrr0tuuzxrrwcg6hgeqhw5wqpck2y55734e7zcrp745aardlp0qqg8jz06",
      name: "Apemos",
      display: "apemos",
      symbol: "APEMOS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/apemos.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/apemos.png",
        theme: {
          primary_color_hex: "#4d5264"
        }
      }]
    },
    {
      description: "The First Doge on Osmosis",
      type_asset: "cw20",
      address: "juno1ytymtllllsp3hfmndvcp802p2xmy5s8m59ufel8xv9ahyxyfs4hs4kd4je",
      denom_units: [{
        denom: "cw20:juno1ytymtllllsp3hfmndvcp802p2xmy5s8m59ufel8xv9ahyxyfs4hs4kd4je",
        exponent: 0
      }, {
        denom: "osdoge",
        exponent: 6
      }],
      base: "cw20:juno1ytymtllllsp3hfmndvcp802p2xmy5s8m59ufel8xv9ahyxyfs4hs4kd4je",
      name: "Osmosis Doge",
      display: "osdoge",
      symbol: "OSDOGE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/osdoge.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/osdoge.png",
        theme: {
          primary_color_hex: "#f49c4c"
        }
      }]
    },
    {
      description: "Doge Apr",
      type_asset: "cw20",
      address: "juno1k2ruzzvvwwtwny6gq6kcwyfhkzahaunp685wmz4hafplduekj98q9hgs6d",
      denom_units: [{
        denom: "cw20:juno1k2ruzzvvwwtwny6gq6kcwyfhkzahaunp685wmz4hafplduekj98q9hgs6d",
        exponent: 0
      }, {
        denom: "doga",
        exponent: 6
      }],
      base: "cw20:juno1k2ruzzvvwwtwny6gq6kcwyfhkzahaunp685wmz4hafplduekj98q9hgs6d",
      name: "Doge Apr",
      display: "doga",
      symbol: "DOGA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/doga.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/doga.png",
        theme: {
          primary_color_hex: "#d6a84f"
        }
      }]
    },
    {
      description: "Osmo Pepe",
      type_asset: "cw20",
      address: "juno1zqrj3ta4u7ylv0wqzd8t8q3jrr9rdmn43zuzp9zemeunecnhy8fss778g7",
      denom_units: [{
        denom: "cw20:juno1zqrj3ta4u7ylv0wqzd8t8q3jrr9rdmn43zuzp9zemeunecnhy8fss778g7",
        exponent: 0
      }, {
        denom: "pepe",
        exponent: 6
      }],
      base: "cw20:juno1zqrj3ta4u7ylv0wqzd8t8q3jrr9rdmn43zuzp9zemeunecnhy8fss778g7",
      name: "Osmo Pepe",
      display: "pepe",
      symbol: "PEPE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/pepe.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/pepe.png",
        theme: {
          primary_color_hex: "#f3c79e"
        }
      }]
    },
    {
      description: "Catmos",
      type_asset: "cw20",
      address: "juno1f5datjdse3mdgrapwuzs3prl7pvxxht48ns6calnn0t77v2s9l8s0qu488",
      denom_units: [{
        denom: "cw20:juno1f5datjdse3mdgrapwuzs3prl7pvxxht48ns6calnn0t77v2s9l8s0qu488",
        exponent: 0
      }, {
        denom: "catmos",
        exponent: 6
      }],
      base: "cw20:juno1f5datjdse3mdgrapwuzs3prl7pvxxht48ns6calnn0t77v2s9l8s0qu488",
      name: "Catmos",
      display: "catmos",
      symbol: "CATMOS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/catmos.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/catmos.png",
        theme: {
          primary_color_hex: "#140c44"
        }
      }]
    },
    {
      description: "Spacer",
      type_asset: "cw20",
      address: "juno1dyyf7pxeassxvftf570krv7fdf5r8e4r04mp99h0mllsqzp3rs4q7y8yqg",
      denom_units: [{
        denom: "cw20:juno1dyyf7pxeassxvftf570krv7fdf5r8e4r04mp99h0mllsqzp3rs4q7y8yqg",
        exponent: 0
      }, {
        denom: "spacer",
        exponent: 6
      }],
      base: "cw20:juno1dyyf7pxeassxvftf570krv7fdf5r8e4r04mp99h0mllsqzp3rs4q7y8yqg",
      name: "Spacer",
      display: "spacer",
      symbol: "SPACER",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/spacer.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/spacer.png",
        theme: {
          primary_color_hex: "#695335"
        }
      }]
    },
    {
      description: "Light: LumenX community DAO treasury token",
      type_asset: "cw20",
      address: "juno1dpany8c0lj526lsa02sldv7shzvnw5dt5ues72rk35hd69rrydxqeraz8l",
      denom_units: [{
        denom: "cw20:juno1dpany8c0lj526lsa02sldv7shzvnw5dt5ues72rk35hd69rrydxqeraz8l",
        exponent: 0
      }, {
        denom: "light",
        exponent: 9
      }],
      base: "cw20:juno1dpany8c0lj526lsa02sldv7shzvnw5dt5ues72rk35hd69rrydxqeraz8l",
      name: "LIGHT",
      display: "light",
      symbol: "LIGHT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/light.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/light.png",
        theme: {
          primary_color_hex: "#e5e5e5"
        }
      }]
    },
    {
      description: "Mille: the 1000th token on osmosis",
      type_asset: "cw20",
      address: "juno1llg7q2d5dqlrqzh5dxv8c7kzzjszld34s5vktqmlmaaxqjssz43sxyhq0d",
      denom_units: [{
        denom: "cw20:juno1llg7q2d5dqlrqzh5dxv8c7kzzjszld34s5vktqmlmaaxqjssz43sxyhq0d",
        exponent: 0
      }, {
        denom: "mile",
        exponent: 6
      }],
      base: "cw20:juno1llg7q2d5dqlrqzh5dxv8c7kzzjszld34s5vktqmlmaaxqjssz43sxyhq0d",
      name: "Mille",
      display: "mile",
      symbol: "MILE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mille.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mille.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Void",
      type_asset: "cw20",
      address: "juno1lpvx3mv2a6ddzfjc7zzz2v2cm5gqgqf0hx67hc5p5qwn7hz4cdjsnznhu8",
      denom_units: [{
        denom: "cw20:juno1lpvx3mv2a6ddzfjc7zzz2v2cm5gqgqf0hx67hc5p5qwn7hz4cdjsnznhu8",
        exponent: 0
      }, {
        denom: "void",
        exponent: 6
      }],
      base: "cw20:juno1lpvx3mv2a6ddzfjc7zzz2v2cm5gqgqf0hx67hc5p5qwn7hz4cdjsnznhu8",
      name: "Void",
      display: "void",
      symbol: "VOID",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/void.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/void.png",
        theme: {
          primary_color_hex: "#5b2e96"
        }
      }]
    },
    {
      description: "Silica",
      type_asset: "cw20",
      address: "juno10vgf2u03ufcf25tspgn05l7j3tfg0j63ljgpffy98t697m5r5hmqaw95ux",
      denom_units: [{
        denom: "cw20:juno10vgf2u03ufcf25tspgn05l7j3tfg0j63ljgpffy98t697m5r5hmqaw95ux",
        exponent: 0
      }, {
        denom: "silica",
        exponent: 6
      }],
      base: "cw20:juno10vgf2u03ufcf25tspgn05l7j3tfg0j63ljgpffy98t697m5r5hmqaw95ux",
      name: "Silica",
      display: "silica",
      symbol: "SLCA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/silica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/silica.png",
        theme: {
          primary_color_hex: "#21538f"
        }
      }]
    },
    {
      description: "Pepec",
      type_asset: "cw20",
      address: "juno1epxnvge53c4hkcmqzlxryw5fp7eae2utyk6ehjcfpwajwp48km3sgxsh9k",
      denom_units: [{
        denom: "cw20:juno1epxnvge53c4hkcmqzlxryw5fp7eae2utyk6ehjcfpwajwp48km3sgxsh9k",
        exponent: 0
      }, {
        denom: "pepec",
        exponent: 6
      }],
      base: "cw20:juno1epxnvge53c4hkcmqzlxryw5fp7eae2utyk6ehjcfpwajwp48km3sgxsh9k",
      name: "Pepec",
      display: "pepec",
      symbol: "PEPEC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/pepec.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/pepec.png",
        theme: {
          primary_color_hex: "#e9bc37"
        }
      }]
    },
    {
      description: "Palantin",
      type_asset: "cw20",
      address: "juno15au4k2jgwd0jnchy0fkg3lm00fpt7jt0j2duuzradn2q7sega2dszyn5pp",
      denom_units: [{
        denom: "cw20:juno15au4k2jgwd0jnchy0fkg3lm00fpt7jt0j2duuzradn2q7sega2dszyn5pp",
        exponent: 0
      }, {
        denom: "pltn",
        exponent: 6
      }],
      base: "cw20:juno15au4k2jgwd0jnchy0fkg3lm00fpt7jt0j2duuzradn2q7sega2dszyn5pp",
      name: "Palantin",
      display: "pltn",
      symbol: "PLTN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/pltn.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/pltn.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Propose. Vote. Build.",
      type_asset: "cw20",
      address: "juno12mcwmd6wqhledkjsurlfqtc8j0pedvxlcxw3gs4kh2qf808ehehsen8nmw",
      denom_units: [{
        denom: "cw20:juno12mcwmd6wqhledkjsurlfqtc8j0pedvxlcxw3gs4kh2qf808ehehsen8nmw",
        exponent: 0
      }, {
        denom: "yfd",
        exponent: 6
      }],
      base: "cw20:juno12mcwmd6wqhledkjsurlfqtc8j0pedvxlcxw3gs4kh2qf808ehehsen8nmw",
      name: "Y-Foundry DAO",
      display: "yfd",
      symbol: "YFD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/yfd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/yfd.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/yfd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/yfd.svg",
        theme: {
          primary_color_hex: "#dc542c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "factory/juno1qly4zcmzr2gyxtze5yt9chv2srczwwunppxjfh/NEXX",
        exponent: 0
      }, {
        denom: "nexx",
        exponent: 6
      }],
      address: "juno1qly4zcmzr2gyxtze5yt9chv2srczwwunppxjfh",
      base: "factory/juno1qly4zcmzr2gyxtze5yt9chv2srczwwunppxjfh/NEXX",
      name: "NEXX GEN AI",
      display: "nexx",
      symbol: "NEXX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/nexx.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/nexx.png",
        theme: {
          primary_color_hex: "#040405"
        }
      }]
    },
    {
      denom_units: [{
        denom: "factory/juno1u805lv20qc6jy7c3ttre7nct6uyl20pfky5r7e/DGL",
        exponent: 0
      }, {
        denom: "dgl",
        exponent: 6
      }],
      address: "juno1u805lv20qc6jy7c3ttre7nct6uyl20pfky5r7e",
      base: "factory/juno1u805lv20qc6jy7c3ttre7nct6uyl20pfky5r7e/DGL",
      name: "Licorice",
      display: "dgl",
      symbol: "DGL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dgl.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dgl.png",
        theme: {
          primary_color_hex: "#dfe0e0"
        }
      }]
    },
    {
      description: "ERIS liquid staked JUNO",
      type_asset: "cw20",
      address: "juno1a0khag6cfzu5lrwazmyndjgvlsuk7g4vn9jd8ceym8f4jf6v2l9q6d348a",
      denom_units: [{
        denom: "cw20:juno1a0khag6cfzu5lrwazmyndjgvlsuk7g4vn9jd8ceym8f4jf6v2l9q6d348a",
        exponent: 0
      }, {
        denom: "ampJUNO",
        exponent: 6
      }],
      base: "cw20:juno1a0khag6cfzu5lrwazmyndjgvlsuk7g4vn9jd8ceym8f4jf6v2l9q6d348a",
      name: "ERIS Amplified JUNO",
      display: "ampJUNO",
      symbol: "ampJUNO",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/ampjuno.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/ampjuno.svg"
      }]
    },
    {
      description: "BITS - Native token of Bitswift Cash",
      type_asset: "cw20",
      address: "juno14fz92ehqt37e096xr95kmy8nc0kz803uezxtg4fwx7agjjma86sqm8mg3h",
      denom_units: [{
        denom: "cw20:juno14fz92ehqt37e096xr95kmy8nc0kz803uezxtg4fwx7agjjma86sqm8mg3h",
        exponent: 0
      }, {
        denom: "bits",
        exponent: 8
      }],
      base: "cw20:juno14fz92ehqt37e096xr95kmy8nc0kz803uezxtg4fwx7agjjma86sqm8mg3h",
      name: "BITS",
      display: "bits",
      symbol: "BITS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bits.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bits.png",
        theme: {
          primary_color_hex: "#7bbc43"
        }
      }]
    },
    {
      description: "The least memeable memecoin in existence. The cats have had their day, it's time for $POIL coin to take reign.",
      type_asset: "cw20",
      address: "juno13epyeat7ef0k7q6kllmyvc8zpfd9xm7cqjrgtk0qkgrk7n5mjfmq8979jw",
      denom_units: [{
        denom: "cw20:juno13epyeat7ef0k7q6kllmyvc8zpfd9xm7cqjrgtk0qkgrk7n5mjfmq8979jw",
        exponent: 0
      }, {
        denom: "poil",
        exponent: 6
      }],
      base: "cw20:juno13epyeat7ef0k7q6kllmyvc8zpfd9xm7cqjrgtk0qkgrk7n5mjfmq8979jw",
      name: "POIL",
      display: "poil",
      symbol: "POIL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/poil.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/poil.png",
        theme: {
          primary_color_hex: "#ef6d1d"
        }
      }]
    },
    {
      description: "Minerva was one of the main goddesses worshiped by the Roman Pagans and is a goddess from Roman Mythology.",
      type_asset: "cw20",
      address: "juno1h86ut5aevlxuuxrra6wy3dfq6e39zkzzv9eelz678jr6amxlc4gsx46j82",
      denom_units: [{
        denom: "cw20:juno1h86ut5aevlxuuxrra6wy3dfq6e39zkzzv9eelz678jr6amxlc4gsx46j82",
        exponent: 0
      }, {
        denom: "minerva",
        exponent: 6
      }],
      base: "cw20:juno1h86ut5aevlxuuxrra6wy3dfq6e39zkzzv9eelz678jr6amxlc4gsx46j82",
      name: "MINERVA",
      display: "minerva",
      symbol: "MRVA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/minerva.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/minerva.png",
        theme: {
          primary_color_hex: "#744c2f"
        }
      }]
    },
    {
      description: "In Roman mythology, Juno (Latin: Iuno; pronounced [[Help:Pronunciation|[ˈjuːnoː]]]) was the protector and advisor of the state.",
      type_asset: "cw20",
      address: "juno13c57ssxvlzefsj4v5spdz4m9r6c6s2far5npvmc9en7nz02xqjyqne40gk",
      denom_units: [{
        denom: "cw20:juno13c57ssxvlzefsj4v5spdz4m9r6c6s2far5npvmc9en7nz02xqjyqne40gk",
        exponent: 0
      }, {
        denom: "luno",
        exponent: 6
      }],
      base: "cw20:juno13c57ssxvlzefsj4v5spdz4m9r6c6s2far5npvmc9en7nz02xqjyqne40gk",
      name: "LUNO",
      display: "luno",
      symbol: "LUNO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/luno.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/luno.png",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }]
    },
    {
      description: "ATEN is NETA.",
      type_asset: "cw20",
      address: "juno1elpg96tju8a32vzn25u6asvscajjm4000589z0zthhvks28ajypqzurl7r",
      denom_units: [{
        denom: "cw20:juno1elpg96tju8a32vzn25u6asvscajjm4000589z0zthhvks28ajypqzurl7r",
        exponent: 0
      }, {
        denom: "aten",
        exponent: 6
      }],
      base: "cw20:juno1elpg96tju8a32vzn25u6asvscajjm4000589z0zthhvks28ajypqzurl7r",
      name: "ATEN",
      display: "aten",
      symbol: "ATEN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/aten.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/aten.png",
        theme: {
          primary_color_hex: "#1e1d1d"
        }
      }]
    },
    {
      description: "HERA is the goddess of marriage in Greek mythology.",
      type_asset: "cw20",
      address: "juno1dtd45vxvv080v9x7hffysnmvrqm6ysecjdnvafqul28646hm04xs9gheh0",
      denom_units: [{
        denom: "cw20:juno1dtd45vxvv080v9x7hffysnmvrqm6ysecjdnvafqul28646hm04xs9gheh0",
        exponent: 0
      }, {
        denom: "hera",
        exponent: 6
      }],
      base: "cw20:juno1dtd45vxvv080v9x7hffysnmvrqm6ysecjdnvafqul28646hm04xs9gheh0",
      name: "HERA",
      display: "hera",
      symbol: "HERA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hera.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hera.png",
        theme: {
          primary_color_hex: "#a9784c"
        }
      }]
    },
    {
      description: "BackBone Labs Liquid Staked JUNO",
      type_asset: "cw20",
      address: "juno1mvkgcr5uce2rnpzr4qrzf50hx4qreuwzlt7fzsjrhjud3xnjmttq5mkh2m",
      denom_units: [{
        denom: "cw20:juno1mvkgcr5uce2rnpzr4qrzf50hx4qreuwzlt7fzsjrhjud3xnjmttq5mkh2m",
        exponent: 0
      }, {
        denom: "bJUNO",
        exponent: 6
      }],
      base: "cw20:juno1mvkgcr5uce2rnpzr4qrzf50hx4qreuwzlt7fzsjrhjud3xnjmttq5mkh2m",
      name: "BackBone Labs Liquid Staked JUNO",
      display: "bJUNO",
      symbol: "bJUNO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bJUNO-bbl.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bJUNO-bbl.png",
        theme: {
          primary_color_hex: "#d17e7f"
        }
      }],
      coingecko_id: "backbone-labs-staked-juno"
    },
    {
      type_asset: "ics20",
      description: "USD Coin on Juno",
      denom_units: [{
        denom: "ibc/4A482FA914A4B9B05801ED81C33713899F322B24F76A06F4B8FE872485EA22FF",
        exponent: 0,
        aliases: ["uusdc", "microusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      base: "ibc/4A482FA914A4B9B05801ED81C33713899F322B24F76A06F4B8FE872485EA22FF",
      name: "USD Coin",
      display: "usdc",
      symbol: "USDC",
      coingecko_id: "usd-coin",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      traces: [{
        type: "ibc",
        counterparty: {
          channel_id: "channel-3",
          base_denom: "uusdc",
          chain_name: "noble"
        },
        chain: {
          channel_id: "channel-224",
          path: "transfer/channel-224/uusdc"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/F0C440C8040E2FCCAC621D32D3A00D9B347C989D52CE869A91CB34D07B0021D2",
        exponent: 0,
        aliases: ["factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"]
      }, {
        denom: "rstk",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F0C440C8040E2FCCAC621D32D3A00D9B347C989D52CE869A91CB34D07B0021D2",
      name: "Restake DAO Token",
      display: "rstk",
      symbol: "RSTK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-210",
          path: "transfer/channel-210/factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.svg",
        theme: {
          primary_color_hex: "#3ccc64"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.svg"
      }
    },
    {
      denom_units: [{
        denom: "factory/juno1h6y8tkceau4d8zyv5aa0fwdj2pa2y0gz2hx0tq/uwind",
        exponent: 0
      }, {
        denom: "wind",
        exponent: 6
      }],
      address: "juno1h6y8tkceau4d8zyv5aa0fwdj2pa2y0gz2hx0tq",
      base: "factory/juno1h6y8tkceau4d8zyv5aa0fwdj2pa2y0gz2hx0tq/uwind",
      name: "Wind Token",
      display: "wind",
      symbol: "WIND",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wind.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wind.png",
        theme: {
          primary_color_hex: "#122b4d"
        }
      }]
    },
    {
      description: "Airdrop For All [AFA - New Name on Cosmos Ecosystem, A4A - Old Name on TurtleNetwork] is a token from turtleNetwork towards cosmos ecosystem.",
      type_asset: "cw20",
      address: "juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg",
      denom_units: [{
        denom: "cw20:juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg",
        exponent: 0
      }],
      base: "cw20:juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg",
      name: "Airdrop For All",
      display: "cw20:juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg",
      symbol: "AFA",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/afa.png",
        theme: {
          primary_color_hex: "#f3cb0c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/afa.png"
      }
    },
    {
      description: "The token for the Arena DAO",
      type_asset: "sdk.coin",
      address: "juno12dgadj3wwv5jn0ec7tw5cgvq526nn4gnt2tujlmd57p2ra6k87esl36r9k",
      denom_units: [{
        denom: "factory/juno1vwmnqk0vyxc96qgffrure4nqxupjrql0zut8s02hadgp0n79r8xq5xdsxy/ARENA",
        exponent: 0
      }, {
        denom: "arena",
        exponent: 6
      }],
      base: "factory/juno1vwmnqk0vyxc96qgffrure4nqxupjrql0zut8s02hadgp0n79r8xq5xdsxy/ARENA",
      name: "Arena Token",
      display: "arena",
      symbol: "ARENA",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/arena.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/arena.png",
        theme: {
          primary_color_hex: "#dc6c24"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/arena.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/arena.svg"
      }
    },
    {
      description: "ashWIND",
      denom_units: [{
        denom: "factory/juno16uprl38e4ljj5ctuha9ehpvp2l93z3d5jmwj2cttt6jkhlrhscpqgglalk/wind.ash",
        exponent: 0
      }, {
        denom: "ashWIND",
        exponent: 6
      }],
      base: "factory/juno16uprl38e4ljj5ctuha9ehpvp2l93z3d5jmwj2cttt6jkhlrhscpqgglalk/wind.ash",
      name: "ashWIND",
      display: "ashWIND",
      symbol: "ashWIND",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wind.ash.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wind.ash.png"
      }]
    }
  ]
};
f0.default = $M;
var w0 = {};
Object.defineProperty(w0, "__esModule", { value: !0 });
const zM = {
  $schema: "../chain.schema.json",
  chain_name: "juno",
  status: "live",
  network_type: "mainnet",
  website: "https://www.junonetwork.io/",
  pretty_name: "Juno",
  chain_type: "cosmos",
  chain_id: "juno-1",
  bech32_prefix: "juno",
  daemon_name: "junod",
  node_home: "$HOME/.juno",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ujuno",
      fixed_min_gas_price: 0.075,
      low_gas_price: 0.075,
      average_gas_price: 0.1,
      high_gas_price: 0.125
    }, {
      denom: "ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9",
      fixed_min_gas_price: 3e-3,
      low_gas_price: 3e-3,
      average_gas_price: 35e-4,
      high_gas_price: 4e-3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ujuno"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.12",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.46.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.svg"
  },
  description: "Juno is a completely community owned and operated smart contract platform.",
  apis: {
    rpc: [
      {
        address: "https://rpc-juno.itastakers.com",
        provider: "itastakers"
      },
      {
        address: "http://juno.rpc.m.stavr.tech:1067",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-juno.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://juno-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc.lavenderfive.com:443/juno",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-juno.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://rpc-juno.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://rpc-juno-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc.juno.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://juno-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://juno-rpc.icycro.org",
        provider: "IcyCRO 🧊"
      },
      {
        address: "https://rpc.juno.bh.rocks",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://juno-rpc.kingnodes.com",
        provider: "kingnodes 👑"
      },
      {
        address: "https://juno-rpc.reece.sh",
        provider: "Reecepbcups"
      },
      {
        address: "https://juno-rpc.stakeandrelax.net",
        provider: "Stake&Relax Validator 🦥"
      },
      {
        address: "https://rpc-juno.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://rpc-juno-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://rpc-juno.validavia.me",
        provider: "Validavia"
      },
      {
        address: "https://juno-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://juno-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://juno-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://rpc-juno.mainnet.validatrium.club:443",
        provider: "Validatrium"
      },
      {
        address: "https://juno-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://rpc.juno.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://rpc.juno.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://juno-rpc.cogwheel.zone",
        provider: "Cogwheel"
      },
      {
        address: "https://juno.declab.pro:26610",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://juno.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      }
    ],
    rest: [
      {
        address: "https://lcd-juno.itastakers.com",
        provider: "itastakers"
      },
      {
        address: "https://rest-juno.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://rest.lavenderfive.com:443/juno",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://juno.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-juno.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://api-juno-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://api.juno.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://juno-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://api-juno.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://juno-api.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://api.juno.bh.rocks",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://juno-rest.kingnodes.com",
        provider: "kingnodes 👑"
      },
      {
        address: "https://juno-api.stakeandrelax.net",
        provider: "Stake&Relax Validator 🦥"
      },
      {
        address: "https://rest-juno.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://api-juno-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://lcd-juno.validavia.me",
        provider: "Validavia"
      },
      {
        address: "https://juno-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://juno-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://juno-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://juno-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://api.juno.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://lcd.juno.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://juno-api.cogwheel.zone",
        provider: "Cogwheel"
      },
      {
        address: "https://juno.declab.pro:443",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://juno.api.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      }
    ],
    grpc: [
      {
        address: "grpc-juno-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "juno.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "juno-grpc.polkachu.com:12690",
        provider: "Polkachu"
      },
      {
        address: "http://juno.grpc.m.stavr.tech:504",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://juno-grpc.kingnodes.com:443",
        provider: "kingnodes 👑"
      },
      {
        address: "grpc-juno.cosmos-spaces.cloud:4830",
        provider: "Cosmos Spaces"
      },
      {
        address: "http://juno-grpc.stakeandrelax.net:12690",
        provider: "Stake&Relax Validator 🦥"
      },
      {
        address: "grpc-juno.architectnodes.com:1443",
        provider: "Architect Nodes"
      },
      {
        address: "juno-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "http://167.235.211.168:9091",
        provider: "CommunityStaking"
      },
      {
        address: "grpc-juno-01.stakeflow.io:2302",
        provider: "Stakeflow"
      },
      {
        address: "juno-grpc.w3coins.io:12690",
        provider: "w3coins"
      },
      {
        address: "juno-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "juno-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "138.201.21.121:24990",
        provider: "Validatrium"
      },
      {
        address: "juno-grpc.stakeandrelax.net:12690",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "grpc.juno.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://grpc.juno.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "juno-grpc.cogwheel.zone:443",
        provider: "Cogwheel"
      },
      {
        address: "https://juno.declab.pro:9007",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://juno.grpc.nodeshub.online",
        provider: "Nodes Hub"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/juno",
      tx_page: "https://ezstaking.app/juno/txs/${txHash}",
      account_page: "https://ezstaking.app/juno/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/juno",
      tx_page: "https://ping.pub/juno/tx/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://juno.explorers.guru",
      tx_page: "https://juno.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/juno",
      tx_page: "https://www.mintscan.io/juno/transactions/${txHash}",
      account_page: "https://www.mintscan.io/juno/accounts/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/juno",
      tx_page: "https://atomscan.com/juno/transactions/${txHash}",
      account_page: "https://atomscan.com/juno/accounts/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/juno",
      tx_page: "https://explorer.stavr.tech/juno/transactions/${txHash}",
      account_page: "https://explorer.stavr.tech/juno/accounts/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/juno",
      tx_page: "https://explorer.tcnetwork.io/juno/transaction/${txHash}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/juno",
      account_page: "https://stakeflow.io/juno/accounts/${accountAddress}"
    },
    {
      kind: "Decloud Nodes Lab",
      url: "https://explorer.declab.pro/Juno",
      tx_page: "https://explorer.declab.pro/Juno/tx/${txHash}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
      url: "https://explorer.nodeshub.online/juno/",
      tx_page: "https://explorer.nodeshub.online/juno/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/juno/accounts/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/juno",
      tx_page: "https://mainnet.whispernode.com/juno/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/juno/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.svg",
    theme: {
      primary_color_hex: "#fa7b7b"
    }
  }]
};
w0.default = zM;
var x0 = {};
Object.defineProperty(x0, "__esModule", { value: !0 });
const qM = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-84",
      connection_id: "connection-58"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-80",
      connection_id: "connection-47"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-35",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-18",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-387",
      connection_id: "connection-379"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-290",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "assetmantle",
      client_id: "07-tendermint-22",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-167",
      connection_id: "connection-113"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-83",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-25",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-150",
      connection_id: "connection-97"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-71",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitcanna",
      client_id: "07-tendermint-12",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-110",
      connection_id: "connection-70"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitsong",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-33",
      connection_id: "connection-26"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-54",
      connection_id: "connection-30"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-79",
      connection_id: "connection-46"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-28",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-30",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-92",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-30",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-382",
      connection_id: "connection-376"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-280",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-439",
      connection_id: "connection-372"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-207",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-5",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-160",
      connection_id: "connection-107"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-81",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dig",
      client_id: "07-tendermint-17",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-100",
      connection_id: "connection-62"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "emoney",
      client_id: "07-tendermint-51",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-24",
      connection_id: "connection-16"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "furya",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "juno",
      client_id: "07-tendermint-501",
      connection_id: "connection-505"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-417",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-198",
      connection_id: "connection-140"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-87",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-300",
      connection_id: "connection-270"
    },
    chain_2: {
      chain_name: "mars",
      client_id: "07-tendermint-11",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-209",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-310",
      connection_id: "connection-282"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-210",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-557",
      connection_id: "connection-524"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-97",
      connection_id: "connection-71"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-548",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4328",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-334",
      connection_id: "connection-322"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-3",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-224",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-335",
      connection_id: "connection-325"
    },
    chain_2: {
      chain_name: "nois",
      client_id: "07-tendermint-1",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-225",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-243",
        port_id: "wasm.juno1qr84ktm57q5t02u04ddk5r8s79axdzglad6tfdd9g2xgt4hkh6jsgeq9x2"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-314",
      connection_id: "connection-285"
    },
    chain_2: {
      chain_name: "okexchain",
      client_id: "07-tendermint-122",
      connection_id: "connection-92"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-212",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-52",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1457",
      connection_id: "connection-1142"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-47",
        port_id: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn"
      },
      chain_2: {
        channel_id: "channel-169",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-89",
      connection_id: "connection-51"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-49",
      connection_id: "connection-48"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-318",
      connection_id: "connection-309"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-17",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-215",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-108",
      connection_id: "connection-68"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-23",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-48",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-163",
        port_id: "transfer",
        client_id: "07-tendermint-108",
        connection_id: "connection-68"
      },
      chain_2: {
        channel_id: "channel-45",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
        client_id: "07-tendermint-23",
        connection_id: "connection-9"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-9",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-37",
      connection_id: "connection-17"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-44",
      connection_id: "connection-30"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-13",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-263",
      connection_id: "connection-205"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-31",
      connection_id: "connection-19"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-139",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-24",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-202",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-48",
          port_id: "icacontroller-juno-1.DELEGATION"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0,
          properties: "liquid staking"
        }
      },
      {
        chain_1: {
          channel_id: "channel-143",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-26",
          port_id: "icacontroller-juno-1.FEE"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0,
          properties: "liquid staking"
        }
      },
      {
        chain_1: {
          channel_id: "channel-142",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-27",
          port_id: "icacontroller-juno-1.WITHDRAWAL"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0,
          properties: "liquid staking"
        }
      },
      {
        chain_1: {
          channel_id: "channel-140",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-28",
          port_id: "icacontroller-juno-1.REDEMPTION"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0,
          properties: "liquid staking"
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-63",
      connection_id: "connection-43"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-32",
      connection_id: "connection-34"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-185",
      connection_id: "connection-128"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-3",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-86",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
x0.default = qM;
var k0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ht, "__esModule", { value: !0 });
Ht.ibc = Ht.chain = Ht.assets = void 0;
const SM = k0(f0), TM = k0(w0), RM = k0(x0);
Ht.assets = SM.default;
Ht.chain = TM.default;
Ht.ibc = RM.default;
var Lt = {}, A0 = {};
Object.defineProperty(A0, "__esModule", { value: !0 });
const OM = {
  $schema: "../assetlist.schema.json",
  chain_name: "kava",
  assets: [
    {
      description: "Kava is a decentralized finance (DeFi) platform that provides a range of financial services, including lending, borrowing, and stablecoins, leveraging the Cosmos and Ethereum ecosystems.",
      extended_description: "Kava offers a suite of DeFi services, such as lending, borrowing, and stablecoin issuance, utilizing a cross-chain platform that integrates the Cosmos SDK and Ethereum interoperability. Users can collateralize their assets to borrow Kava's stablecoin, USDX, or participate in lending and liquidity pools to earn rewards. Kava's native token, KAVA, is used for staking, governance, and securing the network. The platform's goal is to provide a decentralized, efficient, and accessible financial ecosystem that bridges multiple blockchain networks.",
      denom_units: [{
        denom: "ukava",
        exponent: 0
      }, {
        denom: "kava",
        exponent: 6
      }],
      base: "ukava",
      name: "Kava",
      display: "kava",
      symbol: "KAVA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.svg"
      },
      coingecko_id: "kava",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.svg",
        theme: {
          primary_color_hex: "#e64942"
        }
      }],
      socials: {
        website: "https://www.kava.io/",
        twitter: "https://twitter.com/KAVA_CHAIN"
      }
    },
    {
      description: "Governance token of Kava Lend Protocol",
      denom_units: [{
        denom: "hard",
        exponent: 0
      }, {
        denom: "HARD",
        exponent: 6
      }],
      base: "hard",
      name: "Kava Hard",
      display: "HARD",
      symbol: "HARD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/hard.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/hard.svg"
      },
      coingecko_id: "kava-lend",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/hard.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/hard.svg",
        theme: {
          primary_color_hex: "#7b34ac"
        }
      }]
    },
    {
      description: "Governance token of Kava Swap Protocol",
      denom_units: [{
        denom: "swp",
        exponent: 0
      }, {
        denom: "SWP",
        exponent: 6
      }],
      base: "swp",
      name: "Kava Swap",
      display: "SWP",
      symbol: "SWP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/swp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/swp.svg"
      },
      coingecko_id: "kava-swap",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/swp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/swp.svg",
        theme: {
          primary_color_hex: "#544cfc"
        }
      }]
    },
    {
      description: "The native stablecoin of Kava",
      denom_units: [{
        denom: "usdx",
        exponent: 0
      }, {
        denom: "USDX",
        exponent: 6
      }],
      base: "usdx",
      name: "Kava USDX",
      display: "USDX",
      symbol: "USDX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/usdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/usdx.svg"
      },
      coingecko_id: "usdx",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/usdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/usdx.svg",
        theme: {
          primary_color_hex: "#04d4a3"
        }
      }]
    },
    {
      denom_units: [{
        denom: "erc20/tether/usdt",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      base: "erc20/tether/usdt",
      name: "Tether USD",
      display: "usdt",
      symbol: "USDT",
      coingecko_id: "tether",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        provider: "Tether"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    }
  ]
};
A0.default = OM;
var j0 = {};
Object.defineProperty(j0, "__esModule", { value: !0 });
const MM = {
  $schema: "../chain.schema.json",
  chain_name: "kava",
  status: "live",
  network_type: "mainnet",
  website: "https://www.kava.io/",
  pretty_name: "Kava",
  chain_type: "cosmos",
  chain_id: "kava_2222-10",
  bech32_prefix: "kava",
  daemon_name: "kava",
  node_home: "$HOME/.kava",
  slip44: 459,
  alternative_slip44s: [118],
  fees: {
    fee_tokens: [{
      denom: "ukava",
      low_gas_price: 0.05,
      average_gas_price: 0.1,
      high_gas_price: 0.25
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ukava"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.svg"
  },
  description: "Kava is a decentralized blockchain that combines the speed and interoperability of Cosmos with the developer power of Ethereum.",
  apis: {
    rpc: [
      {
        address: "https://rpc.data.kava.io",
        provider: "kava"
      },
      {
        address: "https://kava-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-kava-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://kava-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://kava-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rpc-kava-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://kava-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://kava.drpc.org",
        provider: "dRPC"
      }
    ],
    rest: [
      {
        address: "https://api.data.kava.io/",
        provider: "kava"
      },
      {
        address: "https://api-kava-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://kava-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://kava-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://kava-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://api-kava-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://kava-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "grpc.data.kava.io:443",
        provider: "kava"
      },
      {
        address: "grpc-kava-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "kava-grpc.polkachu.com:13990",
        provider: "Polkachu"
      },
      {
        address: "kava-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-kava-01.stakeflow.io:1202",
        provider: "Stakeflow"
      },
      {
        address: "kava-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://evm.kava.io/",
        provider: "kava"
      },
      {
        address: "https://kava-evm.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://kava.api.onfinality.io/public",
        provider: "OnFinality"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/kava",
      tx_page: "https://www.mintscan.io/kava/transactions/${txHash}",
      account_page: "https://www.mintscan.io/kava/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/kava",
      tx_page: "https://ezstaking.app/kava/txs/${txHash}",
      account_page: "https://ezstaking.app/kava/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/kava",
      tx_page: "https://ping.pub/kava/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/kava",
      tx_page: "https://atomscan.com/kava/transactions/${txHash}",
      account_page: "https://atomscan.com/kava/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/kava",
      account_page: "https://stakeflow.io/kava/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.svg",
    theme: {
      primary_color_hex: "#e64942"
    }
  }]
};
j0.default = MM;
var C0 = {};
Object.defineProperty(C0, "__esModule", { value: !0 });
const IM = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-78",
      connection_id: "connection-73"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-147",
      connection_id: "connection-182"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-133",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-26",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-133",
      connection_id: "connection-168"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-124",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-49",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-158",
      connection_id: "connection-198"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-140",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-29",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-160",
      connection_id: "connection-200"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-142",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-557",
      connection_id: "connection-460"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-277",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cronos",
      client_id: "07-tendermint-33",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-134",
      connection_id: "connection-169"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-125",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-7",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-154",
      connection_id: "connection-195"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-137",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-162",
      connection_id: "connection-203"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-144",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-113",
      connection_id: "connection-67"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-120",
      connection_id: "connection-157"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-83",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-117",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "haqq",
      client_id: "07-tendermint-5",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-149",
      connection_id: "connection-193"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-135",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-205",
      connection_id: "connection-189"
    },
    chain_2: {
      chain_name: "kava",
      client_id: "07-tendermint-130",
      connection_id: "connection-166"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-143",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-122",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-119",
      connection_id: "connection-156"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-140",
      connection_id: "connection-106"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-95",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-125",
      connection_id: "connection-162"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-90",
      connection_id: "connection-73"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-120",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-48",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-151",
      connection_id: "connection-194"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-54",
      connection_id: "connection-37"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-136",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-172",
      connection_id: "connection-214"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-107",
      connection_id: "connection-102"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-151",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-163",
      connection_id: "connection-204"
    },
    chain_2: {
      chain_name: "onex",
      client_id: "07-tendermint-1",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-145",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1735",
      connection_id: "connection-1328"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-143",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-148",
      connection_id: "connection-189"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-156",
      connection_id: "connection-195"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-134",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-129",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-146",
      connection_id: "connection-181"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-38",
      connection_id: "connection-33"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-132",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-156",
      connection_id: "connection-196"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-386",
      connection_id: "connection-362"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-138",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-272",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-124",
      connection_id: "connection-160"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-229",
      connection_id: "connection-191"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-119",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-98",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
C0.default = IM;
var E0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Lt, "__esModule", { value: !0 });
Lt.ibc = Lt.chain = Lt.assets = void 0;
const NM = E0(A0), PM = E0(j0), UM = E0(C0);
Lt.assets = NM.default;
Lt.chain = PM.default;
Lt.ibc = UM.default;
var Wt = {}, D0 = {};
Object.defineProperty(D0, "__esModule", { value: !0 });
const HM = {
  $schema: "../assetlist.schema.json",
  chain_name: "kichain",
  assets: [{
    description: "The native token of Ki Chain",
    denom_units: [{
      denom: "uxki",
      exponent: 0
    }, {
      denom: "xki",
      exponent: 6
    }],
    base: "uxki",
    name: "Ki",
    display: "xki",
    symbol: "XKI",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.svg"
    },
    coingecko_id: "ki",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.svg",
      theme: {
        primary_color_hex: "#1c04fc"
      }
    }]
  }, {
    description: "ELEVENPARIS loyalty token on KiChain",
    type_asset: "cw20",
    address: "ki1dt3lk455ed360pna38fkhqn0p8y44qndsr77qu73ghyaz2zv4whq83mwdy",
    denom_units: [{
      denom: "cw20:ki1dt3lk455ed360pna38fkhqn0p8y44qndsr77qu73ghyaz2zv4whq83mwdy",
      exponent: 0
    }, {
      denom: "lvn",
      exponent: 6
    }],
    base: "cw20:ki1dt3lk455ed360pna38fkhqn0p8y44qndsr77qu73ghyaz2zv4whq83mwdy",
    name: "LVN",
    display: "lvn",
    symbol: "LVN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/lvn.png"
    },
    coingecko_id: "lvn",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/lvn.png",
      theme: {
        primary_color_hex: "#683480"
      }
    }]
  }]
};
D0.default = HM;
var B0 = {};
Object.defineProperty(B0, "__esModule", { value: !0 });
const LM = {
  $schema: "../chain.schema.json",
  chain_name: "kichain",
  status: "live",
  network_type: "mainnet",
  website: "https://foundation.ki/",
  pretty_name: "Ki",
  chain_type: "cosmos",
  chain_id: "kichain-2",
  bech32_prefix: "ki",
  daemon_name: "kid",
  node_home: "$HOME/.kid",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uxki",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.03,
      high_gas_price: 0.05
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uxki"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc-mainnet.blockchain.ki",
        provider: "kifoundation"
      },
      {
        address: "https://kichain-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-kichain-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://kichain-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc.kichain.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://rpc.lavenderfive.com:443/kichain",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "http://ki-chain.statesync.nodersteam.com:14657",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://ki-rpc.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rpc.kichain-2.kichain.aviaone.com",
        provider: "AVIAONE 🟢"
      }
    ],
    rest: [
      {
        address: "https://api-mainnet.blockchain.ki",
        provider: "kifoundation"
      },
      {
        address: "https://api-kichain-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://kichain.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.kichain.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://kichain-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "http://ki-chain.api.nodersteam.com:14017",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://kichain-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rest.lavenderfive.com:443/kichain",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://ki-api.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://api.kichain-2.kichain.aviaone.com",
        provider: "AVIAONE 🟢"
      }
    ],
    grpc: [
      {
        address: "grpc-kichain-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "kichain-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "ki-chain.grpc.nodersteam.com:9410",
        provider: "[NODERS]TEAM"
      },
      {
        address: "kichain-grpc.polkachu.com:13590",
        provider: "Polkachu"
      },
      {
        address: "kichain.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "grpc.kichain-2.kichain.aviaone.com:9230",
        provider: "AVIAONE 🟢"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/kichain",
      tx_page: "https://ezstaking.app/kichain/txs/${txHash}",
      account_page: "https://ezstaking.app/kichain/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/ki-chain",
      tx_page: "https://www.mintscan.io/ki-chain/txs/${txHash}",
      account_page: "https://www.mintscan.io/ki-chain/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Kichain-Mainnet",
      tx_page: "https://explorer.stavr.tech/Kichain-Mainnet/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/kichain",
      tx_page: "https://ping.pub/kichain/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/ki-chain",
      tx_page: "https://atomscan.com/ki-chain/transactions/${txHash}",
      account_page: "https://atomscan.com/ki-chain/accounts/${accountAddress}"
    },
    {
      kind: "AVIAONE Explorer 🟢",
      url: "https://mainnet.explorer.aviaone.com/kichain",
      tx_page: "https://mainnet.explorer.aviaone.com/kichain/transactions/${txHash}",
      account_page: "https://mainnet.explorer.aviaone.com/kichain/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.svg",
    theme: {
      primary_color_hex: "#1c04fc"
    }
  }]
};
B0.default = LM;
var F0 = {};
Object.defineProperty(F0, "__esModule", { value: !0 });
const WM = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cosmoshub",
    client_id: "07-tendermint-475",
    connection_id: "connection-392"
  },
  chain_2: {
    chain_name: "kichain",
    client_id: "07-tendermint-6",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-223",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "kichain",
    client_id: "07-tendermint-4",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1564",
    connection_id: "connection-1225"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-77",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }, {
    chain_1: {
      channel_id: "channel-18",
      port_id: "wasm.ki1hzz0s0ucrhdp6tue2lxk3c03nj6f60qy463we7lgx0wudd72ctmsd9kgha"
    },
    chain_2: {
      channel_id: "channel-261",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
F0.default = WM;
var $0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Wt, "__esModule", { value: !0 });
Wt.ibc = Wt.chain = Wt.assets = void 0;
const VM = $0(D0), GM = $0(B0), KM = $0(F0);
Wt.assets = VM.default;
Wt.chain = GM.default;
Wt.ibc = KM.default;
var Vt = {}, z0 = {};
Object.defineProperty(z0, "__esModule", { value: !0 });
const XM = {
  $schema: "../assetlist.schema.json",
  chain_name: "konstellation",
  assets: [{
    description: "The native token of Konstellation Network",
    denom_units: [{
      denom: "udarc",
      exponent: 0
    }, {
      denom: "darc",
      exponent: 6
    }],
    base: "udarc",
    name: "DARC",
    display: "darc",
    symbol: "DARC",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/konstellation/images/darc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/konstellation/images/darc.svg"
    },
    coingecko_id: "darcmatter-coin",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/konstellation/images/darc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/konstellation/images/darc.svg",
      theme: {
        primary_color_hex: "#042a61"
      }
    }]
  }]
};
z0.default = XM;
var q0 = {};
Object.defineProperty(q0, "__esModule", { value: !0 });
const YM = {
  $schema: "../chain.schema.json",
  chain_name: "konstellation",
  status: "live",
  network_type: "mainnet",
  website: "https://konstellation.tech/",
  pretty_name: "Konstellation",
  chain_type: "cosmos",
  chain_id: "darchub",
  bech32_prefix: "darc",
  daemon_name: "knstld",
  node_home: "$HOME/.knstld",
  slip44: 118,
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/konstellation/images/Konstellation-dark.png"
  },
  fees: {
    fee_tokens: [{
      denom: "udarc",
      fixed_min_gas_price: 0,
      low_gas_price: 1e-4,
      average_gas_price: 1e-3,
      high_gas_price: 0.01
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "udarc"
    }]
  },
  apis: {
    rpc: [{
      address: "https://rpc-konstellation-ia.cosmosia.notional.ventures/",
      provider: "Notional"
    }, {
      address: "https://konstellation-rpc.stakerhouse.com",
      provider: "StakerHouse"
    }],
    rest: [{
      address: "https://api-konstellation-ia.cosmosia.notional.ventures/",
      provider: "Notional"
    }, {
      address: "https://konstellation-rest.stakerhouse.com",
      provider: "StakerHouse"
    }],
    grpc: [
      {
        address: "grpc-konstellation-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "konstellation-grpc.polkachu.com:13390",
        provider: "Polkachu"
      },
      {
        address: "konstellation-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "konstellation-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      }
    ]
  },
  explorers: [{
    kind: "konstellation",
    url: "https://explorer.konstellation.tech/",
    tx_page: "https://explorer.konstellation.tech/tx/${txHash}"
  }, {
    kind: "cosmotracker",
    url: "https://cosmotracker.com/konstellation",
    tx_page: "https://cosmotracker.com/konstellation/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/konstellation/images/Konstellation-dark.png",
    theme: {
      primary_color_hex: "#a3d3fb"
    }
  }]
};
q0.default = YM;
var S0 = {};
Object.defineProperty(S0, "__esModule", { value: !0 });
const JM = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "konstellation",
    client_id: "07-tendermint-1",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1778",
    connection_id: "connection-1384"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-171",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
S0.default = JM;
var T0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Vt, "__esModule", { value: !0 });
Vt.ibc = Vt.chain = Vt.assets = void 0;
const ZM = T0(z0), QM = T0(q0), eI = T0(S0);
Vt.assets = ZM.default;
Vt.chain = QM.default;
Vt.ibc = eI.default;
var Gt = {}, R0 = {};
Object.defineProperty(R0, "__esModule", { value: !0 });
const nI = {
  $schema: "../assetlist.schema.json",
  chain_name: "kujira",
  assets: [
    {
      description: "Kujira is a decentralized finance (DeFi) platform offering a suite of tools and services for managing and optimizing digital assets and investments.",
      extended_description: "Kujira provides a comprehensive DeFi platform that includes tools for lending, borrowing, and yield farming, leveraging blockchain technology to offer a transparent, secure, and efficient user experience. The native token, KUJI, is central to the ecosystem, used for transaction fees, staking, and governance. Kujira's user-centric design and innovative features make it a popular choice in the DeFi space, enabling users to maximize their returns and effectively manage their digital assets.",
      denom_units: [{
        denom: "ukuji",
        exponent: 0
      }, {
        denom: "kuji",
        exponent: 6
      }],
      base: "ukuji",
      name: "Kujira",
      display: "kuji",
      symbol: "KUJI",
      coingecko_id: "kujira",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.svg",
        theme: {
          primary_color_hex: "#e33b34"
        }
      }],
      socials: {
        website: "https://kujira.network/",
        twitter: "https://twitter.com/TeamKujira"
      }
    },
    {
      description: "The native over-collateralized stablecoin from the Kujira chain.",
      denom_units: [{
        denom: "factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk",
        exponent: 0
      }, {
        denom: "usk",
        exponent: 6
      }],
      base: "factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk",
      name: "USK",
      display: "usk",
      symbol: "USK",
      coingecko_id: "usk",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/usk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/usk.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/usk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/usk.svg",
        theme: {
          primary_color_hex: "#2e363f"
        }
      }]
    },
    {
      description: "Quark's auto-compounding KUJI derivative",
      denom_units: [{
        denom: "factory/kujira1m96ucsfpt2yy72w09z2rxjdj38y5qd8lqx5jtggnejmdua2ynpnsxyvjex/urcpt",
        exponent: 0
      }, {
        denom: "qcKUJI",
        exponent: 6
      }],
      base: "factory/kujira1m96ucsfpt2yy72w09z2rxjdj38y5qd8lqx5jtggnejmdua2ynpnsxyvjex/urcpt",
      name: "qcKUJI",
      display: "qcKUJI",
      symbol: "qcKUJI",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/qckuji.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/qckuji.svg"
      }]
    },
    {
      description: "ampKUJI",
      denom_units: [{
        denom: "factory/kujira1n3fr5f56r2ce0s37wdvwrk98yhhq3unnxgcqus8nzsfxvllk0yxquurqty/ampKUJI",
        exponent: 0
      }, {
        denom: "ampKUJI",
        exponent: 6
      }],
      base: "factory/kujira1n3fr5f56r2ce0s37wdvwrk98yhhq3unnxgcqus8nzsfxvllk0yxquurqty/ampKUJI",
      name: "ampKUJI",
      display: "ampKUJI",
      symbol: "ampKUJI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/ampkuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/ampkuji.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/ampkuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/ampkuji.svg",
        theme: {
          primary_color_hex: "#4b7bbb"
        }
      }]
    },
    {
      description: "MantaDAO Governance Token",
      denom_units: [{
        denom: "factory/kujira1643jxg8wasy5cfcn7xm8rd742yeazcksqlg4d7/umnta",
        exponent: 0
      }, {
        denom: "mnta",
        exponent: 6
      }],
      base: "factory/kujira1643jxg8wasy5cfcn7xm8rd742yeazcksqlg4d7/umnta",
      name: "MantaDAO",
      display: "mnta",
      symbol: "MNTA",
      coingecko_id: "mantadao",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/mnta.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/mnta.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/mnta.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/mnta.svg",
        theme: {
          primary_color_hex: "#0c141c"
        }
      }]
    },
    {
      description: "Quark's auto-compounding MNTA derivative",
      denom_units: [{
        denom: "factory/kujira1qzu3up50auxhqyzfq56znuj8n38q2ra7daaf9ef7vg8gu66jh4fqd2wd2y/urcpt",
        exponent: 0
      }, {
        denom: "qcMNTA",
        exponent: 6
      }],
      base: "factory/kujira1qzu3up50auxhqyzfq56znuj8n38q2ra7daaf9ef7vg8gu66jh4fqd2wd2y/urcpt",
      name: "qcMNTA",
      display: "qcMNTA",
      symbol: "qcMNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/qcmnta.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/qcmnta.svg"
      }]
    },
    {
      description: "ERIS Liquid Staked MNTA",
      denom_units: [{
        denom: "factory/kujira175yatpvkpgw07w0chhzuks3zrrae9z9g2y6r7u5pzqesyau4x9eqqyv0rr/ampMNTA",
        exponent: 0
      }, {
        denom: "ampMNTA",
        exponent: 6
      }],
      base: "factory/kujira175yatpvkpgw07w0chhzuks3zrrae9z9g2y6r7u5pzqesyau4x9eqqyv0rr/ampMNTA",
      name: "ERIS Amplified MNTA",
      display: "ampMNTA",
      symbol: "ampMNTA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/ampmnta.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/ampmnta.png",
        theme: {
          primary_color_hex: "#618bc8"
        }
      }]
    },
    {
      description: "The content house of Kujira",
      denom_units: [{
        denom: "factory/kujira12cjjeytrqcj25uv349thltcygnp9k0kukpct0e/uwink",
        exponent: 0
      }, {
        denom: "wink",
        exponent: 6
      }],
      base: "factory/kujira12cjjeytrqcj25uv349thltcygnp9k0kukpct0e/uwink",
      name: "WINK",
      display: "wink",
      symbol: "WINK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/wink.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/wink.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/wink.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/wink.svg",
        theme: {
          primary_color_hex: "#fc7991"
        }
      }]
    },
    {
      description: "Blend Token",
      denom_units: [{
        denom: "factory/kujira1slueerjz7mx9jp45u3y0rjwtvhcf8a68wf2mjt/ublend",
        exponent: 0
      }, {
        denom: "blend",
        exponent: 6
      }],
      base: "factory/kujira1slueerjz7mx9jp45u3y0rjwtvhcf8a68wf2mjt/ublend",
      name: "BLEND",
      display: "blend",
      symbol: "BLEND",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/blend.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/blend.svg"
      }]
    },
    {
      description: "Tether USDt on Kujira",
      denom_units: [{
        denom: "ibc/20014F963CC9E6488B299622F87B60C6DE71632864859EC08B4753478DAB2BB8",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/20014F963CC9E6488B299622F87B60C6DE71632864859EC08B4753478DAB2BB8",
      name: "Tether USD",
      display: "usdt",
      symbol: "USDT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt",
          channel_id: "channel-116"
        },
        chain: {
          channel_id: "channel-95",
          path: "transfer/channel-95/erc20/tether/usdt"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    },
    {
      description: "The staking and governance token of Fuzion",
      denom_units: [{
        denom: "factory/kujira1sc6a0347cc5q3k890jj0pf3ylx2s38rh4sza4t/ufuzn",
        exponent: 0
      }, {
        denom: "fuzn",
        exponent: 6
      }],
      base: "factory/kujira1sc6a0347cc5q3k890jj0pf3ylx2s38rh4sza4t/ufuzn",
      name: "Fuzion",
      display: "fuzn",
      symbol: "FUZN",
      coingecko_id: "fuzion",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/fuzion.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/fuzion.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/fuzion.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/fuzion.svg",
        theme: {
          primary_color_hex: "#f05d8d"
        }
      }]
    },
    {
      description: "The receipt token of Fuzion",
      denom_units: [{
        denom: "factory/kujira1sc6a0347cc5q3k890jj0pf3ylx2s38rh4sza4t/urfuzn",
        exponent: 0
      }, {
        denom: "rfuzn",
        exponent: 6
      }],
      base: "factory/kujira1sc6a0347cc5q3k890jj0pf3ylx2s38rh4sza4t/urfuzn",
      name: "Fuzion Receipt",
      display: "rfuzn",
      symbol: "rFUZN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/fuzionr.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/fuzionr.png",
        theme: {
          primary_color_hex: "#949494"
        }
      }]
    },
    {
      description: "The yield token of Fuzion",
      denom_units: [{
        denom: "factory/kujira1sc6a0347cc5q3k890jj0pf3ylx2s38rh4sza4t/uyfuzn",
        exponent: 0
      }, {
        denom: "yfuzn",
        exponent: 6
      }],
      base: "factory/kujira1sc6a0347cc5q3k890jj0pf3ylx2s38rh4sza4t/uyfuzn",
      name: "Fuzion Yield",
      display: "yfuzn",
      symbol: "yFUZN",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/fuziony.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/fuziony.svg"
      }]
    },
    {
      description: "Quark's auto-compounding FUZN derivative",
      denom_units: [{
        denom: "factory/kujira1l04ged98c7a7s9tllu62ld09ztylwf442qgm4thfgmadrvngeumsz4zrh2/urcpt",
        exponent: 0
      }, {
        denom: "qcFUZN",
        exponent: 6
      }],
      base: "factory/kujira1l04ged98c7a7s9tllu62ld09ztylwf442qgm4thfgmadrvngeumsz4zrh2/urcpt",
      name: "qcFUZN",
      display: "qcFUZN",
      symbol: "qcFUZN",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/qcfuzn.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/qcfuzn.svg"
      }]
    },
    {
      description: "Quark's auto-compounding AQLA derivative",
      denom_units: [{
        denom: "factory/kujira1d9fmsgvu3yvvppvqech2s3dhrqdm5ukngcf82ghcl70edfpwcrlsu6yr0u/urcpt",
        exponent: 0
      }, {
        denom: "qcAQLA",
        exponent: 6
      }],
      traces: [{
        type: "liquid-stake",
        counterparty: {
          base_denom: "factory/kujira1xe0awk5planmtsmjel5xtx2hzhqdw5p8z66yqd/uaqla",
          chain_name: "kujira"
        },
        provider: "Quark Protocol",
        chain: {
          contract: "kujira1d9fmsgvu3yvvppvqech2s3dhrqdm5ukngcf82ghcl70edfpwcrlsu6yr0u"
        }
      }],
      base: "factory/kujira1d9fmsgvu3yvvppvqech2s3dhrqdm5ukngcf82ghcl70edfpwcrlsu6yr0u/urcpt",
      name: "qcAQLA",
      display: "qcAQLA",
      symbol: "qcAQLA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/qcaqla.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/qcaqla.svg"
      }]
    },
    {
      description: "The Aqualibre project's token",
      denom_units: [{
        denom: "factory/kujira1xe0awk5planmtsmjel5xtx2hzhqdw5p8z66yqd/uaqla",
        exponent: 0
      }, {
        denom: "AQLA",
        exponent: 6
      }],
      base: "factory/kujira1xe0awk5planmtsmjel5xtx2hzhqdw5p8z66yqd/uaqla",
      name: "AQLA",
      display: "AQLA",
      symbol: "AQLA",
      coingecko_id: "aqualibre",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/aqla.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/aqla.svg"
      }]
    },
    {
      description: "The Revenue & Governance token of Unstake.fi",
      denom_units: [{
        denom: "factory/kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh/unstk",
        exponent: 0
      }, {
        denom: "nstk",
        exponent: 6
      }],
      base: "factory/kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh/unstk",
      name: "Unstake Fi",
      display: "nstk",
      symbol: "NSTK",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nstk.svg"
      },
      coingecko_id: "unstake-fi",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nstk.svg"
      }]
    },
    {
      description: "Local Money",
      denom_units: [{
        denom: "factory/kujira1swkuyt08z74n5jl7zr6hx0ru5sa2yev5v896p6/local",
        exponent: 0
      }, {
        denom: "local",
        exponent: 6
      }],
      base: "factory/kujira1swkuyt08z74n5jl7zr6hx0ru5sa2yev5v896p6/local",
      name: "LOCAL",
      display: "local",
      symbol: "LOCAL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/local.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/local.png",
        theme: {
          primary_color_hex: "#242424"
        }
      }]
    },
    {
      description: "Food for whales",
      denom_units: [{
        denom: "factory/kujira166ysf07ze5suazfzj0r05tv8amk2yn8zvsfuu7/uplnk",
        exponent: 0
      }, {
        denom: "PLNK",
        exponent: 6
      }],
      base: "factory/kujira166ysf07ze5suazfzj0r05tv8amk2yn8zvsfuu7/uplnk",
      name: "Plankton",
      display: "PLNK",
      symbol: "PLNK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/PLNK_drk.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/PLNK_drk.png",
        theme: {
          primary_color_hex: "#c87ae9"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/E5CA126979E2FFB4C70C072F8094D07ECF27773B37623AD2BF7582AD0726F0F3",
        exponent: 0
      }, {
        denom: "sol",
        exponent: 8
      }],
      base: "ibc/E5CA126979E2FFB4C70C072F8094D07ECF27773B37623AD2BF7582AD0726F0F3",
      name: "Wormhole Solana",
      display: "sol",
      symbol: "SOL.wh",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA",
          channel_id: "channel-9"
        },
        chain: {
          channel_id: "channel-113",
          path: "transfer/channel-113/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        theme: {
          circle: !0,
          background_color_hex: "#000000"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/F3AA7EF362EC5E791FE78A0F4CCC69FEE1F9A7485EB1A8CAB3F6601C00522F10",
        exponent: 0
      }, {
        denom: "evmos",
        exponent: 18
      }],
      base: "ibc/F3AA7EF362EC5E791FE78A0F4CCC69FEE1F9A7485EB1A8CAB3F6601C00522F10",
      name: "Evmos",
      display: "evmos",
      symbol: "EVMOS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "evmos",
          base_denom: "aevmos",
          channel_id: "channel-18"
        },
        chain: {
          channel_id: "channel-23",
          path: "transfer/channel-23/aevmos"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "evmos",
          base_denom: "aevmos"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg",
        theme: {
          primary_color_hex: "#ec4c34"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/004EBF085BBED1029326D56BE8A2E67C08CECE670A94AC1947DF413EF5130EB2",
        exponent: 0
      }, {
        denom: "avax",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/004EBF085BBED1029326D56BE8A2E67C08CECE670A94AC1947DF413EF5130EB2",
      name: "Axelar Wrapped AVAX",
      display: "avax",
      symbol: "wAVAX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "wavax-wei",
          channel_id: "channel-14"
        },
        chain: {
          channel_id: "channel-9",
          path: "transfer/channel-9/wavax-wei"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "axelar",
          base_denom: "wavax-wei"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/wavax.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/wavax.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/FE98AAD68F02F03565E9FA39A5E627946699B2B07115889ED812D8BA639576A9",
        exponent: 0
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/FE98AAD68F02F03565E9FA39A5E627946699B2B07115889ED812D8BA639576A9",
      name: "Noble USD Coin",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "noble",
          base_denom: "uusdc",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-62",
          path: "transfer/channel-62/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/47BD209179859CDE4A2806763D7189B6E6FE13A17880FE2B42DE1E6C1E329E23",
        exponent: 0
      }, {
        denom: "osmo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/47BD209179859CDE4A2806763D7189B6E6FE13A17880FE2B42DE1E6C1E329E23",
      name: "Osmosis",
      display: "osmo",
      symbol: "OSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo",
          channel_id: "channel-259"
        },
        chain: {
          channel_id: "channel-3",
          path: "transfer/channel-3/uosmo"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/295548A78785A1007F232DE286149A6FF512F180AF5657780FC89C009E2C348F",
        exponent: 0
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/295548A78785A1007F232DE286149A6FF512F180AF5657780FC89C009E2C348F",
      name: "Axelar USD Coin",
      display: "usdc",
      symbol: "axlUSDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "uusdc",
          channel_id: "channel-14"
        },
        chain: {
          channel_id: "channel-9",
          path: "transfer/channel-9/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "axelar",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
        theme: {
          primary_color_hex: "#2474cc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/3607EB5B5E64DD1C0E12E07F077FF470D5BC4706AFCBC98FE1BA960E5AE4CE07",
        exponent: 0
      }, {
        denom: "cmdx",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/3607EB5B5E64DD1C0E12E07F077FF470D5BC4706AFCBC98FE1BA960E5AE4CE07",
      name: "Comdex",
      display: "cmdx",
      symbol: "CMDX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "comdex",
          base_denom: "ucmdx",
          channel_id: "channel-31"
        },
        chain: {
          channel_id: "channel-18",
          path: "transfer/channel-18/ucmdx"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "comdex",
          base_denom: "ucmdx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.svg",
        theme: {
          primary_color_hex: "#fc4454"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/EFF323CC632EC4F747C61BCE238A758EFDB7699C3226565F7C20DA06509D59A5",
        exponent: 0
      }, {
        denom: "juno",
        exponent: 6
      }],
      base: "ibc/EFF323CC632EC4F747C61BCE238A758EFDB7699C3226565F7C20DA06509D59A5",
      name: "Juno",
      display: "juno",
      symbol: "JUNO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "juno",
          base_denom: "ujuno",
          channel_id: "channel-87"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/ujuno"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "ujuno"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.svg",
        theme: {
          primary_color_hex: "#fa7b7b"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/1B38805B1C75352B28169284F96DF56BDEBD9E8FAC005BDCC8CF0378C82AA8E7",
        exponent: 0
      }, {
        denom: "weth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/1B38805B1C75352B28169284F96DF56BDEBD9E8FAC005BDCC8CF0378C82AA8E7",
      name: "Axelar Wrapped Ether",
      display: "weth",
      symbol: "wETH.axl",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "weth-wei",
          channel_id: "channel-14"
        },
        chain: {
          channel_id: "channel-9",
          path: "transfer/channel-9/weth-wei"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "axelar",
          base_denom: "weth-wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/weth.png",
        theme: {
          primary_color_hex: "#3a3444"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/weth.png"
      }
    },
    {
      denom_units: [{
        denom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        exponent: 0
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
      name: "Cosmos Hub Atom",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-343"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/DA59C009A0B3B95E0549E6BF7B075C8239285989FF457A8EDDBB56F10B2A6986",
        exponent: 0
      }, {
        denom: "luna",
        exponent: 6
      }],
      base: "ibc/DA59C009A0B3B95E0549E6BF7B075C8239285989FF457A8EDDBB56F10B2A6986",
      name: "Luna",
      display: "luna",
      symbol: "LUNA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "terra2",
          base_denom: "uluna",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-5",
          path: "transfer/channel-5/uluna"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "uluna"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg",
        theme: {
          primary_color_hex: "#f4de6f"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/4F393C3FCA4190C0A6756CE7F6D897D5D1BE57D6CCB80D0BC87393566A7B6602",
        exponent: 0
      }, {
        denom: "stars",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4F393C3FCA4190C0A6756CE7F6D897D5D1BE57D6CCB80D0BC87393566A7B6602",
      name: "Stargaze",
      display: "stars",
      symbol: "STARS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "ustars",
          channel_id: "channel-49"
        },
        chain: {
          channel_id: "channel-7",
          path: "transfer/channel-7/ustars"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "stargaze",
          base_denom: "ustars"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg",
        theme: {
          primary_color_hex: "#db2777"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/A358D7F19237777AF6D8AD0E0F53268F8B18AE8A53ED318095C14D6D7F3B2DB5",
        exponent: 0
      }, {
        denom: "scrt",
        exponent: 6
      }],
      base: "ibc/A358D7F19237777AF6D8AD0E0F53268F8B18AE8A53ED318095C14D6D7F3B2DB5",
      name: "Secret Network",
      display: "scrt",
      symbol: "SCRT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "uscrt",
          channel_id: "channel-22"
        },
        chain: {
          channel_id: "channel-10",
          path: "transfer/channel-10/uscrt"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "uscrt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/086C1B2E9E611F23D3C9159C858D3F4C6A911D348DFB916A11AE306A865A77A8",
        exponent: 0,
        aliases: ["stk/uatom"]
      }, {
        denom: "stkatom",
        exponent: 6,
        aliases: ["stk/atom"]
      }],
      type_asset: "ics20",
      base: "ibc/086C1B2E9E611F23D3C9159C858D3F4C6A911D348DFB916A11AE306A865A77A8",
      name: "PSTAKE staked ATOM",
      display: "stkatom",
      symbol: "stkATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "persistence",
          base_denom: "stk/uatom",
          channel_id: "channel-152"
        },
        chain: {
          channel_id: "channel-158",
          path: "transfer/channel-158/stk/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "persistence",
          base_denom: "stk/uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg",
        theme: {
          primary_color_hex: "#c4444c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg"
      }
    },
    {
      description: "BackBone Labs Liquid Staked KUJI",
      denom_units: [{
        denom: "factory/kujira15e8q5wzlk5k38gjxlhse3vu6vqnafysncx2ltexd6y9gx50vuj2qpt7dgv/boneKuji",
        exponent: 0
      }, {
        denom: "bKUJI",
        exponent: 6
      }],
      base: "factory/kujira15e8q5wzlk5k38gjxlhse3vu6vqnafysncx2ltexd6y9gx50vuj2qpt7dgv/boneKuji",
      name: "BackBone Labs Liquid Staked KUJI",
      display: "bKUJI",
      symbol: "bKUJI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bKUJI.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bKUJI.png",
        theme: {
          primary_color_hex: "#cc3533"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/82B298F9E74A9A211C55C67C7AB0C790836BD43672D5DD830F7AE2C5D010AD7D",
        exponent: 0,
        aliases: ["factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"]
      }, {
        denom: "rstk",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/82B298F9E74A9A211C55C67C7AB0C790836BD43672D5DD830F7AE2C5D010AD7D",
      name: "Restake DAO Token",
      display: "rstk",
      symbol: "RSTK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-58",
          path: "transfer/channel-58/factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.svg",
        theme: {
          primary_color_hex: "#3ccc64"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.svg"
      }
    },
    {
      description: "Ghost Vault USK",
      denom_units: [{
        denom: "factory/kujira1w4yaama77v53fp0f9343t9w2f932z526vj970n2jv5055a7gt92sxgwypf/urcpt",
        exponent: 0
      }, {
        denom: "xusk",
        exponent: 6
      }],
      base: "factory/kujira1w4yaama77v53fp0f9343t9w2f932z526vj970n2jv5055a7gt92sxgwypf/urcpt",
      name: "Ghost Vault USK",
      display: "xusk",
      symbol: "xUSK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/xusk.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/xusk.png",
        theme: {
          primary_color_hex: "#303741"
        }
      }]
    },
    {
      description: "Ghost Vault MNTA",
      denom_units: [{
        denom: "factory/kujira1ya42knfcsvy6eztegsn3hz7zpjvhzn05ge85xa2dy2zrjeul9hnspp3c06/urcpt",
        exponent: 0
      }, {
        denom: "xmnta",
        exponent: 6
      }],
      base: "factory/kujira1ya42knfcsvy6eztegsn3hz7zpjvhzn05ge85xa2dy2zrjeul9hnspp3c06/urcpt",
      name: "Ghost Vault MNTA",
      display: "xmnta",
      symbol: "xMNTA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/xmnta.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/xmnta.png",
        theme: {
          primary_color_hex: "#0f151f"
        }
      }]
    },
    {
      description: "Stride staked ATOM",
      denom_units: [{
        denom: "ibc/0306D6B66EAA2EDBB7EAD23C0EC9DDFC69BB43E80B398035E90FBCFEF3FD1A87",
        exponent: 0
      }, {
        denom: "statom",
        exponent: 6
      }],
      base: "ibc/0306D6B66EAA2EDBB7EAD23C0EC9DDFC69BB43E80B398035E90FBCFEF3FD1A87",
      name: "stATOM",
      display: "statom",
      symbol: "stATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stuatom",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-32",
          path: "transfer/channel-32/stuatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stuatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Axelar Bridged wBTC",
      denom_units: [{
        denom: "ibc/301DAF9CB0A9E247CD478533EF0E21F48FF8118C4A51F77C8BC3EB70E5566DBC",
        exponent: 0
      }, {
        denom: "wbtc.axl",
        exponent: 6
      }],
      base: "ibc/301DAF9CB0A9E247CD478533EF0E21F48FF8118C4A51F77C8BC3EB70E5566DBC",
      name: "Axelar Bridged wBTC",
      display: "wbtc.axl",
      symbol: "wBTC.axl",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "wbtc-satoshi",
          channel_id: "channel-14"
        },
        chain: {
          channel_id: "channel-32",
          path: "transfer/channel-9/wbtc-satoshi"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/wbtc.png"
      },
      images: [{
        image_sync: {
          chain_name: "axelar",
          base_denom: "wbtc-satoshi"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/wbtc.png",
        theme: {
          primary_color_hex: "#41394d"
        }
      }]
    },
    {
      description: "Stride staked OSMO",
      denom_units: [{
        denom: "ibc/F97BDCE220CCB52139C73066E36C45EC7EDCEEF1DAFF891A34F4FBA195A2E6E8",
        exponent: 0
      }, {
        denom: "stosmo",
        exponent: 6
      }],
      base: "ibc/F97BDCE220CCB52139C73066E36C45EC7EDCEEF1DAFF891A34F4FBA195A2E6E8",
      name: "Stride staked OSMO",
      display: "stosmo",
      symbol: "stOSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stuosmo",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-32",
          path: "transfer/channel-32/uosmo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stuosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "LP Bow: DOT.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira10qyzrqaza0f593cmnl4sc3p3nhqqakn9j56d899u723pznxpn8us6cypuw/ulp",
        exponent: 0
      }, {
        denom: "lp-dot-mnta",
        exponent: 6
      }],
      base: "factory/kujira10qyzrqaza0f593cmnl4sc3p3nhqqakn9j56d899u723pznxpn8us6cypuw/ulp",
      name: "LP Bow: DOT.axl-MNTA",
      display: "lp-dot-mnta",
      symbol: "LP DOT.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: SHD-MNTA",
      denom_units: [{
        denom: "factory/kujira12tpc335t72qtrjh64ccdydzsr9qtswkqn72cyvfj4d5hmtgynphsv4xjtu/ulp",
        exponent: 0
      }, {
        denom: "lp-shd-mnta",
        exponent: 6
      }],
      base: "factory/kujira12tpc335t72qtrjh64ccdydzsr9qtswkqn72cyvfj4d5hmtgynphsv4xjtu/ulp",
      name: "LP Bow: SHD-MNTA",
      display: "lp-shd-mnta",
      symbol: "LP SHD-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: DYDX-MNTA",
      denom_units: [{
        denom: "factory/kujira13g2eelkf9q4md4xx52ylqvlgpccn50f2vyu05eazufd2g4jatmhq2425pq/ulp",
        exponent: 0
      }, {
        denom: "lp-dydx-mnta",
        exponent: 6
      }],
      base: "factory/kujira13g2eelkf9q4md4xx52ylqvlgpccn50f2vyu05eazufd2g4jatmhq2425pq/ulp",
      name: "LP Bow: DYDX-MNTA",
      display: "lp-dydx-mnta",
      symbol: "LP DYDX-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wAVAX.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira15pk8c09vcsgsdq4xlh2qfqxtu2r8pgdy7nggkqj8p3h2phke80pqwnvtzk/ulp",
        exponent: 0
      }, {
        denom: "lp-wavax-mnta",
        exponent: 6
      }],
      base: "factory/kujira15pk8c09vcsgsdq4xlh2qfqxtu2r8pgdy7nggkqj8p3h2phke80pqwnvtzk/ulp",
      name: "LP Bow: wAVAX.axl-MNTA",
      display: "lp-wavax-mnta",
      symbol: "LP wAVAX.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: CHEQ-MNTA",
      denom_units: [{
        denom: "factory/kujira15w6jhxsv924mn9cfr0qg9z36hltmw4rzd68x40d9re6hzyhslumqjw9zqd/ulp",
        exponent: 0
      }, {
        denom: "lp-cheq-mnta",
        exponent: 6
      }],
      base: "factory/kujira15w6jhxsv924mn9cfr0qg9z36hltmw4rzd68x40d9re6hzyhslumqjw9zqd/ulp",
      name: "LP Bow: CHEQ-MNTA",
      display: "lp-cheq-mnta",
      symbol: "LP CHEQ-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: FUZN-MNTA",
      denom_units: [{
        denom: "factory/kujira1622xuv8unv22xzazljvqh8uukcdz3yzmrp6axgerh7vxg4kum5tqcwcqmv/ulp",
        exponent: 0
      }, {
        denom: "lp-fuzn-mnta",
        exponent: 6
      }],
      base: "factory/kujira1622xuv8unv22xzazljvqh8uukcdz3yzmrp6axgerh7vxg4kum5tqcwcqmv/ulp",
      name: "LP Bow: FUZN-MNTA",
      display: "lp-fuzn-mnta",
      symbol: "LP FUZN-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: SOMM-MNTA",
      denom_units: [{
        denom: "factory/kujira17djzq5x5e5zm9q9zlp6dtxdt9p8q2zvj0qtmjs0wrxm5g9e2vf5q9d6y2t/ulp",
        exponent: 0
      }, {
        denom: "lp-somm-mnta",
        exponent: 6
      }],
      base: "factory/kujira17djzq5x5e5zm9q9zlp6dtxdt9p8q2zvj0qtmjs0wrxm5g9e2vf5q9d6y2t/ulp",
      name: "LP Bow: SOMM-MNTA",
      display: "lp-somm-mnta",
      symbol: "LP SOMM-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wETH.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira17x2v39aut0paj5d6wc5jxvqqxrdhy9kvca4y5xn6vsfpsxkgc6gq7n4tg0/ulp",
        exponent: 0
      }, {
        denom: "lp-weth-mnta",
        exponent: 6
      }],
      base: "factory/kujira17x2v39aut0paj5d6wc5jxvqqxrdhy9kvca4y5xn6vsfpsxkgc6gq7n4tg0/ulp",
      name: "LP Bow: wETH.axl-MNTA",
      display: "lp-weth-mnta",
      symbol: "LP wETH.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: NTRN-MNTA",
      denom_units: [{
        denom: "factory/kujira18lhugzap20ndlqr5j2p86yk4pxpe9jjuac05z0ypxuwn3mm5vjhsjh4etr/ulp",
        exponent: 0
      }, {
        denom: "lp-ntrn-mnta",
        exponent: 6
      }],
      base: "factory/kujira18lhugzap20ndlqr5j2p86yk4pxpe9jjuac05z0ypxuwn3mm5vjhsjh4etr/ulp",
      name: "LP Bow: NTRN-MNTA",
      display: "lp-ntrn-mnta",
      symbol: "LP NTRN-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wFTM.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira18mveas6xseaqu3fmukwv2ac6mp4hszk08lvyamedytjs0kxm42yqs9v89x/ulp",
        exponent: 0
      }, {
        denom: "lp-wftm-mnta",
        exponent: 6
      }],
      base: "factory/kujira18mveas6xseaqu3fmukwv2ac6mp4hszk08lvyamedytjs0kxm42yqs9v89x/ulp",
      name: "LP Bow: wFTM.axl-MNTA",
      display: "lp-wftm-mnta",
      symbol: "LP wFTM.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: STARS-MNTA",
      denom_units: [{
        denom: "factory/kujira1av284rnqh6s0l2lwdqgpgz8wuva3wh9lkmlsupjd9escn5v4fels6kwc7v/ulp",
        exponent: 0
      }, {
        denom: "lp-stars-mnta",
        exponent: 6
      }],
      base: "factory/kujira1av284rnqh6s0l2lwdqgpgz8wuva3wh9lkmlsupjd9escn5v4fels6kwc7v/ulp",
      name: "LP Bow: STARS-MNTA",
      display: "lp-stars-mnta",
      symbol: "LP STARS-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: TIA-MNTA",
      denom_units: [{
        denom: "factory/kujira1cpdyhrkwdnz38u45el3zq7007at9dm6h05tc36zpxvs6vrdwzrrskt0tgg/ulp",
        exponent: 0
      }, {
        denom: "lp-tia-mnta",
        exponent: 6
      }],
      base: "factory/kujira1cpdyhrkwdnz38u45el3zq7007at9dm6h05tc36zpxvs6vrdwzrrskt0tgg/ulp",
      name: "LP Bow: TIA-MNTA",
      display: "lp-tia-mnta",
      symbol: "LP TIA-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: SOL.wh-MNTA",
      denom_units: [{
        denom: "factory/kujira1eqd96322ec258w7k9n9cfqkusrlvzwv38jkph3qs720egdv0epmq70j2zl/ulp",
        exponent: 0
      }, {
        denom: "lp-sol-mnta",
        exponent: 6
      }],
      base: "factory/kujira1eqd96322ec258w7k9n9cfqkusrlvzwv38jkph3qs720egdv0epmq70j2zl/ulp",
      name: "LP Bow: SOL.wh-MNTA",
      display: "lp-sol-mnta",
      symbol: "LP SOL.wh-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: DYM-MNTA",
      denom_units: [{
        denom: "factory/kujira1fg7wmsde7ygw3pm6hqmd29cdvp947anajmunsvk0guvjta3md25qdqk4fw/ulp",
        exponent: 0
      }, {
        denom: "lp-dym-mnta",
        exponent: 6
      }],
      base: "factory/kujira1fg7wmsde7ygw3pm6hqmd29cdvp947anajmunsvk0guvjta3md25qdqk4fw/ulp",
      name: "LP Bow: DYM-MNTA",
      display: "lp-dym-mnta",
      symbol: "LP DYM-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: AKT-MNTA",
      denom_units: [{
        denom: "factory/kujira1gnftck9586x0nhsqsj99k9zednl6tx4kezu9hpph0u6jtqnafpyqxha3me/ulp",
        exponent: 0
      }, {
        denom: "lp-akt-mnta",
        exponent: 6
      }],
      base: "factory/kujira1gnftck9586x0nhsqsj99k9zednl6tx4kezu9hpph0u6jtqnafpyqxha3me/ulp",
      name: "LP Bow: AKT-MNTA",
      display: "lp-akt-mnta",
      symbol: "LP AKT-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: LINK.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira1gnvja05kkmpeh9dnxl0c2p4sde7fpsy2r44njzyqgpsf72nqs78q3gzpzc/ulp",
        exponent: 0
      }, {
        denom: "lp-link-mnta",
        exponent: 6
      }],
      base: "factory/kujira1gnvja05kkmpeh9dnxl0c2p4sde7fpsy2r44njzyqgpsf72nqs78q3gzpzc/ulp",
      name: "LP Bow: LINK.axl-MNTA",
      display: "lp-link-mnta",
      symbol: "LP LINK.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wTAO.grv-MNTA",
      denom_units: [{
        denom: "factory/kujira1gz2kvfw7hpds9fvygwkj64znl3a9pw697g77cspcq5y4vj3ru45s7qc0rd/ulp",
        exponent: 0
      }, {
        denom: "lp-wtao-mnta",
        exponent: 6
      }],
      base: "factory/kujira1gz2kvfw7hpds9fvygwkj64znl3a9pw697g77cspcq5y4vj3ru45s7qc0rd/ulp",
      name: "LP Bow: wTAO.grv-MNTA",
      display: "lp-wtao-mnta",
      symbol: "LP wTAO.grv-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: MNTA-KUJI",
      denom_units: [{
        denom: "factory/kujira1h75predtjdm2e7u8cuvqs3usc6xs2mxlkcr20zsshvw3qap25frsr4z949/ulp",
        exponent: 0
      }, {
        denom: "lp-mnta-kuji",
        exponent: 6
      }],
      base: "factory/kujira1h75predtjdm2e7u8cuvqs3usc6xs2mxlkcr20zsshvw3qap25frsr4z949/ulp",
      name: "LP Bow: MNTA-KUJI",
      display: "lp-mnta-kuji",
      symbol: "LP MNTA-KUJI",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: AXL-MNTA",
      denom_units: [{
        denom: "factory/kujira1h929g9e9vxhc5y8v7uexdrncacxdatjupr67velewafwepfyfaaq6s7l3v/ulp",
        exponent: 0
      }, {
        denom: "lp-axl-mnta",
        exponent: 6
      }],
      base: "factory/kujira1h929g9e9vxhc5y8v7uexdrncacxdatjupr67velewafwepfyfaaq6s7l3v/ulp",
      name: "LP Bow: AXL-MNTA",
      display: "lp-axl-mnta",
      symbol: "LP AXL-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: ATOM-MNTA",
      denom_units: [{
        denom: "factory/kujira1h9f3k54j060pzlnea8ep8qfymsmwl5yhwc5hqept5p2esqzve7tq2ghnm4/ulp",
        exponent: 0
      }, {
        denom: "lp-atom-mnta",
        exponent: 6
      }],
      base: "factory/kujira1h9f3k54j060pzlnea8ep8qfymsmwl5yhwc5hqept5p2esqzve7tq2ghnm4/ulp",
      name: "LP Bow: ATOM-MNTA",
      display: "lp-atom-mnta",
      symbol: "LP ATOM-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: ARB-MNTA",
      denom_units: [{
        denom: "factory/kujira1kc90tgn4ucvdv4c9xycktanwz2lna0nfel6244ylqjvhaetfntusnmyu3d/ulp",
        exponent: 0
      }, {
        denom: "lp-arb-mnta",
        exponent: 6
      }],
      base: "factory/kujira1kc90tgn4ucvdv4c9xycktanwz2lna0nfel6244ylqjvhaetfntusnmyu3d/ulp",
      name: "LP Bow: ARB-MNTA",
      display: "lp-arb-mnta",
      symbol: "LP ARB-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: WHALE-MNTA",
      denom_units: [{
        denom: "factory/kujira1jsjygyj8hwa4f0p9wwgct4yzmzzexe5x5u6l40l7ty2qzwwwsemqavhk3x/ulp",
        exponent: 0
      }, {
        denom: "lp-whale-mnta",
        exponent: 6
      }],
      base: "factory/kujira1jsjygyj8hwa4f0p9wwgct4yzmzzexe5x5u6l40l7ty2qzwwwsemqavhk3x/ulp",
      name: "LP Bow: WHALE-MNTA",
      display: "lp-whale-mnta",
      symbol: "LP WHALE-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: SCRT-MNTA",
      denom_units: [{
        denom: "factory/kujira1p7w9ncnnme9yzzhrvzv0hnsa5u5ga06v0ckt7lq9yfap04hc5k9sn2vf6w/ulp",
        exponent: 0
      }, {
        denom: "lp-scrt-mnta",
        exponent: 6
      }],
      base: "factory/kujira1p7w9ncnnme9yzzhrvzv0hnsa5u5ga06v0ckt7lq9yfap04hc5k9sn2vf6w/ulp",
      name: "LP Bow: SCRT-MNTA",
      display: "lp-scrt-mnta",
      symbol: "LP SCRT-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wstETH.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira1qx3hcr297qmgjt5f6u9peldf4phxqufvmew8d3eey3ns29e8qp3snj6jfu/ulp",
        exponent: 0
      }, {
        denom: "lp-wsteth-mnta",
        exponent: 6
      }],
      base: "factory/kujira1qx3hcr297qmgjt5f6u9peldf4phxqufvmew8d3eey3ns29e8qp3snj6jfu/ulp",
      name: "LP Bow: wstETH.axl-MNTA",
      display: "lp-wsteth-mnta",
      symbol: "LP wstETH.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wMATIC.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira1smfdnww47xav4nn849xphku3gk3xp7a24fk533dce8masnsz4v8quklajx/ulp",
        exponent: 0
      }, {
        denom: "lp-wmatic-mnta",
        exponent: 6
      }],
      base: "factory/kujira1smfdnww47xav4nn849xphku3gk3xp7a24fk533dce8masnsz4v8quklajx/ulp",
      name: "LP Bow: wMATIC.axl-MNTA",
      display: "lp-wmatic-mnta",
      symbol: "LP wMATIC.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: UNI.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira1t4mr2xt4ky4mfwcy752chzlquam3hzs44mt8vwyec8mvypmzxu5s90vamt/ulp",
        exponent: 0
      }, {
        denom: "lp-uni-mnta",
        exponent: 6
      }],
      base: "factory/kujira1t4mr2xt4ky4mfwcy752chzlquam3hzs44mt8vwyec8mvypmzxu5s90vamt/ulp",
      name: "LP Bow: UNI.axl-MNTA",
      display: "lp-uni-mnta",
      symbol: "LP UNI.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: yieldETH.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira1u8dluwa4a83q7anz0cgpmma605r07a06f0789ajcl8l0xjrplqss005cgn/ulp",
        exponent: 0
      }, {
        denom: "lp-yieldeth-mnta",
        exponent: 6
      }],
      base: "factory/kujira1u8dluwa4a83q7anz0cgpmma605r07a06f0789ajcl8l0xjrplqss005cgn/ulp",
      name: "LP Bow: yieldETH.axl-MNTA",
      display: "lp-yieldeth-mnta",
      symbol: "LP yieldETH.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wBTC.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira1vj39mdwekxznxxa97fv5gt957cghfdqhwju8fdv5ysu0x6vsyhps4zmqjl/ulp",
        exponent: 0
      }, {
        denom: "lp-wbtc-mnta",
        exponent: 6
      }],
      base: "factory/kujira1vj39mdwekxznxxa97fv5gt957cghfdqhwju8fdv5ysu0x6vsyhps4zmqjl/ulp",
      name: "LP Bow: wBTC.axl-MNTA",
      display: "lp-wbtc-mnta",
      symbol: "LP wBTC.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: PAXG.grv-MNTA",
      denom_units: [{
        denom: "factory/kujira1vqdyup9zxxl9gqy5hwh593vvuc84lstldj7qzt7fylf3q3e3uemqlwpg9y/ulp",
        exponent: 0
      }, {
        denom: "lp-paxg-mnta",
        exponent: 6
      }],
      base: "factory/kujira1vqdyup9zxxl9gqy5hwh593vvuc84lstldj7qzt7fylf3q3e3uemqlwpg9y/ulp",
      name: "LP Bow: PAXG.grv-MNTA",
      display: "lp-paxg-mnta",
      symbol: "LP PAXG.grv-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wBNB.axl-MNTA",
      denom_units: [{
        denom: "factory/kujira1y24jwsv84lnuv5j78qeqz5ujjpd058qsft7wfc0nk9jvycugm32sqnq53d/ulp",
        exponent: 0
      }, {
        denom: "lp-wbnb-mnta",
        exponent: 6
      }],
      base: "factory/kujira1y24jwsv84lnuv5j78qeqz5ujjpd058qsft7wfc0nk9jvycugm32sqnq53d/ulp",
      name: "LP Bow: wBNB.axl-MNTA",
      display: "lp-wbnb-mnta",
      symbol: "LP wBNB.axl-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: OSMO-MNTA",
      denom_units: [{
        denom: "factory/kujira1ygperwf0dc9ng2jffj0pwnnray3rscn9el6d78qjtt25qwgqukqszmdwtv/ulp",
        exponent: 0
      }, {
        denom: "lp-osmo-mnta",
        exponent: 6
      }],
      base: "factory/kujira1ygperwf0dc9ng2jffj0pwnnray3rscn9el6d78qjtt25qwgqukqszmdwtv/ulp",
      name: "LP Bow: OSMO-MNTA",
      display: "lp-osmo-mnta",
      symbol: "LP OSMO-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: INJ-MNTA",
      denom_units: [{
        denom: "factory/kujira1znx048dcc6arqfw6kpckl0k4ts2h7cdx20nk22wz2cxh5vle3wxqknk238/ulp",
        exponent: 0
      }, {
        denom: "lp-inj-mnta",
        exponent: 6
      }],
      base: "factory/kujira1znx048dcc6arqfw6kpckl0k4ts2h7cdx20nk22wz2cxh5vle3wxqknk238/ulp",
      name: "LP Bow: INJ-MNTA",
      display: "lp-inj-mnta",
      symbol: "LP INJ-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: stOSMO-OSMO",
      denom_units: [{
        denom: "factory/kujira18sek950cg92gd0kvpj67dfg6p7kee6hzw92etcf2jgufr3mttvaslt5sal/ulp",
        exponent: 0
      }, {
        denom: "lp-stosmo-osmo",
        exponent: 6
      }],
      base: "factory/kujira18sek950cg92gd0kvpj67dfg6p7kee6hzw92etcf2jgufr3mttvaslt5sal/ulp",
      name: "LP Bow: stOSMO-OSMO",
      display: "lp-stosmo-osmo",
      symbol: "LP stOSMO-OSMO",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wstETH.axl-wETH.axl",
      denom_units: [{
        denom: "factory/kujira1lyyeyuw4qgan6nz45thw2m0nmxa457uz7cp9dqw5d9a0h7ccek7qavkm6g/ulp",
        exponent: 0
      }, {
        denom: "lp-wsteth-weth",
        exponent: 6
      }],
      base: "factory/kujira1lyyeyuw4qgan6nz45thw2m0nmxa457uz7cp9dqw5d9a0h7ccek7qavkm6g/ulp",
      name: "LP Bow: wstETH.axl-wETH.axl",
      display: "lp-wsteth-weth",
      symbol: "LP wstETH.axl-wETH.axl",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: qcMNTA-MNTA",
      denom_units: [{
        denom: "factory/kujira1ul00h0a2kgcg9x2yfa86wj9qguhyv7jmpjpw6ztt24j9mn9xjw3slawyc8/ulp",
        exponent: 0
      }, {
        denom: "lp-qcmnta-mnta",
        exponent: 6
      }],
      base: "factory/kujira1ul00h0a2kgcg9x2yfa86wj9qguhyv7jmpjpw6ztt24j9mn9xjw3slawyc8/ulp",
      name: "LP Bow: qcMNTA-MNTA",
      display: "lp-qcmnta-mnta",
      symbol: "LP qcMNTA-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: ampMNTA-MNTA",
      denom_units: [{
        denom: "factory/kujira1vj36ntsqd3msc69lxldcv9dd50jngknmael9e07rz4fpn5kyq0jsglvz2m/ulp",
        exponent: 0
      }, {
        denom: "lp-ampmnta-mnta",
        exponent: 6
      }],
      base: "factory/kujira1vj36ntsqd3msc69lxldcv9dd50jngknmael9e07rz4fpn5kyq0jsglvz2m/ulp",
      name: "LP Bow: ampMNTA-MNTA",
      display: "lp-ampmnta-mnta",
      symbol: "LP ampMNTA-MNTA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wETH.axl-USK",
      denom_units: [{
        denom: "factory/kujira1n648rfqqvjxm6c7zgfnfqay85rkapgg0z7da9pnmjazz5m5d7l0qxdtq90/ulp",
        exponent: 0
      }, {
        denom: "lp-weth-usk",
        exponent: 6
      }],
      base: "factory/kujira1n648rfqqvjxm6c7zgfnfqay85rkapgg0z7da9pnmjazz5m5d7l0qxdtq90/ulp",
      name: "LP Bow: wETH.axl-USK",
      display: "lp-weth-usk",
      symbol: "LP wETH.axl-USK",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "The token of NAMI",
      denom_units: [{
        denom: "factory/kujira13x2l25mpkhwnwcwdzzd34cr8fyht9jlj7xu9g4uffe36g3fmln8qkvm3qn/unami",
        exponent: 0
      }, {
        denom: "nami",
        exponent: 6
      }],
      base: "factory/kujira13x2l25mpkhwnwcwdzzd34cr8fyht9jlj7xu9g4uffe36g3fmln8qkvm3qn/unami",
      name: "NAMI",
      display: "nami",
      symbol: "NAMI",
      coingecko_id: "nami-protocol",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nami.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nami.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nami.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nami.svg",
        theme: {
          primary_color_hex: "#1a1b1b"
        }
      }]
    },
    {
      description: "The receipt token of NAMI Protocol",
      denom_units: [{
        denom: "factory/kujira18thffdpuz8tm3mwwun4uhks8a2v7ye0jmw3fllqhklma82lqkpms20gh9c/unausd",
        exponent: 0
      }, {
        denom: "nausd",
        exponent: 6
      }],
      base: "factory/kujira18thffdpuz8tm3mwwun4uhks8a2v7ye0jmw3fllqhklma82lqkpms20gh9c/unausd",
      name: "NAUSD",
      display: "nausd",
      symbol: "NAUSD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nausd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nausd.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nausd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nausd.svg"
      }]
    },
    {
      description: "The token of MCTest",
      denom_units: [{
        denom: "factory/kujira1mn2pgkggquqm2m44zqlaq29jxwtad53qkv4xy4/MCTest",
        exponent: 0
      }, {
        denom: "mctest",
        exponent: 6
      }],
      base: "factory/kujira1mn2pgkggquqm2m44zqlaq29jxwtad53qkv4xy4/MCTest",
      name: "MCTEST",
      display: "mctest",
      symbol: "MC01",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/mctest.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/mctest.png",
        theme: {
          primary_color_hex: "#1a1b1b"
        }
      }]
    },
    {
      description: "The token of AUTO",
      denom_units: [{
        denom: "factory/kujira13x2l25mpkhwnwcwdzzd34cr8fyht9jlj7xu9g4uffe36g3fmln8qkvm3qn/uauto",
        exponent: 0
      }, {
        denom: "auto",
        exponent: 6
      }],
      base: "factory/kujira13x2l25mpkhwnwcwdzzd34cr8fyht9jlj7xu9g4uffe36g3fmln8qkvm3qn/uauto",
      name: "AUTO",
      display: "auto",
      symbol: "AUTO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/auto.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/auto.png",
        theme: {
          primary_color_hex: "#1a1b1b"
        }
      }]
    },
    {
      description: "Quark's auto-compounding DYDX derivative",
      denom_units: [{
        denom: "factory/kujira1seqq2ekz47uqayshqkg5wqx5vcyrmtwcl9vscnwy2gjh7mz5aapsdfxsd5/urcpt",
        exponent: 0
      }, {
        denom: "qcDYDX",
        exponent: 18
      }],
      base: "factory/kujira1seqq2ekz47uqayshqkg5wqx5vcyrmtwcl9vscnwy2gjh7mz5aapsdfxsd5/urcpt",
      name: "qcDYDX",
      display: "qcDYDX",
      symbol: "qcDYDX",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/qcdydx.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/qcdydx.svg"
      }]
    },
    {
      description: "The Kujira Recovery Token",
      denom_units: [{
        denom: "factory/kujira1tsekaqv9vmem0zwskmf90gpf0twl6k57e8vdnq/urkuji",
        exponent: 0
      }, {
        denom: "rkuji",
        exponent: 6
      }],
      base: "factory/kujira1tsekaqv9vmem0zwskmf90gpf0twl6k57e8vdnq/urkuji",
      name: "rKUJI",
      display: "rkuji",
      symbol: "rKUJI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/rkuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/rkuji.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/rkuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/rkuji.svg"
      }]
    },
    {
      description: "LP Bow: ATOM-USK",
      denom_units: [{
        denom: "factory/kujira1yncutssgh2vj9scaymtteg949hwcft07c6qmgarxnaf04yesq3jsn6g2uv/ulp",
        exponent: 0
      }, {
        denom: "lp-atom-usk",
        exponent: 6
      }],
      base: "factory/kujira1yncutssgh2vj9scaymtteg949hwcft07c6qmgarxnaf04yesq3jsn6g2uv/ulp",
      name: "LP Bow: ATOM-USK",
      display: "lp-atom-usk",
      symbol: "LP ATOM-USK",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wETH.axl-USK",
      denom_units: [{
        denom: "factory/kujira1xwvvjq5w0887v2vz4e83kcu38s0jq8q8lqa3z5hxm295q7y4uejqp24la7/ulp",
        exponent: 0
      }, {
        denom: "lp-weth-usk",
        exponent: 6
      }],
      base: "factory/kujira1xwvvjq5w0887v2vz4e83kcu38s0jq8q8lqa3z5hxm295q7y4uejqp24la7/ulp",
      name: "LP Bow: wETH.axl-USK",
      display: "lp-weth-usk",
      symbol: "LP wETH.axl-USK",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: SOL.wh-USK",
      denom_units: [{
        denom: "factory/kujira1vcmh95lje5dln782pxckma65eujs4sv960w22whgsp7a2ajsc6lsvnlhgd/ulp",
        exponent: 0
      }, {
        denom: "lp-sol-usk",
        exponent: 6
      }],
      base: "factory/kujira1vcmh95lje5dln782pxckma65eujs4sv960w22whgsp7a2ajsc6lsvnlhgd/ulp",
      name: "LP Bow: SOL.wh-USK",
      display: "lp-sol-usk",
      symbol: "LP SOL.wh-USK",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wETH.axl-USDC",
      denom_units: [{
        denom: "factory/kujira1n4jfv39hzv2dtshzv6gj4hp8rkdy5rrsr7l84lc3x9cahz4v0umq24q3lu/ulp",
        exponent: 0
      }, {
        denom: "lp-weth-usdc",
        exponent: 6
      }],
      base: "factory/kujira1n4jfv39hzv2dtshzv6gj4hp8rkdy5rrsr7l84lc3x9cahz4v0umq24q3lu/ulp",
      name: "LP Bow: wETH.axl-USDC",
      display: "lp-weth-usdc",
      symbol: "LP wETH.axl-USDC",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: DYDX-USK",
      denom_units: [{
        denom: "factory/kujira1lctu7hy65466fxw3tcqf8w45zwrpwgd9chvjqpgyfgcr73k774nsv4ya6t/ulp",
        exponent: 0
      }, {
        denom: "lp-dydx-usk",
        exponent: 6
      }],
      base: "factory/kujira1lctu7hy65466fxw3tcqf8w45zwrpwgd9chvjqpgyfgcr73k774nsv4ya6t/ulp",
      name: "LP Bow: DYDX-USK",
      display: "lp-dydx-usk",
      symbol: "LP DYDX-USK",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: AKT-USDC",
      denom_units: [{
        denom: "factory/kujira1g5st8p6qdyf23zzerjcxgpr2r7a9wzdyaymu79ngg6ve3m9v3n4sdetv4e/ulp",
        exponent: 0
      }, {
        denom: "lp-akt-usdc",
        exponent: 6
      }],
      base: "factory/kujira1g5st8p6qdyf23zzerjcxgpr2r7a9wzdyaymu79ngg6ve3m9v3n4sdetv4e/ulp",
      name: "LP Bow: AKT-USDC",
      display: "lp-akt-usdc",
      symbol: "LP AKT-USDC",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wBTC-USK",
      denom_units: [{
        denom: "factory/kujira1d7jt9zwlnpvf7sskfm57c77pm9mtwczqre75t9k80ees0v523kasss9htj/ulp",
        exponent: 0
      }, {
        denom: "lp-wbtc-usk",
        exponent: 6
      }],
      base: "factory/kujira1d7jt9zwlnpvf7sskfm57c77pm9mtwczqre75t9k80ees0v523kasss9htj/ulp",
      name: "LP Bow: wBTC-USK",
      display: "lp-wbtc-usk",
      symbol: "LP wBTC-USK",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: wBTC.axl-wBTC",
      denom_units: [{
        denom: "factory/kujira1c4e2zk4z0anrufjh64gxtse6e4s5g52fe2ja8ke3r9e0pvpd0z0qws8zsp/ulp",
        exponent: 0
      }, {
        denom: "lp-wbtc-wbtc",
        exponent: 8
      }],
      base: "factory/kujira1c4e2zk4z0anrufjh64gxtse6e4s5g52fe2ja8ke3r9e0pvpd0z0qws8zsp/ulp",
      name: "LP Bow: wBTC.axl-wBTC",
      display: "lp-wbtc-wbtc",
      symbol: "LP wBTC.axl-wBTC",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: INJ-USDC",
      denom_units: [{
        denom: "factory/kujira14jwhlsg3az20f7keav2axxj205fyv5j8mp6rv5svqwwll3ls9slq6zwleg/ulp",
        exponent: 0
      }, {
        denom: "lp-inj-usdc",
        exponent: 6
      }],
      base: "factory/kujira14jwhlsg3az20f7keav2axxj205fyv5j8mp6rv5svqwwll3ls9slq6zwleg/ulp",
      name: "LP Bow: INJ-USDC",
      display: "lp-inj-usdc",
      symbol: "LP INJ-USDC",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: ATOM-USDC",
      denom_units: [{
        denom: "factory/kujira13my0qtm2a8jp0wg8uzg49tyn4zcea8scy3dc7ghn8z9eys08yzls49ymdm/ulp",
        exponent: 0
      }, {
        denom: "lp-atom-usdc",
        exponent: 6
      }],
      base: "factory/kujira13my0qtm2a8jp0wg8uzg49tyn4zcea8scy3dc7ghn8z9eys08yzls49ymdm/ulp",
      name: "LP Bow: ATOM-USDC",
      display: "lp-atom-usdc",
      symbol: "LP ATOM-USDC",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: MNTA-USDC",
      denom_units: [{
        denom: "factory/kujira1742pe93mxm0cwqjxgxh6th9sspdrluqvw9pha9q69eeatue4x5xs0wdq2d/ulp",
        exponent: 0
      }, {
        denom: "lp-mnta-usdc",
        exponent: 6
      }],
      base: "factory/kujira1742pe93mxm0cwqjxgxh6th9sspdrluqvw9pha9q69eeatue4x5xs0wdq2d/ulp",
      name: "LP Bow: MNTA-USDC",
      display: "lp-mnta-usdc",
      symbol: "LP MNTA-USDC",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "LP Bow: MNTA-USK",
      denom_units: [{
        denom: "factory/kujira1xtaadmh06s8u3z5mypp8qayhrnxgga5wr88s7raram4rz8zu37hquf82wk/ulp",
        exponent: 0
      }, {
        denom: "lp-mnta-usk",
        exponent: 6
      }],
      base: "factory/kujira1xtaadmh06s8u3z5mypp8qayhrnxgga5wr88s7raram4rz8zu37hquf82wk/ulp",
      name: "LP Bow: MNTA-USK",
      display: "lp-mnta-usk",
      symbol: "LP MNTA-USK",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/bow.svg"
      }]
    },
    {
      description: "The token that fuels the Boon app",
      denom_units: [{
        denom: "factory/kujira1gewwffxhaygxe8tacd3z9h4uyvpd2h7v9qtfmaw8jjhwalxxpd7qlqld4m/boon",
        exponent: 0
      }, {
        denom: "boon",
        exponent: 6
      }],
      base: "factory/kujira1gewwffxhaygxe8tacd3z9h4uyvpd2h7v9qtfmaw8jjhwalxxpd7qlqld4m/boon",
      name: "Boon",
      display: "boon",
      symbol: "BOON",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/boon.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/boon.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/boon.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/boon.svg"
      }]
    }
  ]
};
R0.default = nI;
var O0 = {};
Object.defineProperty(O0, "__esModule", { value: !0 });
const tI = {
  $schema: "../chain.schema.json",
  chain_name: "kujira",
  chain_type: "cosmos",
  chain_id: "kaiyo-1",
  pretty_name: "Kujira",
  status: "live",
  network_type: "mainnet",
  website: "https://kujira.app/",
  bech32_prefix: "kujira",
  daemon_name: "kujirad",
  node_home: "$HOME/.kujira",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [
      {
        denom: "ukuji",
        fixed_min_gas_price: 34e-4,
        low_gas_price: 34e-4,
        average_gas_price: 51e-4,
        high_gas_price: 681e-5
      },
      {
        denom: "factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk",
        fixed_min_gas_price: 0.01186,
        low_gas_price: 0.01186,
        average_gas_price: 0.01779,
        high_gas_price: 0.02372
      },
      {
        denom: "ibc/295548A78785A1007F232DE286149A6FF512F180AF5657780FC89C009E2C348F",
        fixed_min_gas_price: 0.0119,
        low_gas_price: 0.0119,
        average_gas_price: 0.01785,
        high_gas_price: 0.02379
      },
      {
        denom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        fixed_min_gas_price: 129e-5,
        low_gas_price: 129e-5,
        average_gas_price: 193e-5,
        high_gas_price: 258e-5
      },
      {
        denom: "ibc/47BD209179859CDE4A2806763D7189B6E6FE13A17880FE2B42DE1E6C1E329E23",
        fixed_min_gas_price: 0.01795,
        low_gas_price: 0.01795,
        average_gas_price: 0.02692,
        high_gas_price: 0.0359
      },
      {
        denom: "ibc/3607EB5B5E64DD1C0E12E07F077FF470D5BC4706AFCBC98FE1BA960E5AE4CE07",
        fixed_min_gas_price: 0.65943,
        low_gas_price: 0.65943,
        average_gas_price: 0.98915,
        high_gas_price: 1.31887
      },
      {
        denom: "ibc/F3AA7EF362EC5E791FE78A0F4CCC69FEE1F9A7485EB1A8CAB3F6601C00522F10",
        fixed_min_gas_price: 160416396197,
        low_gas_price: 160416396197,
        average_gas_price: 240624594296,
        high_gas_price: 320832792394
      },
      {
        denom: "ibc/EFF323CC632EC4F747C61BCE238A758EFDB7699C3226565F7C20DA06509D59A5",
        fixed_min_gas_price: 0.02689,
        low_gas_price: 0.02689,
        average_gas_price: 0.04034,
        high_gas_price: 0.05379
      },
      {
        denom: "ibc/DA59C009A0B3B95E0549E6BF7B075C8239285989FF457A8EDDBB56F10B2A6986",
        fixed_min_gas_price: 0.01495,
        low_gas_price: 0.01495,
        average_gas_price: 0.02243,
        high_gas_price: 0.02991
      },
      {
        denom: "ibc/A358D7F19237777AF6D8AD0E0F53268F8B18AE8A53ED318095C14D6D7F3B2DB5",
        fixed_min_gas_price: 0.03139,
        low_gas_price: 0.03139,
        average_gas_price: 0.04709,
        high_gas_price: 0.06278
      },
      {
        denom: "ibc/4F393C3FCA4190C0A6756CE7F6D897D5D1BE57D6CCB80D0BC87393566A7B6602",
        fixed_min_gas_price: 0.90403,
        low_gas_price: 0.90403,
        average_gas_price: 1.35605,
        high_gas_price: 1.80806
      },
      {
        denom: "ibc/004EBF085BBED1029326D56BE8A2E67C08CECE670A94AC1947DF413EF5130EB2",
        fixed_min_gas_price: 559196837,
        low_gas_price: 559196837,
        average_gas_price: 838795256,
        high_gas_price: 1118393675
      },
      {
        denom: "ibc/1B38805B1C75352B28169284F96DF56BDEBD9E8FAC005BDCC8CF0378C82AA8E7",
        fixed_min_gas_price: 5772801,
        low_gas_price: 5772801,
        average_gas_price: 8659201,
        high_gas_price: 11545602
      },
      {
        denom: "factory/kujira1643jxg8wasy5cfcn7xm8rd742yeazcksqlg4d7/umnta",
        fixed_min_gas_price: 0.01807,
        low_gas_price: 0.01807,
        average_gas_price: 0.02711,
        high_gas_price: 0.03615
      },
      {
        denom: "ibc/FE98AAD68F02F03565E9FA39A5E627946699B2B07115889ED812D8BA639576A9",
        fixed_min_gas_price: 0.01194,
        low_gas_price: 0.01194,
        average_gas_price: 0.01792,
        high_gas_price: 0.02389
      },
      {
        denom: "ibc/E5CA126979E2FFB4C70C072F8094D07ECF27773B37623AD2BF7582AD0726F0F3",
        fixed_min_gas_price: 19e-5,
        low_gas_price: 19e-5,
        average_gas_price: 29e-5,
        high_gas_price: 39e-5
      }
    ]
  },
  staking: {
    staking_tokens: [{
      denom: "ukuji"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.12",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.45.0"
  },
  description: "A decentralized ecosystem for protocols, builders and web3 users seeking sustainable FinTech.",
  apis: {
    rpc: [
      {
        address: "https://rpc.kaiyo.kujira.setten.io",
        provider: "setten.io"
      },
      {
        address: "https://kujira-rpc.polkachu.com",
        provider: "polkachu"
      },
      {
        address: "https://rpc-kujira.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://rpc.lavenderfive.com:443/kujira",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc.kujira.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://rpc-kujira-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://kujira-rpc.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rpc-kujira.starsquid.io",
        provider: "Starsquid"
      },
      {
        address: "https://kujira.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://kuji-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://rpc-kujira.goldenratiostaking.net",
        provider: "Golden Ratio Staking"
      },
      {
        address: "https://kujira-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc.kujira.rektdao.club",
        provider: "rektDAO"
      },
      {
        address: "https://kujira-rpc.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://kujira-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://rpc-kujira.mms.team",
        provider: "MMS"
      },
      {
        address: "https://kujira-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://kujira.interstellar-lounge.org",
        provider: "Interstellar Lounge 🍸"
      }
    ],
    rest: [
      {
        address: "https://lcd.kaiyo.kujira.setten.io",
        provider: "setten.io"
      },
      {
        address: "https://rest.lavenderfive.com:443/kujira",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://kujira-api.polkachu.com/",
        provider: "polkachu"
      },
      {
        address: "https://rest-kujira.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://api-kujira-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://kujira-lcd.wildsage.io/",
        provider: "WildSage Labs"
      },
      {
        address: "https://kujira-api.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://api-kujira.starsquid.io",
        provider: "Starsquid"
      },
      {
        address: "https://kujira.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://kuji-api.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://kujira-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://api.kujira.rektdao.club",
        provider: "rektDAO"
      },
      {
        address: "https://kujira-api.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://kujira-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://api-kujira.mms.team",
        provider: "MMS"
      },
      {
        address: "https://kujira-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://kujira-rest.interstellar-lounge.org",
        provider: "Interstellar Lounge 🍸"
      }
    ],
    grpc: [
      {
        address: "kujira.grpcui.chaintools.host:443",
        provider: "ChainTools"
      },
      {
        address: "grpc-kujira-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "kujira.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "kujira-grpc.polkachu.com:11890",
        provider: "Polkachu"
      },
      {
        address: "kujira-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "kujira.grpc.kjnodes.com:11390",
        provider: "kjnodes"
      },
      {
        address: "kujira-grpc.w3coins.io:11890",
        provider: "w3coins"
      },
      {
        address: "grpc-kujira.mms.team:443",
        provider: "MMS"
      },
      {
        address: "kujira-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "kujira",
      url: "https://finder.kujira.app",
      tx_page: "https://finder.kujira.app/kaiyo-1/tx/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://kujira.explorers.guru",
      tx_page: "https://kujira.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/kujira",
      tx_page: "https://ezstaking.app/kujira/txs/${txHash}",
      account_page: "https://ezstaking.app/kujira/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/kujira",
      tx_page: "https://atomscan.com/kujira/transactions/${txHash}",
      account_page: "https://atomscan.com/kujira/accounts/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/kujira",
      tx_page: "https://mainnet.whispernode.com/kujira/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/kujira/account/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kujira-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.svg"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kujira-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.svg",
    theme: {
      primary_color_hex: "#e33b34"
    }
  }]
};
O0.default = tI;
var M0 = {};
Object.defineProperty(M0, "__esModule", { value: !0 });
const sI = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-8",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-61",
      connection_id: "connection-41"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-47",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-20",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-94",
      connection_id: "connection-64"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-126",
      connection_id: "connection-103"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-103",
      connection_id: "connection-72"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-164",
      connection_id: "connection-127"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-123",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-12",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-144",
      connection_id: "connection-110"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-99",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "assetmantle",
      client_id: "07-tendermint-50",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-104",
      connection_id: "connection-73"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-42",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-11",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-16",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-60",
      connection_id: "connection-40"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-52",
      connection_id: "connection-34"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-20",
      connection_id: "connection-15"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-31",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-110",
      connection_id: "connection-43"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-147",
      connection_id: "connection-112"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-101",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-28",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-163",
      connection_id: "connection-126"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-122",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-769",
      connection_id: "connection-555"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-343",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-78",
      connection_id: "connection-68"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-105",
      connection_id: "connection-75"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-67",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-5",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-158",
      connection_id: "connection-122"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-118",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-17",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-169",
      connection_id: "connection-132"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-160",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-53",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-25",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "furya",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-160",
      connection_id: "connection-123"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-119",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gateway",
      client_id: "07-tendermint-13",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-153",
      connection_id: "connection-117"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-113",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-225",
      connection_id: "connection-189"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-69",
      connection_id: "connection-45"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-107",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-144",
      connection_id: "connection-116"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-77",
      connection_id: "connection-53"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-98",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-54",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "jackal",
      client_id: "07-tendermint-57",
      connection_id: "connection-47"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-139",
      connection_id: "connection-105"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-39",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-94",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-198",
      connection_id: "connection-140"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-87",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-119",
      connection_id: "connection-156"
    },
    chain_2: {
      chain_name: "kujira",
      client_id: "07-tendermint-140",
      connection_id: "connection-106"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-95",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-78",
      connection_id: "connection-54"
    },
    chain_2: {
      chain_name: "mars",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-55",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-82",
      connection_id: "connection-59"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-16",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-58",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-112",
      connection_id: "connection-82"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-75",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-95",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-2",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-156",
      connection_id: "connection-120"
    },
    chain_2: {
      chain_name: "nomic",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-166",
      connection_id: "connection-129"
    },
    chain_2: {
      chain_name: "odin",
      client_id: "07-tendermint-114",
      connection_id: "connection-83"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-157",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "kujira"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-108",
      connection_id: "connection-78"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-43",
      connection_id: "connection-36"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-70",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2017",
      connection_id: "connection-1559"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-259",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-167",
      connection_id: "connection-130"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-162",
      connection_id: "connection-200"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-158",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-152",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-70",
      connection_id: "connection-46"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-144",
      connection_id: "connection-151"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-155",
      connection_id: "connection-119"
    },
    chain_2: {
      chain_name: "realio",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-115",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-106",
      connection_id: "connection-76"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-115",
      connection_id: "connection-104"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-68",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-100",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-12",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-48",
      connection_id: "connection-29"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-44",
        port_id: "transfer",
        client_id: "07-tendermint-12",
        connection_id: "connection-7"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
        client_id: "07-tendermint-48",
        connection_id: "connection-29"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-107",
      connection_id: "connection-77"
    },
    chain_2: {
      chain_name: "sommelier",
      client_id: "07-tendermint-12",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-69",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-96",
      connection_id: "connection-68"
    },
    chain_2: {
      chain_name: "stafihub",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-9",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-178",
      connection_id: "connection-111"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-37",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-5",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-32",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-132",
      connection_id: "connection-100"
    },
    chain_2: {
      chain_name: "teritori",
      client_id: "07-tendermint-61",
      connection_id: "connection-38"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-89",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-5",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-11",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-28",
        port_id: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
M0.default = sI;
var I0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Gt, "__esModule", { value: !0 });
Gt.ibc = Gt.chain = Gt.assets = void 0;
const aI = I0(R0), oI = I0(O0), rI = I0(M0);
Gt.assets = aI.default;
Gt.chain = oI.default;
Gt.ibc = rI.default;
var Kt = {}, N0 = {};
Object.defineProperty(N0, "__esModule", { value: !0 });
const iI = {
  $schema: "../assetlist.schema.json",
  chain_name: "kyve",
  assets: [{
    description: "The native utility token of the KYVE network.",
    denom_units: [{
      denom: "ukyve",
      exponent: 0
    }, {
      denom: "kyve",
      exponent: 6
    }],
    base: "ukyve",
    name: "KYVE",
    display: "kyve",
    symbol: "KYVE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.svg"
    },
    coingecko_id: "kyve-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.svg",
      theme: {
        primary_color_hex: "#335350"
      }
    }],
    socials: {
      website: "https://www.kyve.network/",
      twitter: "https://twitter.com/KYVENetwork"
    }
  }]
};
N0.default = iI;
var P0 = {};
Object.defineProperty(P0, "__esModule", { value: !0 });
const cI = {
  $schema: "../chain.schema.json",
  chain_name: "kyve",
  chain_type: "cosmos",
  chain_id: "kyve-1",
  pretty_name: "KYVE",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "kyve",
  daemon_name: "kyved",
  node_home: "$HOME/.kyve",
  website: "https://www.kyve.network/",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ukyve",
      fixed_min_gas_price: 0.02,
      low_gas_price: 0.02,
      average_gas_price: 0.03,
      high_gas_price: 0.06
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ukyve"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.50.7-kyve-rc0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve.svg"
  },
  description: "Revolutionizing data reliability in the Web3 space, KYVE Network provides fast and easy tooling for data validation, immutability, and retrieval, ensuring trustless data for seamless scalability and eliminating data risks and roadblocks.",
  apis: {
    rpc: [
      {
        address: "https://rpc-eu-1.kyve.network",
        provider: "kyve"
      },
      {
        address: "https://rpc-kyve.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://rpc.lavenderfive.com:443/kyve",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "http://kyve.rpc.m.stavr.tech:12357",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-kyve.imperator.co",
        provider: "Imperator.co"
      },
      {
        address: "https://kyve-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rpc.kyve.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://kyve.rpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://rpc-kyve.mms.team",
        provider: "MMS"
      },
      {
        address: "https://kyve.declab.pro:26616",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://kyve-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://kyve_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://kyve-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    rest: [
      {
        address: "https://api-eu-1.kyve.network",
        provider: "kyve"
      },
      {
        address: "https://rest.lavenderfive.com:443/kyve",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rest-kyve.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://lcd-kyve.imperator.co",
        provider: "Imperator.co"
      },
      {
        address: "https://kyve.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://kyve-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://api.kyve.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://kyve.api.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://api-kyve.mms.team",
        provider: "MMS"
      },
      {
        address: "https://kyve.declab.pro:443",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://kyve-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://kyve_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://kyve-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    grpc: [
      {
        address: "https://grpc.kyve.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "kyve.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://grpc-kyve.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "http://kyve.grpc.stavr.tech:7106",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://kyve.grpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "grpc-kyve.mms.team:443",
        provider: "MMS"
      },
      {
        address: "https://kyve.declab.pro:9011",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "kyve-grpc.noders.services:15090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "kyve-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/kyve",
      tx_page: "https://ezstaking.app/kyve/txs/${txHash}",
      account_page: "https://ezstaking.app/kyve/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/kyve",
      tx_page: "https://www.mintscan.io/kyve/txs/${txHash}",
      account_page: "https://www.mintscan.io/kyve/account/${accountAddress}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/kyve",
      tx_page: "https://explorer.nodestake.top/kyve/txs/${txHash}",
      account_page: "https://explorer.nodestake.top/kyve/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Kyve",
      tx_page: "https://explorer.stavr.tech/Kyve/txs/${txHash}",
      account_page: "https://explorer.stavr.tech/Kyve/account/${accountAddress}"
    },
    {
      kind: "Stake-Take",
      url: "https://explorer.stake-take.com/kyve",
      tx_page: "https://explorer.stake-take.com/kyve/txs/${txHash}",
      account_page: "https://explorer.stake-take.com/kyve/account/${accountAddress}"
    },
    {
      kind: "Decloud Nodes Lab",
      url: "https://explorer.declab.pro/Kyve",
      tx_page: "https://explorer.declab.pro/Kyve/txs/${txHash}",
      account_page: "https://explorer.declab.pro/Kyve/account/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/kyve",
      tx_page: "https://explorer.whenmoonwhenlambo.money/kyve/txs/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/kyve/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve.svg",
    theme: {
      primary_color_hex: "#325350"
    }
  }]
};
P0.default = cI;
var U0 = {};
Object.defineProperty(U0, "__esModule", { value: !0 });
const dI = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-17",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "kyve",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      fee_version: "ics29-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-118",
      connection_id: "connection-107"
    },
    chain_2: {
      chain_name: "kyve",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-75",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kyve",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2757",
      connection_id: "connection-2274"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-767",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kyve",
      client_id: "07-tendermint-3",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "source",
      client_id: "07-tendermint-15",
      connection_id: "connection-16"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      fee_version: "ics29-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
U0.default = dI;
var H0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Kt, "__esModule", { value: !0 });
Kt.ibc = Kt.chain = Kt.assets = void 0;
const mI = H0(N0), hI = H0(P0), pI = H0(U0);
Kt.assets = mI.default;
Kt.chain = hI.default;
Kt.ibc = pI.default;
var Xt = {}, L0 = {};
Object.defineProperty(L0, "__esModule", { value: !0 });
const lI = {
  $schema: "../assetlist.schema.json",
  chain_name: "lambda",
  assets: [{
    description: "The native token of Lambda",
    denom_units: [{
      denom: "ulamb",
      exponent: 0
    }, {
      denom: "lamb",
      exponent: 18
    }],
    base: "ulamb",
    name: "Lambda",
    display: "lamb",
    symbol: "LAMB",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.svg"
    },
    coingecko_id: "lambda",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.svg",
      theme: {
        primary_color_hex: "#e41c54"
      }
    }]
  }]
};
L0.default = lI;
var W0 = {};
Object.defineProperty(W0, "__esModule", { value: !0 });
const gI = {
  $schema: "../chain.schema.json",
  chain_name: "lambda",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Lambda",
  chain_type: "cosmos",
  chain_id: "lambda_92000-1",
  bech32_prefix: "lamb",
  node_home: "$HOME/.lambdavm",
  daemon_name: "lambdavm",
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "ulamb",
      low_gas_price: 1e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ulamb"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.lambda.im",
        provider: "Lambda"
      },
      {
        address: "http://lambda.rpc.m.stavr.tech:31327",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.lambda.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://lambda-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://lambda_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://rest.lambda.im",
        provider: "Lambda"
      },
      {
        address: "https://lambda.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.lambda.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://lambda-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://lambda_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "http://lambda.grpc.m.stavr.tech:2287",
        provider: "🔥STAVR🔥"
      },
      {
        address: "grpc.lambda.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "lambda-grpc.noders.services:31090",
        provider: "[NODERS]TEAM"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://jsonrpc-lambda.d-stake.xyz",
        provider: "D-stake"
      },
      {
        address: "https://lambda-jsonrpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://lambda_mainnet_evm.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ]
  },
  explorers: [
    {
      kind: "blockscout",
      url: "https://explorer.lambda.im/",
      tx_page: "https://explorer.lambda.im/tx/${txHash}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.top/lambda",
      tx_page: "https://explorer.nodestake.top/lambda/txs/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/lambda",
      tx_page: "https://explorer.stavr.tech/lambda/txs/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/lambda",
      tx_page: "https://atomscan.com/lambda/transactions/${txHash}",
      account_page: "https://atomscan.com/lambda/accounts/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/lambda",
      tx_page: "https://explorer.whenmoonwhenlambo.money/lambda/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/lambda/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.svg",
    theme: {
      primary_color_hex: "#e41c54"
    }
  }]
};
W0.default = gI;
var V0 = {};
Object.defineProperty(V0, "__esModule", { value: !0 });
const uI = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "lambda",
    client_id: "07-tendermint-6",
    connection_id: "connection-5"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2217",
    connection_id: "connection-1733"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-378",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
V0.default = uI;
var G0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Xt, "__esModule", { value: !0 });
Xt.ibc = Xt.chain = Xt.assets = void 0;
const _I = G0(L0), yI = G0(W0), bI = G0(V0);
Xt.assets = _I.default;
Xt.chain = yI.default;
Xt.ibc = bI.default;
var Yt = {}, K0 = {};
Object.defineProperty(K0, "__esModule", { value: !0 });
const vI = {
  $schema: "../assetlist.schema.json",
  chain_name: "lava",
  assets: [{
    description: "Lava Network is a modular data network designed to provide fast, reliable, and scalable access to blockchain data for developers and users.",
    extended_description: "Lava Network is an innovative blockchain platform that aims to unlock the full potential of decentralized applications by providing a modular data access network. This platform allows developers to easily connect to multiple blockchains through fast and reliable RPC (Remote Procedure Call) services. By leveraging a peer-to-peer network of node operators, Lava ensures high performance and low latency for data requests across over 30 blockchain ecosystems. The native token, LAVA, is used for securing the network, rewarding node operators, and governance. Lava Network's goal is to create a seamless and efficient data infrastructure that supports the scalability and flexibility needs of the Web3 ecosystem.",
    denom_units: [{
      denom: "ulava",
      exponent: 0
    }, {
      denom: "lava",
      exponent: 6
    }],
    type_asset: "sdk.coin",
    base: "ulava",
    name: "Lava",
    coingecko_id: "lava-network",
    display: "lava",
    symbol: "LAVA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lava/images/lava.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lava/images/lava.png",
      theme: {
        primary_color_hex: "#6f043e"
      }
    }],
    keywords: [
      "modular",
      "data",
      "data access",
      "rpc",
      "staking",
      "dual staking",
      "indexing",
      "incentivized public rpc"
    ],
    socials: {
      website: "https://lavanet.xyz",
      twitter: "https://twitter.com/lavanetxyz"
    }
  }]
};
K0.default = vI;
var X0 = {};
Object.defineProperty(X0, "__esModule", { value: !0 });
const fI = {
  $schema: "../chain.schema.json",
  chain_name: "lava",
  status: "live",
  network_type: "mainnet",
  website: "https://lavanet.xyz/",
  update_link: "https://raw.githubusercontent.com/lavanet/lava/main/chain.schema.json",
  pretty_name: "Lava",
  chain_type: "cosmos",
  chain_id: "lava-mainnet-1",
  bech32_prefix: "lava@",
  daemon_name: "lavad",
  node_home: "$HOME/.lava",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ulava",
      fixed_min_gas_price: 2e-5,
      low_gas_price: 2e-5,
      average_gas_price: 0.025,
      high_gas_price: 0.05
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ulava"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "lavanet/cosmos-sdk v0.47.13-lava-cosmos",
    cosmwasm_enabled: !1
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lava/images/lava.png",
    theme: {
      primary_color_hex: "#6f043e"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lava/images/lava.png"
  },
  description: "Lava (LAVA) is the data access layer of the modular stack. developers and ecosystems permissionlessly add services to be served or accessed through lava. featuring a fully decentralized open source sdk integrable in frontends and a battle tested fully scalable open source server kit and can be used locally or through managed endpoints. Lava features rpc data access, indexing services, debug apis, archive access and more. Service providers can join the network, earn rewards either in the native token of the chain via token bought subscriptions on chain or through any ibc transferred token via incentive pools created and funded by ecosystems and DAOs. Developers can use the abstraction and go multi chain in seconds, not needing to choose what tools to use, having the access aggregated for them. Build whatever, wherever.",
  apis: {
    rpc: [
      {
        address: "https://lava.tendermintrpc.lava.build",
        provider: "Lava Over Lava"
      },
      {
        address: "https://lava-rpc.w3coins.io:443",
        provider: "w3coins"
      },
      {
        address: "https://lava-rpc.finteh.org:26657",
        provider: "finteh"
      },
      {
        address: "https://lava-rpc.y2.finance:443",
        provider: "YTWOFUND"
      },
      {
        address: "https://lava-rpc.ibs.team:443",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rpc.lava-mainnet-1.lava.aviaone.com:443",
        provider: "AVIAONE 🟢"
      },
      {
        address: "https://rpc-lava.r93axnodes.cloud:443",
        provider: "r93AX Nodes"
      },
      {
        address: "https://lava-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://lava.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://lava.rpc-archive.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://lava-rpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "https://lava.rpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://lava-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://lava-rpc.bluestake.net:443",
        provider: "BlueStake 🚀"
      },
      {
        address: "https://lava.rpc.stakevillage.net:443",
        provider: "Stake Village"
      }
    ],
    rest: [
      {
        address: "https://lava-api.finteh.org:443",
        provider: "finteh"
      },
      {
        address: "https://lava.rest.lava.build",
        provider: "Lava Over Lava"
      },
      {
        address: "https://lava-api.w3coins.io:443",
        provider: "w3coins"
      },
      {
        address: "https://lava-api.ibs.team:443",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://api.lava-mainnet-1.lava.aviaone.com",
        provider: "AVIAONE 🟢"
      },
      {
        address: "https://api-lava.r93axnodes.cloud:443",
        provider: "r93AX Nodes"
      },
      {
        address: "https://lava-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://lava.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://lava.api-archive.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://lava-api.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "https://lava.api.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://lava-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://lava-api.bluestake.net",
        provider: "BlueStake 🚀"
      },
      {
        address: "https://lava.api.stakevillage.net:443",
        provider: "Stake Village"
      }
    ],
    grpc: [
      {
        address: "lava.grpc.lava.build:443",
        provider: "Lava Over Lava"
      },
      {
        address: "lava-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "lava.grpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "lava.grpc-archive.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "lava-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "lava.grpc.liveraven.net:443",
        provider: "LiveRaveN"
      },
      {
        address: "lava-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "lava.grpc.stakevillage.net:443",
        provider: "Stake Village"
      },
      {
        address: "grpc-lava.r93axnodes.cloud:443",
        provider: "r93AX Nodes"
      },
      {
        address: "grpc.lava-mainnet-1.lava.aviaone.com:9104/",
        provider: "AVIAONE 🟢"
      }
    ]
  },
  explorers: [
    {
      kind: "finteh",
      url: "https://explorer.finteh.org/lava",
      tx_page: "https://explorer.finteh.org/lava/tx/${txHash}",
      account_page: "https://explorer.finteh.org/lava/account/${accountAddress}"
    },
    {
      kind: "guru",
      url: "https://lava.explorers.guru/",
      tx_page: "https://lava.explorers.guru/transaction/${txHash}",
      account_page: "https://lava.explorers.guru/account/${accountAddress}"
    },
    {
      kind: "w3coins",
      url: "https://lava-explorer.w3coins.io/Lava",
      tx_page: "https://lava-explorer.w3coins.io/Lava/tx/${txHash}",
      account_page: "https://lava-explorer.w3coins.io/Lava/account/${accountAddress}"
    },
    {
      kind: "Stake Village",
      url: "https://exp.stakevillage.net/lava-mainnet",
      tx_page: "https://exp.stakevillage.net/lava-mainnet/tx/${txHash}",
      account_page: "https://exp.stakevillage.net/lava-mainnet/account/${accountAddress}"
    },
    {
      kind: "AVIAONE 🟢",
      url: "https://mainnet.explorer.aviaone.com/lava/",
      tx_page: "https://mainnet.explorer.aviaone.com/lava/tx/${txHash}",
      account_page: "https://mainnet.explorer.aviaone.com/lava/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Lava-Mainnet",
      tx_page: "https://explorer.stavr.tech/Lava-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Lava-Mainnet/account/${accountAddress}"
    }
  ],
  keywords: [
    "modular",
    "data",
    "data access",
    "rpc",
    "staking",
    "dual staking",
    "indexing",
    "incentivized public rpc"
  ]
};
X0.default = fI;
var Y0 = {};
Object.defineProperty(Y0, "__esModule", { value: !0 });
const wI = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-225",
      connection_id: "connection-210"
    },
    chain_2: {
      chain_name: "lava",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-156",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1318",
      connection_id: "connection-1050"
    },
    chain_2: {
      chain_name: "lava",
      client_id: "07-tendermint-7",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-969",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "lava",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3210",
      connection_id: "connection-2668"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-76971",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
Y0.default = wI;
var J0 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Yt, "__esModule", { value: !0 });
Yt.ibc = Yt.chain = Yt.assets = void 0;
const xI = J0(K0), kI = J0(X0), AI = J0(Y0);
Yt.assets = xI.default;
Yt.chain = kI.default;
Yt.ibc = AI.default;
var Jt = {}, Z0 = {};
Object.defineProperty(Z0, "__esModule", { value: !0 });
const jI = {
  $schema: "../assetlist.schema.json",
  chain_name: "likecoin",
  assets: [{
    description: "LIKE is the native staking and governance token of LikeCoin chain, a Decentralized Publishing Infrastructure to empower content ownership, authenticity, and provenance.",
    denom_units: [{
      denom: "nanolike",
      exponent: 0
    }, {
      denom: "like",
      exponent: 9
    }],
    base: "nanolike",
    name: "LikeCoin",
    display: "like",
    symbol: "LIKE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.svg"
    },
    coingecko_id: "likecoin",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.svg",
      theme: {
        primary_color_hex: "#2d656c"
      }
    }]
  }]
};
Z0.default = jI;
var Q0 = {};
Object.defineProperty(Q0, "__esModule", { value: !0 });
const CI = {
  $schema: "../chain.schema.json",
  chain_name: "likecoin",
  status: "live",
  website: "https://like.co/",
  network_type: "mainnet",
  pretty_name: "LikeCoin",
  chain_type: "cosmos",
  chain_id: "likecoin-mainnet-2",
  bech32_prefix: "like",
  daemon_name: "liked",
  node_home: "$HOME/.liked",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "nanolike",
      fixed_min_gas_price: 1e3,
      low_gas_price: 1e3,
      average_gas_price: 1e4,
      high_gas_price: 1e6
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "nanolike"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.46",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [
      {
        address: "https://mainnet-node.like.co/rpc/",
        provider: "like.co"
      },
      {
        address: "https://likecoin-node.oldcat.io:443/rpc/",
        provider: "Oldcat"
      },
      {
        address: "https://like.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-likecoin-mainnet.pikaser.net",
        provider: "PikaSer"
      },
      {
        address: "https://rpc.likecoin.citizenweb3.com:443",
        provider: "Citizen Web3"
      }
    ],
    rest: [
      {
        address: "https://mainnet-node.like.co",
        provider: "like.co"
      },
      {
        address: "https://like.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://likecoin-node.oldcat.io:443/api/",
        provider: "Oldcat"
      },
      {
        address: "https://rest-likecoin-mainnet.pikaser.net",
        provider: "PikaSer"
      }
    ],
    grpc: [
      {
        address: "mainnet-node-grpc.like.co:80",
        provider: "like.co"
      },
      {
        address: "like.grpc.m.stavr.tech:2000",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://likecoin-node.oldcat.io:443/grpc/",
        provider: "Oldcat"
      },
      {
        address: "grpc-likecoin-mainnet.pikaser.net:443",
        provider: "PikaSer"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/likecoin",
      tx_page: "https://ezstaking.app/likecoin/txs/${txHash}",
      account_page: "https://ezstaking.app/likecoin/account/${accountAddress}"
    },
    {
      kind: "lunie-ng",
      url: "https://stake.like.co/"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Likecoin-M",
      tx_page: "https://explorer.stavr.tech/Likecoin-M/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/likecoin",
      tx_page: "https://ping.pub/likecoin/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/likecoin",
      tx_page: "https://atomscan.com/likecoin/transactions/${txHash}",
      account_page: "https://atomscan.com/likecoin/accounts/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/likecoin-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/likecoin-chain-logo.svg"
  },
  keywords: [
    "ebook",
    "depub",
    "publishing",
    "like",
    "book",
    "writing",
    "nft"
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/likecoin-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/likecoin-chain-logo.svg",
    theme: {
      primary_color_hex: "#2e656d"
    }
  }]
};
Q0.default = CI;
var ey = {};
Object.defineProperty(ey, "__esModule", { value: !0 });
const EI = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cosmoshub",
    client_id: "07-tendermint-468",
    connection_id: "connection-386"
  },
  chain_2: {
    chain_name: "likecoin",
    client_id: "07-tendermint-24",
    connection_id: "connection-13"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-217",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-5",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {}
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "likecoin",
    client_id: "07-tendermint-16",
    connection_id: "connection-9"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1507",
    connection_id: "connection-1173"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-3",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-53",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
ey.default = EI;
var ny = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Jt, "__esModule", { value: !0 });
Jt.ibc = Jt.chain = Jt.assets = void 0;
const DI = ny(Z0), BI = ny(Q0), FI = ny(ey);
Jt.assets = DI.default;
Jt.chain = BI.default;
Jt.ibc = FI.default;
var cr = {}, ty = {};
Object.defineProperty(ty, "__esModule", { value: !0 });
const $I = {
  $schema: "../assetlist.schema.json",
  chain_name: "logos",
  assets: [{
    description: "The native token of Logos",
    denom_units: [{
      denom: "aLYT",
      exponent: 0
    }, {
      denom: "LYT",
      exponent: 18
    }],
    base: "aLYT",
    name: "LYT",
    display: "LYT",
    symbol: "LYT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/logos/images/logos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/logos/images/logos.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/logos/images/logos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/logos/images/logos.svg",
      theme: {
        primary_color_hex: "#848484"
      }
    }]
  }]
};
ty.default = $I;
var sy = {};
Object.defineProperty(sy, "__esModule", { value: !0 });
const zI = {
  $schema: "../chain.schema.json",
  chain_name: "logos",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Logos",
  chain_type: "cosmos",
  chain_id: "logos_7002-1",
  bech32_prefix: "logos",
  daemon_name: "logosd",
  node_home: "$HOME/.logos",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aLYT"
    }]
  },
  apis: {
    rpc: [{
      address: "https://logos-rpc.provable.dev:443/",
      provider: "laurel.provable"
    }],
    rest: [{
      address: "https://logos.provable.dev/rest/",
      provider: "laurel.provable"
    }],
    grpc: [{
      address: "logos-grpc.provable.dev:443",
      provider: "laurel.provable"
    }],
    "evm-http-jsonrpc": [{
      address: "https://logos-evm.provable.dev/",
      provider: "laurel.provable"
    }]
  },
  explorers: [],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/logos/images/logos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/logos/images/logos.svg"
  },
  codebase: {},
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/logos/images/logos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/logos/images/logos.svg",
    theme: {
      primary_color_hex: "#848484"
    }
  }]
};
sy.default = zI;
var S9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(cr, "__esModule", { value: !0 });
cr.chain = cr.assets = void 0;
const qI = S9(ty), SI = S9(sy);
cr.assets = qI.default;
cr.chain = SI.default;
var dr = {}, ay = {};
Object.defineProperty(ay, "__esModule", { value: !0 });
const TI = {
  $schema: "../assetlist.schema.json",
  chain_name: "loop",
  assets: [{
    description: "The native token of Loop",
    denom_units: [{
      denom: "token",
      exponent: 0
    }],
    type_asset: "sdk.coin",
    base: "token",
    name: "Token",
    display: "token",
    symbol: "TOKEN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/loop.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/loop.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/loop.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/loop.svg",
      theme: {
        primary_color_hex: "#4991ee"
      }
    }],
    socials: {
      website: "https://www.loop.fans/",
      twitter: "https://twitter.com/LoopFans"
    }
  }, {
    denom_units: [{
      denom: "upoa",
      exponent: 0
    }, {
      denom: "poa",
      exponent: 6
    }],
    type_asset: "sdk.coin",
    base: "upoa",
    name: "POA",
    display: "poa",
    symbol: "POA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/poa.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/poa.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/poa.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/poa.svg",
      theme: {
        primary_color_hex: "#bdaf88"
      }
    }],
    keywords: ["poa"]
  }]
};
ay.default = TI;
var oy = {};
Object.defineProperty(oy, "__esModule", { value: !0 });
const RI = {
  $schema: "../chain.schema.json",
  chain_name: "loop",
  status: "live",
  network_type: "mainnet",
  website: "https://www.loop.fans/",
  pretty_name: "Loop",
  chain_type: "cosmos",
  chain_id: "loop-1",
  bech32_prefix: "loop",
  daemon_name: "loopd",
  node_home: "$HOME/.loopchain",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "token",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "upoa"
    }]
  },
  codebase: {
    cosmwasm_enabled: !0
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/loop.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/loop.svg",
    theme: {
      primary_color_hex: "#4991ee"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/loop.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loop/images/loop.svg"
  },
  description: "Empowering Artists and Superfans.",
  apis: {
    rpc: [{
      address: "https://rpc.loop.pfc.zone/",
      provider: "PFC"
    }],
    rest: [{
      address: "https://api.loop.pfc.zone/",
      provider: "PFC"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://ping.pfc.zone/loop",
    tx_page: "https://ping.pfc.zone/loop/tx/${txHash}"
  }],
  keywords: ["fans"]
};
oy.default = RI;
var T9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(dr, "__esModule", { value: !0 });
dr.chain = dr.assets = void 0;
const OI = T9(ay), MI = T9(oy);
dr.assets = OI.default;
dr.chain = MI.default;
var Zt = {}, ry = {};
Object.defineProperty(ry, "__esModule", { value: !0 });
const II = {
  $schema: "../assetlist.schema.json",
  chain_name: "lorenzo",
  assets: [{
    description: "Native staking token of Lorenzo: LRZ (alrz)",
    denom_units: [{
      denom: "alrz",
      exponent: 0
    }, {
      denom: "LRZ",
      exponent: 18
    }],
    base: "alrz",
    name: "LRZ",
    display: "LRZ",
    symbol: "LRZ",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/lorenzo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/lorenzo.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/lorenzo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/lorenzo.svg",
      theme: {
        primary_color_hex: "#133348"
      }
    }],
    socials: {
      website: "https://www.lorenzo-protocol.xyz/",
      twitter: "https://x.com/LorenzoProtocol"
    }
  }, {
    description: `stBTC is the liquid principal token of the Lorenzo protocol, designed to represent staked Bitcoin within the Babylon ecosystem.

`,
    extended_description: `stBTC serves as a crucial component of the Lorenzo protocol, enabling Bitcoin holders to unlock the liquidity of their assets while participating in the security of Proof-of-Stake (PoS) networks. By staking BTC through Lorenzo, users receive stBTC, which is redeemable 1-to-1 for the original Bitcoin. This mechanism allows users to earn yield without sacrificing liquidity, as stBTC can be freely utilized within the Lorenzo DeFi ecosystem.

The innovative dual-token system of stBTC and Yield Accruing Tokens (YATs) empowers users to not only stake their BTC but also engage in various decentralized finance activities such as trading, lending, and collateralization. This enhances the utility and flexibility of Bitcoin, providing additional financial opportunities while contributing to the security of PoS networks.

stBTC's role in the Lorenzo protocol illustrates its importance in creating a highly interconnected and efficient financial ecosystem, making it a valuable asset in the broader landscape of decentralized finance.`,
    denom_units: [{
      denom: "stBTC",
      exponent: 0
    }, {
      denom: "display_stBTC",
      exponent: 18
    }],
    base: "stBTC",
    name: "Lorenzo stBTC",
    display: "display_stBTC",
    symbol: "stBTC",
    traces: [{
      type: "liquid-stake",
      counterparty: {
        chain_name: "bitcoin",
        base_denom: "sat"
      },
      provider: "Lorenzo"
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/stBTC.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/stBTC.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/stBTC.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/stBTC.svg",
      theme: {
        primary_color_hex: "#133348"
      }
    }],
    socials: {
      website: "https://www.lorenzo-protocol.xyz/",
      twitter: "https://x.com/LorenzoProtocol"
    }
  }]
};
ry.default = II;
var iy = {};
Object.defineProperty(iy, "__esModule", { value: !0 });
const NI = {
  $schema: "../chain.schema.json",
  chain_name: "lorenzo",
  status: "live",
  network_type: "mainnet",
  website: "https://www.lorenzo-protocol.xyz/",
  pretty_name: "Lorenzo Protocol",
  chain_type: "cosmos",
  chain_id: "lorenzo_8329-1",
  bech32_prefix: "lrz",
  daemon_name: "lorenzod",
  node_home: "$HOME/.lorenzo",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "stBTC",
      fixed_min_gas_price: 2e6,
      low_gas_price: 2e6,
      average_gas_price: 2e6,
      high_gas_price: 8e6
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "alrz"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/lorenzo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/lorenzo.svg"
  },
  description: "Lorenzo aims to be the premier Bitcoin platform for yield-bearing token issuance, trading, and settlement.",
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc-cosmos.lorenzo-protocol.xyz/",
      provider: "Lorenzo Protocol"
    }],
    "evm-http-jsonrpc": [{
      address: "https://rpc-testnet.lorenzo-protocol.xyz/",
      provider: "Lorenzo Protocol"
    }]
  },
  explorers: [{
    kind: "blockscout",
    url: "https://scan.lorenzo-protocol.xyz/",
    tx_page: "https://scan.lorenzo-protocol.xyz/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/lorenzo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lorenzo/images/lorenzo.svg",
    theme: {
      primary_color_hex: "#133348"
    }
  }]
};
iy.default = NI;
var cy = {};
Object.defineProperty(cy, "__esModule", { value: !0 });
const PI = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "lorenzo",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3243",
    connection_id: "connection-2731"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-79840",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
cy.default = PI;
var dy = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Zt, "__esModule", { value: !0 });
Zt.ibc = Zt.chain = Zt.assets = void 0;
const UI = dy(ry), HI = dy(iy), LI = dy(cy);
Zt.assets = UI.default;
Zt.chain = HI.default;
Zt.ibc = LI.default;
var mr = {}, my = {};
Object.defineProperty(my, "__esModule", { value: !0 });
const WI = {
  $schema: "../assetlist.schema.json",
  chain_name: "loyal",
  assets: [{
    description: "The native token of Loyal",
    denom_units: [{
      denom: "ulyl",
      exponent: 0
    }, {
      denom: "lyl",
      exponent: 6
    }],
    base: "ulyl",
    name: "Loyal",
    display: "lyl",
    symbol: "LYL",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loyal/images/lyl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loyal/images/lyl.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loyal/images/lyl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loyal/images/lyl.svg",
      theme: {
        primary_color_hex: "#5445fb"
      }
    }]
  }]
};
my.default = WI;
var hy = {};
Object.defineProperty(hy, "__esModule", { value: !0 });
const VI = {
  $schema: "../chain.schema.json",
  chain_name: "loyal",
  status: "live",
  network_type: "mainnet",
  website: "https://www.joinloyal.com/",
  pretty_name: "Loyal",
  chain_type: "cosmos",
  chain_id: "loyal-main-02",
  bech32_prefix: "loyal",
  daemon_name: "loyald",
  node_home: "$HOME/.loyal",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ulyl",
      fixed_min_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ulyl"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loyal/images/lyl.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loyal/images/lyl.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc-main.joinloyal.io/"
    }, {
      address: "https://loyal-rpc.polkachu.com",
      provider: "Polkachu"
    }],
    rest: [{
      address: "https://lcd-main.joinloyal.io/"
    }, {
      address: "https://loyal-api.polkachu.com",
      provider: "Polkachu"
    }],
    grpc: [{
      address: "https://grpc.loyal.nodestake.top",
      provider: "NodeStake"
    }]
  },
  explorers: [
    {
      kind: "Loyal explorer",
      url: "https://pingpub.joinloyal.io/loyal",
      tx_page: "https://pingpub.joinloyal.io/loyal/tx/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/loyal",
      tx_page: "https://explorer.tcnetwork.io/loyal/transaction/${txHash}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/loyal",
      tx_page: "https://explorer.nodestake.top/loyal/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loyal/images/lyl.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/loyal/images/lyl.svg",
    theme: {
      primary_color_hex: "#5445fb"
    }
  }]
};
hy.default = VI;
var R9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(mr, "__esModule", { value: !0 });
mr.chain = mr.assets = void 0;
const GI = R9(my), KI = R9(hy);
mr.assets = GI.default;
mr.chain = KI.default;
var Qt = {}, py = {};
Object.defineProperty(py, "__esModule", { value: !0 });
const XI = {
  $schema: "../assetlist.schema.json",
  chain_name: "lumenx",
  assets: [{
    description: "The native token of LumenX Network",
    denom_units: [{
      denom: "ulumen",
      exponent: 0
    }, {
      denom: "lumen",
      exponent: 6
    }],
    base: "ulumen",
    name: "LUMEN",
    display: "lumen",
    symbol: "LUMEN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.svg",
      theme: {
        primary_color_hex: "#cb8b40"
      }
    }]
  }]
};
py.default = XI;
var ly = {};
Object.defineProperty(ly, "__esModule", { value: !0 });
const YI = {
  $schema: "../chain.schema.json",
  chain_name: "lumenx",
  status: "killed",
  network_type: "mainnet",
  pretty_name: "LumenX",
  chain_type: "cosmos",
  chain_id: "LumenX",
  bech32_prefix: "lumen",
  daemon_name: "lumenxd",
  node_home: "$HOME/.lumenx",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ulumen",
      fixed_min_gas_price: 25e-4,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ulumen"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc-lumenx.cryptonet.pl/",
      provider: "CryptoNet"
    }, {
      address: "https://lumenx-rpc.kynraze.com/",
      provider: "Kynraze"
    }],
    rest: [
      {
        address: "https://api-lumenx.cryptonet.pl/",
        provider: "CryptoNet"
      },
      {
        address: "https://api-lumenx.nodine.id/",
        provider: "Nodine.ID"
      },
      {
        address: "https://lcd.lumenx.hexnodes.co/",
        provider: "Hexnodes"
      }
    ],
    grpc: [
      {
        address: "https://lumenx-grpc.kynraze.com",
        provider: "Kynraze"
      },
      {
        address: "https://grpc-lumenx.nodine.id",
        provider: "Nodine.ID"
      },
      {
        address: "https://grpc.lumenx.hexnodes.co",
        provider: "Hexnodes"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://explorer.chaintools.tech/lumenx",
      tx_page: "https://explorer.chaintools.tech/lumenx/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.cryptonet.pl/lumenx",
      tx_page: "https://explorer.cryptonet.pl/lumenx/tx/${txHash}"
    },
    {
      kind: "Kynraze",
      url: "https://explorer.kynraze.com/lumenx",
      tx_page: "https://explorer.kynraze.com/lumenx/tx/${txHash}"
    },
    {
      kind: "ComunityNode",
      url: "https://explorer.comunitynode.my.id/lumenx",
      tx_page: "https://explorer.comunitynode.my.id/lumenx/tx/${txHash}"
    },
    {
      kind: "Nodine.ID",
      url: "https://explorer.co.id/lumenx",
      tx_page: "https://explorer.co.id/lumenx/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/lumenx",
      tx_page: "https://atomscan.com/lumenx/transactions/${txHash}",
      account_page: "https://atomscan.com/lumenx/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.svg",
    theme: {
      primary_color_hex: "#cb8b40"
    }
  }]
};
ly.default = YI;
var gy = {};
Object.defineProperty(gy, "__esModule", { value: !0 });
const JI = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "lumenx",
    client_id: "07-tendermint-0",
    connection_id: "connection-6"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2079",
    connection_id: "connection-1620"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-3",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-286",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
gy.default = JI;
var uy = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qt, "__esModule", { value: !0 });
Qt.ibc = Qt.chain = Qt.assets = void 0;
const ZI = uy(py), QI = uy(ly), eN = uy(gy);
Qt.assets = ZI.default;
Qt.chain = QI.default;
Qt.ibc = eN.default;
var es = {}, _y = {};
Object.defineProperty(_y, "__esModule", { value: !0 });
const nN = {
  $schema: "../assetlist.schema.json",
  chain_name: "lumnetwork",
  assets: [{
    description: "Native token of the Lum Network",
    denom_units: [{
      denom: "ulum",
      exponent: 0
    }, {
      denom: "lum",
      exponent: 6
    }],
    base: "ulum",
    name: "Lum",
    display: "lum",
    symbol: "LUM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.svg"
    },
    coingecko_id: "lum-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.svg",
      theme: {
        primary_color_hex: "#080808"
      }
    }]
  }]
};
_y.default = nN;
var yy = {};
Object.defineProperty(yy, "__esModule", { value: !0 });
const tN = {
  $schema: "../chain.schema.json",
  chain_name: "lumnetwork",
  status: "live",
  network_type: "mainnet",
  website: "https://lum.network/",
  pretty_name: "Lum Network",
  chain_type: "cosmos",
  chain_id: "lum-network-1",
  bech32_prefix: "lum",
  daemon_name: "lumd",
  node_home: "$HOME/.lumd",
  key_algos: ["secp256k1"],
  slip44: 880,
  fees: {
    fee_tokens: [{
      denom: "ulum",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ulum"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.11"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.node0.mainnet.lum.network",
        provider: "Lum Foundation"
      },
      {
        address: "https://lum.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.lavenderfive.com:443/lumnetwork",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://lum-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://lum-rpc.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://lumnetwork_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://rest.node0.mainnet.lum.network",
        provider: "Lum Foundation"
      },
      {
        address: "https://rest.lavenderfive.com:443/lumnetwork",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://lum.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://lum-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://lum-rest.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://lumnetwork_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "lumnetwork.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "lum.grpc.m.stavr.tech:2277",
        provider: "🔥STAVR🔥"
      },
      {
        address: "lum-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "lum-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/lumnetwork",
      tx_page: "https://ezstaking.app/lumnetwork/txs/${txHash}",
      account_page: "https://ezstaking.app/lumnetwork/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/lum",
      tx_page: "https://www.mintscan.io/lum/transactions/${txHash}",
      account_page: "https://www.mintscan.io/lum/accounts/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/LumNetwork-Mainnet",
      tx_page: "https://explorer.stavr.tech/LumNetwork-Mainnet/tx/${txHash}"
    },
    {
      kind: "lum-network",
      url: "https://explorer.lum.network",
      tx_page: "https://explorer.lum.network/txs/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/lum-network",
      tx_page: "https://ping.pub/lum-network/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/lum-network",
      tx_page: "https://atomscan.com/lum-network/transactions/${txHash}",
      account_page: "https://atomscan.com/lum-network/accounts/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/lum-network",
      tx_page: "https://explorer.whenmoonwhenlambo.money/lum-network/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/lum-network/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.svg",
    theme: {
      primary_color_hex: "#080808"
    }
  }]
};
yy.default = tN;
var by = {};
Object.defineProperty(by, "__esModule", { value: !0 });
const sN = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cosmoshub",
    client_id: "07-tendermint-1120",
    connection_id: "connection-807"
  },
  chain_2: {
    chain_name: "lumnetwork",
    client_id: "07-tendermint-21",
    connection_id: "connection-22"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-566",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-12",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "lumnetwork",
    client_id: "07-tendermint-7",
    connection_id: "connection-5"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1668",
    connection_id: "connection-1280"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-3",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-115",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
by.default = sN;
var vy = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(es, "__esModule", { value: !0 });
es.ibc = es.chain = es.assets = void 0;
const aN = vy(_y), oN = vy(yy), rN = vy(by);
es.assets = aN.default;
es.chain = oN.default;
es.ibc = rN.default;
var ns = {}, fy = {};
Object.defineProperty(fy, "__esModule", { value: !0 });
const iN = {
  $schema: "../assetlist.schema.json",
  chain_name: "mande",
  assets: [{
    description: "The native token of Mande Network.",
    extended_description: "Credibility Hub for Web3",
    denom_units: [{
      denom: "amand",
      exponent: 0
    }, {
      denom: "mand",
      exponent: 18
    }],
    type_asset: "sdk.coin",
    base: "amand",
    name: "Mande Network",
    display: "mand",
    symbol: "MAND",
    coingecko_id: "mande-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.svg",
      theme: {
        primary_color_hex: "#274cbf"
      }
    }],
    socials: {
      website: "https://mande.network/",
      twitter: "https://twitter.com/MandeNetwork"
    },
    keywords: ["credibility", "web3"],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.svg"
    }
  }]
};
fy.default = iN;
var wy = {};
Object.defineProperty(wy, "__esModule", { value: !0 });
const cN = {
  $schema: "../chain.schema.json",
  chain_name: "mande",
  status: "live",
  network_type: "mainnet",
  website: "https://mande.network",
  pretty_name: "Mande Network",
  chain_type: "cosmos",
  chain_id: "mande_18071918-1",
  bech32_prefix: "mande",
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "amand",
      low_gas_price: 2e10,
      average_gas_price: 2e10,
      high_gas_price: 2e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "amand"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.svg"
  },
  description: "Credibility Hub for Web3",
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.svg",
    theme: {
      primary_color_hex: "#274cbf"
    }
  }],
  codebase: {},
  apis: {
    rpc: [{
      address: "https://mande-mainnet-tendermint.public.blastapi.io",
      provider: "BlastAPI"
    }],
    rest: [{
      address: "https://mande-mainnet-rest.public.blastapi.io",
      provider: "BlastAPI"
    }],
    "evm-http-jsonrpc": [{
      address: "https://mande-mainnet.public.blastapi.io",
      provider: "BlastAPI"
    }]
  },
  explorers: [{
    kind: "FYI",
    url: "https://dym.fyi/r/mande",
    tx_page: "https://dym.fyi/r/mande/tx/${txHash}",
    account_page: "https://dym.fyi/r/mande/address/${accountAddress}"
  }]
};
wy.default = cN;
var xy = {};
Object.defineProperty(xy, "__esModule", { value: !0 });
const dN = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "dymension",
    client_id: "07-tendermint-50",
    connection_id: "connection-36"
  },
  chain_2: {
    chain_name: "mande",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-51",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
xy.default = dN;
var ky = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ns, "__esModule", { value: !0 });
ns.ibc = ns.chain = ns.assets = void 0;
const mN = ky(fy), hN = ky(wy), pN = ky(xy);
ns.assets = mN.default;
ns.chain = hN.default;
ns.ibc = pN.default;
var ts = {}, Ay = {};
Object.defineProperty(Ay, "__esModule", { value: !0 });
const lN = {
  $schema: "../assetlist.schema.json",
  chain_name: "mars",
  assets: [{
    description: "Mars Protocol token (pre-migration)",
    denom_units: [{
      denom: "umars",
      exponent: 0
    }, {
      denom: "mars",
      exponent: 6
    }],
    base: "umars",
    name: "Mars",
    display: "mars",
    symbol: "MARS.old",
    traces: [{
      type: "legacy-mintage",
      counterparty: {
        chain_name: "neutron",
        base_denom: "factory/neutron1ndu2wvkrxtane8se2tr48gv7nsm46y5gcqjhux/MARS"
      },
      provider: "Mars Hub"
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-token-ibc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-token-ibc.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-token-ibc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-token-ibc.svg",
      theme: {
        primary_color_hex: "#000000"
      }
    }],
    socials: {
      website: "https://www.marsprotocol.io/",
      twitter: "https://twitter.com/mars_protocol"
    }
  }]
};
Ay.default = lN;
var jy = {};
Object.defineProperty(jy, "__esModule", { value: !0 });
const gN = {
  $schema: "../chain.schema.json",
  chain_name: "mars",
  status: "live",
  network_type: "mainnet",
  website: "https://www.marsprotocol.io/",
  pretty_name: "Mars Hub",
  chain_type: "cosmos",
  chain_id: "mars-1",
  bech32_prefix: "mars",
  daemon_name: "marsd",
  node_home: "$HOME/.mars",
  key_algos: ["secp256k1"],
  slip44: 118,
  alternative_slip44s: [330],
  fees: {
    fee_tokens: [{
      denom: "umars",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0.01
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "umars"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46.7",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30.0"
  },
  description: "Lend, borrow and earn with an autonomous credit protocol in the Cosmos universe. Open to all, closed to none.",
  apis: {
    rpc: [
      {
        address: "https://rpc.marsprotocol.io:443",
        provider: "Delphi Labs"
      },
      {
        address: "https://rpc.lavenderfive.com:443/mars",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://mars-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://mars-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc.expedition-mars.com",
        provider: "Expedition Mars"
      },
      {
        address: "https://mars-rpc.genznodes.dev:443",
        provider: "genznodes"
      },
      {
        address: "https://mars-rpc.stakeandrelax.net",
        provider: "Stake&Relax Validator 🦥"
      },
      {
        address: "https://mars-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://mars-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      }
    ],
    rest: [
      {
        address: "https://rest.marsprotocol.io:443",
        provider: "Delphi Labs"
      },
      {
        address: "https://rest.lavenderfive.com:443/mars",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://mars-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://mars-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://lcd.expedition-mars.com:443",
        provider: "Expedition Mars"
      },
      {
        address: "https://mars-api.genznodes.dev:443",
        provider: "genznodes"
      },
      {
        address: "https://mars-api.stakeandrelax.net",
        provider: "Stake&Relax Validator 🦥"
      },
      {
        address: "https://mars-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://mars-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      }
    ],
    grpc: [
      {
        address: "grpc.marsprotocol.io:443",
        provider: "Delphi Labs"
      },
      {
        address: "mars.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "mars-grpc.polkachu.com:18590",
        provider: "Polkachu"
      },
      {
        address: "mars-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "mars-grpc.genznodes.dev:26090",
        provider: "genznodes"
      },
      {
        address: "mars.grpc.kjnodes.com:14590",
        provider: "kjnodes"
      },
      {
        address: "grpc.mars.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "mars-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "mars-grpc.stakeandrelax.net:18590",
        provider: "Stake&Relax 🦥"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/mars-protocol",
      tx_page: "https://ezstaking.app/mars-protocol/txs/${txHash}",
      account_page: "https://ezstaking.app/mars-protocol/account/${accountAddress}"
    },
    {
      kind: "BigDipper",
      url: "https://explorer.marsprotocol.io",
      tx_page: "https://explorer.marsprotocol.io/transactions/${txHash}",
      account_page: "https://explorer.marsprotocol.io/accounts/${accountAddress}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/mars",
      tx_page: "https://explorer.nodestake.top/mars/transactions/${txHash}",
      account_page: "https://explorer.nodestake.top/mars/account/${accountAddress}"
    },
    {
      kind: "Nodes.Guru",
      url: "https://mars.explorers.guru/",
      tx_page: "https://mars.explorers.guru/transaction/${txHash}",
      account_page: "https://mars.explorers.guru/account/${accountAddress}"
    },
    {
      kind: "MintScan",
      url: "https://www.mintscan.io/mars-protocol",
      tx_page: "https://www.mintscan.io/mars-protocol/transactions/${txHash}",
      account_page: "https://www.mintscan.io/mars-protocol/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/mars",
      tx_page: "https://ping.pub/mars/tx/${txHash}",
      account_page: "https://ping.pub/mars/account/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-protocol.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-protocol.svg"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-protocol.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-protocol.svg",
    theme: {
      primary_color_hex: "#040404"
    }
  }]
};
jy.default = gN;
var Cy = {};
Object.defineProperty(Cy, "__esModule", { value: !0 });
const uN = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-53",
      connection_id: "connection-52"
    },
    chain_2: {
      chain_name: "mars",
      client_id: "07-tendermint-14",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-35",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-300",
      connection_id: "connection-270"
    },
    chain_2: {
      chain_name: "mars",
      client_id: "07-tendermint-11",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-209",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-78",
      connection_id: "connection-54"
    },
    chain_2: {
      chain_name: "mars",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-55",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "mars",
      client_id: "07-tendermint-64",
      connection_id: "connection-50"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-21",
      connection_id: "connection-21"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "mars",
      client_id: "07-tendermint-4",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2602",
      connection_id: "connection-2114"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-557",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "mars",
      client_id: "07-tendermint-10",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-104",
      connection_id: "connection-91"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-78",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Cy.default = uN;
var Ey = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ts, "__esModule", { value: !0 });
ts.ibc = ts.chain = ts.assets = void 0;
const _N = Ey(Ay), yN = Ey(jy), bN = Ey(Cy);
ts.assets = _N.default;
ts.chain = yN.default;
ts.ibc = bN.default;
var hr = {}, Dy = {};
Object.defineProperty(Dy, "__esModule", { value: !0 });
const vN = {
  $schema: "../assetlist.schema.json",
  chain_name: "mayachain",
  assets: [{
    description: "The native token of Maya Protocol",
    denom_units: [{
      denom: "cacao",
      exponent: 0
    }, {
      denom: "CACAO",
      exponent: 10
    }],
    base: "cacao",
    name: "Cacao",
    display: "CACAO",
    symbol: "CACAO",
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mayachain/images/cacao.svg"
    }],
    coingecko_id: "cacao",
    keywords: ["dex"],
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mayachain/images/cacao.svg"
    }
  }, {
    description: "The native revenue sharing token of Maya Protocol",
    denom_units: [{
      denom: "maya",
      exponent: 0
    }, {
      denom: "MAYA",
      exponent: 4
    }],
    base: "maya",
    name: "Maya",
    display: "MAYA",
    symbol: "MAYA",
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mayachain/images/maya.svg"
    }],
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mayachain/images/maya.svg"
    }
  }]
};
Dy.default = vN;
var By = {};
Object.defineProperty(By, "__esModule", { value: !0 });
const fN = {
  $schema: "../chain.schema.json",
  chain_name: "mayachain",
  status: "live",
  network_type: "mainnet",
  website: "https://mayaprotocol.com/",
  pretty_name: "Maya Protocol",
  chain_type: "cosmos",
  chain_id: "mayachain-mainnet-v1",
  bech32_prefix: "maya",
  daemon_name: "mayanode",
  node_home: "$HOME/.mayanode",
  slip44: 931,
  codebase: {},
  apis: {
    rpc: [{
      address: "https://tendermint.mayachain.info",
      provider: "tendermint"
    }],
    rest: [{
      address: "https://mayanode.mayachain.info",
      provider: "mayanode"
    }]
  },
  explorers: [{
    kind: "Maya Protocol explorer",
    url: "https://www.explorer.mayachain.info",
    tx_page: "https://www.explorer.mayachain.info/#/txs/${txHash}"
  }]
};
By.default = fN;
var O9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(hr, "__esModule", { value: !0 });
hr.chain = hr.assets = void 0;
const wN = O9(Dy), xN = O9(By);
hr.assets = wN.default;
hr.chain = xN.default;
var ss = {}, Fy = {};
Object.defineProperty(Fy, "__esModule", { value: !0 });
const kN = {
  $schema: "../assetlist.schema.json",
  chain_name: "medasdigital",
  assets: [{
    description: "The native token of Medas Digital Network",
    denom_units: [{
      denom: "umedas",
      exponent: 0
    }, {
      denom: "medas",
      exponent: 6
    }],
    base: "umedas",
    name: "Medas Digital",
    display: "medas",
    symbol: "MEDAS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.svg"
    },
    keywords: ["medas"],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.svg",
      theme: {
        primary_color_hex: "#147ccc"
      }
    }]
  }]
};
Fy.default = kN;
var $y = {};
Object.defineProperty($y, "__esModule", { value: !0 });
const AN = {
  $schema: "../chain.schema.json",
  chain_name: "medasdigital",
  status: "live",
  network_type: "mainnet",
  website: "https://medas-digital.io/",
  pretty_name: "Medas Digital Network",
  chain_type: "cosmos",
  chain_id: "medasdigital-1",
  bech32_prefix: "medas",
  daemon_name: "medasdigitald",
  node_home: "$HOME/.medasdigital",
  slip44: 118,
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "umedas",
      low_gas_price: 0.1,
      average_gas_price: 0.25,
      high_gas_price: 0.4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "umedas"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.medas-digital.io:26657/",
      provider: "Neptun Validator"
    }],
    rest: [{
      address: "https://lcd.medas-digital.io:1317/",
      provider: "Neptun Validator"
    }],
    grpc: [{
      address: "grpc.medas-digital.io:9090",
      provider: "Neptun Validator"
    }]
  },
  explorers: [{
    kind: "BigDipper",
    url: "https://explorer.medas-digital.io:3100/medasdigital",
    tx_page: "https://explorer.medas-digital.io:3100/medasdigital/transactions/${txHash}",
    account_page: "explorer.medas-digital.io:3100/medasdigital/accounts/${accountAddress}"
  }, {
    kind: "atomscan",
    url: "https://atomscan.com/frontier/medasdigital",
    tx_page: "https://atomscan.com/frontier/medasdigital/transactions/${txHash}",
    account_page: "https://atomscan.com/frontier/medasdigital/accounts/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.svg",
    theme: {
      primary_color_hex: "#147ccc"
    }
  }]
};
$y.default = AN;
var zy = {};
Object.defineProperty(zy, "__esModule", { value: !0 });
const jN = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "medasdigital",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2372",
    connection_id: "connection-1869"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-519",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "medasdigital",
    client_id: "07-tendermint-4",
    connection_id: "connection-4"
  },
  chain_2: {
    chain_name: "sentinel",
    client_id: "07-tendermint-110",
    connection_id: "connection-87"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-4",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-60",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
zy.default = jN;
var qy = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ss, "__esModule", { value: !0 });
ss.ibc = ss.chain = ss.assets = void 0;
const CN = qy(Fy), EN = qy($y), DN = qy(zy);
ss.assets = CN.default;
ss.chain = EN.default;
ss.ibc = DN.default;
var as = {}, Sy = {};
Object.defineProperty(Sy, "__esModule", { value: !0 });
const BN = {
  $schema: "../assetlist.schema.json",
  chain_name: "meme",
  assets: [{
    description: "MEME Token (MEME) is the native staking token of the MEME Chain",
    denom_units: [{
      denom: "umeme",
      exponent: 0
    }, {
      denom: "meme",
      exponent: 6
    }],
    base: "umeme",
    name: "MEME",
    display: "meme",
    symbol: "MEME",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.svg"
    },
    coingecko_id: "meme-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.svg",
      theme: {
        primary_color_hex: "#b7dcd8"
      }
    }]
  }, {
    description: "The native EVM, governance and staking token of the Planq Network",
    extended_description: "Planq is the very first cryptocurrency project to keep mobile platform usability at heart, taking a step away from dependency on desktop services. By focusing on easy accessibility and close integration of other blockchains via easy to use bridges, Planq will push Web 3 adoption in the mobile space to the next level.",
    denom_units: [{
      denom: "ibc/FACC1CE598366EA01D86CF1CBE05F1A6C7511F673E91DEFF04342ED8DEFE3A60",
      exponent: 0
    }, {
      denom: "planq",
      exponent: 18
    }],
    name: "Planq",
    display: "planq",
    symbol: "PLQ",
    type_asset: "ics20",
    base: "ibc/FACC1CE598366EA01D86CF1CBE05F1A6C7511F673E91DEFF04342ED8DEFE3A60",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.svg"
    },
    traces: [{
      type: "ibc",
      counterparty: {
        chain_name: "planq",
        base_denom: "aplanq",
        channel_id: "channel-64"
      },
      chain: {
        channel_id: "channel-11",
        path: "transfer/channel-11/aplanq"
      }
    }],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.svg",
      image_sync: {
        chain_name: "planq",
        base_denom: "aplanq"
      },
      theme: {
        primary_color_hex: "#d4f3fb"
      }
    }]
  }]
};
Sy.default = BN;
var Ty = {};
Object.defineProperty(Ty, "__esModule", { value: !0 });
const FN = {
  $schema: "../chain.schema.json",
  chain_name: "meme",
  status: "live",
  network_type: "mainnet",
  pretty_name: "MEME",
  chain_type: "cosmos",
  chain_id: "meme-1",
  bech32_prefix: "meme",
  daemon_name: "memed",
  node_home: "$HOME/.memed",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "umeme",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.035,
      high_gas_price: 0.045
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "umeme"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc-meme-1.meme.sx/",
        provider: "MEME Foundation"
      },
      {
        address: "https://meme-rpc.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-meme.pupmos.network/",
        provider: "PUPMØS"
      },
      {
        address: "https://meme.rpc.m.anode.team",
        provider: "ANODE TEAM"
      }
    ],
    rest: [
      {
        address: "https://api-meme-1.meme.sx/",
        provider: "MEME Foundation"
      },
      {
        address: "https://meme-api.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://api-meme.pupmos.network/",
        provider: "PUPMØS"
      },
      {
        address: "https://meme.api.m.anode.team",
        provider: "ANODE TEAM"
      },
      {
        address: "https://meme.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      }
    ],
    grpc: [{
      address: "meme-grpc.polkachu.com:14790",
      provider: "Polkachu"
    }]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/meme",
      tx_page: "https://ping.pub/meme/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/meme",
      tx_page: "https://atomscan.com/meme/transactions/${txHash}",
      account_page: "https://atomscan.com/meme/accounts/${accountAddress}"
    },
    {
      kind: "MEME Explorer",
      url: "https://explorer.meme.sx/meme",
      tx_page: "https://explorer.meme.sx/meme/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/meme",
      tx_page: "https://atomscan.com/meme/transactions/${txHash}",
      account_page: "https://atomscan.com/meme/accounts/${accountAddress}"
    },
    {
      kind: "Brochain",
      url: "https://explorer.brocha.in/meme",
      tx_page: "https://explorer.brocha.in/meme/tx/${txHash}"
    },
    {
      kind: "Stake-Take",
      url: "https://explorer.stake-take.com/meme",
      tx_page: "https://explorer.stake-take.com/meme/tx/${txHash}",
      account_page: "https://explorer.stake-take.com/meme/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Meme",
      tx_page: "https://explorer.stavr.tech/Meme/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Meme/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.svg",
    theme: {
      primary_color_hex: "#b7dcd8"
    }
  }]
};
Ty.default = FN;
var Ry = {};
Object.defineProperty(Ry, "__esModule", { value: !0 });
const $N = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "meme",
    client_id: "07-tendermint-0",
    connection_id: "connection-1"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1931",
    connection_id: "connection-1502"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-238",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Ry.default = $N;
var Oy = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(as, "__esModule", { value: !0 });
as.ibc = as.chain = as.assets = void 0;
const zN = Oy(Sy), qN = Oy(Ty), SN = Oy(Ry);
as.assets = zN.default;
as.chain = qN.default;
as.ibc = SN.default;
var os = {}, My = {};
Object.defineProperty(My, "__esModule", { value: !0 });
const TN = {
  $schema: "../assetlist.schema.json",
  chain_name: "microtick",
  assets: [{
    description: "TICK coin is the token for the Microtick Price Discovery & Oracle App",
    denom_units: [{
      denom: "utick",
      exponent: 0
    }, {
      denom: "tick",
      exponent: 6
    }],
    base: "utick",
    display: "tick",
    name: "Microtick",
    symbol: "TICK",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.svg"
    },
    coingecko_id: "microtick",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.svg",
      theme: {
        primary_color_hex: "#6bab14"
      }
    }]
  }]
};
My.default = TN;
var Iy = {};
Object.defineProperty(Iy, "__esModule", { value: !0 });
const RN = {
  $schema: "../chain.schema.json",
  chain_name: "microtick",
  status: "killed",
  network_type: "mainnet",
  pretty_name: "Microtick",
  chain_type: "cosmos",
  chain_id: "microtick-1",
  bech32_prefix: "micro",
  daemon_name: "mtm",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utick",
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "utick"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.svg"
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://ping.pub/microtick",
    tx_page: "https://ping.pub/microtick/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.svg",
    theme: {
      primary_color_hex: "#6bab14"
    }
  }]
};
Iy.default = RN;
var Ny = {};
Object.defineProperty(Ny, "__esModule", { value: !0 });
const ON = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "microtick",
    client_id: "07-tendermint-99",
    connection_id: "connection-92"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1453",
    connection_id: "connection-1139"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-16",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-39",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Ny.default = ON;
var Py = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(os, "__esModule", { value: !0 });
os.ibc = os.chain = os.assets = void 0;
const MN = Py(My), IN = Py(Iy), NN = Py(Ny);
os.assets = MN.default;
os.chain = IN.default;
os.ibc = NN.default;
var rs = {}, Uy = {};
Object.defineProperty(Uy, "__esModule", { value: !0 });
const PN = {
  $schema: "../assetlist.schema.json",
  chain_name: "migaloo",
  assets: [
    {
      description: "Migaloo is a cosmwasm-powered, permissionless blockchain designed to build decentralized applications with a focus on interchain liquidity solutions.",
      extended_description: "Migaloo originated as part of the Terra ecosystem but has since transitioned to the Cosmos ecosystem, focusing on creating a decentralized platform that balances and distributes liquidity across various zones. Key features include its permissionless nature and the Alliance module, which facilitates cross-chain staking and enhances blockchain security. Migaloo's flagship application is the White Whale Protocol, an interchain liquidity protocol that uses trading and flash loans to generate yield for stakers. The platform emphasizes interoperability, scalability, and community engagement, aiming to be a pivotal player in the Cosmos ecosystem.",
      denom_units: [{
        denom: "uwhale",
        exponent: 0
      }, {
        denom: "whale",
        exponent: 6
      }],
      base: "uwhale",
      name: "Whale",
      display: "whale",
      symbol: "WHALE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.svg"
      },
      coingecko_id: "white-whale",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.svg",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }]
    },
    {
      description: "ampWHALE",
      denom_units: [{
        denom: "factory/migaloo1436kxs0w2es6xlqpp9rd35e3d0cjnw4sv8j3a7483sgks29jqwgshqdky4/ampWHALE",
        exponent: 0
      }, {
        denom: "ampWHALE",
        exponent: 6
      }],
      base: "factory/migaloo1436kxs0w2es6xlqpp9rd35e3d0cjnw4sv8j3a7483sgks29jqwgshqdky4/ampWHALE",
      name: "ampWHALE",
      display: "ampWHALE",
      symbol: "ampWHALE",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ampwhale.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ampwhale.svg"
      }]
    },
    {
      description: "BackBone Labs Liquid Staked WHALE",
      denom_units: [{
        denom: "factory/migaloo1mf6ptkssddfmxvhdx0ech0k03ktp6kf9yk59renau2gvht3nq2gqdhts4u/boneWhale",
        exponent: 0
      }, {
        denom: "bWHALE",
        exponent: 6
      }],
      base: "factory/migaloo1mf6ptkssddfmxvhdx0ech0k03ktp6kf9yk59renau2gvht3nq2gqdhts4u/boneWhale",
      name: "BackBone Labs Liquid Staked WHALE",
      display: "bWHALE",
      symbol: "bWHALE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/bWHALE.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/bWHALE.png",
        theme: {
          primary_color_hex: "#d8d8d8"
        }
      }],
      coingecko_id: "backbone-labs-staked-whale"
    },
    {
      description: "FABLE",
      denom_units: [{
        denom: "factory/migaloo18a9m9stu3dyvewwcq9qmp85euxqcvln5mefync/fable",
        exponent: 0
      }, {
        denom: "fable",
        exponent: 6
      }],
      base: "factory/migaloo18a9m9stu3dyvewwcq9qmp85euxqcvln5mefync/fable",
      name: "FABLE",
      display: "fable",
      symbol: "FABLE",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/fable.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/fable.svg"
      }]
    },
    {
      description: "boneLUNA are autocompounding LUNA tokens",
      denom_units: [{
        denom: "ibc/40C29143BF4153B365089E40E437B7AA819672646C45BB0A5F1E10915A0B6708",
        exponent: 0
      }, {
        denom: "bluna",
        exponent: 6
      }],
      base: "ibc/40C29143BF4153B365089E40E437B7AA819672646C45BB0A5F1E10915A0B6708",
      address: "cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml",
      type_asset: "ics20",
      name: "boneLuna",
      display: "bluna",
      symbol: "bLUNA",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra2",
          base_denom: "cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml",
          port: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
          channel_id: "channel-87"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-2",
          path: "transfer/channel-2/cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bLUNA.png"
      },
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bLUNA.png",
        theme: {
          primary_color_hex: "#070707"
        }
      }]
    },
    {
      description: "RAC",
      denom_units: [{
        denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/urac",
        exponent: 0
      }, {
        denom: "RAC",
        exponent: 6
      }],
      base: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/urac",
      name: "Racoon",
      display: "RAC",
      symbol: "RAC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rac.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rac.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rac.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rac.svg",
        theme: {
          primary_color_hex: "#2b2434"
        }
      }]
    },
    {
      description: "ASH",
      denom_units: [{
        denom: "factory/migaloo1erul6xyq0gk6ws98ncj7lnq9l4jn4gnnu9we73gdz78yyl2lr7qqrvcgup/ash",
        exponent: 0
      }, {
        denom: "ASH",
        exponent: 6
      }],
      base: "factory/migaloo1erul6xyq0gk6ws98ncj7lnq9l4jn4gnnu9we73gdz78yyl2lr7qqrvcgup/ash",
      name: "ASH",
      display: "ASH",
      symbol: "ASH",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ash.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ash.svg"
      }]
    },
    {
      description: "Tether USDt on Migaloo",
      denom_units: [{
        denom: "ibc/86A25A8A327164AE7C68A29B6ED745C7EEDC36E260A6666F33A6407BECEC4737",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/86A25A8A327164AE7C68A29B6ED745C7EEDC36E260A6666F33A6407BECEC4737",
      name: "Tether USDt",
      display: "usdt",
      symbol: "USDt",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt",
          channel_id: "channel-120"
        },
        chain: {
          channel_id: "channel-48",
          path: "transfer/channel-48/erc20/tether/usdt"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    },
    {
      description: "Auto componded USDC despoited into Ginkou on Migaloo chain",
      denom_units: [{
        denom: "cw20:migaloo10nucfm2zqgzqmy7y7ls398t58pjt9cwjsvpy88y2nvamtl34rgmqt5em2v",
        exponent: 0
      }, {
        denom: "mUSDC",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "migaloo10nucfm2zqgzqmy7y7ls398t58pjt9cwjsvpy88y2nvamtl34rgmqt5em2v",
      base: "cw20:migaloo10nucfm2zqgzqmy7y7ls398t58pjt9cwjsvpy88y2nvamtl34rgmqt5em2v",
      name: "mUSDC",
      display: "mUSDC",
      symbol: "mUSDC",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/mUSDC.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/mUSDC.svg"
      }]
    },
    {
      description: "GUPPY",
      denom_units: [{
        denom: "factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy",
        exponent: 0
      }, {
        denom: "GUPPY",
        exponent: 6
      }],
      base: "factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy",
      name: "GUPPY",
      display: "GUPPY",
      symbol: "GUPPY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/guppy.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/guppy.png",
        theme: {
          primary_color_hex: "#d9966e"
        }
      }]
    },
    {
      description: "OPHIR is a Cosmos Treasury DAO established on Migaloo.",
      denom_units: [{
        denom: "factory/migaloo1t862qdu9mj5hr3j727247acypym3ej47axu22rrapm4tqlcpuseqltxwq5/ophir",
        exponent: 0
      }, {
        denom: "OPHIR",
        exponent: 6
      }],
      base: "factory/migaloo1t862qdu9mj5hr3j727247acypym3ej47axu22rrapm4tqlcpuseqltxwq5/ophir",
      name: "OPHIR",
      display: "OPHIR",
      symbol: "OPHIR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ophir.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ophir.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "SHARK is the apex price prediction market within Cosmos.",
      denom_units: [{
        denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/shark",
        exponent: 0
      }, {
        denom: "SHARK",
        exponent: 6
      }],
      base: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/shark",
      name: "SHARK",
      display: "SHARK",
      symbol: "SHARK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/shark.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/shark.png",
        theme: {
          primary_color_hex: "#062d54"
        }
      }]
    },
    {
      description: "lsdSHARK is the liquid staking derivative of SHARK.",
      denom_units: [{
        denom: "factory/migaloo1p3aj9f09d7c4jxhgue0hpdpw370j6gzc59nxxx6l8d0gc9f9rfwsdwetus/lsdSHARK",
        exponent: 0
      }, {
        denom: "lsdSHARK",
        exponent: 6
      }],
      base: "factory/migaloo1p3aj9f09d7c4jxhgue0hpdpw370j6gzc59nxxx6l8d0gc9f9rfwsdwetus/lsdSHARK",
      name: "lsdSHARK",
      display: "lsdSHARK",
      symbol: "lsdSHARK",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/shark"
        },
        provider: "Shark Protocol"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/lsdshark.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/lsdshark.png",
        theme: {
          primary_color_hex: "#0d739c"
        }
      }]
    },
    {
      description: "The native staking token of Terra.",
      denom_units: [{
        denom: "ibc/4627AD2524E3E0523047E35BB76CC90E37D9D57ACF14F0FCBCEB2480705F3CB8",
        exponent: 0
      }, {
        denom: "luna",
        exponent: 6
      }],
      base: "ibc/4627AD2524E3E0523047E35BB76CC90E37D9D57ACF14F0FCBCEB2480705F3CB8",
      name: "Luna",
      display: "luna",
      symbol: "LUNA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "terra2",
          base_denom: "uluna",
          channel_id: "channel-86"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/uluna"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg"
      },
      coingecko_id: "terra-luna-2",
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "uluna"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg",
        theme: {
          primary_color_hex: "#f4de6f"
        }
      }],
      socials: {
        website: "https://www.terra.money/",
        twitter: "https://twitter.com/terra_money"
      }
    },
    {
      description: "Rakoff Token",
      denom_units: [{
        denom: "ibc/44C29C91F202E20C8E28DFB1FA89B725C54171CD77B8948836C72E7A97E4A018",
        exponent: 0
      }, {
        denom: "Rakoff",
        exponent: 6
      }],
      base: "ibc/44C29C91F202E20C8E28DFB1FA89B725C54171CD77B8948836C72E7A97E4A018",
      type_asset: "ics20",
      name: "Rakoff",
      display: "Rakoff",
      symbol: "RAKOFF",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra",
          base_denom: "cw20:terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2",
          port: "wasm.terra19pfxzj9580h7rjd6z6sn5x2se76vgrc0etltr79g9z3t82jzp4hq63qguc",
          channel_id: "channel-87"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-114",
          path: "transfer/channel-114/cw20:terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/juris.png"
      },
      images: [{
        image_sync: {
          chain_name: "terra",
          base_denom: "cw20:terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/juris.png"
      }]
    },
    {
      description: "GASH",
      denom_units: [{
        denom: "factory/migaloo1r9x8fz4alekzr78k42rpmr9unpa7egsldpqeynmwl2nfvzexue9sn8l5rg/gash",
        exponent: 0
      }, {
        denom: "gash",
        exponent: 6
      }],
      base: "factory/migaloo1r9x8fz4alekzr78k42rpmr9unpa7egsldpqeynmwl2nfvzexue9sn8l5rg/gash",
      name: "GASH",
      display: "gash",
      symbol: "GASH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/gash.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/gash.png",
        theme: {
          primary_color_hex: "#1d0918"
        }
      }]
    },
    {
      description: "Restake DAO Token",
      denom_units: [{
        denom: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk",
        exponent: 0
      }, {
        denom: "rstk",
        exponent: 6
      }],
      base: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk",
      name: "RESTAKE",
      display: "rstk",
      symbol: "RSTK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.svg",
        theme: {
          primary_color_hex: "#3ccc64"
        }
      }]
    },
    {
      description: "Frogztrik NFT Token",
      denom_units: [{
        denom: "ibc/B1BD4EF49A2E051EFC85E8C6A932B559CE62F9519E0E83BE29A8F0BDF89BD1D3",
        exponent: 0
      }, {
        denom: "frog",
        exponent: 6
      }],
      base: "ibc/B1BD4EF49A2E051EFC85E8C6A932B559CE62F9519E0E83BE29A8F0BDF89BD1D3",
      type_asset: "ics20",
      name: "Frogztrik NFT Token",
      display: "frog",
      symbol: "FROG",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra",
          base_denom: "cw20:terra1wez9puj43v4s25vrex7cv3ut3w75w4h6j5e537sujyuxj0r5ne2qp9uwl9",
          port: "wasm.terra19pfxzj9580h7rjd6z6sn5x2se76vgrc0etltr79g9z3t82jzp4hq63qguc",
          channel_id: "channel-87"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-114",
          path: "transfer/channel-114/cw20:terra1wez9puj43v4s25vrex7cv3ut3w75w4h6j5e537sujyuxj0r5ne2qp9uwl9"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/FROG.png"
      },
      images: [{
        image_sync: {
          chain_name: "terra",
          base_denom: "cw20:terra1wez9puj43v4s25vrex7cv3ut3w75w4h6j5e537sujyuxj0r5ne2qp9uwl9"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/FROG.png",
        theme: {
          primary_color_hex: "#182615"
        }
      }]
    },
    {
      description: "GRAC is the official token of Racoon.Bet's gaming platform.",
      denom_units: [{
        denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/ugrac",
        exponent: 0
      }, {
        denom: "GRAC",
        exponent: 6
      }],
      base: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/ugrac",
      name: "Gaming RAC Token",
      display: "GRAC",
      symbol: "GRAC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/grac.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/grac.png",
        theme: {
          primary_color_hex: "#f5bf09"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/721B42229246EEDA7A656DB17E494127F91E84AD63E21852737628321892A928",
        exponent: 0,
        aliases: ["factory/juno1h6y8tkceau4d8zyv5aa0fwdj2pa2y0gz2hx0tq/uwind"]
      }, {
        denom: "wind",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/721B42229246EEDA7A656DB17E494127F91E84AD63E21852737628321892A928",
      name: "Wind Token",
      display: "wind",
      symbol: "WIND",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "juno",
          base_denom: "factory/juno1h6y8tkceau4d8zyv5aa0fwdj2pa2y0gz2hx0tq/uwind",
          channel_id: "channel-210"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/factory/juno1h6y8tkceau4d8zyv5aa0fwdj2pa2y0gz2hx0tq/uwind"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "factory/juno1h6y8tkceau4d8zyv5aa0fwdj2pa2y0gz2hx0tq/uwind"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wind.png",
        theme: {
          primary_color_hex: "#122b4d"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wind.png"
      }
    },
    {
      denom_units: [{
        denom: "ibc/0E1B883A15D5FCA533332CBAB1A672934C3936920399F2A3EB4F438E3EBAD0E9",
        exponent: 0,
        aliases: ["factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/shitmos"]
      }, {
        denom: "shitmos",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0E1B883A15D5FCA533332CBAB1A672934C3936920399F2A3EB4F438E3EBAD0E9",
      name: "Shitmos",
      display: "shitmos",
      symbol: "SHITMOS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/shitmos",
          channel_id: "channel-642"
        },
        chain: {
          channel_id: "channel-5",
          path: "transfer/channel-5/factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/shitmos"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/shitmos"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.svg",
        theme: {
          primary_color_hex: "#639BFF",
          circle: !0
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.svg"
      }
    },
    {
      description: "ERIS Liquid Alliance Staked GASH",
      denom_units: [{
        denom: "factory/migaloo1nsskhvvh0msm7d5ke2kfg24a8d4jecsnxd28s27h0uz5kf9ap60shlqmcl/ampGASH",
        exponent: 0
      }, {
        denom: "ampGASH",
        exponent: 6
      }],
      base: "factory/migaloo1nsskhvvh0msm7d5ke2kfg24a8d4jecsnxd28s27h0uz5kf9ap60shlqmcl/ampGASH",
      name: "ampGASH",
      display: "ampGASH",
      symbol: "ampGASH",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ampgash.png",
        theme: {
          primary_color_hex: "#374455"
        }
      }],
      traces: [{
        type: "liquid-stake",
        chain: {
          contract: "migaloo1nsskhvvh0msm7d5ke2kfg24a8d4jecsnxd28s27h0uz5kf9ap60shlqmcl"
        },
        provider: "ERIS Protocol",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1r9x8fz4alekzr78k42rpmr9unpa7egsldpqeynmwl2nfvzexue9sn8l5rg/gash",
          contract: "migaloo1r9x8fz4alekzr78k42rpmr9unpa7egsldpqeynmwl2nfvzexue9sn8l5rg"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/33E97105B5C1F48CB7D6400F4673F9B3699AC59EDB621CCCD57D5D480E0C83B6",
        exponent: 0,
        aliases: ["factory/inj1a6xdezq7a94qwamec6n6cnup02nvewvjtz6h6e/SYN"]
      }, {
        denom: "SYN",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/33E97105B5C1F48CB7D6400F4673F9B3699AC59EDB621CCCD57D5D480E0C83B6",
      name: "SYN",
      display: "SYN",
      symbol: "SYN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "factory/inj1a6xdezq7a94qwamec6n6cnup02nvewvjtz6h6e/SYN",
          channel_id: "channel-102"
        },
        chain: {
          channel_id: "channel-3",
          path: "transfer/channel-3/factory/inj1a6xdezq7a94qwamec6n6cnup02nvewvjtz6h6e/SYN"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "injective",
          base_denom: "factory/inj1a6xdezq7a94qwamec6n6cnup02nvewvjtz6h6e/SYN"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/syn.png",
        theme: {
          primary_color_hex: "#04a2fc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/syn.png"
      }
    }
  ]
};
Uy.default = PN;
var Hy = {};
Object.defineProperty(Hy, "__esModule", { value: !0 });
const UN = {
  $schema: "../chain.schema.json",
  chain_name: "migaloo",
  status: "live",
  network_type: "mainnet",
  website: "https://www.whitewhale.money/",
  pretty_name: "Migaloo",
  chain_type: "cosmos",
  chain_id: "migaloo-1",
  bech32_prefix: "migaloo",
  daemon_name: "migalood",
  node_home: "$HOME/.migalood",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uwhale",
      fixed_min_gas_price: 1,
      low_gas_price: 1,
      average_gas_price: 2,
      high_gas_price: 3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uwhale"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/migaloo-light.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/migaloo-light.svg"
  },
  codebase: {
    cosmos_sdk_version: "v0.47.7",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.45.0"
  },
  apis: {
    rpc: [
      {
        address: "https://migaloo-rpc.polkachu.com:443",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-migaloo.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://migaloo-rpc.kleomedes.network:443",
        provider: "Kleomedes"
      },
      {
        address: "https://rpc.whitewhale.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://migaloo-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://migaloo-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://migaloo-api.polkachu.com:443",
        provider: "Polkachu"
      },
      {
        address: "https://api-migaloo.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://migaloo-api.kleomedes.network:443",
        provider: "Kleomedes"
      },
      {
        address: "https://api.whitewhale.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://migaloo-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://migaloo-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "migaloo-grpc.polkachu.com:20790",
        provider: "Polkachu"
      },
      {
        address: "whitewhale-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-migaloo.cosmos-spaces.cloud:4810",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://grpc.whitewhale.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "migaloo-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    "grpc-web": [{
      address: "https://migaloo-grpc-web.publicnode.com",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }]
  },
  explorers: [
    {
      kind: "Migaloo Explorers Guru",
      url: "https://migaloo.explorers.guru",
      tx_page: "https://migaloo.explorers.guru/transaction/${txHash}",
      account_page: "https://migaloo.explorers.guru/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/migaloo",
      tx_page: "https://ping.pub/migaloo/tx/${txHash}"
    },
    {
      kind: "Silk Nodes",
      url: "https://explorer.silknodes.io/migaloo",
      tx_page: "https://explorer.silknodes.io/migaloo/tx/${txHash}",
      account_page: "https://explorer.silknodes.io/migaloo/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/migaloo",
      tx_page: "https://atomscan.com/migaloo/transactions/${txHash}",
      account_page: "https://atomscan.com/migaloo/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/migaloo-light.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/migaloo-light.svg",
    theme: {
      primary_color_hex: "#3ccc64"
    }
  }]
};
Hy.default = UN;
var Ly = {};
Object.defineProperty(Ly, "__esModule", { value: !0 });
const HN = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-180",
      connection_id: "connection-158"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-101",
      connection_id: "connection-80"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-121",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-53",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-126",
      connection_id: "connection-81"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-21",
      connection_id: "connection-21"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-39",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-139",
      connection_id: "connection-71"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-25",
      connection_id: "connection-24"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-154",
      connection_id: "connection-123"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-5",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-102",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-310",
      connection_id: "connection-282"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-210",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-125",
      connection_id: "connection-162"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-90",
      connection_id: "connection-73"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-120",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-48",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-82",
      connection_id: "connection-59"
    },
    chain_2: {
      chain_name: "migaloo",
      client_id: "07-tendermint-16",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-58",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-113",
      connection_id: "connection-89"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-19",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-60",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-3",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2669",
      connection_id: "connection-2171"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-642",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-6",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-116",
      connection_id: "connection-87"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-103",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-129",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-108",
      connection_id: "connection-84"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-22",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-118",
      connection_id: "connection-90"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-352",
      connection_id: "connection-287"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-69",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-269",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-122",
      connection_id: "connection-92"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-244",
      connection_id: "connection-151"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-114",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-87",
        port_id: "wasm.terra19pfxzj9580h7rjd6z6sn5x2se76vgrc0etltr79g9z3t82jzp4hq63qguc"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-105",
      connection_id: "connection-93"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-86",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-87",
        port_id: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-104",
      connection_id: "connection-83"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-234",
      connection_id: "connection-195"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-56",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-104",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Ly.default = HN;
var Wy = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(rs, "__esModule", { value: !0 });
rs.ibc = rs.chain = rs.assets = void 0;
const LN = Wy(Uy), WN = Wy(Hy), VN = Wy(Ly);
rs.assets = LN.default;
rs.chain = WN.default;
rs.ibc = VN.default;
var pr = {}, Vy = {};
Object.defineProperty(Vy, "__esModule", { value: !0 });
const GN = {
  $schema: "../assetlist.schema.json",
  chain_name: "mises",
  assets: [{
    description: "The native staking and gov token of the Mises Network.",
    denom_units: [
      {
        denom: "umis",
        exponent: 0,
        aliases: ["micromis"]
      },
      {
        denom: "mmis",
        exponent: 3,
        aliases: ["millimis"]
      },
      {
        denom: "mis",
        exponent: 6
      }
    ],
    base: "umis",
    display: "mis",
    name: "mises network MIS",
    symbol: "MIS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mises/images/mises.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mises/images/mises.png",
      theme: {
        primary_color_hex: "#f5f5f8"
      }
    }]
  }]
};
Vy.default = GN;
var Gy = {};
Object.defineProperty(Gy, "__esModule", { value: !0 });
const KN = {
  $schema: "../chain.schema.json",
  chain_name: "mises",
  status: "live",
  network_type: "mainnet",
  website: "https://mises.site",
  pretty_name: "Mises",
  chain_type: "cosmos",
  chain_id: "mainnet",
  bech32_prefix: "mises",
  node_home: "$HOME/.misestm",
  daemon_name: "misestmd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "umis",
      fixed_min_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "umis"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mises/images/mises.png"
  },
  apis: {
    rpc: [{
      address: "https://rpc.gw.mises.site:443",
      provider: "Mises-1"
    }, {
      address: "https://e2.mises.site:443",
      provider: "Mises-3"
    }],
    rest: [],
    grpc: []
  },
  explorers: [{
    kind: "Mises-GW Explorer",
    url: "https://gw.mises.site",
    tx_page: "https://gw.mises.site/tx/${txHash}"
  }, {
    kind: "Jambulmerah ping.pub based",
    url: "https://explorer.jambulmerah.dev/mises",
    tx_page: "https://explorer.jambulmerah.dev/mises/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mises/images/mises.png",
    theme: {
      primary_color_hex: "#f5f5f8"
    }
  }]
};
Gy.default = KN;
var M9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(pr, "__esModule", { value: !0 });
pr.chain = pr.assets = void 0;
const XN = M9(Vy), YN = M9(Gy);
pr.assets = XN.default;
pr.chain = YN.default;
var lr = {}, Ky = {};
Object.defineProperty(Ky, "__esModule", { value: !0 });
const JN = {
  $schema: "../assetlist.schema.json",
  chain_name: "mtgbp",
  assets: [{
    description: "MTGBP the stablecoin of the future.",
    extended_description: `MTGBP is known as the stablecoin of the future. This stablecoin is based on the British pound, which means its value stays the same as the pound.

MTGBP aims to connect traditional money with digital money, giving people a stable and trustworthy digital currency. This stablecoin combines the stability of the British pound with the speed and efficiency of blockchain technology.

MTGBP makes it easy to do financial transactions without the ups and downs that other cryptocurrencies have. With MTGBP, you can send money, trade, and invest knowing that its value will stay steady. This makes it useful for everyday use and for long-term financial plans.

In short, MTGBP offers the stability of the British pound and the benefits of cryptocurrency, making it a safe and easy option for everyone.

`,
    denom_units: [{
      denom: "mtgbp",
      exponent: 0
    }],
    base: "mtgbp",
    name: "mtgbp",
    display: "mtgbp",
    symbol: "MTGBP",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mtgbp/images/mtgbp.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mtgbp/images/mtgbp.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mtgbp/images/mtgbp.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mtgbp/images/mtgbp.svg",
      theme: {
        primary_color_hex: "#e8692b"
      }
    }],
    socials: {
      website: "https://mtgbp.com/"
    }
  }]
};
Ky.default = JN;
var Xy = {};
Object.defineProperty(Xy, "__esModule", { value: !0 });
const ZN = {
  $schema: "../chain.schema.json",
  chain_name: "mtgbp",
  status: "live",
  network_type: "mainnet",
  website: "https://mtgbp.com/",
  pretty_name: "mtgbp",
  chain_type: "cosmos",
  chain_id: "mtgbp-1",
  bech32_prefix: "mtgbp",
  daemon_name: "mtgbp",
  node_home: "$HOME/.ssc",
  key_algos: ["secp256k1"],
  slip44: 1179993441,
  staking: {
    staking_tokens: [{
      denom: "mtgbp"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  fees: {
    fee_tokens: [{
      denom: "mtgbp",
      low_gas_price: 1e-6,
      average_gas_price: 5e-6,
      high_gas_price: 1e-4
    }]
  },
  apis: {
    rpc: [{
      address: "https://rcp.mtgbp.com",
      provider: "mtgbp"
    }],
    rest: [{
      address: "https://lcd.mtgbp.com",
      provider: "mtgbp"
    }],
    grpc: [{
      address: "https://grcp.mtgbp.com:4090",
      provider: "mtgbp"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mtgbp/images/mtgbp.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mtgbp/images/mtgbp.svg"
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://blockexplorer.mtgbp.com/mtgbp",
    tx_page: "https://blockexplorer.mtgbp.com/mtgbp/tx/${txHash}",
    account_page: "https://blockexplorer.mtgbp.com/mtgbp/accounts/${accountAddress}"
  }],
  keywords: [],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mtgbp/images/mtgbp.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mtgbp/images/mtgbp.svg",
    theme: {
      primary_color_hex: "#e8692b"
    }
  }]
};
Xy.default = ZN;
var I9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(lr, "__esModule", { value: !0 });
lr.chain = lr.assets = void 0;
const QN = I9(Ky), eP = I9(Xy);
lr.assets = QN.default;
lr.chain = eP.default;
var gr = {}, Yy = {};
Object.defineProperty(Yy, "__esModule", { value: !0 });
const nP = {
  $schema: "../assetlist.schema.json",
  chain_name: "mun",
  assets: [{
    description: "The native token of Mun",
    denom_units: [{
      denom: "umun",
      exponent: 0
    }, {
      denom: "mun",
      exponent: 6
    }],
    base: "umun",
    name: "Mun",
    display: "mun",
    symbol: "MUN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mun/images/mun.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mun/images/mun.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mun/images/mun.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mun/images/mun.svg",
      theme: {
        primary_color_hex: "#f6ba32"
      }
    }]
  }]
};
Yy.default = nP;
var Jy = {};
Object.defineProperty(Jy, "__esModule", { value: !0 });
const tP = {
  $schema: "../chain.schema.json",
  chain_name: "mun",
  website: "https://mun.money",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Mun",
  chain_type: "cosmos",
  chain_id: "mun-1",
  bech32_prefix: "mun",
  daemon_name: "mund",
  node_home: "$HOME/.mun",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "umun",
      fixed_min_gas_price: 0.025
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "umun"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mun/images/mun.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mun/images/mun.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://mainnet1rpc.mun.money",
        provider: "Mun"
      },
      {
        address: "https://mainnet-mun-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://rpc.mun.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://mun_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://mainnet1.mun.money",
        provider: "Mun"
      },
      {
        address: "https://mainnet-mun-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://rest.mun.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://mun_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: []
  },
  explorers: [
    {
      url: "https://explorer.mun.money/mun",
      tx_page: "https://explorer.mun.money/mun/${txHash}"
    },
    {
      url: "https://explorer.indonode.net/mun/staking",
      tx_page: "https://explorer.indonode.net/mun/${txHash}"
    },
    {
      url: "https://explorer.konsortech.xyz/mun/staking",
      tx_page: "https://explorer.konsortech.xyz/mun/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/mun",
      tx_page: "https://ping.pub/mun/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/mun",
      tx_page: "https://explorer.tcnetwork.io/mun/transaction/${txHash}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/mun",
      tx_page: "https://explorer.whenmoonwhenlambo.money/mun/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/mun/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mun/images/mun.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mun/images/mun.svg",
    theme: {
      primary_color_hex: "#f6ba32"
    }
  }]
};
Jy.default = tP;
var N9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(gr, "__esModule", { value: !0 });
gr.chain = gr.assets = void 0;
const sP = N9(Yy), aP = N9(Jy);
gr.assets = sP.default;
gr.chain = aP.default;
var ur = {}, Zy = {};
Object.defineProperty(Zy, "__esModule", { value: !0 });
const oP = {
  $schema: "../assetlist.schema.json",
  chain_name: "mythos",
  assets: [{
    description: "The native token of Mythos",
    denom_units: [{
      denom: "aMYT",
      exponent: 0
    }, {
      denom: "MYT",
      exponent: 18
    }],
    base: "aMYT",
    name: "MYT",
    display: "MYT",
    symbol: "MYT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mythos/images/mythos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mythos/images/mythos.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mythos/images/mythos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mythos/images/mythos.svg",
      theme: {
        primary_color_hex: "#848484"
      }
    }]
  }]
};
Zy.default = oP;
var Qy = {};
Object.defineProperty(Qy, "__esModule", { value: !0 });
const rP = {
  $schema: "../chain.schema.json",
  chain_name: "mythos",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Mythos",
  chain_type: "cosmos",
  chain_id: "mythos_7001-1",
  bech32_prefix: "mythos",
  daemon_name: "mythosd",
  node_home: "$HOME/.mythosd",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aMYT"
    }]
  },
  apis: {
    rpc: [{
      address: "https://mythos-rpc.provable.dev:443/",
      provider: "laurel.provable"
    }],
    rest: [{
      address: "https://mythos.provable.dev/rest/",
      provider: "laurel.provable"
    }],
    grpc: [{
      address: "mythos-grpc.provable.dev:443",
      provider: "laurel.provable"
    }],
    "evm-http-jsonrpc": []
  },
  explorers: [],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mythos/images/mythos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mythos/images/mythos.svg"
  },
  codebase: {},
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mythos/images/mythos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mythos/images/mythos.svg",
    theme: {
      primary_color_hex: "#848484"
    }
  }]
};
Qy.default = rP;
var P9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ur, "__esModule", { value: !0 });
ur.chain = ur.assets = void 0;
const iP = P9(Zy), cP = P9(Qy);
ur.assets = iP.default;
ur.chain = cP.default;
var _r = {}, eb = {};
Object.defineProperty(eb, "__esModule", { value: !0 });
const dP = {
  $schema: "../assetlist.schema.json",
  chain_name: "neura",
  assets: [{
    description: "ANKR: The native EVM, governance, and staking token for Neura, enabling secure transactions, and seamless GPU resourcing within the ecosystem.",
    denom_units: [{
      denom: "atankr",
      exponent: 0
    }, {
      denom: "ankr",
      exponent: 18
    }],
    base: "atankr",
    name: "Neura",
    display: "ankr",
    symbol: "ANKR",
    traces: [{
      type: "additional-mintage",
      counterparty: {
        chain_name: "ethereum",
        base_denom: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4"
      },
      provider: "Neura"
    }],
    images: [{
      image_sync: {
        chain_name: "ethereum",
        base_denom: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4"
      },
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ankr.svg"
    }],
    coingecko_id: "ankr",
    socials: {
      website: "https://www.ankr.com",
      twitter: "https://x.com/ankr"
    }
  }]
};
eb.default = dP;
var nb = {};
Object.defineProperty(nb, "__esModule", { value: !0 });
const mP = {
  $schema: "../chain.schema.json",
  chain_name: "neura",
  chain_type: "cosmos",
  chain_id: "neura_266-1",
  bech32_prefix: "neura",
  pretty_name: "Neura",
  website: "https://www.neuraprotocol.io/",
  description: "Neura is an AI-centric, EVM-compatible Layer 1 blockchain built on the Cosmos SDK. We democratize GPU access and revolutionize AI project funding with IMO’s to advance AI development.",
  status: "upcoming",
  network_type: "mainnet",
  node_home: "$HOME/.neurad",
  daemon_name: "neurad",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "atankr"
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "atankr"
    }]
  },
  codebase: {},
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neura/images/neura.png",
    theme: {
      primary_color_hex: "#4e5afc"
    }
  }]
};
nb.default = mP;
var U9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(_r, "__esModule", { value: !0 });
_r.chain = _r.assets = void 0;
const hP = U9(eb), pP = U9(nb);
_r.assets = hP.default;
_r.chain = pP.default;
var is = {}, tb = {};
Object.defineProperty(tb, "__esModule", { value: !0 });
const lP = {
  $schema: "../assetlist.schema.json",
  chain_name: "neutaro",
  assets: [{
    description: "The native token of Neutaro",
    denom_units: [{
      denom: "uneutaro",
      exponent: 0
    }, {
      denom: "neutaro",
      exponent: 6
    }],
    base: "uneutaro",
    name: "Neutaro",
    display: "neutaro",
    symbol: "NTMPI",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.svg"
    },
    coingecko_id: "neutaro",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.svg",
      theme: {
        primary_color_hex: "#cbfb06"
      }
    }]
  }]
};
tb.default = lP;
var sb = {};
Object.defineProperty(sb, "__esModule", { value: !0 });
const gP = {
  $schema: "../chain.schema.json",
  chain_name: "neutaro",
  status: "live",
  network_type: "mainnet",
  website: "https://neutaro.com/",
  pretty_name: "Neutaro",
  chain_type: "cosmos",
  chain_id: "Neutaro-1",
  bech32_prefix: "neutaro",
  daemon_name: "neutaro",
  node_home: "$HOME/.Neutaro",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uneutaro",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0.035
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uneutaro"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.svg"
  },
  description: "The Blockchain that is Pioneering Ethical Standards, Values, and Transparency in cross chain Blockchain Technology to drive innovation",
  apis: {
    rpc: [{
      address: "https://rpc2.neutaro.tech:443",
      provider: "Neutaro"
    }, {
      address: "https://rpc3.neutaro.tech:26657",
      provider: "Neutaro"
    }],
    rest: [{
      address: "https://api2.neutaro.tech:443",
      provider: "Neutaro"
    }],
    grpc: [{
      address: "https://grpc2.neutaro.tech:443",
      provider: "Neutaro"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://explorer.neutaro.tech/Neutaro",
    tx_page: "https://explorer.neutaro.tech/Neutaro/tx/${txHash}",
    account_page: "https://explorer.neutaro.tech/Neutaro/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.svg",
    theme: {
      primary_color_hex: "#cbfb06"
    }
  }]
};
sb.default = gP;
var ab = {};
Object.defineProperty(ab, "__esModule", { value: !0 });
const uP = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "neutaro",
    client_id: "07-tendermint-3",
    connection_id: "connection-9"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3226",
    connection_id: "connection-2703"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-4",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-79092",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
ab.default = uP;
var ob = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(is, "__esModule", { value: !0 });
is.ibc = is.chain = is.assets = void 0;
const _P = ob(tb), yP = ob(sb), bP = ob(ab);
is.assets = _P.default;
is.chain = yP.default;
is.ibc = bP.default;
var cs = {}, rb = {};
Object.defineProperty(rb, "__esModule", { value: !0 });
const vP = {
  $schema: "../assetlist.schema.json",
  chain_name: "neutron",
  assets: [
    {
      description: "Neutron is a smart contract blockchain within the Cosmos ecosystem, leveraging the Cosmos Hub's security to provide cross-chain DeFi applications.",
      extended_description: "Neutron is a blockchain network designed to bring smart contracts to the Cosmos ecosystem using CosmWasm. It leverages Interchain Security to rely on the Cosmos Hub's validator set, enhancing its security without needing its own validators. This allows Neutron to provide robust, cross-chain smart contract applications across more than 50 interconnected blockchains. Neutron's focus on interchain queries and transactions enables secure data retrieval and transaction execution across multiple chains, fostering the development of complex and decentralized applications within the Cosmos network.",
      denom_units: [{
        denom: "untrn",
        exponent: 0
      }, {
        denom: "ntrn",
        exponent: 6
      }],
      base: "untrn",
      name: "Neutron",
      display: "ntrn",
      symbol: "NTRN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.svg"
      },
      coingecko_id: "neutron-3",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.svg",
        theme: {
          primary_color_hex: "#040404",
          background_color_hex: "#000000",
          circle: !0
        }
      }],
      socials: {
        website: "https://neutron.org/",
        twitter: "https://twitter.com/Neutron_org"
      }
    },
    {
      description: "IBC uatom through cosmoshub-4 transfer/channel-1",
      denom_units: [{
        denom: "ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9",
        exponent: 0,
        aliases: ["uatom"]
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9",
      name: "IBC atom",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-569"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      }
    },
    {
      description: "IBC Axelar uusdc through axelar-dojo-1 transfer/channel-2",
      denom_units: [{
        denom: "ibc/F082B65C88E4B6D5EF1DB243CDA1D331D002759E938A0F5CD3FFDC5D53B3E349",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "axlusdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F082B65C88E4B6D5EF1DB243CDA1D331D002759E938A0F5CD3FFDC5D53B3E349",
      name: "USD Coin (Axelar)",
      display: "axlusdc",
      symbol: "axlUSDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "uusdc",
          channel_id: "channel-78"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "axelar",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
        theme: {
          primary_color_hex: "#2474cc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg"
      }
    },
    {
      description: "Tia on Neutron",
      denom_units: [{
        denom: "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
        exponent: 0,
        aliases: ["utia"]
      }, {
        denom: "tia",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
      name: "Celestia TIA",
      display: "tia",
      symbol: "TIA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "celestia",
          base_denom: "utia",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-35",
          path: "transfer/channel-35/utia"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "celestia",
          base_denom: "utia"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg",
        theme: {
          primary_color_hex: "#7c2cfb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg"
      }
    },
    {
      description: "Astropepe meme coin",
      denom_units: [{
        denom: "factory/neutron14henrqx9y328fjrdvz6l6d92r0t7g5hk86q5nd/uastropepe",
        exponent: 0
      }, {
        denom: "ASTROPEPE",
        exponent: 6
      }],
      base: "factory/neutron14henrqx9y328fjrdvz6l6d92r0t7g5hk86q5nd/uastropepe",
      name: "AstroPepe",
      display: "ASTROPEPE",
      symbol: "ASTROPEPE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astropepe.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astropepe.png",
        theme: {
          primary_color_hex: "#47391d"
        }
      }]
    },
    {
      description: "wstETH on Neutron",
      denom_units: [{
        denom: "factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH",
        exponent: 0
      }, {
        denom: "wstETH",
        exponent: 18
      }],
      base: "factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH",
      name: "wstETH",
      display: "wstETH",
      symbol: "wstETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0"
        },
        provider: "Lido wstETH Cosmos Bridge"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }
    },
    {
      description: "NBTC on Neutron",
      denom_units: [{
        denom: "ibc/DDC3C60EE82BF544F1A0C6A983FF500EF1C14DE20071A5E1E7C0FB470E36E920",
        exponent: 0,
        aliases: ["usat"]
      }, {
        denom: "sat",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/DDC3C60EE82BF544F1A0C6A983FF500EF1C14DE20071A5E1E7C0FB470E36E920",
      name: "Nomic NBTC",
      display: "sat",
      symbol: "SAT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nomic",
          base_denom: "usat",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-42",
          path: "transfer/channel-42/usat"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "nomic",
          base_denom: "usat"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg",
        theme: {
          primary_color_hex: "#8436e6"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg"
      }
    },
    {
      description: "DYDX on Neutron",
      denom_units: [{
        denom: "ibc/2CB87BCE0937B1D1DFCEE79BE4501AAF3C265E923509AEAC410AD85D27F35130",
        exponent: 0,
        aliases: ["adydx"]
      }, {
        denom: "dydx",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/2CB87BCE0937B1D1DFCEE79BE4501AAF3C265E923509AEAC410AD85D27F35130",
      name: "DYDX",
      display: "dydx",
      symbol: "DYDX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "dydx",
          base_denom: "adydx",
          channel_id: "channel-11"
        },
        chain: {
          channel_id: "channel-48",
          path: "transfer/channel-48/adydx"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "dydx",
          base_denom: "adydx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
        theme: {
          primary_color_hex: "#21212f"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg"
      }
    },
    {
      description: "The cutest NEWT token on Neutron chain.",
      denom_units: [{
        denom: "factory/neutron1p8d89wvxyjcnawmgw72klknr3lg9gwwl6ypxda/newt",
        exponent: 0,
        aliases: ["unewt"]
      }, {
        denom: "newt",
        exponent: 6
      }],
      base: "factory/neutron1p8d89wvxyjcnawmgw72klknr3lg9gwwl6ypxda/newt",
      name: "Newt",
      display: "newt",
      symbol: "NEWT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/newt.png"
      },
      coingecko_id: "newt",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/newt.png",
        theme: {
          primary_color_hex: "#16233d"
        }
      }]
    },
    {
      description: "Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.",
      denom_units: [{
        denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro",
        exponent: 0,
        aliases: ["uastro"]
      }, {
        denom: "astro",
        exponent: 6
      }],
      base: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro",
      name: "Astroport token",
      display: "astro",
      symbol: "ASTRO",
      coingecko_id: "astroport-fi",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg",
        theme: {
          primary_color_hex: "#4056e9"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg"
      },
      socials: {
        website: "https://astroport.fi/",
        twitter: "https://twitter.com/astroport_fi"
      }
    },
    {
      description: "Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.",
      denom_units: [{
        denom: "factory/neutron1zlf3hutsa4qnmue53lz2tfxrutp8y2e3rj4nkghg3rupgl4mqy8s5jgxsn/xASTRO",
        exponent: 0,
        aliases: ["uxastro"]
      }, {
        denom: "xASTRO",
        exponent: 6
      }],
      base: "factory/neutron1zlf3hutsa4qnmue53lz2tfxrutp8y2e3rj4nkghg3rupgl4mqy8s5jgxsn/xASTRO",
      name: "Staked Astroport Token",
      display: "xASTRO",
      symbol: "xASTRO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        provider: "Astroport"
      }],
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/xAstro.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/xAstro.svg"
      },
      socials: {
        website: "https://astroport.fi/",
        twitter: "https://twitter.com/astroport_fi"
      }
    },
    {
      description: "ASTRO.cw20 on Neutron",
      denom_units: [{
        denom: "ibc/5751B8BCDA688FD0A8EC0B292EEF1CDEAB4B766B63EC632778B196D317C40C3A",
        exponent: 0,
        aliases: ["uastro"]
      }, {
        denom: "astro.cw20",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/5751B8BCDA688FD0A8EC0B292EEF1CDEAB4B766B63EC632778B196D317C40C3A",
      name: "Astroport CW20 token",
      display: "astro.cw20",
      symbol: "ASTRO.cw20",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra2",
          base_denom: "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26",
          channel_id: "channel-167",
          port: "wasm.terra1jhfjnm39y3nn9l4520mdn4k5mw23nz0674c4gsvyrcr90z9tqcvst22fce"
        },
        chain: {
          channel_id: "channel-5",
          path: "transfer/channel-5/cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26",
          port: "transfer"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/astro-cw20.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/astro-cw20.svg"
      }
    },
    {
      description: "Baby Corgi is the real doggo of Neutron!",
      denom_units: [{
        denom: "factory/neutron1tklm6cvr2wxg8k65t8gh5ewslnzdfd5fsk0w3f/corgi",
        exponent: 0,
        aliases: ["ucorgi"]
      }, {
        denom: "corgi",
        exponent: 6
      }],
      base: "factory/neutron1tklm6cvr2wxg8k65t8gh5ewslnzdfd5fsk0w3f/corgi",
      name: "Baby Corgi",
      display: "corgi",
      symbol: "CORGI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/babycorgi.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/babycorgi.png",
        theme: {
          primary_color_hex: "#fab442"
        }
      }]
    },
    {
      description: "clownmaxxed store of value",
      denom_units: [{
        denom: "factory/neutron170v88vrtnedesyfytuku257cggxc79rd7lwt7q/ucircus",
        exponent: 0,
        aliases: ["ucircus"]
      }, {
        denom: "circus",
        exponent: 6
      }],
      base: "factory/neutron170v88vrtnedesyfytuku257cggxc79rd7lwt7q/ucircus",
      name: "AtomEconomicZone69JaeKwonInu",
      display: "circus",
      symbol: "CIRCUS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/circus.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/circus.png",
        theme: {
          primary_color_hex: "#242033"
        }
      }]
    },
    {
      description: "Jimmy Neutron Finance",
      denom_units: [{
        denom: "factory/neutron108x7vp9zv22d6wxrs9as8dshd3pd5vsga463yd/JIMMY",
        exponent: 0,
        aliases: ["ujimmy"]
      }, {
        denom: "jimmy",
        exponent: 6
      }],
      base: "factory/neutron108x7vp9zv22d6wxrs9as8dshd3pd5vsga463yd/JIMMY",
      name: "jimmy",
      display: "jimmy",
      symbol: "JIMMY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/jimmy.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/jimmy.png",
        theme: {
          primary_color_hex: "#7d3c20"
        }
      }]
    },
    {
      description: "Baddest coin on Cosmos",
      denom_units: [{
        denom: "factory/neutron143wp6g8paqasnuuey6zyapucknwy9rhnld8hkr/bad",
        exponent: 0,
        aliases: ["ubad"]
      }, {
        denom: "bad",
        exponent: 6
      }],
      base: "factory/neutron143wp6g8paqasnuuey6zyapucknwy9rhnld8hkr/bad",
      name: "Badcoin",
      display: "bad",
      symbol: "BAD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/bad.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/bad.png",
        theme: {
          primary_color_hex: "#211a0d"
        }
      }]
    },
    {
      description: "BITCOSMOS",
      denom_units: [{
        denom: "neutron1fjzg7fmv770hsvahqm0nwnu6grs3rjnd2wa6fvm9unv6vedkzekqpw44qj",
        exponent: 0,
        aliases: ["ubitcosmos"]
      }, {
        denom: "bitcosmos",
        exponent: 6
      }],
      base: "neutron1fjzg7fmv770hsvahqm0nwnu6grs3rjnd2wa6fvm9unv6vedkzekqpw44qj",
      name: "Bitcosmos",
      display: "bitcosmos",
      symbol: "BTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/bitcosmos.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/bitcosmos.png",
        theme: {
          primary_color_hex: "#1b0847"
        }
      }]
    },
    {
      description: "What the Fuck",
      denom_units: [{
        denom: "neutron12h09p8hq5y4xpsmcuxxzsn9juef4f6jvekp8yefc6xnlwm6uumnsdk29wf",
        exponent: 0,
        aliases: ["uwtf"]
      }, {
        denom: "wtf",
        exponent: 6
      }],
      base: "neutron12h09p8hq5y4xpsmcuxxzsn9juef4f6jvekp8yefc6xnlwm6uumnsdk29wf",
      name: "wtf",
      display: "wtf",
      symbol: "WTF",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/WTF.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/WTF.png",
        theme: {
          primary_color_hex: "#dcd5ab"
        }
      }]
    },
    {
      description: "NLS on Neutron",
      denom_units: [{
        denom: "ibc/6C9E6701AC217C0FC7D74B0F7A6265B9B4E3C3CDA6E80AADE5F950A8F52F9972",
        exponent: 0,
        aliases: ["unls"]
      }, {
        denom: "nls",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/6C9E6701AC217C0FC7D74B0F7A6265B9B4E3C3CDA6E80AADE5F950A8F52F9972",
      name: "Nolus NLS",
      display: "nls",
      symbol: "NLS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nolus",
          base_denom: "unls",
          channel_id: "channel-3839"
        },
        chain: {
          channel_id: "channel-44",
          path: "transfer/channel-44/unls"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "nolus",
          base_denom: "unls"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.svg",
        theme: {
          primary_color_hex: "#fc542c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.svg"
      }
    },
    {
      description: "A Mechanical Canine",
      denom_units: [{
        denom: "factory/neutron1t5qrjtyryh8gzt800qr5vylhh2f8cmx4wmz9mc/ugoddard",
        exponent: 0,
        aliases: ["ugoddard"]
      }, {
        denom: "goddard",
        exponent: 6
      }],
      base: "factory/neutron1t5qrjtyryh8gzt800qr5vylhh2f8cmx4wmz9mc/ugoddard",
      name: "Goddard",
      display: "goddard",
      symbol: "GODRD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/goddardntrn.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/goddardntrn.png",
        theme: {
          primary_color_hex: "#516b80"
        }
      }]
    },
    {
      description: "The deflationary utility token of the Apollo DAO project",
      denom_units: [{
        denom: "factory/neutron154gg0wtm2v4h9ur8xg32ep64e8ef0g5twlsgvfeajqwghdryvyqsqhgk8e/APOLLO",
        exponent: 0,
        aliases: ["uapollo"]
      }, {
        denom: "apollo",
        exponent: 6
      }],
      base: "factory/neutron154gg0wtm2v4h9ur8xg32ep64e8ef0g5twlsgvfeajqwghdryvyqsqhgk8e/APOLLO",
      name: "Apollo DAO",
      display: "apollo",
      symbol: "APOLLO",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/apollo.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/apollo.svg"
      }],
      socials: {
        website: "https://apollo.farm/",
        twitter: "https://twitter.com/ApolloDAO"
      }
    },
    {
      description: "NEWTROLL",
      denom_units: [{
        denom: "factory/neutron1ume2n42r5j0660gegrr28fzdze7aqf7r5cd9y6/newtroll",
        exponent: 0,
        aliases: ["unewtroll"]
      }, {
        denom: "newtroll",
        exponent: 6
      }],
      base: "factory/neutron1ume2n42r5j0660gegrr28fzdze7aqf7r5cd9y6/newtroll",
      name: "Newtroll",
      display: "newtroll",
      symbol: "NTRL",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/newtroll.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/newtroll.svg"
      }]
    },
    {
      description: "Retro Game",
      denom_units: [{
        denom: "factory/neutron1t24nc7whl77relnu3taxyg3p66pjyuk82png2y/uretro",
        exponent: 0,
        aliases: ["uretro"]
      }, {
        denom: "retro",
        exponent: 6
      }],
      base: "factory/neutron1t24nc7whl77relnu3taxyg3p66pjyuk82png2y/uretro",
      name: "Retro",
      display: "retro",
      symbol: "RETRO",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/retro.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/retro.svg"
      }]
    },
    {
      description: "THE FIRST NATIVE GODDARD MEMECOIN ON NEUTRON",
      denom_units: [{
        denom: "factory/neutron1yqj9vcc0y73xfxjzegaj4v8q0zefevnlpuh4rj/GODDARD",
        exponent: 0,
        aliases: ["ugoddard"]
      }, {
        denom: "goddard",
        exponent: 6
      }],
      base: "factory/neutron1yqj9vcc0y73xfxjzegaj4v8q0zefevnlpuh4rj/GODDARD",
      name: "Goddard",
      display: "goddard",
      symbol: "GODDARD",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/goddard.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/goddard.svg"
      }]
    },
    {
      description: "The first memecoin on osmosis.",
      denom_units: [{
        denom: "ibc/7DA39F5140741177846FCF3CFAB14450EE7F57B7794E5A94BEF73825D3741958",
        exponent: 0
      }, {
        denom: "WOSMO",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/7DA39F5140741177846FCF3CFAB14450EE7F57B7794E5A94BEF73825D3741958",
      name: "Wosmo",
      display: "WOSMO",
      symbol: "WOSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO",
          channel_id: "channel-874"
        },
        chain: {
          channel_id: "channel-10",
          path: "transfer/channel-10/factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png",
        theme: {
          primary_color_hex: "#edd5ee"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png"
      }
    },
    {
      description: "Astro BOY",
      denom_units: [{
        denom: "neutron1uqvse8fdrd9tam47f2jhy9m6al6xxtqpc83f9pdnz5gdle4swc0spfnctv",
        exponent: 0,
        aliases: ["uboy"]
      }, {
        denom: "boy",
        exponent: 6
      }],
      base: "neutron1uqvse8fdrd9tam47f2jhy9m6al6xxtqpc83f9pdnz5gdle4swc0spfnctv",
      name: "boy",
      display: "boy",
      symbol: "BOY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/boy.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/boy.png",
        theme: {
          primary_color_hex: "#333333"
        }
      }]
    },
    {
      description: "A clan of 11y bad kids crafting chaos on the Cosmos eco. One bad memecoin to rule them all  $BADKID. Airdropped to Badkids NFT holders and $STARS stakers. It's so bad, your wallet's throwing a tantrum for it.",
      denom_units: [{
        denom: "ibc/9F8417FBA11E5E01F7F85DDD48C400EB746E95084C11706041663845B4A700A8",
        exponent: 0
      }, {
        denom: "BADKID",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9F8417FBA11E5E01F7F85DDD48C400EB746E95084C11706041663845B4A700A8",
      name: "Badkid",
      display: "BADKID",
      symbol: "BADKID",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo10n8rv8npx870l69248hnp6djy6pll2yuzzn9x8/BADKID",
          channel_id: "channel-874"
        },
        chain: {
          channel_id: "channel-10",
          path: "transfer/channel-10/factory/osmo10n8rv8npx870l69248hnp6djy6pll2yuzzn9x8/BADKID"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo10n8rv8npx870l69248hnp6djy6pll2yuzzn9x8/BADKID"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/badkid.png",
        theme: {
          primary_color_hex: "#57443f"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/badkid.png"
      }
    },
    {
      description: "Reflections of cartel activity on Cosmos.",
      denom_units: [{
        denom: "factory/neutron1w0pz4mjw7n96kkragj8etgfgakg5vw9lzg77wq/cartel",
        exponent: 0,
        aliases: ["ucartel"]
      }, {
        denom: "cartel",
        exponent: 6
      }],
      base: "factory/neutron1w0pz4mjw7n96kkragj8etgfgakg5vw9lzg77wq/cartel",
      name: "cartel",
      display: "cartel",
      symbol: "CARTEL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/cartel.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/cartel.png",
        theme: {
          primary_color_hex: "#8c9098"
        }
      }]
    },
    {
      description: "$ATOM to $1,000 LFG!!",
      denom_units: [{
        denom: "factory/neutron13lkh47msw28yynspc5rnmty3yktk43wc3dsv0l/ATOM1KLFG",
        exponent: 0,
        aliases: ["uatom1klfg"]
      }, {
        denom: "ATOM1KLFG",
        exponent: 6
      }],
      base: "factory/neutron13lkh47msw28yynspc5rnmty3yktk43wc3dsv0l/ATOM1KLFG",
      name: "ATOM1KLFG",
      display: "ATOM1KLFG",
      symbol: "ATOM1KLFG",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ATOM1KLFGc.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ATOM1KLFGc.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      type_asset: "ics20",
      description: "USD Coin on Neutron",
      denom_units: [{
        denom: "ibc/B559A80D62249C8AA07A380E2A2BEA6E5CA9A6F079C912C3A9E9B494105E4F81",
        exponent: 0,
        aliases: ["uusdc", "microusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      base: "ibc/B559A80D62249C8AA07A380E2A2BEA6E5CA9A6F079C912C3A9E9B494105E4F81",
      name: "USD Coin",
      display: "usdc",
      symbol: "USDC",
      coingecko_id: "usd-coin",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      traces: [{
        type: "ibc",
        counterparty: {
          channel_id: "channel-18",
          base_denom: "uusdc",
          chain_name: "noble"
        },
        chain: {
          channel_id: "channel-30",
          path: "transfer/channel-30/uusdc"
        }
      }]
    },
    {
      description: "WEIRD FRIENDS token",
      denom_units: [{
        denom: "factory/neutron133xakkrfksq39wxy575unve2nyehg5npx75nph/WEIRD",
        exponent: 0,
        aliases: ["uWEIRD"]
      }, {
        denom: "WEIRD",
        exponent: 6
      }],
      base: "factory/neutron133xakkrfksq39wxy575unve2nyehg5npx75nph/WEIRD",
      name: "WEIRD",
      display: "WEIRD",
      symbol: "WEIRD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/WEIRD.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/WEIRD.png",
        theme: {
          primary_color_hex: "#ebf0f4"
        }
      }]
    },
    {
      denom_units: [{
        denom: "factory/neutron19tynwawkm2rgefqxy7weupu4hdamyhg890zep2/TAKUMI",
        exponent: 0,
        aliases: ["utakumi"]
      }, {
        denom: "takumi",
        exponent: 6
      }],
      base: "factory/neutron19tynwawkm2rgefqxy7weupu4hdamyhg890zep2/TAKUMI",
      name: "Takumi Asano",
      display: "takumi",
      symbol: "TAKUMI",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/TAKUMI.png",
        theme: {
          primary_color_hex: "#556867"
        }
      }]
    },
    {
      name: "Ninja Blaze Token",
      description: "Ninja Blaze Token",
      denom_units: [{
        denom: "factory/neutron1a6ydq8urdj0gkvjw9e9e5y9r5ce2qegm9m4xufpt96kcm60kmuass0mqq4/nbz",
        exponent: 0,
        aliases: ["uNBZ"]
      }, {
        denom: "NBZ",
        exponent: 6
      }],
      base: "factory/neutron1a6ydq8urdj0gkvjw9e9e5y9r5ce2qegm9m4xufpt96kcm60kmuass0mqq4/nbz",
      display: "NBZ",
      symbol: "NBZ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/NBZ.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/NBZ.png",
        theme: {
          primary_color_hex: "#9890f9"
        }
      }]
    },
    {
      description: "Mars Protocol is a cross-collateralized Money Market Protocol on Neutron and Osmosis.",
      extended_description: "Lend, borrow and earn with an autonomous credit protocol in the Cosmos universe. Open to all, closed to none.",
      denom_units: [{
        denom: "factory/neutron1ndu2wvkrxtane8se2tr48gv7nsm46y5gcqjhux/MARS",
        exponent: 0,
        aliases: ["umars"]
      }, {
        denom: "MARS",
        exponent: 6
      }],
      base: "factory/neutron1ndu2wvkrxtane8se2tr48gv7nsm46y5gcqjhux/MARS",
      name: "Mars Protocol token",
      display: "MARS",
      symbol: "MARS",
      coingecko_id: "mars-protocol-a7fcbcfb-fd61-4017-92f0-7ee9f9cc6da3",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.svg",
        theme: {
          primary_color_hex: "#ef4136"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.svg"
      },
      socials: {
        website: "https://marsprotocol.io/",
        twitter: "https://x.com/mars_protocol"
      }
    },
    {
      description: "Drop staked ATOM",
      extended_description: "Drop protocol token for the interchain liquidity",
      denom_units: [{
        denom: "factory/neutron1k6hr0f83e7un2wjf29cspk7j69jrnskk65k3ek2nj9dztrlzpj6q00rtsa/udatom",
        exponent: 0
      }, {
        denom: "dATOM",
        exponent: 6
      }],
      base: "factory/neutron1k6hr0f83e7un2wjf29cspk7j69jrnskk65k3ek2nj9dztrlzpj6q00rtsa/udatom",
      name: "dATOM",
      display: "dATOM",
      symbol: "dATOM",
      coingecko_id: "drop-staked-atom",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        provider: "Drop Protocol"
      }],
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/dATOM.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/dATOM.svg"
      },
      socials: {
        website: "https://www.drop.money/",
        twitter: "https://x.com/Dropdotmoney"
      }
    },
    {
      description: "SinGarden token",
      denom_units: [{
        denom: "factory/neutron133xakkrfksq39wxy575unve2nyehg5npx75nph/sin",
        exponent: 0,
        aliases: ["uSIN"]
      }, {
        denom: "SIN",
        exponent: 6
      }],
      base: "factory/neutron133xakkrfksq39wxy575unve2nyehg5npx75nph/sin",
      name: "SIN",
      display: "SIN",
      symbol: "SIN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/sin.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/sin.png",
        theme: {
          primary_color_hex: "#ebf0f4"
        }
      }]
    }
  ]
};
rb.default = vP;
var ib = {};
Object.defineProperty(ib, "__esModule", { value: !0 });
const fP = {
  $schema: "../chain.schema.json",
  chain_name: "neutron",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Neutron",
  chain_type: "cosmos",
  chain_id: "neutron-1",
  bech32_prefix: "neutron",
  website: "https://neutron.org/",
  daemon_name: "neutrond",
  node_home: "$HOME/.neutrond",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [
      {
        denom: "untrn",
        low_gas_price: 53e-4,
        average_gas_price: 53e-4,
        high_gas_price: 53e-4
      },
      {
        denom: "ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9",
        low_gas_price: 8e-4,
        average_gas_price: 8e-4,
        high_gas_price: 8e-4
      },
      {
        denom: "ibc/F082B65C88E4B6D5EF1DB243CDA1D331D002759E938A0F5CD3FFDC5D53B3E349",
        low_gas_price: 8e-3,
        average_gas_price: 8e-3,
        high_gas_price: 8e-3
      },
      {
        denom: "factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH",
        low_gas_price: 29032316597e-4,
        average_gas_price: 29032316597e-4,
        high_gas_price: 29032316597e-4
      },
      {
        denom: "ibc/2CB87BCE0937B1D1DFCEE79BE4501AAF3C265E923509AEAC410AD85D27F35130",
        low_gas_price: 25641025641026e-4,
        average_gas_price: 25641025641026e-4,
        high_gas_price: 25641025641026e-4
      },
      {
        denom: "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
        low_gas_price: 4e-4,
        average_gas_price: 4e-4,
        high_gas_price: 4e-4
      }
    ]
  },
  staking: {
    staking_tokens: [{
      denom: "untrn"
    }]
  },
  codebase: {
    cosmos_sdk_version: "neutron-org/cosmos-sdk v0.50.7-neutron",
    cosmwasm_enabled: !0,
    cosmwasm_version: "neutron-org/wasmd v0.51.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/neutron-raw.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/neutron-raw.svg"
  },
  description: "The most secure CosmWasm platform in Cosmos, Neutron lets smart-contracts leverage bleeding-edge Interchain technology with minimal overhead.",
  apis: {
    rpc: [
      {
        address: "https://rpc.novel.remedy.tm.p2p.org",
        provider: "P2P"
      },
      {
        address: "https://rpc.lavenderfive.com:443/neutron",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-neutron.whispernode.com",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://rpc-neutron.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "http://rpc.neutron.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://neutron-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://community.nuxian-node.ch:6797/neutron/trpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://rpc.neutron.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://rpc.neutron.quokkastake.io",
        provider: "🐹 Quokka Stake"
      },
      {
        address: "https://neutron.drpc.org",
        provider: "dRPC"
      }
    ],
    rest: [
      {
        address: "https://api.novel.remedy.tm.p2p.org",
        provider: "P2P"
      },
      {
        address: "https://rest.lavenderfive.com:443/neutron",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://lcd-neutron.whispernode.com",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://api-neutron.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "http://api.neutron.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://neutron-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://community.nuxian-node.ch:6797/neutron/crpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://lcd.neutron.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://api.neutron.quokkastake.io",
        provider: "🐹 Quokka Stake"
      }
    ],
    grpc: [
      {
        address: "grpc-kralum.neutron-1.neutron.org:80",
        provider: "Neutron"
      },
      {
        address: "neutron-grpc-pub.rpc.p2p.world:3001",
        provider: "P2P"
      },
      {
        address: "neutron.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "grpc-neutron.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "grpc-neutron.cosmos-spaces.cloud:3090",
        provider: "Cosmos Spaces"
      },
      {
        address: "grpc.neutron.nodestake.top:9090",
        provider: "NodeStake"
      },
      {
        address: "neutron-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://grpc.neutron.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "rpc.neutron.quokkastake.io:9090",
        provider: "🐹 Quokka Stake"
      }
    ]
  },
  explorers: [
    {
      kind: "Mintscan",
      url: "https://www.mintscan.io/neutron",
      tx_page: "https://www.mintscan.io/neutron/transactions/${txHash}",
      account_page: "https://www.mintscan.io/neutron/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/neutron",
      tx_page: "https://ezstaking.app/neutron/txs/${txHash}",
      account_page: "https://ezstaking.app/neutron/account/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/neutron",
      tx_page: "https://mainnet.whispernode.com/neutron/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/neutron/account/${accountAddress}"
    }
  ],
  images: [
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/neutron-raw.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/neutron-raw.svg",
      theme: {
        primary_color_hex: "#000000",
        background_color_hex: "#00000000",
        circle: !1
      }
    },
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.svg",
      theme: {
        primary_color_hex: "#040404",
        background_color_hex: "#000000",
        circle: !0
      }
    },
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/neutron-black-logo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/neutron-black-logo.svg"
    }
  ]
};
ib.default = fP;
var cb = {};
Object.defineProperty(cb, "__esModule", { value: !0 });
const wP = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-51",
      connection_id: "connection-58"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-62",
      connection_id: "connection-43"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-123",
      connection_id: "connection-110"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-78",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-29",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-48",
      connection_id: "connection-36"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-35",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-191",
      connection_id: "connection-127"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-74",
      connection_id: "connection-53"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-76",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-77",
        port_id: "wasm.chihuahua1jwkag4yvhyj9fuddtkygvavya8hmdjuzmgxwg9vp3lw9twv6lrcq9mgl52"
      },
      chain_2: {
        channel_id: "channel-52",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-66",
      connection_id: "connection-28"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-29",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1119",
      connection_id: "connection-809"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-569",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-11",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-72",
      connection_id: "connection-51"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-48",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-16",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-82",
      connection_id: "connection-61"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-675",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-233",
      connection_id: "connection-220"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-78",
      connection_id: "connection-58"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-177",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-60",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-557",
      connection_id: "connection-524"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-97",
      connection_id: "connection-71"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-548",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4328",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-151",
      connection_id: "connection-194"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-54",
      connection_id: "connection-37"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-136",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-112",
      connection_id: "connection-82"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-75",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "mars",
      client_id: "07-tendermint-64",
      connection_id: "connection-50"
    },
    chain_2: {
      chain_name: "neutron",
      client_id: "07-tendermint-21",
      connection_id: "connection-21"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-40",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-25",
      connection_id: "connection-34"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-83",
      connection_id: "connection-62"
    },
    chain_2: {
      chain_name: "nois",
      client_id: "07-tendermint-20",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-722",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-47",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-1559",
        port_id: "wasm.neutron14cwv7d4lwc69zrjrzywwh8c9327m8dpngpq52f5kgqephhgrjc2s9ry3eu"
      },
      chain_2: {
        channel_id: "channel-48",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-71",
      connection_id: "connection-50"
    },
    chain_2: {
      chain_name: "nolus",
      client_id: "07-tendermint-13",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-44",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3839",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-64",
      connection_id: "connection-44"
    },
    chain_2: {
      chain_name: "nomic",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-19",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2823",
      connection_id: "connection-2338"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-874",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-2107",
        port_id: "wasm.neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07"
      },
      chain_2: {
        channel_id: "channel-39589",
        port_id: "wasm.osmo1pfeve3esg5rhhkfhlujxtthc25akcf3zpa3t9whghvvp2v5v92ps0z30r6"
      },
      ordering: "unordered",
      version: "astroport-ibc-v1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-137",
      connection_id: "connection-98"
    },
    chain_2: {
      chain_name: "penumbra",
      client_id: "07-tendermint-9",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4886",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-73",
      connection_id: "connection-52"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-161",
      connection_id: "connection-199"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-136",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-98",
      connection_id: "connection-72"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4329",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-90",
      connection_id: "connection-66"
    },
    chain_2: {
      chain_name: "saga",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2060",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-85",
      connection_id: "connection-63"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-199",
      connection_id: "connection-192"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1551",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-144",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-1950",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-151",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-89",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-123",
      connection_id: "connection-157"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2016",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-66",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-2110",
        port_id: "wasm.neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07"
      },
      chain_2: {
        channel_id: "channel-71",
        port_id: "wasm.sei12fykm2xhg5ces2vmf4q2aem8c958exv3v0wmvrspa8zucrdwjeds2e2ntx"
      },
      ordering: "unordered",
      version: "astroport-ibc-v1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-31",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-283",
      connection_id: "connection-211"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-191",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-18",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-125",
      connection_id: "connection-113"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-123",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-12",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-274",
      connection_id: "connection-192"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-25",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-229",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-5",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-167",
          port_id: "wasm.terra1jhfjnm39y3nn9l4520mdn4k5mw23nz0674c4gsvyrcr90z9tqcvst22fce"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-2112",
          port_id: "wasm.neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07"
        },
        chain_2: {
          channel_id: "channel-396",
          port_id: "wasm.terra1k9j8rcyk87v5jvfla2m9wp200azegjz0eshl7n2pwv852a7ssceqsnn7pq"
        },
        ordering: "unordered",
        version: "astroport-ibc-v1",
        tags: {
          status: "live",
          preferred: !0
        }
      }
    ]
  }
];
cb.default = wP;
var db = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(cs, "__esModule", { value: !0 });
cs.ibc = cs.chain = cs.assets = void 0;
const xP = db(rb), kP = db(ib), AP = db(cb);
cs.assets = xP.default;
cs.chain = kP.default;
cs.ibc = AP.default;
var ds = {}, mb = {};
Object.defineProperty(mb, "__esModule", { value: !0 });
const jP = {
  $schema: "../assetlist.schema.json",
  chain_name: "nibiru",
  assets: [
    {
      description: "The native token of Nibiru network",
      extended_description: "Nibiru hosts a variety of ecosystem partners in a wide variety of consumer sectors. From RWAs (Coded Estate) to DeFi (Constella, NOM) to Gaming (Blockchain Game Alliance, IntoTheVerse), Nibiru is advancing multiple emerging blockchain narratives that will onboard the next billion users.",
      socials: {
        website: "https://nibiru.fi",
        twitter: "https://twitter.com/nibiruchain"
      },
      denom_units: [
        {
          denom: "unibi",
          exponent: 0
        },
        {
          denom: "nibi",
          exponent: 6
        },
        {
          denom: "attonibi",
          exponent: 18
        }
      ],
      base: "unibi",
      name: "Nibiru",
      display: "nibi",
      symbol: "NIBI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg"
      },
      coingecko_id: "nibiru",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg",
        theme: {
          primary_color_hex: "#14c0ce"
        }
      }]
    },
    {
      description: "uoprek",
      denom_units: [{
        denom: "tf/nibi149m52kn7nvsg5nftvv4fh85scsavpdfxp5nr7zasz97dum89dp5qkyhy0t/uoprek",
        exponent: 0
      }],
      base: "tf/nibi149m52kn7nvsg5nftvv4fh85scsavpdfxp5nr7zasz97dum89dp5qkyhy0t/uoprek",
      name: "uoprek",
      display: "tf/nibi149m52kn7nvsg5nftvv4fh85scsavpdfxp5nr7zasz97dum89dp5qkyhy0t/uoprek",
      symbol: "UOPREK"
    },
    {
      description: "utestate",
      denom_units: [{
        denom: "tf/nibi1lp28kx3gz0prsztl024z730ufkg3alahaq3e7a6gae22nk0dqdvsyrrgqw/utestate",
        exponent: 0
      }],
      base: "tf/nibi1lp28kx3gz0prsztl024z730ufkg3alahaq3e7a6gae22nk0dqdvsyrrgqw/utestate",
      name: "utestate",
      display: "tf/nibi1lp28kx3gz0prsztl024z730ufkg3alahaq3e7a6gae22nk0dqdvsyrrgqw/utestate",
      symbol: "UTESTATE"
    },
    {
      description: "npp",
      denom_units: [{
        denom: "tf/nibi1xpp7yn0tce62ffattws3gpd6v0tah0mlevef3ej3r4pnfvsehcgqk3jvxq/NPP",
        exponent: 0
      }],
      base: "tf/nibi1xpp7yn0tce62ffattws3gpd6v0tah0mlevef3ej3r4pnfvsehcgqk3jvxq/NPP",
      name: "npp",
      display: "tf/nibi1xpp7yn0tce62ffattws3gpd6v0tah0mlevef3ej3r4pnfvsehcgqk3jvxq/NPP",
      symbol: "NPP"
    }
  ]
};
mb.default = jP;
var hb = {};
Object.defineProperty(hb, "__esModule", { value: !0 });
const CP = {
  $schema: "../chain.schema.json",
  chain_name: "nibiru",
  status: "live",
  network_type: "mainnet",
  website: "https://nibiru.fi/",
  pretty_name: "Nibiru",
  chain_type: "cosmos",
  chain_id: "cataclysm-1",
  bech32_prefix: "nibi",
  daemon_name: "nibid",
  node_home: "$HOME/.nibid",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "unibi",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.05,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unibi"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.47.11",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.44.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg"
  },
  description: "A Web3 hub ushering in the next era of money",
  apis: {
    wss: [{
      address: "wss://rpc.nibiru.fi/websocket",
      provider: "Nibiru Foundation"
    }],
    rpc: [
      {
        address: "https://rpc.nibiru.fi",
        provider: "Nibiru Foundation"
      },
      {
        address: "https://nibiru.rpc.kjnodes.com",
        provider: "kjnodes.com 🦄"
      },
      {
        address: "https://rpc.nibiru.nodestake.org",
        provider: "NodeStake"
      },
      {
        address: "https://rpc.lavenderfive.com:443/nibiru",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc.nibiru.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://nibiru.rpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://nibiru-rpc.cogwheel.zone",
        provider: "Cogwheel ⚙️"
      },
      {
        address: "https://nibiru.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      },
      {
        address: "https://nibiru.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://nibiru-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://nibiru-mainnet.rpc.stakevillage.net:443",
        provider: "Stake Village"
      },
      {
        address: "https://nibiru-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc.nibiru.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://nibiru_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://lcd.nibiru.fi",
        provider: "Nibiru Foundation"
      },
      {
        address: "https://nibiru.api.kjnodes.com",
        provider: "kjnodes.com 🦄"
      },
      {
        address: "https://api.nibiru.nodestake.org",
        provider: "NodeStake"
      },
      {
        address: "https://api.nibiru.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://rest.lavenderfive.com:443/nibiru",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://nibiru.api.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://nibiru-api.cogwheel.zone",
        provider: "Cogwheel ⚙️"
      },
      {
        address: "https://nibiru.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://nibiru.api.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      },
      {
        address: "https://nibiru.api.staking-explorer.com",
        provider: "Daily DROP | 2% Fee"
      },
      {
        address: "https://nibiru-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://nibiru-mainnet.api.stakevillage.net",
        provider: "Stake Village"
      },
      {
        address: "https://nibiru-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://api.nibiru.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://nibiru_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "grpc.nibiru.fi:443",
        provider: "Nibiru Foundation"
      },
      {
        address: "nibiru.grpc.kjnodes.com:443",
        provider: "kjnodes.com 🦄"
      },
      {
        address: "grpc.nibiru.nodestake.org:443",
        provider: "NodeStake"
      },
      {
        address: "grpc.nibiru.silentvalidator.com:443",
        provider: "silent"
      },
      {
        address: "nibiru.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "nibiru.grpc.liveraven.net:443",
        provider: "LiveRaveN"
      },
      {
        address: "nibiru-grpc.cogwheel.zone:443",
        provider: "Cogwheel ⚙️"
      },
      {
        address: "https://nibiru.grpc.nodeshub.online",
        provider: "Nodes Hub"
      },
      {
        address: "nibiru.grpc.m.stavr.tech:5023",
        provider: "🔥STAVR🔥"
      },
      {
        address: "nibiru-grpc.noders.services:35090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "nibiru-mainnet.grpc.stakevillage.net:443",
        provider: "Stake Village"
      },
      {
        address: "nibiru-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "grpc.nibiru.roomit.xyz:8443",
        provider: "Roomit"
      }
    ]
  },
  explorers: [
    {
      kind: "Nodes Guru",
      url: "https://nibiru.explorers.guru/",
      tx_page: "https://nibiru.explorers.guru/transaction/${txHash}",
      account_page: "https://nibiru.explorers.guru/account/${accountAddress}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.org/nibiru",
      tx_page: "https://explorer.nodestake.org/nibiru/tx/${txHash}",
      account_page: "https://explorer.nodestake.org/nibiru/account/${accountAddress}"
    },
    {
      kind: "LiveRaveN",
      url: "https://mainnet.explorer.liveraven.net/nibiru",
      tx_page: "https://mainnet.explorer.liveraven.net/nibiru/tx/${txHash}",
      account_page: "https://mainnet.explorer.liveraven.net/nibiru/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Nibiru-Mainnet",
      tx_page: "https://explorer.stavr.tech/Nibiru-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Nibiru-Mainnet/account/${accountAddress}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
      url: "https://explorer.nodeshub.online/nibiru/",
      tx_page: "https://explorer.nodeshub.online/nibiru/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/nibiru/accounts/${accountAddress}"
    },
    {
      kind: "Stake Village",
      url: "https://exp.stakevillage.net/nibiru-mainnet",
      tx_page: "https://exp.stakevillage.net/nibiru-mainnet/tx/${txHash}",
      account_page: "https://exp.stakevillage.net/nibiru-mainnet/accounts/${accountAddress}"
    },
    {
      kind: "Roomit",
      url: "https://explorer.tendermint.roomit.xyz/nibiru-mainnet",
      tx_page: "https://explorer.tendermint.roomit.xyz/nibiru-mainnet/tx/${txHash}",
      account_page: "https://explorer.tendermint.roomit.xyz/nibiru-mainnet/accounts/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/nibiru",
      tx_page: "https://explorer.whenmoonwhenlambo.money/nibiru/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/nibiru/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg",
    theme: {
      primary_color_hex: "#14c0ce"
    }
  }]
};
hb.default = CP;
var pb = {};
Object.defineProperty(pb, "__esModule", { value: !0 });
const EP = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-200",
      connection_id: "connection-181"
    },
    chain_2: {
      chain_name: "nibiru",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-139",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nibiru",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-86",
      connection_id: "connection-86"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-67",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nibiru",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3104",
      connection_id: "connection-2580"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21113",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
pb.default = EP;
var lb = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ds, "__esModule", { value: !0 });
ds.ibc = ds.chain = ds.assets = void 0;
const DP = lb(mb), BP = lb(hb), FP = lb(pb);
ds.assets = DP.default;
ds.chain = BP.default;
ds.ibc = FP.default;
var ms = {}, gb = {};
Object.defineProperty(gb, "__esModule", { value: !0 });
const $P = {
  $schema: "../assetlist.schema.json",
  chain_name: "nim",
  assets: [{
    description: "The native token of Nim Network.",
    extended_description: "Nim Network is a highly-adoptable AI Gaming chain that will provide the ultimate ecosystem for exploration and development of games at the intersection of Web3 and AI.",
    denom_units: [{
      denom: "anim",
      exponent: 0
    }, {
      denom: "nim",
      exponent: 18
    }],
    type_asset: "sdk.coin",
    base: "anim",
    name: "NIM Network",
    display: "nim",
    symbol: "NIM",
    coingecko_id: "nim-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.svg",
      theme: {
        primary_color_hex: "#519cea"
      }
    }],
    socials: {
      website: "https://ai.nim.network/",
      twitter: "https://twitter.com/nim_network"
    },
    keywords: ["gaming", "AI"],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.svg"
    }
  }]
};
gb.default = $P;
var ub = {};
Object.defineProperty(ub, "__esModule", { value: !0 });
const zP = {
  $schema: "../chain.schema.json",
  chain_name: "nim",
  status: "live",
  network_type: "mainnet",
  website: "https://ai.nim.network",
  pretty_name: "Nim Network",
  chain_type: "cosmos",
  chain_id: "nim_1122-1",
  bech32_prefix: "nim",
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "anim",
      low_gas_price: 2e10,
      average_gas_price: 2e10,
      high_gas_price: 2e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "anim"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.svg"
  },
  description: "Nim Network is a highly-adoptable AI Gaming chain that will provide the ultimate ecosystem for exploration and development of games at the intersection of Web3 and AI.",
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.svg",
    theme: {
      primary_color_hex: "#519cea"
    }
  }],
  codebase: {},
  apis: {
    rpc: [{
      address: "https://nim-mainnet-tendermint.public.blastapi.io",
      provider: "BlastAPI"
    }],
    rest: [{
      address: "https://nim-mainnet-rest.public.blastapi.io",
      provider: "BlastAPI"
    }],
    "evm-http-jsonrpc": [{
      address: "https://nim-mainnet.public.blastapi.io",
      provider: "BlastAPI"
    }]
  },
  explorers: [{
    kind: "FYI",
    url: "https://dym.fyi/r/nim",
    tx_page: "https://dym.fyi/r/nim/tx/${txHash}",
    account_page: "https://dym.fyi/r/nim/address/${accountAddress}"
  }]
};
ub.default = zP;
var _b = {};
Object.defineProperty(_b, "__esModule", { value: !0 });
const qP = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "dymension",
    client_id: "07-tendermint-44",
    connection_id: "connection-34"
  },
  chain_2: {
    chain_name: "nim",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-49",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
_b.default = qP;
var yb = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ms, "__esModule", { value: !0 });
ms.ibc = ms.chain = ms.assets = void 0;
const SP = yb(gb), TP = yb(ub), RP = yb(_b);
ms.assets = SP.default;
ms.chain = TP.default;
ms.ibc = RP.default;
var hs = {}, bb = {};
Object.defineProperty(bb, "__esModule", { value: !0 });
const OP = {
  $schema: "../assetlist.schema.json",
  chain_name: "noble",
  assets: [
    {
      description: "The permissioned staking asset for Noble Chain",
      denom_units: [{
        denom: "ustake",
        exponent: 0,
        aliases: ["microstake"]
      }, {
        denom: "stake",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "ustake",
      name: "Stake",
      display: "stake",
      symbol: "STAKE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/stake.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/stake.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/stake.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/stake.svg",
        theme: {
          primary_color_hex: "#a8bbfb"
        }
      }]
    },
    {
      description: "Frienzies are an IBC token redeemable exclusively for a physical asset issued by the Noble entity.",
      denom_units: [{
        denom: "ufrienzies",
        exponent: 0,
        aliases: ["microfrienzies"]
      }, {
        denom: "frienzies",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "ufrienzies",
      display: "frienzies",
      name: "Frienzies",
      symbol: "FRNZ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/frnz.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/frnz.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/frnz.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/frnz.svg",
        theme: {
          primary_color_hex: "#04041c"
        }
      }]
    },
    {
      description: "ATOM token on Noble",
      denom_units: [{
        denom: "ibc/EF48E6B1A1A19F47ECAEA62F5670C37C0580E86A9E88498B7E393EB6F49F33C0",
        exponent: 0
      }, {
        denom: "atom",
        exponent: 6,
        aliases: ["ATOM"]
      }],
      type_asset: "ics20",
      base: "ibc/EF48E6B1A1A19F47ECAEA62F5670C37C0580E86A9E88498B7E393EB6F49F33C0",
      name: "Atom Staking Coin",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-536"
        },
        chain: {
          channel_id: "channel-4",
          path: "transfer/channel-4/uatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }]
    },
    {
      description: "USD Coin",
      denom_units: [{
        denom: "uusdc",
        exponent: 0,
        aliases: ["microusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "uusdc",
      display: "usdc",
      name: "USDC",
      symbol: "USDC",
      coingecko_id: "usd-coin",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        provider: "Circle"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "Ondo US Dollar Yield",
      extended_description: "USDY is a tokenized note secured by short-term US Treasuries and bank demand deposits. USDY is accessible to non-US individual and institutional investors and is transferable onchain 40-50 days after purchase.",
      denom_units: [{
        denom: "ausdy",
        exponent: 0,
        aliases: ["attousdy"]
      }, {
        denom: "usdy",
        exponent: 18
      }],
      base: "ausdy",
      display: "usdy",
      name: "Ondo US Dollar Yield",
      symbol: "USDY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/usdy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/usdy.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/usdy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/usdy.svg",
        theme: {
          primary_color_hex: "#142c5c"
        }
      }],
      coingecko_id: "ondo-us-dollar-yield",
      socials: {
        website: "https://ondo.finance/usdy",
        twitter: "https://x.com/OndoFinance"
      }
    },
    {
      description: "EURe is a Euro-backed stablecoin issued by Monerium on Noble.",
      denom_units: [{
        denom: "ueure",
        exponent: 0
      }, {
        denom: "eure",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "ueure",
      name: "Monerium EUR emoney",
      display: "eure",
      symbol: "EURe",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x3231Cb76718CDeF2155FC47b5286d82e6eDA273f"
        },
        provider: "Monerium"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x3231Cb76718CDeF2155FC47b5286d82e6eDA273f"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eure.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eure.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#0095D7",
          background_color_hex: "#FFFFFF"
        }
      }]
    }
  ]
};
bb.default = OP;
var vb = {};
Object.defineProperty(vb, "__esModule", { value: !0 });
const MP = {
  $schema: "../chain.schema.json",
  chain_name: "noble",
  chain_type: "cosmos",
  chain_id: "noble-1",
  website: "https://nobleassets.xyz/",
  pretty_name: "Noble",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "noble",
  daemon_name: "nobled",
  node_home: "$HOME/.noble",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uusdc",
      fixed_min_gas_price: 0.1,
      low_gas_price: 0.1,
      average_gas_price: 0.1,
      high_gas_price: 0.2
    }, {
      denom: "ibc/EF48E6B1A1A19F47ECAEA62F5670C37C0580E86A9E88498B7E393EB6F49F33C0",
      fixed_min_gas_price: 0.01,
      low_gas_price: 0.01,
      average_gas_price: 0.01,
      high_gas_price: 0.02
    }]
  },
  codebase: {
    cosmos_sdk_version: "noble-assets/cosmos-sdk v0.45.16-send-restrictions",
    cosmwasm_enabled: !1
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/stake.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/stake.svg"
  },
  description: "The most reliable, secure, and frictionless way to natively issue a digital asset in Cosmos.",
  apis: {
    rpc: [{
      address: "https://noble-rpc.polkachu.com",
      provider: "polkachu"
    }, {
      address: "https://rpc.lavenderfive.com:443/noble",
      provider: "Lavender.Five Nodes 🐝"
    }],
    rest: [{
      address: "https://noble-api.polkachu.com",
      provider: "polkachu"
    }, {
      address: "https://rest.lavenderfive.com:443/noble",
      provider: "Lavender.Five Nodes 🐝"
    }],
    grpc: [{
      address: "noble-grpc.polkachu.com:21590",
      provider: "polkachu"
    }, {
      address: "noble.lavenderfive.com:443",
      provider: "Lavender.Five Nodes 🐝"
    }]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/noble",
      tx_page: "https://www.mintscan.io/noble/txs/${txHash}",
      account_page: "https://www.mintscan.io/noble/account/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/noble",
      tx_page: "https://ezstaking.app/noble/txs/${txHash}",
      account_page: "https://ezstaking.app/noble/account/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/noble",
      account_page: "https://stakeflow.io/noble/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/stake.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/stake.svg",
    theme: {
      primary_color_hex: "#a8bbfb"
    }
  }]
};
vb.default = MP;
var fb = {};
Object.defineProperty(fb, "__esModule", { value: !0 });
const IP = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-77",
      connection_id: "connection-72"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-32",
      connection_id: "connection-40"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-28",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-17",
      connection_id: "connection-26"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-43",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-66",
      connection_id: "connection-63"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "beezee",
      client_id: "07-tendermint-9",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-112",
      connection_id: "connection-107"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-95",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-32",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-71",
      connection_id: "connection-72"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1116",
      connection_id: "connection-790"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-4",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-536",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-68",
      connection_id: "connection-63"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-23",
      connection_id: "connection-29"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-111",
      connection_id: "connection-106"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-94",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-59",
      connection_id: "connection-57"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-14",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-79",
      connection_id: "connection-80"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-106",
      connection_id: "connection-63"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-12",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "furya",
      client_id: "07-tendermint-5",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-67",
      connection_id: "connection-64"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "haqq",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-58",
      connection_id: "connection-56"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-32",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "impacthub",
      client_id: "07-tendermint-59",
      connection_id: "connection-43"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-20",
      connection_id: "connection-29"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-212",
      connection_id: "connection-195"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-57",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-148",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-31",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "joltify",
      client_id: "07-tendermint-4",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-102",
      connection_id: "connection-94"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-81",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-334",
      connection_id: "connection-322"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-3",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-224",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-172",
      connection_id: "connection-214"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-107",
      connection_id: "connection-102"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-151",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-95",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-2",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-113",
      connection_id: "connection-89"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-19",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-60",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-40",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-25",
      connection_id: "connection-34"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nibiru",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "noble",
      client_id: "07-tendermint-86",
      connection_id: "connection-86"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-67",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-68",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-51",
      connection_id: "connection-49"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-44",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-98",
      connection_id: "connection-91"
    },
    chain_2: {
      chain_name: "onex",
      client_id: "07-tendermint-6",
      connection_id: "connection-14"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-78",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-60",
      connection_id: "connection-58"
    },
    chain_2: {
      chain_name: "oraichain",
      client_id: "07-tendermint-106",
      connection_id: "connection-83"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-147",
        port_id: "wasm.orai195269awwnt5m6c843q6w7hp8rt0k7syfu9de4h0wz384slshuzps8y7ccm"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "oraidex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-0",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2704",
      connection_id: "connection-2241"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-750",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-61",
      connection_id: "connection-59"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-160",
      connection_id: "connection-198"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-132",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-103",
      connection_id: "connection-95"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-567",
      connection_id: "connection-490"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-82",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-30",
      connection_id: "connection-37"
    },
    chain_2: {
      chain_name: "provenance",
      client_id: "07-tendermint-36",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-100",
      connection_id: "connection-92"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-5",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-79",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-104",
      connection_id: "connection-96"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-177",
      connection_id: "connection-149"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-83",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-165",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-24",
      connection_id: "connection-33"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-170",
      connection_id: "connection-127"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-45",
      connection_id: "connection-61"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-45",
      connection_id: "connection-77"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-39",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-45",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-106",
      connection_id: "connection-99"
    },
    chain_2: {
      chain_name: "shido",
      client_id: "07-tendermint-9",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-87",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-16",
      connection_id: "connection-25"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-287",
      connection_id: "connection-214"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-204",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-76",
      connection_id: "connection-77"
    },
    chain_2: {
      chain_name: "teritori",
      client_id: "07-tendermint-97",
      connection_id: "connection-97"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-54",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-56",
      connection_id: "connection-54"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-367",
      connection_id: "connection-302"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-253",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-73",
      connection_id: "connection-74"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-248",
      connection_id: "connection-210"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-120",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
fb.default = IP;
var wb = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(hs, "__esModule", { value: !0 });
hs.ibc = hs.chain = hs.assets = void 0;
const NP = wb(bb), PP = wb(vb), UP = wb(fb);
hs.assets = NP.default;
hs.chain = PP.default;
hs.ibc = UP.default;
var ps = {}, xb = {};
Object.defineProperty(xb, "__esModule", { value: !0 });
const HP = {
  $schema: "../assetlist.schema.json",
  chain_name: "nois",
  assets: [{
    description: "The native token of Nois",
    denom_units: [{
      denom: "unois",
      exponent: 0
    }, {
      denom: "nois",
      exponent: 6
    }],
    base: "unois",
    name: "Nois",
    display: "nois",
    symbol: "NOIS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.svg"
    },
    keywords: [
      "nois",
      "randomness",
      "drand",
      "wasm"
    ],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.svg",
      theme: {
        primary_color_hex: "#0c0c14"
      }
    }]
  }]
};
xb.default = HP;
var kb = {};
Object.defineProperty(kb, "__esModule", { value: !0 });
const LP = {
  $schema: "../chain.schema.json",
  chain_name: "nois",
  status: "live",
  network_type: "mainnet",
  website: "https://nois.network",
  pretty_name: "Nois",
  chain_type: "cosmos",
  chain_id: "nois-1",
  bech32_prefix: "nois",
  daemon_name: "noisd",
  node_home: "$HOME/.noisd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "unois",
      fixed_min_gas_price: 0.05,
      low_gas_price: 0.05,
      average_gas_price: 0.05,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unois"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.45.15",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.31.0"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png",
    theme: {
      primary_color_hex: "#0C0914"
    }
  }, {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.svg",
    theme: {
      primary_color_hex: "#0c0c14"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png"
  },
  apis: {
    rpc: [
      {
        address: "https://nois-rpc.nysa.network",
        provider: "nysa.network"
      },
      {
        address: "https://nois.rpc.bccnodes.com",
        provider: "BccNodes"
      },
      {
        address: "https://rpc.lavenderfive.com:443/nois",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-nois.mib.tech/",
        provider: "MadeInBlock"
      },
      {
        address: "https://m-nois.rpc.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "http://nois.rpc.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-nois.ezstaking.dev",
        provider: "EZStaking"
      },
      {
        address: "https://nois-mainnet-rpc.itrocket.net",
        provider: "itrocket"
      },
      {
        address: "https://rpc-nois.d-stake.xyz",
        provider: "D-Stake"
      },
      {
        address: "https://rpc-nois.sr20de.xyz",
        provider: "SR20DE"
      },
      {
        address: "https://nois-mainnet-rpc.autostake.com",
        provider: "AutoStake"
      },
      {
        address: "https://nois-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://nois-rpc.kingnodes.com",
        provider: "kingnodes 👑"
      },
      {
        address: "https://rpc.nois.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://nois-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://rpc.nois.cumulo.org.es",
        provider: "Cumulo"
      }
    ],
    grpc: [
      {
        address: "https://nois-grpc.nysa.network",
        provider: "nysa.network"
      },
      {
        address: "nois.grpc.bccnodes.com:443",
        provider: "BccNodes"
      },
      {
        address: "nois.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://grpc.noismain.mcbnode.online",
        provider: "mcbnode"
      },
      {
        address: "http://nois.grpc.m.stavr.tech:191",
        provider: "🔥STAVR🔥"
      },
      {
        address: "nois-mainnet-grpc.itrocket.net:36090",
        provider: "itrocket"
      },
      {
        address: "nois-mainnet-grpc.itrocket.net:36090",
        provider: "itrocket"
      },
      {
        address: "https://grpc.nois.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://grpc-nois.d-stake.xyz",
        provider: "D-Stake"
      },
      {
        address: "https://grpc.nois.hexnodes.co",
        provider: "HexNodes"
      },
      {
        address: "https://grpc-nois.sr20de.xyz",
        provider: "SR20DE"
      },
      {
        address: "https://nois-testnet-grpc.autostake.com",
        provider: "AutoStake"
      },
      {
        address: "nois-grpc.polkachu.com:17390",
        provider: "Polkachu"
      },
      {
        address: "https://nois-grpc.kingnodes.com",
        provider: "kingnodes 👑"
      },
      {
        address: "grpc.nois.silentvalidator.com:443",
        provider: "silent"
      },
      {
        address: "nois-grpc.stakeandrelax.net:17390",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "grpc.nois.cumulo.org.es:443",
        provider: "Cumulo"
      }
    ],
    rest: [
      {
        address: "https://m-nois.api.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://rest.lavenderfive.com:443/nois",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://lcd-nois.ezstaking.dev",
        provider: "EZStaking"
      },
      {
        address: "https://lcd-nois.mib.tech/",
        provider: "MadeInBlock"
      },
      {
        address: "https://nois.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://nois-mainnet-api.itrocket.net",
        provider: "itrocket"
      },
      {
        address: "https://api-nois.d-stake.xyz",
        provider: "D-Stake"
      },
      {
        address: "https://api-nois.sr20de.xyz",
        provider: "SR20DE"
      },
      {
        address: "https://nois-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://nois-rest.kingnodes.com",
        provider: "kingnodes 👑"
      },
      {
        address: "https://api.nois.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://nois-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://api.nois.cumulo.org.es",
        provider: "Cumulo"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/nois",
      tx_page: "https://ezstaking.app/nois/txs/${txHash}",
      account_page: "https://ezstaking.app/nois/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/nois-mainnet",
      tx_page: "https://explorer.stavr.tech/nois-mainnet/txs/${txHash}",
      account_page: "https://explorer.stavr.tech/nois-mainnet/account/${accountAddress}"
    },
    {
      kind: "BccNodes",
      url: "https://explorer.stavr.tech/nois-mainnet",
      tx_page: "https://explorer.bccnodes.com/nois-M/txs/${txHash}",
      account_page: "https://explorer.bccnodes.com/nois-M/account/${accountAddress}"
    },
    {
      kind: "explorers.guru",
      url: "https://nois.explorers.guru",
      tx_page: "https://nois.explorers.guru/transaction/${txHash}",
      account_page: "https://nois.explorers.guru/account/${accountAddress}"
    }
  ],
  keywords: [
    "nois",
    "randomness",
    "drand",
    "wasm"
  ]
};
kb.default = LP;
var Ab = {};
Object.defineProperty(Ab, "__esModule", { value: !0 });
const WP = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-22",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "nois",
      client_id: "07-tendermint-15",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-19",
        port_id: "wasm.archway10f3aasgsnpv84ymjyld50jayc4ecu267sdpjamauwm8nvxlzex9qj4dkwr"
      },
      chain_2: {
        channel_id: "channel-22",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-13",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "nois",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-8",
        port_id: "wasm.aura1r3zgdsn3dcze07a4r60rxxx7ppvkxfshn9np0pwtkgarrld0786s72jtjt"
      },
      chain_2: {
        channel_id: "channel-35",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-201",
      connection_id: "connection-184"
    },
    chain_2: {
      chain_name: "nois",
      client_id: "07-tendermint-13",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-138",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-140",
        port_id: "wasm.inj1w9g3sk7lk8k0pdtctygupt6f3te7x4thvzz57a"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-335",
      connection_id: "connection-325"
    },
    chain_2: {
      chain_name: "nois",
      client_id: "07-tendermint-1",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-225",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-243",
        port_id: "wasm.juno1qr84ktm57q5t02u04ddk5r8s79axdzglad6tfdd9g2xgt4hkh6jsgeq9x2"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-83",
      connection_id: "connection-62"
    },
    chain_2: {
      chain_name: "nois",
      client_id: "07-tendermint-20",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-722",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-47",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-1559",
        port_id: "wasm.neutron14cwv7d4lwc69zrjrzywwh8c9327m8dpngpq52f5kgqephhgrjc2s9ry3eu"
      },
      chain_2: {
        channel_id: "channel-48",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nois",
      client_id: "07-tendermint-16",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3017",
      connection_id: "connection-2507"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8277",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-11319",
        port_id: "wasm.osmo1tvzr8ur0ynjhqftxpkl4qwel8ly7erhy6cu6ks426xmzf92vk6eqfp9wcl"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nois",
      client_id: "07-tendermint-19",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-106",
      connection_id: "connection-144"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-43",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-58",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-44",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      chain_2: {
        channel_id: "channel-59",
        port_id: "wasm.sei1vxlzhn6qvf95syha2tgr0ct23sk5359s2vqzylgthuyy7kd7ql5qcxa4r0"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nois",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-237",
      connection_id: "connection-171"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-137",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-238",
        port_id: "wasm.stars1mw5y55f53mnara7g3pn2pylxl8dpauscyn83c68442hz9nwktzrq8tjzyf"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Ab.default = WP;
var jb = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ps, "__esModule", { value: !0 });
ps.ibc = ps.chain = ps.assets = void 0;
const VP = jb(xb), GP = jb(kb), KP = jb(Ab);
ps.assets = VP.default;
ps.chain = GP.default;
ps.ibc = KP.default;
var ls = {}, Cb = {};
Object.defineProperty(Cb, "__esModule", { value: !0 });
const XP = {
  $schema: "../assetlist.schema.json",
  chain_name: "nolus",
  assets: [
    {
      description: "The native token of Nolus chain",
      denom_units: [{
        denom: "unls",
        exponent: 0
      }, {
        denom: "nls",
        exponent: 6
      }],
      base: "unls",
      name: "Nolus",
      display: "nls",
      symbol: "NLS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.svg"
      },
      coingecko_id: "nolus",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.svg",
        theme: {
          primary_color_hex: "#fc542c"
        }
      }],
      socials: {
        website: "https://nolus.io/",
        twitter: "https://twitter.com/NolusProtocol"
      }
    },
    {
      description: "axlUSDC transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/7FBDBEEEBA9C50C4BCDF7BF438EAB99E64360833D240B32655C96E319559E911",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/7FBDBEEEBA9C50C4BCDF7BF438EAB99E64360833D240B32655C96E319559E911",
      name: "axlUSDC",
      display: "usdc",
      symbol: "axlUSDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-208/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.svg",
        theme: {
          primary_color_hex: "#2474cb"
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
        theme: {
          primary_color_hex: "#2474cc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.svg"
      }
    },
    {
      description: "OSMO transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
        exponent: 0,
        aliases: ["uosmo"]
      }, {
        denom: "osmo",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
      name: "Osmosis",
      display: "osmo",
      symbol: "OSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/uosmo"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      }
    },
    {
      description: "stOSMO transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/AF5559D128329B6C753F15481BEC26E533B847A471074703FA4903E7E6F61BA1",
        exponent: 0,
        aliases: ["stuosmo"]
      }, {
        denom: "stosmo",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/AF5559D128329B6C753F15481BEC26E533B847A471074703FA4903E7E6F61BA1",
      name: "Osmosis",
      display: "stosmo",
      symbol: "stOSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/D176154B0C63D1F9C6DCFB4F70349EBF2E2B5A87A05902F57A6AE92B863E9AEC",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-326/stuosmo"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/D176154B0C63D1F9C6DCFB4F70349EBF2E2B5A87A05902F57A6AE92B863E9AEC"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg"
      }
    },
    {
      description: "ATOM transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/6CDD4663F2F09CD62285E2D45891FC149A3568E316CE3EBBE201A71A78A69388",
        exponent: 0,
        aliases: ["uatom"]
      }, {
        denom: "atom",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/6CDD4663F2F09CD62285E2D45891FC149A3568E316CE3EBBE201A71A78A69388",
      name: "Atom",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-0/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      }
    },
    {
      description: "stATOM transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/FCFF8B19C61677F3B78E2A5AE3B4A34A8D23858D16905F253B8438B3AFD07FF8",
        exponent: 0,
        aliases: ["ustatom"]
      }, {
        denom: "statom",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/FCFF8B19C61677F3B78E2A5AE3B4A34A8D23858D16905F253B8438B3AFD07FF8",
      name: "stATOM",
      display: "statom",
      symbol: "stATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/C140AFD542AE77BD7DCC83F13FDD8C5E5BB8C4929785E6EC2F4C636F98F17901",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-326/stuatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/C140AFD542AE77BD7DCC83F13FDD8C5E5BB8C4929785E6EC2F4C636F98F17901"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg"
      }
    },
    {
      description: "WETH transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/A7C4A3FB19E88ABE60416125F9189DA680800F4CDD14E3C10C874E022BEFF04C",
        exponent: 0,
        aliases: ["weth-wei"]
      }, {
        denom: "weth",
        exponent: 18,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/A7C4A3FB19E88ABE60416125F9189DA680800F4CDD14E3C10C874E022BEFF04C",
      name: "WETH",
      display: "weth",
      symbol: "WETH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/EA1D43981D5C9A1C4AAEA9C23BB1D4FA126BA9BC7020A25E0AE4AA841EA25DC5",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-208/weth-wei"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/EA1D43981D5C9A1C4AAEA9C23BB1D4FA126BA9BC7020A25E0AE4AA841EA25DC5"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.axl.svg"
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/weth.png",
        theme: {
          primary_color_hex: "#3a3444"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.axl.svg"
      }
    },
    {
      description: "WBTC transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/84E70F4A34FB2DE135FD3A04FDDF53B7DA4206080AA785C8BAB7F8B26299A221",
        exponent: 0,
        aliases: ["wbtc-satoshi"]
      }, {
        denom: "wbtc",
        exponent: 8,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/84E70F4A34FB2DE135FD3A04FDDF53B7DA4206080AA785C8BAB7F8B26299A221",
      name: "WBTC",
      display: "wbtc",
      symbol: "WBTC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-208/wbtc-satoshi"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.svg",
        theme: {
          primary_color_hex: "#312b3a"
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/wbtc.png",
        theme: {
          primary_color_hex: "#41394d"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.svg"
      }
    },
    {
      description: "AKT transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/ADC63C00000CA75F909D2BE3ACB5A9980BED3A73B92746E0FCE6C67414055459",
        exponent: 0,
        aliases: ["uakt"]
      }, {
        denom: "akt",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/ADC63C00000CA75F909D2BE3ACB5A9980BED3A73B92746E0FCE6C67414055459",
      name: "AKT",
      display: "akt",
      symbol: "AKT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/1480B8FD20AD5FCAE81EA87584D269547DD4D436843C1D20F15E00EB64743EF4",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-1/uakt"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/1480B8FD20AD5FCAE81EA87584D269547DD4D436843C1D20F15E00EB64743EF4"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg",
        theme: {
          primary_color_hex: "#bc342c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
      }
    },
    {
      description: "AXL transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/1B03A71B8E6F6EF424411DC9326A8E0D25D096E4D2616425CFAF2AF06F0FE717",
        exponent: 0,
        aliases: ["uaxl"]
      }, {
        denom: "axl",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/1B03A71B8E6F6EF424411DC9326A8E0D25D096E4D2616425CFAF2AF06F0FE717",
      name: "AXL",
      display: "axl",
      symbol: "AXL",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/903A61A498756EA560B85A85132D3AEE21B5DEDD41213725D22ABF276EA6945E",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-208/uaxl"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/903A61A498756EA560B85A85132D3AEE21B5DEDD41213725D22ABF276EA6945E"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg"
      }
    },
    {
      description: "JUNO transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/4F3E83AB35529435E4BFEA001F5D935E7250133347C4E1010A9C77149EF0394C",
        exponent: 0,
        aliases: ["ujuno"]
      }, {
        denom: "juno",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/4F3E83AB35529435E4BFEA001F5D935E7250133347C4E1010A9C77149EF0394C",
      name: "JUNO",
      display: "juno",
      symbol: "JUNO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/46B44899322F3CD854D2D46DEEF881958467CDD4B3B10086DA49296BBED94BED",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-42/ujuno"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/46B44899322F3CD854D2D46DEEF881958467CDD4B3B10086DA49296BBED94BED"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.svg",
        theme: {
          primary_color_hex: "#fa7b7b"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.svg"
      }
    },
    {
      description: "EVMOS transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/A59A9C955F1AB8B76671B00C1A0482C64A6590352944BB5880E5122358F7E1CE",
        exponent: 0,
        aliases: ["aevmos"]
      }, {
        denom: "evmos",
        exponent: 18,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/A59A9C955F1AB8B76671B00C1A0482C64A6590352944BB5880E5122358F7E1CE",
      name: "EVMOS",
      display: "evmos",
      symbol: "EVMOS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/6AE98883D4D5D5FF9E50D7130F1305DA2FFA0C652D1DD9C123657C6B4EB2DF8A",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-204/aevmos"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/6AE98883D4D5D5FF9E50D7130F1305DA2FFA0C652D1DD9C123657C6B4EB2DF8A"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg",
        theme: {
          primary_color_hex: "#ec4c34"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg"
      }
    },
    {
      description: "stkATOM transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/DAAD372DB7DD45BBCFA4DDD40CA9793E9D265D1530083AB41A8A0C53C3EBE865",
        exponent: 0,
        aliases: ["stk/uatom"]
      }, {
        denom: "stk/atom",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/DAAD372DB7DD45BBCFA4DDD40CA9793E9D265D1530083AB41A8A0C53C3EBE865",
      name: "stkATOM",
      display: "stk/atom",
      symbol: "stkATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/CAA179E40F0266B0B29FB5EAA288FB9212E628822265D4141EBD1C47C3CBFCBC",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-4/stk/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/CAA179E40F0266B0B29FB5EAA288FB9212E628822265D4141EBD1C47C3CBFCBC"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg",
        theme: {
          primary_color_hex: "#c4444c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg"
      }
    },
    {
      description: "SCRT transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/EA00FFF0335B07B5CD1530B7EB3D2C710620AE5B168C71AFF7B50532D690E107",
        exponent: 0,
        aliases: ["uscrt"]
      }, {
        denom: "scrt",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/EA00FFF0335B07B5CD1530B7EB3D2C710620AE5B168C71AFF7B50532D690E107",
      name: "SCRT",
      display: "scrt",
      symbol: "SCRT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/0954E1C28EB7AF5B72D24F3BC2B47BBB2FDF91BDDFD57B74B99E133AED40972A",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-88/uscrt"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/0954E1C28EB7AF5B72D24F3BC2B47BBB2FDF91BDDFD57B74B99E133AED40972A"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg"
      }
    },
    {
      description: "CRO transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/E1BCC0F7B932E654B1A930F72B76C0678D55095387E2A4D8F00E941A8F82EE48",
        exponent: 0,
        aliases: ["basecro"]
      }, {
        denom: "cro",
        exponent: 8,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/E1BCC0F7B932E654B1A930F72B76C0678D55095387E2A4D8F00E941A8F82EE48",
      name: "CRO",
      display: "cro",
      symbol: "CRO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/E6931F78057F7CC5DA0FD6CEF82FF39373A6E0452BF1FD76910B93292CF356C1",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-5/basecro"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/E6931F78057F7CC5DA0FD6CEF82FF39373A6E0452BF1FD76910B93292CF356C1"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg"
      }
    },
    {
      description: "STARS transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/11E3CF372E065ACB1A39C531A3C7E7E03F60B5D0653AD2139D31128ACD2772B5",
        exponent: 0,
        aliases: ["ustars"]
      }, {
        denom: "stars",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/11E3CF372E065ACB1A39C531A3C7E7E03F60B5D0653AD2139D31128ACD2772B5",
      name: "STARS",
      display: "stars",
      symbol: "STARS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/987C17B11ABC2B20019178ACE62929FE9840202CE79498E29FE8E5CB02B7C0A4",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-75/ustars"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/987C17B11ABC2B20019178ACE62929FE9840202CE79498E29FE8E5CB02B7C0A4"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg",
        theme: {
          primary_color_hex: "#db2777"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg"
      }
    },
    {
      description: "TIA transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/6C349F0EB135C5FA99301758F35B87DB88403D690E5E314AB080401FEE4066E5",
        exponent: 0,
        aliases: ["utia"]
      }, {
        denom: "tia",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/6C349F0EB135C5FA99301758F35B87DB88403D690E5E314AB080401FEE4066E5",
      name: "TIA",
      display: "tia",
      symbol: "TIA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-6994/utia"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg",
        theme: {
          primary_color_hex: "#7c2cfb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg"
      }
    },
    {
      description: "STRD transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/04CA9067228BB51F1C39A506DA00DF07E1496D8308DD21E8EF66AD6169FA722B",
        exponent: 0,
        aliases: ["ustrd"]
      }, {
        denom: "strd",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/04CA9067228BB51F1C39A506DA00DF07E1496D8308DD21E8EF66AD6169FA722B",
      name: "STRD",
      display: "strd",
      symbol: "STRD",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/A8CA5EE328FA10C9519DF6057DA1F69682D28F7D0F5CCC7ECB72E3DCA2D157A4",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-326/ustrd"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/A8CA5EE328FA10C9519DF6057DA1F69682D28F7D0F5CCC7ECB72E3DCA2D157A4"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg",
        theme: {
          primary_color_hex: "#e4047c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg"
      }
    },
    {
      description: "CUDOS transferred from the Osmosis mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/BB9810E7FE8836311126F15BE0B20E7463189751840F8C3FEF3AC8F87D8AB7C8",
        exponent: 0,
        aliases: ["acudos"]
      }, {
        denom: "cudos",
        exponent: 18,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/BB9810E7FE8836311126F15BE0B20E7463189751840F8C3FEF3AC8F87D8AB7C8",
      name: "CUDOS",
      display: "cudos",
      symbol: "CUDOS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/E09ED39F390EC51FA9F3F69BEA08B5BBE6A48B3057B2B1C3467FAAE9E58B021B",
          channel_id: "channel-783"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/transfer/channel-298/acudos"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/E09ED39F390EC51FA9F3F69BEA08B5BBE6A48B3057B2B1C3467FAAE9E58B021B"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.svg",
        theme: {
          primary_color_hex: "#5d95ec"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.svg"
      }
    },
    {
      description: "NTRN transferred from the Neutron mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/3D6BC6E049CAEB905AC97031A42800588C58FB471EBDC7A3530FFCD0C3DC9E09",
        exponent: 0,
        aliases: ["untrn"]
      }, {
        denom: "ntrn",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/3D6BC6E049CAEB905AC97031A42800588C58FB471EBDC7A3530FFCD0C3DC9E09",
      name: "NTRN",
      display: "ntrn",
      symbol: "NTRN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "untrn",
          channel_id: "channel-44"
        },
        chain: {
          channel_id: "channel-3839",
          path: "transfer/channel-3839/untrn"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "untrn"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.svg",
        theme: {
          primary_color_hex: "#040404",
          background_color_hex: "#000000",
          circle: !0
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/neutron.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/neutron.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.svg"
      }
    },
    {
      description: "DYDX transferred from the Neutron mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/6DF8CF5C976851D152E2C7270B0AB25C4F9D64C0A46513A68D6CBB2662A98DF4",
        exponent: 0,
        aliases: ["adydx"]
      }, {
        denom: "dydx",
        exponent: 18,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/6DF8CF5C976851D152E2C7270B0AB25C4F9D64C0A46513A68D6CBB2662A98DF4",
      name: "DYDX",
      display: "dydx",
      symbol: "DYDX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "ibc/2CB87BCE0937B1D1DFCEE79BE4501AAF3C265E923509AEAC410AD85D27F35130",
          channel_id: "channel-44"
        },
        chain: {
          channel_id: "channel-3839",
          path: "transfer/channel-3839/transfer/channel-48/adydx"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "ibc/2CB87BCE0937B1D1DFCEE79BE4501AAF3C265E923509AEAC410AD85D27F35130"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
        theme: {
          primary_color_hex: "#21212f"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg"
      }
    },
    {
      description: "dATOM transferred from the Neutron mainnet that is supported on the Nolus chain",
      denom_units: [{
        denom: "ibc/EB08474FFC49B6BB2F03F7D9B08697138F4DA53347CA1AB718C8BCFBB58C1B2B",
        exponent: 0,
        aliases: ["udatom"]
      }, {
        denom: "dATOM",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/EB08474FFC49B6BB2F03F7D9B08697138F4DA53347CA1AB718C8BCFBB58C1B2B",
      name: "dATOM",
      display: "dATOM",
      symbol: "dATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1k6hr0f83e7un2wjf29cspk7j69jrnskk65k3ek2nj9dztrlzpj6q00rtsa/udatom",
          channel_id: "channel-44"
        },
        chain: {
          channel_id: "channel-3839",
          path: "transfer/channel-3839/factory/neutron1k6hr0f83e7un2wjf29cspk7j69jrnskk65k3ek2nj9dztrlzpj6q00rtsa/udatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1k6hr0f83e7un2wjf29cspk7j69jrnskk65k3ek2nj9dztrlzpj6q00rtsa/udatom"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/dATOM.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/dATOM.svg"
      }
    }
  ]
};
Cb.default = XP;
var Eb = {};
Object.defineProperty(Eb, "__esModule", { value: !0 });
const YP = {
  $schema: "../chain.schema.json",
  chain_name: "nolus",
  status: "live",
  website: "https://nolus.io/",
  network_type: "mainnet",
  pretty_name: "Nolus",
  chain_type: "cosmos",
  chain_id: "pirin-1",
  bech32_prefix: "nolus",
  daemon_name: "nolusd",
  node_home: "$HOME/.nolus",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "unls",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.05
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unls"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "nolus-protocol/cosmos-sdk v0.50.7-nolus-rc1",
    cosmwasm_enabled: !0,
    cosmwasm_version: "neutron-org/wasmd v0.51.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.svg"
  },
  description: "Elevate your game with up to 3x equity. Dive into a world of minimized risks and unlock the full potential of your assets.",
  apis: {
    rpc: [
      {
        address: "https://pirin-cl.nolus.network:26657",
        provider: "NolusProtocol"
      },
      {
        address: "https://nolus-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc.lavenderfive.com:443/nolus",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://nolus.rpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://rpc-nolus.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://nolus.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://nolus-rpc.enigma-validator.com/",
        provider: "Enigma"
      },
      {
        address: "https://nolus-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://rpc-nolus.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://nolus-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://nolus-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      }
    ],
    rest: [
      {
        address: "https://pirin-cl.nolus.network:1317",
        provider: "NolusProtocol"
      },
      {
        address: "https://nolus-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest.lavenderfive.com:443/nolus",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api-nolus.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://nolus.api.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://rest-nolus.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://nolus.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://nolus-lcd.enigma-validator.com/",
        provider: "Enigma"
      },
      {
        address: "https://nolus-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://nolus-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://nolus-api.ibs.team",
        provider: "Inter Blockchain Services"
      }
    ],
    grpc: [
      {
        address: "https://pirin-cl.nolus.network:9090",
        provider: "NolusProtocol"
      },
      {
        address: "nolus-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "nolus.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://nolus.grpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "grpc-nolus.architectnodes.com:1443",
        provider: "Architect Nodes"
      },
      {
        address: "grpc-nolus.cosmos-spaces.cloud:1190",
        provider: "Cosmos Spaces"
      },
      {
        address: "nolus.grpc.kjnodes.com:14390",
        provider: "kjnodes"
      },
      {
        address: "nolus-grpc.w3coins.io:19790",
        provider: "w3coins"
      },
      {
        address: "nolus-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "Nolus Explorer",
      url: "https://explorer.nolus.io/pirin-1",
      tx_page: "https://explorer.nolus.io/pirin-1/tx/${txHash}",
      account_page: "https://explorer.nolus.io/pirin-1/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/nolus",
      tx_page: "https://ping.pub/nolus/tx/${txHash}",
      account_page: "https://ping.pub/nolus/account/${accountAddress}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodexcapital.com/nolus",
      tx_page: "https://explorer.nodexcapital.com/nolus/tx/${txHash}",
      account_page: "https://explorer.nodexcapital.com/nolus/account/${accountAddress}"
    },
    {
      kind: "Nodes Guru Explorer",
      url: "https://nolus.explorers.guru",
      tx_page: "https://nolus.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "KJ Nodes Explorer",
      url: "https://explorer.kjnodes.com/nolus",
      tx_page: "https://explorer.kjnodes.com/nolus/tx/${txHash}",
      account_page: "https://explorer.kjnodes.com/nolus/account/${accountAddress}"
    }
  ],
  keywords: ["mainnet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.svg",
    theme: {
      primary_color_hex: "#fc542c"
    }
  }]
};
Eb.default = YP;
var Db = {};
Object.defineProperty(Db, "__esModule", { value: !0 });
const JP = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-205",
      connection_id: "connection-186"
    },
    chain_2: {
      chain_name: "nolus",
      client_id: "07-tendermint-17",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-143",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10177",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-13",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "nolus",
      client_id: "07-tendermint-14",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4092",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-71",
      connection_id: "connection-50"
    },
    chain_2: {
      chain_name: "nolus",
      client_id: "07-tendermint-13",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-44",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3839",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nolus",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2791",
      connection_id: "connection-2289"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-783",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nolus",
      client_id: "07-tendermint-18",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-201",
      connection_id: "connection-193"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13995",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-146",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Db.default = JP;
var Bb = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ls, "__esModule", { value: !0 });
ls.ibc = ls.chain = ls.assets = void 0;
const ZP = Bb(Cb), QP = Bb(Eb), eU = Bb(Db);
ls.assets = ZP.default;
ls.chain = QP.default;
ls.ibc = eU.default;
var gs = {}, Fb = {};
Object.defineProperty(Fb, "__esModule", { value: !0 });
const nU = {
  $schema: "../assetlist.schema.json",
  chain_name: "nomic",
  assets: [{
    description: "Nomic's native token.",
    denom_units: [{
      denom: "unom",
      exponent: 0
    }, {
      denom: "nom",
      exponent: 6
    }],
    base: "unom",
    name: "Nomic",
    display: "nom",
    symbol: "NOM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg",
      theme: {
        primary_color_hex: "#6404fc"
      }
    }]
  }, {
    description: "Bitcoin. On Cosmos.",
    denom_units: [{
      denom: "usat",
      exponent: 0
    }, {
      denom: "nbtc",
      exponent: 14
    }],
    base: "usat",
    name: "Nomic Bitcoin",
    display: "nbtc",
    symbol: "nBTC",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg"
    },
    traces: [{
      type: "bridge",
      counterparty: {
        chain_name: "bitcoin",
        base_denom: "sat"
      },
      provider: "Nomic"
    }],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg",
      theme: {
        primary_color_hex: "#8436e6"
      }
    }]
  }]
};
Fb.default = nU;
var $b = {};
Object.defineProperty($b, "__esModule", { value: !0 });
const tU = {
  $schema: "../chain.schema.json",
  chain_name: "nomic",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Nomic",
  website: "https://nomic.io/",
  chain_type: "cosmos",
  chain_id: "nomic-stakenet-3",
  bech32_prefix: "nomic",
  daemon_name: "nomic",
  node_home: "$HOME/.nomic-stakenet-3",
  slip44: 118,
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "unom",
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0
    }, {
      denom: "usat",
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unom"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg"
  },
  description: "The superior way to use Bitcoin in Cosmos DeFi. Use IBC to securely and efficiently bridge your BTC to Osmosis and more.",
  apis: {
    rpc: [
      {
        address: "https://stakenet-rpc.nomic.io:2096",
        provider: "nomic-io"
      },
      {
        address: "https://nomic-rpc.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-nomic.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://rpc.nomic.basementnodes.ca:443",
        provider: "Basement Nodes ⚡️"
      },
      {
        address: "https://rpc.nomic.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    rest: [{
      address: "https://app.nomic.io:8443",
      provider: "nomic-io"
    }]
  },
  explorers: [
    {
      kind: "bigdipper",
      url: "https://bigdipper.live/nomic",
      account_page: "https://bigdipper.live/nomic/accounts/${accountAddress}",
      tx_page: "https://bigdipper.live/nomic/transactions/${txHash}"
    },
    {
      kind: "Zenscan.io",
      url: "https://nomic.zenscan.io/index.php",
      account_page: "https://nomic.zenscan.io/address.php?address=${accountAddress}",
      tx_page: "https://nomic.zenscan.io/transaction.php?hash=${txHash}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/nomic",
      tx_page: "https://mainnet.whispernode.com/nomic/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/nomic/account/${accountAddress}"
    }
  ],
  images: [{
    image_sync: {
      chain_name: "nomic",
      base_denom: "unom"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg",
    theme: {
      primary_color_hex: "#6404fc"
    }
  }],
  bech32_config: {
    bech32PrefixAccAddr: "nomic",
    bech32PrefixAccPub: "nomic",
    bech32PrefixConsAddr: "nomic",
    bech32PrefixConsPub: "nomic",
    bech32PrefixValAddr: "nomic",
    bech32PrefixValPub: "nomic"
  }
};
$b.default = tU;
var zb = {};
Object.defineProperty(zb, "__esModule", { value: !0 });
const sU = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-156",
      connection_id: "connection-120"
    },
    chain_2: {
      chain_name: "nomic",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-64",
      connection_id: "connection-44"
    },
    chain_2: {
      chain_name: "nomic",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nomic",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3010",
      connection_id: "connection-2501"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6897",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
zb.default = sU;
var qb = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(gs, "__esModule", { value: !0 });
gs.ibc = gs.chain = gs.assets = void 0;
const aU = qb(Fb), oU = qb($b), rU = qb(zb);
gs.assets = aU.default;
gs.chain = oU.default;
gs.ibc = rU.default;
var us = {}, Sb = {};
Object.defineProperty(Sb, "__esModule", { value: !0 });
const iU = {
  $schema: "../assetlist.schema.json",
  chain_name: "nyx",
  assets: [{
    description: "NYX Token (NYX) is the Nym Network's native staking and governance token.",
    denom_units: [{
      denom: "unyx",
      exponent: 0
    }, {
      denom: "nyx",
      exponent: 6
    }],
    base: "unyx",
    name: "NYX",
    display: "nyx",
    symbol: "NYX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nyx.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nyx.png",
      theme: {
        primary_color_hex: "#f45135"
      }
    }]
  }, {
    description: "NYM Token (NYM) is the Nym Network's native utility token, used as the primary means to incentivize mixnet node operators.",
    denom_units: [{
      denom: "unym",
      exponent: 0
    }, {
      denom: "nym",
      exponent: 6
    }],
    base: "unym",
    name: "NYM",
    display: "nym",
    symbol: "NYM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.svg"
    },
    coingecko_id: "nym",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.svg",
      theme: {
        dark_mode: !1,
        circle: !0,
        primary_color_hex: "#151525"
      }
    }, {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_dark.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_dark.svg",
      theme: {
        dark_mode: !0,
        circle: !0,
        primary_color_hex: "#141424"
      }
    }]
  }]
};
Sb.default = iU;
var Tb = {};
Object.defineProperty(Tb, "__esModule", { value: !0 });
const cU = {
  $schema: "../chain.schema.json",
  chain_name: "nyx",
  status: "live",
  network_type: "mainnet",
  website: "https://nymtech.net/",
  pretty_name: "Nym",
  chain_type: "cosmos",
  chain_id: "nyx",
  bech32_prefix: "n",
  daemon_name: "nyxd",
  node_home: "$HOME/.nyxd",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "unym",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }, {
      denom: "unyx",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unyx"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmwasm_enabled: !0
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.nymtech.net/",
        provider: "Nym"
      },
      {
        address: "https://rpc.nyx.nodes.guru/",
        provider: "nodes guru"
      },
      {
        address: "https://rpc.nym.forbole.com/",
        provider: "forbole"
      },
      {
        address: "https://nym-mainnet-rpc.commodum.io/",
        provider: "commodum"
      },
      {
        address: "https://nym-rpc.polkachu.com/",
        provider: "Polkachu"
      }
    ],
    rest: [
      {
        address: "https://nym-api.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://api.nyx.nodes.guru/",
        provider: "nodes guru"
      },
      {
        address: "https://api.nymtech.net",
        provider: "Nym"
      }
    ],
    grpc: [{
      address: "nym-grpc.polkachu.com:15390",
      provider: "Polkachu"
    }, {
      address: "grpc.nymtech.net:443",
      provider: "Nym"
    }]
  },
  explorers: [
    {
      kind: "Nodes Guru explorer",
      url: "https://nym.explorers.guru/",
      tx_page: "https://nym.explorers.guru/transaction/${txHash}",
      account_page: "https://nym.explorers.guru/account/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/nyx",
      tx_page: "https://ezstaking.app/nyx/txs/${txHash}",
      account_page: "https://ezstaking.app/nyx/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/nyx",
      tx_page: "https://www.mintscan.io/nyx/transactions/${txHash}",
      account_page: "https://www.mintscan.io/nyx/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/nyx",
      tx_page: "https://ping.pub/nyx/tx/${txHash}"
    }
  ],
  images: [
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.svg",
      theme: {
        dark_mode: !1,
        circle: !0,
        primary_color_hex: "#151525"
      }
    },
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_dark.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_dark.svg",
      theme: {
        dark_mode: !0,
        circle: !0,
        primary_color_hex: "#141424"
      }
    },
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.png",
      theme: {
        primary_color_hex: "#151525"
      }
    }
  ]
};
Tb.default = cU;
var Rb = {};
Object.defineProperty(Rb, "__esModule", { value: !0 });
const dU = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "gravitybridge",
    client_id: "07-tendermint-33",
    connection_id: "connection-44"
  },
  chain_2: {
    chain_name: "nyx",
    client_id: "07-tendermint-1",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-18",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "nyx",
    client_id: "07-tendermint-17",
    connection_id: "connection-8"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3065",
    connection_id: "connection-2555"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-8",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-15464",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
Rb.default = dU;
var Ob = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(us, "__esModule", { value: !0 });
us.ibc = us.chain = us.assets = void 0;
const mU = Ob(Sb), hU = Ob(Tb), pU = Ob(Rb);
us.assets = mU.default;
us.chain = hU.default;
us.ibc = pU.default;
var yr = {}, Mb = {};
Object.defineProperty(Mb, "__esModule", { value: !0 });
const lU = {
  $schema: "../assetlist.schema.json",
  chain_name: "octa",
  assets: [{
    description: "The native token of Octa Chain",
    denom_units: [{
      denom: "uocta",
      exponent: 0,
      aliases: []
    }, {
      denom: "octa",
      exponent: 6,
      aliases: []
    }],
    base: "uocta",
    display: "octa",
    name: "Octa",
    symbol: "OCTA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/octa/images/octa.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/octa/images/octa.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/octa/images/octa.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/octa/images/octa.svg",
      theme: {
        primary_color_hex: "#04a7f8"
      }
    }]
  }]
};
Mb.default = lU;
var Ib = {};
Object.defineProperty(Ib, "__esModule", { value: !0 });
const gU = {
  $schema: "../chain.schema.json",
  chain_name: "octa",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Octa",
  chain_type: "cosmos",
  chain_id: "octa",
  bech32_prefix: "octa",
  daemon_name: "octadaemon",
  node_home: "$HOME/.octa",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uocta",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/octa/images/octa.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/octa/images/octa.svg"
  },
  apis: {
    rpc: [],
    rest: []
  },
  explorers: [{
    kind: "Octa explorer",
    url: "http://explorer.octa-coin.com/",
    tx_page: "http://explorer.octa-coin.com/txs/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/octa/images/octa.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/octa/images/octa.svg",
    theme: {
      primary_color_hex: "#04a7f8"
    }
  }]
};
Ib.default = gU;
var H9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(yr, "__esModule", { value: !0 });
yr.chain = yr.assets = void 0;
const uU = H9(Mb), _U = H9(Ib);
yr.assets = uU.default;
yr.chain = _U.default;
var _s = {}, Nb = {};
Object.defineProperty(Nb, "__esModule", { value: !0 });
const yU = {
  $schema: "../assetlist.schema.json",
  chain_name: "odin",
  assets: [
    {
      description: "Staking and governance token for ODIN Protocol",
      denom_units: [{
        denom: "loki",
        exponent: 0
      }, {
        denom: "odin",
        exponent: 6
      }],
      base: "loki",
      name: "ODIN",
      display: "odin",
      symbol: "ODIN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.svg"
      },
      coingecko_id: "odin-protocol",
      images: [{
        image_sync: {
          chain_name: "odin",
          base_denom: "loki"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.svg"
      }]
    },
    {
      description: "GEO token for ODIN Protocol",
      denom_units: [{
        denom: "mGeo",
        exponent: 0
      }, {
        denom: "geo",
        exponent: 6
      }],
      base: "mGeo",
      name: "GEO",
      display: "geo",
      symbol: "GEO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/geo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/geo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "odin",
          base_denom: "mGeo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/geo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/geo.svg",
        theme: {
          primary_color_hex: "#c3ebf3"
        }
      }]
    },
    {
      description: "O9W token for ODIN Protocol",
      denom_units: [{
        denom: "mO9W",
        exponent: 0
      }, {
        denom: "O9W",
        exponent: 6
      }],
      base: "mO9W",
      name: "O9W",
      display: "O9W",
      symbol: "O9W",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/o9w.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/o9w.svg"
      },
      images: [{
        image_sync: {
          chain_name: "odin",
          base_denom: "mO9W"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/o9w.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/o9w.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    }
  ]
};
Nb.default = yU;
var Pb = {};
Object.defineProperty(Pb, "__esModule", { value: !0 });
const bU = {
  $schema: "../chain.schema.json",
  chain_name: "odin",
  status: "killed",
  network_type: "mainnet",
  website: "https://odinprotocol.io/",
  pretty_name: "Odin Protocol",
  chain_type: "cosmos",
  chain_id: "odin-mainnet-freya",
  bech32_prefix: "odin",
  daemon_name: "odind",
  node_home: "$HOME/.odin",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "loki",
      fixed_min_gas_price: 0.0125,
      low_gas_price: 0.025,
      average_gas_price: 0.05,
      high_gas_price: 0.06
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "loki"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.svg"
  },
  apis: {
    rpc: [
      {
        address: "http://34.79.179.216:26657",
        provider: "Odin Protocol"
      },
      {
        address: "https://rpc.lavenderfive.com:443/odin",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://odin-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    rest: [
      {
        address: "http://34.79.179.216:1317/",
        provider: "Odin Protocol"
      },
      {
        address: "https://rest.lavenderfive.com:443/odin",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://odin-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    grpc: [{
      address: "odin.lavenderfive.com:443",
      provider: "Lavender.Five Nodes 🐝"
    }, {
      address: "odin-mainnet-grpc.autostake.com:443",
      provider: "AutoStake 🛡️ Slash Protected"
    }]
  },
  explorers: [{
    kind: "odin web",
    url: "https://mainnet.odinprotocol.io/",
    tx_page: "https://mainnet.odinprotocol.io/transactions/${txHash}"
  }, {
    kind: "ping.pub",
    url: "https://ping.pub/odin",
    tx_page: "https://ping.pub/odin/tx/${txHash}"
  }],
  images: [{
    image_sync: {
      chain_name: "odin"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.svg"
  }]
};
Pb.default = bU;
var Ub = {};
Object.defineProperty(Ub, "__esModule", { value: !0 });
const vU = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-150",
      connection_id: "connection-135"
    },
    chain_2: {
      chain_name: "odin",
      client_id: "07-tendermint-66",
      connection_id: "connection-151"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-102",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-253",
      connection_id: "connection-245"
    },
    chain_2: {
      chain_name: "odin",
      client_id: "07-tendermint-122",
      connection_id: "connection-85"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-214",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-166",
      connection_id: "connection-129"
    },
    chain_2: {
      chain_name: "odin",
      client_id: "07-tendermint-114",
      connection_id: "connection-83"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-157",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "kujira"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "odin",
      client_id: "07-tendermint-113",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2007",
      connection_id: "connection-1551"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-258",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
Ub.default = vU;
var Hb = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(_s, "__esModule", { value: !0 });
_s.ibc = _s.chain = _s.assets = void 0;
const fU = Hb(Nb), wU = Hb(Pb), xU = Hb(Ub);
_s.assets = fU.default;
_s.chain = wU.default;
_s.ibc = xU.default;
var ys = {}, Lb = {};
Object.defineProperty(Lb, "__esModule", { value: !0 });
const kU = {
  $schema: "../assetlist.schema.json",
  chain_name: "okexchain",
  assets: [{
    description: "The native token of OKExChain",
    denom_units: [{
      denom: "wei",
      exponent: 0
    }, {
      denom: "okt",
      exponent: 18
    }],
    base: "wei",
    name: "OKExChain",
    display: "okt",
    symbol: "OKT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/okexchain/images/okc.png"
    },
    coingecko_id: "oec-token",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/okexchain/images/okc.png",
      theme: {
        primary_color_hex: "#bbbbbb"
      }
    }]
  }]
};
Lb.default = kU;
var Wb = {};
Object.defineProperty(Wb, "__esModule", { value: !0 });
const AU = {
  $schema: "../chain.schema.json",
  chain_name: "okexchain",
  status: "live",
  network_type: "mainnet",
  pretty_name: "OKExChain",
  chain_type: "cosmos",
  chain_id: "exchain-66",
  bech32_prefix: "ex",
  daemon_name: "exchaind",
  node_home: "$HOME/.exchaind",
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "wei",
      low_gas_price: 2e8,
      average_gas_price: 25e7,
      high_gas_price: 4e8
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/okexchain/images/okc.png"
  },
  apis: {
    rpc: [{
      address: "https://exchaintmrpc.okex.org",
      provider: "okx chain"
    }],
    rest: []
  },
  explorers: [{
    kind: "OKLink",
    url: "https://www.oklink.com/en/okc",
    tx_page: "https://www.oklink.com/en/okc/tx/${txHash}",
    account_page: "https://www.oklink.com/en/okc/address/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/okexchain/images/okc.png",
    theme: {
      primary_color_hex: "#bbbbbb"
    }
  }]
};
Wb.default = AU;
var Vb = {};
Object.defineProperty(Vb, "__esModule", { value: !0 });
const jU = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "assetmantle",
      client_id: "07-tendermint-42",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "okexchain",
      client_id: "07-tendermint-92",
      connection_id: "connection-35"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-85",
      connection_id: "connection-54"
    },
    chain_2: {
      chain_name: "okexchain",
      client_id: "07-tendermint-5",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-44",
      connection_id: "connection-46"
    },
    chain_2: {
      chain_name: "okexchain",
      client_id: "07-tendermint-116",
      connection_id: "connection-78"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-31",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-314",
      connection_id: "connection-285"
    },
    chain_2: {
      chain_name: "okexchain",
      client_id: "07-tendermint-122",
      connection_id: "connection-92"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-212",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-52",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "okexchain",
      client_id: "07-tendermint-100",
      connection_id: "connection-44"
    },
    chain_2: {
      chain_name: "vidulum",
      client_id: "07-tendermint-5",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Vb.default = jU;
var Gb = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ys, "__esModule", { value: !0 });
ys.ibc = ys.chain = ys.assets = void 0;
const CU = Gb(Lb), EU = Gb(Wb), DU = Gb(Vb);
ys.assets = CU.default;
ys.chain = EU.default;
ys.ibc = DU.default;
var bs = {}, Kb = {};
Object.defineProperty(Kb, "__esModule", { value: !0 });
const BU = {
  $schema: "../assetlist.schema.json",
  chain_name: "omniflixhub",
  assets: [
    {
      description: "OmniFlix is a decentralized media platform that enables content creators to distribute, monetize, and manage their digital content using blockchain technology.",
      extended_description: "OmniFlix is a decentralized media platform designed to empower content creators by providing tools for the distribution, monetization, and management of digital content. By leveraging blockchain technology, OmniFlix ensures that creators retain control over their work, allowing for direct interactions with their audience and transparent revenue streams. The platform supports various media types, including video, audio, and text, enabling creators to reach a wide audience. OmniFlix's native token is used for transactions, staking, and governance, incentivizing users to participate in the platform's ecosystem and contribute to its growth and development. The platform aims to revolutionize the media industry by offering a decentralized alternative to traditional content distribution models.",
      denom_units: [{
        denom: "uflix",
        exponent: 0
      }, {
        denom: "flix",
        exponent: 6
      }],
      base: "uflix",
      name: "Flix",
      display: "flix",
      symbol: "FLIX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.svg"
      },
      coingecko_id: "omniflix-network",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.svg",
        theme: {
          primary_color_hex: "#c33635"
        }
      }],
      socials: {
        website: "https://omniflix.network/",
        twitter: "https://twitter.com/OmniFlixNetwork"
      }
    },
    {
      denom_units: [{
        denom: "ibc/A8C2D23A1E6F95DA4E48BA349667E322BD7A6C996D8A4AAE8BA72E190F3D1477",
        exponent: 0,
        aliases: ["uatom"]
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/A8C2D23A1E6F95DA4E48BA349667E322BD7A6C996D8A4AAE8BA72E190F3D1477",
      name: "Cosmos Hub Atom",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-306"
        },
        chain: {
          channel_id: "channel-12",
          path: "transfer/channel-12/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B",
        exponent: 0,
        aliases: ["uosmo"]
      }, {
        denom: "osmo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B",
      name: "Osmosis osmo",
      display: "osmo",
      symbol: "OSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo",
          channel_id: "channel-199"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/uosmo"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/43D3010F4CA111744AC8B68E460BC95E565C32928A267FA2B30609C04C10B274",
        exponent: 0,
        aliases: ["uist"]
      }, {
        denom: "ist",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/43D3010F4CA111744AC8B68E460BC95E565C32928A267FA2B30609C04C10B274",
      name: "Agoric IST (Inter Stable Token)",
      display: "ist",
      symbol: "IST",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "agoric",
          base_denom: "uist",
          channel_id: "channel-58"
        },
        chain: {
          channel_id: "channel-30",
          path: "transfer/channel-30/uist"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "agoric",
          base_denom: "uist"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.svg",
        theme: {
          primary_color_hex: "#d485e2"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/AC4C84DD7D3732CFA95A420247FAD5179BE4F42E5635E2BF0A62C67E2E2FA4A9",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/AC4C84DD7D3732CFA95A420247FAD5179BE4F42E5635E2BF0A62C67E2E2FA4A9",
      name: "USD Coin (Axelar)",
      display: "usdc",
      symbol: "USDC.axl",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "uusdc",
          channel_id: "channel-77"
        },
        chain: {
          channel_id: "channel-27",
          path: "transfer/channel-27/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "axelar",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
        theme: {
          primary_color_hex: "#2474cc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg"
      }
    },
    {
      description: "Akash Token (AKT) is the Akash Network's native utility token",
      denom_units: [{
        denom: "ibc/6901B45BC2C5418ED8B3C3C9F9A641A3DAF2D234230AFA9DF32D8F9F9434721C",
        exponent: 0,
        aliases: ["uakt"]
      }, {
        denom: "akt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/6901B45BC2C5418ED8B3C3C9F9A641A3DAF2D234230AFA9DF32D8F9F9434721C",
      name: "Akash",
      display: "akt",
      symbol: "AKT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "akash",
          base_denom: "uakt",
          channel_id: "channel-61"
        },
        chain: {
          channel_id: "channel-25",
          path: "transfer/channel-25/uakt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "akash",
          base_denom: "uakt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg",
        theme: {
          primary_color_hex: "#bc342c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/9F28238BDB687A86681B30764BA1437E079C3565D04FDD7862055A83F7E5C630",
        exponent: 0
      }, {
        denom: "baddog",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9F28238BDB687A86681B30764BA1437E079C3565D04FDD7862055A83F7E5C630",
      name: "BadDog (Osmosis)",
      display: "baddog",
      symbol: "BADDOG.osmo",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/2FFE07C4B4EFC0DDA099A16C6AF3C9CCA653CC56077E87217A585D48794B0BC7",
          channel_id: "channel-199"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/transfer/channel-113/factory/chihuahua1x4q2vkrz4dfgd9hcw0p5m2f2nuv2uqmt9xr8k2/achihuahuawifhat"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/2FFE07C4B4EFC0DDA099A16C6AF3C9CCA653CC56077E87217A585D48794B0BC7"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/baddog.png",
        theme: {
          primary_color_hex: "#F7E3C0",
          background_color_hex: "#F7E3C0",
          circle: !0
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/baddog.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/baddog.svg",
        theme: {
          primary_color_hex: "#eedebe"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/baddog.png"
      }
    }
  ]
};
Kb.default = BU;
var Xb = {};
Object.defineProperty(Xb, "__esModule", { value: !0 });
const FU = {
  $schema: "../chain.schema.json",
  chain_name: "omniflixhub",
  status: "live",
  network_type: "mainnet",
  website: "https://omniflix.network/",
  pretty_name: "OmniFlix",
  chain_type: "cosmos",
  chain_id: "omniflixhub-1",
  daemon_name: "omniflixhubd",
  node_home: "$HOME/.omniflixhub",
  bech32_prefix: "omniflix",
  slip44: 118,
  codebase: {
    cosmos_sdk_version: "v0.47.10",
    cosmwasm_version: "v0.45.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.svg"
  },
  fees: {
    fee_tokens: [{
      denom: "uflix",
      fixed_min_gas_price: 0,
      low_gas_price: 1e-3,
      average_gas_price: 25e-4,
      high_gas_price: 0.025
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uflix"
    }]
  },
  description: "Decentralized media and network layer for Creators & Sovereign Communities powered by NFTs and related distribution protocols.",
  apis: {
    rpc: [
      {
        address: "https://omniflix-rpc.kingnodes.com",
        provider: "kingnodes 👑"
      },
      {
        address: "https://rpc.omniflix.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rpc.omniflix.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://rpc-omniflixhub-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc.lavenderfive.com:443/omniflixhub",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc.omniflix.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://omniflixhub-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc-omniflix.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://omniflix-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://rpc-omniflixhub.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://omniflix-rpc.dakshavalidator.in",
        provider: "Daksha Validator"
      },
      {
        address: "https://rpc-omniflix.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "https://rpc.omniflix.stakeup.tech:443",
        provider: "StakeUp"
      },
      {
        address: "https://rpc.omniflix.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://omniflix-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://mainnet.omniflix.rpc.srv.stakr.space",
        provider: "STAKR.space"
      }
    ],
    rest: [
      {
        address: "https://api.omniflix.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://api-omniflixhub-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rest.lavenderfive.com:443/omniflixhub",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api-omniflixhub.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://api.omniflix.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://omniflix-rest.kingnodes.com",
        provider: "kingnodes 👑"
      },
      {
        address: "https://omniflixhub-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest-omniflix.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://omniflix-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://omniflix-api.dakshavalidator.in",
        provider: "Daksha Validator"
      },
      {
        address: "https://omniflix.api.staking-explorer.com",
        provider: "Daily DROP | 3% Fee"
      },
      {
        address: "https://api.omniflix.stakeup.tech",
        provider: "StakeUp"
      },
      {
        address: "https://lcd.omniflix.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://omniflix-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://mainnet.omniflix.api.srv.stakr.space",
        provider: "STAKR.space"
      }
    ],
    grpc: [
      {
        address: "https://omniflix-grpc.kingnodes.com:443",
        provider: "kingnodes 👑"
      },
      {
        address: "grpc.omniflix.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "grpc-omniflixhub-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "omniflixhub.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "grpc-omniflixhub.cosmos-spaces.cloud:2230",
        provider: "Cosmos Spaces"
      },
      {
        address: "omniflixhub-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-omniflix.architectnodes.com:1443",
        provider: "Architect Nodes"
      },
      {
        address: "services.staketab.com:9015",
        provider: "Staketab"
      },
      {
        address: "grpc-omniflix.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "grpc.omniflix.stakeup.tech:443",
        provider: "StakeUp"
      },
      {
        address: "https://grpc.omniflix.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "omniflix-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "mainnet.omniflix.grpc.stakr.space:39090",
        provider: "STAKR.space"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/omniflixhub",
      tx_page: "https://ezstaking.app/omniflixhub/txs/${txHash}",
      account_page: "https://ezstaking.app/omniflixhub/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/omniflix",
      tx_page: "https://www.mintscan.io/omniflix/transactions/${txHash}",
      account_page: "https://www.mintscan.io/omniflix/accounts/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/omniflixhub",
      tx_page: "https://atomscan.com/omniflixhub/transactions/${txHash}",
      account_page: "https://atomscan.com/omniflixhub/accounts/${accountAddress}"
    },
    {
      kind: "STAKR.space explorer",
      url: "https://explorer.stakr.space/omniflix/",
      tx_page: "https://explorer.stakr.space/omniflix/tx/${txHash}",
      account_page: "https://explorer.stakr.space/omniflix/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.svg",
    theme: {
      primary_color_hex: "#c33635"
    }
  }]
};
Xb.default = FU;
var Yb = {};
Object.defineProperty(Yb, "__esModule", { value: !0 });
const $U = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-73",
      connection_id: "connection-67"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-47",
      connection_id: "connection-40"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-58",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-119",
      connection_id: "connection-93"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-42",
      connection_id: "connection-35"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-39",
      connection_id: "connection-42"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-49",
      connection_id: "connection-43"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-32",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-122",
      connection_id: "connection-109"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-44",
      connection_id: "connection-37"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-77",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-656",
      connection_id: "connection-501"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-23",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-306",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-108",
      connection_id: "connection-78"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-43",
      connection_id: "connection-36"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-70",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-68",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-51",
      connection_id: "connection-49"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-44",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-8",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1829",
      connection_id: "connection-1431"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-199",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
Yb.default = $U;
var Jb = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(bs, "__esModule", { value: !0 });
bs.ibc = bs.chain = bs.assets = void 0;
const zU = Jb(Kb), qU = Jb(Xb), SU = Jb(Yb);
bs.assets = zU.default;
bs.chain = qU.default;
bs.ibc = SU.default;
var vs = {}, Zb = {};
Object.defineProperty(Zb, "__esModule", { value: !0 });
const TU = {
  $schema: "../assetlist.schema.json",
  chain_name: "onex",
  assets: [{
    description: "The native token of ONEX",
    denom_units: [{
      denom: "aonex",
      exponent: 0
    }, {
      denom: "onex",
      exponent: 18
    }],
    base: "aonex",
    name: "ONEX",
    display: "onex",
    symbol: "ONEX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onex/images/onex.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onex/images/onex.svg"
    },
    keywords: ["dex"],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onex/images/onex.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onex/images/onex.svg"
    }]
  }]
};
Zb.default = TU;
var Qb = {};
Object.defineProperty(Qb, "__esModule", { value: !0 });
const RU = {
  $schema: "../chain.schema.json",
  chain_name: "onex",
  status: "live",
  website: "https://app.onomy.io/",
  network_type: "mainnet",
  pretty_name: "ONEX",
  chain_type: "cosmos",
  chain_id: "onex-mainnet-1",
  bech32_prefix: "onomy",
  daemon_name: "onexd",
  node_home: "$HOME/.onomy_onex",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "aonex",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aonex"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45.16"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onex/images/onex.png",
    theme: {
      primary_color_hex: "#000000"
    }
  }],
  apis: {
    rpc: [{
      address: "https://rpc.mainnet.onex.onomy.io",
      provider: "pendulum"
    }],
    rest: [{
      address: "https://rest.mainnet.onex.onomy.io",
      provider: "pendulum"
    }],
    grpc: [{
      address: "a.node.mainnet.onomy.io:19091",
      provider: "pendulum"
    }]
  },
  explorers: [{
    kind: "Dexplorer - must enter rpc link provided above",
    url: "https://dexplorer.cakralabs.site",
    tx_page: "https://dexplorer.cakralabs.site/txs/${txHash}",
    account_page: "https://dexplorer.cakralabs.site/${accountAddress}"
  }],
  keywords: ["dex"],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onex/images/onex.png"
  }
};
Qb.default = RU;
var ev = {};
Object.defineProperty(ev, "__esModule", { value: !0 });
const OU = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-163",
      connection_id: "connection-204"
    },
    chain_2: {
      chain_name: "onex",
      client_id: "07-tendermint-1",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-145",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-98",
      connection_id: "connection-91"
    },
    chain_2: {
      chain_name: "onex",
      client_id: "07-tendermint-6",
      connection_id: "connection-14"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-78",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "onex",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "onomy",
      client_id: "07-tendermint-12",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "onex",
      client_id: "07-tendermint-7",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3202",
      connection_id: "connection-2659"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-74628",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
ev.default = OU;
var nv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(vs, "__esModule", { value: !0 });
vs.ibc = vs.chain = vs.assets = void 0;
const MU = nv(Zb), IU = nv(Qb), NU = nv(ev);
vs.assets = MU.default;
vs.chain = IU.default;
vs.ibc = NU.default;
var fs = {}, tv = {};
Object.defineProperty(tv, "__esModule", { value: !0 });
const PU = {
  $schema: "../assetlist.schema.json",
  chain_name: "onomy",
  assets: [{
    description: "The native token of Onomy Protocol",
    denom_units: [{
      denom: "anom",
      exponent: 0
    }, {
      denom: "nom",
      exponent: 18
    }],
    base: "anom",
    name: "Nom",
    display: "nom",
    symbol: "NOM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onomy/images/nom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onomy/images/nom.svg"
    },
    keywords: [
      "dex",
      "stablecoin",
      "bridge",
      "staking"
    ],
    coingecko_id: "onomy-protocol",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onomy/images/nom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onomy/images/nom.svg",
      theme: {
        primary_color_hex: "#1c1c28"
      }
    }]
  }]
};
tv.default = PU;
var sv = {};
Object.defineProperty(sv, "__esModule", { value: !0 });
const UU = {
  $schema: "../chain.schema.json",
  chain_name: "onomy",
  status: "live",
  network_type: "mainnet",
  website: "https://onomy.io/",
  pretty_name: "Onomy",
  chain_type: "cosmos",
  chain_id: "onomy-mainnet-1",
  bech32_prefix: "onomy",
  daemon_name: "onomyd",
  node_home: "$HOME/.onomyd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "anom",
      low_gas_price: 0,
      average_gas_price: 0.03,
      high_gas_price: 0.06
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "anom"
    }]
  },
  codebase: {
    cosmos_sdk_version: "onomyprotocol/onomy-sdk v0.45.16-onomy-dev"
  },
  apis: {
    rpc: [{
      address: "https://rpc-mainnet.onomy.io",
      provider: "onomy"
    }, {
      address: "https://onomy-mainnet-rpc.autostake.com:443",
      provider: "AutoStake 🛡️ Slash Protected"
    }],
    rest: [{
      address: "https://rest-mainnet.onomy.io",
      provider: "onomy"
    }, {
      address: "https://onomy-mainnet-lcd.autostake.com:443",
      provider: "AutoStake 🛡️ Slash Protected"
    }],
    grpc: []
  },
  explorers: [{
    kind: "mintscan",
    url: "https://www.mintscan.io/onomy-protocol",
    tx_page: "https://www.mintscan.io/onomy-protocol/transactions/${txHash}",
    account_page: "https://www.mintscan.io/onomy-protocol/accounts/${accountAddress}"
  }, {
    kind: "ezstaking",
    url: "https://ezstaking.app/onomy",
    tx_page: "https://ezstaking.app/onomy/txs/${txHash}",
    account_page: "https://ezstaking.app/onomy/account/${accountAddress}"
  }],
  keywords: [
    "dex",
    "stablecoin",
    "bridge",
    "staking",
    "ics",
    "rwa"
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onomy/images/nom.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onomy/images/nom.svg",
    theme: {
      primary_color_hex: "#1c1c28"
    }
  }]
};
sv.default = UU;
var av = {};
Object.defineProperty(av, "__esModule", { value: !0 });
const HU = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "onex",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "onomy",
    client_id: "07-tendermint-12",
    connection_id: "connection-12"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-11",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "onomy",
    client_id: "07-tendermint-0",
    connection_id: "connection-1"
  },
  chain_2: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2405",
    connection_id: "connection-1892"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-525",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
av.default = HU;
var ov = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(fs, "__esModule", { value: !0 });
fs.ibc = fs.chain = fs.assets = void 0;
const LU = ov(tv), WU = ov(sv), VU = ov(av);
fs.assets = LU.default;
fs.chain = WU.default;
fs.ibc = VU.default;
var ws = {}, rv = {};
Object.defineProperty(rv, "__esModule", { value: !0 });
const GU = {
  $schema: "../assetlist.schema.json",
  chain_name: "oraichain",
  assets: [
    {
      description: "The native token of Oraichain",
      denom_units: [{
        denom: "orai",
        exponent: 0
      }, {
        denom: "ORAI",
        exponent: 6
      }],
      base: "orai",
      name: "Oraichain",
      display: "ORAI",
      symbol: "ORAI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-token.svg"
      },
      coingecko_id: "oraichain-token",
      socials: {
        website: "https://orai.io/",
        twitter: "https://x.com/oraichain"
      },
      images: [
        {
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-token.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-token.svg",
          theme: {
            circle: !0,
            primary_color_hex: "#000000",
            background_color_hex: "#FFFFFF"
          }
        },
        {
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-white.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-white.svg",
          theme: {
            circle: !1,
            dark_mode: !0,
            primary_color_hex: "#FFFFFF"
          }
        },
        {
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai.svg",
          theme: {
            circle: !1,
            dark_mode: !1,
            primary_color_hex: "#000000"
          }
        }
      ]
    },
    {
      description: "The ATOM native token of Oraichain.",
      denom_units: [{
        denom: "ibc/A2E2EEC9057A4A1C2C0A6A4C78B0239118DF5F278830F50B4A6BDD7A66506B78",
        exponent: 0
      }, {
        denom: "atom",
        exponent: 6
      }],
      base: "ibc/A2E2EEC9057A4A1C2C0A6A4C78B0239118DF5F278830F50B4A6BDD7A66506B78",
      name: "ATOM",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-301"
        },
        chain: {
          channel_id: "channel-15",
          path: "transfer/channel-15/uatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }]
    },
    {
      description: "The OSMO native token of Oraichain.",
      denom_units: [{
        denom: "ibc/9C4DCD21B48231D0BC2AC3D1B74A864746B37E4292694C93C617324250D002FC",
        exponent: 0
      }, {
        denom: "osmo",
        exponent: 6
      }],
      base: "ibc/9C4DCD21B48231D0BC2AC3D1B74A864746B37E4292694C93C617324250D002FC",
      name: "OSMO",
      display: "osmo",
      symbol: "OSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo",
          channel_id: "channel-216"
        },
        chain: {
          channel_id: "channel-13",
          path: "transfer/channel-13/uosmo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }]
    },
    {
      description: "The INJ token for the Oraichain.",
      denom_units: [{
        denom: "ibc/49D820DFDE9F885D7081725A58202ABA2F465CAEE4AFBC683DFB79A8E013E83E",
        exponent: 0
      }, {
        denom: "inj",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/49D820DFDE9F885D7081725A58202ABA2F465CAEE4AFBC683DFB79A8E013E83E",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "inj",
          channel_id: "channel-147"
        },
        chain: {
          channel_id: "channel-146",
          path: "transfer/channel-146/inj"
        }
      }],
      name: "Injective",
      display: "inj",
      symbol: "INJ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg"
      },
      images: [{
        image_sync: {
          chain_name: "injective",
          base_denom: "inj"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg",
        theme: {
          primary_color_hex: "#04a2fc"
        }
      }]
    },
    {
      description: "The Wrapped INJ token for the Oraichain.",
      type_asset: "sdk.coin",
      address: "orai19rtmkk6sn4tppvjmp5d5zj6gfsdykrl5rw2euu5gwur3luheuuusesqn49",
      denom_units: [{
        denom: "cw20:orai19rtmkk6sn4tppvjmp5d5zj6gfsdykrl5rw2euu5gwur3luheuuusesqn49",
        exponent: 0
      }, {
        denom: "inj",
        exponent: 6
      }],
      base: "cw20:orai19rtmkk6sn4tppvjmp5d5zj6gfsdykrl5rw2euu5gwur3luheuuusesqn49",
      name: "Injective",
      display: "inj",
      symbol: "INJ",
      traces: [{
        type: "wrapped",
        counterparty: {
          chain_name: "oraichain",
          base_denom: "ibc/49D820DFDE9F885D7081725A58202ABA2F465CAEE4AFBC683DFB79A8E013E83E"
        },
        provider: "Oraichain"
      }],
      images: [{
        image_sync: {
          chain_name: "oraichain",
          base_denom: "ibc/49D820DFDE9F885D7081725A58202ABA2F465CAEE4AFBC683DFB79A8E013E83E"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg",
        theme: {
          primary_color_hex: "#04a2fc"
        }
      }]
    },
    {
      description: "The USDT token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai12hzjxfh77wl572gdzct2fxv2arxcwh6gykc7qh",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai12hzjxfh77wl572gdzct2fxv2arxcwh6gykc7qh",
      base: "cw20:orai12hzjxfh77wl572gdzct2fxv2arxcwh6gykc7qh",
      name: "Usdt",
      display: "usdt",
      symbol: "USDT",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    },
    {
      description: "The AIRI token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai10ldgzued6zjp0mkqwsv2mux3ml50l97c74x8sg",
        exponent: 0
      }, {
        denom: "airi",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai10ldgzued6zjp0mkqwsv2mux3ml50l97c74x8sg",
      base: "cw20:orai10ldgzued6zjp0mkqwsv2mux3ml50l97c74x8sg",
      name: "Airight",
      display: "airi",
      coingecko_id: "airight",
      symbol: "AIRI",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/airi.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/airi.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/airi.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/airi.svg"
      }
    },
    {
      description: "The ORAIX token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai1lus0f0rhx8s03gdllx2n6vhkmf0536dv57wfge",
        exponent: 0
      }, {
        denom: "oraix",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai1lus0f0rhx8s03gdllx2n6vhkmf0536dv57wfge",
      base: "cw20:orai1lus0f0rhx8s03gdllx2n6vhkmf0536dv57wfge",
      name: "Oraix",
      display: "oraix",
      symbol: "ORAIX",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/oraix.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/oraix.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/oraix.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/oraix.svg"
      }
    },
    {
      description: "USDC issued on Oraichain.",
      denom_units: [{
        denom: "cw20:orai15un8msx3n5zf9ahlxmfeqd2kwa5wm0nrpxer304m9nd5q6qq0g6sku5pdd",
        exponent: 0
      }, {
        denom: "usdc",
        exponent: 6
      }],
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "noble",
          base_denom: "uusdc",
          channel_id: "channel-34"
        },
        chain: {
          channel_id: "channel-301",
          path: "transfer/channel-301/uusdc"
        }
      }],
      type_asset: "cw20",
      address: "orai15un8msx3n5zf9ahlxmfeqd2kwa5wm0nrpxer304m9nd5q6qq0g6sku5pdd",
      base: "cw20:orai15un8msx3n5zf9ahlxmfeqd2kwa5wm0nrpxer304m9nd5q6qq0g6sku5pdd",
      name: "Usdc",
      display: "usdc",
      symbol: "USDC",
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }
    },
    {
      description: "The KAWAII token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai1nd4r053e3kgedgld2ymen8l9yrw8xpjyaal7j5",
        exponent: 0
      }, {
        denom: "kwt",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai1nd4r053e3kgedgld2ymen8l9yrw8xpjyaal7j5",
      base: "cw20:orai1nd4r053e3kgedgld2ymen8l9yrw8xpjyaal7j5",
      name: "Kwt",
      display: "kwt",
      symbol: "KWT",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/kwt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/kwt.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/kwt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/kwt.svg"
      }
    },
    {
      description: "The MILKY token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai1gzvndtzceqwfymu2kqhta2jn6gmzxvzqwdgvjw",
        exponent: 0
      }, {
        denom: "milky",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai1gzvndtzceqwfymu2kqhta2jn6gmzxvzqwdgvjw",
      base: "cw20:orai1gzvndtzceqwfymu2kqhta2jn6gmzxvzqwdgvjw",
      name: "Milky",
      display: "milky",
      symbol: "MILKY",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/milky-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/milky-token.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/milky-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/milky-token.svg"
      }
    },
    {
      description: "The scORAI token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai1065qe48g7aemju045aeyprflytemx7kecxkf5m7u5h5mphd0qlcs47pclp",
        exponent: 0
      }, {
        denom: "scorai",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai1065qe48g7aemju045aeyprflytemx7kecxkf5m7u5h5mphd0qlcs47pclp",
      base: "cw20:orai1065qe48g7aemju045aeyprflytemx7kecxkf5m7u5h5mphd0qlcs47pclp",
      name: "Scorai",
      display: "scorai",
      symbol: "SCORAI",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/scorai.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/scorai.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/scorai.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/scorai.svg"
      }
    },
    {
      description: "The TRX token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai1c7tpjenafvgjtgm9aqwm7afnke6c56hpdms8jc6md40xs3ugd0es5encn0",
        exponent: 0
      }, {
        denom: "wtrx",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai1c7tpjenafvgjtgm9aqwm7afnke6c56hpdms8jc6md40xs3ugd0es5encn0",
      base: "cw20:orai1c7tpjenafvgjtgm9aqwm7afnke6c56hpdms8jc6md40xs3ugd0es5encn0",
      name: "Wtrx",
      display: "wtrx",
      symbol: "wTRX",
      images: [{
        image_sync: {
          chain_name: "tron",
          base_denom: "sun"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#FF060A",
          background_color_hex: "#FF060A"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.svg"
      }
    },
    {
      description: "The scATOM token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai19q4qak2g3cj2xc2y3060t0quzn3gfhzx08rjlrdd3vqxhjtat0cq668phq",
        exponent: 0
      }, {
        denom: "scatom",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai19q4qak2g3cj2xc2y3060t0quzn3gfhzx08rjlrdd3vqxhjtat0cq668phq",
      base: "cw20:orai19q4qak2g3cj2xc2y3060t0quzn3gfhzx08rjlrdd3vqxhjtat0cq668phq",
      name: "scATOM",
      display: "scatom",
      symbol: "scATOM",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/scatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/scatom.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/scatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/scatom.svg"
      }
    },
    {
      description: "The xOCH token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai1lplapmgqnelqn253stz6kmvm3ulgdaytn89a8mz9y85xq8wd684s6xl3lt",
        exponent: 0
      }, {
        denom: "xoch",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai1lplapmgqnelqn253stz6kmvm3ulgdaytn89a8mz9y85xq8wd684s6xl3lt",
      base: "cw20:orai1lplapmgqnelqn253stz6kmvm3ulgdaytn89a8mz9y85xq8wd684s6xl3lt",
      name: "Xoch",
      display: "xoch",
      symbol: "xOCH",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/och.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/och.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/och.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/och.svg"
      }
    },
    {
      description: "The wETH token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai1dqa52a7hxxuv8ghe7q5v0s36ra0cthea960q2cukznleqhk0wpnshfegez",
        exponent: 0
      }, {
        denom: "weth",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai1dqa52a7hxxuv8ghe7q5v0s36ra0cthea960q2cukznleqhk0wpnshfegez",
      base: "cw20:orai1dqa52a7hxxuv8ghe7q5v0s36ra0cthea960q2cukznleqhk0wpnshfegez",
      name: "Weth",
      display: "weth",
      symbol: "wETH",
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        theme: {
          primary_color_hex: "#303030"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg"
      }
    },
    {
      description: "The BTC token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai10g6frpysmdgw5tdqke47als6f97aqmr8s3cljsvjce4n5enjftcqtamzsd",
        exponent: 0
      }, {
        denom: "btc",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai10g6frpysmdgw5tdqke47als6f97aqmr8s3cljsvjce4n5enjftcqtamzsd",
      base: "cw20:orai10g6frpysmdgw5tdqke47als6f97aqmr8s3cljsvjce4n5enjftcqtamzsd",
      name: "Btc",
      display: "btc",
      symbol: "BTC",
      images: [{
        image_sync: {
          chain_name: "bitcoin",
          base_denom: "sat"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/bitcoin/images/btc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/bitcoin/images/btc.svg",
        theme: {
          primary_color_hex: "#f4941c",
          background_color_hex: "#f4941c",
          circle: !0
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/bitcoin/images/btc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/bitcoin/images/btc.svg"
      }
    },
    {
      description: "The OCH token is the cw20 token for the Oraichain.",
      denom_units: [{
        denom: "cw20:orai1hn8w33cqvysun2aujk5sv33tku4pgcxhhnsxmvnkfvdxagcx0p8qa4l98q",
        exponent: 0
      }, {
        denom: "och",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "orai1hn8w33cqvysun2aujk5sv33tku4pgcxhhnsxmvnkfvdxagcx0p8qa4l98q",
      base: "cw20:orai1hn8w33cqvysun2aujk5sv33tku4pgcxhhnsxmvnkfvdxagcx0p8qa4l98q",
      name: "Och",
      display: "och",
      symbol: "OCH",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/och.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/och.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/och.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/och.svg"
      }
    },
    {
      description: "The TON native token of Oraichain",
      extended_description: "Toincoin has been bridged from The Open Network to Oraichain.",
      denom_units: [{
        denom: "factory/orai1wuvhex9xqs3r539mvc6mtm7n20fcj3qr2m0y9khx6n5vtlngfzes3k0rq9/ton",
        exponent: 0,
        aliases: ["nanoTon"]
      }, {
        denom: "ton",
        exponent: 9
      }],
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ton",
          base_denom: "nanoton"
        },
        provider: "Oraichain Labs TON Bridge"
      }],
      base: "factory/orai1wuvhex9xqs3r539mvc6mtm7n20fcj3qr2m0y9khx6n5vtlngfzes3k0rq9/ton",
      name: "Toncoin",
      display: "ton",
      symbol: "TON",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ton",
          base_denom: "nanoton"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#0088CC",
          background_color_hex: "#0088CC"
        }
      }]
    }
  ]
};
rv.default = GU;
var iv = {};
Object.defineProperty(iv, "__esModule", { value: !0 });
const KU = {
  $schema: "../chain.schema.json",
  chain_name: "oraichain",
  status: "live",
  network_type: "mainnet",
  website: "https://orai.io/",
  pretty_name: "Oraichain",
  chain_type: "cosmos",
  chain_id: "Oraichain",
  bech32_prefix: "orai",
  daemon_name: "oraid",
  node_home: "$WORKSPACE/.oraid",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "orai",
      fixed_min_gas_price: 0,
      low_gas_price: 3e-3,
      average_gas_price: 5e-3,
      high_gas_price: 7e-3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "orai"
    }]
  },
  codebase: {
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30.2"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.orai.io",
        provider: "oraichain-team"
      },
      {
        address: "https://rpc.orai.pfc.zone/",
        provider: "PFC"
      },
      {
        address: "https://rpc-orai.nodine.id/",
        provider: "Nodine.ID"
      },
      {
        address: "https://oraichain-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc-oraichain.mms.team",
        provider: "MMS"
      },
      {
        address: "https://rpc-orai.blockval.io/",
        provider: "Blockval"
      },
      {
        address: "https://mainnet-orai-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://rpc.orai.mortysnode.nl",
        provider: "Morty's Nodes"
      },
      {
        address: "https://orai.rpc.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://oraichain-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://orai-rpc.imdev.app",
        provider: "imORAI"
      }
    ],
    rest: [
      {
        address: "http://lcd.orai.io",
        provider: "oraichain-team"
      },
      {
        address: "https://oraichain-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://api-oraichain.mms.team",
        provider: "MMS"
      },
      {
        address: "https://api-orai.blockval.io",
        provider: "Blockval"
      },
      {
        address: "https://mainnet-orai-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://orai.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://oraichain-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "grpc-oraichain.mms.team:443",
        provider: "MMS"
      },
      {
        address: "grpc.orai.pfc.zone:443",
        provider: "PFC"
      },
      {
        address: "oraichain-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-orai.blockval.io:9390",
        provider: "Blockval"
      },
      {
        address: "mainnet-orai.konsortech.xyz:33090",
        provider: "KonsorTech"
      },
      {
        address: "orai.grpc.m.stavr.tech:110",
        provider: "🔥STAVR🔥"
      },
      {
        address: "oraichain-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "oraiscan",
      url: "https://scan.orai.io",
      tx_page: "https://scan.orai.io/txs/${txHash}"
    },
    {
      kind: "Nodine Explorer",
      url: "https://explorer.co.id/orai",
      tx_page: "https://explorer.co.id/orai/tx/${txHash}"
    },
    {
      kind: "Blockval Explorer",
      url: "https://explorer.blockval.io/oraichain",
      tx_page: "https://explorer.blockval.io/oraichain/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/orai",
      tx_page: "https://atomscan.com/orai/transactions/${txHash}",
      account_page: "https://atomscan.com/orai/accounts/${accountAddress}"
    },
    {
      kind: "KonsorTech Explorer",
      url: "https://explorer.konsortech.xyz/oraichain",
      tx_page: "https://explorer.konsortech.xyz/oraichain/transactions/${txHash}",
      account_page: "https://explorer.konsortech.xyz/oraichain/accounts/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/Orai-Mainnet",
      tx_page: "https://explorer.stavr.tech/Orai-Mainnet/transactions/${txHash}",
      account_page: "https://explorer.stavr.tech/Orai-Mainnet/accounts/${accountAddress}"
    },
    {
      kind: "imORAI ORAIchain Explorer",
      url: "https://explorer.imdev.app/oraichain",
      tx_page: "https://explorer.imdev.app/oraichain/tx/${txHash}",
      account_page: "https://explorer.imdev.app/oraichain/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai.svg",
    theme: {
      circle: !1,
      dark_mode: !1,
      primary_color_hex: "#000000"
    }
  }]
};
iv.default = KU;
var cv = {};
Object.defineProperty(cv, "__esModule", { value: !0 });
const XU = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-12",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "oraichain",
      client_id: "07-tendermint-74",
      connection_id: "connection-42"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-651",
      connection_id: "connection-497"
    },
    chain_2: {
      chain_name: "oraichain",
      client_id: "07-tendermint-47",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-301",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "oraidex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-211",
      connection_id: "connection-194"
    },
    chain_2: {
      chain_name: "oraichain",
      client_id: "07-tendermint-105",
      connection_id: "connection-82"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-147",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-146",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "oraidex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-60",
      connection_id: "connection-58"
    },
    chain_2: {
      chain_name: "oraichain",
      client_id: "07-tendermint-106",
      connection_id: "connection-83"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-147",
        port_id: "wasm.orai195269awwnt5m6c843q6w7hp8rt0k7syfu9de4h0wz384slshuzps8y7ccm"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "oraidex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "oraichain",
      client_id: "07-tendermint-49",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1882",
      connection_id: "connection-1464"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-216",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "oraichain",
      client_id: "07-tendermint-178",
      connection_id: "connection-142"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-195",
      connection_id: "connection-190"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-135",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-217",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }, {
      chain_1: {
        channel_id: "channel-140",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-222",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  }
];
cv.default = XU;
var dv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ws, "__esModule", { value: !0 });
ws.ibc = ws.chain = ws.assets = void 0;
const YU = dv(rv), JU = dv(iv), ZU = dv(cv);
ws.assets = YU.default;
ws.chain = JU.default;
ws.ibc = ZU.default;
var xs = {}, mv = {};
Object.defineProperty(mv, "__esModule", { value: !0 });
const QU = {
  $schema: "../assetlist.schema.json",
  chain_name: "osmosis",
  assets: [
    {
      description: "The native token of Osmosis",
      extended_description: `Osmosis (OSMO) is the premier DEX and cross-chain DeFi hub within the Cosmos ecosystem, a network of over 50 sovereign, interoperable blockchains seamlessly connected through the Inter-Blockchain Communication Protocol (IBC). Pioneering in its approach, Osmosis offers a dynamic trading and liquidity provision experience, integrating non-IBC assets from other ecosystems, including Ethereum, Solana, Avalanche, and Polkadot. Initially adopting Balancer-style pools, Osmosis now also features a concentrated liquidity model that is orders of magnitude more capital efficient, meaning that significantly less liquidity is required to handle the same amount of trading volume with minimal slippage.

As a true appchain, Osmosis has greater control over the full blockchain stack than traditional smart contract DEXs, which must follow the code of the parent chain that it is built on. This fine-grained control has enabled, for example, the development of Superfluid Staking, an extension of Proof of Stake that allows assets at the application layer to be staked to secure the chain. The customizability of appchains also allows implementing features like the Protocol Revenue module, which enables Osmosis to conduct on-chain arbitrage on behalf of OSMO stakers, balancing prices across pools while generating real yield revenue from this volume. Additionally, as a sovereign appchain, Osmosis governance can vote on upgrades to the protocol. One example of this was the introduction of a Taker Fee, which switched on the collection of exchange fees to generate diverse yield from Osmosis volume and distribute it to OSMO stakers.

Osmosis is bringing the full centralized exchange experience to the decentralized world by building a cross-chain native DEX and trading suite that connects all chains over IBC, including Ethereum and Bitcoin. To reach this goal, Osmosis hosts an ever-expanding suite of DeFi applications aimed at providing a one-stop experience that includes lending, credit, margin, DeFi strategy vaults, power perps, fiat on-ramps, NFTs, stablecoins, and more — all of the functionalities that centralized exchange offer and more, in the trust-minimized environment of decentralized finance.`,
      denom_units: [{
        denom: "uosmo",
        exponent: 0
      }, {
        denom: "osmo",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "uosmo",
      name: "Osmosis",
      display: "osmo",
      symbol: "OSMO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }],
      coingecko_id: "osmosis",
      keywords: ["dex", "staking"],
      socials: {
        website: "https://osmosis.zone",
        twitter: "https://twitter.com/osmosiszone"
      }
    },
    {
      description: "ION is the second native token of Osmosis.",
      extended_description: "ION DAO is governed by ION holders. ION is the second native token of Osmosis, the biggest DEX in Cosmos. The origin of ION was a meme coin, but ION DAO has been trying to find ways to add values on ION.",
      denom_units: [{
        denom: "uion",
        exponent: 0
      }, {
        denom: "ion",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "uion",
      name: "Ion DAO",
      display: "ion",
      symbol: "ION",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.svg",
        theme: {
          primary_color_hex: "#4453c7"
        }
      }],
      coingecko_id: "ion",
      keywords: ["memecoin", "defi"],
      socials: {
        website: "https://ion.wtf",
        twitter: "https://twitter.com/_IONDAO"
      }
    },
    {
      description: "Circle's stablecoin on Axelar",
      denom_units: [{
        denom: "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858",
      name: "USDC (Ethereum via Axelar)",
      display: "usdc",
      symbol: "USDC.eth.axl",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "uusdc",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/uusdc"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.svg",
        theme: {
          primary_color_hex: "#2474cb"
        }
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
        theme: {
          primary_color_hex: "#2474cc"
        }
      }]
    },
    {
      description: `Ethereum (ETH) is a decentralized, open-source blockchain system featuring smart contract functionality. It's the native cryptocurrency of the Ethereum platform, often regarded as the second most popular digital currency after Bitcoin. Ethereum was proposed in late 2013 and development was crowdfunded in 2014, leading to its network going live on 30 July 2015.

ETH, as a digital currency, is used for a variety of purposes within the Ethereum ecosystem, including the execution of decentralized smart contracts and as a mode of payment. Unlike Bitcoin, Ethereum was designed to be a platform for applications that can operate without the need for intermediaries, using blockchain technology. This has made Ethereum a leading platform for various applications, including decentralized finance (DeFi), non-fungible tokens (NFTs), and more. Ethereum is constantly evolving, with a significant upgrade termed Ethereum 2.0, which aims to improve its scalability, security, and sustainability.`,
      denom_units: [{
        denom: "ibc/EA1D43981D5C9A1C4AAEA9C23BB1D4FA126BA9BC7020A25E0AE4AA841EA25DC5",
        exponent: 0,
        aliases: ["weth-wei"]
      }, {
        denom: "weth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/EA1D43981D5C9A1C4AAEA9C23BB1D4FA126BA9BC7020A25E0AE4AA841EA25DC5",
      name: "Ethereum (Axelar)",
      display: "weth",
      symbol: "ETH.axl",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Ethereum"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "weth-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/weth-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.axl.svg"
      },
      images: [
        {
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.axl.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.axl.svg"
        },
        {
          image_sync: {
            chain_name: "axelar",
            base_denom: "weth-wei"
          },
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/weth.png",
          theme: {
            primary_color_hex: "#3a3444"
          }
        },
        {
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg",
          theme: {
            primary_color_hex: "#303030"
          }
        }
      ]
    },
    {
      description: "Wrapped Bitcoin on Axelar",
      denom_units: [{
        denom: "ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F",
        exponent: 0,
        aliases: ["wbtc-satoshi"]
      }, {
        denom: "wbtc",
        exponent: 8
      }],
      type_asset: "ics20",
      base: "ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F",
      name: "Wrapped Bitcoin (Ethereum via Axelar)",
      display: "wbtc",
      symbol: "WBTC.eth.axl",
      traces: [
        {
          type: "bridge",
          counterparty: {
            chain_name: "bitcoin",
            base_denom: "sat"
          },
          provider: "BitGo, Kyber, and Ren"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "wbtc-satoshi",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/wbtc-satoshi"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.axl.svg",
        theme: {
          primary_color_hex: "#312b3a"
        }
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "wbtc-satoshi"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/wbtc.png",
        theme: {
          primary_color_hex: "#41394d"
        }
      }]
    },
    {
      description: "Tether's USD stablecoin on Axelar",
      denom_units: [{
        denom: "ibc/8242AD24008032E457D2E12D46588FD39FB54FB29680C6C7663D296B383C37C4",
        exponent: 0,
        aliases: ["uusdt"]
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/8242AD24008032E457D2E12D46588FD39FB54FB29680C6C7663D296B383C37C4",
      name: "Tether USD (Ethereum via Axelar)",
      display: "usdt",
      symbol: "USDT.eth.axl",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Tether"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "uusdt",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/uusdt"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.axl.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.axl.png",
        theme: {
          primary_color_hex: "#049393"
        }
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "uusdt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdt.svg",
        theme: {
          primary_color_hex: "#54ac94"
        }
      }]
    },
    {
      description: "Multi-Collateral Dai, brings a lot of new and exciting features, such as support for new CDP collateral types and Dai Savings Rate.",
      denom_units: [{
        denom: "ibc/0CD3A0285E1341859B5E86B6AB7682F023D03E97607CCC1DC95706411D866DF7",
        exponent: 0,
        aliases: ["dai-wei"]
      }, {
        denom: "dai",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/0CD3A0285E1341859B5E86B6AB7682F023D03E97607CCC1DC95706411D866DF7",
      name: "Dai Stablecoin",
      display: "dai",
      symbol: "DAI",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "MakerDAO"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "dai-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/dai-wei"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      }]
    },
    {
      description: "Binance USD (BUSD) is a dollar-backed stablecoin issued and custodied by Paxos Trust Company, and regulated by the New York State Department of Financial Services. BUSD is available directly for sale 1:1 with USD on Paxos.com and will be listed for trading on Binance.",
      denom_units: [{
        denom: "ibc/6329DD8CF31A334DD5BE3F68C846C9FE313281362B37686A62343BAC1EB1546D",
        exponent: 0,
        aliases: ["busd-wei"]
      }, {
        denom: "busd",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/6329DD8CF31A334DD5BE3F68C846C9FE313281362B37686A62343BAC1EB1546D",
      name: "Binance USD",
      display: "busd",
      symbol: "BUSD",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Binance"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x4fabb145d64652a948d72533023f6e7a623c7c53"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "busd-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/busd-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x4fabb145d64652a948d72533023f6e7a623c7c53"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/busd.svg",
        theme: {
          primary_color_hex: "#f3bb0c"
        }
      }]
    },
    {
      description: "The native staking and governance token of the Cosmos Hub.",
      denom_units: [{
        denom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        exponent: 0,
        aliases: ["uatom"]
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
      name: "Cosmos Hub",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-141"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/uatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }]
    },
    {
      description: "CRO is the native token of the Crypto.org Chain, referred to as Native CRO.",
      denom_units: [{
        denom: "ibc/E6931F78057F7CC5DA0FD6CEF82FF39373A6E0452BF1FD76910B93292CF356C1",
        exponent: 0,
        aliases: ["basecro"]
      }, {
        denom: "cro",
        exponent: 8
      }],
      type_asset: "ics20",
      base: "ibc/E6931F78057F7CC5DA0FD6CEF82FF39373A6E0452BF1FD76910B93292CF356C1",
      name: "Cronos POS Chain",
      display: "cro",
      symbol: "CRO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cryptoorgchain",
          base_denom: "basecro",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-5",
          path: "transfer/channel-5/basecro"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cryptoorgchain",
          base_denom: "basecro"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cro.svg"
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cronos/images/cronos.png",
        theme: {
          primary_color_hex: "#0c2c71"
        }
      }]
    },
    {
      description: "BNB powers the BNB Chain ecosystem and is the native coin of the BNB Beacon Chain and BNB Smart Chain.",
      denom_units: [{
        denom: "ibc/F4A070A6D78496D53127EA85C094A9EC87DFC1F36071B8CCDDBD020F933D213D",
        exponent: 0,
        aliases: ["wbnb-wei"]
      }, {
        denom: "wbnb",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/F4A070A6D78496D53127EA85C094A9EC87DFC1F36071B8CCDDBD020F933D213D",
      name: "Binance Coin",
      display: "wbnb",
      symbol: "BNB",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "binancesmartchain",
            base_denom: "wei"
          },
          chain: {
            contract: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
          },
          provider: "Binance"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "binancesmartchain",
            base_denom: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "wbnb-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/wbnb-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/bnb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/bnb.svg"
      },
      images: [{
        image_sync: {
          chain_name: "binancesmartchain",
          base_denom: "wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/bnb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/bnb.svg",
        theme: {
          primary_color_hex: "#f3bb0c"
        }
      }]
    },
    {
      description: "Polygon (formerly Matic) Network brings massive scale to Ethereum using an adapted version of Plasma with PoS based side chains. Polygon is a well-structured, easy-to-use platform for Ethereum scaling and infrastructure development.",
      denom_units: [{
        denom: "ibc/AB589511ED0DD5FA56171A39978AFBF1371DB986EC1C3526CE138A16377E39BB",
        exponent: 0,
        aliases: ["wmatic-wei"]
      }, {
        denom: "wmatic",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/AB589511ED0DD5FA56171A39978AFBF1371DB986EC1C3526CE138A16377E39BB",
      name: "Polygon",
      display: "wmatic",
      symbol: "MATIC",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "polygon",
            base_denom: "wei"
          },
          provider: "Polygon"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "polygon",
            base_denom: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "wmatic-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/wmatic-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polygon/images/matic-purple.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polygon/images/matic-purple.svg"
      },
      images: [{
        image_sync: {
          chain_name: "polygon",
          base_denom: "wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polygon/images/matic-purple.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polygon/images/matic-purple.svg",
        theme: {
          primary_color_hex: "#8444e4"
        }
      }]
    },
    {
      description: "AVAX is the native token of Avalanche. It is a hard-capped, scarce asset that is used to pay for fees, secure the platform through staking, and provide a basic unit of account between the multiple subnets created on Avalanche.",
      denom_units: [{
        denom: "ibc/6F62F01D913E3FFE472A38C78235B8F021B511BC6596ADFF02615C8F83D3B373",
        exponent: 0,
        aliases: ["wavax-wei"]
      }, {
        denom: "avax",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/6F62F01D913E3FFE472A38C78235B8F021B511BC6596ADFF02615C8F83D3B373",
      name: "Avalanche",
      display: "avax",
      symbol: "AVAX",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "avalanche",
            base_denom: "wei"
          },
          provider: "Avalanche"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "avalanche",
            base_denom: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "wavax-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/wavax-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/avax.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/avax.svg"
      },
      images: [{
        image_sync: {
          chain_name: "avalanche",
          base_denom: "wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/avax.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/avax.svg",
        theme: {
          primary_color_hex: "#eb4444"
        }
      }]
    },
    {
      description: "The native staking token of Terra Classic.",
      denom_units: [
        {
          denom: "ibc/0EF15DF2F02480ADE0BB6E85D9EBB5DAEA2836D3860E9F97F9AADE4F57A31AA0",
          exponent: 0,
          aliases: ["microluna", "uluna"]
        },
        {
          denom: "mluna",
          exponent: 3,
          aliases: ["milliluna"]
        },
        {
          denom: "luna",
          exponent: 6,
          aliases: ["lunc"]
        }
      ],
      type_asset: "ics20",
      base: "ibc/0EF15DF2F02480ADE0BB6E85D9EBB5DAEA2836D3860E9F97F9AADE4F57A31AA0",
      name: "Luna Classic",
      display: "luna",
      symbol: "LUNC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "terra",
          base_denom: "uluna",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-72",
          path: "transfer/channel-72/uluna"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.svg"
      },
      images: [{
        image_sync: {
          chain_name: "terra",
          base_denom: "uluna"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.svg",
        theme: {
          primary_color_hex: "#fcdb5b"
        }
      }]
    },
    {
      description: "The native token of JUNO Chain",
      denom_units: [{
        denom: "ibc/46B44899322F3CD854D2D46DEEF881958467CDD4B3B10086DA49296BBED94BED",
        exponent: 0,
        aliases: ["ujuno"]
      }, {
        denom: "juno",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/46B44899322F3CD854D2D46DEEF881958467CDD4B3B10086DA49296BBED94BED",
      name: "Juno",
      display: "juno",
      symbol: "JUNO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "juno",
          base_denom: "ujuno",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-42",
          path: "transfer/channel-42/ujuno"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "ujuno"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/juno.svg",
        theme: {
          primary_color_hex: "#fa7b7b"
        }
      }]
    },
    {
      description: "Wrapped Polkadot on Axelar",
      denom_units: [{
        denom: "ibc/3FF92D26B407FD61AE95D975712A7C319CDE28DE4D80BDC9978D935932B991D7",
        exponent: 0,
        aliases: ["dot-planck"]
      }, {
        denom: "dot",
        exponent: 10
      }],
      type_asset: "ics20",
      base: "ibc/3FF92D26B407FD61AE95D975712A7C319CDE28DE4D80BDC9978D935932B991D7",
      name: "Polkadot (Moonbeam via Axelar)",
      display: "dot",
      symbol: "DOT.glmr.axl",
      traces: [
        {
          type: "bridge",
          counterparty: {
            chain_name: "polkadot",
            base_denom: "Planck"
          },
          provider: "Polkadot Parachain"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "moonbeam",
            base_denom: "0xffffffff1fcacbd218edc0eba20fc2308c778080"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "dot-planck",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/dot-planck"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/dot.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/dot.axl.svg"
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "dot-planck"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg",
        theme: {
          primary_color_hex: "#e4047c"
        }
      }]
    },
    {
      description: "The native EVM, governance and staking token of the Evmos Hub",
      denom_units: [{
        denom: "ibc/6AE98883D4D5D5FF9E50D7130F1305DA2FFA0C652D1DD9C123657C6B4EB2DF8A",
        exponent: 0,
        aliases: ["aevmos"]
      }, {
        denom: "evmos",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/6AE98883D4D5D5FF9E50D7130F1305DA2FFA0C652D1DD9C123657C6B4EB2DF8A",
      name: "Evmos",
      display: "evmos",
      symbol: "EVMOS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "evmos",
          base_denom: "aevmos",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-204",
          path: "transfer/channel-204/aevmos"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg"
      },
      images: [{
        image_sync: {
          chain_name: "evmos",
          base_denom: "aevmos"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/evmos.svg",
        theme: {
          primary_color_hex: "#ec4c34"
        }
      }]
    },
    {
      description: "The native staking and governance token of Kava",
      denom_units: [{
        denom: "ibc/57AA1A70A4BC9769C525EBF6386F7A21536E04A79D62E1981EFCEF9428EBB205",
        exponent: 0,
        aliases: ["ukava"]
      }, {
        denom: "kava",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/57AA1A70A4BC9769C525EBF6386F7A21536E04A79D62E1981EFCEF9428EBB205",
      name: "Kava",
      display: "kava",
      symbol: "KAVA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "ukava",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-143",
          path: "transfer/channel-143/ukava"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "ukava"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/kava.svg",
        theme: {
          primary_color_hex: "#e64942"
        }
      }]
    },
    {
      description: "The native token of Secret Network",
      denom_units: [{
        denom: "ibc/0954E1C28EB7AF5B72D24F3BC2B47BBB2FDF91BDDFD57B74B99E133AED40972A",
        exponent: 0,
        aliases: ["uscrt"]
      }, {
        denom: "scrt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0954E1C28EB7AF5B72D24F3BC2B47BBB2FDF91BDDFD57B74B99E133AED40972A",
      name: "Secret Network",
      display: "scrt",
      symbol: "SCRT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "uscrt",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-88",
          path: "transfer/channel-88/uscrt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "uscrt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The USD stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "ibc/BE1BB42D4BE3C30D50B68D7C41DB4DFCE9678E8EF8C539F6E6A9345048894FCC",
          exponent: 0,
          aliases: ["microusd", "uusd"]
        },
        {
          denom: "musd",
          exponent: 3,
          aliases: ["milliusd"]
        },
        {
          denom: "ust",
          exponent: 6,
          aliases: ["ustc"]
        }
      ],
      type_asset: "ics20",
      base: "ibc/BE1BB42D4BE3C30D50B68D7C41DB4DFCE9678E8EF8C539F6E6A9345048894FCC",
      name: "TerraClassicUSD",
      display: "ust",
      symbol: "USTC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "terra",
          base_denom: "uusd",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-72",
          path: "transfer/channel-72/uusd"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ust.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ust.svg"
      },
      images: [{
        image_sync: {
          chain_name: "terra",
          base_denom: "uusd"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ust.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ust.svg",
        theme: {
          primary_color_hex: "#5493f2"
        }
      }]
    },
    {
      description: "The native token of Stargaze",
      denom_units: [{
        denom: "ibc/987C17B11ABC2B20019178ACE62929FE9840202CE79498E29FE8E5CB02B7C0A4",
        exponent: 0,
        aliases: ["ustars"]
      }, {
        denom: "stars",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/987C17B11ABC2B20019178ACE62929FE9840202CE79498E29FE8E5CB02B7C0A4",
      name: "Stargaze",
      display: "stars",
      symbol: "STARS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "ustars",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-75",
          path: "transfer/channel-75/ustars"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stargaze",
          base_denom: "ustars"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg",
        theme: {
          primary_color_hex: "#db2777"
        }
      }]
    },
    {
      description: "The native token of Chihuahua Chain",
      denom_units: [{
        denom: "ibc/B9E0A1A524E98BB407D3CED8720EFEFD186002F90C1B1B7964811DD0CCC12228",
        exponent: 0,
        aliases: ["uhuahua"]
      }, {
        denom: "huahua",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B9E0A1A524E98BB407D3CED8720EFEFD186002F90C1B1B7964811DD0CCC12228",
      name: "Chihuahua",
      display: "huahua",
      symbol: "HUAHUA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "chihuahua",
          base_denom: "uhuahua",
          channel_id: "channel-7"
        },
        chain: {
          channel_id: "channel-113",
          path: "transfer/channel-113/uhuahua"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.svg"
      },
      images: [{
        image_sync: {
          chain_name: "chihuahua",
          base_denom: "uhuahua"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.svg",
        theme: {
          primary_color_hex: "#343434"
        }
      }]
    },
    {
      description: "The XPRT token is primarily a governance token for the Persistence chain.",
      denom_units: [{
        denom: "ibc/A0CC0CF735BFB30E730C70019D4218A1244FF383503FF7579C9201AB93CA9293",
        exponent: 0,
        aliases: ["uxprt"]
      }, {
        denom: "xprt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/A0CC0CF735BFB30E730C70019D4218A1244FF383503FF7579C9201AB93CA9293",
      name: "Persistence",
      display: "xprt",
      symbol: "XPRT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "persistence",
          base_denom: "uxprt",
          channel_id: "channel-6"
        },
        chain: {
          channel_id: "channel-4",
          path: "transfer/channel-4/uxprt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "persistence",
          base_denom: "uxprt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#E59636",
          background_color_hex: "#000000"
        }
      }]
    },
    {
      description: "pSTAKE is a liquid staking protocol unlocking the liquidity of staked assets. Stakers of PoS tokens can stake their assets while maintaining the liquidity of these assets. Users earn staking rewards + receive 1:1 pegged staked representative tokens which can be used to generate additional yield.",
      denom_units: [{
        denom: "ibc/8061A06D3BD4D52C4A28FFECF7150D370393AF0BA661C3776C54FF32836C3961",
        exponent: 0,
        aliases: [
          "gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
          "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
          "ibc/A6E3AF63B3C906416A9AF7A556C59EA4BD50E617EFFE6299B99700CCB780E444"
        ]
      }, {
        denom: "pstake",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/8061A06D3BD4D52C4A28FFECF7150D370393AF0BA661C3776C54FF32836C3961",
      name: "pSTAKE Finance",
      display: "pstake",
      symbol: "PSTAKE",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "persistence",
            base_denom: "uxprt"
          },
          provider: "Persistence"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006"
          },
          provider: "Gravity Bridge"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gravitybridge",
            base_denom: "gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
            channel_id: "channel-24"
          },
          chain: {
            channel_id: "channel-38",
            path: "transfer/channel-38/gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "persistence",
            base_denom: "ibc/A6E3AF63B3C906416A9AF7A556C59EA4BD50E617EFFE6299B99700CCB780E444",
            channel_id: "channel-6"
          },
          chain: {
            channel_id: "channel-4",
            path: "transfer/channel-4/transfer/channel-38/gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.svg",
        theme: {
          primary_color_hex: "#050505"
        }
      }]
    },
    {
      description: "Akash Token (AKT) is the Akash Network's native utility token, used as the primary means to govern, secure the blockchain, incentivize participants, and provide a default mechanism to store and exchange value.",
      denom_units: [{
        denom: "ibc/1480B8FD20AD5FCAE81EA87584D269547DD4D436843C1D20F15E00EB64743EF4",
        exponent: 0,
        aliases: ["uakt"]
      }, {
        denom: "akt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1480B8FD20AD5FCAE81EA87584D269547DD4D436843C1D20F15E00EB64743EF4",
      name: "Akash",
      display: "akt",
      symbol: "AKT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "akash",
          base_denom: "uakt",
          channel_id: "channel-9"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/uakt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "akash",
          base_denom: "uakt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg",
        theme: {
          primary_color_hex: "#bc342c"
        }
      }]
    },
    {
      description: "REGEN coin is the token for the Regen Network Platform",
      denom_units: [{
        denom: "ibc/1DCC8A6CB5689018431323953344A9F6CC4D0BFB261E88C9F7777372C10CD076",
        exponent: 0,
        aliases: ["uregen"]
      }, {
        denom: "regen",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1DCC8A6CB5689018431323953344A9F6CC4D0BFB261E88C9F7777372C10CD076",
      name: "Regen",
      display: "regen",
      symbol: "REGEN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "regen",
          base_denom: "uregen",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-8",
          path: "transfer/channel-8/uregen"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.svg"
      },
      images: [{
        image_sync: {
          chain_name: "regen",
          base_denom: "uregen"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.svg",
        theme: {
          primary_color_hex: "#56b790"
        }
      }]
    },
    {
      description: "DVPN is the native token of the Sentinel Hub.",
      denom_units: [{
        denom: "ibc/9712DBB13B9631EDFA9BF61B55F1B2D290B2ADB67E3A4EB3A875F3B6081B3B84",
        exponent: 0,
        aliases: ["udvpn"]
      }, {
        denom: "dvpn",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9712DBB13B9631EDFA9BF61B55F1B2D290B2ADB67E3A4EB3A875F3B6081B3B84",
      name: "Sentinel",
      display: "dvpn",
      symbol: "DVPN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "sentinel",
          base_denom: "udvpn",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/udvpn"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.svg"
      },
      images: [{
        image_sync: {
          chain_name: "sentinel",
          base_denom: "udvpn"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.svg",
        theme: {
          primary_color_hex: "#10a7ef"
        }
      }]
    },
    {
      description: "The IRIS token is the native governance token for the IrisNet chain.",
      denom_units: [{
        denom: "ibc/7C4D60AA95E5A7558B0A364860979CA34B7FF8AAF255B87AF9E879374470CEC0",
        exponent: 0,
        aliases: ["uiris"]
      }, {
        denom: "iris",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/7C4D60AA95E5A7558B0A364860979CA34B7FF8AAF255B87AF9E879374470CEC0",
      name: "IRISnet",
      display: "iris",
      symbol: "IRIS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "irisnet",
          base_denom: "uiris",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-6",
          path: "transfer/channel-6/uiris"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.svg"
      },
      images: [{
        image_sync: {
          chain_name: "irisnet",
          base_denom: "uiris"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.svg",
        theme: {
          primary_color_hex: "#5664ad"
        }
      }]
    },
    {
      description: "IOV coin is the token for the Starname (IOV) Asset Name Service",
      denom_units: [{
        denom: "ibc/52B1AA623B34EB78FD767CEA69E8D7FA6C9CFE1FBF49C5406268FD325E2CC2AC",
        exponent: 0,
        aliases: ["uiov"]
      }, {
        denom: "iov",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/52B1AA623B34EB78FD767CEA69E8D7FA6C9CFE1FBF49C5406268FD325E2CC2AC",
      name: "Starname",
      display: "iov",
      symbol: "IOV",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "starname",
          base_denom: "uiov",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-15",
          path: "transfer/channel-15/uiov"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.svg"
      },
      images: [{
        image_sync: {
          chain_name: "starname",
          base_denom: "uiov"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.svg",
        theme: {
          primary_color_hex: "#5c64b4"
        }
      }]
    },
    {
      description: "e-Money NGM staking token. In addition to earning staking rewards the token is bought back and burned based on e-Money stablecoin inflation.",
      denom_units: [{
        denom: "ibc/1DC495FCEFDA068A3820F903EDBD78B942FBD204D7E93D3BA2B432E9669D1A59",
        exponent: 0,
        aliases: ["ungm"]
      }, {
        denom: "ngm",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1DC495FCEFDA068A3820F903EDBD78B942FBD204D7E93D3BA2B432E9669D1A59",
      name: "e-Money",
      display: "ngm",
      symbol: "NGM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "emoney",
          base_denom: "ungm",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-37",
          path: "transfer/channel-37/ungm"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.svg"
      },
      images: [{
        image_sync: {
          chain_name: "emoney",
          base_denom: "ungm"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.svg",
        theme: {
          primary_color_hex: "#caf2ea"
        }
      }]
    },
    {
      description: "e-Money EUR stablecoin. Audited and backed by fiat EUR deposits and government bonds.",
      denom_units: [{
        denom: "ibc/5973C068568365FFF40DEDCF1A1CB7582B6116B731CD31A12231AE25E20B871F",
        exponent: 0,
        aliases: ["eeur"]
      }, {
        denom: "eur",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/5973C068568365FFF40DEDCF1A1CB7582B6116B731CD31A12231AE25E20B871F",
      name: "e-Money EUR",
      display: "eur",
      symbol: "EEUR",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "emoney",
          base_denom: "eeur",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-37",
          path: "transfer/channel-37/eeur"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.svg"
      },
      images: [{
        image_sync: {
          chain_name: "emoney",
          base_denom: "eeur"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.svg",
        theme: {
          primary_color_hex: "#f4c808"
        }
      }]
    },
    {
      description: "LIKE is the native staking and governance token of LikeCoin chain, a Decentralized Publishing Infrastructure to empower content ownership, authenticity, and provenance.",
      denom_units: [{
        denom: "ibc/9989AD6CCA39D1131523DB0617B50F6442081162294B4795E26746292467B525",
        exponent: 0,
        aliases: ["nanolike"]
      }, {
        denom: "like",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/9989AD6CCA39D1131523DB0617B50F6442081162294B4795E26746292467B525",
      name: "LikeCoin",
      display: "like",
      symbol: "LIKE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "likecoin",
          base_denom: "nanolike",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-53",
          path: "transfer/channel-53/nanolike"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.svg"
      },
      images: [{
        image_sync: {
          chain_name: "likecoin",
          base_denom: "nanolike"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.svg",
        theme: {
          primary_color_hex: "#2d656c"
        }
      }]
    },
    {
      description: "The native token of IXO Chain",
      denom_units: [{
        denom: "ibc/F3FF7A84A73B62921538642F9797C423D2B4C4ACB3C7FCFFCE7F12AA69909C4B",
        exponent: 0,
        aliases: ["uixo"]
      }, {
        denom: "ixo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F3FF7A84A73B62921538642F9797C423D2B4C4ACB3C7FCFFCE7F12AA69909C4B",
      name: "Impacts Hub",
      display: "ixo",
      symbol: "IXO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "impacthub",
          base_denom: "uixo",
          channel_id: "channel-4"
        },
        chain: {
          channel_id: "channel-38",
          path: "transfer/channel-38/uixo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "impacthub",
          base_denom: "uixo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg",
        theme: {
          primary_color_hex: "#2c4484"
        }
      }]
    },
    {
      description: "The BCNA coin is the transactional token within the BitCanna network, serving the legal cannabis industry through its payment network, supply chain and trust network.",
      denom_units: [{
        denom: "ibc/D805F1DA50D31B96E4282C1D4181EDDFB1A44A598BFF5666F4B43E4B8BEA95A5",
        exponent: 0,
        aliases: ["ubcna"]
      }, {
        denom: "bcna",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D805F1DA50D31B96E4282C1D4181EDDFB1A44A598BFF5666F4B43E4B8BEA95A5",
      name: "BitCanna",
      display: "bcna",
      symbol: "BCNA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bitcanna",
          base_denom: "ubcna",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-51",
          path: "transfer/channel-51/ubcna"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.svg"
      },
      images: [{
        image_sync: {
          chain_name: "bitcanna",
          base_denom: "ubcna"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitcanna/images/bcna.svg",
        theme: {
          primary_color_hex: "#3cc494"
        }
      }]
    },
    {
      description: "BitSong Native Token",
      denom_units: [{
        denom: "ibc/4E5444C35610CC76FC94E7F7886B93121175C28262DDFDDE6F84E82BF2425452",
        exponent: 0,
        aliases: ["ubtsg"]
      }, {
        denom: "btsg",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4E5444C35610CC76FC94E7F7886B93121175C28262DDFDDE6F84E82BF2425452",
      name: "BitSong",
      display: "btsg",
      symbol: "BTSG",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bitsong",
          base_denom: "ubtsg",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-73",
          path: "transfer/channel-73/ubtsg"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.svg"
      },
      images: [{
        image_sync: {
          chain_name: "bitsong",
          base_denom: "ubtsg"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/btsg.svg",
        theme: {
          primary_color_hex: "#c8307f"
        }
      }]
    },
    {
      description: "The native token of Ki Chain",
      denom_units: [{
        denom: "ibc/B547DC9B897E7C3AA5B824696110B8E3D2C31E3ED3F02FF363DCBAD82457E07E",
        exponent: 0,
        aliases: ["uxki"]
      }, {
        denom: "xki",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B547DC9B897E7C3AA5B824696110B8E3D2C31E3ED3F02FF363DCBAD82457E07E",
      name: "Ki",
      display: "xki",
      symbol: "XKI",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kichain",
          base_denom: "uxki",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-77",
          path: "transfer/channel-77/uxki"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kichain",
          base_denom: "uxki"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.svg",
        theme: {
          primary_color_hex: "#1c04fc"
        }
      }]
    },
    {
      description: "Panacea is a public blockchain launched by MediBloc, which is the key infrastructure for reinventing the patient-centered healthcare data ecosystem",
      denom_units: [{
        denom: "ibc/3BCCC93AD5DF58D11A6F8A05FA8BC801CBA0BA61A981F57E91B8B598BF8061CB",
        exponent: 0,
        aliases: ["umed"]
      }, {
        denom: "med",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/3BCCC93AD5DF58D11A6F8A05FA8BC801CBA0BA61A981F57E91B8B598BF8061CB",
      name: "Medibloc",
      display: "med",
      symbol: "MED",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "panacea",
          base_denom: "umed",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-82",
          path: "transfer/channel-82/umed"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.svg"
      },
      images: [{
        image_sync: {
          chain_name: "panacea",
          base_denom: "umed"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.svg",
        theme: {
          primary_color_hex: "#2474ec"
        }
      }]
    },
    {
      description: "The staking token of Bostrom",
      denom_units: [{
        denom: "ibc/FE2CD1E6828EC0FAB8AF39BAC45BC25B965BA67CCBC50C13A14BD610B0D1E2C4",
        exponent: 0,
        aliases: ["boot"]
      }],
      type_asset: "ics20",
      base: "ibc/FE2CD1E6828EC0FAB8AF39BAC45BC25B965BA67CCBC50C13A14BD610B0D1E2C4",
      name: "bostrom",
      display: "ibc/FE2CD1E6828EC0FAB8AF39BAC45BC25B965BA67CCBC50C13A14BD610B0D1E2C4",
      symbol: "BOOT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bostrom",
          base_denom: "boot",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-95",
          path: "transfer/channel-95/boot"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.svg"
      },
      images: [{
        image_sync: {
          chain_name: "bostrom",
          base_denom: "boot"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/boot.svg",
        theme: {
          primary_color_hex: "#4cea4e"
        }
      }]
    },
    {
      description: "Native Token of Comdex Protocol",
      denom_units: [{
        denom: "ibc/EA3E1640F9B1532AB129A571203A0B9F789A7F14BB66E350DCBFA18E1A1931F0",
        exponent: 0,
        aliases: ["ucmdx"]
      }, {
        denom: "cmdx",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/EA3E1640F9B1532AB129A571203A0B9F789A7F14BB66E350DCBFA18E1A1931F0",
      name: "Comdex",
      display: "cmdx",
      symbol: "CMDX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "comdex",
          base_denom: "ucmdx",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-87",
          path: "transfer/channel-87/ucmdx"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.svg"
      },
      images: [{
        image_sync: {
          chain_name: "comdex",
          base_denom: "ucmdx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmdx.svg",
        theme: {
          primary_color_hex: "#fc4454"
        }
      }]
    },
    {
      description: "Native token for the cheqd network",
      denom_units: [{
        denom: "ibc/7A08C6F11EF0F59EB841B9F788A87EC9F2361C7D9703157EC13D940DC53031FA",
        exponent: 0,
        aliases: ["ncheq"]
      }, {
        denom: "cheq",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/7A08C6F11EF0F59EB841B9F788A87EC9F2361C7D9703157EC13D940DC53031FA",
      name: "Cheqd",
      display: "cheq",
      symbol: "CHEQ",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cheqd",
          base_denom: "ncheq",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-108",
          path: "transfer/channel-108/ncheq"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cheqd",
          base_denom: "ncheq"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.svg",
        theme: {
          primary_color_hex: "#fc5f04"
        }
      }]
    },
    {
      description: "Native token of the Lum Network",
      denom_units: [{
        denom: "ibc/8A34AF0C1943FD0DFCDE9ADBF0B2C9959C45E87E6088EA2FC6ADACD59261B8A2",
        exponent: 0,
        aliases: ["ulum"]
      }, {
        denom: "lum",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/8A34AF0C1943FD0DFCDE9ADBF0B2C9959C45E87E6088EA2FC6ADACD59261B8A2",
      name: "Lum Network",
      display: "lum",
      symbol: "LUM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "lumnetwork",
          base_denom: "ulum",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-115",
          path: "transfer/channel-115/ulum"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.svg"
      },
      images: [{
        image_sync: {
          chain_name: "lumnetwork",
          base_denom: "ulum"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumnetwork/images/lum.svg",
        theme: {
          primary_color_hex: "#080808"
        }
      }]
    },
    {
      description: "The native token of Vidulum",
      denom_units: [{
        denom: "ibc/E7B35499CFBEB0FF5778127ABA4FB2C4B79A6B8D3D831D4379C4048C238796BD",
        exponent: 0,
        aliases: ["uvdl"]
      }, {
        denom: "vdl",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E7B35499CFBEB0FF5778127ABA4FB2C4B79A6B8D3D831D4379C4048C238796BD",
      name: "Vidulum (Vidulum)",
      display: "vdl",
      symbol: "VDL.vdl",
      traces: [{
        type: "legacy-mintage",
        counterparty: {
          chain_name: "beezee",
          base_denom: "factory/bze13gzq40che93tgfm9kzmkpjamah5nj0j73pyhqk/uvdl"
        },
        provider: "Vidulum"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "vidulum",
          base_denom: "uvdl",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-124",
          path: "transfer/channel-124/uvdl"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg"
      },
      images: [{
        image_sync: {
          chain_name: "vidulum",
          base_denom: "uvdl"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg",
        theme: {
          primary_color_hex: "#3454bc"
        }
      }, {
        image_sync: {
          chain_name: "vidulum",
          base_denom: "uvdl"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg",
        theme: {
          primary_color_hex: "#3454bc"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "The native token of Desmos",
      denom_units: [{
        denom: "ibc/EA4C0A9F72E2CEDF10D0E7A9A6A22954DB3444910DB5BE980DF59B05A46DAD1C",
        exponent: 0,
        aliases: ["udsm"]
      }, {
        denom: "dsm",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/EA4C0A9F72E2CEDF10D0E7A9A6A22954DB3444910DB5BE980DF59B05A46DAD1C",
      name: "Desmos",
      display: "dsm",
      symbol: "DSM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "desmos",
          base_denom: "udsm",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-135",
          path: "transfer/channel-135/udsm"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.svg"
      },
      images: [{
        image_sync: {
          chain_name: "desmos",
          base_denom: "udsm"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.svg",
        theme: {
          primary_color_hex: "#fb804e"
        }
      }]
    },
    {
      description: "Native token of Dig Chain",
      denom_units: [{
        denom: "ibc/307E5C96C8F60D1CBEE269A9A86C0834E1DB06F2B3788AE4F716EDB97A48B97D",
        exponent: 0,
        aliases: ["udig"]
      }, {
        denom: "dig",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/307E5C96C8F60D1CBEE269A9A86C0834E1DB06F2B3788AE4F716EDB97A48B97D",
      name: "Dig Chain",
      display: "dig",
      symbol: "DIG",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "dig",
          base_denom: "udig",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-128",
          path: "transfer/channel-128/udig"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dig/images/dig.png"
      },
      images: [{
        image_sync: {
          chain_name: "dig",
          base_denom: "udig"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dig/images/dig.png",
        theme: {
          primary_color_hex: "#1b1433"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "Somm Token (SOMM) is the native staking token of the Sommelier Chain",
      denom_units: [
        {
          denom: "ibc/9BBA9A1C257E971E38C1422780CE6F0B0686F0A3085E2D61118D904BFE0F5F5E",
          exponent: 0,
          aliases: ["microsomm", "usomm"]
        },
        {
          denom: "msomm",
          exponent: 3,
          aliases: ["millisomm"]
        },
        {
          denom: "somm",
          exponent: 6
        }
      ],
      type_asset: "ics20",
      base: "ibc/9BBA9A1C257E971E38C1422780CE6F0B0686F0A3085E2D61118D904BFE0F5F5E",
      name: "Sommelier",
      display: "somm",
      symbol: "SOMM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "sommelier",
          base_denom: "usomm",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-165",
          path: "transfer/channel-165/usomm"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.svg"
      },
      images: [{
        image_sync: {
          chain_name: "sommelier",
          base_denom: "usomm"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.svg",
        theme: {
          primary_color_hex: "#f36353"
        }
      }]
    },
    {
      description: "The native token of BandChain",
      denom_units: [{
        denom: "ibc/F867AE2112EFE646EC71A25CD2DFABB8927126AC1E19F1BBF0FF693A4ECA05DE",
        exponent: 0,
        aliases: ["uband"]
      }, {
        denom: "band",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F867AE2112EFE646EC71A25CD2DFABB8927126AC1E19F1BBF0FF693A4ECA05DE",
      name: "Band Protocol",
      display: "band",
      symbol: "BAND",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bandchain",
          base_denom: "uband",
          channel_id: "channel-83"
        },
        chain: {
          channel_id: "channel-148",
          path: "transfer/channel-148/uband"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.svg"
      },
      images: [{
        image_sync: {
          chain_name: "bandchain",
          base_denom: "uband"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bandchain/images/band.svg",
        theme: {
          primary_color_hex: "#4424e4"
        }
      }]
    },
    {
      description: "The native token of Konstellation Network",
      denom_units: [{
        denom: "ibc/346786EA82F41FE55FAD14BF69AD8BA9B36985406E43F3CB23E6C45A285A9593",
        exponent: 0,
        aliases: ["udarc"]
      }, {
        denom: "darc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/346786EA82F41FE55FAD14BF69AD8BA9B36985406E43F3CB23E6C45A285A9593",
      name: "Konstellation",
      display: "darc",
      symbol: "DARC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "konstellation",
          base_denom: "udarc",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-171",
          path: "transfer/channel-171/udarc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/konstellation/images/darc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/konstellation/images/darc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "konstellation",
          base_denom: "udarc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/konstellation/images/darc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/konstellation/images/darc.svg",
        theme: {
          primary_color_hex: "#042a61"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "The native token of Umee",
      denom_units: [{
        denom: "ibc/67795E528DF67C5606FC20F824EA39A6EF55BA133F4DC79C90A8C47A0901E17C",
        exponent: 0,
        aliases: ["uumee"]
      }, {
        denom: "umee",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/67795E528DF67C5606FC20F824EA39A6EF55BA133F4DC79C90A8C47A0901E17C",
      name: "UX Chain",
      display: "umee",
      symbol: "UMEE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "umee",
          base_denom: "uumee",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-184",
          path: "transfer/channel-184/uumee"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.svg"
      },
      images: [{
        image_sync: {
          chain_name: "umee",
          base_denom: "uumee"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.svg",
        theme: {
          primary_color_hex: "#22f2e9"
        }
      }]
    },
    {
      description: "The native token of Gravity Bridge",
      denom_units: [{
        denom: "ibc/E97634A40119F1898989C2A23224ED83FDD0A57EA46B3A094E287288D1672B44",
        exponent: 0,
        aliases: ["ugraviton"]
      }, {
        denom: "graviton",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E97634A40119F1898989C2A23224ED83FDD0A57EA46B3A094E287288D1672B44",
      name: "Gravity Bridge",
      display: "graviton",
      symbol: "GRAV",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "gravitybridge",
          base_denom: "ugraviton",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-144",
          path: "transfer/channel-144/ugraviton"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.svg"
      },
      images: [{
        image_sync: {
          chain_name: "gravitybridge",
          base_denom: "ugraviton"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gravitybridge/images/grav.svg",
        theme: {
          primary_color_hex: "#042ca4"
        }
      }]
    },
    {
      description: "The native token of Decentr",
      denom_units: [{
        denom: "ibc/9BCB27203424535B6230D594553F1659C77EC173E36D9CF4759E7186EE747E84",
        exponent: 0,
        aliases: ["udec"]
      }, {
        denom: "dec",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9BCB27203424535B6230D594553F1659C77EC173E36D9CF4759E7186EE747E84",
      name: "Decentr",
      display: "dec",
      symbol: "DEC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "decentr",
          base_denom: "udec",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-181",
          path: "transfer/channel-181/udec"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.svg"
      },
      images: [{
        image_sync: {
          chain_name: "decentr",
          base_denom: "udec"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/decentr/images/dec.svg",
        theme: {
          primary_color_hex: "#4678e9"
        }
      }]
    },
    {
      description: "The native token cw20 for Marble DAO on Juno Chain",
      denom_units: [{
        denom: "ibc/F6B691D5F7126579DDC87357B09D653B47FDCE0A3383FF33C8D8B544FE29A8A6",
        exponent: 0,
        aliases: ["cw20:juno1g2g7ucurum66d42g8k5twk34yegdq8c82858gz0tq2fc75zy7khssgnhjl"]
      }, {
        denom: "marble",
        exponent: 3
      }],
      type_asset: "ics20",
      base: "ibc/F6B691D5F7126579DDC87357B09D653B47FDCE0A3383FF33C8D8B544FE29A8A6",
      name: "Marble",
      display: "marble",
      symbol: "MARBLE",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1g2g7ucurum66d42g8k5twk34yegdq8c82858gz0tq2fc75zy7khssgnhjl",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1g2g7ucurum66d42g8k5twk34yegdq8c82858gz0tq2fc75zy7khssgnhjl"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/marble.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/marble.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1g2g7ucurum66d42g8k5twk34yegdq8c82858gz0tq2fc75zy7khssgnhjl"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/marble.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/marble.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The native governance token of Carbon",
      denom_units: [{
        denom: "ibc/8FEFAE6AECF6E2A255585617F781F35A8D5709A545A804482A261C0C9548A9D3",
        exponent: 0,
        aliases: ["swth"]
      }, {
        denom: "dswth",
        exponent: 8,
        aliases: ["SWTH"]
      }],
      type_asset: "ics20",
      base: "ibc/8FEFAE6AECF6E2A255585617F781F35A8D5709A545A804482A261C0C9548A9D3",
      name: "Carbon",
      display: "dswth",
      symbol: "SWTH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "carbon",
          base_denom: "swth",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-188",
          path: "transfer/channel-188/swth"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.svg"
      },
      images: [{
        image_sync: {
          chain_name: "carbon",
          base_denom: "swth"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/carbon/images/swth.svg",
        theme: {
          primary_color_hex: "#a5edf2"
        }
      }]
    },
    {
      description: "The native token of Cerberus Chain",
      denom_units: [{
        denom: "ibc/41999DF04D9441DAC0DF5D8291DF4333FBCBA810FFD63FDCE34FDF41EF37B6F7",
        exponent: 0,
        aliases: ["ucrbrus"]
      }, {
        denom: "crbrus",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/41999DF04D9441DAC0DF5D8291DF4333FBCBA810FFD63FDCE34FDF41EF37B6F7",
      name: "Cerberus",
      display: "crbrus",
      symbol: "CRBRUS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cerberus",
          base_denom: "ucrbrus",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-212",
          path: "transfer/channel-212/ucrbrus"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cerberus",
          base_denom: "ucrbrus"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cerberus/images/crbrus.svg",
        theme: {
          primary_color_hex: "#c6c6c9"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "The native staking and governance token of the Fetch Hub.",
      denom_units: [{
        denom: "ibc/5D1F516200EE8C6B2354102143B78A2DEDA25EDE771AC0F8DC3C1837C8FD4447",
        exponent: 0,
        aliases: ["afet"]
      }, {
        denom: "fet",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/5D1F516200EE8C6B2354102143B78A2DEDA25EDE771AC0F8DC3C1837C8FD4447",
      name: "Fetch.ai",
      display: "fet",
      symbol: "FET",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "fetchhub",
          base_denom: "afet",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-229",
          path: "transfer/channel-229/afet"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.svg"
      },
      images: [{
        image_sync: {
          chain_name: "fetchhub",
          base_denom: "afet"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.svg",
        theme: {
          primary_color_hex: "#1c2444"
        }
      }]
    },
    {
      description: "The native token of Asset Mantle",
      denom_units: [{
        denom: "ibc/CBA34207E969623D95D057D9B11B0C8B32B89A71F170577D982FDDE623813FFC",
        exponent: 0,
        aliases: ["umntl"]
      }, {
        denom: "mntl",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/CBA34207E969623D95D057D9B11B0C8B32B89A71F170577D982FDDE623813FFC",
      name: "AssetMantle",
      display: "mntl",
      symbol: "MNTL",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "assetmantle",
          base_denom: "umntl",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-232",
          path: "transfer/channel-232/umntl"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/mntl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/mntl.svg"
      },
      images: [{
        image_sync: {
          chain_name: "assetmantle",
          base_denom: "umntl"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/mntl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/assetmantle/images/mntl.svg",
        theme: {
          primary_color_hex: "#edb548"
        }
      }]
    },
    {
      description: "The native token cw20 for Neta on Juno Chain",
      denom_units: [{
        denom: "ibc/297C64CC42B5A8D8F82FE2EBE208A6FE8F94B86037FA28C4529A23701C228F7A",
        exponent: 0,
        aliases: ["cw20:juno168ctmpyppk90d34p3jjy658zf5a5l3w8wk35wht6ccqj4mr0yv8s4j5awr"]
      }, {
        denom: "neta",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/297C64CC42B5A8D8F82FE2EBE208A6FE8F94B86037FA28C4529A23701C228F7A",
      name: "Neta",
      display: "neta",
      symbol: "NETA",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno168ctmpyppk90d34p3jjy658zf5a5l3w8wk35wht6ccqj4mr0yv8s4j5awr",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno168ctmpyppk90d34p3jjy658zf5a5l3w8wk35wht6ccqj4mr0yv8s4j5awr"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/neta.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/neta.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno168ctmpyppk90d34p3jjy658zf5a5l3w8wk35wht6ccqj4mr0yv8s4j5awr"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/neta.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/neta.svg",
        theme: {
          primary_color_hex: "#f87b7b"
        }
      }]
    },
    {
      description: "The INJ token is the native governance token for the Injective chain.",
      denom_units: [{
        denom: "ibc/64BA6E31FE887D66C6F8F31C7B1A80C7CA179239677B4088BB55F5EA07DBE273",
        exponent: 0,
        aliases: ["inj"]
      }, {
        denom: "INJ",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/64BA6E31FE887D66C6F8F31C7B1A80C7CA179239677B4088BB55F5EA07DBE273",
      name: "Injective",
      display: "INJ",
      symbol: "INJ",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "inj",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-122",
          path: "transfer/channel-122/inj"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg"
      },
      images: [{
        image_sync: {
          chain_name: "injective",
          base_denom: "inj"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg",
        theme: {
          primary_color_hex: "#04a2fc"
        }
      }]
    },
    {
      description: "The KRW stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "ibc/204A582244FC241613DBB50B04D1D454116C58C4AF7866C186AA0D6EEAD42780",
          exponent: 0,
          aliases: ["microkrw", "ukrw"]
        },
        {
          denom: "mkrw",
          exponent: 3,
          aliases: ["millikrw"]
        },
        {
          denom: "krt",
          exponent: 6,
          aliases: ["krtc"]
        }
      ],
      type_asset: "ics20",
      base: "ibc/204A582244FC241613DBB50B04D1D454116C58C4AF7866C186AA0D6EEAD42780",
      name: "TerraClassicKRW",
      display: "krt",
      symbol: "KRTC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "terra",
          base_denom: "ukrw",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-72",
          path: "transfer/channel-72/ukrw"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/krt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/krt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "terra",
          base_denom: "ukrw"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/krt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/krt.svg",
        theme: {
          primary_color_hex: "#4b83e0"
        }
      }]
    },
    {
      description: "TICK coin is the token for the Microtick Price Discovery & Oracle App",
      denom_units: [{
        denom: "ibc/655BCEF3CDEBE32863FF281DBBE3B06160339E9897DC9C9C9821932A5F8BA6F8",
        exponent: 0,
        aliases: ["utick"]
      }, {
        denom: "tick",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/655BCEF3CDEBE32863FF281DBBE3B06160339E9897DC9C9C9821932A5F8BA6F8",
      name: "Microtick",
      display: "tick",
      symbol: "TICK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "microtick",
          base_denom: "utick",
          channel_id: "channel-16"
        },
        chain: {
          channel_id: "channel-39",
          path: "transfer/channel-39/utick"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.svg"
      },
      images: [{
        image_sync: {
          chain_name: "microtick",
          base_denom: "utick"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/microtick/images/tick.svg",
        theme: {
          primary_color_hex: "#6bab14"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "Rowan Token (ROWAN) is the Sifchain Network's native utility token, used as the primary means to govern, provide liquidity, secure the blockchain, incentivize participants, and provide a default mechanism to store and exchange value.",
      denom_units: [{
        denom: "ibc/8318FD63C42203D16DDCAF49FE10E8590669B3219A3E87676AC9DA50722687FB",
        exponent: 0,
        aliases: ["rowan"]
      }, {
        denom: "ROWAN",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/8318FD63C42203D16DDCAF49FE10E8590669B3219A3E87676AC9DA50722687FB",
      name: "Sifchain",
      display: "ROWAN",
      symbol: "ROWAN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "sifchain",
          base_denom: "rowan",
          channel_id: "channel-17"
        },
        chain: {
          channel_id: "channel-47",
          path: "transfer/channel-47/rowan"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.svg"
      },
      images: [{
        image_sync: {
          chain_name: "sifchain",
          base_denom: "rowan"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.svg",
        theme: {
          primary_color_hex: "#be9926"
        }
      }]
    },
    {
      description: "The native token of Shentu",
      denom_units: [{
        denom: "ibc/7ED954CFFFC06EE8419387F3FC688837FF64EF264DE14219935F724EEEDBF8D3",
        exponent: 0,
        aliases: ["uctk"]
      }, {
        denom: "ctk",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/7ED954CFFFC06EE8419387F3FC688837FF64EF264DE14219935F724EEEDBF8D3",
      name: "Shentu",
      display: "ctk",
      symbol: "CTK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "shentu",
          base_denom: "uctk",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-146",
          path: "transfer/channel-146/uctk"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.svg"
      },
      images: [{
        image_sync: {
          chain_name: "shentu",
          base_denom: "uctk"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.svg",
        theme: {
          primary_color_hex: "#e4ac4c"
        }
      }]
    },
    {
      description: "Hope Galaxy is an NFT collection based on its own native Token $HOPE, a cw20 token on Juno chain.",
      denom_units: [{
        denom: "ibc/C2A2E9CA95DDD4828B75124B5E27B8401C7D8493BC48353D418CBFC04565899B",
        exponent: 0,
        aliases: ["cw20:juno1re3x67ppxap48ygndmrc7har2cnc7tcxtm9nplcas4v0gc3wnmvs3s807z"]
      }, {
        denom: "hope",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C2A2E9CA95DDD4828B75124B5E27B8401C7D8493BC48353D418CBFC04565899B",
      name: "Hope Galaxy",
      display: "hope",
      symbol: "HOPE",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1re3x67ppxap48ygndmrc7har2cnc7tcxtm9nplcas4v0gc3wnmvs3s807z",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1re3x67ppxap48ygndmrc7har2cnc7tcxtm9nplcas4v0gc3wnmvs3s807z"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hope.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hope.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1re3x67ppxap48ygndmrc7har2cnc7tcxtm9nplcas4v0gc3wnmvs3s807z"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hope.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hope.svg",
        theme: {
          primary_color_hex: "#e2877e"
        }
      }]
    },
    {
      description: "Racoon aims to simplify accessibility to AI, NFTs and Gambling on the Cosmos Ecosystem",
      denom_units: [{
        denom: "ibc/6BDB4C8CCD45033F9604E4B93ED395008A753E01EECD6992E7D1EA23D9D3B788",
        exponent: 0,
        aliases: ["cw20:juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa"]
      }, {
        denom: "rac",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/6BDB4C8CCD45033F9604E4B93ED395008A753E01EECD6992E7D1EA23D9D3B788",
      name: "Racoon (Juno)",
      display: "rac",
      symbol: "RAC.juno",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/urac"
        },
        provider: "Racoon"
      }, {
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/rac.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/rac.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/rac.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/rac.svg",
        theme: {
          primary_color_hex: "#070f0e"
        }
      }]
    },
    {
      description: "Frax is a fractional-algorithmic stablecoin protocol. It aims to provide a highly scalable, decentralized, algorithmic money in place of fixed-supply assets like BTC. Additionally, FXS is the value accrual and governance token of the entire Frax ecosystem.",
      denom_units: [{
        denom: "ibc/0E43EDE2E2A3AFA36D0CD38BDDC0B49FECA64FA426A82E102F304E430ECF46EE",
        exponent: 0,
        aliases: ["frax-wei"]
      }, {
        denom: "frax",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/0E43EDE2E2A3AFA36D0CD38BDDC0B49FECA64FA426A82E102F304E430ECF46EE",
      name: "Frax",
      display: "frax",
      symbol: "FRAX",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Frax Protocol"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x853d955acef822db058eb8505911ed77f175b99e"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "frax-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/frax-wei"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x853d955acef822db058eb8505911ed77f175b99e"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg"
      }]
    },
    {
      description: "Gravity Bridge WBTC",
      denom_units: [{
        denom: "ibc/C9B0D48FD2C5B91135F118FF2484551888966590D7BDC20F6A87308DBA670796",
        exponent: 0,
        aliases: ["gravity0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"]
      }, {
        denom: "gwbtc",
        exponent: 8
      }],
      type_asset: "ics20",
      base: "ibc/C9B0D48FD2C5B91135F118FF2484551888966590D7BDC20F6A87308DBA670796",
      name: "Wrapped Bitcoin (Gravity Bridge)",
      display: "gwbtc",
      symbol: "WBTC.eth.grv",
      traces: [
        {
          type: "bridge",
          counterparty: {
            chain_name: "bitcoin",
            base_denom: "sat"
          },
          provider: "BitGo, Kyber, and Ren"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
          },
          provider: "Gravity Bridge"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gravitybridge",
            base_denom: "gravity0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
            channel_id: "channel-10"
          },
          chain: {
            channel_id: "channel-144",
            path: "transfer/channel-144/gravity0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.grv.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wbtc.grv.svg"
      }, {
        image_sync: {
          chain_name: "gravitybridge",
          base_denom: "gravity0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg",
        theme: {
          primary_color_hex: "#f39444"
        }
      }]
    },
    {
      description: "Gravity Bridge WETH",
      denom_units: [{
        denom: "ibc/65381C5F3FD21442283D56925E62EA524DED8B6927F0FF94E21E0020954C40B5",
        exponent: 0,
        aliases: ["gravity0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"]
      }, {
        denom: "gweth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/65381C5F3FD21442283D56925E62EA524DED8B6927F0FF94E21E0020954C40B5",
      name: "Ether (Gravity Bridge)",
      display: "gweth",
      symbol: "ETH.grv",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Ethereum"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"
          },
          provider: "Gravity Bridge"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gravitybridge",
            base_denom: "gravity0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
            channel_id: "channel-10"
          },
          chain: {
            channel_id: "channel-144",
            path: "transfer/channel-144/gravity0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/weth.grv.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/weth.grv.svg"
      }, {
        image_sync: {
          chain_name: "gravitybridge",
          base_denom: "gravity0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }]
    },
    {
      description: "Gravity Bridge USDC",
      denom_units: [{
        denom: "ibc/9F9B07EF9AD291167CF5700628145DE1DEB777C2CFC7907553B24446515F6D0E",
        exponent: 0,
        aliases: ["gravity0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"]
      }, {
        denom: "gusdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9F9B07EF9AD291167CF5700628145DE1DEB777C2CFC7907553B24446515F6D0E",
      name: "USDC (Gravity Bridge)",
      display: "gusdc",
      symbol: "USDC.eth.grv",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
          },
          provider: "Gravity Bridge"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gravitybridge",
            base_denom: "gravity0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
            channel_id: "channel-10"
          },
          chain: {
            channel_id: "channel-144",
            path: "transfer/channel-144/gravity0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.grv.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.grv.svg"
      }, {
        image_sync: {
          chain_name: "gravitybridge",
          base_denom: "gravity0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "Gravity Bridge DAI",
      denom_units: [{
        denom: "ibc/F292A17CF920E3462C816CBE6B042E779F676CAB59096904C4C1C966413E3DF5",
        exponent: 0,
        aliases: ["gravity0x6B175474E89094C44Da98b954EedeAC495271d0F"]
      }, {
        denom: "gdai",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/F292A17CF920E3462C816CBE6B042E779F676CAB59096904C4C1C966413E3DF5",
      name: "DAI Stablecoin (Gravity Bridge)",
      display: "gdai",
      symbol: "DAI.grv",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "MakerDAO"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f"
          },
          provider: "Gravity Bridge"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gravitybridge",
            base_denom: "gravity0x6B175474E89094C44Da98b954EedeAC495271d0F",
            channel_id: "channel-10"
          },
          chain: {
            channel_id: "channel-144",
            path: "transfer/channel-144/gravity0x6B175474E89094C44Da98b954EedeAC495271d0F"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/dai.grv.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/dai.grv.svg"
      }, {
        image_sync: {
          chain_name: "gravitybridge",
          base_denom: "gravity0x6B175474E89094C44Da98b954EedeAC495271d0F"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      }]
    },
    {
      description: "Gravity Bridge USDT",
      denom_units: [{
        denom: "ibc/71B441E27F1BBB44DD0891BCD370C2794D404D60A4FFE5AECCD9B1E28BC89805",
        exponent: 0,
        aliases: ["gravity0xdAC17F958D2ee523a2206206994597C13D831ec7"]
      }, {
        denom: "gusdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/71B441E27F1BBB44DD0891BCD370C2794D404D60A4FFE5AECCD9B1E28BC89805",
      name: "Tether USD (Gravity Bridge)",
      display: "gusdt",
      symbol: "USDT.eth.grv",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Tether"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
          },
          provider: "Gravity Bridge"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gravitybridge",
            base_denom: "gravity0xdAC17F958D2ee523a2206206994597C13D831ec7",
            channel_id: "channel-10"
          },
          chain: {
            channel_id: "channel-144",
            path: "transfer/channel-144/gravity0xdAC17F958D2ee523a2206206994597C13D831ec7"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.grv.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.grv.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.grv.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.grv.png",
        theme: {
          primary_color_hex: "#059394"
        }
      }, {
        image_sync: {
          chain_name: "gravitybridge",
          base_denom: "gravity0xdAC17F958D2ee523a2206206994597C13D831ec7"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }]
    },
    {
      description: "The native token of Marble DEX on Juno Chain",
      denom_units: [{
        denom: "ibc/DB9755CB6FE55192948AE074D18FA815E1429D3D374D5BDA8D89623C6CF235C3",
        exponent: 0,
        aliases: ["cw20:juno1y9rf7ql6ffwkv02hsgd4yruz23pn4w97p75e2slsnkm0mnamhzysvqnxaq"]
      }, {
        denom: "block",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/DB9755CB6FE55192948AE074D18FA815E1429D3D374D5BDA8D89623C6CF235C3",
      name: "Block",
      display: "block",
      symbol: "BLOCK",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1y9rf7ql6ffwkv02hsgd4yruz23pn4w97p75e2slsnkm0mnamhzysvqnxaq",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1y9rf7ql6ffwkv02hsgd4yruz23pn4w97p75e2slsnkm0mnamhzysvqnxaq"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/block.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/block.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1y9rf7ql6ffwkv02hsgd4yruz23pn4w97p75e2slsnkm0mnamhzysvqnxaq"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/block.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/block.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Hash is the staking token of the Provenance Blockchain",
      denom_units: [{
        denom: "ibc/CE5BFF1D9BADA03BB5CCA5F56939392A761B53A10FBD03B37506669C3218D3B2",
        exponent: 0,
        aliases: ["nhash"]
      }, {
        denom: "hash",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/CE5BFF1D9BADA03BB5CCA5F56939392A761B53A10FBD03B37506669C3218D3B2",
      name: "Provenance",
      display: "hash",
      symbol: "HASH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "provenance",
          base_denom: "nhash",
          channel_id: "channel-7"
        },
        chain: {
          channel_id: "channel-222",
          path: "transfer/channel-222/nhash"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.svg"
      },
      images: [{
        image_sync: {
          chain_name: "provenance",
          base_denom: "nhash"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.svg",
        theme: {
          primary_color_hex: "#4c7cdc"
        }
      }]
    },
    {
      description: "GLX is the staking token of the Galaxy Chain",
      denom_units: [{
        denom: "ibc/F49DE040EBA5AB2FAD5F660C2A1DDF98A68470FAE82229818BE775EBF3EE79F2",
        exponent: 0,
        aliases: ["uglx"]
      }, {
        denom: "glx",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F49DE040EBA5AB2FAD5F660C2A1DDF98A68470FAE82229818BE775EBF3EE79F2",
      name: "Galaxy",
      display: "glx",
      symbol: "GLX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "galaxy",
          base_denom: "uglx",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-236",
          path: "transfer/channel-236/uglx"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.svg"
      },
      images: [{
        image_sync: {
          chain_name: "galaxy",
          base_denom: "uglx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galaxy/images/glx.svg",
        theme: {
          primary_color_hex: "#5e3be6"
        }
      }]
    },
    {
      description: "The DAO token to build consensus among Hong Kong People",
      denom_units: [{
        denom: "ibc/52E12CF5CA2BB903D84F5298B4BFD725D66CAB95E09AA4FC75B2904CA5485FEB",
        exponent: 0,
        aliases: ["dhk", "cw20:juno1tdjwrqmnztn2j3sj2ln9xnyps5hs48q3ddwjrz7jpv6mskappjys5czd49"]
      }],
      type_asset: "ics20",
      base: "ibc/52E12CF5CA2BB903D84F5298B4BFD725D66CAB95E09AA4FC75B2904CA5485FEB",
      name: "DHK",
      display: "dhk",
      symbol: "DHK",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1tdjwrqmnztn2j3sj2ln9xnyps5hs48q3ddwjrz7jpv6mskappjys5czd49",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1tdjwrqmnztn2j3sj2ln9xnyps5hs48q3ddwjrz7jpv6mskappjys5czd49"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dhk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dhk.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1tdjwrqmnztn2j3sj2ln9xnyps5hs48q3ddwjrz7jpv6mskappjys5czd49"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dhk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dhk.svg",
        theme: {
          primary_color_hex: "#fae204"
        }
      }]
    },
    {
      description: "Token governance for Junoswap",
      denom_units: [{
        denom: "ibc/00B6E60AD3D65CBEF5579AC8AF609527C0B57535B6E32D96C80A735344FD9DCC",
        exponent: 0,
        aliases: ["cw20:juno15u3dt79t6sxxa3x3kpkhzsy56edaa5a66wvt3kxmukqjz2sx0hes5sn38g"]
      }, {
        denom: "raw",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/00B6E60AD3D65CBEF5579AC8AF609527C0B57535B6E32D96C80A735344FD9DCC",
      name: "JunoSwap",
      display: "raw",
      symbol: "RAW",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno15u3dt79t6sxxa3x3kpkhzsy56edaa5a66wvt3kxmukqjz2sx0hes5sn38g",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno15u3dt79t6sxxa3x3kpkhzsy56edaa5a66wvt3kxmukqjz2sx0hes5sn38g"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/raw.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/raw.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno15u3dt79t6sxxa3x3kpkhzsy56edaa5a66wvt3kxmukqjz2sx0hes5sn38g"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/raw.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/raw.svg",
        theme: {
          primary_color_hex: "#f07c92"
        }
      }]
    },
    {
      description: "MEME Token (MEME) is the native staking token of the MEME Chain",
      denom_units: [{
        denom: "ibc/67C89B8B0A70C08F093C909A4DD996DD10E0494C87E28FD9A551697BF173D4CA",
        exponent: 0,
        aliases: ["umeme"]
      }, {
        denom: "meme",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/67C89B8B0A70C08F093C909A4DD996DD10E0494C87E28FD9A551697BF173D4CA",
      name: "MEME",
      display: "meme",
      symbol: "MEME",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "meme",
          base_denom: "umeme",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-238",
          path: "transfer/channel-238/umeme"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.svg"
      },
      images: [{
        image_sync: {
          chain_name: "meme",
          base_denom: "umeme"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.svg",
        theme: {
          primary_color_hex: "#b7dcd8"
        }
      }]
    },
    {
      description: "Profit sharing token for Another.Software validator. Hold and receive dividends from Another.Software validator commissions!",
      denom_units: [{
        denom: "ibc/AA1C80225BCA7B32ED1FC6ABF8B8E899BEB48ECDB4B417FD69873C6D715F97E7",
        exponent: 0,
        aliases: ["cw20:juno17wzaxtfdw5em7lc94yed4ylgjme63eh73lm3lutp2rhcxttyvpwsypjm4w"]
      }, {
        denom: "asvt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/AA1C80225BCA7B32ED1FC6ABF8B8E899BEB48ECDB4B417FD69873C6D715F97E7",
      name: "Another.Software Validator Token",
      display: "asvt",
      symbol: "ASVT",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno17wzaxtfdw5em7lc94yed4ylgjme63eh73lm3lutp2rhcxttyvpwsypjm4w",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno17wzaxtfdw5em7lc94yed4ylgjme63eh73lm3lutp2rhcxttyvpwsypjm4w"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/asvt.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno17wzaxtfdw5em7lc94yed4ylgjme63eh73lm3lutp2rhcxttyvpwsypjm4w"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/asvt.png",
        theme: {
          primary_color_hex: "#402e5d"
        }
      }]
    },
    {
      description: "DAO dedicated to building tools on the Juno Network",
      denom_units: [{
        denom: "ibc/0CB9DB3441D0D50F35699DEE22B9C965487E83FB2D9F483D1CC5CA34E856C484",
        exponent: 0,
        aliases: ["cw20:juno1n7n7d5088qlzlj37e9mgmkhx6dfgtvt02hqxq66lcap4dxnzdhwqfmgng3"]
      }, {
        denom: "joe",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0CB9DB3441D0D50F35699DEE22B9C965487E83FB2D9F483D1CC5CA34E856C484",
      name: "JoeDAO",
      display: "joe",
      symbol: "JOE",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1n7n7d5088qlzlj37e9mgmkhx6dfgtvt02hqxq66lcap4dxnzdhwqfmgng3",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1n7n7d5088qlzlj37e9mgmkhx6dfgtvt02hqxq66lcap4dxnzdhwqfmgng3"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/joe.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1n7n7d5088qlzlj37e9mgmkhx6dfgtvt02hqxq66lcap4dxnzdhwqfmgng3"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/joe.png",
        theme: {
          primary_color_hex: "#f3baaf"
        }
      }]
    },
    {
      description: "The native staking token of Terra.",
      denom_units: [{
        denom: "ibc/785AFEC6B3741100D15E7AF01374E3C4C36F24888E96479B1C33F5C71F364EF9",
        exponent: 0,
        aliases: ["uluna"]
      }, {
        denom: "luna",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/785AFEC6B3741100D15E7AF01374E3C4C36F24888E96479B1C33F5C71F364EF9",
      name: "Luna",
      display: "luna",
      symbol: "LUNA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "terra2",
          base_denom: "uluna",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-251",
          path: "transfer/channel-251/uluna"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg"
      },
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "uluna"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg",
        theme: {
          primary_color_hex: "#f4de6f"
        }
      }]
    },
    {
      description: "Native token of Rizon Chain",
      denom_units: [{
        denom: "ibc/2716E3F2E146664BEFA9217F1A03BFCEDBCD5178B3C71CACB1A0D7584451D219",
        exponent: 0,
        aliases: ["uatolo"]
      }, {
        denom: "atolo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2716E3F2E146664BEFA9217F1A03BFCEDBCD5178B3C71CACB1A0D7584451D219",
      name: "Rizon",
      display: "atolo",
      symbol: "ATOLO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "rizon",
          base_denom: "uatolo",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-221",
          path: "transfer/channel-221/uatolo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "rizon",
          base_denom: "uatolo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.svg",
        theme: {
          primary_color_hex: "#2b1c54"
        }
      }]
    },
    {
      description: "Governance token of Kava Lend Protocol",
      denom_units: [{
        denom: "ibc/D6C28E07F7343360AC41E15DDD44D79701DDCA2E0C2C41279739C8D4AE5264BC",
        exponent: 0,
        aliases: ["hard"]
      }, {
        denom: "HARD",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D6C28E07F7343360AC41E15DDD44D79701DDCA2E0C2C41279739C8D4AE5264BC",
      name: "Kava Hard",
      display: "HARD",
      symbol: "HARD",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "hard",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-143",
          path: "transfer/channel-143/hard"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/hard.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/hard.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "hard"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/hard.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/hard.svg",
        theme: {
          primary_color_hex: "#7b34ac"
        }
      }]
    },
    {
      description: "Governance token of Kava Swap Protocol",
      denom_units: [{
        denom: "ibc/70CF1A54E23EA4E480DEDA9E12082D3FD5684C3483CBDCE190C5C807227688C5",
        exponent: 0,
        aliases: ["swp"]
      }, {
        denom: "SWP",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/70CF1A54E23EA4E480DEDA9E12082D3FD5684C3483CBDCE190C5C807227688C5",
      name: "Kava Swap",
      display: "SWP",
      symbol: "SWP",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "swp",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-143",
          path: "transfer/channel-143/swp"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/swp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/swp.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "swp"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/swp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/swp.svg",
        theme: {
          primary_color_hex: "#544cfc"
        }
      }]
    },
    {
      description: "A blockchain-based middleware, acting as a bridge between cryptocurrency smart contracts, data feeds, APIs and traditional bank account payments.",
      denom_units: [{
        denom: "ibc/D3327A763C23F01EC43D1F0DB3CEFEC390C362569B6FD191F40A5192F8960049",
        exponent: 0,
        aliases: ["link-wei"]
      }, {
        denom: "link",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/D3327A763C23F01EC43D1F0DB3CEFEC390C362569B6FD191F40A5192F8960049",
      name: "Chainlink (Axelar)",
      display: "link",
      symbol: "LINK.axl",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x514910771af9ca656af840dff83e8264ecf986ca"
        },
        provider: "Axelar"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "link-wei",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-208",
          path: "transfer/channel-208/link-wei"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/link.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/link.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/link.axl.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/link.axl.png"
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "link-wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.svg",
        theme: {
          primary_color_hex: "#2c5cdc"
        }
      }]
    },
    {
      description: "L1 coin is the GenesisL1 blockchain utility, governance and EVM token",
      denom_units: [{
        denom: "ibc/F16FDC11A7662B86BC0B9CE61871CBACF7C20606F95E86260FD38915184B75B4",
        exponent: 0,
        aliases: ["el1"]
      }, {
        denom: "l1",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/F16FDC11A7662B86BC0B9CE61871CBACF7C20606F95E86260FD38915184B75B4",
      name: "GenesisL1",
      display: "l1",
      symbol: "L1",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "genesisl1",
          base_denom: "el1",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-253",
          path: "transfer/channel-253/el1"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.svg"
      },
      images: [{
        image_sync: {
          chain_name: "genesisl1",
          base_denom: "el1"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/genesisl1/images/l1.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "Aave is an Open Source and Non-Custodial protocol to earn interest on deposits & borrow assets. It also features access to highly innovative flash loans, which let developers borrow instantly and easily; no collateral needed. With 16 different assets, 5 of which are stablecoins.",
      denom_units: [{
        denom: "ibc/384E5DD50BDE042E1AAF51F312B55F08F95BC985C503880189258B4D9374CBBE",
        exponent: 0,
        aliases: ["aave-wei"]
      }, {
        denom: "aave",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/384E5DD50BDE042E1AAF51F312B55F08F95BC985C503880189258B4D9374CBBE",
      name: "Aave",
      display: "aave",
      symbol: "AAVE",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9"
        },
        provider: "Axelar"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "aave-wei",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-208",
          path: "transfer/channel-208/aave-wei"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/aave.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/aave.svg"
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "ApeCoin found new expression in web3 through art, gaming, entertainment, and events. APE is a token made to support what’s next, controlled, and built on by the community. It will serve as a decentralized protocol layer for community-led initiatives that drive culture forward into the metaverse.",
      denom_units: [{
        denom: "ibc/F83CC6471DA4D4B508F437244F10B9E4C68975344E551A2DEB6B8617AB08F0D4",
        exponent: 0,
        aliases: ["ape-wei"]
      }, {
        denom: "ape",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/F83CC6471DA4D4B508F437244F10B9E4C68975344E551A2DEB6B8617AB08F0D4",
      name: "ApeCoin",
      display: "ape",
      symbol: "APE",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x4d224452801aced8b2f0aebe155379bb5d594381"
        },
        provider: "Axelar"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "ape-wei",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-208",
          path: "transfer/channel-208/ape-wei"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ape.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x4d224452801aced8b2f0aebe155379bb5d594381"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ape.svg"
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "Maker is a Decentralized Autonomous Organization that creates and insures the dai stablecoin on the Ethereum blockchain",
      denom_units: [{
        denom: "ibc/D27DDDF34BB47E5D5A570742CC667DE53277867116CCCA341F27785E899A70F3",
        exponent: 0,
        aliases: ["mkr-wei"]
      }, {
        denom: "mkr",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/D27DDDF34BB47E5D5A570742CC667DE53277867116CCCA341F27785E899A70F3",
      name: "Maker",
      display: "mkr",
      symbol: "MKR",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2"
        },
        provider: "Axelar"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "mkr-wei",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-208",
          path: "transfer/channel-208/mkr-wei"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/mkr.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/mkr.svg"
      }]
    },
    {
      description: "RAI is a non-pegged, ETH-backed stable asset. It is useful as more 'stable' collateral for other DeFi protocols (compared to ETH or BTC) or as a stable asset with an embedded interest rate.",
      denom_units: [{
        denom: "ibc/BD796662F8825327D41C96355DF62045A5BA225BAE31C0A86289B9D88ED3F44E",
        exponent: 0,
        aliases: ["rai-wei"]
      }, {
        denom: "rai",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/BD796662F8825327D41C96355DF62045A5BA225BAE31C0A86289B9D88ED3F44E",
      name: "Rai Reflex Index",
      display: "rai",
      symbol: "RAI",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "RAI Finance"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "rai-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/rai-wei"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/rai.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/rai.svg"
      }]
    },
    {
      description: "SHIBA INU is a 100% decentralized community experiment with it claims that 1/2 the tokens have been sent to Vitalik and the other half were locked to a Uniswap pool and the keys burned.",
      denom_units: [{
        denom: "ibc/19305E20681911F14D1FB275E538CDE524C3BF88CF9AE5D5F78F4D4DA05E85B2",
        exponent: 0,
        aliases: ["shib-wei"]
      }, {
        denom: "shib",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/19305E20681911F14D1FB275E538CDE524C3BF88CF9AE5D5F78F4D4DA05E85B2",
      name: "Shiba Inu (Axelar)",
      display: "shib",
      symbol: "SHIB.axl",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce"
        },
        provider: "Axelar"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "shib-wei",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-208",
          path: "transfer/channel-208/shib-wei"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shib.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shib.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shib.axl.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shib.axl.png"
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "shib-wei"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/shib.svg",
        theme: {
          primary_color_hex: "#FFA409",
          background_color_hex: "#00000000"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "The native staking and governance token of the Kujira chain.",
      denom_units: [{
        denom: "ibc/BB6BCDB515050BAE97516111873CCD7BCF1FD0CCB723CC12F3C4F704D6C646CE",
        exponent: 0,
        aliases: ["ukuji"]
      }, {
        denom: "kuji",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/BB6BCDB515050BAE97516111873CCD7BCF1FD0CCB723CC12F3C4F704D6C646CE",
      name: "Kujira",
      display: "kuji",
      symbol: "KUJI",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kujira",
          base_denom: "ukuji",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-259",
          path: "transfer/channel-259/ukuji"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kujira",
          base_denom: "ukuji"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.svg",
        theme: {
          primary_color_hex: "#e33b34"
        }
      }]
    },
    {
      description: "The native token of Tgrade",
      denom_units: [{
        denom: "ibc/1E09CB0F506ACF12FDE4683FB6B34DA62FB4BE122641E0D93AAF98A87675676C",
        exponent: 0,
        aliases: ["utgd"]
      }, {
        denom: "tgd",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1E09CB0F506ACF12FDE4683FB6B34DA62FB4BE122641E0D93AAF98A87675676C",
      name: "Tgrade",
      display: "tgd",
      symbol: "TGD",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "tgrade",
          base_denom: "utgd",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-263",
          path: "transfer/channel-263/utgd"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-symbol-gradient.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-symbol-gradient.svg"
      },
      images: [{
        image_sync: {
          chain_name: "tgrade",
          base_denom: "utgd"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-symbol-gradient.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-symbol-gradient.svg",
        theme: {
          primary_color_hex: "#a7248a"
        }
      }]
    },
    {
      description: "Echelon - a scalable EVM on Cosmos, built on Proof-of-Stake with fast-finality that prioritizes interoperability and novel economics",
      denom_units: [{
        denom: "ibc/47EE224A9B33CF0ABEAC82106E52F0F6E8D8CEC5BA80B9D9A6F55172CBB0177D",
        exponent: 0,
        aliases: ["aechelon"]
      }, {
        denom: "echelon",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/47EE224A9B33CF0ABEAC82106E52F0F6E8D8CEC5BA80B9D9A6F55172CBB0177D",
      name: "Echelon",
      display: "echelon",
      symbol: "ECH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "echelon",
          base_denom: "aechelon",
          channel_id: "channel-11"
        },
        chain: {
          channel_id: "channel-403",
          path: "transfer/channel-403/aechelon"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/echelon/images/ech.svg"
      },
      images: [{
        image_sync: {
          chain_name: "echelon",
          base_denom: "aechelon"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/echelon/images/ech.svg"
      }]
    },
    {
      description: "Staking and governance token for ODIN Protocol",
      denom_units: [{
        denom: "ibc/C360EF34A86D334F625E4CBB7DA3223AEA97174B61F35BB3758081A8160F7D9B",
        exponent: 0,
        aliases: ["loki"]
      }, {
        denom: "odin",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C360EF34A86D334F625E4CBB7DA3223AEA97174B61F35BB3758081A8160F7D9B",
      name: "Odin Protocol",
      display: "odin",
      symbol: "ODIN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "odin",
          base_denom: "loki",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-258",
          path: "transfer/channel-258/loki"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.svg"
      },
      images: [{
        image_sync: {
          chain_name: "odin",
          base_denom: "loki"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/odin.svg"
      }]
    },
    {
      description: "GEO token for ODIN Protocol",
      denom_units: [{
        denom: "ibc/9B6FBABA36BB4A3BF127AE5E96B572A5197FD9F3111D895D8919B07BC290764A",
        exponent: 0,
        aliases: ["mGeo"]
      }, {
        denom: "geo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9B6FBABA36BB4A3BF127AE5E96B572A5197FD9F3111D895D8919B07BC290764A",
      name: "GEO",
      display: "geo",
      symbol: "GEO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "odin",
          base_denom: "mGeo",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-258",
          path: "transfer/channel-258/mGeo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/geo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/geo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "odin",
          base_denom: "mGeo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/geo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/geo.svg",
        theme: {
          primary_color_hex: "#c3ebf3"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "O9W token for ODIN Protocol",
      denom_units: [{
        denom: "ibc/0CD46223FEABD2AEAAAF1F057D01E63BCA79B7D4BD6B68F1EB973A987344695D",
        exponent: 0,
        aliases: ["mO9W"]
      }, {
        denom: "O9W",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0CD46223FEABD2AEAAAF1F057D01E63BCA79B7D4BD6B68F1EB973A987344695D",
      name: "O9W",
      display: "O9W",
      symbol: "O9W",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "odin",
          base_denom: "mO9W",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-258",
          path: "transfer/channel-258/mO9W"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/o9w.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/o9w.svg"
      },
      images: [{
        image_sync: {
          chain_name: "odin",
          base_denom: "mO9W"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/o9w.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/o9w.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "ELEVENPARIS loyalty token on KiChain",
      denom_units: [{
        denom: "ibc/AD185F62399F770CCCE8A36A180A77879FF6C26A0398BD3D2A74E087B0BFA121",
        exponent: 0,
        aliases: ["cw20:ki1dt3lk455ed360pna38fkhqn0p8y44qndsr77qu73ghyaz2zv4whq83mwdy"]
      }, {
        denom: "lvn",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/AD185F62399F770CCCE8A36A180A77879FF6C26A0398BD3D2A74E087B0BFA121",
      name: "LVN",
      display: "lvn",
      symbol: "LVN.ki",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "kichain",
          base_denom: "cw20:ki1dt3lk455ed360pna38fkhqn0p8y44qndsr77qu73ghyaz2zv4whq83mwdy",
          port: "wasm.ki1hzz0s0ucrhdp6tue2lxk3c03nj6f60qy463we7lgx0wudd72ctmsd9kgha",
          channel_id: "channel-18"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-261",
          path: "transfer/channel-261/cw20:ki1dt3lk455ed360pna38fkhqn0p8y44qndsr77qu73ghyaz2zv4whq83mwdy"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/lvn.png"
      },
      images: [{
        image_sync: {
          chain_name: "kichain",
          base_denom: "cw20:ki1dt3lk455ed360pna38fkhqn0p8y44qndsr77qu73ghyaz2zv4whq83mwdy"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/lvn.png",
        theme: {
          primary_color_hex: "#683480"
        }
      }]
    },
    {
      description: "Glimmer (GLMR) is the utility token of the Moonbeam Network, Moonbeam’s primary deployment on the Polkadot network that serves as a developer-friendly parachain.",
      denom_units: [{
        denom: "ibc/1E26DB0E5122AED464D98462BD384FCCB595732A66B3970AE6CE0B58BAE0FC49",
        exponent: 0,
        aliases: ["wglmr-wei"]
      }, {
        denom: "wglmr",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/1E26DB0E5122AED464D98462BD384FCCB595732A66B3970AE6CE0B58BAE0FC49",
      name: "Moonbeam",
      display: "wglmr",
      symbol: "GLMR",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "moonbeam",
            base_denom: "Wei"
          },
          provider: "Moonbeam"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "moonbeam",
            base_denom: "0xacc15dc74880c9944775448304b263d191c6077f"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "wglmr-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/wglmr-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/moonbeam/images/glmr.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/moonbeam/images/glmr.svg"
      },
      images: [{
        image_sync: {
          chain_name: "moonbeam",
          base_denom: "Wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/moonbeam/images/glmr.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/moonbeam/images/glmr.svg",
        theme: {
          primary_color_hex: "#e4147c"
        }
      }]
    },
    {
      description: "DeFi gaming platform built on Juno",
      denom_units: [{
        denom: "ibc/52C57FCA7D6854AA178E7A183DDBE4EF322B904B1D719FC485F6FFBC1F72A19E",
        exponent: 0,
        aliases: ["cw20:juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se"]
      }, {
        denom: "glto",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/52C57FCA7D6854AA178E7A183DDBE4EF322B904B1D719FC485F6FFBC1F72A19E",
      name: "Gelotto (Juno)",
      display: "glto",
      symbol: "GLTO.juno",
      traces: [{
        type: "legacy-mintage",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2"
        },
        provider: "Gelotto"
      }, {
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg",
        theme: {
          primary_color_hex: "#501cad"
        }
      }, {
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg",
        theme: {
          primary_color_hex: "#501cad"
        }
      }]
    },
    {
      description: "Gelotto Year 1 Grand Prize Token",
      denom_units: [{
        denom: "ibc/7C781B4C2082CD62129A972D47486D78EC17155C299270E3C89348EA026BEAF8",
        exponent: 0,
        aliases: ["cw20:juno1gz8cf86zr4vw9cjcyyv432vgdaecvr9n254d3uwwkx9rermekddsxzageh"]
      }, {
        denom: "gkey",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/7C781B4C2082CD62129A972D47486D78EC17155C299270E3C89348EA026BEAF8",
      name: "GKey",
      display: "gkey",
      symbol: "GKEY",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1gz8cf86zr4vw9cjcyyv432vgdaecvr9n254d3uwwkx9rermekddsxzageh",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1gz8cf86zr4vw9cjcyyv432vgdaecvr9n254d3uwwkx9rermekddsxzageh"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/gkey.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/gkey.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1gz8cf86zr4vw9cjcyyv432vgdaecvr9n254d3uwwkx9rermekddsxzageh"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/gkey.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/gkey.svg",
        theme: {
          primary_color_hex: "#521caf"
        }
      }]
    },
    {
      description: "The native token of Crescent",
      denom_units: [{
        denom: "ibc/5A7C219BA5F7582B99629BA3B2A01A61BFDA0F6FD1FE95B5366F7334C4BC0580",
        exponent: 0,
        aliases: ["ucre"]
      }, {
        denom: "cre",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/5A7C219BA5F7582B99629BA3B2A01A61BFDA0F6FD1FE95B5366F7334C4BC0580",
      name: "Crescent",
      display: "cre",
      symbol: "CRE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "crescent",
          base_denom: "ucre",
          channel_id: "channel-9"
        },
        chain: {
          channel_id: "channel-297",
          path: "transfer/channel-297/ucre"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.svg"
      },
      images: [{
        image_sync: {
          chain_name: "crescent",
          base_denom: "ucre"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/crescent/images/cre.svg",
        theme: {
          primary_color_hex: "#3c2832"
        }
      }]
    },
    {
      description: "The native token of LumenX Network",
      denom_units: [{
        denom: "ibc/FFA652599C77E853F017193E36B5AB2D4D9AFC4B54721A74904F80C9236BF3B7",
        exponent: 0,
        aliases: ["ulumen"]
      }, {
        denom: "lumen",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/FFA652599C77E853F017193E36B5AB2D4D9AFC4B54721A74904F80C9236BF3B7",
      name: "LumenX",
      display: "lumen",
      symbol: "LUMEN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "lumenx",
          base_denom: "ulumen",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-286",
          path: "transfer/channel-286/ulumen"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.svg"
      },
      images: [{
        image_sync: {
          chain_name: "lumenx",
          base_denom: "ulumen"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lumenx/images/lumen.svg",
        theme: {
          primary_color_hex: "#cb8b40"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "The native token of Oraichain",
      denom_units: [{
        denom: "ibc/161D7D62BAB3B9C39003334F1671208F43C06B643CC9EDBBE82B64793C857F1D",
        exponent: 0,
        aliases: ["orai"]
      }, {
        denom: "ORAI",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/161D7D62BAB3B9C39003334F1671208F43C06B643CC9EDBBE82B64793C857F1D",
      name: "Oraichain",
      display: "ORAI",
      symbol: "ORAI",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "oraichain",
          base_denom: "orai",
          channel_id: "channel-13"
        },
        chain: {
          channel_id: "channel-216",
          path: "transfer/channel-216/orai"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-token.svg"
      },
      images: [
        {
          image_sync: {
            chain_name: "oraichain",
            base_denom: "orai"
          },
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-token.png",
          theme: {
            circle: !0,
            primary_color_hex: "#000000",
            background_color_hex: "#FFFFFF"
          },
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-token.svg"
        },
        {
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-white.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai-white.svg",
          theme: {
            circle: !0,
            dark_mode: !0,
            primary_color_hex: "#FFFFFF"
          }
        },
        {
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/oraichain/images/orai.svg",
          theme: {
            circle: !0,
            dark_mode: !1,
            primary_color_hex: "#000000"
          }
        }
      ]
    },
    {
      description: "The native token of the Cudos blockchain",
      denom_units: [{
        denom: "ibc/E09ED39F390EC51FA9F3F69BEA08B5BBE6A48B3057B2B1C3467FAAE9E58B021B",
        exponent: 0,
        aliases: ["attocudos", "acudos"]
      }, {
        denom: "cudos",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/E09ED39F390EC51FA9F3F69BEA08B5BBE6A48B3057B2B1C3467FAAE9E58B021B",
      name: "Cudos",
      display: "cudos",
      symbol: "CUDOS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cudos",
          base_denom: "acudos",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-298",
          path: "transfer/channel-298/acudos"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cudos",
          base_denom: "acudos"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cudos/images/cudos.svg",
        theme: {
          primary_color_hex: "#5d95ec"
        }
      }]
    },
    {
      description: "The native stablecoin of Kava",
      denom_units: [{
        denom: "ibc/C78F65E1648A3DFE0BAEB6C4CDA69CC2A75437F1793C0E6386DFDA26393790AE",
        exponent: 0,
        aliases: ["usdx"]
      }, {
        denom: "USDX",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C78F65E1648A3DFE0BAEB6C4CDA69CC2A75437F1793C0E6386DFDA26393790AE",
      name: "Kava USDX",
      display: "USDX",
      symbol: "USDX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "usdx",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-143",
          path: "transfer/channel-143/usdx"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/usdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/usdx.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "usdx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/usdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kava/images/usdx.svg",
        theme: {
          primary_color_hex: "#04d4a3"
        }
      }]
    },
    {
      description: "BLD is the token used to secure the Agoric chain through staking and to backstop Inter Protocol.",
      denom_units: [{
        denom: "ibc/2DA9C149E9AD2BD27FEFA635458FB37093C256C1A940392634A16BEA45262604",
        exponent: 0,
        aliases: ["ubld"]
      }, {
        denom: "bld",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2DA9C149E9AD2BD27FEFA635458FB37093C256C1A940392634A16BEA45262604",
      name: "Agoric",
      display: "bld",
      symbol: "BLD",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "agoric",
          base_denom: "ubld",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-320",
          path: "transfer/channel-320/ubld"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/bld.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/bld.svg"
      },
      images: [{
        image_sync: {
          chain_name: "agoric",
          base_denom: "ubld"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/bld.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/bld.svg",
        theme: {
          primary_color_hex: "#c42b44"
        }
      }]
    },
    {
      description: "IST is the stable token used by the Agoric chain for execution fees and commerce.",
      denom_units: [{
        denom: "ibc/92BE0717F4678905E53F4E45B2DED18BC0CB97BF1F8B6A25AFEDF3D5A879B4D5",
        exponent: 0,
        aliases: ["uist"]
      }, {
        denom: "ist",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/92BE0717F4678905E53F4E45B2DED18BC0CB97BF1F8B6A25AFEDF3D5A879B4D5",
      name: "Inter Stable Token",
      display: "ist",
      symbol: "IST",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "agoric",
          base_denom: "uist",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-320",
          path: "transfer/channel-320/uist"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.svg"
      },
      images: [{
        image_sync: {
          chain_name: "agoric",
          base_denom: "uist"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/agoric/images/ist.svg",
        theme: {
          primary_color_hex: "#d485e2"
        }
      }]
    },
    {
      description: "Staking derivative seJUNO for staked JUNO",
      denom_units: [{
        denom: "ibc/C6B6BFCB6EE49A7CAB1A7E7B021DE35B99D525AC660844952F0F6C78DCB2A57B",
        exponent: 0,
        aliases: ["cw20:juno1dd0k0um5rqncfueza62w9sentdfh3ec4nw4aq4lk5hkjl63vljqscth9gv"]
      }, {
        denom: "sejuno",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C6B6BFCB6EE49A7CAB1A7E7B021DE35B99D525AC660844952F0F6C78DCB2A57B",
      name: "StakeEasy seJUNO",
      display: "sejuno",
      symbol: "SEJUNO",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1dd0k0um5rqncfueza62w9sentdfh3ec4nw4aq4lk5hkjl63vljqscth9gv",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1dd0k0um5rqncfueza62w9sentdfh3ec4nw4aq4lk5hkjl63vljqscth9gv"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sejuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sejuno.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1dd0k0um5rqncfueza62w9sentdfh3ec4nw4aq4lk5hkjl63vljqscth9gv"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sejuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sejuno.svg",
        theme: {
          primary_color_hex: "#26363f"
        }
      }]
    },
    {
      description: "Staking derivative bJUNO for staked JUNO",
      denom_units: [{
        denom: "ibc/C2DF5C3949CA835B221C575625991F09BAB4E48FB9C11A4EE357194F736111E3",
        exponent: 0,
        aliases: ["cw20:juno1wwnhkagvcd3tjz6f8vsdsw5plqnw8qy2aj3rrhqr2axvktzv9q2qz8jxn3"]
      }, {
        denom: "bjuno",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C2DF5C3949CA835B221C575625991F09BAB4E48FB9C11A4EE357194F736111E3",
      name: "StakeEasy bJUNO",
      display: "bjuno",
      symbol: "BJUNO",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1wwnhkagvcd3tjz6f8vsdsw5plqnw8qy2aj3rrhqr2axvktzv9q2qz8jxn3",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1wwnhkagvcd3tjz6f8vsdsw5plqnw8qy2aj3rrhqr2axvktzv9q2qz8jxn3"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bjuno.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1wwnhkagvcd3tjz6f8vsdsw5plqnw8qy2aj3rrhqr2axvktzv9q2qz8jxn3"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/bjuno.svg",
        theme: {
          primary_color_hex: "#254454"
        }
      }]
    },
    {
      description: "The native token of Stride",
      denom_units: [{
        denom: "ibc/A8CA5EE328FA10C9519DF6057DA1F69682D28F7D0F5CCC7ECB72E3DCA2D157A4",
        exponent: 0,
        aliases: ["ustrd"]
      }, {
        denom: "strd",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/A8CA5EE328FA10C9519DF6057DA1F69682D28F7D0F5CCC7ECB72E3DCA2D157A4",
      name: "Stride",
      display: "strd",
      symbol: "STRD",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "ustrd",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/ustrd"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "ustrd"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg",
        theme: {
          primary_color_hex: "#e4047c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/C140AFD542AE77BD7DCC83F13FDD8C5E5BB8C4929785E6EC2F4C636F98F17901",
        exponent: 0,
        aliases: ["stuatom"]
      }, {
        denom: "statom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C140AFD542AE77BD7DCC83F13FDD8C5E5BB8C4929785E6EC2F4C636F98F17901",
      name: "Stride Staked ATOM",
      display: "statom",
      symbol: "stATOM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stuatom",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stuatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stuatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/5DD1F95ED336014D00CE2520977EC71566D282F9749170ADC83A392E0EA7426A",
        exponent: 0,
        aliases: ["stustars"]
      }, {
        denom: "ststars",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/5DD1F95ED336014D00CE2520977EC71566D282F9749170ADC83A392E0EA7426A",
      name: "Stride Staked STARS",
      display: "ststars",
      symbol: "stSTARS",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "ustars"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stustars",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stustars"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/ststars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/ststars.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stustars"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/ststars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/ststars.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Solarbank DAO Governance Token for speeding up the shift to renewable and green energy",
      denom_units: [{
        denom: "ibc/C3FC4DED273E7D1DD2E7BAA3317EC9A53CD3252B577AA33DC00D9DF2BDF3ED5C",
        exponent: 0,
        aliases: ["cw20:juno159q8t5g02744lxq8lfmcn6f78qqulq9wn3y9w7lxjgkz4e0a6kvsfvapse"]
      }, {
        denom: "solar",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C3FC4DED273E7D1DD2E7BAA3317EC9A53CD3252B577AA33DC00D9DF2BDF3ED5C",
      name: "Solarbank DAO",
      display: "solar",
      symbol: "SOLAR",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno159q8t5g02744lxq8lfmcn6f78qqulq9wn3y9w7lxjgkz4e0a6kvsfvapse",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno159q8t5g02744lxq8lfmcn6f78qqulq9wn3y9w7lxjgkz4e0a6kvsfvapse"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/solar.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/solar.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno159q8t5g02744lxq8lfmcn6f78qqulq9wn3y9w7lxjgkz4e0a6kvsfvapse"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/solar.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/solar.svg",
        theme: {
          primary_color_hex: "#1c1c1b"
        }
      }]
    },
    {
      description: "StakeEasy governance token",
      denom_units: [{
        denom: "ibc/18A676A074F73B9B42DA4F9DFC8E5AEF334C9A6636DDEC8D34682F52F1DECDF6",
        exponent: 0,
        aliases: ["cw20:juno19rqljkh95gh40s7qdx40ksx3zq5tm4qsmsrdz9smw668x9zdr3lqtg33mf"]
      }, {
        denom: "seasy",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/18A676A074F73B9B42DA4F9DFC8E5AEF334C9A6636DDEC8D34682F52F1DECDF6",
      name: "StakeEasy SEASY",
      display: "seasy",
      symbol: "SEASY",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno19rqljkh95gh40s7qdx40ksx3zq5tm4qsmsrdz9smw668x9zdr3lqtg33mf",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno19rqljkh95gh40s7qdx40ksx3zq5tm4qsmsrdz9smw668x9zdr3lqtg33mf"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/seasy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/seasy.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno19rqljkh95gh40s7qdx40ksx3zq5tm4qsmsrdz9smw668x9zdr3lqtg33mf"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/seasy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/seasy.svg",
        theme: {
          primary_color_hex: "#2d2c2d"
        }
      }]
    },
    {
      description: "The native token of Axelar",
      denom_units: [{
        denom: "ibc/903A61A498756EA560B85A85132D3AEE21B5DEDD41213725D22ABF276EA6945E",
        exponent: 0,
        aliases: ["uaxl"]
      }, {
        denom: "axl",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/903A61A498756EA560B85A85132D3AEE21B5DEDD41213725D22ABF276EA6945E",
      name: "Axelar",
      display: "axl",
      symbol: "AXL",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "uaxl",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-208",
          path: "transfer/channel-208/uaxl"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg"
      },
      images: [{
        image_sync: {
          chain_name: "axelar",
          base_denom: "uaxl"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "REBUS, the native coin of the Rebus chain.",
      denom_units: [{
        denom: "ibc/A1AC7F9EE2F643A68E3A35BCEB22040120BEA4059773BB56985C76BDFEBC71D9",
        exponent: 0,
        aliases: ["arebus"]
      }, {
        denom: "rebus",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/A1AC7F9EE2F643A68E3A35BCEB22040120BEA4059773BB56985C76BDFEBC71D9",
      name: "Rebus",
      display: "rebus",
      symbol: "REBUS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "rebus",
          base_denom: "arebus",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-355",
          path: "transfer/channel-355/arebus"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.svg"
      },
      images: [{
        image_sync: {
          chain_name: "rebus",
          base_denom: "arebus"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.svg",
        theme: {
          primary_color_hex: "#e75486"
        }
      }]
    },
    {
      description: "The native token of Teritori",
      denom_units: [{
        denom: "ibc/EB7FB9C8B425F289B63703413327C2051030E848CE4EAAEA2E51199D6D39D3EC",
        exponent: 0,
        aliases: ["utori"]
      }, {
        denom: "tori",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/EB7FB9C8B425F289B63703413327C2051030E848CE4EAAEA2E51199D6D39D3EC",
      name: "Teritori",
      display: "tori",
      symbol: "TORI",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "teritori",
          base_denom: "utori",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-362",
          path: "transfer/channel-362/utori"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/utori.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/utori.svg"
      },
      images: [{
        image_sync: {
          chain_name: "teritori",
          base_denom: "utori"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/utori.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/utori.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/84502A75BCA4A5F68D464C00B3F610CE2585847D59B52E5FFB7C3C9D2DDCD3FE",
        exponent: 0,
        aliases: ["stujuno"]
      }, {
        denom: "stjuno",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/84502A75BCA4A5F68D464C00B3F610CE2585847D59B52E5FFB7C3C9D2DDCD3FE",
      name: "Stride Staked JUNO",
      display: "stjuno",
      symbol: "stJUNO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "juno",
          base_denom: "ujuno"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stujuno",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stujuno"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stjuno.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stujuno"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stjuno.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/D176154B0C63D1F9C6DCFB4F70349EBF2E2B5A87A05902F57A6AE92B863E9AEC",
        exponent: 0,
        aliases: ["stuosmo"]
      }, {
        denom: "stosmo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D176154B0C63D1F9C6DCFB4F70349EBF2E2B5A87A05902F57A6AE92B863E9AEC",
      name: "Stride Staked OSMO",
      display: "stosmo",
      symbol: "stOSMO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stuosmo",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stuosmo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stuosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "The native token cw20 for MuseDAO on Juno Chain",
      denom_units: [{
        denom: "ibc/6B982170CE024689E8DD0E7555B129B488005130D4EDA426733D552D10B36D8F",
        exponent: 0,
        aliases: ["cw20:juno1p8x807f6h222ur0vssqy3qk6mcpa40gw2pchquz5atl935t7kvyq894ne3"]
      }, {
        denom: "muse",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/6B982170CE024689E8DD0E7555B129B488005130D4EDA426733D552D10B36D8F",
      name: "MuseDAO",
      display: "muse",
      symbol: "MUSE",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1p8x807f6h222ur0vssqy3qk6mcpa40gw2pchquz5atl935t7kvyq894ne3",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1p8x807f6h222ur0vssqy3qk6mcpa40gw2pchquz5atl935t7kvyq894ne3"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/muse.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1p8x807f6h222ur0vssqy3qk6mcpa40gw2pchquz5atl935t7kvyq894ne3"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/muse.png",
        theme: {
          primary_color_hex: "#32255f"
        }
      }]
    },
    {
      description: "The native token of Lambda",
      denom_units: [{
        denom: "ibc/80825E8F04B12D914ABEADB1F4D39C04755B12C8402F6876EE3168450C0A90BB",
        exponent: 0,
        aliases: ["ulamb"]
      }, {
        denom: "lamb",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/80825E8F04B12D914ABEADB1F4D39C04755B12C8402F6876EE3168450C0A90BB",
      name: "Lambda",
      display: "lamb",
      symbol: "LAMB",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "lambda",
          base_denom: "ulamb",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-378",
          path: "transfer/channel-378/ulamb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.svg"
      },
      images: [{
        image_sync: {
          chain_name: "lambda",
          base_denom: "ulamb"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lambda/images/lambda.svg",
        theme: {
          primary_color_hex: "#e41c54"
        }
      }]
    },
    {
      description: "The native over-collateralized stablecoin from the Kujira chain.",
      denom_units: [{
        denom: "ibc/44492EAB24B72E3FB59B9FA619A22337FB74F95D8808FE6BC78CC0E6C18DC2EC",
        exponent: 0,
        aliases: ["factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk"]
      }, {
        denom: "usk",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/44492EAB24B72E3FB59B9FA619A22337FB74F95D8808FE6BC78CC0E6C18DC2EC",
      name: "USK",
      display: "usk",
      symbol: "USK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kujira",
          base_denom: "factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-259",
          path: "transfer/channel-259/factory:kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7:uusk"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/usk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/usk.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kujira",
          base_denom: "factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/usk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/usk.svg",
        theme: {
          primary_color_hex: "#2e363f"
        }
      }]
    },
    {
      description: "Staking and governance coin for the Unification Blockchain",
      denom_units: [{
        denom: "ibc/608EF5C0CE64FEA097500DB39657BDD36CA708CC5DCC2E250A024B6981DD36BC",
        exponent: 0,
        aliases: ["nund"]
      }, {
        denom: "FUND",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/608EF5C0CE64FEA097500DB39657BDD36CA708CC5DCC2E250A024B6981DD36BC",
      name: "Unification",
      display: "FUND",
      symbol: "FUND",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "unification",
          base_denom: "nund",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-382",
          path: "transfer/channel-382/nund"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg"
      },
      images: [{
        image_sync: {
          chain_name: "unification",
          base_denom: "nund"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png",
        theme: {
          primary_color_hex: "#2279c0"
        }
      }]
    },
    {
      description: "The native staking and governance token of Jackal.",
      denom_units: [{
        denom: "ibc/8E697BDABE97ACE8773C6DF7402B2D1D5104DD1EEABE12608E3469B7F64C15BA",
        exponent: 0,
        aliases: ["ujkl"]
      }, {
        denom: "jkl",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/8E697BDABE97ACE8773C6DF7402B2D1D5104DD1EEABE12608E3469B7F64C15BA",
      name: "Jackal",
      display: "jkl",
      symbol: "JKL",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "jackal",
          base_denom: "ujkl",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-412",
          path: "transfer/channel-412/ujkl"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.svg"
      },
      images: [{
        image_sync: {
          chain_name: "jackal",
          base_denom: "ujkl"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.svg",
        theme: {
          primary_color_hex: "#dbdbcb"
        }
      }]
    },
    {
      description: "The native token cw20 for Alter on Secret Network",
      denom_units: [{
        denom: "ibc/A6383B6CF5EA23E067666C06BC34E2A96869927BD9744DC0C1643E589C710AA3",
        exponent: 0,
        aliases: ["cw20:secret12rcvz0umvk875kd6a803txhtlu7y0pnd73kcej"]
      }, {
        denom: "alter",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/A6383B6CF5EA23E067666C06BC34E2A96869927BD9744DC0C1643E589C710AA3",
      name: "Alter",
      display: "alter",
      symbol: "ALTER",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret12rcvz0umvk875kd6a803txhtlu7y0pnd73kcej",
          port: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
          channel_id: "channel-44"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-476",
          path: "transfer/channel-476/cw20:secret12rcvz0umvk875kd6a803txhtlu7y0pnd73kcej"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/alter.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/alter.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret12rcvz0umvk875kd6a803txhtlu7y0pnd73kcej"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/alter.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/alter.svg",
        theme: {
          primary_color_hex: "#694c90"
        }
      }]
    },
    {
      description: "The native token cw20 for Button on Secret Network",
      denom_units: [{
        denom: "ibc/1FBA9E763B8679BEF7BAAAF2D16BCA78C3B297D226C3F31312C769D7B8F992D8",
        exponent: 0,
        aliases: ["cw20:secret1yxcexylwyxlq58umhgsjgstgcg2a0ytfy4d9lt"]
      }, {
        denom: "butt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1FBA9E763B8679BEF7BAAAF2D16BCA78C3B297D226C3F31312C769D7B8F992D8",
      name: "Button",
      display: "butt",
      symbol: "BUTT",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1yxcexylwyxlq58umhgsjgstgcg2a0ytfy4d9lt",
          port: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
          channel_id: "channel-44"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-476",
          path: "transfer/channel-476/cw20:secret1yxcexylwyxlq58umhgsjgstgcg2a0ytfy4d9lt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/butt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/butt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1yxcexylwyxlq58umhgsjgstgcg2a0ytfy4d9lt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/butt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/butt.svg",
        theme: {
          primary_color_hex: "#7b04eb"
        }
      }]
    },
    {
      description: "The native token cw20 for Shade on Secret Network",
      denom_units: [{
        denom: "ibc/71055835C7639739EAE03AACD1324FE162DBA41D09F197CB72D966D014225B1C",
        exponent: 0,
        aliases: ["cw20:secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d"]
      }, {
        denom: "shd",
        exponent: 8
      }],
      type_asset: "ics20",
      base: "ibc/71055835C7639739EAE03AACD1324FE162DBA41D09F197CB72D966D014225B1C",
      name: "Shade (old)",
      display: "shd",
      symbol: "SHD(old)",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d",
          port: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
          channel_id: "channel-44"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-476",
          path: "transfer/channel-476/cw20:secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shdold.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shdold.svg"
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "The native token cw20 for SIENNA on Secret Network",
      denom_units: [{
        denom: "ibc/9A8A93D04917A149C8AC7C16D3DA8F470D59E8D867499C4DA97450E1D7363213",
        exponent: 0,
        aliases: ["cw20:secret1rgm2m5t530tdzyd99775n6vzumxa5luxcllml4"]
      }, {
        denom: "sienna",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/9A8A93D04917A149C8AC7C16D3DA8F470D59E8D867499C4DA97450E1D7363213",
      name: "SIENNA",
      display: "sienna",
      symbol: "SIENNA",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1rgm2m5t530tdzyd99775n6vzumxa5luxcllml4",
          port: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
          channel_id: "channel-44"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-476",
          path: "transfer/channel-476/cw20:secret1rgm2m5t530tdzyd99775n6vzumxa5luxcllml4"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/sienna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/sienna.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1rgm2m5t530tdzyd99775n6vzumxa5luxcllml4"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/sienna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/sienna.svg",
        theme: {
          primary_color_hex: "#2c2c2c"
        }
      }]
    },
    {
      description: "The native token cw20 for SCRT Staking Derivatives on Secret Network",
      denom_units: [{
        denom: "ibc/D0E5BF2940FB58D9B283A339032DE88111407AAD7D94A7F1F3EB78874F8616D4",
        exponent: 0,
        aliases: ["cw20:secret1k6u0cy4feepm6pehnz804zmwakuwdapm69tuc4"]
      }, {
        denom: "stkd-scrt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D0E5BF2940FB58D9B283A339032DE88111407AAD7D94A7F1F3EB78874F8616D4",
      name: "SCRT Staking Derivatives",
      display: "stkd-scrt",
      symbol: "stkd-SCRT",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1k6u0cy4feepm6pehnz804zmwakuwdapm69tuc4",
          port: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
          channel_id: "channel-44"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-476",
          path: "transfer/channel-476/cw20:secret1k6u0cy4feepm6pehnz804zmwakuwdapm69tuc4"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/stkd-scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/stkd-scrt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1k6u0cy4feepm6pehnz804zmwakuwdapm69tuc4"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/stkd-scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/stkd-scrt.svg",
        theme: {
          primary_color_hex: "#b8a2dc"
        }
      }]
    },
    {
      description: "BeeZee native blockchain",
      denom_units: [{
        denom: "ibc/C822645522FC3EECF817609AA38C24B64D04F5C267A23BCCF8F2E3BC5755FA88",
        exponent: 0,
        aliases: ["ubze"]
      }, {
        denom: "bze",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C822645522FC3EECF817609AA38C24B64D04F5C267A23BCCF8F2E3BC5755FA88",
      name: "BeeZee",
      display: "bze",
      symbol: "BZE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "beezee",
          base_denom: "ubze",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-340",
          path: "transfer/channel-340/ubze"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.svg"
      },
      images: [{
        image_sync: {
          chain_name: "beezee",
          base_denom: "ubze"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/bze.svg",
        theme: {
          primary_color_hex: "#079fd7"
        }
      }]
    },
    {
      description: "The native token cw20 for Fanfury on Juno Chain",
      denom_units: [{
        denom: "ibc/7CE5F388D661D82A0774E47B5129DA51CC7129BD1A70B5FA6BCEBB5B0A2FAEAF",
        exponent: 0,
        aliases: ["cw20:juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz"]
      }, {
        denom: "fury",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/7CE5F388D661D82A0774E47B5129DA51CC7129BD1A70B5FA6BCEBB5B0A2FAEAF",
      name: "FURY.legacy",
      display: "fury",
      symbol: "FURY.juno",
      traces: [{
        type: "legacy-mintage",
        counterparty: {
          chain_name: "furya",
          base_denom: "ufury"
        },
        provider: "Fanfury"
      }, {
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/fanfury.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/fanfury.png",
        theme: {
          primary_color_hex: "#14045c"
        }
      }]
    },
    {
      description: "The native EVM, governance and staking token of the Acrechain",
      denom_units: [{
        denom: "ibc/BB936517F7E5D77A63E0ADB05217A6608B0C4CF8FBA7EA2F4BAE4107A7238F06",
        exponent: 0,
        aliases: ["aacre"]
      }, {
        denom: "acre",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/BB936517F7E5D77A63E0ADB05217A6608B0C4CF8FBA7EA2F4BAE4107A7238F06",
      name: "Acrechain",
      display: "acre",
      symbol: "ACRE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "acrechain",
          base_denom: "aacre",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-490",
          path: "transfer/channel-490/aacre"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.svg"
      },
      images: [{
        image_sync: {
          chain_name: "acrechain",
          base_denom: "aacre"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/acre.svg",
        theme: {
          primary_color_hex: "#4aa29e"
        }
      }]
    },
    {
      description: "Stable Token of Harbor protocol on Comdex network",
      denom_units: [{
        denom: "ibc/23CA6C8D1AB2145DD13EB1E089A2E3F960DC298B468CCE034E19E5A78B61136E",
        exponent: 0,
        aliases: ["ucmst"]
      }, {
        denom: "cmst",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/23CA6C8D1AB2145DD13EB1E089A2E3F960DC298B468CCE034E19E5A78B61136E",
      name: "CMST",
      display: "cmst",
      symbol: "CMST",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "comdex",
          base_denom: "ucmst",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-87",
          path: "transfer/channel-87/ucmst"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmst.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmst.svg"
      },
      images: [{
        image_sync: {
          chain_name: "comdex",
          base_denom: "ucmst"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmst.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/cmst.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The native EVM, governance and staking token of the Imversed",
      denom_units: [{
        denom: "ibc/92B223EBFA74DB99BEA92B23DEAA6050734FEEAABB84689CB8E1AE8F9C9F9AF4",
        exponent: 0,
        aliases: ["aimv"]
      }, {
        denom: "imv",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/92B223EBFA74DB99BEA92B23DEAA6050734FEEAABB84689CB8E1AE8F9C9F9AF4",
      name: "Imversed",
      display: "imv",
      symbol: "IMV",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "imversed",
          base_denom: "aimv",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-517",
          path: "transfer/channel-517/aimv"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.svg"
      },
      images: [{
        image_sync: {
          chain_name: "imversed",
          base_denom: "aimv"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/imversed/images/imversed.svg",
        theme: {
          primary_color_hex: "#4c54e4"
        }
      }]
    },
    {
      description: "The native token of Medas Digital Network",
      denom_units: [{
        denom: "ibc/01E94A5FF29B8DDEFC86F412CC3927F7330E9B523CC63A6194B1108F5276025C",
        exponent: 0,
        aliases: ["umedas"]
      }, {
        denom: "medas",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/01E94A5FF29B8DDEFC86F412CC3927F7330E9B523CC63A6194B1108F5276025C",
      name: "Medas Digital Network",
      display: "medas",
      symbol: "MEDAS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "medasdigital",
          base_denom: "umedas",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-519",
          path: "transfer/channel-519/umedas"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.svg"
      },
      images: [{
        image_sync: {
          chain_name: "medasdigital",
          base_denom: "umedas"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/medasdigital/images/medas.svg",
        theme: {
          primary_color_hex: "#147ccc"
        }
      }],
      keywords: ["medas"]
    },
    {
      description: "The native token cw20 for PHMN on Juno Chain",
      extended_description: "$PHMN is the governance token of a distributed validator. Similar to PoS chains, each holder possesses voting rights proportionate to the number of locked tokens. PHMN holders can govern the POSTHUMAN validator via DAODAO. For instance, decisions such as diversifying the treasury, updating the validator's commission rate, or exiting the network are determined by the PHMN community.",
      denom_units: [{
        denom: "ibc/D3B574938631B0A1BA704879020C696E514CFADAA7643CDE4BD5EB010BDE327B",
        exponent: 0,
        aliases: ["cw20:juno1rws84uz7969aaa7pej303udhlkt3j9ca0l3egpcae98jwak9quzq8szn2l"]
      }, {
        denom: "phmn",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D3B574938631B0A1BA704879020C696E514CFADAA7643CDE4BD5EB010BDE327B",
      name: "POSTHUMAN",
      display: "phmn",
      symbol: "PHMN",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1rws84uz7969aaa7pej303udhlkt3j9ca0l3egpcae98jwak9quzq8szn2l",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1rws84uz7969aaa7pej303udhlkt3j9ca0l3egpcae98jwak9quzq8szn2l"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/phmn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/phmn.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1rws84uz7969aaa7pej303udhlkt3j9ca0l3egpcae98jwak9quzq8szn2l"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/phmn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/phmn.svg",
        theme: {
          primary_color_hex: "#bbc2c6"
        }
      }],
      socials: {
        website: "https://posthuman.digital/",
        twitter: "https://twitter.com/POSTHUMAN_DVS"
      }
    },
    {
      description: "The native token cw20 for Amber on Secret Network",
      denom_units: [{
        denom: "ibc/18A1B70E3205A48DE8590C0D11030E7146CDBF1048789261D53FFFD7527F8B55",
        exponent: 0,
        aliases: ["cw20:secret1s09x2xvfd2lp2skgzm29w2xtena7s8fq98v852"]
      }, {
        denom: "amber",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/18A1B70E3205A48DE8590C0D11030E7146CDBF1048789261D53FFFD7527F8B55",
      name: "Amber",
      display: "amber",
      symbol: "AMBER",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1s09x2xvfd2lp2skgzm29w2xtena7s8fq98v852",
          port: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
          channel_id: "channel-44"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-476",
          path: "transfer/channel-476/cw20:secret1s09x2xvfd2lp2skgzm29w2xtena7s8fq98v852"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/amber.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/amber.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1s09x2xvfd2lp2skgzm29w2xtena7s8fq98v852"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/amber.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/amber.svg",
        theme: {
          primary_color_hex: "#f2b854"
        }
      }]
    },
    {
      description: "The native token of Onomy Protocol",
      denom_units: [{
        denom: "ibc/B9606D347599F0F2FDF82BA3EE339000673B7D274EA50F59494DC51EFCD42163",
        exponent: 0,
        aliases: ["anom"]
      }, {
        denom: "nom",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/B9606D347599F0F2FDF82BA3EE339000673B7D274EA50F59494DC51EFCD42163",
      name: "Onomy",
      display: "nom",
      symbol: "NOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "onomy",
          base_denom: "anom",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-525",
          path: "transfer/channel-525/anom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onomy/images/nom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onomy/images/nom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "onomy",
          base_denom: "anom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onomy/images/nom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/onomy/images/nom.svg",
        theme: {
          primary_color_hex: "#1c1c28"
        }
      }],
      keywords: [
        "dex",
        "stablecoin",
        "bridge",
        "staking"
      ]
    },
    {
      description: "PSTAKE Liquid-Staked ATOM",
      denom_units: [{
        denom: "ibc/CAA179E40F0266B0B29FB5EAA288FB9212E628822265D4141EBD1C47C3CBFCBC",
        exponent: 0,
        aliases: ["stk/uatom"]
      }, {
        denom: "stkatom",
        exponent: 6,
        aliases: ["stk/atom"]
      }],
      type_asset: "ics20",
      base: "ibc/CAA179E40F0266B0B29FB5EAA288FB9212E628822265D4141EBD1C47C3CBFCBC",
      name: "PSTAKE staked ATOM",
      display: "stkatom",
      symbol: "stkATOM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        provider: "pSTAKE"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "persistence",
          base_denom: "stk/uatom",
          channel_id: "channel-6"
        },
        chain: {
          channel_id: "channel-4",
          path: "transfer/channel-4/stk/uatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "persistence",
          base_denom: "stk/uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg",
        theme: {
          primary_color_hex: "#c4444c"
        }
      }]
    },
    {
      description: "The native staking and governance token of the Dyson Protocol",
      denom_units: [{
        denom: "ibc/E27CD305D33F150369AB526AEB6646A76EC3FFB1A6CA58A663B5DE657A89D55D",
        exponent: 0,
        aliases: ["dys"]
      }],
      type_asset: "ics20",
      base: "ibc/E27CD305D33F150369AB526AEB6646A76EC3FFB1A6CA58A663B5DE657A89D55D",
      name: "Dyson Protocol",
      display: "ibc/E27CD305D33F150369AB526AEB6646A76EC3FFB1A6CA58A663B5DE657A89D55D",
      symbol: "DYS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "dyson",
          base_denom: "dys",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-526",
          path: "transfer/channel-526/dys"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.svg"
      },
      images: [{
        image_sync: {
          chain_name: "dyson",
          base_denom: "dys"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The native token cw20 for Hopers on Juno Chain",
      denom_units: [{
        denom: "ibc/D3ADAF73F84CDF205BCB72C142FDAEEA2C612AB853CEE6D6C06F184FA38B1099",
        exponent: 0,
        aliases: ["cw20:juno1u45shlp0q4gcckvsj06ss4xuvsu0z24a0d0vr9ce6r24pht4e5xq7q995n"]
      }, {
        denom: "hopers",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D3ADAF73F84CDF205BCB72C142FDAEEA2C612AB853CEE6D6C06F184FA38B1099",
      name: "Hopers",
      display: "hopers",
      symbol: "HOPERS",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1u45shlp0q4gcckvsj06ss4xuvsu0z24a0d0vr9ce6r24pht4e5xq7q995n",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1u45shlp0q4gcckvsj06ss4xuvsu0z24a0d0vr9ce6r24pht4e5xq7q995n"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hopers.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hopers.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1u45shlp0q4gcckvsj06ss4xuvsu0z24a0d0vr9ce6r24pht4e5xq7q995n"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hopers.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/hopers.svg",
        theme: {
          primary_color_hex: "#08d890"
        }
      }]
    },
    {
      description: "Overcollateralized stable coin for Arable derivatives v1",
      denom_units: [{
        denom: "ibc/5D270A584B1078FBE07D14570ED5E88EC1FEDA8518B76C322606291E6FD8286F",
        exponent: 0,
        aliases: ["erc20/0x2Cbea61fdfDFA520Ee99700F104D5b75ADf50B0c"]
      }, {
        denom: "arusd",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/5D270A584B1078FBE07D14570ED5E88EC1FEDA8518B76C322606291E6FD8286F",
      name: "Arable USD",
      display: "arusd",
      symbol: "arUSD",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "acrechain",
          base_denom: "erc20/0x2Cbea61fdfDFA520Ee99700F104D5b75ADf50B0c",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-490",
          path: "transfer/channel-490/erc20/0x2Cbea61fdfDFA520Ee99700F104D5b75ADf50B0c"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/arusd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/arusd.svg"
      },
      images: [{
        image_sync: {
          chain_name: "acrechain",
          base_denom: "erc20/0x2Cbea61fdfDFA520Ee99700F104D5b75ADf50B0c"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/arusd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/arusd.svg",
        theme: {
          primary_color_hex: "#77b64f"
        }
      }]
    },
    {
      description: "The native EVM, governance and staking token of the Planq Network",
      denom_units: [{
        denom: "ibc/B1E0166EA0D759FDF4B207D1F5F12210D8BFE36F2345CEFC76948CE2B36DFBAF",
        exponent: 0,
        aliases: ["aplanq"]
      }, {
        denom: "planq",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/B1E0166EA0D759FDF4B207D1F5F12210D8BFE36F2345CEFC76948CE2B36DFBAF",
      name: "Planq",
      display: "planq",
      symbol: "PLQ",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "planq",
          base_denom: "aplanq",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-492",
          path: "transfer/channel-492/aplanq"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.svg"
      },
      images: [{
        image_sync: {
          chain_name: "planq",
          base_denom: "aplanq"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.svg",
        theme: {
          primary_color_hex: "#d4f3fb"
        }
      }]
    },
    {
      description: "Fantom's native utility token — FTM — powers the entire Fantom blockchain ecosystem. FTM tokens are used for staking, governance, payments, and fees on the network.",
      denom_units: [{
        denom: "ibc/5E2DFDF1734137302129EA1C1BA21A580F96F778D4F021815EA4F6DB378DA1A4",
        exponent: 0,
        aliases: ["wftm-wei"]
      }, {
        denom: "ftm",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/5E2DFDF1734137302129EA1C1BA21A580F96F778D4F021815EA4F6DB378DA1A4",
      name: "Fantom",
      display: "ftm",
      symbol: "FTM",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "fantom",
            base_denom: "wei"
          },
          chain: {
            contract: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83"
          },
          provider: "Fantom"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "fantom",
            base_denom: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "wftm-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/wftm-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/fantom/images/ftm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/fantom/images/ftm.svg"
      },
      images: [{
        image_sync: {
          chain_name: "fantom",
          base_denom: "wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/fantom/images/ftm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/fantom/images/ftm.svg",
        theme: {
          primary_color_hex: "#1c6cfc"
        }
      }]
    },
    {
      description: "Canto is a Layer-1 blockchain built to deliver on the promise of DeFi",
      denom_units: [{
        denom: "ibc/47CAF2DB8C016FAC960F33BC492FD8E454593B65CC59D70FA9D9F30424F9C32F",
        exponent: 0,
        aliases: ["acanto"]
      }, {
        denom: "canto",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/47CAF2DB8C016FAC960F33BC492FD8E454593B65CC59D70FA9D9F30424F9C32F",
      name: "Canto",
      display: "canto",
      symbol: "CANTO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "canto",
          base_denom: "acanto",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-550",
          path: "transfer/channel-550/acanto"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.svg"
      },
      images: [{
        image_sync: {
          chain_name: "canto",
          base_denom: "acanto"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/canto/images/canto.svg",
        theme: {
          primary_color_hex: "#1c1f1f"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked STARS",
      denom_units: [{
        denom: "ibc/46C83BB054E12E189882B5284542DB605D94C99827E367C9192CF0579CD5BC83",
        exponent: 0,
        aliases: ["uqstars"]
      }, {
        denom: "qstars",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/46C83BB054E12E189882B5284542DB605D94C99827E367C9192CF0579CD5BC83",
      name: "Quicksilver Liquid Staked STARS",
      display: "qstars",
      symbol: "qSTARS",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "ustars"
        },
        provider: "Quicksilver"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "quicksilver",
          base_denom: "uqstars",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-522",
          path: "transfer/channel-522/uqstars"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qstars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qstars.svg"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilver",
          base_denom: "uqstars"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qstars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qstars.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "WYND DAO Governance Token",
      denom_units: [{
        denom: "ibc/2FBAC4BF296D7844796844B35978E5899984BA5A6314B2DD8F83C215550010B3",
        exponent: 0,
        aliases: ["cw20:juno1mkw83sv6c7sjdvsaplrzc8yaes9l42p4mhy0ssuxjnyzl87c9eps7ce3m9"]
      }, {
        denom: "wynd",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2FBAC4BF296D7844796844B35978E5899984BA5A6314B2DD8F83C215550010B3",
      name: "Wynd DAO Governance Token",
      display: "wynd",
      symbol: "WYND",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1mkw83sv6c7sjdvsaplrzc8yaes9l42p4mhy0ssuxjnyzl87c9eps7ce3m9",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1mkw83sv6c7sjdvsaplrzc8yaes9l42p4mhy0ssuxjnyzl87c9eps7ce3m9"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wynd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wynd.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1mkw83sv6c7sjdvsaplrzc8yaes9l42p4mhy0ssuxjnyzl87c9eps7ce3m9"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wynd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/wynd.svg",
        theme: {
          primary_color_hex: "#6bcc95"
        }
      }]
    },
    {
      description: "USDC is a fully collateralized US Dollar stablecoin developed by CENTRE, the open source project with Circle being the first of several forthcoming issuers.",
      denom_units: [{
        denom: "ibc/231FD77ECCB2DB916D314019DA30FE013202833386B1908A191D16989AD80B5A",
        exponent: 0,
        aliases: ["polygon-uusdc"]
      }, {
        denom: "polygon-usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/231FD77ECCB2DB916D314019DA30FE013202833386B1908A191D16989AD80B5A",
      name: "USDC (Ethereum) (Polygon via Axelar)",
      display: "polygon-usdc",
      symbol: "USDC.e.matic.axl",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
          },
          provider: "Polygon PoS Bridge"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "polygon",
            base_denom: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "polygon-uusdc",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/polygon-uusdc"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/polygon.usdc.svg"
      },
      images: [
        {
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/polygon.usdc.svg"
        },
        {
          image_sync: {
            chain_name: "axelar",
            base_denom: "polygon-uusdc"
          },
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
          theme: {
            primary_color_hex: "#2474cc"
          }
        },
        {
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
        }
      ]
    },
    {
      description: "USDC is a fully collateralized US Dollar stablecoin developed by CENTRE, the open source project with Circle being the first of several forthcoming issuers.",
      denom_units: [{
        denom: "ibc/F17C9CA112815613C5B6771047A093054F837C3020CBA59DFFD9D780A8B2984C",
        exponent: 0,
        aliases: ["avalanche-uusdc"]
      }, {
        denom: "avalanche-usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F17C9CA112815613C5B6771047A093054F837C3020CBA59DFFD9D780A8B2984C",
      name: "USD Coin (Avalanche)",
      display: "avalanche-usdc",
      symbol: "USDC.avax.axl",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "additional-mintage",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
          },
          provider: "Circle"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "avalanche",
            base_denom: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "avalanche-uusdc",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/avalanche-uusdc"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/avalanche.usdc.svg"
      },
      images: [
        {
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/avalanche.usdc.svg"
        },
        {
          image_sync: {
            chain_name: "axelar",
            base_denom: "avalanche-uusdc"
          },
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
          theme: {
            primary_color_hex: "#2474cc"
          }
        },
        {
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
        }
      ]
    },
    {
      description: "Mars Protocol token (pre-migration)",
      denom_units: [{
        denom: "ibc/573FCD90FACEE750F55A8864EF7D38265F07E5A9273FA0E8DAFD39951332B580",
        exponent: 0,
        aliases: ["umars"]
      }, {
        denom: "MARS.old",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/573FCD90FACEE750F55A8864EF7D38265F07E5A9273FA0E8DAFD39951332B580",
      name: "Mars Protocol token (Mars Hub)",
      display: "MARS.old",
      symbol: "MARS.mars",
      traces: [{
        type: "legacy-mintage",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ndu2wvkrxtane8se2tr48gv7nsm46y5gcqjhux/MARS"
        },
        provider: "Mars Hub"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "mars",
          base_denom: "umars",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-557",
          path: "transfer/channel-557/umars"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-token-ibc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-token-ibc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "mars",
          base_denom: "umars"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-token-ibc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-token-ibc.svg",
        theme: {
          primary_color_hex: "#000000"
        }
      }]
    },
    {
      description: "Ciento Exchange Token",
      denom_units: [{
        denom: "ibc/D38BB3DD46864694F009AF01DA5A815B3A875F8CC52FF5679BFFCC35DC7451D5",
        exponent: 0,
        aliases: ["erc20/0xAE6D3334989a22A65228732446731438672418F2"]
      }, {
        denom: "cnto",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/D38BB3DD46864694F009AF01DA5A815B3A875F8CC52FF5679BFFCC35DC7451D5",
      name: "Ciento Token",
      display: "cnto",
      symbol: "CNTO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "acrechain",
          base_denom: "erc20/0xAE6D3334989a22A65228732446731438672418F2",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-490",
          path: "transfer/channel-490/erc20/0xAE6D3334989a22A65228732446731438672418F2"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/cnto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/cnto.svg"
      },
      images: [{
        image_sync: {
          chain_name: "acrechain",
          base_denom: "erc20/0xAE6D3334989a22A65228732446731438672418F2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/cnto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/acrechain/images/cnto.svg",
        theme: {
          primary_color_hex: "#ecc53b"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/C491E7582E94AE921F6A029790083CDE1106C28F3F6C4AD7F1340544C13EC372",
        exponent: 0,
        aliases: ["stuluna"]
      }, {
        denom: "stluna",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C491E7582E94AE921F6A029790083CDE1106C28F3F6C4AD7F1340544C13EC372",
      name: "Stride Staked LUNA",
      display: "stluna",
      symbol: "stLUNA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "terra2",
          base_denom: "uluna"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stuluna",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stuluna"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stluna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stluna.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stuluna"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stluna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stluna.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/C5579A9595790017C600DD726276D978B9BF314CF82406CE342720A9C7911A01",
        exponent: 0,
        aliases: ["staevmos"]
      }, {
        denom: "stevmos",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/C5579A9595790017C600DD726276D978B9BF314CF82406CE342720A9C7911A01",
      name: "Stride Staked EVMOS",
      display: "stevmos",
      symbol: "stEVMOS",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "evmos",
          base_denom: "aevmos"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "staevmos",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/staevmos"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stevmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stevmos.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "staevmos"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stevmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stevmos.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "nRide Token",
      extended_description: "nRide is developing a uber-like ride-hailing protocol, leveraging cosmwasm smart-contracts for payment, driver registration and text-messaging between the rider and the driver, to create a trustless public transportation environment for any cab or taxi company to use.",
      denom_units: [{
        denom: "ibc/E750D31033DC1CF4A044C3AA0A8117401316DC918FBEBC4E3D34F91B09D5F54C",
        exponent: 0,
        aliases: ["cw20:juno1qmlchtmjpvu0cr7u0tad2pq8838h6farrrjzp39eqa9xswg7teussrswlq"]
      }, {
        denom: "nride",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E750D31033DC1CF4A044C3AA0A8117401316DC918FBEBC4E3D34F91B09D5F54C",
      name: "nRide Token",
      display: "nride",
      symbol: "NRIDE",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1qmlchtmjpvu0cr7u0tad2pq8838h6farrrjzp39eqa9xswg7teussrswlq",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1qmlchtmjpvu0cr7u0tad2pq8838h6farrrjzp39eqa9xswg7teussrswlq"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/nride.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/nride.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1qmlchtmjpvu0cr7u0tad2pq8838h6farrrjzp39eqa9xswg7teussrswlq"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/nride.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/nride.svg",
        theme: {
          primary_color_hex: "#050505"
        }
      }]
    },
    {
      description: "The native staking token of 8ball.",
      denom_units: [{
        denom: "ibc/8BE73A810E22F80E5E850531A688600D63AE7392E7C2770AE758CAA4FD921B7F",
        exponent: 0,
        aliases: ["uebl"]
      }, {
        denom: "ebl",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/8BE73A810E22F80E5E850531A688600D63AE7392E7C2770AE758CAA4FD921B7F",
      name: "8ball",
      display: "ebl",
      symbol: "EBL",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "8ball",
          base_denom: "uebl",
          channel_id: "channel-16"
        },
        chain: {
          channel_id: "channel-641",
          path: "transfer/channel-641/uebl"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.svg"
      },
      images: [{
        image_sync: {
          chain_name: "8ball",
          base_denom: "uebl"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/8ball/images/8ball.svg",
        theme: {
          primary_color_hex: "#dbdbdb"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked ATOM",
      denom_units: [{
        denom: "ibc/FA602364BEC305A696CBDF987058E99D8B479F0318E47314C49173E8838C5BAC",
        exponent: 0,
        aliases: ["uqatom"]
      }, {
        denom: "qatom",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/FA602364BEC305A696CBDF987058E99D8B479F0318E47314C49173E8838C5BAC",
      name: "Quicksilver Liquid Staked ATOM",
      display: "qatom",
      symbol: "qATOM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        provider: "Quicksilver"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "quicksilver",
          base_denom: "uqatom",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-522",
          path: "transfer/channel-522/uqatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qatom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilver",
          base_denom: "uqatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qatom.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Governance Token of Harbor protocol on Comdex network",
      denom_units: [{
        denom: "ibc/AD4DEA52408EA07C0C9E19444EC8DA84A274A70AD2687A710EFDDEB28BB2986A",
        exponent: 0,
        aliases: ["uharbor"]
      }, {
        denom: "harbor",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/AD4DEA52408EA07C0C9E19444EC8DA84A274A70AD2687A710EFDDEB28BB2986A",
      name: "Harbor",
      display: "harbor",
      symbol: "HARBOR",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "comdex",
          base_denom: "uharbor",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-87",
          path: "transfer/channel-87/uharbor"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/harbor.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/harbor.svg"
      },
      images: [{
        image_sync: {
          chain_name: "comdex",
          base_denom: "uharbor"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/harbor.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/comdex/images/harbor.svg",
        theme: {
          primary_color_hex: "#645ca4"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked REGEN",
      denom_units: [{
        denom: "ibc/79A676508A2ECA1021EDDC7BB9CF70CEEC9514C478DA526A5A8B3E78506C2206",
        exponent: 0,
        aliases: ["uqregen"]
      }, {
        denom: "qregen",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/79A676508A2ECA1021EDDC7BB9CF70CEEC9514C478DA526A5A8B3E78506C2206",
      name: "Quicksilver Liquid Staked Regen",
      display: "qregen",
      symbol: "qREGEN",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "regen",
          base_denom: "uregen"
        },
        provider: "Quicksilver"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "quicksilver",
          base_denom: "uqregen",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-522",
          path: "transfer/channel-522/uqregen"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qregen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qregen.svg"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilver",
          base_denom: "uqregen"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qregen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qregen.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Inspired by Bonk. A community project to celebrate the settlers of JunoNetwork.",
      denom_units: [{
        denom: "ibc/4F24D904BAB5FFBD3524F2DE3EC3C7A9E687A2408D9A985E57B356D9FA9201C6",
        exponent: 0,
        aliases: ["cw20:juno1u8cr3hcjvfkzxcaacv9q75uw9hwjmn8pucc93pmy6yvkzz79kh3qncca8x"]
      }, {
        denom: "fox",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4F24D904BAB5FFBD3524F2DE3EC3C7A9E687A2408D9A985E57B356D9FA9201C6",
      name: "Juno Fox",
      display: "fox",
      symbol: "FOX",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1u8cr3hcjvfkzxcaacv9q75uw9hwjmn8pucc93pmy6yvkzz79kh3qncca8x",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1u8cr3hcjvfkzxcaacv9q75uw9hwjmn8pucc93pmy6yvkzz79kh3qncca8x"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/fox.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1u8cr3hcjvfkzxcaacv9q75uw9hwjmn8pucc93pmy6yvkzz79kh3qncca8x"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/fox.png",
        theme: {
          primary_color_hex: "#ee5f06"
        }
      }]
    },
    {
      description: "QCK - native token of Quicksilver",
      denom_units: [{
        denom: "ibc/635CB83EF1DFE598B10A3E90485306FD0D47D34217A4BE5FD9977FA010A5367D",
        exponent: 0,
        aliases: ["uqck"]
      }, {
        denom: "qck",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/635CB83EF1DFE598B10A3E90485306FD0D47D34217A4BE5FD9977FA010A5367D",
      name: "Quicksilver",
      display: "qck",
      symbol: "QCK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "quicksilver",
          base_denom: "uqck",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-522",
          path: "transfer/channel-522/uqck"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.png"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilver",
          base_denom: "uqck"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.png",
        theme: {
          primary_color_hex: "#b2b2b2"
        }
      }]
    },
    {
      description: "The native token of Arkhadian",
      denom_units: [{
        denom: "ibc/0F91EE8B98AAE3CF393D94CD7F89A10F8D7758C5EC707E721899DFE65C164C28",
        exponent: 0,
        aliases: ["arkh"]
      }, {
        denom: "ARKH",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0F91EE8B98AAE3CF393D94CD7F89A10F8D7758C5EC707E721899DFE65C164C28",
      name: "Arkhadian",
      display: "ARKH",
      symbol: "ARKH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "arkh",
          base_denom: "arkh",
          channel_id: "channel-12"
        },
        chain: {
          channel_id: "channel-648",
          path: "transfer/channel-648/arkh"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.svg"
      },
      images: [{
        image_sync: {
          chain_name: "arkh",
          base_denom: "arkh"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/arkh/images/arkh.svg",
        theme: {
          primary_color_hex: "#bdbb82"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "Quicksilver Liquid Staked OSMO",
      denom_units: [{
        denom: "ibc/42D24879D4569CE6477B7E88206ADBFE47C222C6CAD51A54083E4A72594269FC",
        exponent: 0,
        aliases: ["uqosmo"]
      }, {
        denom: "qosmo",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/42D24879D4569CE6477B7E88206ADBFE47C222C6CAD51A54083E4A72594269FC",
      name: "Quicksilver Liquid Staked OSMO",
      display: "qosmo",
      symbol: "qOSMO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        provider: "Quicksilver"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "quicksilver",
          base_denom: "uqosmo",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-522",
          path: "transfer/channel-522/uqosmo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qosmo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilver",
          base_denom: "uqosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qosmo.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Frienzies are an IBC token redeemable exclusively for a physical asset issued by the Noble entity.",
      denom_units: [{
        denom: "ibc/7FA7EC64490E3BDE5A1A28CBE73CC0AD22522794957BC891C46321E3A6074DB9",
        exponent: 0,
        aliases: ["microfrienzies", "ufrienzies"]
      }, {
        denom: "frienzies",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/7FA7EC64490E3BDE5A1A28CBE73CC0AD22522794957BC891C46321E3A6074DB9",
      name: "Frienzies",
      display: "frienzies",
      symbol: "FRNZ",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "noble",
          base_denom: "ufrienzies",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-750",
          path: "transfer/channel-750/ufrienzies"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/frnz.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/frnz.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "ufrienzies"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/frnz.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/frnz.svg",
        theme: {
          primary_color_hex: "#04041c"
        }
      }]
    },
    {
      description: "The native token of Migaloo Chain",
      denom_units: [{
        denom: "ibc/EDD6F0D66BCD49C1084FB2C35353B4ACD7B9191117CE63671B61320548F7C89D",
        exponent: 0,
        aliases: ["uwhale"]
      }, {
        denom: "whale",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/EDD6F0D66BCD49C1084FB2C35353B4ACD7B9191117CE63671B61320548F7C89D",
      name: "Migaloo",
      display: "whale",
      symbol: "WHALE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "uwhale",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-642",
          path: "transfer/channel-642/uwhale"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.svg"
      },
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "uwhale"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.svg",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }]
    },
    {
      description: "Evmos Guardians governance token.",
      denom_units: [{
        denom: "ibc/BAC9C6998F1F5C316D3353622EAEDAF8BD00FAABEB374FECDF8C9BC475172CFA",
        exponent: 0,
        aliases: ["cw20:juno1xekkh27punj0uxruv3gvuydyt856fax0nu750xns99t2qcxp7xmsqwhfma"]
      }, {
        denom: "grdn",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/BAC9C6998F1F5C316D3353622EAEDAF8BD00FAABEB374FECDF8C9BC475172CFA",
      name: "Guardian",
      display: "grdn",
      symbol: "GRDN",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1xekkh27punj0uxruv3gvuydyt856fax0nu750xns99t2qcxp7xmsqwhfma",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1xekkh27punj0uxruv3gvuydyt856fax0nu750xns99t2qcxp7xmsqwhfma"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/guardian.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1xekkh27punj0uxruv3gvuydyt856fax0nu750xns99t2qcxp7xmsqwhfma"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/guardian.png",
        theme: {
          primary_color_hex: "#07d7ac"
        }
      }]
    },
    {
      description: "Mini Punks Token",
      denom_units: [{
        denom: "ibc/DC0D3303BBE739E073224D0314385B88B247F56D71D726A91414CCA244FFFE7E",
        exponent: 0,
        aliases: ["cw20:juno166heaxlyntd33a5euh4rrz26svhean4klzw594esmd02l4atan6sazy2my"]
      }, {
        denom: "mnpu",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/DC0D3303BBE739E073224D0314385B88B247F56D71D726A91414CCA244FFFE7E",
      name: "Mini Punks",
      display: "mnpu",
      symbol: "MNPU",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno166heaxlyntd33a5euh4rrz26svhean4klzw594esmd02l4atan6sazy2my",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno166heaxlyntd33a5euh4rrz26svhean4klzw594esmd02l4atan6sazy2my"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mnpu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mnpu.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno166heaxlyntd33a5euh4rrz26svhean4klzw594esmd02l4atan6sazy2my"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mnpu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mnpu.svg",
        theme: {
          primary_color_hex: "#dadbce"
        }
      }]
    },
    {
      description: "Shiba Cosmos",
      denom_units: [{
        denom: "ibc/447A0DCE83691056289503DDAB8EB08E52E167A73629F2ACC59F056B92F51CE8",
        exponent: 0,
        aliases: ["cw20:juno1x5qt47rw84c4k6xvvywtrd40p8gxjt8wnmlahlqg07qevah3f8lqwxfs7z"]
      }, {
        denom: "shibac",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/447A0DCE83691056289503DDAB8EB08E52E167A73629F2ACC59F056B92F51CE8",
      name: "ShibaCosmos",
      display: "shibac",
      symbol: "SHIBAC",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1x5qt47rw84c4k6xvvywtrd40p8gxjt8wnmlahlqg07qevah3f8lqwxfs7z",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1x5qt47rw84c4k6xvvywtrd40p8gxjt8wnmlahlqg07qevah3f8lqwxfs7z"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/shibacosmos.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1x5qt47rw84c4k6xvvywtrd40p8gxjt8wnmlahlqg07qevah3f8lqwxfs7z"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/shibacosmos.png",
        theme: {
          primary_color_hex: "#eea95d"
        }
      }]
    },
    {
      description: "Sikoba Governance Token",
      denom_units: [{
        denom: "ibc/71066B030D8FC6479E638580E1BA9C44925E8C1F6E45036669D22017CFDC8C5E",
        exponent: 0,
        aliases: ["cw20:juno1qqwf3lkfjhp77yja7gmg3y95pda0e5xctqrdhf3wvwdd79flagvqfgrgxp"]
      }, {
        denom: "sikoba",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/71066B030D8FC6479E638580E1BA9C44925E8C1F6E45036669D22017CFDC8C5E",
      name: "Sikoba Token",
      display: "sikoba",
      symbol: "SKOJ",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1qqwf3lkfjhp77yja7gmg3y95pda0e5xctqrdhf3wvwdd79flagvqfgrgxp",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1qqwf3lkfjhp77yja7gmg3y95pda0e5xctqrdhf3wvwdd79flagvqfgrgxp"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sikoba.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sikoba.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1qqwf3lkfjhp77yja7gmg3y95pda0e5xctqrdhf3wvwdd79flagvqfgrgxp"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sikoba.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sikoba.svg",
        theme: {
          primary_color_hex: "#fbfbfb"
        }
      }]
    },
    {
      description: "Nature Carbon Ton (NCT) is a carbon token standard backed 1:1 by carbon credits issued by Verra, a global leader in the voluntary carbon market. NCT credits on Regen Network have been tokenized by Toucan.earth.",
      denom_units: [{
        denom: "ibc/A76EB6ECF4E3E2D4A23C526FD1B48FDD42F171B206C9D2758EF778A7826ADD68",
        exponent: 0,
        aliases: ["eco.uC.NCT"]
      }, {
        denom: "nct",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/A76EB6ECF4E3E2D4A23C526FD1B48FDD42F171B206C9D2758EF778A7826ADD68",
      name: "Nature Carbon Ton",
      display: "nct",
      symbol: "NCT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "regen",
          base_denom: "eco.uC.NCT",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-8",
          path: "transfer/channel-8/eco.uC.NCT"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/nct.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/nct.svg"
      },
      images: [{
        image_sync: {
          chain_name: "regen",
          base_denom: "eco.uC.NCT"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/nct.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/nct.svg",
        theme: {
          primary_color_hex: "#171c25"
        }
      }]
    },
    {
      description: "Celestims",
      denom_units: [{
        denom: "ibc/0E4FA664327BD40B32803EE84A77F145834C0281B7F82B65521333B3669FA0BA",
        exponent: 0,
        aliases: ["cw20:juno1ngww7zxak55fql42wmyqrr4rhzpne24hhs4p3w4cwhcdgqgr3hxsmzl9zg"]
      }, {
        denom: "clst",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0E4FA664327BD40B32803EE84A77F145834C0281B7F82B65521333B3669FA0BA",
      name: "Celestims",
      display: "clst",
      symbol: "CLST",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1ngww7zxak55fql42wmyqrr4rhzpne24hhs4p3w4cwhcdgqgr3hxsmzl9zg",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1ngww7zxak55fql42wmyqrr4rhzpne24hhs4p3w4cwhcdgqgr3hxsmzl9zg"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/celestims.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1ngww7zxak55fql42wmyqrr4rhzpne24hhs4p3w4cwhcdgqgr3hxsmzl9zg"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/celestims.png",
        theme: {
          primary_color_hex: "#0b1d33"
        }
      }]
    },
    {
      description: "The First Doge on Osmosis",
      denom_units: [{
        denom: "ibc/8AEEA9B9304392070F72611076C0E328CE3F2DECA1E18557E36F9DB4F09C0156",
        exponent: 0,
        aliases: ["cw20:juno1ytymtllllsp3hfmndvcp802p2xmy5s8m59ufel8xv9ahyxyfs4hs4kd4je"]
      }, {
        denom: "osdoge",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/8AEEA9B9304392070F72611076C0E328CE3F2DECA1E18557E36F9DB4F09C0156",
      name: "Osmosis Doge",
      display: "osdoge",
      symbol: "OSDOGE",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1ytymtllllsp3hfmndvcp802p2xmy5s8m59ufel8xv9ahyxyfs4hs4kd4je",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1ytymtllllsp3hfmndvcp802p2xmy5s8m59ufel8xv9ahyxyfs4hs4kd4je"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/osdoge.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1ytymtllllsp3hfmndvcp802p2xmy5s8m59ufel8xv9ahyxyfs4hs4kd4je"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/osdoge.png",
        theme: {
          primary_color_hex: "#f49c4c"
        }
      }]
    },
    {
      description: "Apemos",
      denom_units: [{
        denom: "ibc/1EB03F13F29FEA73444586FC4E88A8C14ACE9291501E9658E3BEF951EA4AC85D",
        exponent: 0,
        aliases: ["cw20:juno1jrr0tuuzxrrwcg6hgeqhw5wqpck2y55734e7zcrp745aardlp0qqg8jz06"]
      }, {
        denom: "apemos",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1EB03F13F29FEA73444586FC4E88A8C14ACE9291501E9658E3BEF951EA4AC85D",
      name: "Apemos",
      display: "apemos",
      symbol: "APEMOS",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1jrr0tuuzxrrwcg6hgeqhw5wqpck2y55734e7zcrp745aardlp0qqg8jz06",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1jrr0tuuzxrrwcg6hgeqhw5wqpck2y55734e7zcrp745aardlp0qqg8jz06"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/apemos.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1jrr0tuuzxrrwcg6hgeqhw5wqpck2y55734e7zcrp745aardlp0qqg8jz06"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/apemos.png",
        theme: {
          primary_color_hex: "#4d5264"
        }
      }]
    },
    {
      description: "Evmos Guardians' Invaders DAO token.",
      denom_units: [{
        denom: "ibc/3DB1721541C94AD19D7735FECED74C227E13F925BDB814392980B40A19C1ED54",
        exponent: 0,
        aliases: ["cw20:juno1jwdy7v4egw36pd84aeks3ww6n8k7zhsumd4ac8q5lts83ppxueus4626e8"]
      }, {
        denom: "invdrs",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/3DB1721541C94AD19D7735FECED74C227E13F925BDB814392980B40A19C1ED54",
      name: "Invaders",
      display: "invdrs",
      symbol: "INVDRS",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1jwdy7v4egw36pd84aeks3ww6n8k7zhsumd4ac8q5lts83ppxueus4626e8",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1jwdy7v4egw36pd84aeks3ww6n8k7zhsumd4ac8q5lts83ppxueus4626e8"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/invdrs.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1jwdy7v4egw36pd84aeks3ww6n8k7zhsumd4ac8q5lts83ppxueus4626e8"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/invdrs.png",
        theme: {
          primary_color_hex: "#04ccab"
        }
      }]
    },
    {
      description: "Doge Apr",
      denom_units: [{
        denom: "ibc/04BE4E9C825ED781F9684A1226114BB49607500CAD855F1E3FEEC18532297250",
        exponent: 0,
        aliases: ["cw20:juno1k2ruzzvvwwtwny6gq6kcwyfhkzahaunp685wmz4hafplduekj98q9hgs6d"]
      }, {
        denom: "doga",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/04BE4E9C825ED781F9684A1226114BB49607500CAD855F1E3FEEC18532297250",
      name: "Doge Apr",
      display: "doga",
      symbol: "DOGA",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1k2ruzzvvwwtwny6gq6kcwyfhkzahaunp685wmz4hafplduekj98q9hgs6d",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1k2ruzzvvwwtwny6gq6kcwyfhkzahaunp685wmz4hafplduekj98q9hgs6d"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/doga.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1k2ruzzvvwwtwny6gq6kcwyfhkzahaunp685wmz4hafplduekj98q9hgs6d"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/doga.png",
        theme: {
          primary_color_hex: "#d6a84f"
        }
      }]
    },
    {
      description: "Catmos",
      denom_units: [{
        denom: "ibc/F4A07138CAEF0BFB4889E03C44C57956A48631061F1C8AB80421C1F229C1B835",
        exponent: 0,
        aliases: ["cw20:juno1f5datjdse3mdgrapwuzs3prl7pvxxht48ns6calnn0t77v2s9l8s0qu488"]
      }, {
        denom: "catmos",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F4A07138CAEF0BFB4889E03C44C57956A48631061F1C8AB80421C1F229C1B835",
      name: "Catmos",
      display: "catmos",
      symbol: "CATMOS",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1f5datjdse3mdgrapwuzs3prl7pvxxht48ns6calnn0t77v2s9l8s0qu488",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1f5datjdse3mdgrapwuzs3prl7pvxxht48ns6calnn0t77v2s9l8s0qu488"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/catmos.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1f5datjdse3mdgrapwuzs3prl7pvxxht48ns6calnn0t77v2s9l8s0qu488"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/catmos.png",
        theme: {
          primary_color_hex: "#140c44"
        }
      }]
    },
    {
      description: "Social Impact DAO providing showers, meals, and vehicles to the homeless",
      denom_units: [{
        denom: "ibc/56B988C4D934FB7503F5EA9B440C75D489C8AD5D193715B477BEC4F84B8BBA2A",
        exponent: 0,
        aliases: ["cw20:juno1j4ux0f6gt7e82z7jdpm25v4g2gts880ap64rdwa49989wzhd0dfqed6vqm"]
      }, {
        denom: "summit",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/56B988C4D934FB7503F5EA9B440C75D489C8AD5D193715B477BEC4F84B8BBA2A",
      name: "Summit",
      display: "summit",
      symbol: "SUMMIT",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1j4ux0f6gt7e82z7jdpm25v4g2gts880ap64rdwa49989wzhd0dfqed6vqm",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1j4ux0f6gt7e82z7jdpm25v4g2gts880ap64rdwa49989wzhd0dfqed6vqm"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/summit.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1j4ux0f6gt7e82z7jdpm25v4g2gts880ap64rdwa49989wzhd0dfqed6vqm"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/summit.png",
        theme: {
          primary_color_hex: "#cbdb44"
        }
      }]
    },
    {
      description: "The native staking token of OmniFlix Hub.",
      denom_units: [{
        denom: "ibc/CEE970BB3D26F4B907097B6B660489F13F3B0DA765B83CC7D9A0BC0CE220FA6F",
        exponent: 0,
        aliases: ["uflix"]
      }, {
        denom: "flix",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/CEE970BB3D26F4B907097B6B660489F13F3B0DA765B83CC7D9A0BC0CE220FA6F",
      name: "OmniFlix",
      display: "flix",
      symbol: "FLIX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "omniflixhub",
          base_denom: "uflix",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-199",
          path: "transfer/channel-199/uflix"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.svg"
      },
      images: [{
        image_sync: {
          chain_name: "omniflixhub",
          base_denom: "uflix"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/flix.svg",
        theme: {
          primary_color_hex: "#c33635"
        }
      }]
    },
    {
      description: "Spacer",
      denom_units: [{
        denom: "ibc/7A496DB7C2277D4B74EC4428DDB5AC8A62816FBD0DEBE1CFE094935D746BE19C",
        exponent: 0,
        aliases: ["cw20:juno1dyyf7pxeassxvftf570krv7fdf5r8e4r04mp99h0mllsqzp3rs4q7y8yqg"]
      }, {
        denom: "spacer",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/7A496DB7C2277D4B74EC4428DDB5AC8A62816FBD0DEBE1CFE094935D746BE19C",
      name: "Spacer",
      display: "spacer",
      symbol: "SPACER",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1dyyf7pxeassxvftf570krv7fdf5r8e4r04mp99h0mllsqzp3rs4q7y8yqg",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1dyyf7pxeassxvftf570krv7fdf5r8e4r04mp99h0mllsqzp3rs4q7y8yqg"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/spacer.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1dyyf7pxeassxvftf570krv7fdf5r8e4r04mp99h0mllsqzp3rs4q7y8yqg"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/spacer.png",
        theme: {
          primary_color_hex: "#695335"
        }
      }]
    },
    {
      description: "Light: LumenX community DAO treasury token",
      denom_units: [{
        denom: "ibc/3DC08BDF2689978DBCEE28C7ADC2932AA658B2F64B372760FBC5A0058669AD29",
        exponent: 0,
        aliases: ["cw20:juno1dpany8c0lj526lsa02sldv7shzvnw5dt5ues72rk35hd69rrydxqeraz8l"]
      }, {
        denom: "light",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/3DC08BDF2689978DBCEE28C7ADC2932AA658B2F64B372760FBC5A0058669AD29",
      name: "LIGHT",
      display: "light",
      symbol: "LIGHT",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1dpany8c0lj526lsa02sldv7shzvnw5dt5ues72rk35hd69rrydxqeraz8l",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1dpany8c0lj526lsa02sldv7shzvnw5dt5ues72rk35hd69rrydxqeraz8l"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/light.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1dpany8c0lj526lsa02sldv7shzvnw5dt5ues72rk35hd69rrydxqeraz8l"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/light.png",
        theme: {
          primary_color_hex: "#e5e5e5"
        }
      }]
    },
    {
      description: "The native token cw20 for Silk on Secret Network",
      denom_units: [{
        denom: "ibc/8A025A1E70101E39DE0C0F153E582A30806D3DA16795F6D868A3AA247D2DEDF7",
        exponent: 0,
        aliases: ["cw20:secret1fl449muk5yq8dlad7a22nje4p5d2pnsgymhjfd"]
      }, {
        denom: "silk",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/8A025A1E70101E39DE0C0F153E582A30806D3DA16795F6D868A3AA247D2DEDF7",
      name: "Silk",
      display: "silk",
      symbol: "SILK",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1fl449muk5yq8dlad7a22nje4p5d2pnsgymhjfd",
          port: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
          channel_id: "channel-44"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-476",
          path: "transfer/channel-476/cw20:secret1fl449muk5yq8dlad7a22nje4p5d2pnsgymhjfd"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/silk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/silk.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret1fl449muk5yq8dlad7a22nje4p5d2pnsgymhjfd"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/silk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/silk.svg",
        theme: {
          primary_color_hex: "#3142fc"
        }
      }]
    },
    {
      description: "Mille: the 1000th token on osmosis",
      denom_units: [{
        denom: "ibc/912275A63A565BFD80734AEDFFB540132C51E446EAC41483B26EDE8A557C71CF",
        exponent: 0,
        aliases: ["cw20:juno1llg7q2d5dqlrqzh5dxv8c7kzzjszld34s5vktqmlmaaxqjssz43sxyhq0d"]
      }, {
        denom: "mile",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/912275A63A565BFD80734AEDFFB540132C51E446EAC41483B26EDE8A557C71CF",
      name: "Mille",
      display: "mile",
      symbol: "MILE",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1llg7q2d5dqlrqzh5dxv8c7kzzjszld34s5vktqmlmaaxqjssz43sxyhq0d",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1llg7q2d5dqlrqzh5dxv8c7kzzjszld34s5vktqmlmaaxqjssz43sxyhq0d"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mille.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1llg7q2d5dqlrqzh5dxv8c7kzzjszld34s5vktqmlmaaxqjssz43sxyhq0d"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/mille.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Social Impact DAO dedicated to combatting food insecurity and malnutrition",
      denom_units: [{
        denom: "ibc/980A2748F37C938AD129B92A51E2ABA8CFFC6862ADD61EC1B291125535DBE30B",
        exponent: 0,
        aliases: ["cw20:juno13ca2g36ng6etcfhr9qxx352uw2n5e92np54thfkm3w3nzlhsgvwsjaqlyq"]
      }, {
        denom: "manna",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/980A2748F37C938AD129B92A51E2ABA8CFFC6862ADD61EC1B291125535DBE30B",
      name: "Manna",
      display: "manna",
      symbol: "MANNA",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno13ca2g36ng6etcfhr9qxx352uw2n5e92np54thfkm3w3nzlhsgvwsjaqlyq",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno13ca2g36ng6etcfhr9qxx352uw2n5e92np54thfkm3w3nzlhsgvwsjaqlyq"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/manna.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno13ca2g36ng6etcfhr9qxx352uw2n5e92np54thfkm3w3nzlhsgvwsjaqlyq"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/manna.png",
        theme: {
          primary_color_hex: "#299544"
        }
      }]
    },
    {
      description: `Filecoin is a decentralized storage network designed to turn cloud storage into an algorithmic market. The network facilitates open markets for storing and retrieving data, where users pay to store their files on storage miners. Filecoin is built on top of the InterPlanetary File System (IPFS), a peer-to-peer storage network. Filecoin aims to store data in a decentralized manner, unlike traditional cloud storage providers.

Participants in the Filecoin network are incentivized to act honestly and store as much data as possible because they earn the Filecoin cryptocurrency (FIL) in exchange for their storage services. This setup ensures the integrity and accessibility of data stored. Filecoin's model allows for a variety of storage options, including long-term archival storage and more rapid retrieval services, making it a versatile solution for decentralized data storage. The project, developed by Protocol Labs, also focuses on ensuring that data is stored reliably and efficiently.`,
      denom_units: [{
        denom: "ibc/18FB5C09D9D2371F659D4846A956FA56225E377EE3C3652A2BF3542BF809159D",
        exponent: 0,
        aliases: ["wfil-wei"]
      }, {
        denom: "fil",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/18FB5C09D9D2371F659D4846A956FA56225E377EE3C3652A2BF3542BF809159D",
      name: "Filecoin",
      display: "fil",
      symbol: "FIL",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "filecoin",
            base_denom: "attoFIL"
          },
          provider: "Filecoin"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "filecoin",
            base_denom: "0x60E1773636CF5E4A227d9AC24F20fEca034ee25A"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "wfil-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/wfil-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/filecoin/images/fil.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/filecoin/images/fil.svg"
      },
      images: [{
        image_sync: {
          chain_name: "filecoin",
          base_denom: "attoFIL"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/filecoin/images/fil.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/filecoin/images/fil.svg",
        theme: {
          primary_color_hex: "#0493fc"
        }
      }]
    },
    {
      description: "Void",
      denom_units: [{
        denom: "ibc/593F820ECE676A3E0890C734EC4F3A8DE16EC10A54EEDFA8BDFEB40EEA903960",
        exponent: 0,
        aliases: ["cw20:juno1lpvx3mv2a6ddzfjc7zzz2v2cm5gqgqf0hx67hc5p5qwn7hz4cdjsnznhu8"]
      }, {
        denom: "void",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/593F820ECE676A3E0890C734EC4F3A8DE16EC10A54EEDFA8BDFEB40EEA903960",
      name: "Void",
      display: "void",
      symbol: "VOID",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1lpvx3mv2a6ddzfjc7zzz2v2cm5gqgqf0hx67hc5p5qwn7hz4cdjsnznhu8",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1lpvx3mv2a6ddzfjc7zzz2v2cm5gqgqf0hx67hc5p5qwn7hz4cdjsnznhu8"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/void.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1lpvx3mv2a6ddzfjc7zzz2v2cm5gqgqf0hx67hc5p5qwn7hz4cdjsnznhu8"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/void.png",
        theme: {
          primary_color_hex: "#5b2e96"
        }
      }]
    },
    {
      description: "The native token cw20 for Shade on Secret Network",
      denom_units: [{
        denom: "ibc/0B3D528E74E3DEAADF8A68F393887AC7E06028904D02173561B0D27F6E751D0A",
        exponent: 0,
        aliases: ["cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm"]
      }, {
        denom: "shd",
        exponent: 8
      }],
      type_asset: "ics20",
      base: "ibc/0B3D528E74E3DEAADF8A68F393887AC7E06028904D02173561B0D27F6E751D0A",
      name: "Shade",
      display: "shd",
      symbol: "SHD",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm",
          port: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
          channel_id: "channel-44"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-476",
          path: "transfer/channel-476/cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.svg",
        theme: {
          primary_color_hex: "#342c52"
        }
      }]
    },
    {
      description: "The native token of Bluzelle",
      denom_units: [{
        denom: "ibc/63CDD51098FD99E04E5F5610A3882CBE7614C441607BA6FCD7F3A3C1CD5325F8",
        exponent: 0,
        aliases: ["ubnt"]
      }, {
        denom: "bnt",
        exponent: 6,
        aliases: ["blz"]
      }],
      type_asset: "ics20",
      base: "ibc/63CDD51098FD99E04E5F5610A3882CBE7614C441607BA6FCD7F3A3C1CD5325F8",
      name: "Bluzelle",
      display: "bnt",
      symbol: "BLZ",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bluzelle",
          base_denom: "ubnt",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-763",
          path: "transfer/channel-763/ubnt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.svg"
      },
      images: [{
        image_sync: {
          chain_name: "bluzelle",
          base_denom: "ubnt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bluzelle/images/bluzelle.svg",
        theme: {
          primary_color_hex: "#708ffc"
        }
      }],
      keywords: ["bluzelle", "game"]
    },
    {
      description: "Native token of Arbitrum",
      denom_units: [{
        denom: "ibc/10E5E5B06D78FFBB61FD9F89209DEE5FD4446ED0550CBB8E3747DA79E10D9DC6",
        exponent: 0,
        aliases: ["arb-wei"]
      }, {
        denom: "arb",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/10E5E5B06D78FFBB61FD9F89209DEE5FD4446ED0550CBB8E3747DA79E10D9DC6",
      name: "Arbitrum (Axelar)",
      display: "arb",
      symbol: "ARB.axl",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "arbitrum",
          base_denom: "0x912CE59144191C1204E64559FE8253a0e49E6548"
        },
        provider: "Axelar"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "arb-wei",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-208",
          path: "transfer/channel-208/arb-wei"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/arb.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/arb.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/arb.axl.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/arb.axl.png"
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "arb-wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/arbitrum/images/arb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/arbitrum/images/arb.svg",
        theme: {
          primary_color_hex: "#253545"
        }
      }]
    },
    {
      description: "Silica",
      denom_units: [{
        denom: "ibc/5164ECF584AD7DC27DA9E6A89E75DAB0F7C4FCB0A624B69215B8BC6A2C40CD07",
        exponent: 0,
        aliases: ["cw20:juno10vgf2u03ufcf25tspgn05l7j3tfg0j63ljgpffy98t697m5r5hmqaw95ux"]
      }, {
        denom: "silica",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/5164ECF584AD7DC27DA9E6A89E75DAB0F7C4FCB0A624B69215B8BC6A2C40CD07",
      name: "Silica",
      display: "silica",
      symbol: "SLCA",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno10vgf2u03ufcf25tspgn05l7j3tfg0j63ljgpffy98t697m5r5hmqaw95ux",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno10vgf2u03ufcf25tspgn05l7j3tfg0j63ljgpffy98t697m5r5hmqaw95ux"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/silica.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno10vgf2u03ufcf25tspgn05l7j3tfg0j63ljgpffy98t697m5r5hmqaw95ux"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/silica.png",
        theme: {
          primary_color_hex: "#21538f"
        }
      }]
    },
    {
      description: "Pepec",
      denom_units: [{
        denom: "ibc/C00B17F74C94449A62935B4C886E6F0F643249A270DEF269D53CE6741ECCDB93",
        exponent: 0,
        aliases: ["cw20:juno1epxnvge53c4hkcmqzlxryw5fp7eae2utyk6ehjcfpwajwp48km3sgxsh9k"]
      }, {
        denom: "pepec",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C00B17F74C94449A62935B4C886E6F0F643249A270DEF269D53CE6741ECCDB93",
      name: "Pepec",
      display: "pepec",
      symbol: "PEPEC",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1epxnvge53c4hkcmqzlxryw5fp7eae2utyk6ehjcfpwajwp48km3sgxsh9k",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1epxnvge53c4hkcmqzlxryw5fp7eae2utyk6ehjcfpwajwp48km3sgxsh9k"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/pepec.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1epxnvge53c4hkcmqzlxryw5fp7eae2utyk6ehjcfpwajwp48km3sgxsh9k"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/pepec.png",
        theme: {
          primary_color_hex: "#e9bc37"
        }
      }]
    },
    {
      description: "Pepe is a community based memecoin with one mission: to make memecoins great again. Made to honor the iconic meme we all know and love, Pepe is here to take reign as the most memeable memecoin in existence, fueled purely by memetic power. Pepe is for the people.",
      denom_units: [{
        denom: "ibc/E47F4E97C534C95B942729E1B25DBDE111EA791411CFF100515050BEA0AC0C6B",
        exponent: 0,
        aliases: ["0x6982508145454Ce325dDbE47a25d4ec3d2311933", "pepe-wei"]
      }, {
        denom: "pepe",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/E47F4E97C534C95B942729E1B25DBDE111EA791411CFF100515050BEA0AC0C6B",
      name: "Pepe (Axelar)",
      display: "pepe",
      symbol: "PEPE.axl",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x6982508145454Ce325dDbE47a25d4ec3d2311933"
        },
        provider: "Axelar"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "pepe-wei",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-208",
          path: "transfer/channel-208/pepe-wei"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/pepe.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/pepe.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/pepe.axl.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/pepe.axl.png"
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "pepe-wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.svg",
        theme: {
          primary_color_hex: "#cc3233"
        }
      }],
      keywords: ["meme"]
    },
    {
      denom_units: [{
        denom: "factory/osmo14klwqgkmackvx2tqa0trtg69dmy0nrg4ntq4gjgw2za4734r5seqjqm4gm/uibcx",
        exponent: 0
      }, {
        denom: "ibcx",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo14klwqgkmackvx2tqa0trtg69dmy0nrg4ntq4gjgw2za4734r5seqjqm4gm",
      base: "factory/osmo14klwqgkmackvx2tqa0trtg69dmy0nrg4ntq4gjgw2za4734r5seqjqm4gm/uibcx",
      name: "IBC Index",
      display: "ibcx",
      symbol: "IBCX",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ibcx.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ibcx.svg"
      }],
      coingecko_id: "ibc-index"
    },
    {
      description: "Coinbase Wrapped Staked ETH (“cbETH”) is a utility token and liquid representation of ETH staked through Coinbase. cbETH gives customers the option to sell, transfer, or otherwise use their staked ETH in dapps while it remains locked by the Ethereum protocol.",
      denom_units: [{
        denom: "ibc/4D7A6F2A7744B1534C984A21F9EDFFF8809FC71A9E9243FFB702073E7FCA513A",
        exponent: 0,
        aliases: ["0xbe9895146f7af43049ca1c1ae358b0541ea49704", "cbeth-wei"]
      }, {
        denom: "cbeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/4D7A6F2A7744B1534C984A21F9EDFFF8809FC71A9E9243FFB702073E7FCA513A",
      name: "Coinbase Wrapped Staked ETH",
      display: "cbeth",
      symbol: "cbETH",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Coinbase"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xbe9895146f7af43049ca1c1ae358b0541ea49704"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "cbeth-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/cbeth-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/cbeth.png"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xbe9895146f7af43049ca1c1ae358b0541ea49704"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/cbeth.png",
        theme: {
          primary_color_hex: "#c9dbfc"
        }
      }]
    },
    {
      description: "Rocket Pool is a decentralised Ethereum Proof of Stake pool.",
      denom_units: [{
        denom: "ibc/E610B83FD5544E00A8A1967A2EB3BEF25F1A8CFE8650FE247A8BD4ECA9DC9222",
        exponent: 0,
        aliases: ["0xae78736cd615f374d3085123a210448e74fc6393", "reth-wei"]
      }, {
        denom: "reth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/E610B83FD5544E00A8A1967A2EB3BEF25F1A8CFE8650FE247A8BD4ECA9DC9222",
      name: "Rocket Pool Ether",
      display: "reth",
      symbol: "rETH",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Rocket Pool"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xae78736cd615f374d3085123a210448e74fc6393"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "reth-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/reth-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/reth.png"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xae78736cd615f374d3085123a210448e74fc6393"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/reth.png",
        theme: {
          primary_color_hex: "#fba487"
        }
      }]
    },
    {
      description: "sfrxETH is the version of frxETH which accrues staking yield. All profit generated from Frax Ether validators is distributed to sfrxETH holders. By exchanging frxETH for sfrxETH, one become's eligible for staking yield, which is redeemed upon converting sfrxETH back to frxETH.",
      denom_units: [{
        denom: "ibc/81F578C39006EB4B27FFFA9460954527910D73390991B379C03B18934D272F46",
        exponent: 0,
        aliases: ["0xac3e018457b222d93114458476f3e3416abbe38f", "sfrxeth-wei"]
      }, {
        denom: "sfrxeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/81F578C39006EB4B27FFFA9460954527910D73390991B379C03B18934D272F46",
      name: "Staked Frax Ether",
      display: "sfrxeth",
      symbol: "sfrxETH",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Frax"
        },
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x5e8422345238f34275888049021821e8e08caa1f"
          },
          provider: "Frax"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xac3e018457b222d93114458476f3e3416abbe38f"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "sfrxeth-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/sfrxeth-wei"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrxeth.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xac3e018457b222d93114458476f3e3416abbe38f"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrxeth.svg"
      }]
    },
    {
      denom_units: [{
        denom: "ibc/B2BD584CD2A0A9CE53D4449667E26160C7D44A9C41AF50F602C201E5B3CCA46C",
        exponent: 0,
        aliases: ["0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0", "wsteth-wei"]
      }, {
        denom: "wsteth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/B2BD584CD2A0A9CE53D4449667E26160C7D44A9C41AF50F602C201E5B3CCA46C",
      name: "Wrapped Lido Staked Ether (Axelar)",
      display: "wsteth",
      symbol: "wstETH.eth.axl",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Lido"
        },
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84"
          },
          provider: "Lido"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "wsteth-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/wsteth-wei"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wstETH.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wstETH.axl.svg"
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "wsteth-wei"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }]
    },
    {
      description: "The native token of Gitopia",
      denom_units: [{
        denom: "ibc/B1C1806A540B3E165A2D42222C59946FB85BA325596FC85662D7047649F419F3",
        exponent: 0,
        aliases: ["ulore"]
      }, {
        denom: "LORE",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B1C1806A540B3E165A2D42222C59946FB85BA325596FC85662D7047649F419F3",
      name: "Gitopia",
      display: "LORE",
      symbol: "LORE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "gitopia",
          base_denom: "ulore",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-781",
          path: "transfer/channel-781/ulore"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/lore.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/lore.svg"
      },
      images: [{
        image_sync: {
          chain_name: "gitopia",
          base_denom: "ulore"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/lore.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/lore.svg",
        theme: {
          primary_color_hex: "#2c173c"
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/gitopia/images/gitopia.png",
        theme: {
          primary_color_hex: "#2e154d"
        }
      }]
    },
    {
      description: "Lion DAO is a community DAO that lives on the Terra blockchain with the mission to reactivate the LUNAtic community and showcase Terra protocols & tooling",
      denom_units: [{
        denom: "ibc/98BCD43F190C6960D0005BC46BB765C827403A361C9C03C2FF694150A30284B0",
        exponent: 0,
        aliases: ["cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv"]
      }, {
        denom: "roar",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/98BCD43F190C6960D0005BC46BB765C827403A361C9C03C2FF694150A30284B0",
      name: "Lion DAO",
      display: "roar",
      symbol: "ROAR",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra2",
          base_denom: "cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv",
          port: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
          channel_id: "channel-26"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-341",
          path: "transfer/channel-341/cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/roar.png"
      },
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/roar.png",
        theme: {
          primary_color_hex: "#f3f313"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/02F196DA6FD0917DD5FEA249EE61880F4D941EE9059E7964C5C9B50AF103800F",
        exponent: 0,
        aliases: ["stuumee"]
      }, {
        denom: "stumee",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/02F196DA6FD0917DD5FEA249EE61880F4D941EE9059E7964C5C9B50AF103800F",
      name: "Stride Staked UMEE",
      display: "stumee",
      symbol: "stUMEE",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "umee",
          base_denom: "uumee"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stuumee",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stuumee"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stumee.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stumee.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stuumee"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stumee.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stumee.svg",
        theme: {
          primary_color_hex: "#fbd9e9"
        }
      }]
    },
    {
      denom_units: [{
        denom: "factory/osmo1xqw2sl9zk8a6pch0csaw78n4swg5ws8t62wc5qta4gnjxfqg6v2qcs243k/stuibcx",
        exponent: 0
      }, {
        denom: "stibcx",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1xqw2sl9zk8a6pch0csaw78n4swg5ws8t62wc5qta4gnjxfqg6v2qcs243k",
      base: "factory/osmo1xqw2sl9zk8a6pch0csaw78n4swg5ws8t62wc5qta4gnjxfqg6v2qcs243k/stuibcx",
      name: "Staked IBCX",
      display: "stibcx",
      symbol: "stIBCX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/stibcx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/stibcx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/stibcx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/stibcx.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "The native token of Nolus chain",
      denom_units: [{
        denom: "ibc/D9AFCECDD361D38302AA66EB3BAC23B95234832C51D12489DC451FA2B7C72782",
        exponent: 0,
        aliases: ["unls"]
      }, {
        denom: "nls",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D9AFCECDD361D38302AA66EB3BAC23B95234832C51D12489DC451FA2B7C72782",
      name: "Nolus",
      display: "nls",
      symbol: "NLS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nolus",
          base_denom: "unls",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-783",
          path: "transfer/channel-783/unls"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.svg"
      },
      images: [{
        image_sync: {
          chain_name: "nolus",
          base_denom: "unls"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nolus/images/nolus.svg",
        theme: {
          primary_color_hex: "#fc542c"
        }
      }]
    },
    {
      description: "Lion Cub DAO is a useless meme community DAO on Terra",
      denom_units: [{
        denom: "ibc/6F18EFEBF1688AA77F7EAC17065609494DC1BA12AFC78E9AEC832AF70A11BEF3",
        exponent: 0,
        aliases: ["cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t"]
      }, {
        denom: "cub",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/6F18EFEBF1688AA77F7EAC17065609494DC1BA12AFC78E9AEC832AF70A11BEF3",
      name: "Lion Cub DAO",
      display: "cub",
      symbol: "CUB",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra2",
          base_denom: "cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t",
          port: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
          channel_id: "channel-26"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-341",
          path: "transfer/channel-341/cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/cub.png"
      },
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/cub.png",
        theme: {
          primary_color_hex: "#f3d343"
        }
      }]
    },
    {
      description: "BLUE CUB DAO is a community DAO on Terra",
      denom_units: [{
        denom: "ibc/DA961FE314B009C38595FFE3AF41225D8894D663B8C3F6650DCB5B6F8435592E",
        exponent: 0,
        aliases: ["cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584"]
      }, {
        denom: "blue",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/DA961FE314B009C38595FFE3AF41225D8894D663B8C3F6650DCB5B6F8435592E",
      name: "BLUE CUB DAO",
      display: "blue",
      symbol: "BLUE",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra2",
          base_denom: "cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584",
          port: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
          channel_id: "channel-26"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-341",
          path: "transfer/channel-341/cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/blue.png"
      },
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/blue.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The native token of Neutron chain.",
      denom_units: [{
        denom: "ibc/126DA09104B71B164883842B769C0E9EC1486C0887D27A9999E395C2C8FB5682",
        exponent: 0,
        aliases: ["untrn"]
      }, {
        denom: "ntrn",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/126DA09104B71B164883842B769C0E9EC1486C0887D27A9999E395C2C8FB5682",
      name: "Neutron",
      display: "ntrn",
      symbol: "NTRN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "untrn",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-874",
          path: "transfer/channel-874/untrn"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.svg"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "untrn"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ntrn.svg",
        theme: {
          primary_color_hex: "#040404",
          background_color_hex: "#000000",
          circle: !0
        }
      }]
    },
    {
      description: "An innovative DAO dedicated to housing the most vulnerable",
      denom_units: [{
        denom: "ibc/2F5C084037D951B24D100F15CC013A131DF786DCE1B1DBDC48F018A9B9A138DE",
        exponent: 0,
        aliases: ["cw20:juno1ju8k8sqwsqu5k6umrypmtyqu2wqcpnrkf4w4mntvl0javt4nma7s8lzgss"]
      }, {
        denom: "casa",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2F5C084037D951B24D100F15CC013A131DF786DCE1B1DBDC48F018A9B9A138DE",
      name: "Casa",
      display: "casa",
      symbol: "CASA",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1ju8k8sqwsqu5k6umrypmtyqu2wqcpnrkf4w4mntvl0javt4nma7s8lzgss",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1ju8k8sqwsqu5k6umrypmtyqu2wqcpnrkf4w4mntvl0javt4nma7s8lzgss"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/casa.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1ju8k8sqwsqu5k6umrypmtyqu2wqcpnrkf4w4mntvl0javt4nma7s8lzgss"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/casa.png",
        theme: {
          primary_color_hex: "#04040c"
        }
      }]
    },
    {
      description: "The native staking and governance token of Composable.",
      denom_units: [{
        denom: "ibc/56D7C03B8F6A07AD322EEE1BEF3AE996E09D1C1E34C27CF37E0D4A0AC5972516",
        exponent: 0,
        aliases: ["ppica"]
      }, {
        denom: "pica",
        exponent: 12
      }],
      type_asset: "ics20",
      base: "ibc/56D7C03B8F6A07AD322EEE1BEF3AE996E09D1C1E34C27CF37E0D4A0AC5972516",
      name: "Picasso",
      display: "pica",
      symbol: "PICA",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "picasso",
          base_denom: "ppica"
        },
        provider: "Picasso"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "composable",
          base_denom: "ppica",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-1279",
          path: "transfer/channel-1279/ppica"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/composable/images/pica.svg"
      },
      images: [{
        image_sync: {
          chain_name: "picasso",
          base_denom: "ppica"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/composable/images/pica.svg"
      }]
    },
    {
      description: "The native fee, governance, staking, and bonding token of the Polkadot platform.",
      denom_units: [{
        denom: "ibc/6727B2F071643B3841BD535ECDD4ED9CAE52ABDD0DCD07C3630811A7A37B215C",
        exponent: 0,
        aliases: ["4", "ibc/EE9046745AEC0E8302CB7ED9D5AD67F528FB3B7AE044B247FB0FB293DBDA35E9"]
      }, {
        denom: "ksm",
        exponent: 12
      }],
      type_asset: "ics20",
      base: "ibc/6727B2F071643B3841BD535ECDD4ED9CAE52ABDD0DCD07C3630811A7A37B215C",
      name: "Kusama",
      display: "ksm",
      symbol: "KSM",
      traces: [
        {
          type: "bridge",
          counterparty: {
            chain_name: "kusama",
            base_denom: "Planck"
          },
          provider: "Kusama Parachain"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "picasso",
            base_denom: "4",
            channel_id: "channel-17"
          },
          chain: {
            channel_id: "channel-2",
            path: "transfer/channel-2/4"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/EE9046745AEC0E8302CB7ED9D5AD67F528FB3B7AE044B247FB0FB293DBDA35E9",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-2/4"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/kusama/images/ksm.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kusama",
          base_denom: "Planck"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/kusama/images/ksm.svg"
      }]
    },
    {
      description: "The native fee, governance, staking, and bonding token of the Polkadot platform.",
      denom_units: [{
        denom: "ibc/6B2B19D874851F631FF0AF82C38A20D4B82F438C7A22F41EDA33568345397244",
        exponent: 0,
        aliases: ["79228162514264337593543950342", "ibc/3CC19CEC7E5A3E90E78A5A9ECC5A0E2F8F826A375CF1E096F4515CF09DA3E366"]
      }, {
        denom: "dot",
        exponent: 10
      }],
      type_asset: "ics20",
      base: "ibc/6B2B19D874851F631FF0AF82C38A20D4B82F438C7A22F41EDA33568345397244",
      name: "Polkadot (Picasso)",
      display: "dot",
      symbol: "DOT.pica",
      traces: [
        {
          type: "bridge",
          counterparty: {
            chain_name: "polkadot",
            base_denom: "Planck"
          },
          provider: "Polkadot Parachain"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composablepolkadot",
            base_denom: "79228162514264337593543950342",
            channel_id: "channel-15"
          },
          chain: {
            channel_id: "channel-15",
            path: "transfer/channel-15/79228162514264337593543950342"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "picasso",
            base_denom: "79228162514264337593543950342",
            channel_id: "channel-17"
          },
          chain: {
            channel_id: "channel-2",
            path: "transfer/channel-2/transfer/channel-15/79228162514264337593543950342"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/3CC19CEC7E5A3E90E78A5A9ECC5A0E2F8F826A375CF1E096F4515CF09DA3E366",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-2/transfer/channel-15/79228162514264337593543950342"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/dot.pica.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/dot.pica.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/dot.pica.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/dot.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/3CC19CEC7E5A3E90E78A5A9ECC5A0E2F8F826A375CF1E096F4515CF09DA3E366"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.png",
        theme: {
          primary_color_hex: "#e4047c"
        }
      }]
    },
    {
      description: "The native token of Quasar",
      denom_units: [{
        denom: "ibc/1B708808D372E959CD4839C594960309283424C775F4A038AAEBE7F83A988477",
        exponent: 0,
        aliases: ["uqsr"]
      }, {
        denom: "qsr",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/1B708808D372E959CD4839C594960309283424C775F4A038AAEBE7F83A988477",
      name: "Quasar",
      display: "qsr",
      symbol: "QSR",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "quasar",
          base_denom: "uqsr",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-688",
          path: "transfer/channel-688/uqsr"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.png"
      },
      images: [{
        image_sync: {
          chain_name: "quasar",
          base_denom: "uqsr"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.png",
        theme: {
          primary_color_hex: "#a493e4"
        }
      }]
    },
    {
      description: "The native token of Archway network",
      denom_units: [
        {
          denom: "ibc/23AB778D694C1ECFC59B91D8C399C115CC53B0BD1C61020D8E19519F002BDD85",
          exponent: 0,
          aliases: ["aarch"]
        },
        {
          denom: "uarch",
          exponent: 12
        },
        {
          denom: "arch",
          exponent: 18
        }
      ],
      type_asset: "ics20",
      base: "ibc/23AB778D694C1ECFC59B91D8C399C115CC53B0BD1C61020D8E19519F002BDD85",
      name: "Archway",
      display: "arch",
      symbol: "ARCH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "archway",
          base_denom: "aarch",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-1429",
          path: "transfer/channel-1429/aarch"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.svg"
      },
      images: [{
        image_sync: {
          chain_name: "archway",
          base_denom: "aarch"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.svg",
        theme: {
          primary_color_hex: "#fc4c04"
        }
      }]
    },
    {
      description: "The native staking and governance token of Empower.",
      denom_units: [{
        denom: "ibc/DD3938D8131F41994C1F01F4EB5233DEE9A0A5B787545B9A07A321925655BF38",
        exponent: 0,
        aliases: ["umpwr"]
      }, {
        denom: "mpwr",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/DD3938D8131F41994C1F01F4EB5233DEE9A0A5B787545B9A07A321925655BF38",
      name: "EmpowerChain",
      display: "mpwr",
      symbol: "MPWR",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "empowerchain",
          base_denom: "umpwr",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-1411",
          path: "transfer/channel-1411/umpwr"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/empowerchain/images/mpwr.svg"
      },
      images: [{
        image_sync: {
          chain_name: "empowerchain",
          base_denom: "umpwr"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/empowerchain/images/mpwr.svg",
        theme: {
          primary_color_hex: "#00e33a",
          background_color_hex: "#00e33a",
          circle: !0
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/empowerchain/images/mpwr.png",
        theme: {
          primary_color_hex: "#00e33a",
          background_color_hex: "#00e33a",
          circle: !1
        }
      }]
    },
    {
      description: "A revolutionary DAO created to bring clean drinking water to men, women, and children worldwide. We hope you join us on our journey!",
      denom_units: [{
        denom: "ibc/AABCB14ACAFD53A5C455BAC01EA0CA5AE18714895846681A52BFF1E3B960B44E",
        exponent: 0,
        aliases: ["cw20:juno1m4h8q4p305wgy7vkux0w6e5ylhqll3s6pmadhxkhqtuwd5wlxhxs8xklsw"]
      }, {
        denom: "watr",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/AABCB14ACAFD53A5C455BAC01EA0CA5AE18714895846681A52BFF1E3B960B44E",
      name: "WATR",
      display: "watr",
      symbol: "WATR",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1m4h8q4p305wgy7vkux0w6e5ylhqll3s6pmadhxkhqtuwd5wlxhxs8xklsw",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1m4h8q4p305wgy7vkux0w6e5ylhqll3s6pmadhxkhqtuwd5wlxhxs8xklsw"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/watr.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1m4h8q4p305wgy7vkux0w6e5ylhqll3s6pmadhxkhqtuwd5wlxhxs8xklsw"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/watr.png",
        theme: {
          primary_color_hex: "#38b5c5"
        }
      }]
    },
    {
      description: "The native utility token of the KYVE network.",
      denom_units: [{
        denom: "ibc/613BF0BF2F2146AE9941E923725745E931676B2C14E9768CD609FA0849B2AE13",
        exponent: 0,
        aliases: ["ukyve"]
      }, {
        denom: "kyve",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/613BF0BF2F2146AE9941E923725745E931676B2C14E9768CD609FA0849B2AE13",
      name: "KYVE",
      display: "kyve",
      symbol: "KYVE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kyve",
          base_denom: "ukyve",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-767",
          path: "transfer/channel-767/ukyve"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kyve",
          base_denom: "ukyve"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.svg",
        theme: {
          primary_color_hex: "#335350"
        }
      }]
    },
    {
      description: "Tether gives you the joint benefits of open blockchain technology and traditional currency by converting your cash into a stable digital currency equivalent.",
      denom_units: [{
        denom: "ibc/4ABBEF4C8926DDDB320AE5188CFD63267ABBCEFC0583E4AE05D6E5AA2401DDAB",
        exponent: 0,
        aliases: ["erc20/tether/usdt"]
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4ABBEF4C8926DDDB320AE5188CFD63267ABBCEFC0583E4AE05D6E5AA2401DDAB",
      name: "Tether USD (Kava)",
      display: "usdt",
      symbol: "USDT.kava",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Tether"
        },
        {
          type: "additional-mintage",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
          },
          provider: "Tether"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "kava",
            base_denom: "erc20/tether/usdt",
            channel_id: "channel-1"
          },
          chain: {
            channel_id: "channel-143",
            path: "transfer/channel-143/erc20/tether/usdt"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.kava.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.kava.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.kava.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.kava.png",
        theme: {
          primary_color_hex: "#049494"
        }
      }, {
        image_sync: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }]
    },
    {
      description: "ERIS liquid staked OSMO",
      denom_units: [{
        denom: "factory/osmo1dv8wz09tckslr2wy5z86r46dxvegylhpt97r9yd6qc3kyc6tv42qa89dr9/ampOSMO",
        exponent: 0
      }, {
        denom: "ampOSMO",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1dv8wz09tckslr2wy5z86r46dxvegylhpt97r9yd6qc3kyc6tv42qa89dr9",
      base: "factory/osmo1dv8wz09tckslr2wy5z86r46dxvegylhpt97r9yd6qc3kyc6tv42qa89dr9/ampOSMO",
      name: "ERIS Amplified OSMO",
      display: "ampOSMO",
      symbol: "ampOSMO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/amposmo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/amposmo.png",
        theme: {
          primary_color_hex: "#cfdbf1"
        }
      }],
      socials: {
        website: "https://www.erisprotocol.com/",
        twitter: "https://twitter.com/eris_protocol"
      }
    },
    {
      description: "The native staking token of Sei.",
      denom_units: [{
        denom: "ibc/71F11BC0AF8E526B80E44172EBA9D3F0A8E03950BB882325435691EBC9450B1D",
        exponent: 0,
        aliases: ["usei"]
      }, {
        denom: "sei",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/71F11BC0AF8E526B80E44172EBA9D3F0A8E03950BB882325435691EBC9450B1D",
      name: "Sei",
      display: "sei",
      symbol: "SEI",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "sei",
          base_denom: "usei",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-782",
          path: "transfer/channel-782/usei"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.svg"
      },
      images: [{
        image_sync: {
          chain_name: "sei",
          base_denom: "usei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.svg",
        theme: {
          primary_color_hex: "#9c1c1c"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked SOMM",
      denom_units: [{
        denom: "ibc/EAF76AD1EEF7B16D167D87711FB26ABE881AC7D9F7E6D0CF313D5FA530417208",
        exponent: 0,
        aliases: ["uqsomm"]
      }, {
        denom: "qsomm",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/EAF76AD1EEF7B16D167D87711FB26ABE881AC7D9F7E6D0CF313D5FA530417208",
      name: "Quicksilver Liquid Staked SOMM",
      display: "qsomm",
      symbol: "qSOMM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "sommelier",
          base_denom: "usomm"
        },
        provider: "Quicksilver"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "quicksilver",
          base_denom: "uqsomm",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-522",
          path: "transfer/channel-522/uqsomm"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsomm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsomm.svg"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilver",
          base_denom: "uqsomm"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsomm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsomm.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "The native staking and governance token of the Passage chain.",
      denom_units: [{
        denom: "ibc/208B2F137CDE510B44C41947C045CFDC27F996A9D990EA64460BDD5B3DBEB2ED",
        exponent: 0,
        aliases: ["upasg"]
      }, {
        denom: "pasg",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/208B2F137CDE510B44C41947C045CFDC27F996A9D990EA64460BDD5B3DBEB2ED",
      name: "Passage",
      display: "pasg",
      symbol: "PASG",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "passage",
          base_denom: "upasg",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-2494",
          path: "transfer/channel-2494/upasg"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/passage/images/pasg.png"
      },
      images: [{
        image_sync: {
          chain_name: "passage",
          base_denom: "upasg"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/passage/images/pasg.png",
        theme: {
          primary_color_hex: "#05050c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/5A0060579D24FBE5268BEA74C3281E7FE533D361C41A99307B4998FEC611E46B",
        exponent: 0,
        aliases: ["stusomm"]
      }, {
        denom: "stsomm",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/5A0060579D24FBE5268BEA74C3281E7FE533D361C41A99307B4998FEC611E46B",
      name: "Stride Staked SOMM",
      display: "stsomm",
      symbol: "stSOMM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "sommelier",
          base_denom: "usomm"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stusomm",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stusomm"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsomm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsomm.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stusomm"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsomm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsomm.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Solana (SOL) is the native asset of the Solana blockchain.",
      denom_units: [{
        denom: "ibc/1E43D59E565D41FB4E54CA639B838FFD5BCFC20003D330A56CB1396231AA1CBA",
        exponent: 0,
        aliases: ["factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA"]
      }, {
        denom: "wormhole/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA/8",
        exponent: 8,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/1E43D59E565D41FB4E54CA639B838FFD5BCFC20003D330A56CB1396231AA1CBA",
      name: "Solana (Wormhole)",
      display: "wormhole/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA/8",
      symbol: "SOL.wh",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "solana",
            base_denom: "Lamport"
          },
          provider: "Solana"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "solana",
            base_denom: "So11111111111111111111111111111111111111112"
          },
          provider: "Wormhole"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gateway",
            base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-2186",
            path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sol.wh.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sol.wh.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sol.wh.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sol.wh.png"
      }, {
        image_sync: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        theme: {
          circle: !0,
          background_color_hex: "#000000"
        }
      }]
    },
    {
      description: "The Official Bonk Inu token",
      denom_units: [{
        denom: "ibc/CA3733CB0071F480FAE8EF0D9C3D47A49C6589144620A642BBE0D59A293D110E",
        exponent: 0,
        aliases: ["factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR"]
      }, {
        denom: "wormhole/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR/5",
        exponent: 5,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/CA3733CB0071F480FAE8EF0D9C3D47A49C6589144620A642BBE0D59A293D110E",
      name: "Bonk",
      display: "wormhole/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR/5",
      symbol: "BONK",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263"
        },
        provider: "Wormhole"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-2186",
          path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bonk.png"
      },
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bonk.png",
        theme: {
          primary_color_hex: "#ee950a"
        }
      }]
    },
    {
      description: "Tether USD (Wormhole), USDT, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi",
      denom_units: [{
        denom: "ibc/2108F2D81CBE328F371AD0CEF56691B18A86E08C3651504E42487D9EE92DDE9C",
        exponent: 0,
        aliases: ["factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi"]
      }, {
        denom: "wormhole/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi/6",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/2108F2D81CBE328F371AD0CEF56691B18A86E08C3651504E42487D9EE92DDE9C",
      name: "Tether USD (Ethereum via Wormhole)",
      display: "wormhole/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi/6",
      symbol: "USDT.eth.wh",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Tether"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
          },
          provider: "Wormhole"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gateway",
            base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-2186",
            path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.wh.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.wh.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.wh.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.wh.png",
        theme: {
          primary_color_hex: "#049393"
        }
      }, {
        image_sync: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }]
    },
    {
      description: "Sui’s native asset is called SUI.",
      denom_units: [{
        denom: "ibc/B1C287C2701774522570010EEBCD864BCB7AB714711B3AA218699FDD75E832F5",
        exponent: 0,
        aliases: ["factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh"]
      }, {
        denom: "wormhole/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh/8",
        exponent: 8,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/B1C287C2701774522570010EEBCD864BCB7AB714711B3AA218699FDD75E832F5",
      name: "Sui",
      display: "wormhole/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh/8",
      symbol: "SUI",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "sui",
          base_denom: "0x2::sui::SUI"
        },
        provider: "Wormhole"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-2186",
          path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/sui/images/sui.svg"
      },
      images: [{
        image_sync: {
          chain_name: "sui",
          base_denom: "0x2::sui::SUI"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/sui/images/sui.svg"
      }]
    },
    {
      description: "Aptos token (APT) is the Aptos blockchain native token used for paying network and transaction fees.",
      denom_units: [{
        denom: "ibc/A4D176906C1646949574B48C1928D475F2DF56DE0AC04E1C99B08F90BC21ABDE",
        exponent: 0,
        aliases: ["factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r"]
      }, {
        denom: "wormhole/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r/8",
        exponent: 8,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/A4D176906C1646949574B48C1928D475F2DF56DE0AC04E1C99B08F90BC21ABDE",
      name: "Aptos Coin",
      display: "wormhole/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r/8",
      symbol: "APT",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "aptos",
          base_denom: "0x1::aptos_coin::AptosCoin"
        },
        provider: "Wormhole"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-2186",
          path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/aptos/images/apt-dm.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/aptos/images/apt-dm.svg",
        theme: {
          dark_mode: !0
        }
      }, {
        image_sync: {
          chain_name: "aptos",
          base_denom: "0x1::aptos_coin::AptosCoin"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/aptos/images/aptos.svg"
      }]
    },
    {
      description: "MantaDAO Governance Token",
      denom_units: [{
        denom: "ibc/51D893F870B7675E507E91DA8DB0B22EA66333207E4F5C0708757F08EE059B0B",
        exponent: 0,
        aliases: ["factory/kujira1643jxg8wasy5cfcn7xm8rd742yeazcksqlg4d7/umnta"]
      }, {
        denom: "mnta",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/51D893F870B7675E507E91DA8DB0B22EA66333207E4F5C0708757F08EE059B0B",
      name: "MantaDAO",
      display: "mnta",
      symbol: "MNTA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kujira",
          base_denom: "factory/kujira1643jxg8wasy5cfcn7xm8rd742yeazcksqlg4d7/umnta",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-259",
          path: "transfer/channel-259/factory:kujira1643jxg8wasy5cfcn7xm8rd742yeazcksqlg4d7:umnta"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/mnta.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/mnta.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kujira",
          base_denom: "factory/kujira1643jxg8wasy5cfcn7xm8rd742yeazcksqlg4d7/umnta"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/mnta.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/mnta.svg",
        theme: {
          primary_color_hex: "#0c141c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/D69F6D787EC649F4E998161A9F0646F4C2DCC64748A2AB982F14CAFBA7CC0EC9",
        exponent: 0,
        aliases: ["factory/juno1u805lv20qc6jy7c3ttre7nct6uyl20pfky5r7e/DGL"]
      }, {
        denom: "dgl",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D69F6D787EC649F4E998161A9F0646F4C2DCC64748A2AB982F14CAFBA7CC0EC9",
      name: "Licorice",
      display: "dgl",
      symbol: "DGL",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "juno",
          base_denom: "factory/juno1u805lv20qc6jy7c3ttre7nct6uyl20pfky5r7e/DGL",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-42",
          path: "transfer/channel-42/factory/juno1u805lv20qc6jy7c3ttre7nct6uyl20pfky5r7e/DGL"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dgl.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "factory/juno1u805lv20qc6jy7c3ttre7nct6uyl20pfky5r7e/DGL"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/dgl.png",
        theme: {
          primary_color_hex: "#dfe0e0"
        }
      }]
    },
    {
      description: "USD Coin (Wormhole), USDC, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt",
      denom_units: [{
        denom: "ibc/6B99DB46AA9FF47162148C1726866919E44A6A5E0274B90912FD17E19A337695",
        exponent: 0,
        aliases: ["factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt"]
      }, {
        denom: "wormhole/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt/6",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/6B99DB46AA9FF47162148C1726866919E44A6A5E0274B90912FD17E19A337695",
      name: "USDC (Ethereum via Wormhole)",
      display: "wormhole/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt/6",
      symbol: "USDC.eth.wh",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
          },
          provider: "Wormhole"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gateway",
            base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-2186",
            path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.hole.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.hole.svg"
      }, {
        image_sync: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "Wrapped Ether (Wormhole), WETH, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp",
      denom_units: [{
        denom: "ibc/62F82550D0B96522361C89B0DA1119DE262FBDFB25E5502BC5101B5C0D0DBAAC",
        exponent: 0,
        aliases: ["factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp"]
      }, {
        denom: "wormhole/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp/8",
        exponent: 8,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/62F82550D0B96522361C89B0DA1119DE262FBDFB25E5502BC5101B5C0D0DBAAC",
      name: "Ethereum (Wormhole)",
      display: "wormhole/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp/8",
      symbol: "ETH.wh",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Ethereum"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"
          },
          provider: "Wormhole"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gateway",
            base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-2186",
            path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/weth.hole.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/weth.hole.svg"
      }, {
        image_sync: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg",
        theme: {
          primary_color_hex: "#303030"
        }
      }]
    },
    {
      description: "USDC is a fully collateralized US Dollar stablecoin developed by CENTRE, the open source project with Circle being the first of several forthcoming issuers.",
      denom_units: [{
        denom: "ibc/498A0751C798A0D9A389AA3691123DADA57DAA4FE165D5C75894505B876BA6E4",
        exponent: 0,
        aliases: ["microusdc", "uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/498A0751C798A0D9A389AA3691123DADA57DAA4FE165D5C75894505B876BA6E4",
      name: "USDC",
      display: "usdc",
      symbol: "USDC",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "additional-mintage",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
          },
          provider: "Circle"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "noble",
            base_denom: "uusdc",
            channel_id: "channel-1"
          },
          chain: {
            channel_id: "channel-750",
            path: "transfer/channel-750/uusdc"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png"
      }, {
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "Maximize ETH yield through leveraged staking across Aave, Compound and Morpho and liquidity provision of ETH liquid staking tokens on Uniswap V3.",
      denom_units: [{
        denom: "ibc/FBB3FEF80ED2344D821D4F95C31DBFD33E4E31D5324CAD94EF756E67B749F668",
        exponent: 0,
        aliases: ["0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec", "yieldeth-wei"]
      }, {
        denom: "YieldETH",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/FBB3FEF80ED2344D821D4F95C31DBFD33E4E31D5324CAD94EF756E67B749F668",
      name: "Real Yield ETH",
      display: "YieldETH",
      symbol: "YieldETH",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Seven Seas & DeFine Logic Labs"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "yieldeth-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/yieldeth-wei"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xb5b29320d2Dde5BA5BAFA1EbcD270052070483ec"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/yieldeth.svg",
        theme: {
          primary_color_hex: "#14448c"
        }
      }]
    },
    {
      description: "The native staking token of XPLA.",
      denom_units: [{
        denom: "ibc/95C9B5870F95E21A242E6AF9ADCB1F212EE4A8855087226C36FBE43FC41A77B8",
        exponent: 0,
        aliases: ["axpla"]
      }, {
        denom: "xpla",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/95C9B5870F95E21A242E6AF9ADCB1F212EE4A8855087226C36FBE43FC41A77B8",
      name: "XPLA",
      display: "xpla",
      symbol: "XPLA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "xpla",
          base_denom: "axpla",
          channel_id: "channel-9"
        },
        chain: {
          channel_id: "channel-1634",
          path: "transfer/channel-1634/axpla"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.svg"
      },
      images: [{
        image_sync: {
          chain_name: "xpla",
          base_denom: "axpla"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.svg",
        theme: {
          primary_color_hex: "#04b4fc"
        }
      }]
    },
    {
      description: "OIN Token ($OIN) is a groundbreaking digital asset developed on the $SEI Blockchain. It transcends being merely a cryptocurrency; $OIN stands as a robust store of value, symbolizing the future of decentralized finance and its potential to reshape the crypto landscape.",
      denom_units: [{
        denom: "ibc/98B3DBF1FA79C4C14CC5F08F62ACD5498560FCB515F677526FD200D54EA048B6",
        exponent: 0,
        aliases: ["factory/sei1thgp6wamxwqt7rthfkeehktmq0ujh5kspluw6w/OIN"]
      }, {
        denom: "oin",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/98B3DBF1FA79C4C14CC5F08F62ACD5498560FCB515F677526FD200D54EA048B6",
      name: "OIN STORE OF VALUE",
      display: "oin",
      symbol: "OIN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "sei",
          base_denom: "factory/sei1thgp6wamxwqt7rthfkeehktmq0ujh5kspluw6w/OIN",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-782",
          path: "transfer/channel-782/factory/sei1thgp6wamxwqt7rthfkeehktmq0ujh5kspluw6w/OIN"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/oin.png"
      },
      images: [{
        image_sync: {
          chain_name: "sei",
          base_denom: "factory/sei1thgp6wamxwqt7rthfkeehktmq0ujh5kspluw6w/OIN"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/oin.png",
        theme: {
          primary_color_hex: "#6cdbac"
        }
      }]
    },
    {
      description: "The token of Neokingdom DAO.",
      denom_units: [{
        denom: "ibc/DEE262653B9DE39BCEF0493D47E0DFC4FE62F7F046CF38B9FDEFEBE98D149A71",
        exponent: 0,
        aliases: ["erc20/0x655ecB57432CC1370f65e5dc2309588b71b473A9"]
      }, {
        denom: "neok",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/DEE262653B9DE39BCEF0493D47E0DFC4FE62F7F046CF38B9FDEFEBE98D149A71",
      name: "Neokingdom DAO",
      display: "neok",
      symbol: "NEOK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "evmos",
          base_denom: "erc20/0x655ecB57432CC1370f65e5dc2309588b71b473A9",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-204",
          path: "transfer/channel-204/erc20/0x655ecB57432CC1370f65e5dc2309588b71b473A9"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/neok.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/neok.svg"
      },
      images: [{
        image_sync: {
          chain_name: "evmos",
          base_denom: "erc20/0x655ecB57432CC1370f65e5dc2309588b71b473A9"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/neok.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/neok.svg",
        theme: {
          primary_color_hex: "#7f0f70"
        }
      }]
    },
    {
      description: "The native currency of the Realio Network.",
      denom_units: [{
        denom: "ibc/1CDF9C7D073DD59ED06F15DB08CC0901F2A24759BE70463570E8896F9A444ADF",
        exponent: 0,
        aliases: ["ario"]
      }, {
        denom: "rio",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/1CDF9C7D073DD59ED06F15DB08CC0901F2A24759BE70463570E8896F9A444ADF",
      name: "Realio Network",
      display: "rio",
      symbol: "RIO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "realio",
          base_denom: "ario",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-1424",
          path: "transfer/channel-1424/ario"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rio.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rio.svg"
      },
      images: [{
        image_sync: {
          chain_name: "realio",
          base_denom: "ario"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rio.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rio.svg",
        theme: {
          primary_color_hex: "#000000",
          background_color_hex: "#000000",
          circle: !0
        }
      }]
    },
    {
      description: "Membrane's CDP-style stablecoin called CDT",
      denom_units: [{
        denom: "factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt",
        exponent: 0
      }, {
        denom: "cdt",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt",
      name: "CDT Stablecoin",
      display: "cdt",
      symbol: "CDT",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CDT.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CDT.svg"
      }],
      coingecko_id: "collateralized-debt-token"
    },
    {
      description: "Membrane's protocol token",
      denom_units: [{
        denom: "factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn",
        exponent: 0
      }, {
        denom: "mbrn",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn",
      name: "Membrane",
      display: "mbrn",
      symbol: "MBRN",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/MBRN.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/MBRN.svg"
      }],
      coingecko_id: "membrane"
    },
    {
      description: "The native token of SGE Network",
      denom_units: [{
        denom: "ibc/A1830DECC0B742F0B2044FF74BE727B5CF92C9A28A9235C3BACE4D24A23504FA",
        exponent: 0,
        aliases: ["usge"]
      }, {
        denom: "sge",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/A1830DECC0B742F0B2044FF74BE727B5CF92C9A28A9235C3BACE4D24A23504FA",
      name: "SGE",
      display: "sge",
      symbol: "SGE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "sge",
          base_denom: "usge",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-5485",
          path: "transfer/channel-5485/usge"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg"
      },
      images: [{
        image_sync: {
          chain_name: "sge",
          base_denom: "usge"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg",
        theme: {
          primary_color_hex: "#C0A15B",
          background_color_hex: "#00000000",
          circle: !1
        }
      }]
    },
    {
      description: "The native staking and governance token of the StaFi Hub.",
      denom_units: [{
        denom: "ibc/01D2F0C4739C871BFBEE7E786709E6904A55559DC1483DD92ED392EF12247862",
        exponent: 0,
        aliases: ["ufis"]
      }, {
        denom: "fis",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/01D2F0C4739C871BFBEE7E786709E6904A55559DC1483DD92ED392EF12247862",
      name: "StaFi Hub",
      display: "fis",
      symbol: "FIS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stafihub",
          base_denom: "ufis",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-5413",
          path: "transfer/channel-5413/ufis"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/fis.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stafihub",
          base_denom: "ufis"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/fis.svg"
      }]
    },
    {
      description: "A liquid staking representation of staked ATOMs",
      denom_units: [{
        denom: "ibc/B66CE615C600ED0A8B5AF425ECFE0D57BE2377587F66C45934A76886F34DC9B7",
        exponent: 0,
        aliases: ["uratom"]
      }, {
        denom: "ratom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B66CE615C600ED0A8B5AF425ECFE0D57BE2377587F66C45934A76886F34DC9B7",
      name: "rATOM",
      display: "ratom",
      symbol: "rATOM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        provider: "StaFiHub"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stafihub",
          base_denom: "uratom",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-5413",
          path: "transfer/channel-5413/uratom"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/ratom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stafihub",
          base_denom: "uratom"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/ratom.svg"
      }]
    },
    {
      description: "The native token of ohhNFT.",
      denom_units: [{
        denom: "ibc/CFF40564FDA3E958D9904B8B479124987901168494655D9CC6B7C0EC0416020B",
        exponent: 0,
        aliases: ["factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/dust"]
      }, {
        denom: "strdst",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/CFF40564FDA3E958D9904B8B479124987901168494655D9CC6B7C0EC0416020B",
      name: "Stardust STRDST",
      display: "strdst",
      symbol: "STRDST",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/dust",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-75",
          path: "transfer/channel-75/factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/dust"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stargaze",
          base_denom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/dust"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.svg",
        theme: {
          primary_color_hex: "#c9720c"
        }
      }]
    },
    {
      description: "The native staking and governance token of the Theta testnet version of the Dora Vota.",
      denom_units: [{
        denom: "ibc/672406ADE4EDFD8C5EA7A0D0DD0C37E431DA7BD8393A15CD2CFDE3364917EB2A",
        exponent: 0,
        aliases: ["peaka"]
      }, {
        denom: "DORA",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/672406ADE4EDFD8C5EA7A0D0DD0C37E431DA7BD8393A15CD2CFDE3364917EB2A",
      name: "Dora Vota",
      display: "DORA",
      symbol: "DORA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "doravota",
          base_denom: "peaka",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-2694",
          path: "transfer/channel-2694/peaka"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/doravota/images/dora.svg"
      },
      images: [{
        image_sync: {
          chain_name: "doravota",
          base_denom: "peaka"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/doravota/images/dora.svg"
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/doravota/images/doravota.png",
        theme: {
          primary_color_hex: "#fba214"
        }
      }]
    },
    {
      description: "The native token of Coreum",
      denom_units: [{
        denom: "ibc/F3166F4D31D6BA1EC6C9F5536F5DDDD4CC93DBA430F7419E7CDC41C497944A65",
        exponent: 0,
        aliases: ["ucore"]
      }, {
        denom: "core",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F3166F4D31D6BA1EC6C9F5536F5DDDD4CC93DBA430F7419E7CDC41C497944A65",
      name: "Coreum",
      display: "core",
      symbol: "COREUM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "coreum",
          base_denom: "ucore",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-2188",
          path: "transfer/channel-2188/ucore"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.svg"
      },
      images: [{
        image_sync: {
          chain_name: "coreum",
          base_denom: "ucore"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.svg",
        theme: {
          primary_color_hex: "#24d494"
        }
      }],
      keywords: [
        "dex",
        "staking",
        "wasm",
        "assets",
        "nft",
        "XRPL"
      ]
    },
    {
      description: "The native token of the Celestia blockchain.",
      denom_units: [{
        denom: "ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877",
        exponent: 0,
        aliases: ["utia"]
      }, {
        denom: "tia",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877",
      name: "Celestia",
      display: "tia",
      symbol: "TIA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "celestia",
          base_denom: "utia",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-6994",
          path: "transfer/channel-6994/utia"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg"
      },
      images: [{
        image_sync: {
          chain_name: "celestia",
          base_denom: "utia"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg",
        theme: {
          primary_color_hex: "#7c2cfb"
        }
      }]
    },
    {
      description: "DYDX is a decentralized trading platform focused on derivatives and perpetual contracts, offering a secure and efficient trading experience without intermediaries.",
      extended_description: `DYDX is a leading decentralized trading platform specializing in derivatives and perpetual contracts. It enables users to trade with leverage, providing a sophisticated and efficient trading environment without intermediaries. Built on the Ethereum blockchain, DYDX uses smart contracts to ensure transaction security and transparency, giving users full control over their funds and trades.

The DYDX platform's native token, DYDX, is integral to its ecosystem, used for governance, staking, and fee discounts, incentivizing active participation. DYDX offers a wide range of trading pairs and supports advanced trading features like margin trading and lending. Combining the benefits of decentralized finance with traditional trading platform functionality, DYDX is paving the way for a more open and inclusive financial system.`,
      denom_units: [{
        denom: "ibc/831F0B1BBB1D08A2B75311892876D71565478C532967545476DF4C2D7492E48C",
        exponent: 0,
        aliases: ["adydx"]
      }, {
        denom: "dydx",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/831F0B1BBB1D08A2B75311892876D71565478C532967545476DF4C2D7492E48C",
      name: "dYdX Protocol",
      display: "dydx",
      symbol: "DYDX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "dydx",
          base_denom: "adydx",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-6787",
          path: "transfer/channel-6787/adydx"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx-circle.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx-circle.svg",
        theme: {
          circle: !0
        }
      }, {
        image_sync: {
          chain_name: "dydx",
          base_denom: "adydx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
        theme: {
          primary_color_hex: "#21212f"
        }
      }]
    },
    {
      description: "The native staking token of the Function X",
      denom_units: [{
        denom: "ibc/2B30802A0B03F91E4E16D6175C9B70F2911377C1CAE9E50FF011C821465463F9",
        exponent: 0,
        aliases: ["FX"]
      }, {
        denom: "WFX",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/2B30802A0B03F91E4E16D6175C9B70F2911377C1CAE9E50FF011C821465463F9",
      name: "f(x)Core",
      display: "WFX",
      symbol: "FX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "fxcore",
          base_denom: "FX",
          channel_id: "channel-19"
        },
        chain: {
          channel_id: "channel-2716",
          path: "transfer/channel-2716/FX"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.svg"
      },
      images: [{
        image_sync: {
          chain_name: "fxcore",
          base_denom: "FX"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fxcore/images/fx.svg",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }]
    },
    {
      description: "Bitcoin. On Cosmos.",
      denom_units: [{
        denom: "ibc/75345531D87BD90BF108BE7240BD721CB2CB0A1F16D4EBA71B09EC3C43E15C8F",
        exponent: 0,
        aliases: ["usat"]
      }, {
        denom: "nbtc",
        exponent: 14
      }],
      type_asset: "ics20",
      base: "ibc/75345531D87BD90BF108BE7240BD721CB2CB0A1F16D4EBA71B09EC3C43E15C8F",
      name: "Nomic Bitcoin",
      display: "nbtc",
      symbol: "nBTC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "bitcoin",
          base_denom: "sat"
        },
        provider: "Nomic"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "nomic",
          base_denom: "usat",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-6897",
          path: "transfer/channel-6897/usat"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "nomic",
          base_denom: "usat"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg",
        theme: {
          primary_color_hex: "#8436e6"
        }
      }]
    },
    {
      description: "The native token of Nois",
      denom_units: [{
        denom: "ibc/6928AFA9EA721938FED13B051F9DBF1272B16393D20C49EA5E4901BB76D94A90",
        exponent: 0,
        aliases: ["unois"]
      }, {
        denom: "nois",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/6928AFA9EA721938FED13B051F9DBF1272B16393D20C49EA5E4901BB76D94A90",
      name: "Nois",
      display: "nois",
      symbol: "NOIS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nois",
          base_denom: "unois",
          channel_id: "channel-37"
        },
        chain: {
          channel_id: "channel-8277",
          path: "transfer/channel-8277/unois"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.svg"
      },
      images: [{
        image_sync: {
          chain_name: "nois",
          base_denom: "unois"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.svg",
        theme: {
          primary_color_hex: "#0c0c14"
        }
      }],
      keywords: [
        "nois",
        "randomness",
        "drand",
        "wasm"
      ]
    },
    {
      description: "Margined Power Token sqOSMO",
      denom_units: [{
        denom: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/squosmo",
        exponent: 0
      }, {
        denom: "sqosmo",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/squosmo",
      name: "OSMO Squared",
      display: "sqosmo",
      symbol: "sqOSMO",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqosmo.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqosmo.svg"
      }]
    },
    {
      description: "The Revenue & Governance token of Unstake.fi",
      denom_units: [{
        denom: "ibc/F74225B0AFD2F675AF56E9BE3F235486BCDE5C5E09AA88A97AFD2E052ABFE04C",
        exponent: 0,
        aliases: ["factory/kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh/unstk"]
      }, {
        denom: "nstk",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F74225B0AFD2F675AF56E9BE3F235486BCDE5C5E09AA88A97AFD2E052ABFE04C",
      name: "Unstake Fi",
      display: "nstk",
      symbol: "NSTK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kujira",
          base_denom: "factory/kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh/unstk",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-259",
          path: "transfer/channel-259/factory:kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh:unstk"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nstk.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kujira",
          base_denom: "factory/kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh/unstk"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nstk.svg"
      }]
    },
    {
      description: "ohhNFT LP token.",
      denom_units: [{
        denom: "ibc/71DAA4CAFA4FE2F9803ABA0696BA5FC0EFC14305A2EA8B4E01880DB851B1EC02",
        exponent: 0,
        aliases: ["factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uBRNCH"]
      }, {
        denom: "BRNCH",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/71DAA4CAFA4FE2F9803ABA0696BA5FC0EFC14305A2EA8B4E01880DB851B1EC02",
      name: "Branch",
      display: "BRNCH",
      symbol: "BRNCH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uBRNCH",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-75",
          path: "transfer/channel-75/factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uBRNCH"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stargaze",
          base_denom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uBRNCH"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.svg",
        theme: {
          primary_color_hex: "#70372a"
        }
      }]
    },
    {
      description: "wstETH is a wrapped version of stETH. As some DeFi protocols require a constant balance mechanism for tokens, wstETH keeps your balance of stETH fixed and uses an underlying share system to reflect your earned staking rewards.",
      denom_units: [{
        denom: "ibc/2F21E6D4271DE3F561F20A02CD541DAF7405B1E9CB3B9B07E3C2AC7D8A4338A5",
        exponent: 0,
        aliases: ["factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH"]
      }, {
        denom: "wstETH",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/2F21E6D4271DE3F561F20A02CD541DAF7405B1E9CB3B9B07E3C2AC7D8A4338A5",
      name: "Wrapped Lido Staked Ether",
      display: "wstETH",
      symbol: "wstETH",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Lido"
        },
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84"
          },
          provider: "Lido"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0"
          },
          provider: "Lido wstETH Cosmos Bridge"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "neutron",
            base_denom: "factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH",
            channel_id: "channel-10"
          },
          chain: {
            channel_id: "channel-874",
            path: "transfer/channel-874/factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }]
    },
    {
      description: "Margined Power Token sqATOM",
      denom_units: [{
        denom: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqatom",
        exponent: 0
      }, {
        denom: "sqatom",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqatom",
      name: "ATOM Squared",
      display: "sqatom",
      symbol: "sqATOM",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqatom.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqatom.svg"
      }]
    },
    {
      description: "Margined Power Token sqBTC",
      denom_units: [{
        denom: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqbtc",
        exponent: 0
      }, {
        denom: "sqbtc",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqbtc",
      name: "BTC Squared",
      display: "sqbtc",
      symbol: "sqBTC",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqbtc.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqbtc.svg"
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "QWOYN is the native governance token for Qwoyn Network",
      denom_units: [{
        denom: "ibc/09FAF1E04435E14C68DE7AB0D03C521C92975C792DB12B2EA390BAA2E06B3F3D",
        exponent: 0,
        aliases: ["uqwoyn"]
      }, {
        denom: "qwoyn",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/09FAF1E04435E14C68DE7AB0D03C521C92975C792DB12B2EA390BAA2E06B3F3D",
      name: "Qwoyn",
      display: "qwoyn",
      symbol: "QWOYN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "qwoyn",
          base_denom: "uqwoyn",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-880",
          path: "transfer/channel-880/uqwoyn"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qwoyn/images/qwoyn.png"
      },
      images: [{
        image_sync: {
          chain_name: "qwoyn",
          base_denom: "uqwoyn"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qwoyn/images/qwoyn.png",
        theme: {
          primary_color_hex: "#04e4fc"
        }
      }],
      keywords: ["gaming"]
    },
    {
      description: "The liquid staking token of Bostrom",
      denom_units: [{
        denom: "ibc/4F3B0EC2FE2D370D10C3671A1B7B06D2A964C721470C305CBB846ED60E6CAA20",
        exponent: 0,
        aliases: ["hydrogen"]
      }],
      type_asset: "ics20",
      base: "ibc/4F3B0EC2FE2D370D10C3671A1B7B06D2A964C721470C305CBB846ED60E6CAA20",
      name: "Bostrom Hydrogen",
      display: "ibc/4F3B0EC2FE2D370D10C3671A1B7B06D2A964C721470C305CBB846ED60E6CAA20",
      symbol: "HYDROGEN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bostrom",
          base_denom: "hydrogen",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-95",
          path: "transfer/channel-95/hydrogen"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/hydrogen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/hydrogen.svg"
      },
      images: [{
        image_sync: {
          chain_name: "bostrom",
          base_denom: "hydrogen"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/hydrogen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/hydrogen.svg",
        theme: {
          primary_color_hex: "#ffffff"
        }
      }]
    },
    {
      description: "The staking token of Cyber",
      denom_units: [{
        denom: "ibc/BCDB35B7390806F35E716D275E1E017999F8281A81B6F128F087EF34D1DFA761",
        exponent: 0,
        aliases: ["tocyb"]
      }],
      type_asset: "ics20",
      base: "ibc/BCDB35B7390806F35E716D275E1E017999F8281A81B6F128F087EF34D1DFA761",
      name: "Bostrom Tocyb",
      display: "ibc/BCDB35B7390806F35E716D275E1E017999F8281A81B6F128F087EF34D1DFA761",
      symbol: "TOCYB",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bostrom",
          base_denom: "tocyb",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-95",
          path: "transfer/channel-95/tocyb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/tocyb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/tocyb.svg"
      },
      images: [{
        image_sync: {
          chain_name: "bostrom",
          base_denom: "tocyb"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/tocyb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/tocyb.svg",
        theme: {
          primary_color_hex: "#1e8fa9"
        }
      }]
    },
    {
      description: "The resource token of Bostrom",
      denom_units: [{
        denom: "ibc/D3A1900B2B520E45608B5671ADA461E1109628E89B4289099557C6D3996F7DAA",
        exponent: 0,
        aliases: ["millivolt"]
      }, {
        denom: "volt",
        exponent: 3,
        aliases: ["volt"]
      }],
      type_asset: "ics20",
      base: "ibc/D3A1900B2B520E45608B5671ADA461E1109628E89B4289099557C6D3996F7DAA",
      name: "Bostrom Volt",
      display: "volt",
      symbol: "V",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bostrom",
          base_denom: "millivolt",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-95",
          path: "transfer/channel-95/millivolt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/volt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/volt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "bostrom",
          base_denom: "millivolt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/volt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/volt.svg",
        theme: {
          primary_color_hex: "#fba809"
        }
      }]
    },
    {
      description: "The resource token of Bostrom",
      denom_units: [{
        denom: "ibc/020F5162B7BC40656FC5432622647091F00D53E82EE8D21757B43D3282F25424",
        exponent: 0,
        aliases: ["milliampere"]
      }, {
        denom: "ampere",
        exponent: 3,
        aliases: ["ampere"]
      }],
      type_asset: "ics20",
      base: "ibc/020F5162B7BC40656FC5432622647091F00D53E82EE8D21757B43D3282F25424",
      name: "Bostrom Ampere",
      display: "ampere",
      symbol: "A",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bostrom",
          base_denom: "milliampere",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-95",
          path: "transfer/channel-95/milliampere"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/ampere.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/ampere.svg"
      },
      images: [{
        image_sync: {
          chain_name: "bostrom",
          base_denom: "milliampere"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/ampere.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bostrom/images/ampere.svg",
        theme: {
          primary_color_hex: "#f4ecce"
        }
      }]
    },
    {
      description: "The native token of SOURCE Chain",
      denom_units: [{
        denom: "ibc/E7905742CE2EA4EA5D592527DC89220C59B617DE803939FE7293805A64B484D7",
        exponent: 0,
        aliases: ["usource"]
      }, {
        denom: "source",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E7905742CE2EA4EA5D592527DC89220C59B617DE803939FE7293805A64B484D7",
      name: "Source",
      display: "source",
      symbol: "SOURCE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "source",
          base_denom: "usource",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-8945",
          path: "transfer/channel-8945/usource"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.svg"
      },
      images: [{
        image_sync: {
          chain_name: "source",
          base_denom: "usource"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.svg",
        theme: {
          primary_color_hex: "#39a5fc"
        }
      }]
    },
    {
      description: `Pyth is a protocol that allows market participants to publish pricing information on-chain for others to use. The protocol is an interaction between three parties:
-Publishers submit pricing information to Pyth's oracle program. Pyth has multiple data publishers for every product to improve the accuracy and robustness of the system.
-Pyth's oracle program combines publishers' data to produce a single aggregate price and confidence interval.
Consumers read the price information produced by the oracle program.

Pyth's oracle program runs simultaneously on both Solana mainnet and Pythnet. Each instance of the program is responsible for its own set of price feeds. Solana Price Feeds are available for use by Solana protocols. In this case, since the oracle program itself runs on Solana, the resulting prices are immediately available to consumers without requiring any additional work. Pythnet Price Feeds are available on 12+ blockchains. The prices constructed on Pythnet are transferred cross-chain to reach consumers on these blockchains.

In both cases, the critical component of the system is the oracle program that combines the data from each individual publisher. This program maintains a number of different Solana accounts that list the products on Pyth and their current price data. Publishers publish their price and confidence by interacting with the oracle program on every slot. The program stores this information in its accounts. The first price update in a slot additionally triggers price aggregation, which combines the price data from the previous slot into a single aggregate price and confidence interval. This aggregate price is written to the Solana account where it is readable by other on-chain programs and available for transmission to other blockchains.`,
      denom_units: [{
        denom: "ibc/E42006ED917C769EDE1B474650EEA6BFE3F97958912B9206DD7010A28D01D9D5",
        exponent: 0,
        aliases: ["HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3", "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy"]
      }, {
        denom: "wormhole/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy/6",
        exponent: 6,
        aliases: ["pyth"]
      }],
      type_asset: "ics20",
      base: "ibc/E42006ED917C769EDE1B474650EEA6BFE3F97958912B9206DD7010A28D01D9D5",
      name: "Pyth Network",
      display: "wormhole/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy/6",
      symbol: "PYTH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3"
        },
        provider: "Wormhole"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-2186",
          path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pyth.svg"
      },
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pyth.svg"
      }]
    },
    {
      description: "PSTAKE Liquid-Staked OSMO",
      denom_units: [{
        denom: "ibc/ECBE78BF7677320A93E7BA1761D144BCBF0CBC247C290C049655E106FE5DC68E",
        exponent: 0,
        aliases: ["stk/uosmo"]
      }, {
        denom: "stkosmo",
        exponent: 6,
        aliases: ["stk/osmo"]
      }],
      type_asset: "ics20",
      base: "ibc/ECBE78BF7677320A93E7BA1761D144BCBF0CBC247C290C049655E106FE5DC68E",
      name: "PSTAKE staked OSMO",
      display: "stkosmo",
      symbol: "stkOSMO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        provider: "pSTAKE"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "persistence",
          base_denom: "stk/uosmo",
          channel_id: "channel-6"
        },
        chain: {
          channel_id: "channel-4",
          path: "transfer/channel-4/stk/uosmo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "persistence",
          base_denom: "stk/uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.svg",
        theme: {
          primary_color_hex: "#c3343d"
        }
      }]
    },
    {
      description: "Levana Well-funded Perps is a protocol for perpetual swaps, which are leveraged trading contracts.",
      extended_description: `Levana Well-funded Perps is a protocol for perpetual swaps, which are leveraged trading contracts. It aims to manage risk and provide benefits to both traders and liquidity providers.

For traders, Levana's solution is to make all positions "well-funded," meaning that the maximum profit for each position is locked in advance. This eliminates the possibility of bad debt and insolvency, providing greater security.

Liquidity providers, on the other hand, receive a yield for taking on the risk of market instability. They supply funds that act as collateral, and in return, they earn a fee with a risk premium.

The protocol addresses the issues with existing perpetual swap models, such as the virtual AMM. These models rely on complex mechanisms to maintain price stability, but they have limitations and can be risky in volatile markets.

By separating different trading pairs and creating a decentralized market for liquidity, Levana reduces the risk of contagion between different markets. This also makes it easier to expand to other blockchain networks.

Overall, Levana's perpetual swaps protocol offers a reliable and secure platform for traders and liquidity providers. It ensures fair settlement, minimizes risks, and allows for the development of additional financial protocols on top of tokenized positions.`,
      denom_units: [{
        denom: "factory/osmo1mlng7pz4pnyxtpq0akfwall37czyk9lukaucsrn30ameplhhshtqdvfm5c/ulvn",
        exponent: 0
      }, {
        denom: "lvn",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1mlng7pz4pnyxtpq0akfwall37czyk9lukaucsrn30ameplhhshtqdvfm5c/ulvn",
      name: "Levana",
      display: "lvn",
      symbol: "LVN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/levana.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/levana.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/levana.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/levana.svg",
        theme: {
          primary_color_hex: "#4c146c"
        }
      }],
      coingecko_id: "levana-protocol"
    },
    {
      description: "Puppy",
      denom_units: [{
        denom: "ibc/46AC07DBFF1352EC94AF5BD4D23740D92D9803A6B41F6E213E77F3A1143FB963",
        exponent: 0,
        aliases: ["cw20:chihuahua1yl8z39ugle8s02fpwkhh293509q5xcpalmdzc4amvchz8nkexrmsy95gef"]
      }, {
        denom: "puppy",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/46AC07DBFF1352EC94AF5BD4D23740D92D9803A6B41F6E213E77F3A1143FB963",
      name: "Puppy",
      display: "puppy",
      symbol: "PUPPY",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "chihuahua",
          base_denom: "cw20:chihuahua1yl8z39ugle8s02fpwkhh293509q5xcpalmdzc4amvchz8nkexrmsy95gef",
          port: "wasm.chihuahua1jwkag4yvhyj9fuddtkygvavya8hmdjuzmgxwg9vp3lw9twv6lrcq9mgl52",
          channel_id: "channel-73"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-11348",
          path: "transfer/channel-11348/cw20:chihuahua1yl8z39ugle8s02fpwkhh293509q5xcpalmdzc4amvchz8nkexrmsy95gef"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/puppyhuahua_logo.png"
      },
      images: [{
        image_sync: {
          chain_name: "chihuahua",
          base_denom: "cw20:chihuahua1yl8z39ugle8s02fpwkhh293509q5xcpalmdzc4amvchz8nkexrmsy95gef"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/puppyhuahua_logo.png",
        theme: {
          primary_color_hex: "#100e0d"
        }
      }],
      keywords: ["osmosis_unstable"]
    },
    {
      description: "The cutest NEWT token on Neutron chain.",
      denom_units: [{
        denom: "ibc/BF685448E564B5A4AC8F6E0493A0B979D0E0BF5EC11F7E15D25A0A2160C944DD",
        exponent: 0,
        aliases: ["unewt", "factory/neutron1p8d89wvxyjcnawmgw72klknr3lg9gwwl6ypxda/newt"]
      }, {
        denom: "newt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/BF685448E564B5A4AC8F6E0493A0B979D0E0BF5EC11F7E15D25A0A2160C944DD",
      name: "Newt",
      display: "newt",
      symbol: "NEWT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1p8d89wvxyjcnawmgw72klknr3lg9gwwl6ypxda/newt",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-874",
          path: "transfer/channel-874/factory/neutron1p8d89wvxyjcnawmgw72klknr3lg9gwwl6ypxda/newt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/newt.png"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1p8d89wvxyjcnawmgw72klknr3lg9gwwl6ypxda/newt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/newt.png",
        theme: {
          primary_color_hex: "#16233d"
        }
      }]
    },
    {
      description: "MilkyWay's liquid staked TIA",
      denom_units: [{
        denom: "factory/osmo1f5vfcph2dvfeqcqkhetwv75fda69z7e5c2dldm3kvgj23crkv6wqcn47a0/umilkTIA",
        exponent: 0
      }, {
        denom: "milkTIA",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1f5vfcph2dvfeqcqkhetwv75fda69z7e5c2dldm3kvgj23crkv6wqcn47a0/umilkTIA",
      name: "milkTIA",
      display: "milkTIA",
      symbol: "milkTIA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "celestia",
          base_denom: "utia"
        },
        provider: "MilkyWay"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/milktia.svg",
        theme: {
          primary_color_hex: "#d18dfc"
        }
      }],
      coingecko_id: "milkyway-staked-tia"
    },
    {
      description: "ASH",
      denom_units: [{
        denom: "ibc/4976049456D261659D0EC499CC9C2391D3C7D1128A0B9FB0BBF2842D1B2BC7BC",
        exponent: 0,
        aliases: ["factory/migaloo1erul6xyq0gk6ws98ncj7lnq9l4jn4gnnu9we73gdz78yyl2lr7qqrvcgup/ash"]
      }, {
        denom: "ASH",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4976049456D261659D0EC499CC9C2391D3C7D1128A0B9FB0BBF2842D1B2BC7BC",
      name: "ASH",
      display: "ASH",
      symbol: "ASH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1erul6xyq0gk6ws98ncj7lnq9l4jn4gnnu9we73gdz78yyl2lr7qqrvcgup/ash",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-642",
          path: "transfer/channel-642/factory/migaloo1erul6xyq0gk6ws98ncj7lnq9l4jn4gnnu9we73gdz78yyl2lr7qqrvcgup/ash"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ash.svg"
      },
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1erul6xyq0gk6ws98ncj7lnq9l4jn4gnnu9we73gdz78yyl2lr7qqrvcgup/ash"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/ash.svg"
      }]
    },
    {
      description: "RAC",
      denom_units: [{
        denom: "ibc/DDF1CD4CDC14AE2D6A3060193624605FF12DEE71CF1F8C19EEF35E9447653493",
        exponent: 0,
        aliases: ["factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/urac"]
      }, {
        denom: "RAC",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/DDF1CD4CDC14AE2D6A3060193624605FF12DEE71CF1F8C19EEF35E9447653493",
      name: "Racoon",
      display: "RAC",
      symbol: "RAC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/urac",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-642",
          path: "transfer/channel-642/factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/urac"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rac.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rac.svg"
      },
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/urac"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rac.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rac.svg",
        theme: {
          primary_color_hex: "#2b2434"
        }
      }]
    },
    {
      description: "GUPPY",
      denom_units: [{
        denom: "ibc/42A9553A7770F3D7B62F3A82AF04E7719B4FD6EAF31BE5645092AAC4A6C2201D",
        exponent: 0,
        aliases: ["factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy"]
      }, {
        denom: "GUPPY",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/42A9553A7770F3D7B62F3A82AF04E7719B4FD6EAF31BE5645092AAC4A6C2201D",
      name: "GUPPY",
      display: "GUPPY",
      symbol: "GUPPY",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-642",
          path: "transfer/channel-642/factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/guppy.png"
      },
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/guppy.png",
        theme: {
          primary_color_hex: "#d9966e"
        }
      }]
    },
    {
      description: "The native EVM, governance and staking token of the Haqq Network",
      denom_units: [{
        denom: "ibc/69110FF673D70B39904FF056CFDFD58A90BEC3194303F45C32CB91B8B0A738EA",
        exponent: 0,
        aliases: ["aISLM"]
      }, {
        denom: "ISLM",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/69110FF673D70B39904FF056CFDFD58A90BEC3194303F45C32CB91B8B0A738EA",
      name: "Haqq Network",
      display: "ISLM",
      symbol: "ISLM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "haqq",
          base_denom: "aISLM",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-1575",
          path: "transfer/channel-1575/aISLM"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/islm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/islm.svg"
      },
      images: [{
        image_sync: {
          chain_name: "haqq",
          base_denom: "aISLM"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/islm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/islm.svg",
        theme: {
          primary_color_hex: "#04cd80"
        }
      }]
    },
    {
      description: "$AUTISM exists to celebrate autism as a superior biological tech stack for a changing world",
      denom_units: [{
        denom: "ibc/9DDF52A334F92BC57A9E0D59DFF9984EAC61D2A14E5162605DF601AA58FDFC6D",
        exponent: 0,
        aliases: ["factory/inj14lf8xm6fcvlggpa7guxzjqwjmtr24gnvf56hvz/autism"]
      }, {
        denom: "autism",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9DDF52A334F92BC57A9E0D59DFF9984EAC61D2A14E5162605DF601AA58FDFC6D",
      name: "Autism",
      display: "autism",
      symbol: "AUTISM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "factory/inj14lf8xm6fcvlggpa7guxzjqwjmtr24gnvf56hvz/autism",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-122",
          path: "transfer/channel-122/factory/inj14lf8xm6fcvlggpa7guxzjqwjmtr24gnvf56hvz/autism"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/autism.png"
      },
      images: [{
        image_sync: {
          chain_name: "injective",
          base_denom: "factory/inj14lf8xm6fcvlggpa7guxzjqwjmtr24gnvf56hvz/autism"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/autism.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "The PAGE token is used for actions in the PageDAO NFT literary ecosystem and for DAO governance.",
      denom_units: [{
        denom: "ibc/23A62409E4AD8133116C249B1FA38EED30E500A115D7B153109462CD82C1CD99",
        exponent: 0,
        aliases: ["gravity0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e"]
      }, {
        denom: "page",
        exponent: 8
      }],
      type_asset: "ics20",
      base: "ibc/23A62409E4AD8133116C249B1FA38EED30E500A115D7B153109462CD82C1CD99",
      name: "Page",
      display: "page",
      symbol: "PAGE",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e"
        },
        provider: "Gravity Bridge"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "gravitybridge",
          base_denom: "gravity0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-144",
          path: "transfer/channel-144/gravity0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/page.svg",
        theme: {
          primary_color_hex: "#ebb324"
        }
      }]
    },
    {
      description: "PURSE Token",
      denom_units: [{
        denom: "ibc/6FD2938076A4C1BB3A324A676E76B0150A4443DAE0E002FB62AC0E6B604B1519",
        exponent: 0,
        aliases: ["bsc0x29a63F4B209C29B4DC47f06FFA896F32667DAD2C"]
      }, {
        denom: "PURSE",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/6FD2938076A4C1BB3A324A676E76B0150A4443DAE0E002FB62AC0E6B604B1519",
      name: "PURSE Token",
      display: "PURSE",
      symbol: "PURSE",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "binancesmartchain",
          base_denom: "0x29a63F4B209C29B4DC47f06FFA896F32667DAD2C",
          contract: "0x84238c00c8313920826D798e3cF6793Ef4F610ad"
        },
        provider: "Function X"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "pundix",
          base_denom: "bsc0x29a63F4B209C29B4DC47f06FFA896F32667DAD2C",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-12618",
          path: "transfer/channel-12618/bsc0x29a63F4B209C29B4DC47f06FFA896F32667DAD2C"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/purse-token-logo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/purse-token-logo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "binancesmartchain",
          base_denom: "0x29a63F4B209C29B4DC47f06FFA896F32667DAD2C"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/purse-token-logo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/purse-token-logo.svg",
        theme: {
          primary_color_hex: "#1c1c1b"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "The first meme coin on Injective. It’s a dog, but he has nunchucks",
      denom_units: [{
        denom: "ibc/183C0BB962D2F57C957E0B134CFA0AC9D6F755C02DE9DC2A59089BA23009DEC3",
        exponent: 0,
        aliases: ["factory/inj1xtel2knkt8hmc9dnzpjz6kdmacgcfmlv5f308w/ninja"]
      }, {
        denom: "NINJA",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/183C0BB962D2F57C957E0B134CFA0AC9D6F755C02DE9DC2A59089BA23009DEC3",
      name: "Dog wif nunchucks",
      display: "NINJA",
      symbol: "NINJA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "factory/inj1xtel2knkt8hmc9dnzpjz6kdmacgcfmlv5f308w/ninja",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-122",
          path: "transfer/channel-122/factory/inj1xtel2knkt8hmc9dnzpjz6kdmacgcfmlv5f308w/ninja"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/ninja.png"
      },
      images: [{
        image_sync: {
          chain_name: "injective",
          base_denom: "factory/inj1xtel2knkt8hmc9dnzpjz6kdmacgcfmlv5f308w/ninja"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/ninja.png",
        theme: {
          primary_color_hex: "#00468E",
          background_color_hex: "#00468E",
          circle: !0
        }
      }]
    },
    {
      description: "Kleomedes Token",
      denom_units: [{
        denom: "ibc/5F5B7DA5ECC80F6C7A8702D525BB0B74279B1F7B8EFAE36E423D68788F7F39FF",
        exponent: 0,
        aliases: ["cw20:juno10gthz5ufgrpuk5cscve2f0hjp56wgp90psqxcrqlg4m9mcu9dh8q4864xy"]
      }, {
        denom: "kleo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/5F5B7DA5ECC80F6C7A8702D525BB0B74279B1F7B8EFAE36E423D68788F7F39FF",
      name: "Kleomedes",
      display: "kleo",
      symbol: "KLEO",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno10gthz5ufgrpuk5cscve2f0hjp56wgp90psqxcrqlg4m9mcu9dh8q4864xy",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno10gthz5ufgrpuk5cscve2f0hjp56wgp90psqxcrqlg4m9mcu9dh8q4864xy"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/kleomedes.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno10gthz5ufgrpuk5cscve2f0hjp56wgp90psqxcrqlg4m9mcu9dh8q4864xy"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/kleomedes.png",
        theme: {
          primary_color_hex: "#240454"
        }
      }]
    },
    {
      description: "NYX Token (NYX) is the Nym Network's native token.",
      denom_units: [{
        denom: "ibc/1A611E8A3E4248106A1A5A80A64BFA812739435E8B9888EB3F652A21F029F317",
        exponent: 0,
        aliases: ["unyx"]
      }, {
        denom: "nyx",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1A611E8A3E4248106A1A5A80A64BFA812739435E8B9888EB3F652A21F029F317",
      name: "Nym",
      display: "nyx",
      symbol: "NYX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nyx",
          base_denom: "unyx",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-15464",
          path: "transfer/channel-15464/unyx"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nyx.png"
      },
      images: [{
        image_sync: {
          chain_name: "nyx",
          base_denom: "unyx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nyx.png",
        theme: {
          primary_color_hex: "#f45135"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "NYM Token (NYM) is the Nym Network's native utility token, used as the primary means to incentivize mixnet node operators.",
      denom_units: [{
        denom: "ibc/37CB3078432510EE57B9AFA8DBE028B33AE3280A144826FEAC5F2334CF2C5539",
        exponent: 0,
        aliases: ["unym"]
      }, {
        denom: "nym",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/37CB3078432510EE57B9AFA8DBE028B33AE3280A144826FEAC5F2334CF2C5539",
      name: "NYM",
      display: "nym",
      symbol: "NYM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nyx",
          base_denom: "unym",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-15464",
          path: "transfer/channel-15464/unym"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.svg"
      },
      images: [
        {
          image_sync: {
            chain_name: "nyx",
            base_denom: "unym"
          },
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_light.svg",
          theme: {
            dark_mode: !1,
            circle: !0,
            primary_color_hex: "#151525"
          }
        },
        {
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_dark.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym_token_dark.svg",
          theme: {
            dark_mode: !0,
            circle: !0,
            primary_color_hex: "#141424"
          }
        },
        {
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyx/images/nym.png",
          theme: {
            primary_color_hex: "#293a5d"
          }
        }
      ]
    },
    {
      description: "has a hat",
      denom_units: [{
        denom: "ibc/2FFE07C4B4EFC0DDA099A16C6AF3C9CCA653CC56077E87217A585D48794B0BC7",
        exponent: 0,
        aliases: ["factory/chihuahua1x4q2vkrz4dfgd9hcw0p5m2f2nuv2uqmt9xr8k2/achihuahuawifhat"]
      }, {
        denom: "achihuahuawifhat",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2FFE07C4B4EFC0DDA099A16C6AF3C9CCA653CC56077E87217A585D48794B0BC7",
      name: "Chihuahuawifhat",
      display: "achihuahuawifhat",
      symbol: "BADDOG",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "chihuahua",
          base_denom: "factory/chihuahua1x4q2vkrz4dfgd9hcw0p5m2f2nuv2uqmt9xr8k2/achihuahuawifhat",
          channel_id: "channel-7"
        },
        chain: {
          channel_id: "channel-113",
          path: "transfer/channel-113/factory/chihuahua1x4q2vkrz4dfgd9hcw0p5m2f2nuv2uqmt9xr8k2/achihuahuawifhat"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/baddog.png"
      },
      images: [{
        image_sync: {
          chain_name: "chihuahua",
          base_denom: "factory/chihuahua1x4q2vkrz4dfgd9hcw0p5m2f2nuv2uqmt9xr8k2/achihuahuawifhat"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/baddog.png",
        theme: {
          primary_color_hex: "#F7E3C0",
          background_color_hex: "#F7E3C0",
          circle: !0
        }
      }]
    },
    {
      description: "clownmaxxed store of value",
      denom_units: [{
        denom: "ibc/8C8F6349F656C943543C6B040377BE44123D01F712277815C3C13098BB98818C",
        exponent: 0,
        aliases: ["ucircus", "factory/neutron170v88vrtnedesyfytuku257cggxc79rd7lwt7q/ucircus"]
      }, {
        denom: "circus",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/8C8F6349F656C943543C6B040377BE44123D01F712277815C3C13098BB98818C",
      name: "AtomEconomicZone69JaeKwonInu",
      display: "circus",
      symbol: "CIRCUS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron170v88vrtnedesyfytuku257cggxc79rd7lwt7q/ucircus",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-874",
          path: "transfer/channel-874/factory/neutron170v88vrtnedesyfytuku257cggxc79rd7lwt7q/ucircus"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/circus.png"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron170v88vrtnedesyfytuku257cggxc79rd7lwt7q/ucircus"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/circus.png",
        theme: {
          primary_color_hex: "#242033"
        }
      }]
    },
    {
      description: "Governance and utility token for the Junø Apes NFT platform on Juno",
      denom_units: [{
        denom: "ibc/176DD560277BB0BD676260BE02EBAB697725CA85144D8A2BF286C6B5323DB5FE",
        exponent: 0,
        aliases: ["cw20:juno1zkwveux7y6fmsr88atf3cyffx96p0c96qr8tgcsj7vfnhx7sal3s3zu3ps"]
      }, {
        denom: "jape",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/176DD560277BB0BD676260BE02EBAB697725CA85144D8A2BF286C6B5323DB5FE",
      name: "Junø Apes",
      display: "jape",
      symbol: "JAPE",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1zkwveux7y6fmsr88atf3cyffx96p0c96qr8tgcsj7vfnhx7sal3s3zu3ps",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1zkwveux7y6fmsr88atf3cyffx96p0c96qr8tgcsj7vfnhx7sal3s3zu3ps"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/jape.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1zkwveux7y6fmsr88atf3cyffx96p0c96qr8tgcsj7vfnhx7sal3s3zu3ps"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/jape.png",
        theme: {
          primary_color_hex: "#ee8179"
        }
      }]
    },
    {
      description: "Woof",
      denom_units: [{
        denom: "ibc/9B8EC667B6DF55387DC0F3ACC4F187DA6921B0806ED35DE6B04DE96F5AB81F53",
        exponent: 0,
        aliases: ["factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uwoof"]
      }, {
        denom: "WOOF",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9B8EC667B6DF55387DC0F3ACC4F187DA6921B0806ED35DE6B04DE96F5AB81F53",
      name: "WOOF",
      display: "WOOF",
      symbol: "WOOF",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "chihuahua",
          base_denom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uwoof",
          channel_id: "channel-7"
        },
        chain: {
          channel_id: "channel-113",
          path: "transfer/channel-113/factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uwoof"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/woof.png"
      },
      images: [{
        image_sync: {
          chain_name: "chihuahua",
          base_denom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uwoof"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/woof.png",
        theme: {
          primary_color_hex: "#d9905f"
        }
      }]
    },
    {
      description: "The native coin of Sneaky Productions.",
      denom_units: [{
        denom: "ibc/94ED1F172BC633DFC56D7E26551D8B101ADCCC69052AC44FED89F97FF658138F",
        exponent: 0,
        aliases: ["factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky"]
      }, {
        denom: "sneaky",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/94ED1F172BC633DFC56D7E26551D8B101ADCCC69052AC44FED89F97FF658138F",
      name: "Sneaky Productions",
      display: "sneaky",
      symbol: "SNEAKY",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-75",
          path: "transfer/channel-75/factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stargaze",
          base_denom: "factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.svg",
        theme: {
          primary_color_hex: "#fbcaca"
        }
      }]
    },
    {
      description: "Wrapped Bitcoin (WBTC) is an ERC20 token backed 1:1 with Bitcoin. Completely transparent. 100% verifiable. Community led.",
      denom_units: [{
        denom: "factory/osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743/wbtc",
        exponent: 0,
        aliases: ["wbtc-satoshi"]
      }, {
        denom: "wbtc",
        exponent: 8
      }],
      type_asset: "sdk.coin",
      address: "osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743",
      base: "factory/osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743/wbtc",
      name: "Wrapped Bitcoin",
      display: "wbtc",
      symbol: "WBTC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "bitcoin",
          base_denom: "sat"
        },
        provider: "BitGo, Kyber, and Ren"
      }, {
        type: "additional-mintage",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        },
        provider: "BitGo, Kyber, and Ren"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg",
        theme: {
          primary_color_hex: "#f39444"
        }
      }],
      coingecko_id: "wrapped-bitcoin"
    },
    {
      description: "Baddest coin on Cosmos",
      denom_units: [{
        denom: "ibc/442A08C33AE9875DF90792FFA73B5728E1CAECE87AB4F26AE9B422F1E682ED23",
        exponent: 0,
        aliases: ["ubad", "factory/neutron143wp6g8paqasnuuey6zyapucknwy9rhnld8hkr/bad"]
      }, {
        denom: "bad",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/442A08C33AE9875DF90792FFA73B5728E1CAECE87AB4F26AE9B422F1E682ED23",
      name: "Badcoin",
      display: "bad",
      symbol: "BAD",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron143wp6g8paqasnuuey6zyapucknwy9rhnld8hkr/bad",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-874",
          path: "transfer/channel-874/factory/neutron143wp6g8paqasnuuey6zyapucknwy9rhnld8hkr/bad"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/bad.png"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron143wp6g8paqasnuuey6zyapucknwy9rhnld8hkr/bad"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/bad.png",
        theme: {
          primary_color_hex: "#211a0d"
        }
      }]
    },
    {
      description: "Signal Art and Gaming on Juno",
      denom_units: [{
        denom: "ibc/4BDADBEDA31899036AB286E9901116496A9D85FB87B35A408C9D67C0DCAC660A",
        exponent: 0,
        aliases: ["cw20:juno14lycavan8gvpjn97aapzvwmsj8kyrvf644p05r0hu79namyj3ens87650k"]
      }, {
        denom: "sgnl",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4BDADBEDA31899036AB286E9901116496A9D85FB87B35A408C9D67C0DCAC660A",
      name: "Signal",
      display: "sgnl",
      symbol: "SGNL",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno14lycavan8gvpjn97aapzvwmsj8kyrvf644p05r0hu79namyj3ens87650k",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno14lycavan8gvpjn97aapzvwmsj8kyrvf644p05r0hu79namyj3ens87650k"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sgnl.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno14lycavan8gvpjn97aapzvwmsj8kyrvf644p05r0hu79namyj3ens87650k"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/sgnl.png",
        theme: {
          primary_color_hex: "#c5c2c2"
        }
      }]
    },
    {
      description: "The first native memecoin on Osmosis. Crafted by the deftest of hands in the lab of lunacy. It's scientifically anarchic, professionally foolish, and your ticket to the madhouse.",
      denom_units: [{
        denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO",
        exponent: 0
      }, {
        denom: "WOSMO",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3",
      base: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO",
      name: "WOSMO",
      display: "WOSMO",
      symbol: "WOSMO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png",
        theme: {
          primary_color_hex: "#edd5ee"
        }
      }]
    },
    {
      description: "Margined Power Token sqTIA",
      denom_units: [{
        denom: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqtia",
        exponent: 0
      }, {
        denom: "sqtia",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqtia",
      name: "TIA Squared",
      display: "sqtia",
      symbol: "sqTIA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqtia.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sqtia.svg"
      }]
    },
    {
      description: "The deflationary utility token of the Apollo DAO project",
      denom_units: [{
        denom: "ibc/73BB20AF857D1FE6E061D01CA13870872AD0C979497CAF71BEA25B1CBF6879F1",
        exponent: 0,
        aliases: ["uapollo", "factory/neutron154gg0wtm2v4h9ur8xg32ep64e8ef0g5twlsgvfeajqwghdryvyqsqhgk8e/APOLLO"]
      }, {
        denom: "apollo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/73BB20AF857D1FE6E061D01CA13870872AD0C979497CAF71BEA25B1CBF6879F1",
      name: "Apollo DAO",
      display: "apollo",
      symbol: "APOLLO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron154gg0wtm2v4h9ur8xg32ep64e8ef0g5twlsgvfeajqwghdryvyqsqhgk8e/APOLLO",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-874",
          path: "transfer/channel-874/factory/neutron154gg0wtm2v4h9ur8xg32ep64e8ef0g5twlsgvfeajqwghdryvyqsqhgk8e/APOLLO"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/apollo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron154gg0wtm2v4h9ur8xg32ep64e8ef0g5twlsgvfeajqwghdryvyqsqhgk8e/APOLLO"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/apollo.svg"
      }]
    },
    {
      description: "Stride's liquid staked DYDX",
      denom_units: [{
        denom: "ibc/980E82A9F8E7CA8CD480F4577E73682A6D3855A267D1831485D7EBEF0E7A6C2C",
        exponent: 0,
        aliases: ["stadydx"]
      }, {
        denom: "stDYDX",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/980E82A9F8E7CA8CD480F4577E73682A6D3855A267D1831485D7EBEF0E7A6C2C",
      name: "Stride Staked DYDX",
      display: "stDYDX",
      symbol: "stDYDX",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "dydx",
          base_denom: "adydx"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stadydx",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stadydx"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stadydx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Stride's liquid staked TIA",
      denom_units: [{
        denom: "ibc/698350B8A61D575025F3ED13E9AC9C0F45C89DEFE92F76D5838F1D3C1A7FF7C9",
        exponent: 0,
        aliases: ["stutia"]
      }, {
        denom: "stTIA",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/698350B8A61D575025F3ED13E9AC9C0F45C89DEFE92F76D5838F1D3C1A7FF7C9",
      name: "Stride Staked TIA",
      display: "stTIA",
      symbol: "stTIA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "celestia",
          base_denom: "utia"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stutia",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stutia"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stutia"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Stride's liquid staked SAGA",
      denom_units: [{
        denom: "ibc/2CD9F8161C3FC332E78EF0C25F6E684D09379FB2F56EF9267E7EC139642EC57B",
        exponent: 0,
        aliases: ["stusaga"]
      }, {
        denom: "stSAGA",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2CD9F8161C3FC332E78EF0C25F6E684D09379FB2F56EF9267E7EC139642EC57B",
      name: "Stride Staked SAGA",
      display: "stSAGA",
      symbol: "stSAGA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "saga",
          base_denom: "usaga"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stusaga",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stusaga"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsaga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsaga.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stusaga"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsaga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsaga.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/C04DFC9BCD893E57F2BEFE40F63EFD18D2768514DBD5F63ABD2FF7F48FC01D36",
        exponent: 0,
        aliases: ["stinj"]
      }, {
        denom: "stINJ",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/C04DFC9BCD893E57F2BEFE40F63EFD18D2768514DBD5F63ABD2FF7F48FC01D36",
      name: "Stride Staked INJ",
      display: "stINJ",
      symbol: "stINJ",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "injective",
          base_denom: "inj"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stinj",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stinj"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stinj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stinj.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stinj"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stinj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stinj.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "GLTO-ERC20 on injective",
      denom_units: [{
        denom: "ibc/072E5B3D6F278B3E6A9C51D7EAD1A737148609512C5EBE8CBCB5663264A0DDB7",
        exponent: 0,
        aliases: ["peggy0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2"]
      }, {
        denom: "glto",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/072E5B3D6F278B3E6A9C51D7EAD1A737148609512C5EBE8CBCB5663264A0DDB7",
      name: "Gelotto (Injective)",
      display: "glto",
      symbol: "GLTO",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2"
        },
        provider: "Peggy"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "peggy0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-122",
          path: "transfer/channel-122/peggy0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg",
        theme: {
          primary_color_hex: "#501cad"
        }
      }, {
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/glto.svg",
        theme: {
          primary_color_hex: "#501cad"
        }
      }]
    },
    {
      description: "The native governance and staking token of the Dymension Hub",
      denom_units: [{
        denom: "ibc/9A76CDF0CBCEF37923F32518FA15E5DC92B9F56128292BC4D63C4AEA76CBB110",
        exponent: 0,
        aliases: ["adym"]
      }, {
        denom: "dym",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/9A76CDF0CBCEF37923F32518FA15E5DC92B9F56128292BC4D63C4AEA76CBB110",
      name: "Dymension Hub",
      display: "dym",
      symbol: "DYM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "dymension",
          base_denom: "adym",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-19774",
          path: "transfer/channel-19774/adym"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "dymension",
          base_denom: "adym"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dymension/images/dymension-logo.svg",
        theme: {
          primary_color_hex: "#f4e4d4"
        }
      }]
    },
    {
      description: "Rapture insurance is the first ever P2P insurance platform on $OSMO. Get rewarded to take care of peoples loved ones after the Rapture.",
      denom_units: [{
        denom: "factory/osmo1279xudevmf5cw83vkhglct7jededp86k90k2le/RAPTR",
        exponent: 0
      }, {
        denom: "RAPTR",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1279xudevmf5cw83vkhglct7jededp86k90k2le",
      base: "factory/osmo1279xudevmf5cw83vkhglct7jededp86k90k2le/RAPTR",
      name: "RAPTR",
      display: "RAPTR",
      symbol: "RAPTR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/RAPTR.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/RAPTR.png",
        theme: {
          primary_color_hex: "#e2b67d"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.",
      denom_units: [{
        denom: "ibc/C25A2303FE24B922DAFFDCE377AC5A42E5EF746806D32E2ED4B610DE85C203F7",
        exponent: 0,
        aliases: ["cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26"]
      }, {
        denom: "astro.cw20",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C25A2303FE24B922DAFFDCE377AC5A42E5EF746806D32E2ED4B610DE85C203F7",
      name: "Astroport token (Terra)",
      display: "astro.cw20",
      symbol: "ASTRO.terra",
      traces: [{
        type: "legacy-mintage",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        provider: "Astroport"
      }, {
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra2",
          base_denom: "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26",
          port: "wasm.terra1jhfjnm39y3nn9l4520mdn4k5mw23nz0674c4gsvyrcr90z9tqcvst22fce",
          channel_id: "channel-392"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-21671",
          path: "transfer/channel-21671/cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/astro-cw20.svg"
      },
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/astro-cw20.svg"
      }, {
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg",
        theme: {
          primary_color_hex: "#4056e9"
        }
      }]
    },
    {
      description: "A clan of 11y bad kids crafting chaos on the Cosmos eco. One bad memecoin to rule them all  $BADKID. Airdropped to Badkids NFT holders and $STARS stakers. It's so bad, your wallet's throwing a tantrum for it.",
      denom_units: [{
        denom: "factory/osmo10n8rv8npx870l69248hnp6djy6pll2yuzzn9x8/BADKID",
        exponent: 0
      }, {
        denom: "BADKID",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo10n8rv8npx870l69248hnp6djy6pll2yuzzn9x8",
      base: "factory/osmo10n8rv8npx870l69248hnp6djy6pll2yuzzn9x8/BADKID",
      name: "BADKID",
      display: "BADKID",
      symbol: "BADKID",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/badkid.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/badkid.png",
        theme: {
          primary_color_hex: "#57443f"
        }
      }]
    },
    {
      description: "Solana USD Coin (Wormhole), Solana USDC, factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3",
      denom_units: [{
        denom: "ibc/F08DE332018E8070CC4C68FE06E04E254F527556A614F5F8F9A68AF38D367E45",
        exponent: 0,
        aliases: ["factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3"]
      }, {
        denom: "wormhole/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3/6",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/F08DE332018E8070CC4C68FE06E04E254F527556A614F5F8F9A68AF38D367E45",
      name: "USDC (Solana via Wormhole)",
      display: "wormhole/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3/6",
      symbol: "USDC.sol.wh",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "additional-mintage",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
          },
          provider: "Circle"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "solana",
            base_denom: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
          },
          provider: "Wormhole"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gateway",
            base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-2186",
            path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/solana.USDC.wh.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/solana.USDC.wh.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/solana.USDC.wh.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/solana.USDC.wh.svg",
        theme: {
          primary_color_hex: "#2775cb"
        }
      }, {
        image_sync: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "The native staking and governance token of Humans.ai.",
      denom_units: [{
        denom: "ibc/35CECC330D11DD00FACB555D07687631E0BC7D226260CC5F015F6D7980819533",
        exponent: 0,
        aliases: ["aheart"]
      }, {
        denom: "heart",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/35CECC330D11DD00FACB555D07687631E0BC7D226260CC5F015F6D7980819533",
      name: "Humans.ai",
      display: "heart",
      symbol: "HEART",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "humans",
          base_denom: "aheart",
          channel_id: "channel-4"
        },
        chain: {
          channel_id: "channel-20082",
          path: "transfer/channel-20082/aheart"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.svg"
      },
      images: [{
        image_sync: {
          chain_name: "humans",
          base_denom: "aheart"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/humans/images/heart-dark-mode.svg",
        theme: {
          dark_mode: !0,
          primary_color_hex: "#f3f3f3"
        }
      }]
    },
    {
      description: "The token of Teledisko DAO.",
      denom_units: [{
        denom: "ibc/2BF9656CAB0384A31167DB9B0254F0FB1CB4346A229BD7E5CBDCBB911C3740F7",
        exponent: 0,
        aliases: ["erc20/0x1cFc8f1FE8D5668BAFF2724547EcDbd6f013a280"]
      }, {
        denom: "berlin",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/2BF9656CAB0384A31167DB9B0254F0FB1CB4346A229BD7E5CBDCBB911C3740F7",
      name: "Teledisko DAO - Legacy",
      display: "berlin",
      symbol: "BERLIN-legacy",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "evmos",
          base_denom: "erc20/0x1cFc8f1FE8D5668BAFF2724547EcDbd6f013a280",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-204",
          path: "transfer/channel-204/erc20/0x1cFc8f1FE8D5668BAFF2724547EcDbd6f013a280"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/berlin.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/berlin.svg"
      },
      images: [{
        image_sync: {
          chain_name: "evmos",
          base_denom: "erc20/0x1cFc8f1FE8D5668BAFF2724547EcDbd6f013a280"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/berlin.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/berlin.svg",
        theme: {
          primary_color_hex: "#bbce1a"
        }
      }]
    },
    {
      description: "The native token of Scorum",
      denom_units: [{
        denom: "ibc/178248C262DE2E141EE6287EE7AB0854F05F25B0A3F40C4B912FA1C7E51F466E",
        exponent: 0,
        aliases: ["nscr"]
      }, {
        denom: "scr",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/178248C262DE2E141EE6287EE7AB0854F05F25B0A3F40C4B912FA1C7E51F466E",
      name: "Scorum",
      display: "scr",
      symbol: "SCR",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "scorum",
          base_denom: "nscr",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-20100",
          path: "transfer/channel-20100/nscr"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scr.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scr.svg"
      },
      images: [{
        image_sync: {
          chain_name: "scorum",
          base_denom: "nscr"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scr.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scr.svg",
        theme: {
          primary_color_hex: "#0bc47e"
        }
      }]
    },
    {
      description: "The native token of Chain4Energy",
      denom_units: [{
        denom: "ibc/62118FB4D5FEDD5D2B18DC93648A745CD5E5B01D420E9B7A5FED5381CB13A7E8",
        exponent: 0,
        aliases: ["uc4e"]
      }, {
        denom: "c4e",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/62118FB4D5FEDD5D2B18DC93648A745CD5E5B01D420E9B7A5FED5381CB13A7E8",
      name: "C4E",
      display: "c4e",
      symbol: "C4E",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "chain4energy",
          base_denom: "uc4e",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-22172",
          path: "transfer/channel-22172/uc4e"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chain4energy/images/c4e.png"
      },
      images: [{
        image_sync: {
          chain_name: "chain4energy",
          base_denom: "uc4e"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chain4energy/images/c4e.png",
        theme: {
          primary_color_hex: "#24344c"
        }
      }]
    },
    {
      description: "Bitmos opens doors for BRC20 tokens to thrive alongside established players in the Cosmos Network, revolutionizing decentralized finance (DeFi) for all.",
      denom_units: [{
        denom: "ibc/7D389F0ABF1E4D45BE6D7BBE36A2C50EA0559C01E076B02F8E381E685EC1F942",
        exponent: 0,
        aliases: ["cw20:terra1sxe8u2hjczlekwfkcq0rs28egt38pg3wqzfx4zcrese4fnvzzupsk9gjkq"]
      }, {
        denom: "bitmos",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/7D389F0ABF1E4D45BE6D7BBE36A2C50EA0559C01E076B02F8E381E685EC1F942",
      name: "Bitmos",
      display: "bitmos",
      symbol: "BMOS",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra2",
          base_denom: "cw20:terra1sxe8u2hjczlekwfkcq0rs28egt38pg3wqzfx4zcrese4fnvzzupsk9gjkq",
          port: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
          channel_id: "channel-26"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-341",
          path: "transfer/channel-341/cw20:terra1sxe8u2hjczlekwfkcq0rs28egt38pg3wqzfx4zcrese4fnvzzupsk9gjkq"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bitmos.png"
      },
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "cw20:terra1sxe8u2hjczlekwfkcq0rs28egt38pg3wqzfx4zcrese4fnvzzupsk9gjkq"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bitmos.png",
        theme: {
          primary_color_hex: "#0c0704"
        }
      }]
    },
    {
      description: "The SRCX token of Source Protocol.",
      denom_units: [{
        denom: "ibc/C97473CD237EBA2F94FDFA6ABA5EC0E22FA140655D73D2A2754F03A347BBA40B",
        exponent: 0,
        aliases: ["nsrcx", "ibc/FC5A7360EEED0713AE3E83E9D55A69AF873056A172AC495890ACE4582FF9685A"]
      }, {
        denom: "srcx",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/C97473CD237EBA2F94FDFA6ABA5EC0E22FA140655D73D2A2754F03A347BBA40B",
      name: "Source Token",
      display: "srcx",
      symbol: "SRCX",
      traces: [
        {
          type: "bridge",
          counterparty: {
            chain_name: "binancesmartchain",
            base_denom: "0x454b90716a9435e7161a9aea5cf00e0acbe565ae",
            contract: "0xC891aBa0b42818fb4c975Bf6461033c62BCE75ff"
          },
          chain: {
            contract: "0xC891aBa0b42818fb4c975Bf6461033c62BCE75ff"
          },
          provider: "DeltaSwap.io"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "planq",
            base_denom: "erc20/0x091F9A57A3F58d758b6572E9d41675918EAC7F09",
            channel_id: "channel-61"
          },
          chain: {
            channel_id: "channel-1",
            path: "transfer/channel-1/erc20/0x091F9A57A3F58d758b6572E9d41675918EAC7F09"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "source",
            base_denom: "ibc/FC5A7360EEED0713AE3E83E9D55A69AF873056A172AC495890ACE4582FF9685A",
            channel_id: "channel-0"
          },
          chain: {
            channel_id: "channel-8945",
            path: "transfer/channel-8945/transfer/channel-1/erc20/0x091F9A57A3F58d758b6572E9d41675918EAC7F09"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/srcx.png"
      },
      images: [{
        image_sync: {
          chain_name: "binancesmartchain",
          base_denom: "0x454b90716a9435e7161a9aea5cf00e0acbe565ae"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/srcx.png",
        theme: {
          primary_color_hex: "#7f22bc"
        }
      }]
    },
    {
      description: "The revenue token for Pylons",
      denom_units: [{
        denom: "ibc/0835781EF3F3ADD053874323AB660C75B50B18B16733CAB783CA6BBD78244EDF",
        exponent: 0,
        aliases: ["ubedrock"]
      }, {
        denom: "rock",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0835781EF3F3ADD053874323AB660C75B50B18B16733CAB783CA6BBD78244EDF",
      name: "Pylons",
      display: "rock",
      symbol: "ROCK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "pylons",
          base_denom: "ubedrock",
          channel_id: "channel-29"
        },
        chain: {
          channel_id: "channel-17683",
          path: "transfer/channel-17683/ubedrock"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pylons/images/pylons.png"
      },
      images: [{
        image_sync: {
          chain_name: "pylons",
          base_denom: "ubedrock"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pylons/images/pylons.png",
        theme: {
          primary_color_hex: "#ec4424"
        }
      }]
    },
    {
      description: "BSKT tracks the top assets across the crypto ecosystem",
      denom_units: [{
        denom: "ibc/CDD1E59BD5034C1B2597DD199782204EB397DB93200AA2E99C0AF3A66B2915FA",
        exponent: 0,
        aliases: [
          "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA",
          "wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst",
          "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst"
        ]
      }, {
        denom: "wormhole/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst/5",
        exponent: 5,
        aliases: ["bskt"]
      }],
      type_asset: "ics20",
      base: "ibc/CDD1E59BD5034C1B2597DD199782204EB397DB93200AA2E99C0AF3A66B2915FA",
      name: "Basket",
      display: "wormhole/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst/5",
      symbol: "BSKT",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA"
        },
        provider: "Wormhole"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-2186",
          path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bskt.png"
      },
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "6gnCPhXtLnUD76HjQuSYPENLSZdG8RvDB1pTLM5aLSJA"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/bskt.png",
        theme: {
          primary_color_hex: "#485573"
        }
      }]
    },
    {
      description: "The native staking and governance token of the AIOZ Network.",
      denom_units: [
        {
          denom: "ibc/BB0AFE2AFBD6E883690DAE4B9168EAC2B306BCC9C9292DACBB4152BBB08DB25F",
          exponent: 0,
          aliases: ["attoaioz"]
        },
        {
          denom: "nanoaioz",
          exponent: 9
        },
        {
          denom: "aioz",
          exponent: 18
        }
      ],
      type_asset: "ics20",
      base: "ibc/BB0AFE2AFBD6E883690DAE4B9168EAC2B306BCC9C9292DACBB4152BBB08DB25F",
      name: "AIOZ Network",
      display: "aioz",
      symbol: "AIOZ",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "aioz",
          base_denom: "attoaioz",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-779",
          path: "transfer/channel-779/attoaioz"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.svg"
      },
      images: [{
        image_sync: {
          chain_name: "aioz",
          base_denom: "attoaioz"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aioz/images/aioz.svg",
        theme: {
          primary_color_hex: "#24241c"
        }
      }]
    },
    {
      description: "Stride's liquid staked DYM",
      denom_units: [{
        denom: "ibc/D53E785DC9C5C2CA50CADB1EFE4DE5D0C30418BE0E9C6F2AF9F092A247E8BC22",
        exponent: 0,
        aliases: ["stadym"]
      }, {
        denom: "stDYM",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/D53E785DC9C5C2CA50CADB1EFE4DE5D0C30418BE0E9C6F2AF9F092A247E8BC22",
      name: "Stride Staked DYM",
      display: "stDYM",
      symbol: "stDYM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "dymension",
          base_denom: "adym"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stadym",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stadym"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdym.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdym.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stadym"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdym.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdym.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "DOKI the last Dragon",
      denom_units: [{
        denom: "ibc/C12C353A83CD1005FC38943410B894DBEC5F2ABC97FC12908F0FB03B970E8E1B",
        exponent: 0,
        aliases: ["udoki"]
      }, {
        denom: "doki",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C12C353A83CD1005FC38943410B894DBEC5F2ABC97FC12908F0FB03B970E8E1B",
      name: "DOKI",
      display: "doki",
      symbol: "DOKI",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "odin",
          base_denom: "udoki",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-258",
          path: "transfer/channel-258/udoki"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/doki_Logo.png"
      },
      images: [{
        image_sync: {
          chain_name: "odin",
          base_denom: "udoki"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/odin/images/doki_Logo.png",
        theme: {
          primary_color_hex: "#2e2d2a"
        }
      }]
    },
    {
      description: "Sail DAO is a liquidity deployment and management DAO built as a collaboration between the Osmosis and Migaloo Blockchains.",
      extended_description: "Sail DAO is a liquidity deployment and management DAO built as a collaboration between the Osmosis and Migaloo Blockchains. Seeded by both the Osmosis Community Pool and the Migaloo Foundation, Sail DAO is open to hear offers from cosmos based projects that hope to seed liquidity for their token on the Osmosis blockchain. Along with the creation of this DAO the White Whale DEX is deployed on Osmosis, being the first DEX apart from Osmosis to deploy on the chain, it is a great step towards Osmosis becoming an ecosystem from an appchain. Migaloo incubated projects are encouraged to participate in OTC deals with Sail DAO in order to seed or enhance liquidity on WW's Osmosis DEX. However, offers are not limited to Migaloo projects and liquidity is not limited to being deployed on WW DEX. The treasury of this DAO can be deployed however it wishes at the discretion of the Sail DAO voters. The Osmosis CP has been given veto authorization over any props introduced in this DAO and has also been given clawback rights if this venture ever gets off track.",
      denom_units: [{
        denom: "factory/osmo1rckme96ptawr4zwexxj5g5gej9s2dmud8r2t9j0k0prn5mch5g4snzzwjv/sail",
        exponent: 0
      }, {
        denom: "sail",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1rckme96ptawr4zwexxj5g5gej9s2dmud8r2t9j0k0prn5mch5g4snzzwjv/sail",
      name: "Sail",
      display: "sail",
      symbol: "SAIL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sail.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sail.png",
        theme: {
          primary_color_hex: "#1e264f"
        }
      }],
      coingecko_id: "sail-dao",
      socials: {
        website: "https://daodao.zone/dao/osmo106tvcj58rvdn9k36m9m3xcmcwk2c3fgft3ldcst9lgy05gcmjanqexru3h/home",
        twitter: "https://twitter.com/Sail_DAO_"
      }
    },
    {
      description: "SHARK is the apex price prediction market within Cosmos.",
      denom_units: [{
        denom: "ibc/64D56DF9EC69BE554F49EBCE0199611062FF1137EF105E2F645C1997344F3834",
        exponent: 0,
        aliases: ["factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/shark"]
      }, {
        denom: "SHARK",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/64D56DF9EC69BE554F49EBCE0199611062FF1137EF105E2F645C1997344F3834",
      name: "SHARK",
      display: "SHARK",
      symbol: "SHARK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/shark",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-642",
          path: "transfer/channel-642/factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/shark"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/shark.png"
      },
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/shark"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/shark.png",
        theme: {
          primary_color_hex: "#062d54"
        }
      }]
    },
    {
      description: "XRP bridged from XRPL",
      denom_units: [{
        denom: "ibc/63A7CA0B6838AD8CAD6B5103998FF9B9B6A6F06FBB9638BFF51E63E0142339F3",
        exponent: 0,
        aliases: ["drop", "drop-core1zhs909jp9yktml6qqx9f0ptcq2xnhhj99cja03j3lfcsp2pgm86studdrz"]
      }, {
        denom: "xrp",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/63A7CA0B6838AD8CAD6B5103998FF9B9B6A6F06FBB9638BFF51E63E0142339F3",
      name: "Ripple (Coreum)",
      display: "xrp",
      symbol: "XRP.core",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "xrpl",
          base_denom: "drop"
        },
        provider: "Coreum"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "coreum",
          base_denom: "drop-core1zhs909jp9yktml6qqx9f0ptcq2xnhhj99cja03j3lfcsp2pgm86studdrz",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-2188",
          path: "transfer/channel-2188/drop-core1zhs909jp9yktml6qqx9f0ptcq2xnhhj99cja03j3lfcsp2pgm86studdrz"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/xrp.core.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/xrp.core.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }, {
        image_sync: {
          chain_name: "coreum",
          base_denom: "drop-core1zhs909jp9yktml6qqx9f0ptcq2xnhhj99cja03j3lfcsp2pgm86studdrz"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/xrpl/images/xrp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/xrpl/images/xrp.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The Original Meme Coin of SEI Network",
      denom_units: [{
        denom: "ibc/86074B8DF625A75C25D52FA6112E3FD5446BA41FE418880C168CA99D10E22F05",
        exponent: 0,
        aliases: ["cw20:sei1hrndqntlvtmx2kepr0zsfgr7nzjptcc72cr4ppk4yav58vvy7v3s4er8ed"]
      }, {
        denom: "SEIYAN",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/86074B8DF625A75C25D52FA6112E3FD5446BA41FE418880C168CA99D10E22F05",
      name: "SEIYAN",
      display: "SEIYAN",
      symbol: "SEIYAN",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "sei",
          base_denom: "cw20:sei1hrndqntlvtmx2kepr0zsfgr7nzjptcc72cr4ppk4yav58vvy7v3s4er8ed",
          port: "transfer",
          channel_id: "channel-0"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-782",
          path: "transfer/channel-782/cw20:sei1hrndqntlvtmx2kepr0zsfgr7nzjptcc72cr4ppk4yav58vvy7v3s4er8ed"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/SEIYAN.png"
      },
      images: [{
        image_sync: {
          chain_name: "sei",
          base_denom: "cw20:sei1hrndqntlvtmx2kepr0zsfgr7nzjptcc72cr4ppk4yav58vvy7v3s4er8ed"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/SEIYAN.png",
        theme: {
          primary_color_hex: "#db1f22"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "The native token of Nibiru network",
      denom_units: [{
        denom: "ibc/4017C65CEA338196ECCEC3FE3FE8258F23D1DE88F1D95750CC912C7A1C1016FF",
        exponent: 0,
        aliases: ["unibi"]
      }, {
        denom: "nibi",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4017C65CEA338196ECCEC3FE3FE8258F23D1DE88F1D95750CC912C7A1C1016FF",
      name: "Nibiru",
      display: "nibi",
      symbol: "NIBI",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nibiru",
          base_denom: "unibi",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-21113",
          path: "transfer/channel-21113/unibi"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg"
      },
      images: [{
        image_sync: {
          chain_name: "nibiru",
          base_denom: "unibi"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg",
        theme: {
          primary_color_hex: "#14c0ce"
        }
      }]
    },
    {
      description: "BEAST-ERC20 on injective",
      denom_units: [{
        denom: "ibc/B84F8CC583A54DA8173711C0B66B22FDC1954FEB1CA8DBC66C89919DAFE02000",
        exponent: 0,
        aliases: ["peggy0xA4426666addBE8c4985377d36683D17FB40c31Be"]
      }, {
        denom: "beast",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B84F8CC583A54DA8173711C0B66B22FDC1954FEB1CA8DBC66C89919DAFE02000",
      name: "Gelotto BEAST",
      display: "beast",
      symbol: "BEAST",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xA4426666addBE8c4985377d36683D17FB40c31Be"
        },
        provider: "Peggy"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "peggy0xA4426666addBE8c4985377d36683D17FB40c31Be",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-122",
          path: "transfer/channel-122/peggy0xA4426666addBE8c4985377d36683D17FB40c31Be"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/beast.png"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xA4426666addBE8c4985377d36683D17FB40c31Be"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/beast.png",
        theme: {
          primary_color_hex: "#21172b"
        }
      }]
    },
    {
      description: "Cvn is a Layer-1 blockchain built to deliver on the promise of DeFi",
      denom_units: [{
        denom: "ibc/044B7B28AFE93CEC769CF529ADC626DA09EA0EFA3E0E3284D540E9E00E01E24A",
        exponent: 0,
        aliases: ["acvnt"]
      }, {
        denom: "cvnt",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/044B7B28AFE93CEC769CF529ADC626DA09EA0EFA3E0E3284D540E9E00E01E24A",
      name: "ConsciousDAO",
      display: "cvnt",
      symbol: "CVN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "conscious",
          base_denom: "acvnt",
          channel_id: "channel-6"
        },
        chain: {
          channel_id: "channel-73971",
          path: "transfer/channel-73971/acvnt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.svg"
      },
      images: [{
        image_sync: {
          chain_name: "conscious",
          base_denom: "acvnt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/conscious/images/cvn.svg",
        theme: {
          primary_color_hex: "#047e04"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "The memecoin built for the Celestia community",
      denom_units: [{
        denom: "factory/osmo1nr8zfakf6jauye3uqa9lrmr5xumee5n42lv92z/toro",
        exponent: 0
      }, {
        denom: "toro",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1nr8zfakf6jauye3uqa9lrmr5xumee5n42lv92z",
      base: "factory/osmo1nr8zfakf6jauye3uqa9lrmr5xumee5n42lv92z/toro",
      name: "TORO",
      display: "toro",
      symbol: "TORO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/toro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/toro.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/toro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/toro.svg",
        theme: {
          primary_color_hex: "#c39ccc"
        }
      }]
    },
    {
      description: "Sayve is a revolutionary language learning app in the Web3 era that combines gamification, blockchain technology, and a Metaverse experience to motivate users to learn languages while earning rewards.",
      denom_units: [{
        denom: "ibc/06EF575844982382F4D1BC3830D294557A30EDB3CD223153AFC8DFEF06349C56",
        exponent: 0,
        aliases: ["cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3"]
      }, {
        denom: "sayve",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/06EF575844982382F4D1BC3830D294557A30EDB3CD223153AFC8DFEF06349C56",
      name: "sayve",
      display: "sayve",
      symbol: "SAYVE",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra2",
          base_denom: "cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3",
          port: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au",
          channel_id: "channel-26"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-341",
          path: "transfer/channel-341/cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.svg"
      },
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.svg",
        theme: {
          primary_color_hex: "#f3ebdb"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "LAB - Everything is an Experiment",
      extended_description: `LAB - Everything is an Experiment

Use 10 $LAB tokens to mint 1 Mad Scientist NFT on Backbone Labs Osmosis Launchpad. You will then be able to trade your NFTs on the marketplace. You can also choose to hold onto your $LAB tokens as unrevealed NFTs and trade it.

 Fair Launch: The event was marked by the absence of whitelists (WLs), no bots and no lock, ensuring an equitable opportunity for all interested parties.

Preparation for the Launch: Participants were given a 52.91-hour window to deposit $OSMO into a pool on Streamswap.

The Swap Process: After the initial deposit period, $OSMO was converted into $LAB tokens over an additional hour, allowing for a smooth transition and fair distribution.`,
      denom_units: [{
        denom: "factory/osmo17fel472lgzs87ekt9dvk0zqyh5gl80sqp4sk4n/LAB",
        exponent: 0
      }, {
        denom: "LAB",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo17fel472lgzs87ekt9dvk0zqyh5gl80sqp4sk4n",
      base: "factory/osmo17fel472lgzs87ekt9dvk0zqyh5gl80sqp4sk4n/LAB",
      name: "LAB",
      display: "LAB",
      symbol: "LAB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/LAB.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/LAB.png",
        theme: {
          primary_color_hex: "#bcdd76"
        }
      }],
      coingecko_id: "mad-scientists"
    },
    {
      description: "BackBone Labs Liquid Staked OSMO",
      extended_description: "bOSMO - solving capital inefficiencies in the NFT market space",
      denom_units: [{
        denom: "factory/osmo1s3l0lcqc7tu0vpj6wdjz9wqpxv8nk6eraevje4fuwkyjnwuy82qsx3lduv/boneOsmo",
        exponent: 0
      }, {
        denom: "bOSMO",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1s3l0lcqc7tu0vpj6wdjz9wqpxv8nk6eraevje4fuwkyjnwuy82qsx3lduv",
      base: "factory/osmo1s3l0lcqc7tu0vpj6wdjz9wqpxv8nk6eraevje4fuwkyjnwuy82qsx3lduv/boneOsmo",
      name: "BackBone Labs Liquid Staked OSMO",
      display: "bOSMO",
      symbol: "bOSMO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/bOSMO.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/bOSMO.png",
        theme: {
          primary_color_hex: "#c68db5"
        }
      }],
      socials: {
        website: "https://app.backbonelabs.io/",
        twitter: "https://twitter.com/BackBone_Labs"
      }
    },
    {
      description: "PUNDIX token is the native token that functions within the Pundi X ecosystem, including PundiX Chain and XPOS.",
      denom_units: [{
        denom: "ibc/46D8D1A6E2A80ECCB7CA6663086A2E749C508B68DA56A077CD26E6F4F9691EEE",
        exponent: 0,
        aliases: ["eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"]
      }, {
        denom: "PUNDIX",
        exponent: 18,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/46D8D1A6E2A80ECCB7CA6663086A2E749C508B68DA56A077CD26E6F4F9691EEE",
      name: "Pundi X Token",
      display: "PUNDIX",
      symbol: "PUNDIX",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
          contract: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"
        },
        provider: "Function X"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "fxcore",
          base_denom: "eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
          channel_id: "channel-19"
        },
        chain: {
          channel_id: "channel-2716",
          path: "transfer/channel-2716/eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-token-logo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-token-logo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-token-logo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-token-logo.svg",
        theme: {
          primary_color_hex: "#f1d20c"
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pundix.png",
        theme: {
          primary_color_hex: "#f1d20c"
        }
      }]
    },
    {
      description: "The native fee, governance and staking token of the Tinkernet Parachain.",
      denom_units: [{
        denom: "ibc/3A0A392E610A8D477851ABFEA74F3D828F36C015AB8E93B0FBB7566A6D13C4D6",
        exponent: 0,
        aliases: ["2125", "ibc/C58E5D2571042137CB68B1B9851C4E7211C05F7C2C79E21E0966AF0F063961F8"]
      }, {
        denom: "tnkr",
        exponent: 12
      }],
      type_asset: "ics20",
      base: "ibc/3A0A392E610A8D477851ABFEA74F3D828F36C015AB8E93B0FBB7566A6D13C4D6",
      name: "Tinkernet",
      display: "tnkr",
      symbol: "TNKR",
      traces: [
        {
          type: "bridge",
          counterparty: {
            chain_name: "tinkernet",
            base_denom: "Planck"
          },
          provider: "Tinkernet Parachain"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "picasso",
            base_denom: "2125",
            channel_id: "channel-17"
          },
          chain: {
            channel_id: "channel-2",
            path: "transfer/channel-2/2125"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/C58E5D2571042137CB68B1B9851C4E7211C05F7C2C79E21E0966AF0F063961F8",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-2/2125"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tinkernet/images/tnkr.svg"
      },
      images: [{
        image_sync: {
          chain_name: "tinkernet",
          base_denom: "Planck"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tinkernet/images/tnkr.svg"
      }]
    },
    {
      description: "W is the native token powering the Wormhole interoperability platform.",
      denom_units: [{
        denom: "ibc/AC6EE43E608B5A7EEE460C960480BC1C3708010E32B2071C429DA259836E10C3",
        exponent: 0,
        aliases: ["factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/2Wb6ueMFc9WLc2eyYVha6qnwHKbwzUXdooXsg6XXVvos"]
      }, {
        denom: "w",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/AC6EE43E608B5A7EEE460C960480BC1C3708010E32B2071C429DA259836E10C3",
      name: "Wormhole Token",
      display: "w",
      symbol: "W",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ"
        },
        provider: "Wormhole"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/2Wb6ueMFc9WLc2eyYVha6qnwHKbwzUXdooXsg6XXVvos",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-2186",
          path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/2Wb6ueMFc9WLc2eyYVha6qnwHKbwzUXdooXsg6XXVvos"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/w.png"
      },
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/w.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The native token of dHealth",
      denom_units: [{
        denom: "ibc/FD506CCA1FC574F2A8175FB574C981E9F6351E194AA48AC219BD67FF934E2F33",
        exponent: 0,
        aliases: ["udhp"]
      }, {
        denom: "dhp",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/FD506CCA1FC574F2A8175FB574C981E9F6351E194AA48AC219BD67FF934E2F33",
      name: "dHealth",
      display: "dhp",
      symbol: "DHP",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "dhealth",
          base_denom: "udhp",
          channel_id: "channel-4"
        },
        chain: {
          channel_id: "channel-75030",
          path: "transfer/channel-75030/udhp"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.svg"
      },
      images: [{
        image_sync: {
          chain_name: "dhealth",
          base_denom: "udhp"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.svg",
        theme: {
          primary_color_hex: "#140c7c"
        }
      }]
    },
    {
      description: "The native token of Furya",
      denom_units: [{
        denom: "ibc/E4C60B9F95BF54CC085A5E39F6057ABD4DF92793D330EB884A36530F7E6804DE",
        exponent: 0,
        aliases: ["ufury"]
      }, {
        denom: "fury",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E4C60B9F95BF54CC085A5E39F6057ABD4DF92793D330EB884A36530F7E6804DE",
      name: "furya",
      display: "fury",
      symbol: "FURY",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "furya",
          base_denom: "ufury",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-74222",
          path: "transfer/channel-74222/ufury"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.svg"
      },
      images: [{
        image_sync: {
          chain_name: "furya",
          base_denom: "ufury"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      keywords: ["gaming", "staking"]
    },
    {
      description: "The native staking and governance token of Saga.",
      denom_units: [{
        denom: "ibc/094FB70C3006906F67F5D674073D2DAFAFB41537E7033098F5C752F211E7B6C2",
        exponent: 0,
        aliases: ["usaga"]
      }, {
        denom: "saga",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/094FB70C3006906F67F5D674073D2DAFAFB41537E7033098F5C752F211E7B6C2",
      name: "Saga",
      display: "saga",
      symbol: "SAGA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "saga",
          base_denom: "usaga",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-38946",
          path: "transfer/channel-38946/usaga"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga_white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga_white.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga_white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga_white.svg",
        theme: {
          primary_color_hex: "#FFFFFF",
          dark_mode: !0
        }
      }, {
        image_sync: {
          chain_name: "saga",
          base_denom: "usaga"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.svg",
        theme: {
          primary_color_hex: "#000000",
          dark_mode: !1
        }
      }]
    },
    {
      description: "$ATOM to $1,000 LFG!!",
      denom_units: [{
        denom: "ibc/0E77E090EC04C476DE2BC0A7056580AC47660DAEB7B0D4701C085E3A046AC7B7",
        exponent: 0,
        aliases: ["uatom1klfg", "factory/neutron13lkh47msw28yynspc5rnmty3yktk43wc3dsv0l/ATOM1KLFG"]
      }, {
        denom: "ATOM1KLFG",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0E77E090EC04C476DE2BC0A7056580AC47660DAEB7B0D4701C085E3A046AC7B7",
      name: "ATOM1KLFG",
      display: "ATOM1KLFG",
      symbol: "ATOM1KLFG",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron13lkh47msw28yynspc5rnmty3yktk43wc3dsv0l/ATOM1KLFG",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-874",
          path: "transfer/channel-874/factory/neutron13lkh47msw28yynspc5rnmty3yktk43wc3dsv0l/ATOM1KLFG"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ATOM1KLFGc.png"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron13lkh47msw28yynspc5rnmty3yktk43wc3dsv0l/ATOM1KLFG"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/ATOM1KLFGc.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The native EVM and Wasm, governance and staking token of the Shido Chain",
      denom_units: [{
        denom: "ibc/62B50BB1DAEAD2A92D6C6ACAC118F4ED8CBE54265DCF5688E8D0A0A978AA46E7",
        exponent: 0,
        aliases: ["shido"]
      }, {
        denom: "SHIDO",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/62B50BB1DAEAD2A92D6C6ACAC118F4ED8CBE54265DCF5688E8D0A0A978AA46E7",
      name: "Shido",
      display: "SHIDO",
      symbol: "SHIDO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "shido",
          base_denom: "shido",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-73755",
          path: "transfer/channel-73755/shido"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.svg"
      },
      images: [{
        image_sync: {
          chain_name: "shido",
          base_denom: "shido"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.svg",
        theme: {
          primary_color_hex: "#046ffc"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "Decentralized Machine Learning",
      denom_units: [{
        denom: "ibc/EFC1776BEFB7842F2DC7BABD9A3050E188145C99007ECC5F3526FED45A68D5F5",
        exponent: 0,
        aliases: ["ucif"]
      }, {
        denom: "cif",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/EFC1776BEFB7842F2DC7BABD9A3050E188145C99007ECC5F3526FED45A68D5F5",
      name: "Cifer",
      display: "cif",
      symbol: "CIF",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cifer",
          base_denom: "ucif",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-39205",
          path: "transfer/channel-39205/ucif"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cifer",
          base_denom: "ucif"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cifer/images/cif.svg",
        theme: {
          primary_color_hex: "#af49b7"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "Hava Coin is the lifeblood of the Cosmos & Injective networks, rewarding builders and welcoming supporters. https://havacoin.xyz/",
      denom_units: [{
        denom: "ibc/884EBC228DFCE8F1304D917A712AA9611427A6C1ECC3179B2E91D7468FB091A2",
        exponent: 0,
        aliases: ["factory/inj1h0ypsdtjfcjynqu3m75z2zwwz5mmrj8rtk2g52/uhava"]
      }, {
        denom: "hava",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/884EBC228DFCE8F1304D917A712AA9611427A6C1ECC3179B2E91D7468FB091A2",
      name: "Hava Coin",
      display: "hava",
      symbol: "HAVA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "factory/inj1h0ypsdtjfcjynqu3m75z2zwwz5mmrj8rtk2g52/uhava",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-122",
          path: "transfer/channel-122/factory/inj1h0ypsdtjfcjynqu3m75z2zwwz5mmrj8rtk2g52/uhava"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/hava.png"
      },
      images: [{
        image_sync: {
          chain_name: "injective",
          base_denom: "factory/inj1h0ypsdtjfcjynqu3m75z2zwwz5mmrj8rtk2g52/uhava"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/hava.png",
        theme: {
          primary_color_hex: "#eacea5"
        }
      }]
    },
    {
      description: "OnE mEmEcOiN tO cOnNeCt oL ImBeCiles - aNd in Da Cosmos BiNd DeM",
      denom_units: [{
        denom: "factory/osmo1kqdw6pvn0xww6tyfv2sqvkkencdz0qw406x54r/IBC",
        exponent: 0
      }, {
        denom: "IBC",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1kqdw6pvn0xww6tyfv2sqvkkencdz0qw406x54r/IBC",
      name: "IBC",
      display: "IBC",
      symbol: "IBC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ibc.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ibc.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      keywords: ["memecoin", "osmosis_unlisted"],
      socials: {
        website: "https://www.ibcmeme.wtf",
        twitter: "https://twitter.com/IBCmemecoin"
      }
    },
    {
      description: "The token of Crowdpunk DAO",
      denom_units: [{
        denom: "ibc/B87F0F5255CC658408F167C2F7B987A8D914622E1F73BCC267406360588F2B1E",
        exponent: 0,
        aliases: ["erc20/0xfbf4318d24a93753f11d365a6dcf8b830e98ab0f"]
      }, {
        denom: "crowdp",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/B87F0F5255CC658408F167C2F7B987A8D914622E1F73BCC267406360588F2B1E",
      name: "Crowdpunk DAO",
      display: "crowdp",
      symbol: "CROWDP",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "evmos",
          base_denom: "erc20/0xfbf4318d24a93753f11d365a6dcf8b830e98ab0f",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-204",
          path: "transfer/channel-204/erc20/0xfbf4318d24a93753f11d365a6dcf8b830e98ab0f"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.svg"
      },
      images: [{
        image_sync: {
          chain_name: "evmos",
          base_denom: "erc20/0xfbf4318d24a93753f11d365a6dcf8b830e98ab0f"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.svg",
        theme: {
          primary_color_hex: "#04fbfb"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.",
      denom_units: [{
        denom: "ibc/B8C608CEE08C4F30A15A7955306F2EDAF4A02BB191CABC4185C1A57FD978DA1B",
        exponent: 0,
        aliases: ["uastro"]
      }, {
        denom: "astro",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B8C608CEE08C4F30A15A7955306F2EDAF4A02BB191CABC4185C1A57FD978DA1B",
      name: "Astroport token",
      display: "astro",
      symbol: "ASTRO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-874",
          path: "transfer/channel-874/factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg",
        theme: {
          primary_color_hex: "#4056e9"
        }
      }]
    },
    {
      description: "Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.",
      denom_units: [{
        denom: "ibc/2ED09B03AA396BC2F35B741F4CA4A82D33A24A1007BFC1973299842DD626F564",
        exponent: 0,
        aliases: ["uxastro", "factory/neutron1zlf3hutsa4qnmue53lz2tfxrutp8y2e3rj4nkghg3rupgl4mqy8s5jgxsn/xASTRO"]
      }, {
        denom: "xASTRO",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2ED09B03AA396BC2F35B741F4CA4A82D33A24A1007BFC1973299842DD626F564",
      name: "Staked Astroport Token",
      display: "xASTRO",
      symbol: "xASTRO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        provider: "Astroport"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1zlf3hutsa4qnmue53lz2tfxrutp8y2e3rj4nkghg3rupgl4mqy8s5jgxsn/xASTRO",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-874",
          path: "transfer/channel-874/factory/neutron1zlf3hutsa4qnmue53lz2tfxrutp8y2e3rj4nkghg3rupgl4mqy8s5jgxsn/xASTRO"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/xAstro.svg"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1zlf3hutsa4qnmue53lz2tfxrutp8y2e3rj4nkghg3rupgl4mqy8s5jgxsn/xASTRO"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/xAstro.svg"
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "Gravity Bridge Paxos Gold",
      denom_units: [{
        denom: "ibc/A5CCD24BA902843B1003A7EEE5F937C632808B9CF4925601241B15C5A0A51A53",
        exponent: 0,
        aliases: ["gravity0x45804880De22913dAFE09f4980848ECE6EcbAf78"]
      }, {
        denom: "gpaxg",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/A5CCD24BA902843B1003A7EEE5F937C632808B9CF4925601241B15C5A0A51A53",
      name: "Paxos Gold (Gravity Bridge)",
      display: "gpaxg",
      symbol: "PAXG.grv",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "comex",
            base_denom: "XAU"
          },
          provider: "Paxos"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x45804880De22913dAFE09f4980848ECE6EcbAf78"
          },
          provider: "Gravity Bridge"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gravitybridge",
            base_denom: "gravity0x45804880De22913dAFE09f4980848ECE6EcbAf78",
            channel_id: "channel-10"
          },
          chain: {
            channel_id: "channel-144",
            path: "transfer/channel-144/gravity0x45804880De22913dAFE09f4980848ECE6EcbAf78"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/paxg.grv.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/paxg.grv.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/paxg.grv.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/paxg.grv.svg",
        theme: {
          primary_color_hex: "#ddc81a"
        }
      }, {
        image_sync: {
          chain_name: "gravitybridge",
          base_denom: "gravity0x45804880De22913dAFE09f4980848ECE6EcbAf78"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/paxg.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/paxg.svg",
        theme: {
          primary_color_hex: "#ebe60e"
        }
      }]
    },
    {
      description: "Restake DAO Token",
      denom_units: [{
        denom: "ibc/04FAC73DFF7F1DD59395948F2F043B0BBF978AD4533EE37E811340F501A08FFB",
        exponent: 0,
        aliases: ["factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"]
      }, {
        denom: "rstk",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/04FAC73DFF7F1DD59395948F2F043B0BBF978AD4533EE37E811340F501A08FFB",
      name: "RESTAKE",
      display: "rstk",
      symbol: "RSTK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-642",
          path: "transfer/channel-642/factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.svg"
      },
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.svg",
        theme: {
          primary_color_hex: "#3ccc64"
        }
      }]
    },
    {
      description: "Bernese Mountain Dog. Thematic dog token to have fun and be friends with all other dog tokens. Fixed supply 132M",
      denom_units: [{
        denom: "factory/osmo1s6ht8qrm8x0eg8xag5x3ckx9mse9g4se248yss/BERNESE",
        exponent: 0
      }, {
        denom: "BERNESE",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1s6ht8qrm8x0eg8xag5x3ckx9mse9g4se248yss",
      base: "factory/osmo1s6ht8qrm8x0eg8xag5x3ckx9mse9g4se248yss/BERNESE",
      name: "BERNESE",
      display: "BERNESE",
      symbol: "BERNESE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/bernese.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/bernese.png",
        theme: {
          primary_color_hex: "#e7754f"
        }
      }]
    },
    {
      description: "The native token of Ethereum, bridged via IBC.",
      denom_units: [{
        denom: "ibc/A23E590BA7E0D808706FB5085A449B3B9D6864AE4DDE7DAF936243CEBB2A3D43",
        exponent: 0,
        aliases: ["wei", "ibc/F9D075D4079FC56A9C49B601E54A45292C319D8B0E8CC0F8439041130AA7166C"]
      }, {
        denom: "eth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/A23E590BA7E0D808706FB5085A449B3B9D6864AE4DDE7DAF936243CEBB2A3D43",
      name: "Ethereum (Picasso)",
      display: "eth",
      symbol: "ETH.pica",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/wei"
        }
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "composable",
          base_denom: "ibc/F9D075D4079FC56A9C49B601E54A45292C319D8B0E8CC0F8439041130AA7166C",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-1279",
          path: "transfer/channel-1279/transfer/channel-52/wei"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.pica.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.pica.svg"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/F9D075D4079FC56A9C49B601E54A45292C319D8B0E8CC0F8439041130AA7166C"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        theme: {
          primary_color_hex: "#303030"
        }
      }]
    },
    {
      description: "A stablecoin issued by Maker Protocol.",
      denom_units: [{
        denom: "ibc/37DFAFDA529FF7D513B0DB23E9728DF9BF73122D38D46824C78BB7F91E6A736B",
        exponent: 0,
        aliases: ["dai-wei", "ibc/A342F6F8D1CDE1D934C50E8EAFF91E813D971E1BFEED7E557F1674E01004A533"]
      }, {
        denom: "dai",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/37DFAFDA529FF7D513B0DB23E9728DF9BF73122D38D46824C78BB7F91E6A736B",
      name: "Dai Stablecoin (Picasso)",
      display: "dai",
      symbol: "DAI.pica",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "MakerDAO"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x6b175474e89094c44da98b954eedeac495271d0f",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0x6b175474e89094c44da98b954eedeac495271d0f"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/A342F6F8D1CDE1D934C50E8EAFF91E813D971E1BFEED7E557F1674E01004A533",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0x6b175474e89094c44da98b954eedeac495271d0f"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/dai.pica.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/dai.pica.svg"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/A342F6F8D1CDE1D934C50E8EAFF91E813D971E1BFEED7E557F1674E01004A533"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/dai.svg"
      }]
    },
    {
      description: "The governance token of the Frax ecosystem.",
      denom_units: [{
        denom: "ibc/5435437A8C9416B650DDA49C338B63CCFC6465123B715F6BAA9B1B2071E27913",
        exponent: 0,
        aliases: ["fxs-wei", "ibc/5F9BE030FC355733EC79307409FA98398BBFC747C9430B326C144A74F6808B29"]
      }, {
        denom: "fxs",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/5435437A8C9416B650DDA49C338B63CCFC6465123B715F6BAA9B1B2071E27913",
      name: "Frax Share (Picasso)",
      display: "fxs",
      symbol: "FXS.pica",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0"
        }
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "composable",
          base_denom: "ibc/5F9BE030FC355733EC79307409FA98398BBFC747C9430B326C144A74F6808B29",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-1279",
          path: "transfer/channel-1279/transfer/channel-52/0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fxs.pica.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fxs.pica.svg"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/5F9BE030FC355733EC79307409FA98398BBFC747C9430B326C144A74F6808B29"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/fxs.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/fxs.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The first fractional-algorithmic stablecoin by Frax Finance.",
      denom_units: [{
        denom: "ibc/9A8CBC029002DC5170E715F93FBF35011FFC9796371F59B1F3C3094AE1B453A9",
        exponent: 0,
        aliases: ["frax-wei", "ibc/4F20D68B51ED559F99C3CD658383E91F45486D884BF546E7B25337A058562CDB"]
      }, {
        denom: "frax",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/9A8CBC029002DC5170E715F93FBF35011FFC9796371F59B1F3C3094AE1B453A9",
      name: "Frax (Picasso)",
      display: "frax",
      symbol: "FRAX.pica",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Frax Protocol"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x853d955acef822db058eb8505911ed77f175b99e",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0x853d955acef822db058eb8505911ed77f175b99e"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/4F20D68B51ED559F99C3CD658383E91F45486D884BF546E7B25337A058562CDB",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0x853d955acef822db058eb8505911ed77f175b99e"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/frax.pica.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/frax.pica.svg"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/4F20D68B51ED559F99C3CD658383E91F45486D884BF546E7B25337A058562CDB"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frax.svg"
      }]
    },
    {
      description: "A stablecoin issued by Tether that is pegged 1:1 to the USD.",
      denom_units: [{
        denom: "ibc/078AD6F581E8115CDFBD8FFA29D8C71AFE250CE952AFF80040CBC64868D44AD3",
        exponent: 0,
        aliases: ["uusdt", "ibc/37CC704EA53E96AB09A9C31D79142DE7DB252420F3AB18015F9870AE219947BD"]
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/078AD6F581E8115CDFBD8FFA29D8C71AFE250CE952AFF80040CBC64868D44AD3",
      name: "Tether USD (Ethereum) (Picasso)",
      display: "usdt",
      symbol: "USDT.eth.pica",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Tether"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0xdac17f958d2ee523a2206206994597c13d831ec7"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/37CC704EA53E96AB09A9C31D79142DE7DB252420F3AB18015F9870AE219947BD",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0xdac17f958d2ee523a2206206994597c13d831ec7"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.pica.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.pica.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.pica.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.pica.png",
        theme: {
          primary_color_hex: "#049494"
        }
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/37CC704EA53E96AB09A9C31D79142DE7DB252420F3AB18015F9870AE219947BD"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }]
    },
    {
      description: "An ERC4626 staking vault that distributes part of the Frax Protocol yield weekly to stakers denominated in FRAX stablecoins. ",
      denom_units: [{
        denom: "ibc/0EFA07F312E05258A56AE1DD600E39B9151CF7A91C8A94EEBCF4F03ECFE5DD98",
        exponent: 0,
        aliases: ["sfrax-wei", "ibc/5BD7F23FE150D9CF3BCC944DB829380BCC51A4022A131151C4D13B3AFAC2D1D9"]
      }, {
        denom: "sfrax",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/0EFA07F312E05258A56AE1DD600E39B9151CF7A91C8A94EEBCF4F03ECFE5DD98",
      name: "Staked FRAX (Picasso)",
      display: "sfrax",
      symbol: "sFRAX.pica",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Frax Protocol"
        },
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x853d955acef822db058eb8505911ed77f175b99e"
          },
          provider: "Frax"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/5BD7F23FE150D9CF3BCC944DB829380BCC51A4022A131151C4D13B3AFAC2D1D9",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sfrax.pica.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sfrax.pica.svg"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/5BD7F23FE150D9CF3BCC944DB829380BCC51A4022A131151C4D13B3AFAC2D1D9"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrax.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrax.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "A liquid ETH staking derivative designed to leverage the Frax ecosystem.",
      denom_units: [{
        denom: "ibc/688E70EF567E5D4BA1CF4C54BAD758C288BC1A6C8B0B12979F911A2AE95E27EC",
        exponent: 0,
        aliases: ["frxeth-wei", "ibc/458032E654E41DB91EF98F13E2CE4F9E0FE86BA3E0CDBEC074A854E9F5229A90"]
      }, {
        denom: "frxeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/688E70EF567E5D4BA1CF4C54BAD758C288BC1A6C8B0B12979F911A2AE95E27EC",
      name: "Frax Ether (Picasso)",
      display: "frxeth",
      symbol: "frxETH.pica",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Frax"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x5e8422345238f34275888049021821e8e08caa1f",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0x5e8422345238f34275888049021821e8e08caa1f"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/458032E654E41DB91EF98F13E2CE4F9E0FE86BA3E0CDBEC074A854E9F5229A90",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0x5e8422345238f34275888049021821e8e08caa1f"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/frxeth.pica.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/frxeth.pica.svg"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/458032E654E41DB91EF98F13E2CE4F9E0FE86BA3E0CDBEC074A854E9F5229A90"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frxeth.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/frxeth.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "A Liquid Staking Derivative designed to accrue the staking yield of the Frax ETH validators.",
      denom_units: [{
        denom: "ibc/F17CCB4F07948CC2D8B72952C2D0A84F2B763962F698774BB121B872AE4611B5",
        exponent: 0,
        aliases: ["sfrxeth-wei", "ibc/4E0ECE7819D77B0F2B49F5C34B5E594A02D2BA8B1B0F103208F847B53EBFB69A"]
      }, {
        denom: "sfrxeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/F17CCB4F07948CC2D8B72952C2D0A84F2B763962F698774BB121B872AE4611B5",
      name: "Staked Frax Ether (Picasso)",
      display: "sfrxeth",
      symbol: "sfrxETH.pica",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Frax"
        },
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x5e8422345238f34275888049021821e8e08caa1f"
          },
          provider: "Frax"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xac3e018457b222d93114458476f3e3416abbe38f",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0xac3e018457b222d93114458476f3e3416abbe38f"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/4E0ECE7819D77B0F2B49F5C34B5E594A02D2BA8B1B0F103208F847B53EBFB69A",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0xac3e018457b222d93114458476f3e3416abbe38f"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sfrxeth.pica.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/sfrxeth.pica.svg"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/4E0ECE7819D77B0F2B49F5C34B5E594A02D2BA8B1B0F103208F847B53EBFB69A"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/sfrxeth.svg"
      }]
    },
    {
      description: "Adam Clay a BitSong Music FanToken",
      denom_units: [{
        denom: "ibc/7ABF696369EFB3387DF22B6A24204459FE5EFD010220E8E5618DC49DB877047B",
        exponent: 0,
        aliases: ["ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09"]
      }, {
        denom: "clay",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/7ABF696369EFB3387DF22B6A24204459FE5EFD010220E8E5618DC49DB877047B",
      name: "Adam Clay FanToken",
      display: "clay",
      symbol: "CLAY",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bitsong",
          base_denom: "ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-73",
          path: "transfer/channel-73/ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09.png"
      },
      images: [{
        image_sync: {
          chain_name: "bitsong",
          base_denom: "ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09.png",
        theme: {
          primary_color_hex: "#e8e5e7"
        }
      }]
    },
    {
      description: "404Deep Records a BitSong Music FanToken",
      denom_units: [{
        denom: "ibc/B797E4F42CD33C50511B341E50C5CC0E8EF0D93B1E1247ABAA071583B8619202",
        exponent: 0,
        aliases: ["ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A"]
      }, {
        denom: "404dr",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B797E4F42CD33C50511B341E50C5CC0E8EF0D93B1E1247ABAA071583B8619202",
      name: "404Deep Records Fantoken",
      display: "404dr",
      symbol: "404DR",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bitsong",
          base_denom: "ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-73",
          path: "transfer/channel-73/ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A.png"
      },
      images: [{
        image_sync: {
          chain_name: "bitsong",
          base_denom: "ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A.png",
        theme: {
          primary_color_hex: "#cfb1b3"
        }
      }]
    },
    {
      description: "wLibra is a bridged version of Libra Coin from 0L Network via LibraBridge.",
      extended_description: `Libra Coin is a fork from Facebook's Diem (Libra) blockchain that was announced in 2019. Libra Coin operates on its own high-performance Layer 1 blockchain, known as the 0L Network. In October 2021, Libra Coin began mining.

 Like Bitcoin, there were no pre-mined coins or dedicated token allocation to any parties; all coins were minted through a mining process. Unlike Bitcoin, which undergoes continuous issuance, Libra Coin has a fixed supply. By December 2023, all the Libra Coin had been issued, establishing a capped supply and making the coin permanently deflationary.

 Fiercely independent, the project has a long-term view because it is unburdened by venture capital funding, labs entities, a foundation, and the influence of other blockchain ecosystems. Carpe diem.`,
      denom_units: [{
        denom: "factory/osmo19hdqma2mj0vnmgcxag6ytswjnr8a3y07q7e70p/wLIBRA",
        exponent: 0
      }, {
        denom: "wLIBRA",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo19hdqma2mj0vnmgcxag6ytswjnr8a3y07q7e70p",
      base: "factory/osmo19hdqma2mj0vnmgcxag6ytswjnr8a3y07q7e70p/wLIBRA",
      name: "Wrapped Libra Coin (LibraBridge)",
      display: "wLIBRA",
      symbol: "wLIBRA",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "0l",
          base_denom: "microlibra"
        },
        provider: "LibraBridge"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/0l/images/libra.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/0l/images/libra.svg"
      },
      images: [{
        image_sync: {
          chain_name: "0l",
          base_denom: "microlibra"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/0l/images/libra.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/0l/images/libra.png",
        theme: {
          primary_color_hex: "#e45c5c"
        }
      }],
      socials: {
        website: "https://0l.network/",
        twitter: "https://twitter.com/0LNetwork"
      }
    },
    {
      description: "The native token of Nim Network.",
      extended_description: "Nim Network is a highly-adoptable AI Gaming chain that will provide the ultimate ecosystem for exploration and development of games at the intersection of Web3 and AI.",
      denom_units: [{
        denom: "ibc/279D69A6EF8E37456C8D2DC7A7C1C50F7A566EC4758F6DE17472A9FDE36C4426",
        exponent: 0,
        aliases: ["anim", "ibc/FB53D1684F155CBB86D9CE917807E42B59209EBE3AD3A92E15EF66586C073942"]
      }, {
        denom: "nim",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/279D69A6EF8E37456C8D2DC7A7C1C50F7A566EC4758F6DE17472A9FDE36C4426",
      name: "Nim Network",
      display: "nim",
      symbol: "NIM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nim",
          base_denom: "anim",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-49",
          path: "transfer/channel-49/anim"
        }
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "dymension",
          base_denom: "ibc/FB53D1684F155CBB86D9CE917807E42B59209EBE3AD3A92E15EF66586C073942",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-19774",
          path: "transfer/channel-19774/transfer/channel-49/anim"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.svg"
      },
      images: [{
        image_sync: {
          chain_name: "nim",
          base_denom: "anim"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nim/images/nim.svg",
        theme: {
          primary_color_hex: "#519cea"
        }
      }],
      keywords: [
        "gaming",
        "AI",
        "osmosis_unstable"
      ],
      socials: {
        website: "https://ai.nim.network/",
        twitter: "https://twitter.com/nim_network"
      }
    },
    {
      description: "The native token of SEDA Chain.",
      denom_units: [{
        denom: "ibc/956AEF1DA92F70584266E87978C3F30A43B91EE6ABC62F03D097E79F6B99C4D8",
        exponent: 0,
        aliases: ["aseda"]
      }, {
        denom: "seda",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/956AEF1DA92F70584266E87978C3F30A43B91EE6ABC62F03D097E79F6B99C4D8",
      name: "SEDA",
      display: "seda",
      symbol: "SEDA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "seda",
          base_denom: "aseda",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-75016",
          path: "transfer/channel-75016/aseda"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.svg"
      },
      images: [{
        image_sync: {
          chain_name: "seda",
          base_denom: "aseda"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.svg",
        theme: {
          primary_color_hex: "#8178d1"
        }
      }]
    },
    {
      description: "Cosmos Airdrop Chat",
      extended_description: "Official Token of the Cosmos Airdrop community",
      denom_units: [{
        denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/cac",
        exponent: 0
      }, {
        denom: "CAC",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8",
      base: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/cac",
      name: "Cosmos Airdrop Chat",
      display: "CAC",
      symbol: "CAC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CAC.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CAC.png",
        theme: {
          primary_color_hex: "#160542"
        }
      }]
    },
    {
      description: "WEIRD token for WEIRD friends collection",
      denom_units: [{
        denom: "ibc/38ADC6FFDDDB7D70B72AD0322CEA8844CB18FAA0A23400DBA8A99D43E18B3748",
        exponent: 0,
        aliases: ["uWEIRD"]
      }, {
        denom: "WEIRD",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/38ADC6FFDDDB7D70B72AD0322CEA8844CB18FAA0A23400DBA8A99D43E18B3748",
      name: "WEIRD",
      display: "WEIRD",
      symbol: "WEIRD",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron133xakkrfksq39wxy575unve2nyehg5npx75nph/WEIRD",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-874",
          path: "transfer/channel-874/factory/neutron133xakkrfksq39wxy575unve2nyehg5npx75nph/WEIRD"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/WEIRD.png"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron133xakkrfksq39wxy575unve2nyehg5npx75nph/WEIRD"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/WEIRD.png",
        theme: {
          primary_color_hex: "#ebf0f4"
        }
      }]
    },
    {
      description: "Uhm, Power Bottom",
      denom_units: [{
        denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/pbb",
        exponent: 0
      }, {
        denom: "PBB",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8",
      base: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/pbb",
      name: "Power Bottom",
      display: "PBB",
      symbol: "PBB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/PBB.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/PBB.png",
        theme: {
          primary_color_hex: "#f21313"
        }
      }]
    },
    {
      description: "Beer Is Good for You!",
      denom_units: [{
        denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/bwh",
        exponent: 0
      }, {
        denom: "bwh",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8",
      base: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/bwh",
      name: "BeerWifHat",
      display: "bwh",
      symbol: "BWH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/BWH.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/BWH.png",
        theme: {
          primary_color_hex: "#775038"
        }
      }]
    },
    {
      description: "Airdrop For All [AFA - New Name on Cosmos Ecosystem, A4A - Old Name on TurtleNetwork] is a token from turtleNetwork towards cosmos ecosystem.",
      denom_units: [{
        denom: "ibc/0D62E47FDEBBC199D4E1853C0708F0F9337AC62D95B719585C9700E466060995",
        exponent: 0,
        aliases: ["cw20:juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg"]
      }],
      type_asset: "ics20",
      base: "ibc/0D62E47FDEBBC199D4E1853C0708F0F9337AC62D95B719585C9700E466060995",
      name: "Airdrop For All",
      display: "cw20:juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg",
      symbol: "AFA",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "juno",
          base_denom: "cw20:juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg",
          port: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn",
          channel_id: "channel-47"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-169",
          path: "transfer/channel-169/cw20:juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/afa.png"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "cw20:juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/juno/images/afa.png",
        theme: {
          primary_color_hex: "#f3cb0c"
        }
      }]
    },
    {
      description: "The Cosmos Network's premier self-hatred memecoin.",
      extended_description: "Shitmos is a fair launched token deployed via the start.cooking liquidity bootstrapping protocol (LBP) on the Osmosis blockchain. It is powered by the Shitmos Economic Zone (SEZ), and it has been designed with the goal of uniting the Cosmos Network and interchain-at-large ecosystems by making crypto fun. The SEZ is a federation of nft collections on Stargaze that supports Shitmos by providing at least 2% of royalties towards open market purchases of Shitmos.",
      denom_units: [{
        denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/shitmos",
        exponent: 0
      }, {
        denom: "SHITMOS",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8",
      base: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/shitmos",
      name: "Shitmos",
      display: "SHITMOS",
      symbol: "SHITMOS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.svg",
        theme: {
          primary_color_hex: "#639BFF",
          circle: !0
        }
      }],
      keywords: ["memecoin"],
      socials: {
        website: "https://shitmos.wtf",
        twitter: "https://twitter.com/shitoncosmos"
      }
    },
    {
      description: "Quicksilver Liquid Staked JUNO",
      denom_units: [{
        denom: "ibc/B4E18E61E1505C2F371B621E49B09E983F6A138F251A7B5286A6BDF739FD0D54",
        exponent: 0,
        aliases: ["uqjuno"]
      }, {
        denom: "qjuno",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/B4E18E61E1505C2F371B621E49B09E983F6A138F251A7B5286A6BDF739FD0D54",
      name: "Quicksilver Liquid Staked JUNO",
      display: "qjuno",
      symbol: "qJUNO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "juno",
          base_denom: "ujuno"
        },
        provider: "Quicksilver"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "quicksilver",
          base_denom: "uqjuno",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-522",
          path: "transfer/channel-522/uqjuno"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qjuno.svg"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilver",
          base_denom: "uqjuno"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qjuno.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked SAGA",
      denom_units: [{
        denom: "ibc/F2D400F2728E9DA06EAE2AFAB289931A69EDDA5A661578C66A3177EDFE3C0D13",
        exponent: 0,
        aliases: ["uqsaga"]
      }, {
        denom: "qsaga",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/F2D400F2728E9DA06EAE2AFAB289931A69EDDA5A661578C66A3177EDFE3C0D13",
      name: "Quicksilver Liquid Staked SAGA",
      display: "qsaga",
      symbol: "qSAGA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "saga",
          base_denom: "usaga"
        },
        provider: "Quicksilver"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "quicksilver",
          base_denom: "uqsaga",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-522",
          path: "transfer/channel-522/uqsaga"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsaga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsaga.svg"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilver",
          base_denom: "uqsaga"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsaga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsaga.svg",
        theme: {
          primary_color_hex: "#f9924b"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked DYDX",
      denom_units: [{
        denom: "ibc/273C593E51ACE56F1F2BDB3E03A5CB81BB208B894BCAA642676A32C3454E8C27",
        exponent: 0,
        aliases: ["aqdydx"]
      }, {
        denom: "qdydx",
        exponent: 18,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/273C593E51ACE56F1F2BDB3E03A5CB81BB208B894BCAA642676A32C3454E8C27",
      name: "Quicksilver Liquid Staked DYDX",
      display: "qdydx",
      symbol: "qDYDX",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "dydx",
          base_denom: "adydx"
        },
        provider: "Quicksilver"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "quicksilver",
          base_denom: "aqdydx",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-522",
          path: "transfer/channel-522/aqdydx"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qdydx.svg"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilver",
          base_denom: "aqdydx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qdydx.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked BLD",
      denom_units: [{
        denom: "ibc/C1C106D915C8E8C59E5DC69BF30FEF64729A6F788060B184C86A315DBB762EF7",
        exponent: 0,
        aliases: ["uqbld"]
      }, {
        denom: "qbld",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/C1C106D915C8E8C59E5DC69BF30FEF64729A6F788060B184C86A315DBB762EF7",
      name: "Quicksilver Liquid Staked BLD",
      display: "qbld",
      symbol: "qBLD",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "agoric",
          base_denom: "ubld"
        },
        provider: "Quicksilver"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "quicksilver",
          base_denom: "uqbld",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-522",
          path: "transfer/channel-522/uqbld"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qbld.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qbld.svg"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilver",
          base_denom: "uqbld"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qbld.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qbld.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "PEPE is a deflationary memecoin launched on Ethereum. ",
      denom_units: [{
        denom: "ibc/5B5BFCC8A9F0D554A4245117F7798E85BE25B6C73DBFA2D6F369BD9DD6CACC6D",
        exponent: 0,
        aliases: ["pepe-wei", "ibc/6367C5AF2E2477FB13DD0C8CB0027FEDDF5AE947EE84C69FB75003E604E29D05"]
      }, {
        denom: "pepe",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/5B5BFCC8A9F0D554A4245117F7798E85BE25B6C73DBFA2D6F369BD9DD6CACC6D",
      name: "Pepe (Picasso)",
      display: "pepe",
      symbol: "PEPE.pica",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x6982508145454ce325ddbe47a25d4ec3d2311933"
        }
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "composable",
          base_denom: "ibc/6367C5AF2E2477FB13DD0C8CB0027FEDDF5AE947EE84C69FB75003E604E29D05",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-1279",
          path: "transfer/channel-1279/transfer/channel-52/0x6982508145454ce325ddbe47a25d4ec3d2311933"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/pepe.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/pepe.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/6367C5AF2E2477FB13DD0C8CB0027FEDDF5AE947EE84C69FB75003E604E29D05"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.png",
        theme: {
          primary_color_hex: "#cc3233"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "CRV is the governance token for Curve Finance.",
      denom_units: [{
        denom: "ibc/080CE38C1E49595F2199E88BE7281F93FAEEF3FE354EECED0640625E8311C9CF",
        exponent: 0,
        aliases: ["crv-wei", "ibc/52C8C6197989684F891076F228F20CD1659AB6E1776E3B85E65CBBEC67DA5DED"]
      }, {
        denom: "crv",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/080CE38C1E49595F2199E88BE7281F93FAEEF3FE354EECED0640625E8311C9CF",
      name: "Curve DAO (Picasso)",
      display: "crv",
      symbol: "CRV.pica",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xd533a949740bb3306d119cc777fa900ba034cd52",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0xd533a949740bb3306d119cc777fa900ba034cd52"
        }
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "composable",
          base_denom: "ibc/52C8C6197989684F891076F228F20CD1659AB6E1776E3B85E65CBBEC67DA5DED",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-1279",
          path: "transfer/channel-1279/transfer/channel-52/0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/crv.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/crv.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/52C8C6197989684F891076F228F20CD1659AB6E1776E3B85E65CBBEC67DA5DED"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/crv.png",
        theme: {
          primary_color_hex: "#1fcbdb"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "A Liquid Restaking Token (LRT) and Strategy Manager for EigenLayer.",
      denom_units: [{
        denom: "ibc/39AAE0F5F918B731BEF1E02E9BAED33C242805F668B0A941AC509FB569FE51CB",
        exponent: 0,
        aliases: ["ezeth-wei", "ibc/0247E0E2C174135AADF4EA172D97FF5C15A64689A403E83603EAE4F0616DD365"]
      }, {
        denom: "ezeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/39AAE0F5F918B731BEF1E02E9BAED33C242805F668B0A941AC509FB569FE51CB",
      name: "Renzo Restaked ETH (Picasso)",
      display: "ezeth",
      symbol: "ezETH.pica",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Renzo"
        },
        {
          type: "ibc-bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xbf5495efe5db9ce00f80364c8b423567e58d2110",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0xbf5495efe5db9ce00f80364c8b423567e58d2110"
          },
          provider: "Picasso"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/E317539F148285AAC77E7614101CBE94E20EDF169B233A5E0C867112972F9041",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0xbf5495efe5db9ce00f80364c8b423567e58d2110"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ezeth.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ezeth.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/E317539F148285AAC77E7614101CBE94E20EDF169B233A5E0C867112972F9041"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ezeth.png",
        theme: {
          primary_color_hex: "#9bcf2c"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "Ethena USDe is a synthetic dollar protocol built on Ethereum.",
      denom_units: [{
        denom: "ibc/BFFE212A23384C4EB055CF6F95A1F5EC1BE0F9BD286FAA66C3748F0444E67D63",
        exponent: 0,
        aliases: ["usde-wei", "ibc/FFD9EB71B4480ED4D73F7370A2AEBDB48447A0AAE27265F8060A957F0FF71983"]
      }, {
        denom: "usde",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/BFFE212A23384C4EB055CF6F95A1F5EC1BE0F9BD286FAA66C3748F0444E67D63",
      name: "Ethena USDe (Picasso)",
      display: "usde",
      symbol: "USDe.pica",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Ethena"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x4c9edd5852cd905f086c759e8383e09bff1e68b3",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0x4c9edd5852cd905f086c759e8383e09bff1e68b3"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/FFD9EB71B4480ED4D73F7370A2AEBDB48447A0AAE27265F8060A957F0FF71983",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0x4c9edd5852cd905f086c759e8383e09bff1e68b3"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usde.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usde.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/FFD9EB71B4480ED4D73F7370A2AEBDB48447A0AAE27265F8060A957F0FF71983"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usde.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "The native governance token of Ethena.",
      denom_units: [{
        denom: "ibc/257FF64F160106F6EE43CEE7C761DA64C1346221895373CC810FFA1BFAC5A7CD",
        exponent: 0,
        aliases: ["ena-wei", "ibc/B089810D5A6316AD5E9C7808733DC4AB11C7BA3033221D28711FC7206BACB929"]
      }, {
        denom: "ena",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/257FF64F160106F6EE43CEE7C761DA64C1346221895373CC810FFA1BFAC5A7CD",
      name: "Ethena (Picasso)",
      display: "ena",
      symbol: "ENA.pica",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x57e114b691db790c35207b2e685d4a43181e6061",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-52",
          path: "transfer/channel-52/0x57e114b691db790c35207b2e685d4a43181e6061"
        }
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "composable",
          base_denom: "ibc/B089810D5A6316AD5E9C7808733DC4AB11C7BA3033221D28711FC7206BACB929",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-1279",
          path: "transfer/channel-1279/transfer/channel-52/0x57e114b691db790c35207b2e685d4a43181e6061"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ena.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ena.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/B089810D5A6316AD5E9C7808733DC4AB11C7BA3033221D28711FC7206BACB929"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ena.png",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "eETH is a natively restaked liquid staking token on Ethereum.",
      denom_units: [{
        denom: "ibc/8D0FFEA4EDB04E3C1738C9599B66AE49683E0540FC4C1214AC84534C200D818B",
        exponent: 0,
        aliases: ["eeth-wei", "ibc/34C23BA6BAA2EAE0199D85AD1E2E214F76B0BFAD42BF75542D15F71264EEB05B"]
      }, {
        denom: "eeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/8D0FFEA4EDB04E3C1738C9599B66AE49683E0540FC4C1214AC84534C200D818B",
      name: "ether.fi Staked ETH (Picasso)",
      display: "eeth",
      symbol: "eETH.pica",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "EtherFi"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x35fa164735182de50811e8e2e824cfb9b6118ac2",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0x35fa164735182de50811e8e2e824cfb9b6118ac2"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/34C23BA6BAA2EAE0199D85AD1E2E214F76B0BFAD42BF75542D15F71264EEB05B",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0x35fa164735182de50811e8e2e824cfb9b6118ac2"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eeth.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eeth.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/34C23BA6BAA2EAE0199D85AD1E2E214F76B0BFAD42BF75542D15F71264EEB05B"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eeth.png",
        theme: {
          primary_color_hex: "#5045b7"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "pxETH is built on top of the Pirex platform and forms the foundation of the Dinero protocol.",
      denom_units: [{
        denom: "ibc/D09BB89B2187EF13EF006B44510749B0F02FD0B34F8BB55C70D812A1FF6148C7",
        exponent: 0,
        aliases: ["pxeth-wei", "ibc/36EF1EA47A09689C81D848B08E5240FA9FF13B17DB7DCF48B77D4D0D9B152821"]
      }, {
        denom: "pxeth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/D09BB89B2187EF13EF006B44510749B0F02FD0B34F8BB55C70D812A1FF6148C7",
      name: "Dinero Staked ETH (Picasso)",
      display: "pxeth",
      symbol: "pxETH.pica",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Dinero"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0x04c154b66cb340f3ae24111cc767e0184ed00cc6",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0x04c154b66cb340f3ae24111cc767e0184ed00cc6"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/36EF1EA47A09689C81D848B08E5240FA9FF13B17DB7DCF48B77D4D0D9B152821",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0x04c154b66cb340f3ae24111cc767e0184ed00cc6"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/pxeth.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/pxeth.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/36EF1EA47A09689C81D848B08E5240FA9FF13B17DB7DCF48B77D4D0D9B152821"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pxeth.png",
        theme: {
          primary_color_hex: "#c3cbd2"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "A collateralized-debt-position (CDP) stablecoin by Curve DAO.",
      denom_units: [{
        denom: "ibc/63551E7BB24008F0AFC1CB051A423A5104F781F035F8B1A191264B7086A0A0F6",
        exponent: 0,
        aliases: ["crvusd-wei", "ibc/C9D79BE8E3E75CA2DFDC722C77D7B179C39A4802D59019C790A825FDE34B724A"]
      }, {
        denom: "crvusd",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/63551E7BB24008F0AFC1CB051A423A5104F781F035F8B1A191264B7086A0A0F6",
      name: "crvUSD (Picasso)",
      display: "crvusd",
      symbol: "crvUSD.pica",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Curve Finance"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e",
            channel_id: "channel-2"
          },
          chain: {
            channel_id: "channel-52",
            path: "transfer/channel-52/0xf939e0a03fb07f59a73314e73794be0e57ac1b4e"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/C9D79BE8E3E75CA2DFDC722C77D7B179C39A4802D59019C790A825FDE34B724A",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-52/0xf939e0a03fb07f59a73314e73794be0e57ac1b4e"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/crvUSD.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/crvUSD.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/C9D79BE8E3E75CA2DFDC722C77D7B179C39A4802D59019C790A825FDE34B724A"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/crvusd.png",
        theme: {
          primary_color_hex: "#d6e3d9"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "Coin to support the real world in Wilhelmshall im Huy",
      denom_units: [{
        denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/wiha",
        exponent: 0
      }, {
        denom: "WIHA",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8",
      base: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/wiha",
      name: "WiliHall",
      display: "WIHA",
      symbol: "WIHA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/WIHA.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/WIHA.png",
        theme: {
          primary_color_hex: "#f2f2ec"
        }
      }]
    },
    {
      description: "For th",
      denom_units: [{
        denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/crazyhorse",
        exponent: 0
      }, {
        denom: "CRAZYHORSE",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8",
      base: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/crazyhorse",
      name: "HorseShoeBar",
      display: "CRAZYHORSE",
      symbol: "CRAZYHORSE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CrazyHorse.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CrazyHorse.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Cosmus Cartol always get rich",
      denom_units: [{
        denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/coca",
        exponent: 0
      }, {
        denom: "COCA",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8",
      base: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/coca",
      name: "CosmusCartol",
      display: "COCA",
      symbol: "COCA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/COCA.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/COCA.png",
        theme: {
          primary_color_hex: "#1e2029"
        }
      }]
    },
    {
      description: "Tether, issued natively on Solana.",
      denom_units: [{
        denom: "ibc/0233A3F2541FD43DBCA569B27AF886E97F5C03FC0305E4A8A3FAC6AC26249C7A",
        exponent: 0,
        aliases: ["ibc/D105950618E47CA2AEC314282BC401625025F80A4F812808DEEBB1941C685575"]
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0233A3F2541FD43DBCA569B27AF886E97F5C03FC0305E4A8A3FAC6AC26249C7A",
      name: "Tether USD (Solana) (Picasso)",
      display: "usdt",
      symbol: "USDT.sol.pica",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Tether"
        },
        {
          type: "additional-mintage",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
          },
          provider: "Tether"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "solana",
            base_denom: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
            channel_id: "channel-1"
          },
          chain: {
            channel_id: "channel-71",
            path: "transfer/channel-71/Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/D105950618E47CA2AEC314282BC401625025F80A4F812808DEEBB1941C685575",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-71/Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.solana.pica.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.solana.pica.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.solana.pica.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.solana.pica.png",
        theme: {
          primary_color_hex: "#089496"
        }
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/D105950618E47CA2AEC314282BC401625025F80A4F812808DEEBB1941C685575"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using the Edgevana protocol.",
      denom_units: [{
        denom: "ibc/B83F9E20B4A07FA8846880000BD9D8985D89567A090F5E9390C64E81C39B4607",
        exponent: 0,
        aliases: ["ibc/BADB5950C4A81AC201696EBCB33CD295137FA86F0AA620CDDE946D3700E0208C"]
      }, {
        denom: "edgesol",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/B83F9E20B4A07FA8846880000BD9D8985D89567A090F5E9390C64E81C39B4607",
      name: "Edgevana Staked SOL (Picasso)",
      display: "edgesol",
      symbol: "edgeSOL.pica",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "solana",
            base_denom: "Lamport"
          },
          provider: "Edgevana"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "solana",
            base_denom: "edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt",
            channel_id: "channel-1"
          },
          chain: {
            channel_id: "channel-71",
            path: "transfer/channel-71/edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/BADB5950C4A81AC201696EBCB33CD295137FA86F0AA620CDDE946D3700E0208C",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-71/edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/edgesol.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/edgesol.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/BADB5950C4A81AC201696EBCB33CD295137FA86F0AA620CDDE946D3700E0208C"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/edgesol.png",
        theme: {
          primary_color_hex: "#146cfc"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using the MarginFi protocol.",
      denom_units: [{
        denom: "ibc/F618D130A2B8203D169811658BD0361F18DC2453085965FA0E5AEB8018DD54EE",
        exponent: 0,
        aliases: ["ibc/55F5B582483FEFA5422794292B079B4D49A5BAB9881E7C801F9F271F1D234F1D"]
      }, {
        denom: "lst",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/F618D130A2B8203D169811658BD0361F18DC2453085965FA0E5AEB8018DD54EE",
      name: "Liquid Staking Token (Picasso)",
      display: "lst",
      symbol: "LST.pica",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "solana",
            base_denom: "Lamport"
          },
          provider: "MarginFi"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "solana",
            base_denom: "LSTxxxnJzKDFSLr4dUkPcmCf5VyryEqzPLz5j4bpxFp",
            channel_id: "channel-1"
          },
          chain: {
            channel_id: "channel-71",
            path: "transfer/channel-71/LSTxxxnJzKDFSLr4dUkPcmCf5VyryEqzPLz5j4bpxFp"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/55F5B582483FEFA5422794292B079B4D49A5BAB9881E7C801F9F271F1D234F1D",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-71/LSTxxxnJzKDFSLr4dUkPcmCf5VyryEqzPLz5j4bpxFp"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/lst.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/lst.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/55F5B582483FEFA5422794292B079B4D49A5BAB9881E7C801F9F271F1D234F1D"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/msol.png",
        theme: {
          primary_color_hex: "#cbebe3"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "A representative token for staked SOL, derived through the process of liquid staking SOL using Jito.",
      denom_units: [{
        denom: "ibc/9A83BDF4C8C5FFDDE735533BC8CD4363714A6474AED1C2C492FB003BB77C7982",
        exponent: 0,
        aliases: ["ibc/91A2FE07F8BDFC0552B1C9972FCCBF2CFD067DDE5F496D81E5132CE57762B0F2"]
      }, {
        denom: "jitosol",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/9A83BDF4C8C5FFDDE735533BC8CD4363714A6474AED1C2C492FB003BB77C7982",
      name: "Jito Staked SOL (Picasso)",
      display: "jitosol",
      symbol: "jitoSOL.pica",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "solana",
            base_denom: "Lamport"
          },
          provider: "Jito"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "solana",
            base_denom: "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn",
            channel_id: "channel-1"
          },
          chain: {
            channel_id: "channel-71",
            path: "transfer/channel-71/J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/91A2FE07F8BDFC0552B1C9972FCCBF2CFD067DDE5F496D81E5132CE57762B0F2",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-71/J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/jitosol.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/jitosol.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/91A2FE07F8BDFC0552B1C9972FCCBF2CFD067DDE5F496D81E5132CE57762B0F2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/jitosol.png",
        theme: {
          primary_color_hex: "#5bb384"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "SOL is the native cryptocurrency of the Solana blockchain.",
      denom_units: [{
        denom: "ibc/0F9E9277B61A78CB31014D541ACA5BF6AB06DFC4524C4C836490B131DAAECD78",
        exponent: 0,
        aliases: ["Lamport", "ibc/2CC39C8141F257EBBA250F65B9D0F31DC8D153C225E51EC192DE6E3F65D43F0C"]
      }, {
        denom: "wsol",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/0F9E9277B61A78CB31014D541ACA5BF6AB06DFC4524C4C836490B131DAAECD78",
      name: "Solana (Picasso)",
      display: "wsol",
      symbol: "SOL.pica",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "solana",
            base_denom: "Lamport"
          },
          provider: "Solana"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "solana",
            base_denom: "So11111111111111111111111111111111111111112",
            channel_id: "channel-1"
          },
          chain: {
            channel_id: "channel-71",
            path: "transfer/channel-71/So11111111111111111111111111111111111111112"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/2CC39C8141F257EBBA250F65B9D0F31DC8D153C225E51EC192DE6E3F65D43F0C",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-71/So11111111111111111111111111111111111111112"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wsol.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wsol.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/2CC39C8141F257EBBA250F65B9D0F31DC8D153C225E51EC192DE6E3F65D43F0C"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        theme: {
          circle: !0,
          background_color_hex: "#000000"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "An alloy of USDT asset variants on Osmosis.",
      extended_description: "Multiple Tether USD variants on Osmosis comprise the liquidity backing of a tokenized transmuter pool to create an alloy of USDT.",
      denom_units: [{
        denom: "factory/osmo1em6xs47hd82806f5cxgyufguxrrc7l0aqx7nzzptjuqgswczk8csavdxek/alloyed/allUSDT",
        exponent: 0
      }, {
        denom: "allUSDT",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1em6xs47hd82806f5cxgyufguxrrc7l0aqx7nzzptjuqgswczk8csavdxek",
      base: "factory/osmo1em6xs47hd82806f5cxgyufguxrrc7l0aqx7nzzptjuqgswczk8csavdxek/alloyed/allUSDT",
      name: "Tether USD",
      display: "allUSDT",
      symbol: "USDT",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "Tether"
      }, {
        type: "synthetic",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      },
      images: [
        {
          image_sync: {
            chain_name: "ethereum",
            base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
          },
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
          theme: {
            circle: !0,
            primary_color_hex: "#009393",
            background_color_hex: "#009393"
          }
        },
        {
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt_logomark.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt_logomark.svg",
          theme: {
            circle: !1,
            primary_color_hex: "#50AF95",
            background_color_hex: "#00000000"
          }
        },
        {
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allUSDT.svg"
        }
      ],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "Whinecoin is an experimental memecoin by the Sommelier Finance team.",
      denom_units: [{
        denom: "ibc/A8C568580D613F16F7E9075EA9FAD69FEBE0CC1F4AF46C60255FEC4459C166F1",
        exponent: 0,
        aliases: ["ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump", "ibc/9D5DA3720001F91DD76B8F609A93F96688EC8185B54BF9A1A1450EB34FF2D912"]
      }, {
        denom: "whine",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/A8C568580D613F16F7E9075EA9FAD69FEBE0CC1F4AF46C60255FEC4459C166F1",
      name: "WHINEcoin",
      display: "whine",
      symbol: "WHINE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "solana",
          base_denom: "ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-71",
          path: "transfer/channel-71/ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump"
        }
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "composable",
          base_denom: "ibc/9D5DA3720001F91DD76B8F609A93F96688EC8185B54BF9A1A1450EB34FF2D912",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-1279",
          path: "transfer/channel-1279/transfer/channel-71/ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/whine.png"
      },
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "ATeTQcUkWGs7AZ15mCiFUWCW9EUL7KpDZEHCN1Y8pump"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/whine.png",
        theme: {
          primary_color_hex: "#FFFFFF",
          background_color_hex: "#FFFFFF",
          circle: !1
        }
      }]
    },
    {
      description: "A group of french boulanger who wanna bring fun and baguette on cosmos",
      denom_units: [{
        denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/bag",
        exponent: 0
      }, {
        denom: "BAG",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8",
      base: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/bag",
      name: "Baguette",
      display: "BAG",
      symbol: "BAG",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/BAG.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/BAG.png",
        theme: {
          primary_color_hex: "#a07042"
        }
      }]
    },
    {
      description: "An alloy of BTC asset variants on Osmosis.",
      extended_description: "Multiple Bitcoin variants on Osmosis comprise the liquidity backing of a tokenized transmuter pool to create an alloy of BTC.",
      denom_units: [{
        denom: "factory/osmo1z6r6qdknhgsc0zeracktgpcxf43j6sekq07nw8sxduc9lg0qjjlqfu25e3/alloyed/allBTC",
        exponent: 0
      }, {
        denom: "allBTC",
        exponent: 8
      }],
      type_asset: "sdk.coin",
      address: "osmo1z6r6qdknhgsc0zeracktgpcxf43j6sekq07nw8sxduc9lg0qjjlqfu25e3",
      base: "factory/osmo1z6r6qdknhgsc0zeracktgpcxf43j6sekq07nw8sxduc9lg0qjjlqfu25e3/alloyed/allBTC",
      name: "Bitcoin",
      display: "allBTC",
      symbol: "BTC",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "bitcoin",
          base_denom: "sat"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/bitcoin/images/btc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/bitcoin/images/btc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "bitcoin",
          base_denom: "sat"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/bitcoin/images/btc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/bitcoin/images/btc.png",
        theme: {
          primary_color_hex: "#f4941c",
          background_color_hex: "#f4941c",
          circle: !0
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allBTC.svg"
      }]
    },
    {
      description: "N43 a BitSong Music FanToken",
      denom_units: [{
        denom: "ibc/E4FFAACCDB7D55CE2D257DF637C00158CB841F11D0013B2D03E31FF7800A2C58",
        exponent: 0,
        aliases: ["ft387C1C279D962ED80C09C1D592A92C4275FD7C5D"]
      }, {
        denom: "n43",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E4FFAACCDB7D55CE2D257DF637C00158CB841F11D0013B2D03E31FF7800A2C58",
      name: "N43 Fantoken",
      display: "n43",
      symbol: "N43",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "bitsong",
          base_denom: "ft387C1C279D962ED80C09C1D592A92C4275FD7C5D",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-73",
          path: "transfer/channel-73/ft387C1C279D962ED80C09C1D592A92C4275FD7C5D"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft387C1C279D962ED80C09C1D592A92C4275FD7C5D.png"
      },
      images: [{
        image_sync: {
          chain_name: "bitsong",
          base_denom: "ft387C1C279D962ED80C09C1D592A92C4275FD7C5D"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/bitsong/images/ft387C1C279D962ED80C09C1D592A92C4275FD7C5D.png",
        theme: {
          primary_color_hex: "#0a0a0a"
        }
      }]
    },
    {
      description: "Rakoff Token is the Meme Token for Terra Classic",
      denom_units: [{
        denom: "ibc/46579C587A0B8CF8B0A1FF6B0EFA2082F11876578E47FC81A9CAAD31F424AF98",
        exponent: 0,
        aliases: ["cw20:terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2"]
      }, {
        denom: "rakoff",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/46579C587A0B8CF8B0A1FF6B0EFA2082F11876578E47FC81A9CAAD31F424AF98",
      name: "Rakoff Token",
      display: "rakoff",
      symbol: "RAKOFF",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "terra",
          base_denom: "cw20:terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2",
          port: "wasm.terra19pfxzj9580h7rjd6z6sn5x2se76vgrc0etltr79g9z3t82jzp4hq63qguc",
          channel_id: "channel-108"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-78488",
          path: "transfer/channel-78488/cw20:terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/juris.png"
      },
      images: [{
        image_sync: {
          chain_name: "terra",
          base_denom: "cw20:terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/juris.png"
      }]
    },
    {
      denom_units: [{
        denom: "ibc/64E62451C9A5682FF3047429C6E4714A02CDC0C35DE35CAB01E18D1188004CEB",
        exponent: 0,
        aliases: ["arbitrum-weth-wei"]
      }, {
        denom: "arbitrum-weth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/64E62451C9A5682FF3047429C6E4714A02CDC0C35DE35CAB01E18D1188004CEB",
      name: "Wrapped Ether (Arbitrum via Axelar)",
      display: "arbitrum-weth",
      symbol: "ETH.arb.axl",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Ethereum"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"
          },
          provider: "Arbitrum Bridge"
        },
        {
          type: "wrapped",
          counterparty: {
            chain_name: "arbitrum",
            base_denom: "wei"
          },
          provider: "Arbitrum"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "arbitrum",
            base_denom: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "arbitrum-weth-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/arbitrum-weth-wei"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.arb.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.arb.axl.svg"
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "arbitrum-weth-wei"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }]
    },
    {
      denom_units: [{
        denom: "ibc/D7D6DEF2A4F7ED0A6F5F0E266C1B2C9726E82F67EBBE49BBB47B3DEC289F8D7B",
        exponent: 0,
        aliases: ["base-weth-wei"]
      }, {
        denom: "base-weth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/D7D6DEF2A4F7ED0A6F5F0E266C1B2C9726E82F67EBBE49BBB47B3DEC289F8D7B",
      name: "Wrapped Ether (Base via Axelar)",
      display: "base-weth",
      symbol: "ETH.base.axl",
      traces: [
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Base Bridge"
        },
        {
          type: "wrapped",
          counterparty: {
            chain_name: "base",
            base_denom: "wei"
          },
          provider: "Base"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "base",
            base_denom: "0x4200000000000000000000000000000000000006"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "base-weth-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/base-weth-wei"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.base.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.base.axl.svg"
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "base-weth-wei"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }]
    },
    {
      denom_units: [{
        denom: "ibc/F9EB60AC212DBF05F4C5ED0FDE03BB9F08309B0EE9899A406AD4B904CF84968E",
        exponent: 0,
        aliases: ["polygon-weth-wei"]
      }, {
        denom: "polygon-weth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/F9EB60AC212DBF05F4C5ED0FDE03BB9F08309B0EE9899A406AD4B904CF84968E",
      name: "Wrapped Ether (Polygon via Axelar)",
      display: "polygon-weth",
      symbol: "ETH.matic.axl",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "wei"
          },
          provider: "Ethereum"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2"
          },
          provider: "Polygon PoS Bridge"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "polygon",
            base_denom: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelar",
            base_denom: "polygon-weth-wei",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-208",
            path: "transfer/channel-208/polygon-weth-wei"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.matic.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/eth.matic.axl.svg"
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "polygon-weth-wei"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }]
    },
    {
      denom_units: [{
        denom: "ibc/245C3CA604AAB4BB9EEA5E86F23F52D59253D8722C8FC9C4E3E69F77C5CD3D2F",
        exponent: 0,
        aliases: ["staISLM"]
      }, {
        denom: "stISLM",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/245C3CA604AAB4BB9EEA5E86F23F52D59253D8722C8FC9C4E3E69F77C5CD3D2F",
      name: "Stride Staked ISLM",
      display: "stISLM",
      symbol: "stISLM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "haqq",
          base_denom: "aISLM"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "staISLM",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/staISLM"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stislm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stislm.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "staISLM"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stislm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stislm.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "The native token of Mande Network.",
      extended_description: "Mande network is an open on-chain reputation layer on Web3",
      denom_units: [{
        denom: "ibc/739D70CB432FE1C6D94AF306B68C14F4CFB0B9EDD1238D3A8718B1B0E84E8547",
        exponent: 0,
        aliases: ["amand", "ibc/5A26C8DC8DA66F4DD94326E67F94510188F5F7AFE2DB3933A0C823670E56EABF"]
      }, {
        denom: "mand",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/739D70CB432FE1C6D94AF306B68C14F4CFB0B9EDD1238D3A8718B1B0E84E8547",
      name: "Mande Network",
      display: "mand",
      symbol: "MAND",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "mande",
          base_denom: "amand",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-51",
          path: "transfer/channel-51/amand"
        }
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "dymension",
          base_denom: "ibc/5A26C8DC8DA66F4DD94326E67F94510188F5F7AFE2DB3933A0C823670E56EABF",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-19774",
          path: "transfer/channel-19774/transfer/channel-51/amand"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.svg"
      },
      images: [{
        image_sync: {
          chain_name: "mande",
          base_denom: "amand"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mande/images/mande.svg",
        theme: {
          primary_color_hex: "#274cbf"
        }
      }],
      keywords: [
        "credibility",
        "identity",
        "osmosis_unstable"
      ],
      socials: {
        website: "https://mande.network/",
        twitter: "https://twitter.com/MandeNetwork"
      }
    },
    {
      description: "The native token of Neutaro",
      denom_units: [{
        denom: "ibc/DAED51CBD967A3BE0C467687970AFD97B202AFE4A1718B36936F49178AFE0133",
        exponent: 0,
        aliases: ["uneutaro"]
      }, {
        denom: "neutaro",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/DAED51CBD967A3BE0C467687970AFD97B202AFE4A1718B36936F49178AFE0133",
      name: "Neutaro",
      display: "neutaro",
      symbol: "NTMPI",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutaro",
          base_denom: "uneutaro",
          channel_id: "channel-4"
        },
        chain: {
          channel_id: "channel-79092",
          path: "transfer/channel-79092/uneutaro"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.svg"
      },
      images: [{
        image_sync: {
          chain_name: "neutaro",
          base_denom: "uneutaro"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutaro/images/neutaro.svg",
        theme: {
          primary_color_hex: "#cbfb06"
        }
      }]
    },
    {
      description: "Pepe Bruce Jenner",
      denom_units: [{
        denom: "ibc/E0D6A7FFAE26FA90C8F1AA3461A5A21E74DB154F183EAE56C96769F48F81FCA2",
        exponent: 0,
        aliases: [
          "ANu4Wuq86WzRU8tykszQUJ66eQzFNfkwap2HcQ5UaFaU",
          "wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP",
          "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP"
        ]
      }, {
        denom: "wormhole/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP/6",
        exponent: 6,
        aliases: ["pbj", "PBJ"]
      }],
      type_asset: "ics20",
      base: "ibc/E0D6A7FFAE26FA90C8F1AA3461A5A21E74DB154F183EAE56C96769F48F81FCA2",
      name: "Pepe Bruce Jenner",
      display: "wormhole/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP/6",
      symbol: "PBJ",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "solana",
          base_denom: "ANu4Wuq86WzRU8tykszQUJ66eQzFNfkwap2HcQ5UaFaU"
        },
        provider: "Wormhole"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-2186",
          path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pbj.png"
      },
      images: [{
        image_sync: {
          chain_name: "solana",
          base_denom: "ANu4Wuq86WzRU8tykszQUJ66eQzFNfkwap2HcQ5UaFaU"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/pbj.png",
        theme: {
          primary_color_hex: "#488000",
          background_color_hex: "#ee0000"
        }
      }]
    },
    {
      description: "Ondo US Dollar Yield",
      denom_units: [{
        denom: "ibc/23104D411A6EB6031FA92FB75F227422B84989969E91DCAD56A535DD7FF0A373",
        exponent: 0,
        aliases: ["attousdy", "ausdy"]
      }, {
        denom: "usdy",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/23104D411A6EB6031FA92FB75F227422B84989969E91DCAD56A535DD7FF0A373",
      name: "Ondo US Dollar Yield",
      display: "usdy",
      symbol: "USDY",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "noble",
          base_denom: "ausdy",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-750",
          path: "transfer/channel-750/ausdy"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/usdy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/usdy.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "ausdy"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/usdy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/usdy.svg",
        theme: {
          primary_color_hex: "#142c5c"
        }
      }]
    },
    {
      description: `Jacob Haertnellez Turtle. Launched by Jake's Personally appointed TURD Cult Leader..."NotSeanO'Riley." TURD is going to lead the shitcoins of Cosmos! Or Rug You. It will be Jake's Fault. `,
      denom_units: [{
        denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/turd",
        exponent: 0
      }, {
        denom: "TURD",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8",
      base: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/turd",
      name: "TURDLE",
      display: "TURD",
      symbol: "TURD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/TURD.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/TURD.png"
      }]
    },
    {
      description: "FIRMACHAIN adds a signing and verifying e-contract function to the blockchain. Unlocking new limits of electronic contracts with blockchain technology, FIRMACHAIN seeks to resolve all the social and legal issues (contracts, notarial, etc.) with written contracts through the use of electronic contracts based on FIRMACHAIN’s data blockchain.",
      denom_units: [{
        denom: "ibc/E43ABCC7E80E99E4E6E1226AE5695DDE0F83CB5C257CD04D47C36B8B90C1C839",
        exponent: 0,
        aliases: ["ufct"]
      }, {
        denom: "fct",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E43ABCC7E80E99E4E6E1226AE5695DDE0F83CB5C257CD04D47C36B8B90C1C839",
      name: "FIRMACHAIN",
      display: "fct",
      symbol: "FCT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "firmachain",
          base_denom: "ufct",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-79241",
          path: "transfer/channel-79241/ufct"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.svg"
      },
      images: [{
        image_sync: {
          chain_name: "firmachain",
          base_denom: "ufct"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/firmachain/images/fct.svg",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }]
    },
    {
      description: "An alloy of ETH asset variants on Osmosis.",
      extended_description: "Multiple Ethereum variants on Osmosis comprise the liquidity backing of a tokenized transmuter pool to create an alloy of ETH.",
      denom_units: [{
        denom: "factory/osmo1k6c8jln7ejuqwtqmay3yvzrg3kueaczl96pk067ldg8u835w0yhsw27twm/alloyed/allETH",
        exponent: 0
      }, {
        denom: "allETH",
        exponent: 18
      }],
      type_asset: "sdk.coin",
      address: "osmo1k6c8jln7ejuqwtqmay3yvzrg3kueaczl96pk067ldg8u835w0yhsw27twm",
      base: "factory/osmo1k6c8jln7ejuqwtqmay3yvzrg3kueaczl96pk067ldg8u835w0yhsw27twm/alloyed/allETH",
      name: "Ethereum",
      display: "allETH",
      symbol: "ETH",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "wei"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/eth-white.svg",
        theme: {
          primary_color_hex: "#303030"
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allETH.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allETH.png"
      }]
    },
    {
      description: "An alloy of SOL asset variants on Osmosis.",
      extended_description: "Multiple Solana variants on Osmosis comprise the liquidity backing of a tokenized transmuter pool to create an alloy of SOL.",
      denom_units: [{
        denom: "factory/osmo1n3n75av8awcnw4jl62n3l48e6e4sxqmaf97w5ua6ddu4s475q5qq9udvx4/alloyed/allSOL",
        exponent: 0
      }, {
        denom: "allSOL",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1n3n75av8awcnw4jl62n3l48e6e4sxqmaf97w5ua6ddu4s475q5qq9udvx4",
      base: "factory/osmo1n3n75av8awcnw4jl62n3l48e6e4sxqmaf97w5ua6ddu4s475q5qq9udvx4/alloyed/allSOL",
      name: "Solana",
      display: "allSOL",
      symbol: "SOL",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "solana",
          base_denom: "Lamport"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg"
      },
      images: [
        {
          image_sync: {
            chain_name: "solana",
            base_denom: "Lamport"
          },
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.svg",
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol_circle.png",
          theme: {
            circle: !0,
            background_color_hex: "#000000"
          }
        },
        {
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/solana/images/sol.svg",
          theme: {
            circle: !1,
            background_color_hex: "#00000000"
          }
        },
        {
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allSOL_circle.svg",
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allSOL_circle.png",
          theme: {
            circle: !1,
            background_color_hex: "#00000000"
          }
        },
        {
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allSOL.svg",
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allSOL.png",
          theme: {
            circle: !1,
            background_color_hex: "#00000000"
          }
        }
      ]
    },
    {
      description: "Lava Network is a modular data network designed to provide fast, reliable, and scalable access to blockchain data for developers and users.",
      denom_units: [{
        denom: "ibc/1AEF145C549D4F9847C79E49710B198C294C7F4A107F4610DEE8E725FFC4B378",
        exponent: 0,
        aliases: ["ulava"]
      }, {
        denom: "lava",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1AEF145C549D4F9847C79E49710B198C294C7F4A107F4610DEE8E725FFC4B378",
      name: "Lava",
      display: "lava",
      symbol: "LAVA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "lava",
          base_denom: "ulava",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-76971",
          path: "transfer/channel-76971/ulava"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lava/images/lava.png"
      },
      images: [{
        image_sync: {
          chain_name: "lava",
          base_denom: "ulava"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/lava/images/lava.png",
        theme: {
          primary_color_hex: "#6f043e"
        }
      }]
    },
    {
      description: "The native token of Penumbra.",
      denom_units: [{
        denom: "ibc/0FA9232B262B89E77D1335D54FB1E1F506A92A7E4B51524B400DC69C68D28372",
        exponent: 0,
        aliases: ["upenumbra"]
      }, {
        denom: "penumbra",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0FA9232B262B89E77D1335D54FB1E1F506A92A7E4B51524B400DC69C68D28372",
      name: "Penumbra",
      display: "penumbra",
      symbol: "UM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "penumbra",
          base_denom: "upenumbra",
          channel_id: "channel-4"
        },
        chain: {
          channel_id: "channel-79703",
          path: "transfer/channel-79703/upenumbra"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/penumbra/images/um.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/penumbra/images/um.svg"
      },
      images: [{
        image_sync: {
          chain_name: "penumbra",
          base_denom: "upenumbra"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/penumbra/images/um.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/penumbra/images/um.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#c7b07f"
        }
      }]
    },
    {
      description: "TRONIX is the mainnet native token of the TRON Protocol issued by TRON DAO, known as TRX.",
      denom_units: [{
        denom: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/TRX.rt",
        exponent: 0
      }, {
        denom: "trx",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9",
      base: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/TRX.rt",
      name: "Tron (Router)",
      display: "trx",
      symbol: "TRX.rt",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "tron",
          base_denom: "sun"
        },
        provider: "Router"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.svg"
      },
      images: [{
        image_sync: {
          chain_name: "tron",
          base_denom: "sun"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.png",
        theme: {
          circle: !0,
          primary_color_hex: "#FF060A",
          background_color_hex: "#FF060A"
        }
      }]
    },
    {
      description: "A synthetic version of USDT issued by Router, which can be unwrapped to USDT on several chains.",
      denom_units: [{
        denom: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/USDT.rt",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9",
      base: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/USDT.rt",
      name: "Tether USD (Ethereum via Router)",
      display: "usdt",
      symbol: "USDT.eth.rt",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "forex",
          base_denom: "USD"
        },
        provider: "Tether"
      }, {
        type: "synthetic",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        provider: "Router"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.rt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.rt.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.rt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.rt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }, {
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }]
    },
    {
      description: "Cosmo is the best currency in the universe.",
      denom_units: [{
        denom: "ibc/4925733868E7999F5822C961ADE9470A7FC5FA4A560BAE1DE102783C3F64C201",
        exponent: 0,
        aliases: ["factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO"]
      }, {
        denom: "COSMO",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4925733868E7999F5822C961ADE9470A7FC5FA4A560BAE1DE102783C3F64C201",
      name: "Cosmo",
      display: "COSMO",
      symbol: "COSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-122",
          path: "transfer/channel-122/factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/cosmo.png"
      },
      images: [{
        image_sync: {
          chain_name: "injective",
          base_denom: "factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/cosmo.png",
        theme: {
          primary_color_hex: "#343169"
        }
      }],
      socials: {
        website: "https://github.com/raphaellafar/Cosmo",
        twitter: "https://x.com/CosmoClub84"
      }
    },
    {
      denom_units: [{
        denom: "ibc/603140E681973C7A3A33B06B1D377AAD0F6AC376119735CECC04C9184A1AB080",
        exponent: 0,
        aliases: ["stuband"]
      }, {
        denom: "stBAND",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/603140E681973C7A3A33B06B1D377AAD0F6AC376119735CECC04C9184A1AB080",
      name: "Stride Staked BAND",
      display: "stBAND",
      symbol: "stBAND",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "bandchain",
          base_denom: "uband"
        },
        provider: "Stride"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stuband",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-326",
          path: "transfer/channel-326/stuband"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stband.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stband.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stuband"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stband.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stband.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "COOK is the governance token for Start.Cooking, the premier token factory on Cosmos.",
      denom_units: [{
        denom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/COOK",
        exponent: 0
      }, {
        denom: "COOK",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8",
      base: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/COOK",
      name: "COOK",
      display: "COOK",
      symbol: "COOK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/COOK.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/COOK.png"
      }]
    },
    {
      description: "TRONIX is the mainnet native token of the TRON Protocol issued by TRON DAO, known as TRX.",
      denom_units: [{
        denom: "factory/osmo14mafhhp337yjj2aujplawz0tks6jd2lel4hkwz4agyzhvvztzaqsqzjq8x/alloyed/allTRX",
        exponent: 0,
        aliases: ["sun"]
      }, {
        denom: "trx",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo14mafhhp337yjj2aujplawz0tks6jd2lel4hkwz4agyzhvvztzaqsqzjq8x",
      base: "factory/osmo14mafhhp337yjj2aujplawz0tks6jd2lel4hkwz4agyzhvvztzaqsqzjq8x/alloyed/allTRX",
      name: "Tron",
      display: "trx",
      symbol: "TRX",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "tron",
          base_denom: "sun"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.svg"
      },
      images: [{
        image_sync: {
          chain_name: "tron",
          base_denom: "sun"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/tron/images/trx.png",
        theme: {
          circle: !0,
          primary_color_hex: "#FF060A",
          background_color_hex: "#FF060A"
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allTRX.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allTRX.png",
        theme: {
          circle: !0,
          primary_color_hex: "#FF060A",
          background_color_hex: "#FF060A"
        }
      }]
    },
    {
      description: "The native token of Router Chain",
      denom_units: [{
        denom: "ibc/3F8F00094F0F79D17750FF69C5F09B078084018570AAF4F1C92C86D3F73E6488",
        exponent: 0,
        aliases: ["route"]
      }, {
        denom: "ROUTE",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/3F8F00094F0F79D17750FF69C5F09B078084018570AAF4F1C92C86D3F73E6488",
      name: "Router Protocol",
      display: "ROUTE",
      symbol: "ROUTE",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "routerchain",
          base_denom: "route",
          channel_id: "channel-7"
        },
        chain: {
          channel_id: "channel-79180",
          path: "transfer/channel-79180/route"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/routerchain/images/router.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/routerchain/images/router.svg"
      },
      images: [{
        image_sync: {
          chain_name: "routerchain",
          base_denom: "route"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/routerchain/images/router.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/routerchain/images/router.png",
        theme: {
          primary_color_hex: "#cb0766"
        }
      }]
    },
    {
      description: "An alloy of OP asset variants on Osmosis.",
      denom_units: [{
        denom: "factory/osmo1nufyzqlm8qhu2w7lm0l4rrax0ec8rsk69mga4tel8eare7c7ljaqpk2lyg/alloyed/allOP",
        exponent: 0
      }, {
        denom: "op",
        exponent: 12
      }],
      type_asset: "sdk.coin",
      address: "osmo1nufyzqlm8qhu2w7lm0l4rrax0ec8rsk69mga4tel8eare7c7ljaqpk2lyg",
      base: "factory/osmo1nufyzqlm8qhu2w7lm0l4rrax0ec8rsk69mga4tel8eare7c7ljaqpk2lyg/alloyed/allOP",
      name: "Optimism",
      display: "op",
      symbol: "OP",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "optimism",
          base_denom: "0x4200000000000000000000000000000000000042"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/optimism/images/op.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/optimism/images/op.svg"
      },
      images: [{
        image_sync: {
          chain_name: "optimism",
          base_denom: "0x4200000000000000000000000000000000000042"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/optimism/images/op.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/optimism/images/op.png",
        theme: {
          primary_color_hex: "#fc0424"
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allOP.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allOP.png",
        theme: {
          primary_color_hex: "#fc0424"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/14A291DD362798D6805B7ABCB8D09AEEE02176108F89FA09AA43EA2EE096A2A9",
        exponent: 0,
        aliases: ["0x4200000000000000000000000000000000000042", "op-wei"]
      }, {
        denom: "op",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/14A291DD362798D6805B7ABCB8D09AEEE02176108F89FA09AA43EA2EE096A2A9",
      name: "Optimism (Axelar)",
      display: "op",
      symbol: "OP.axl",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "optimism",
          base_denom: "0x4200000000000000000000000000000000000042"
        },
        provider: "Axelar"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "op-wei",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-208",
          path: "transfer/channel-208/op-wei"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/op.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/op.axl.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/op.axl.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/op.axl.png"
      }, {
        image_sync: {
          chain_name: "axelar",
          base_denom: "op-wei"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/optimism/images/op.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/optimism/images/op.png",
        theme: {
          primary_color_hex: "#fc0424"
        }
      }]
    },
    {
      description: "An alloy of SHIB asset variants on Osmosis.",
      denom_units: [{
        denom: "factory/osmo1f588gk9dazpsueevdl2w6wfkmfmhg5gdvg2uerdlzl0atkasqhsq59qc6a/alloyed/allSHIB",
        exponent: 0
      }, {
        denom: "shib",
        exponent: 12
      }],
      type_asset: "sdk.coin",
      address: "osmo1f588gk9dazpsueevdl2w6wfkmfmhg5gdvg2uerdlzl0atkasqhsq59qc6a",
      base: "factory/osmo1f588gk9dazpsueevdl2w6wfkmfmhg5gdvg2uerdlzl0atkasqhsq59qc6a/alloyed/allSHIB",
      name: "Shiba Inu",
      display: "shib",
      symbol: "SHIB",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/shib.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/shib.svg",
        theme: {
          primary_color_hex: "#FFA409",
          background_color_hex: "#00000000"
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allSHIB.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allSHIB.png",
        theme: {
          circle: !0,
          primary_color_hex: "#FFA409"
        }
      }]
    },
    {
      description: "An alloy of ARB asset variants on Osmosis.",
      denom_units: [{
        denom: "factory/osmo1p7x454ex08s4f9ztmm7wfv7lvtgdkfztj2u7v7fezfcauy85q35qmqrdpk/alloyed/allARB",
        exponent: 0
      }, {
        denom: "arb",
        exponent: 12
      }],
      type_asset: "sdk.coin",
      address: "osmo1p7x454ex08s4f9ztmm7wfv7lvtgdkfztj2u7v7fezfcauy85q35qmqrdpk",
      base: "factory/osmo1p7x454ex08s4f9ztmm7wfv7lvtgdkfztj2u7v7fezfcauy85q35qmqrdpk/alloyed/allARB",
      name: "Arbitrum",
      display: "arb",
      symbol: "ARB",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "arbitrum",
          base_denom: "0x912CE59144191C1204E64559FE8253a0e49E6548"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/arbitrum/images/arb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/arbitrum/images/arb.svg"
      },
      images: [{
        image_sync: {
          chain_name: "arbitrum",
          base_denom: "0x912CE59144191C1204E64559FE8253a0e49E6548"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/arbitrum/images/arb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/arbitrum/images/arb.svg",
        theme: {
          primary_color_hex: "#253545"
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allARB.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allARB.png",
        theme: {
          primary_color_hex: "#9DCCED"
        }
      }]
    },
    {
      description: "An alloy of LINK asset variants on Osmosis.",
      denom_units: [{
        denom: "factory/osmo18zdw5yvs6gfp95rp74qqwug9yduw2fyr8kplk2xgs726s9axc5usa2vpgw/alloyed/allLINK",
        exponent: 0
      }, {
        denom: "link",
        exponent: 12
      }],
      type_asset: "sdk.coin",
      address: "osmo18zdw5yvs6gfp95rp74qqwug9yduw2fyr8kplk2xgs726s9axc5usa2vpgw",
      base: "factory/osmo18zdw5yvs6gfp95rp74qqwug9yduw2fyr8kplk2xgs726s9axc5usa2vpgw/alloyed/allLINK",
      name: "Chainlink",
      display: "link",
      symbol: "LINK",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x514910771af9ca656af840dff83e8264ecf986ca"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x514910771af9ca656af840dff83e8264ecf986ca"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/link.svg",
        theme: {
          primary_color_hex: "#2c5cdc"
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allLINK.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allLINK.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2A5ADA"
        }
      }]
    },
    {
      description: "An alloy of PEPE asset variants on Osmosis.",
      denom_units: [{
        denom: "factory/osmo1nnlxegt0scm9qkzys9c874t0ntapv4epfjy2w49c0xdrp3dr0v4ssmelzx/alloyed/allPEPE",
        exponent: 0
      }, {
        denom: "pepe",
        exponent: 12
      }],
      type_asset: "sdk.coin",
      address: "osmo1nnlxegt0scm9qkzys9c874t0ntapv4epfjy2w49c0xdrp3dr0v4ssmelzx",
      base: "factory/osmo1nnlxegt0scm9qkzys9c874t0ntapv4epfjy2w49c0xdrp3dr0v4ssmelzx/alloyed/allPEPE",
      name: "Pepe",
      display: "pepe",
      symbol: "PEPE",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0x6982508145454Ce325dDbE47a25d4ec3d2311933"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0x6982508145454Ce325dDbE47a25d4ec3d2311933"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pepe.svg",
        theme: {
          primary_color_hex: "#cc3233"
        }
      }, {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allPEPE.png",
        theme: {
          circle: !0,
          primary_color_hex: "#549C44"
        }
      }]
    },
    {
      description: "An alloy of DOT asset variants on Osmosis.",
      denom_units: [{
        denom: "factory/osmo1r53fx9fvcdzncrs7zkn4gw5vfelx5gk8k5wc6wqha2jpkh992rusr5tk02/alloyed/allDOT",
        exponent: 0
      }, {
        denom: "dot",
        exponent: 10
      }],
      type_asset: "sdk.coin",
      address: "osmo1r53fx9fvcdzncrs7zkn4gw5vfelx5gk8k5wc6wqha2jpkh992rusr5tk02",
      base: "factory/osmo1r53fx9fvcdzncrs7zkn4gw5vfelx5gk8k5wc6wqha2jpkh992rusr5tk02/alloyed/allDOT",
      name: "Polkadot",
      display: "dot",
      symbol: "DOT",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "polkadot",
          base_denom: "Planck"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg"
      },
      images: [
        {
          image_sync: {
            chain_name: "polkadot",
            base_denom: "Planck"
          },
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.png",
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg",
          theme: {
            primary_color_hex: "#e4047c"
          }
        },
        {
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allDOT.svg",
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allDOT.png",
          theme: {
            circle: !0,
            primary_color_hex: "#E6007A"
          }
        },
        {
          image_sync: {
            chain_name: "polkadot",
            base_denom: "Planck"
          },
          svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg",
          png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.png",
          theme: {
            primary_color_hex: "#e4047c"
          }
        }
      ]
    },
    {
      description: "Unicorn from Solana via Picasso IBC",
      denom_units: [{
        denom: "ibc/C91210281CEB708DC6E41A47FC9EC298F45712273DD58C682BEBAD00DCB59DC2",
        exponent: 0,
        aliases: ["UwU8RVXB69Y6Dcju6cN2Qef6fykkq6UUNpB15rZku6Z", "ibc/586C150919550F6106711C7557DAAAEAB765DDF05648BAC0D96487AE90394BA1"]
      }, {
        denom: "unicorn",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C91210281CEB708DC6E41A47FC9EC298F45712273DD58C682BEBAD00DCB59DC2",
      name: "Unicorn (Picasso)",
      display: "unicorn",
      symbol: "UWU.pica",
      traces: [
        {
          type: "additional-mintage",
          counterparty: {
            chain_name: "unicorn",
            base_denom: "uwunicorn"
          },
          provider: "Unicorn"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "solana",
            base_denom: "UwU8RVXB69Y6Dcju6cN2Qef6fykkq6UUNpB15rZku6Z",
            channel_id: "channel-1"
          },
          chain: {
            channel_id: "channel-71",
            path: "transfer/channel-71/UwU8RVXB69Y6Dcju6cN2Qef6fykkq6UUNpB15rZku6Z"
          }
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "composable",
            base_denom: "ibc/586C150919550F6106711C7557DAAAEAB765DDF05648BAC0D96487AE90394BA1",
            channel_id: "channel-3"
          },
          chain: {
            channel_id: "channel-1279",
            path: "transfer/channel-1279/transfer/channel-71/UwU8RVXB69Y6Dcju6cN2Qef6fykkq6UUNpB15rZku6Z"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/UWU.pica.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/UWU.pica.png"
      }, {
        image_sync: {
          chain_name: "composable",
          base_denom: "ibc/586C150919550F6106711C7557DAAAEAB765DDF05648BAC0D96487AE90394BA1"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unicorn/images/uwu.png",
        theme: {
          primary_color_hex: "#D44CE6"
        }
      }]
    },
    {
      description: "Deenar gold-backed stablecoin",
      denom_units: [{
        denom: "ibc/108604FDBE97DAEF128FD4ECFEB2A8AFC2D04A7162C97EAA2FD5BCB0869D0BBC",
        exponent: 0,
        aliases: ["erc20/0x4FEBDDe47Ab9a76200e57eFcC80b212a07b3e6cE"]
      }, {
        denom: "DEEN",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/108604FDBE97DAEF128FD4ECFEB2A8AFC2D04A7162C97EAA2FD5BCB0869D0BBC",
      name: "Deenar",
      display: "DEEN",
      symbol: "DEEN",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "comex",
          base_denom: "XAU"
        },
        provider: "Deenar"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "haqq",
          base_denom: "erc20/0x4FEBDDe47Ab9a76200e57eFcC80b212a07b3e6cE",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-1575",
          path: "transfer/channel-1575/erc20/0x4FEBDDe47Ab9a76200e57eFcC80b212a07b3e6cE"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/deen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/deen.svg"
      },
      images: [{
        image_sync: {
          chain_name: "haqq",
          base_denom: "erc20/0x4FEBDDe47Ab9a76200e57eFcC80b212a07b3e6cE"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/deen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/haqq/images/deen.svg",
        theme: {
          primary_color_hex: "#ffbc05",
          circle: !0
        }
      }]
    },
    {
      description: "CosmoUSD",
      extended_description: "Community loyalty points.",
      denom_units: [{
        denom: "factory/osmo104jtrwcljnxfljhml8mxrw7qetcsdmqvy3sprw/ucosmousd",
        exponent: 0,
        aliases: ["ucosmousd"]
      }, {
        denom: "CosmoUSD",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo104jtrwcljnxfljhml8mxrw7qetcsdmqvy3sprw/ucosmousd",
      name: "CosmoUSD",
      display: "CosmoUSD",
      symbol: "COSMOUSD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CosmoUSD.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CosmoUSD.png",
        theme: {
          primary_color_hex: "#343169"
        }
      }],
      socials: {
        website: "https://github.com/raphaellafar/Cosmo",
        twitter: "https://x.com/CosmoClub84"
      }
    },
    {
      description: "The Representative factory token for Trump Kemistry",
      denom_units: [{
        denom: "factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP",
        exponent: 0
      }, {
        denom: "XTRUMP",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl",
      base: "factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP",
      name: "XTRUMP",
      display: "XTRUMP",
      symbol: "XTRUMP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/XTRUMP.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/XTRUMP.png",
        theme: {
          primary_color_hex: "#b02b27"
        }
      }]
    },
    {
      description: "Tether USDt from Ethereum via Peggy bridge.",
      denom_units: [{
        denom: "ibc/2AD3C64D19ADFBB522CD738B58F421102143F827C1CAFF574A8BF0B81017D53D",
        exponent: 0,
        aliases: ["peggy0xdAC17F958D2ee523a2206206994597C13D831ec7"]
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2AD3C64D19ADFBB522CD738B58F421102143F827C1CAFF574A8BF0B81017D53D",
      name: "Tether USD (Ethereum) (Injective)",
      display: "usdt",
      symbol: "USDT.eth.inj",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Tether"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xdac17f958d2ee523a2206206994597c13d831ec7"
          },
          provider: "Peggy"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "injective",
            base_denom: "peggy0xdAC17F958D2ee523a2206206994597C13D831ec7",
            channel_id: "channel-8"
          },
          chain: {
            channel_id: "channel-122",
            path: "transfer/channel-122/peggy0xdAC17F958D2ee523a2206206994597C13D831ec7"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.inj.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.inj.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdt.inj.png"
      }, {
        image_sync: {
          chain_name: "injective",
          base_denom: "peggy0xdAC17F958D2ee523a2206206994597C13D831ec7"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }]
    },
    {
      description: "Fractionalized Bad Kids",
      extended_description: "Fractionalized Bad Kids NFT Via Fractal.fun",
      denom_units: [{
        denom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fBAD",
        exponent: 0
      }, {
        denom: "fBAD",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv",
      base: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fBAD",
      name: "fBAD",
      display: "fBAD",
      symbol: "fBAD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fBAD.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fBAD.png",
        theme: {
          primary_color_hex: "#639BFF"
        }
      }],
      keywords: ["nft"],
      socials: {
        website: "https://fractal.fun",
        twitter: "https://twitter.com/fractaldotfun"
      }
    },
    {
      description: "Fractionalized Mad Scientists",
      extended_description: "Fractionalized Mad Scientists NFT Via Fractal.fun",
      denom_units: [{
        denom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fMAD",
        exponent: 0
      }, {
        denom: "fMAD",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv",
      base: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fMAD",
      name: "fMAD",
      display: "fMAD",
      symbol: "fMAD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fMAD.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fMAD.png",
        theme: {
          primary_color_hex: "#639BFF"
        }
      }],
      keywords: ["nft"],
      socials: {
        website: "https://fractal.fun",
        twitter: "https://twitter.com/fractaldotfun"
      }
    },
    {
      description: "Fractionalized Celestine Sloth Society",
      extended_description: "Fractionalized Celestine Sloth Society NFT Via Fractal.fun",
      denom_units: [{
        denom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fSLOTH",
        exponent: 0
      }, {
        denom: "fSLOTH",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv",
      base: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fSLOTH",
      name: "fSLOTH",
      display: "fSLOTH",
      symbol: "fSLOTH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fSLOTH.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fSLOTH.png",
        theme: {
          primary_color_hex: "#639BFF"
        }
      }],
      keywords: ["nft"],
      socials: {
        website: "https://fractal.fun",
        twitter: "https://twitter.com/fractaldotfun"
      }
    },
    {
      description: "Fractionalized DAONuts",
      extended_description: "Fractionalized DAONuts NFT Via Fractal.fun",
      denom_units: [{
        denom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fNUT",
        exponent: 0
      }, {
        denom: "fNUT",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv",
      base: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fNUT",
      name: "fNUT",
      display: "fNUT",
      symbol: "fNUT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fNUT.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fNUT.png",
        theme: {
          primary_color_hex: "#639BFF"
        }
      }],
      keywords: ["nft"],
      socials: {
        website: "https://fractal.fun",
        twitter: "https://twitter.com/fractaldotfun"
      }
    },
    {
      description: "Mars Protocol is a cross-collateralized Money Market Protocol on Neutron and Osmosis",
      denom_units: [{
        denom: "ibc/B67DF59507B3755EEDE0866C449445BD54B4DA82CCEBA89D775E53DC35664255",
        exponent: 0,
        aliases: ["umars"]
      }, {
        denom: "MARS",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B67DF59507B3755EEDE0866C449445BD54B4DA82CCEBA89D775E53DC35664255",
      name: "Mars Protocol token",
      display: "MARS",
      symbol: "MARS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ndu2wvkrxtane8se2tr48gv7nsm46y5gcqjhux/MARS",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-874",
          path: "transfer/channel-874/factory/neutron1ndu2wvkrxtane8se2tr48gv7nsm46y5gcqjhux/MARS"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.svg"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ndu2wvkrxtane8se2tr48gv7nsm46y5gcqjhux/MARS"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.svg",
        theme: {
          primary_color_hex: "#ef4136"
        }
      }]
    },
    {
      description: "The native token of TON",
      denom_units: [{
        denom: "ibc/905889A7F0B94F1CE1506D9BADF13AE9141E4CBDBCD565E1DFC7AE418B3E3E98",
        exponent: 0,
        aliases: ["nanoTon"]
      }, {
        denom: "ton",
        exponent: 9
      }],
      type_asset: "ics20",
      base: "ibc/905889A7F0B94F1CE1506D9BADF13AE9141E4CBDBCD565E1DFC7AE418B3E3E98",
      name: "TON (The Open Network) (Oraichain)",
      display: "ton",
      symbol: "TON.orai",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ton",
          base_denom: "nanoton"
        },
        provider: "Oraichain Labs TON Bridge"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "oraichain",
          base_denom: "factory/orai1wuvhex9xqs3r539mvc6mtm7n20fcj3qr2m0y9khx6n5vtlngfzes3k0rq9/ton",
          channel_id: "channel-13"
        },
        chain: {
          channel_id: "channel-216",
          path: "transfer/channel-216/factory/orai1wuvhex9xqs3r539mvc6mtm7n20fcj3qr2m0y9khx6n5vtlngfzes3k0rq9/ton"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ton.orai.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ton.orai.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ton.orai.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ton.orai.png"
      }, {
        image_sync: {
          chain_name: "oraichain",
          base_denom: "factory/orai1wuvhex9xqs3r539mvc6mtm7n20fcj3qr2m0y9khx6n5vtlngfzes3k0rq9/ton"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.png",
        theme: {
          circle: !0,
          primary_color_hex: "#0088CC",
          background_color_hex: "#0088CC"
        }
      }]
    },
    {
      description: "An alloy of TON asset variants on Osmosis.",
      extended_description: "Multiple Toncoin variants on Osmosis comprise the liquidity backing of a tokenized transmuter pool to create an alloy of TON.",
      denom_units: [{
        denom: "factory/osmo12lnwf54yd30p6amzaged2atln8k0l32n7ncxf04ctg7u7ymnsy7qkqgsw4/alloyed/allTON",
        exponent: 0
      }, {
        denom: "ton",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo12lnwf54yd30p6amzaged2atln8k0l32n7ncxf04ctg7u7ymnsy7qkqgsw4",
      base: "factory/osmo12lnwf54yd30p6amzaged2atln8k0l32n7ncxf04ctg7u7ymnsy7qkqgsw4/alloyed/allTON",
      name: "TON (The Open Network)",
      display: "ton",
      symbol: "TON",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "ton",
          base_denom: "nanoton"
        },
        provider: "Osmosis"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ton",
          base_denom: "nanoton"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ton/images/ton.png",
        theme: {
          circle: !0,
          primary_color_hex: "#0088CC",
          background_color_hex: "#0088CC"
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allTON.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/allTON.png",
        theme: {
          primary_color_hex: "#0088CC"
        }
      }]
    },
    {
      description: "The native token of Furya",
      denom_units: [{
        denom: "ibc/42D0FBF9DDC72D7359D309A93A6DF9F6FDEE3987EA1C5B3CDE95C06FCE183F12",
        exponent: 0,
        aliases: ["ufury"]
      }, {
        denom: "fury",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/42D0FBF9DDC72D7359D309A93A6DF9F6FDEE3987EA1C5B3CDE95C06FCE183F12",
      name: "furya",
      display: "fury",
      symbol: "FURY",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "furya",
          base_denom: "ufury",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-8690",
          path: "transfer/channel-8690/ufury"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.svg"
      },
      images: [{
        image_sync: {
          chain_name: "furya",
          base_denom: "ufury"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/furya/images/fury.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      keywords: ["gaming", "staking"]
    },
    {
      description: "PUNDIX token is the native token that functions within the Pundi X ecosystem, including PundiX Chain and XPOS.",
      denom_units: [{
        denom: "ibc/2EB516F83C9FF44AB6826F269CA98A5622608C6C955E12112E58F23A324FEE07",
        exponent: 0,
        aliases: ["ibc/55367B7B6572631B78A93C66EF9FDFCE87CDE372CC4ED7848DA78C1EB1DCDD78"]
      }, {
        denom: "PUNDIX",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/2EB516F83C9FF44AB6826F269CA98A5622608C6C955E12112E58F23A324FEE07",
      name: "Pundi X Token",
      display: "PUNDIX",
      symbol: "PUNDIX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "fxcore",
          base_denom: "eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"
        }
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "pundix",
          base_denom: "ibc/55367B7B6572631B78A93C66EF9FDFCE87CDE372CC4ED7848DA78C1EB1DCDD78",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-12618",
          path: "transfer/channel-12618/transfer/channel-0/eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pundix.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/pundix.png",
        theme: {
          primary_color_hex: "#f1d20c"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "The native token of dHealth",
      denom_units: [{
        denom: "ibc/320F8D6EC17E14436D19C6D844BB9A5AE9B9A209F6D18364A2191FF08E8732A9",
        exponent: 0,
        aliases: ["udhp"]
      }, {
        denom: "dhp",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/320F8D6EC17E14436D19C6D844BB9A5AE9B9A209F6D18364A2191FF08E8732A9",
      name: "dHealth",
      display: "dhp",
      symbol: "DHP",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "dhealth",
          base_denom: "udhp",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-38776",
          path: "transfer/channel-38776/udhp"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.svg"
      },
      images: [{
        image_sync: {
          chain_name: "dhealth",
          base_denom: "udhp"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dhealth/images/dhp.svg",
        theme: {
          primary_color_hex: "#140c7c"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "The native EVM and Wasm, governance and staking token of the Shido Chain",
      denom_units: [{
        denom: "ibc/BBE825F7D1673E1EBF05AB02000E23E6077967B79547A3733B60AE4ED62C4D32",
        exponent: 0,
        aliases: ["shido"]
      }, {
        denom: "SHIDO",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/BBE825F7D1673E1EBF05AB02000E23E6077967B79547A3733B60AE4ED62C4D32",
      name: "Shido",
      display: "SHIDO",
      symbol: "SHIDO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "shido",
          base_denom: "shido",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-38921",
          path: "transfer/channel-38921/shido"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.svg"
      },
      images: [{
        image_sync: {
          chain_name: "shido",
          base_denom: "shido"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.svg",
        theme: {
          primary_color_hex: "#046ffc"
        }
      }],
      keywords: ["osmosis_unlisted"]
    },
    {
      description: "The Revenue & Governance token of Unstake.fi",
      denom_units: [{
        denom: "ibc/F74225B0AFD2F675AF56E9BE3F235486BCDE5C5E09AA88A97AFD2E052ABFE04C",
        exponent: 0,
        aliases: ["factory/kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh/unstk"]
      }, {
        denom: "nstk",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F74225B0AFD2F675AF56E9BE3F235486BCDE5C5E09AA88A97AFD2E052ABFE04C",
      name: "Unstake Fi",
      display: "nstk",
      symbol: "NSTK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kujira",
          base_denom: "factory/kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh/unstk",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-259",
          path: "transfer/channel-259/factory:kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh:unstk"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nstk.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kujira",
          base_denom: "factory/kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh/unstk"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/nstk.svg"
      }]
    },
    {
      denom_units: [{
        denom: "ibc/0B3C3D06228578334B66B57FBFBA4033216CEB8119B27ACDEE18D92DA5B28D43",
        exponent: 0,
        aliases: ["avalanche-uusdc"]
      }, {
        denom: "avalanche-usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/0B3C3D06228578334B66B57FBFBA4033216CEB8119B27ACDEE18D92DA5B28D43",
      name: "Wormhole USDC(Avalanche)",
      display: "avalanche-usdc",
      symbol: "avalanche.USDC.wh",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "gateway",
          base_denom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4",
          channel_id: "channel-3"
        },
        chain: {
          channel_id: "channel-2186",
          path: "transfer/channel-2186/factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4"
        }
      }],
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.hole.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.hole.svg",
        theme: {
          primary_color_hex: "#2474cb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.hole.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.hole.svg"
      }
    },
    {
      description: "Nomic's native token.",
      denom_units: [{
        denom: "ibc/F49DFB3BC8105C57EE7F17EC2402438825B31212CFDD81681EB87911E934F32C",
        exponent: 0,
        aliases: ["unom"]
      }, {
        denom: "nom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F49DFB3BC8105C57EE7F17EC2402438825B31212CFDD81681EB87911E934F32C",
      name: "Nomic",
      display: "nom",
      symbol: "nomic.NOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nomic",
          base_denom: "unom",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-6897",
          path: "transfer/channel-6897/unom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "nomic",
          base_denom: "unom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg",
        theme: {
          primary_color_hex: "#6404fc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg"
      }
    },
    {
      description: "The governance and utility token of Yieldmos, the Interchain Automation Protocol",
      denom_units: [{
        denom: "factory/osmo1vdvnznwg597qngrq9mnfcfk0am9jdc9y446jewhcqdreqz4r75xq5j5zvy/ymos",
        exponent: 0
      }, {
        denom: "ymos",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1vdvnznwg597qngrq9mnfcfk0am9jdc9y446jewhcqdreqz4r75xq5j5zvy",
      base: "factory/osmo1vdvnznwg597qngrq9mnfcfk0am9jdc9y446jewhcqdreqz4r75xq5j5zvy/ymos",
      name: "Yieldmos Coin",
      display: "ymos",
      symbol: "YMOS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ymos.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ymos.png",
        theme: {
          primary_color_hex: "#2c3554"
        }
      }]
    },
    {
      description: "Memecoin for The International Brane Wave",
      denom_units: [{
        denom: "factory/osmo13gu58hzw3e9aqpj25h67m7snwcjuccd7v4p55w/brnz",
        exponent: 0,
        aliases: ["brnz"]
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo13gu58hzw3e9aqpj25h67m7snwcjuccd7v4p55w/brnz",
      name: "Branez",
      display: "factory/osmo13gu58hzw3e9aqpj25h67m7snwcjuccd7v4p55w/brnz",
      symbol: "BRNZ",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/BRNZ.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/BRNZ.svg"
      }]
    },
    {
      description: "ashLAB - Burned LAB",
      extended_description: "ashLAB - receipt token recieved when burning LAB via ASH DAOs Furnace",
      denom_units: [{
        denom: "factory/osmo1svj5kd8kzj7xxtrd6ftjk0856ffpyj4egz7f9pd9dge5wr4kwansmefq07/lab.ash",
        exponent: 0
      }, {
        denom: "ashLAB",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      address: "osmo1svj5kd8kzj7xxtrd6ftjk0856ffpyj4egz7f9pd9dge5wr4kwansmefq07",
      base: "factory/osmo1svj5kd8kzj7xxtrd6ftjk0856ffpyj4egz7f9pd9dge5wr4kwansmefq07/lab.ash",
      name: "Burned LAB",
      display: "ashLAB",
      symbol: "ashLAB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ashLAB.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ashLAB.png",
        theme: {
          primary_color_hex: "#ebb093"
        }
      }]
    },
    {
      description: "GRAC is the official token of Racoon.Bet's gaming platform.",
      denom_units: [{
        denom: "ibc/58E4261D2E21FE3A459C290A9F97F3DCD257B28F48AAE828298B38E048804829",
        exponent: 0,
        aliases: ["factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/ugrac"]
      }, {
        denom: "grac",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/58E4261D2E21FE3A459C290A9F97F3DCD257B28F48AAE828298B38E048804829",
      name: "Gaming RAC Token",
      display: "grac",
      symbol: "GRAC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/ugrac",
          channel_id: "channel-5"
        },
        chain: {
          channel_id: "channel-642",
          path: "transfer/channel-642/factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/ugrac"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/grac.png"
      },
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/ugrac"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/grac.png",
        theme: {
          primary_color_hex: "#f5bf09"
        }
      }]
    },
    {
      description: "USDC supplied on Mars looped using Membrane by a vault",
      denom_units: [{
        denom: "factory/osmo1vf6e300hv2qe7r5rln8deft45ewgyytjnwfrdfcv5rgzrfy0s6cswjqf9r/mars-usdc-looped",
        exponent: 0
      }, {
        denom: "loopedUSDCmars",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo1vf6e300hv2qe7r5rln8deft45ewgyytjnwfrdfcv5rgzrfy0s6cswjqf9r/mars-usdc-looped",
      name: "Mars Looped USDC",
      display: "loopedUSDCmars",
      symbol: "loopedUSDCmars"
    },
    {
      denom_units: [{
        denom: "factory/osmo1xu0gk9aggv79597xwazyfzaggv2pze9z7cq3p9p72tkkux9a7xaqufa792/BVT",
        exponent: 0
      }, {
        denom: "BVT0",
        exponent: 18
      }],
      description: "Banana Vault Token - Peelworks Factory II",
      type_asset: "sdk.coin",
      base: "factory/osmo1xu0gk9aggv79597xwazyfzaggv2pze9z7cq3p9p72tkkux9a7xaqufa792/BVT",
      name: "Peelworks Factory",
      display: "BVT0",
      symbol: "BVT0",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/BVT0.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/BVT0.png",
        theme: {
          primary_color_hex: "#203135"
        }
      }]
    },
    {
      description: "Banana Vault Token - Banana Beach (🍹,🌴) II",
      denom_units: [{
        denom: "factory/osmo16nxtnrnl7lctvnhhpcxqmmpv63n93zgg0ukaveyc0jl4dtad79cs53c3an/BVT",
        exponent: 0
      }, {
        denom: "BVT1",
        exponent: 18
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo16nxtnrnl7lctvnhhpcxqmmpv63n93zgg0ukaveyc0jl4dtad79cs53c3an/BVT",
      name: "Banana Beach",
      display: "BVT1",
      symbol: "BVT1",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/BVT1.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/BVT1.png",
        theme: {
          primary_color_hex: "#00bdc3"
        }
      }]
    },
    {
      description: "Avail is a web3 infrastructure layer that allows modular execution layers to scale and interoperate in a trust minimized way.",
      type_asset: "sdk.coin",
      address: "osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9",
      denom_units: [{
        denom: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/AVAIL.rt",
        exponent: 0,
        aliases: [
          "0xEeB4d8400AEefafC1B2953e0094134A887C76Bd8",
          "avail-wei",
          "avail"
        ]
      }, {
        denom: "AVAIL",
        exponent: 18
      }],
      base: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/AVAIL.rt",
      name: "Avail",
      display: "AVAIL",
      symbol: "AVAIL",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereum",
          base_denom: "0xEeB4d8400AEefafC1B2953e0094134A887C76Bd8"
        },
        provider: "Router"
      }],
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/avail.eth.rt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/avail.eth.rt.png",
        theme: {
          circle: !1,
          primary_color_hex: "#2B80D7"
        }
      }, {
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xEeB4d8400AEefafC1B2953e0094134A887C76Bd8"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avail/images/avail.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avail/images/avail.png",
        theme: {
          circle: !1,
          primary_color_hex: "#2B80D7"
        }
      }]
    },
    {
      description: "Fractionalized Pixel Wizards",
      extended_description: "Fractionalized Pixel Wizards NFT Via Fractal.fun",
      denom_units: [{
        denom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fWIZ",
        exponent: 0
      }, {
        denom: "fWIZ",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv",
      base: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fWIZ",
      name: "fWIZ",
      display: "fWIZ",
      symbol: "fWIZ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fWIZ.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fWIZ.png",
        theme: {
          primary_color_hex: "#639BFF"
        }
      }],
      keywords: ["nft"],
      socials: {
        website: "https://fractal.fun",
        twitter: "https://twitter.com/fractaldotfun"
      }
    },
    {
      description: "Fractionalized Pixel Witches",
      extended_description: "Fractionalized Pixel Witches NFT Via Fractal.fun",
      denom_units: [{
        denom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fWITCH",
        exponent: 0
      }, {
        denom: "fWITCH",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv",
      base: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fWITCH",
      name: "fWITCH",
      display: "fWITCH",
      symbol: "fWITCH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fWITCH.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fWITCH.png",
        theme: {
          primary_color_hex: "#639BFF"
        }
      }],
      keywords: ["nft"],
      socials: {
        website: "https://fractal.fun",
        twitter: "https://twitter.com/fractaldotfun"
      }
    },
    {
      description: "Fractionalized Cryptonium Maker",
      extended_description: "Fractionalized Cryptonium Maker NFT Via Fractal.fun",
      denom_units: [{
        denom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fCRYPTONIUM",
        exponent: 0
      }, {
        denom: "fCRYPTONIUM",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv",
      base: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fCRYPTONIUM",
      name: "fCRYPTONIUM",
      display: "fCRYPTONIUM",
      symbol: "fCRYPTONIUM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fCRYPTONIUM.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fCRYPTONIUM.png",
        theme: {
          primary_color_hex: "#639BFF"
        }
      }],
      keywords: ["nft"],
      socials: {
        website: "https://fractal.fun",
        twitter: "https://twitter.com/fractaldotfun"
      }
    },
    {
      description: "Fractionalized Geckies",
      extended_description: "Fractionalized Geckies NFT Via Fractal.fun",
      denom_units: [{
        denom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fGECK",
        exponent: 0
      }, {
        denom: "fGECK",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv",
      base: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fGECK",
      name: "fGECK",
      display: "fGECK",
      symbol: "fGECK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fGECK.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fGECK.png",
        theme: {
          primary_color_hex: "#639BFF"
        }
      }],
      keywords: ["nft"],
      socials: {
        website: "https://fractal.fun",
        twitter: "https://twitter.com/fractaldotfun"
      }
    },
    {
      description: "Fractionalized Atlas DAO",
      extended_description: "Fractionalized Atlas DAO NFT Via Fractal.fun",
      denom_units: [{
        denom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fATLAS",
        exponent: 0
      }, {
        denom: "fATLAS",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv",
      base: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fATLAS",
      name: "fATLAS",
      display: "fATLAS",
      symbol: "fATLAS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fATLAS.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fATLAS.png",
        theme: {
          primary_color_hex: "#639BFF"
        }
      }],
      keywords: ["nft"],
      socials: {
        website: "https://fractal.fun",
        twitter: "https://twitter.com/fractaldotfun"
      }
    },
    {
      description: "Fractionalized Rekt Bulls",
      extended_description: "Fractionalized Rekt Bulls NFT Via Fractal.fun",
      denom_units: [{
        denom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fBULLS",
        exponent: 0
      }, {
        denom: "fBULLS",
        exponent: 9
      }],
      type_asset: "sdk.coin",
      address: "osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv",
      base: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fBULLS",
      name: "fBULLS",
      display: "fBULLS",
      symbol: "fBULLS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fBULLS.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/fBULLS.png",
        theme: {
          primary_color_hex: "#639BFF"
        }
      }],
      keywords: ["nft"],
      socials: {
        website: "https://fractal.fun",
        twitter: "https://twitter.com/fractaldotfun"
      }
    },
    {
      description: "Roostock BTC bridged via Router.",
      type_asset: "sdk.coin",
      address: "osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9",
      denom_units: [{
        denom: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/BTC.rt",
        exponent: 0,
        aliases: ["0x542FDA317318eBf1d3DeAF76E0B632741a7e677d", "sat"]
      }, {
        denom: "rbtc",
        exponent: 18
      }],
      base: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/BTC.rt",
      name: "Rootstock Smart Bitcoin",
      display: "rbtc",
      symbol: "RBTC",
      traces: [{
        type: "synthetic",
        counterparty: {
          chain_name: "rootstock",
          base_denom: "0x542FDA317318eBf1d3DeAF76E0B632741a7e677d"
        },
        provider: "Router"
      }],
      images: [{
        image_sync: {
          chain_name: "rootstock",
          base_denom: "sat"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/rootstock/images/rbtc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/rootstock/images/rbtc.png",
        theme: {
          circle: !1,
          primary_color_hex: "#FF9931",
          background_color_hex: "#00000000"
        }
      }]
    },
    {
      description: "Chain-key Bitcoin bridged via Omnity Network.",
      address: "osmo10c4y9csfs8q7mtvfg4p9gd8d0acx0hpc2mte9xqzthd7rd3348tsfhaesm",
      denom_units: [{
        denom: "factory/osmo10c4y9csfs8q7mtvfg4p9gd8d0acx0hpc2mte9xqzthd7rd3348tsfhaesm/sICP-icrc-ckBTC",
        exponent: 0,
        aliases: ["uckBTC"]
      }, {
        denom: "ckBTC",
        exponent: 8
      }],
      type_asset: "sdk.coin",
      base: "factory/osmo10c4y9csfs8q7mtvfg4p9gd8d0acx0hpc2mte9xqzthd7rd3348tsfhaesm/sICP-icrc-ckBTC",
      name: "Chain-key Bitcoin",
      display: "ckBTC",
      symbol: "ckBTC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "internetcomputer",
          base_denom: "uckBTC"
        },
        provider: "Omnity Network"
      }],
      images: [{
        image_sync: {
          chain_name: "internetcomputer",
          base_denom: "uckBTC"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/internetcomputer/images/ckbtc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/internetcomputer/images/ckbtc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#3B00B9",
          background_color_hex: "#3B00B9"
        }
      }]
    }
  ]
};
mv.default = QU;
var hv = {};
Object.defineProperty(hv, "__esModule", { value: !0 });
const eH = {
  $schema: "../chain.schema.json",
  chain_name: "osmosis",
  status: "live",
  network_type: "mainnet",
  website: "https://osmosis.zone/",
  update_link: "https://raw.githubusercontent.com/osmosis-labs/osmosis/main/chain.schema.json",
  pretty_name: "Osmosis",
  chain_type: "cosmos",
  chain_id: "osmosis-1",
  bech32_prefix: "osmo",
  daemon_name: "osmosisd",
  node_home: "$HOME/.osmosisd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uosmo",
      fixed_min_gas_price: 25e-4,
      low_gas_price: 25e-4,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uosmo"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {
    cosmos_sdk_version: "osmosis-labs/cosmos-sdk v0.47.5-v25-osmo-1",
    cosmwasm_enabled: !0,
    cosmwasm_version: "osmosis-labs/wasmd v0.45.0-osmo"
  },
  images: [{
    image_sync: {
      chain_name: "osmosis",
      base_denom: "uosmo"
    },
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
    theme: {
      primary_color_hex: "#760dbb"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
  },
  description: `Osmosis (OSMO) is the premier DEX and cross-chain DeFi hub within the Cosmos ecosystem, a network of over 50 sovereign, interoperable blockchains seamlessly connected through the Inter-Blockchain Communication Protocol (IBC). Pioneering in its approach, Osmosis offers a dynamic trading and liquidity provision experience, integrating non-IBC assets from other ecosystems, including Ethereum, Solana, Avalanche, and Polkadot. Initially adopting Balancer-style pools, Osmosis now also features a concentrated liquidity model that is orders of magnitude more capital efficient, meaning that significantly less liquidity is required to handle the same amount of trading volume with minimal slippage.

As a true appchain, Osmosis has greater control over the full blockchain stack than traditional smart contract DEXs, which must follow the code of the parent chain that it is built on. This fine-grained control has enabled, for example, the development of Superfluid Staking, an extension of Proof of Stake that allows assets at the application layer to be staked to secure the chain. The customizability of appchains also allows implementing features like the Protocol Revenue module, which enables Osmosis to conduct on-chain arbitrage on behalf of OSMO stakers, balancing prices across pools while generating real yield revenue from this volume. Additionally, as a sovereign appchain, Osmosis governance can vote on upgrades to the protocol. One example of this was the introduction of a Taker Fee, which switched on the collection of exchange fees to generate diverse yield from Osmosis volume and distribute it to OSMO stakers.

Osmosis is bringing the full centralized exchange experience to the decentralized world by building a cross-chain native DEX and trading suite that connects all chains over IBC, including Ethereum and Bitcoin. To reach this goal, Osmosis hosts an ever-expanding suite of DeFi applications aimed at providing a one-stop experience that includes lending, credit, margin, DeFi strategy vaults, power perps, fiat on-ramps, NFTs, stablecoins, and more — all of the functionalities that centralized exchange offer and more, in the trust-minimized environment of decentralized finance.`,
  apis: {
    rpc: [
      {
        address: "https://rpc.osmosis.zone/",
        provider: "Osmosis Foundation"
      },
      {
        address: "https://rpc-osmosis.blockapsis.com",
        provider: "chainapsis"
      },
      {
        address: "https://osmosis-rpc.onivalidator.com",
        provider: "Oni Validator ⛩️"
      },
      {
        address: "https://osmosis-rpc.quickapi.com:443",
        provider: "Chainlayer"
      },
      {
        address: "https://rpc-osmosis.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://rpc.lavenderfive.com:443/osmosis",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-osmosis.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://rpc-osmosis.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://osmosis-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-osmosis-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "https://osmosis.rpc.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://osmosis-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://osmosis.api.onfinality.io/public",
        provider: "OnFinality"
      },
      {
        address: "https://rpc-osmosis-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://osmosis-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://osmosis-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://community.nuxian-node.ch:6797/osmosis/trpc",
        provider: "PRO Delegators"
      },
      {
        address: "http://rpc-osmosis.freshstaking.com:31657",
        provider: "FreshSTAKING"
      },
      {
        address: "https://osmosis-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://osmosis-mainnet.rpc.l0vd.com:443",
        provider: "L0vd.com ❤️"
      },
      {
        address: "https://osmosis-rpc.reece.sh",
        provider: "Reecepbcups"
      },
      {
        address: "https://rpc.osmosis.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://rpc.osmosis.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://osmosis.interstellar-lounge.org",
        provider: "Interstellar Lounge 🍸"
      },
      {
        address: "https://public.stakewolle.com/cosmos/osmosis/rpc",
        provider: "Stakewolle"
      },
      {
        address: "https://rpc.cros-nest.com/osmosis",
        provider: "Crosnest"
      },
      {
        address: "https://rpc-osmo.kewrnode.com",
        provider: "Kewr Node"
      },
      {
        address: "https://rpc.osmosis.goldenratiostaking.net",
        provider: "Golden Ratio Staking"
      },
      {
        address: "https://osmosis-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://osmosis.drpc.org",
        provider: "dRPC"
      }
    ],
    rest: [
      {
        address: "https://lcd.osmosis.zone/",
        provider: "Osmosis Foundation"
      },
      {
        address: "https://rest.osmosis.goldenratiostaking.net",
        provider: "Golden Ratio Staking"
      },
      {
        address: "https://osmosis-lcd.quickapi.com:443",
        provider: "Chainlayer"
      },
      {
        address: "https://lcd-osmosis.blockapsis.com",
        provider: "chainapsis"
      },
      {
        address: "https://rest.lavenderfive.com:443/osmosis",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rest-osmosis.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://api-osmosis-ia.cosmosia.notional.ventures",
        provider: "Notional"
      },
      {
        address: "https://api-osmosis.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://osmosis-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://osmosis.rest.stakin-nodes.com",
        provider: "Stakin"
      },
      {
        address: "https://osmosis-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://api-osmosis-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://osmosis-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://lcd-osmosis.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://osmosis-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://community.nuxian-node.ch:6797/osmosis/crpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://osmosis-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://osmosis-api.reece.sh",
        provider: "Reecepbcups"
      },
      {
        address: "https://api.osmosis.validatus.com:443",
        provider: "Validatus"
      },
      {
        address: "https://lcd.osmosis.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://osmosis-rest.interstellar-lounge.org",
        provider: "Interstellar Lounge 🍸"
      },
      {
        address: "https://public.stakewolle.com/cosmos/osmosis/rest",
        provider: "Stakewolle"
      },
      {
        address: "https://rest.cros-nest.com/osmosis",
        provider: "Crosnest"
      },
      {
        address: "https://rest-osmo.kewrnode.com",
        provider: "Kewr Node"
      },
      {
        address: "https://osmosis-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "osmosis.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "grpc-osmosis-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "osmosis.grpc.stakin-nodes.com:443",
        provider: "Stakin"
      },
      {
        address: "osmosis-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-osmosis.cosmos-spaces.cloud:1130",
        provider: "Cosmos Spaces"
      },
      {
        address: "grpc-osmosis-01.stakeflow.io:6754",
        provider: "Stakeflow"
      },
      {
        address: "services.staketab.com:9010",
        provider: "Staketab"
      },
      {
        address: "osmosis-grpc.w3coins.io:12590",
        provider: "w3coins"
      },
      {
        address: "grpc-osmosis.mms.team:443",
        provider: "MMS"
      },
      {
        address: "osmosis-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "osmosis-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "https://grpc-osmosis.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "osmosis-mainnet.grpc.l0vd.com:80",
        provider: "L0vd.com ❤️"
      },
      {
        address: "grpc-osmosis.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "grpc.osmosis.validatus.com:443",
        provider: "Validatus"
      },
      {
        address: "https://grpc.osmosis.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "osmosis-grpc.noders.services:10090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/osmosis",
      tx_page: "https://ezstaking.app/osmosis/txs/${txHash}",
      account_page: "https://ezstaking.app/osmosis/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/osmosis",
      tx_page: "https://www.mintscan.io/osmosis/transactions/${txHash}",
      account_page: "https://www.mintscan.io/osmosis/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/osmosis",
      tx_page: "https://ping.pub/osmosis/tx/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://osmosis.explorers.guru",
      tx_page: "https://osmosis.explorers.guru/transaction/${txHash}",
      account_page: "https://osmosis.explorers.guru/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/osmosis",
      tx_page: "https://atomscan.com/osmosis/transactions/${txHash}",
      account_page: "https://atomscan.com/osmosis/accounts/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/osmosis",
      tx_page: "https://explorer.tcnetwork.io/osmosis/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/osmosis/account/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/osmosis",
      account_page: "https://stakeflow.io/osmosis/accounts/${accountAddress}"
    },
    {
      kind: "Nodeist Explorer",
      url: "https://exp.nodeist.net/osmosis",
      tx_page: "https://exp.nodeist.net/osmosis/tx/${txHash}"
    },
    {
      kind: "L0vd.com ❤️",
      url: "https://explorers.l0vd.com/osmosis-mainnet",
      tx_page: "https://explorers.l0vd.com/osmosis-mainnet/tx/${txHash}"
    },
    {
      kind: "Chainscope",
      url: "https://chainsco.pe/osmosis",
      tx_page: "https://chainsco.pe/osmosis/tx/${txHash}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/osmosis",
      tx_page: "https://mainnet.whispernode.com/osmosis/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/osmosis/account/${accountAddress}"
    }
  ],
  keywords: ["dex"]
};
hv.default = eH;
var pv = {};
Object.defineProperty(pv, "__esModule", { value: !0 });
const nH = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "8ball",
      client_id: "07-tendermint-2",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2668",
      connection_id: "connection-2163"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-641",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2316",
      connection_id: "connection-1814"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-490",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2109",
      connection_id: "connection-1649"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-320",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aioz",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2785",
      connection_id: "connection-2285"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-779",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-18",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-0",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-19",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3250",
      connection_id: "connection-2735"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-81924",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2850",
      connection_id: "connection-2362"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-1",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-1429",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live"
        }
      },
      {
        chain_1: {
          channel_id: "*",
          port_id: "wasm.*"
        },
        chain_2: {
          channel_id: "*",
          port_id: "icahost"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live"
        }
      },
      {
        chain_1: {
          channel_id: "*",
          port_id: "wasm.*"
        },
        chain_2: {
          channel_id: "*",
          port_id: "icqhost"
        },
        ordering: "unordered",
        version: "icq-1",
        tags: {
          status: "live"
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "arkh",
      client_id: "07-tendermint-34",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2697",
      connection_id: "connection-2235"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-648",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "assetmantle",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1923",
      connection_id: "connection-1498"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-232",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-47",
      connection_id: "connection-33"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3054",
      connection_id: "connection-2551"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11304",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-23",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1862",
      connection_id: "connection-1453"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-208",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bandchain",
      client_id: "07-tendermint-94",
      connection_id: "connection-91"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1743",
      connection_id: "connection-1345"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-83",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-148",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "beezee",
      client_id: "07-tendermint-2",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2154",
      connection_id: "connection-1672"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-340",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitcanna",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1499",
      connection_id: "connection-1167"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bitsong",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1551",
      connection_id: "connection-1216"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-73",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bluzelle",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2754",
      connection_id: "connection-2273"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-763",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bostrom",
      client_id: "07-tendermint-5",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1597",
      connection_id: "connection-1255"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-95",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "canto",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2481",
      connection_id: "connection-2017"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-550",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-3",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1808",
      connection_id: "connection-1412"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-188",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-10",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3012",
      connection_id: "connection-2503"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6994",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cerberus",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1875",
      connection_id: "connection-1460"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-212",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chain4energy",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3107",
      connection_id: "connection-2586"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-22172",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cheqd",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1615",
      connection_id: "connection-1268"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-108",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-45",
      connection_id: "connection-25"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1666",
      connection_id: "connection-1278"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-113",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-73",
        port_id: "wasm.chihuahua1jwkag4yvhyj9fuddtkygvavya8hmdjuzmgxwg9vp3lw9twv6lrcq9mgl52"
      },
      chain_2: {
        channel_id: "channel-11348",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cifer",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3184",
      connection_id: "connection-2646"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-39205",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1587",
      connection_id: "connection-1243"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-87",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2846",
      connection_id: "connection-2358"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1279",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "conscious",
      client_id: "07-tendermint-12",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3199",
      connection_id: "connection-2656"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-73971",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2929",
      connection_id: "connection-2426"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2188",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-259",
      connection_id: "connection-257"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-141",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-17",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2083",
      connection_id: "connection-1624"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-297",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-33",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-4",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cudos",
      client_id: "07-tendermint-2084",
      connection_id: "connection-1626"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-298",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "decentr",
      client_id: "07-tendermint-6",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1798",
      connection_id: "connection-1403"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-181",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "desmos",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1726",
      connection_id: "connection-1315"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-135",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dhealth",
      client_id: "07-tendermint-4",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3205",
      connection_id: "connection-2662"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-75030",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dig",
      client_id: "07-tendermint-13",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1714",
      connection_id: "connection-1304"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-128",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-0",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2959",
      connection_id: "connection-2454"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2694",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-3",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3009",
      connection_id: "connection-2500"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6787",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3086",
      connection_id: "connection-2566"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-19774",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dyson",
      client_id: "07-tendermint-2",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2407",
      connection_id: "connection-1895"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-526",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "echelon",
      client_id: "07-tendermint-107",
      connection_id: "connection-29"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2268",
      connection_id: "connection-1760"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-403",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "emoney",
      client_id: "07-tendermint-7",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1447",
      connection_id: "connection-1132"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "empowerchain",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2848",
      connection_id: "connection-2360"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1411",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1840",
      connection_id: "connection-1440"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-204",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "fetchhub",
      client_id: "07-tendermint-10",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1913",
      connection_id: "connection-1490"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-229",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "firmachain",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3236",
      connection_id: "connection-2723"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-79241",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "furya",
      client_id: "07-tendermint-10",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3201",
      connection_id: "connection-2658"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-74222",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "fxcore",
      client_id: "07-tendermint-23",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2961",
      connection_id: "connection-2456"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2716",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "galaxy",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1928",
      connection_id: "connection-1500"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-236",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gateway",
      client_id: "07-tendermint-8",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2927",
      connection_id: "connection-2424"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2186",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "genesisl1",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1983",
      connection_id: "connection-1539"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-253",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gitopia",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2787",
      connection_id: "connection-2287"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-781",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-13",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1737",
      connection_id: "connection-1340"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-144",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "haqq",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2871",
      connection_id: "connection-2388"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1575",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "humans",
      client_id: "07-tendermint-13",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3091",
      connection_id: "connection-2570"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20082",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "impacthub",
      client_id: "07-tendermint-12",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1451",
      connection_id: "connection-1137"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "imversed",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2366",
      connection_id: "connection-1866"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-517",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-19",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1703",
      connection_id: "connection-1298"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-122",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-5",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-5",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "jackal",
      client_id: "07-tendermint-2",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2273",
      connection_id: "connection-1762"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-412",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1457",
      connection_id: "connection-1142"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-47",
        port_id: "wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn"
      },
      chain_2: {
        channel_id: "channel-169",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1735",
      connection_id: "connection-1328"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-143",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kichain",
      client_id: "07-tendermint-4",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1564",
      connection_id: "connection-1225"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-77",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-18",
        port_id: "wasm.ki1hzz0s0ucrhdp6tue2lxk3c03nj6f60qy463we7lgx0wudd72ctmsd9kgha"
      },
      chain_2: {
        channel_id: "channel-261",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "konstellation",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1778",
      connection_id: "connection-1384"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-171",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2017",
      connection_id: "connection-1559"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-259",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kyve",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2757",
      connection_id: "connection-2274"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-767",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "lambda",
      client_id: "07-tendermint-6",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2217",
      connection_id: "connection-1733"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-378",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "lava",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3210",
      connection_id: "connection-2668"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-76971",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "likecoin",
      client_id: "07-tendermint-16",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1507",
      connection_id: "connection-1173"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-53",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "lorenzo",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3243",
      connection_id: "connection-2731"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-79840",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "lumenx",
      client_id: "07-tendermint-0",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2079",
      connection_id: "connection-1620"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-286",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "lumnetwork",
      client_id: "07-tendermint-7",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1668",
      connection_id: "connection-1280"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-115",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "mars",
      client_id: "07-tendermint-4",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2602",
      connection_id: "connection-2114"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-557",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "medasdigital",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2372",
      connection_id: "connection-1869"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-519",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "meme",
      client_id: "07-tendermint-0",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1931",
      connection_id: "connection-1502"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-238",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "microtick",
      client_id: "07-tendermint-99",
      connection_id: "connection-92"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1453",
      connection_id: "connection-1139"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-39",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-3",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2669",
      connection_id: "connection-2171"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-642",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutaro",
      client_id: "07-tendermint-3",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3226",
      connection_id: "connection-2703"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-79092",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-19",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2823",
      connection_id: "connection-2338"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-874",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-2107",
        port_id: "wasm.neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07"
      },
      chain_2: {
        channel_id: "channel-39589",
        port_id: "wasm.osmo1pfeve3esg5rhhkfhlujxtthc25akcf3zpa3t9whghvvp2v5v92ps0z30r6"
      },
      ordering: "unordered",
      version: "astroport-ibc-v1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nibiru",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3104",
      connection_id: "connection-2580"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21113",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-0",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2704",
      connection_id: "connection-2241"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-750",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nois",
      client_id: "07-tendermint-16",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3017",
      connection_id: "connection-2507"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8277",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-11319",
        port_id: "wasm.osmo1tvzr8ur0ynjhqftxpkl4qwel8ly7erhy6cu6ks426xmzf92vk6eqfp9wcl"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nolus",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2791",
      connection_id: "connection-2289"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-783",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nomic",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3010",
      connection_id: "connection-2501"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6897",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nyx",
      client_id: "07-tendermint-17",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3065",
      connection_id: "connection-2555"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15464",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "odin",
      client_id: "07-tendermint-113",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2007",
      connection_id: "connection-1551"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-258",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "omniflixhub",
      client_id: "07-tendermint-8",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1829",
      connection_id: "connection-1431"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-199",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "onex",
      client_id: "07-tendermint-7",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3202",
      connection_id: "connection-2659"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-74628",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "onomy",
      client_id: "07-tendermint-0",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2405",
      connection_id: "connection-1892"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-525",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "oraichain",
      client_id: "07-tendermint-49",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1882",
      connection_id: "connection-1464"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-216",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1576",
      connection_id: "connection-1231"
    },
    chain_2: {
      chain_name: "panacea",
      client_id: "07-tendermint-6",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-82",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2935",
      connection_id: "connection-2430"
    },
    chain_2: {
      chain_name: "passage",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2494",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3242",
      connection_id: "connection-2730"
    },
    chain_2: {
      chain_name: "penumbra",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-79703",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-6",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2318",
      connection_id: "connection-1815"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-492",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1899",
      connection_id: "connection-1472"
    },
    chain_2: {
      chain_name: "provenance",
      client_id: "07-tendermint-31",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-222",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3206",
      connection_id: "connection-2663"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-75755",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-2",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-76804",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-15",
          port_id: "icacontroller-reward-uosmo"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-76805",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-16",
          port_id: "icacontroller-sweep-uosmo"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-79080",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-22",
          port_id: "icacontroller-delegation-uosmo"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3059",
      connection_id: "connection-2554"
    },
    chain_2: {
      chain_name: "pundix",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12618",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3070",
      connection_id: "connection-2558"
    },
    chain_2: {
      chain_name: "pylons",
      client_id: "07-tendermint-32",
      connection_id: "connection-25"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17683",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2703",
      connection_id: "connection-2240"
    },
    chain_2: {
      chain_name: "quasar",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-688",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2400",
      connection_id: "connection-1889"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-6",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-522",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2831",
      connection_id: "connection-2345"
    },
    chain_2: {
      chain_name: "qwoyn",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-880",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2849",
      connection_id: "connection-2361"
    },
    chain_2: {
      chain_name: "realio",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1424",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2173",
      connection_id: "connection-1692"
    },
    chain_2: {
      chain_name: "rebus",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-355",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-6",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1898",
      connection_id: "connection-1471"
    },
    chain_2: {
      chain_name: "rizon",
      client_id: "07-tendermint-3",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-221",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3235",
      connection_id: "connection-2722"
    },
    chain_2: {
      chain_name: "routerchain",
      client_id: "07-tendermint-7",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-79180",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-79179",
        port_id: "wasm.osmo145vur8faym70dt7a4h60jz348vxxxqwpnezdz6ee9r88a4cftsvq85dtxr"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "crosschain"
      },
      ordering: "unordered",
      version: "router-ibc-v1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3157",
      connection_id: "connection-2626"
    },
    chain_2: {
      chain_name: "saga",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-38946",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3098",
      connection_id: "connection-2571"
    },
    chain_2: {
      chain_name: "scorum",
      client_id: "07-tendermint-6",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-20100",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1588",
      connection_id: "connection-1244"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis",
        properties: "privacy"
      }
    }, {
      chain_1: {
        channel_id: "channel-476",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-44",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis",
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3204",
      connection_id: "connection-2661"
    },
    chain_2: {
      chain_name: "seda",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-75016",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2790",
      connection_id: "connection-2288"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-2",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-782",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3213",
      connection_id: "connection-2684"
    },
    chain_2: {
      chain_name: "self",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-78292",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2972",
      connection_id: "connection-2468"
    },
    chain_2: {
      chain_name: "sge",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5485",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2680",
      connection_id: "connection-2182"
    },
    chain_2: {
      chain_name: "shareledger",
      client_id: "07-tendermint-1",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-647",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1741",
      connection_id: "connection-1342"
    },
    chain_2: {
      chain_name: "shentu",
      client_id: "07-tendermint-9",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-146",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3198",
      connection_id: "connection-2654"
    },
    chain_2: {
      chain_name: "shido",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-73755",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1484",
      connection_id: "connection-1159"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-41",
      connection_id: "connection-20"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-47",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1745",
      connection_id: "connection-1348"
    },
    chain_2: {
      chain_name: "sommelier",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-165",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3035",
      connection_id: "connection-2524"
    },
    chain_2: {
      chain_name: "source",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8945",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2969",
      connection_id: "connection-2465"
    },
    chain_2: {
      chain_name: "stafihub",
      client_id: "07-tendermint-7",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5413",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1562",
      connection_id: "connection-1223"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-75",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-39535",
        port_id: "wasm.osmo10vzkd8pyme67z38epdr3gf027y03dxq7t8vau5fp3r28vxks7mwse02j8f"
      },
      chain_2: {
        channel_id: "channel-309",
        port_id: "wasm.stars1r0a8ygvnjfaegy4n5z9325e0ew9uy2s7rn4vt7qf4ltv49fj4tnsk6pvtv"
      },
      ordering: "unordered",
      version: "ics721-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-71",
      connection_id: "connection-42"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2119",
      connection_id: "connection-1657"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-1",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-326",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2192",
      connection_id: "connection-1710"
    },
    chain_2: {
      chain_name: "teritori",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-362",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1215",
      connection_id: "connection-1549"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-12",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-72",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-78488",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-108",
        port_id: "wasm.terra19pfxzj9580h7rjd6z6sn5x2se76vgrc0etltr79g9z3t82jzp4hq63qguc"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !1,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1979",
      connection_id: "connection-1536"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-251",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-1",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0,
          dex: "osmosis"
        }
      },
      {
        chain_1: {
          channel_id: "channel-559",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-85",
          port_id: "wasm.terra1d90p5lacfxnqgjxjupu234lxnxyeu8fdeef4d0e0nqy3p30r7gss4myn9x"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0,
          dex: "osmosis"
        }
      },
      {
        chain_1: {
          channel_id: "channel-341",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-26",
          port_id: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0,
          dex: "osmosis"
        }
      },
      {
        chain_1: {
          channel_id: "channel-21671",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-392",
          port_id: "wasm.terra1jhfjnm39y3nn9l4520mdn4k5mw23nz0674c4gsvyrcr90z9tqcvst22fce"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0,
          dex: "osmosis"
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2025",
      connection_id: "connection-1565"
    },
    chain_2: {
      chain_name: "tgrade",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-263",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1805",
      connection_id: "connection-1410"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-6",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-184",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2229",
      connection_id: "connection-1746"
    },
    chain_2: {
      chain_name: "unification",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-382",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1705",
      connection_id: "connection-1300"
    },
    chain_2: {
      chain_name: "vidulum",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-124",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2875",
      connection_id: "connection-2389"
    },
    chain_2: {
      chain_name: "xpla",
      client_id: "07-tendermint-11",
      connection_id: "connection-19"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1634",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
pv.default = nH;
var lv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(xs, "__esModule", { value: !0 });
xs.ibc = xs.chain = xs.assets = void 0;
const tH = lv(mv), sH = lv(hv), aH = lv(pv);
xs.assets = tH.default;
xs.chain = sH.default;
xs.ibc = aH.default;
var br = {}, gv = {};
Object.defineProperty(gv, "__esModule", { value: !0 });
const oH = {
  $schema: "../assetlist.schema.json",
  chain_name: "paloma",
  assets: [{
    description: "The native token of the Paloma chain",
    denom_units: [{
      denom: "ugrain",
      exponent: 0
    }, {
      denom: "grain",
      exponent: 6
    }],
    base: "ugrain",
    name: "Grain",
    display: "grain",
    symbol: "GRAIN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/paloma/images/grain.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/paloma/images/grain.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/paloma/images/grain.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/paloma/images/grain.svg"
    }],
    socials: {
      website: "https://palomachain.com/",
      twitter: "https://twitter.com/paloma_chain"
    }
  }]
};
gv.default = oH;
var uv = {};
Object.defineProperty(uv, "__esModule", { value: !0 });
const rH = {
  $schema: "../chain.schema.json",
  chain_name: "paloma",
  status: "live",
  network_type: "mainnet",
  website: "https://palomachain.com/",
  pretty_name: "Paloma",
  chain_type: "cosmos",
  chain_id: "tumbler",
  bech32_prefix: "paloma",
  daemon_name: "palomad",
  node_home: "$HOME/.paloma",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ugrain",
      fixed_min_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ugrain"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.50.6"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/paloma/images/paloma.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/paloma/images/paloma.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc-1.paloma.nodes.guru/",
      provider: "Nodes.Guru"
    }]
  },
  explorers: [{
    kind: "explorers.guru",
    url: "https://paloma.explorers.guru/",
    tx_page: "https://paloma.explorers.guru/transaction/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/paloma/images/paloma.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/paloma/images/paloma.svg"
  }]
};
uv.default = rH;
var L9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(br, "__esModule", { value: !0 });
br.chain = br.assets = void 0;
const iH = L9(gv), cH = L9(uv);
br.assets = iH.default;
br.chain = cH.default;
var ks = {}, _v = {};
Object.defineProperty(_v, "__esModule", { value: !0 });
const dH = {
  $schema: "../assetlist.schema.json",
  chain_name: "panacea",
  assets: [{
    description: "Panacea is a public blockchain launched by MediBloc, which is the key infrastructure for reinventing the patient-centered healthcare data ecosystem",
    denom_units: [{
      denom: "umed",
      exponent: 0
    }, {
      denom: "med",
      exponent: 6
    }],
    base: "umed",
    name: "MediBloc",
    display: "med",
    symbol: "MED",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.svg"
    },
    coingecko_id: "medibloc",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.svg",
      theme: {
        primary_color_hex: "#2474ec"
      }
    }]
  }]
};
_v.default = dH;
var yv = {};
Object.defineProperty(yv, "__esModule", { value: !0 });
const mH = {
  $schema: "../chain.schema.json",
  chain_name: "panacea",
  status: "live",
  network_type: "mainnet",
  website: "https://medibloc.com/en/",
  pretty_name: "Medibloc",
  chain_type: "cosmos",
  chain_id: "panacea-3",
  bech32_prefix: "panacea",
  daemon_name: "panacead",
  node_home: "$HOME/.panacead",
  key_algos: ["secp256k1"],
  slip44: 371,
  fees: {
    fee_tokens: [{
      denom: "umed",
      fixed_min_gas_price: 5,
      low_gas_price: 5,
      average_gas_price: 7,
      high_gas_price: 9
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "umed"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.gopanacea.org",
      provider: "medibloc"
    }, {
      address: "https://panacea-rpc.staketab.org:443",
      provider: "Staketab"
    }],
    rest: [{
      address: "https://api.gopanacea.org",
      provider: "medibloc"
    }, {
      address: "https://panacea-rest.staketab.org",
      provider: "Staketab"
    }],
    grpc: [{
      address: "services.staketab.com:9400",
      provider: "Staketab"
    }]
  },
  explorers: [{
    kind: "mintscan",
    url: "https://www.mintscan.io/medibloc",
    tx_page: "https://www.mintscan.io/medibloc/transactions/${txHash}",
    account_page: "https://www.mintscan.io/medibloc/accounts/${accountAddress}"
  }, {
    kind: "bigdipper",
    url: "https://explorer.gopanacea.org",
    tx_page: "https://explorer.gopanacea.org/transactions/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/panacea/images/med.svg",
    theme: {
      primary_color_hex: "#2474ec"
    }
  }]
};
yv.default = mH;
var bv = {};
Object.defineProperty(bv, "__esModule", { value: !0 });
const hH = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1576",
    connection_id: "connection-1231"
  },
  chain_2: {
    chain_name: "panacea",
    client_id: "07-tendermint-6",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-82",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
bv.default = hH;
var vv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ks, "__esModule", { value: !0 });
ks.ibc = ks.chain = ks.assets = void 0;
const pH = vv(_v), lH = vv(yv), gH = vv(bv);
ks.assets = pH.default;
ks.chain = lH.default;
ks.ibc = gH.default;
var As = {}, fv = {};
Object.defineProperty(fv, "__esModule", { value: !0 });
const uH = {
  $schema: "../assetlist.schema.json",
  chain_name: "passage",
  assets: [{
    description: "Passage.io is a decentralized platform that enables users to create, distribute, and monetize immersive virtual experiences and content using blockchain technology.",
    extended_description: "Passage.io provides a decentralized environment for creating, distributing, and monetizing virtual experiences and content. By leveraging blockchain technology, Passage.io ensures secure ownership and transparent transactions for digital assets. The platform supports a wide range of virtual content, including virtual reality (VR), augmented reality (AR), and other immersive experiences. Users can create and share their content, interact with others, and earn rewards through the platform's native token, PASS. Passage.io aims to revolutionize the virtual content industry by offering a decentralized alternative to traditional content distribution models.",
    denom_units: [{
      denom: "upasg",
      exponent: 0
    }, {
      denom: "pasg",
      exponent: 6
    }],
    base: "upasg",
    name: "Passage",
    display: "pasg",
    symbol: "PASG",
    coingecko_id: "passage",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/passage/images/pasg.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/passage/images/pasg.png",
      theme: {
        primary_color_hex: "#05050c"
      }
    }]
  }]
};
fv.default = uH;
var wv = {};
Object.defineProperty(wv, "__esModule", { value: !0 });
const _H = {
  $schema: "../chain.schema.json",
  chain_name: "passage",
  chain_type: "cosmos",
  chain_id: "passage-2",
  pre_fork_chain_name: "passage1",
  pretty_name: "Passage",
  status: "live",
  network_type: "mainnet",
  website: "https://passage3d.com/",
  bech32_prefix: "pasg",
  daemon_name: "passage",
  node_home: "$HOME/.passage",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "upasg",
      fixed_min_gas_price: 0,
      low_gas_price: 1e-3,
      average_gas_price: 25e-4,
      high_gas_price: 0.01
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "upasg"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.45.16",
    cosmwasm_version: "v0.31.0"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.passage.vitwit.com",
        provider: "vitwit"
      },
      {
        address: "https://passage-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://rpc-passage.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://rpc.lavenderfive.com:443/passage",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-passage-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc-passage.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://rpc.passage.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://passage-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://passage-rpc.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rpc-passage.d-stake.xyz",
        provider: "D-stake"
      },
      {
        address: "https://passage-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://passage-rpc.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://passage-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://passage-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://rpc-passage.mainnet.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "https://rpc.passage.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://passage-rpc.bluestake.net:443",
        provider: "BlueStake 🚀"
      }
    ],
    rest: [
      {
        address: "https://api.passage.vitwit.com",
        provider: "vitwit"
      },
      {
        address: "https://passage-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://rest-passage.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://rest.lavenderfive.com:443/passage",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api-passage.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://api-passage-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://api.passage.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://passage-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://passage-api.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://api-passage.d-stake.xyz",
        provider: "D-stake"
      },
      {
        address: "https://passage-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://passage-rest.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://passage-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://passage-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://api-passage.mainnet.validatrium.club",
        provider: "Validatrium"
      },
      {
        address: "https://api.passage.silentvalidator.com",
        provider: "silent"
      },
      {
        address: "https://passage-api.bluestake.net",
        provider: "BlueStake 🚀"
      }
    ],
    grpc: [
      {
        address: "grpc-passage-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "passage.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "passage-grpc.polkachu.com:15690",
        provider: "Polkachu"
      },
      {
        address: "grpc-passage.cosmos-spaces.cloud:2320",
        provider: "Cosmos Spaces"
      },
      {
        address: "grpc.passage.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "passage-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "services.staketab.com:9023",
        provider: "Staketab"
      },
      {
        address: "passage-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "passage-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "passage-grpc.stakeandrelax.net:15690",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "grpc-passage.mainnet.validatrium.club:20590",
        provider: "Validatrium"
      },
      {
        address: "grpc.passage.silentvalidator.com:443",
        provider: "silent"
      }
    ]
  },
  explorers: [
    {
      kind: "aneka",
      url: "https://passage.aneka.io",
      tx_page: "https://passage.aneka.io/txs/${txHash}",
      account_page: "https://passage.aneka.io/accounts/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/passage",
      tx_page: "https://www.mintscan.io/passage/transactions/${txHash}",
      account_page: "https://www.mintscan.io/passage/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/passage",
      tx_page: "https://ezstaking.app/passage/txs/${txHash}",
      account_page: "https://ezstaking.app/passage/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/passage",
      tx_page: "https://atomscan.com/passage/transactions/${txHash}",
      account_page: "https://atomscan.com/passage/accounts/${accountAddress}"
    },
    {
      kind: "cosmotracker",
      url: "https://cosmotracker.com/passage",
      tx_page: "https://cosmotracker.com/passage/tx/${txHash}",
      account_page: "https://cosmotracker.com/passage/account/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/passage",
      tx_page: "https://mainnet.whispernode.com/passage/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/passage/account/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/passage/images/pasg.png"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/passage/images/pasg.png",
    theme: {
      primary_color_hex: "#05050c"
    }
  }]
};
wv.default = _H;
var xv = {};
Object.defineProperty(xv, "__esModule", { value: !0 });
const yH = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2935",
    connection_id: "connection-2430"
  },
  chain_2: {
    chain_name: "passage",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-2494",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
xv.default = yH;
var kv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(As, "__esModule", { value: !0 });
As.ibc = As.chain = As.assets = void 0;
const bH = kv(fv), vH = kv(wv), fH = kv(xv);
As.assets = bH.default;
As.chain = vH.default;
As.ibc = fH.default;
var vr = {}, Av = {};
Object.defineProperty(Av, "__esModule", { value: !0 });
const wH = {
  $schema: "../assetlist.schema.json",
  chain_name: "passage1",
  assets: [{
    description: "The native staking and governance token of the Passage chain.",
    denom_units: [{
      denom: "upasg",
      exponent: 0
    }, {
      denom: "pasg",
      exponent: 6
    }],
    base: "upasg",
    name: "Passage",
    display: "pasg",
    symbol: "PASG",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/passage/images/pasg.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/passage/images/pasg.png",
      theme: {
        primary_color_hex: "#05050c"
      }
    }]
  }]
};
Av.default = wH;
var jv = {};
Object.defineProperty(jv, "__esModule", { value: !0 });
const xH = {
  $schema: "../chain.schema.json",
  chain_name: "passage1",
  chain_type: "cosmos",
  chain_id: "passage-1",
  pretty_name: "Passage",
  status: "killed",
  network_type: "mainnet",
  website: "https://passage3d.com/",
  bech32_prefix: "pasg",
  daemon_name: "passage",
  node_home: "$HOME/.passage",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "upasg",
      fixed_min_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "upasg"
    }]
  },
  codebase: {},
  explorers: [
    {
      kind: "aneka",
      url: "https://passage.aneka.io",
      tx_page: "https://passage.aneka.io/txs/${txHash}",
      account_page: "https://passage.aneka.io/accounts/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/passage",
      tx_page: "https://www.mintscan.io/passage/txs/${txHash}",
      account_page: "https://www.mintscan.io/passage/account/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/passage",
      tx_page: "https://ezstaking.app/passage/txs/${txHash}",
      account_page: "https://ezstaking.app/passage/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/passage",
      tx_page: "https://atomscan.com/passage/transactions/${txHash}",
      account_page: "https://atomscan.com/passage/accounts/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/passage/images/pasg.png"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/passage/images/pasg.png",
    theme: {
      primary_color_hex: "#05050c"
    }
  }]
};
jv.default = xH;
var W9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(vr, "__esModule", { value: !0 });
vr.chain = vr.assets = void 0;
const kH = W9(Av), AH = W9(jv);
vr.assets = kH.default;
vr.chain = AH.default;
var js = {}, Cv = {};
Object.defineProperty(Cv, "__esModule", { value: !0 });
const jH = {
  $schema: "../assetlist.schema.json",
  chain_name: "persistence",
  assets: [
    {
      description: "Persistence is a blockchain platform designed to facilitate institutional decentralized finance (DeFi) and real-world asset tokenization, integrating with the Cosmos ecosystem.",
      extended_description: "Persistence aims to bridge traditional finance and decentralized finance (DeFi) by enabling the tokenization of real-world assets. The platform supports various financial products, including staking-as-a-service, commodity trading, and debt financing. Persistence leverages the Cosmos SDK for interoperability and scalability, ensuring seamless integration with other blockchain networks. The native token, XPRT, is used for staking, governance, and securing the network. Persistence's mission is to create a decentralized financial ecosystem that brings institutional-grade solutions to the blockchain space.",
      denom_units: [{
        denom: "uxprt",
        exponent: 0
      }, {
        denom: "xprt",
        exponent: 6
      }],
      base: "uxprt",
      name: "Persistence",
      display: "xprt",
      symbol: "XPRT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg"
      },
      coingecko_id: "persistence",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#E59636",
          background_color_hex: "#000000"
        }
      }],
      socials: {
        website: "https://persistence.one/",
        twitter: "https://twitter.com/PersistenceOne"
      }
    },
    {
      description: "PSTAKE Liquid-Staked ATOM",
      denom_units: [{
        denom: "stk/uatom",
        exponent: 0,
        aliases: []
      }, {
        denom: "stkatom",
        exponent: 6,
        aliases: ["stk/atom"]
      }],
      base: "stk/uatom",
      name: "PSTAKE staked ATOM",
      display: "stkatom",
      symbol: "stkATOM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        provider: "pSTAKE"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg"
      },
      coingecko_id: "stkatom",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg",
        theme: {
          primary_color_hex: "#c4444c"
        }
      }]
    },
    {
      description: "pSTAKE Finance is a Bitcoin Yield and Liquid Staking protocol, backed by Binance Labs.",
      extended_description: "With pSTAKE Finance, users can liquid stake BTC to get rewards from Babylon's Trustless BTC staking for securing other app chains while maintaining their liquidity, powered by institutional custody providers like Cobo. Accessing Bitcoin yields should not be complex, risky, or unsafe. With four years of liquid staking expertise and expert-curated yield strategies, pSTAKE Finance helps individuals and institutions put their BTC to work in BTCfi. pSTAKE Finance has partnered with leading blockchain security firms, such as Halborn, Hexens, Oak Security, Immunefi, Forta, and more, to offer a secure liquid staking product suite. PSTAKE is the governance and incentivization token of the pSTAKE Finance protocol. It has some of the most prominent investors, including Binance Labs, DeFiance Capital, Spartan Group, Coinbase Ventures, and Kraken Ventures.",
      denom_units: [{
        denom: "ibc/A6E3AF63B3C906416A9AF7A556C59EA4BD50E617EFFE6299B99700CCB780E444",
        exponent: 0,
        aliases: ["gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006", "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006"]
      }, {
        denom: "pstake",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/A6E3AF63B3C906416A9AF7A556C59EA4BD50E617EFFE6299B99700CCB780E444",
      name: "pSTAKE Finance",
      display: "pstake",
      symbol: "PSTAKE",
      traces: [
        {
          type: "liquid-stake",
          counterparty: {
            chain_name: "persistence",
            base_denom: "uxprt"
          },
          provider: "Persistence"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006"
          },
          provider: "Gravity Bridge"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "gravitybridge",
            base_denom: "gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
            channel_id: "channel-24"
          },
          chain: {
            channel_id: "channel-38",
            path: "transfer/channel-38/gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.svg"
      },
      keywords: ["canon"],
      images: [{
        image_sync: {
          chain_name: "ethereum",
          base_denom: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/pstake.svg",
        theme: {
          primary_color_hex: "#050505"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/C8A74ABBE2AF892E15680D916A7C22130585CE5704F9B17A10F184A90D53BECA",
        exponent: 0,
        aliases: ["uatom"]
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C8A74ABBE2AF892E15680D916A7C22130585CE5704F9B17A10F184A90D53BECA",
      name: "Cosmos Hub Atom",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-190"
        },
        chain: {
          channel_id: "channel-24",
          path: "transfer/channel-24/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      }
    },
    {
      description: "Tether USDT on Persistence",
      denom_units: [{
        denom: "ibc/C559977F5797BDC1D74C0836A10C379C991D664166CB60D776A83029852431B4",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C559977F5797BDC1D74C0836A10C379C991D664166CB60D776A83029852431B4",
      name: "Tether USDT",
      display: "usdt",
      symbol: "USDT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt",
          channel_id: "channel-134"
        },
        chain: {
          channel_id: "channel-129",
          path: "transfer/channel-129/erc20/tether/usdt"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/B3792E4A62DF4A934EF2DF5968556DB56F5776ED25BDE11188A4F58A7DD406F0",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B3792E4A62DF4A934EF2DF5968556DB56F5776ED25BDE11188A4F58A7DD406F0",
      name: "Noble USD Coin",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "noble",
          base_denom: "uusdc",
          channel_id: "channel-36"
        },
        chain: {
          channel_id: "channel-132",
          path: "transfer/channel-132/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }
    },
    {
      description: "dydx staking token",
      denom_units: [{
        denom: "ibc/23DC3FF0E4CBB53A1915E4C62507CB7796956E84C68CA49707787CB8BDE90A1E",
        exponent: 0,
        aliases: ["adydx"]
      }, {
        denom: "dydx",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/23DC3FF0E4CBB53A1915E4C62507CB7796956E84C68CA49707787CB8BDE90A1E",
      name: "dYdX",
      display: "dydx",
      symbol: "DYDX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "dydx",
          base_denom: "adydx",
          channel_id: "channel-4"
        },
        chain: {
          channel_id: "channel-131",
          path: "transfer/channel-131/adydx"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "dydx",
          base_denom: "adydx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
        theme: {
          primary_color_hex: "#21212f"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg"
      }
    },
    {
      description: "PSTAKE Liquid-Staked OSMO",
      denom_units: [{
        denom: "stk/uosmo",
        exponent: 0,
        aliases: []
      }, {
        denom: "stkosmo",
        exponent: 6,
        aliases: ["stk/osmo"]
      }],
      base: "stk/uosmo",
      name: "PSTAKE staked OSMO",
      display: "stkosmo",
      symbol: "stkOSMO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        provider: "pSTAKE"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.svg"
      },
      coingecko_id: "pstake-staked-osmo",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.svg",
        theme: {
          primary_color_hex: "#c3343d"
        }
      }]
    },
    {
      description: "PSTAKE Liquid-Staked DYDX",
      denom_units: [{
        denom: "stk/adydx",
        exponent: 0,
        aliases: []
      }, {
        denom: "stkdydx",
        exponent: 18,
        aliases: ["stk/dydx"]
      }],
      base: "stk/adydx",
      name: "PSTAKE staked DYDX",
      display: "stkdydx",
      symbol: "stkDYDX",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "dydx",
          base_denom: "adydx"
        },
        provider: "pSTAKE"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkdydx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkdydx.svg",
        theme: {
          primary_color_hex: "#c4474e"
        }
      }]
    },
    {
      description: "PSTAKE Liquid-Staked STARS",
      denom_units: [{
        denom: "stk/ustars",
        exponent: 0,
        aliases: []
      }, {
        denom: "stkstars",
        exponent: 6,
        aliases: ["stk/stars"]
      }],
      base: "stk/ustars",
      name: "PSTAKE staked STARS",
      display: "stkstars",
      symbol: "stkSTARS",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "ustars"
        },
        provider: "pSTAKE"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkstars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkstars.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkstars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkstars.svg",
        theme: {
          primary_color_hex: "#070e0e"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/AD8E1D4AC4EA8FC79CC46E33319A3791477D4DEBFC30D5D874074B993422B41B",
        exponent: 0,
        aliases: ["ustars"]
      }, {
        denom: "stars",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/AD8E1D4AC4EA8FC79CC46E33319A3791477D4DEBFC30D5D874074B993422B41B",
      name: "Stargaze",
      display: "stars",
      symbol: "STARS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "ustars",
          channel_id: "channel-287"
        },
        chain: {
          channel_id: "channel-197",
          path: "transfer/channel-197/ustars"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "stargaze",
          base_denom: "ustars"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg",
        theme: {
          primary_color_hex: "#db2777"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg"
      }
    },
    {
      description: "The native token cw20 for Shade on Secret Network",
      denom_units: [{
        denom: "ibc/5D3B6445EA1D7064C4B1CCB588638589529556E1BCBADF13475021B42EA8C73B",
        exponent: 0,
        aliases: ["cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm"]
      }, {
        denom: "shd",
        exponent: 8
      }],
      type_asset: "ics20",
      base: "ibc/5D3B6445EA1D7064C4B1CCB588638589529556E1BCBADF13475021B42EA8C73B",
      name: "Shade",
      display: "shd",
      symbol: "SHD",
      traces: [{
        type: "ibc-cw20",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm",
          port: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
          channel_id: "channel-132"
        },
        chain: {
          port: "transfer",
          channel_id: "channel-159",
          path: "transfer/channel-159/cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.svg",
        theme: {
          primary_color_hex: "#342c52"
        }
      }]
    },
    {
      description: "PSTAKE Liquid-Staked HUAHUA",
      denom_units: [{
        denom: "stk/uhuahua",
        exponent: 0,
        aliases: []
      }, {
        denom: "stkhuahua",
        exponent: 6,
        aliases: ["stk/huahua"]
      }],
      base: "stk/uhuahua",
      name: "PSTAKE staked HUAHUA",
      display: "stkhuahua",
      symbol: "stkHUAHUA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "chihuahua",
          base_denom: "uhuahua"
        },
        provider: "pSTAKE"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkhuahua.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkhuahua.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkhuahua.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkhuahua.svg",
        theme: {
          primary_color_hex: "#f2cc2f"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/B597D779FCDD9021263C98A48F1AFA9D2BCCCE980F397CDE5681CCEDE7DEE1A4",
        exponent: 0,
        aliases: ["uhuahua"]
      }, {
        denom: "huahua",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B597D779FCDD9021263C98A48F1AFA9D2BCCCE980F397CDE5681CCEDE7DEE1A4",
      name: "Chihuahua",
      display: "huahua",
      symbol: "HUAHUA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "chihuahua",
          base_denom: "uhuahua",
          channel_id: "channel-94"
        },
        chain: {
          channel_id: "channel-203",
          path: "transfer/channel-203/uhuahua"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "chihuahua",
          base_denom: "uhuahua"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.svg",
        theme: {
          primary_color_hex: "#343434"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chihuahua/images/huahua.svg"
      }
    },
    {
      description: "PSTAKE Liquid-Staked XPRT",
      denom_units: [{
        denom: "stk/uxprt",
        exponent: 0,
        aliases: []
      }, {
        denom: "stkxprt",
        exponent: 6,
        aliases: ["stk/xprt"]
      }],
      base: "stk/uxprt",
      name: "PSTAKE staked XPRT",
      display: "stkxprt",
      symbol: "stkXPRT",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "persistence",
          base_denom: "uxprt"
        },
        provider: "pSTAKE"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkxprt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkxprt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkxprt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkxprt.svg",
        theme: {
          primary_color_hex: "#c3343b"
        }
      }]
    },
    {
      description: "Wrapped Bitcoin on Persistence",
      denom_units: [{
        denom: "ibc/CCA9F9B22D39884C09975D45E1869B73A12B87080EE53CB44905CE2C422CA228",
        exponent: 0,
        aliases: ["factory/osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743/wbtc"]
      }, {
        denom: "wbtc",
        exponent: 8
      }],
      type_asset: "ics20",
      base: "ibc/CCA9F9B22D39884C09975D45E1869B73A12B87080EE53CB44905CE2C422CA228",
      name: "Wrapped Bitcoin",
      display: "wbtc",
      symbol: "WBTC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743/wbtc",
          channel_id: "channel-4"
        },
        chain: {
          channel_id: "channel-6",
          path: "transfer/channel-6/factory/osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743/wbtc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743/wbtc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wbtc.svg",
        theme: {
          primary_color_hex: "#f39444"
        }
      }]
    }
  ]
};
Cv.default = jH;
var Ev = {};
Object.defineProperty(Ev, "__esModule", { value: !0 });
const CH = {
  $schema: "../chain.schema.json",
  chain_name: "persistence",
  chain_type: "cosmos",
  chain_id: "core-1",
  pretty_name: "Persistence",
  status: "live",
  network_type: "mainnet",
  website: "https://persistence.one/",
  bech32_prefix: "persistence",
  daemon_name: "persistenceCore",
  node_home: "$HOME/.persistenceCore",
  key_algos: ["secp256k1"],
  slip44: 118,
  alternative_slip44s: [750],
  fees: {
    fee_tokens: [{
      denom: "uxprt",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uxprt"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "persistenceOne/cosmos-sdk v0.47.10-lsm-rc0",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.45.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg"
  },
  description: "Persistence is an app chain for Liquid Staking powering an ecosystem of DeFi applications focused on unlocking the liquidity of staked assets.",
  apis: {
    rpc: [
      {
        address: "https://rpc.core.persistence.one",
        provider: "Persistence"
      },
      {
        address: "https://rpc-persistent-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://persistence.rpc.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://persistence-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://persistence-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://rpc-persistence.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://rpc-persistence.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://persistence-mainnet-rpc.cosmonautstakes.com",
        provider: "Cosmonaut Stakes"
      },
      {
        address: "https://persistence-rpc.quantnode.tech",
        provider: "QuantNode"
      },
      {
        address: "https://persistence-rpc.zenscape.one",
        provider: "Zenscape"
      },
      {
        address: "https://persistence-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://persistence-rpc.stakeandrelax.net",
        provider: "Stake&Relax Validator 🦥"
      },
      {
        address: "https://rpc.persistence.posthuman.digital:443",
        provider: "POSTHUMAN∞DVS"
      },
      {
        address: "https://rpc-persistence-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://persistence-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://persistence-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://persistence-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://rpc.persistence.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://public.stakewolle.com/cosmos/persistence/rpc",
        provider: "Stakewolle"
      },
      {
        address: "https://xprt-rpc.antrixy.org/",
        provider: "Antrix Validators"
      },
      {
        address: "https://persistence-rpc.stake-town.com",
        provider: "StakeTown"
      }
    ],
    rest: [
      {
        address: "https://rest.core.persistence.one",
        provider: "Persistence"
      },
      {
        address: "https://api-persistent-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://persistence.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://persistence-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://api-persistence.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://persistence-api.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://rest-persistence.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://persistence-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://persistence-mainnet-rest.cosmonautstakes.com",
        provider: "Cosmonaut Stakes"
      },
      {
        address: "https://persistence-lcd.quantnode.tech",
        provider: "QuantNode"
      },
      {
        address: "https://persistence-rest.zenscape.one",
        provider: "Zenscape"
      },
      {
        address: "https://persistence-api.stakeandrelax.net",
        provider: "Stake&Relax Validator 🦥"
      },
      {
        address: "https://rest.persistence.posthuman.digital:443",
        provider: "POSTHUMAN∞DVS"
      },
      {
        address: "https://api-persistence-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://persistence-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://persistence-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://persistence-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://api.persistence.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://public.stakewolle.com/cosmos/persistence/rest",
        provider: "Stakewolle"
      },
      {
        address: "https://xprt-rest.antrixy.org/",
        provider: "Antrix Validators"
      },
      {
        address: "https://persistence-api.stake-town.com",
        provider: "StakeTown"
      }
    ],
    grpc: [
      {
        address: "grpc.core.persistence.one:443",
        provider: "Persistence"
      },
      {
        address: "grpc-persistent-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "persistence.grpc.m.stavr.tech:410",
        provider: "🔥STAVR🔥"
      },
      {
        address: "persistence-grpc.polkachu.com:15490",
        provider: "Polkachu"
      },
      {
        address: "persistence-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc.persistence.posthuman.digital:80",
        provider: "POSTHUMAN∞DVS"
      },
      {
        address: "grpc-persistence.cosmos-spaces.cloud:1180",
        provider: "Cosmos Spaces"
      },
      {
        address: "141.95.33.97:9090",
        provider: "Stakewolle.com | Auto-compound"
      },
      {
        address: "grpc-persistence-01.stakeflow.io:49090",
        provider: "Stakeflow"
      },
      {
        address: "persistence-grpc.w3coins.io:15490",
        provider: "w3coins"
      },
      {
        address: "persistence-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "persistence-grpc.stakeandrelax.net:15490",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "grpc.persistence.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://xprt-grpc.antrixy.org/",
        provider: "Antrix Validators"
      },
      {
        address: "persistence-grpc.stake-town.com:443",
        provider: "StakeTown"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/persistence",
      tx_page: "https://www.mintscan.io/persistence/transactions/${txHash}",
      account_page: "https://www.mintscan.io/persistence/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/persistence",
      tx_page: "https://ezstaking.app/persistence/txs/${txHash}",
      account_page: "https://ezstaking.app/persistence/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/persistence",
      tx_page: "https://ping.pub/persistence/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Persistence-Mainnet",
      tx_page: "https://explorer.stavr.tech/Persistence-Mainnet/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/persistence",
      tx_page: "https://atomscan.com/persistence/transactions/${txHash}",
      account_page: "https://atomscan.com/persistence/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/persistence",
      account_page: "https://stakeflow.io/persistence/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg",
    theme: {
      primary_color_hex: "#242424"
    }
  }]
};
Ev.default = CH;
var Dv = {};
Object.defineProperty(Dv, "__esModule", { value: !0 });
const EH = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-93",
      connection_id: "connection-91"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-167",
      connection_id: "connection-210"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-72",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-202",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-188",
      connection_id: "connection-174"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-169",
      connection_id: "connection-214"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-127",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-213",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-207",
      connection_id: "connection-137"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-168",
      connection_id: "connection-212"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-94",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-203",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-123",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-94",
      connection_id: "connection-75"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-71",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-391",
      connection_id: "connection-344"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-36",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-190",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-42",
      connection_id: "connection-41"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-88",
      connection_id: "connection-72"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-68",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-61",
      connection_id: "connection-34"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-24",
      connection_id: "connection-17"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-4",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-159",
      connection_id: "connection-197"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-131",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-39",
      connection_id: "connection-50"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-51",
      connection_id: "connection-49"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-110",
      connection_id: "connection-91"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-57",
      connection_id: "connection-53"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-82",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-34",
      connection_id: "connection-25"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-31",
      connection_id: "connection-25"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-89",
      connection_id: "connection-51"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-49",
      connection_id: "connection-48"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-148",
      connection_id: "connection-189"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-156",
      connection_id: "connection-195"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-134",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-129",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-167",
      connection_id: "connection-130"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-162",
      connection_id: "connection-200"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-158",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-152",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-73",
      connection_id: "connection-52"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-161",
      connection_id: "connection-199"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-136",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-61",
      connection_id: "connection-59"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-160",
      connection_id: "connection-198"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-132",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "persistence",
      client_id: "07-tendermint-6",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-96",
      connection_id: "connection-77"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-15",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-73",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-33",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-30",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-106",
      connection_id: "connection-146"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-126",
      connection_id: "connection-98"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-82",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }, {
      chain_1: {
        channel_id: "channel-159",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-132",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-34",
      connection_id: "connection-28"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-61",
      connection_id: "connection-36"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-38",
      connection_id: "connection-32"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-18",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-166",
      connection_id: "connection-207"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-358",
      connection_id: "connection-293"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-197",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-287",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-39",
      connection_id: "connection-39"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-44",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-83",
      connection_id: "connection-71"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-54",
      connection_id: "connection-33"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-67",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-53",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-105",
      connection_id: "connection-144"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-179",
      connection_id: "connection-119"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-81",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Dv.default = EH;
var Bv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(js, "__esModule", { value: !0 });
js.ibc = js.chain = js.assets = void 0;
const DH = Bv(Cv), BH = Bv(Ev), FH = Bv(Dv);
js.assets = DH.default;
js.chain = BH.default;
js.ibc = FH.default;
var Cs = {}, Fv = {};
Object.defineProperty(Fv, "__esModule", { value: !0 });
const $H = {
  $schema: "../assetlist.schema.json",
  chain_name: "planq",
  assets: [
    {
      description: "The native EVM, governance and staking token of the Planq Network",
      extended_description: "Planq is the very first cryptocurrency project to keep mobile platform usability at heart, taking a step away from dependency on desktop services. By focusing on easy accessibility and close integration of other blockchains via easy to use bridges, Planq will push Web 3 adoption in the mobile space to the next level.",
      denom_units: [{
        denom: "aplanq",
        exponent: 0
      }, {
        denom: "planq",
        exponent: 18
      }],
      base: "aplanq",
      name: "Planq",
      display: "planq",
      symbol: "PLQ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.svg"
      },
      coingecko_id: "planq",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.svg",
        theme: {
          primary_color_hex: "#d4f3fb"
        }
      }],
      socials: {
        website: "https://planq.network",
        twitter: "https://twitter.com/planqfoundation"
      }
    },
    {
      description: "The token of Source Protocol bridged from BSC.",
      denom_units: [{
        denom: "erc20/0x091F9A57A3F58d758b6572E9d41675918EAC7F09",
        exponent: 0
      }, {
        denom: "srcx",
        exponent: 9
      }],
      base: "erc20/0x091F9A57A3F58d758b6572E9d41675918EAC7F09",
      name: "Source Token",
      display: "srcx",
      symbol: "SRCX",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "binancesmartchain",
          base_denom: "0x454b90716a9435e7161a9aea5cf00e0acbe565ae",
          contract: "0xC891aBa0b42818fb4c975Bf6461033c62BCE75ff"
        },
        chain: {
          contract: "0xC891aBa0b42818fb4c975Bf6461033c62BCE75ff"
        },
        provider: "DeltaSwap.io"
      }],
      images: [{
        image_sync: {
          chain_name: "binancesmartchain",
          base_denom: "0x454b90716a9435e7161a9aea5cf00e0acbe565ae"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/srcx.png",
        theme: {
          primary_color_hex: "#7f22bc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/srcx.png"
      }
    },
    {
      description: "MEME Token (MEME) is the native staking token of the MEME Chain",
      denom_units: [{
        denom: "ibc/747FF58D3F211497581252CEBE11D7E785FC1E53AC5C29497A361E3830F1AF4A",
        exponent: 0
      }, {
        denom: "meme",
        exponent: 6
      }],
      base: "ibc/747FF58D3F211497581252CEBE11D7E785FC1E53AC5C29497A361E3830F1AF4A",
      name: "MEME",
      display: "meme",
      symbol: "MEME",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.svg"
      },
      type_asset: "ics20",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "meme",
          base_denom: "umeme",
          channel_id: "channel-11"
        },
        chain: {
          channel_id: "channel-64",
          path: "transfer/channel-64/umeme"
        }
      }],
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/meme/images/meme.svg",
        image_sync: {
          chain_name: "meme",
          base_denom: "umeme"
        },
        theme: {
          primary_color_hex: "#b7dcd8"
        }
      }]
    }
  ]
};
Fv.default = $H;
var $v = {};
Object.defineProperty($v, "__esModule", { value: !0 });
const zH = {
  $schema: "../chain.schema.json",
  chain_name: "planq",
  status: "live",
  network_type: "mainnet",
  website: "https://planq.network/",
  pretty_name: "Planq",
  chain_type: "cosmos",
  chain_id: "planq_7070-2",
  bech32_prefix: "plq",
  node_home: "$HOME/.planqd",
  daemon_name: "planqd",
  key_algos: ["ethsecp256k1"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aplanq",
      fixed_min_gas_price: 2e10,
      low_gas_price: 3e10,
      average_gas_price: 35e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aplanq"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.46.3"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.planq.network",
        provider: "planq.network"
      },
      {
        address: "https://planq.rpc.bccnodes.com",
        provider: "BccNodes"
      },
      {
        address: "https://planq.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.planq.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://planq-rpc.kynraze.com",
        provider: "Kynraze"
      },
      {
        address: "https://rpc.planq.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://rpc.planq.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://planq-rpc.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://rpc.planq.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://planq.rpc.skynodejs.net",
        provider: "skynodejs"
      },
      {
        address: "https://planq-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://mainnet-planq-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://planq_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://rpc-planq.blockval.io",
        provider: "Blockval"
      }
    ],
    rest: [
      {
        address: "https://rest.planq.network",
        provider: "planq.network"
      },
      {
        address: "https://planq.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.planq.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://planq-api.kynraze.com",
        provider: "Kynraze"
      },
      {
        address: "https://api.planq.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://api.planq.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://planq-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://api.planq.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://planq.api.skynodejs.net",
        provider: "skynodejs"
      },
      {
        address: "https://planq-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://mainnet-planq-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://planq_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://api-planq.blockval.io",
        provider: "Blockval"
      }
    ],
    grpc: [
      {
        address: "grpc.planq.network:443",
        provider: "planq.network"
      },
      {
        address: "planq.grpc.m.stavr.tech:2070",
        provider: "🔥STAVR🔥"
      },
      {
        address: "planq.grpc.bccnodes.com:443",
        provider: "BccNodes"
      },
      {
        address: "grpc.planq.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "https://grpc-planq.nodine.id",
        provider: "Nodine.id"
      },
      {
        address: "https://grpc-planq.sxlzptprjkt.xyz:443",
        provider: "sxlzptprjkt | VALIDATOR"
      },
      {
        address: "https://grpc.planq.nodexcapital.com:443",
        provider: "NodeX Validator"
      },
      {
        address: "grpc.planq.roomit.xyz:8443",
        provider: "Roomit"
      },
      {
        address: "https://grpc.planq.hexnodes.co:33090",
        provider: "Hexnodes"
      },
      {
        address: "planq-grpc.genznodes.dev:28090",
        provider: "genznodes"
      },
      {
        address: "grpc.planq.safeblock.space:9090",
        provider: "Safe Block"
      },
      {
        address: "https://planq.grpc.skynodejs.net",
        provider: "skynodejs"
      },
      {
        address: "planq-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "mainnet-planq.konsortech.xyz:10090",
        provider: "KonsorTech"
      },
      {
        address: "https://grpc-planq.blockval.io",
        provider: "Blockval"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://evm-rpc.planq.network",
        provider: "planq.network"
      },
      {
        address: "https://jsonrpc.planq.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rpc-evm-planq.sxlzptprjkt.xyz",
        provider: "sxlzptprjkt | VALIDATOR"
      },
      {
        address: "https://jsonrpc.planq.nodexcapital.com",
        provider: "NodeX Validator"
      },
      {
        address: "https://planq-rpc-evm.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://evm.planq.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://planq-jsonrpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://mainnet-planq-evmrpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://planq_mainnet_evm.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://evm.planq.roomit.xyz",
        provider: "Roomit"
      }
    ]
  },
  explorers: [
    {
      kind: "bigdipper",
      url: "https://explorer.planq.network",
      tx_page: "https://explorer.planq.network/transactions/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Planq-Mainnet",
      tx_page: "https://explorer.stavr.tech/Planq-Mainnet/tx/${txHash}"
    },
    {
      kind: "blockscout",
      url: "https://evm.planq.network",
      tx_page: "https://evm.planq.network/tx/${txHash}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/planq",
      tx_page: "https://explorer.nodestake.top/planq/tx/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/planq",
      tx_page: "https://explorer.tcnetwork.io/planq/transaction/${txHash}"
    },
    {
      kind: "Roomit",
      url: "https://explorer.tendermint.roomit.xyz/planq-mainnet",
      tx_page: "https://explorer.tendermint.roomit.xyz/planq-mainnet/transaction/${txHash}"
    },
    {
      kind: "Kynraze",
      url: "https://explorer.kynraze.com/planq",
      tx_page: "https://explorer.kynraze.com/planq/tx/${txHash}"
    },
    {
      kind: "THE EXPLORER",
      url: "https://explorer.sxlzptprjkt.xyz/planq",
      tx_page: "https://explorer.sxlzptprjkt.xyz/planq/tx/${txHash}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodexcapital.com/planq",
      tx_page: "https://explorer.nodexcapital.com/planq/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/planq",
      tx_page: "https://atomscan.com/planq/transactions/${txHash}",
      account_page: "https://atomscan.com/planq/accounts/${accountAddress}"
    },
    {
      kind: "Indonode",
      url: "https://explorer.indonode.net/planq",
      tx_page: "https://explorer.indonode.net/planq/tx/${txHash}"
    },
    {
      kind: "Safe Block",
      url: "https://explorer.safeblock.space/planq",
      tx_page: "https://explorer.safeblock.space/planq/tx/${txHash}"
    },
    {
      kind: "KonsorTech",
      url: "https://explorer.konsortech.xyz/planq",
      tx_page: "https://explorer.konsortech.xyz/planq/tx/${txHash}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/planq",
      tx_page: "https://explorer.whenmoonwhenlambo.money/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/planq/images/planq.svg",
    theme: {
      primary_color_hex: "#d4f3fb"
    }
  }]
};
$v.default = zH;
var zv = {};
Object.defineProperty(zv, "__esModule", { value: !0 });
const qH = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-82",
      connection_id: "connection-83"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-561",
      connection_id: "connection-486"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-112",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-994",
      connection_id: "connection-693"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-5",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-446",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-195",
      connection_id: "connection-165"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-102",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-70",
      connection_id: "connection-46"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-144",
      connection_id: "connection-151"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-103",
      connection_id: "connection-95"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-567",
      connection_id: "connection-490"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-82",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2318",
      connection_id: "connection-1815"
    },
    chain_2: {
      chain_name: "planq",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-492",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "planq",
      client_id: "07-tendermint-545",
      connection_id: "connection-477"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-21",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-59",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "planq",
      client_id: "07-tendermint-558",
      connection_id: "connection-483"
    },
    chain_2: {
      chain_name: "source",
      client_id: "07-tendermint-10",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
zv.default = qH;
var qv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Cs, "__esModule", { value: !0 });
Cs.ibc = Cs.chain = Cs.assets = void 0;
const SH = qv(Fv), TH = qv($v), RH = qv(zv);
Cs.assets = SH.default;
Cs.chain = TH.default;
Cs.ibc = RH.default;
var Es = {}, Sv = {};
Object.defineProperty(Sv, "__esModule", { value: !0 });
const OH = {
  $schema: "../assetlist.schema.json",
  chain_name: "point",
  assets: [{
    description: "The native governance and staking token of the Point network",
    denom_units: [{
      denom: "apoint",
      exponent: 0
    }, {
      denom: "point",
      exponent: 18
    }],
    base: "apoint",
    name: "Point",
    display: "point",
    symbol: "POINT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/point/images/point-logo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/point/images/point-logo.svg"
    },
    coingecko_id: "point-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/point/images/point-logo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/point/images/point-logo.svg",
      theme: {
        primary_color_hex: "#040404"
      }
    }]
  }]
};
Sv.default = OH;
var Tv = {};
Object.defineProperty(Tv, "__esModule", { value: !0 });
const MH = {
  $schema: "../chain.schema.json",
  chain_name: "point",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Point Network",
  chain_type: "cosmos",
  chain_id: "point_10687-1",
  bech32_prefix: "point",
  node_home: "$HOME/.pointd",
  daemon_name: "pointd",
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "apoint",
      low_gas_price: 5e9,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "apoint"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/point/images/point-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/point/images/point-logo.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc-mainnet-1.point.space:26657",
        provider: "Point Network"
      },
      {
        address: "https://rpc.point.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://point.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.point.indonode.net",
        provider: "Indonode"
      }
    ],
    rest: [
      {
        address: "https://rpc-mainnet-1.point.space:1317",
        provider: "Point Network"
      },
      {
        address: "https://point.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.point.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://api.point.indonode.net",
        provider: "Indonode"
      }
    ],
    grpc: [
      {
        address: "grpc.point.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "point.grpc.m.stavr.tech:2050",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://grpc.point.nodexcapital.com",
        provider: "⚡NodeX Validator⚡"
      },
      {
        address: "https://grpc.point.indonode.net:21090",
        provider: "Indonode"
      }
    ],
    "evm-http-jsonrpc": [{
      address: "https://rpc-mainnet-1.point.space",
      provider: "Point Network"
    }, {
      address: "https://jsonrpc.point.nodestake.top",
      provider: "NodeStake"
    }]
  },
  explorers: [
    {
      kind: "blockscout",
      url: "https://explorer.pointnetwork.io/",
      tx_page: "https://explorer.pointnetwork.io/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Point-Mainnet",
      tx_page: "https://explorer.stavr.tech/Point-Mainnet/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://cosmos.pointnetwork.io/",
      tx_page: "https://cosmos.pointnetwork.io/point/tx/${txHash}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodexcapital.com/point",
      tx_page: "https://explorer.nodexcapital.com/point/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/point",
      tx_page: "https://atomscan.com/point/transactions/${txHash}",
      account_page: "https://atomscan.com/point/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/point/images/point-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/point/images/point-logo.svg",
    theme: {
      primary_color_hex: "#040404"
    }
  }]
};
Tv.default = MH;
var Rv = {};
Object.defineProperty(Rv, "__esModule", { value: !0 });
const IH = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cosmoshub",
    client_id: "07-tendermint-926",
    connection_id: "connection-648"
  },
  chain_2: {
    chain_name: "point",
    client_id: "07-tendermint-1",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-404",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
Rv.default = IH;
var Ov = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Es, "__esModule", { value: !0 });
Es.ibc = Es.chain = Es.assets = void 0;
const NH = Ov(Sv), PH = Ov(Tv), UH = Ov(Rv);
Es.assets = NH.default;
Es.chain = PH.default;
Es.ibc = UH.default;
var Ds = {}, Mv = {};
Object.defineProperty(Mv, "__esModule", { value: !0 });
const HH = {
  $schema: "../assetlist.schema.json",
  chain_name: "provenance",
  assets: [{
    description: "Hash is the staking token of the Provenance Blockchain",
    denom_units: [{
      denom: "nhash",
      exponent: 0
    }, {
      denom: "hash",
      exponent: 9
    }],
    base: "nhash",
    name: "Hash",
    display: "hash",
    symbol: "HASH",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.svg"
    },
    coingecko_id: "provenance-blockchain",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.svg",
      theme: {
        primary_color_hex: "#4c7cdc"
      }
    }]
  }]
};
Mv.default = HH;
var Iv = {};
Object.defineProperty(Iv, "__esModule", { value: !0 });
const LH = {
  $schema: "../chain.schema.json",
  chain_name: "provenance",
  status: "live",
  network_type: "mainnet",
  website: "https://provenance.io/",
  pretty_name: "Provenance",
  chain_type: "cosmos",
  chain_id: "pio-mainnet-1",
  bech32_prefix: "pb",
  daemon_name: "provenanced",
  node_home: "$HOME/Provenance",
  key_algos: ["secp256k1"],
  slip44: 505,
  fees: {
    fee_tokens: [{
      denom: "nhash",
      fixed_min_gas_price: 1905,
      low_gas_price: 1905,
      average_gas_price: 2100,
      high_gas_price: 2500
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "nhash"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46.13",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc-provenance.takeshi.team/",
        provider: "TAKESHI"
      },
      {
        address: "https://rpc.provenance.io/",
        provider: "Figure"
      },
      {
        address: "https://rpc-provenance-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://provenance-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://provenance-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://provenance-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://rpc.provenance.blockval.io/",
        provider: "Blockval"
      },
      {
        address: "https://provenance-rpc.panthea.eu",
        provider: "Panthea EU"
      },
      {
        address: "https://provenance_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://rpc.pio-mainnet-1.provenance.aviaone.com",
        provider: "AVIAONE 🟢"
      }
    ],
    rest: [
      {
        address: "https://api-provenance.takeshi.team",
        provider: "TAKESHI"
      },
      {
        address: "https://provenance-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://api.provenance.io",
        provider: "Figure"
      },
      {
        address: "https://provenance.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-provenance-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://provenance-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://provenance-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://api.provenance.blockval.io",
        provider: "Blockval"
      },
      {
        address: "https://provenance-api.panthea.eu",
        provider: "Panthea EU"
      },
      {
        address: "https://provenance_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://api.pio-mainnet-1.provenance.aviaone.com",
        provider: "AVIAONE 🟢"
      }
    ],
    grpc: [
      {
        address: "grpc-provenance.takeshi.team:443",
        provider: "TAKESHI"
      },
      {
        address: "provenance-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-provenance-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "grpc.provenance.blockval.io:9290",
        provider: "Blockval"
      },
      {
        address: "provenance-grpc.panthea.eu:16780",
        provider: "Panthea EU"
      },
      {
        address: "grpc.pio-mainnet-1.provenance.aviaone.com:9231",
        provider: "AVIAONE 🟢"
      }
    ]
  },
  explorers: [
    {
      kind: "Provenance",
      url: "https://explorer.provenance.io",
      tx_page: "https://explorer.provenance.io/tx/${txHash}"
    },
    {
      kind: "hubble",
      url: "https://hubble.figment.io/provenance/chains/pio-mainnet-1",
      tx_page: "https://hubble.figment.io/provenance/chains/pio-mainnet-1/${block}/transactions/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/provenance",
      tx_page: "https://ping.pub/provenance/tx/${txHash}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/provenance",
      tx_page: "https://www.mintscan.io/provenance/transactions/${txHash}",
      account_page: "https://www.mintscan.io/provenance/accounts/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Provenance",
      tx_page: "https://explorer.stavr.tech/Provenance/txs/${txHash}",
      account_page: "https://explorer.stavr.tech/Provenance/account/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/provenance",
      tx_page: "https://ezstaking.app/provenance/txs/${txHash}",
      account_page: "https://ezstaking.app/provenance/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/provenance",
      tx_page: "https://atomscan.com/provenance/transactions/${txHash}",
      account_page: "https://atomscan.com/provenance/accounts/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/provenance",
      tx_page: "https://explorer.whenmoonwhenlambo.money/provenance/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/provenance/account/${accountAddress}"
    },
    {
      kind: "AVIAONE 🟢",
      url: "https://mainnet.explorer.aviaone.com/provenance",
      tx_page: "https://mainnet.explorer.aviaone.com/provenance/tx/${txHash}",
      account_page: "https://mainnet.explorer.aviaone.com/provenance/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/provenance/images/prov.svg",
    theme: {
      primary_color_hex: "#4c7cdc"
    }
  }]
};
Iv.default = LH;
var Nv = {};
Object.defineProperty(Nv, "__esModule", { value: !0 });
const WH = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-175",
      connection_id: "connection-153"
    },
    chain_2: {
      chain_name: "provenance",
      client_id: "07-tendermint-35",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-30",
      connection_id: "connection-37"
    },
    chain_2: {
      chain_name: "provenance",
      client_id: "07-tendermint-36",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1899",
      connection_id: "connection-1472"
    },
    chain_2: {
      chain_name: "provenance",
      client_id: "07-tendermint-31",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-222",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
Nv.default = WH;
var Pv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ds, "__esModule", { value: !0 });
Ds.ibc = Ds.chain = Ds.assets = void 0;
const VH = Pv(Mv), GH = Pv(Iv), KH = Pv(Nv);
Ds.assets = VH.default;
Ds.chain = GH.default;
Ds.ibc = KH.default;
var Bs = {}, Uv = {};
Object.defineProperty(Uv, "__esModule", { value: !0 });
const XH = {
  $schema: "../assetlist.schema.json",
  chain_name: "pryzm",
  assets: [
    {
      description: "The native token of PRYZM",
      denom_units: [{
        denom: "upryzm",
        exponent: 0
      }, {
        denom: "pryzm",
        exponent: 6
      }],
      base: "upryzm",
      name: "Pryzm",
      display: "pryzm",
      symbol: "PRYZM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pryzm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pryzm.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pryzm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pryzm.svg",
        theme: {
          primary_color_hex: "#c6ddf5"
        }
      }]
    },
    {
      description: "The meme token of PRYZM",
      denom_units: [{
        denom: "factory/pryzm1jnhcsa5ddjsjq2t97v6a82z542rduxvtw6wd9h/uauuu",
        exponent: 0,
        aliases: ["uauuu"]
      }, {
        denom: "auuu",
        exponent: 6
      }],
      base: "factory/pryzm1jnhcsa5ddjsjq2t97v6a82z542rduxvtw6wd9h/uauuu",
      name: "AUUU",
      display: "auuu",
      symbol: "AUUU",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/AUUU.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/AUUU.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/AUUU.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/AUUU.svg",
        theme: {
          primary_color_hex: "#eb536c"
        }
      }]
    },
    {
      description: "The native staking and governance token of the Cosmos Hub",
      denom_units: [{
        denom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        exponent: 0,
        aliases: ["uatom"]
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
      name: "Atom",
      display: "atom",
      symbol: "ATOM",
      coingecko_id: "cosmos",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-859"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/uatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }]
    },
    {
      description: "The native staking and governance token of the Injective chain",
      denom_units: [{
        denom: "ibc/DE63D8AC34B752FB7D4CAA7594145EDE1C9FC256AC6D4043D0F12310EB8FC255",
        exponent: 0,
        aliases: ["inj"]
      }, {
        denom: "INJ",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/DE63D8AC34B752FB7D4CAA7594145EDE1C9FC256AC6D4043D0F12310EB8FC255",
      name: "Injective",
      display: "INJ",
      symbol: "INJ",
      coingecko_id: "injective-protocol",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "inj",
          channel_id: "channel-284"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/inj"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg"
      },
      images: [{
        image_sync: {
          chain_name: "injective",
          base_denom: "inj"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg",
        theme: {
          primary_color_hex: "#04a2fc"
        }
      }]
    },
    {
      description: "The native staking and governance token of the Osmosis chain",
      denom_units: [{
        denom: "ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B",
        exponent: 0,
        aliases: ["uosmo"]
      }, {
        denom: "osmo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B",
      name: "Osmo",
      display: "osmo",
      symbol: "OSMO",
      coingecko_id: "osmosis",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo",
          channel_id: "channel-75755"
        },
        chain: {
          channel_id: "channel-2",
          path: "transfer/channel-2/uosmo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }]
    },
    {
      description: "The native staking and governance token of the Celestia chain",
      denom_units: [{
        denom: "ibc/BF28D9C17E0306B194D50F51C3B2590BEAD15E04E03ADD34C3A26E62D85C9676",
        exponent: 0,
        aliases: ["utia"]
      }, {
        denom: "tia",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/BF28D9C17E0306B194D50F51C3B2590BEAD15E04E03ADD34C3A26E62D85C9676",
      name: "Tia",
      display: "tia",
      symbol: "TIA",
      coingecko_id: "celestia",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "celestia",
          base_denom: "utia",
          channel_id: "channel-34"
        },
        chain: {
          channel_id: "channel-3",
          path: "transfer/channel-3/utia"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg"
      },
      images: [{
        image_sync: {
          chain_name: "celestia",
          base_denom: "utia"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg",
        theme: {
          primary_color_hex: "#7c2cfb"
        }
      }]
    },
    {
      description: "The native staking and governance token of the Terra chain",
      denom_units: [{
        denom: "ibc/B8AF5D92165F35AB31F3FC7C7B444B9D240760FA5D406C49D24862BD0284E395",
        exponent: 0,
        aliases: ["uluna"]
      }, {
        denom: "luna",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B8AF5D92165F35AB31F3FC7C7B444B9D240760FA5D406C49D24862BD0284E395",
      name: "Luna",
      display: "luna",
      symbol: "LUNA",
      coingecko_id: "terra-luna-2",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "terra2",
          base_denom: "uluna",
          channel_id: "channel-473"
        },
        chain: {
          channel_id: "channel-4",
          path: "transfer/channel-4/uluna"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg"
      },
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "uluna"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg",
        theme: {
          primary_color_hex: "#f4de6f"
        }
      }]
    },
    {
      description: "Circle's USDC on Noble",
      denom_units: [{
        denom: "ibc/BFAAB7870A9AAABF64A7366DAAA0B8E5065EAA1FCE762F45677DC24BE796EF65",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/BFAAB7870A9AAABF64A7366DAAA0B8E5065EAA1FCE762F45677DC24BE796EF65",
      name: "USDC",
      display: "usdc",
      symbol: "USDC",
      coingecko_id: "usd-coin",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "noble",
          base_denom: "uusdc",
          channel_id: "channel-79"
        },
        chain: {
          channel_id: "channel-5",
          path: "transfer/channel-5/uusdc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "Circle's USDC on Axelar",
      denom_units: [{
        denom: "ibc/B9E4FD154C92D3A23BEA029906C4C5FF2FE74CB7E3A058290B77197A263CF88B",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B9E4FD154C92D3A23BEA029906C4C5FF2FE74CB7E3A058290B77197A263CF88B",
      name: "USDC (Axelar)",
      display: "usdc",
      symbol: "USDC.axl",
      coingecko_id: "axlusdc",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "axelar",
          base_denom: "uusdc",
          channel_id: "channel-155"
        },
        chain: {
          channel_id: "channel-13",
          path: "transfer/channel-13/uusdc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "axelar",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg",
        theme: {
          primary_color_hex: "#2474cc"
        }
      }]
    },
    {
      description: "The native staking and governance token of the dYdX chain",
      denom_units: [{
        denom: "ibc/F8CA5236869F819BC006EEF088E67889A26E4140339757878F0F4E229CDDA858",
        exponent: 0,
        aliases: ["adydx"]
      }, {
        denom: "dydx",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/F8CA5236869F819BC006EEF088E67889A26E4140339757878F0F4E229CDDA858",
      name: "dYdX",
      display: "dydx",
      symbol: "DYDX",
      coingecko_id: "dydx-chain",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "dydx",
          base_denom: "adydx",
          channel_id: "channel-71"
        },
        chain: {
          channel_id: "channel-24",
          path: "transfer/channel-24/adydx"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg"
      },
      images: [{
        image_sync: {
          chain_name: "dydx",
          base_denom: "adydx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
        theme: {
          primary_color_hex: "#21212f"
        }
      }]
    },
    {
      description: "Stride's liquid staked TIA",
      denom_units: [{
        denom: "ibc/FA78980867B7E87F382CDA00275C55DDC248CABC7DEE27AC6868CCF97DD5E02F",
        exponent: 0,
        aliases: ["stutia"]
      }, {
        denom: "stTIA",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/FA78980867B7E87F382CDA00275C55DDC248CABC7DEE27AC6868CCF97DD5E02F",
      name: "Stride Staked TIA",
      display: "stTIA",
      symbol: "stTIA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stutia",
          channel_id: "channel-257"
        },
        chain: {
          channel_id: "channel-23",
          path: "transfer/channel-23/stutia"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stutia"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Stride's liquid staked DYDX",
      denom_units: [{
        denom: "ibc/120DC39B61CC121E91525C1D51624E41BBE74C537D7B0BE50BBFF9A00E37B6EE",
        exponent: 0,
        aliases: ["stadydx"]
      }, {
        denom: "stDYDX",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/120DC39B61CC121E91525C1D51624E41BBE74C537D7B0BE50BBFF9A00E37B6EE",
      name: "Stride Staked DYDX",
      display: "stDYDX",
      symbol: "stDYDX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "stride",
          base_denom: "stadydx",
          channel_id: "channel-257"
        },
        chain: {
          channel_id: "channel-23",
          path: "transfer/channel-23/stadydx"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.svg"
      },
      images: [{
        image_sync: {
          chain_name: "stride",
          base_denom: "stadydx"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Drop Protocol's liquid staked ATOM",
      denom_units: [{
        denom: "ibc/EA6E1E8BA2EB9F681C4BD12C8C81A46530A62934F2BD561B120A00F46946CE87",
        exponent: 0,
        aliases: ["udatom"]
      }, {
        denom: "dATOM",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/EA6E1E8BA2EB9F681C4BD12C8C81A46530A62934F2BD561B120A00F46946CE87",
      name: "dATOM",
      display: "dATOM",
      symbol: "dATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1k6hr0f83e7un2wjf29cspk7j69jrnskk65k3ek2nj9dztrlzpj6q00rtsa/udatom",
          channel_id: "channel-4329"
        },
        chain: {
          channel_id: "channel-6",
          path: "transfer/channel-6/factory/neutron1k6hr0f83e7un2wjf29cspk7j69jrnskk65k3ek2nj9dztrlzpj6q00rtsa/udatom"
        }
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/dATOM.svg"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1k6hr0f83e7un2wjf29cspk7j69jrnskk65k3ek2nj9dztrlzpj6q00rtsa/udatom"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/dATOM.svg"
      }]
    },
    {
      description: "Pryzm's native liquid staking token for ATOM",
      denom_units: [{
        denom: "c:uatom",
        exponent: 0
      }, {
        denom: "catom",
        exponent: 6
      }],
      base: "c:uatom",
      name: "cAtom",
      display: "catom",
      symbol: "cATOM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        provider: "Pryzm"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cAtom.svg"
      }]
    },
    {
      description: "Pryzm's native liquid staking token for INJ",
      denom_units: [{
        denom: "c:inj",
        exponent: 0
      }, {
        denom: "cINJ",
        exponent: 6
      }],
      base: "c:inj",
      name: "cInj",
      display: "cINJ",
      symbol: "cINJ",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "injective",
          base_denom: "inj"
        },
        provider: "Pryzm"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cInj.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cInj.svg"
      }]
    },
    {
      description: "Pryzm's native liquid staking token for OSMO",
      denom_units: [{
        denom: "c:uosmo",
        exponent: 0
      }, {
        denom: "cosmo",
        exponent: 6
      }],
      base: "c:uosmo",
      name: "cOsmo",
      display: "cosmo",
      symbol: "cOSMO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        provider: "Pryzm"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cOsmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cOsmo.svg"
      }]
    },
    {
      description: "Pryzm's native liquid staking token for LUNA",
      denom_units: [{
        denom: "c:uluna",
        exponent: 0
      }, {
        denom: "cluna",
        exponent: 6
      }],
      base: "c:uluna",
      name: "cLuna",
      display: "cluna",
      symbol: "cLUNA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "terra2",
          base_denom: "uluna"
        },
        provider: "Pryzm"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cLuna.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cLuna.svg"
      }]
    },
    {
      description: "Pryzm's native liquid staking token for AUUU",
      denom_units: [{
        denom: "factory/pryzm1qg5ega6dykkxc307y25pecuufrjkxkaggkkxh7nad0vhyhtuhw3sk0s70x/cuauuu",
        exponent: 0
      }, {
        denom: "cauuu",
        exponent: 6
      }],
      base: "factory/pryzm1qg5ega6dykkxc307y25pecuufrjkxkaggkkxh7nad0vhyhtuhw3sk0s70x/cuauuu",
      name: "cAuuu",
      display: "cauuu",
      symbol: "cAUUU",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "pryzm",
          base_denom: "factory/pryzm1jnhcsa5ddjsjq2t97v6a82z542rduxvtw6wd9h/uauuu"
        },
        provider: "Pryzm"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cAuuu.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/cAuuu.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for ATOM with maturity of 30Sep2024",
      denom_units: [{
        denom: "p:uatom:30Sep2024",
        exponent: 0
      }, {
        denom: "pATOM30Sep2024",
        exponent: 6
      }],
      base: "p:uatom:30Sep2024",
      name: "pAtom (30Sep2024)",
      display: "pATOM30Sep2024",
      symbol: "pATOM-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for ATOM with maturity of 31Dec2024",
      denom_units: [{
        denom: "p:uatom:31Dec2024",
        exponent: 0
      }, {
        denom: "pATOM31Dec2024",
        exponent: 6
      }],
      base: "p:uatom:31Dec2024",
      name: "pAtom (31Dec2024)",
      display: "pATOM31Dec2024",
      symbol: "pATOM-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for ATOM with maturity of 31Dec2025",
      denom_units: [{
        denom: "p:uatom:31Dec2025",
        exponent: 0
      }, {
        denom: "pATOM31Dec2025",
        exponent: 6
      }],
      base: "p:uatom:31Dec2025",
      name: "pAtom (31Dec2025)",
      display: "pATOM31Dec2025",
      symbol: "pATOM-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for OSMO with maturity of 30Sep2024",
      denom_units: [{
        denom: "p:uosmo:30Sep2024",
        exponent: 0
      }, {
        denom: "pOSMO30Sep2024",
        exponent: 6
      }],
      base: "p:uosmo:30Sep2024",
      name: "pOsmo (30Sep2024)",
      display: "pOSMO30Sep2024",
      symbol: "pOSMO-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for OSMO with maturity of 31Dec2024",
      denom_units: [{
        denom: "p:uosmo:31Dec2024",
        exponent: 0
      }, {
        denom: "pOSMO31Dec2024",
        exponent: 6
      }],
      base: "p:uosmo:31Dec2024",
      name: "pOsmo (31Dec2024)",
      display: "pOSMO31Dec2024",
      symbol: "pOSMO-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for OSMO with maturity of 31Dec2025",
      denom_units: [{
        denom: "p:uosmo:31Dec2025",
        exponent: 0
      }, {
        denom: "pOSMO31Dec2025",
        exponent: 6
      }],
      base: "p:uosmo:31Dec2025",
      name: "pOsmo (31Dec2025)",
      display: "pOSMO31Dec2025",
      symbol: "pOSMO-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pOsmo.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for INJ with maturity of 30Sep2024",
      denom_units: [{
        denom: "p:inj:30Sep2024",
        exponent: 0
      }, {
        denom: "pINJ30Sep2024",
        exponent: 6
      }],
      base: "p:inj:30Sep2024",
      name: "pInj (30Sep2024)",
      display: "pINJ30Sep2024",
      symbol: "pINJ-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for INJ with maturity of 31Dec2024",
      denom_units: [{
        denom: "p:inj:31Dec2024",
        exponent: 0
      }, {
        denom: "pINJ31Dec2024",
        exponent: 6
      }],
      base: "p:inj:31Dec2024",
      name: "pInj (31Dec2024)",
      display: "pINJ31Dec2024",
      symbol: "pINJ-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for INJ with maturity of 31Dec2025",
      denom_units: [{
        denom: "p:inj:31Dec2025",
        exponent: 0
      }, {
        denom: "pINJ31Dec2025",
        exponent: 6
      }],
      base: "p:inj:31Dec2025",
      name: "pInj (31Dec2025)",
      display: "pINJ31Dec2025",
      symbol: "pINJ-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pInj.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for LUNA with maturity of 30Sep2024",
      denom_units: [{
        denom: "p:uluna:30Sep2024",
        exponent: 0
      }, {
        denom: "pLUNA30Sep2024",
        exponent: 6
      }],
      base: "p:uluna:30Sep2024",
      name: "pLuna (30Sep2024)",
      display: "pLUNA30Sep2024",
      symbol: "pLUNA-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for LUNA with maturity of 31Dec2024",
      denom_units: [{
        denom: "p:uluna:31Dec2024",
        exponent: 0
      }, {
        denom: "pLUNA31Dec2024",
        exponent: 6
      }],
      base: "p:uluna:31Dec2024",
      name: "pLuna (31Dec2024)",
      display: "pLUNA31Dec2024",
      symbol: "pLUNA-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for LUNA with maturity of 31Dec2025",
      denom_units: [{
        denom: "p:uluna:31Dec2025",
        exponent: 0
      }, {
        denom: "pLUNA31Dec2025",
        exponent: 6
      }],
      base: "p:uluna:31Dec2025",
      name: "pLuna (31Dec2025)",
      display: "pLUNA31Dec2025",
      symbol: "pLUNA-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pLuna.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for AUUU with maturity of 30Sep2024",
      denom_units: [{
        denom: "p:uauuu:30Sep2024",
        exponent: 0
      }, {
        denom: "pAUUU30Sep2024",
        exponent: 6
      }],
      base: "p:uauuu:30Sep2024",
      name: "pAuuu (30Sep2024)",
      display: "pAUUU30Sep2024",
      symbol: "pAUUU-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for AUUU with maturity of 31Dec2024",
      denom_units: [{
        denom: "p:uauuu:31Dec2024",
        exponent: 0
      }, {
        denom: "pAUUU31Dec2024",
        exponent: 6
      }],
      base: "p:uauuu:31Dec2024",
      name: "pAuuu (31Dec2024)",
      display: "pAUUU31Dec2024",
      symbol: "pAUUU-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for AUUU with maturity of 31Dec2025",
      denom_units: [{
        denom: "p:uauuu:31Dec2025",
        exponent: 0
      }, {
        denom: "pAUUU31Dec2025",
        exponent: 6
      }],
      base: "p:uauuu:31Dec2025",
      name: "pAuuu (31Dec2025)",
      display: "pAUUU31Dec2025",
      symbol: "pAUUU-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pAuuu.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for stTIA with maturity of 30Sep2024",
      denom_units: [{
        denom: "p:stutia:30Sep2024",
        exponent: 0
      }, {
        denom: "pstTIA30Sep2024",
        exponent: 6
      }],
      base: "p:stutia:30Sep2024",
      name: "pstTia (30Sep2024)",
      display: "pstTIA30Sep2024",
      symbol: "pstTIA-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for stTIA with maturity of 31Dec2024",
      denom_units: [{
        denom: "p:stutia:31Dec2024",
        exponent: 0
      }, {
        denom: "pstTIA31Dec2024",
        exponent: 6
      }],
      base: "p:stutia:31Dec2024",
      name: "pstTia (31Dec2024)",
      display: "pstTIA31Dec2024",
      symbol: "pstTIA-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for stTIA with maturity of 31Dec2025",
      denom_units: [{
        denom: "p:stutia:31Dec2025",
        exponent: 0
      }, {
        denom: "pstTIA31Dec2025",
        exponent: 6
      }],
      base: "p:stutia:31Dec2025",
      name: "pstTia (31Dec2025)",
      display: "pstTIA31Dec2025",
      symbol: "pstTIA-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstTia.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for stDYDX with maturity of 30Sep2024",
      denom_units: [{
        denom: "p:stadydx:30Sep2024",
        exponent: 0
      }, {
        denom: "pstDYDX30Sep2024",
        exponent: 18
      }],
      base: "p:stadydx:30Sep2024",
      name: "pstDydx (30Sep2024)",
      display: "pstDYDX30Sep2024",
      symbol: "pstDYDX-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for stDYDX with maturity of 31Dec2024",
      denom_units: [{
        denom: "p:stadydx:31Dec2024",
        exponent: 0
      }, {
        denom: "pstDYDX31Dec2024",
        exponent: 18
      }],
      base: "p:stadydx:31Dec2024",
      name: "pstDydx (31Dec2024)",
      display: "pstDYDX31Dec2024",
      symbol: "pstDYDX-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for stDYDX with maturity of 31Dec2025",
      denom_units: [{
        denom: "p:stadydx:31Dec2025",
        exponent: 0
      }, {
        denom: "pstDYDX31Dec2025",
        exponent: 18
      }],
      base: "p:stadydx:31Dec2025",
      name: "pstDydx (31Dec2025)",
      display: "pstDYDX31Dec2025",
      symbol: "pstDYDX-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pstDydx.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for dATOM with maturity of 31Dec2024",
      denom_units: [{
        denom: "p:udatom:31Dec2024",
        exponent: 0
      }, {
        denom: "pdATOM31Dec2024",
        exponent: 6
      }],
      base: "p:udatom:31Dec2024",
      name: "pdAtom (31Dec2024)",
      display: "pdATOM31Dec2024",
      symbol: "pdATOM-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for dATOM with maturity of 30Jun2025",
      denom_units: [{
        denom: "p:udatom:30Jun2025",
        exponent: 0
      }, {
        denom: "pdATOM30Jun2025",
        exponent: 6
      }],
      base: "p:udatom:30Jun2025",
      name: "pdAtom (30Jun2025)",
      display: "pdATOM30Jun2025",
      symbol: "pdATOM-30Jun2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted principal token for dATOM with maturity of 31Dec2025",
      denom_units: [{
        denom: "p:udatom:31Dec2025",
        exponent: 0
      }, {
        denom: "pdATOM31Dec2025",
        exponent: 6
      }],
      base: "p:udatom:31Dec2025",
      name: "pdAtom (31Dec2025)",
      display: "pdATOM31Dec2025",
      symbol: "pdATOM-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pdAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for ATOM with maturity of 30Sep2024",
      denom_units: [{
        denom: "y:uatom:30Sep2024",
        exponent: 0
      }, {
        denom: "yATOM30Sep2024",
        exponent: 6
      }],
      base: "y:uatom:30Sep2024",
      name: "yAtom (30Sep2024)",
      display: "yATOM30Sep2024",
      symbol: "yATOM-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for ATOM with maturity of 31Dec2024",
      denom_units: [{
        denom: "y:uatom:31Dec2024",
        exponent: 0
      }, {
        denom: "yATOM31Dec2024",
        exponent: 6
      }],
      base: "y:uatom:31Dec2024",
      name: "yAtom (31Dec2024)",
      display: "yATOM31Dec2024",
      symbol: "yATOM-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for ATOM with maturity of 31Dec2025",
      denom_units: [{
        denom: "y:uatom:31Dec2025",
        exponent: 0
      }, {
        denom: "yATOM31Dec2025",
        exponent: 6
      }],
      base: "y:uatom:31Dec2025",
      name: "yAtom (31Dec2025)",
      display: "yATOM31Dec2025",
      symbol: "yATOM-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for OSMO with maturity of 30Sep2024",
      denom_units: [{
        denom: "y:uosmo:30Sep2024",
        exponent: 0
      }, {
        denom: "yOSMO30Sep2024",
        exponent: 6
      }],
      base: "y:uosmo:30Sep2024",
      name: "yOsmo (30Sep2024)",
      display: "yOSMO30Sep2024",
      symbol: "yOSMO-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for OSMO with maturity of 31Dec2024",
      denom_units: [{
        denom: "y:uosmo:31Dec2024",
        exponent: 0
      }, {
        denom: "yOSMO31Dec2024",
        exponent: 6
      }],
      base: "y:uosmo:31Dec2024",
      name: "yOsmo (31Dec2024)",
      display: "yOSMO31Dec2024",
      symbol: "yOSMO-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for OSMO with maturity of 31Dec2025",
      denom_units: [{
        denom: "y:uosmo:31Dec2025",
        exponent: 0
      }, {
        denom: "yOSMO31Dec2025",
        exponent: 6
      }],
      base: "y:uosmo:31Dec2025",
      name: "yOsmo (31Dec2025)",
      display: "yOSMO31Dec2025",
      symbol: "yOSMO-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yOsmo.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for INJ with maturity of 30Sep2024",
      denom_units: [{
        denom: "y:inj:30Sep2024",
        exponent: 0
      }, {
        denom: "yINJ30Sep2024",
        exponent: 6
      }],
      base: "y:inj:30Sep2024",
      name: "yInj (30Sep2024)",
      display: "yINJ30Sep2024",
      symbol: "yINJ-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for INJ with maturity of 31Dec2024",
      denom_units: [{
        denom: "y:inj:31Dec2024",
        exponent: 0
      }, {
        denom: "yINJ31Dec2024",
        exponent: 6
      }],
      base: "y:inj:31Dec2024",
      name: "yInj (31Dec2024)",
      display: "yINJ31Dec2024",
      symbol: "yINJ-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for INJ with maturity of 31Dec2025",
      denom_units: [{
        denom: "y:inj:31Dec2025",
        exponent: 0
      }, {
        denom: "yINJ31Dec2025",
        exponent: 6
      }],
      base: "y:inj:31Dec2025",
      name: "yInj (31Dec2025)",
      display: "yINJ31Dec2025",
      symbol: "yINJ-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yInj.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for LUNA with maturity of 30Sep2024",
      denom_units: [{
        denom: "y:uluna:30Sep2024",
        exponent: 0
      }, {
        denom: "yLUNA30Sep2024",
        exponent: 6
      }],
      base: "y:uluna:30Sep2024",
      name: "yLuna (30Sep2024)",
      display: "yLUNA30Sep2024",
      symbol: "yLUNA-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for LUNA with maturity of 31Dec2024",
      denom_units: [{
        denom: "y:uluna:31Dec2024",
        exponent: 0
      }, {
        denom: "yLUNA31Dec2024",
        exponent: 6
      }],
      base: "y:uluna:31Dec2024",
      name: "yLuna (31Dec2024)",
      display: "yLUNA31Dec2024",
      symbol: "yLUNA-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for LUNA with maturity of 31Dec2025",
      denom_units: [{
        denom: "y:uluna:31Dec2025",
        exponent: 0
      }, {
        denom: "yLUNA31Dec2025",
        exponent: 6
      }],
      base: "y:uluna:31Dec2025",
      name: "yLuna (31Dec2025)",
      display: "yLUNA31Dec2025",
      symbol: "yLUNA-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yLuna.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for AUUU with maturity of 30Sep2024",
      denom_units: [{
        denom: "y:uauuu:30Sep2024",
        exponent: 0
      }, {
        denom: "yAUUU30Sep2024",
        exponent: 6
      }],
      base: "y:uauuu:30Sep2024",
      name: "yAuuu (30Sep2024)",
      display: "yAUUU30Sep2024",
      symbol: "yAUUU-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for AUUU with maturity of 31Dec2024",
      denom_units: [{
        denom: "y:uauuu:31Dec2024",
        exponent: 0
      }, {
        denom: "yAUUU31Dec2024",
        exponent: 6
      }],
      base: "y:uauuu:31Dec2024",
      name: "yAuuu (31Dec2024)",
      display: "yAUUU31Dec2024",
      symbol: "yAUUU-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for AUUU with maturity of 31Dec2025",
      denom_units: [{
        denom: "y:uauuu:31Dec2025",
        exponent: 0
      }, {
        denom: "yAUUU31Dec2025",
        exponent: 6
      }],
      base: "y:uauuu:31Dec2025",
      name: "yAuuu (31Dec2025)",
      display: "yAUUU31Dec2025",
      symbol: "yAUUU-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/yAuuu.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for stTIA with maturity of 30Sep2024",
      denom_units: [{
        denom: "y:stutia:30Sep2024",
        exponent: 0
      }, {
        denom: "ystTIA30Sep2024",
        exponent: 6
      }],
      base: "y:stutia:30Sep2024",
      name: "ystTia (30Sep2024)",
      display: "ystTIA30Sep2024",
      symbol: "ystTIA-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for stTIA with maturity of 31Dec2024",
      denom_units: [{
        denom: "y:stutia:31Dec2024",
        exponent: 0
      }, {
        denom: "ystTIA31Dec2024",
        exponent: 6
      }],
      base: "y:stutia:31Dec2024",
      name: "ystTia (31Dec2024)",
      display: "ystTIA31Dec2024",
      symbol: "ystTIA-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for stTIA with maturity of 31Dec2025",
      denom_units: [{
        denom: "y:stutia:31Dec2025",
        exponent: 0
      }, {
        denom: "ystTIA31Dec2025",
        exponent: 6
      }],
      base: "y:stutia:31Dec2025",
      name: "ystTia (31Dec2025)",
      display: "ystTIA31Dec2025",
      symbol: "ystTIA-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystTia.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for stDYDX with maturity of 30Sep2024",
      denom_units: [{
        denom: "y:stadydx:30Sep2024",
        exponent: 0
      }, {
        denom: "ystDYDX30Sep2024",
        exponent: 6
      }],
      base: "y:stadydx:30Sep2024",
      name: "ystDydx (30Sep2024)",
      display: "ystDYDX30Sep2024",
      symbol: "ystDYDX-30Sep2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for stDYDX with maturity of 31Dec2024",
      denom_units: [{
        denom: "y:stadydx:31Dec2024",
        exponent: 0
      }, {
        denom: "ystDYDX31Dec2024",
        exponent: 6
      }],
      base: "y:stadydx:31Dec2024",
      name: "ystDydx (31Dec2024)",
      display: "ystDYDX31Dec2024",
      symbol: "ystDYDX-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for stDYDX with maturity of 31Dec2025",
      denom_units: [{
        denom: "y:stadydx:31Dec2025",
        exponent: 0
      }, {
        denom: "ystDYDX31Dec2025",
        exponent: 6
      }],
      base: "y:stadydx:31Dec2025",
      name: "ystDydx (31Dec2025)",
      display: "ystDYDX31Dec2025",
      symbol: "ystDYDX-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ystDydx.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for dATOM with maturity of 31Dec2024",
      denom_units: [{
        denom: "y:udatom:31Dec2024",
        exponent: 0
      }, {
        denom: "ydATOM31Dec2024",
        exponent: 6
      }],
      base: "y:udatom:31Dec2024",
      name: "ydAtom (31Dec2024)",
      display: "ydATOM31Dec2024",
      symbol: "ydATOM-31Dec2024",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for dATOM with maturity of 30Jun2025",
      denom_units: [{
        denom: "y:udatom:30Jun2025",
        exponent: 0
      }, {
        denom: "ydATOM30Jun2025",
        exponent: 6
      }],
      base: "y:udatom:30Jun2025",
      name: "ydAtom (30Jun2025)",
      display: "ydATOM30Jun2025",
      symbol: "ydATOM-30Jun2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.svg"
      }]
    },
    {
      description: "Pryzm's refracted yield token for dATOM with maturity of 31Dec2025",
      denom_units: [{
        denom: "y:udatom:31Dec2025",
        exponent: 0
      }, {
        denom: "ydATOM31Dec2025",
        exponent: 6
      }],
      base: "y:udatom:31Dec2025",
      name: "ydAtom (31Dec2025)",
      display: "ydATOM31Dec2025",
      symbol: "ydATOM-31Dec2025",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/ydAtom.svg"
      }]
    },
    {
      description: "Pryzm's LP token for USDC / USDC.axl pool",
      denom_units: [{
        denom: "lp:6:uusdc.axl-uusdc",
        exponent: 0
      }, {
        denom: "lp:6:usdc.axl-usdc",
        exponent: 6
      }],
      base: "lp:6:uusdc.axl-uusdc",
      name: "USDC / USDC.axl LP",
      display: "lp:6:usdc.axl-usdc",
      symbol: "USDC-USDC.axl-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for ATOM Yield pool",
      denom_units: [{
        denom: "lp:0:uatom",
        exponent: 0
      }, {
        denom: "lp:0:atom",
        exponent: 6
      }],
      base: "lp:0:uatom",
      name: "ATOM Yield LP",
      display: "lp:0:atom",
      symbol: "ATOM-YIELD-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for ATOM Boost pool",
      denom_units: [{
        denom: "lp:2:uatomypt-uatom",
        exponent: 0
      }, {
        denom: "lp:2:atomypt-atom",
        exponent: 6
      }],
      base: "lp:2:uatomypt-uatom",
      name: "ATOM Boost LP",
      display: "lp:2:atomypt-atom",
      symbol: "ATOM-BOOST-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for ATOM / USDC pool",
      denom_units: [{
        denom: "lp:3:uatom-uusdc",
        exponent: 0
      }, {
        denom: "lp:3:atom-usdc",
        exponent: 6
      }],
      base: "lp:3:uatom-uusdc",
      name: "ATOM / USDC LP",
      display: "lp:3:atom-usdc",
      symbol: "ATOM-USDC-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for INJ Yield pool",
      denom_units: [{
        denom: "lp:1:inj",
        exponent: 0
      }, {
        denom: "lp:1:INJ",
        exponent: 6
      }],
      base: "lp:1:inj",
      name: "INJ Yield LP",
      display: "lp:1:INJ",
      symbol: "INJ-YIELD-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for INJ Boost pool",
      denom_units: [{
        denom: "lp:4:injypt-inj",
        exponent: 0
      }, {
        denom: "lp:4:INJypt-INJ",
        exponent: 6
      }],
      base: "lp:4:injypt-inj",
      name: "INJ Boost LP",
      display: "lp:4:INJypt-INJ",
      symbol: "INJ-BOOST-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for INJ / USDC pool",
      denom_units: [{
        denom: "lp:5:inj-uusdc",
        exponent: 0
      }, {
        denom: "lp:5:INJ-usdc",
        exponent: 18
      }],
      base: "lp:5:inj-uusdc",
      name: "INJ / USDC LP",
      display: "lp:5:INJ-usdc",
      symbol: "INJ-USDC-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for OSMO Yield pool",
      denom_units: [{
        denom: "lp:8:uosmo",
        exponent: 0
      }, {
        denom: "lp:8:osmo",
        exponent: 6
      }],
      base: "lp:8:uosmo",
      name: "OSMO Yield LP",
      display: "lp:8:osmo",
      symbol: "OSMO-YIELD-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for OSMO Boost pool",
      denom_units: [{
        denom: "lp:10:uosmoypt-uosmo",
        exponent: 0
      }, {
        denom: "lp:10:osmoypt-osmo",
        exponent: 6
      }],
      base: "lp:10:uosmoypt-uosmo",
      name: "OSMO Boost LP",
      display: "lp:10:osmoypt-osmo",
      symbol: "OSMO-BOOST-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for OSMO / USDC pool",
      denom_units: [{
        denom: "lp:11:uosmo-uusdc",
        exponent: 0
      }, {
        denom: "lp:11:osmo-usdc",
        exponent: 6
      }],
      base: "lp:11:uosmo-uusdc",
      name: "OSMO / USDC LP",
      display: "lp:11:osmo-usdc",
      symbol: "OSMO-USDC-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for LUNA Yield pool",
      denom_units: [{
        denom: "lp:9:uluna",
        exponent: 0
      }, {
        denom: "lp:9:luna",
        exponent: 6
      }],
      base: "lp:9:uluna",
      name: "LUNA Yield LP",
      display: "lp:9:luna",
      symbol: "LUNA-YIELD-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for LUNA Boost pool",
      denom_units: [{
        denom: "lp:12:ulunaypt-uluna",
        exponent: 0
      }, {
        denom: "lp:12:lunaypt-luna",
        exponent: 6
      }],
      base: "lp:12:ulunaypt-uluna",
      name: "LUNA Boost LP",
      display: "lp:12:lunaypt-luna",
      symbol: "LUNA-BOOST-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for LUNA / USDC pool",
      denom_units: [{
        denom: "lp:13:uluna-uusdc",
        exponent: 0
      }, {
        denom: "lp:13:luna-usdc",
        exponent: 6
      }],
      base: "lp:13:uluna-uusdc",
      name: "LUNA / USDC LP",
      display: "lp:13:luna-usdc",
      symbol: "LUNA-USDC-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for AUUU Yield pool",
      denom_units: [{
        denom: "lp:14:uauuu",
        exponent: 0
      }, {
        denom: "lp:14:auuu",
        exponent: 6
      }],
      base: "lp:14:uauuu",
      name: "AUUU Yield LP",
      display: "lp:14:auuu",
      symbol: "AUUU-YIELD-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for AUUU Boost pool",
      denom_units: [{
        denom: "lp:17:uauuuypt-uauuu",
        exponent: 0
      }, {
        denom: "lp:17:auuuypt-auuu",
        exponent: 6
      }],
      base: "lp:17:uauuuypt-uauuu",
      name: "AUUU Boost LP",
      display: "lp:17:auuuypt-auuu",
      symbol: "AUUU-BOOST-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for AUUU / USDC pool",
      denom_units: [{
        denom: "lp:7:uauuu-uusdc",
        exponent: 0
      }, {
        denom: "lp:7:auuu-usdc",
        exponent: 6
      }],
      base: "lp:7:uauuu-uusdc",
      name: "AUUU / USDC LP",
      display: "lp:7:auuu-usdc",
      symbol: "AUUU-USDC-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for stDYDX Yield pool",
      denom_units: [{
        denom: "lp:15:stadydx",
        exponent: 0
      }, {
        denom: "lp:15:stdydx",
        exponent: 18
      }],
      base: "lp:15:stadydx",
      name: "stDYDX Yield LP",
      display: "lp:15:stdydx",
      symbol: "stDYDX-YIELD-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for stDYDX Boost pool",
      denom_units: [{
        denom: "lp:18:stadydxypt-adydx",
        exponent: 0
      }, {
        denom: "lp:18:stdydxypt-dydx",
        exponent: 18
      }],
      base: "lp:18:stadydxypt-adydx",
      name: "stDYDX Boost LP",
      display: "lp:18:stdydxypt-dydx",
      symbol: "stDYDX-BOOST-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for DYDX / USDC pool",
      denom_units: [{
        denom: "lp:19:adydx-uusdc",
        exponent: 0
      }, {
        denom: "lp:19:dydx-usdc",
        exponent: 18
      }],
      base: "lp:19:adydx-uusdc",
      name: "DYDX / USDC LP",
      display: "lp:19:dydx-usdc",
      symbol: "DYDX-USDC-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for stTIA Yield pool",
      denom_units: [{
        denom: "lp:16:stutia",
        exponent: 0
      }, {
        denom: "lp:16:sttia",
        exponent: 6
      }],
      base: "lp:16:stutia",
      name: "stTIA Yield LP",
      display: "lp:16:sttia",
      symbol: "stTIA-YIELD-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for stTIA Boost pool",
      denom_units: [{
        denom: "lp:20:stutiaypt-utia",
        exponent: 0
      }, {
        denom: "lp:20:sttiaypt-tia",
        exponent: 6
      }],
      base: "lp:20:stutiaypt-utia",
      name: "stTIA Boost LP",
      display: "lp:20:sttiaypt-tia",
      symbol: "stTIA-BOOST-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for TIA / USDC pool",
      denom_units: [{
        denom: "lp:21:utia-uusdc",
        exponent: 0
      }, {
        denom: "lp:21:tia-usdc",
        exponent: 6
      }],
      base: "lp:21:utia-uusdc",
      name: "TIA / USDC LP",
      display: "lp:21:tia-usdc",
      symbol: "TIA-USDC-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for dATOM Yield pool",
      denom_units: [{
        denom: "lp:22:udatom",
        exponent: 0
      }, {
        denom: "lp:22:datom",
        exponent: 6
      }],
      base: "lp:22:udatom",
      name: "dATOM Yield LP",
      display: "lp:22:datom",
      symbol: "dATOM-YIELD-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    },
    {
      description: "Pryzm's LP token for dATOM Boost pool",
      denom_units: [{
        denom: "lp:23:udatomypt-uatom",
        exponent: 0
      }, {
        denom: "lp:23:datomypt-atom",
        exponent: 6
      }],
      base: "lp:23:udatomypt-uatom",
      name: "dATOM Boost LP",
      display: "lp:23:datomypt-atom",
      symbol: "dATOM-BOOST-LP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/lp.svg"
      }]
    }
  ]
};
Uv.default = XH;
var Hv = {};
Object.defineProperty(Hv, "__esModule", { value: !0 });
const YH = {
  $schema: "../chain.schema.json",
  chain_name: "pryzm",
  website: "https://pryzm.zone",
  description: "Trade Your Future Yield, Today",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Pryzm",
  chain_type: "cosmos",
  chain_id: "pryzm-1",
  bech32_prefix: "pryzm",
  daemon_name: "pryzmd",
  node_home: "$HOME/.pryzm",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [
      {
        denom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        fixed_min_gas_price: 25e-4,
        low_gas_price: 25e-4,
        average_gas_price: 3e-3,
        high_gas_price: 4e-3
      },
      {
        denom: "ibc/DE63D8AC34B752FB7D4CAA7594145EDE1C9FC256AC6D4043D0F12310EB8FC255",
        fixed_min_gas_price: 5e8,
        low_gas_price: 5e8,
        average_gas_price: 6e8,
        high_gas_price: 7e8
      },
      {
        denom: "ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B",
        fixed_min_gas_price: 0.025,
        low_gas_price: 0.025,
        average_gas_price: 0.03,
        high_gas_price: 0.04
      },
      {
        denom: "ibc/BF28D9C17E0306B194D50F51C3B2590BEAD15E04E03ADD34C3A26E62D85C9676",
        fixed_min_gas_price: 2e-3,
        low_gas_price: 2e-3,
        average_gas_price: 3e-3,
        high_gas_price: 4e-3
      },
      {
        denom: "ibc/B8AF5D92165F35AB31F3FC7C7B444B9D240760FA5D406C49D24862BD0284E395",
        fixed_min_gas_price: 0.015,
        low_gas_price: 0.015,
        average_gas_price: 0.02,
        high_gas_price: 0.03
      },
      {
        denom: "ibc/BFAAB7870A9AAABF64A7366DAAA0B8E5065EAA1FCE762F45677DC24BE796EF65",
        fixed_min_gas_price: 0.02,
        low_gas_price: 0.02,
        average_gas_price: 0.03,
        high_gas_price: 0.04
      },
      {
        denom: "factory/pryzm1jnhcsa5ddjsjq2t97v6a82z542rduxvtw6wd9h/uauuu",
        fixed_min_gas_price: 0.01,
        low_gas_price: 0.01,
        average_gas_price: 0.015,
        high_gas_price: 0.02
      },
      {
        denom: "ibc/F8CA5236869F819BC006EEF088E67889A26E4140339757878F0F4E229CDDA858",
        fixed_min_gas_price: 1e10,
        low_gas_price: 1e10,
        average_gas_price: 12e9,
        high_gas_price: 14e9
      },
      {
        denom: "ibc/FA78980867B7E87F382CDA00275C55DDC248CABC7DEE27AC6868CCF97DD5E02F",
        fixed_min_gas_price: 2e-3,
        low_gas_price: 2e-3,
        average_gas_price: 3e-3,
        high_gas_price: 4e-3
      },
      {
        denom: "ibc/120DC39B61CC121E91525C1D51624E41BBE74C537D7B0BE50BBFF9A00E37B6EE",
        fixed_min_gas_price: 1e10,
        low_gas_price: 1e10,
        average_gas_price: 12e9,
        high_gas_price: 14e9
      },
      {
        denom: "ibc/EA6E1E8BA2EB9F681C4BD12C8C81A46530A62934F2BD561B120A00F46946CE87",
        fixed_min_gas_price: 25e-4,
        low_gas_price: 25e-4,
        average_gas_price: 3e-3,
        high_gas_price: 4e-3
      }
    ]
  },
  staking: {
    staking_tokens: [{
      denom: "upryzm"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.47.13",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.46.0"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.pryzm.zone",
        provider: "PRYZM"
      },
      {
        address: "https://rpc.lavenderfive.com:443/pryzm",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://pryzm-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    rest: [
      {
        address: "https://api.pryzm.zone",
        provider: "PRYZM"
      },
      {
        address: "https://rest.lavenderfive.com:443/pryzm",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://pryzm-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    grpc: [
      {
        address: "https://grpc.pryzm.zone",
        provider: "PRYZM"
      },
      {
        address: "pryzm.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "pryzm-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pryzm-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pryzm-logo.svg"
  },
  explorers: [{
    kind: "Chainscope",
    url: "https://chainsco.pe/pryzm",
    tx_page: "https://chainsco.pe/pryzm/tx/${txHash}",
    account_page: "https://chainsco.pe/pryzm/address/${accountAddress}",
    block_page: "https://chainsco.pe/pryzm/block/${blockHeight}",
    proposal_page: "https://chainsco.pe/pryzm/governance/proposal/${proposalId}",
    validator_page: "https://chainsco.pe/pryzm/validator/${validatorAddress}"
  }, {
    kind: "PingPub",
    url: "https://cosmosrun.info/pryzm",
    tx_page: "https://cosmosrun.info/pryzm/tx/${txHash}",
    account_page: "https://cosmosrun.info/pryzm/account/${accountAddress}",
    block_page: "https://cosmosrun.info/pryzm/blocks/${blockHeight}",
    proposal_page: "https://cosmosrun.info/pryzm/gov/${proposalId}",
    validator_page: "https://cosmosrun.info/pryzm/staking/${validatorAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pryzm-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pryzm/images/pryzm-logo.svg",
    theme: {
      primary_color_hex: "#141424"
    }
  }]
};
Hv.default = YH;
var Lv = {};
Object.defineProperty(Lv, "__esModule", { value: !0 });
const JH = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-224",
      connection_id: "connection-209"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-155",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-88",
      connection_id: "connection-57"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1304",
      connection_id: "connection-1038"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-859",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-0",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-863",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-8",
          port_id: "icacontroller-reward-uatom"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-861",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-9",
          port_id: "icacontroller-sweep-uatom"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-891",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-20",
          port_id: "icacontroller-delegation-uatom"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-29",
      connection_id: "connection-34"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-71",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-267",
      connection_id: "connection-268"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-284",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-1",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-285",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-10",
          port_id: "icacontroller-delegation-inj"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-286",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-11",
          port_id: "icacontroller-reward-inj"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-287",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-12",
          port_id: "icacontroller-sweep-inj"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-98",
      connection_id: "connection-72"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4329",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-100",
      connection_id: "connection-92"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-5",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-79",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3206",
      connection_id: "connection-2663"
    },
    chain_2: {
      chain_name: "pryzm",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-75755",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-2",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-76804",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-15",
          port_id: "icacontroller-reward-uosmo"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-76805",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-16",
          port_id: "icacontroller-sweep-uosmo"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-79080",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-22",
          port_id: "icacontroller-delegation-uosmo"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "pryzm",
      client_id: "07-tendermint-8",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-145",
      connection_id: "connection-145"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-257",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "pryzm",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-410",
      connection_id: "connection-414"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-4",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-473",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-17",
          port_id: "icacontroller-delegation-uluna"
        },
        chain_2: {
          channel_id: "channel-478",
          port_id: "icahost"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-18",
          port_id: "icacontroller-reward-uluna"
        },
        chain_2: {
          channel_id: "channel-479",
          port_id: "icahost"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-19",
          port_id: "icacontroller-sweep-uluna"
        },
        chain_2: {
          channel_id: "channel-480",
          port_id: "icahost"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      }
    ]
  }
];
Lv.default = JH;
var Wv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Bs, "__esModule", { value: !0 });
Bs.ibc = Bs.chain = Bs.assets = void 0;
const ZH = Wv(Uv), QH = Wv(Hv), eL = Wv(Lv);
Bs.assets = ZH.default;
Bs.chain = QH.default;
Bs.ibc = eL.default;
var Fs = {}, Vv = {};
Object.defineProperty(Vv, "__esModule", { value: !0 });
const nL = {
  $schema: "../assetlist.schema.json",
  chain_name: "pundix",
  assets: [{
    description: "PUNDIX token is the native token that functions within the Pundi X ecosystem.",
    extended_description: `PUNDIX token is the native token that functions within the Pundi X ecosystem, including PundiX Chain and XPOS. PUNDIX has several core use cases, including:
- Payment for goods and services from merchants through XPOS
- Gas Fee on PundiX Chain
- Listing tokens in the XPOS
- Merchant payments for loyalty programs and ads`,
    denom_units: [{
      denom: "ibc/55367B7B6572631B78A93C66EF9FDFCE87CDE372CC4ED7848DA78C1EB1DCDD78",
      exponent: 0
    }, {
      denom: "PUNDIX",
      exponent: 18
    }],
    type_asset: "ics20",
    base: "ibc/55367B7B6572631B78A93C66EF9FDFCE87CDE372CC4ED7848DA78C1EB1DCDD78",
    name: "Pundi X Token",
    display: "PUNDIX",
    symbol: "PUNDIX",
    traces: [{
      type: "ibc",
      counterparty: {
        chain_name: "fxcore",
        base_denom: "eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
        channel_id: "channel-0"
      },
      chain: {
        channel_id: "channel-0",
        path: "transfer/channel-0/eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"
      }
    }],
    images: [{
      image_sync: {
        chain_name: "fxcore",
        base_denom: "eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-token-logo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-token-logo.svg",
      theme: {
        primary_color_hex: "#f1d20c"
      }
    }],
    socials: {
      website: "https://pundix.com",
      twitter: "https://twitter.com/PundiXLabs"
    }
  }, {
    description: "Purse is the decentralised loyalty program for physical stores and merchants. PURSE token shall serve as governance token of the PURSE Merchant loyalty point platform, the gas fee as well as the transaction fee on PURSE Merchant platform. To launch any merchant loyalty tokens and do transaction on the merchant platform, users and merchants need Purse tokens.",
    denom_units: [{
      denom: "bsc0x29a63F4B209C29B4DC47f06FFA896F32667DAD2C",
      exponent: 0
    }, {
      denom: "PURSE",
      exponent: 18
    }],
    type_asset: "sdk.coin",
    base: "bsc0x29a63F4B209C29B4DC47f06FFA896F32667DAD2C",
    name: "PURSE Token",
    display: "PURSE",
    symbol: "PURSE",
    traces: [{
      type: "bridge",
      counterparty: {
        chain_name: "binancesmartchain",
        base_denom: "0x29a63F4B209C29B4DC47f06FFA896F32667DAD2C",
        contract: "0x84238c00c8313920826D798e3cF6793Ef4F610ad"
      },
      provider: "Function X"
    }],
    images: [{
      image_sync: {
        chain_name: "binancesmartchain",
        base_denom: "0x29a63F4B209C29B4DC47f06FFA896F32667DAD2C"
      },
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/purse-token-logo.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/purse-token-logo.png",
      theme: {
        primary_color_hex: "#1c1c1b"
      }
    }],
    socials: {
      website: "https://purse.land",
      twitter: "https://twitter.com/Purse_Land"
    }
  }]
};
Vv.default = nL;
var Gv = {};
Object.defineProperty(Gv, "__esModule", { value: !0 });
const tL = {
  $schema: "../chain.schema.json",
  chain_name: "pundix",
  chain_type: "cosmos",
  chain_id: "PUNDIX",
  website: "https://pundix.com",
  pretty_name: "Pundi X Chain",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "px",
  daemon_name: "pundixd",
  node_home: "$HOME/.pundix",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ibc/55367B7B6572631B78A93C66EF9FDFCE87CDE372CC4ED7848DA78C1EB1DCDD78",
      fixed_min_gas_price: 2e12,
      low_gas_price: 2e12,
      average_gas_price: 25e11,
      high_gas_price: 3e12
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ibc/55367B7B6572631B78A93C66EF9FDFCE87CDE372CC4ED7848DA78C1EB1DCDD78"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45.11"
  },
  description: "Pundi X Chain is a dedicated payment-focused blockchain in the Function X network. It is specially designed to perform high throughput transactions with low latency and low transaction fees. In addition, it provides room for future compliance requirement upgrades, hardware (XPOS) integration, and Point-of-Sales compatibility, with tokenonomics that offer incentives to merchants and payment processors.",
  apis: {
    rpc: [{
      address: "https://px-json.pundix.com",
      provider: "Pundi X"
    }, {
      address: "https://pundix.rpc.nodeshub.online:443",
      provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
    }],
    rest: [{
      address: "https://px-rest.pundix.com",
      provider: "Pundi X"
    }, {
      address: "https://pundix.api.nodeshub.online:443",
      provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
    }],
    grpc: [{
      address: "https://px-grpc.pundix.com",
      provider: "Pundi X"
    }, {
      address: "https://pundix.grpc.nodeshub.online",
      provider: "Nodes Hub"
    }]
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-chain-logo.svg",
    theme: {
      primary_color_hex: "#141414"
    }
  }, {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-chain-logo.png",
    theme: {
      primary_color_hex: "#141414"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pundix/images/pundi-x-chain-logo.svg"
  },
  explorers: [{
    kind: "starscan",
    url: "https://starscan.io",
    tx_page: "https://starscan.io/pundix/tx/${txHash}",
    account_page: "https://starscan.io/pundix/address/${accountAddress}"
  }, {
    kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
    url: "https://explorer.nodeshub.online/pundix/",
    tx_page: "https://explorer.nodeshub.online/pundix/tx/${txHash}",
    account_page: "https://explorer.nodeshub.online/pundix/accounts/${accountAddress}"
  }]
};
Gv.default = tL;
var Kv = {};
Object.defineProperty(Kv, "__esModule", { value: !0 });
const sL = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "fxcore",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "pundix",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3059",
    connection_id: "connection-2554"
  },
  chain_2: {
    chain_name: "pundix",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-12618",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Kv.default = sL;
var Xv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Fs, "__esModule", { value: !0 });
Fs.ibc = Fs.chain = Fs.assets = void 0;
const aL = Xv(Vv), oL = Xv(Gv), rL = Xv(Kv);
Fs.assets = aL.default;
Fs.chain = oL.default;
Fs.ibc = rL.default;
var $s = {}, Yv = {};
Object.defineProperty(Yv, "__esModule", { value: !0 });
const iL = {
  $schema: "../assetlist.schema.json",
  chain_name: "pylons",
  assets: [{
    description: "The revenue token for Pylons",
    denom_units: [{
      denom: "ubedrock",
      exponent: 0
    }, {
      denom: "rock",
      exponent: 6
    }],
    base: "ubedrock",
    name: "Pylons",
    display: "rock",
    symbol: "ROCK",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pylons/images/pylons.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pylons/images/pylons.png",
      theme: {
        primary_color_hex: "#ec4424"
      }
    }],
    socials: {
      website: "https://pylons.tech",
      twitter: "https://twitter.com/pylonstech"
    }
  }]
};
Yv.default = iL;
var Jv = {};
Object.defineProperty(Jv, "__esModule", { value: !0 });
const cL = {
  $schema: "../chain.schema.json",
  chain_name: "pylons",
  status: "live",
  network_type: "mainnet",
  website: "https://pylons.tech",
  pretty_name: "Pylons",
  chain_type: "cosmos",
  chain_id: "pylons-mainnet-1",
  bech32_prefix: "pylo",
  node_home: "$HOME/.pylons",
  daemon_name: "pylonsd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ubedrock",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0.5,
      high_gas_price: 1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ubedrock"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pylons/images/pylons.png"
  },
  apis: {
    rpc: [{
      address: "https://rpc.nodejumper.io:443/pylons",
      provider: "Nodejumper.io"
    }, {
      address: "https:/pylons-rpc.noders.services",
      provider: "[NODERS]TEAM"
    }],
    rest: [{
      address: "https://rest.nodejumper.io/pylons",
      provider: "Nodejumper.io"
    }, {
      address: "https://pylons-api.noders.services",
      provider: "[NODERS]TEAM"
    }]
  },
  explorers: [{
    kind: "Nodes.guru",
    url: "https://pylons.explorers.guru/",
    tx_page: "https://pylons.explorers.guru/transaction/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/pylons/images/pylons.png",
    theme: {
      primary_color_hex: "#ec4424"
    }
  }]
};
Jv.default = cL;
var Zv = {};
Object.defineProperty(Zv, "__esModule", { value: !0 });
const dL = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3070",
    connection_id: "connection-2558"
  },
  chain_2: {
    chain_name: "pylons",
    client_id: "07-tendermint-32",
    connection_id: "connection-25"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-17683",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-29",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live"
    }
  }]
}];
Zv.default = dL;
var Qv = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty($s, "__esModule", { value: !0 });
$s.ibc = $s.chain = $s.assets = void 0;
const mL = Qv(Yv), hL = Qv(Jv), pL = Qv(Zv);
$s.assets = mL.default;
$s.chain = hL.default;
$s.ibc = pL.default;
var fr = {}, e1 = {};
Object.defineProperty(e1, "__esModule", { value: !0 });
const lL = {
  $schema: "../assetlist.schema.json",
  chain_name: "qfs",
  assets: [{
    description: "QFS stands for Quantum Financial Systems, the aim is to bridge traditional finance with the crypto ecosystem",
    extended_description: "QFS stands for Quantum Financial Systems, a revolutionary concept designed to integrate traditional financial systems with the rapidly evolving world of cryptocurrency and blockchain technology. The primary aim of QFS is to create a seamless interface that allows for the secure, efficient, and transparent exchange of assets between these two financial realms. By leveraging advanced quantum computing capabilities, QFS seeks to enhance the speed and security of transactions, reduce the risk of fraud, and provide a robust framework for financial innovation. This system is poised to transform how we conduct financial operations, offering unprecedented levels of trust and efficiency in the global financial landscape. Through the integration of traditional banking structures with the decentralized nature of cryptocurrencies, QFS aspires to bridge the gap between conventional and digital finance, paving the way for a more inclusive and technologically advanced financial future.",
    denom_units: [{
      denom: "qfs",
      exponent: 0
    }],
    base: "qfs",
    name: "qfs",
    display: "qfs",
    symbol: "QFS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qfs/images/qfs.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qfs/images/qfs.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qfs/images/qfs.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qfs/images/qfs.svg",
      theme: {
        primary_color_hex: "#2979dc"
      }
    }],
    socials: {
      website: "https://qfsone.com/"
    }
  }]
};
e1.default = lL;
var n1 = {};
Object.defineProperty(n1, "__esModule", { value: !0 });
const gL = {
  $schema: "../chain.schema.json",
  chain_name: "qfs",
  status: "live",
  network_type: "mainnet",
  website: "https://qfs.com/",
  pretty_name: "Quantum Financial Systems",
  chain_type: "cosmos",
  chain_id: "qfs-1",
  bech32_prefix: "qfs",
  daemon_name: "qfs",
  node_home: "$HOME/.ssc",
  key_algos: ["secp256k1"],
  slip44: 1179993431,
  staking: {
    staking_tokens: [{
      denom: "qfs"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  fees: {
    fee_tokens: [{
      denom: "qfs",
      low_gas_price: 1e-6,
      average_gas_price: 5e-6,
      high_gas_price: 1e-4
    }]
  },
  apis: {
    rpc: [{
      address: "https://rcp.qfsone.com",
      provider: "qfs"
    }],
    rest: [{
      address: "https://lcd.qfsone.com",
      provider: "qfs"
    }],
    grpc: [{
      address: "https://grc.qfsone.com:9090",
      provider: "qfs"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qfs/images/qfs.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qfs/images/qfs.svg"
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://blockexplorer.qfsone.com/qfs",
    tx_page: "https://blockexplorer.qfsone.com/qfs/tx/${txHash}",
    account_page: "https://blockexplorer.qfsone.com/qfs/accounts/${accountAddress}"
  }],
  keywords: [],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qfs/images/qfs.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qfs/images/qfs.svg",
    theme: {
      primary_color_hex: "#2979dc"
    }
  }]
};
n1.default = gL;
var V9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(fr, "__esModule", { value: !0 });
fr.chain = fr.assets = void 0;
const uL = V9(e1), _L = V9(n1);
fr.assets = uL.default;
fr.chain = _L.default;
var zs = {}, t1 = {};
Object.defineProperty(t1, "__esModule", { value: !0 });
const yL = {
  $schema: "../assetlist.schema.json",
  chain_name: "quasar",
  assets: [
    {
      description: "The native token of Quasar",
      denom_units: [{
        denom: "uqsr",
        exponent: 0,
        aliases: []
      }, {
        denom: "qsr",
        exponent: 6,
        aliases: []
      }],
      type_asset: "sdk.coin",
      base: "uqsr",
      name: "Quasar",
      display: "qsr",
      symbol: "QSR",
      coingecko_id: "quasar-2",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.png",
        theme: {
          primary_color_hex: "#a493e4"
        }
      }],
      socials: {
        website: "https://www.quasar.fi/",
        twitter: "https://twitter.com/QuasarFi"
      }
    },
    {
      description: "OSMO from Osmosis",
      denom_units: [{
        denom: "ibc/0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B",
        exponent: 0,
        aliases: ["uosmo"]
      }, {
        denom: "osmo",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B",
      name: "Osmosis",
      display: "osmo",
      symbol: "OSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo",
          channel_id: "channel-668"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/uosmo"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      }
    },
    {
      description: "ATOM from Osmosis",
      denom_units: [{
        denom: "ibc/FA0006F056DB6719B8C16C551FC392B62F5729978FC0B125AC9A432DBB2AA1A5",
        exponent: 0,
        aliases: ["uatom"]
      }, {
        denom: "atom",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/FA0006F056DB6719B8C16C551FC392B62F5729978FC0B125AC9A432DBB2AA1A5",
      name: "Atom",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
          channel_id: "channel-668"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/transfer/channel-0/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      }
    },
    {
      description: "USDC.axl from Osmosis",
      denom_units: [{
        denom: "ibc/FA7775734CC73176B7425910DE001A1D2AD9B6D9E93129A5D0750EAD13E4E63A",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/FA7775734CC73176B7425910DE001A1D2AD9B6D9E93129A5D0750EAD13E4E63A",
      name: "USD Coin",
      display: "usdc",
      symbol: "USDC.axl",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858",
          channel_id: "channel-668"
        },
        chain: {
          channel_id: "channel-1",
          path: "transfer/channel-1/transfer/channel-208/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.svg",
        theme: {
          primary_color_hex: "#2474cb"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/usdc.axl.svg"
      }
    }
  ]
};
t1.default = yL;
var s1 = {};
Object.defineProperty(s1, "__esModule", { value: !0 });
const bL = {
  $schema: "../chain.schema.json",
  chain_name: "quasar",
  status: "live",
  network_type: "mainnet",
  website: "https://www.quasar.fi/",
  pretty_name: "Quasar",
  chain_type: "cosmos",
  chain_id: "quasar-1",
  bech32_prefix: "quasar",
  daemon_name: "quasard",
  node_home: "$HOME/.quasarnode",
  key_algos: ["secp256k1"],
  slip44: 118,
  staking: {
    staking_tokens: [{
      denom: "uqsr"
    }]
  },
  fees: {
    fee_tokens: [
      {
        denom: "uqsr",
        fixed_min_gas_price: 0.1,
        low_gas_price: 0.1,
        average_gas_price: 0.25,
        high_gas_price: 0.3
      },
      {
        denom: "ibc/0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B",
        fixed_min_gas_price: 0.01,
        low_gas_price: 0.01,
        average_gas_price: 0.025,
        high_gas_price: 0.03
      },
      {
        denom: "ibc/FA0006F056DB6719B8C16C551FC392B62F5729978FC0B125AC9A432DBB2AA1A5",
        fixed_min_gas_price: 0.01,
        low_gas_price: 0.01,
        average_gas_price: 0.025,
        high_gas_price: 0.03
      },
      {
        denom: "ibc/FA7775734CC73176B7425910DE001A1D2AD9B6D9E93129A5D0750EAD13E4E63A",
        fixed_min_gas_price: 0.01,
        low_gas_price: 0.01,
        average_gas_price: 0.025,
        high_gas_price: 0.03
      }
    ]
  },
  codebase: {
    cosmos_sdk_version: "v0.50.9",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.53.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.png"
  },
  description: "Quasar is the first decentralized asset management (D.A.M.) platform enabled by IBC. A secure, permissionless, composable, and diversified interchain DeFi experience is finally here.",
  apis: {
    rpc: [
      {
        address: "https://rpc.lavenderfive.com:443/quasar",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://quasar-rpc.polkachu.com",
        provider: "polkachu"
      },
      {
        address: "https://quasar-rpc.enigma-validator.com",
        provider: "Enigma"
      },
      {
        address: "https://rpc-quasar.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://quasar-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://quasar.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://rpc-quasar.validavia.me",
        provider: "Validavia"
      },
      {
        address: "https://quasar-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://quasar-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://quasar-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://quasar-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://quasar-rpc.genznodes.dev",
        provider: "genznodes"
      }
    ],
    rest: [
      {
        address: "https://rest.lavenderfive.com:443/quasar",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://quasar-api.polkachu.com",
        provider: "polkachu"
      },
      {
        address: "https://api-quasar.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://quasar-lcd.enigma-validator.com",
        provider: "Enigma"
      },
      {
        address: "https://quasar-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://quasar.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://lcd-quasar.validavia.me",
        provider: "Validavia"
      },
      {
        address: "https://quasar-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://quasar-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://quasar-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://quasar-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://quasar-api.genznodes.dev",
        provider: "genznodes"
      }
    ],
    grpc: [
      {
        address: "quasar.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "quasar-grpc.polkachu.com:18290",
        provider: "polkachu"
      },
      {
        address: "grpc-quasar.cosmos-spaces.cloud:12890",
        provider: "Cosmos Spaces"
      },
      {
        address: "quasar-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "quasar.grpc.kjnodes.com:14890",
        provider: "kjnodes"
      },
      {
        address: "quasar-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "quasar-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "quasar-grpc.stakeandrelax.net:18290",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "quasar-grpc.genznodes.dev:29090",
        provider: "genznodes"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/quasar",
      tx_page: "https://www.mintscan.io/quasar/transactions/${txHash}",
      account_page: "https://www.mintscan.io/quasar/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/quasar",
      tx_page: "https://ezstaking.app/quasar/txs/${txHash}",
      account_page: "https://ezstaking.app/quasar/account/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/quasar",
      tx_page: "https://mainnet.whispernode.com/quasar/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/quasar/account/${accountAddress}"
    }
  ],
  keywords: ["mainnet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.png",
    theme: {
      primary_color_hex: "#a493e4"
    }
  }]
};
s1.default = bL;
var a1 = {};
Object.defineProperty(a1, "__esModule", { value: !0 });
const vL = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2703",
    connection_id: "connection-2240"
  },
  chain_2: {
    chain_name: "quasar",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-688",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
a1.default = vL;
var o1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(zs, "__esModule", { value: !0 });
zs.ibc = zs.chain = zs.assets = void 0;
const fL = o1(t1), wL = o1(s1), xL = o1(a1);
zs.assets = fL.default;
zs.chain = wL.default;
zs.ibc = xL.default;
var qs = {}, r1 = {};
Object.defineProperty(r1, "__esModule", { value: !0 });
const kL = {
  $schema: "../assetlist.schema.json",
  chain_name: "quicksilver",
  assets: [
    {
      description: "QCK - native token of Quicksilver",
      denom_units: [{
        denom: "uqck",
        exponent: 0,
        aliases: []
      }, {
        denom: "qck",
        exponent: 6,
        aliases: []
      }],
      base: "uqck",
      name: "Quicksilver",
      display: "qck",
      symbol: "QCK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.png"
      },
      coingecko_id: "quicksilver",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.png",
        theme: {
          primary_color_hex: "#b2b2b2"
        }
      }],
      socials: {
        website: "https://quicksilver.zone/",
        twitter: "https://twitter.com/quicksilverzone"
      }
    },
    {
      description: "Quicksilver Liquid Staked STARS",
      denom_units: [{
        denom: "uqstars",
        exponent: 0,
        aliases: []
      }, {
        denom: "qstars",
        exponent: 6,
        aliases: []
      }],
      base: "uqstars",
      name: "Quicksilver Liquid Staked STARS",
      display: "qstars",
      symbol: "qSTARS",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "ustars"
        },
        provider: "Quicksilver"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qstars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qstars.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qstars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qstars.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked ATOM",
      denom_units: [{
        denom: "uqatom",
        exponent: 0,
        aliases: []
      }, {
        denom: "qatom",
        exponent: 6,
        aliases: []
      }],
      base: "uqatom",
      name: "Quicksilver Liquid Staked ATOM",
      display: "qatom",
      symbol: "qATOM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        provider: "Quicksilver"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qatom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qatom.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked REGEN",
      denom_units: [{
        denom: "uqregen",
        exponent: 0,
        aliases: []
      }, {
        denom: "qregen",
        exponent: 6,
        aliases: []
      }],
      base: "uqregen",
      name: "Quicksilver Liquid Staked Regen",
      display: "qregen",
      symbol: "qREGEN",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "regen",
          base_denom: "uregen"
        },
        provider: "Quicksilver"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qregen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qregen.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qregen.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qregen.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked OSMO",
      denom_units: [{
        denom: "uqosmo",
        exponent: 0,
        aliases: []
      }, {
        denom: "qosmo",
        exponent: 6,
        aliases: []
      }],
      base: "uqosmo",
      name: "Quicksilver Liquid Staked OSMO",
      display: "qosmo",
      symbol: "qOSMO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        provider: "Quicksilver"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qosmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qosmo.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked SOMM",
      denom_units: [{
        denom: "uqsomm",
        exponent: 0,
        aliases: []
      }, {
        denom: "qsomm",
        exponent: 6,
        aliases: []
      }],
      base: "uqsomm",
      name: "Quicksilver Liquid Staked SOMM",
      display: "qsomm",
      symbol: "qSOMM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "sommelier",
          base_denom: "usomm"
        },
        provider: "Quicksilver"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsomm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsomm.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsomm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsomm.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked JUNO",
      denom_units: [{
        denom: "uqjuno",
        exponent: 0,
        aliases: []
      }, {
        denom: "qjuno",
        exponent: 6,
        aliases: []
      }],
      base: "uqjuno",
      name: "Quicksilver Liquid Staked JUNO",
      display: "qjuno",
      symbol: "qJUNO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "juno",
          base_denom: "ujuno"
        },
        provider: "Quicksilver"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qjuno.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qjuno.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked DYDX",
      denom_units: [{
        denom: "aqdydx",
        exponent: 0,
        aliases: []
      }, {
        denom: "qdydx",
        exponent: 18,
        aliases: []
      }],
      base: "aqdydx",
      name: "Quicksilver Liquid Staked DYDX",
      display: "qdydx",
      symbol: "qDYDX",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "dydx",
          base_denom: "adydx"
        },
        provider: "Quicksilver"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qdydx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qdydx.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked SAGA",
      denom_units: [{
        denom: "uqsaga",
        exponent: 0,
        aliases: []
      }, {
        denom: "qsaga",
        exponent: 6,
        aliases: []
      }],
      base: "uqsaga",
      name: "Quicksilver Liquid Staked SAGA",
      display: "qsaga",
      symbol: "qSAGA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "saga",
          base_denom: "usaga"
        },
        provider: "Quicksilver"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsaga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsaga.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsaga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qsaga.svg",
        theme: {
          primary_color_hex: "#f9924b"
        }
      }]
    },
    {
      description: "Quicksilver Liquid Staked BLD",
      denom_units: [{
        denom: "uqbld",
        exponent: 0,
        aliases: []
      }, {
        denom: "qbld",
        exponent: 6,
        aliases: []
      }],
      base: "uqbld",
      name: "Quicksilver Liquid Staked BLD",
      display: "qbld",
      symbol: "qBLD",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "agoric",
          base_denom: "ubld"
        },
        provider: "Quicksilver"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qbld.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qbld.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qbld.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qbld.svg",
        theme: {
          primary_color_hex: "#fc944c"
        }
      }]
    },
    {
      description: "Noble USDC via dYdX Protocol",
      denom_units: [{
        denom: "ibc/5666A86DCC869C75F69A7938AD6DCFECAC4A09C73522599E7A85B10143E5FBD2",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/5666A86DCC869C75F69A7938AD6DCFECAC4A09C73522599E7A85B10143E5FBD2",
      name: "Noble USDC",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "dydx",
          base_denom: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
          channel_id: "channel-32"
        },
        chain: {
          channel_id: "channel-164",
          path: "transfer/channel-164/transfer/channel-0/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    }
  ]
};
r1.default = kL;
var i1 = {};
Object.defineProperty(i1, "__esModule", { value: !0 });
const AL = {
  $schema: "../chain.schema.json",
  chain_name: "quicksilver",
  status: "live",
  network_type: "mainnet",
  website: "https://quicksilver.zone/",
  pretty_name: "Quicksilver",
  chain_type: "cosmos",
  chain_id: "quicksilver-2",
  daemon_name: "quicksilverd",
  node_home: "$HOME/.quicksilverd",
  bech32_prefix: "quick",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uqck",
      fixed_min_gas_price: 1e-4,
      low_gas_price: 1e-4,
      average_gas_price: 1e-4,
      high_gas_price: 25e-5
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uqck"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.46.16"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.svg"
  },
  description: "Liquid Stake your Cosmos assets with your preferred validator and receive liquid staked assets (qASSETs) that you can use for swapping, pooling, lending, and more, all while your original stake earns staking APY from securing the network.",
  apis: {
    rpc: [
      {
        address: "https://rpc-quicksilver.takeshi.team:443",
        provider: "TAKESHI"
      },
      {
        address: "https://rpc.quicksilver.zone:443",
        provider: "Quicksilver"
      },
      {
        address: "https://rpc-quicksilver-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "https://rpc.lavenderfive.com:443/quicksilver",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-quicksilver.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://m-quicksilver.rpc.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "http://quick.rpc.m.stavr.tech:21027",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://quicksilver-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://quicksilver-rpc.ibs.team:443",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://quicksilver.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://rpc-quicksilver.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://rpc.quicksilver.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://quicksilver-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://quicksilver-rpc.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://quicksilver-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://rpc-quicksilver.mms.team/",
        provider: "MMS"
      },
      {
        address: "https://quicksilver-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://quicksilver-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://mainnet-quicksilver-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://quicksilver.tdrsys.com:2053",
        provider: "TdrSys"
      },
      {
        address: "https://rpc.quicksilver.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://quicksilver-rpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [
      {
        address: "https://api-quicksilver.takeshi.team:443",
        provider: "TAKESHI"
      },
      {
        address: "https://api-quicksilver-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "https://rest.lavenderfive.com:443/quicksilver",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api-quicksilver.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://quicksilver-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://m-quicksilver.api.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://quick.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://quicksilver.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://rest-quicksilver.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://api.quicksilver.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://quicksilver-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://quicksilver-api.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://quicksilver-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://api-quicksilver.mms.team",
        provider: "MMS"
      },
      {
        address: "https://quicksilver-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://quicksilver-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://mainnet-quicksilver-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://quicksilver.tdrsys.com",
        provider: "TdrSys"
      },
      {
        address: "https://api.quicksilver.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://quicksilver-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "grpc-quicksilver.takeshi.team:443",
        provider: "TAKESHI"
      },
      {
        address: "grpc-quicksilver-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "quicksilver.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "quicksilver.grpc.nodersteam.com:9161",
        provider: "[NODERS]TEAM"
      },
      {
        address: "grpc-quicksilver.cosmos-spaces.cloud:3300",
        provider: "Cosmos Spaces"
      },
      {
        address: "quicksilver-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "quicksilver.grpc.kjnodes.com:11190",
        provider: "kjnodes"
      },
      {
        address: "quick.grpc.m.stavr.tech:9113",
        provider: "🔥STAVR🔥"
      },
      {
        address: "grpc-quicksilver.architectnodes.com:1443",
        provider: "Architect Nodes"
      },
      {
        address: "archive-grpc-quicksilver.huginn.tech:9090",
        provider: "Huginn"
      },
      {
        address: "https://grpc.quicksilver.indonode.net:28090",
        provider: "Indonode"
      },
      {
        address: "services.staketab.com:9034",
        provider: "Staketab"
      },
      {
        address: "https://quicksilver-grpc.theamsolutions.info:9797",
        provider: "AM Solutions"
      },
      {
        address: "quicksilver-grpc.w3coins.io:11190",
        provider: "w3coins"
      },
      {
        address: "grpc-quicksilver.mms.team:443",
        provider: "MMS"
      },
      {
        address: "quicksilver-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "quicksilver-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "mainnet-quicksilver.konsortech.xyz:46090",
        provider: "KonsorTech"
      },
      {
        address: "https://quicksilver.tdrsys.com:2083",
        provider: "TdrSys"
      },
      {
        address: "grpc.quicksilver.validatus.com",
        provider: "Validatus"
      },
      {
        address: "quicksilver-grpc.noders.services:16090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/quicksilver",
      tx_page: "https://www.mintscan.io/quicksilver/transactions/${txHash}",
      account_page: "https://www.mintscan.io/quicksilver/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/quicksilver",
      tx_page: "https://ezstaking.app/quicksilver/txs/${txHash}",
      account_page: "https://ezstaking.app/quicksilver/account/${accountAddress}"
    },
    {
      kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀 explorer",
      url: "https://exp.utsa.tech/quicksilver",
      tx_page: "https://exp.utsa.tech/quicksilver/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥 explorer",
      url: "https://explorer.stavr.tech/quicksilver-mainnet",
      tx_page: "https://explorer.stavr.tech/quicksilver-mainnet/tx/${txHash}"
    },
    {
      kind: "Stake-Take",
      url: "https://explorer.stake-take.com/quicksilver",
      tx_page: "https://explorer.stake-take.com/quicksilver/tx/${txHash}"
    },
    {
      kind: "AM Solutions Explorers",
      url: "https://explorer.theamsolutions.info/quicksilver-main/staking",
      tx_page: "https://explorer.theamsolutions.info/quicksilver-main/tx/${txHash}"
    },
    {
      kind: "KonsorTech",
      url: "https://explorer.konsortech.xyz/quicksilver/staking",
      tx_page: "https://explorer.konsortech.xyz/quicksilver/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.svg",
    theme: {
      primary_color_hex: "#b2b2b2"
    }
  }]
};
i1.default = AL;
var c1 = {};
Object.defineProperty(c1, "__esModule", { value: !0 });
const jL = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-36",
      connection_id: "connection-39"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-83",
      connection_id: "connection-58"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-31",
      connection_id: "connection-16"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-78",
      connection_id: "connection-53"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-94",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1018",
      connection_id: "connection-709"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-467",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-318",
      connection_id: "connection-309"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-17",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-215",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2400",
      connection_id: "connection-1889"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-6",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-522",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-96",
      connection_id: "connection-77"
    },
    chain_2: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-15",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-73",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-16",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-113",
      connection_id: "connection-102"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-28",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-138",
      connection_id: "connection-99"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-52",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-225",
      connection_id: "connection-159"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-124",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-27",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-183",
      connection_id: "connection-122"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-53",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  }
];
c1.default = jL;
var d1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(qs, "__esModule", { value: !0 });
qs.ibc = qs.chain = qs.assets = void 0;
const CL = d1(r1), EL = d1(i1), DL = d1(c1);
qs.assets = CL.default;
qs.chain = EL.default;
qs.ibc = DL.default;
var Ss = {}, m1 = {};
Object.defineProperty(m1, "__esModule", { value: !0 });
const BL = {
  $schema: "../assetlist.schema.json",
  chain_name: "qwoyn",
  assets: [{
    description: "The native governance token for Qwoyn Network",
    extended_description: "The Qwoyn Network stands as a cutting-edge gaming hub that embeds Web3 technologies into the core of interactive entertainment. It revolutionizes the gaming industry by ensuring true ownership of in-game assets for players, facilitated through blockchain. This approach not only enhances gameplay but also fosters a unique ecosystem of interoperability and innovation. As a beacon in the gaming world, Qwoyn Network is dedicated to merging the excitement of traditional gaming with the transformative potential of Web3, creating a seamless and enriched gaming experience.",
    denom_units: [{
      denom: "uqwoyn",
      exponent: 0
    }, {
      denom: "qwoyn",
      exponent: 6
    }],
    base: "uqwoyn",
    name: "Qwoyn Network",
    display: "qwoyn",
    symbol: "QWOYN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qwoyn/images/qwoyn.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qwoyn/images/qwoyn.png",
      theme: {
        primary_color_hex: "#04e4fc"
      }
    }],
    coingecko_id: "qwoyn",
    keywords: ["gaming"],
    socials: {
      website: "https://qwoyn.studio",
      twitter: "https://twitter.com/Qwoyn_Studios"
    }
  }]
};
m1.default = BL;
var h1 = {};
Object.defineProperty(h1, "__esModule", { value: !0 });
const FL = {
  $schema: "../chain.schema.json",
  chain_name: "qwoyn",
  status: "live",
  network_type: "mainnet",
  website: "https://qwoyn.studio/",
  description: "The Qwoyn Network stands as a cutting-edge gaming hub that embeds Web3 technologies into the core of interactive entertainment. It revolutionizes the gaming industry by ensuring true ownership of in-game assets for players, facilitated through blockchain. This approach not only enhances gameplay but also fosters a unique ecosystem of interoperability and innovation. As a beacon in the gaming world, Qwoyn Network is dedicated to merging the excitement of traditional gaming with the transformative potential of Web3, creating a seamless and enriched gaming experience.",
  pretty_name: "Qwoyn",
  chain_type: "cosmos",
  chain_id: "qwoyn-1",
  bech32_prefix: "qwoyn",
  daemon_name: "qwoynd",
  node_home: "$HOME/.qwoynd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uqwoyn",
      fixed_min_gas_price: 0.03,
      low_gas_price: 0.03,
      average_gas_price: 0.05,
      high_gas_price: 0.075
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uqwoyn"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47.6",
    cosmwasm_version: "0.40.0"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.qwoyn.studio:443",
        provider: "Qwoyn Studios"
      },
      {
        address: "https://rpc-qwoyn.theamsolutions.info:443",
        provider: "AM Solutions"
      },
      {
        address: "https://qwoyn.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://qwoyn-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://qwoyn-rpc-archive.staketab.org:443",
        provider: "Staketab archive"
      },
      {
        address: "https://rpc.lavenderfive.com:443/qwoyn",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc-qwoyn.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "https://rpc.qwoyn.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    grpc: [
      {
        address: "services.staketab.com:9430",
        provider: "Staketab"
      },
      {
        address: "qwoyn.grpc.m.stavr.tech:1907",
        provider: "🔥STAVR🔥"
      },
      {
        address: "services.staketab.com:2000",
        provider: "Staketab archive"
      },
      {
        address: "https://grpc-qwoyn.theamsolutions.info:443",
        provider: "AM Solutions"
      },
      {
        address: "qwoyn.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "grpc-qwoyn.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "https://grpc.qwoyn.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ],
    rest: [
      {
        address: "https://rest-qwoyn.theamsolutions.info:443",
        provider: "AM Solutions"
      },
      {
        address: "https://qwoyn-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://qwoyn.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://qwoyn-rest-archive.staketab.org",
        provider: "Staketab archive"
      },
      {
        address: "https://rest.lavenderfive.com:443/qwoyn",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api-qwoyn.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://lcd.qwoyn.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ]
  },
  explorers: [
    {
      kind: "ping",
      url: "https://explorer.theamsolutions.info/qwoyn-main/",
      tx_page: "https://explorer.theamsolutions.info/qwoyn-main/blocks",
      account_page: "https://explorer.theamsolutions.info/qwoyn-main/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Qwoyn-Mainnet",
      tx_page: "https://explorer.stavr.tech/Qwoyn-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Qwoyn-Mainnet/account/${accountAddress}"
    },
    {
      kind: "ping",
      url: "https://explorer.theamsolutions.info/QWOYN-MAIN",
      tx_page: "https://explorer.theamsolutions.info/QWOYN-MAIN/tx/${txHash}",
      account_page: "https://explorer.theamsolutions.info/QWOYN-MAIN/account/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qwoyn/images/qwoyn.png"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/qwoyn/images/qwoyn.png",
    theme: {
      primary_color_hex: "#04e4fc"
    }
  }]
};
h1.default = FL;
var p1 = {};
Object.defineProperty(p1, "__esModule", { value: !0 });
const $L = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "archway",
    client_id: "07-tendermint-55",
    connection_id: "connection-65"
  },
  chain_2: {
    chain_name: "qwoyn",
    client_id: "07-tendermint-8",
    connection_id: "connection-5"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-88",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-5",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "astrovault"
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2831",
    connection_id: "connection-2345"
  },
  chain_2: {
    chain_name: "qwoyn",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-880",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
p1.default = $L;
var l1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ss, "__esModule", { value: !0 });
Ss.ibc = Ss.chain = Ss.assets = void 0;
const zL = l1(m1), qL = l1(h1), SL = l1(p1);
Ss.assets = zL.default;
Ss.chain = qL.default;
Ss.ibc = SL.default;
var Ts = {}, g1 = {};
Object.defineProperty(g1, "__esModule", { value: !0 });
const TL = {
  $schema: "../assetlist.schema.json",
  chain_name: "realio",
  assets: [{
    description: "The native currency of the Realio Network.",
    extended_description: "An interoperable Layer-1 multi-chain Web3 ecosystem focused on the issuance and management of digitally native real-world assets (RWAs). Its design is fully open-source, permissionless, and purpose-built.",
    denom_units: [{
      denom: "ario",
      exponent: 0
    }, {
      denom: "rio",
      exponent: 18
    }],
    base: "ario",
    name: "Realio Network",
    display: "rio",
    symbol: "RIO",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rio.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rio.svg"
    },
    coingecko_id: "realio-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rio.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rio.svg",
      theme: {
        primary_color_hex: "#000000",
        background_color_hex: "#000000",
        circle: !0
      }
    }],
    socials: {
      webiste: "https://realio.network/",
      twitter: "https://x.com/realio_network"
    }
  }, {
    description: "A hybrid equity token that represent ownership of the Realio Ecosystem and provides utility functions on the Network.",
    denom_units: [{
      denom: "arst",
      exponent: 0
    }, {
      denom: "rst",
      exponent: 18
    }],
    base: "arst",
    name: "Realio Security Token",
    display: "rst",
    symbol: "RST",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rst.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rst.png",
      theme: {
        primary_color_hex: "#e0e0e0"
      }
    }]
  }]
};
g1.default = TL;
var u1 = {};
Object.defineProperty(u1, "__esModule", { value: !0 });
const RL = {
  $schema: "../chain.schema.json",
  chain_name: "realio",
  status: "live",
  network_type: "mainnet",
  website: "https://realio.network/",
  pretty_name: "Realio Network",
  chain_type: "cosmos",
  chain_id: "realionetwork_3301-1",
  bech32_prefix: "realio",
  node_home: "$HOME/.realio-network",
  daemon_name: "realio-networkd",
  key_algos: ["ethsecp256k1"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "ario",
      fixed_min_gas_price: 1e9,
      low_gas_price: 4e9,
      average_gas_price: 5e9,
      high_gas_price: 8e9
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ario"
    }, {
      denom: "arst"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.46.12"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rio.png"
  },
  apis: {
    rpc: [
      {
        address: "https://realio-rpc.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://realio.rpc.bccnodes.com/",
        provider: "BccNodes"
      },
      {
        address: "https://rpc-realio-network.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "http://realio.rpc.m.stavr.tech:21097",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.realio.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://rpc-realio.vinjan.xyz",
        provider: "vinjan"
      },
      {
        address: "https://api-realio.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://rpc.realio.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://realio.declab.pro:26622",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://realio-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://rpc-realio.blockval.io",
        provider: "Blockval"
      },
      {
        address: "https://realio_rio_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://realio-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://realio.lcd.bccnodes.com/",
        provider: "BccNodes"
      },
      {
        address: "https://api-realio-network.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "https://realio.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.realio.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://api-realio.vinjan.xyz",
        provider: "vinjan"
      },
      {
        address: "https://rpc-realio.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://api.realio.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://realio.declab.pro:443",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://realio-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://api-realio.blockval.io",
        provider: "Blockval"
      },
      {
        address: "https://realio_rio_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "realio-grpc.genznodes.dev:30090",
        provider: "genznodes"
      },
      {
        address: "realio.grpc.bccnodes.com:10990",
        provider: "BccNodes"
      },
      {
        address: "http://realio.grpc.m.stavr.tech:9062",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://grpc-realio.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "https://grpc.realio.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "https://grpc-realio.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "grpc.realio.safeblock.space:9090",
        provider: "Safe Block"
      },
      {
        address: "realio.grpc.skynodejs.net",
        provider: "skynodejs"
      },
      {
        address: "https://realio.declab.pro:9015",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "realio-grpc.noders.services:22090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://grpc-realio.blockval.io",
        provider: "Blockval"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://realio-rpc-evm.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://jsonrpc.realio.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://evm-realio.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://evm.realio.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://realio-jsonrpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://realio_rio_mainnet_evm.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ]
  },
  explorers: [
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/realio-mainnet",
      tx_page: "https://explorer.stavr.tech/realio-mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/realio-mainnet/account/{$accountAddress}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/realio",
      tx_page: "https://explorer.nodestake.top/realio/tx/${txHash}",
      account_page: "https://explorer.nodestake.top/realio/account/{$accountAddress}"
    },
    {
      kind: "Sr20de Explorer",
      url: "https://explorer.sr20de.xyz/Realio",
      tx_page: "https://explorer.sr20de.xyz/Realio/tx/${txHash}",
      account_page: "https://explorer.sr20de.xyz/Realio/account/{$accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/realio",
      tx_page: "https://explorer.tcnetwork.io/realio/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/realio/account/${accountAddress}"
    },
    {
      kind: "Safe Block",
      url: "https://explorer.safeblock.space/realio",
      tx_page: "https://explorer.safeblock.space/realio/tx/${txHash}",
      account_page: "https://explorer.safeblock.space/realio/account/${accountAddress}"
    },
    {
      kind: "Decloud Nodes Lab",
      url: "https://explorer.declab.pro/realio",
      tx_page: "https://explorer.declab.pro/realio/tx/${txHash}",
      account_page: "https://explorer.declab.pro/realio/account/{$accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/realio",
      tx_page: "https://explorer.whenmoonwhenlambo.money/realio/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/realio/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/realio/images/rio.png",
    theme: {
      primary_color_hex: "#181818"
    }
  }]
};
u1.default = RL;
var _1 = {};
Object.defineProperty(_1, "__esModule", { value: !0 });
const OL = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1157",
      connection_id: "connection-879"
    },
    chain_2: {
      chain_name: "realio",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-645",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-155",
      connection_id: "connection-119"
    },
    chain_2: {
      chain_name: "realio",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-115",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2849",
      connection_id: "connection-2361"
    },
    chain_2: {
      chain_name: "realio",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1424",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
_1.default = OL;
var y1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ts, "__esModule", { value: !0 });
Ts.ibc = Ts.chain = Ts.assets = void 0;
const ML = y1(g1), IL = y1(u1), NL = y1(_1);
Ts.assets = ML.default;
Ts.chain = IL.default;
Ts.ibc = NL.default;
var Rs = {}, b1 = {};
Object.defineProperty(b1, "__esModule", { value: !0 });
const PL = {
  $schema: "../assetlist.schema.json",
  chain_name: "rebus",
  assets: [{
    description: "REBUS, the native coin of the Rebus chain.",
    denom_units: [{
      denom: "arebus",
      exponent: 0
    }, {
      denom: "rebus",
      exponent: 18
    }],
    base: "arebus",
    name: "Rebus",
    display: "rebus",
    symbol: "REBUS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.svg"
    },
    coingecko_id: "rebus",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.svg",
      theme: {
        primary_color_hex: "#e75486"
      }
    }]
  }]
};
b1.default = PL;
var v1 = {};
Object.defineProperty(v1, "__esModule", { value: !0 });
const UL = {
  $schema: "../chain.schema.json",
  chain_name: "rebus",
  website: "https://www.rebuschain.com/",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Rebus",
  chain_type: "cosmos",
  chain_id: "reb_1111-1",
  bech32_prefix: "rebus",
  daemon_name: "rebusd",
  node_home: "$HOME/.rebusd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "arebus",
      fixed_min_gas_price: 0,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "arebus"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://api.rebuschain.com:26657/",
        provider: "Rebuschain"
      },
      {
        address: "https://rebus.rpc.bccnodes.com:443",
        provider: "BccNodes"
      },
      {
        address: "https://rebus.rpc.manticore.team:443/",
        provider: "MantiCore"
      },
      {
        address: "https://rpc.rebus.nodestake.top/",
        provider: "NodeStake"
      },
      {
        address: "http://rebus.rpc.m.stavr.tech:40107",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-1.rebus.nodes.guru",
        provider: "Nodes.Guru"
      },
      {
        address: "https://api.mainnet.rebus.money:26657",
        provider: "Rebuschain"
      },
      {
        address: "https://rebus-rpc.brocha.in",
        provider: "Brochain"
      },
      {
        address: "https://rebus-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rebus.rpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://rebus-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rebus-rpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [
      {
        address: "https://api.rebuschain.com:1317/",
        provider: "Rebuschain"
      },
      {
        address: "https://rebus.api.manticore.team:443/",
        provider: "MantiCore"
      },
      {
        address: "https://api.rebus.nodestake.top/",
        provider: "NodeStake"
      },
      {
        address: "https://rebus.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-1.rebus.nodes.guru",
        provider: "Nodes.Guru"
      },
      {
        address: "https://api.mainnet.rebus.money:1317",
        provider: "Rebuschain"
      },
      {
        address: "https://rebus-rest.brocha.in",
        provider: "Brochain"
      },
      {
        address: "https://rebus-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rebus.api.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://rebus-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https:/rebus-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "rebus.grpc.manticore.team:443",
        provider: "MantiCore"
      },
      {
        address: "rebus.grpc.bccnodes.com:14090",
        provider: "BccNodes"
      },
      {
        address: "grpc.rebus.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "rebus.grpc.nodersteam.com:9181",
        provider: "[NODERS]TEAM"
      },
      {
        address: "http://rebus.grpc.m.stavr.tech:3211",
        provider: "🔥STAVR🔥"
      },
      {
        address: "rebus-grpc.brocha.in:443",
        provider: "Brochain"
      },
      {
        address: "rebus-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rebus.grpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "rebus-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "rebus-grpc.noders.services:18090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "explorers.guru",
      url: "https://rebus.explorers.guru",
      tx_page: "https://rebus.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.top/rebus",
      tx_page: "https://explorer.nodestake.top/rebus/tx/${txHash}"
    },
    {
      kind: "BccNodes",
      url: "https://explorer.bccnodes.com/rebus-M",
      tx_page: "https://explorer.bccnodes.com/rebus-M/tx/${txHash}"
    },
    {
      kind: "Brochain",
      url: "https://explorer.brocha.in/rebus",
      tx_page: "https://explorer.brocha.in/rebus/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/rebus",
      tx_page: "https://explorer.stavr.tech/rebus/tx/${txHash}"
    },
    {
      kind: "tcnetwork",
      url: "https://rebus.tcnetwork.io",
      tx_page: "https://rebus.tcnetwork.io/transaction/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/rebus",
      tx_page: "https://atomscan.com/rebus/transactions/${txHash}",
      account_page: "https://atomscan.com/rebus/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rebus/images/rebus.svg",
    theme: {
      primary_color_hex: "#e75486"
    }
  }]
};
v1.default = UL;
var f1 = {};
Object.defineProperty(f1, "__esModule", { value: !0 });
const HL = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2173",
    connection_id: "connection-1692"
  },
  chain_2: {
    chain_name: "rebus",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-355",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
f1.default = HL;
var w1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Rs, "__esModule", { value: !0 });
Rs.ibc = Rs.chain = Rs.assets = void 0;
const LL = w1(b1), WL = w1(v1), VL = w1(f1);
Rs.assets = LL.default;
Rs.chain = WL.default;
Rs.ibc = VL.default;
var Os = {}, x1 = {};
Object.defineProperty(x1, "__esModule", { value: !0 });
const GL = {
  $schema: "../assetlist.schema.json",
  chain_name: "regen",
  assets: [{
    description: "REGEN coin is the token for the Regen Network Platform",
    denom_units: [{
      denom: "uregen",
      exponent: 0
    }, {
      denom: "regen",
      exponent: 6
    }],
    base: "uregen",
    name: "Regen Network",
    display: "regen",
    symbol: "REGEN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.svg"
    },
    coingecko_id: "regen",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.svg",
      theme: {
        primary_color_hex: "#56b790"
      }
    }],
    socials: {
      website: "https://www.regen.network/",
      twitter: "https://twitter.com/regen_network"
    }
  }, {
    description: "Nature Carbon Ton (NCT) is a carbon token standard backed 1:1 by carbon credits issued by Verra, a global leader in the voluntary carbon market. NCT credits on Regen Network have been tokenized by Toucan.earth.",
    denom_units: [{
      denom: "eco.uC.NCT",
      exponent: 0
    }, {
      denom: "nct",
      exponent: 6
    }],
    base: "eco.uC.NCT",
    name: "Nature Carbon Ton",
    display: "nct",
    symbol: "NCT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/nct.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/nct.svg"
    },
    coingecko_id: "toucan-protocol-nature-carbon-tonne",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/nct.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/nct.svg",
      theme: {
        primary_color_hex: "#171c25"
      }
    }]
  }]
};
x1.default = GL;
var k1 = {};
Object.defineProperty(k1, "__esModule", { value: !0 });
const KL = {
  $schema: "../chain.schema.json",
  chain_name: "regen",
  status: "live",
  network_type: "mainnet",
  website: "https://www.regen.network/",
  pretty_name: "Regen",
  chain_type: "cosmos",
  chain_id: "regen-1",
  bech32_prefix: "regen",
  daemon_name: "regen",
  node_home: "$HOME/.regen",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uregen",
      low_gas_price: 0.015,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uregen"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46"
  },
  description: "Regen Network, a platform to originate and invest in high-integrity carbon and biodiversity credits from ecological regeneration projects.",
  apis: {
    rpc: [
      {
        address: "https://rpc-regen.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "http://public-rpc.regen.vitwit.com:26657",
        provider: "vitwit"
      },
      {
        address: "https://regen.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://regen.stakesystems.io:2053",
        provider: "stakesystems"
      },
      {
        address: "http://rpc.regen.forbole.com:80",
        provider: "forbole"
      },
      {
        address: "https://rpc-regen-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://regen-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://regen-rpc.easy2stake.com",
        provider: "Easy 2 Stake"
      },
      {
        address: "https://regen-rpc.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://regen-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://regen-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "http://public-rpc.regen.vitwit.com:1317",
        provider: "vitwit"
      },
      {
        address: "https://regen.stakesystems.io",
        provider: "stakesystems"
      },
      {
        address: "https://regen.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-regen-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://regen-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest-regen.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://regen-lcd.easy2stake.com",
        provider: "Easy 2 Stake"
      },
      {
        address: "https://regen-api.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://regen-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://regen-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "grpc-regen-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "regen-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "regen.grpc.m.stavr.tech:124",
        provider: "🔥STAVR🔥"
      },
      {
        address: "regen-grpc.w3coins.io:22790",
        provider: "w3coins"
      },
      {
        address: "regen-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/regen",
      tx_page: "https://ezstaking.app/regen/txs/${txHash}",
      account_page: "https://ezstaking.app/regen/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Regen-Mainnet",
      tx_page: "https://explorer.stavr.tech/Regen-Mainnet/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/regen",
      tx_page: "https://ping.pub/regen/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/regen-network",
      tx_page: "https://atomscan.com/regen-network/transactions/${txHash}",
      account_page: "https://atomscan.com/regen-network/accounts/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.svg"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/regen/images/regen.svg",
    theme: {
      primary_color_hex: "#56b790"
    }
  }]
};
k1.default = KL;
var A1 = {};
Object.defineProperty(A1, "__esModule", { value: !0 });
const XL = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-47",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-20",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-386",
      connection_id: "connection-340"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-27",
      connection_id: "connection-24"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-185",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-732",
      connection_id: "connection-218"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-28",
      connection_id: "connection-26"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-35",
      connection_id: "connection-26"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-25",
      connection_id: "connection-22"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-106",
      connection_id: "connection-76"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-115",
      connection_id: "connection-104"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-68",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-100",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-104",
      connection_id: "connection-96"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-177",
      connection_id: "connection-149"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-83",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-165",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-6",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-33",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-30",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-16",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "regen",
      client_id: "07-tendermint-113",
      connection_id: "connection-102"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "regen",
      client_id: "07-tendermint-31",
      connection_id: "connection-29"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-56",
      connection_id: "connection-32"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "regen",
      client_id: "07-tendermint-73",
      connection_id: "connection-60"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-31",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-28",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "regen",
      client_id: "07-tendermint-74",
      connection_id: "connection-61"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-45",
      connection_id: "connection-31"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "regen",
      client_id: "07-tendermint-176",
      connection_id: "connection-148"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-239",
      connection_id: "connection-200"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-158",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-107",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
A1.default = XL;
var j1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Os, "__esModule", { value: !0 });
Os.ibc = Os.chain = Os.assets = void 0;
const YL = j1(x1), JL = j1(k1), ZL = j1(A1);
Os.assets = YL.default;
Os.chain = JL.default;
Os.ibc = ZL.default;
var Ms = {}, C1 = {};
Object.defineProperty(C1, "__esModule", { value: !0 });
const QL = {
  $schema: "../assetlist.schema.json",
  chain_name: "rizon",
  assets: [{
    description: "Native token of Rizon Chain",
    denom_units: [{
      denom: "uatolo",
      exponent: 0
    }, {
      denom: "atolo",
      exponent: 6
    }],
    base: "uatolo",
    name: "Rizon Chain",
    display: "atolo",
    symbol: "ATOLO",
    coingecko_id: "rizon",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.svg",
      theme: {
        primary_color_hex: "#2b1c54"
      }
    }],
    socials: {
      website: "https://rizon.world/",
      twitter: "https://twitter.com/hdac_rizon"
    }
  }]
};
C1.default = QL;
var E1 = {};
Object.defineProperty(E1, "__esModule", { value: !0 });
const eW = {
  $schema: "../chain.schema.json",
  chain_name: "rizon",
  status: "live",
  network_type: "mainnet",
  website: "https://rizon.world/",
  pretty_name: "Rizon",
  chain_type: "cosmos",
  chain_id: "titan-1",
  bech32_prefix: "rizon",
  daemon_name: "rizond",
  node_home: "$HOME/.rizon",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uatolo",
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.035
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uatolo"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpcapi.rizon.world/",
        provider: "HDAC Technology AG"
      },
      {
        address: "https://rpc.rizon.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://rizon-rpc.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rizon-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://restapi.rizon.world/",
        provider: "HDAC Technology AG"
      },
      {
        address: "https://api.rizon.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://rizon-api.ibs.team/",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rizon-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rizon.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      }
    ],
    grpc: [{
      address: "grpc-rizon.mms.team:443",
      provider: "MMS"
    }, {
      address: "rizon-grpc.publicnode.com:443",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/rizon",
      tx_page: "https://ezstaking.app/rizon/txs/${txHash}",
      account_page: "https://ezstaking.app/rizon/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/rizon",
      tx_page: "https://www.mintscan.io/rizon/transactions/${txHash}",
      account_page: "https://www.mintscan.io/rizon/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/rizon",
      tx_page: "https://ping.pub/rizon/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/rizon",
      tx_page: "https://atomscan.com/rizon/transactions/${txHash}",
      account_page: "https://atomscan.com/rizon/accounts/${accountAddress}"
    },
    {
      kind: "bigdipper",
      url: "https://bigdipper.live/rizon",
      tx_page: "https://bigdipper.live/rizon/transactions/${txHash}",
      account_page: "https://bigdipper.live/rizon/accounts/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Rizon",
      tx_page: "https://explorer.stavr.tech/Rizon/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Rizon/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/rizon/images/atolo.svg",
    theme: {
      primary_color_hex: "#2b1c54"
    }
  }]
};
E1.default = eW;
var D1 = {};
Object.defineProperty(D1, "__esModule", { value: !0 });
const nW = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1898",
    connection_id: "connection-1471"
  },
  chain_2: {
    chain_name: "rizon",
    client_id: "07-tendermint-3",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-221",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
D1.default = nW;
var B1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ms, "__esModule", { value: !0 });
Ms.ibc = Ms.chain = Ms.assets = void 0;
const tW = B1(C1), sW = B1(E1), aW = B1(D1);
Ms.assets = tW.default;
Ms.chain = sW.default;
Ms.ibc = aW.default;
var Is = {}, F1 = {};
Object.defineProperty(F1, "__esModule", { value: !0 });
const oW = {
  $schema: "../assetlist.schema.json",
  chain_name: "routerchain",
  assets: [{
    description: "The native token of Router Chain",
    extended_description: "Router Chain is a PoS L1 that allows stateful bridging–enabling truly omnichain dapps that can abstract chains from the users and aggregate liquidity across multiple chains.",
    denom_units: [{
      denom: "route",
      exponent: 0
    }, {
      denom: "ROUTE",
      exponent: 18
    }],
    base: "route",
    name: "Router Chain",
    display: "ROUTE",
    symbol: "ROUTE",
    coingecko_id: "router-protocol-2",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/routerchain/images/router.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/routerchain/images/router.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/routerchain/images/router.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/routerchain/images/router.png",
      theme: {
        primary_color_hex: "#cb0766"
      }
    }],
    socials: {
      website: "https://www.routerprotocol.com/",
      twitter: "https://x.com/routerprotocol"
    }
  }]
};
F1.default = oW;
var $1 = {};
Object.defineProperty($1, "__esModule", { value: !0 });
const rW = {
  $schema: "../chain.schema.json",
  chain_name: "routerchain",
  chain_type: "cosmos",
  chain_id: "router_9600-1",
  pretty_name: "Router Protocol",
  status: "live",
  network_type: "mainnet",
  website: "https://www.routerprotocol.com/",
  bech32_prefix: "router",
  node_home: "$HOME/.routerd",
  daemon_name: "routerd",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "route",
      fixed_min_gas_price: 7,
      low_gas_price: 7,
      average_gas_price: 7,
      high_gas_price: 10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "route"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.10",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.45.0"
  },
  apis: {
    rpc: [
      {
        address: "https://sentry.tm.rpc.routerprotocol.com/",
        provider: "Router"
      },
      {
        address: "https://router-rpc.genznodes.dev/",
        provider: "genznodes"
      },
      {
        address: "https://router.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️"
      }
    ],
    rest: [
      {
        address: "https://sentry.lcd.routerprotocol.com/",
        provider: "Router"
      },
      {
        address: "https://router-api.genznodes.dev/",
        provider: "genznodes"
      },
      {
        address: "https://router.api.nodeshub.online",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️"
      }
    ],
    grpc: [
      {
        address: "sentry.grpc.routerprotocol.com:9090",
        provider: "Router"
      },
      {
        address: "router-grpc.genznodes.dev:3090",
        provider: "genznodes"
      },
      {
        address: "router.grpc.nodeshub.online",
        provider: "Nodes Hub"
      }
    ],
    "evm-http-jsonrpc": [{
      address: "https://sentry.evm.rpc.routerprotocol.com",
      provider: "Router"
    }, {
      address: "https://router-rpc-evm.genznodes.dev",
      provider: "genznodes"
    }]
  },
  explorers: [
    {
      kind: "Routerscan",
      url: "https://routerscan.io/",
      tx_page: "https://routerscan.io/transactions/${txHash}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.org/router",
      tx_page: "https://explorer.nodestake.org/router/tx/${txHash}"
    },
    {
      kind: "Router Explorer",
      url: "https://router.explorers.guru/",
      tx_page: "https://router.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️",
      url: "https://explorer.nodeshub.online/router/",
      tx_page: "https://explorer.nodeshub.online/router/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/router/accounts/${accountAddress}"
    }
  ],
  images: [{
    image_sync: {
      chain_name: "routerchain",
      base_denom: "route"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/routerchain/images/router.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/routerchain/images/router.svg",
    theme: {
      primary_color_hex: "#cb0766"
    }
  }]
};
$1.default = rW;
var z1 = {};
Object.defineProperty(z1, "__esModule", { value: !0 });
const iW = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3235",
    connection_id: "connection-2722"
  },
  chain_2: {
    chain_name: "routerchain",
    client_id: "07-tendermint-7",
    connection_id: "connection-9"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-79180",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-7",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }, {
    chain_1: {
      channel_id: "channel-79179",
      port_id: "wasm.osmo145vur8faym70dt7a4h60jz348vxxxqwpnezdz6ee9r88a4cftsvq85dtxr"
    },
    chain_2: {
      channel_id: "channel-6",
      port_id: "crosschain"
    },
    ordering: "unordered",
    version: "router-ibc-v1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
z1.default = iW;
var q1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Is, "__esModule", { value: !0 });
Is.ibc = Is.chain = Is.assets = void 0;
const cW = q1(F1), dW = q1($1), mW = q1(z1);
Is.assets = cW.default;
Is.chain = dW.default;
Is.ibc = mW.default;
var Ns = {}, S1 = {};
Object.defineProperty(S1, "__esModule", { value: !0 });
const hW = {
  $schema: "../assetlist.schema.json",
  chain_name: "saga",
  assets: [{
    description: "Saga is a blockchain platform focused on providing customizable blockchain solutions with a strong emphasis on security and scalability.",
    extended_description: `Saga is a Layer 1 protocol that allows developers to automatically spin up VM-agnostic, parallelized and interoperable dedicated chains, or “Chainlets,” that provide applications with infinite horizontal scalability. Each Chainlet is a replica of the Saga Mainnet, with the same validator set and security model.

Saga’s mission is to enable the next 1000 chains in gaming and entertainment as part of the growing Saga Multiverse.`,
    denom_units: [{
      denom: "usaga",
      exponent: 0
    }, {
      denom: "saga",
      exponent: 6
    }],
    base: "usaga",
    name: "Saga",
    display: "saga",
    symbol: "SAGA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.svg"
    },
    coingecko_id: "saga-2",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.svg",
      theme: {
        primary_color_hex: "#000000",
        dark_mode: !1
      }
    }, {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga_white.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga_white.svg",
      theme: {
        primary_color_hex: "#FFFFFF",
        dark_mode: !0
      }
    }],
    socials: {
      website: "https://www.saga.xyz/",
      twitter: "https://twitter.com/Sagaxyz__"
    }
  }]
};
S1.default = hW;
var T1 = {};
Object.defineProperty(T1, "__esModule", { value: !0 });
const pW = {
  $schema: "../chain.schema.json",
  chain_name: "saga",
  status: "live",
  network_type: "mainnet",
  website: "https://www.saga.xyz/",
  pretty_name: "Saga",
  chain_type: "cosmos",
  chain_id: "ssc-1",
  bech32_prefix: "saga",
  daemon_name: "sscd",
  node_home: "$HOME/.ssc",
  key_algos: ["secp256k1"],
  slip44: 118,
  staking: {
    staking_tokens: [{
      denom: "usaga"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  fees: {
    fee_tokens: [{
      denom: "usaga",
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  codebase: {
    cosmos_sdk_version: "osmosis-labs/cosmos-sdk v0.47.5",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [
      {
        address: "https://rpc-saga.keplr.app",
        provider: "chainapsis"
      },
      {
        address: "https://saga-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://saga-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc.saga.nodestake.org",
        provider: "NodeStake"
      },
      {
        address: "https://saga.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://rpc.saga.goldenratiostaking.net",
        provider: "Golden Ratio Staking"
      },
      {
        address: "https://rpc.saga.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://rpc.lavenderfive.com:443/saga",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://saga-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      }
    ],
    rest: [
      {
        address: "https://saga-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://saga-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rest.saga.goldenratiostaking.net",
        provider: "Golden Ratio Staking"
      },
      {
        address: "https://api.saga.nodestake.org",
        provider: "NodeStake"
      },
      {
        address: "https://saga.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://lcd.saga.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://rest.lavenderfive.com:443/saga",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://saga-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      }
    ],
    grpc: [
      {
        address: "saga-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "saga-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "grpc.saga.nodestake.org:443",
        provider: "NodeStake"
      },
      {
        address: "saga.grpc.kjnodes.com:443",
        provider: "kjnodes"
      },
      {
        address: "grpc.saga.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "saga.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "http://saga-grpc.stakeandrelax.net:24990",
        provider: "Stake&Relax 🦥"
      }
    ]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.svg"
  },
  description: `Saga is a Layer 1 protocol that allows developers to automatically spin up VM-agnostic, parallelized and interoperable dedicated chains, or “Chainlets,” that provide applications with infinite horizontal scalability. Each Chainlet is a replica of the Saga Mainnet, with the same validator set and security model.

Saga’s mission is to enable the next 1000 chains in gaming and entertainment as part of the growing Saga Multiverse. `,
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/saga",
      tx_page: "https://www.mintscan.io/saga/transactions/${txHash}",
      account_page: "https://www.mintscan.io/saga/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/saga",
      tx_page: "https://ezstaking.app/saga/txs/${txHash}",
      account_page: "https://ezstaking.app/saga/account/${accountAddress}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.org/saga",
      tx_page: "https://explorer.nodestake.org/saga/tx/${txHash}",
      account_page: "https://explorer.nodestake.org/saga/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.svg",
    theme: {
      primary_color_hex: "#040404"
    }
  }]
};
T1.default = pW;
var R1 = {};
Object.defineProperty(R1, "__esModule", { value: !0 });
const lW = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-208",
      connection_id: "connection-189"
    },
    chain_2: {
      chain_name: "saga",
      client_id: "07-tendermint-11",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-146",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-90",
      connection_id: "connection-66"
    },
    chain_2: {
      chain_name: "saga",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2060",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3157",
      connection_id: "connection-2626"
    },
    chain_2: {
      chain_name: "saga",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-38946",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "saga",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-202",
      connection_id: "connection-194"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-152",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "saga",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-142",
      connection_id: "connection-142"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-213",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
R1.default = lW;
var O1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ns, "__esModule", { value: !0 });
Ns.ibc = Ns.chain = Ns.assets = void 0;
const gW = O1(S1), uW = O1(T1), _W = O1(R1);
Ns.assets = gW.default;
Ns.chain = uW.default;
Ns.ibc = _W.default;
var Ps = {}, M1 = {};
Object.defineProperty(M1, "__esModule", { value: !0 });
const yW = {
  $schema: "../assetlist.schema.json",
  chain_name: "scorum",
  assets: [{
    description: "The native token of Scorum",
    extended_description: "Scorum is a dynamic Layer-1 blockchain powered by Cosmos, designed to redefine the gaming and entertainment industries. Currently, it supports Aviatrix, a compelling crash game that not only leverages blockchain technology for secure and transparent gaming outcomes but also utilizes it for the integration of Non-Fungible Tokens (NFTs). Central to Scorum’s ecosystem is the SCR token, which supports both Aviatrix and future applications set to expand the platform’s offerings. The adoption of the Inter-Blockchain Communication protocol significantly enhances Scorum’s interoperability and scalability, paving the way for its ongoing expansion and the development of innovative, blockchain-powered entertainment solutions.",
    denom_units: [{
      denom: "nscr",
      exponent: 0
    }, {
      denom: "scr",
      exponent: 9
    }],
    base: "nscr",
    name: "Scorum",
    display: "scr",
    symbol: "SCR",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scr.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scr.svg"
    },
    coingecko_id: "scorum",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scr.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scr.svg",
      theme: {
        primary_color_hex: "#0bc47e"
      }
    }],
    socials: {
      website: "https://scorum.network",
      twitter: "https://twitter.com/scorum_en"
    }
  }, {
    description: "Virtual(non-transferable) coin used to pay gas",
    denom_units: [{
      denom: "gas",
      exponent: 0
    }],
    base: "gas",
    name: "GAS",
    display: "gas",
    symbol: "GAS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/gas.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/gas.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/gas.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/gas.svg",
      theme: {
        primary_color_hex: "#555555"
      }
    }]
  }]
};
M1.default = yW;
var I1 = {};
Object.defineProperty(I1, "__esModule", { value: !0 });
const bW = {
  $schema: "../chain.schema.json",
  chain_name: "scorum",
  status: "live",
  network_type: "mainnet",
  website: "https://scorum.com/",
  pretty_name: "Scorum Network",
  chain_type: "cosmos",
  chain_id: "scorum-1",
  bech32_prefix: "scorum",
  daemon_name: "scorumd",
  node_home: "$HOME/.scorum",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "gas",
      fixed_min_gas_price: 1,
      low_gas_price: 1,
      average_gas_price: 1,
      high_gas_price: 1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "nscr"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scorum.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scorum.svg"
  },
  apis: {
    rpc: [{
      address: "https://scorum-blockchain-mainnet-rpc.scorum.com",
      provider: "scorum"
    }],
    rest: [{
      address: "https://scorum-blockchain-mainnet-api.scorum.com",
      provider: "scorum"
    }],
    grpc: [{
      address: "https://scorum-blockchain-mainnet-grpc.scorum.com",
      provider: "scorum"
    }]
  },
  explorers: [{
    kind: "ezstaking",
    url: "https://ezstaking.app/scorum",
    tx_page: "https://ezstaking.app/scorum/txs/${txHash}",
    account_page: "https://ezstaking.app/scorum/account/${accountAddress}"
  }, {
    kind: "bigdipper",
    url: "https://cosmos.scorum.com/scorum",
    tx_page: "https://cosmos.scorum.com/scorum/transactions/${txHash}",
    account_page: "https://cosmos.scorum.com/scorum/accounts/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scorum.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/scorum/images/scorum.svg",
    theme: {
      primary_color_hex: "#242424"
    }
  }]
};
I1.default = bW;
var N1 = {};
Object.defineProperty(N1, "__esModule", { value: !0 });
const vW = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3098",
    connection_id: "connection-2571"
  },
  chain_2: {
    chain_name: "scorum",
    client_id: "07-tendermint-6",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-20100",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
N1.default = vW;
var P1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ps, "__esModule", { value: !0 });
Ps.ibc = Ps.chain = Ps.assets = void 0;
const fW = P1(M1), wW = P1(I1), xW = P1(N1);
Ps.assets = fW.default;
Ps.chain = wW.default;
Ps.ibc = xW.default;
var Us = {}, U1 = {};
Object.defineProperty(U1, "__esModule", { value: !0 });
const kW = {
  $schema: "../assetlist.schema.json",
  chain_name: "secretnetwork",
  assets: [
    {
      description: "Secret Network is a privacy-focused blockchain that enables private and secure smart contracts, protecting sensitive data.",
      extended_description: "Secret Network is a blockchain platform that focuses on privacy and security by enabling private smart contracts, known as Secret Contracts. These contracts allow developers to create decentralized applications (dApps) that can utilize sensitive data without exposing it on the blockchain. By incorporating privacy-preserving technologies, Secret Network ensures that data remains confidential while still enabling complex computations and interactions. The native token, SCRT, is used for transaction fees, staking, and governance, empowering users to participate in the network's operations and decision-making processes. Secret Network aims to enhance the privacy and functionality of blockchain applications, making it suitable for use cases where data confidentiality is paramount.",
      denom_units: [{
        denom: "uscrt",
        exponent: 0
      }, {
        denom: "scrt",
        exponent: 6
      }],
      base: "uscrt",
      name: "Secret Network",
      display: "scrt",
      symbol: "SCRT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg"
      },
      coingecko_id: "secret",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }],
      socials: {
        website: "https://scrt.network/",
        twitter: "https://twitter.com/SecretNetwork"
      }
    },
    {
      description: "The native token cw20 for SIENNA on Secret Network",
      denom_units: [{
        denom: "cw20:secret1rgm2m5t530tdzyd99775n6vzumxa5luxcllml4",
        exponent: 0
      }, {
        denom: "sienna",
        exponent: 18
      }],
      type_asset: "snip20",
      address: "secret1rgm2m5t530tdzyd99775n6vzumxa5luxcllml4",
      base: "cw20:secret1rgm2m5t530tdzyd99775n6vzumxa5luxcllml4",
      name: "SIENNA",
      display: "sienna",
      symbol: "SIENNA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/sienna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/sienna.svg"
      },
      coingecko_id: "sienna",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/sienna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/sienna.svg",
        theme: {
          primary_color_hex: "#2c2c2c"
        }
      }]
    },
    {
      description: "The native token cw20 for Shade on Secret Network",
      denom_units: [{
        denom: "cw20:secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d",
        exponent: 0
      }, {
        denom: "shd",
        exponent: 8
      }],
      type_asset: "snip20",
      address: "secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d",
      base: "cw20:secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d",
      name: "Shade (old)",
      display: "shd",
      symbol: "SHD(old)",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shdold.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shdold.svg"
      }]
    },
    {
      description: "The native token cw20 for Shade on Secret Network",
      denom_units: [{
        denom: "cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm",
        exponent: 0
      }, {
        denom: "shd",
        exponent: 8
      }],
      type_asset: "snip25",
      address: "secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm",
      base: "cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm",
      name: "Shade",
      display: "shd",
      symbol: "SHD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.svg"
      },
      coingecko_id: "shade-protocol",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shd.svg",
        theme: {
          primary_color_hex: "#342c52"
        }
      }]
    },
    {
      description: "The native token cw20 for Silk on Secret Network",
      denom_units: [{
        denom: "cw20:secret1fl449muk5yq8dlad7a22nje4p5d2pnsgymhjfd",
        exponent: 0
      }, {
        denom: "silk",
        exponent: 6
      }],
      type_asset: "snip25",
      address: "secret1fl449muk5yq8dlad7a22nje4p5d2pnsgymhjfd",
      base: "cw20:secret1fl449muk5yq8dlad7a22nje4p5d2pnsgymhjfd",
      name: "Silk",
      display: "silk",
      symbol: "SILK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/silk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/silk.svg"
      },
      coingecko_id: "silk-bcec1136-561c-4706-a42c-8b67d0d7f7d2",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/silk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/silk.svg",
        theme: {
          primary_color_hex: "#3142fc"
        }
      }]
    },
    {
      description: "The native token cw20 for SCRT Staking Derivatives on Secret Network",
      denom_units: [{
        denom: "cw20:secret1k6u0cy4feepm6pehnz804zmwakuwdapm69tuc4",
        exponent: 0
      }, {
        denom: "stkd-scrt",
        exponent: 6
      }],
      type_asset: "snip20",
      address: "secret1k6u0cy4feepm6pehnz804zmwakuwdapm69tuc4",
      base: "cw20:secret1k6u0cy4feepm6pehnz804zmwakuwdapm69tuc4",
      name: "SCRT Staking Derivatives",
      display: "stkd-scrt",
      symbol: "stkd-SCRT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/stkd-scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/stkd-scrt.svg"
      },
      coingecko_id: "stkd-scrt",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/stkd-scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/stkd-scrt.svg",
        theme: {
          primary_color_hex: "#b8a2dc"
        }
      }]
    },
    {
      description: "The native token cw20 for Button on Secret Network",
      denom_units: [{
        denom: "cw20:secret1yxcexylwyxlq58umhgsjgstgcg2a0ytfy4d9lt",
        exponent: 0
      }, {
        denom: "butt",
        exponent: 6
      }],
      type_asset: "snip20",
      address: "secret1yxcexylwyxlq58umhgsjgstgcg2a0ytfy4d9lt",
      base: "cw20:secret1yxcexylwyxlq58umhgsjgstgcg2a0ytfy4d9lt",
      name: "Button",
      display: "butt",
      symbol: "BUTT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/butt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/butt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/butt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/butt.svg",
        theme: {
          primary_color_hex: "#7b04eb"
        }
      }]
    },
    {
      description: "The native token cw20 for Alter on Secret Network",
      denom_units: [{
        denom: "cw20:secret12rcvz0umvk875kd6a803txhtlu7y0pnd73kcej",
        exponent: 0
      }, {
        denom: "alter",
        exponent: 6
      }],
      base: "cw20:secret12rcvz0umvk875kd6a803txhtlu7y0pnd73kcej",
      name: "Alter",
      display: "alter",
      symbol: "ALTER",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/alter.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/alter.svg"
      },
      coingecko_id: "alter",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/alter.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/alter.svg",
        theme: {
          primary_color_hex: "#694c90"
        }
      }],
      socials: {
        website: "http://alter.network/",
        twitter: "https://twitter.com/AlterDapp"
      }
    },
    {
      description: "The native token cw20 for Amber on Secret Network",
      denom_units: [{
        denom: "cw20:secret1s09x2xvfd2lp2skgzm29w2xtena7s8fq98v852",
        exponent: 0
      }, {
        denom: "amber",
        exponent: 6
      }],
      type_asset: "snip20",
      address: "secret1s09x2xvfd2lp2skgzm29w2xtena7s8fq98v852",
      base: "cw20:secret1s09x2xvfd2lp2skgzm29w2xtena7s8fq98v852",
      name: "Amber",
      display: "amber",
      symbol: "AMBER",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/amber.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/amber.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/amber.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/amber.svg",
        theme: {
          primary_color_hex: "#f2b854"
        }
      }],
      socials: {
        website: "http://amber.money/",
        twitter: "https://twitter.com/AmberDAO_"
      }
    },
    {
      description: "The native token cw20 for Shill on Secret Network",
      denom_units: [{
        denom: "cw20:secret197dvnt9yjxwn8sjdlx05f7zuk27lsdxtfnwxse",
        exponent: 0
      }, {
        denom: "shill",
        exponent: 6
      }],
      type_asset: "snip25",
      address: "secret197dvnt9yjxwn8sjdlx05f7zuk27lsdxtfnwxse",
      base: "cw20:secret197dvnt9yjxwn8sjdlx05f7zuk27lsdxtfnwxse",
      name: "Shill",
      display: "shill",
      symbol: "SHILL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shill.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shill.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shill.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/shill.svg",
        theme: {
          primary_color_hex: "#c49df3"
        }
      }]
    }
  ]
};
U1.default = kW;
var H1 = {};
Object.defineProperty(H1, "__esModule", { value: !0 });
const AW = {
  $schema: "../chain.schema.json",
  chain_name: "secretnetwork",
  status: "live",
  network_type: "mainnet",
  website: "https://scrt.network/",
  pretty_name: "Secret Network",
  chain_type: "cosmos",
  chain_id: "secret-4",
  bech32_prefix: "secret",
  daemon_name: "secretd",
  node_home: "$HOME/.secretd",
  key_algos: ["secp256k1"],
  slip44: 529,
  alternative_slip44s: [118],
  fees: {
    fee_tokens: [{
      denom: "uscrt",
      fixed_min_gas_price: 0.05,
      low_gas_price: 0.05,
      average_gas_price: 0.1,
      high_gas_price: 0.25
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uscrt"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg"
  },
  description: "Secret Network is the first blockchain with customizable privacy. You get to choose what you share, with whom, and how. This protects users, and empowers developers to build a better Web3.",
  apis: {
    "grpc-web": [{
      address: "https://grpc.mainnet.secretsaturn.net",
      provider: "🪐 𝕊ecret 𝕊aturn"
    }],
    rpc: [
      {
        address: "https://scrt.public-rpc.com",
        provider: "ANKR"
      },
      {
        address: "https://rpc.lavenderfive.com:443/secretnetwork",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://1rpc.io/scrt-rpc",
        provider: "1RPC - Automata Network"
      },
      {
        address: "https://secretnetwork-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://rpc.mainnet.secretsaturn.net",
        provider: "🪐 𝕊ecret 𝕊aturn"
      },
      {
        address: "https://rpc-secret.01node.com",
        provider: "01node"
      },
      {
        address: "https://public.stakewolle.com/cosmos/secretnetwork/rpc",
        provider: "Stakewolle"
      }
    ],
    rest: [
      {
        address: "https://rest.lavenderfive.com:443/secretnetwork",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "http://secretnetwork-mainnet-lcd.autostake.com:1317",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://1rpc.io/scrt-lcd",
        provider: "1RPC - Automata Network"
      },
      {
        address: "https://secretnetwork-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://lcd.mainnet.secretsaturn.net",
        provider: "🪐 𝕊ecret 𝕊aturn"
      },
      {
        address: "https://rest-secret.01node.com",
        provider: "01node"
      },
      {
        address: "https://public.stakewolle.com/cosmos/secretnetwork/rest",
        provider: "Stakewolle"
      }
    ],
    grpc: [{
      address: "secretnetwork.lavenderfive.com:443",
      provider: "Lavender.Five Nodes 🐝"
    }, {
      address: "secretnetwork-mainnet-grpc.autostake.com:9090",
      provider: "AutoStake 🛡️ Slash Protected"
    }]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/secretnetwork",
      tx_page: "https://ezstaking.app/secretnetwork/txs/${txHash}",
      account_page: "https://ezstaking.app/secretnetwork/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/secret",
      tx_page: "https://ping.pub/secret/tx/${txHash}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/secret",
      tx_page: "https://www.mintscan.io/secret/transactions/${txHash}",
      account_page: "https://www.mintscan.io/secret/accounts/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/secret-network",
      tx_page: "https://atomscan.com/secret-network/transactions/${txHash}",
      account_page: "https://atomscan.com/secret-network/accounts/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/secret",
      tx_page: "https://mainnet.whispernode.com/secret/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/secret/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg",
    theme: {
      primary_color_hex: "#040404"
    }
  }]
};
H1.default = AW;
var L1 = {};
Object.defineProperty(L1, "__esModule", { value: !0 });
const jW = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-17",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-111",
      connection_id: "connection-80"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-102",
      connection_id: "connection-69"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-47",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-43",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-176",
      connection_id: "connection-133"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-97",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-24",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-169",
      connection_id: "connection-119"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-84",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-40",
      connection_id: "connection-22"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-44",
      connection_id: "connection-26"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }, {
      chain_1: {
        channel_id: "channel-69",
        port_id: "transfer",
        client_id: "07-tendermint-103",
        connection_id: "connection-89"
      },
      chain_2: {
        channel_id: "channel-61",
        port_id: "wasm.secret1yxjmepvyl2c25vnt53cr2dpn8amknwausxee83",
        client_id: "07-tendermint-120",
        connection_id: "connection-93"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-52",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-174",
      connection_id: "connection-131"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-91",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cheqd",
      client_id: "07-tendermint-85",
      connection_id: "connection-63"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-196",
      connection_id: "connection-191"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-141",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      fee_version: "ics29-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-70",
      connection_id: "connection-38"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-27",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-142",
      connection_id: "connection-74"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-125",
      connection_id: "connection-95"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-52",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-166",
      connection_id: "connection-116"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-80",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-26",
        port_id: "transfer",
        client_id: "07-tendermint-52",
        connection_id: "connection-21"
      },
      chain_2: {
        channel_id: "channel-83",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
        client_id: "07-tendermint-166",
        connection_id: "connection-116"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreum",
      client_id: "07-tendermint-40",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-186",
      connection_id: "connection-138"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-101",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-492",
      connection_id: "connection-401"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-235",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-18",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-53",
      connection_id: "connection-31"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent",
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-29",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-194",
      connection_id: "connection-189"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-35",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-130",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-50",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-42",
      connection_id: "connection-24"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gravitybridge",
      client_id: "07-tendermint-140",
      connection_id: "connection-139"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-40",
      connection_id: "connection-23"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-79",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-150",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-148",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-126",
      connection_id: "connection-101"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-49",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "jackal",
      client_id: "07-tendermint-6",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-124",
      connection_id: "connection-94"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-108",
      connection_id: "connection-68"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-23",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-48",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-163",
        port_id: "transfer",
        client_id: "07-tendermint-108",
        connection_id: "connection-68"
      },
      chain_2: {
        channel_id: "channel-45",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
        client_id: "07-tendermint-23",
        connection_id: "connection-9"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-12",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-48",
      connection_id: "connection-29"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-44",
        port_id: "transfer",
        client_id: "07-tendermint-12",
        connection_id: "connection-7"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4",
        client_id: "07-tendermint-48",
        connection_id: "connection-29"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-6",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-116",
      connection_id: "connection-87"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-103",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-129",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-85",
      connection_id: "connection-63"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-199",
      connection_id: "connection-192"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1551",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-144",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-1950",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-151",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-24",
      connection_id: "connection-33"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-170",
      connection_id: "connection-127"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nolus",
      client_id: "07-tendermint-18",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-201",
      connection_id: "connection-193"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13995",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-146",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "oraichain",
      client_id: "07-tendermint-178",
      connection_id: "connection-142"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-195",
      connection_id: "connection-190"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-135",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-217",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }, {
      chain_1: {
        channel_id: "channel-140",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-222",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1588",
      connection_id: "connection-1244"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-88",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis",
        properties: "privacy"
      }
    }, {
      chain_1: {
        channel_id: "channel-476",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-44",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis",
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-106",
      connection_id: "connection-146"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-126",
      connection_id: "connection-98"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-82",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }, {
      chain_1: {
        channel_id: "channel-159",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-132",
        port_id: "wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-28",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-138",
      connection_id: "connection-99"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-52",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "saga",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    chain_2: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-202",
      connection_id: "connection-194"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-152",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-14",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-96",
      connection_id: "connection-75"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-37",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-171",
      connection_id: "connection-98"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-43",
      connection_id: "connection-25"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-177",
      connection_id: "connection-110"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-48",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-75",
      connection_id: "connection-40"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-37",
      connection_id: "connection-25"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-40",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-192",
      connection_id: "connection-185"
    },
    chain_2: {
      chain_name: "teritori",
      client_id: "07-tendermint-99",
      connection_id: "connection-122"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-111",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-28",
      connection_id: "connection-29"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-38",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-4",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }, {
      chain_1: {
        channel_id: "channel-127",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-382",
        port_id: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-193",
      connection_id: "connection-188"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-249",
      connection_id: "connection-213"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-126",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-123",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  }
];
L1.default = jW;
var W1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Us, "__esModule", { value: !0 });
Us.ibc = Us.chain = Us.assets = void 0;
const CW = W1(U1), EW = W1(H1), DW = W1(L1);
Us.assets = CW.default;
Us.chain = EW.default;
Us.ibc = DW.default;
var Hs = {}, V1 = {};
Object.defineProperty(V1, "__esModule", { value: !0 });
const BW = {
  $schema: "../assetlist.schema.json",
  chain_name: "seda",
  assets: [{
    description: "The native token of SEDA Chain.",
    extended_description: "SEDA is a standard for modular data transport and querying. Any data type, for all networks.",
    denom_units: [{
      denom: "aseda",
      exponent: 0
    }, {
      denom: "seda",
      exponent: 18
    }],
    base: "aseda",
    name: "Seda",
    display: "seda",
    symbol: "SEDA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.svg"
    },
    coingecko_id: "seda-2",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.svg",
      theme: {
        primary_color_hex: "#8178d1"
      }
    }],
    socials: {
      website: "https://www.seda.xyz/",
      twitter: "https://twitter.com/sedaprotocol"
    }
  }]
};
V1.default = BW;
var G1 = {};
Object.defineProperty(G1, "__esModule", { value: !0 });
const FW = {
  $schema: "../chain.schema.json",
  chain_name: "seda",
  status: "live",
  network_type: "mainnet",
  website: "https://www.seda.xyz/",
  pretty_name: "SEDA",
  chain_type: "cosmos",
  chain_id: "seda-1",
  bech32_prefix: "seda",
  daemon_name: "sedad",
  node_home: "$HOME/.sedad",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "aseda",
      fixed_min_gas_price: 1e10,
      low_gas_price: 1e10,
      average_gas_price: 1e10,
      high_gas_price: 14e9
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aseda"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.50.5"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.svg"
  },
  description: "SEDA is a standard for modular data transport and querying. Any data type, for all networks.",
  apis: {
    rpc: [
      {
        address: "https://rpc.mainnet.seda.xyz/",
        provider: "SEDA"
      },
      {
        address: "https://seda-rpc.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://seda.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://seda-rpc.synergynodes.com/",
        provider: "Synergy Nodes"
      },
      {
        address: "https://rpc.lavenderfive.com:443/seda",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://seda-rpc.kleomedes.network/",
        provider: "Kleomedes"
      },
      {
        address: "https://seda-rpc.ibs.team:443",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://seda-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc.seda.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://rpc-seda.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://seda-rpc.applejuice.256x25.tech:443",
        provider: "Apple juice 🧃"
      },
      {
        address: "https://seda-rpc.bluestake.net:443",
        provider: "BlueStake 🚀"
      },
      {
        address: "https://seda_mainnet_rpc.chain.whenmoonwhenlambo.money:443",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://rpc-seda-mainnet.keepitstaked.com:443",
        provider: "KeepItStaked.com"
      }
    ],
    rest: [
      {
        address: "https://lcd.mainnet.seda.xyz/",
        provider: "SEDA"
      },
      {
        address: "https://seda-api.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://seda.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://seda-api.synergynodes.com/",
        provider: "Synergy Nodes"
      },
      {
        address: "https://rest.lavenderfive.com:443/seda",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://seda-api.kleomedes.network/",
        provider: "Kleomedes"
      },
      {
        address: "https://seda-api.ibs.team:443",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://seda-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://lcd.seda.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://api-seda.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://seda-api.applejuice.256x25.tech:443",
        provider: "Apple juice 🧃"
      },
      {
        address: "https://seda-api.bluestake.net",
        provider: "BlueStake 🚀"
      },
      {
        address: "https://seda_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://api-seda-mainnet.keepitstaked.com:443",
        provider: "KeepItStaked.com"
      }
    ],
    grpc: [
      {
        address: "seda-grpc.polkachu.com:25890",
        provider: "Polkachu"
      },
      {
        address: "https://seda-grpc.synergynodes.com/",
        provider: "Synergy Nodes"
      },
      {
        address: "seda.grpc.kjnodes.com:443",
        provider: "kjnodes"
      },
      {
        address: "seda.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "seda-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://grpc.seda.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "grpc-seda.whispernode.com:443",
        provider: "WhisperNode 🤐"
      }
    ]
  },
  explorers: [
    {
      kind: "sedaexplorer",
      url: "https://explorer.seda.xyz/",
      tx_page: "https://explorer.seda.xyz/txs/${txHash}",
      account_page: "https://explorer.seda.xyz/account/${accountAddress}"
    },
    {
      kind: "explorers.guru",
      url: "https://seda.explorers.guru",
      tx_page: "https://seda.explorers.guru/transaction/${txHash}",
      account_page: "https://seda.explorers.guru/account/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/seda",
      tx_page: "https://mainnet.whispernode.com/seda/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/seda/account/${accountAddress}"
    },
    {
      kind: "Apple juice 🧃",
      url: "https://explorer.256x25.tech/seda-mainnet",
      tx_page: "https://explorer.256x25.tech/seda-mainnet/tx/${txHash}",
      account_page: "https://explorer.256x25.tech/seda-mainnet/account/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/seda",
      tx_page: "https://explorer.whenmoonwhenlambo.money/seda/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/seda/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/seda/images/seda.svg",
    theme: {
      primary_color_hex: "#8178d1"
    }
  }]
};
G1.default = FW;
var K1 = {};
Object.defineProperty(K1, "__esModule", { value: !0 });
const $W = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-3204",
    connection_id: "connection-2661"
  },
  chain_2: {
    chain_name: "seda",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-75016",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
K1.default = $W;
var X1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Hs, "__esModule", { value: !0 });
Hs.ibc = Hs.chain = Hs.assets = void 0;
const zW = X1(V1), qW = X1(G1), SW = X1(K1);
Hs.assets = zW.default;
Hs.chain = qW.default;
Hs.ibc = SW.default;
var Ls = {}, Y1 = {};
Object.defineProperty(Y1, "__esModule", { value: !0 });
const TW = {
  $schema: "../assetlist.schema.json",
  chain_name: "sei",
  assets: [
    {
      description: "Sei is a layer-1 blockchain optimized for trading, focusing on providing high throughput, low latency, and efficient execution for decentralized exchanges.",
      extended_description: "Sei is a layer-1 blockchain designed specifically for trading applications, offering a high-performance environment for decentralized exchanges (DEXs). It focuses on providing high throughput, low latency, and efficient order execution. Sei's architecture includes features like parallel processing and a unique consensus mechanism to achieve fast and reliable transaction processing. The native token, SEI, is used for transaction fees, staking, and governance within the network. Sei aims to create an optimal infrastructure for trading, addressing the needs of traders and developers in the DeFi space.",
      denom_units: [{
        denom: "usei",
        exponent: 0
      }, {
        denom: "sei",
        exponent: 6
      }],
      base: "usei",
      name: "Sei",
      display: "sei",
      symbol: "SEI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.svg"
      },
      coingecko_id: "sei-network",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.svg",
        theme: {
          primary_color_hex: "#9c1c1c"
        }
      }],
      socials: {
        website: "https://www.sei.io/",
        twitter: "https://twitter.com/SeiNetwork"
      }
    },
    {
      description: "OIN Token ($OIN) is a groundbreaking digital asset developed on the $SEI Blockchain. It transcends being merely a cryptocurrency; $OIN stands as a robust store of value, symbolizing the future of decentralized finance and its potential to reshape the crypto landscape.",
      denom_units: [{
        denom: "factory/sei1thgp6wamxwqt7rthfkeehktmq0ujh5kspluw6w/OIN",
        exponent: 0
      }, {
        denom: "oin",
        exponent: 6
      }],
      address: "sei1thgp6wamxwqt7rthfkeehktmq0ujh5kspluw6w",
      base: "factory/sei1thgp6wamxwqt7rthfkeehktmq0ujh5kspluw6w/OIN",
      name: "OIN STORE OF VALUE",
      display: "oin",
      symbol: "OIN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/oin.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/oin.png",
        theme: {
          primary_color_hex: "#6cdbac"
        }
      }]
    },
    {
      description: "ERIS liquid staked SEI",
      denom_units: [{
        denom: "factory/sei1x2fgaaqecvk8kwuqkjqcj27clw5p5g99uawdzy9sc4rku8avumcq3cky4k/ampSEI",
        exponent: 0
      }, {
        denom: "ampSEI",
        exponent: 6
      }],
      base: "factory/sei1x2fgaaqecvk8kwuqkjqcj27clw5p5g99uawdzy9sc4rku8avumcq3cky4k/ampSEI",
      name: "ERIS Amplified SEI",
      display: "ampSEI",
      symbol: "ampSEI",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/ampsei.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/ampsei.svg"
      }]
    },
    {
      description: "Popeye the Seilor",
      denom_units: [{
        denom: "factory/sei1fl8pg59wfsgw2wp4aruk38zqccfnc2g8ptrm24/popeye",
        exponent: 0
      }, {
        denom: "popeye",
        exponent: 6
      }],
      base: "factory/sei1fl8pg59wfsgw2wp4aruk38zqccfnc2g8ptrm24/popeye",
      name: "Popeye",
      display: "popeye",
      symbol: "POPEYE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/popeye.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/popeye.png",
        theme: {
          primary_color_hex: "#04040a"
        }
      }]
    },
    {
      description: "A wise dog and a marshal arts master",
      denom_units: [{
        denom: "factory/sei1ta5rkr6y2qlkj7px8w2cvear7m2822q4f4ea0m/sensei",
        exponent: 0
      }, {
        denom: "sensei",
        exponent: 6
      }],
      base: "factory/sei1ta5rkr6y2qlkj7px8w2cvear7m2822q4f4ea0m/sensei",
      name: "Sensei Dog",
      display: "sensei",
      symbol: "SENSEI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/SenseiDog.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/SenseiDog.png",
        theme: {
          primary_color_hex: "#d4d0c7"
        }
      }]
    },
    {
      description: "The first memecoin on osmosis.",
      denom_units: [{
        denom: "ibc/B023C57727A38A9CF87238F9008477C3761AD4774D528BFA458DD707D90B553A",
        exponent: 0
      }, {
        denom: "WOSMO",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B023C57727A38A9CF87238F9008477C3761AD4774D528BFA458DD707D90B553A",
      name: "Wosmo",
      display: "WOSMO",
      symbol: "WOSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-782",
          path: "transfer/channel-782/factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png",
        theme: {
          primary_color_hex: "#edd5ee"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png"
      }
    },
    {
      description: "OOZARU is a meme token on SEI Network inspired by the iconic transformation in the Dragon Ball series",
      denom_units: [{
        denom: "sei1wlf9j5uv50rcg0u5j6xk00px5tflptzprj39keck27eg8g7qd7hqq6kvda",
        exponent: 0
      }, {
        denom: "oozaru",
        exponent: 6
      }],
      base: "sei1wlf9j5uv50rcg0u5j6xk00px5tflptzprj39keck27eg8g7qd7hqq6kvda",
      name: "Oozaru",
      display: "oozaru",
      symbol: "OOZARU",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/oozaru.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/oozaru.png",
        theme: {
          primary_color_hex: "#2b1619"
        }
      }]
    },
    {
      description: "The Original Meme Coin of SEI Network",
      type_asset: "cw20",
      address: "sei1hrndqntlvtmx2kepr0zsfgr7nzjptcc72cr4ppk4yav58vvy7v3s4er8ed",
      denom_units: [{
        denom: "cw20:sei1hrndqntlvtmx2kepr0zsfgr7nzjptcc72cr4ppk4yav58vvy7v3s4er8ed",
        exponent: 0
      }, {
        denom: "SEIYAN",
        exponent: 6
      }],
      base: "cw20:sei1hrndqntlvtmx2kepr0zsfgr7nzjptcc72cr4ppk4yav58vvy7v3s4er8ed",
      name: "SEIYAN",
      display: "SEIYAN",
      symbol: "SEIYAN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/SEIYAN.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/SEIYAN.png",
        theme: {
          primary_color_hex: "#db1f22"
        }
      }]
    },
    {
      description: "Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.",
      denom_units: [{
        denom: "ibc/063F4461F7317CFF10F50AB044E44932D22AAD84FA7107082744946E6DB7B7A8",
        exponent: 0,
        aliases: ["uastro"]
      }, {
        denom: "astro",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/063F4461F7317CFF10F50AB044E44932D22AAD84FA7107082744946E6DB7B7A8",
      name: "Astroport token",
      display: "astro",
      symbol: "ASTRO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro",
          channel_id: "channel-2016"
        },
        chain: {
          channel_id: "channel-66",
          path: "transfer/channel-177/factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg",
        theme: {
          primary_color_hex: "#4056e9"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg"
      }
    }
  ]
};
Y1.default = TW;
var J1 = {};
Object.defineProperty(J1, "__esModule", { value: !0 });
const RW = {
  $schema: "../chain.schema.json",
  chain_name: "sei",
  status: "live",
  website: "https://www.sei.io/",
  network_type: "mainnet",
  pretty_name: "Sei",
  chain_type: "cosmos",
  chain_id: "pacific-1",
  bech32_prefix: "sei",
  daemon_name: "seid",
  node_home: "$HOME/.sei",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usei",
      fixed_min_gas_price: 0.02,
      low_gas_price: 0.02,
      average_gas_price: 0.02,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "usei"
    }]
  },
  codebase: {
    cosmos_sdk_version: "sei-cosmos v0.3.35",
    cosmwasm_enabled: !0,
    cosmwasm_version: "sei-wasmd v0.2.4"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.svg"
  },
  description: "Sei is the fastest Layer 1 blockchain, designed to scale with the industry.",
  apis: {
    rpc: [
      {
        address: "https://rpc.sei-apis.com",
        provider: "Rhino Stake"
      },
      {
        address: "https://rpc.lavenderfive.com:443/sei",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://sei-rpc.polkachu.com",
        provider: "polkachu.com"
      },
      {
        address: "https://sei-rpc.brocha.in",
        provider: "Brochain"
      },
      {
        address: "https://rpc-sei.stingray.plus",
        provider: "StingRay"
      },
      {
        address: "https://rpc-sei.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://sei.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://sei-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://rest.sei-apis.com",
        provider: "Rhino Stake"
      },
      {
        address: "https://rest.lavenderfive.com:443/sei",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://sei-api.polkachu.com",
        provider: "polkachu.com"
      },
      {
        address: "https://sei-rest.brocha.in",
        provider: "Brochain"
      },
      {
        address: "https://api-sei.stingray.plus",
        provider: "StingRay"
      },
      {
        address: "https://lcd-sei.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://sei.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://sei-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "https://grpc.sei-apis.com:443",
        provider: "Rhino Stake"
      },
      {
        address: "sei.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://sei-grpc.polkachu.com:11990",
        provider: "polkachu.com"
      },
      {
        address: "sei-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-sei.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "sei.grpc.kjnodes.com:443",
        provider: "kjnodes"
      },
      {
        address: "sei-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://evm-rpc.sei-apis.com",
        provider: "Rhino Stake"
      },
      {
        address: "https://seievm-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://jsonrpc.lavenderfive.com:443/sei",
        provider: "Lavender.Five Nodes"
      }
    ]
  },
  explorers: [
    {
      kind: "blockscout",
      url: "https://seitrace.com",
      tx_page: "https://seitrace.com/tx/${txHash}?chain=pacific-1",
      account_page: "https://seitrace.com/address/${accountAddress}?chain=pacific-1"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/sei",
      tx_page: "https://www.mintscan.io/sei/transactions/${txHash}",
      account_page: "https://www.mintscan.io/sei/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/sei",
      tx_page: "https://ezstaking.app/sei/txs/${txHash}",
      account_page: "https://ezstaking.app/sei/account/${accountAddress}"
    },
    {
      kind: "celatone",
      url: "https://www.seiscan.app/pacific-1",
      tx_page: "https://www.seiscan.app/pacific-1/txs/${txHash}",
      account_page: "https://www.seiscan.app/pacific-1/accounts/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/sei",
      tx_page: "https://mainnet.whispernode.com/sei/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/sei/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.svg",
    theme: {
      primary_color_hex: "#9c1c1c"
    }
  }]
};
J1.default = RW;
var Z1 = {};
Object.defineProperty(Z1, "__esModule", { value: !0 });
const OW = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-151",
      connection_id: "connection-136"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-8",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-103",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1140",
      connection_id: "connection-827"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-3",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-584",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravota",
      client_id: "07-tendermint-21",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-109",
      connection_id: "connection-153"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-146",
      connection_id: "connection-181"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-38",
      connection_id: "connection-33"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-132",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-108",
      connection_id: "connection-84"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-22",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-89",
      connection_id: "connection-65"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-123",
      connection_id: "connection-157"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2016",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-66",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-2110",
        port_id: "wasm.neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07"
      },
      chain_2: {
        channel_id: "channel-71",
        port_id: "wasm.sei12fykm2xhg5ces2vmf4q2aem8c958exv3v0wmvrspa8zucrdwjeds2e2ntx"
      },
      ordering: "unordered",
      version: "astroport-ibc-v1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-45",
      connection_id: "connection-61"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-45",
      connection_id: "connection-77"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-39",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-45",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nois",
      client_id: "07-tendermint-19",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-106",
      connection_id: "connection-144"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-43",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-58",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-44",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      chain_2: {
        channel_id: "channel-59",
        port_id: "wasm.sei1vxlzhn6qvf95syha2tgr0ct23sk5359s2vqzylgthuyy7kd7ql5qcxa4r0"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2790",
      connection_id: "connection-2288"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-2",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-782",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "planq",
      client_id: "07-tendermint-545",
      connection_id: "connection-477"
    },
    chain_2: {
      chain_name: "sei",
      client_id: "07-tendermint-21",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-59",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "sei",
      client_id: "07-tendermint-18",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-130",
      connection_id: "connection-119"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-149",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Z1.default = OW;
var Q1 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ls, "__esModule", { value: !0 });
Ls.ibc = Ls.chain = Ls.assets = void 0;
const MW = Q1(Y1), IW = Q1(J1), NW = Q1(Z1);
Ls.assets = MW.default;
Ls.chain = IW.default;
Ls.ibc = NW.default;
var Ws = {}, e2 = {};
Object.defineProperty(e2, "__esModule", { value: !0 });
const PW = {
  $schema: "../assetlist.schema.json",
  chain_name: "self",
  assets: [{
    description: "The native staking token of Self Chain.",
    denom_units: [{
      denom: "uslf",
      exponent: 0
    }, {
      denom: "slf",
      exponent: 6
    }],
    base: "uslf",
    name: "Self",
    display: "slf",
    symbol: "SLF",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/self/images/self.png"
    },
    coingecko_id: "self-chain",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/self/images/self.png",
      theme: {
        primary_color_hex: "#9454f1"
      }
    }],
    socials: {
      website: "https://selfchain.xyz",
      twitter: "https://x.com/selfchainxyz"
    }
  }]
};
e2.default = PW;
var n2 = {};
Object.defineProperty(n2, "__esModule", { value: !0 });
const UW = {
  $schema: "../chain.schema.json",
  chain_name: "self",
  status: "live",
  website: "https://selfchain.xyz",
  network_type: "mainnet",
  pretty_name: "Self Chain",
  chain_type: "cosmos",
  chain_id: "self-1",
  bech32_prefix: "self",
  daemon_name: "selfchaind",
  node_home: "$HOME/.selfchain",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uslf",
      fixed_min_gas_price: 5e-3,
      low_gas_price: 5e-3,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uslf"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/self/images/self.png"
  },
  description: "Self Chain Is The First Modular Intent-Centric Access Layer L1 Blockchain And Keyless Wallet Infrastructure Service That Uses MPC-TSS/AA For Multi-Chain Web3 Access.",
  apis: {
    rpc: [
      {
        address: "https://rpc.selfchain.io:26657",
        provider: "Self Chain"
      },
      {
        address: "https://rpc.selfchain.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://selfchain_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://selfchain.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️"
      },
      {
        address: "https://selfchain-mainnet.rpc.stakevillage.net:443",
        provider: "Stake Village"
      },
      {
        address: "https://selfchain-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    rest: [
      {
        address: "https://api.selfchain.io",
        provider: "Self Chain"
      },
      {
        address: "https://selfchain.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.selfchain.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://selfchain_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://selfchain.api.nodeshub.online",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️"
      },
      {
        address: "https://selfchain-mainnet.api.stakevillage.net",
        provider: "Stake Village"
      },
      {
        address: "https://selfchain-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ],
    grpc: [
      {
        address: "grpc.selfchain.roomit.xyz:8443",
        provider: "Roomit"
      },
      {
        address: "selfchain.grpc.nodeshub.online",
        provider: "Nodes Hub"
      },
      {
        address: "selfchain-mainnet.grpc.stakevillage.net:443",
        provider: "Stake Village"
      },
      {
        address: "selfchain-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ]
  },
  explorers: [
    {
      kind: "Self Chain",
      url: "https://explorer.selfchain.xyz/selfchain",
      tx_page: "https://explorer.selfchain.xyz/selfchain/tx/${txHash}",
      account_page: "https://explorer.selfchain.xyz/selfchain/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Selfchain-Mainnet",
      tx_page: "https://explorer.stavr.tech/Selfchain-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Selfchain-Mainnet/account/${accountAddress}"
    },
    {
      kind: "Roomit",
      url: "https://explorer.tendermint.roomit.xyz/selfchain-mainnet",
      tx_page: "https://explorer.tendermint.roomit.xyz/selfchain-mainnet/tx/${txHash}",
      account_page: "https://explorer.tendermint.roomit.xyz/selfchain-mainnet/account/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/self",
      tx_page: "https://explorer.whenmoonwhenlambo.money/self/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/self/account/${accountAddress}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️",
      url: "https://explorer.nodeshub.online/selfchain/",
      tx_page: "https://explorer.nodeshub.online/selfchain/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/selfchain/accounts/${accountAddress}"
    },
    {
      kind: "Stake Village",
      url: "https://exp.stakevillage.net/selfchain-mainnet",
      tx_page: "https://exp.stakevillage.net/selfchain-mainnet/tx/${txHash}",
      account_page: "https://exp.stakevillage.net/selfchain-mainnet/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/self/images/self.png",
    theme: {
      primary_color_hex: "#9454f1"
    }
  }]
};
n2.default = UW;
var t2 = {};
Object.defineProperty(t2, "__esModule", { value: !0 });
const HW = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-226",
      connection_id: "connection-211"
    },
    chain_2: {
      chain_name: "self",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-157",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1310",
      connection_id: "connection-1043"
    },
    chain_2: {
      chain_name: "self",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-892",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3213",
      connection_id: "connection-2684"
    },
    chain_2: {
      chain_name: "self",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-78292",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
t2.default = HW;
var s2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ws, "__esModule", { value: !0 });
Ws.ibc = Ws.chain = Ws.assets = void 0;
const LW = s2(e2), WW = s2(n2), VW = s2(t2);
Ws.assets = LW.default;
Ws.chain = WW.default;
Ws.ibc = VW.default;
var Vs = {}, a2 = {};
Object.defineProperty(a2, "__esModule", { value: !0 });
const GW = {
  $schema: "../assetlist.schema.json",
  chain_name: "sentinel",
  assets: [{
    description: "Sentinel is a decentralized VPN (dVPN) network that provides private and secure internet access by leveraging blockchain technology.",
    extended_description: "Sentinel is a blockchain platform designed to offer decentralized, censorship-resistant internet access via a global network of autonomous dVPN applications. The Sentinel ecosystem includes a decentralized bandwidth marketplace, where users can monetize their unused bandwidth by sharing it with others. This decentralized approach enhances privacy and security, protecting users from traditional centralized VPN vulnerabilities. Sentinel's native token, DVPN, is used for transactions within the network, staking, and governance. By leveraging blockchain technology, Sentinel ensures that internet access remains private, secure, and resilient against censorship.",
    denom_units: [{
      denom: "udvpn",
      exponent: 0
    }, {
      denom: "dvpn",
      exponent: 6
    }],
    base: "udvpn",
    name: "Sentinel",
    display: "dvpn",
    symbol: "DVPN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.svg"
    },
    coingecko_id: "sentinel",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.svg",
      theme: {
        primary_color_hex: "#10a7ef"
      }
    }],
    socials: {
      website: "https://www.sentinel.co/",
      twitter: "https://x.com/SentinelDVPN"
    }
  }]
};
a2.default = GW;
var o2 = {};
Object.defineProperty(o2, "__esModule", { value: !0 });
const KW = {
  $schema: "../chain.schema.json",
  chain_name: "sentinel",
  status: "live",
  network_type: "mainnet",
  website: "https://sentinel.co/",
  pretty_name: "Sentinel",
  chain_type: "cosmos",
  chain_id: "sentinelhub-2",
  bech32_prefix: "sent",
  daemon_name: "sentinelhub",
  node_home: "$HOME/.sentinelhub",
  slip44: 118,
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "udvpn",
      low_gas_price: 0.1,
      average_gas_price: 0.25,
      high_gas_price: 0.4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "udvpn"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.svg"
  },
  description: "The Sentinel ecosystem is a global network of autonomous dVPN applications that enable private and censorship resistant internet access.",
  apis: {
    rpc: [
      {
        address: "https://rpc-sentinel.busurnode.com",
        provider: "Busurnode"
      },
      {
        address: "https://rpc-sentinel-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://rpc.sentinel.chaintools.tech/",
        provider: "ChainTools"
      },
      {
        address: "https://rpc.sentinel.quokkastake.io",
        provider: "🐹 Quokka Stake"
      },
      {
        address: "https://rpc.dvpn.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://sentinel-rpc.badgerbite.io/",
        provider: "BadgerBite"
      },
      {
        address: "https://sentinel-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://sentinel-rpc.validatornode.com/",
        provider: "ValidatorNode"
      },
      {
        address: "https://rpc.trinitystake.io",
        provider: "Trinity Stake"
      },
      {
        address: "https://rpc.sentineldao.com",
        provider: "Sentinel Growth DAO"
      },
      {
        address: "https://public.stakewolle.com/cosmos/sentinel/rpc",
        provider: "Stakewolle"
      },
      {
        address: "http://163.197.193.2:26657",
        provider: "Tesla Full Node"
      },
      {
        address: "https://sentinel.declab.pro:26628",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://sentinel.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      },
      {
        address: "https://rpc.dvpn.me:443",
        provider: "MathNodes China"
      },
      {
        address: "https://rpc.ro.mathnodes.com:443",
        provider: "MathNodes Romania"
      },
      {
        address: "https://rpc.noncompliant.network:443",
        provider: "Noncompliant Network"
      },
      {
        address: "https://rpc-sentinel.chainvibes.com:443",
        provider: "chainvibes"
      }
    ],
    rest: [
      {
        address: "https://api-sentinel.busurnode.com",
        provider: "Busurnode"
      },
      {
        address: "https://api-sentinel-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://api.sentinel.quokkastake.io",
        provider: "🐹 Quokka Stake"
      },
      {
        address: "https://api.dvpn.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://sentinel-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://sentinel-api.validatornode.com",
        provider: "ValidatorNode"
      },
      {
        address: "https://api.trinitystake.io",
        provider: "Trinity Stake"
      },
      {
        address: "https://api.sentineldao.com",
        provider: "Sentinel Growth DAO"
      },
      {
        address: "https://public.stakewolle.com/cosmos/sentinel/rest",
        provider: "Stakewolle"
      },
      {
        address: "http://163.197.193.2:26657",
        provider: "Tesla Full Node"
      },
      {
        address: "https://sentinel.declab.pro:443",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://sentinel.api.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      },
      {
        address: "https://api.dvpn.me:443",
        provider: "MathNodes China"
      },
      {
        address: "https://api.ro.mathnodes.com:443",
        provider: "MathNodes Romania"
      },
      {
        address: "https://api.noncompliant.network:443",
        provider: "Noncompliant Network"
      },
      {
        address: "https://api-sentinel.chainvibes.com:443",
        provider: "chainvibes"
      }
    ],
    grpc: [
      {
        address: "grpc-sentinel-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "sentinel.grpcui.chaintools.host:443",
        provider: "ChainTools"
      },
      {
        address: "sentinel-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc.dvpn.roomit.xyz:8443",
        provider: "Roomit"
      },
      {
        address: "sentinel-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://sentinel.declab.pro:9019",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://sentinel.grpc.nodeshub.online",
        provider: "Nodes Hub"
      },
      {
        address: "https://grpc.dvpn.me:443",
        provider: "MathNodes China"
      },
      {
        address: "https://grc.mathnodes.com:443",
        provider: "MathNodes Romania"
      },
      {
        address: "https://grpc.noncompliant.network:443",
        provider: "Noncompliant Network"
      },
      {
        address: "https://grpc.dvpn.me:9090",
        provider: "MathNodes China (Insecure)"
      },
      {
        address: "https://grc.mathnodes.com:9000",
        provider: "MathNodes Romania (Insecure)"
      },
      {
        address: "https://grpc.noncompliant.network:9090",
        provider: "Noncompliant Network (Insecure)"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/sentinel",
      tx_page: "https://www.mintscan.io/sentinel/transactions/${txHash}",
      account_page: "https://www.mintscan.io/sentinel/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/sentinel",
      tx_page: "https://ezstaking.app/sentinel/txs/${txHash}",
      account_page: "https://ezstaking.app/sentinel/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/sentinel",
      tx_page: "https://atomscan.com/sentinel/transactions/${txHash}",
      account_page: "https://atomscan.com/sentinel/accounts/${accountAddress}"
    },
    {
      kind: "Roomit",
      url: "https://explorer.tendermint.roomit.xyz/sentinel-mainnet",
      tx_page: "https://explorer.tendermint.roomit.xyz/sentinel-mainnet/transactions/${txHash}",
      account_page: "https://explorer.tendermint.roomit.xyz/sentinel-mainnet/accounts/${accountAddress}"
    },
    {
      kind: "ValidatorNode",
      url: "https://explorer.validatornode.com/sentinel",
      tx_page: "https://explorer.validatornode.com/sentinel/tx/${txHash}"
    },
    {
      kind: "Decloud Nodes Lab",
      url: "https://explorer.declab.pro/Sentinel",
      tx_page: "https://explorer.declab.pro/Sentinel/tx/${txHash}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
      url: "https://explorer.nodeshub.online/sentinel/",
      tx_page: "https://explorer.nodeshub.online/sentinel/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/sentinel/accounts/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/sentinel",
      tx_page: "https://mainnet.whispernode.com/sentinel/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/sentinel/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sentinel/images/dvpn.svg",
    theme: {
      primary_color_hex: "#10a7ef"
    }
  }]
};
o2.default = KW;
var r2 = {};
Object.defineProperty(r2, "__esModule", { value: !0 });
const XW = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-45",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-42",
      connection_id: "connection-27"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-388",
      connection_id: "connection-341"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-58",
      connection_id: "connection-33"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-186",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-63",
      connection_id: "connection-36"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-43",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "decentr",
      client_id: "07-tendermint-13",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-103",
      connection_id: "connection-81"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-55",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-36",
      connection_id: "connection-28"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-54",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "medasdigital",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-110",
      connection_id: "connection-87"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-60",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-34",
      connection_id: "connection-28"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-61",
      connection_id: "connection-36"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "regen",
      client_id: "07-tendermint-31",
      connection_id: "connection-29"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-56",
      connection_id: "connection-32"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-14",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "sentinel",
      client_id: "07-tendermint-96",
      connection_id: "connection-75"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "sentinel",
      client_id: "07-tendermint-84",
      connection_id: "connection-58"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-9",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "sentinel",
      client_id: "07-tendermint-88",
      connection_id: "connection-70"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-46",
      connection_id: "connection-32"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-40",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  }
];
r2.default = XW;
var i2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Vs, "__esModule", { value: !0 });
Vs.ibc = Vs.chain = Vs.assets = void 0;
const YW = i2(a2), JW = i2(o2), ZW = i2(r2);
Vs.assets = YW.default;
Vs.chain = JW.default;
Vs.ibc = ZW.default;
var Gs = {}, c2 = {};
Object.defineProperty(c2, "__esModule", { value: !0 });
const QW = {
  $schema: "../assetlist.schema.json",
  chain_name: "sge",
  assets: [{
    description: "The native token of SGE Network",
    extended_description: "The Sports, Gaming, and Entertainment Network (SGE Network) is a Cosmos SDK-based layer-1 blockchain that uses its own native utility token (SGE Token). The SGE Network leverages the modular components, blockchain interoperability and minimal gas fees of the Cosmos-based design to support applications at the intersection of blockchain, sports, gaming and entertainment that are pioneering novel ways of engaging users with a UX, value proposition and utility never before seen in the space.",
    denom_units: [{
      denom: "usge",
      exponent: 0
    }, {
      denom: "sge",
      exponent: 6
    }],
    base: "usge",
    name: "SGE",
    display: "sge",
    symbol: "SGE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg"
    },
    coingecko_id: "six-sigma",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg",
      theme: {
        primary_color_hex: "#C0A15B",
        background_color_hex: "#00000000",
        circle: !1
      }
    }],
    socials: {
      website: "https://sgenetwork.io/",
      twitter: "https://x.com/sge_network"
    }
  }]
};
c2.default = QW;
var d2 = {};
Object.defineProperty(d2, "__esModule", { value: !0 });
const eV = {
  $schema: "../chain.schema.json",
  chain_name: "sge",
  status: "live",
  network_type: "mainnet",
  pretty_name: "SGE",
  chain_type: "cosmos",
  chain_id: "sgenet-1",
  bech32_prefix: "sge",
  daemon_name: "sged",
  node_home: "$HOME/.sge",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usge",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 0.1,
      average_gas_price: 0.25,
      high_gas_price: 0.5
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "usge"
    }]
  },
  codebase: {
    cosmos_sdk_version: "sge-network/cosmos-sdk v0.47.9-0.20240409081440-054c8c413d45"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.lavenderfive.com:443/sge",
        provider: "Lavenderfive"
      },
      {
        address: "https://sge-rpc.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://rpc.sge.nodestake.top/",
        provider: "Nodestake"
      },
      {
        address: "https://rpc.sge.roomit.xyz/",
        provider: "Roomit"
      },
      {
        address: "https://sge.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-sge.nodeist.net/",
        provider: "Nodeist"
      },
      {
        address: "https://sge-rpc.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://sge-rpc.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://rpc.sge.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://sge-rpc.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://rpc.sge.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://mainnet-sge-rpc.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://sge-rpc.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://sge_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://rest.lavenderfive.com:443/sge",
        provider: "Lavenderfive"
      },
      {
        address: "https://sge-api.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://api.sge.nodestake.top/",
        provider: "Nostake"
      },
      {
        address: "https://api-sge.nodeist.net/",
        provider: "Nodeist"
      },
      {
        address: "https://sge.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://sge-api.ramuchi.tech/",
        provider: "ramuchi.tech"
      },
      {
        address: "https://sge-rest.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://rest.sge.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://sge-api.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://api.sge.safeblock.space",
        provider: "Safe Block"
      },
      {
        address: "https://mainnet-sge-api.konsortech.xyz",
        provider: "KonsorTech"
      },
      {
        address: "https://sge-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://api.sge.roomit.xyz/",
        provider: "Roomit"
      },
      {
        address: "https://sge_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "sge.lavenderfive.com:443",
        provider: "Lavenderfive"
      },
      {
        address: "https://grpc.sge.nodestake.top/",
        provider: "Nodestake"
      },
      {
        address: "https://grpc-sge.nodeist.net/",
        provider: "Nodeist"
      },
      {
        address: "https://sge-grpc.ramuchi.tech:443",
        provider: "ramuchi.tech"
      },
      {
        address: "http://sge.grpc.m.stavr.tech:543",
        provider: "🔥STAVR🔥"
      },
      {
        address: "sge-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "https://sge-grpc.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "mainnet-sge.konsortech.xyz:22090",
        provider: "KonsorTech"
      },
      {
        address: "sge-grpc.genznodes.dev:5090",
        provider: "genznodes"
      },
      {
        address: "grpc.sge.roomit.xyz:8443",
        provider: "Roomit"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://blockexplorer.sgenetwork.io/sge",
      tx_page: "https://blockexplorer.sgenetwork.io/sge/tx/${txHash}"
    },
    {
      kind: "nodestake.top",
      url: "https://explorer.nodestake.top/sge",
      tx_page: "https://explorer.nodestake.top/sge/tx/${txHash}"
    },
    {
      kind: "stakerhouse",
      url: "https://cosmotracker.com/sge",
      tx_page: "https://cosmotracker.com/sge/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Sge-Mainnet",
      tx_page: "https://explorer.stavr.tech/Sge-Mainnet/transaction/${txHash}",
      account_page: "https://explorer.stavr.tech/Sge-Mainnet/account/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/sge",
      tx_page: "https://explorer.tcnetwork.io/sge/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/sge/account/${accountAddress}"
    },
    {
      kind: "Safe Block",
      url: "https://explorer.safeblock.space/sge",
      tx_page: "https://explorer.safeblock.space/sge/tx/${txHash}",
      account_page: "https://explorer.safeblock.space/sge/account/${accountAddress}"
    },
    {
      kind: "KonsorTech",
      url: "https://explorer.konsortech.xyz/sge",
      tx_page: "https://explorer.konsortech.xyz/sge/tx/${txHash}",
      account_page: "https://explorer.konsortech.xyz/sge/account/${accountAddress}"
    },
    {
      kind: "Roomit",
      url: "https://explorer.tendermint.roomit.xyz/sge-mainnet",
      tx_page: "https://explorer.tendermint.roomit.xyz/sge-mainnet/tx/${txHash}",
      account_page: "https://explorer.tendermint.roomit.xyz/sge-mainnet/account/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/sge",
      tx_page: "https://explorer.whenmoonwhenlambo.money/sge/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/sge/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg",
    theme: {
      primary_color_hex: "#b99952"
    }
  }]
};
d2.default = eV;
var m2 = {};
Object.defineProperty(m2, "__esModule", { value: !0 });
const nV = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2972",
    connection_id: "connection-2468"
  },
  chain_2: {
    chain_name: "sge",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-5485",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
m2.default = nV;
var h2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Gs, "__esModule", { value: !0 });
Gs.ibc = Gs.chain = Gs.assets = void 0;
const tV = h2(c2), sV = h2(d2), aV = h2(m2);
Gs.assets = tV.default;
Gs.chain = sV.default;
Gs.ibc = aV.default;
var Ks = {}, p2 = {};
Object.defineProperty(p2, "__esModule", { value: !0 });
const oV = {
  $schema: "../assetlist.schema.json",
  chain_name: "shareledger",
  assets: [{
    description: "The native token of Shareledger",
    denom_units: [{
      denom: "nshr",
      exponent: 0
    }, {
      denom: "shr",
      exponent: 9
    }],
    base: "nshr",
    name: "Shareledger",
    display: "shr",
    symbol: "SHR",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shareledger/images/token.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shareledger/images/token.svg"
    },
    coingecko_id: "shareledger",
    keywords: ["id"],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shareledger/images/token.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shareledger/images/token.svg",
      theme: {
        primary_color_hex: "#1c2474"
      }
    }]
  }]
};
p2.default = oV;
var l2 = {};
Object.defineProperty(l2, "__esModule", { value: !0 });
const rV = {
  $schema: "../chain.schema.json",
  chain_name: "shareledger",
  status: "live",
  network_type: "mainnet",
  website: "https://www.sharering.network/",
  pretty_name: "Shareledger",
  chain_type: "cosmos",
  chain_id: "ShareRing-VoyagerNet",
  bech32_prefix: "shareledger",
  daemon_name: "shareledger",
  node_home: "$HOME/.shareledger",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "nshr",
      fixed_min_gas_price: 0,
      low_gas_price: 2e3,
      average_gas_price: 3e3,
      high_gas_price: 4e3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "nshr"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.27"
  },
  apis: {
    rpc: [{
      address: "https://rpc.explorer.shareri.ng",
      provider: "ShareRing"
    }],
    rest: [{
      address: "https://lcd.explorer.shareri.ng/",
      provider: "ShareRing"
    }],
    grpc: [{
      address: "rpc.explorer.shareri.ng:443",
      provider: "ShareRing"
    }]
  },
  explorers: [{
    kind: "big dipper",
    url: "https://explorer.shareri.ng",
    tx_page: "https://explorer.shareri.ng/transactions/${txHash}",
    account_page: "https://explorer.shareri.ng/accounts/${accountAddress}"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shareledger/images/chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shareledger/images/token.svg"
  },
  keywords: ["id"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shareledger/images/chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shareledger/images/token.svg",
    theme: {
      primary_color_hex: "#1c2474"
    }
  }]
};
l2.default = rV;
var g2 = {};
Object.defineProperty(g2, "__esModule", { value: !0 });
const iV = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2680",
    connection_id: "connection-2182"
  },
  chain_2: {
    chain_name: "shareledger",
    client_id: "07-tendermint-1",
    connection_id: "connection-5"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-647",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
g2.default = iV;
var u2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ks, "__esModule", { value: !0 });
Ks.ibc = Ks.chain = Ks.assets = void 0;
const cV = u2(p2), dV = u2(l2), mV = u2(g2);
Ks.assets = cV.default;
Ks.chain = dV.default;
Ks.ibc = mV.default;
var Xs = {}, _2 = {};
Object.defineProperty(_2, "__esModule", { value: !0 });
const hV = {
  $schema: "../assetlist.schema.json",
  chain_name: "shentu",
  assets: [{
    description: "The native token of Shentu",
    denom_units: [{
      denom: "uctk",
      exponent: 0
    }, {
      denom: "ctk",
      exponent: 6
    }],
    base: "uctk",
    name: "Shentu",
    display: "ctk",
    symbol: "CTK",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.svg"
    },
    coingecko_id: "certik",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.svg",
      theme: {
        primary_color_hex: "#e4ac4c"
      }
    }]
  }]
};
_2.default = hV;
var y2 = {};
Object.defineProperty(y2, "__esModule", { value: !0 });
const pV = {
  $schema: "../chain.schema.json",
  chain_name: "shentu",
  status: "live",
  network_type: "mainnet",
  website: "https://www.shentu.technology/",
  pretty_name: "Shentu",
  chain_type: "cosmos",
  chain_id: "shentu-2.2",
  bech32_prefix: "shentu",
  daemon_name: "shentud",
  node_home: "$HOME/.shentud",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uctk",
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uctk"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://shenturpc.noopsbycertik.com/",
        provider: "Shentu"
      },
      {
        address: "https://shentu-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://shentu.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://shentu-rpc.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://rpc-shentu-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://shentu-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://shentu-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://shentu-rpc.panthea.eu",
        provider: "Panthea EU"
      },
      {
        address: "https://shentu-rpc.kleomedes.network",
        provider: "Kleomedes"
      }
    ],
    rest: [
      {
        address: "https://rest.noopsbycertik.com/",
        provider: "Shentu"
      },
      {
        address: "https://shentu-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://shentu.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://shentu-api.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://api-shentu-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://shentu-api.tienthuattoan.ventures",
        provider: "TienThuatToan"
      },
      {
        address: "https://shentu-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://shentu-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://shentu-api.panthea.eu",
        provider: "Panthea EU"
      },
      {
        address: "https://shentu-api.kleomedes.network",
        provider: "Kleomedes"
      }
    ],
    grpc: [
      {
        address: "shentu-grpc.polkachu.com:14090",
        provider: "Polkachu"
      },
      {
        address: "shentu.grpc.m.stavr.tech:9593",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://shentu-grpc.ramuchi.tech:12090",
        provider: "ramuchi.tech"
      },
      {
        address: "grpc-shentu-01.stakeflow.io:2402",
        provider: "Stakeflow"
      },
      {
        address: "shentu-grpc.tienthuattoan.ventures:9490",
        provider: "TienThuatToan"
      },
      {
        address: "shentu-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "shentu-grpc.panthea.eu:16700",
        provider: "Panthea EU"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/shentu",
      tx_page: "https://ezstaking.app/shentu/txs/${txHash}",
      account_page: "https://ezstaking.app/shentu/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Shentu-Mainnet",
      tx_page: "https://explorer.stavr.tech/Shentu-Mainnet/txs/${txHash}",
      account_page: "https://explorer.stavr.tech/Shentu-Mainnet/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/shentu",
      tx_page: "https://www.mintscan.io/shentu/transactions/${txHash}",
      account_page: "https://www.mintscan.io/shentu/accounts/${accountAddress}"
    },
    {
      kind: "Shentu Explorer",
      url: "https://explorer.shentu.technology/?net=shentu-2.2",
      tx_page: "https://explorer.shentu.technology/transactions/${txHash}?net=shentu-2.2"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/shentu",
      tx_page: "https://ping.pub/shentu/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/shentu",
      tx_page: "https://atomscan.com/shentu/transactions/${txHash}",
      account_page: "https://atomscan.com/shentu/accounts/${accountAddress}"
    },
    {
      kind: "bigdipper",
      url: "https://bigdipper.live/shentu",
      tx_page: "https://bigdipper.live/shentu/transactions/${txHash}",
      account_page: "https://bigdipper.live/shentu/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/shentu",
      account_page: "https://stakeflow.io/shentu/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shentu/images/ctk.svg",
    theme: {
      primary_color_hex: "#e4ac4c"
    }
  }]
};
y2.default = pV;
var b2 = {};
Object.defineProperty(b2, "__esModule", { value: !0 });
const lV = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-1741",
    connection_id: "connection-1342"
  },
  chain_2: {
    chain_name: "shentu",
    client_id: "07-tendermint-9",
    connection_id: "connection-8"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-146",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-8",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
b2.default = lV;
var v2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Xs, "__esModule", { value: !0 });
Xs.ibc = Xs.chain = Xs.assets = void 0;
const gV = v2(_2), uV = v2(y2), _V = v2(b2);
Xs.assets = gV.default;
Xs.chain = uV.default;
Xs.ibc = _V.default;
var Ys = {}, f2 = {};
Object.defineProperty(f2, "__esModule", { value: !0 });
const yV = {
  $schema: "../assetlist.schema.json",
  chain_name: "shido",
  assets: [{
    description: "The native EVM and Wasm, governance and staking token of the Shido Chain",
    denom_units: [{
      denom: "shido",
      exponent: 0
    }, {
      denom: "SHIDO",
      exponent: 18
    }],
    base: "shido",
    name: "Shido",
    display: "SHIDO",
    symbol: "SHIDO",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.svg"
    },
    coingecko_id: "shido-2",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.svg",
      theme: {
        primary_color_hex: "#046ffc"
      }
    }],
    socials: {
      website: "https://shido.io/",
      twitter: "https://twitter.com/ShidoGlobal"
    }
  }]
};
f2.default = yV;
var w2 = {};
Object.defineProperty(w2, "__esModule", { value: !0 });
const bV = {
  $schema: "../chain.schema.json",
  chain_name: "shido",
  status: "live",
  network_type: "mainnet",
  website: "https://shido.io/",
  pretty_name: "Shido",
  chain_type: "cosmos",
  chain_id: "shido_9008-1",
  bech32_prefix: "shido",
  node_home: "$HOME/.shidod",
  daemon_name: "shidod",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "shido",
      fixed_min_gas_price: 25e7,
      low_gas_price: 2e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "shido"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.4",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.45.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.svg"
  },
  description: "Developers use Shido as the Ethereum and Wasm Chain to deploy applications of the future. Get all the functionalities of Ethereum and Wasm with the power of IBC and Interchain composability.",
  apis: {
    rpc: [
      {
        address: "https://tendermint.shidoscan.com",
        provider: "Shido"
      },
      {
        address: "https://shidochain_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://s2.shido-rpc.applejuice.256x25.tech:443",
        provider: "Apple juice 🧃"
      },
      {
        address: "https://rpc.shido.indonode.net:443",
        provider: "Indonode"
      },
      {
        address: "https://rpc-maverick.mavnode.io",
        provider: "MavNode"
      },
      {
        address: "https://rpc.kenseishido.com",
        provider: "KENSEI"
      }
    ],
    rest: [
      {
        address: "https://swagger.shidoscan.com",
        provider: "Shido"
      },
      {
        address: "https://shidochain_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://s2.shido-api.applejuice.256x25.tech:443",
        provider: "Apple juice 🧃"
      },
      {
        address: "https://api.shido.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://api-maverick.mavnode.io",
        provider: "MavNode"
      },
      {
        address: "https://api.kenseishido.com",
        provider: "KENSEI"
      }
    ],
    grpc: [
      {
        address: "https://grpc.shidoscan.com",
        provider: "shido.io"
      },
      {
        address: "https://grpc-web.shidoscan.com",
        provider: "shido.io"
      },
      {
        address: "https://s2.shido-grpc.applejuice.256x25.tech",
        provider: "Apple juice 🧃"
      },
      {
        address: "https://grpc-maverick.mavnode.io",
        provider: "MavNode"
      },
      {
        address: "https://grpc.kenseishido.com",
        provider: "KENSEI"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://rpc-nodes.shidoscan.com",
        provider: "Shido"
      },
      {
        address: "https://rpc-delta-nodes.shidoscan.com",
        provider: "Shido"
      },
      {
        address: "https://shidochain_mainnet_evm.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://s2.shido-evm.applejuice.256x25.tech:443",
        provider: "Apple juice 🧃"
      },
      {
        address: "https://evm-maverick.mavnode.io",
        provider: "MavNode"
      },
      {
        address: "https://evm.kenseishido.com",
        provider: "KENSEI"
      }
    ]
  },
  explorers: [
    {
      kind: "shido",
      url: "https://shidoscan.com",
      tx_page: "https://shidoscan.com/tx/${txHash}",
      account_page: "https://shidoscan.com/address/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/shido",
      tx_page: "https://explorer.whenmoonwhenlambo.money/shido/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/shido/account/${accountAddress}"
    },
    {
      kind: "Apple juice 🧃",
      url: "https://explorer.256x25.tech/shido",
      tx_page: "https://explorer.256x25.tech/shido/tx/${txHash}",
      account_page: "https://explorer.256x25.tech//shido/account/${accountAddress}"
    },
    {
      kind: "MavNode",
      url: "https://explorer.mavnode.io/shido",
      tx_page: "https://explorer.mavnode.io/shido/tx/${txHash}",
      account_page: "https://explorer.mavnode.io/shido/account/${accountAddress}"
    },
    {
      kind: "Indonode",
      url: "https://explorer.indonode.net/shido",
      tx_page: "https://explorer.indonode.net/shido/tx/${txHash}",
      account_page: "https://explorer.indonode.net/shido/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/shido/images/shido.svg",
    theme: {
      primary_color_hex: "#046ffc"
    }
  }]
};
w2.default = bV;
var x2 = {};
Object.defineProperty(x2, "__esModule", { value: !0 });
const vV = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-210",
      connection_id: "connection-191"
    },
    chain_2: {
      chain_name: "shido",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-148",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-106",
      connection_id: "connection-99"
    },
    chain_2: {
      chain_name: "shido",
      client_id: "07-tendermint-9",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-87",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3198",
      connection_id: "connection-2654"
    },
    chain_2: {
      chain_name: "shido",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-73755",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
x2.default = vV;
var k2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ys, "__esModule", { value: !0 });
Ys.ibc = Ys.chain = Ys.assets = void 0;
const fV = k2(f2), wV = k2(w2), xV = k2(x2);
Ys.assets = fV.default;
Ys.chain = wV.default;
Ys.ibc = xV.default;
var Js = {}, A2 = {};
Object.defineProperty(A2, "__esModule", { value: !0 });
const kV = {
  $schema: "../assetlist.schema.json",
  chain_name: "sifchain",
  assets: [{
    description: "Rowan Token (ROWAN) is the Sifchain Network's native utility token, used as the primary means to govern, provide liquidity, secure the blockchain, incentivize participants, and provide a default mechanism to store and exchange value.",
    denom_units: [{
      denom: "rowan",
      exponent: 0
    }, {
      denom: "ROWAN",
      exponent: 18
    }],
    base: "rowan",
    name: "Sifchain Rowan",
    display: "ROWAN",
    symbol: "ROWAN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.svg"
    },
    coingecko_id: "sifchain",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.svg",
      theme: {
        primary_color_hex: "#be9926"
      }
    }]
  }]
};
A2.default = kV;
var j2 = {};
Object.defineProperty(j2, "__esModule", { value: !0 });
const AV = {
  $schema: "../chain.schema.json",
  chain_name: "sifchain",
  status: "live",
  network_type: "mainnet",
  website: "https://sifchain.finance/",
  pretty_name: "Sifchain",
  chain_type: "cosmos",
  chain_id: "sifchain-1",
  bech32_prefix: "sif",
  daemon_name: "sifnoded",
  node_home: "$HOME/.sifnoded",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "rowan",
      low_gas_price: 1e12,
      average_gas_price: 15e11,
      high_gas_price: 2e12
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "rowan"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://sifchain-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://sifchain-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://sifchain-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://sifchain_mainnet_rpc.chain.whenmoonwhenlambo.money:443",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://api-sifchain-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://sifchain-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://sifchain-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://sifchain-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://sifchain.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://sifchain_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "sifchain-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "sifchain-grpc.polkachu.com:13290",
        provider: "Polkachu"
      },
      {
        address: "sifchain-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/sifchain",
      tx_page: "https://ping.pub/sifchain/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/sifchain",
      tx_page: "https://atomscan.com/sifchain/transactions/${txHash}",
      account_page: "https://atomscan.com/sifchain/accounts/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Sifchain",
      tx_page: "https://explorer.stavr.tech/Sifchain/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Sifchain/accounts/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/sifchain",
      tx_page: "https://explorer.whenmoonwhenlambo.money/sifchain/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/sifchain/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sifchain/images/rowan.svg",
    theme: {
      primary_color_hex: "#be9926"
    }
  }]
};
j2.default = AV;
var C2 = {};
Object.defineProperty(C2, "__esModule", { value: !0 });
const jV = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-61",
      connection_id: "connection-36"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-11",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-395",
      connection_id: "connection-347"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-192",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-1103",
      connection_id: "connection-239"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-20",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "impacthub",
      client_id: "07-tendermint-25",
      connection_id: "connection-25"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-39",
      connection_id: "connection-18"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-42",
      connection_id: "connection-30"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-19",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-9",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-37",
      connection_id: "connection-17"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1484",
      connection_id: "connection-1159"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-41",
      connection_id: "connection-20"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-47",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-38",
      connection_id: "connection-32"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-18",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-26",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "regen",
      client_id: "07-tendermint-73",
      connection_id: "connection-60"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-31",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-28",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-37",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-171",
      connection_id: "connection-98"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-65",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "sentinel",
      client_id: "07-tendermint-84",
      connection_id: "connection-58"
    },
    chain_2: {
      chain_name: "sifchain",
      client_id: "07-tendermint-9",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  }
];
C2.default = jV;
var E2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Js, "__esModule", { value: !0 });
Js.ibc = Js.chain = Js.assets = void 0;
const CV = E2(A2), EV = E2(j2), DV = E2(C2);
Js.assets = CV.default;
Js.chain = EV.default;
Js.ibc = DV.default;
var wr = {}, D2 = {};
Object.defineProperty(D2, "__esModule", { value: !0 });
const BV = {
  $schema: "../assetlist.schema.json",
  chain_name: "six",
  assets: [{
    description: "The native staking token of the SIX Protocol.",
    denom_units: [{
      denom: "usix",
      exponent: 0
    }, {
      denom: "six",
      exponent: 6
    }],
    base: "usix",
    name: "Six token",
    display: "six",
    symbol: "SIX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/six/images/six.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/six/images/six.png",
      theme: {
        primary_color_hex: "#3b75f3"
      }
    }]
  }]
};
D2.default = BV;
var B2 = {};
Object.defineProperty(B2, "__esModule", { value: !0 });
const FV = {
  $schema: "../chain.schema.json",
  chain_name: "six",
  status: "live",
  network_type: "mainnet",
  pretty_name: "SIX Protocol",
  chain_type: "cosmos",
  chain_id: "sixnet",
  bech32_prefix: "6x",
  daemon_name: "sixd",
  node_home: "$HOME/.six",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usix",
      fixed_min_gas_price: 1.25,
      low_gas_price: 1.25,
      average_gas_price: 1.5,
      high_gas_price: 1.75
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "usix"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45"
  },
  apis: {
    rpc: [{
      address: "https://sixnet-rpc.sixprotocol.net:443"
    }],
    rest: [{
      address: "https://sixnet-api.sixprotocol.net:443"
    }]
  },
  explorers: [{
    kind: "sixscan",
    url: "https://sixscan.io/sixnet",
    tx_page: "https://sixscan.io/sixnet/tx/${txHash}"
  }],
  keywords: [
    "sixprotocol",
    "sixnetwork",
    "sixnet",
    "six"
  ]
};
B2.default = FV;
var G9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(wr, "__esModule", { value: !0 });
wr.chain = wr.assets = void 0;
const $V = G9(D2), zV = G9(B2);
wr.assets = $V.default;
wr.chain = zV.default;
var Zs = {}, F2 = {};
Object.defineProperty(F2, "__esModule", { value: !0 });
const qV = {
  $schema: "../assetlist.schema.json",
  chain_name: "sommelier",
  assets: [{
    description: "Somm Token (SOMM) is the native staking token of the Sommelier Chain",
    denom_units: [
      {
        denom: "usomm",
        exponent: 0,
        aliases: ["microsomm"]
      },
      {
        denom: "msomm",
        exponent: 3,
        aliases: ["millisomm"]
      },
      {
        denom: "somm",
        exponent: 6
      }
    ],
    base: "usomm",
    name: "Sommelier",
    display: "somm",
    symbol: "SOMM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.svg"
    },
    coingecko_id: "sommelier",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.svg",
      theme: {
        primary_color_hex: "#f36353"
      }
    }],
    socials: {
      website: "https://www.sommelier.finance/",
      twitter: "https://twitter.com/sommfinance"
    }
  }]
};
F2.default = qV;
var $2 = {};
Object.defineProperty($2, "__esModule", { value: !0 });
const SV = {
  $schema: "../chain.schema.json",
  chain_name: "sommelier",
  status: "live",
  network_type: "mainnet",
  website: "https://sommelier.finance/",
  pretty_name: "Sommelier",
  chain_type: "cosmos",
  chain_id: "sommelier-3",
  bech32_prefix: "somm",
  daemon_name: "sommelier",
  node_home: "$HOME/.sommelier",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usomm",
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "usomm"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.46.14"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.svg"
  },
  description: "Automated vaults find best-in-class yields while mitigating risk.",
  apis: {
    rpc: [
      {
        address: "https://sommelier-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-sommelier.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://somm.rpc.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.lavenderfive.com:443/sommelier",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://sommelier-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://somm-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://sommelier-rpc.w3coins.io",
        provider: "w3coins"
      }
    ],
    rest: [
      {
        address: "https://api-sommelier.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://sommelier-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://som.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rest.lavenderfive.com:443/sommelier",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://sommelier-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://somm-api.kleomedes.network",
        provider: "Kleomedes"
      }
    ],
    grpc: [
      {
        address: "sommelier-grpc.polkachu.com:14190",
        provider: "Polkachu"
      },
      {
        address: "somm.grpc.m.stavr.tech:114",
        provider: "🔥STAVR🔥"
      },
      {
        address: "sommelier.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "sommelier-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://grpc.sommelier.nodexcapital.com",
        provider: "⚡NodeX Validator⚡"
      },
      {
        address: "sommelier-grpc.w3coins.io:14190",
        provider: "w3coins"
      },
      {
        address: "grpc.sommelier.validatus.com",
        provider: "Validatus"
      }
    ]
  },
  explorers: [
    {
      kind: "sommscan",
      url: "https://sommscan.io",
      tx_page: "https://sommscan.io"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/sommelier",
      tx_page: "https://www.mintscan.io/sommelier/transactions/${txHash}",
      account_page: "https://www.mintscan.io/sommelier/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/sommelier",
      tx_page: "https://ezstaking.app/sommelier/txs/${txHash}",
      account_page: "https://ezstaking.app/sommelier/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Sommelier-Mainnet",
      tx_page: "https://explorer.stavr.tech/Sommelier-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Sommelier-Mainnet/account/${accountAddress}"
    },
    {
      kind: "NODEXPLORER",
      url: "https://explorer.nodexcapital.com/sommelier",
      tx_page: "https://explorer.nodexcapital.com/sommelier/tx/${txHash}",
      account_page: "https://explorer.nodexcapital.com/sommelier/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/sommelier",
      tx_page: "https://atomscan.com/sommelier/transactions/${txHash}",
      account_page: "https://atomscan.com/sommelier/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sommelier/images/somm.svg",
    theme: {
      primary_color_hex: "#f36353"
    }
  }]
};
$2.default = SV;
var z2 = {};
Object.defineProperty(z2, "__esModule", { value: !0 });
const TV = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-109",
      connection_id: "connection-96"
    },
    chain_2: {
      chain_name: "sommelier",
      client_id: "07-tendermint-13",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-72",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics-20",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "canto",
      client_id: "07-tendermint-24",
      connection_id: "connection-16"
    },
    chain_2: {
      chain_name: "sommelier",
      client_id: "07-tendermint-10",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-135",
      connection_id: "connection-108"
    },
    chain_2: {
      chain_name: "sommelier",
      client_id: "07-tendermint-4",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-93",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-107",
      connection_id: "connection-77"
    },
    chain_2: {
      chain_name: "sommelier",
      client_id: "07-tendermint-12",
      connection_id: "connection-8"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-69",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1745",
      connection_id: "connection-1348"
    },
    chain_2: {
      chain_name: "sommelier",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-165",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "sommelier",
      client_id: "07-tendermint-60",
      connection_id: "connection-75"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-131",
      connection_id: "connection-122"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-71",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-150",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
z2.default = TV;
var q2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Zs, "__esModule", { value: !0 });
Zs.ibc = Zs.chain = Zs.assets = void 0;
const RV = q2(F2), OV = q2($2), MV = q2(z2);
Zs.assets = RV.default;
Zs.chain = OV.default;
Zs.ibc = MV.default;
var Qs = {}, S2 = {};
Object.defineProperty(S2, "__esModule", { value: !0 });
const IV = {
  $schema: "../assetlist.schema.json",
  chain_name: "source",
  assets: [{
    description: "The native token of SOURCE Chain",
    extended_description: "Enterprises, developers, and individuals are empowered to use SOURCE's sustainable and value backed network to easily access, build, and integrate web3 applications and services.",
    denom_units: [{
      denom: "usource",
      exponent: 0
    }, {
      denom: "source",
      exponent: 6
    }],
    base: "usource",
    name: "Source",
    display: "source",
    symbol: "SOURCE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.svg"
    },
    coingecko_id: "source",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.svg",
      theme: {
        primary_color_hex: "#39a5fc"
      }
    }],
    socials: {
      website: "https://www.sourceprotocol.io/",
      twitter: "https://twitter.com/sourceprotocol_"
    }
  }, {
    description: "Source Protocol's SRCX Token Bridged from BNB Through Planq",
    denom_units: [{
      denom: "ibc/FC5A7360EEED0713AE3E83E9D55A69AF873056A172AC495890ACE4582FF9685A",
      exponent: 0,
      aliases: ["nsrcx"]
    }, {
      denom: "srcx",
      exponent: 9
    }],
    type_asset: "ics20",
    base: "ibc/FC5A7360EEED0713AE3E83E9D55A69AF873056A172AC495890ACE4582FF9685A",
    name: "SRCX",
    display: "srcx",
    symbol: "SRCX",
    traces: [{
      type: "ibc",
      counterparty: {
        chain_name: "planq",
        base_denom: "erc20/0x091F9A57A3F58d758b6572E9d41675918EAC7F09",
        channel_id: "channel-61"
      },
      chain: {
        channel_id: "channel-1",
        path: "transfer/channel-1/erc20/0x091F9A57A3F58d758b6572E9d41675918EAC7F09"
      }
    }],
    images: [{
      image_sync: {
        chain_name: "binancesmartchain",
        base_denom: "0x454b90716a9435e7161a9aea5cf00e0acbe565ae"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/srcx.png",
      theme: {
        primary_color_hex: "#7f22bc"
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/srcx.png"
    }
  }]
};
S2.default = IV;
var T2 = {};
Object.defineProperty(T2, "__esModule", { value: !0 });
const NV = {
  $schema: "../chain.schema.json",
  chain_name: "source",
  status: "live",
  network_type: "mainnet",
  website: "https://www.sourceprotocol.io/",
  pretty_name: "Source",
  chain_type: "cosmos",
  chain_id: "source-1",
  bech32_prefix: "source",
  daemon_name: "sourced",
  node_home: "$HOME/.source",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usource",
      fixed_min_gas_price: 0.05,
      low_gas_price: 0.05,
      average_gas_price: 0.075,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "usource"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.source.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://source.rpc.bccnodes.com/",
        provider: "BccNodes"
      },
      {
        address: "https://source.rpc.moonbridge.team/",
        provider: "MoonBridge"
      },
      {
        address: "https://source.rpc.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-source.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "https://source-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://source-mainnet-rpc.itrocket.net:443",
        provider: "ITRocket"
      },
      {
        address: "https://rpc-source.sr20de.xyz:443",
        provider: "Sr20de"
      },
      {
        address: "https://source-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://rpc.source.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://rpc.source.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://source.rpc.skynodejs.net/",
        provider: "skynodejs"
      },
      {
        address: "https://source.rpc.nodeshub.online/",
        provider: "Nodes Hub"
      },
      {
        address: "https://rpc.source.roomit.xyz/",
        provider: "Roomit"
      },
      {
        address: "https://rpc.source.posthuman.digital",
        provider: "posthuman"
      },
      {
        address: "https://source.declab.pro:26604",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://rpc.source.stakeup.tech",
        provider: "StakeUp"
      },
      {
        address: "https://source_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://source-rpc.bluestake.net:443",
        provider: "BlueStake 🚀"
      }
    ],
    rest: [
      {
        address: "https://api.source.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://source.lcd.bccnodes.com/",
        provider: "BccNodes"
      },
      {
        address: "https://api-source.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "https://source.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://source-mainnet-api.itrocket.net:443",
        provider: "ITRocket"
      },
      {
        address: "https://source-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://source.api.moonbridge.team/",
        provider: "MoonBridge"
      },
      {
        address: "https://api-source.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://source-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://rest.source.tcnetwork.io",
        provider: "TC Network"
      },
      {
        address: "https://api.source.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://source.api.nodeshub.online/",
        provider: "Nodes Hub"
      },
      {
        address: "https://api.source.validatus.com",
        provider: "Validatus"
      },
      {
        address: "https://api.source.roomit.xyz",
        provider: "Roomit"
      },
      {
        address: "https://rest.source.posthuman.digital",
        provider: "posthuman"
      },
      {
        address: "https://source.api.staking-explorer.com",
        provider: "Daily DROP | 3% Fee"
      },
      {
        address: "https://source.declab.pro:443",
        provider: "Decloud Nodes Lab"
      },
      {
        address: "https://api.source.stakeup.tech",
        provider: "StakeUp"
      },
      {
        address: "https://source_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      },
      {
        address: "https://source-api.bluestake.net",
        provider: "BlueStake 🚀"
      }
    ],
    grpc: [
      {
        address: "source-mainnet-grpc.itrocket.net:32090",
        provider: "ITRocket"
      },
      {
        address: "source.grpc.bccnodes.com:443",
        provider: "BccNodes"
      },
      {
        address: "http://source.grpc.m.stavr.tech:9590",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://grpc-source.nodeist.net:443",
        provider: "Nodeist"
      },
      {
        address: "https://grpc.source.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "https://grpc-source.sr20de.xyz:443",
        provider: "Sr20de"
      },
      {
        address: "source-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "source-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "https://source.grpc.skynodejs.net",
        provider: "skynodejs"
      },
      {
        address: "https://source.grpc.nodeshub.online",
        provider: "Nodes Hub"
      },
      {
        address: "https://grpc.source.validatus.com",
        provider: "Validatus"
      },
      {
        address: "grpc.source.roomit.xyz:8443",
        provider: "Roomit"
      },
      {
        address: "https://source.declab.pro:9003",
        provider: "Decloud Nodes Lab"
      }
    ]
  },
  explorers: [
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Source-Mainnet/",
      tx_page: "https://explorer.stavr.tech/Source-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Source-Mainnet/accounts/${accountAddress}"
    },
    {
      kind: "Nodeist",
      url: "https://exp.nodeist.net/source/",
      tx_page: "https://exp.nodeist.net/source/tx/${txHash}",
      account_page: "https://exp.nodeist.net/source/accounts/${accountAddress}"
    },
    {
      kind: "MoonBridge",
      url: "https://explorer.moonbridge.team/source",
      tx_page: "https://explorer.moonbridge.team/source/tx/${txHash}",
      account_page: "https://explorer.moonbridge.team/source/accounts/${accountAddress}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.top/source",
      tx_page: "https://explorer.nodestake.top/source/tx/${txHash}",
      account_page: "https://explorer.nodestake.top/source/accounts/${accountAddress}"
    },
    {
      kind: "Sr20de",
      url: "https://explorer.sr20de.xyz/Source-mainnet",
      tx_page: "https://explorer.sr20de.xyz/Source-mainnet/tx/${txHash}",
      account_page: "https://explorer.sr20de.xyz/Source-mainnet/accounts/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/source",
      tx_page: "https://explorer.tcnetwork.io/source/transaction/${txHash}"
    },
    {
      kind: "Indonode",
      url: "https://explorer.indonode.net/source",
      tx_page: "https://explorer.indonode.net/source/tx/${txHash}"
    },
    {
      kind: "Roomit",
      url: "https://explorer.tendermint.roomit.xyz/source-mainnet/",
      tx_page: "https://explorer.tendermint.roomit.xyz/source-mainnet/tx/${txHash}"
    },
    {
      kind: "posthuman",
      url: "https://explorer.posthuman.digital/source",
      tx_page: "https://explorer.posthuman.digital/source/tx/${txHash}",
      account_page: "https://explorer.posthuman.digital/source/account/${accountAddress}"
    },
    {
      kind: "Decloud Nodes Lab",
      url: "https://explorer.declab.pro/Source",
      tx_page: "https://explorer.declab.pro/Source/tx/${txHash}",
      account_page: "https://explorer.declab.pro/Source/account/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/source",
      tx_page: "https://explorer.whenmoonwhenlambo.money/source/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/source/account/${accountAddress}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
      url: "https://explorer.nodeshub.online/source/",
      tx_page: "https://explorer.nodeshub.online/source/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/source/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.svg",
    theme: {
      primary_color_hex: "#39a5fc"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/source/images/source.svg"
  }
};
T2.default = NV;
var R2 = {};
Object.defineProperty(R2, "__esModule", { value: !0 });
const PV = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-229",
      connection_id: "connection-219"
    },
    chain_2: {
      chain_name: "source",
      client_id: "07-tendermint-17",
      connection_id: "connection-17"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-160",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kyve",
      client_id: "07-tendermint-3",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "source",
      client_id: "07-tendermint-15",
      connection_id: "connection-16"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      fee_version: "ics29-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-3035",
      connection_id: "connection-2524"
    },
    chain_2: {
      chain_name: "source",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8945",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "planq",
      client_id: "07-tendermint-558",
      connection_id: "connection-483"
    },
    chain_2: {
      chain_name: "source",
      client_id: "07-tendermint-10",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-61",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
R2.default = PV;
var O2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qs, "__esModule", { value: !0 });
Qs.ibc = Qs.chain = Qs.assets = void 0;
const UV = O2(S2), HV = O2(T2), LV = O2(R2);
Qs.assets = UV.default;
Qs.chain = HV.default;
Qs.ibc = LV.default;
var ea = {}, M2 = {};
Object.defineProperty(M2, "__esModule", { value: !0 });
const WV = {
  $schema: "../assetlist.schema.json",
  chain_name: "stafihub",
  assets: [
    {
      description: "The native staking and governance token of the StaFi Hub.",
      denom_units: [{
        denom: "ufis",
        exponent: 0
      }, {
        denom: "fis",
        exponent: 6
      }],
      base: "ufis",
      name: "FIS",
      display: "fis",
      symbol: "FIS",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/fis.svg"
      },
      coingecko_id: "stafi",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/fis.svg"
      }]
    },
    {
      description: "A liquid staking representation of staked ATOMs",
      denom_units: [{
        denom: "uratom",
        exponent: 0
      }, {
        denom: "ratom",
        exponent: 6
      }],
      base: "uratom",
      name: "rATOM",
      display: "ratom",
      symbol: "rATOM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        provider: "StaFiHub"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/ratom.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/ratom.svg"
      }]
    },
    {
      description: "A liquid staking representation of staked IRISs",
      denom_units: [{
        denom: "uriris",
        exponent: 0
      }, {
        denom: "riris",
        exponent: 6
      }],
      base: "uriris",
      name: "rIRIS",
      display: "riris",
      symbol: "rIRIS",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "irisnet",
          base_denom: "uiris"
        },
        provider: "StaFiHub"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/riris.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/riris.svg"
      }]
    },
    {
      description: "A liquid staking representation of staked HUAHUAs",
      denom_units: [{
        denom: "urhuahua",
        exponent: 0
      }, {
        denom: "rhuahua",
        exponent: 6
      }],
      base: "urhuahua",
      name: "rHUAHUA",
      display: "rhuahua",
      symbol: "rHUAHUA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "chihuahua",
          base_denom: "uhuahua"
        },
        provider: "StaFiHub"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/rhuahua.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/rhuahua.svg"
      }]
    },
    {
      description: "A liquid staking representation of staked SWTHs",
      denom_units: [{
        denom: "urswth",
        exponent: 0
      }, {
        denom: "rswth",
        exponent: 8
      }],
      base: "urswth",
      name: "rSWTH",
      display: "rswth",
      symbol: "rSWTH",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "carbon",
          base_denom: "swth"
        },
        provider: "StaFiHub"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/rswth.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/rswth.svg"
      }]
    }
  ]
};
M2.default = WV;
var I2 = {};
Object.defineProperty(I2, "__esModule", { value: !0 });
const VV = {
  $schema: "../chain.schema.json",
  chain_name: "stafihub",
  chain_type: "cosmos",
  chain_id: "stafihub-1",
  website: "https://stafihub.io/",
  pretty_name: "StaFi Hub",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "stafi",
  daemon_name: "stafihubd",
  node_home: "$HOME/.stafihub",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ufis",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ufis"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.46"
  },
  apis: {
    rpc: [
      {
        address: "https://public-rpc1.stafihub.io:443",
        provider: "StaFiHub"
      },
      {
        address: "https://public-rpc2.stafihub.io:443",
        provider: "StaFiHub"
      },
      {
        address: "https://rpc.stafihub.nodestake.top:443",
        provider: "NodeStake"
      }
    ],
    rest: [
      {
        address: "https://public-rest-rpc1.stafihub.io",
        provider: "StaFiHub"
      },
      {
        address: "https://public-rest-rpc2.stafihub.io",
        provider: "StaFiHub"
      },
      {
        address: "https://api.stafihub.nodestake.top",
        provider: "NodeStake"
      }
    ],
    grpc: [
      {
        address: "public-grpc-rpc1.stafihub.io:443",
        provider: "StaFiHub"
      },
      {
        address: "public-grpc-rpc2.stafihub.io:443",
        provider: "StaFiHub"
      },
      {
        address: "grpc.stafihub.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "stafihub.nodejumper.io:9090",
        provider: "NODEJUMPER"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/stafi",
      tx_page: "https://www.mintscan.io/stafi/transactions/${txHash}",
      account_page: "https://www.mintscan.io/stafi/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/stafihub",
      tx_page: "https://ezstaking.app/stafihub/txs/${txHash}",
      account_page: "https://ezstaking.app/stafihub/account/${accountAddress}"
    },
    {
      kind: "ping-pub",
      url: "https://ping.pub/stafihub",
      tx_page: "https://ping.pub/stafihub/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/stafihub",
      tx_page: "https://atomscan.com/stafihub/transactions/${txHash}",
      account_page: "https://atomscan.com/stafihub/accounts/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/stafihub-chain-logo.png"
  },
  keywords: ["liquid staking"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stafihub/images/stafihub-chain-logo.png",
    theme: {
      primary_color_hex: "#100d10"
    }
  }]
};
I2.default = VV;
var N2 = {};
Object.defineProperty(N2, "__esModule", { value: !0 });
const GV = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "chihuahua",
      client_id: "07-tendermint-86",
      connection_id: "connection-55"
    },
    chain_2: {
      chain_name: "stafihub",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-892",
      connection_id: "connection-618"
    },
    chain_2: {
      chain_name: "stafihub",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-369",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-63",
      connection_id: "connection-44"
    },
    chain_2: {
      chain_name: "stafihub",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-96",
      connection_id: "connection-68"
    },
    chain_2: {
      chain_name: "stafihub",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2969",
      connection_id: "connection-2465"
    },
    chain_2: {
      chain_name: "stafihub",
      client_id: "07-tendermint-7",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5413",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "stafihub",
      client_id: "07-tendermint-5",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-317",
      connection_id: "connection-233"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-204",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
N2.default = GV;
var P2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ea, "__esModule", { value: !0 });
ea.ibc = ea.chain = ea.assets = void 0;
const KV = P2(M2), XV = P2(I2), YV = P2(N2);
ea.assets = KV.default;
ea.chain = XV.default;
ea.ibc = YV.default;
var na = {}, U2 = {};
Object.defineProperty(U2, "__esModule", { value: !0 });
const JV = {
  $schema: "../assetlist.schema.json",
  chain_name: "stargaze",
  assets: [
    {
      description: "Stargaze is a decentralized blockchain platform designed specifically for non-fungible tokens (NFTs), enabling creators to mint, trade, and interact with NFTs in a fully decentralized environment.",
      extended_description: "Stargaze is an innovative platform in the Cosmos ecosystem focused on NFTs. It provides a decentralized space where creators can mint, trade, and manage their NFTs with ease. The platform's decentralized nature ensures that creators retain full control over their digital assets, enhancing security and ownership rights. Stargaze's user-friendly interface and robust infrastructure make it an ideal choice for artists and collectors looking to engage with NFTs in a decentralized manner.",
      denom_units: [{
        denom: "ustars",
        exponent: 0
      }, {
        denom: "stars",
        exponent: 6
      }],
      base: "ustars",
      name: "Stargaze",
      display: "stars",
      symbol: "STARS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg"
      },
      coingecko_id: "stargaze",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg",
        theme: {
          primary_color_hex: "#db2777"
        }
      }],
      socials: {
        website: "https://www.stargaze.zone/",
        twitter: "https://twitter.com/StargazeZone"
      }
    },
    {
      description: "The native token of ohhNFT.",
      denom_units: [{
        denom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/dust",
        exponent: 0
      }, {
        denom: "strdst",
        exponent: 6
      }],
      base: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/dust",
      name: "Stardust STRDST",
      display: "strdst",
      symbol: "STRDST",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.svg",
        theme: {
          primary_color_hex: "#c9720c"
        }
      }]
    },
    {
      description: "The native meme token of stargaze.",
      denom_units: [{
        denom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/mGAZE",
        exponent: 0
      }, {
        denom: "GAZE",
        exponent: 6
      }],
      base: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/mGAZE",
      name: "Gaze GAZE",
      display: "GAZE",
      symbol: "GAZE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/gaze.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/gaze.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/gaze.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/gaze.svg",
        theme: {
          primary_color_hex: "#b3a584"
        }
      }]
    },
    {
      description: "ohhNFT LP token.",
      denom_units: [{
        denom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uBRNCH",
        exponent: 0
      }, {
        denom: "BRNCH",
        exponent: 6
      }],
      base: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uBRNCH",
      name: "Branch",
      display: "BRNCH",
      symbol: "BRNCH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.svg",
        theme: {
          primary_color_hex: "#70372a"
        }
      }]
    },
    {
      description: "Social token for the ohhVAULT.",
      denom_units: [{
        denom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uOHH",
        exponent: 0
      }, {
        denom: "OHH",
        exponent: 6
      }],
      base: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uOHH",
      name: "ohhVAULT ohh",
      display: "OHH",
      symbol: "OHH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/ohh.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/ohh.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/ohh.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/ohh.svg",
        theme: {
          primary_color_hex: "#dcc0c2"
        }
      }]
    },
    {
      description: "The native coin of Sneaky Productions.",
      denom_units: [{
        denom: "factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky",
        exponent: 0
      }, {
        denom: "sneaky",
        exponent: 6
      }],
      base: "factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky",
      name: "Sneaky Productions",
      display: "sneaky",
      symbol: "SNEAKY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.svg",
        theme: {
          primary_color_hex: "#fbcaca"
        }
      }]
    },
    {
      description: "LAB - Everything is an Experiment",
      extended_description: `LAB - Everything is an Experiment

Use 10 $LAB tokens to mint 1 Mad Scientist NFT on Backbone Labs Osmosis Launchpad. You will then be able to trade your NFTs on the marketplace. You can also choose to hold onto your $LAB tokens as unrevealed NFTs and trade it.

 Fair Launch: The event was marked by the absence of whitelists (WLs), no bots and no lock, ensuring an equitable opportunity for all interested parties.

Preparation for the Launch: Participants were given a 52.91-hour window to deposit $OSMO into a pool on Streamswap.

The Swap Process: After the initial deposit period, $OSMO was converted into $LAB tokens over an additional hour, allowing for a smooth transition and fair distribution.`,
      denom_units: [{
        denom: "ibc/93B1AE0AD5E88242745B245064A2A51DDA1319C18176A966D5F8F9E02ED5373E",
        exponent: 0
      }, {
        denom: "LAB",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/93B1AE0AD5E88242745B245064A2A51DDA1319C18176A966D5F8F9E02ED5373E",
      name: "LAB",
      display: "LAB",
      symbol: "LAB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/LAB.png"
      },
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo17fel472lgzs87ekt9dvk0zqyh5gl80sqp4sk4n/LAB",
          channel_id: "channel-75"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/factory/osmo17fel472lgzs87ekt9dvk0zqyh5gl80sqp4sk4n/LAB"
        }
      }],
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/LAB.png",
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo17fel472lgzs87ekt9dvk0zqyh5gl80sqp4sk4n/LAB"
        },
        theme: {
          primary_color_hex: "#bcdd76"
        }
      }]
    },
    {
      description: "CDT - Membrane's solvency preserving stablecoin",
      denom_units: [{
        denom: "ibc/B0263C28B6F44651F4596413B41FDB749EA010BD1220816DAC0ABF9947C1E806",
        exponent: 0
      }, {
        denom: "CDT",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/B0263C28B6F44651F4596413B41FDB749EA010BD1220816DAC0ABF9947C1E806",
      name: "CDT",
      display: "CDT",
      symbol: "CDT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt",
          channel_id: "channel-75"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt"
        }
      }],
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CDT.svg",
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt"
        }
      }]
    },
    {
      description: "MBRN - Membrane's network token",
      denom_units: [{
        denom: "ibc/E94BB144B818CB8061F43E202BEA1E9273B87D6326C8C6F4E6AE71C62FD37854",
        exponent: 0
      }, {
        denom: "MBRN",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E94BB144B818CB8061F43E202BEA1E9273B87D6326C8C6F4E6AE71C62FD37854",
      name: "MBRN",
      display: "MBRN",
      symbol: "MBRN",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn",
          channel_id: "channel-75"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn"
        }
      }],
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/MBRN.svg",
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn"
        }
      }]
    },
    {
      description: "Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.",
      denom_units: [{
        denom: "ibc/C9C8D88917374F27F03CBCEAF4F1B85F45A62F9F2316CBAADAAC5FDB3675DD3F",
        exponent: 0,
        aliases: ["uastro"]
      }, {
        denom: "astro",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/C9C8D88917374F27F03CBCEAF4F1B85F45A62F9F2316CBAADAAC5FDB3675DD3F",
      name: "Astroport token",
      display: "astro",
      symbol: "ASTRO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro",
          channel_id: "channel-18"
        },
        chain: {
          channel_id: "channel-191",
          path: "transfer/channel-191/factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg"
      },
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg",
        theme: {
          primary_color_hex: "#4056e9"
        }
      }]
    },
    {
      description: "PLEB",
      denom_units: [{
        denom: "factory/stars1k7qsxdxh8calmt4txk75e6hdntefslegwddqnlwjjqgjkmcfqy0qa97sn8/pleb",
        exponent: 0
      }, {
        denom: "PLEB",
        exponent: 6
      }],
      base: "factory/stars1k7qsxdxh8calmt4txk75e6hdntefslegwddqnlwjjqgjkmcfqy0qa97sn8/pleb",
      name: "PLEB",
      display: "PLEB",
      symbol: "PLEB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/pleb.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/pleb.png"
      }]
    },
    {
      description: "KINGSHIT",
      denom_units: [{
        denom: "factory/stars133a6mnkp9d3pkt48y699hy0tvq5xngpz7cwak0qr4suq0cj9zpfslvt0em/kingshit",
        exponent: 0
      }, {
        denom: "KINGSHIT",
        exponent: 6
      }],
      base: "factory/stars133a6mnkp9d3pkt48y699hy0tvq5xngpz7cwak0qr4suq0cj9zpfslvt0em/kingshit",
      name: "KINGSHIT",
      display: "KINGSHIT",
      symbol: "KINGSHIT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/kingshit.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/kingshit.png"
      }]
    },
    {
      description: "BOTZ",
      denom_units: [{
        denom: "factory/stars132jrwxjps93usq3ejy7cq6qqc7j3gtx3mu8jhaj5nnk3p0ste2ssqsndvj/botz",
        exponent: 0
      }, {
        denom: "BOTZ",
        exponent: 6
      }],
      base: "factory/stars132jrwxjps93usq3ejy7cq6qqc7j3gtx3mu8jhaj5nnk3p0ste2ssqsndvj/botz",
      name: "BOTZ",
      display: "BOTZ",
      symbol: "BOTZ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/botz.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/botz.png"
      }]
    },
    {
      description: "COCKS",
      denom_units: [{
        denom: "factory/stars14mfk0sd6rlajkvgpgrvfk9lfhjwmkrzvednekvcn32jzy3drjy5sfem9p7/cocks",
        exponent: 0
      }, {
        denom: "COCKS",
        exponent: 6
      }],
      base: "factory/stars14mfk0sd6rlajkvgpgrvfk9lfhjwmkrzvednekvcn32jzy3drjy5sfem9p7/cocks",
      name: "COCKS",
      display: "COCKS",
      symbol: "COCKS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/cocks.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/cocks.png"
      }]
    },
    {
      description: "The Representative factory token for Trump Kemistry",
      denom_units: [{
        denom: "ibc/4982C47384F003FCCB02490F92CE2F23DBEC9A7A0C1F440BDB12D24357E6703D",
        exponent: 0
      }, {
        denom: "XTRUMP",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4982C47384F003FCCB02490F92CE2F23DBEC9A7A0C1F440BDB12D24357E6703D",
      name: "XTRUMP",
      display: "XTRUMP",
      symbol: "XTRUMP",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP",
          channel_id: "channel-75"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/XTRUMP.png",
        theme: {
          primary_color_hex: "#b02b27"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/XTRUMP.png"
      }
    },
    {
      description: "WOLFSHIT",
      denom_units: [{
        denom: "factory/stars167y92c2fe690l0lrqyk9tahpqvu97au0cmpayh3j9455r2f6f06s78emw4/wolfshit",
        exponent: 0
      }, {
        denom: "WOLFSHIT",
        exponent: 6
      }],
      base: "factory/stars167y92c2fe690l0lrqyk9tahpqvu97au0cmpayh3j9455r2f6f06s78emw4/wolfshit",
      name: "WOLFSHIT",
      display: "WOLFSHIT",
      symbol: "WOLFSHIT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/wolfshit.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/wolfshit.png"
      }]
    },
    {
      description: "Native token of the Underworld.",
      denom_units: [{
        denom: "factory/stars1t6fyr84hn6lyjdvk3e3c697cptfn5cwat2jxqyzuvuesaypznslshy6x9v/vlt",
        exponent: 0
      }, {
        denom: "VLT",
        exponent: 6
      }],
      base: "factory/stars1t6fyr84hn6lyjdvk3e3c697cptfn5cwat2jxqyzuvuesaypznslshy6x9v/vlt",
      name: "VLT",
      display: "VLT",
      symbol: "VAULT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/vault.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/vault.png"
      }]
    }
  ]
};
U2.default = JV;
var H2 = {};
Object.defineProperty(H2, "__esModule", { value: !0 });
const ZV = {
  $schema: "../chain.schema.json",
  chain_name: "stargaze",
  status: "live",
  network_type: "mainnet",
  website: "https://stargaze.zone/",
  pretty_name: "Stargaze",
  chain_type: "cosmos",
  chain_id: "stargaze-1",
  bech32_prefix: "stars",
  daemon_name: "starsd",
  node_home: "$HOME/.starsd",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ustars",
      fixed_min_gas_price: 1,
      low_gas_price: 1,
      average_gas_price: 1.1,
      high_gas_price: 1.2
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ustars"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.12",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.45.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg"
  },
  description: "The premier community-focused blockchain for NFTs. Stargaze empowers creators, developers, collectors, and traders to participate on the platform. The Stargaze chain consists of various NFT-related apps such as a Launchpad, and a Marketplace with offers and auctions.",
  apis: {
    rpc: [
      {
        address: "https://rpc.stargaze-apis.com/",
        provider: "Stargaze Foundation"
      },
      {
        address: "https://rpc-stargaze.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://rpc-stargaze.ezstaking.dev",
        provider: "EZStaking.io"
      },
      {
        address: "https://stargaze-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-stargaze-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://stargaze.c29r3.xyz:443/rpc/",
        provider: "c29r3"
      },
      {
        address: "https://rpc-stargaze.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://stargaze-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://rpc-stargaze.d-stake.xyz",
        provider: "D-stake"
      },
      {
        address: "https://rpc.stargaze.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://stargaze-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://stargaze-rpc.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://stargaze-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://stargaze-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://stargaze-rpc.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://stargaze-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://stargaze-rpc.reece.sh:443",
        provider: "Reecepbcups"
      },
      {
        address: "https://rpc.stargaze.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://stargaze-rpc.kleomedes.network",
        provider: "Kleomedes"
      }
    ],
    rest: [
      {
        address: "https://rest.stargaze-apis.com/",
        provider: "Stargaze Foundation"
      },
      {
        address: "https://api-stargaze.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://api-stargaze.ezstaking.dev",
        provider: "EZStaking.io"
      },
      {
        address: "https://api-stargaze-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://stargaze.c29r3.xyz:443/api/",
        provider: "c29r3"
      },
      {
        address: "https://stargaze-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://stargaze-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://api-stargaze.d-stake.xyz",
        provider: "D-stake"
      },
      {
        address: "https://api-stargaze.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://api.stargaze.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://stargaze-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://stargaze-api.ramuchi.tech",
        provider: "ramuchi.tech"
      },
      {
        address: "https://stargaze-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://stargaze-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://stargaze-rest.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://stargaze-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://stargaze-api.reece.sh:443",
        provider: "Reecepbcups"
      },
      {
        address: "https://lcd.stargaze.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://stargaze-api.kleomedes.network",
        provider: "Kleomedes"
      }
    ],
    grpc: [
      {
        address: "grpc-stargaze-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "stargaze-grpc.polkachu.com:13790",
        provider: "Polkachu"
      },
      {
        address: "stargaze-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc-stargaze.cosmos-spaces.cloud:1150",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://stargaze-grpc.ramuchi.tech:9090",
        provider: "ramuchi.tech"
      },
      {
        address: "services.staketab.com:9092",
        provider: "Staketab"
      },
      {
        address: "stargaze-grpc.w3coins.io:13790",
        provider: "w3coins"
      },
      {
        address: "stargaze-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "stargaze-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "https://grpc.stargaze.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/stargaze",
      tx_page: "https://ezstaking.app/stargaze/txs/${txHash}",
      account_page: "https://ezstaking.app/stargaze/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/stargaze/",
      tx_page: "https://www.mintscan.io/stargaze/transactions/${txHash}",
      account_page: "https://www.mintscan.io/stargaze/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/stargaze",
      tx_page: "https://ping.pub/stargaze/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/stargaze",
      tx_page: "https://atomscan.com/stargaze/transactions/${txHash}",
      account_page: "https://atomscan.com/stargaze/accounts/${accountAddress}"
    },
    {
      kind: "Starscan",
      url: "https://starscan.net/",
      tx_page: "https://starscan.net/stargaze-1/tx/${txHash}",
      account_page: "https://starscan.net/stargaze-1/address/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/stargaze",
      tx_page: "https://mainnet.whispernode.com/stargaze/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/stargaze/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg",
    theme: {
      primary_color_hex: "#db2777"
    }
  }]
};
H2.default = ZV;
var L2 = {};
Object.defineProperty(L2, "__esModule", { value: !0 });
const QV = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-3",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-222",
      connection_id: "connection-156"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-121",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "aura",
      client_id: "07-tendermint-48",
      connection_id: "connection-47"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-339",
      connection_id: "connection-288"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-270",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-24",
        port_id: "wasm.aura1y3244guwexyvn6yx6kqkj5s0f56lzfdnuja3culygnuwxgrxyuqsaz4xvv"
      },
      chain_2: {
        channel_id: "channel-271",
        port_id: "wasm.stars1r0a8ygvnjfaegy4n5z9325e0ew9uy2s7rn4vt7qf4ltv49fj4tnsk6pvtv"
      },
      ordering: "unordered",
      version: "ics721-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-36",
      connection_id: "connection-19"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-224",
      connection_id: "connection-158"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-123",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-86",
      connection_id: "connection-56"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-359",
      connection_id: "connection-296"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-291",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-25",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-279",
      connection_id: "connection-207"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-184",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-1188",
      connection_id: "connection-918"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-320",
      connection_id: "connection-256"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-730",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-239",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-24",
      connection_id: "connection-27"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-180",
      connection_id: "connection-114"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-41",
      connection_id: "connection-17"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-173",
      connection_id: "connection-104"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "gateway",
      client_id: "07-tendermint-16",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-354",
      connection_id: "connection-290"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-278",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-44",
      connection_id: "connection-30"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-13",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-9",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-178",
      connection_id: "connection-111"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-118",
      connection_id: "connection-90"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-352",
      connection_id: "connection-287"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-69",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-269",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-31",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-283",
      connection_id: "connection-211"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-18",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-191",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-16",
      connection_id: "connection-25"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-287",
      connection_id: "connection-214"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-204",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "nois",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-237",
      connection_id: "connection-171"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-137",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-238",
        port_id: "wasm.stars1mw5y55f53mnara7g3pn2pylxl8dpauscyn83c68442hz9nwktzrq8tjzyf"
      },
      chain_2: {
        channel_id: "channel-38",
        port_id: "wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1562",
      connection_id: "connection-1223"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-75",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-39535",
        port_id: "wasm.osmo10vzkd8pyme67z38epdr3gf027y03dxq7t8vau5fp3r28vxks7mwse02j8f"
      },
      chain_2: {
        channel_id: "channel-309",
        port_id: "wasm.stars1r0a8ygvnjfaegy4n5z9325e0ew9uy2s7rn4vt7qf4ltv49fj4tnsk6pvtv"
      },
      ordering: "unordered",
      version: "ics721-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-166",
      connection_id: "connection-207"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-358",
      connection_id: "connection-293"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-197",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-287",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-225",
      connection_id: "connection-159"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-124",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-43",
      connection_id: "connection-25"
    },
    chain_2: {
      chain_name: "stargaze",
      client_id: "07-tendermint-177",
      connection_id: "connection-110"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-48",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "stargaze",
      client_id: "07-tendermint-195",
      connection_id: "connection-128"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-30",
      connection_id: "connection-18"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-106",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "stargaze",
      client_id: "07-tendermint-337",
      connection_id: "connection-275"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-405",
      connection_id: "connection-408"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-266",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-324",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
L2.default = QV;
var W2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(na, "__esModule", { value: !0 });
na.ibc = na.chain = na.assets = void 0;
const eG = W2(U2), nG = W2(H2), tG = W2(L2);
na.assets = eG.default;
na.chain = nG.default;
na.ibc = tG.default;
var ta = {}, V2 = {};
Object.defineProperty(V2, "__esModule", { value: !0 });
const sG = {
  $schema: "../assetlist.schema.json",
  chain_name: "starname",
  assets: [{
    description: "IOV coin is the token for the Starname (IOV) Asset Name Service",
    denom_units: [{
      denom: "uiov",
      exponent: 0
    }, {
      denom: "iov",
      exponent: 6
    }],
    base: "uiov",
    name: "Starname",
    display: "iov",
    symbol: "IOV",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.svg"
    },
    coingecko_id: "starname",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.svg",
      theme: {
        primary_color_hex: "#5c64b4"
      }
    }],
    socials: {
      website: "https://app.starname.me/",
      twitter: "https://twitter.com/starname_me"
    }
  }]
};
V2.default = sG;
var G2 = {};
Object.defineProperty(G2, "__esModule", { value: !0 });
const aG = {
  $schema: "../chain.schema.json",
  chain_name: "starname",
  status: "live",
  network_type: "mainnet",
  website: "https://www.starname.me/",
  pretty_name: "Starname",
  chain_type: "cosmos",
  chain_id: "iov-mainnet-ibc",
  bech32_prefix: "star",
  slip44: 234,
  alternative_slip44s: [118],
  fees: {
    fee_tokens: [{
      denom: "uiov",
      low_gas_price: 1,
      average_gas_price: 2,
      high_gas_price: 3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uiov"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.svg"
  },
  description: "Starname is the best way to claim your part of the blockchain. You can use it for decentralized identification, payments, ownership and applications. Starname can be integrated into digital wallets, dapps and exchanges.",
  apis: {
    rpc: [{
      address: "https://rpc-starname-ia.cosmosia.notional.ventures/",
      provider: "Notional"
    }, {
      address: "https://rpc.starname.app",
      provider: "Chainmasters"
    }],
    rest: [{
      address: "https://api-starname-ia.cosmosia.notional.ventures/",
      provider: "Notional"
    }, {
      address: "https://rest.starname.app",
      provider: "Chainmasters"
    }],
    grpc: [{
      address: "grpc-starname-ia.cosmosia.notional.ventures:443",
      provider: "starname"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://ping.pub/starname",
    tx_page: "https://ping.pub/starname/tx/${txHash}"
  }, {
    kind: "atomscan",
    url: "https://atomscan.com/starname",
    tx_page: "https://atomscan.com/starname/transactions/${txHash}",
    account_page: "https://atomscan.com/starname/accounts/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/starname/images/iov.svg",
    theme: {
      primary_color_hex: "#5c64b4"
    }
  }]
};
G2.default = aG;
var K2 = {};
Object.defineProperty(K2, "__esModule", { value: !0 });
const oG = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-59",
      connection_id: "connection-35"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-29",
      connection_id: "connection-18"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-326",
      connection_id: "connection-300"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-158",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cryptoorgchain",
      client_id: "07-tendermint-66",
      connection_id: "connection-39"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-16",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "irisnet",
      client_id: "07-tendermint-44",
      connection_id: "connection-32"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-41",
      connection_id: "connection-27"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-21",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-71",
      connection_id: "connection-42"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-9",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-39",
      connection_id: "connection-39"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-44",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "regen",
      client_id: "07-tendermint-74",
      connection_id: "connection-61"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-45",
      connection_id: "connection-31"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-14",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "sentinel",
      client_id: "07-tendermint-88",
      connection_id: "connection-70"
    },
    chain_2: {
      chain_name: "starname",
      client_id: "07-tendermint-46",
      connection_id: "connection-32"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-40",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  }
];
K2.default = oG;
var X2 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ta, "__esModule", { value: !0 });
ta.ibc = ta.chain = ta.assets = void 0;
const rG = X2(V2), iG = X2(G2), cG = X2(K2);
ta.assets = rG.default;
ta.chain = iG.default;
ta.ibc = cG.default;
var xr = {}, Y2 = {};
Object.defineProperty(Y2, "__esModule", { value: !0 });
const dG = {
  $schema: "../assetlist.schema.json",
  chain_name: "stratos",
  assets: [{
    description: "STOS coin is the token for the Stratos (STOS) cosmos based blockchain",
    denom_units: [
      {
        denom: "wei",
        exponent: 0
      },
      {
        denom: "gwei",
        exponent: 9
      },
      {
        denom: "stos",
        exponent: 18
      }
    ],
    base: "wei",
    name: "Stratos",
    display: "stos",
    symbol: "STOS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stratos/images/stratos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stratos/images/stratos.svg"
    },
    coingecko_id: "stratos",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stratos/images/stratos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stratos/images/stratos.svg",
      theme: {
        primary_color_hex: "#04847c"
      }
    }]
  }]
};
Y2.default = dG;
var J2 = {};
Object.defineProperty(J2, "__esModule", { value: !0 });
const mG = {
  $schema: "../chain.schema.json",
  chain_name: "stratos",
  status: "live",
  network_type: "mainnet",
  website: "https://www.thestratos.org",
  pretty_name: "Stratos",
  chain_type: "cosmos",
  chain_id: "stratos-1",
  bech32_prefix: "st",
  daemon_name: "stchaind",
  node_home: "$HOME/.stchaind",
  key_algos: ["ethsecp256k1"],
  extra_codecs: [],
  slip44: 606,
  fees: {
    fee_tokens: [{
      denom: "wei"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stratos/images/stratos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stratos/images/stratos.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.thestratos.org",
        provider: "thestratos.org"
      },
      {
        address: "http://stratos.rpc.nodersteam.com:26657/",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://stratos-rpc.noders.services:443",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [{
      address: "https://rest.thestratos.org",
      provider: "thestratos.org"
    }, {
      address: "https://stratos-api.noders.services:443",
      provider: "[NODERS]TEAM"
    }],
    grpc: [
      {
        address: "https://grpc.thestratos.org",
        provider: "thestratos.org"
      },
      {
        address: "https://grpc.stratos.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "stratos.grpc.nodersteam.com:9090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "stratos-grpc.noders.services:29090",
        provider: "[NODERS]TEAM"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://web3-rpc.thestratos.org",
        provider: "thestratos.org"
      },
      {
        address: "https://jsonrpc.stratos.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://stratos-jsonrpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "bigdipper",
      url: "https://explorer.thestratos.org",
      tx_page: "https://explorer.thestratos.org/transactions/${txHash}",
      account_page: "https://explorer.thestratos.org/accounts/${accountAddress}"
    },
    {
      kind: "blockscout",
      url: "https://web3-explorer.thestratos.org",
      tx_page: "https://web3-explorer.thestratos.org/tx/${txHash}",
      account_page: "https://web3-explorer.thestratos.org/address/${accountAddress}"
    },
    {
      kind: "NodeStake",
      url: "https://explorer.nodestake.top/stratos",
      tx_page: "https://explorer.nodestake.top/stratos/tx/${txHash}",
      account_page: "https://explorer.nodestake.top/stratos/accounts/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/stratos",
      tx_page: "https://explorer.tcnetwork.io/stratos/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/stratos/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stratos/images/stratos.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stratos/images/stratos.svg",
    theme: {
      primary_color_hex: "#04847c"
    }
  }]
};
J2.default = mG;
var K9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(xr, "__esModule", { value: !0 });
xr.chain = xr.assets = void 0;
const hG = K9(Y2), pG = K9(J2);
xr.assets = hG.default;
xr.chain = pG.default;
var sa = {}, Z2 = {};
Object.defineProperty(Z2, "__esModule", { value: !0 });
const lG = {
  $schema: "../assetlist.schema.json",
  chain_name: "stride",
  assets: [
    {
      description: "Stride is a liquid staking blockchain in the Cosmos ecosystem that allows users to stake any IBC-compatible tokens and receive stTokens in return, providing liquidity while earning staking rewards.",
      extended_description: `Stride is a blockchain ("zone") that provides liquidity for staked tokens within the Cosmos ecosystem. Users can liquid stake their tokens from any Cosmos chain using Stride, earning staking and DeFi yields across the Cosmos IBC ecosystem. When users stake their tokens with Stride, they receive stTokens, which can be traded or redeemed at any time. Stride's liquid staking derivatives allow users to retain liquidity while earning staking rewards, supporting various IBC-compatible chains and promoting broader DeFi participation. The native token, STRD, is used for governance and securing the network.`,
      denom_units: [{
        denom: "ustrd",
        exponent: 0
      }, {
        denom: "strd",
        exponent: 6
      }],
      base: "ustrd",
      name: "Stride",
      display: "strd",
      symbol: "STRD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg"
      },
      coingecko_id: "stride",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg",
        theme: {
          primary_color_hex: "#e4047c"
        }
      }],
      socials: {
        website: "https://stride.zone/",
        twitter: "https://twitter.com/stride_zone"
      }
    },
    {
      denom_units: [{
        denom: "stuatom",
        exponent: 0
      }, {
        denom: "statom",
        exponent: 6
      }],
      base: "stuatom",
      name: "Stride Staked ATOM",
      display: "statom",
      symbol: "stATOM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg"
      },
      coingecko_id: "stride-staked-atom",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/statom.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "stustars",
        exponent: 0
      }, {
        denom: "ststars",
        exponent: 6
      }],
      base: "stustars",
      name: "Stride Staked STARS",
      display: "ststars",
      symbol: "stSTARS",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "stargaze",
          base_denom: "ustars"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/ststars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/ststars.svg"
      },
      coingecko_id: "stride-staked-stars",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/ststars.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/ststars.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "stuosmo",
        exponent: 0
      }, {
        denom: "stosmo",
        exponent: 6
      }],
      base: "stuosmo",
      name: "Stride Staked OSMO",
      display: "stosmo",
      symbol: "stOSMO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg"
      },
      coingecko_id: "stride-staked-osmo",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stosmo.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "stujuno",
        exponent: 0
      }, {
        denom: "stjuno",
        exponent: 6
      }],
      base: "stujuno",
      name: "Stride Staked JUNO",
      display: "stjuno",
      symbol: "stJUNO",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "juno",
          base_denom: "ujuno"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stjuno.svg"
      },
      coingecko_id: "stride-staked-juno",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stjuno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stjuno.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "stuluna",
        exponent: 0
      }, {
        denom: "stluna",
        exponent: 6
      }],
      base: "stuluna",
      name: "Stride Staked LUNA",
      display: "stluna",
      symbol: "stLUNA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "terra2",
          base_denom: "uluna"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stluna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stluna.svg"
      },
      coingecko_id: "stride-staked-luna",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stluna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stluna.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "stinj",
        exponent: 0
      }, {
        denom: "stINJ",
        exponent: 18
      }],
      base: "stinj",
      name: "Stride Staked INJ",
      display: "stINJ",
      symbol: "stINJ",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "injective",
          base_denom: "inj"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stinj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stinj.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stinj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stinj.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "staevmos",
        exponent: 0
      }, {
        denom: "stevmos",
        exponent: 18
      }],
      base: "staevmos",
      name: "Stride Staked EVMOS",
      display: "stevmos",
      symbol: "stEVMOS",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "evmos",
          base_denom: "aevmos"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stevmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stevmos.svg"
      },
      coingecko_id: "stride-staked-evmos",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stevmos.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stevmos.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Stride's liquid staked DYDX",
      denom_units: [{
        denom: "stadydx",
        exponent: 0
      }, {
        denom: "stDYDX",
        exponent: 18
      }],
      base: "stadydx",
      name: "Stride Staked DYDX",
      display: "stDYDX",
      symbol: "stDYDX",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "dydx",
          base_denom: "adydx"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdydx.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Stride's liquid staked TIA",
      denom_units: [{
        denom: "stutia",
        exponent: 0
      }, {
        denom: "stTIA",
        exponent: 6
      }],
      base: "stutia",
      name: "Stride Staked TIA",
      display: "stTIA",
      symbol: "stTIA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "celestia",
          base_denom: "utia"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/sttia.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Stride's liquid staked DYM",
      denom_units: [{
        denom: "stadym",
        exponent: 0
      }, {
        denom: "stDYM",
        exponent: 18
      }],
      base: "stadym",
      name: "Stride Staked DYM",
      display: "stDYM",
      symbol: "stDYM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "dymension",
          base_denom: "adym"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdym.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdym.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdym.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stdym.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "stuumee",
        exponent: 0
      }, {
        denom: "stumee",
        exponent: 6
      }],
      base: "stuumee",
      name: "Stride Staked UMEE",
      display: "stumee",
      symbol: "stUMEE",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "umee",
          base_denom: "uumee"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stumee.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stumee.svg"
      },
      coingecko_id: "stride-staked-umee",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stumee.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stumee.svg",
        theme: {
          primary_color_hex: "#fbd9e9"
        }
      }]
    },
    {
      denom_units: [{
        denom: "stucmdx",
        exponent: 0
      }, {
        denom: "stcmdx",
        exponent: 6
      }],
      base: "stucmdx",
      name: "Stride Staked CMDX",
      display: "stcmdx",
      symbol: "stCMDX",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "comdex",
          base_denom: "ucmdx"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stcmdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stcmdx.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stcmdx.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stcmdx.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "stusomm",
        exponent: 0
      }, {
        denom: "stsomm",
        exponent: 6
      }],
      base: "stusomm",
      name: "Stride Staked SOMM",
      display: "stsomm",
      symbol: "stSOMM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "sommelier",
          base_denom: "usomm"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsomm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsomm.svg"
      },
      coingecko_id: "stride-staked-sommelier",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsomm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsomm.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "Stride's liquid staked SAGA",
      denom_units: [{
        denom: "stusaga",
        exponent: 0
      }, {
        denom: "stSAGA",
        exponent: 6
      }],
      base: "stusaga",
      name: "Stride Staked SAGA",
      display: "stSAGA",
      symbol: "stSAGA",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "saga",
          base_denom: "usaga"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsaga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsaga.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsaga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stsaga.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      description: "The native token of Celestia",
      denom_units: [{
        denom: "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
        exponent: 0,
        aliases: ["utia"]
      }, {
        denom: "TIA",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
      name: "Celestia",
      display: "TIA",
      symbol: "TIA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "celestia",
          base_denom: "utia",
          channel_id: "channel-4"
        },
        chain: {
          channel_id: "channel-162",
          path: "transfer/channel-162/utia"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg"
      },
      images: [{
        image_sync: {
          chain_name: "celestia",
          base_denom: "utia"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/celestia/images/celestia.svg",
        theme: {
          primary_color_hex: "#7c2cfb"
        }
      }]
    },
    {
      denom_units: [{
        denom: "staISLM",
        exponent: 0
      }, {
        denom: "stISLM",
        exponent: 18
      }],
      base: "staISLM",
      name: "Stride Staked ISLM",
      display: "stISLM",
      symbol: "stISLM",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "haqq",
          base_denom: "aISLM"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stislm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stislm.svg"
      },
      coingecko_id: "stride-staked-islm",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stislm.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stislm.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    },
    {
      denom_units: [{
        denom: "stuband",
        exponent: 0
      }, {
        denom: "stBAND",
        exponent: 6
      }],
      base: "stuband",
      name: "Stride Staked BAND",
      display: "stBAND",
      symbol: "stBAND",
      traces: [{
        type: "liquid-stake",
        counterparty: {
          chain_name: "bandchain",
          base_denom: "uband"
        },
        provider: "Stride"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stband.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stband.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stband.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/stband.svg",
        theme: {
          primary_color_hex: "#e40474"
        }
      }]
    }
  ]
};
Z2.default = lG;
var Q2 = {};
Object.defineProperty(Q2, "__esModule", { value: !0 });
const gG = {
  $schema: "../chain.schema.json",
  chain_name: "stride",
  status: "live",
  network_type: "mainnet",
  website: "https://stride.zone/",
  pretty_name: "Stride",
  chain_type: "cosmos",
  chain_id: "stride-1",
  bech32_prefix: "stride",
  daemon_name: "strided",
  node_home: "$HOME/.stride",
  key_algos: ["ed25519"],
  slip44: 118,
  fees: {
    fee_tokens: [
      {
        denom: "ustrd",
        fixed_min_gas_price: 5e-4,
        low_gas_price: 5e-3,
        average_gas_price: 5e-3,
        high_gas_price: 0.05
      },
      {
        denom: "stuatom",
        fixed_min_gas_price: 1e-4,
        low_gas_price: 1e-4,
        average_gas_price: 2e-4,
        high_gas_price: 5e-4
      },
      {
        denom: "stuosmo",
        fixed_min_gas_price: 1e-3,
        low_gas_price: 1e-3,
        average_gas_price: 2e-3,
        high_gas_price: 4e-3
      },
      {
        denom: "stustars",
        fixed_min_gas_price: 1,
        low_gas_price: 1,
        average_gas_price: 1.1,
        high_gas_price: 1.2
      },
      {
        denom: "stujuno",
        fixed_min_gas_price: 0.075,
        low_gas_price: 0.075,
        average_gas_price: 0.1,
        high_gas_price: 0.125
      },
      {
        denom: "stuluna",
        fixed_min_gas_price: 0.0125,
        low_gas_price: 0.0125,
        average_gas_price: 0.015,
        high_gas_price: 0.04
      },
      {
        denom: "staevmos",
        fixed_min_gas_price: 25e7,
        low_gas_price: 2e10,
        average_gas_price: 25e9,
        high_gas_price: 4e10
      },
      {
        denom: "stinj",
        fixed_min_gas_price: 5e8,
        low_gas_price: 5e8,
        average_gas_price: 7e8,
        high_gas_price: 9e8
      },
      {
        denom: "stucmdx",
        fixed_min_gas_price: 0.02,
        low_gas_price: 0.02,
        average_gas_price: 0.025,
        high_gas_price: 0.04
      },
      {
        denom: "stuumee",
        fixed_min_gas_price: 0.1,
        low_gas_price: 0.1,
        average_gas_price: 0.12,
        high_gas_price: 0.2
      },
      {
        denom: "stutia",
        fixed_min_gas_price: 2e-3,
        low_gas_price: 0.01,
        average_gas_price: 0.02,
        high_gas_price: 0.1
      },
      {
        denom: "stadydx",
        fixed_min_gas_price: 15e9,
        low_gas_price: 15e9,
        average_gas_price: 15e9,
        high_gas_price: 2e10
      },
      {
        denom: "stadym",
        fixed_min_gas_price: 15e9,
        low_gas_price: 15e9,
        average_gas_price: 15e9,
        high_gas_price: 2e10
      },
      {
        denom: "stusaga",
        fixed_min_gas_price: 0.01,
        low_gas_price: 0.01,
        average_gas_price: 0.015,
        high_gas_price: 0.03
      },
      {
        denom: "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
        fixed_min_gas_price: 2e-3,
        low_gas_price: 0.01,
        average_gas_price: 0.02,
        high_gas_price: 0.1
      }
    ]
  },
  staking: {
    staking_tokens: [{
      denom: "ustrd"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.10-stride-distribution-fix-0-mempool-verbose-error-1"
  },
  description: "Stride is a blockchain that provides liquidity for staked tokens. Using Stride, you can earn both taking and DeFi yields across the Cosmos IBC ecosystem.",
  apis: {
    rpc: [
      {
        address: "https://stride-rpc.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://stride-rpc.onivalidator.com",
        provider: "Oni Validator ⛩️"
      },
      {
        address: "https://rpc.lavenderfive.com:443/stride",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc.stride.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://rpc-stride.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://stride.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://rpc-stride.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://rpc-stride.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://rpc-stride.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://stride-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc-stride-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://stride-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://stride-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://community.nuxian-node.ch:6797/stride/trpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://stride-rpc.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://rpc.stride.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://public.stakewolle.com/cosmos/stride/rpc",
        provider: "Stakewolle"
      }
    ],
    rest: [
      {
        address: "https://stride-api.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://api-stride.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://rest.lavenderfive.com:443/stride",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api.stride.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://stride.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://api-stride.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://stride-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest-stride.architectnodes.com",
        provider: "Architect Nodes"
      },
      {
        address: "https://lcd-stride.whispernode.com:443",
        provider: "WhisperNode 🤐"
      },
      {
        address: "https://api-stride-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://stride-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://stride-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://community.nuxian-node.ch:6797/stride/crpc",
        provider: "PRO Delegators"
      },
      {
        address: "https://stride-api.stakeandrelax.net",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://lcd.stride.bronbro.io:443",
        provider: "Bro_n_Bro"
      },
      {
        address: "https://public.stakewolle.com/cosmos/stride/rest",
        provider: "Stakewolle"
      }
    ],
    grpc: [
      {
        address: "stride.grpc.bccnodes.com:443",
        provider: "BccNodes"
      },
      {
        address: "stride-grpc.polkachu.com:12290",
        provider: "Polkachu"
      },
      {
        address: "stride.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "http://stride.grpc.m.stavr.tech:9986",
        provider: "🔥STAVR🔥"
      },
      {
        address: "grpc-stride.cosmos-spaces.cloud:1140",
        provider: "Cosmos Spaces"
      },
      {
        address: "stride-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "stride.grpc.kjnodes.com:11690",
        provider: "kjnodes"
      },
      {
        address: "grpc-stride-01.stakeflow.io:1802",
        provider: "Stakeflow"
      },
      {
        address: "stride-grpc.w3coins.io:12290",
        provider: "w3coins"
      },
      {
        address: "stride-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "stride-grpc.stakeandrelax.net:12290",
        provider: "Stake&Relax 🦥"
      },
      {
        address: "https://grpc.stride.bronbro.io:443",
        provider: "Bro_n_Bro"
      }
    ]
  },
  explorers: [
    {
      kind: "BccNodes",
      url: "https://explorer.bccnodes.com/stride-M",
      tx_page: "https://explorer.bccnodes.com/stride-M/tx/${txHash}",
      account_page: "https://explorer.bccnodes.com/stride-M/account/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/stride",
      tx_page: "https://ezstaking.app/stride/txs/${txHash}",
      account_page: "https://ezstaking.app/stride/account/${accountAddress}"
    },
    {
      kind: "Apollo",
      url: "https://apollo.chandrastation.com/stride",
      tx_page: "https://apollo.chandrastation.com/stride/tx/${txHash}",
      account_page: "https://apollo.chandrastation.com/stride/account/${accountAddress}"
    },
    {
      kind: "Stride Ping Pub",
      url: "https://explorer.stride.zone/stride",
      tx_page: "https://explorer.stride.zone/stride/tx/${txHash}",
      account_page: "https://explorer.stride.zone/stride/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/stride",
      tx_page: "https://explorer.stavr.tech/stride/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/stride/account/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/stride",
      tx_page: "https://www.mintscan.io/stride/transactions/${txHash}",
      account_page: "https://www.mintscan.io/stride/accounts/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/stride",
      tx_page: "https://atomscan.com/stride/transactions/${txHash}",
      account_page: "https://atomscan.com/stride/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/stride",
      account_page: "https://stakeflow.io/stride/accounts/${accountAddress}"
    },
    {
      kind: "Stake-Take",
      url: "https://explorer.stake-take.com/stride",
      tx_page: "https://explorer.stake-take.com/stride/tx/${txHash}",
      account_page: "https://explorer.stake-take.com/stride/account/${accountAddress}"
    },
    {
      kind: "WhisperNode 🤐",
      url: "https://mainnet.whispernode.com/stride",
      tx_page: "https://mainnet.whispernode.com/stride/tx/${txHash}",
      account_page: "https://mainnet.whispernode.com/stride/account/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg"
  },
  images: [{
    image_sync: {
      chain_name: "stride",
      base_denom: "ustrd"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg",
    theme: {
      primary_color_hex: "#e4047c"
    }
  }]
};
Q2.default = gG;
var ef = {};
Object.defineProperty(ef, "__esModule", { value: !0 });
const uG = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-14",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-70",
      connection_id: "connection-48"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-57",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-74",
      connection_id: "connection-68"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-129",
      connection_id: "connection-118"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-59",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-148",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-93",
      connection_id: "connection-78"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-75",
      connection_id: "connection-60"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-64",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-69",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "bandchain",
      client_id: "07-tendermint-169",
      connection_id: "connection-150"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-146",
      connection_id: "connection-146"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-161",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-258",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-13",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-40",
      connection_id: "connection-27"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-47",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-0",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-137",
      connection_id: "connection-125"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-162",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-83",
      connection_id: "connection-50"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-41",
      connection_id: "connection-28"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-45",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "composable",
      client_id: "07-tendermint-14",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-126",
      connection_id: "connection-116"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-134",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-913",
      connection_id: "connection-635"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-391",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-38",
      connection_id: "connection-39"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-44",
      connection_id: "connection-30"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-133",
      connection_id: "connection-123"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-160",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dymension",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-140",
      connection_id: "connection-131"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-197",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "evmos",
      client_id: "07-tendermint-77",
      connection_id: "connection-33"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-8",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "haqq",
      client_id: "07-tendermint-6",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-143",
      connection_id: "connection-143"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-240",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-131",
      connection_id: "connection-103"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-89",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-263",
      connection_id: "connection-205"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-31",
      connection_id: "connection-19"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-139",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-24",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-202",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-48",
          port_id: "icacontroller-juno-1.DELEGATION"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0,
          properties: "liquid staking"
        }
      },
      {
        chain_1: {
          channel_id: "channel-143",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-26",
          port_id: "icacontroller-juno-1.FEE"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0,
          properties: "liquid staking"
        }
      },
      {
        chain_1: {
          channel_id: "channel-142",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-27",
          port_id: "icacontroller-juno-1.WITHDRAWAL"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0,
          properties: "liquid staking"
        }
      },
      {
        chain_1: {
          channel_id: "channel-140",
          port_id: "icahost"
        },
        chain_2: {
          channel_id: "channel-28",
          port_id: "icacontroller-juno-1.REDEMPTION"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0,
          properties: "liquid staking"
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-37",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-5",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-32",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-18",
      connection_id: "connection-15"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-125",
      connection_id: "connection-113"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-123",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2119",
      connection_id: "connection-1657"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-1",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-326",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-83",
      connection_id: "connection-71"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-54",
      connection_id: "connection-33"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-67",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-53",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "pryzm",
      client_id: "07-tendermint-8",
      connection_id: "connection-8"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-145",
      connection_id: "connection-145"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-257",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "saga",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-142",
      connection_id: "connection-142"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-213",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-75",
      connection_id: "connection-40"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-37",
      connection_id: "connection-25"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-40",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "sei",
      client_id: "07-tendermint-18",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-130",
      connection_id: "connection-119"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-149",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "sommelier",
      client_id: "07-tendermint-60",
      connection_id: "connection-75"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-131",
      connection_id: "connection-122"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-71",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-150",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "stargaze",
      client_id: "07-tendermint-195",
      connection_id: "connection-128"
    },
    chain_2: {
      chain_name: "stride",
      client_id: "07-tendermint-30",
      connection_id: "connection-18"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-106",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "stride",
      client_id: "07-tendermint-51",
      connection_id: "connection-32"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-87",
      connection_id: "connection-72"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-52",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "stride",
      client_id: "07-tendermint-32",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-64",
      connection_id: "connection-45"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
ef.default = uG;
var nf = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(sa, "__esModule", { value: !0 });
sa.ibc = sa.chain = sa.assets = void 0;
const _G = nf(Z2), yG = nf(Q2), bG = nf(ef);
sa.assets = _G.default;
sa.chain = yG.default;
sa.ibc = bG.default;
var kr = {}, tf = {};
Object.defineProperty(tf, "__esModule", { value: !0 });
const vG = {
  $schema: "../assetlist.schema.json",
  chain_name: "sunrise",
  assets: [{
    description: "The native token of the Sunrise network for staking. This token is non transferrable. This token can be retrieved by providing liquidity.",
    denom_units: [{
      denom: "uvrise",
      exponent: 0,
      aliases: ["microvRISE", "microvrise"]
    }, {
      denom: "vrise",
      exponent: 6
    }],
    base: "uvrise",
    name: "Sunrise vRISE",
    display: "vrise",
    symbol: "vRISE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/vrise.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/vrise.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/vrise.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/vrise.png",
      theme: {
        primary_color_hex: "#a4b4c4"
      }
    }],
    socials: {
      website: "https://sunriselayer.io/",
      twitter: "https://twitter.com/SunriseLayer"
    }
  }, {
    description: "The native token of the Sunrise network for fees.",
    denom_units: [{
      denom: "urise",
      exponent: 0,
      aliases: ["microRISE", "microrise"]
    }, {
      denom: "rise",
      exponent: 6
    }],
    base: "urise",
    name: "Sunrise RISE",
    display: "rise",
    symbol: "RISE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.png",
      theme: {
        primary_color_hex: "#ecbc64"
      }
    }],
    socials: {
      website: "https://sunriselayer.io/",
      twitter: "https://twitter.com/SunriseLayer"
    }
  }]
};
tf.default = vG;
var sf = {};
Object.defineProperty(sf, "__esModule", { value: !0 });
const fG = {
  $schema: "../chain.schema.json",
  chain_name: "sunrise",
  status: "upcoming",
  network_type: "mainnet",
  website: "https://sunriselayer.io/",
  pretty_name: "Sunrise",
  chain_type: "cosmos",
  chain_id: "sunrise-1",
  bech32_prefix: "sunrise",
  daemon_name: "sunrised",
  node_home: "$HOME/.sunrise",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "urise",
      fixed_min_gas_price: 2e-3,
      low_gas_price: 0.01,
      average_gas_price: 0.02,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uvrise"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.50.2"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.svg"
  },
  apis: {
    rpc: [],
    rest: [],
    grpc: []
  },
  explorers: [],
  images: [{
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.svg",
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.png",
    theme: {
      primary_color_hex: "#ecbc64"
    }
  }]
};
sf.default = fG;
var X9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(kr, "__esModule", { value: !0 });
kr.chain = kr.assets = void 0;
const wG = X9(tf), xG = X9(sf);
kr.assets = wG.default;
kr.chain = xG.default;
var Ar = {}, af = {};
Object.defineProperty(af, "__esModule", { value: !0 });
const kG = {
  $schema: "../assetlist.schema.json",
  chain_name: "synternet",
  assets: [{
    description: "Synternet is a blockchain that powers modular, interoperable data infrastructure across all major chains.",
    extended_description: "The Data Layer is a decentralized, permissionless protocol built on Synternet that serves as the customizable execution layer between all blockchains, enabling developers instant access to any cross-chain data. It uses a pub-sub (publish-subscribe) framework where data providers can stream live data to applications and smart contracts",
    denom_units: [{
      denom: "usynt",
      exponent: 0
    }, {
      denom: "SYNT",
      exponent: 6
    }],
    base: "usynt",
    name: "Synternet",
    display: "SYNT",
    symbol: "SYNT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.svg",
      theme: {
        primary_color_hex: "#272d45"
      }
    }],
    socials: {
      website: "https://www.synternet.com/",
      twitter: "https://twitter.com/synternet_com"
    }
  }]
};
af.default = kG;
var of = {};
Object.defineProperty(of, "__esModule", { value: !0 });
const AG = {
  $schema: "../chain.schema.json",
  chain_name: "synternet",
  chain_type: "cosmos",
  chain_id: "synternet-1",
  website: "https://www.synternet.com/",
  pretty_name: "Synternet",
  status: "live",
  network_type: "mainnet",
  bech32_prefix: "synt",
  daemon_name: "syntd",
  node_home: "$HOME/.amber",
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "usynt",
      fixed_min_gas_price: 0.01,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "usynt"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.11"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.svg"
  },
  description: "Synternet is the backbone of the Data Layer, a protocol serving as the customizable execution layer between all blockchains. It enables builders to See, Interpret and Act on any data from any chain, supercharging their applications.",
  apis: {
    rpc: [{
      address: "https://rpc.synternet.com/",
      provider: "Synternet"
    }],
    rest: [{
      address: "https://api.synternet.com/",
      provider: "Synternet"
    }]
  },
  explorers: [{
    kind: "Big Dipper",
    url: "https://explorer.synternet.com/",
    tx_page: "https://explorer.synternet.com/transactions/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.svg",
    theme: {
      primary_color_hex: "#272d45"
    }
  }],
  slip44: 118
};
of.default = AG;
var Y9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ar, "__esModule", { value: !0 });
Ar.chain = Ar.assets = void 0;
const jG = Y9(af), CG = Y9(of);
Ar.assets = jG.default;
Ar.chain = CG.default;
var jr = {}, rf = {};
Object.defineProperty(rf, "__esModule", { value: !0 });
const EG = {
  $schema: "../assetlist.schema.json",
  chain_name: "taketitan",
  assets: [{
    description: "Taketitan the future of the asset management industry.",
    extended_description: `Taketitan is seen as the future of the asset management industry. This new blockchain technology is changing how asset management works in exciting ways.

Taketitan aims to make managing assets simpler, faster, and more secure. By using blockchain technology, it provides a transparent and trustworthy system where all transactions are recorded in a secure and unchangeable way. This helps reduce the risk of fraud and errors, making asset management safer for everyone.

With Taketitan, managing assets becomes more efficient. Transactions are processed quickly, and the costs are lower compared to traditional methods. This means more people can benefit from high-quality asset management services without the high fees usually involved.

Taketitan also makes it easier for people to track and manage their investments. Everything is done through a digital platform that is easy to use and always available. This gives users better control and visibility over their assets.

In short, Taketitan is revolutionizing the asset management industry by making it more secure, efficient, and accessible for everyone. This blockchain technology is paving the way for a new era in how we manage and grow our financial assets.`,
    denom_units: [{
      denom: "ttnc",
      exponent: 0
    }],
    base: "ttnc",
    name: "taketitan",
    display: "ttnc",
    symbol: "TTNC",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/taketitan/images/taketitan.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/taketitan/images/taketitan.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/taketitan/images/taketitan.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/taketitan/images/taketitan.svg",
      theme: {
        primary_color_hex: "#41918c"
      }
    }],
    socials: {
      website: "https://taketitan.com/"
    }
  }]
};
rf.default = EG;
var cf = {};
Object.defineProperty(cf, "__esModule", { value: !0 });
const DG = {
  $schema: "../chain.schema.json",
  chain_name: "taketitan",
  status: "live",
  network_type: "mainnet",
  website: "https://taketitan.com/",
  pretty_name: "TakeTitan",
  chain_type: "cosmos",
  chain_id: "taketitan-12",
  bech32_prefix: "taketitan",
  daemon_name: "ttnc",
  node_home: "$HOME/.ssc",
  key_algos: ["secp256k1"],
  slip44: 1179993421,
  staking: {
    staking_tokens: [{
      denom: "ttnc"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  fees: {
    fee_tokens: [{
      denom: "ttnc",
      low_gas_price: 1e-6,
      average_gas_price: 5e-6,
      high_gas_price: 1e-4
    }]
  },
  apis: {
    rpc: [{
      address: "https://rcpttnc.taketitan.com",
      provider: "taketitan"
    }],
    rest: [{
      address: "https://lcdttnc.taketitan.com",
      provider: "taketitan"
    }],
    grpc: [{
      address: "https://grcpttnc.taketitan.com:8090",
      provider: "taketitan"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/taketitan/images/taketitan.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/taketitan/images/taketitan.svg"
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://scan.taketitan.com/taketitan",
    tx_page: "https://scan.taketitan.com/taketitan/tx/${txHash}",
    account_page: "https://scan.taketitan.com/taketitan/accounts/${accountAddress}"
  }],
  keywords: [],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/taketitan/images/taketitan.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/taketitan/images/taketitan.svg",
    theme: {
      primary_color_hex: "#41918c"
    }
  }]
};
cf.default = DG;
var J9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(jr, "__esModule", { value: !0 });
jr.chain = jr.assets = void 0;
const BG = J9(rf), FG = J9(cf);
jr.assets = BG.default;
jr.chain = FG.default;
var Cr = {}, df = {};
Object.defineProperty(df, "__esModule", { value: !0 });
const $G = {
  $schema: "../assetlist.schema.json",
  chain_name: "tenet",
  assets: [{
    description: "The native EVM, governance and staking token of the Tenet",
    denom_units: [{
      denom: "atenet",
      exponent: 0
    }, {
      denom: "tenet",
      exponent: 18
    }],
    base: "atenet",
    name: "Tenet",
    display: "tenet",
    symbol: "TENET",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tenet/images/tenet.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tenet/images/tenet.svg"
    },
    coingecko_id: "tenet-1b000f7b-59cb-4e06-89ce-d62b32d362b9",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tenet/images/tenet.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tenet/images/tenet.svg",
      theme: {
        primary_color_hex: "#040404"
      }
    }]
  }]
};
df.default = $G;
var mf = {};
Object.defineProperty(mf, "__esModule", { value: !0 });
const zG = {
  $schema: "../chain.schema.json",
  chain_name: "tenet",
  status: "live",
  network_type: "mainnet",
  website: "https://tenet.org/",
  pretty_name: "Tenet",
  chain_type: "cosmos",
  chain_id: "tenet_1559-1",
  bech32_prefix: "tenet",
  node_home: "$HOME/.tenetd",
  daemon_name: "tenetd",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "atenet",
      fixed_min_gas_price: 25e7,
      low_gas_price: 2e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "atenet"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tenet/images/tenet.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tenet/images/tenet.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://tendermint-1.rpc.tenet.org",
        provider: "tenet"
      },
      {
        address: "https://tenet-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://tenet_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://app.rpc.tenet.org",
        provider: "tenet"
      },
      {
        address: "https://tenet-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://tenet_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [{
      address: "tenet-grpc.publicnode.com:443",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }, {
      address: "kichain-mainnet-grpc.autostake.com:443",
      provider: "AutoStake 🛡️ Slash Protected"
    }],
    "evm-http-jsonrpc": [{
      address: "https://rpc.tenet.org",
      provider: "tenet"
    }, {
      address: "https://tenet-evm.publicnode.com",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/tenet",
      tx_page: "https://ping.pub/tenet/tx/${txHash}"
    },
    {
      kind: "Nodeist Explorer",
      url: "https://exp.nodeist.net/Tenet",
      tx_page: "https://exp.nodeist.net/Tenet/tx/${txHash}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/tenet",
      tx_page: "https://explorer.tcnetwork.io/tenet/transaction/${txHash}",
      account_page: "https://explorer.tcnetwork.io/tenet/account/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/tenet",
      tx_page: "https://explorer.whenmoonwhenlambo.money/tenet/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/tenet/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tenet/images/tenet.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tenet/images/tenet.svg",
    theme: {
      primary_color_hex: "#040404"
    }
  }]
};
mf.default = zG;
var Z9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Cr, "__esModule", { value: !0 });
Cr.chain = Cr.assets = void 0;
const qG = Z9(df), SG = Z9(mf);
Cr.assets = qG.default;
Cr.chain = SG.default;
var aa = {}, hf = {};
Object.defineProperty(hf, "__esModule", { value: !0 });
const TG = {
  $schema: "../assetlist.schema.json",
  chain_name: "teritori",
  assets: [
    {
      description: "The native token of Teritori",
      denom_units: [{
        denom: "utori",
        exponent: 0
      }, {
        denom: "tori",
        exponent: 6
      }],
      base: "utori",
      name: "Teritori",
      display: "tori",
      symbol: "TORI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/utori.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/utori.svg"
      },
      coingecko_id: "teritori",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/utori.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/utori.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "The native token of Osmosis",
      denom_units: [{
        denom: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
        exponent: 0
      }, {
        denom: "osmo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
      name: "Osmosis",
      display: "osmo",
      symbol: "OSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "uosmo",
          channel_id: "channel-362"
        },
        chain: {
          channel_id: "channel-0",
          path: "transfer/channel-0/uosmo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      },
      coingecko_id: "osmosis",
      keywords: ["dex", "staking"],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg",
        theme: {
          primary_color_hex: "#760dbb"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/A670D9568B3E399316EEDE40C1181B7AA4BD0695F0B37513CE9B95B977DFC12E",
        exponent: 0,
        aliases: ["uatom"]
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/A670D9568B3E399316EEDE40C1181B7AA4BD0695F0B37513CE9B95B977DFC12E",
      name: "Cosmos Hub Atom",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshub",
          base_denom: "uatom",
          channel_id: "channel-431"
        },
        chain: {
          channel_id: "channel-10",
          path: "transfer/channel-10/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      }
    },
    {
      description: "The native staking and governance token of the Kujira chain.",
      denom_units: [{
        denom: "ibc/1FECA3491D88F4AD24DE0948ED96718CA6D93F6730CEE7708E621B953594BB5E",
        exponent: 0,
        aliases: ["ukuji"]
      }, {
        denom: "kuji",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/1FECA3491D88F4AD24DE0948ED96718CA6D93F6730CEE7708E621B953594BB5E",
      name: "Kujira",
      display: "kuji",
      symbol: "KUJI",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kujira",
          base_denom: "ukuji",
          channel_id: "channel-89"
        },
        chain: {
          channel_id: "channel-30",
          path: "transfer/channel-30/ukuji"
        }
      }],
      coingecko_id: "kujira",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.svg"
      },
      images: [{
        image_sync: {
          chain_name: "kujira",
          base_denom: "ukuji"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kujira/images/kuji.svg",
        theme: {
          primary_color_hex: "#e33b34"
        }
      }]
    },
    {
      description: "USD Coin",
      denom_units: [{
        denom: "ibc/FE98AAD68F02F03565E9FA39A5E627946699B2B07115889ED812D8BA639576A9",
        exponent: 0
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/FE98AAD68F02F03565E9FA39A5E627946699B2B07115889ED812D8BA639576A9",
      display: "usdc",
      name: "USD Coin",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "noble",
          base_denom: "uusdc",
          channel_id: "channel-54"
        },
        chain: {
          channel_id: "channel-62",
          path: "transfer/channel-62/uusdc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "The native staking and governance token of the Secret chain.",
      denom_units: [{
        denom: "ibc/F3F6BDEE1A79664B169D742651107BF4E03FA67E931452E27380B75F5917B7E9",
        exponent: 0
      }, {
        denom: "scrt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F3F6BDEE1A79664B169D742651107BF4E03FA67E931452E27380B75F5917B7E9",
      name: "Secret Network",
      display: "scrt",
      symbol: "SCRT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "secretnetwork",
          base_denom: "uscrt",
          channel_id: "channel-111"
        },
        chain: {
          channel_id: "channel-63",
          path: "transfer/channel-63/uscrt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "secretnetwork",
          base_denom: "uscrt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    }
  ]
};
hf.default = TG;
var pf = {};
Object.defineProperty(pf, "__esModule", { value: !0 });
const RG = {
  $schema: "../chain.schema.json",
  chain_name: "teritori",
  status: "live",
  network_type: "mainnet",
  website: "https://teritori.com/",
  pretty_name: "Teritori",
  chain_type: "cosmos",
  chain_id: "teritori-1",
  daemon_name: "teritorid",
  node_home: "$HOME/.teritorid",
  bech32_prefix: "tori",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utori",
      low_gas_price: 0,
      average_gas_price: 0.25,
      high_gas_price: 0.5
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "utori"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.6",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.41.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/chain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/chain.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://teritori-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://teritori.rpc.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.teritori.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://teritori-rpc.brocha.in",
        provider: "Brochain"
      },
      {
        address: "https://teritori-rpc.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://teritori.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://rpc.tori.bh.rocks",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://teritori-rpc.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://m-teritori.rpc.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://rpc-teritori.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://teritori-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rpc-teritori.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://teritori-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://teritori-rpc.bluestake.net:443",
        provider: "BlueStake 🚀"
      },
      {
        address: "https://teritori_mainnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://teritori-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://teritori.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.teritori.silentvalidator.com/",
        provider: "silent"
      },
      {
        address: "https://teritori-api.ibs.team",
        provider: "Inter Blockchain Services"
      },
      {
        address: "https://teritori.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://api.tori.bh.rocks",
        provider: "BlockHunters 🎯"
      },
      {
        address: "https://teritori-api.kleomedes.network",
        provider: "Kleomedes"
      },
      {
        address: "https://m-teritori.api.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://api-teritori.pupmos.network",
        provider: "PUPMØS"
      },
      {
        address: "https://teritori-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://rest-teritori.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://teritori-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://teritori-api.bluestake.net",
        provider: "BlueStake 🚀"
      },
      {
        address: "https://teritori_mainnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [
      {
        address: "grpc.teritori.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "teritori.grpc.m.stavr.tech:6705",
        provider: "🔥STAVR🔥"
      },
      {
        address: "teritori-grpc.brocha.in:443",
        provider: "Brochain"
      },
      {
        address: "teritori-grpc.polkachu.com:15990",
        provider: "Polkachu"
      },
      {
        address: "teritori.grpc.silknodes.io:443",
        provider: "Silk Nodes"
      },
      {
        address: "teritori-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "teritori.grpc.kjnodes.com:11990",
        provider: "kjnodes"
      },
      {
        address: "teritori-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/teritori",
      tx_page: "https://ezstaking.app/teritori/txs/${txHash}",
      account_page: "https://ezstaking.app/teritori/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.teritori.com/teritori",
      tx_page: "https://explorer.teritori.com/teritori/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/teritori-main",
      tx_page: "https://explorer.stavr.tech/teritori-main/tx/${txHash}"
    },
    {
      kind: "guru",
      url: "https://teritori.explorers.guru/",
      tx_page: "https://teritori.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "Brochain",
      url: "https://explorer.brocha.in/teritori",
      tx_page: "https://explorer.brocha.in/teritori/tx/${txHash}"
    },
    {
      kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
      url: "https://exp.utsa.tech/teritori",
      tx_page: "https://exp.utsa.tech/teritori/tx/${txHash}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/teritori",
      tx_page: "https://www.mintscan.io/teritori/transactions/${txHash}",
      account_page: "https://www.mintscan.io/teritori/accounts/${accountAddress}"
    },
    {
      kind: "TC Network",
      url: "https://explorer.tcnetwork.io/teritori",
      tx_page: "https://explorer.tcnetwork.io/teritori/transaction/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/teritori",
      tx_page: "https://atomscan.com/teritori/transactions/${txHash}",
      account_page: "https://atomscan.com/teritori/accounts/${accountAddress}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/teritori",
      tx_page: "https://explorer.whenmoonwhenlambo.money/teritori/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/teritori/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/chain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/teritori/images/chain.svg",
    theme: {
      primary_color_hex: "#44c5f1"
    }
  }]
};
pf.default = RG;
var lf = {};
Object.defineProperty(lf, "__esModule", { value: !0 });
const OG = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-962",
      connection_id: "connection-1710"
    },
    chain_2: {
      chain_name: "teritori",
      client_id: "07-tendermint-32",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-431",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-132",
      connection_id: "connection-100"
    },
    chain_2: {
      chain_name: "teritori",
      client_id: "07-tendermint-61",
      connection_id: "connection-38"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-89",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-76",
      connection_id: "connection-77"
    },
    chain_2: {
      chain_name: "teritori",
      client_id: "07-tendermint-97",
      connection_id: "connection-97"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-54",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-62",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-2192",
      connection_id: "connection-1710"
    },
    chain_2: {
      chain_name: "teritori",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-362",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-192",
      connection_id: "connection-185"
    },
    chain_2: {
      chain_name: "teritori",
      client_id: "07-tendermint-99",
      connection_id: "connection-122"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-111",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-63",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  }
];
lf.default = OG;
var gf = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(aa, "__esModule", { value: !0 });
aa.ibc = aa.chain = aa.assets = void 0;
const MG = gf(hf), IG = gf(pf), NG = gf(lf);
aa.assets = MG.default;
aa.chain = IG.default;
aa.ibc = NG.default;
var Er = {}, uf = {};
Object.defineProperty(uf, "__esModule", { value: !0 });
const PG = {
  $schema: "../assetlist.schema.json",
  chain_name: "terpnetwork",
  assets: [{
    description: "Terp Token (TERP) is the Terp Network's native utility token, used as the primary means to govern & secure the blockchain.",
    denom_units: [{
      denom: "uterp",
      exponent: 0
    }, {
      denom: "terp",
      exponent: 6
    }],
    base: "uterp",
    name: "Terp Network Native Token",
    display: "terp",
    symbol: "TERP",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/terp.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/terp.png",
      theme: {
        primary_color_hex: "#a2cd9a"
      }
    }]
  }, {
    description: "Thiol Gas Token (Thiols) is the Terp Network's native utility token, used as the primary means to govern, secure the blockchain & incentivize participants.",
    denom_units: [{
      denom: "uthiol",
      exponent: 0
    }, {
      denom: "thiol",
      exponent: 6
    }],
    base: "uthiol",
    name: "Thiol Terp Gas Token",
    display: "thiol",
    symbol: "THIOL",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/thiol.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/thiol.png",
      theme: {
        primary_color_hex: "#060607"
      }
    }]
  }]
};
uf.default = PG;
var _f = {};
Object.defineProperty(_f, "__esModule", { value: !0 });
const UG = {
  $schema: "../chain.schema.json",
  chain_name: "terpnetwork",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Terp-Network",
  chain_type: "cosmos",
  chain_id: "morocco-1",
  bech32_prefix: "terp",
  daemon_name: "terp",
  node_home: "$HOME/.terp",
  codebase: {},
  fees: {
    fee_tokens: [{
      denom: "uthiol",
      fixed_min_gas_price: 0.05
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uterp"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/logo.png"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc-terp.zenchainlabs.io/",
        provider: "ZenChainLabs"
      },
      {
        address: "https://terp-mainnet-rpc.itrocket.net:443",
        provider: "itrocket.net"
      },
      {
        address: "https://terp.rpc.nodex.one:443",
        provider: "nodex.one"
      }
    ],
    rest: [
      {
        address: "https://api-terp.zenchainlabs.io:443",
        provider: "ZenChainLabs"
      },
      {
        address: "https://terp-mainnet-api.itrocket.net:443",
        provider: "itrocket.net"
      },
      {
        address: "https://terp.api.nodex.one:443",
        provider: "nodex.one"
      },
      {
        address: "https://terp.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      }
    ],
    grpc: [
      {
        address: "https://grpc.terp.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "terp-mainnet-grpc.itrocket.net:13090",
        provider: "itrocket.net"
      },
      {
        address: "https://terp.grpc.nodex.one:443",
        provider: "nodex.one"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://ping.pub/terp",
      tx_page: "https://ping.pub/terp/tx/${txHash}",
      account_page: "https://ping.pub/terp/account/{$accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.nodestake.top",
      tx_page: "https://explorer.nodestake.top/terp/tx/${txHash}",
      account_page: "https://explorer.nodestake.top/terp/account/{$accountAddress}"
    },
    {
      kind: "ZenChainLabs",
      url: "https://terp.zenscan.io/",
      tx_page: "https://terp.zenscan.io/transaction.php?hash=${txHash}",
      account_page: "https://terp.zenscan.io/address.php?address=${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Terp-Mainnet",
      tx_page: "https://explorer.stavr.tech/Terp-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Terp-Mainnet/account/{$accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/logo.png",
    theme: {
      primary_color_hex: "#a2cd9a"
    }
  }],
  slip44: 118
};
_f.default = UG;
var Q9 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Er, "__esModule", { value: !0 });
Er.chain = Er.assets = void 0;
const HG = Q9(uf), LG = Q9(_f);
Er.assets = HG.default;
Er.chain = LG.default;
var oa = {}, yf = {};
Object.defineProperty(yf, "__esModule", { value: !0 });
const WG = {
  $schema: "../assetlist.schema.json",
  chain_name: "terra",
  assets: [
    {
      description: "Terra Classic is the original blockchain platform that powered the UST stablecoin and LUNA token before the launch of Terra 2.0, focusing on stablecoins and DeFi applications.",
      extended_description: "Terra Classic was designed to create a decentralized financial infrastructure using algorithmic stablecoins like UST, which were pegged to various fiat currencies. The platform's native token, LUNA, played a crucial role in stabilizing the stablecoins through a mint-and-burn mechanism. Despite facing significant challenges, Terra Classic paved the way for Terra 2.0, which aims to rebuild and improve upon the original vision. Terra Classic continues to operate with a focus on supporting decentralized finance (DeFi) applications and stablecoin solutions.",
      denom_units: [
        {
          denom: "uluna",
          exponent: 0,
          aliases: ["microluna"]
        },
        {
          denom: "mluna",
          exponent: 3,
          aliases: ["milliluna"]
        },
        {
          denom: "luna",
          exponent: 6,
          aliases: ["lunc"]
        }
      ],
      base: "uluna",
      name: "Luna Classic",
      display: "luna",
      symbol: "LUNC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.svg"
      },
      coingecko_id: "terra-luna",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.svg",
        theme: {
          primary_color_hex: "#fcdb5b"
        }
      }]
    },
    {
      description: "The USD stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "uusd",
          exponent: 0,
          aliases: ["microusd"]
        },
        {
          denom: "musd",
          exponent: 3,
          aliases: ["milliusd"]
        },
        {
          denom: "ust",
          exponent: 6,
          aliases: ["ustc"]
        }
      ],
      base: "uusd",
      name: "TerraClassicUSD",
      display: "ust",
      symbol: "USTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ust.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ust.svg"
      },
      coingecko_id: "terrausd",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ust.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ust.svg",
        theme: {
          primary_color_hex: "#5493f2"
        }
      }]
    },
    {
      description: "The KRW stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "ukrw",
          exponent: 0,
          aliases: ["microkrw"]
        },
        {
          denom: "mkrw",
          exponent: 3,
          aliases: ["millikrw"]
        },
        {
          denom: "krt",
          exponent: 6,
          aliases: ["krtc"]
        }
      ],
      base: "ukrw",
      name: "TerraClassicKRW",
      display: "krt",
      symbol: "KRTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/krt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/krt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/krt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/krt.svg",
        theme: {
          primary_color_hex: "#4b83e0"
        }
      }]
    },
    {
      description: "The governance token of the White Whale protocol on Terra.",
      type_asset: "cw20",
      address: "terra1php5m8a6qd68z02t3zpw4jv2pj4vgw4wz0t8mz",
      denom_units: [{
        denom: "cw20:terra1php5m8a6qd68z02t3zpw4jv2pj4vgw4wz0t8mz",
        exponent: 0
      }, {
        denom: "whale",
        exponent: 6
      }],
      base: "cw20:terra1php5m8a6qd68z02t3zpw4jv2pj4vgw4wz0t8mz",
      name: "Whale Token",
      display: "whale",
      symbol: "WHALE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/whale.png"
      },
      coingecko_id: "white-whale",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/whale.png",
        theme: {
          primary_color_hex: "#43b24b"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1kc87mu460fwkqte29rquh4hc20m54fxwtsx7gp",
        exponent: 0
      }, {
        denom: "bluna",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1kc87mu460fwkqte29rquh4hc20m54fxwtsx7gp",
      base: "cw20:terra1kc87mu460fwkqte29rquh4hc20m54fxwtsx7gp",
      name: "Bonded Luna",
      display: "bluna",
      symbol: "bLuna",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bluna.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bluna.png",
        theme: {
          primary_color_hex: "#fbdb5b"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1dzhzukyezv0etz22ud940z7adyv7xgcjkahuun",
        exponent: 0
      }, {
        denom: "beth",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1dzhzukyezv0etz22ud940z7adyv7xgcjkahuun",
      base: "cw20:terra1dzhzukyezv0etz22ud940z7adyv7xgcjkahuun",
      name: "Bonded ETH",
      display: "beth",
      symbol: "bETH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/beth.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/beth.png",
        theme: {
          primary_color_hex: "#54b649"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1hzh9vpxhsk8253se0vv5jj6etdvxu3nv8z07zu",
        exponent: 0
      }, {
        denom: "aust",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1hzh9vpxhsk8253se0vv5jj6etdvxu3nv8z07zu",
      base: "cw20:terra1hzh9vpxhsk8253se0vv5jj6etdvxu3nv8z07zu",
      name: "Anchor Terra USD",
      display: "aust",
      symbol: "aUST",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/aust.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/aust.png",
        theme: {
          primary_color_hex: "#dd7e7f"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra14z56l0fp2lsf86zy3hty2z47ezkhnthtr9yq76",
        exponent: 0
      }, {
        denom: "anc",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra14z56l0fp2lsf86zy3hty2z47ezkhnthtr9yq76",
      base: "cw20:terra14z56l0fp2lsf86zy3hty2z47ezkhnthtr9yq76",
      name: "Anchor Token",
      display: "anc",
      symbol: "ANC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/anc.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/anc.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra15gwkyepfc6xgca5t5zefzwy42uts8l2m4g40k6",
        exponent: 0
      }, {
        denom: "mir",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra15gwkyepfc6xgca5t5zefzwy42uts8l2m4g40k6",
      base: "cw20:terra15gwkyepfc6xgca5t5zefzwy42uts8l2m4g40k6",
      name: "Mirror",
      display: "mir",
      symbol: "MIR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mir.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mir.png",
        theme: {
          primary_color_hex: "#142444"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1vxtwu4ehgzz77mnfwrntyrmgl64qjs75mpwqaz",
        exponent: 0
      }, {
        denom: "maapl",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1vxtwu4ehgzz77mnfwrntyrmgl64qjs75mpwqaz",
      base: "cw20:terra1vxtwu4ehgzz77mnfwrntyrmgl64qjs75mpwqaz",
      name: "Apple Inc.",
      display: "maapl",
      symbol: "mAAPL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/maapl.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/maapl.png",
        theme: {
          primary_color_hex: "#acacac"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1g4x2pzmkc9z3mseewxf758rllg08z3797xly0n",
        exponent: 0
      }, {
        denom: "mabnb",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1g4x2pzmkc9z3mseewxf758rllg08z3797xly0n",
      base: "cw20:terra1g4x2pzmkc9z3mseewxf758rllg08z3797xly0n",
      name: "Airbnb Inc.",
      display: "mabnb",
      symbol: "mABNB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mabnb.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mabnb.png",
        theme: {
          primary_color_hex: "#e4545c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1qelfthdanju7wavc5tq0k5r0rhsyzyyrsn09qy",
        exponent: 0
      }, {
        denom: "mamc",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1qelfthdanju7wavc5tq0k5r0rhsyzyyrsn09qy",
      base: "cw20:terra1qelfthdanju7wavc5tq0k5r0rhsyzyyrsn09qy",
      name: "AMC Entertainment Holdings Inc.",
      display: "mamc",
      symbol: "mAMC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mamc.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mamc.png",
        theme: {
          primary_color_hex: "#cc2444"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra18ej5nsuu867fkx4tuy2aglpvqjrkcrjjslap3z",
        exponent: 0
      }, {
        denom: "mamd",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra18ej5nsuu867fkx4tuy2aglpvqjrkcrjjslap3z",
      base: "cw20:terra18ej5nsuu867fkx4tuy2aglpvqjrkcrjjslap3z",
      name: "Advanced Micro Devices, Inc.",
      display: "mamd",
      symbol: "mAMD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mamd.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mamd.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra165nd2qmrtszehcfrntlplzern7zl4ahtlhd5t2",
        exponent: 0
      }, {
        denom: "mamzn",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra165nd2qmrtszehcfrntlplzern7zl4ahtlhd5t2",
      base: "cw20:terra165nd2qmrtszehcfrntlplzern7zl4ahtlhd5t2",
      name: "Amazon.com, Inc.",
      display: "mamzn",
      symbol: "mAMZN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mamzn.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mamzn.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1qqfx5jph0rsmkur2zgzyqnfucra45rtjae5vh6",
        exponent: 0
      }, {
        denom: "markk",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1qqfx5jph0rsmkur2zgzyqnfucra45rtjae5vh6",
      base: "cw20:terra1qqfx5jph0rsmkur2zgzyqnfucra45rtjae5vh6",
      name: "ARK Innovation ETF",
      display: "markk",
      symbol: "mARKK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/markk.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/markk.png",
        theme: {
          primary_color_hex: "#0d0d25"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1w7zgkcyt7y4zpct9dw8mw362ywvdlydnum2awa",
        exponent: 0
      }, {
        denom: "mbaba",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1w7zgkcyt7y4zpct9dw8mw362ywvdlydnum2awa",
      base: "cw20:terra1w7zgkcyt7y4zpct9dw8mw362ywvdlydnum2awa",
      name: "Alibaba Group Holding Limited",
      display: "mbaba",
      symbol: "mBABA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mbaba.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mbaba.png",
        theme: {
          primary_color_hex: "#f38506"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1rhhvx8nzfrx5fufkuft06q5marfkucdqwq5sjw",
        exponent: 0
      }, {
        denom: "mbtc",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1rhhvx8nzfrx5fufkuft06q5marfkucdqwq5sjw",
      base: "cw20:terra1rhhvx8nzfrx5fufkuft06q5marfkucdqwq5sjw",
      name: "Bitcoin",
      display: "mbtc",
      symbol: "mBTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mbtc.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mbtc.png",
        theme: {
          primary_color_hex: "#f4941c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra18wayjpyq28gd970qzgjfmsjj7dmgdk039duhph",
        exponent: 0
      }, {
        denom: "mcoin",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra18wayjpyq28gd970qzgjfmsjj7dmgdk039duhph",
      base: "cw20:terra18wayjpyq28gd970qzgjfmsjj7dmgdk039duhph",
      name: "Coinbase Global, Inc.",
      display: "mcoin",
      symbol: "mCOIN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mcoin.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mcoin.png",
        theme: {
          primary_color_hex: "#1454f4"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra149755r3y0rve30e209awkhn5cxgkn5c8ju9pm5",
        exponent: 0
      }, {
        denom: "mdis",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra149755r3y0rve30e209awkhn5cxgkn5c8ju9pm5",
      base: "cw20:terra149755r3y0rve30e209awkhn5cxgkn5c8ju9pm5",
      name: "The Walt Disney Company",
      display: "mdis",
      symbol: "mDIS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mdis.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mdis.png",
        theme: {
          primary_color_hex: "#050505"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra19ya4jpvjvvtggepvmmj6ftmwly3p7way0tt08r",
        exponent: 0
      }, {
        denom: "mdot",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra19ya4jpvjvvtggepvmmj6ftmwly3p7way0tt08r",
      base: "cw20:terra19ya4jpvjvvtggepvmmj6ftmwly3p7way0tt08r",
      name: "Polkadot",
      display: "mdot",
      symbol: "mDOT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mdot.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mdot.png",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1dk3g53js3034x4v5c3vavhj2738une880yu6kx",
        exponent: 0
      }, {
        denom: "meth",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1dk3g53js3034x4v5c3vavhj2738une880yu6kx",
      base: "cw20:terra1dk3g53js3034x4v5c3vavhj2738une880yu6kx",
      name: "Ether",
      display: "meth",
      symbol: "mETH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/meth.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/meth.png",
        theme: {
          primary_color_hex: "#5c648e"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1mqsjugsugfprn3cvgxsrr8akkvdxv2pzc74us7",
        exponent: 0
      }, {
        denom: "mfb",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1mqsjugsugfprn3cvgxsrr8akkvdxv2pzc74us7",
      base: "cw20:terra1mqsjugsugfprn3cvgxsrr8akkvdxv2pzc74us7",
      name: "Facebook Inc.",
      display: "mfb",
      symbol: "mFB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mfb.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mfb.png",
        theme: {
          primary_color_hex: "#1c74f4"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1l5lrxtwd98ylfy09fn866au6dp76gu8ywnudls",
        exponent: 0
      }, {
        denom: "mglxy",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1l5lrxtwd98ylfy09fn866au6dp76gu8ywnudls",
      base: "cw20:terra1l5lrxtwd98ylfy09fn866au6dp76gu8ywnudls",
      name: "Galaxy Digital Holdings Ltd",
      display: "mglxy",
      symbol: "mGLXY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mglxy.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mglxy.png",
        theme: {
          primary_color_hex: "#1d4cac"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1m6j6j9gw728n82k78s0j9kq8l5p6ne0xcc820p",
        exponent: 0
      }, {
        denom: "mgme",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1m6j6j9gw728n82k78s0j9kq8l5p6ne0xcc820p",
      base: "cw20:terra1m6j6j9gw728n82k78s0j9kq8l5p6ne0xcc820p",
      name: "GameStop Corp",
      display: "mgme",
      symbol: "mGME",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mgme.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mgme.png",
        theme: {
          primary_color_hex: "#070707"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1h8arz2k547uvmpxctuwush3jzc8fun4s96qgwt",
        exponent: 0
      }, {
        denom: "mgoogl",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1h8arz2k547uvmpxctuwush3jzc8fun4s96qgwt",
      base: "cw20:terra1h8arz2k547uvmpxctuwush3jzc8fun4s96qgwt",
      name: "Alphabet Inc.",
      display: "mgoogl",
      symbol: "mGOOGL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mgoogl.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mgoogl.png",
        theme: {
          primary_color_hex: "#34ac54"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra137drsu8gce5thf6jr5mxlfghw36rpljt3zj73v",
        exponent: 0
      }, {
        denom: "mgs",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra137drsu8gce5thf6jr5mxlfghw36rpljt3zj73v",
      base: "cw20:terra137drsu8gce5thf6jr5mxlfghw36rpljt3zj73v",
      name: "Goldman Sachs Group Inc.",
      display: "mgs",
      symbol: "mGS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mgs.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mgs.png",
        theme: {
          primary_color_hex: "#749cc4"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra18yqdfzfhnguerz9du5mnvxsh5kxlknqhcxzjfr",
        exponent: 0
      }, {
        denom: "mhood",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra18yqdfzfhnguerz9du5mnvxsh5kxlknqhcxzjfr",
      base: "cw20:terra18yqdfzfhnguerz9du5mnvxsh5kxlknqhcxzjfr",
      name: "Robinhood Markets, Inc.",
      display: "mhood",
      symbol: "mHOOD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mhood.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mhood.png",
        theme: {
          primary_color_hex: "#54c48c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra10h7ry7apm55h4ez502dqdv9gr53juu85nkd4aq",
        exponent: 0
      }, {
        denom: "miau",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra10h7ry7apm55h4ez502dqdv9gr53juu85nkd4aq",
      base: "cw20:terra10h7ry7apm55h4ez502dqdv9gr53juu85nkd4aq",
      name: "iShares Gold Trust",
      display: "miau",
      symbol: "mIAU",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/miau.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/miau.png",
        theme: {
          primary_color_hex: "#141c2c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra15hp9pr8y4qsvqvxf3m4xeptlk7l8h60634gqec",
        exponent: 0
      }, {
        denom: "miau",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra15hp9pr8y4qsvqvxf3m4xeptlk7l8h60634gqec",
      base: "cw20:terra15hp9pr8y4qsvqvxf3m4xeptlk7l8h60634gqec",
      name: "iShares Gold Trust",
      display: "miau",
      symbol: "mIAU",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/miau.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/miau.png",
        theme: {
          primary_color_hex: "#141c2c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1ptdxmj3xmmljzx02nr4auwfuelmj0cnkh8egs2",
        exponent: 0
      }, {
        denom: "mjnj",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1ptdxmj3xmmljzx02nr4auwfuelmj0cnkh8egs2",
      base: "cw20:terra1ptdxmj3xmmljzx02nr4auwfuelmj0cnkh8egs2",
      name: "Johnson & Johnson",
      display: "mjnj",
      symbol: "mJNJ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mjnj.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mjnj.png",
        theme: {
          primary_color_hex: "#c41d2c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1qsnj5gvq8rgs7yws8x5u02gwd5wvtu4tks0hjm",
        exponent: 0
      }, {
        denom: "mko",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1qsnj5gvq8rgs7yws8x5u02gwd5wvtu4tks0hjm",
      base: "cw20:terra1qsnj5gvq8rgs7yws8x5u02gwd5wvtu4tks0hjm",
      name: "Coca-Cola",
      display: "mko",
      symbol: "mKO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mko.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mko.png",
        theme: {
          primary_color_hex: "#fcc9cc"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1227ppwxxj3jxz8cfgq00jgnxqcny7ryenvkwj6",
        exponent: 0
      }, {
        denom: "mmsft",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1227ppwxxj3jxz8cfgq00jgnxqcny7ryenvkwj6",
      base: "cw20:terra1227ppwxxj3jxz8cfgq00jgnxqcny7ryenvkwj6",
      name: "Microsoft Corporation",
      display: "mmsft",
      symbol: "mMSFT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mmsft.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mmsft.png",
        theme: {
          primary_color_hex: "#04a4ec"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1jsxngqasf2zynj5kyh0tgq9mj3zksa5gk35j4k",
        exponent: 0
      }, {
        denom: "mnflx",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1jsxngqasf2zynj5kyh0tgq9mj3zksa5gk35j4k",
      base: "cw20:terra1jsxngqasf2zynj5kyh0tgq9mj3zksa5gk35j4k",
      name: "Netflix, Inc.",
      display: "mnflx",
      symbol: "mNFLX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnflx.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnflx.png",
        theme: {
          primary_color_hex: "#af040c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1dj2cj02zak0nvwy3uj9r9dhhxhdwxnw6psse6p",
        exponent: 0
      }, {
        denom: "mnio",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1dj2cj02zak0nvwy3uj9r9dhhxhdwxnw6psse6p",
      base: "cw20:terra1dj2cj02zak0nvwy3uj9r9dhhxhdwxnw6psse6p",
      name: "NIO Inc.",
      display: "mnio",
      symbol: "mNIO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnio.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnio.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra17ana8hvzea0q7w367dm0dw48sxwql39qekpt7g",
        exponent: 0
      }, {
        denom: "mnke",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra17ana8hvzea0q7w367dm0dw48sxwql39qekpt7g",
      base: "cw20:terra17ana8hvzea0q7w367dm0dw48sxwql39qekpt7g",
      name: "NIKE, Inc.",
      display: "mnke",
      symbol: "mNKE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnke.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnke.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1drsjzvzej4h4qlehcfwclxg4w5l3h5tuvd3jd8",
        exponent: 0
      }, {
        denom: "mnvda",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1drsjzvzej4h4qlehcfwclxg4w5l3h5tuvd3jd8",
      base: "cw20:terra1drsjzvzej4h4qlehcfwclxg4w5l3h5tuvd3jd8",
      name: "NVIDIA Corporation",
      display: "mnvda",
      symbol: "mNVDA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnvda.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnvda.png",
        theme: {
          primary_color_hex: "#74bc04"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1rh2907984nudl7vh56qjdtvv7947z4dujj92sx",
        exponent: 0
      }, {
        denom: "mpypl",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1rh2907984nudl7vh56qjdtvv7947z4dujj92sx",
      base: "cw20:terra1rh2907984nudl7vh56qjdtvv7947z4dujj92sx",
      name: "PayPal Holdings Inc",
      display: "mpypl",
      symbol: "mPYPL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mpypl.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mpypl.png",
        theme: {
          primary_color_hex: "#24377a"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1csk6tc7pdmpr782w527hwhez6gfv632tyf72cp",
        exponent: 0
      }, {
        denom: "mqqq",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1csk6tc7pdmpr782w527hwhez6gfv632tyf72cp",
      base: "cw20:terra1csk6tc7pdmpr782w527hwhez6gfv632tyf72cp",
      name: "Invesco QQQ Trust",
      display: "mqqq",
      symbol: "mQQQ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mqqq.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mqqq.png",
        theme: {
          primary_color_hex: "#041c7c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1246zy658dfgtausf0c4a6ly8sc2e285q4kxqga",
        exponent: 0
      }, {
        denom: "msbux",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1246zy658dfgtausf0c4a6ly8sc2e285q4kxqga",
      base: "cw20:terra1246zy658dfgtausf0c4a6ly8sc2e285q4kxqga",
      name: "Starbucks Corporation",
      display: "msbux",
      symbol: "mSBUX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/msbux.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/msbux.png",
        theme: {
          primary_color_hex: "#047444"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1kscs6uhrqwy6rx5kuw5lwpuqvm3t6j2d6uf2lp",
        exponent: 0
      }, {
        denom: "mslv",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1kscs6uhrqwy6rx5kuw5lwpuqvm3t6j2d6uf2lp",
      base: "cw20:terra1kscs6uhrqwy6rx5kuw5lwpuqvm3t6j2d6uf2lp",
      name: "iShares Silver Trust",
      display: "mslv",
      symbol: "mSLV",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mslv.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mslv.png",
        theme: {
          primary_color_hex: "#141c2c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1aa00lpfexyycedfg5k2p60l9djcmw0ue5l8fhc",
        exponent: 0
      }, {
        denom: "mspy",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1aa00lpfexyycedfg5k2p60l9djcmw0ue5l8fhc",
      base: "cw20:terra1aa00lpfexyycedfg5k2p60l9djcmw0ue5l8fhc",
      name: "SPDR S&P 500",
      display: "mspy",
      symbol: "mSPY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mspy.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mspy.png",
        theme: {
          primary_color_hex: "#141c2c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1u43zu5amjlsgty5j64445fr9yglhm53m576ugh",
        exponent: 0
      }, {
        denom: "msq",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1u43zu5amjlsgty5j64445fr9yglhm53m576ugh",
      base: "cw20:terra1u43zu5amjlsgty5j64445fr9yglhm53m576ugh",
      name: "Square, Inc.",
      display: "msq",
      symbol: "mSQ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/msq.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/msq.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra14y5affaarufk3uscy2vr6pe6w6zqf2wpjzn5sh",
        exponent: 0
      }, {
        denom: "mtsla",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra14y5affaarufk3uscy2vr6pe6w6zqf2wpjzn5sh",
      base: "cw20:terra14y5affaarufk3uscy2vr6pe6w6zqf2wpjzn5sh",
      name: "Tesla, Inc.",
      display: "mtsla",
      symbol: "mTSLA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mtsla.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mtsla.png",
        theme: {
          primary_color_hex: "#e41c34"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1cc3enj9qgchlrj34cnzhwuclc4vl2z3jl7tkqg",
        exponent: 0
      }, {
        denom: "mtwtr",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1cc3enj9qgchlrj34cnzhwuclc4vl2z3jl7tkqg",
      base: "cw20:terra1cc3enj9qgchlrj34cnzhwuclc4vl2z3jl7tkqg",
      name: "Twitter, Inc.",
      display: "mtwtr",
      symbol: "mTWTR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mtwtr.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mtwtr.png",
        theme: {
          primary_color_hex: "#2cace4"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1lvmx8fsagy70tv0fhmfzdw9h6s3sy4prz38ugf",
        exponent: 0
      }, {
        denom: "muso",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1lvmx8fsagy70tv0fhmfzdw9h6s3sy4prz38ugf",
      base: "cw20:terra1lvmx8fsagy70tv0fhmfzdw9h6s3sy4prz38ugf",
      name: "United States Oil Fund, LP",
      display: "muso",
      symbol: "mUSO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/muso.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/muso.png",
        theme: {
          primary_color_hex: "#141c2c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra19cmt6vzvhnnnfsmccaaxzy2uaj06zjktu6yzjx",
        exponent: 0
      }, {
        denom: "mvixy",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra19cmt6vzvhnnnfsmccaaxzy2uaj06zjktu6yzjx",
      base: "cw20:terra19cmt6vzvhnnnfsmccaaxzy2uaj06zjktu6yzjx",
      name: "ProShares VIX Short-Term Futures ETF",
      display: "mvixy",
      symbol: "mVIXY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mvixy.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mvixy.png",
        theme: {
          primary_color_hex: "#141c2c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1zp3a6q6q4953cz376906g5qfmxnlg77hx3te45",
        exponent: 0
      }, {
        denom: "mvixy",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1zp3a6q6q4953cz376906g5qfmxnlg77hx3te45",
      base: "cw20:terra1zp3a6q6q4953cz376906g5qfmxnlg77hx3te45",
      name: "ProShares VIX Short-Term Futures ETF",
      display: "mvixy",
      symbol: "mVIXY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mvixy.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mvixy.png",
        theme: {
          primary_color_hex: "#141c2c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1ez46kxtulsdv07538fh5ra5xj8l68mu8eg24vr",
        exponent: 0
      }, {
        denom: "lota",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1ez46kxtulsdv07538fh5ra5xj8l68mu8eg24vr",
      base: "cw20:terra1ez46kxtulsdv07538fh5ra5xj8l68mu8eg24vr",
      name: "loterra",
      display: "lota",
      symbol: "LOTA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/lota.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/lota.png",
        theme: {
          primary_color_hex: "#c63adc"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra17jnhankdfl8vyzj6vejt7ag8uz0cjc9crkl2h7",
        exponent: 0
      }, {
        denom: "dph",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra17jnhankdfl8vyzj6vejt7ag8uz0cjc9crkl2h7",
      base: "cw20:terra17jnhankdfl8vyzj6vejt7ag8uz0cjc9crkl2h7",
      name: "Digipharm",
      display: "dph",
      symbol: "DPH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/dph.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/dph.png",
        theme: {
          primary_color_hex: "#2c4c9c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1kcthelkax4j9x8d3ny6sdag0qmxxynl3qtcrpy",
        exponent: 0
      }, {
        denom: "mine",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1kcthelkax4j9x8d3ny6sdag0qmxxynl3qtcrpy",
      base: "cw20:terra1kcthelkax4j9x8d3ny6sdag0qmxxynl3qtcrpy",
      name: "Pylon MINE Token",
      display: "mine",
      symbol: "MINE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mine.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mine.png",
        theme: {
          primary_color_hex: "#042c44"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1zsaswh926ey8qa5x4vj93kzzlfnef0pstuca0y",
        exponent: 0
      }, {
        denom: "bpsidp-24m",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1zsaswh926ey8qa5x4vj93kzzlfnef0pstuca0y",
      base: "cw20:terra1zsaswh926ey8qa5x4vj93kzzlfnef0pstuca0y",
      name: "Pylon bDP Token for Gateway Psi 24m Pool",
      display: "bpsidp-24m",
      symbol: "bPsiDP-24m",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bpsidp-24m.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bpsidp-24m.png",
        theme: {
          primary_color_hex: "#3d6d8e"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1s5eczhe0h0jutf46re52x5z4r03c8hupacxmdr",
        exponent: 0
      }, {
        denom: "spec",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1s5eczhe0h0jutf46re52x5z4r03c8hupacxmdr",
      base: "cw20:terra1s5eczhe0h0jutf46re52x5z4r03c8hupacxmdr",
      name: "Spectrum Token",
      display: "spec",
      symbol: "SPEC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/spec.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/spec.png",
        theme: {
          primary_color_hex: "#fa2d6c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1nef5jf6c7js9x6gkntlehgywvjlpytm7pcgkn4",
        exponent: 0
      }, {
        denom: "loop",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1nef5jf6c7js9x6gkntlehgywvjlpytm7pcgkn4",
      base: "cw20:terra1nef5jf6c7js9x6gkntlehgywvjlpytm7pcgkn4",
      name: "LOOP token",
      display: "loop",
      symbol: "LOOP",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/loop.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/loop.png",
        theme: {
          primary_color_hex: "#04dff9"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1jx4lmmke2srcvpjeereetc9hgegp4g5j0p9r2q",
        exponent: 0
      }, {
        denom: "loopr",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1jx4lmmke2srcvpjeereetc9hgegp4g5j0p9r2q",
      base: "cw20:terra1jx4lmmke2srcvpjeereetc9hgegp4g5j0p9r2q",
      name: "LOOPR token",
      display: "loopr",
      symbol: "LOOPR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/loopr.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/loopr.png",
        theme: {
          primary_color_hex: "#550555"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra13xujxcrc9dqft4p9a8ls0w3j0xnzm6y2uvve8n",
        exponent: 0
      }, {
        denom: "stt",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra13xujxcrc9dqft4p9a8ls0w3j0xnzm6y2uvve8n",
      base: "cw20:terra13xujxcrc9dqft4p9a8ls0w3j0xnzm6y2uvve8n",
      name: "StarTerra Token",
      display: "stt",
      symbol: "STT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/stt.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/stt.png",
        theme: {
          primary_color_hex: "#f5e604"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra19djkaepjjswucys4npd5ltaxgsntl7jf0xz7w6",
        exponent: 0
      }, {
        denom: "twd",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra19djkaepjjswucys4npd5ltaxgsntl7jf0xz7w6",
      base: "cw20:terra19djkaepjjswucys4npd5ltaxgsntl7jf0xz7w6",
      name: "TWD Token",
      display: "twd",
      symbol: "TWD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/twd.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/twd.png",
        theme: {
          primary_color_hex: "#25abe3"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1kvjscdgwuvwc6uzm4rqfjl6nlmuhj28tequlnc",
        exponent: 0
      }, {
        denom: "xtra",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1kvjscdgwuvwc6uzm4rqfjl6nlmuhj28tequlnc",
      base: "cw20:terra1kvjscdgwuvwc6uzm4rqfjl6nlmuhj28tequlnc",
      name: "xterra Token",
      display: "xtra",
      symbol: "XTRA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xtra.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xtra.png",
        theme: {
          primary_color_hex: "#0c9cd4"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1vtr50tw0pgqpes34zqu60n554p9x4950wk8f63",
        exponent: 0
      }, {
        denom: "miaw",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1vtr50tw0pgqpes34zqu60n554p9x4950wk8f63",
      base: "cw20:terra1vtr50tw0pgqpes34zqu60n554p9x4950wk8f63",
      name: "MIAW Token",
      display: "miaw",
      symbol: "MIAW",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/miaw.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/miaw.png",
        theme: {
          primary_color_hex: "#060606"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra12897djskt9rge8dtmm86w654g7kzckkd698608",
        exponent: 0
      }, {
        denom: "psi",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra12897djskt9rge8dtmm86w654g7kzckkd698608",
      base: "cw20:terra12897djskt9rge8dtmm86w654g7kzckkd698608",
      name: "Nexus Governance Token",
      display: "psi",
      symbol: "Psi",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/psi.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/psi.png",
        theme: {
          primary_color_hex: "#1c1c2c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra10f2mt82kjnkxqj2gepgwl637u2w4ue2z5nhz5j",
        exponent: 0
      }, {
        denom: "nluna",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra10f2mt82kjnkxqj2gepgwl637u2w4ue2z5nhz5j",
      base: "cw20:terra10f2mt82kjnkxqj2gepgwl637u2w4ue2z5nhz5j",
      name: "Nexus nLuna Token",
      display: "nluna",
      symbol: "nLuna",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/nluna.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/nluna.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra178v546c407pdnx5rer3hu8s2c0fc924k74ymnn",
        exponent: 0
      }, {
        denom: "neth",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra178v546c407pdnx5rer3hu8s2c0fc924k74ymnn",
      base: "cw20:terra178v546c407pdnx5rer3hu8s2c0fc924k74ymnn",
      name: "Nexus nETH Token",
      display: "neth",
      symbol: "nETH",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/neth.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/neth.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1u553zk43jd4rwzc53qrdrq4jc2p8rextyq09dj",
        exponent: 0
      }, {
        denom: "cnluna",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1u553zk43jd4rwzc53qrdrq4jc2p8rextyq09dj",
      base: "cw20:terra1u553zk43jd4rwzc53qrdrq4jc2p8rextyq09dj",
      name: "nLuna autocompounder share representation",
      display: "cnluna",
      symbol: "cnLuna",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cnluna.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cnluna.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1nagqpmyw55yjphea4rhntlfv87ugmeaj8ym756",
        exponent: 0
      }, {
        denom: "cneth",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1nagqpmyw55yjphea4rhntlfv87ugmeaj8ym756",
      base: "cw20:terra1nagqpmyw55yjphea4rhntlfv87ugmeaj8ym756",
      name: "nETH autocompounder share representation",
      display: "cneth",
      symbol: "cnETH",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cneth.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cneth.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra13k62n0285wj8ug0ngcgpf7dgnkzqeu279tz636",
        exponent: 0
      }, {
        denom: "navax",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra13k62n0285wj8ug0ngcgpf7dgnkzqeu279tz636",
      base: "cw20:terra13k62n0285wj8ug0ngcgpf7dgnkzqeu279tz636",
      name: "Nexus nAVAX Token",
      display: "navax",
      symbol: "nAVAX",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/navax.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/navax.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1jtdc6zpf95tvh9peuaxwp3v0yqszcnwl8j5ade",
        exponent: 0
      }, {
        denom: "natom",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1jtdc6zpf95tvh9peuaxwp3v0yqszcnwl8j5ade",
      base: "cw20:terra1jtdc6zpf95tvh9peuaxwp3v0yqszcnwl8j5ade",
      name: "Nexus nATOM Token",
      display: "natom",
      symbol: "nATOM",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/natom.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/natom.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1dy9kmlm4anr92e42mrkjwzyvfqwz66un00rwr5",
        exponent: 0
      }, {
        denom: "vkr",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1dy9kmlm4anr92e42mrkjwzyvfqwz66un00rwr5",
      base: "cw20:terra1dy9kmlm4anr92e42mrkjwzyvfqwz66un00rwr5",
      name: "VKR Token",
      display: "vkr",
      symbol: "VKR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/vkr.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/vkr.png",
        theme: {
          primary_color_hex: "#1c1c1c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1mddcdx0ujx89f38gu7zspk2r2ffdl5enyz2u03",
        exponent: 0
      }, {
        denom: "orion",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1mddcdx0ujx89f38gu7zspk2r2ffdl5enyz2u03",
      base: "cw20:terra1mddcdx0ujx89f38gu7zspk2r2ffdl5enyz2u03",
      name: "Orion Money (Portal)",
      display: "orion",
      symbol: "ORION",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/orion.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/orion.png",
        theme: {
          primary_color_hex: "#04bc74"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1r5506ckw5tfr3z52jwlek8vg9sn3yflrqrzfsc",
        exponent: 0
      }, {
        denom: "tland",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1r5506ckw5tfr3z52jwlek8vg9sn3yflrqrzfsc",
      base: "cw20:terra1r5506ckw5tfr3z52jwlek8vg9sn3yflrqrzfsc",
      name: "TerraLand Token",
      display: "tland",
      symbol: "TLAND",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tland.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tland.png",
        theme: {
          primary_color_hex: "#c3a990"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1w0p5zre38ecdy3ez8efd5h9fvgum5s206xknrg",
        exponent: 0
      }, {
        denom: "vust",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1w0p5zre38ecdy3ez8efd5h9fvgum5s206xknrg",
      base: "cw20:terra1w0p5zre38ecdy3ez8efd5h9fvgum5s206xknrg",
      name: "Vault UST",
      display: "vust",
      symbol: "vUST",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/vust.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/vust.png",
        theme: {
          primary_color_hex: "#3ccb64"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra14tl83xcwqjy0ken9peu4pjjuu755lrry2uy25r",
        exponent: 0
      }, {
        denom: "eth",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra14tl83xcwqjy0ken9peu4pjjuu755lrry2uy25r",
      base: "cw20:terra14tl83xcwqjy0ken9peu4pjjuu755lrry2uy25r",
      name: "Ether (Portal)",
      display: "eth",
      symbol: "ETH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/eth.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/eth.png",
        theme: {
          primary_color_hex: "#2d2831"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1aa7upykmmqqc63l924l5qfap8mrmx5rfdm0v55",
        exponent: 0
      }, {
        denom: "wbtc",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1aa7upykmmqqc63l924l5qfap8mrmx5rfdm0v55",
      base: "cw20:terra1aa7upykmmqqc63l924l5qfap8mrmx5rfdm0v55",
      name: "Wrapped BTC (Portal)",
      display: "wbtc",
      symbol: "WBTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wbtc.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wbtc.png",
        theme: {
          primary_color_hex: "#f3931e"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra190tqwgqx7s8qrknz6kckct7v607cu068gfujpk",
        exponent: 0
      }, {
        denom: "sol",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra190tqwgqx7s8qrknz6kckct7v607cu068gfujpk",
      base: "cw20:terra190tqwgqx7s8qrknz6kckct7v607cu068gfujpk",
      name: "SOL (Portal)",
      display: "sol",
      symbol: "SOL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sol.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sol.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1dfasranqm4uyaz72r960umxy0w8t6zewqlnkuq",
        exponent: 0
      }, {
        denom: "maticet",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1dfasranqm4uyaz72r960umxy0w8t6zewqlnkuq",
      base: "cw20:terra1dfasranqm4uyaz72r960umxy0w8t6zewqlnkuq",
      name: "MATIC (Portal from Ethereum)",
      display: "maticet",
      symbol: "MATICet",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/maticet.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/maticet.png",
        theme: {
          primary_color_hex: "#8447e1"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1cetg5wruw2wsdjp7j46rj44xdel00z006e9yg8",
        exponent: 0
      }, {
        denom: "bnb",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1cetg5wruw2wsdjp7j46rj44xdel00z006e9yg8",
      base: "cw20:terra1cetg5wruw2wsdjp7j46rj44xdel00z006e9yg8",
      name: "Binance Coin (Portal)",
      display: "bnb",
      symbol: "BNB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bnb.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bnb.png",
        theme: {
          primary_color_hex: "#f4bc2c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1xvqlpjl2dxyel9qrp6qvtrg04xe3jh9cyxc6av",
        exponent: 0
      }, {
        denom: "cake",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1xvqlpjl2dxyel9qrp6qvtrg04xe3jh9cyxc6av",
      base: "cw20:terra1xvqlpjl2dxyel9qrp6qvtrg04xe3jh9cyxc6av",
      name: "PancakeSwap Token (Portal)",
      display: "cake",
      symbol: "CAKE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cake.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cake.png",
        theme: {
          primary_color_hex: "#d0894d"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra12dfv3f0e6m22z6cnhfn3nxk2en3z3zeqy6ctym",
        exponent: 0
      }, {
        denom: "link",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra12dfv3f0e6m22z6cnhfn3nxk2en3z3zeqy6ctym",
      base: "cw20:terra12dfv3f0e6m22z6cnhfn3nxk2en3z3zeqy6ctym",
      name: "Chainlink (Portal)",
      display: "link",
      symbol: "LINK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/link.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/link.png",
        theme: {
          primary_color_hex: "#345cd4"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1csvuzlf92nyemu6tv25h0l79etpe8hz3h5vn4a",
        exponent: 0
      }, {
        denom: "sushi",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1csvuzlf92nyemu6tv25h0l79etpe8hz3h5vn4a",
      base: "cw20:terra1csvuzlf92nyemu6tv25h0l79etpe8hz3h5vn4a",
      name: "SushiToken (Portal)",
      display: "sushi",
      symbol: "SUSHI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sushi.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sushi.png",
        theme: {
          primary_color_hex: "#cd68ac"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1wyxkuy5jq545fn7xfn3enpvs5zg9f9dghf6gxf",
        exponent: 0
      }, {
        denom: "uni",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1wyxkuy5jq545fn7xfn3enpvs5zg9f9dghf6gxf",
      base: "cw20:terra1wyxkuy5jq545fn7xfn3enpvs5zg9f9dghf6gxf",
      name: "Uniswap (Portal)",
      display: "uni",
      symbol: "UNI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/uni.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/uni.png",
        theme: {
          primary_color_hex: "#b01e66"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1ce06wkrdm4vl6t0hvc0g86rsy27pu8yadg3dva",
        exponent: 0
      }, {
        denom: "usdtet",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1ce06wkrdm4vl6t0hvc0g86rsy27pu8yadg3dva",
      base: "cw20:terra1ce06wkrdm4vl6t0hvc0g86rsy27pu8yadg3dva",
      name: "Tether USD (Portal from Ethereum)",
      display: "usdtet",
      symbol: "USDTet",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdtet.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdtet.png",
        theme: {
          primary_color_hex: "#56a995"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1pepwcav40nvj3kh60qqgrk8k07ydmc00xyat06",
        exponent: 0
      }, {
        denom: "usdcet",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1pepwcav40nvj3kh60qqgrk8k07ydmc00xyat06",
      base: "cw20:terra1pepwcav40nvj3kh60qqgrk8k07ydmc00xyat06",
      name: "USD Coin (Portal from Ethereum)",
      display: "usdcet",
      symbol: "USDCet",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdcet.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdcet.png",
        theme: {
          primary_color_hex: "#2a75c9"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1xfsdgcemqwxp4hhnyk4rle6wr22sseq7j07dnn",
        exponent: 0
      }, {
        denom: "kuji",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1xfsdgcemqwxp4hhnyk4rle6wr22sseq7j07dnn",
      base: "cw20:terra1xfsdgcemqwxp4hhnyk4rle6wr22sseq7j07dnn",
      name: "Kujira Token",
      display: "kuji",
      symbol: "KUJI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/kuji.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/kuji.png",
        theme: {
          primary_color_hex: "#24242c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra188w26t95tf4dz77raftme8p75rggatxjxfeknw",
        exponent: 0
      }, {
        denom: "skuji",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra188w26t95tf4dz77raftme8p75rggatxjxfeknw",
      base: "cw20:terra188w26t95tf4dz77raftme8p75rggatxjxfeknw",
      name: "Staked KUJI",
      display: "skuji",
      symbol: "sKUJI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/skuji.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/skuji.png",
        theme: {
          primary_color_hex: "#252933"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra133chr09wu8sakfte5v7vd8qzq9vghtkv4tn0ur",
        exponent: 0
      }, {
        denom: "wsteth",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra133chr09wu8sakfte5v7vd8qzq9vghtkv4tn0ur",
      base: "cw20:terra133chr09wu8sakfte5v7vd8qzq9vghtkv4tn0ur",
      name: "Lido wstETH (Portal)",
      display: "wsteth",
      symbol: "wstETH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wsteth.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wsteth.png",
        theme: {
          primary_color_hex: "#9cdcfc"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1t9ul45l7m6jw6sxgvnp8e5hj8xzkjsg82g84ap",
        exponent: 0
      }, {
        denom: "wstsol",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1t9ul45l7m6jw6sxgvnp8e5hj8xzkjsg82g84ap",
      base: "cw20:terra1t9ul45l7m6jw6sxgvnp8e5hj8xzkjsg82g84ap",
      name: "Lido wstSOL (Portal)",
      display: "wstsol",
      symbol: "wstSOL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wstsol.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wstsol.png",
        theme: {
          primary_color_hex: "#1dbffc"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1c3xd5s2j3ejx2d94tvcjfkrdeu6rmz48ghzznj",
        exponent: 0
      }, {
        denom: "wsbsol",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1c3xd5s2j3ejx2d94tvcjfkrdeu6rmz48ghzznj",
      base: "cw20:terra1c3xd5s2j3ejx2d94tvcjfkrdeu6rmz48ghzznj",
      name: "Lido bonded SOL (Portal)",
      display: "wsbsol",
      symbol: "wsbSOL",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wsbsol.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wsbsol.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1jxypgnfa07j6w92wazzyskhreq2ey2a5crgt6z",
        exponent: 0
      }, {
        denom: "ldo",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1jxypgnfa07j6w92wazzyskhreq2ey2a5crgt6z",
      base: "cw20:terra1jxypgnfa07j6w92wazzyskhreq2ey2a5crgt6z",
      name: "Lido DAO (Portal)",
      display: "ldo",
      symbol: "LDO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ldo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ldo.png",
        theme: {
          primary_color_hex: "#f49c8c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1u5szg038ur9kzuular3cae8hq6q5rk5u27tuvz",
        exponent: 0
      }, {
        denom: "webeth",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1u5szg038ur9kzuular3cae8hq6q5rk5u27tuvz",
      base: "cw20:terra1u5szg038ur9kzuular3cae8hq6q5rk5u27tuvz",
      name: "Lido Bonded ETH (Wormhole)",
      display: "webeth",
      symbol: "webETH",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/webeth.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/webeth.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1yg3j2s986nyp5z7r2lvt0hx3r0lnd7kwvwwtsc",
        exponent: 0
      }, {
        denom: "stluna",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1yg3j2s986nyp5z7r2lvt0hx3r0lnd7kwvwwtsc",
      base: "cw20:terra1yg3j2s986nyp5z7r2lvt0hx3r0lnd7kwvwwtsc",
      name: "Lido staked Luna",
      display: "stluna",
      symbol: "stLuna",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/stluna.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/stluna.png",
        theme: {
          primary_color_hex: "#1fc0fb"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra169edevav3pdrtjcx35j6pvzuv54aevewar4nlh",
        exponent: 0
      }, {
        denom: "xdefi",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra169edevav3pdrtjcx35j6pvzuv54aevewar4nlh",
      base: "cw20:terra169edevav3pdrtjcx35j6pvzuv54aevewar4nlh",
      name: "XDEFI (Portal)",
      display: "xdefi",
      symbol: "XDEFI"
    },
    {
      denom_units: [{
        denom: "cw20:terra193c42lfwmlkasvcw22l9qqzc5q2dx208tkd7wl",
        exponent: 0
      }, {
        denom: "btl",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra193c42lfwmlkasvcw22l9qqzc5q2dx208tkd7wl",
      base: "cw20:terra193c42lfwmlkasvcw22l9qqzc5q2dx208tkd7wl",
      name: "Bitlocus Token",
      display: "btl",
      symbol: "BTL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/btl.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/btl.png",
        theme: {
          primary_color_hex: "#5cbc8c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra17y9qkl8dfkeg4py7n0g5407emqnemc3yqk5rup",
        exponent: 0
      }, {
        denom: "lunax",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra17y9qkl8dfkeg4py7n0g5407emqnemc3yqk5rup",
      base: "cw20:terra17y9qkl8dfkeg4py7n0g5407emqnemc3yqk5rup",
      name: "LunaX Token",
      display: "lunax",
      symbol: "LunaX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/lunax.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/lunax.png",
        theme: {
          primary_color_hex: "#cdcdce"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1m3tdguf59xq3pa2twk5fjte5g6szj5y9x5npy7",
        exponent: 0
      }, {
        denom: "luni",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1m3tdguf59xq3pa2twk5fjte5g6szj5y9x5npy7",
      base: "cw20:terra1m3tdguf59xq3pa2twk5fjte5g6szj5y9x5npy7",
      name: "LUNI",
      display: "luni",
      symbol: "LUNI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luni.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luni.png",
        theme: {
          primary_color_hex: "#232742"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra13awdgcx40tz5uygkgm79dytez3x87rpg4uhnvu",
        exponent: 0
      }, {
        denom: "ply",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra13awdgcx40tz5uygkgm79dytez3x87rpg4uhnvu",
      base: "cw20:terra13awdgcx40tz5uygkgm79dytez3x87rpg4uhnvu",
      name: "PlayNity Token",
      display: "ply",
      symbol: "PLY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ply.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ply.png",
        theme: {
          primary_color_hex: "#070706"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1u2k0nkenw0p25ljsr4ksh7rxm65y466vkdewwj",
        exponent: 0
      }, {
        denom: "tfloki",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1u2k0nkenw0p25ljsr4ksh7rxm65y466vkdewwj",
      base: "cw20:terra1u2k0nkenw0p25ljsr4ksh7rxm65y466vkdewwj",
      name: "TFLOKI",
      display: "tfloki",
      symbol: "TFLOKI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tfloki.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tfloki.png",
        theme: {
          primary_color_hex: "#f6c911"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1a8k3jyv3wf6k3zngza5h6srrxcckdf7zv90p6u",
        exponent: 0
      }, {
        denom: "tftic",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1a8k3jyv3wf6k3zngza5h6srrxcckdf7zv90p6u",
      base: "cw20:terra1a8k3jyv3wf6k3zngza5h6srrxcckdf7zv90p6u",
      name: "TFLOKI Genesis Ticket",
      display: "tftic",
      symbol: "TFTIC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tftic.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tftic.png",
        theme: {
          primary_color_hex: "#1c1c1b"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1xt9fgu7965kgvunnjts9zkprd8986kcc444q86",
        exponent: 0
      }, {
        denom: "tfticii",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1xt9fgu7965kgvunnjts9zkprd8986kcc444q86",
      base: "cw20:terra1xt9fgu7965kgvunnjts9zkprd8986kcc444q86",
      name: "TFLOKI New World Ticket",
      display: "tfticii",
      symbol: "TFTICII",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tfticii.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tfticii.png",
        theme: {
          primary_color_hex: "#1c1c1b"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1vte2xv7dr8sfnrnwdf9arcyprqgr0hty5ads28",
        exponent: 0
      }, {
        denom: "tfticiii",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1vte2xv7dr8sfnrnwdf9arcyprqgr0hty5ads28",
      base: "cw20:terra1vte2xv7dr8sfnrnwdf9arcyprqgr0hty5ads28",
      name: "TFLOKI Aviator Ticket",
      display: "tfticiii",
      symbol: "TFTICIII",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tfticiii.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tfticiii.png",
        theme: {
          primary_color_hex: "#1c1c1b"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1hmxxq0y8h79f3228vs0czc4uz5jdgjt0appp26",
        exponent: 0
      }, {
        denom: "moon",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1hmxxq0y8h79f3228vs0czc4uz5jdgjt0appp26",
      base: "cw20:terra1hmxxq0y8h79f3228vs0czc4uz5jdgjt0appp26",
      name: "Moon Token",
      display: "moon",
      symbol: "MOON",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/moon.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/moon.png",
        theme: {
          primary_color_hex: "#ebb30c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1xj49zyqrwpv5k928jwfpfy2ha668nwdgkwlrg3",
        exponent: 0
      }, {
        denom: "astro",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1xj49zyqrwpv5k928jwfpfy2ha668nwdgkwlrg3",
      base: "cw20:terra1xj49zyqrwpv5k928jwfpfy2ha668nwdgkwlrg3",
      name: "Astroport Token",
      display: "astro",
      symbol: "ASTRO",
      traces: [{
        type: "additional-mintage",
        counterparty: {
          chain_name: "terra2",
          base_denom: "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26"
        },
        provider: "Astroport"
      }],
      images: [{
        image_sync: {
          chain_name: "terra2",
          base_denom: "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/astro-cw20.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/astro-cw20.svg"
      }
    },
    {
      denom_units: [{
        denom: "cw20:terra14lpnyzc9z4g3ugr4lhm8s4nle0tq8vcltkhzh7",
        exponent: 0
      }, {
        denom: "xastro.cw20",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra14lpnyzc9z4g3ugr4lhm8s4nle0tq8vcltkhzh7",
      base: "cw20:terra14lpnyzc9z4g3ugr4lhm8s4nle0tq8vcltkhzh7",
      name: "Staked Astroport Token",
      display: "xastro.cw20",
      symbol: "xASTRO.cw20",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xastro-cw20.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xastro-cw20.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1w8kvd6cqpsthupsk4l0clwnmek4l3zr7c84kwq",
        exponent: 0
      }, {
        denom: "halo",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1w8kvd6cqpsthupsk4l0clwnmek4l3zr7c84kwq",
      base: "cw20:terra1w8kvd6cqpsthupsk4l0clwnmek4l3zr7c84kwq",
      name: "Angel Protocol Token",
      display: "halo",
      symbol: "HALO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/halo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/halo.png",
        theme: {
          primary_color_hex: "#54a4dc"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1kdfsdm3c4reun9j3m4mk3nmyw4a4ns7mj24q3j",
        exponent: 0
      }, {
        denom: "pug",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1kdfsdm3c4reun9j3m4mk3nmyw4a4ns7mj24q3j",
      base: "cw20:terra1kdfsdm3c4reun9j3m4mk3nmyw4a4ns7mj24q3j",
      name: "AstroPug Token",
      display: "pug",
      symbol: "PUG",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/pug.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/pug.png",
        theme: {
          primary_color_hex: "#252424"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1hnezwjqlhzawcrfysczcxs6xqxu2jawn729kkf",
        exponent: 0
      }, {
        denom: "orne",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1hnezwjqlhzawcrfysczcxs6xqxu2jawn729kkf",
      base: "cw20:terra1hnezwjqlhzawcrfysczcxs6xqxu2jawn729kkf",
      name: "Orne Token",
      display: "orne",
      symbol: "ORNE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/orne.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/orne.png",
        theme: {
          primary_color_hex: "#fbfbfb"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra14vz4v8adanzph278xyeggll4tfww7teh0xtw2y",
        exponent: 0
      }, {
        denom: "tns",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra14vz4v8adanzph278xyeggll4tfww7teh0xtw2y",
      base: "cw20:terra14vz4v8adanzph278xyeggll4tfww7teh0xtw2y",
      name: "Terra Name Service",
      display: "tns",
      symbol: "TNS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tns.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tns.png",
        theme: {
          primary_color_hex: "#2442cf"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1td743l5k5cmfy7tqq202g7vkmdvq35q48u2jfm",
        exponent: 0
      }, {
        denom: "xrune",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1td743l5k5cmfy7tqq202g7vkmdvq35q48u2jfm",
      base: "cw20:terra1td743l5k5cmfy7tqq202g7vkmdvq35q48u2jfm",
      name: "Thorstarter",
      display: "xrune",
      symbol: "XRUNE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xrune.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xrune.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1366wmr8t8rrkh6mag8fagqxntmf2qe4kyte784",
        exponent: 0
      }, {
        denom: "alot",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1366wmr8t8rrkh6mag8fagqxntmf2qe4kyte784",
      base: "cw20:terra1366wmr8t8rrkh6mag8fagqxntmf2qe4kyte784",
      name: "Alpha Pack Token",
      display: "alot",
      symbol: "aLOT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/alot.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/alot.png",
        theme: {
          primary_color_hex: "#c7bea1"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1z09gnzufuflz6ckd9k0u456l9dnpgsynu0yyhe",
        exponent: 0
      }, {
        denom: "sity",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1z09gnzufuflz6ckd9k0u456l9dnpgsynu0yyhe",
      base: "cw20:terra1z09gnzufuflz6ckd9k0u456l9dnpgsynu0yyhe",
      name: "CurioSITY play to earn token",
      display: "sity",
      symbol: "SITY",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sity.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sity.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra13zx49nk8wjavedjzu8xkk95r3t0ta43c9ptul7",
        exponent: 0
      }, {
        denom: "glow",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra13zx49nk8wjavedjzu8xkk95r3t0ta43c9ptul7",
      base: "cw20:terra13zx49nk8wjavedjzu8xkk95r3t0ta43c9ptul7",
      name: "Glow Token",
      display: "glow",
      symbol: "GLOW",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/glow.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/glow.png",
        theme: {
          primary_color_hex: "#262238"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra100yeqvww74h4yaejj6h733thgcafdaukjtw397",
        exponent: 0
      }, {
        denom: "apollo",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra100yeqvww74h4yaejj6h733thgcafdaukjtw397",
      base: "cw20:terra100yeqvww74h4yaejj6h733thgcafdaukjtw397",
      name: "Apollo DAO Token",
      display: "apollo",
      symbol: "APOLLO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/apollo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/apollo.png",
        theme: {
          primary_color_hex: "#10192a"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1a7ye2splpfzyenu0yrdu8t83uzgusx2malkc7u",
        exponent: 0
      }, {
        denom: "abr",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1a7ye2splpfzyenu0yrdu8t83uzgusx2malkc7u",
      base: "cw20:terra1a7ye2splpfzyenu0yrdu8t83uzgusx2malkc7u",
      name: "Allbridge",
      display: "abr",
      symbol: "ABR",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/abr.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/abr.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1y3d5qexmyac0fg53pfglh2pjk0664ymfvcq9mc",
        exponent: 0
      }, {
        denom: "whgtps",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1y3d5qexmyac0fg53pfglh2pjk0664ymfvcq9mc",
      base: "cw20:terra1y3d5qexmyac0fg53pfglh2pjk0664ymfvcq9mc",
      name: "Global Transaction Payment Solu",
      display: "whgtps",
      symbol: "whGTPS"
    },
    {
      denom_units: [{
        denom: "cw20:terra1dh9478k2qvqhqeajhn75a2a7dsnf74y5ukregw",
        exponent: 0
      }, {
        denom: "prism",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1dh9478k2qvqhqeajhn75a2a7dsnf74y5ukregw",
      base: "cw20:terra1dh9478k2qvqhqeajhn75a2a7dsnf74y5ukregw",
      name: "Prism Protocol Token",
      display: "prism",
      symbol: "PRISM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/prism.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/prism.png",
        theme: {
          primary_color_hex: "#f6f6f6"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1l0y8yg0s86x299nqw0p6fhh7ngex3r4phtjeuq",
        exponent: 0
      }, {
        denom: "sdollar",
        exponent: 2
      }],
      type_asset: "cw20",
      address: "terra1l0y8yg0s86x299nqw0p6fhh7ngex3r4phtjeuq",
      base: "cw20:terra1l0y8yg0s86x299nqw0p6fhh7ngex3r4phtjeuq",
      name: "Space Dollar",
      display: "sdollar",
      symbol: "SDOLLAR"
    },
    {
      denom_units: [{
        denom: "cw20:terra1ku5e0dhutxhuxudsmsn5647wwcz6ndr3rsh90k",
        exponent: 0
      }, {
        denom: "whsail",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1ku5e0dhutxhuxudsmsn5647wwcz6ndr3rsh90k",
      base: "cw20:terra1ku5e0dhutxhuxudsmsn5647wwcz6ndr3rsh90k",
      name: "SAIL",
      display: "whsail",
      symbol: "whSAIL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/whsail.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/whsail.png",
        theme: {
          primary_color_hex: "#0472b3"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1rl0cpwgtwl4utnaynugevdje37fnmsea7rv4uu",
        exponent: 0
      }, {
        denom: "whgsail",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1rl0cpwgtwl4utnaynugevdje37fnmsea7rv4uu",
      base: "cw20:terra1rl0cpwgtwl4utnaynugevdje37fnmsea7rv4uu",
      name: "SolanaSail Governance Token V2",
      display: "whgsail",
      symbol: "whgSAIL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/whgsail.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/whgsail.png",
        theme: {
          primary_color_hex: "#046baa"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1042wzrwg2uk6jqxjm34ysqquyr9esdgm5qyswz",
        exponent: 0
      }, {
        denom: "xprism",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1042wzrwg2uk6jqxjm34ysqquyr9esdgm5qyswz",
      base: "cw20:terra1042wzrwg2uk6jqxjm34ysqquyr9esdgm5qyswz",
      name: "Prism Governance Token",
      display: "xprism",
      symbol: "xPRISM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xprism.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xprism.png",
        theme: {
          primary_color_hex: "#242434"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra13fs83g5atgjwuh7c5ydzh6n7gecel6xyhhy2t5",
        exponent: 0
      }, {
        denom: "cde",
        exponent: 9
      }],
      type_asset: "cw20",
      address: "terra13fs83g5atgjwuh7c5ydzh6n7gecel6xyhhy2t5",
      base: "cw20:terra13fs83g5atgjwuh7c5ydzh6n7gecel6xyhhy2t5",
      name: "CAPITRADE TOKEN",
      display: "cde",
      symbol: "CDE"
    },
    {
      denom_units: [{
        denom: "cw20:terra1rl20t79ffsrqfa29rke48tj05gj9jxumm92vg8",
        exponent: 0
      }, {
        denom: "ctx",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1rl20t79ffsrqfa29rke48tj05gj9jxumm92vg8",
      base: "cw20:terra1rl20t79ffsrqfa29rke48tj05gj9jxumm92vg8",
      name: "C2X Token",
      display: "ctx",
      symbol: "CTX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ctx.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ctx.png",
        theme: {
          primary_color_hex: "#04b4fc"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra13zaagrrrxj47qjwczsczujlvnnntde7fdt0mau",
        exponent: 0
      }, {
        denom: "cluna",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra13zaagrrrxj47qjwczsczujlvnnntde7fdt0mau",
      base: "cw20:terra13zaagrrrxj47qjwczsczujlvnnntde7fdt0mau",
      name: "Prism cLuna Token",
      display: "cluna",
      symbol: "cLuna",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cluna.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cluna.png",
        theme: {
          primary_color_hex: "#211f2e"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1tlgelulz9pdkhls6uglfn5lmxarx7f2gxtdzh2",
        exponent: 0
      }, {
        denom: "pluna",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1tlgelulz9pdkhls6uglfn5lmxarx7f2gxtdzh2",
      base: "cw20:terra1tlgelulz9pdkhls6uglfn5lmxarx7f2gxtdzh2",
      name: "Prism pLuna Token",
      display: "pluna",
      symbol: "pLuna",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/pluna.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/pluna.png",
        theme: {
          primary_color_hex: "#202030"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra17wkadg0tah554r35x6wvff0y5s7ve8npcjfuhz",
        exponent: 0
      }, {
        denom: "yluna",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra17wkadg0tah554r35x6wvff0y5s7ve8npcjfuhz",
      base: "cw20:terra17wkadg0tah554r35x6wvff0y5s7ve8npcjfuhz",
      name: "Prism yLuna Token",
      display: "yluna",
      symbol: "yLuna",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/yluna.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/yluna.png",
        theme: {
          primary_color_hex: "#202130"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1cl7whtrqmz5ldr553q69qahck8xvk80fm33qjx",
        exponent: 0
      }, {
        denom: "atlo",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1cl7whtrqmz5ldr553q69qahck8xvk80fm33qjx",
      base: "cw20:terra1cl7whtrqmz5ldr553q69qahck8xvk80fm33qjx",
      name: "Atlo Token",
      display: "atlo",
      symbol: "ATLO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/atlo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/atlo.png",
        theme: {
          primary_color_hex: "#1b3667"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1vchw83qt25j89zqwdpmdzj722sqxthnckqzxxp",
        exponent: 0
      }, {
        denom: "local",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1vchw83qt25j89zqwdpmdzj722sqxthnckqzxxp",
      base: "cw20:terra1vchw83qt25j89zqwdpmdzj722sqxthnckqzxxp",
      name: "LOCAL Token",
      display: "local",
      symbol: "LOCAL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/local.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/local.png",
        theme: {
          primary_color_hex: "#242424"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra15k5r9r8dl8r7xlr29pry8a9w7sghehcnv5mgp6",
        exponent: 0
      }, {
        denom: "luv",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra15k5r9r8dl8r7xlr29pry8a9w7sghehcnv5mgp6",
      base: "cw20:terra15k5r9r8dl8r7xlr29pry8a9w7sghehcnv5mgp6",
      name: "Lunaverse",
      display: "luv",
      symbol: "LUV",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luv.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luv.png",
        theme: {
          primary_color_hex: "#f7a02f"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1f62tqesptvmhtzr8sudru00gsdtdz24srgm7wp",
        exponent: 0
      }, {
        denom: "robo",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1f62tqesptvmhtzr8sudru00gsdtdz24srgm7wp",
      base: "cw20:terra1f62tqesptvmhtzr8sudru00gsdtdz24srgm7wp",
      name: "RoboHero",
      display: "robo",
      symbol: "ROBO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/robo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/robo.png",
        theme: {
          primary_color_hex: "#2473d2"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1vwz7t30q76s7xx6qgtxdqnu6vpr3ak3vw62ygk",
        exponent: 0
      }, {
        denom: "luart",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1vwz7t30q76s7xx6qgtxdqnu6vpr3ak3vw62ygk",
      base: "cw20:terra1vwz7t30q76s7xx6qgtxdqnu6vpr3ak3vw62ygk",
      name: "Luart Token",
      display: "luart",
      symbol: "LUART",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luart.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luart.png",
        theme: {
          primary_color_hex: "#1b1429"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra12hgwnpupflfpuual532wgrxu2gjp0tcagzgx4n",
        exponent: 0
      }, {
        denom: "mars",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra12hgwnpupflfpuual532wgrxu2gjp0tcagzgx4n",
      base: "cw20:terra12hgwnpupflfpuual532wgrxu2gjp0tcagzgx4n",
      name: "Mars Token",
      display: "mars",
      symbol: "MARS",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mars.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mars.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1a04v570f9cxp49mk06vjsm8axsswndpwwt67k4",
        exponent: 0
      }, {
        denom: "xmars",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1a04v570f9cxp49mk06vjsm8axsswndpwwt67k4",
      base: "cw20:terra1a04v570f9cxp49mk06vjsm8axsswndpwwt67k4",
      name: "xMars Token",
      display: "xmars",
      symbol: "XMARS",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xmars.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xmars.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1vpws4hmpmpsqwnz3gljn8zj42rv7rkpc5atgt4",
        exponent: 0
      }, {
        denom: "dfiat",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1vpws4hmpmpsqwnz3gljn8zj42rv7rkpc5atgt4",
      base: "cw20:terra1vpws4hmpmpsqwnz3gljn8zj42rv7rkpc5atgt4",
      name: "DeFiato",
      display: "dfiat",
      symbol: "DFIAT"
    },
    {
      denom_units: [{
        denom: "cw20:terra1hppnw4jppmrzzga4yvd8s87y3dwkhe27xwwl5d",
        exponent: 0
      }, {
        denom: "ceres",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1hppnw4jppmrzzga4yvd8s87y3dwkhe27xwwl5d",
      base: "cw20:terra1hppnw4jppmrzzga4yvd8s87y3dwkhe27xwwl5d",
      name: "Ceres Governance Token",
      display: "ceres",
      symbol: "CERES",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ceres.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ceres.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1z3e2e4jpk4n0xzzwlkgcfvc95pc5ldq0xcny58",
        exponent: 0
      }, {
        denom: "wasavax",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1z3e2e4jpk4n0xzzwlkgcfvc95pc5ldq0xcny58",
      base: "cw20:terra1z3e2e4jpk4n0xzzwlkgcfvc95pc5ldq0xcny58",
      name: "BENQI Staked AVAX (Portal)",
      display: "wasavax",
      symbol: "wasAVAX",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wasavax.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wasavax.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1zd6let0zg0xjn2sestagxv4ax24a4ml6j40qdr",
        exponent: 0
      }, {
        denom: "mint",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1zd6let0zg0xjn2sestagxv4ax24a4ml6j40qdr",
      base: "cw20:terra1zd6let0zg0xjn2sestagxv4ax24a4ml6j40qdr",
      name: "MintDAO",
      display: "mint",
      symbol: "MINT",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mint.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mint.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1ustvnmngueq0p4jd7gfnutgvdc6ujpsjhsjd02",
        exponent: 0
      }, {
        denom: "sd",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1ustvnmngueq0p4jd7gfnutgvdc6ujpsjhsjd02",
      base: "cw20:terra1ustvnmngueq0p4jd7gfnutgvdc6ujpsjhsjd02",
      name: "Stader SD (Portal)",
      display: "sd",
      symbol: "SD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sd.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sd.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1ln2z938phz0nc2wepxpzfkwp6ezn9yrz9zv9ep",
        exponent: 0
      }, {
        denom: "xsd",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1ln2z938phz0nc2wepxpzfkwp6ezn9yrz9zv9ep",
      base: "cw20:terra1ln2z938phz0nc2wepxpzfkwp6ezn9yrz9zv9ep",
      name: "Stader xSD",
      display: "xsd",
      symbol: "xSD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xsd.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/xsd.png",
        theme: {
          primary_color_hex: "#f3f3f3"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1uux6gwd6pzr0gfzrru5kne55cxex9d0700c72r",
        exponent: 0
      }, {
        denom: "paxg",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1uux6gwd6pzr0gfzrru5kne55cxex9d0700c72r",
      base: "cw20:terra1uux6gwd6pzr0gfzrru5kne55cxex9d0700c72r",
      name: "Paxos Gold (Portal)",
      display: "paxg",
      symbol: "PAXG",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/paxg.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/paxg.png",
        theme: {
          primary_color_hex: "#848484"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1efjugpjc50d8sha7lr8s48cr7wmsthz94eevcl",
        exponent: 0
      }, {
        denom: "whdao",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1efjugpjc50d8sha7lr8s48cr7wmsthz94eevcl",
      base: "cw20:terra1efjugpjc50d8sha7lr8s48cr7wmsthz94eevcl",
      name: "DAO Maker",
      display: "whdao",
      symbol: "whDAO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/whdao.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/whdao.png",
        theme: {
          primary_color_hex: "#2c2c44"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1su6g4t4vwx7y0uh3ksancyaurj4l6w9pfs40qt",
        exponent: 0
      }, {
        denom: "link",
        exponent: 18
      }],
      type_asset: "cw20",
      address: "terra1su6g4t4vwx7y0uh3ksancyaurj4l6w9pfs40qt",
      base: "cw20:terra1su6g4t4vwx7y0uh3ksancyaurj4l6w9pfs40qt",
      name: "ChainLink Token",
      display: "link",
      symbol: "LINK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/link.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/link.png",
        theme: {
          primary_color_hex: "#345cd4"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra14v9wrjs55qsn9lkvylsqela3w2ytwxzkycqzcr",
        exponent: 0
      }, {
        denom: "sayve",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra14v9wrjs55qsn9lkvylsqela3w2ytwxzkycqzcr",
      base: "cw20:terra14v9wrjs55qsn9lkvylsqela3w2ytwxzkycqzcr",
      name: "Sayve Token",
      display: "sayve",
      symbol: "SAYVE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sayve.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sayve.png",
        theme: {
          primary_color_hex: "#f3ebdb"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1z55rhw0ut70jxdmpvge98mvj0rkwcz74q77z0u",
        exponent: 0
      }, {
        denom: "guides",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1z55rhw0ut70jxdmpvge98mvj0rkwcz74q77z0u",
      base: "cw20:terra1z55rhw0ut70jxdmpvge98mvj0rkwcz74q77z0u",
      name: "Guides Token",
      display: "guides",
      symbol: "GUIDES"
    },
    {
      denom_units: [{
        denom: "cw20:terra1mt2ytlrxhvd5c4d4fshxxs3zcus3fkdmuv4mk2",
        exponent: 0
      }, {
        denom: "bro",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1mt2ytlrxhvd5c4d4fshxxs3zcus3fkdmuv4mk2",
      base: "cw20:terra1mt2ytlrxhvd5c4d4fshxxs3zcus3fkdmuv4mk2",
      name: "BRO token",
      display: "bro",
      symbol: "BRO",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bro.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bro.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1qryq5wreecx2wd3cdtzz94syr4z0a92l60asds",
        exponent: 0
      }, {
        denom: "bbro",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1qryq5wreecx2wd3cdtzz94syr4z0a92l60asds",
      base: "cw20:terra1qryq5wreecx2wd3cdtzz94syr4z0a92l60asds",
      name: "bBRO token",
      display: "bbro",
      symbol: "bBRO",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bbro.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bbro.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra15zvyhmv6gwddht7kt4q6w5nasn4tcpgzcdfmgr",
        exponent: 0
      }, {
        denom: "gtps",
        exponent: 18
      }],
      type_asset: "cw20",
      address: "terra15zvyhmv6gwddht7kt4q6w5nasn4tcpgzcdfmgr",
      base: "cw20:terra15zvyhmv6gwddht7kt4q6w5nasn4tcpgzcdfmgr",
      name: "Global Transaction Payment Solut",
      display: "gtps",
      symbol: "GTPS"
    },
    {
      denom_units: [{
        denom: "cw20:terra15pkdjxv2ewjzn9x665y26pfz2h6ymak4d4e8se",
        exponent: 0
      }, {
        denom: "gfi",
        exponent: 18
      }],
      type_asset: "cw20",
      address: "terra15pkdjxv2ewjzn9x665y26pfz2h6ymak4d4e8se",
      base: "cw20:terra15pkdjxv2ewjzn9x665y26pfz2h6ymak4d4e8se",
      name: "Gtps.Finance",
      display: "gfi",
      symbol: "GFI"
    },
    {
      denom_units: [{
        denom: "cw20:terra1fyjsxx73jrufw8ufgtuswa773dvdkny92k70wa",
        exponent: 0
      }, {
        denom: "ulc",
        exponent: 18
      }],
      type_asset: "cw20",
      address: "terra1fyjsxx73jrufw8ufgtuswa773dvdkny92k70wa",
      base: "cw20:terra1fyjsxx73jrufw8ufgtuswa773dvdkny92k70wa",
      name: "Ultimatalioniscoin",
      display: "ulc",
      symbol: "ULC"
    },
    {
      denom_units: [{
        denom: "cw20:terra1689ys6p6gfu0q6xrjqkzfn80sdyhurjqn0jfdl",
        exponent: 0
      }, {
        denom: "sst",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1689ys6p6gfu0q6xrjqkzfn80sdyhurjqn0jfdl",
      base: "cw20:terra1689ys6p6gfu0q6xrjqkzfn80sdyhurjqn0jfdl",
      name: "Sooah Studio Token",
      display: "sst",
      symbol: "SST",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sst.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sst.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1rg8f993m9834afwazersesgx7jjxv4p87q9wvc",
        exponent: 0
      }, {
        denom: "atlas",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1rg8f993m9834afwazersesgx7jjxv4p87q9wvc",
      base: "cw20:terra1rg8f993m9834afwazersesgx7jjxv4p87q9wvc",
      name: "Star Atlas (Portal)",
      display: "atlas",
      symbol: "ATLAS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/atlas.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/atlas.png",
        theme: {
          primary_color_hex: "#c77a91"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1nc6flp57m5hsr6y5y8aexzszy43ksr0drdr8rp",
        exponent: 0
      }, {
        denom: "audio",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1nc6flp57m5hsr6y5y8aexzszy43ksr0drdr8rp",
      base: "cw20:terra1nc6flp57m5hsr6y5y8aexzszy43ksr0drdr8rp",
      name: "Audius (Portal)",
      display: "audio",
      symbol: "AUDIO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/audio.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/audio.png",
        theme: {
          primary_color_hex: "#7d1dc0"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1hj8de24c3yqvcsv9r8chr03fzwsak3hgd8gv3m",
        exponent: 0
      }, {
        denom: "avax",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1hj8de24c3yqvcsv9r8chr03fzwsak3hgd8gv3m",
      base: "cw20:terra1hj8de24c3yqvcsv9r8chr03fzwsak3hgd8gv3m",
      name: "AVAX (Portal)",
      display: "avax",
      symbol: "AVAX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/avax.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/avax.png",
        theme: {
          primary_color_hex: "#e74245"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1apxgj5agkkfdm2tprwvykug0qtahxvfmugnhx2",
        exponent: 0
      }, {
        denom: "bat",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1apxgj5agkkfdm2tprwvykug0qtahxvfmugnhx2",
      base: "cw20:terra1apxgj5agkkfdm2tprwvykug0qtahxvfmugnhx2",
      name: "Basic Attention Token (Portal)",
      display: "bat",
      symbol: "BAT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bat.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/bat.png",
        theme: {
          primary_color_hex: "#f75108"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1skjr69exm6v8zellgjpaa2emhwutrk5a6dz7dd",
        exponent: 0
      }, {
        denom: "busdbs",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1skjr69exm6v8zellgjpaa2emhwutrk5a6dz7dd",
      base: "cw20:terra1skjr69exm6v8zellgjpaa2emhwutrk5a6dz7dd",
      name: "Binance USD (Portal from BSC)",
      display: "busdbs",
      symbol: "BUSDbs",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/busdbs.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/busdbs.png",
        theme: {
          primary_color_hex: "#f4bc0f"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1zmclyfepfmqvfqflu8r3lv6f75trmg05z7xq95",
        exponent: 0
      }, {
        denom: "dai",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1zmclyfepfmqvfqflu8r3lv6f75trmg05z7xq95",
      base: "cw20:terra1zmclyfepfmqvfqflu8r3lv6f75trmg05z7xq95",
      name: "DAI (Portal)",
      display: "dai",
      symbol: "DAI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/dai.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/dai.png",
        theme: {
          primary_color_hex: "#fbb932"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1dtqlfecglk47yplfrtwjzyagkgcqqngd5lgjp8",
        exponent: 0
      }, {
        denom: "maticpo",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1dtqlfecglk47yplfrtwjzyagkgcqqngd5lgjp8",
      base: "cw20:terra1dtqlfecglk47yplfrtwjzyagkgcqqngd5lgjp8",
      name: "MATIC (Portal from Polygon)",
      display: "maticpo",
      symbol: "MATICpo",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/maticpo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/maticpo.png",
        theme: {
          primary_color_hex: "#8445e3"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra15a9dr3a2a2lj5fclrw35xxg9yuxg0d908wpf2y",
        exponent: 0
      }, {
        denom: "mimet",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra15a9dr3a2a2lj5fclrw35xxg9yuxg0d908wpf2y",
      base: "cw20:terra15a9dr3a2a2lj5fclrw35xxg9yuxg0d908wpf2y",
      name: "Magic Internet Money",
      display: "mimet",
      symbol: "MIMet",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mimet.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mimet.png",
        theme: {
          primary_color_hex: "#6f6df0"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1ht5sepn28z999jx33sdduuxm9acthad507jg9q",
        exponent: 0
      }, {
        denom: "ray",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1ht5sepn28z999jx33sdduuxm9acthad507jg9q",
      base: "cw20:terra1ht5sepn28z999jx33sdduuxm9acthad507jg9q",
      name: "Raydium (Portal)",
      display: "ray",
      symbol: "RAY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ray.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/ray.png",
        theme: {
          primary_color_hex: "#4d75f2"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra17h82zsq6q8x5tsgm5ugcx4gytw3axguvzt4pkc",
        exponent: 0
      }, {
        denom: "sbr",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra17h82zsq6q8x5tsgm5ugcx4gytw3axguvzt4pkc",
      base: "cw20:terra17h82zsq6q8x5tsgm5ugcx4gytw3axguvzt4pkc",
      name: "Saber (Portal)",
      display: "sbr",
      symbol: "SBR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sbr.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sbr.png",
        theme: {
          primary_color_hex: "#161527"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1huku2lecfjhq9d00k5a8dh73gw7dwe6vvuf2dd",
        exponent: 0
      }, {
        denom: "shib",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1huku2lecfjhq9d00k5a8dh73gw7dwe6vvuf2dd",
      base: "cw20:terra1huku2lecfjhq9d00k5a8dh73gw7dwe6vvuf2dd",
      name: "Shiba Inu (Portal)",
      display: "shib",
      symbol: "SHIB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/shib.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/shib.png",
        theme: {
          primary_color_hex: "#f99e0e"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1dkam9wd5yvaswv4yq3n2aqd4wm5j8n82qc0c7c",
        exponent: 0
      }, {
        denom: "srmso",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1dkam9wd5yvaswv4yq3n2aqd4wm5j8n82qc0c7c",
      base: "cw20:terra1dkam9wd5yvaswv4yq3n2aqd4wm5j8n82qc0c7c",
      name: "Serum (Portal from Solana)",
      display: "srmso",
      symbol: "SRMso",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/srmso.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/srmso.png",
        theme: {
          primary_color_hex: "#40c2d6"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1pvel56a2hs93yd429pzv9zp5aptcjg5ulhkz7w",
        exponent: 0
      }, {
        denom: "usdcav",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1pvel56a2hs93yd429pzv9zp5aptcjg5ulhkz7w",
      base: "cw20:terra1pvel56a2hs93yd429pzv9zp5aptcjg5ulhkz7w",
      name: "USD Coin (Portal from Avalanche)",
      display: "usdcav",
      symbol: "USDCav",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdcav.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdcav.png",
        theme: {
          primary_color_hex: "#2775cb"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1yljlrxvkar0c6ujpvf8g57m5rpcwl7r032zyvu",
        exponent: 0
      }, {
        denom: "usdcbs",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1yljlrxvkar0c6ujpvf8g57m5rpcwl7r032zyvu",
      base: "cw20:terra1yljlrxvkar0c6ujpvf8g57m5rpcwl7r032zyvu",
      name: "USD Coin (Portal from BSC)",
      display: "usdcbs",
      symbol: "USDCbs",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdcbs.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdcbs.png",
        theme: {
          primary_color_hex: "#2675cb"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1kkyyh7vganlpkj0gkc2rfmhy858ma4rtwywe3x",
        exponent: 0
      }, {
        denom: "usdcpo",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1kkyyh7vganlpkj0gkc2rfmhy858ma4rtwywe3x",
      base: "cw20:terra1kkyyh7vganlpkj0gkc2rfmhy858ma4rtwywe3x",
      name: "USD Coin (Portal from Polygon)",
      display: "usdcpo",
      symbol: "USDCpo",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdcpo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdcpo.png",
        theme: {
          primary_color_hex: "#2a73cc"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1e6mq63y64zcxz8xyu5van4tgkhemj3r86yvgu4",
        exponent: 0
      }, {
        denom: "usdcso",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1e6mq63y64zcxz8xyu5van4tgkhemj3r86yvgu4",
      base: "cw20:terra1e6mq63y64zcxz8xyu5van4tgkhemj3r86yvgu4",
      name: "USD Coin (Portal from Solana)",
      display: "usdcso",
      symbol: "USDCso",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdcso.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdcso.png",
        theme: {
          primary_color_hex: "#2a76cc"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1eqvq3thjhye7anv6f6mhxpjhyvww8zjvqcdgjx",
        exponent: 0
      }, {
        denom: "usdtav",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1eqvq3thjhye7anv6f6mhxpjhyvww8zjvqcdgjx",
      base: "cw20:terra1eqvq3thjhye7anv6f6mhxpjhyvww8zjvqcdgjx",
      name: "Tether USD (Portal from Avalanche)",
      display: "usdtav",
      symbol: "USDTav",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdtav.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdtav.png",
        theme: {
          primary_color_hex: "#55ac94"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1vlqeghv5mt5udh96kt5zxlh2wkh8q4kewkr0dd",
        exponent: 0
      }, {
        denom: "usdtbs",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1vlqeghv5mt5udh96kt5zxlh2wkh8q4kewkr0dd",
      base: "cw20:terra1vlqeghv5mt5udh96kt5zxlh2wkh8q4kewkr0dd",
      name: "Tether USD (Portal from BSC)",
      display: "usdtbs",
      symbol: "USDTbs",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdtbs.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdtbs.png",
        theme: {
          primary_color_hex: "#55ac94"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1hd9n65snaluvf7en0p4hqzse9eqecejz2k8rl5",
        exponent: 0
      }, {
        denom: "usdtso",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1hd9n65snaluvf7en0p4hqzse9eqecejz2k8rl5",
      base: "cw20:terra1hd9n65snaluvf7en0p4hqzse9eqecejz2k8rl5",
      name: "Tether USD (Portal from Solana)",
      display: "usdtso",
      symbol: "USDTso",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdtso.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/usdtso.png",
        theme: {
          primary_color_hex: "#54ac96"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1fpfn2kkr8mv390wx4dtpfk3vkjx9ch3thvykl3",
        exponent: 0
      }, {
        denom: "gohm",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1fpfn2kkr8mv390wx4dtpfk3vkjx9ch3thvykl3",
      base: "cw20:terra1fpfn2kkr8mv390wx4dtpfk3vkjx9ch3thvykl3",
      name: "Governance OHM (Portal)",
      display: "gohm",
      symbol: "gOHM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/gohm.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/gohm.png",
        theme: {
          primary_color_hex: "#b3bec1"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1qvlpf2v0zmru3gtex40sqq02wxp39x3cjh359y",
        exponent: 0
      }, {
        denom: "msol",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1qvlpf2v0zmru3gtex40sqq02wxp39x3cjh359y",
      base: "cw20:terra1qvlpf2v0zmru3gtex40sqq02wxp39x3cjh359y",
      name: "Marinade staked SOL (Portal)",
      display: "msol",
      symbol: "mSOL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/msol.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/msol.png",
        theme: {
          primary_color_hex: "#c8e8e1"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1w7ywr6waxtjuvn5svk5wqydqpjj0q9ps7qct4d",
        exponent: 0
      }, {
        denom: "steth",
        exponent: 8
      }],
      type_asset: "cw20",
      address: "terra1w7ywr6waxtjuvn5svk5wqydqpjj0q9ps7qct4d",
      base: "cw20:terra1w7ywr6waxtjuvn5svk5wqydqpjj0q9ps7qct4d",
      name: "Lido Staked Ether (Portal)",
      display: "steth",
      symbol: "stETH",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/steth.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/steth.png",
        theme: {
          primary_color_hex: "#04a4fb"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1srp2u95kxps35nvan88gn96nfqhukqya2d0ffc",
        exponent: 0
      }, {
        denom: "lct",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1srp2u95kxps35nvan88gn96nfqhukqya2d0ffc",
      base: "cw20:terra1srp2u95kxps35nvan88gn96nfqhukqya2d0ffc",
      name: "LCT Token",
      display: "lct",
      symbol: "LCT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/lct.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/lct.png",
        theme: {
          primary_color_hex: "#2664a3"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra18zqcnl83z98tf6lly37gghm7238k7lh79u4z9a",
        exponent: 0
      }, {
        denom: "batom",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra18zqcnl83z98tf6lly37gghm7238k7lh79u4z9a",
      base: "cw20:terra18zqcnl83z98tf6lly37gghm7238k7lh79u4z9a",
      name: "Bonded ATOM",
      display: "batom",
      symbol: "bATOM",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/batom.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/batom.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra128pe5jpempxu0nws5lw28se9zknhsr78626cpn",
        exponent: 0
      }, {
        denom: "webatom",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra128pe5jpempxu0nws5lw28se9zknhsr78626cpn",
      base: "cw20:terra128pe5jpempxu0nws5lw28se9zknhsr78626cpn",
      name: "pStake Bonded ATOM (Wormhole)",
      display: "webatom",
      symbol: "webATOM",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/webatom.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/webatom.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1laczhlpxlgmrwr9un9ds74qxd2fj4754nf82dn",
        exponent: 0
      }, {
        denom: "wcoin",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1laczhlpxlgmrwr9un9ds74qxd2fj4754nf82dn",
      base: "cw20:terra1laczhlpxlgmrwr9un9ds74qxd2fj4754nf82dn",
      name: "Willisch Coin",
      display: "wcoin",
      symbol: "WCOIN",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wcoin.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/wcoin.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1thhm2u93m2stytzynhsxh5h3jrtg540x4punqy",
        exponent: 0
      }, {
        denom: "lctfancard",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1thhm2u93m2stytzynhsxh5h3jrtg540x4punqy",
      base: "cw20:terra1thhm2u93m2stytzynhsxh5h3jrtg540x4punqy",
      name: "LCT Fancard Token",
      display: "lctfancard",
      symbol: "LCTfancard",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/lctfancard.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/lctfancard.png",
        theme: {
          primary_color_hex: "#2968a5"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1yeyr6taynkwdl85ppaggr3zr8txhf66cny2ang",
        exponent: 0
      }, {
        denom: "kntc",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1yeyr6taynkwdl85ppaggr3zr8txhf66cny2ang",
      base: "cw20:terra1yeyr6taynkwdl85ppaggr3zr8txhf66cny2ang",
      name: "Kinetic Token",
      display: "kntc",
      symbol: "KNTC",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/kntc.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/kntc.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1g53pyke8jtmt4lwvk4yl0xaqc4u0qlsl8dz3ex",
        exponent: 0
      }, {
        denom: "kust",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1g53pyke8jtmt4lwvk4yl0xaqc4u0qlsl8dz3ex",
      base: "cw20:terra1g53pyke8jtmt4lwvk4yl0xaqc4u0qlsl8dz3ex",
      name: "Kinetic kUST Token",
      display: "kust",
      symbol: "kUST",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/kust.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/kust.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1rl4zyexjphwgx6v3ytyljkkc4mrje2pyznaclv",
        exponent: 0
      }, {
        denom: "steak",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1rl4zyexjphwgx6v3ytyljkkc4mrje2pyznaclv",
      base: "cw20:terra1rl4zyexjphwgx6v3ytyljkkc4mrje2pyznaclv",
      name: "Steak Token",
      display: "steak",
      symbol: "STEAK",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/steak.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/steak.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1jkkt5638cd5pur0u5jnr2juw0v6hz5d6z8xu8m",
        exponent: 0
      }, {
        denom: "cst",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1jkkt5638cd5pur0u5jnr2juw0v6hz5d6z8xu8m",
      base: "cw20:terra1jkkt5638cd5pur0u5jnr2juw0v6hz5d6z8xu8m",
      name: "CST Token",
      display: "cst",
      symbol: "CST",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cst.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cst.png",
        theme: {
          primary_color_hex: "#5d2616"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1kz7qszu7p4dg9lts7m9m7lpuarsnan47jh3fam",
        exponent: 0
      }, {
        denom: "cstfancard",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1kz7qszu7p4dg9lts7m9m7lpuarsnan47jh3fam",
      base: "cw20:terra1kz7qszu7p4dg9lts7m9m7lpuarsnan47jh3fam",
      name: "CST Fancard Token",
      display: "cstfancard",
      symbol: "CSTfancard",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cstfancard.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cstfancard.png",
        theme: {
          primary_color_hex: "#5d2616"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1amz5c45l34n7w8m5a3z7rd7u0k037x4nnsemwj",
        exponent: 0
      }, {
        denom: "nwld",
        exponent: 9
      }],
      type_asset: "cw20",
      address: "terra1amz5c45l34n7w8m5a3z7rd7u0k037x4nnsemwj",
      base: "cw20:terra1amz5c45l34n7w8m5a3z7rd7u0k037x4nnsemwj",
      name: "Neworld Labs Develpper Token",
      display: "nwld",
      symbol: "NWLD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/nwld.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/nwld.png",
        theme: {
          primary_color_hex: "#046394"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1cdc6nlsx0l6jmt3nnx7gxjggf902wge3n2z76k",
        exponent: 0
      }, {
        denom: "fury",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1cdc6nlsx0l6jmt3nnx7gxjggf902wge3n2z76k",
      base: "cw20:terra1cdc6nlsx0l6jmt3nnx7gxjggf902wge3n2z76k",
      name: "FURY",
      display: "fury",
      symbol: "FURY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/fury.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/fury.png",
        theme: {
          primary_color_hex: "#14045c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra17n223dxpkypc5c48la7aqjvverczg82ga3cr93",
        exponent: 0
      }, {
        denom: "rct",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra17n223dxpkypc5c48la7aqjvverczg82ga3cr93",
      base: "cw20:terra17n223dxpkypc5c48la7aqjvverczg82ga3cr93",
      name: "Reactor Token",
      display: "rct",
      symbol: "RCT",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/rct.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/rct.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra14vw4sfqwe7jw8ppcc7u44vq7hy9qa2nlstnxmu",
        exponent: 0
      }, {
        denom: "vitc",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra14vw4sfqwe7jw8ppcc7u44vq7hy9qa2nlstnxmu",
      base: "cw20:terra14vw4sfqwe7jw8ppcc7u44vq7hy9qa2nlstnxmu",
      name: "Vitamin Coin",
      display: "vitc",
      symbol: "VITC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/vitc.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/vitc.png",
        theme: {
          primary_color_hex: "#e3551b"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1948uvsah8aw40dhsa9mhl3htq8lraj0smlh77g",
        exponent: 0
      }, {
        denom: "sb",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1948uvsah8aw40dhsa9mhl3htq8lraj0smlh77g",
      base: "cw20:terra1948uvsah8aw40dhsa9mhl3htq8lraj0smlh77g",
      name: "DragonSB",
      display: "sb",
      symbol: "SB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sb.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sb.png",
        theme: {
          primary_color_hex: "#7c241c"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1rz964297kvt86rteajhtp4hsffhcum0ye8eljh",
        exponent: 0
      }, {
        denom: "toad",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1rz964297kvt86rteajhtp4hsffhcum0ye8eljh",
      base: "cw20:terra1rz964297kvt86rteajhtp4hsffhcum0ye8eljh",
      name: "RESToad Token",
      display: "toad",
      symbol: "TOAD",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/toad.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/toad.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1yhlhrea3rgyx2xdnsswsfakn28qa8z7yp5gmhd",
        exponent: 0
      }, {
        denom: "orionastro",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1yhlhrea3rgyx2xdnsswsfakn28qa8z7yp5gmhd",
      base: "cw20:terra1yhlhrea3rgyx2xdnsswsfakn28qa8z7yp5gmhd",
      name: "Orion Money xASTRO Derivative Token",
      display: "orionastro",
      symbol: "orionASTRO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/orionastro.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/orionastro.png",
        theme: {
          primary_color_hex: "#1d90d6"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1j4hwavavmtsafa6zr0npalfz3tk9gf3p4787mp",
        exponent: 0
      }, {
        denom: "retro",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1j4hwavavmtsafa6zr0npalfz3tk9gf3p4787mp",
      base: "cw20:terra1j4hwavavmtsafa6zr0npalfz3tk9gf3p4787mp",
      name: "Retrograde",
      display: "retro",
      symbol: "RETRO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/retro.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/retro.png",
        theme: {
          primary_color_hex: "#eb4024"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra16wggm67a34msdxasg2vergm2pt289y7930wv7d",
        exponent: 0
      }, {
        denom: "tnd",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra16wggm67a34msdxasg2vergm2pt289y7930wv7d",
      base: "cw20:terra16wggm67a34msdxasg2vergm2pt289y7930wv7d",
      name: "TerrnadoCash",
      display: "tnd",
      symbol: "TND",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tnd.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tnd.png",
        theme: {
          primary_color_hex: "#1c53fb"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1n9k2he20h5vpyn4mgv7pg4pzvw2n3wc4a86v3g",
        exponent: 0
      }, {
        denom: "stnd",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1n9k2he20h5vpyn4mgv7pg4pzvw2n3wc4a86v3g",
      base: "cw20:terra1n9k2he20h5vpyn4mgv7pg4pzvw2n3wc4a86v3g",
      name: "TerrnadoCash",
      display: "stnd",
      symbol: "sTND",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/stnd.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/stnd.svg"
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1ezz5xply2v3xdyv32gy5tcd7zq4k235q4xtzwe",
        exponent: 0
      }, {
        denom: "nwt",
        exponent: 9
      }],
      type_asset: "cw20",
      address: "terra1ezz5xply2v3xdyv32gy5tcd7zq4k235q4xtzwe",
      base: "cw20:terra1ezz5xply2v3xdyv32gy5tcd7zq4k235q4xtzwe",
      name: "Neworld Token",
      display: "nwt",
      symbol: "NWT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/nwt.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/nwt.png",
        theme: {
          primary_color_hex: "#aeb8f5"
        }
      }]
    },
    {
      description: "The AUD stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "uaud",
          exponent: 0,
          aliases: ["microaud"]
        },
        {
          denom: "maud",
          exponent: 3,
          aliases: ["milliaud"]
        },
        {
          denom: "aut",
          exponent: 6,
          aliases: ["autc"]
        }
      ],
      base: "uaud",
      display: "aut",
      name: "TerraClassicAUD",
      symbol: "AUTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/aut.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/aut.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/aut.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/aut.svg",
        theme: {
          primary_color_hex: "#5981d7"
        }
      }]
    },
    {
      description: "The CAD stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "ucad",
          exponent: 0,
          aliases: ["microcad"]
        },
        {
          denom: "mcad",
          exponent: 3,
          aliases: ["millicad"]
        },
        {
          denom: "cat",
          exponent: 6,
          aliases: ["catc"]
        }
      ],
      base: "ucad",
      display: "cat",
      name: "TerraClassicCAD",
      symbol: "CATC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cat.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cat.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cat.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cat.svg",
        theme: {
          primary_color_hex: "#de725b"
        }
      }]
    },
    {
      description: "The CHF stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "uchf",
          exponent: 0,
          aliases: ["microchf"]
        },
        {
          denom: "mchf",
          exponent: 3,
          aliases: ["millichf"]
        },
        {
          denom: "cht",
          exponent: 6,
          aliases: ["chtc"]
        }
      ],
      base: "uchf",
      display: "cht",
      name: "TerraClassicCHF",
      symbol: "CHTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cht.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cht.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cht.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cht.svg",
        theme: {
          primary_color_hex: "#c95c41"
        }
      }]
    },
    {
      description: "The CNY stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "ucny",
          exponent: 0,
          aliases: ["microcny"]
        },
        {
          denom: "mcny",
          exponent: 3,
          aliases: ["millicny"]
        },
        {
          denom: "cnt",
          exponent: 6,
          aliases: ["cntc"]
        }
      ],
      base: "ucny",
      display: "cnt",
      name: "TerraClassicCNY",
      symbol: "CNTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cnt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cnt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cnt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/cnt.svg",
        theme: {
          primary_color_hex: "#d3684c"
        }
      }]
    },
    {
      description: "The DKK stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "udkk",
          exponent: 0,
          aliases: ["microdkk"]
        },
        {
          denom: "mdkk",
          exponent: 3,
          aliases: ["millidkk"]
        },
        {
          denom: "dkt",
          exponent: 6,
          aliases: ["dktc"]
        }
      ],
      base: "udkk",
      display: "dkt",
      name: "TerraClassicDKK",
      symbol: "DKTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/dkt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/dkt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/dkt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/dkt.svg",
        theme: {
          primary_color_hex: "#db300a"
        }
      }]
    },
    {
      description: "The EUR stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "ueur",
          exponent: 0,
          aliases: ["microeur"]
        },
        {
          denom: "meur",
          exponent: 3,
          aliases: ["millieur"]
        },
        {
          denom: "eut",
          exponent: 6,
          aliases: ["eutc"]
        }
      ],
      base: "ueur",
      display: "eut",
      name: "TerraClassicEUR",
      symbol: "EUTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/eut.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/eut.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/eut.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/eut.svg",
        theme: {
          primary_color_hex: "#1535b2"
        }
      }]
    },
    {
      description: "The GBP stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "ugbp",
          exponent: 0,
          aliases: ["microgbp"]
        },
        {
          denom: "mgbp",
          exponent: 3,
          aliases: ["milligbp"]
        },
        {
          denom: "gbt",
          exponent: 6,
          aliases: ["gbtc"]
        }
      ],
      base: "ugbp",
      display: "gbt",
      name: "TerraClassicGBP",
      symbol: "GBTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/gbt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/gbt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/gbt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/gbt.svg",
        theme: {
          primary_color_hex: "#d49b9c"
        }
      }]
    },
    {
      description: "The HKD stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "uhkd",
          exponent: 0,
          aliases: ["microhkd"]
        },
        {
          denom: "mhkd",
          exponent: 3,
          aliases: ["millihkd"]
        },
        {
          denom: "hkt",
          exponent: 6,
          aliases: ["hktc"]
        }
      ],
      base: "uhkd",
      display: "hkt",
      name: "TerraClassicHKD",
      symbol: "HKTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/hkt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/hkt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/hkt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/hkt.svg",
        theme: {
          primary_color_hex: "#dc300a"
        }
      }]
    },
    {
      description: "The IDR stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "uidr",
          exponent: 0,
          aliases: ["microidr"]
        },
        {
          denom: "midr",
          exponent: 3,
          aliases: ["milliidr"]
        },
        {
          denom: "idt",
          exponent: 6,
          aliases: ["idtc"]
        }
      ],
      base: "uidr",
      display: "idt",
      name: "TerraClassicIDR",
      symbol: "IDTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/idt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/idt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/idt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/idt.svg",
        theme: {
          primary_color_hex: "#5893ed"
        }
      }]
    },
    {
      description: "The INR stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "uinr",
          exponent: 0,
          aliases: ["microinr"]
        },
        {
          denom: "minr",
          exponent: 3,
          aliases: ["milliinr"]
        },
        {
          denom: "int",
          exponent: 6,
          aliases: ["intc"]
        }
      ],
      base: "uinr",
      display: "int",
      name: "TerraClassicINR",
      symbol: "INTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/int.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/int.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/int.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/int.svg",
        theme: {
          primary_color_hex: "#4b87e6"
        }
      }]
    },
    {
      description: "The JPY stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "ujpy",
          exponent: 0,
          aliases: ["microjpy"]
        },
        {
          denom: "mjpy",
          exponent: 3,
          aliases: ["millijpy"]
        },
        {
          denom: "jpt",
          exponent: 6,
          aliases: ["jptc"]
        }
      ],
      base: "ujpy",
      display: "jpt",
      name: "TerraClassicJPY",
      symbol: "JPTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/jpt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/jpt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/jpt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/jpt.svg",
        theme: {
          primary_color_hex: "#cfcfcf"
        }
      }]
    },
    {
      description: "The MNT stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "umnt",
          exponent: 0,
          aliases: ["micromnt"]
        },
        {
          denom: "mmnt",
          exponent: 3,
          aliases: ["millimnt"]
        },
        {
          denom: "mnt",
          exponent: 6,
          aliases: ["mntc"]
        }
      ],
      base: "umnt",
      display: "mnt",
      name: "TerraClassicMNT",
      symbol: "MNTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/mnt.svg",
        theme: {
          primary_color_hex: "#4085f0"
        }
      }]
    },
    {
      description: "The MYR stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "umyr",
          exponent: 0,
          aliases: ["micromyr"]
        },
        {
          denom: "mmyr",
          exponent: 3,
          aliases: ["millimyr"]
        },
        {
          denom: "myt",
          exponent: 6,
          aliases: ["mytc"]
        }
      ],
      base: "umyr",
      display: "myt",
      name: "TerraClassicMYR",
      symbol: "MYTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/myt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/myt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/myt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/myt.svg",
        theme: {
          primary_color_hex: "#5893ed"
        }
      }]
    },
    {
      description: "The NOK stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "unok",
          exponent: 0,
          aliases: ["micronok"]
        },
        {
          denom: "mnok",
          exponent: 3,
          aliases: ["millinok"]
        },
        {
          denom: "not",
          exponent: 6,
          aliases: ["notc"]
        }
      ],
      base: "unok",
      display: "not",
      name: "TerraClassicNOK",
      symbol: "NOTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/not.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/not.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/not.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/not.svg",
        theme: {
          primary_color_hex: "#5493f3"
        }
      }]
    },
    {
      description: "The PHP stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "uphp",
          exponent: 0,
          aliases: ["microphp"]
        },
        {
          denom: "mphp",
          exponent: 3,
          aliases: ["milliphp"]
        },
        {
          denom: "pht",
          exponent: 6,
          aliases: ["phtc"]
        }
      ],
      base: "uphp",
      display: "pht",
      name: "TerraClassicPHP",
      symbol: "PHTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/pht.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/pht.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/pht.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/pht.svg",
        theme: {
          primary_color_hex: "#e88057"
        }
      }]
    },
    {
      description: "The SDR stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "usdr",
          exponent: 0,
          aliases: ["microsdr"]
        },
        {
          denom: "msdr",
          exponent: 3,
          aliases: ["millisdr"]
        },
        {
          denom: "sdt",
          exponent: 6,
          aliases: ["sdtc"]
        }
      ],
      base: "usdr",
      display: "sdt",
      name: "TerraClassicSDR",
      symbol: "SDTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sdt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sdt.svg",
        theme: {
          primary_color_hex: "#2fa4f1"
        }
      }]
    },
    {
      description: "The SEK stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "usek",
          exponent: 0,
          aliases: ["microsek"]
        },
        {
          denom: "msek",
          exponent: 3,
          aliases: ["millisek"]
        },
        {
          denom: "set",
          exponent: 6,
          aliases: ["setc"]
        }
      ],
      base: "usek",
      display: "set",
      name: "TerraClassicSEK",
      symbol: "SETC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/set.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/set.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/set.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/set.svg",
        theme: {
          primary_color_hex: "#2e71e1"
        }
      }]
    },
    {
      description: "The SGD stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "usgd",
          exponent: 0,
          aliases: ["microsgd"]
        },
        {
          denom: "msgd",
          exponent: 3,
          aliases: ["millisgd"]
        },
        {
          denom: "sgt",
          exponent: 6,
          aliases: ["sgtc"]
        }
      ],
      base: "usgd",
      display: "sgt",
      name: "TerraClassicSGD",
      symbol: "SGTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sgt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sgt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sgt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/sgt.svg",
        theme: {
          primary_color_hex: "#4886e7"
        }
      }]
    },
    {
      description: "The THB stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "uthb",
          exponent: 0,
          aliases: ["microthb"]
        },
        {
          denom: "mthb",
          exponent: 3,
          aliases: ["millithb"]
        },
        {
          denom: "tht",
          exponent: 6,
          aliases: ["thtc"]
        }
      ],
      base: "uthb",
      display: "tht",
      name: "TerraClassicTHB",
      symbol: "THTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tht.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tht.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tht.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tht.svg",
        theme: {
          primary_color_hex: "#5493f3"
        }
      }]
    },
    {
      description: "The TWD stablecoin of Terra Classic.",
      denom_units: [
        {
          denom: "utwd",
          exponent: 0,
          aliases: ["microtwd"]
        },
        {
          denom: "mtwd",
          exponent: 3,
          aliases: ["millitwd"]
        },
        {
          denom: "twt",
          exponent: 6,
          aliases: ["twtc"]
        }
      ],
      base: "utwd",
      display: "twt",
      name: "TerraClassicTWD",
      symbol: "TWTC",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/twt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/twt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/twt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/twt.svg",
        theme: {
          primary_color_hex: "#5493f3"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1mpq5zkkm39nmjrjg9raknpfrfmcfwv0nh0whvn",
        exponent: 0
      }, {
        denom: "neb",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1mpq5zkkm39nmjrjg9raknpfrfmcfwv0nh0whvn",
      base: "cw20:terra1mpq5zkkm39nmjrjg9raknpfrfmcfwv0nh0whvn",
      name: "Nebula Token",
      display: "neb",
      symbol: "NEB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/neb.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/neb.png",
        theme: {
          primary_color_hex: "#8b90ad"
        }
      }]
    },
    {
      denom_units: [{
        denom: "cw20:terra1g6fm3yu79gv0rc8067n2nnfpf0vks6n0wpzaf4u7w48tdrmj98zsy7uu00",
        exponent: 0
      }, {
        denom: "trit",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1g6fm3yu79gv0rc8067n2nnfpf0vks6n0wpzaf4u7w48tdrmj98zsy7uu00",
      base: "cw20:terra1g6fm3yu79gv0rc8067n2nnfpf0vks6n0wpzaf4u7w48tdrmj98zsy7uu00",
      name: "Terra Tritium Token",
      display: "trit",
      symbol: "TRIT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/trit.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/trit.png",
        theme: {
          primary_color_hex: "#24ab9b"
        }
      }]
    },
    {
      description: "Juris Protocol is the Lending Platform for the Terra Ecosystem.",
      type_asset: "cw20",
      address: "terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2",
      denom_units: [{
        denom: "cw20:terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2",
        exponent: 0
      }, {
        denom: "juris",
        exponent: 6
      }],
      base: "cw20:terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2",
      name: "Juris Protocol",
      display: "juris",
      symbol: "JURIS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/juris.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/juris.png"
      }]
    },
    {
      description: "Tadpole Frogztrik Token meme",
      type_asset: "cw20",
      address: "terra19gzvkw5hft3ulp8n6ws3p9yradhc802axqal59lzxau6rqxktj9q0dwf9c",
      display: "tadf",
      denom_units: [{
        denom: "cw20:terra19gzvkw5hft3ulp8n6ws3p9yradhc802axqal59lzxau6rqxktj9q0dwf9c",
        exponent: 0
      }, {
        denom: "tadf",
        exponent: 6
      }],
      base: "cw20:terra19gzvkw5hft3ulp8n6ws3p9yradhc802axqal59lzxau6rqxktj9q0dwf9c",
      name: "Tadpole Frogztrik Token",
      symbol: "TADF",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tadf.png",
        theme: {
          primary_color_hex: "#e9f9f2"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/tadf.png"
      }
    },
    {
      description: "Frogztrik NFT Token",
      type_asset: "cw20",
      address: "terra1wez9puj43v4s25vrex7cv3ut3w75w4h6j5e537sujyuxj0r5ne2qp9uwl9",
      display: "frog",
      denom_units: [{
        denom: "cw20:terra1wez9puj43v4s25vrex7cv3ut3w75w4h6j5e537sujyuxj0r5ne2qp9uwl9",
        exponent: 0
      }, {
        denom: "frog",
        exponent: 6
      }],
      base: "cw20:terra1wez9puj43v4s25vrex7cv3ut3w75w4h6j5e537sujyuxj0r5ne2qp9uwl9",
      name: "Frogztrik NFT Token",
      symbol: "FROG",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/FROG.png",
        theme: {
          primary_color_hex: "#182615"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/FROG.png"
      }
    }
  ]
};
yf.default = WG;
var bf = {};
Object.defineProperty(bf, "__esModule", { value: !0 });
const VG = {
  $schema: "../chain.schema.json",
  chain_name: "terra",
  status: "live",
  network_type: "mainnet",
  pretty_name: "Terra Classic",
  chain_type: "cosmos",
  chain_id: "columbus-5",
  daemon_name: "terrad",
  node_home: "$HOME/.terra",
  bech32_prefix: "terra",
  slip44: 330,
  fees: {
    fee_tokens: [
      {
        denom: "uluna",
        low_gas_price: 28.325,
        average_gas_price: 28.325,
        high_gas_price: 50
      },
      {
        denom: "usdr",
        low_gas_price: 0.52469,
        average_gas_price: 0.52469,
        high_gas_price: 0.52469
      },
      {
        denom: "uusd",
        low_gas_price: 0.75,
        average_gas_price: 0.75,
        high_gas_price: 0.75
      },
      {
        denom: "ukrw",
        low_gas_price: 850,
        average_gas_price: 850,
        high_gas_price: 850
      },
      {
        denom: "umnt",
        low_gas_price: 2142.855,
        average_gas_price: 2142.855,
        high_gas_price: 2142.855
      },
      {
        denom: "ueur",
        low_gas_price: 0.625,
        average_gas_price: 0.625,
        high_gas_price: 0.625
      },
      {
        denom: "ucny",
        low_gas_price: 4.9,
        average_gas_price: 4.9,
        high_gas_price: 4.9
      },
      {
        denom: "ujpy",
        low_gas_price: 81.85,
        average_gas_price: 81.85,
        high_gas_price: 81.85
      },
      {
        denom: "ugbp",
        low_gas_price: 0.55,
        average_gas_price: 0.55,
        high_gas_price: 0.55
      },
      {
        denom: "uinr",
        low_gas_price: 54.4,
        average_gas_price: 54.4,
        high_gas_price: 54.4
      },
      {
        denom: "ucad",
        low_gas_price: 0.95,
        average_gas_price: 0.95,
        high_gas_price: 0.95
      },
      {
        denom: "uchf",
        low_gas_price: 0.7,
        average_gas_price: 0.7,
        high_gas_price: 0.7
      },
      {
        denom: "uaud",
        low_gas_price: 0.95,
        average_gas_price: 0.95,
        high_gas_price: 0.95
      },
      {
        denom: "usgd",
        low_gas_price: 1,
        average_gas_price: 1,
        high_gas_price: 1
      },
      {
        denom: "uthb",
        low_gas_price: 23.1,
        average_gas_price: 23.1,
        high_gas_price: 23.1
      },
      {
        denom: "usek",
        low_gas_price: 6.25,
        average_gas_price: 6.25,
        high_gas_price: 6.25
      },
      {
        denom: "unok",
        low_gas_price: 6.25,
        average_gas_price: 6.25,
        high_gas_price: 6.25
      },
      {
        denom: "udkk",
        low_gas_price: 4.5,
        average_gas_price: 4.5,
        high_gas_price: 4.5
      },
      {
        denom: "uidr",
        low_gas_price: 10900,
        average_gas_price: 10900,
        high_gas_price: 10900
      },
      {
        denom: "uphp",
        low_gas_price: 38,
        average_gas_price: 38,
        high_gas_price: 38
      },
      {
        denom: "uhkd",
        low_gas_price: 5.85,
        average_gas_price: 5.85,
        high_gas_price: 5.85
      },
      {
        denom: "umyr",
        low_gas_price: 3,
        average_gas_price: 3,
        high_gas_price: 3
      },
      {
        denom: "utwd",
        low_gas_price: 20,
        average_gas_price: 20,
        high_gas_price: 20
      }
    ]
  },
  staking: {
    staking_tokens: [{
      denom: "uluna"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://terra-classic-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc-terra-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://terraclassic-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://terraclassic-rpc-server-01.stakely.io",
        provider: "Stakely"
      }
    ],
    rest: [
      {
        address: "https://terra-classic-lcd.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://api-terra-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://terraclassic-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://terraclassic-lcd-server-01.stakely.io",
        provider: "Stakely"
      }
    ],
    grpc: [
      {
        address: "grpc.terrarebels.net",
        provider: "Terra Rebels"
      },
      {
        address: "terra-classic-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "grpc-terra-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "terraclassic-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      }
    ]
  },
  explorers: [
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/terra",
      tx_page: "https://ezstaking.app/terra/txs/${txHash}",
      account_page: "https://ezstaking.app/terra/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/terra-luna",
      tx_page: "https://ping.pub/terra-luna/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/terra",
      tx_page: "https://atomscan.com/terra/transactions/${txHash}",
      account_page: "https://atomscan.com/terra/accounts/${accountAddress}"
    },
    {
      kind: "finder",
      url: "https://finder.terra.money/classic",
      tx_page: "https://finder.terra.money/classic/tx/${txHash}",
      account_page: "https://finder.terra.money/classic/address/${accountAddress}"
    },
    {
      kind: "finder",
      url: "https://finder.terrarebels.net/classic",
      tx_page: "https://finder.terrarebels.net/classic/tx/${txHash}",
      account_page: "https://finder.terrarebels.net/classic/address/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/luna.svg",
    theme: {
      primary_color_hex: "#fcdb5b"
    }
  }]
};
bf.default = VG;
var vf = {};
Object.defineProperty(vf, "__esModule", { value: !0 });
const GG = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-13",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-172",
      connection_id: "connection-99"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-69",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-101",
      connection_id: "connection-70"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-63",
      connection_id: "connection-43"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-32",
      connection_id: "connection-34"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-122",
      connection_id: "connection-92"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-244",
      connection_id: "connection-151"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-114",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-87",
        port_id: "wasm.terra19pfxzj9580h7rjd6z6sn5x2se76vgrc0etltr79g9z3t82jzp4hq63qguc"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1215",
      connection_id: "connection-1549"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-12",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-72",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }, {
      chain_1: {
        channel_id: "channel-78488",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-108",
        port_id: "wasm.terra19pfxzj9580h7rjd6z6sn5x2se76vgrc0etltr79g9z3t82jzp4hq63qguc"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !1,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "terra",
      client_id: "07-tendermint-28",
      connection_id: "connection-29"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "terra",
      client_id: "07-tendermint-235",
      connection_id: "connection-142"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-394",
      connection_id: "connection-384"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-85",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-314",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
vf.default = GG;
var ff = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(oa, "__esModule", { value: !0 });
oa.ibc = oa.chain = oa.assets = void 0;
const KG = ff(yf), XG = ff(bf), YG = ff(vf);
oa.assets = KG.default;
oa.chain = XG.default;
oa.ibc = YG.default;
var ra = {}, wf = {};
Object.defineProperty(wf, "__esModule", { value: !0 });
const JG = {
  $schema: "../assetlist.schema.json",
  chain_name: "terra2",
  assets: [
    {
      description: "The native staking token of Terra.",
      denom_units: [{
        denom: "uluna",
        exponent: 0
      }, {
        denom: "luna",
        exponent: 6
      }],
      base: "uluna",
      name: "Luna",
      display: "luna",
      symbol: "LUNA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg"
      },
      coingecko_id: "terra-luna-2",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg",
        theme: {
          primary_color_hex: "#f4de6f"
        }
      }],
      socials: {
        website: "https://www.terra.money/",
        twitter: "https://twitter.com/terra_money"
      }
    },
    {
      description: "Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.",
      denom_units: [{
        denom: "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26",
        exponent: 0
      }, {
        denom: "astro.cw20",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26",
      base: "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26",
      name: "Astroport CW20 Token",
      display: "astro.cw20",
      symbol: "ASTRO.cw20",
      traces: [{
        type: "legacy-mintage",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        provider: "Astroport"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/astro-cw20.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/astro-cw20.svg"
      }, {
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg",
        theme: {
          primary_color_hex: "#4056e9"
        }
      }],
      socials: {
        website: "https://astroport.fi/",
        twitter: "https://twitter.com/astroport_fi"
      }
    },
    {
      description: "Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.",
      denom_units: [{
        denom: "ibc/8D8A7F7253615E5F76CB6252A1E1BD921D5EDB7BBAAF8913FB1C77FF125D9995",
        exponent: 0,
        aliases: ["uastro"]
      }, {
        denom: "astro",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/8D8A7F7253615E5F76CB6252A1E1BD921D5EDB7BBAAF8913FB1C77FF125D9995",
      name: "Astroport token",
      display: "astro",
      symbol: "ASTRO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro",
          channel_id: "channel-25"
        },
        chain: {
          channel_id: "channel-229",
          path: "transfer/channel-229/factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg",
        theme: {
          primary_color_hex: "#4056e9"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg"
      }
    },
    {
      description: "Dinheiros is the reserve currency of dioalma.protocol, an undivisible and rare token.",
      denom_units: [{
        denom: "cw20:terra1spkm49wd9dqkranhrks4cupecl3rtgeqqljq3qrvrrts2ev2gw6sy5vz3k",
        exponent: 0,
        aliases: ["Dinheiros"]
      }],
      type_asset: "cw20",
      address: "terra1spkm49wd9dqkranhrks4cupecl3rtgeqqljq3qrvrrts2ev2gw6sy5vz3k",
      base: "cw20:terra1spkm49wd9dqkranhrks4cupecl3rtgeqqljq3qrvrrts2ev2gw6sy5vz3k",
      name: "dinheiro",
      display: "cw20:terra1spkm49wd9dqkranhrks4cupecl3rtgeqqljq3qrvrrts2ev2gw6sy5vz3k",
      symbol: "DINHEIROS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Dinheiros.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Dinheiros.png",
        theme: {
          primary_color_hex: "#244c9c"
        }
      }]
    },
    {
      description: "Reis is the king of trading, high volume high liquidity, sibling of Dinheiros, Reis and Alem, a token of dioalma.protocol.",
      denom_units: [{
        denom: "cw20:terra1sdglum2dt4f3fmq7jrt2phf2tegmnudc7qqqqujkpqcm9ujuxxkqakv5u8",
        exponent: 0
      }, {
        denom: "Reis",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1sdglum2dt4f3fmq7jrt2phf2tegmnudc7qqqqujkpqcm9ujuxxkqakv5u8",
      base: "cw20:terra1sdglum2dt4f3fmq7jrt2phf2tegmnudc7qqqqujkpqcm9ujuxxkqakv5u8",
      name: "real",
      display: "Reis",
      symbol: "REIS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Reis.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Reis.png",
        theme: {
          primary_color_hex: "#1d5c65"
        }
      }]
    },
    {
      description: "Escudos is the everyday currency of dioalma.protocol, good to send money back and forward.",
      denom_units: [{
        denom: "cw20:terra1qj5hs3e86qn4vm9dvtgtlkdp550r0rayk9wpay44mfw3gn3tr8nq5jw3dg",
        exponent: 0
      }, {
        denom: "Escudos",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1qj5hs3e86qn4vm9dvtgtlkdp550r0rayk9wpay44mfw3gn3tr8nq5jw3dg",
      base: "cw20:terra1qj5hs3e86qn4vm9dvtgtlkdp550r0rayk9wpay44mfw3gn3tr8nq5jw3dg",
      name: "escudo",
      display: "Escudos",
      symbol: "ESCUDOS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Escudos.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Escudos.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Alem is one of the tokens of the seven families of dioalmaprotocol, alem almagem arika danu torus dmt plasma, all seven families use dinheiros reis and escudos, dioalma.protcol the currency of the seven seas.",
      denom_units: [{
        denom: "cw20:terra1cmf8ytutcwrjrv08zskj9phuh46a3w3nkjax7en4hxezsrdr58lqvzy05q",
        exponent: 0
      }, {
        denom: "Alem",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1cmf8ytutcwrjrv08zskj9phuh46a3w3nkjax7en4hxezsrdr58lqvzy05q",
      base: "cw20:terra1cmf8ytutcwrjrv08zskj9phuh46a3w3nkjax7en4hxezsrdr58lqvzy05q",
      name: "alentejo.money",
      display: "Alem",
      symbol: "ALEM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Alem.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Alem.png",
        theme: {
          primary_color_hex: "#d1b295"
        }
      }]
    },
    {
      description: "almagem is one of the tokens of the seven families of dioalmaprotocol, alem almagem arika danu torus dmt plasma, all seven families use dinheiros reis and escudos, dioalma.protcol the currency of the seven seas.",
      denom_units: [{
        denom: "cw20:terra1en42e2vsvtdsvrcqg5s5e5e4djejjaed6fxmvtpweg3tu33h6k5qkg9c40",
        exponent: 0
      }, {
        denom: "AMG",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1en42e2vsvtdsvrcqg5s5e5e4djejjaed6fxmvtpweg3tu33h6k5qkg9c40",
      base: "cw20:terra1en42e2vsvtdsvrcqg5s5e5e4djejjaed6fxmvtpweg3tu33h6k5qkg9c40",
      name: "almagem",
      display: "AMG",
      symbol: "AMG",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/almagem.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/almagem.png",
        theme: {
          primary_color_hex: "#d1b295"
        }
      }]
    },
    {
      description: "arika is one of the tokens of the seven families of dioalmaprotocol, alem almagem arika danu torus dmt plasma, all seven families use dinheiros reis and escudos, dioalma.protcol the currency of the seven seas.",
      denom_units: [{
        denom: "cw20:terra1ysd87nayjuelxj4wvp4wnp9as0mwszzkje6a9z6f3xx2903ghnsq4hm50y",
        exponent: 0
      }, {
        denom: "ARK",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1ysd87nayjuelxj4wvp4wnp9as0mwszzkje6a9z6f3xx2903ghnsq4hm50y",
      base: "cw20:terra1ysd87nayjuelxj4wvp4wnp9as0mwszzkje6a9z6f3xx2903ghnsq4hm50y",
      name: "arika",
      display: "ARK",
      symbol: "ARK",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/arika.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/arika.png",
        theme: {
          primary_color_hex: "#d1b295"
        }
      }]
    },
    {
      description: "danu is one of the tokens of the seven families of dioalmaprotocol, alem almagem arika danu torus dmt plasma, all seven families use dinheiros reis and escudos, dioalma.protcol the currency of the seven seas.",
      denom_units: [{
        denom: "cw20:terra1vj68f2ntauaj5dfvy5z4tq4we3hsyg363k63js5sae2t7th9aacqan89sr",
        exponent: 0
      }, {
        denom: "DANU",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1vj68f2ntauaj5dfvy5z4tq4we3hsyg363k63js5sae2t7th9aacqan89sr",
      base: "cw20:terra1vj68f2ntauaj5dfvy5z4tq4we3hsyg363k63js5sae2t7th9aacqan89sr",
      name: "danu",
      display: "DANU",
      symbol: "DANU",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/danu.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/danu.png",
        theme: {
          primary_color_hex: "#d1b295"
        }
      }]
    },
    {
      description: "torus is one of the tokens of the seven families of dioalmaprotocol, alem almagem arika danu torus dmt plasma, all seven families use dinheiros reis and escudos, dioalma.protcol the currency of the seven seas.",
      denom_units: [{
        denom: "cw20:terra1swzpenwh39f8aa7qht34r05f8ew6k2vehvqt2aw4fjy0fgghhheqs9l6h7",
        exponent: 0
      }, {
        denom: "TRS",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1swzpenwh39f8aa7qht34r05f8ew6k2vehvqt2aw4fjy0fgghhheqs9l6h7",
      base: "cw20:terra1swzpenwh39f8aa7qht34r05f8ew6k2vehvqt2aw4fjy0fgghhheqs9l6h7",
      name: "torus",
      display: "TRS",
      symbol: "TRS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/trs.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/trs.png",
        theme: {
          primary_color_hex: "#d1b295"
        }
      }]
    },
    {
      description: "plasma is one of the tokens of the seven families of dioalmaprotocol, alem almagem arika danu torus dmt plasma, all seven families use dinheiros reis and escudos, dioalma.protcol the currency of the seven seas.",
      denom_units: [{
        denom: "cw20:terra1mqs6mdx0ak7qvjzs6efhg65g4j5pzwpdkcgdsv5tpekln3qhggrq3qzvdp",
        exponent: 0
      }, {
        denom: "PLASMA",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1mqs6mdx0ak7qvjzs6efhg65g4j5pzwpdkcgdsv5tpekln3qhggrq3qzvdp",
      base: "cw20:terra1mqs6mdx0ak7qvjzs6efhg65g4j5pzwpdkcgdsv5tpekln3qhggrq3qzvdp",
      name: "plasma",
      display: "PLASMA",
      symbol: "PLASMA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/plasma.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/plasma.png",
        theme: {
          primary_color_hex: "#d1b295"
        }
      }]
    },
    {
      description: "dmt is one of the tokens of the seven families of dioalmaprotocol, alem almagem arika danu torus dmt plasma, all seven families use dinheiros reis and escudos, dioalma.protcol the currency of the seven seas.",
      denom_units: [{
        denom: "cw20:terra1xfkkgwxychgrnq0vcp82u32mecrzj8s64s03cxtmf46k6j2n2wssc7rzjf",
        exponent: 0
      }, {
        denom: "DMT",
        exponent: 6
      }],
      type_asset: "cw20",
      address: "terra1xfkkgwxychgrnq0vcp82u32mecrzj8s64s03cxtmf46k6j2n2wssc7rzjf",
      base: "cw20:terra1xfkkgwxychgrnq0vcp82u32mecrzj8s64s03cxtmf46k6j2n2wssc7rzjf",
      name: "dmt",
      display: "DMT",
      symbol: "DMT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/dmt.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/dmt.png",
        theme: {
          primary_color_hex: "#d1b295"
        }
      }]
    },
    {
      description: "ERIS liquid staked LUNA.",
      type_asset: "cw20",
      address: "terra1ecgazyd0waaj3g7l9cmy5gulhxkps2gmxu9ghducvuypjq68mq2s5lvsct",
      denom_units: [{
        denom: "cw20:terra1ecgazyd0waaj3g7l9cmy5gulhxkps2gmxu9ghducvuypjq68mq2s5lvsct",
        exponent: 0
      }, {
        denom: "ampluna",
        exponent: 6
      }],
      base: "cw20:terra1ecgazyd0waaj3g7l9cmy5gulhxkps2gmxu9ghducvuypjq68mq2s5lvsct",
      name: "ERIS Amplified LUNA",
      display: "ampluna",
      symbol: "ampLUNA",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ampluna.svg"
      },
      coingecko_id: "eris-amplified-luna",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ampluna.svg"
      }]
    },
    {
      description: "Lion DAO is a community DAO that lives on the Terra blockchain with the mission to reactivate the LUNAtic community and showcase Terra protocols & tooling",
      type_asset: "cw20",
      address: "terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv",
      denom_units: [{
        denom: "cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv",
        exponent: 0
      }, {
        denom: "roar",
        exponent: 6
      }],
      base: "cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv",
      name: "Lion DAO",
      display: "roar",
      symbol: "ROAR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/roar.png"
      },
      coingecko_id: "lion-dao",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/roar.png",
        theme: {
          primary_color_hex: "#f3f313"
        }
      }]
    },
    {
      description: "GEM DAO, building a decentralized, community-owned, low-supply store of value",
      type_asset: "cw20",
      address: "terra1ynvsz80w9xmhdxucv96gkwpxlwvjgsq75xh2f3pf825c4wfmkfxskq6pqv",
      denom_units: [{
        denom: "cw20:terra1ynvsz80w9xmhdxucv96gkwpxlwvjgsq75xh2f3pf825c4wfmkfxskq6pqv",
        exponent: 0
      }, {
        denom: "gem",
        exponent: 6
      }],
      base: "cw20:terra1ynvsz80w9xmhdxucv96gkwpxlwvjgsq75xh2f3pf825c4wfmkfxskq6pqv",
      name: "GEM DAO",
      display: "gem",
      symbol: "GEM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/gem.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/gem.png",
        theme: {
          primary_color_hex: "#21b6b3"
        }
      }]
    },
    {
      description: "Lion Cub DAO is a useless meme community DAO on Terra",
      type_asset: "cw20",
      address: "terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t",
      denom_units: [{
        denom: "cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t",
        exponent: 0
      }, {
        denom: "cub",
        exponent: 6
      }],
      base: "cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t",
      name: "Lion Cub DAO",
      display: "cub",
      symbol: "CUB",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/cub.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/cub.png",
        theme: {
          primary_color_hex: "#f3d343"
        }
      }]
    },
    {
      description: "BLUE CUB DAO is a community DAO on Terra",
      type_asset: "cw20",
      address: "terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584",
      denom_units: [{
        denom: "cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584",
        exponent: 0
      }, {
        denom: "blue",
        exponent: 6
      }],
      base: "cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584",
      name: "BLUE CUB DAO",
      display: "blue",
      symbol: "BLUE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/blue.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/blue.png",
        theme: {
          primary_color_hex: "#040404"
        }
      }]
    },
    {
      description: "Liquidity token, NFT, HARVEST FOR VALUE",
      type_asset: "cw20",
      address: "terra10se906awphtccf4vd83m0ulpmpt9v4msuakmpy0pwvmtxmup3kdq25rayn",
      denom_units: [{
        denom: "cw20:terra10se906awphtccf4vd83m0ulpmpt9v4msuakmpy0pwvmtxmup3kdq25rayn",
        exponent: 0
      }, {
        denom: "xxx",
        exponent: 10
      }],
      base: "cw20:terra10se906awphtccf4vd83m0ulpmpt9v4msuakmpy0pwvmtxmup3kdq25rayn",
      name: "TheOnlyOne",
      display: "xxx",
      symbol: "xxx",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/xxx3.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/xxx3.png",
        theme: {
          primary_color_hex: "#efe8e9"
        }
      }]
    },
    {
      description: "Just a meme coin on Terra",
      type_asset: "cw20",
      address: "terra19nu4q2y0xe3vza6ve5ymup33uzm049pnrqq5ddeuulmrg279t57qstcces",
      denom_units: [{
        denom: "cw20:terra19nu4q2y0xe3vza6ve5ymup33uzm049pnrqq5ddeuulmrg279t57qstcces",
        exponent: 0
      }, {
        denom: "GUGU",
        exponent: 6
      }],
      base: "cw20:terra19nu4q2y0xe3vza6ve5ymup33uzm049pnrqq5ddeuulmrg279t57qstcces",
      name: "GUGU",
      display: "GUGU",
      symbol: "GUGU",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/gugu.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/gugu.png",
        theme: {
          primary_color_hex: "#e3e2e5"
        }
      }]
    },
    {
      description: "BackBone Labs Liquid Staked LUNA",
      type_asset: "cw20",
      address: "terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml",
      denom_units: [{
        denom: "cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml",
        exponent: 0
      }, {
        denom: "bLUNA",
        exponent: 6
      }],
      base: "cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml",
      name: "BackBone Labs Liquid Staked LUNA",
      display: "bLUNA",
      symbol: "bLUNA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bLUNA.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bLUNA.png",
        theme: {
          primary_color_hex: "#070707"
        }
      }],
      coingecko_id: "backbone-labs-staked-luna"
    },
    {
      description: "Sayve is a revolutionary language learning app in the Web3 era that combines gamification, blockchain technology, and a Metaverse experience to motivate users to learn languages while earning rewards.",
      type_asset: "cw20",
      address: "terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3",
      denom_units: [{
        denom: "cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3",
        exponent: 0
      }, {
        denom: "sayve",
        exponent: 6
      }],
      base: "cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3",
      name: "sayve",
      display: "sayve",
      symbol: "SAYVE",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.svg",
        theme: {
          primary_color_hex: "#f3ebdb"
        }
      }]
    },
    {
      description: "ERIS Alliance Staked ampWHALE on Terra",
      denom_units: [{
        denom: "factory/terra1j35ta0llaxcf55auv2cjqau5a7aee6g8fz7md7my7005cvh23jfsaw83dy/ampWHALEt",
        exponent: 0
      }, {
        denom: "ampWHALEt",
        exponent: 6
      }],
      base: "factory/terra1j35ta0llaxcf55auv2cjqau5a7aee6g8fz7md7my7005cvh23jfsaw83dy/ampWHALEt",
      name: "ERIS Alliance Staked ampWHALE",
      display: "ampWHALEt",
      symbol: "ampWHALEt",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ampwhalet.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ampwhalet.svg"
      }]
    },
    {
      description: "ERIS Alliance Staked boneWHALE on Terra",
      denom_units: [{
        denom: "factory/terra10j3zrymfrkta2pxe0gklc79gu06tqyuy8c3kh6tqdsrrprsjqkrqzfl4df/boneWHALEt",
        exponent: 0
      }, {
        denom: "boneWHALEt",
        exponent: 6
      }],
      base: "factory/terra10j3zrymfrkta2pxe0gklc79gu06tqyuy8c3kh6tqdsrrprsjqkrqzfl4df/boneWHALEt",
      name: "ERIS Alliance Staked boneWHALE",
      display: "boneWHALEt",
      symbol: "boneWHALEt",
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bonewhalet.svg"
      },
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bonewhalet.svg"
      }]
    },
    {
      description: "ERIS Liquid Enterprise Staked ROAR",
      denom_units: [{
        denom: "factory/terra1vklefn7n6cchn0u962w3gaszr4vf52wjvd4y95t2sydwpmpdtszsqvk9wy/ampROAR",
        exponent: 0
      }, {
        denom: "ampROAR",
        exponent: 6
      }],
      base: "factory/terra1vklefn7n6cchn0u962w3gaszr4vf52wjvd4y95t2sydwpmpdtszsqvk9wy/ampROAR",
      name: "ERIS Amplified ROAR",
      display: "ampROAR",
      symbol: "ampROAR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/amproar.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/amproar.png",
        theme: {
          primary_color_hex: "#5b83c3"
        }
      }]
    },
    {
      description: "Nico Dao Money",
      type_asset: "cw20",
      address: "terra1e0efrrrj8d55pflme3dmtyuj7klzcef5cfmz6r2jyqz77kk2jz3qa6drg3",
      denom_units: [{
        denom: "cw20:terra1e0efrrrj8d55pflme3dmtyuj7klzcef5cfmz6r2jyqz77kk2jz3qa6drg3",
        exponent: 0
      }, {
        denom: "nico",
        exponent: 18
      }],
      base: "cw20:terra1e0efrrrj8d55pflme3dmtyuj7klzcef5cfmz6r2jyqz77kk2jz3qa6drg3",
      name: "nico",
      display: "nico",
      symbol: "NICO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/nicodao.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/nicodao.png",
        theme: {
          primary_color_hex: "#f1cc79"
        }
      }]
    },
    {
      description: "Sailing the Seas DAO is a community DAO built on Enterprise on Terra",
      type_asset: "cw20",
      address: "terra1rc6ssp5rym7a0hg29xpj4cc9e67tl56kg5jyzgl9qrhfxxc2ugvsnrkala",
      denom_units: [{
        denom: "cw20:terra1rc6ssp5rym7a0hg29xpj4cc9e67tl56kg5jyzgl9qrhfxxc2ugvsnrkala",
        exponent: 0
      }, {
        denom: "seas",
        exponent: 6
      }],
      base: "cw20:terra1rc6ssp5rym7a0hg29xpj4cc9e67tl56kg5jyzgl9qrhfxxc2ugvsnrkala",
      name: "Sailing The SeaS DAO",
      display: "seas",
      symbol: "SEAS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/SEAS.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/SEAS.png",
        theme: {
          primary_color_hex: "#c0943f"
        }
      }]
    },
    {
      description: "A community DAO built on Enterprise",
      type_asset: "cw20",
      address: "terra18vp5s0r7keezm35hdxsgw8zgfnyn8wejdkk893ag2kqncgpqxhjqwjpc0v",
      denom_units: [{
        denom: "cw20:terra18vp5s0r7keezm35hdxsgw8zgfnyn8wejdkk893ag2kqncgpqxhjqwjpc0v",
        exponent: 0
      }, {
        denom: "bitz",
        exponent: 6
      }],
      base: "cw20:terra18vp5s0r7keezm35hdxsgw8zgfnyn8wejdkk893ag2kqncgpqxhjqwjpc0v",
      name: "BitzDAO",
      display: "bitz",
      symbol: "BITZ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/BITZ.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/BITZ.png",
        theme: {
          primary_color_hex: "#dd6a30"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/A356EC90DC3AE43D485514DA7260EDC7ABB5CFAA0654CE2524C739392975AD3C",
        exponent: 0,
        aliases: ["wstETH"]
      }, {
        denom: "factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/A356EC90DC3AE43D485514DA7260EDC7ABB5CFAA0654CE2524C739392975AD3C",
      name: "Wrapped Lido Staked Ether",
      display: "wstETH",
      symbol: "wstETH",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH",
          channel_id: "channel-25"
        },
        chain: {
          channel_id: "channel-229",
          path: "transfer/channel-229/factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "neutron",
          base_denom: "factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg"
      }
    },
    {
      description: "SEUL DAO",
      type_asset: "cw20",
      address: "terra13s5pxw5j2p4ssvzwvxd8l7h30vke8vjgtng75vqgv6p9vddfk3hskfka0l",
      denom_units: [{
        denom: "cw20:terra13s5pxw5j2p4ssvzwvxd8l7h30vke8vjgtng75vqgv6p9vddfk3hskfka0l",
        exponent: 0
      }, {
        denom: "seul",
        exponent: 6
      }],
      base: "cw20:terra13s5pxw5j2p4ssvzwvxd8l7h30vke8vjgtng75vqgv6p9vddfk3hskfka0l",
      name: "seul",
      display: "seul",
      symbol: "SEUL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/seul.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/seul.png",
        theme: {
          primary_color_hex: "#0da8c9"
        }
      }]
    },
    {
      description: "SEUL DAO",
      type_asset: "cw20",
      address: "terra1q328gl40az3cf9x67cgudn8e8w2az9vsmhtkwsgdu7a43rhy5caqc82yr5",
      denom_units: [{
        denom: "cw20:terra1q328gl40az3cf9x67cgudn8e8w2az9vsmhtkwsgdu7a43rhy5caqc82yr5",
        exponent: 0
      }, {
        denom: "xseul",
        exponent: 6
      }],
      base: "cw20:terra1q328gl40az3cf9x67cgudn8e8w2az9vsmhtkwsgdu7a43rhy5caqc82yr5",
      name: "xseul",
      display: "xseul",
      symbol: "xSEUL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/xseul.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/xseul.png",
        theme: {
          primary_color_hex: "#0ba7ce"
        }
      }]
    },
    {
      description: "ITO DAO",
      type_asset: "cw20",
      address: "terra1c77xqv746m7ghxayrge79dxr4kcezev8g6cnrfled4f3n4ufj0vs5gz28s",
      denom_units: [{
        denom: "cw20:terra1c77xqv746m7ghxayrge79dxr4kcezev8g6cnrfled4f3n4ufj0vs5gz28s",
        exponent: 0
      }, {
        denom: "ito",
        exponent: 6
      }],
      base: "cw20:terra1c77xqv746m7ghxayrge79dxr4kcezev8g6cnrfled4f3n4ufj0vs5gz28s",
      name: "ito",
      display: "ito",
      symbol: "ITO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/I.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/I.png",
        theme: {
          primary_color_hex: "#f8d034"
        }
      }]
    },
    {
      description: "Chris Armani Token",
      type_asset: "cw20",
      address: "terra1aa7stl3fytvave9xtcexgv0kne4k7ks068dcljkrfj37hy8q270sjadav8",
      denom_units: [{
        denom: "cw20:terra1aa7stl3fytvave9xtcexgv0kne4k7ks068dcljkrfj37hy8q270sjadav8",
        exponent: 0
      }, {
        denom: "ARMANI",
        exponent: 6
      }],
      base: "cw20:terra1aa7stl3fytvave9xtcexgv0kne4k7ks068dcljkrfj37hy8q270sjadav8",
      name: "ARMANI",
      display: "ARMANI",
      symbol: "ARMANI",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/armani.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/armani.png",
        theme: {
          primary_color_hex: "#d19a84"
        }
      }]
    },
    {
      description: "useless meme coin",
      type_asset: "cw20",
      address: "terra1cl273523kmr2uwjhhznq54je69mted2u3ljffm8kp2ap4z3drdksftwqun",
      denom_units: [{
        denom: "cw20:terra1cl273523kmr2uwjhhznq54je69mted2u3ljffm8kp2ap4z3drdksftwqun",
        exponent: 0
      }, {
        denom: "DROGO",
        exponent: 6
      }],
      base: "cw20:terra1cl273523kmr2uwjhhznq54je69mted2u3ljffm8kp2ap4z3drdksftwqun",
      name: "DROGO",
      display: "DROGO",
      symbol: "DROGO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/drogo.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/drogo.png",
        theme: {
          primary_color_hex: "#ae987b"
        }
      }]
    },
    {
      description: "ado the flower of night",
      type_asset: "cw20",
      address: "terra1w8xk6rtu40st6lvl3yv7ynw5urm2n686u9cchvrzltmnktzwdesqcwy0nu",
      denom_units: [{
        denom: "cw20:terra1w8xk6rtu40st6lvl3yv7ynw5urm2n686u9cchvrzltmnktzwdesqcwy0nu",
        exponent: 0
      }, {
        denom: "ADO",
        exponent: 6
      }],
      base: "cw20:terra1w8xk6rtu40st6lvl3yv7ynw5urm2n686u9cchvrzltmnktzwdesqcwy0nu",
      name: "ADO",
      display: "ADO",
      symbol: "ADO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ADO.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ADO.png",
        theme: {
          primary_color_hex: "#040607"
        }
      }]
    },
    {
      description: "The first memecoin on osmosis.",
      denom_units: [{
        denom: "ibc/E18C0D303957867A164DE2863D1C3F83135936E6F17CADF4D241FBC12B0F23B2",
        exponent: 0
      }, {
        denom: "WOSMO",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E18C0D303957867A164DE2863D1C3F83135936E6F17CADF4D241FBC12B0F23B2",
      name: "Wosmo",
      display: "WOSMO",
      symbol: "WOSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO",
          channel_id: "channel-1"
        },
        chain: {
          channel_id: "channel-251",
          path: "transfer/channel-251/factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosis",
          base_denom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png",
        theme: {
          primary_color_hex: "#edd5ee"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/wosmo.png"
      }
    },
    {
      description: "DNA DAO",
      type_asset: "cw20",
      address: "terra1epka8wevu90rxlvt6g5x9veevd800a760vtuftc5kqdfmrh47qds9f0m8h",
      denom_units: [{
        denom: "cw20:terra1epka8wevu90rxlvt6g5x9veevd800a760vtuftc5kqdfmrh47qds9f0m8h",
        exponent: 0
      }, {
        denom: "DNA",
        exponent: 6
      }],
      base: "cw20:terra1epka8wevu90rxlvt6g5x9veevd800a760vtuftc5kqdfmrh47qds9f0m8h",
      name: "DNA",
      display: "DNA",
      symbol: "DNA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/DNA.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/DNA.png",
        theme: {
          primary_color_hex: "#232333"
        }
      }]
    },
    {
      description: "Bitmos opens doors for BRC20 tokens to thrive alongside established players in the Cosmos Network, revolutionizing decentralized finance (DeFi) for all.",
      type_asset: "cw20",
      address: "terra1sxe8u2hjczlekwfkcq0rs28egt38pg3wqzfx4zcrese4fnvzzupsk9gjkq",
      denom_units: [{
        denom: "cw20:terra1sxe8u2hjczlekwfkcq0rs28egt38pg3wqzfx4zcrese4fnvzzupsk9gjkq",
        exponent: 0
      }, {
        denom: "bitmos",
        exponent: 6
      }],
      base: "cw20:terra1sxe8u2hjczlekwfkcq0rs28egt38pg3wqzfx4zcrese4fnvzzupsk9gjkq",
      name: "Bitmos",
      display: "bitmos",
      symbol: "BMOS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bitmos.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bitmos.png",
        theme: {
          primary_color_hex: "#0c0704"
        }
      }]
    },
    {
      type_asset: "cw20",
      address: "terra1eh8eq60cjy997w5dc3a6exfzanlaurupav8klx7m9u9ddfgh25mqjwl5vj",
      denom_units: [{
        denom: "cw20:terra1eh8eq60cjy997w5dc3a6exfzanlaurupav8klx7m9u9ddfgh25mqjwl5vj",
        exponent: 0
      }, {
        denom: "lads",
        exponent: 6
      }],
      base: "cw20:terra1eh8eq60cjy997w5dc3a6exfzanlaurupav8klx7m9u9ddfgh25mqjwl5vj",
      name: "LADS",
      display: "lads",
      symbol: "LADS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/LADS.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/LADS.png",
        theme: {
          primary_color_hex: "#040507"
        }
      }]
    },
    {
      denom_units: [{
        denom: "ibc/F709DF4969CD26174C1A53AA95F3D98BE643C1A52C9981487766F96A1811F6A4",
        exponent: 0,
        aliases: ["factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"]
      }, {
        denom: "rstk",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/F709DF4969CD26174C1A53AA95F3D98BE643C1A52C9981487766F96A1811F6A4",
      name: "Restake DAO Token",
      display: "rstk",
      symbol: "RSTK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-86",
          path: "transfer/channel-86/factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "migaloo",
          base_denom: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.svg",
        theme: {
          primary_color_hex: "#3ccc64"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/rstk.svg"
      }
    },
    {
      description: "ClonEliteFund invests in Cosmos ecosystem projects, focusing on scalability, security, and interoperability to maximize returns.",
      type_asset: "cw20",
      address: "terra164ssz60yvsxey0ku9mtcaegdeyxwzuwwqyrp238nvflwqve0pvxsra7fa2",
      denom_units: [{
        denom: "cw20:terra164ssz60yvsxey0ku9mtcaegdeyxwzuwwqyrp238nvflwqve0pvxsra7fa2",
        exponent: 0
      }, {
        denom: "CLON",
        exponent: 6
      }],
      base: "cw20:terra164ssz60yvsxey0ku9mtcaegdeyxwzuwwqyrp238nvflwqve0pvxsra7fa2",
      name: "CLON",
      display: "CLON",
      symbol: "CLON",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/clon1.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/clon1.png",
        theme: {
          primary_color_hex: "#c7cbcf"
        }
      }]
    },
    {
      description: "ERIS Liquid Alliance Staked ampROAR",
      denom_units: [{
        denom: "factory/terra1dndhtdr2v7ca8rrn67chlqw3cl3xhm3m2uxls62vghcg3fsh5tpss5xmcu/MOAR",
        exponent: 0
      }, {
        denom: "MOAR",
        exponent: 6
      }],
      base: "factory/terra1dndhtdr2v7ca8rrn67chlqw3cl3xhm3m2uxls62vghcg3fsh5tpss5xmcu/MOAR",
      name: "ERIS MOAR",
      display: "MOAR",
      symbol: "MOAR",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/moar.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/moar.png",
        theme: {
          primary_color_hex: "#9363b3"
        }
      }]
    },
    {
      description: "Tether USDt on Terra",
      denom_units: [{
        denom: "ibc/9B19062D46CAB50361CE9B0A3E6D0A7A53AC9E7CB361F32A73CC733144A9A9E5",
        exponent: 0
      }, {
        denom: "usdt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9B19062D46CAB50361CE9B0A3E6D0A7A53AC9E7CB361F32A73CC733144A9A9E5",
      name: "Tether USDt",
      display: "usdt",
      symbol: "USDt",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt",
          channel_id: "channel-138"
        },
        chain: {
          channel_id: "channel-272",
          path: "transfer/channel-272/erc20/tether/usdt"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "kava",
          base_denom: "erc20/tether/usdt"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        theme: {
          circle: !0,
          primary_color_hex: "#009393",
          background_color_hex: "#009393"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdt.svg"
      }
    },
    {
      description: "ATOM-LUNA liquidity pool token on URA",
      denom_units: [{
        denom: "factory/terra1djk2zl83dspt696ex5crhfacu8vm6934576t4zdd2592fzyahr2qma6guq/ULUN-IBC/-LP",
        exponent: 0
      }, {
        denom: "atom-luna-lp",
        exponent: 6
      }],
      base: "factory/terra1djk2zl83dspt696ex5crhfacu8vm6934576t4zdd2592fzyahr2qma6guq/ULUN-IBC/-LP",
      name: "ATOM-LUNA LP Token URA",
      display: "atom-luna-lp",
      symbol: "ATOM-LUNA-LP",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ura.svg"
      }]
    },
    {
      description: "LUNA-USDC liquidity pool token on URA",
      denom_units: [{
        denom: "factory/terra12jxfw2vg4cu6mxlgf39dp5ccxtuwm468w8eh9cnh2qsxc9t0sffs7ekhft/ULUN-IBC/-LP",
        exponent: 0
      }, {
        denom: "luna-usdc-lp",
        exponent: 6
      }],
      base: "factory/terra12jxfw2vg4cu6mxlgf39dp5ccxtuwm468w8eh9cnh2qsxc9t0sffs7ekhft/ULUN-IBC/-LP",
      name: "LUNA-USDC LP Token URA",
      display: "luna-usdc-lp",
      symbol: "LUNA-USDC-LP",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ura.svg"
      }]
    },
    {
      description: "LUNA-USDT liquidity pool token on URA",
      denom_units: [{
        denom: "factory/terra1w9spejtuac5dt0gympq576uhwde39exhh7hdxwl99rjvaphfukkq6y4cv7/ULUN-IBC/-LP",
        exponent: 0
      }, {
        denom: "luna-usdt-lp",
        exponent: 6
      }],
      base: "factory/terra1w9spejtuac5dt0gympq576uhwde39exhh7hdxwl99rjvaphfukkq6y4cv7/ULUN-IBC/-LP",
      name: "LUNA-USDT LP Token URA",
      display: "luna-usdt-lp",
      symbol: "LUNA-USDT-LP",
      images: [{
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ura.svg"
      }]
    },
    {
      description: "ashLUNA",
      denom_units: [{
        denom: "factory/terra1f5cfm48gcezl3cx25l64ngc4yktnmx7rcpj3kggu6v273742sqqs5yn5ks/luna.ash",
        exponent: 0
      }, {
        denom: "ashLUNA",
        exponent: 6
      }],
      base: "factory/terra1f5cfm48gcezl3cx25l64ngc4yktnmx7rcpj3kggu6v273742sqqs5yn5ks/luna.ash",
      name: "ashLUNA",
      display: "ashLUNA",
      symbol: "ashLUNA",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.ash.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.ash.png",
        theme: {
          primary_color_hex: "#66bcf2"
        }
      }]
    },
    {
      description: "USDC is a fully collateralized US Dollar stablecoin developed by CENTRE, the open source project with Circle being the first of several forthcoming issuers.",
      denom_units: [{
        denom: "ibc/2C962DAB9F57FE0921435426AE75196009FAA1981BF86991203C8411F8980FDB",
        exponent: 0,
        aliases: ["microusdc", "uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2C962DAB9F57FE0921435426AE75196009FAA1981BF86991203C8411F8980FDB",
      name: "USDC",
      display: "usdc",
      symbol: "USDC",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "additional-mintage",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
          },
          provider: "Circle"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "noble",
            base_denom: "uusdc",
            channel_id: "channel-30"
          },
          chain: {
            channel_id: "channel-253",
            path: "transfer/channel-253/uusdc"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }, {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }]
    },
    {
      description: "Cosmo is the best currency in the universe.",
      denom_units: [{
        denom: "ibc/4925733868E7999F5822C961ADE9470A7FC5FA4A560BAE1DE102783C3F64C201",
        exponent: 0,
        aliases: ["factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO"]
      }, {
        denom: "COSMO",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/4925733868E7999F5822C961ADE9470A7FC5FA4A560BAE1DE102783C3F64C201",
      name: "Cosmo",
      display: "COSMO",
      symbol: "COSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "injective",
          base_denom: "factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO",
          channel_id: "channel-8"
        },
        chain: {
          channel_id: "channel-122",
          path: "transfer/channel-122/factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/cosmo.png"
      },
      images: [{
        image_sync: {
          chain_name: "injective",
          base_denom: "factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/cosmo.png",
        theme: {
          primary_color_hex: "#343169"
        }
      }],
      socials: {
        website: "https://github.com/raphaellafar/Cosmo",
        twitter: "https://x.com/CosmoClub84"
      }
    }
  ]
};
wf.default = JG;
var xf = {};
Object.defineProperty(xf, "__esModule", { value: !0 });
const ZG = {
  $schema: "../chain.schema.json",
  chain_name: "terra2",
  status: "live",
  network_type: "mainnet",
  website: "https://www.terra.money/",
  pretty_name: "Terra",
  chain_type: "cosmos",
  chain_id: "phoenix-1",
  daemon_name: "terrad",
  node_home: "$HOME/.terra",
  bech32_prefix: "terra",
  slip44: 330,
  fees: {
    fee_tokens: [{
      denom: "uluna",
      fixed_min_gas_price: 0.015,
      low_gas_price: 0.015,
      average_gas_price: 0.015,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uluna"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg"
  },
  description: "Fueled by a passionate community and deep developer talent pool, the Terra blockchain is built to enable the next generation of Web3 products and services.",
  apis: {
    rpc: [
      {
        address: "https://rpc.lavenderfive.com:443/terra2",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://terra-rpc.polkachu.com",
        provider: "polkachu"
      },
      {
        address: "https://terra-rpc.stakely.io:443/",
        provider: "stakely"
      },
      {
        address: "https://phoenix-rpc.terra.dev:443",
        provider: "Terraform Labs"
      },
      {
        address: "https://terra-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc-terra-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://rpc-terra.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://terra-phoenix-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://rpc-terra.wildsage.io",
        provider: "🧙 WildSage Labs"
      },
      {
        address: "https://terra.interstellar-lounge.org",
        provider: "Interstellar Lounge 🍸"
      },
      {
        address: "https://terra2.tdrsys.com:2053",
        provider: "TdrSys"
      },
      {
        address: "https://terra-rpc.cosmosrescue.dev:8443",
        provider: "cosmosrescue"
      }
    ],
    rest: [
      {
        address: "https://lcd-terra.wildsage.io",
        provider: "🧙 WildSage Labs"
      },
      {
        address: "https://phoenix-lcd.terra.dev:443",
        provider: "Terraform Labs"
      },
      {
        address: "https://api-terra.cosmos-spaces.cloud",
        provider: "Cosmos Spaces"
      },
      {
        address: "https://terra-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://api-terra-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://terra-phoenix-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://terra-rest.interstellar-lounge.org",
        provider: "Interstellar Lounge 🍸"
      },
      {
        address: "https://terra2.tdrsys.com",
        provider: "TdrSys"
      },
      {
        address: "https://terra-api.cosmosrescue.dev:8443",
        provider: "cosmosrescue"
      }
    ],
    grpc: [
      {
        address: "terra2.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "terra-grpc.polkachu.com:11790",
        provider: "Polkachu"
      },
      {
        address: "terra-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "terra-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "grpc-terra.cosmos-spaces.cloud:2690",
        provider: "Cosmos Spaces"
      },
      {
        address: "grpc-terra-01.stakeflow.io:1102",
        provider: "Stakeflow"
      },
      {
        address: "https://terra2.tdrsys.com:2083",
        provider: "TdrSys"
      }
    ]
  },
  explorers: [
    {
      kind: "atomscan",
      url: "https://atomscan.com/terra2",
      tx_page: "https://atomscan.com/terra2/transactions/${txHash}",
      account_page: "https://atomscan.com/terra2/accounts/${accountAddress}"
    },
    {
      kind: "finder",
      url: "http://finder.terra.money/",
      tx_page: "https://finder.terra.money/mainnet/tx/${txHash}",
      account_page: "https://finder.terra.money/mainnet/address/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/terra",
      account_page: "https://stakeflow.io/terra/accounts/${accountAddress}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/terra",
      tx_page: "https://www.mintscan.io/terra/transactions/${txHash}",
      account_page: "https://www.mintscan.io/terra/accounts/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg",
    theme: {
      primary_color_hex: "#f4de6f"
    }
  }]
};
xf.default = ZG;
var kf = {};
Object.defineProperty(kf, "__esModule", { value: !0 });
const QG = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "acrechain",
      client_id: "07-tendermint-11",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-101",
      connection_id: "connection-89"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-77",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "akash",
      client_id: "07-tendermint-173",
      connection_id: "connection-159"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-387",
      connection_id: "connection-364"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-273",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "andromeda",
      client_id: "07-tendermint-15",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-409",
      connection_id: "connection-413"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-351",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-42",
      connection_id: "connection-47"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-384",
      connection_id: "connection-360"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-265",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-39",
      connection_id: "connection-21"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-7",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "carbon",
      client_id: "07-tendermint-33",
      connection_id: "connection-16"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-66",
      connection_id: "connection-54"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "demex"
      }
    }, {
      chain_1: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-41",
        port_id: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-53",
      connection_id: "connection-16"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-391",
      connection_id: "connection-381"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-15",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-300",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cheqd",
      client_id: "07-tendermint-83",
      connection_id: "connection-61"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-392",
      connection_id: "connection-382"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-301",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "comdex",
      client_id: "07-tendermint-117",
      connection_id: "connection-56"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-70",
      connection_id: "connection-59"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-39",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-760",
      connection_id: "connection-551"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-0",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-339",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-36",
      connection_id: "connection-37"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-68",
      connection_id: "connection-57"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-27",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "decentr",
      client_id: "07-tendermint-26",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-395",
      connection_id: "connection-385"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-315",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-9",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-390",
      connection_id: "connection-380"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-299",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "furya",
      client_id: "07-tendermint-14",
      connection_id: "connection-10"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-422",
      connection_id: "connection-436"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-495",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-216",
      connection_id: "connection-202"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-369",
      connection_id: "connection-311"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-151",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-255",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "juno",
      client_id: "07-tendermint-185",
      connection_id: "connection-128"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-3",
      connection_id: "connection-6"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-86",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-156",
      connection_id: "connection-196"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-386",
      connection_id: "connection-362"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-138",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-272",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kujira",
      client_id: "07-tendermint-5",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-11",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-28",
        port_id: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "mars",
      client_id: "07-tendermint-10",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-104",
      connection_id: "connection-91"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-78",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-105",
      connection_id: "connection-93"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-86",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-87",
        port_id: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutron",
      client_id: "07-tendermint-12",
      connection_id: "connection-9"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-274",
      connection_id: "connection-192"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-25",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-229",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-5",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-167",
          port_id: "wasm.terra1jhfjnm39y3nn9l4520mdn4k5mw23nz0674c4gsvyrcr90z9tqcvst22fce"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-2112",
          port_id: "wasm.neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07"
        },
        chain_2: {
          channel_id: "channel-396",
          port_id: "wasm.terra1k9j8rcyk87v5jvfla2m9wp200azegjz0eshl7n2pwv852a7ssceqsnn7pq"
        },
        ordering: "unordered",
        version: "astroport-ibc-v1",
        tags: {
          status: "live",
          preferred: !0
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-56",
      connection_id: "connection-54"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-367",
      connection_id: "connection-302"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-30",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-253",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1979",
      connection_id: "connection-1536"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-251",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-1",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0,
          dex: "osmosis"
        }
      },
      {
        chain_1: {
          channel_id: "channel-559",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-85",
          port_id: "wasm.terra1d90p5lacfxnqgjxjupu234lxnxyeu8fdeef4d0e0nqy3p30r7gss4myn9x"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0,
          dex: "osmosis"
        }
      },
      {
        chain_1: {
          channel_id: "channel-341",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-26",
          port_id: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0,
          dex: "osmosis"
        }
      },
      {
        chain_1: {
          channel_id: "channel-21671",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-392",
          port_id: "wasm.terra1jhfjnm39y3nn9l4520mdn4k5mw23nz0674c4gsvyrcr90z9tqcvst22fce"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0,
          dex: "osmosis"
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "pryzm",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-410",
      connection_id: "connection-414"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-4",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-473",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-17",
          port_id: "icacontroller-delegation-uluna"
        },
        chain_2: {
          channel_id: "channel-478",
          port_id: "icahost"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-18",
          port_id: "icacontroller-reward-uluna"
        },
        chain_2: {
          channel_id: "channel-479",
          port_id: "icahost"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      },
      {
        chain_1: {
          channel_id: "channel-19",
          port_id: "icacontroller-sweep-uluna"
        },
        chain_2: {
          channel_id: "channel-480",
          port_id: "icahost"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live",
          preferred: !0
        }
      }
    ]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-38",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-4",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }, {
      chain_1: {
        channel_id: "channel-127",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-382",
        port_id: "wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "stafihub",
      client_id: "07-tendermint-5",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-317",
      connection_id: "connection-233"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-204",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "stargaze",
      client_id: "07-tendermint-337",
      connection_id: "connection-275"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-405",
      connection_id: "connection-408"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-266",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-324",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "stride",
      client_id: "07-tendermint-51",
      connection_id: "connection-32"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-87",
      connection_id: "connection-72"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-52",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-46",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "terra",
      client_id: "07-tendermint-235",
      connection_id: "connection-142"
    },
    chain_2: {
      chain_name: "terra2",
      client_id: "07-tendermint-394",
      connection_id: "connection-384"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-85",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-314",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
kf.default = QG;
var Af = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ra, "__esModule", { value: !0 });
ra.ibc = ra.chain = ra.assets = void 0;
const eK = Af(wf), nK = Af(xf), tK = Af(kf);
ra.assets = eK.default;
ra.chain = nK.default;
ra.ibc = tK.default;
var ia = {}, jf = {};
Object.defineProperty(jf, "__esModule", { value: !0 });
const sK = {
  $schema: "../assetlist.schema.json",
  chain_name: "tgrade",
  assets: [{
    description: "The native token of Tgrade",
    denom_units: [{
      denom: "utgd",
      exponent: 0
    }, {
      denom: "tgd",
      exponent: 6
    }],
    base: "utgd",
    name: "Tgrade",
    display: "tgd",
    symbol: "TGD",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-symbol-gradient.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-symbol-gradient.svg"
    },
    coingecko_id: "tgrade",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-symbol-gradient.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-symbol-gradient.svg",
      theme: {
        primary_color_hex: "#a7248a"
      }
    }]
  }]
};
jf.default = sK;
var Cf = {};
Object.defineProperty(Cf, "__esModule", { value: !0 });
const aK = {
  $schema: "../chain.schema.json",
  chain_name: "tgrade",
  status: "live",
  network_type: "mainnet",
  website: "https://tgrade.finance/",
  pretty_name: "Tgrade",
  chain_type: "cosmos",
  chain_id: "tgrade-mainnet-1",
  bech32_prefix: "tgrade",
  daemon_name: "tgrade",
  node_home: "$HOME/.tgrade",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utgd",
      fixed_min_gas_price: 0.05,
      low_gas_price: 0.05,
      average_gas_price: 0.075,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "utgd"
    }]
  },
  codebase: {
    cosmwasm_enabled: !0
  },
  apis: {
    rpc: [{
      address: "https://rpc.mainnet-1.tgrade.confio.run",
      provider: "Confio"
    }, {
      address: "https://rpc.tgrade.posthuman.digital",
      provider: "POSTHUMAN ꝏ DVS"
    }],
    rest: [{
      address: "https://api.mainnet-1.tgrade.confio.run",
      provider: "Confio"
    }, {
      address: "https://lcd.tgrade.posthuman.digital",
      provider: "POSTHUMAN ꝏ DVS"
    }],
    grpc: []
  },
  explorers: [{
    kind: "aneka",
    url: "https://tgrade.aneka.io",
    tx_page: "https://tgrade.aneka.io/txs/${txHash}",
    account_page: "https://tgrade.aneka.io/accounts/${accountAddress}"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-logo-gradient_h.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-symbol-gradient.svg"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-logo-gradient_h.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/tgrade/images/tgrade-symbol-gradient.svg",
    theme: {
      primary_color_hex: "#c9167b"
    }
  }]
};
Cf.default = aK;
var Ef = {};
Object.defineProperty(Ef, "__esModule", { value: !0 });
const oK = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "evmos",
    client_id: "07-tendermint-88",
    connection_id: "connection-46"
  },
  chain_2: {
    chain_name: "tgrade",
    client_id: "07-tendermint-8",
    connection_id: "connection-11"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-34",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-9",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2025",
    connection_id: "connection-1565"
  },
  chain_2: {
    chain_name: "tgrade",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-263",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Ef.default = oK;
var Df = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ia, "__esModule", { value: !0 });
ia.ibc = ia.chain = ia.assets = void 0;
const rK = Df(jf), iK = Df(Cf), cK = Df(Ef);
ia.assets = rK.default;
ia.chain = iK.default;
ia.ibc = cK.default;
var Dr = {}, Bf = {};
Object.defineProperty(Bf, "__esModule", { value: !0 });
const dK = {
  $schema: "../assetlist.schema.json",
  chain_name: "thorchain",
  assets: [{
    description: "The native token of THORChain",
    denom_units: [{
      denom: "rune",
      exponent: 0
    }, {
      denom: "RUNE",
      exponent: 8
    }],
    base: "rune",
    name: "THORChain RUNE",
    display: "RUNE",
    symbol: "RUNE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/thorchain/images/rune.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/thorchain/images/rune.svg"
    },
    coingecko_id: "thorchain",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/thorchain/images/rune.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/thorchain/images/rune.svg"
    }]
  }]
};
Bf.default = dK;
var Ff = {};
Object.defineProperty(Ff, "__esModule", { value: !0 });
const mK = {
  $schema: "../chain.schema.json",
  chain_name: "thorchain",
  status: "live",
  network_type: "mainnet",
  website: "https://thorchain.org/",
  pretty_name: "THORChain",
  chain_type: "cosmos",
  chain_id: "thorchain-1",
  bech32_prefix: "thor",
  daemon_name: "thord",
  node_home: "$HOME/.thornode",
  slip44: 931,
  codebase: {
    cosmos_sdk_version: "v0.45.16",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [],
    rest: []
  },
  explorers: [{
    kind: "THORChain explorer",
    url: "https://thorchain.net",
    tx_page: "https://thorchain.net/#/txs/${txHash}"
  }, {
    kind: "viewblock",
    url: "https://viewblock.io/thorchain",
    tx_page: "https://viewblock.io/thorchain/tx/${txHash}"
  }]
};
Ff.default = mK;
var eA = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Dr, "__esModule", { value: !0 });
Dr.chain = Dr.assets = void 0;
const hK = eA(Bf), pK = eA(Ff);
Dr.assets = hK.default;
Dr.chain = pK.default;
var Br = {}, $f = {};
Object.defineProperty($f, "__esModule", { value: !0 });
const lK = {
  $schema: "../assetlist.schema.json",
  chain_name: "titan",
  assets: [{
    description: "The native token of the Titan network.",
    denom_units: [
      {
        denom: "atkx",
        exponent: 0,
        aliases: ["attotkx"]
      },
      {
        denom: "utkx",
        exponent: 12,
        aliases: ["microtkx"]
      },
      {
        denom: "mtkx",
        exponent: 15,
        aliases: ["millitkx"]
      },
      {
        denom: "tkx",
        exponent: 18,
        aliases: []
      }
    ],
    base: "atkx",
    display: "tkx",
    name: "titan tkx",
    symbol: "TKX",
    coingecko_id: "tokenize-xchange",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/titan/images/tkx.png",
      theme: {
        primary_color_hex: "#fc641c"
      }
    }],
    keywords: ["staking"],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/titan/images/tkx.png"
    }
  }]
};
$f.default = lK;
var zf = {};
Object.defineProperty(zf, "__esModule", { value: !0 });
const gK = {
  $schema: "../chain.schema.json",
  chain_name: "titan",
  status: "live",
  network_type: "mainnet",
  website: "https://titanlab.io/",
  pretty_name: "Titan",
  chain_type: "cosmos",
  chain_id: "titan_18888-1",
  bech32_prefix: "titan",
  node_home: "$HOME/.titand",
  daemon_name: "titand",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "atkx",
      fixed_min_gas_price: 1e11,
      low_gas_price: 1e11,
      average_gas_price: 11e10,
      high_gas_price: 2e11
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "atkx"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47.6-titan.4",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.45.0"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/titan/images/chain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/titan/images/chain.svg",
    theme: {
      primary_color_hex: "#fc641c"
    }
  }],
  apis: {
    rpc: [
      {
        address: "https://titan-rpc.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-rpc-tokyo.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-rpc-seoul.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-rpc-hongkong.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-rpc.ibs.team",
        provider: "ibs.team"
      }
    ],
    rest: [
      {
        address: "https://titan-lcd.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-lcd-tokyo.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-lcd-seoul.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-lcd-hongkong.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-api.ibs.team",
        provider: "ibs.team"
      }
    ],
    grpc: [
      {
        address: "titan-grpc.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "titan-grpc-hongkong.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "titan-grpc-tokyo.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "titan-grpc-seoul.titanlab.io:443",
        provider: "Titanlab.io"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://titan-json-rpc.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-json-rpc-tokyo.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-json-rpc-seoul.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-json-rpc-hongkong.titanlab.io:443",
        provider: "Titanlab.io"
      }
    ]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://tkxscan.io",
    tx_page: "https://tkxscan.io/Titan/tx/${txHash}",
    account_page: "https://tkxscan.io/Titan/account/${accountAddress}"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/titan/images/chain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/titan/images/chain.svg"
  }
};
zf.default = gK;
var nA = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Br, "__esModule", { value: !0 });
Br.chain = Br.assets = void 0;
const uK = nA($f), _K = nA(zf);
Br.assets = uK.default;
Br.chain = _K.default;
var ca = {}, qf = {};
Object.defineProperty(qf, "__esModule", { value: !0 });
const yK = {
  $schema: "../assetlist.schema.json",
  chain_name: "umee",
  assets: [{
    description: "The native token of Umee",
    denom_units: [{
      denom: "uumee",
      exponent: 0
    }, {
      denom: "umee",
      exponent: 6
    }],
    base: "uumee",
    name: "Umee",
    display: "umee",
    symbol: "UMEE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.svg"
    },
    coingecko_id: "umee",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.svg",
      theme: {
        primary_color_hex: "#22f2e9"
      }
    }]
  }]
};
qf.default = yK;
var Sf = {};
Object.defineProperty(Sf, "__esModule", { value: !0 });
const bK = {
  $schema: "../chain.schema.json",
  chain_name: "umee",
  status: "live",
  network_type: "mainnet",
  website: "https://www.ux.xyz",
  pretty_name: "UX Chain",
  chain_type: "cosmos",
  chain_id: "umee-1",
  bech32_prefix: "umee",
  daemon_name: "umeed",
  node_home: "$HOME/.umee",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uumee",
      fixed_min_gas_price: 0.1,
      low_gas_price: 0.1,
      average_gas_price: 0.12,
      high_gas_price: 0.2
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uumee"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.43"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://umee-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-umee-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://umee-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "http://umee.rpc.m.stavr.tech:10457",
        provider: "🔥STAVR🔥"
      },
      {
        address: "http://rpc-umee-0.node75.org:26657",
        provider: "Pro-Nodes75"
      },
      {
        address: "https://umee-rpc.quantnode.tech",
        provider: "QuantNode"
      },
      {
        address: "https://umee-rpc.tienthuattoan.com",
        provider: "TTT 🇻🇳"
      },
      {
        address: "https://rpc-umee-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://umee-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://umee-rpc.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://umee.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://umee-rpc.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://rpc-umee.mms.team",
        provider: "MMS"
      },
      {
        address: "https://rpc-umee.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://umee-rpc.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://umee-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://umee.rpc.stakevillage.net:443",
        provider: "Stake Village"
      },
      {
        address: "https://umee-rpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [
      {
        address: "https://api-umee-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://umee.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://umee-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://umee-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://umee-lcd.quantnode.tech",
        provider: "QuantNode"
      },
      {
        address: "https://umee-api.tienthuattoan.ventures",
        provider: "TienThuatToan"
      },
      {
        address: "https://api-umee-01.stakeflow.io",
        provider: "Stakeflow"
      },
      {
        address: "https://umee-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://umee-api.theamsolutions.info",
        provider: "AM Solutions"
      },
      {
        address: "https://umee.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://umee-api.w3coins.io",
        provider: "w3coins"
      },
      {
        address: "https://api-umee.mms.team",
        provider: "MMS"
      },
      {
        address: "https://api-umee.mzonder.com",
        provider: "MZONDER"
      },
      {
        address: "https://umee-api.stake-town.com",
        provider: "StakeTown"
      },
      {
        address: "https://umee-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://umee.api.stakevillage.net",
        provider: "Stake Village"
      },
      {
        address: "https://umee-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "grpc-umee-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "umee-grpc.polkachu.com:13690",
        provider: "Polkachu"
      },
      {
        address: "umee-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "umee-grpc.quantnode.tech:9090",
        provider: "QuantNode gRPC"
      },
      {
        address: "umee.grpc.m.stavr.tech:9090",
        provider: "🔥STAVR🔥"
      },
      {
        address: "umee-grpc.quantnode.tech:9091",
        provider: "QuantNode gRPCweb"
      },
      {
        address: "umee-grpc.tienthuattoan.ventures:9090",
        provider: "TienThuatToan"
      },
      {
        address: "grpc-umee-01.stakeflow.io:9990",
        provider: "Stakeflow"
      },
      {
        address: "services.staketab.com:9020",
        provider: "Staketab"
      },
      {
        address: "umee.grpc.kjnodes.com:16290",
        provider: "kjnodes"
      },
      {
        address: "umee-grpc.w3coins.io:13690",
        provider: "w3coins"
      },
      {
        address: "grpc-umee.mms.team:443",
        provider: "MMS"
      },
      {
        address: "grpc-umee.mzonder.com:443",
        provider: "MZONDER"
      },
      {
        address: "umee-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "umee.grpc.stakevillage.net:11090",
        provider: "Stake Village"
      },
      {
        address: "umee-grpc.noders.services:32090",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/umee/",
      tx_page: "https://www.mintscan.io/umee/transactions/${txHash}",
      account_page: "https://www.mintscan.io/umee/accounts/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/umee",
      tx_page: "https://ping.pub/umee/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/umee",
      tx_page: "https://explorer.stavr.tech/umee/tx/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://umee.explorers.guru",
      tx_page: "https://umee.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/umee",
      tx_page: "https://atomscan.com/umee/transactions/${txHash}",
      account_page: "https://atomscan.com/umee/accounts/${accountAddress}"
    },
    {
      kind: "Stakeflow",
      url: "https://stakeflow.io/umee",
      account_page: "https://stakeflow.io/umee/accounts/${accountAddress}"
    },
    {
      kind: "Stake-Take",
      url: "https://explorer.stake-take.com/umee",
      tx_page: "https://explorer.stake-take.com/umee/transactions/${txHash}",
      account_page: "https://explorer.stake-take.com/umee/account/${accountAddress}"
    },
    {
      kind: "Stake Village",
      url: "https://exp.stakevillage.net/umee",
      tx_page: "https://exp.stakevillage.net/umee/tx/${txHash}",
      account_page: "https://exp.stakevillage.net/umee/account/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/umee",
      tx_page: "https://ezstaking.app/umee/txs/${txHash}",
      account_page: "https://ezstaking.app/umee/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/umee/images/umee.svg",
    theme: {
      primary_color_hex: "#22f2e9"
    }
  }]
};
Sf.default = bK;
var Tf = {};
Object.defineProperty(Tf, "__esModule", { value: !0 });
const vK = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "agoric",
      client_id: "07-tendermint-18",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-152",
      connection_id: "connection-101"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-42",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-6",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-228",
      connection_id: "connection-190"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-97",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelar",
      client_id: "07-tendermint-64",
      connection_id: "connection-43"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-63",
      connection_id: "connection-44"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestia",
      client_id: "07-tendermint-58",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-245",
      connection_id: "connection-209"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-119",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshub",
      client_id: "07-tendermint-611",
      connection_id: "connection-473"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-9",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-288",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {}
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "crescent",
      client_id: "07-tendermint-56",
      connection_id: "connection-53"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-170",
      connection_id: "connection-110"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-36",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "crescent"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "dydx",
      client_id: "07-tendermint-8",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-244",
      connection_id: "connection-208"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-118",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "injective",
      client_id: "07-tendermint-229",
      connection_id: "connection-217"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-243",
      connection_id: "connection-206"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-159",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-116",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "kava",
      client_id: "07-tendermint-124",
      connection_id: "connection-160"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-229",
      connection_id: "connection-191"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-119",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-98",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "migaloo",
      client_id: "07-tendermint-104",
      connection_id: "connection-83"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-234",
      connection_id: "connection-195"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-56",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-104",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "noble",
      client_id: "07-tendermint-73",
      connection_id: "connection-74"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-248",
      connection_id: "connection-210"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-120",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1805",
      connection_id: "connection-1410"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-6",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-184",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "persistence",
      client_id: "07-tendermint-105",
      connection_id: "connection-144"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-179",
      connection_id: "connection-119"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-81",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "quicksilver",
      client_id: "07-tendermint-27",
      connection_id: "connection-13"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-183",
      connection_id: "connection-122"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-49",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-53",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1"
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "regen",
      client_id: "07-tendermint-176",
      connection_id: "connection-148"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-239",
      connection_id: "connection-200"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-158",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-107",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "secretnetwork",
      client_id: "07-tendermint-193",
      connection_id: "connection-188"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-249",
      connection_id: "connection-213"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-126",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-123",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        properties: "privacy"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "stride",
      client_id: "07-tendermint-32",
      connection_id: "connection-20"
    },
    chain_2: {
      chain_name: "umee",
      client_id: "07-tendermint-64",
      connection_id: "connection-45"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-29",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Tf.default = vK;
var Rf = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ca, "__esModule", { value: !0 });
ca.ibc = ca.chain = ca.assets = void 0;
const fK = Rf(qf), wK = Rf(Sf), xK = Rf(Tf);
ca.assets = fK.default;
ca.chain = wK.default;
ca.ibc = xK.default;
var Fr = {}, Of = {};
Object.defineProperty(Of, "__esModule", { value: !0 });
const kK = {
  $schema: "../assetlist.schema.json",
  chain_name: "unicorn",
  assets: [{
    description: "The native token of Unicorn.",
    denom_units: [{
      denom: "uwunicorn",
      exponent: 0
    }, {
      denom: "unicorn",
      exponent: 6
    }],
    base: "uwunicorn",
    name: "Unicorn",
    display: "unicorn",
    symbol: "UWU",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unicorn/images/uwu.png",
      theme: {
        primary_color_hex: "#D44CE6"
      }
    }],
    socials: {
      website: "https://unicorn.meme/",
      twitter: "https://x.com/unicornandmemes"
    },
    keywords: ["meme"]
  }]
};
Of.default = kK;
var Mf = {};
Object.defineProperty(Mf, "__esModule", { value: !0 });
const AK = {
  $schema: "../chain.schema.json",
  chain_name: "unicorn",
  status: "live",
  network_type: "mainnet",
  website: "https://unicorn.meme/",
  pretty_name: "Unicorn",
  chain_type: "cosmos",
  chain_id: "unicorn-420",
  bech32_prefix: "unicorn",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uwunicorn",
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uwunicorn"
    }]
  }
};
Mf.default = AK;
var tA = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Fr, "__esModule", { value: !0 });
Fr.chain = Fr.assets = void 0;
const jK = tA(Of), CK = tA(Mf);
Fr.assets = jK.default;
Fr.chain = CK.default;
var da = {}, If = {};
Object.defineProperty(If, "__esModule", { value: !0 });
const EK = {
  $schema: "../assetlist.schema.json",
  chain_name: "unification",
  assets: [{
    description: "Staking and governance coin for the Unification Blockchain",
    extended_description: "Fundamentally, the Unification Blockchain Toolkit comprises two core branches: Blockchain Business products, to welcome traditional enterprises into the Web3 economy; and Permissionless Products, an open-access toolkit to power and enrich Dapps on Ethereum/EVM networks",
    denom_units: [{
      denom: "nund",
      exponent: 0
    }, {
      denom: "FUND",
      exponent: 9
    }],
    base: "nund",
    name: "Unification Network",
    display: "FUND",
    symbol: "FUND",
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png",
      theme: {
        primary_color_hex: "#2279c0"
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg"
    },
    socials: {
      website: "https://unification.com",
      twitter: "https://twitter.com/UnificationUND"
    },
    coingecko_id: "unification"
  }]
};
If.default = EK;
var Nf = {};
Object.defineProperty(Nf, "__esModule", { value: !0 });
const DK = {
  $schema: "../chain.schema.json",
  chain_name: "unification",
  status: "live",
  network_type: "mainnet",
  website: "https://unification.com/",
  pretty_name: "Unification",
  chain_type: "cosmos",
  chain_id: "FUND-MainNet-2",
  bech32_prefix: "und",
  daemon_name: "und",
  node_home: "$HOME/.und_mainchain",
  key_algos: ["secp256k1"],
  slip44: 5555,
  fees: {
    fee_tokens: [{
      denom: "nund",
      fixed_min_gas_price: 25,
      low_gas_price: 100,
      average_gas_price: 200,
      high_gas_price: 300
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "nund"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.47.13",
    cosmwasm_enabled: !1
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg",
    theme: {
      primary_color_hex: "#2279c0"
    }
  }],
  apis: {
    rpc: [{
      address: "https://rpc.unification.io:443",
      provider: "Unification"
    }, {
      address: "https://rpc.unification.chainmasters.ninja/",
      provider: "Chainmasters"
    }],
    rest: [{
      address: "https://rest.unification.io",
      provider: "Unification"
    }, {
      address: "https://rest.unification.chainmasters.ninja/",
      provider: "Chainmasters"
    }],
    wss: [{
      address: "wss://wss.unification.io",
      provider: "Unification"
    }],
    grpc: [{
      address: "grpc.unification.io:443",
      provider: "Unification"
    }, {
      address: "grpc.unification.chainmasters.info",
      provider: "Chainmasters"
    }]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://explorer.unification.io/u",
      tx_page: "https://explorer.unification.io/u/tx/${txHash}",
      account_page: "https://explorer.unification.io/u/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.unification.chainmasters.ninja/unification",
      tx_page: "https://explorer.unification.chainmasters.ninja/unification/tx/${txHash}",
      account_page: "https://explorer.unification.chainmasters.ninja/Unification/account/${accountAddress}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/unification",
      tx_page: "https://atomscan.com/unification/transactions/${txHash}",
      account_page: "https://atomscan.com/unification/accounts/${accountAddress}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg"
  }
};
Nf.default = DK;
var Pf = {};
Object.defineProperty(Pf, "__esModule", { value: !0 });
const BK = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "gravitybridge",
    client_id: "07-tendermint-190",
    connection_id: "connection-161"
  },
  chain_2: {
    chain_name: "unification",
    client_id: "07-tendermint-4",
    connection_id: "connection-4"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-98",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2229",
    connection_id: "connection-1746"
  },
  chain_2: {
    chain_name: "unification",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-382",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
Pf.default = BK;
var Uf = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(da, "__esModule", { value: !0 });
da.ibc = da.chain = da.assets = void 0;
const FK = Uf(If), $K = Uf(Nf), zK = Uf(Pf);
da.assets = FK.default;
da.chain = $K.default;
da.ibc = zK.default;
var $r = {}, Hf = {};
Object.defineProperty(Hf, "__esModule", { value: !0 });
const qK = {
  $schema: "../assetlist.schema.json",
  chain_name: "ununifi",
  assets: [{
    description: "The governance token of UnUniFi protocol.",
    denom_units: [{
      denom: "uguu",
      exponent: 0
    }, {
      denom: "guu",
      exponent: 6
    }],
    base: "uguu",
    name: "UnUniFi",
    display: "guu",
    symbol: "GUU",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ununifi/images/ununifi.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ununifi/images/ununifi.svg"
    },
    keywords: [
      "staking",
      "wasm",
      "assets",
      "nft"
    ],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ununifi/images/ununifi.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ununifi/images/ununifi.svg",
      theme: {
        primary_color_hex: "#546c8c"
      }
    }]
  }]
};
Hf.default = qK;
var Lf = {};
Object.defineProperty(Lf, "__esModule", { value: !0 });
const SK = {
  $schema: "../chain.schema.json",
  chain_name: "ununifi",
  status: "live",
  network_type: "mainnet",
  website: "https://ununifi.io/",
  pretty_name: "UnUniFi",
  chain_type: "cosmos",
  chain_id: "ununifi-beta-v1",
  bech32_prefix: "ununifi",
  daemon_name: "ununifid",
  node_home: "$HOME/.ununifi",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uguu",
      fixed_min_gas_price: 25e-4,
      low_gas_price: 25e-4,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uguu"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {
    cosmos_sdk_version: "ununifi/cosmos-sdk v0.47.3-custom-bank-1",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.40.1"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ununifi/images/ununifi.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ununifi/images/ununifi.svg"
  },
  apis: {
    rpc: [
      {
        address: "http://a.lcd.ununifi.cauchye.net:26657",
        provider: "CauchyE"
      },
      {
        address: "https://rpc.ununifi.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rpc.lavenderfive.com:443/ununifi",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc.lavenderfive.com:443/ununifi",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://ununifi-rpc.genznodes.dev",
        provider: "genznodes"
      }
    ],
    rest: [
      {
        address: "https://a.lcd.ununifi.cauchye.net:1318",
        provider: "CauchyE"
      },
      {
        address: "https://b.lcd.ununifi.cauchye.net:1318",
        provider: "CauchyE"
      },
      {
        address: "https://api.ununifi.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://rest.lavenderfive.com:443/ununifi",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://ununifi-api.genznodes.dev",
        provider: "genznodes"
      }
    ],
    grpc: [
      {
        address: "a.lcd.ununifi.cauchye.net:9092",
        provider: "CauchyE"
      },
      {
        address: "b.lcd.ununifi.cauchye.net:9092",
        provider: "CauchyE"
      },
      {
        address: "ununifi-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "grpc.ununifi.nodestake.top:9090",
        provider: "NodeStake"
      },
      {
        address: "https://grpc-ununifi.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "ununifi.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "ununifi-grpc.genznodes.dev:54090",
        provider: "genznodes"
      }
    ]
  },
  explorers: [
    {
      kind: "UnUniFi Explorer",
      url: "https://ununifi.io/explorer",
      tx_page: "https://ununifi.io/explorer/txs/${txHash}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/ununifi",
      tx_page: "https://explorer.nodestake.top/ununifi/tx/${txHash}"
    },
    {
      kind: "Nodeist Explorer",
      url: "https://exp.nodeist.net/Ununifi",
      tx_page: "https://exp.nodeist.net/Ununifi/tx/${txHash}"
    }
  ],
  keywords: [
    "staking",
    "wasm",
    "assets",
    "nft"
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ununifi/images/ununifi.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/ununifi/images/ununifi.svg",
    theme: {
      primary_color_hex: "#546c8c"
    }
  }]
};
Lf.default = SK;
var sA = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty($r, "__esModule", { value: !0 });
$r.chain = $r.assets = void 0;
const TK = sA(Hf), RK = sA(Lf);
$r.assets = TK.default;
$r.chain = RK.default;
var ma = {}, Wf = {};
Object.defineProperty(Wf, "__esModule", { value: !0 });
const OK = {
  $schema: "../assetlist.schema.json",
  chain_name: "uptick",
  assets: [{
    description: "The native token of Uptick",
    denom_units: [{
      denom: "auptick",
      exponent: 0
    }, {
      denom: "uptick",
      exponent: 18
    }],
    base: "auptick",
    name: "Uptick",
    display: "uptick",
    symbol: "UPTICK",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/uptick/images/uptick.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/uptick/images/uptick.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/uptick/images/uptick.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/uptick/images/uptick.svg",
      theme: {
        primary_color_hex: "#1f182f"
      }
    }]
  }]
};
Wf.default = OK;
var Vf = {};
Object.defineProperty(Vf, "__esModule", { value: !0 });
const MK = {
  $schema: "../chain.schema.json",
  chain_name: "uptick",
  status: "live",
  network_type: "mainnet",
  website: "https://uptick.network/",
  pretty_name: "Uptick",
  chain_type: "cosmos",
  chain_id: "uptick_117-1",
  bech32_prefix: "uptick",
  daemon_name: "uptickd",
  node_home: "$HOME/.uptickd",
  key_algos: ["secp256k1"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "auptick",
      fixed_min_gas_price: 13e9,
      low_gas_price: 13e9,
      average_gas_price: 16e9,
      high_gas_price: 2e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "auptick"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.5",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.45.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/uptick/images/uptick.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/uptick/images/uptick.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://uptick-rpc.brocha.in:443",
        provider: "Brochain"
      },
      {
        address: "https://uptick.rpc.bccnodes.com:443",
        provider: "BccNodes"
      },
      {
        address: "https://rpc.uptick.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://uptick.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "http://uptick.rpc.m.stavr.tech:3157",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://m-uptick.rpc.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://uptick-mainnet-rpc.itrocket.net:443",
        provider: "itrocket"
      },
      {
        address: "https://uptick.rpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://uptick-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://uptick-rpc.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://rpc-uptick.cakralabs.site",
        provider: "Cakra Labs"
      },
      {
        address: "https://rpc-uptick.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://uptick-rpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    rest: [
      {
        address: "https://uptick-rest.brocha.in:443",
        provider: "Brochain"
      },
      {
        address: "https://api.uptick.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://uptick.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://uptick.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://m-uptick.api.utsa.tech",
        provider: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀"
      },
      {
        address: "https://uptick-mainnet-api.itrocket.net:443",
        provider: "itrocket"
      },
      {
        address: "https://uptick.api.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://uptick-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://uptick-rest.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://rest-uptick.cakralabs.site",
        provider: "Cakra Labs"
      },
      {
        address: "https://api-uptick.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://uptick-api.noders.services",
        provider: "[NODERS]TEAM"
      }
    ],
    grpc: [
      {
        address: "https://grpc.uptick.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "uptick.rpc.bccnodes.com:9690",
        provider: "BccNodes"
      },
      {
        address: "uptick.grpc.nodersteam.com:9211",
        provider: "[NODERS]TEAM"
      },
      {
        address: "uptick.grpc.kjnodes.com:11590",
        provider: "kjnodes"
      },
      {
        address: "uptick.grpc.m.stavr.tech:1901",
        provider: "🔥STAVR🔥"
      },
      {
        address: "uptick-mainnet-grpc.itrocket.net:10090",
        provider: "itrocket"
      },
      {
        address: "https://uptick.grpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "services.staketab.com:9190",
        provider: "Staketab"
      },
      {
        address: "uptick-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "grpc-uptick.mms.team:443",
        provider: "MMS"
      },
      {
        address: "https://grpc-uptick.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "uptick-grpc.noders.services:24090",
        provider: "[NODERS]TEAM"
      }
    ],
    "evm-http-jsonrpc": [
      {
        address: "https://jsonrpc.uptick.nodestake.top",
        provider: "NodeStake"
      },
      {
        address: "https://uptick.jsonrpc.liveraven.net",
        provider: "LiveRaveN"
      },
      {
        address: "https://evm-uptick.sr20de.xyz",
        provider: "Sr20de"
      },
      {
        address: "https://uptick-jsonrpc.noders.services",
        provider: "[NODERS]TEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://explorers.brocha.in/uptick",
      tx_page: "https://explorers.brocha.in/uptick/tx/${txHash}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.top/uptick",
      tx_page: "https://explorer.nodestake.top/uptick/tx/${txHash}"
    },
    {
      kind: "BccNodes Explorer",
      url: "https://explorer.bccnodes.com/uptick-M",
      tx_page: "https://explorer.bccnodes.com/uptick-M/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/uptick-mainnet",
      tx_page: "https://explorer.stavr.tech/uptick-mainnet/tx/${txHash}"
    },
    {
      kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀 Explorer",
      url: "https://exp.utsa.tech/uptick",
      tx_page: "https://exp.utsa.tech/uptick/tx/${txHash}"
    },
    {
      kind: "cosmotracker",
      url: "https://cosmotracker.com/uptick",
      tx_page: "https://cosmotracker.com/uptick/tx/${txHash}"
    },
    {
      kind: "Upscan",
      url: "https://upscan.xyz/",
      tx_page: "https://upscan.xyz/uptick_117-1/tx/${txHash}"
    },
    {
      kind: "Sr20de",
      url: "https://explorer.sr20de.xyz/uptick",
      tx_page: "https://explorer.sr20de.xyz/uptick/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/uptick/images/uptick.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/uptick/images/uptick.svg",
    theme: {
      primary_color_hex: "#1f182f"
    }
  }]
};
Vf.default = MK;
var Gf = {};
Object.defineProperty(Gf, "__esModule", { value: !0 });
const IK = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cosmoshub",
    client_id: "07-tendermint-1115",
    connection_id: "connection-788"
  },
  chain_2: {
    chain_name: "uptick",
    client_id: "07-tendermint-3",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-535",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1"
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "irisnet",
    client_id: "07-tendermint-93",
    connection_id: "connection-72"
  },
  chain_2: {
    chain_name: "uptick",
    client_id: "07-tendermint-8",
    connection_id: "connection-2"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-39",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1"
  }]
}];
Gf.default = IK;
var Kf = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ma, "__esModule", { value: !0 });
ma.ibc = ma.chain = ma.assets = void 0;
const NK = Kf(Wf), PK = Kf(Vf), UK = Kf(Gf);
ma.assets = NK.default;
ma.chain = PK.default;
ma.ibc = UK.default;
var ha = {}, Xf = {};
Object.defineProperty(Xf, "__esModule", { value: !0 });
const HK = {
  $schema: "../assetlist.schema.json",
  chain_name: "vidulum",
  assets: [{
    description: "The native token of Vidulum",
    denom_units: [{
      denom: "uvdl",
      exponent: 0
    }, {
      denom: "vdl",
      exponent: 6
    }],
    base: "uvdl",
    name: "Vidulum",
    display: "vdl",
    symbol: "VDL",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg"
    },
    coingecko_id: "vidulum",
    images: [{
      image_sync: {
        chain_name: "beezee",
        base_denom: "factory/bze13gzq40che93tgfm9kzmkpjamah5nj0j73pyhqk/uvdl"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/beezee/images/vdl.svg",
      theme: {
        primary_color_hex: "#3454bc"
      }
    }, {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/vidulum/images/vdl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/vidulum/images/vdl.svg"
    }],
    traces: [{
      type: "legacy-mintage",
      counterparty: {
        chain_name: "beezee",
        base_denom: "factory/bze13gzq40che93tgfm9kzmkpjamah5nj0j73pyhqk/uvdl"
      },
      provider: "Vidulum"
    }]
  }]
};
Xf.default = HK;
var Yf = {};
Object.defineProperty(Yf, "__esModule", { value: !0 });
const LK = {
  $schema: "../chain.schema.json",
  chain_name: "vidulum",
  status: "killed",
  network_type: "mainnet",
  website: "https://vidulum.app/",
  pretty_name: "Vidulum",
  chain_type: "cosmos",
  chain_id: "vidulum-1",
  bech32_prefix: "vdl",
  daemon_name: "vidulumd",
  node_home: "$HOME/.vidulum",
  key_algos: ["secp256k1"],
  slip44: 370,
  fees: {
    fee_tokens: [{
      denom: "uvdl",
      fixed_min_gas_price: 2e-4,
      low_gas_price: 2e-3,
      average_gas_price: 5e-3,
      high_gas_price: 7e-3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uvdl"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/vidulum/images/vdl.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/vidulum/images/vdl.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://mainnet-rpc.vidulum.app/",
        provider: "vidulum"
      },
      {
        address: "https://vidulum.rpc.m.stavr.tech:443",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc-vidulum-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://vidulum.declab.pro:26619",
        provider: "Decloud Nodes Lab"
      }
    ],
    rest: [
      {
        address: "https://mainnet-lcd.vidulum.app",
        provider: "vidulum"
      },
      {
        address: "https://api-vidulum-ia.cosmosia.notional.ventures/",
        provider: "Notional"
      },
      {
        address: "https://vidulum.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-vdl.nodine.id/",
        provider: "Nodine.ID"
      },
      {
        address: "https://vidulum.declab.pro:443",
        provider: "Decloud Nodes Lab"
      }
    ],
    grpc: [
      {
        address: "grpc-vidulum-ia.cosmosia.notional.ventures:443",
        provider: "Notional"
      },
      {
        address: "vidulum.grpc.m.stavr.tech:2040",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://vidulum.declab.pro:9013",
        provider: "Decloud Nodes Lab"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://explorers.vidulum.app/vidulum",
      tx_page: "https://explorers.vidulum.app/vidulum/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/vidulum",
      tx_page: "https://ping.pub/vidulum/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Vidulum-Mainnet",
      tx_page: "https://explorer.stavr.tech/Vidulum-Mainnet/tx/${txHash}"
    },
    {
      kind: "atomscan",
      url: "https://atomscan.com/vidulum",
      tx_page: "https://atomscan.com/vidulum/transactions/${txHash}",
      account_page: "https://atomscan.com/vidulum/accounts/${accountAddress}"
    },
    {
      kind: "Nodine Explorer",
      url: "https://explorer.co.id/vidulum",
      tx_page: "https://explorer.co.id/vidulum/tx/${txHash}"
    },
    {
      kind: "Decloud Nodes Lab",
      url: "https://explorer.declab.pro/Vidulum",
      tx_page: "https://explorer.declab.pro/Vidulum/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/vidulum/images/vdl.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/vidulum/images/vdl.svg",
    theme: {
      primary_color_hex: "#3454bc"
    }
  }]
};
Yf.default = LK;
var Jf = {};
Object.defineProperty(Jf, "__esModule", { value: !0 });
const WK = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "archway",
      client_id: "07-tendermint-80",
      connection_id: "connection-81"
    },
    chain_2: {
      chain_name: "vidulum",
      client_id: "07-tendermint-49",
      connection_id: "connection-46"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-110",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-24",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "okexchain",
      client_id: "07-tendermint-100",
      connection_id: "connection-44"
    },
    chain_2: {
      chain_name: "vidulum",
      client_id: "07-tendermint-5",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-37",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosis",
      client_id: "07-tendermint-1705",
      connection_id: "connection-1300"
    },
    chain_2: {
      chain_name: "vidulum",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-124",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
Jf.default = WK;
var Zf = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ha, "__esModule", { value: !0 });
ha.ibc = ha.chain = ha.assets = void 0;
const VK = Zf(Xf), GK = Zf(Yf), KK = Zf(Jf);
ha.assets = VK.default;
ha.chain = GK.default;
ha.ibc = KK.default;
var pa = {}, Qf = {};
Object.defineProperty(Qf, "__esModule", { value: !0 });
const XK = {
  $schema: "../assetlist.schema.json",
  chain_name: "xpla",
  assets: [{
    description: "The native staking token of XPLA.",
    denom_units: [{
      denom: "axpla",
      exponent: 0
    }, {
      denom: "xpla",
      exponent: 18
    }],
    base: "axpla",
    name: "Xpla",
    display: "xpla",
    symbol: "XPLA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.svg"
    },
    coingecko_id: "xpla",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.svg",
      theme: {
        primary_color_hex: "#04b4fc"
      }
    }]
  }]
};
Qf.default = XK;
var ew = {};
Object.defineProperty(ew, "__esModule", { value: !0 });
const YK = {
  $schema: "../chain.schema.json",
  chain_name: "xpla",
  status: "live",
  website: "https://xpla.io",
  network_type: "mainnet",
  pretty_name: "XPLA",
  chain_type: "cosmos",
  chain_id: "dimension_37-1",
  bech32_prefix: "xpla",
  daemon_name: "xplad",
  node_home: "$HOME/.xpla",
  key_algos: ["ethsecp256k1"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "axpla",
      fixed_min_gas_price: 85e10,
      low_gas_price: 85e10,
      average_gas_price: 11475e8,
      high_gas_price: 14875e8
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "axpla"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.13-xpla",
    cosmwasm_version: "v0.46.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://dimension-rpc.xpla.dev",
        provider: "Holdings"
      },
      {
        address: "https://xpla.rpc.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.lavenderfive.com:443/xpla",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://xpla-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://dimension-lcd.xpla.io",
        provider: "ZenaAD"
      },
      {
        address: "https://dimension-lcd.xpla.dev",
        provider: "Holdings"
      },
      {
        address: "https://xpla.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rest.lavenderfive.com:443/xpla",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://xpla-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [{
      address: "xpla-grpc.publicnode.com:443",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }],
    "evm-http-jsonrpc": [{
      address: "https://dimension-evm-rpc.xpla.dev",
      provider: "Holdings"
    }, {
      address: "https://xpla-evm-rpc.publicnode.com",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }]
  },
  explorers: [
    {
      kind: "explorer.xpla",
      url: "https://explorer.xpla.io",
      tx_page: "https://explorer.xpla.io/mainnet/tx/${txHash}"
    },
    {
      kind: "finder",
      url: "https://finder.xpla.io",
      tx_page: "https://finder.xpla.io/mainnet/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Xpla-Mainnet",
      tx_page: "https://explorer.stavr.tech/Xpla-Mainnet/tx/${txHash}"
    },
    {
      kind: "mintscan",
      url: "https://www.mintscan.io/xpla",
      tx_page: "https://www.mintscan.io/xpla/transactions/${txHash}",
      account_page: "https://www.mintscan.io/xpla/accounts/${accountAddress}"
    },
    {
      kind: "ezstaking",
      url: "https://ezstaking.app/xpla",
      tx_page: "https://ezstaking.app/xpla/txs/${txHash}",
      account_page: "https://ezstaking.app/xpla/account/${accountAddress}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xpla/images/xpla.svg",
    theme: {
      primary_color_hex: "#04b4fc"
    }
  }]
};
ew.default = YK;
var nw = {};
Object.defineProperty(nw, "__esModule", { value: !0 });
const JK = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "injective",
    client_id: "07-tendermint-197",
    connection_id: "connection-182"
  },
  chain_2: {
    chain_name: "xpla",
    client_id: "07-tendermint-6",
    connection_id: "connection-12"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-137",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-7",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosis",
    client_id: "07-tendermint-2875",
    connection_id: "connection-2389"
  },
  chain_2: {
    chain_name: "xpla",
    client_id: "07-tendermint-11",
    connection_id: "connection-19"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1634",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-9",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
nw.default = JK;
var tw = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(pa, "__esModule", { value: !0 });
pa.ibc = pa.chain = pa.assets = void 0;
const ZK = tw(Qf), QK = tw(ew), eX = tw(nw);
pa.assets = ZK.default;
pa.chain = QK.default;
pa.ibc = eX.default;
var zr = {}, sw = {};
Object.defineProperty(sw, "__esModule", { value: !0 });
const nX = {
  $schema: "../assetlist.schema.json",
  chain_name: "zetachain",
  assets: [{
    description: "The native token of ZetaChain",
    denom_units: [{
      denom: "azeta",
      exponent: 0
    }, {
      denom: "zeta",
      exponent: 18
    }],
    base: "azeta",
    name: "ZetaChain",
    display: "zeta",
    symbol: "ZETA",
    coingecko_id: "zetachain",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/zetachain/images/zetachain.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/zetachain/images/zetachain.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/zetachain/images/zetachain.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/zetachain/images/zetachain.svg",
      theme: {
        primary_color_hex: "#045443"
      }
    }]
  }]
};
sw.default = nX;
var aw = {};
Object.defineProperty(aw, "__esModule", { value: !0 });
const tX = {
  $schema: "../chain.schema.json",
  chain_name: "zetachain",
  status: "live",
  network_type: "mainnet",
  pretty_name: "ZetaChain",
  chain_type: "cosmos",
  chain_id: "zetachain_7000-1",
  bech32_prefix: "zeta",
  daemon_name: "zetacored",
  node_home: "$HOME/.zetacored",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "azeta",
      low_gas_price: 2e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "azeta"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.10"
  },
  apis: {
    rpc: [
      {
        address: "https://zetachain.blockpi.network/rpc/v1/public",
        provider: "BlockPI"
      },
      {
        address: "https://zetachain-mainnet-archive.allthatnode.com:26657",
        provider: "All That Node"
      },
      {
        address: "https://rpc.lavenderfive.com:443/zetachain",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://rpc.zetachain.nodestake.org",
        provider: "NodeStake"
      },
      {
        address: "https://zetachain-rpc.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://zetachain.rpc.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      },
      {
        address: "https://zeta-chain.drpc.org",
        provider: "dRPC"
      }
    ],
    rest: [
      {
        address: "https://zetachain.blockpi.network/lcd/v1/public",
        provider: "BlockPI"
      },
      {
        address: "https://zetachain-mainnet-archive.allthatnode.com:1317",
        provider: "All That Node"
      },
      {
        address: "https://rest.lavenderfive.com:443/zetachain",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://api.zetachain.nodestake.org",
        provider: "NodeStake"
      },
      {
        address: "https://zetachain-api.noders.services",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://zetachain.api.nodeshub.online:443",
        provider: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅"
      }
    ],
    grpc: [
      {
        address: "zetachain.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://grpc.zetachain.nodestake.org:443",
        provider: "NodeStake"
      },
      {
        address: "zetachain-grpc.noders.services:28090",
        provider: "[NODERS]TEAM"
      },
      {
        address: "https://zetachain.grpc.nodeshub.online",
        provider: "Nodes Hub"
      }
    ]
  },
  explorers: [
    {
      kind: "ZetaScan",
      url: "https://explorer.zetachain.com/",
      tx_page: "https://explorer.zetachain.com/cc/tx/${txHash}"
    },
    {
      kind: "BlockScout",
      url: "https://zetachain.blockscout.com/",
      tx_page: "https://zetachain.blockscout.com/tx/${txHash}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.org/zetachain",
      tx_page: "https://explorer.nodestake.org/zetachain/tx/${txHash}"
    },
    {
      kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
      url: "https://explorer.nodeshub.online/zetachain/",
      tx_page: "https://explorer.nodeshub.online/zetachain/tx/${txHash}",
      account_page: "https://explorer.nodeshub.online/zetachain/accounts/${accountAddress}"
    }
  ]
};
aw.default = tX;
var aA = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(zr, "__esModule", { value: !0 });
zr.chain = zr.assets = void 0;
const sX = aA(sw), aX = aA(aw);
zr.assets = sX.default;
zr.chain = aX.default;
var oX = r && r.__createBinding || (Object.create ? function(e, n, t, s) {
  s === void 0 && (s = t);
  var a = Object.getOwnPropertyDescriptor(n, t);
  (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return n[t];
  } }), Object.defineProperty(e, s, a);
} : function(e, n, t, s) {
  s === void 0 && (s = t), e[s] = n[t];
}), rX = r && r.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), z = r && r.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var t in e) t !== "default" && Object.prototype.hasOwnProperty.call(e, t) && oX(n, e, t);
  return rX(n, e), n;
};
Object.defineProperty(Ph, "__esModule", { value: !0 });
const iX = z(zn), cX = z(Po), dX = z(qn), mX = z(Uo), hX = z(Ho), pX = z(Sn), lX = z(Tn), gX = z(Rn), uX = z(On), _X = z(Mn), yX = z(Lo), bX = z(Wo), vX = z(In), fX = z(Nn), wX = z(Pn), xX = z(Un), kX = z(Hn), AX = z(Vo), jX = z(Ln), CX = z(Wn), EX = z(Vn), DX = z(Go), BX = z(Gn), FX = z(Kn), $X = z(Ko), zX = z(Xo), qX = z(Xn), SX = z(Yn), TX = z(Jn), RX = z(Zn), OX = z(Qn), MX = z(et), IX = z(nt), NX = z(tt), PX = z(st), UX = z(Yo), HX = z(Jo), LX = z(at), WX = z(Zo), VX = z(Qo), GX = z(ot), KX = z(er), XX = z(rt), YX = z(it), JX = z(ct), ZX = z(dt), QX = z(nr), eY = z(mt), nY = z(ht), tY = z(pt), sY = z(lt), aY = z(gt), oY = z(ut), rY = z(_t), iY = z(yt), cY = z(bt), dY = z(vt), mY = z(ft), hY = z(wt), pY = z(xt), lY = z(kt), gY = z(At), uY = z(tr), _Y = z(jt), yY = z(Ct), bY = z(sr), vY = z(Et), fY = z(Dt), wY = z(Bt), xY = z(Ft), kY = z($t), AY = z(zt), jY = z(qt), CY = z(ar), EY = z(St), DY = z(Tt), BY = z(or), FY = z(rr), $Y = z(Rt), zY = z(ir), qY = z(Ot), SY = z(Mt), TY = z(It), RY = z(Nt), OY = z(Pt), MY = z(Ut), IY = z(Ht), NY = z(Lt), PY = z(Wt), UY = z(Vt), HY = z(Gt), LY = z(Kt), WY = z(Xt), VY = z(Yt), GY = z(Jt), KY = z(cr), XY = z(dr), YY = z(Zt), JY = z(mr), ZY = z(Qt), QY = z(es), eJ = z(ns), nJ = z(ts), tJ = z(hr), sJ = z(ss), aJ = z(as), oJ = z(os), rJ = z(rs), iJ = z(pr), cJ = z(lr), dJ = z(gr), mJ = z(ur), hJ = z(_r), pJ = z(is), lJ = z(cs), gJ = z(ds), uJ = z(ms), _J = z(hs), yJ = z(ps), bJ = z(ls), vJ = z(gs), fJ = z(us), wJ = z(yr), xJ = z(_s), kJ = z(ys), AJ = z(bs), jJ = z(vs), CJ = z(fs), EJ = z(ws), DJ = z(xs), BJ = z(br), FJ = z(ks), $J = z(As), zJ = z(vr), qJ = z(js), SJ = z(Cs), TJ = z(Es), RJ = z(Ds), OJ = z(Bs), MJ = z(Fs), IJ = z($s), NJ = z(fr), PJ = z(zs), UJ = z(qs), HJ = z(Ss), LJ = z(Ts), WJ = z(Rs), VJ = z(Os), GJ = z(Ms), KJ = z(Is), XJ = z(Ns), YJ = z(Ps), JJ = z(Us), ZJ = z(Hs), QJ = z(Ls), eZ = z(Ws), nZ = z(Vs), tZ = z(Gs), sZ = z(Ks), aZ = z(Xs), oZ = z(Ys), rZ = z(Js), iZ = z(wr), cZ = z(Zs), dZ = z(Qs), mZ = z(ea), hZ = z(na), pZ = z(ta), lZ = z(xr), gZ = z(sa), uZ = z(kr), _Z = z(Ar), yZ = z(jr), bZ = z(Cr), vZ = z(aa), fZ = z(Er), wZ = z(oa), xZ = z(ra), kZ = z(ia), AZ = z(Dr), jZ = z(Br), CZ = z(ca), EZ = z(Fr), DZ = z(da), BZ = z($r), FZ = z(ma), $Z = z(ha), zZ = z(pa), qZ = z(zr), SZ = [
  iX.assets,
  cX.assets,
  dX.assets,
  mX.assets,
  hX.assets,
  pX.assets,
  lX.assets,
  gX.assets,
  uX.assets,
  _X.assets,
  yX.assets,
  bX.assets,
  vX.assets,
  fX.assets,
  wX.assets,
  xX.assets,
  kX.assets,
  AX.assets,
  jX.assets,
  CX.assets,
  EX.assets,
  DX.assets,
  BX.assets,
  FX.assets,
  $X.assets,
  zX.assets,
  qX.assets,
  SX.assets,
  TX.assets,
  RX.assets,
  OX.assets,
  MX.assets,
  IX.assets,
  NX.assets,
  PX.assets,
  UX.assets,
  HX.assets,
  LX.assets,
  WX.assets,
  VX.assets,
  GX.assets,
  KX.assets,
  XX.assets,
  YX.assets,
  JX.assets,
  ZX.assets,
  QX.assets,
  eY.assets,
  nY.assets,
  tY.assets,
  sY.assets,
  aY.assets,
  oY.assets,
  rY.assets,
  iY.assets,
  cY.assets,
  dY.assets,
  mY.assets,
  hY.assets,
  pY.assets,
  lY.assets,
  gY.assets,
  uY.assets,
  _Y.assets,
  yY.assets,
  bY.assets,
  vY.assets,
  fY.assets,
  wY.assets,
  xY.assets,
  kY.assets,
  AY.assets,
  jY.assets,
  CY.assets,
  EY.assets,
  DY.assets,
  BY.assets,
  FY.assets,
  $Y.assets,
  zY.assets,
  qY.assets,
  SY.assets,
  TY.assets,
  RY.assets,
  OY.assets,
  MY.assets,
  IY.assets,
  NY.assets,
  PY.assets,
  UY.assets,
  HY.assets,
  LY.assets,
  WY.assets,
  VY.assets,
  GY.assets,
  KY.assets,
  XY.assets,
  YY.assets,
  JY.assets,
  ZY.assets,
  QY.assets,
  eJ.assets,
  nJ.assets,
  tJ.assets,
  sJ.assets,
  aJ.assets,
  oJ.assets,
  rJ.assets,
  iJ.assets,
  cJ.assets,
  dJ.assets,
  mJ.assets,
  hJ.assets,
  pJ.assets,
  lJ.assets,
  gJ.assets,
  uJ.assets,
  _J.assets,
  yJ.assets,
  bJ.assets,
  vJ.assets,
  fJ.assets,
  wJ.assets,
  xJ.assets,
  kJ.assets,
  AJ.assets,
  jJ.assets,
  CJ.assets,
  EJ.assets,
  DJ.assets,
  BJ.assets,
  FJ.assets,
  $J.assets,
  zJ.assets,
  qJ.assets,
  SJ.assets,
  TJ.assets,
  RJ.assets,
  OJ.assets,
  MJ.assets,
  IJ.assets,
  NJ.assets,
  PJ.assets,
  UJ.assets,
  HJ.assets,
  LJ.assets,
  WJ.assets,
  VJ.assets,
  GJ.assets,
  KJ.assets,
  XJ.assets,
  YJ.assets,
  JJ.assets,
  ZJ.assets,
  QJ.assets,
  eZ.assets,
  nZ.assets,
  tZ.assets,
  sZ.assets,
  aZ.assets,
  oZ.assets,
  rZ.assets,
  iZ.assets,
  cZ.assets,
  dZ.assets,
  mZ.assets,
  hZ.assets,
  pZ.assets,
  lZ.assets,
  gZ.assets,
  uZ.assets,
  _Z.assets,
  yZ.assets,
  bZ.assets,
  vZ.assets,
  fZ.assets,
  wZ.assets,
  xZ.assets,
  kZ.assets,
  AZ.assets,
  jZ.assets,
  CZ.assets,
  EZ.assets,
  DZ.assets,
  BZ.assets,
  FZ.assets,
  $Z.assets,
  zZ.assets,
  qZ.assets
];
Ph.default = SZ;
var ow = {}, gm = {}, rw = {};
Object.defineProperty(rw, "__esModule", { value: !0 });
const TZ = {
  $schema: "../chain.schema.json",
  chain_name: "andromeda1",
  chain_type: "cosmos",
  chain_id: "andromeda-1",
  pretty_name: "Andromeda",
  status: "killed",
  network_type: "mainnet",
  bech32_prefix: "andr",
  daemon_name: "andromedad",
  node_home: "$HOME/.andromeda",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uandr"
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uandr"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://rpc.andromeda-1.andromeda.aviaone.com",
        provider: "AVIAONE"
      },
      {
        address: "https://andromeda.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://andromeda.rpc.nodex.one",
        provider: "nodex"
      },
      {
        address: "https://andro.rpc.m.stavr.tech/",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rpc.lavenderfive.com:443/andromeda",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://andromeda-mainnet-rpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://andromeda-rpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "https://andromeda-rpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "https://andromeda-rpc.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://andromeda-rpc.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://nibiru.rpc.kjnodes.comv",
        provider: "kjnodes.com 🦄"
      }
    ],
    rest: [
      {
        address: "https://api.andromeda-1.andromeda.aviaone.com/",
        provider: "AVIAONE"
      },
      {
        address: "https://andromeda.api.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://andromeda.api.nodex.one",
        provider: "nodex"
      },
      {
        address: "https://andro.api.m.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://rest.lavenderfive.com:443/andromeda",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://andromeda-mainnet-lcd.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://andromeda-api.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "https://andromeda-rest.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "https://andromeda-api.highstakes.ch",
        provider: "High Stakes 🇨🇭"
      },
      {
        address: "https://andromeda-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://nibiru.api.kjnodes.com",
        provider: "kjnodes.com 🦄"
      }
    ],
    grpc: [
      {
        address: "andromeda.lavenderfive.com:443",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://grpc.andromeda-1.andromeda.aviaone.com:9094",
        provider: "AVIAONE"
      },
      {
        address: "andromeda.grpc.kjnodes.com:443",
        provider: "kjnodes"
      },
      {
        address: "andromeda-mainnet-grpc.autostake.com:443",
        provider: "AutoStake 🛡️ Slash Protected"
      },
      {
        address: "https://andromeda.grpc.nodex.one:443",
        provider: "nodex"
      },
      {
        address: "http://andromedad.grpc.t.stavr.tech:132",
        provider: "🔥STAVR🔥"
      },
      {
        address: "andromeda-grpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "andromeda-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "andromeda-grpc.genznodes.dev:27090",
        provider: "genznodes"
      },
      {
        address: "nibiru.grpc.kjnodes.com:443",
        provider: "kjnodes.com 🦄"
      }
    ]
  },
  explorers: [
    {
      kind: "🔥STAVR🔥 Explorer",
      url: "https://explorer.stavr.tech/Andromeda-Mainnet",
      tx_page: "https://explorer.stavr.tech/Andromeda-Mainnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Andromeda-Mainnet/account/${accountAddress}"
    },
    {
      kind: "exploreme.pro",
      url: "https://andromeda.exploreme.pro",
      tx_page: "https://andromeda.exploreme.pro/transaction/${txHash}",
      account_page: "https://andromeda.exploreme.pro/account/${accountAddress}"
    },
    {
      kind: "Cosmotracker",
      url: "https://cosmotracker.com/andromeda",
      tx_page: "https://cosmotracker.com/andromeda/tx/${txHash}",
      account_page: "https://cosmotracker.com/andromeda/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://ping.pub/andromeda",
      tx_page: "https://ping.pub/andromeda/tx/${txHash}"
    }
  ],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/andromeda/images/andromeda-logo.png"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/andromeda/images/andromeda-logo.png",
    theme: {
      primary_color_hex: "#040404"
    }
  }]
};
rw.default = TZ;
var RZ = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(gm, "__esModule", { value: !0 });
gm.chain = void 0;
const OZ = RZ(rw);
gm.chain = OZ.default;
var MZ = r && r.__createBinding || (Object.create ? function(e, n, t, s) {
  s === void 0 && (s = t);
  var a = Object.getOwnPropertyDescriptor(n, t);
  (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return n[t];
  } }), Object.defineProperty(e, s, a);
} : function(e, n, t, s) {
  s === void 0 && (s = t), e[s] = n[t];
}), IZ = r && r.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), $ = r && r.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var t in e) t !== "default" && Object.prototype.hasOwnProperty.call(e, t) && MZ(n, e, t);
  return IZ(n, e), n;
};
Object.defineProperty(ow, "__esModule", { value: !0 });
const NZ = $(zn), PZ = $(Po), UZ = $(qn), HZ = $(Uo), LZ = $(Ho), WZ = $(Sn), VZ = $(Tn), GZ = $(Rn), KZ = $(On), XZ = $(Mn), YZ = $(Lo), JZ = $(Wo), ZZ = $(In), QZ = $(gm), eQ = $(Nn), nQ = $(Pn), tQ = $(Un), sQ = $(Hn), aQ = $(Vo), oQ = $(Ln), rQ = $(Wn), iQ = $(Vn), cQ = $(Go), dQ = $(Gn), mQ = $(Kn), hQ = $(Ko), pQ = $(Xo), lQ = $(Xn), gQ = $(Yn), uQ = $(Jn), _Q = $(Zn), yQ = $(Qn), bQ = $(et), vQ = $(nt), fQ = $(tt), wQ = $(st), xQ = $(Yo), kQ = $(Jo), AQ = $(at), jQ = $(Zo), CQ = $(Qo), EQ = $(ot), DQ = $(er), BQ = $(rt), FQ = $(it), $Q = $(ct), zQ = $(dt), qQ = $(nr), SQ = $(mt), TQ = $(ht), RQ = $(pt), OQ = $(lt), MQ = $(gt), IQ = $(ut), NQ = $(_t), PQ = $(yt), UQ = $(bt), HQ = $(vt), LQ = $(ft), WQ = $(wt), VQ = $(xt), GQ = $(kt), KQ = $(At), XQ = $(tr), YQ = $(jt), JQ = $(Ct), ZQ = $(sr), QQ = $(Et), eee = $(Dt), nee = $(Bt), tee = $(Ft), see = $($t), aee = $(zt), oee = $(qt), ree = $(ar), iee = $(St), cee = $(Tt), dee = $(or), mee = $(rr), hee = $(Rt), pee = $(ir), lee = $(Ot), gee = $(Mt), uee = $(It), _ee = $(Nt), yee = $(Pt), bee = $(Ut), vee = $(Ht), fee = $(Lt), wee = $(Wt), xee = $(Vt), kee = $(Gt), Aee = $(Kt), jee = $(Xt), Cee = $(Yt), Eee = $(Jt), Dee = $(cr), Bee = $(dr), Fee = $(Zt), $ee = $(mr), zee = $(Qt), qee = $(es), See = $(ns), Tee = $(ts), Ree = $(hr), Oee = $(ss), Mee = $(as), Iee = $(os), Nee = $(rs), Pee = $(pr), Uee = $(lr), Hee = $(gr), Lee = $(ur), Wee = $(_r), Vee = $(is), Gee = $(cs), Kee = $(ds), Xee = $(ms), Yee = $(hs), Jee = $(ps), Zee = $(ls), Qee = $(gs), ene = $(us), nne = $(yr), tne = $(_s), sne = $(ys), ane = $(bs), one = $(vs), rne = $(fs), ine = $(ws), cne = $(xs), dne = $(br), mne = $(ks), hne = $(As), pne = $(vr), lne = $(js), gne = $(Cs), une = $(Es), _ne = $(Ds), yne = $(Bs), bne = $(Fs), vne = $($s), fne = $(fr), wne = $(zs), xne = $(qs), kne = $(Ss), Ane = $(Ts), jne = $(Rs), Cne = $(Os), Ene = $(Ms), Dne = $(Is), Bne = $(Ns), Fne = $(Ps), $ne = $(Us), zne = $(Hs), qne = $(Ls), Sne = $(Ws), Tne = $(Vs), Rne = $(Gs), One = $(Ks), Mne = $(Xs), Ine = $(Ys), Nne = $(Js), Pne = $(wr), Une = $(Zs), Hne = $(Qs), Lne = $(ea), Wne = $(na), Vne = $(ta), Gne = $(xr), Kne = $(sa), Xne = $(kr), Yne = $(Ar), Jne = $(jr), Zne = $(Cr), Qne = $(aa), ete = $(Er), nte = $(oa), tte = $(ra), ste = $(ia), ate = $(Dr), ote = $(Br), rte = $(ca), ite = $(Fr), cte = $(da), dte = $($r), mte = $(ma), hte = $(ha), pte = $(pa), lte = $(zr), gte = [
  NZ.chain,
  PZ.chain,
  UZ.chain,
  HZ.chain,
  LZ.chain,
  WZ.chain,
  VZ.chain,
  GZ.chain,
  KZ.chain,
  XZ.chain,
  YZ.chain,
  JZ.chain,
  ZZ.chain,
  QZ.chain,
  eQ.chain,
  nQ.chain,
  tQ.chain,
  sQ.chain,
  aQ.chain,
  oQ.chain,
  rQ.chain,
  iQ.chain,
  cQ.chain,
  dQ.chain,
  mQ.chain,
  hQ.chain,
  pQ.chain,
  lQ.chain,
  gQ.chain,
  uQ.chain,
  _Q.chain,
  yQ.chain,
  bQ.chain,
  vQ.chain,
  fQ.chain,
  wQ.chain,
  xQ.chain,
  kQ.chain,
  AQ.chain,
  jQ.chain,
  CQ.chain,
  EQ.chain,
  DQ.chain,
  BQ.chain,
  FQ.chain,
  $Q.chain,
  zQ.chain,
  qQ.chain,
  SQ.chain,
  TQ.chain,
  RQ.chain,
  OQ.chain,
  MQ.chain,
  IQ.chain,
  NQ.chain,
  PQ.chain,
  UQ.chain,
  HQ.chain,
  LQ.chain,
  WQ.chain,
  VQ.chain,
  GQ.chain,
  KQ.chain,
  XQ.chain,
  YQ.chain,
  JQ.chain,
  ZQ.chain,
  QQ.chain,
  eee.chain,
  nee.chain,
  tee.chain,
  see.chain,
  aee.chain,
  oee.chain,
  ree.chain,
  iee.chain,
  cee.chain,
  dee.chain,
  mee.chain,
  hee.chain,
  pee.chain,
  lee.chain,
  gee.chain,
  uee.chain,
  _ee.chain,
  yee.chain,
  bee.chain,
  vee.chain,
  fee.chain,
  wee.chain,
  xee.chain,
  kee.chain,
  Aee.chain,
  jee.chain,
  Cee.chain,
  Eee.chain,
  Dee.chain,
  Bee.chain,
  Fee.chain,
  $ee.chain,
  zee.chain,
  qee.chain,
  See.chain,
  Tee.chain,
  Ree.chain,
  Oee.chain,
  Mee.chain,
  Iee.chain,
  Nee.chain,
  Pee.chain,
  Uee.chain,
  Hee.chain,
  Lee.chain,
  Wee.chain,
  Vee.chain,
  Gee.chain,
  Kee.chain,
  Xee.chain,
  Yee.chain,
  Jee.chain,
  Zee.chain,
  Qee.chain,
  ene.chain,
  nne.chain,
  tne.chain,
  sne.chain,
  ane.chain,
  one.chain,
  rne.chain,
  ine.chain,
  cne.chain,
  dne.chain,
  mne.chain,
  hne.chain,
  pne.chain,
  lne.chain,
  gne.chain,
  une.chain,
  _ne.chain,
  yne.chain,
  bne.chain,
  vne.chain,
  fne.chain,
  wne.chain,
  xne.chain,
  kne.chain,
  Ane.chain,
  jne.chain,
  Cne.chain,
  Ene.chain,
  Dne.chain,
  Bne.chain,
  Fne.chain,
  $ne.chain,
  zne.chain,
  qne.chain,
  Sne.chain,
  Tne.chain,
  Rne.chain,
  One.chain,
  Mne.chain,
  Ine.chain,
  Nne.chain,
  Pne.chain,
  Une.chain,
  Hne.chain,
  Lne.chain,
  Wne.chain,
  Vne.chain,
  Gne.chain,
  Kne.chain,
  Xne.chain,
  Yne.chain,
  Jne.chain,
  Zne.chain,
  Qne.chain,
  ete.chain,
  nte.chain,
  tte.chain,
  ste.chain,
  ate.chain,
  ote.chain,
  rte.chain,
  ite.chain,
  cte.chain,
  dte.chain,
  mte.chain,
  hte.chain,
  pte.chain,
  lte.chain
];
ow.default = gte;
var iw = {}, ute = r && r.__createBinding || (Object.create ? function(e, n, t, s) {
  s === void 0 && (s = t);
  var a = Object.getOwnPropertyDescriptor(n, t);
  (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return n[t];
  } }), Object.defineProperty(e, s, a);
} : function(e, n, t, s) {
  s === void 0 && (s = t), e[s] = n[t];
}), _te = r && r.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), I = r && r.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var t in e) t !== "default" && Object.prototype.hasOwnProperty.call(e, t) && ute(n, e, t);
  return _te(n, e), n;
};
Object.defineProperty(iw, "__esModule", { value: !0 });
const yte = I(zn), bte = I(qn), vte = I(Sn), fte = I(Tn), wte = I(Rn), xte = I(On), kte = I(Mn), Ate = I(In), jte = I(Nn), Cte = I(Pn), Ete = I(Un), Dte = I(Hn), Bte = I(Ln), Fte = I(Wn), $te = I(Vn), zte = I(Gn), qte = I(Kn), Ste = I(Xn), Tte = I(Yn), Rte = I(Jn), Ote = I(Zn), Mte = I(Qn), Ite = I(et), Nte = I(nt), Pte = I(tt), Ute = I(st), Hte = I(at), Lte = I(ot), Wte = I(rt), Vte = I(it), Gte = I(ct), Kte = I(dt), Xte = I(mt), Yte = I(ht), Jte = I(pt), Zte = I(lt), Qte = I(gt), ese = I(ut), nse = I(_t), tse = I(yt), sse = I(bt), ase = I(vt), ose = I(ft), rse = I(wt), ise = I(xt), cse = I(kt), dse = I(At), mse = I(jt), hse = I(Ct), pse = I(Et), lse = I(Dt), gse = I(Bt), use = I(Ft), _se = I($t), yse = I(zt), bse = I(qt), vse = I(St), fse = I(Tt), wse = I(Rt), xse = I(Ot), kse = I(Mt), Ase = I(It), jse = I(Nt), Cse = I(Pt), Ese = I(Ut), Dse = I(Ht), Bse = I(Lt), Fse = I(Wt), $se = I(Vt), zse = I(Gt), qse = I(Kt), Sse = I(Xt), Tse = I(Yt), Rse = I(Jt), Ose = I(Zt), Mse = I(Qt), Ise = I(es), Nse = I(ns), Pse = I(ts), Use = I(ss), Hse = I(as), Lse = I(os), Wse = I(rs), Vse = I(is), Gse = I(cs), Kse = I(ds), Xse = I(ms), Yse = I(hs), Jse = I(ps), Zse = I(ls), Qse = I(gs), eae = I(us), nae = I(_s), tae = I(ys), sae = I(bs), aae = I(vs), oae = I(fs), rae = I(ws), iae = I(xs), cae = I(ks), dae = I(As), mae = I(js), hae = I(Cs), pae = I(Es), lae = I(Ds), gae = I(Bs), uae = I(Fs), _ae = I($s), yae = I(zs), bae = I(qs), vae = I(Ss), fae = I(Ts), wae = I(Rs), xae = I(Os), kae = I(Ms), Aae = I(Is), jae = I(Ns), Cae = I(Ps), Eae = I(Us), Dae = I(Hs), Bae = I(Ls), Fae = I(Ws), $ae = I(Vs), zae = I(Gs), qae = I(Ks), Sae = I(Xs), Tae = I(Ys), Rae = I(Js), Oae = I(Zs), Mae = I(Qs), Iae = I(ea), Nae = I(na), Pae = I(ta), Uae = I(sa), Hae = I(aa), Lae = I(oa), Wae = I(ra), Vae = I(ia), Gae = I(ca), Kae = I(da), Xae = I(ma), Yae = I(ha), Jae = I(pa), Zae = [
  ...yte.ibc,
  ...bte.ibc,
  ...vte.ibc,
  ...fte.ibc,
  ...wte.ibc,
  ...xte.ibc,
  ...kte.ibc,
  ...Ate.ibc,
  ...jte.ibc,
  ...Cte.ibc,
  ...Ete.ibc,
  ...Dte.ibc,
  ...Bte.ibc,
  ...Fte.ibc,
  ...$te.ibc,
  ...zte.ibc,
  ...qte.ibc,
  ...Ste.ibc,
  ...Tte.ibc,
  ...Rte.ibc,
  ...Ote.ibc,
  ...Mte.ibc,
  ...Ite.ibc,
  ...Nte.ibc,
  ...Pte.ibc,
  ...Ute.ibc,
  ...Hte.ibc,
  ...Lte.ibc,
  ...Wte.ibc,
  ...Vte.ibc,
  ...Gte.ibc,
  ...Kte.ibc,
  ...Xte.ibc,
  ...Yte.ibc,
  ...Jte.ibc,
  ...Zte.ibc,
  ...Qte.ibc,
  ...ese.ibc,
  ...nse.ibc,
  ...tse.ibc,
  ...sse.ibc,
  ...ase.ibc,
  ...ose.ibc,
  ...rse.ibc,
  ...ise.ibc,
  ...cse.ibc,
  ...dse.ibc,
  ...mse.ibc,
  ...hse.ibc,
  ...pse.ibc,
  ...lse.ibc,
  ...gse.ibc,
  ...use.ibc,
  ..._se.ibc,
  ...yse.ibc,
  ...bse.ibc,
  ...vse.ibc,
  ...fse.ibc,
  ...wse.ibc,
  ...xse.ibc,
  ...kse.ibc,
  ...Ase.ibc,
  ...jse.ibc,
  ...Cse.ibc,
  ...Ese.ibc,
  ...Dse.ibc,
  ...Bse.ibc,
  ...Fse.ibc,
  ...$se.ibc,
  ...zse.ibc,
  ...qse.ibc,
  ...Sse.ibc,
  ...Tse.ibc,
  ...Rse.ibc,
  ...Ose.ibc,
  ...Mse.ibc,
  ...Ise.ibc,
  ...Nse.ibc,
  ...Pse.ibc,
  ...Use.ibc,
  ...Hse.ibc,
  ...Lse.ibc,
  ...Wse.ibc,
  ...Vse.ibc,
  ...Gse.ibc,
  ...Kse.ibc,
  ...Xse.ibc,
  ...Yse.ibc,
  ...Jse.ibc,
  ...Zse.ibc,
  ...Qse.ibc,
  ...eae.ibc,
  ...nae.ibc,
  ...tae.ibc,
  ...sae.ibc,
  ...aae.ibc,
  ...oae.ibc,
  ...rae.ibc,
  ...iae.ibc,
  ...cae.ibc,
  ...dae.ibc,
  ...mae.ibc,
  ...hae.ibc,
  ...pae.ibc,
  ...lae.ibc,
  ...gae.ibc,
  ...uae.ibc,
  ..._ae.ibc,
  ...yae.ibc,
  ...bae.ibc,
  ...vae.ibc,
  ...fae.ibc,
  ...wae.ibc,
  ...xae.ibc,
  ...kae.ibc,
  ...Aae.ibc,
  ...jae.ibc,
  ...Cae.ibc,
  ...Eae.ibc,
  ...Dae.ibc,
  ...Bae.ibc,
  ...Fae.ibc,
  ...$ae.ibc,
  ...zae.ibc,
  ...qae.ibc,
  ...Sae.ibc,
  ...Tae.ibc,
  ...Rae.ibc,
  ...Oae.ibc,
  ...Mae.ibc,
  ...Iae.ibc,
  ...Nae.ibc,
  ...Pae.ibc,
  ...Uae.ibc,
  ...Hae.ibc,
  ...Lae.ibc,
  ...Wae.ibc,
  ...Vae.ibc,
  ...Gae.ibc,
  ...Kae.ibc,
  ...Xae.ibc,
  ...Yae.ibc,
  ...Jae.ibc
];
iw.default = Zae;
var cw = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(xo, "__esModule", { value: !0 });
xo.ibc = _m = xo.chains = um = xo.assets = void 0;
const oA = cw(Ph);
var um = xo.assets = oA.default;
const rA = cw(ow);
var _m = xo.chains = rA.default;
const iA = cw(iw);
xo.ibc = iA.default;
xo.default = {
  assets: oA.default,
  chains: rA.default,
  ibc: iA.default
};
const Qae = [
  ..._m,
  ...Bh
], eoe = [
  ...um,
  ...Fh
], noe = [
  ..._m,
  ...Bh
], toe = [
  ...um,
  ...Fh
], cA = Qae.map((e) => {
  try {
    return rm(e, eoe);
  } catch {
    return;
  }
}).filter((e) => e && e.rpc);
noe.map((e) => {
  try {
    return rm(e, toe);
  } catch {
    return;
  }
}).filter((e) => e);
const soe = [
  "90u-4",
  "FUND-MainNet-2",
  "HICKORY",
  "HoneyWood",
  "LumenX",
  "Neutaro-1",
  "ShareRing-VoyagerNet",
  "agoric-3",
  "aioz_168-1",
  "akashnet-2",
  "alfama",
  "arctic-1",
  "ares-1",
  "arkeo",
  "athens_7001-1",
  "atlantic-2",
  "axelar-dojo-1",
  "axelar-testnet-lisbon-3",
  "band-laozi-testnet6",
  "banksy-testnet-5",
  "bbn-dev-5",
  "bbn-test-3",
  "berberis-1",
  "birdee-1",
  "bitcanna-1",
  "blockx_100-1",
  "bluechip-2",
  "bluzelle-testnet-10",
  "bluzelle-9",
  "bostrom",
  "bouachain",
  "buenavista-1",
  "bzetestnet-2",
  "celestia",
  "chihuahua-1",
  "cifer-2",
  "cnho_stables-1",
  "colosseum-1",
  "columbus-5",
  "comdex-test-4",
  "constantine-3",
  "core-1",
  "coreum-testnet-1",
  "cosmoshub-4",
  "coss-1",
  "crossfi-evm-testnet-1",
  "crypto-org-chain-mainnet-1",
  "cudos-1",
  "cvm_323-1",
  "cvn_2032-1",
  "desmos-mainnet",
  "developer",
  "dimension_37-1",
  "dydx-mainnet-1",
  "dydx-testnet-4",
  "dymension_1100-1",
  "dyson-mainnet-01",
  "earendel-1",
  "ebony-2",
  "elgafar-1",
  "elystestnet-1",
  "emoney-3",
  "empe-testnet-2",
  "entrypoint-pubtest-2",
  "evmos_9001-2",
  "fairyring-testnet-1",
  "fiamma-testnet-1",
  "finschia-2",
  "fivenet",
  "froopyland_100-1",
  "furya-1",
  "fxcore",
  "galactica_9302-1",
  "govgen-1",
  "grand-1",
  "helichain",
  "iconlake-testnet-1",
  "iconlake-1",
  "indigo-1",
  "initiation-1",
  "injective-888",
  "injective-1",
  "inns-1",
  "iov-mainnet-ibc",
  "irishub-1",
  "ixo-5",
  "joltify_1729-1",
  "juno-1",
  "kaon-1",
  "kava_2222-10",
  "korellia-2",
  "kyve-1",
  "lambda_92000-1",
  "laozi-mainnet",
  "lava-mainnet-1",
  "lava-testnet-2",
  "likecoin-mainnet-2",
  "likecoin-public-testnet-5",
  "loop-1",
  "mainnet-tura",
  "mande_18071918-1",
  "mantra-hongbai-1",
  "mars-1",
  "medasdigital-1",
  "meme-1",
  "mineplex-mainnet-1",
  "mocha-4",
  "morocco-1",
  "mutelandia1",
  "neutron-1",
  "nibiru-devnet-1",
  "nibiru-testnet-1",
  "nillion-chain-testnet-1",
  "nim_1122-1",
  "noble-1",
  "nubit-alphatestnet-1",
  "omniflixhub-1",
  "osmo-test-5",
  "osmosis-1",
  "ovg",
  "panacea-3",
  "passage-2",
  "phoenix-1",
  "pio-testnet-1",
  "pion-1",
  "planq_7077-1",
  "poktroll",
  "provider",
  "pryzm-1",
  "pulsar-3",
  "quasar-1",
  "quicksilver-2",
  "qwoyn-1",
  "realionetwork_3300-3",
  "realionetwork_3301-1",
  "reapchain_221230-1",
  "regen-1",
  "router_9600-1",
  "scorum-1",
  "secret-4",
  "seda-1-testnet",
  "seda-1",
  "sentinelhub-2",
  "sge-network-4",
  "sgenet-1",
  "shido_9007-1",
  "sixnet",
  "soarchaintestnet",
  "sommelier-3",
  "sourcetest-1",
  "ssc-testnet-2",
  "ssc-1",
  "stafihub-1",
  "stargaze-1",
  "stratos-1",
  "stride-internal-1",
  "stride-1",
  "stwart_test_1",
  "stwart_testnet_1",
  "swisstronik_1291-1",
  "symphony-testnet-3",
  "synternet-1",
  "tenet_1559-1",
  "test-core-2",
  "tgrade-mainnet-1",
  "theta-testnet-001",
  "titan-test-3",
  "titan_18889-1",
  "tucana_712-1",
  "tumbler",
  "umee-1",
  "unicorn-420",
  "union-testnet-8",
  "uptick_117-1",
  "wormchain",
  "xion-testnet-1",
  "yulei-2.1",
  "zetachain_7000-1"
], aoe = [
  "cosmoshub-4",
  "injective-1",
  "pacific-1",
  "noble-1",
  "osmosis-1",
  "neutron-1",
  "pryzm-1",
  "axelar-dojo-1",
  "chihuahua-1"
], ooe = {
  [ze.KEPLR]: {
    name: "Keplr",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-keplr.png"
  },
  [ze.LEAP]: {
    name: "Leap",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-leap.png"
  },
  [ze.COSMOSTATION]: {
    name: "Cosmostation",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-cosmostation.png"
  },
  [ze.VECTIS]: {
    name: "Vectis",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-vectis.svg"
  },
  [ze.STATION]: {
    name: "Station",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-station.svg"
  },
  [ze.XDEFI]: {
    name: "XDefi",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-xdefi.jpeg"
  },
  [ze.METAMASK_SNAP_LEAP]: {
    name: "Metamask Snap Leap",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-metamask.png"
  },
  [ze.METAMASK_SNAP_COSMOS]: {
    name: "Metamask Snap Cosmos",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-metamask.png"
  },
  [ze.WALLETCONNECT]: {
    name: "WalletConnect",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-walletconnect.png"
  },
  [ze.WC_KEPLR_MOBILE]: {
    name: "Keplr Mobile",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-keplr.png",
    mobile: !0
  },
  [ze.WC_LEAP_MOBILE]: {
    name: "Leap Mobile",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-leap.png",
    mobile: !0
  },
  [ze.WC_COSMOSTATION_MOBILE]: {
    name: "Cosmostation Mobile",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-cosmostation.png",
    mobile: !0
  },
  [ze.CAPSULE]: {
    name: "Capsule",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-capsule.jpg"
  },
  [ze.COSMIFRAME]: {
    name: "DAO DAO",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-daodao.png"
  },
  [ze.COMPASS]: {
    name: "Compass",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-compass.png"
  }
}, dA = (e) => ooe[e], roe = ({
  children: e
}) => /* @__PURE__ */ c.jsx(oD, { grazOptions: {
  // @ts-expect-error mismatch keplr types version
  chains: cA,
  autoReconnect: !0,
  walletDefaultOptions: {
    sign: {
      preferNoSetFee: !0
    }
  }
}, children: e });
function Fe(e) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...e
  };
}
const mA = "2.21.15";
let Ad = {
  getDocsUrl: ({ docsBaseUrl: e, docsPath: n = "", docsSlug: t }) => n ? `${e ?? "https://viem.sh"}${n}${t ? `#${t}` : ""}` : void 0,
  version: mA
}, ee = class dh extends Error {
  constructor(n, t = {}) {
    var d;
    const s = (() => {
      var m;
      return t.cause instanceof dh ? t.cause.details : (m = t.cause) != null && m.message ? t.cause.message : t.details;
    })(), a = t.cause instanceof dh && t.cause.docsPath || t.docsPath, o = (d = Ad.getDocsUrl) == null ? void 0 : d.call(Ad, { ...t, docsPath: a }), i = [
      n || "An error occurred.",
      "",
      ...t.metaMessages ? [...t.metaMessages, ""] : [],
      ...o ? [`Docs: ${o}`] : [],
      ...s ? [`Details: ${s}`] : [],
      `Version: ${Ad.version}`
    ].join(`
`);
    super(i, t.cause ? { cause: t.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = s, this.docsPath = a, this.metaMessages = t.metaMessages, this.name = t.name ?? this.name, this.shortMessage = n, this.version = mA;
  }
  walk(n) {
    return hA(this, n);
  }
};
function hA(e, n) {
  return n != null && n(e) ? e : e && typeof e == "object" && "cause" in e ? hA(e.cause, n) : n ? null : e;
}
class ioe extends ee {
  constructor({ max: n, min: t, signed: s, size: a, value: o }) {
    super(`Number "${o}" is not in safe ${a ? `${a * 8}-bit ${s ? "signed" : "unsigned"} ` : ""}integer range ${n ? `(${t} to ${n})` : `(above ${t})`}`, { name: "IntegerOutOfRangeError" });
  }
}
class coe extends ee {
  constructor({ givenSize: n, maxSize: t }) {
    super(`Size cannot exceed ${t} bytes. Given size: ${n} bytes.`, { name: "SizeOverflowError" });
  }
}
function qr(e, { strict: n = !0 } = {}) {
  return !e || typeof e != "string" ? !1 : n ? /^0x[0-9a-fA-F]*$/.test(e) : e.startsWith("0x");
}
function Dc(e) {
  return qr(e, { strict: !1 }) ? Math.ceil((e.length - 2) / 2) : e.length;
}
function Bc(e, { dir: n = "left" } = {}) {
  let t = typeof e == "string" ? e.replace("0x", "") : e, s = 0;
  for (let a = 0; a < t.length - 1 && t[n === "left" ? a : t.length - a - 1].toString() === "0"; a++)
    s++;
  return t = n === "left" ? t.slice(s) : t.slice(0, t.length - s), typeof e == "string" ? (t.length === 1 && n === "right" && (t = `${t}0`), `0x${t.length % 2 === 1 ? `0${t}` : t}`) : t;
}
class doe extends ee {
  constructor({ offset: n, position: t, size: s }) {
    super(`Slice ${t === "start" ? "starting" : "ending"} at offset "${n}" is out-of-bounds (size: ${s}).`, { name: "SliceOffsetOutOfBoundsError" });
  }
}
class pA extends ee {
  constructor({ size: n, targetSize: t, type: s }) {
    super(`${s.charAt(0).toUpperCase()}${s.slice(1).toLowerCase()} size (${n}) exceeds padding size (${t}).`, { name: "SizeExceedsPaddingSizeError" });
  }
}
class x6 extends ee {
  constructor({ size: n, targetSize: t, type: s }) {
    super(`${s.charAt(0).toUpperCase()}${s.slice(1).toLowerCase()} is expected to be ${t} ${s} long, but is ${n} ${s} long.`, { name: "InvalidBytesLengthError" });
  }
}
function Nc(e, { dir: n, size: t = 32 } = {}) {
  return typeof e == "string" ? moe(e, { dir: n, size: t }) : hoe(e, { dir: n, size: t });
}
function moe(e, { dir: n, size: t = 32 } = {}) {
  if (t === null)
    return e;
  const s = e.replace("0x", "");
  if (s.length > t * 2)
    throw new pA({
      size: Math.ceil(s.length / 2),
      targetSize: t,
      type: "hex"
    });
  return `0x${s[n === "right" ? "padEnd" : "padStart"](t * 2, "0")}`;
}
function hoe(e, { dir: n, size: t = 32 } = {}) {
  if (t === null)
    return e;
  if (e.length > t)
    throw new pA({
      size: e.length,
      targetSize: t,
      type: "bytes"
    });
  const s = new Uint8Array(t);
  for (let a = 0; a < t; a++) {
    const o = n === "right";
    s[o ? a : t - a - 1] = e[o ? a : e.length - a - 1];
  }
  return s;
}
const poe = /* @__PURE__ */ Array.from({ length: 256 }, (e, n) => n.toString(16).padStart(2, "0"));
function te(e, n = {}) {
  return typeof e == "number" || typeof e == "bigint" ? Be(e, n) : typeof e == "string" ? uoe(e, n) : typeof e == "boolean" ? loe(e, n) : lo(e, n);
}
function loe(e, n = {}) {
  const t = `0x${Number(e)}`;
  return typeof n.size == "number" ? (Pc(t, { size: n.size }), Nc(t, { size: n.size })) : t;
}
function lo(e, n = {}) {
  let t = "";
  for (let a = 0; a < e.length; a++)
    t += poe[e[a]];
  const s = `0x${t}`;
  return typeof n.size == "number" ? (Pc(s, { size: n.size }), Nc(s, { dir: "right", size: n.size })) : s;
}
function Be(e, n = {}) {
  const { signed: t, size: s } = n, a = BigInt(e);
  let o;
  s ? t ? o = (1n << BigInt(s) * 8n - 1n) - 1n : o = 2n ** (BigInt(s) * 8n) - 1n : typeof e == "number" && (o = BigInt(Number.MAX_SAFE_INTEGER));
  const i = typeof o == "bigint" && t ? -o - 1n : 0;
  if (o && a > o || a < i) {
    const m = typeof e == "bigint" ? "n" : "";
    throw new ioe({
      max: o ? `${o}${m}` : void 0,
      min: `${i}${m}`,
      signed: t,
      size: s,
      value: `${e}${m}`
    });
  }
  const d = `0x${(t && a < 0 ? (1n << BigInt(s * 8)) + BigInt(a) : a).toString(16)}`;
  return s ? Nc(d, { size: s }) : d;
}
const goe = /* @__PURE__ */ new TextEncoder();
function uoe(e, n = {}) {
  const t = goe.encode(e);
  return lo(t, n);
}
const _oe = /* @__PURE__ */ new TextEncoder();
function lA(e, n = {}) {
  return typeof e == "number" || typeof e == "bigint" ? boe(e, n) : typeof e == "boolean" ? yoe(e, n) : qr(e) ? Eo(e, n) : gA(e, n);
}
function yoe(e, n = {}) {
  const t = new Uint8Array(1);
  return t[0] = Number(e), typeof n.size == "number" ? (Pc(t, { size: n.size }), Nc(t, { size: n.size })) : t;
}
const to = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function k6(e) {
  if (e >= to.zero && e <= to.nine)
    return e - to.zero;
  if (e >= to.A && e <= to.F)
    return e - (to.A - 10);
  if (e >= to.a && e <= to.f)
    return e - (to.a - 10);
}
function Eo(e, n = {}) {
  let t = e;
  n.size && (Pc(t, { size: n.size }), t = Nc(t, { dir: "right", size: n.size }));
  let s = t.slice(2);
  s.length % 2 && (s = `0${s}`);
  const a = s.length / 2, o = new Uint8Array(a);
  for (let i = 0, d = 0; i < a; i++) {
    const m = k6(s.charCodeAt(d++)), h = k6(s.charCodeAt(d++));
    if (m === void 0 || h === void 0)
      throw new ee(`Invalid byte sequence ("${s[d - 2]}${s[d - 1]}" in "${s}").`);
    o[i] = m * 16 + h;
  }
  return o;
}
function boe(e, n) {
  const t = Be(e, n);
  return Eo(t);
}
function gA(e, n = {}) {
  const t = _oe.encode(e);
  return typeof n.size == "number" ? (Pc(t, { size: n.size }), Nc(t, { dir: "right", size: n.size })) : t;
}
function Pc(e, { size: n }) {
  if (Dc(e) > n)
    throw new coe({
      givenSize: Dc(e),
      maxSize: n
    });
}
function yn(e, n = {}) {
  const { signed: t } = n;
  n.size && Pc(e, { size: n.size });
  const s = BigInt(e);
  if (!t)
    return s;
  const a = (e.length - 2) / 2, o = (1n << BigInt(a) * 8n - 1n) - 1n;
  return s <= o ? s : s - BigInt(`0x${"f".padStart(a * 2, "f")}`) - 1n;
}
function Sr(e, n = {}) {
  return Number(yn(e, n));
}
function ym(e, n) {
  return ({ exclude: t, format: s }) => ({
    exclude: t,
    format: (a) => {
      const o = n(a);
      if (t)
        for (const i of t)
          delete o[i];
      return {
        ...o,
        ...s(a)
      };
    },
    type: e
  });
}
const uA = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559",
  "0x3": "eip4844",
  "0x4": "eip7702"
};
function bm(e) {
  const n = {
    ...e,
    blockHash: e.blockHash ? e.blockHash : null,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    chainId: e.chainId ? Sr(e.chainId) : void 0,
    gas: e.gas ? BigInt(e.gas) : void 0,
    gasPrice: e.gasPrice ? BigInt(e.gasPrice) : void 0,
    maxFeePerBlobGas: e.maxFeePerBlobGas ? BigInt(e.maxFeePerBlobGas) : void 0,
    maxFeePerGas: e.maxFeePerGas ? BigInt(e.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: e.maxPriorityFeePerGas ? BigInt(e.maxPriorityFeePerGas) : void 0,
    nonce: e.nonce ? Sr(e.nonce) : void 0,
    to: e.to ? e.to : null,
    transactionIndex: e.transactionIndex ? Number(e.transactionIndex) : null,
    type: e.type ? uA[e.type] : void 0,
    typeHex: e.type ? e.type : void 0,
    value: e.value ? BigInt(e.value) : void 0,
    v: e.v ? BigInt(e.v) : void 0
  };
  return e.authorizationList && (n.authorizationList = voe(e.authorizationList)), n.yParity = (() => {
    if (e.yParity)
      return Number(e.yParity);
    if (typeof n.v == "bigint") {
      if (n.v === 0n || n.v === 27n)
        return 0;
      if (n.v === 1n || n.v === 28n)
        return 1;
      if (n.v >= 35n)
        return n.v % 2n === 0n ? 1 : 0;
    }
  })(), n.type === "legacy" && (delete n.accessList, delete n.maxFeePerBlobGas, delete n.maxFeePerGas, delete n.maxPriorityFeePerGas, delete n.yParity), n.type === "eip2930" && (delete n.maxFeePerBlobGas, delete n.maxFeePerGas, delete n.maxPriorityFeePerGas), n.type === "eip1559" && delete n.maxFeePerBlobGas, n;
}
const _A = /* @__PURE__ */ ym("transaction", bm);
function voe(e) {
  return e.map((n) => ({
    contractAddress: n.address,
    r: n.r,
    s: n.s,
    chainId: Number(n.chainId),
    nonce: Number(n.nonce),
    ...typeof n.yParity < "u" ? { yParity: Number(n.yParity) } : {},
    ...typeof n.v < "u" && typeof n.yParity > "u" ? { v: Number(n.v) } : {}
  }));
}
function yA(e) {
  var t;
  const n = (t = e.transactions) == null ? void 0 : t.map((s) => typeof s == "string" ? s : bm(s));
  return {
    ...e,
    baseFeePerGas: e.baseFeePerGas ? BigInt(e.baseFeePerGas) : null,
    blobGasUsed: e.blobGasUsed ? BigInt(e.blobGasUsed) : void 0,
    difficulty: e.difficulty ? BigInt(e.difficulty) : void 0,
    excessBlobGas: e.excessBlobGas ? BigInt(e.excessBlobGas) : void 0,
    gasLimit: e.gasLimit ? BigInt(e.gasLimit) : void 0,
    gasUsed: e.gasUsed ? BigInt(e.gasUsed) : void 0,
    hash: e.hash ? e.hash : null,
    logsBloom: e.logsBloom ? e.logsBloom : null,
    nonce: e.nonce ? e.nonce : null,
    number: e.number ? BigInt(e.number) : null,
    size: e.size ? BigInt(e.size) : void 0,
    timestamp: e.timestamp ? BigInt(e.timestamp) : void 0,
    transactions: n,
    totalDifficulty: e.totalDifficulty ? BigInt(e.totalDifficulty) : null
  };
}
const bA = /* @__PURE__ */ ym("block", yA);
function foe(e, { args: n, eventName: t } = {}) {
  return {
    ...e,
    blockHash: e.blockHash ? e.blockHash : null,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    logIndex: e.logIndex ? Number(e.logIndex) : null,
    transactionHash: e.transactionHash ? e.transactionHash : null,
    transactionIndex: e.transactionIndex ? Number(e.transactionIndex) : null,
    ...t ? { args: n, eventName: t } : {}
  };
}
const woe = {
  "0x0": "reverted",
  "0x1": "success"
};
function xoe(e) {
  const n = {
    ...e,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    contractAddress: e.contractAddress ? e.contractAddress : null,
    cumulativeGasUsed: e.cumulativeGasUsed ? BigInt(e.cumulativeGasUsed) : null,
    effectiveGasPrice: e.effectiveGasPrice ? BigInt(e.effectiveGasPrice) : null,
    gasUsed: e.gasUsed ? BigInt(e.gasUsed) : null,
    logs: e.logs ? e.logs.map((t) => foe(t)) : null,
    to: e.to ? e.to : null,
    transactionIndex: e.transactionIndex ? Sr(e.transactionIndex) : null,
    status: e.status ? woe[e.status] : null,
    type: e.type ? uA[e.type] || e.type : null
  };
  return e.blobGasPrice && (n.blobGasPrice = BigInt(e.blobGasPrice)), e.blobGasUsed && (n.blobGasUsed = BigInt(e.blobGasUsed)), n;
}
const koe = /* @__PURE__ */ ym("transactionReceipt", xoe), Aoe = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2",
  eip4844: "0x3",
  eip7702: "0x4"
};
function dw(e) {
  const n = {};
  return typeof e.authorizationList < "u" && (n.authorizationList = Coe(e.authorizationList)), typeof e.accessList < "u" && (n.accessList = e.accessList), typeof e.blobVersionedHashes < "u" && (n.blobVersionedHashes = e.blobVersionedHashes), typeof e.blobs < "u" && (typeof e.blobs[0] != "string" ? n.blobs = e.blobs.map((t) => lo(t)) : n.blobs = e.blobs), typeof e.data < "u" && (n.data = e.data), typeof e.from < "u" && (n.from = e.from), typeof e.gas < "u" && (n.gas = Be(e.gas)), typeof e.gasPrice < "u" && (n.gasPrice = Be(e.gasPrice)), typeof e.maxFeePerBlobGas < "u" && (n.maxFeePerBlobGas = Be(e.maxFeePerBlobGas)), typeof e.maxFeePerGas < "u" && (n.maxFeePerGas = Be(e.maxFeePerGas)), typeof e.maxPriorityFeePerGas < "u" && (n.maxPriorityFeePerGas = Be(e.maxPriorityFeePerGas)), typeof e.nonce < "u" && (n.nonce = Be(e.nonce)), typeof e.to < "u" && (n.to = e.to), typeof e.type < "u" && (n.type = Aoe[e.type]), typeof e.value < "u" && (n.value = Be(e.value)), n;
}
const joe = /* @__PURE__ */ ym("transactionRequest", dw);
function Coe(e) {
  return e.map((n) => ({
    address: n.contractAddress,
    r: n.r,
    s: n.s,
    chainId: Be(n.chainId),
    nonce: Be(n.nonce),
    ...typeof n.yParity < "u" ? { yParity: Be(n.yParity) } : {},
    ...typeof n.v < "u" && typeof n.yParity > "u" ? { v: Be(n.v) } : {}
  }));
}
const ld = 2n ** 256n - 1n;
function cc(e) {
  return `0x${e.reduce((n, t) => n + t.replace("0x", ""), "")}`;
}
class A6 extends ee {
  constructor({ offset: n }) {
    super(`Offset \`${n}\` cannot be negative.`, {
      name: "NegativeOffsetError"
    });
  }
}
class Eoe extends ee {
  constructor({ length: n, position: t }) {
    super(`Position \`${t}\` is out of bounds (\`0 < position < ${n}\`).`, { name: "PositionOutOfBoundsError" });
  }
}
class Doe extends ee {
  constructor({ count: n, limit: t }) {
    super(`Recursive read limit of \`${t}\` exceeded (recursive read count: \`${n}\`).`, { name: "RecursiveReadLimitExceededError" });
  }
}
const Boe = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: Number.POSITIVE_INFINITY,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new Doe({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(e) {
    if (e < 0 || e > this.bytes.length - 1)
      throw new Eoe({
        length: this.bytes.length,
        position: e
      });
  },
  decrementPosition(e) {
    if (e < 0)
      throw new A6({ offset: e });
    const n = this.position - e;
    this.assertPosition(n), this.position = n;
  },
  getReadCount(e) {
    return this.positionReadCount.get(e || this.position) || 0;
  },
  incrementPosition(e) {
    if (e < 0)
      throw new A6({ offset: e });
    const n = this.position + e;
    this.assertPosition(n), this.position = n;
  },
  inspectByte(e) {
    const n = e ?? this.position;
    return this.assertPosition(n), this.bytes[n];
  },
  inspectBytes(e, n) {
    const t = n ?? this.position;
    return this.assertPosition(t + e - 1), this.bytes.subarray(t, t + e);
  },
  inspectUint8(e) {
    const n = e ?? this.position;
    return this.assertPosition(n), this.bytes[n];
  },
  inspectUint16(e) {
    const n = e ?? this.position;
    return this.assertPosition(n + 1), this.dataView.getUint16(n);
  },
  inspectUint24(e) {
    const n = e ?? this.position;
    return this.assertPosition(n + 2), (this.dataView.getUint16(n) << 8) + this.dataView.getUint8(n + 2);
  },
  inspectUint32(e) {
    const n = e ?? this.position;
    return this.assertPosition(n + 3), this.dataView.getUint32(n);
  },
  pushByte(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushBytes(e) {
    this.assertPosition(this.position + e.length - 1), this.bytes.set(e, this.position), this.position += e.length;
  },
  pushUint8(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushUint16(e) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, e), this.position += 2;
  },
  pushUint24(e) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, e >> 8), this.dataView.setUint8(this.position + 2, e & 255), this.position += 3;
  },
  pushUint32(e) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, e), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectByte();
    return this.position++, e;
  },
  readBytes(e, n) {
    this.assertReadLimit(), this._touch();
    const t = this.inspectBytes(e);
    return this.position += n ?? e, t;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint8();
    return this.position += 1, e;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint16();
    return this.position += 2, e;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint24();
    return this.position += 3, e;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint32();
    return this.position += 4, e;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(e) {
    const n = this.position;
    return this.assertPosition(e), this.position = e, () => this.position = n;
  },
  _touch() {
    if (this.recursiveReadLimit === Number.POSITIVE_INFINITY)
      return;
    const e = this.getReadCount();
    this.positionReadCount.set(this.position, e + 1), e > 0 && this.recursiveReadCount++;
  }
};
function vA(e, { recursiveReadLimit: n = 8192 } = {}) {
  const t = Object.create(Boe);
  return t.bytes = e, t.dataView = new DataView(e.buffer, e.byteOffset, e.byteLength), t.positionReadCount = /* @__PURE__ */ new Map(), t.recursiveReadLimit = n, t;
}
function mo(e, n = "hex") {
  const t = fA(e), s = vA(new Uint8Array(t.length));
  return t.encode(s), n === "hex" ? lo(s.bytes) : s.bytes;
}
function fA(e) {
  return Array.isArray(e) ? Foe(e.map((n) => fA(n))) : $oe(e);
}
function Foe(e) {
  const n = e.reduce((a, o) => a + o.length, 0), t = wA(n);
  return {
    length: n <= 55 ? 1 + n : 1 + t + n,
    encode(a) {
      n <= 55 ? a.pushByte(192 + n) : (a.pushByte(247 + t), t === 1 ? a.pushUint8(n) : t === 2 ? a.pushUint16(n) : t === 3 ? a.pushUint24(n) : a.pushUint32(n));
      for (const { encode: o } of e)
        o(a);
    }
  };
}
function $oe(e) {
  const n = typeof e == "string" ? Eo(e) : e, t = wA(n.length);
  return {
    length: n.length === 1 && n[0] < 128 ? 1 : n.length <= 55 ? 1 + n.length : 1 + t + n.length,
    encode(a) {
      n.length === 1 && n[0] < 128 ? a.pushBytes(n) : n.length <= 55 ? (a.pushByte(128 + n.length), a.pushBytes(n)) : (a.pushByte(183 + t), t === 1 ? a.pushUint8(n.length) : t === 2 ? a.pushUint16(n.length) : t === 3 ? a.pushUint24(n.length) : a.pushUint32(n.length), a.pushBytes(n));
    }
  };
}
function wA(e) {
  if (e < 2 ** 8)
    return 1;
  if (e < 2 ** 16)
    return 2;
  if (e < 2 ** 24)
    return 3;
  if (e < 2 ** 32)
    return 4;
  throw new ee("Length is too large.");
}
const zoe = {
  gwei: 9,
  wei: 18
}, qoe = {
  ether: -9,
  wei: 9
};
function xA(e, n) {
  let t = e.toString();
  const s = t.startsWith("-");
  s && (t = t.slice(1)), t = t.padStart(n, "0");
  let [a, o] = [
    t.slice(0, t.length - n),
    t.slice(t.length - n)
  ];
  return o = o.replace(/(0+)$/, ""), `${s ? "-" : ""}${a || "0"}${o ? `.${o}` : ""}`;
}
function kA(e, n = "wei") {
  return xA(e, zoe[n]);
}
function An(e, n = "wei") {
  return xA(e, qoe[n]);
}
function mw(e) {
  const n = Object.entries(e).map(([s, a]) => a === void 0 || a === !1 ? null : [s, a]).filter(Boolean), t = n.reduce((s, [a]) => Math.max(s, a.length), 0);
  return n.map(([s, a]) => `  ${`${s}:`.padEnd(t + 1)}  ${a}`).join(`
`);
}
class Soe extends ee {
  constructor() {
    super([
      "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
      "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
    ].join(`
`), { name: "FeeConflictError" });
  }
}
class Toe extends ee {
  constructor({ v: n }) {
    super(`Invalid \`v\` value "${n}". Expected 27 or 28.`, {
      name: "InvalidLegacyVError"
    });
  }
}
class Roe extends ee {
  constructor({ transaction: n }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        mw(n),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
        "- an EIP-7702 Transaction with `authorizationList`, or",
        "- a Legacy Transaction with `gasPrice`"
      ],
      name: "InvalidSerializableTransactionError"
    });
  }
}
class Ooe extends ee {
  constructor({ storageKey: n }) {
    super(`Size for storage key "${n}" is invalid. Expected 32 bytes. Got ${Math.floor((n.length - 2) / 2)} bytes.`, { name: "InvalidStorageKeySizeError" });
  }
}
function hw(e) {
  const { kzg: n } = e, t = e.to ?? (typeof e.blobs[0] == "string" ? "hex" : "bytes"), s = typeof e.blobs[0] == "string" ? e.blobs.map((o) => Eo(o)) : e.blobs, a = [];
  for (const o of s)
    a.push(Uint8Array.from(n.blobToKzgCommitment(o)));
  return t === "bytes" ? a : a.map((o) => lo(o));
}
function pw(e) {
  const { kzg: n } = e, t = e.to ?? (typeof e.blobs[0] == "string" ? "hex" : "bytes"), s = typeof e.blobs[0] == "string" ? e.blobs.map((i) => Eo(i)) : e.blobs, a = typeof e.commitments[0] == "string" ? e.commitments.map((i) => Eo(i)) : e.commitments, o = [];
  for (let i = 0; i < s.length; i++) {
    const d = s[i], m = a[i];
    o.push(Uint8Array.from(n.computeBlobKzgProof(d, m)));
  }
  return t === "bytes" ? o : o.map((i) => lo(i));
}
function Gd(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`positive integer expected, not ${e}`);
}
function Moe(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function vm(e, ...n) {
  if (!Moe(e))
    throw new Error("Uint8Array expected");
  if (n.length > 0 && !n.includes(e.length))
    throw new Error(`Uint8Array expected of length ${n}, not of length=${e.length}`);
}
function v3e(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  Gd(e.outputLen), Gd(e.blockLen);
}
function Kd(e, n = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (n && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function AA(e, n) {
  vm(e);
  const t = n.outputLen;
  if (e.length < t)
    throw new Error(`digestInto() expects output buffer of length at least ${t}`);
}
const Rm = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Ioe = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), Om = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), Cn = (e, n) => e << 32 - n | e >>> n, j6 = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, Noe = (e) => e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255;
function C6(e) {
  for (let n = 0; n < e.length; n++)
    e[n] = Noe(e[n]);
}
function Poe(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function lw(e) {
  return typeof e == "string" && (e = Poe(e)), vm(e), e;
}
function f3e(...e) {
  let n = 0;
  for (let s = 0; s < e.length; s++) {
    const a = e[s];
    vm(a), n += a.length;
  }
  const t = new Uint8Array(n);
  for (let s = 0, a = 0; s < e.length; s++) {
    const o = e[s];
    t.set(o, a), a += o.length;
  }
  return t;
}
class jA {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function CA(e) {
  const n = (s) => e().update(lw(s)).digest(), t = e();
  return n.outputLen = t.outputLen, n.blockLen = t.blockLen, n.create = () => e(), n;
}
function w3e(e = 32) {
  if (Rm && typeof Rm.getRandomValues == "function")
    return Rm.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
function Uoe(e, n, t, s) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(n, t, s);
  const a = BigInt(32), o = BigInt(4294967295), i = Number(t >> a & o), d = Number(t & o), m = s ? 4 : 0, h = s ? 0 : 4;
  e.setUint32(n + m, i, s), e.setUint32(n + h, d, s);
}
const Hoe = (e, n, t) => e & n ^ ~e & t, Loe = (e, n, t) => e & n ^ e & t ^ n & t;
class Woe extends jA {
  constructor(n, t, s, a) {
    super(), this.blockLen = n, this.outputLen = t, this.padOffset = s, this.isLE = a, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(n), this.view = Om(this.buffer);
  }
  update(n) {
    Kd(this);
    const { view: t, buffer: s, blockLen: a } = this;
    n = lw(n);
    const o = n.length;
    for (let i = 0; i < o; ) {
      const d = Math.min(a - this.pos, o - i);
      if (d === a) {
        const m = Om(n);
        for (; a <= o - i; i += a)
          this.process(m, i);
        continue;
      }
      s.set(n.subarray(i, i + d), this.pos), this.pos += d, i += d, this.pos === a && (this.process(t, 0), this.pos = 0);
    }
    return this.length += n.length, this.roundClean(), this;
  }
  digestInto(n) {
    Kd(this), AA(n, this), this.finished = !0;
    const { buffer: t, view: s, blockLen: a, isLE: o } = this;
    let { pos: i } = this;
    t[i++] = 128, this.buffer.subarray(i).fill(0), this.padOffset > a - i && (this.process(s, 0), i = 0);
    for (let _ = i; _ < a; _++)
      t[_] = 0;
    Uoe(s, a - 8, BigInt(this.length * 8), o), this.process(s, 0);
    const d = Om(n), m = this.outputLen;
    if (m % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const h = m / 4, p = this.get();
    if (h > p.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let _ = 0; _ < h; _++)
      d.setUint32(4 * _, p[_], o);
  }
  digest() {
    const { buffer: n, outputLen: t } = this;
    this.digestInto(n);
    const s = n.slice(0, t);
    return this.destroy(), s;
  }
  _cloneInto(n) {
    n || (n = new this.constructor()), n.set(...this.get());
    const { blockLen: t, buffer: s, length: a, finished: o, destroyed: i, pos: d } = this;
    return n.length = a, n.pos = d, n.finished = o, n.destroyed = i, a % t && n.buffer.set(s), n;
  }
}
const Voe = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), _o = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), yo = /* @__PURE__ */ new Uint32Array(64);
class Goe extends Woe {
  constructor() {
    super(64, 32, 8, !1), this.A = _o[0] | 0, this.B = _o[1] | 0, this.C = _o[2] | 0, this.D = _o[3] | 0, this.E = _o[4] | 0, this.F = _o[5] | 0, this.G = _o[6] | 0, this.H = _o[7] | 0;
  }
  get() {
    const { A: n, B: t, C: s, D: a, E: o, F: i, G: d, H: m } = this;
    return [n, t, s, a, o, i, d, m];
  }
  // prettier-ignore
  set(n, t, s, a, o, i, d, m) {
    this.A = n | 0, this.B = t | 0, this.C = s | 0, this.D = a | 0, this.E = o | 0, this.F = i | 0, this.G = d | 0, this.H = m | 0;
  }
  process(n, t) {
    for (let _ = 0; _ < 16; _++, t += 4)
      yo[_] = n.getUint32(t, !1);
    for (let _ = 16; _ < 64; _++) {
      const y = yo[_ - 15], w = yo[_ - 2], q = Cn(y, 7) ^ Cn(y, 18) ^ y >>> 3, k = Cn(w, 17) ^ Cn(w, 19) ^ w >>> 10;
      yo[_] = k + yo[_ - 7] + q + yo[_ - 16] | 0;
    }
    let { A: s, B: a, C: o, D: i, E: d, F: m, G: h, H: p } = this;
    for (let _ = 0; _ < 64; _++) {
      const y = Cn(d, 6) ^ Cn(d, 11) ^ Cn(d, 25), w = p + y + Hoe(d, m, h) + Voe[_] + yo[_] | 0, k = (Cn(s, 2) ^ Cn(s, 13) ^ Cn(s, 22)) + Loe(s, a, o) | 0;
      p = h, h = m, m = d, d = i + w | 0, i = o, o = a, a = s, s = w + k | 0;
    }
    s = s + this.A | 0, a = a + this.B | 0, o = o + this.C | 0, i = i + this.D | 0, d = d + this.E | 0, m = m + this.F | 0, h = h + this.G | 0, p = p + this.H | 0, this.set(s, a, o, i, d, m, h, p);
  }
  roundClean() {
    yo.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const Koe = /* @__PURE__ */ CA(() => new Goe());
function Xoe(e, n) {
  return Koe(qr(e, { strict: !1 }) ? lA(e) : e);
}
function Yoe(e) {
  const { commitment: n, version: t = 1 } = e, s = e.to ?? (typeof n == "string" ? "hex" : "bytes"), a = Xoe(n);
  return a.set([t], 0), s === "bytes" ? a : lo(a);
}
function EA(e) {
  const { commitments: n, version: t } = e, s = e.to ?? (typeof n[0] == "string" ? "hex" : "bytes"), a = [];
  for (const o of n)
    a.push(Yoe({
      commitment: o,
      to: s,
      version: t
    }));
  return a;
}
const E6 = 6, DA = 32, gw = 4096, BA = DA * gw, D6 = BA * E6 - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * gw * E6, FA = 1;
class Joe extends ee {
  constructor({ maxSize: n, size: t }) {
    super("Blob size is too large.", {
      metaMessages: [`Max: ${n} bytes`, `Given: ${t} bytes`],
      name: "BlobSizeTooLargeError"
    });
  }
}
class $A extends ee {
  constructor() {
    super("Blob data must not be empty.", { name: "EmptyBlobError" });
  }
}
class Zoe extends ee {
  constructor({ hash: n, size: t }) {
    super(`Versioned hash "${n}" size is invalid.`, {
      metaMessages: ["Expected: 32", `Received: ${t}`],
      name: "InvalidVersionedHashSizeError"
    });
  }
}
class Qoe extends ee {
  constructor({ hash: n, version: t }) {
    super(`Versioned hash "${n}" version is invalid.`, {
      metaMessages: [
        `Expected: ${FA}`,
        `Received: ${t}`
      ],
      name: "InvalidVersionedHashVersionError"
    });
  }
}
function ere(e) {
  const n = e.to ?? (typeof e.data == "string" ? "hex" : "bytes"), t = typeof e.data == "string" ? Eo(e.data) : e.data, s = Dc(t);
  if (!s)
    throw new $A();
  if (s > D6)
    throw new Joe({
      maxSize: D6,
      size: s
    });
  const a = [];
  let o = !0, i = 0;
  for (; o; ) {
    const d = vA(new Uint8Array(BA));
    let m = 0;
    for (; m < gw; ) {
      const h = t.slice(i, i + (DA - 1));
      if (d.pushByte(0), d.pushBytes(h), h.length < 31) {
        d.pushByte(128), o = !1;
        break;
      }
      m++, i += 31;
    }
    a.push(d);
  }
  return n === "bytes" ? a.map((d) => d.bytes) : a.map((d) => lo(d.bytes));
}
function zA(e) {
  const { data: n, kzg: t, to: s } = e, a = e.blobs ?? ere({ data: n, to: s }), o = e.commitments ?? hw({ blobs: a, kzg: t, to: s }), i = e.proofs ?? pw({ blobs: a, commitments: o, kzg: t, to: s }), d = [];
  for (let m = 0; m < a.length; m++)
    d.push({
      blob: a[m],
      commitment: o[m],
      proof: i[m]
    });
  return d;
}
function nre(e) {
  if (!e || e.length === 0)
    return [];
  const n = [];
  for (const t of e) {
    const { contractAddress: s, chainId: a, nonce: o, ...i } = t;
    n.push([
      te(a),
      s,
      o ? te(o) : "0x",
      ...Uc({}, i)
    ]);
  }
  return n;
}
class vn extends ee {
  constructor({ address: n }) {
    super(`Address "${n}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ],
      name: "InvalidAddressError"
    });
  }
}
class gd extends ee {
  constructor({ chainId: n }) {
    super(typeof n == "number" ? `Chain ID "${n}" is invalid.` : "Chain ID is invalid.", { name: "InvalidChainIdError" });
  }
}
class bc extends ee {
  constructor({ cause: n, message: t } = {}) {
    var a;
    const s = (a = t == null ? void 0 : t.replace("execution reverted: ", "")) == null ? void 0 : a.replace("execution reverted", "");
    super(`Execution reverted ${s ? `with reason: ${s}` : "for an unknown reason"}.`, {
      cause: n,
      name: "ExecutionRevertedError"
    });
  }
}
Object.defineProperty(bc, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 3
});
Object.defineProperty(bc, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /execution reverted/
});
class Do extends ee {
  constructor({ cause: n, maxFeePerGas: t } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${t ? ` = ${An(t)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: n,
      name: "FeeCapTooHighError"
    });
  }
}
Object.defineProperty(Do, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class mh extends ee {
  constructor({ cause: n, maxFeePerGas: t } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${t ? ` = ${An(t)}` : ""} gwei) cannot be lower than the block base fee.`, {
      cause: n,
      name: "FeeCapTooLowError"
    });
  }
}
Object.defineProperty(mh, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class hh extends ee {
  constructor({ cause: n, nonce: t } = {}) {
    super(`Nonce provided for the transaction ${t ? `(${t}) ` : ""}is higher than the next one expected.`, { cause: n, name: "NonceTooHighError" });
  }
}
Object.defineProperty(hh, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too high/
});
class ph extends ee {
  constructor({ cause: n, nonce: t } = {}) {
    super([
      `Nonce provided for the transaction ${t ? `(${t}) ` : ""}is lower than the current nonce of the account.`,
      "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
    ].join(`
`), { cause: n, name: "NonceTooLowError" });
  }
}
Object.defineProperty(ph, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too low|transaction already imported|already known/
});
class lh extends ee {
  constructor({ cause: n, nonce: t } = {}) {
    super(`Nonce provided for the transaction ${t ? `(${t}) ` : ""}exceeds the maximum allowed nonce.`, { cause: n, name: "NonceMaxValueError" });
  }
}
Object.defineProperty(lh, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce has max value/
});
class gh extends ee {
  constructor({ cause: n } = {}) {
    super([
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
    ].join(`
`), {
      cause: n,
      metaMessages: [
        "This error could arise when the account does not have enough funds to:",
        " - pay for the total gas fee,",
        " - pay for the value to send.",
        " ",
        "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
        " - `gas` is the amount of gas needed for transaction to execute,",
        " - `gas fee` is the gas fee,",
        " - `value` is the amount of ether to send to the recipient."
      ],
      name: "InsufficientFundsError"
    });
  }
}
Object.defineProperty(gh, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /insufficient funds|exceeds transaction sender account balance/
});
class uh extends ee {
  constructor({ cause: n, gas: t } = {}) {
    super(`The amount of gas ${t ? `(${t}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
      cause: n,
      name: "IntrinsicGasTooHighError"
    });
  }
}
Object.defineProperty(uh, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too high|gas limit reached/
});
class _h extends ee {
  constructor({ cause: n, gas: t } = {}) {
    super(`The amount of gas ${t ? `(${t}) ` : ""}provided for the transaction is too low.`, {
      cause: n,
      name: "IntrinsicGasTooLowError"
    });
  }
}
Object.defineProperty(_h, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too low/
});
class yh extends ee {
  constructor({ cause: n }) {
    super("The transaction type is not supported for this chain.", {
      cause: n,
      name: "TransactionTypeNotSupportedError"
    });
  }
}
Object.defineProperty(yh, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /transaction type not valid/
});
class Fc extends ee {
  constructor({ cause: n, maxPriorityFeePerGas: t, maxFeePerGas: s } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${t ? ` = ${An(t)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${s ? ` = ${An(s)} gwei` : ""}).`
    ].join(`
`), {
      cause: n,
      name: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(Fc, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class uw extends ee {
  constructor({ cause: n }) {
    super(`An error occurred while executing: ${n == null ? void 0 : n.shortMessage}`, {
      cause: n,
      name: "UnknownNodeError"
    });
  }
}
class qA extends Map {
  constructor(n) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = n;
  }
  get(n) {
    const t = super.get(n);
    return super.has(n) && t !== void 0 && (this.delete(n), super.set(n, t)), t;
  }
  set(n, t) {
    if (super.set(n, t), this.maxSize && this.size > this.maxSize) {
      const s = this.keys().next().value;
      s && this.delete(s);
    }
    return this;
  }
}
const jd = /* @__PURE__ */ BigInt(2 ** 32 - 1), B6 = /* @__PURE__ */ BigInt(32);
function tre(e, n = !1) {
  return n ? { h: Number(e & jd), l: Number(e >> B6 & jd) } : { h: Number(e >> B6 & jd) | 0, l: Number(e & jd) | 0 };
}
function sre(e, n = !1) {
  let t = new Uint32Array(e.length), s = new Uint32Array(e.length);
  for (let a = 0; a < e.length; a++) {
    const { h: o, l: i } = tre(e[a], n);
    [t[a], s[a]] = [o, i];
  }
  return [t, s];
}
const are = (e, n, t) => e << t | n >>> 32 - t, ore = (e, n, t) => n << t | e >>> 32 - t, rre = (e, n, t) => n << t - 32 | e >>> 64 - t, ire = (e, n, t) => e << t - 32 | n >>> 64 - t, SA = [], TA = [], RA = [], cre = /* @__PURE__ */ BigInt(0), Yc = /* @__PURE__ */ BigInt(1), dre = /* @__PURE__ */ BigInt(2), mre = /* @__PURE__ */ BigInt(7), hre = /* @__PURE__ */ BigInt(256), pre = /* @__PURE__ */ BigInt(113);
for (let e = 0, n = Yc, t = 1, s = 0; e < 24; e++) {
  [t, s] = [s, (2 * t + 3 * s) % 5], SA.push(2 * (5 * s + t)), TA.push((e + 1) * (e + 2) / 2 % 64);
  let a = cre;
  for (let o = 0; o < 7; o++)
    n = (n << Yc ^ (n >> mre) * pre) % hre, n & dre && (a ^= Yc << (Yc << /* @__PURE__ */ BigInt(o)) - Yc);
  RA.push(a);
}
const [lre, gre] = /* @__PURE__ */ sre(RA, !0), F6 = (e, n, t) => t > 32 ? rre(e, n, t) : are(e, n, t), $6 = (e, n, t) => t > 32 ? ire(e, n, t) : ore(e, n, t);
function ure(e, n = 24) {
  const t = new Uint32Array(10);
  for (let s = 24 - n; s < 24; s++) {
    for (let i = 0; i < 10; i++)
      t[i] = e[i] ^ e[i + 10] ^ e[i + 20] ^ e[i + 30] ^ e[i + 40];
    for (let i = 0; i < 10; i += 2) {
      const d = (i + 8) % 10, m = (i + 2) % 10, h = t[m], p = t[m + 1], _ = F6(h, p, 1) ^ t[d], y = $6(h, p, 1) ^ t[d + 1];
      for (let w = 0; w < 50; w += 10)
        e[i + w] ^= _, e[i + w + 1] ^= y;
    }
    let a = e[2], o = e[3];
    for (let i = 0; i < 24; i++) {
      const d = TA[i], m = F6(a, o, d), h = $6(a, o, d), p = SA[i];
      a = e[p], o = e[p + 1], e[p] = m, e[p + 1] = h;
    }
    for (let i = 0; i < 50; i += 10) {
      for (let d = 0; d < 10; d++)
        t[d] = e[i + d];
      for (let d = 0; d < 10; d++)
        e[i + d] ^= ~t[(d + 2) % 10] & t[(d + 4) % 10];
    }
    e[0] ^= lre[s], e[1] ^= gre[s];
  }
  t.fill(0);
}
class _w extends jA {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(n, t, s, a = !1, o = 24) {
    if (super(), this.blockLen = n, this.suffix = t, this.outputLen = s, this.enableXOF = a, this.rounds = o, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, Gd(s), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = Ioe(this.state);
  }
  keccak() {
    j6 || C6(this.state32), ure(this.state32, this.rounds), j6 || C6(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(n) {
    Kd(this);
    const { blockLen: t, state: s } = this;
    n = lw(n);
    const a = n.length;
    for (let o = 0; o < a; ) {
      const i = Math.min(t - this.pos, a - o);
      for (let d = 0; d < i; d++)
        s[this.pos++] ^= n[o++];
      this.pos === t && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: n, suffix: t, pos: s, blockLen: a } = this;
    n[s] ^= t, t & 128 && s === a - 1 && this.keccak(), n[a - 1] ^= 128, this.keccak();
  }
  writeInto(n) {
    Kd(this, !1), vm(n), this.finish();
    const t = this.state, { blockLen: s } = this;
    for (let a = 0, o = n.length; a < o; ) {
      this.posOut >= s && this.keccak();
      const i = Math.min(s - this.posOut, o - a);
      n.set(t.subarray(this.posOut, this.posOut + i), a), this.posOut += i, a += i;
    }
    return n;
  }
  xofInto(n) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(n);
  }
  xof(n) {
    return Gd(n), this.xofInto(new Uint8Array(n));
  }
  digestInto(n) {
    if (AA(n, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(n), this.destroy(), n;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(n) {
    const { blockLen: t, suffix: s, outputLen: a, rounds: o, enableXOF: i } = this;
    return n || (n = new _w(t, s, a, i, o)), n.state32.set(this.state32), n.pos = this.pos, n.posOut = this.posOut, n.finished = this.finished, n.rounds = o, n.suffix = s, n.outputLen = a, n.enableXOF = i, n.destroyed = this.destroyed, n;
  }
}
const _re = (e, n, t) => CA(() => new _w(n, e, t)), yre = /* @__PURE__ */ _re(1, 136, 256 / 8);
function yw(e, n) {
  const t = n || "hex", s = yre(qr(e, { strict: !1 }) ? lA(e) : e);
  return t === "bytes" ? s : te(s);
}
const Mm = /* @__PURE__ */ new qA(8192);
function bw(e, n) {
  if (Mm.has(`${e}.${n}`))
    return Mm.get(`${e}.${n}`);
  const t = e.substring(2).toLowerCase(), s = yw(gA(t), "bytes"), a = t.split("");
  for (let i = 0; i < 40; i += 2)
    s[i >> 1] >> 4 >= 8 && a[i] && (a[i] = a[i].toUpperCase()), (s[i >> 1] & 15) >= 8 && a[i + 1] && (a[i + 1] = a[i + 1].toUpperCase());
  const o = `0x${a.join("")}`;
  return Mm.set(`${e}.${n}`, o), o;
}
function bre(e, n) {
  if (!rn(e, { strict: !1 }))
    throw new vn({ address: e });
  return bw(e, n);
}
const vre = /^0x[a-fA-F0-9]{40}$/, Im = /* @__PURE__ */ new qA(8192);
function rn(e, n) {
  const { strict: t = !0 } = n ?? {}, s = `${e}.${t}`;
  if (Im.has(s))
    return Im.get(s);
  const a = vre.test(e) ? e.toLowerCase() === e ? !0 : t ? bw(e) === e : !0 : !1;
  return Im.set(s, a), a;
}
function fre(e, n, t, { strict: s } = {}) {
  return qr(e, { strict: !1 }) ? xre(e, n, t, {
    strict: s
  }) : wre(e, n, t, {
    strict: s
  });
}
function OA(e, n, t) {
  if (Dc(e) !== t - n)
    throw new doe({
      offset: t,
      position: "end",
      size: Dc(e)
    });
}
function wre(e, n, t, { strict: s } = {}) {
  const a = e.slice(n, t);
  return s && OA(a, n, t), a;
}
function xre(e, n, t, { strict: s } = {}) {
  const a = `0x${e.replace("0x", "").slice(n * 2, t * 2)}`;
  return s && OA(a, n, t), a;
}
function kre(e) {
  const { authorizationList: n } = e;
  if (n)
    for (const t of n) {
      const { contractAddress: s, chainId: a } = t;
      if (!rn(s))
        throw new vn({ address: s });
      if (a <= 0)
        throw new gd({ chainId: a });
    }
  vw(e);
}
function Are(e) {
  const { blobVersionedHashes: n } = e;
  if (n) {
    if (n.length === 0)
      throw new $A();
    for (const t of n) {
      const s = Dc(t), a = Sr(fre(t, 0, 1));
      if (s !== 32)
        throw new Zoe({ hash: t, size: s });
      if (a !== FA)
        throw new Qoe({
          hash: t,
          version: a
        });
    }
  }
  vw(e);
}
function vw(e) {
  const { chainId: n, maxPriorityFeePerGas: t, maxFeePerGas: s, to: a } = e;
  if (n <= 0)
    throw new gd({ chainId: n });
  if (a && !rn(a))
    throw new vn({ address: a });
  if (s && s > ld)
    throw new Do({ maxFeePerGas: s });
  if (t && s && t > s)
    throw new Fc({ maxFeePerGas: s, maxPriorityFeePerGas: t });
}
function jre(e) {
  const { chainId: n, maxPriorityFeePerGas: t, gasPrice: s, maxFeePerGas: a, to: o } = e;
  if (n <= 0)
    throw new gd({ chainId: n });
  if (o && !rn(o))
    throw new vn({ address: o });
  if (t || a)
    throw new ee("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
  if (s && s > ld)
    throw new Do({ maxFeePerGas: s });
}
function Cre(e) {
  const { chainId: n, maxPriorityFeePerGas: t, gasPrice: s, maxFeePerGas: a, to: o } = e;
  if (o && !rn(o))
    throw new vn({ address: o });
  if (typeof n < "u" && n <= 0)
    throw new gd({ chainId: n });
  if (t || a)
    throw new ee("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
  if (s && s > ld)
    throw new Do({ maxFeePerGas: s });
}
function MA(e) {
  if (e.type)
    return e.type;
  if (typeof e.authorizationList < "u")
    return "eip7702";
  if (typeof e.blobs < "u" || typeof e.blobVersionedHashes < "u" || typeof e.maxFeePerBlobGas < "u" || typeof e.sidecars < "u")
    return "eip4844";
  if (typeof e.maxFeePerGas < "u" || typeof e.maxPriorityFeePerGas < "u")
    return "eip1559";
  if (typeof e.gasPrice < "u")
    return typeof e.accessList < "u" ? "eip2930" : "legacy";
  throw new Roe({ transaction: e });
}
function ud(e) {
  if (!e || e.length === 0)
    return [];
  const n = [];
  for (let t = 0; t < e.length; t++) {
    const { address: s, storageKeys: a } = e[t];
    for (let o = 0; o < a.length; o++)
      if (a[o].length - 2 !== 64)
        throw new Ooe({ storageKey: a[o] });
    if (!rn(s, { strict: !1 }))
      throw new vn({ address: s });
    n.push([s, a]);
  }
  return n;
}
function Ere(e, n) {
  const t = MA(e);
  return t === "eip1559" ? Fre(e, n) : t === "eip2930" ? $re(e, n) : t === "eip4844" ? Bre(e, n) : t === "eip7702" ? Dre(e, n) : zre(e, n);
}
function Dre(e, n) {
  const { authorizationList: t, chainId: s, gas: a, nonce: o, to: i, value: d, maxFeePerGas: m, maxPriorityFeePerGas: h, accessList: p, data: _ } = e;
  kre(e);
  const y = ud(p), w = nre(t);
  return cc([
    "0x04",
    mo([
      te(s),
      o ? te(o) : "0x",
      h ? te(h) : "0x",
      m ? te(m) : "0x",
      a ? te(a) : "0x",
      i ?? "0x",
      d ? te(d) : "0x",
      _ ?? "0x",
      y,
      w,
      ...Uc(e, n)
    ])
  ]);
}
function Bre(e, n) {
  const { chainId: t, gas: s, nonce: a, to: o, value: i, maxFeePerBlobGas: d, maxFeePerGas: m, maxPriorityFeePerGas: h, accessList: p, data: _ } = e;
  Are(e);
  let y = e.blobVersionedHashes, w = e.sidecars;
  if (e.blobs && (typeof y > "u" || typeof w > "u")) {
    const b = typeof e.blobs[0] == "string" ? e.blobs : e.blobs.map((M) => lo(M)), O = e.kzg, D = hw({
      blobs: b,
      kzg: O
    });
    if (typeof y > "u" && (y = EA({
      commitments: D
    })), typeof w > "u") {
      const M = pw({ blobs: b, commitments: D, kzg: O });
      w = zA({ blobs: b, commitments: D, proofs: M });
    }
  }
  const q = ud(p), k = [
    te(t),
    a ? te(a) : "0x",
    h ? te(h) : "0x",
    m ? te(m) : "0x",
    s ? te(s) : "0x",
    o ?? "0x",
    i ? te(i) : "0x",
    _ ?? "0x",
    q,
    d ? te(d) : "0x",
    y ?? [],
    ...Uc(e, n)
  ], B = [], v = [], g = [];
  if (w)
    for (let b = 0; b < w.length; b++) {
      const { blob: O, commitment: D, proof: M } = w[b];
      B.push(O), v.push(D), g.push(M);
    }
  return cc([
    "0x03",
    // If sidecars are enabled, envelope turns into a "wrapper":
    mo(w ? [k, B, v, g] : k)
  ]);
}
function Fre(e, n) {
  const { chainId: t, gas: s, nonce: a, to: o, value: i, maxFeePerGas: d, maxPriorityFeePerGas: m, accessList: h, data: p } = e;
  vw(e);
  const _ = ud(h), y = [
    te(t),
    a ? te(a) : "0x",
    m ? te(m) : "0x",
    d ? te(d) : "0x",
    s ? te(s) : "0x",
    o ?? "0x",
    i ? te(i) : "0x",
    p ?? "0x",
    _,
    ...Uc(e, n)
  ];
  return cc([
    "0x02",
    mo(y)
  ]);
}
function $re(e, n) {
  const { chainId: t, gas: s, data: a, nonce: o, to: i, value: d, accessList: m, gasPrice: h } = e;
  jre(e);
  const p = ud(m), _ = [
    te(t),
    o ? te(o) : "0x",
    h ? te(h) : "0x",
    s ? te(s) : "0x",
    i ?? "0x",
    d ? te(d) : "0x",
    a ?? "0x",
    p,
    ...Uc(e, n)
  ];
  return cc([
    "0x01",
    mo(_)
  ]);
}
function zre(e, n) {
  const { chainId: t = 0, gas: s, data: a, nonce: o, to: i, value: d, gasPrice: m } = e;
  Cre(e);
  let h = [
    o ? te(o) : "0x",
    m ? te(m) : "0x",
    s ? te(s) : "0x",
    i ?? "0x",
    d ? te(d) : "0x",
    a ?? "0x"
  ];
  if (n) {
    const p = (() => {
      if (n.v >= 35n)
        return (n.v - 35n) / 2n > 0 ? n.v : 27n + (n.v === 35n ? 0n : 1n);
      if (t > 0)
        return BigInt(t * 2) + BigInt(35n + n.v - 27n);
      const w = 27n + (n.v === 27n ? 0n : 1n);
      if (n.v !== w)
        throw new Toe({ v: n.v });
      return w;
    })(), _ = Bc(n.r), y = Bc(n.s);
    h = [
      ...h,
      te(p),
      _ === "0x00" ? "0x" : _,
      y === "0x00" ? "0x" : y
    ];
  } else t > 0 && (h = [
    ...h,
    te(t),
    "0x",
    "0x"
  ]);
  return mo(h);
}
function Uc(e, n) {
  const t = n ?? e, { v: s, yParity: a } = t;
  if (typeof t.r > "u")
    return [];
  if (typeof t.s > "u")
    return [];
  if (typeof s > "u" && typeof a > "u")
    return [];
  const o = Bc(t.r), i = Bc(t.s);
  return [typeof a == "number" ? a ? te(1) : "0x" : s === 0n ? "0x" : s === 1n ? te(1) : s === 27n ? "0x" : te(1), o === "0x00" ? "0x" : o, i === "0x00" ? "0x" : i];
}
const qre = {
  gasPriceOracle: { address: "0x420000000000000000000000000000000000000F" },
  l1Block: { address: "0x4200000000000000000000000000000000000015" },
  l2CrossDomainMessenger: {
    address: "0x4200000000000000000000000000000000000007"
  },
  l2Erc721Bridge: { address: "0x4200000000000000000000000000000000000014" },
  l2StandardBridge: { address: "0x4200000000000000000000000000000000000010" },
  l2ToL1MessagePasser: {
    address: "0x4200000000000000000000000000000000000016"
  }
}, Sre = {
  block: /* @__PURE__ */ bA({
    format(e) {
      var t;
      return {
        transactions: (t = e.transactions) == null ? void 0 : t.map((s) => {
          if (typeof s == "string")
            return s;
          const a = bm(s);
          return a.typeHex === "0x7e" && (a.isSystemTx = s.isSystemTx, a.mint = s.mint ? yn(s.mint) : void 0, a.sourceHash = s.sourceHash, a.type = "deposit"), a;
        }),
        stateRoot: e.stateRoot
      };
    }
  }),
  transaction: /* @__PURE__ */ _A({
    format(e) {
      const n = {};
      return e.type === "0x7e" && (n.isSystemTx = e.isSystemTx, n.mint = e.mint ? yn(e.mint) : void 0, n.sourceHash = e.sourceHash, n.type = "deposit"), n;
    }
  }),
  transactionReceipt: /* @__PURE__ */ koe({
    format(e) {
      return {
        l1GasPrice: e.l1GasPrice ? yn(e.l1GasPrice) : null,
        l1GasUsed: e.l1GasUsed ? yn(e.l1GasUsed) : null,
        l1Fee: e.l1Fee ? yn(e.l1Fee) : null,
        l1FeeScalar: e.l1FeeScalar ? Number(e.l1FeeScalar) : null
      };
    }
  })
};
function IA(e, n) {
  return Ore(e) ? Rre(e) : Ere(e, n);
}
const Tre = {
  transaction: IA
};
function Rre(e) {
  Mre(e);
  const { sourceHash: n, data: t, from: s, gas: a, isSystemTx: o, mint: i, to: d, value: m } = e, h = [
    n,
    s,
    d ?? "0x",
    i ? te(i) : "0x",
    m ? te(m) : "0x",
    a ? te(a) : "0x",
    o ? "0x1" : "0x",
    t ?? "0x"
  ];
  return cc([
    "0x7e",
    mo(h)
  ]);
}
function Ore(e) {
  return e.type === "deposit" || typeof e.sourceHash < "u";
}
function Mre(e) {
  const { from: n, to: t } = e;
  if (n && !rn(n))
    throw new vn({ address: n });
  if (t && !rn(t))
    throw new vn({ address: t });
}
const Bo = {
  contracts: qre,
  formatters: Sre,
  serializers: Tre
}, z6 = /* @__PURE__ */ Fe({
  id: 42161,
  name: "Arbitrum One",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://arb1.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://arbiscan.io",
      apiUrl: "https://api.arbiscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7654707
    }
  }
}), q6 = /* @__PURE__ */ Fe({
  id: 421614,
  name: "Arbitrum Sepolia",
  nativeCurrency: {
    name: "Arbitrum Sepolia Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia-rollup.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://sepolia.arbiscan.io",
      apiUrl: "https://api-sepolia.arbiscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 81930
    }
  },
  testnet: !0
}), S6 = /* @__PURE__ */ Fe({
  id: 43114,
  name: "Avalanche",
  nativeCurrency: {
    decimals: 18,
    name: "Avalanche",
    symbol: "AVAX"
  },
  rpcUrls: {
    default: { http: ["https://api.avax.network/ext/bc/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "SnowTrace",
      url: "https://snowtrace.io",
      apiUrl: "https://api.snowtrace.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 11907934
    }
  }
}), T6 = /* @__PURE__ */ Fe({
  id: 43113,
  name: "Avalanche Fuji",
  nativeCurrency: {
    decimals: 18,
    name: "Avalanche Fuji",
    symbol: "AVAX"
  },
  rpcUrls: {
    default: { http: ["https://api.avax-test.network/ext/bc/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "SnowTrace",
      url: "https://testnet.snowtrace.io",
      apiUrl: "https://api-testnet.snowtrace.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7096959
    }
  },
  testnet: !0
}), Cd = 1, R6 = /* @__PURE__ */ Fe({
  ...Bo,
  id: 8453,
  name: "Base",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.base.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://basescan.org",
      apiUrl: "https://api.basescan.org/api"
    }
  },
  contracts: {
    ...Bo.contracts,
    l2OutputOracle: {
      [Cd]: {
        address: "0x56315b90c40730925ec5485cf004d835058518A0"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 5022
    },
    portal: {
      [Cd]: {
        address: "0x49048044D57e1C92A77f79988d21Fa8fAF74E97e",
        blockCreated: 17482143
      }
    },
    l1StandardBridge: {
      [Cd]: {
        address: "0x3154Cf16ccdb4C6d922629664174b904d80F2C35",
        blockCreated: 17482143
      }
    }
  },
  sourceId: Cd
}), Jc = 11155111, O6 = /* @__PURE__ */ Fe({
  ...Bo,
  id: 84532,
  network: "base-sepolia",
  name: "Base Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.base.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://sepolia.basescan.org",
      apiUrl: "https://api-sepolia.basescan.org/api"
    }
  },
  contracts: {
    ...Bo.contracts,
    disputeGameFactory: {
      [Jc]: {
        address: "0xd6E6dBf4F7EA0ac412fD8b65ED297e64BB7a06E1"
      }
    },
    l2OutputOracle: {
      [Jc]: {
        address: "0x84457ca9D0163FbC4bbfe4Dfbb20ba46e48DF254"
      }
    },
    portal: {
      [Jc]: {
        address: "0x49f53e41452c74589e85ca1677426ba426459e85",
        blockCreated: 4446677
      }
    },
    l1StandardBridge: {
      [Jc]: {
        address: "0xfd0Bf71F60660E2f608ed56e1659C450eB113120",
        blockCreated: 4446677
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1059647
    }
  },
  testnet: !0,
  sourceId: Jc
}), Ire = 1, M6 = /* @__PURE__ */ Fe({
  id: 81457,
  name: "Blast",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://rpc.blast.io"] }
  },
  blockExplorers: {
    default: {
      name: "Blastscan",
      url: "https://blastscan.io",
      apiUrl: "https://api.blastscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 212929
    }
  },
  sourceId: Ire
}), Nre = 11155111, I6 = /* @__PURE__ */ Fe({
  id: 168587773,
  name: "Blast Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia.blast.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blastscan",
      url: "https://sepolia.blastscan.io",
      apiUrl: "https://api-sepolia.blastscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 756690
    }
  },
  testnet: !0,
  sourceId: Nre
}), N6 = /* @__PURE__ */ Fe({
  id: 56,
  name: "BNB Smart Chain",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB"
  },
  rpcUrls: {
    default: { http: ["https://rpc.ankr.com/bsc"] }
  },
  blockExplorers: {
    default: {
      name: "BscScan",
      url: "https://bscscan.com",
      apiUrl: "https://api.bscscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 15921452
    }
  }
}), Pre = {
  /*
     * Estimates the fees per gas for a transaction.
  
     * If the transaction is to be paid in a token (feeCurrency is present) then the fees
     * are estimated in the value of the token. Otherwise falls back to the default
     * estimation by returning null.
     *
     * @param params fee estimation function parameters
     */
  estimateFeesPerGas: async (e) => {
    var s;
    if (!((s = e.request) != null && s.feeCurrency))
      return null;
    const [n, t] = await Promise.all([
      Ure(e.client, e.request.feeCurrency),
      Hre(e.client, e.request.feeCurrency)
    ]);
    return {
      maxFeePerGas: n,
      maxPriorityFeePerGas: t
    };
  }
};
async function Ure(e, n) {
  const t = await e.request({
    method: "eth_gasPrice",
    params: [n]
  });
  return BigInt(t);
}
async function Hre(e, n) {
  const t = await e.request({
    method: "eth_maxPriorityFeePerGas",
    params: [n]
  });
  return BigInt(t);
}
function NA(e) {
  return e === 0 || e === 0n || e === void 0 || e === null || e === "0" || e === "" || typeof e == "string" && (Bc(e).toLowerCase() === "0x" || Bc(e).toLowerCase() === "0x00");
}
function id(e) {
  return !NA(e);
}
function Lre(e) {
  return typeof e.maxFeePerGas < "u" && typeof e.maxPriorityFeePerGas < "u";
}
function PA(e) {
  return e.type === "cip64" ? !0 : Lre(e) && id(e.feeCurrency);
}
const Wre = {
  block: /* @__PURE__ */ bA({
    format(e) {
      var t;
      return {
        transactions: (t = e.transactions) == null ? void 0 : t.map((s) => typeof s == "string" ? s : {
          ...bm(s),
          ...s.gatewayFee ? {
            gatewayFee: yn(s.gatewayFee),
            gatewayFeeRecipient: s.gatewayFeeRecipient
          } : {},
          feeCurrency: s.feeCurrency
        }),
        ...e.randomness ? { randomness: e.randomness } : {}
      };
    }
  }),
  transaction: /* @__PURE__ */ _A({
    format(e) {
      if (e.type === "0x7e")
        return {
          isSystemTx: e.isSystemTx,
          mint: e.mint ? yn(e.mint) : void 0,
          sourceHash: e.sourceHash,
          type: "deposit"
        };
      const n = { feeCurrency: e.feeCurrency };
      return e.type === "0x7b" ? n.type = "cip64" : (e.type === "0x7c" && (n.type = "cip42"), n.gatewayFee = e.gatewayFee ? yn(e.gatewayFee) : null, n.gatewayFeeRecipient = e.gatewayFeeRecipient), n;
    }
  }),
  transactionRequest: /* @__PURE__ */ joe({
    format(e) {
      const n = {};
      return e.feeCurrency && (n.feeCurrency = e.feeCurrency), PA(e) && (n.type = "0x7b"), n;
    }
  })
};
function Vre(e, n) {
  return PA(e) ? Kre(e, n) : IA(e, n);
}
const Gre = {
  transaction: Vre
};
function Kre(e, n) {
  Yre(e);
  const { chainId: t, gas: s, nonce: a, to: o, value: i, maxFeePerGas: d, maxPriorityFeePerGas: m, accessList: h, feeCurrency: p, data: _ } = e, y = [
    te(t),
    a ? te(a) : "0x",
    m ? te(m) : "0x",
    d ? te(d) : "0x",
    s ? te(s) : "0x",
    o ?? "0x",
    i ? te(i) : "0x",
    _ ?? "0x",
    ud(h),
    p,
    ...Uc(e, n)
  ];
  return cc([
    "0x7b",
    mo(y)
  ]);
}
const Xre = ld;
function Yre(e) {
  const { chainId: n, maxPriorityFeePerGas: t, gasPrice: s, maxFeePerGas: a, to: o, feeCurrency: i } = e;
  if (n <= 0)
    throw new gd({ chainId: n });
  if (o && !rn(o))
    throw new vn({ address: o });
  if (s)
    throw new ee("`gasPrice` is not a valid CIP-64 Transaction attribute.");
  if (id(a) && a > Xre)
    throw new Do({ maxFeePerGas: a });
  if (id(t) && id(a) && t > a)
    throw new Fc({ maxFeePerGas: a, maxPriorityFeePerGas: t });
  if (id(i) && !rn(i))
    throw new ee("`feeCurrency` MUST be a token address for CIP-64 transactions.");
  if (NA(i))
    throw new ee("`feeCurrency` must be provided for CIP-64 transactions.");
}
const Jre = {
  formatters: Wre,
  serializers: Gre,
  fees: Pre
}, P6 = /* @__PURE__ */ Fe({
  ...Jre,
  id: 42220,
  name: "Celo",
  nativeCurrency: {
    decimals: 18,
    name: "CELO",
    symbol: "CELO"
  },
  rpcUrls: {
    default: { http: ["https://forno.celo.org"] }
  },
  blockExplorers: {
    default: {
      name: "Celo Explorer",
      url: "https://celoscan.io",
      apiUrl: "https://api.celoscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 13112599
    }
  },
  testnet: !1
}), U6 = /* @__PURE__ */ Fe({
  id: 250,
  name: "Fantom",
  nativeCurrency: {
    decimals: 18,
    name: "Fantom",
    symbol: "FTM"
  },
  rpcUrls: {
    default: { http: ["https://rpc.ankr.com/fantom"] }
  },
  blockExplorers: {
    default: {
      name: "FTMScan",
      url: "https://ftmscan.com",
      apiUrl: "https://api.ftmscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 33001987
    }
  }
}), H6 = /* @__PURE__ */ Fe({
  id: 314,
  name: "Filecoin Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "filecoin",
    symbol: "FIL"
  },
  rpcUrls: {
    default: { http: ["https://api.node.glif.io/rpc/v1"] }
  },
  blockExplorers: {
    default: {
      name: "Filfox",
      url: "https://filfox.info/en"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3328594
    }
  }
}), L6 = /* @__PURE__ */ Fe({
  id: 2222,
  name: "Kava EVM",
  network: "kava-mainnet",
  nativeCurrency: {
    name: "Kava",
    symbol: "KAVA",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://evm.kava.io"] }
  },
  blockExplorers: {
    default: {
      name: "Kava EVM Explorer",
      url: "https://kavascan.com",
      apiUrl: "https://kavascan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 3661165
    }
  },
  testnet: !1
});
function Hc(e) {
  return typeof e == "string" ? { address: e, type: "json-rpc" } : e;
}
class Zre extends ee {
  constructor() {
    super("`baseFeeMultiplier` must be greater than 1.", {
      name: "BaseFeeScalarError"
    });
  }
}
class fw extends ee {
  constructor() {
    super("Chain does not support EIP-1559 fees.", {
      name: "Eip1559FeesNotSupportedError"
    });
  }
}
class Qre extends ee {
  constructor({ maxPriorityFeePerGas: n }) {
    super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${An(n)} gwei).`, { name: "MaxFeePerGasTooLowError" });
  }
}
function ro(e, n, t) {
  const s = e[n.name];
  if (typeof s == "function")
    return s;
  const a = e[t];
  return typeof a == "function" ? a : (o) => n(e, o);
}
class eie extends ee {
  constructor({ blockHash: n, blockNumber: t }) {
    let s = "Block";
    n && (s = `Block at hash "${n}"`), t && (s = `Block at number "${t}"`), super(`${s} could not be found.`, { name: "BlockNotFoundError" });
  }
}
async function Xd(e, { blockHash: n, blockNumber: t, blockTag: s, includeTransactions: a } = {}) {
  var p, _, y;
  const o = s ?? "latest", i = a ?? !1, d = t !== void 0 ? Be(t) : void 0;
  let m = null;
  if (n ? m = await e.request({
    method: "eth_getBlockByHash",
    params: [n, i]
  }, { dedupe: !0 }) : m = await e.request({
    method: "eth_getBlockByNumber",
    params: [d || o, i]
  }, { dedupe: !!d }), !m)
    throw new eie({ blockHash: n, blockNumber: t });
  return (((y = (_ = (p = e.chain) == null ? void 0 : p.formatters) == null ? void 0 : _.block) == null ? void 0 : y.format) || yA)(m);
}
async function UA(e) {
  const n = await e.request({
    method: "eth_gasPrice"
  });
  return BigInt(n);
}
async function nie(e, n) {
  var o, i;
  const { block: t, chain: s = e.chain, request: a } = n || {};
  try {
    const d = ((o = s == null ? void 0 : s.fees) == null ? void 0 : o.maxPriorityFeePerGas) ?? ((i = s == null ? void 0 : s.fees) == null ? void 0 : i.defaultPriorityFee);
    if (typeof d == "function") {
      const h = t || await ro(e, Xd, "getBlock")({}), p = await d({
        block: h,
        client: e,
        request: a
      });
      if (p === null)
        throw new Error();
      return p;
    }
    if (typeof d < "u")
      return d;
    const m = await e.request({
      method: "eth_maxPriorityFeePerGas"
    });
    return yn(m);
  } catch {
    const [d, m] = await Promise.all([
      t ? Promise.resolve(t) : ro(e, Xd, "getBlock")({}),
      ro(e, UA, "getGasPrice")({})
    ]);
    if (typeof d.baseFeePerGas != "bigint")
      throw new fw();
    const h = m - d.baseFeePerGas;
    return h < 0n ? 0n : h;
  }
}
async function W6(e, n) {
  var y, w;
  const { block: t, chain: s = e.chain, request: a, type: o = "eip1559" } = n || {}, i = await (async () => {
    var q, k;
    return typeof ((q = s == null ? void 0 : s.fees) == null ? void 0 : q.baseFeeMultiplier) == "function" ? s.fees.baseFeeMultiplier({
      block: t,
      client: e,
      request: a
    }) : ((k = s == null ? void 0 : s.fees) == null ? void 0 : k.baseFeeMultiplier) ?? 1.2;
  })();
  if (i < 1)
    throw new Zre();
  const m = 10 ** (((y = i.toString().split(".")[1]) == null ? void 0 : y.length) ?? 0), h = (q) => q * BigInt(Math.ceil(i * m)) / BigInt(m), p = t || await ro(e, Xd, "getBlock")({});
  if (typeof ((w = s == null ? void 0 : s.fees) == null ? void 0 : w.estimateFeesPerGas) == "function") {
    const q = await s.fees.estimateFeesPerGas({
      block: t,
      client: e,
      multiply: h,
      request: a,
      type: o
    });
    if (q !== null)
      return q;
  }
  if (o === "eip1559") {
    if (typeof p.baseFeePerGas != "bigint")
      throw new fw();
    const q = typeof (a == null ? void 0 : a.maxPriorityFeePerGas) == "bigint" ? a.maxPriorityFeePerGas : await nie(e, {
      block: p,
      chain: s,
      request: a
    }), k = h(p.baseFeePerGas);
    return {
      maxFeePerGas: (a == null ? void 0 : a.maxFeePerGas) ?? k + q,
      maxPriorityFeePerGas: q
    };
  }
  return {
    gasPrice: (a == null ? void 0 : a.gasPrice) ?? h(await ro(e, UA, "getGasPrice")({}))
  };
}
function tie(e) {
  const n = yw(`0x${e.substring(4)}`).substring(26);
  return bw(`0x${n}`);
}
async function sie({ hash: e, signature: n }) {
  const t = qr(e) ? e : te(e), { secp256k1: s } = await import("./secp256k1-mPx8MhOc.js");
  return `0x${(() => {
    if (typeof n == "object" && "r" in n && "s" in n) {
      const { r: h, s: p, v: _, yParity: y } = n, w = Number(y ?? _), q = V6(w);
      return new s.Signature(yn(h), yn(p)).addRecoveryBit(q);
    }
    const i = qr(n) ? n : te(n), d = Sr(`0x${i.slice(130)}`), m = V6(d);
    return s.Signature.fromCompact(i.substring(2, 130)).addRecoveryBit(m);
  })().recoverPublicKey(t.substring(2)).toHex(!1)}`;
}
function V6(e) {
  if (e === 0 || e === 1)
    return e;
  if (e === 27)
    return 0;
  if (e === 28)
    return 1;
  throw new Error("Invalid yParityOrV value");
}
async function aie({ hash: e, signature: n }) {
  return tie(await sie({ hash: e, signature: n }));
}
function oie(e) {
  const { chainId: n, contractAddress: t, nonce: s, to: a } = e, o = yw(cc([
    "0x05",
    mo([
      Be(n),
      t,
      s ? Be(s) : "0x"
    ])
  ]));
  return a === "bytes" ? Eo(o) : o;
}
async function rie(e) {
  const { authorization: n, signature: t } = e;
  return aie({
    hash: oie(n),
    signature: t ?? n
  });
}
class iie extends ee {
  constructor(n, { account: t, docsPath: s, chain: a, data: o, gas: i, gasPrice: d, maxFeePerGas: m, maxPriorityFeePerGas: h, nonce: p, to: _, value: y }) {
    var q;
    const w = mw({
      from: t == null ? void 0 : t.address,
      to: _,
      value: typeof y < "u" && `${kA(y)} ${((q = a == null ? void 0 : a.nativeCurrency) == null ? void 0 : q.symbol) || "ETH"}`,
      data: o,
      gas: i,
      gasPrice: typeof d < "u" && `${An(d)} gwei`,
      maxFeePerGas: typeof m < "u" && `${An(m)} gwei`,
      maxPriorityFeePerGas: typeof h < "u" && `${An(h)} gwei`,
      nonce: p
    });
    super(n.shortMessage, {
      cause: n,
      docsPath: s,
      metaMessages: [
        ...n.metaMessages ? [...n.metaMessages, " "] : [],
        "Estimate Gas Arguments:",
        w
      ].filter(Boolean),
      name: "EstimateGasExecutionError"
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.cause = n;
  }
}
function HA(e, n) {
  const t = (e.details || "").toLowerCase(), s = e instanceof ee ? e.walk((a) => (a == null ? void 0 : a.code) === bc.code) : e;
  return s instanceof ee ? new bc({
    cause: e,
    message: s.details
  }) : bc.nodeMessage.test(t) ? new bc({
    cause: e,
    message: e.details
  }) : Do.nodeMessage.test(t) ? new Do({
    cause: e,
    maxFeePerGas: n == null ? void 0 : n.maxFeePerGas
  }) : mh.nodeMessage.test(t) ? new mh({
    cause: e,
    maxFeePerGas: n == null ? void 0 : n.maxFeePerGas
  }) : hh.nodeMessage.test(t) ? new hh({ cause: e, nonce: n == null ? void 0 : n.nonce }) : ph.nodeMessage.test(t) ? new ph({ cause: e, nonce: n == null ? void 0 : n.nonce }) : lh.nodeMessage.test(t) ? new lh({ cause: e, nonce: n == null ? void 0 : n.nonce }) : gh.nodeMessage.test(t) ? new gh({ cause: e }) : uh.nodeMessage.test(t) ? new uh({ cause: e, gas: n == null ? void 0 : n.gas }) : _h.nodeMessage.test(t) ? new _h({ cause: e, gas: n == null ? void 0 : n.gas }) : yh.nodeMessage.test(t) ? new yh({ cause: e }) : Fc.nodeMessage.test(t) ? new Fc({
    cause: e,
    maxFeePerGas: n == null ? void 0 : n.maxFeePerGas,
    maxPriorityFeePerGas: n == null ? void 0 : n.maxPriorityFeePerGas
  }) : new uw({
    cause: e
  });
}
function cie(e, { docsPath: n, ...t }) {
  const s = (() => {
    const a = HA(e, t);
    return a instanceof uw ? e : a;
  })();
  return new iie(s, {
    docsPath: n,
    ...t
  });
}
function LA(e, { format: n }) {
  if (!n)
    return {};
  const t = {};
  function s(o) {
    const i = Object.keys(o);
    for (const d of i)
      d in e && (t[d] = e[d]), o[d] && typeof o[d] == "object" && !Array.isArray(o[d]) && s(o[d]);
  }
  const a = n(e || {});
  return s(a), t;
}
class die extends ee {
  constructor({ address: n }) {
    super(`State for account "${n}" is set multiple times.`, {
      name: "AccountStateConflictError"
    });
  }
}
class mie extends ee {
  constructor() {
    super("state and stateDiff are set on the same account.", {
      name: "StateAssignmentConflictError"
    });
  }
}
function G6(e) {
  return e.reduce((n, { slot: t, value: s }) => `${n}        ${t}: ${s}
`, "");
}
function hie(e) {
  return e.reduce((n, { address: t, ...s }) => {
    let a = `${n}    ${t}:
`;
    return s.nonce && (a += `      nonce: ${s.nonce}
`), s.balance && (a += `      balance: ${s.balance}
`), s.code && (a += `      code: ${s.code}
`), s.state && (a += `      state:
`, a += G6(s.state)), s.stateDiff && (a += `      stateDiff:
`, a += G6(s.stateDiff)), a;
  }, `  State Override:
`).slice(0, -1);
}
function K6(e) {
  if (!(!e || e.length === 0))
    return e.reduce((n, { slot: t, value: s }) => {
      if (t.length !== 66)
        throw new x6({
          size: t.length,
          targetSize: 66,
          type: "hex"
        });
      if (s.length !== 66)
        throw new x6({
          size: s.length,
          targetSize: 66,
          type: "hex"
        });
      return n[t] = s, n;
    }, {});
}
function pie(e) {
  const { balance: n, nonce: t, state: s, stateDiff: a, code: o } = e, i = {};
  if (o !== void 0 && (i.code = o), n !== void 0 && (i.balance = Be(n)), t !== void 0 && (i.nonce = Be(t)), s !== void 0 && (i.state = K6(s)), a !== void 0) {
    if (i.state)
      throw new mie();
    i.stateDiff = K6(a);
  }
  return i;
}
function lie(e) {
  if (!e)
    return;
  const n = {};
  for (const { address: t, ...s } of e) {
    if (!rn(t, { strict: !1 }))
      throw new vn({ address: t });
    if (n[t])
      throw new die({ address: t });
    n[t] = pie(s);
  }
  return n;
}
function ww(e) {
  const { account: n, gasPrice: t, maxFeePerGas: s, maxPriorityFeePerGas: a, to: o } = e, i = n ? Hc(n) : void 0;
  if (i && !rn(i.address))
    throw new vn({ address: i.address });
  if (o && !rn(o))
    throw new vn({ address: o });
  if (typeof t < "u" && (typeof s < "u" || typeof a < "u"))
    throw new Soe();
  if (s && s > ld)
    throw new Do({ maxFeePerGas: s });
  if (a && s && a > s)
    throw new Fc({ maxFeePerGas: s, maxPriorityFeePerGas: a });
}
async function gie(e, { address: n, blockNumber: t, blockTag: s = "latest" }) {
  const a = t ? Be(t) : void 0, o = await e.request({
    method: "eth_getBalance",
    params: [n, a || s]
  });
  return BigInt(o);
}
async function uie(e, n) {
  var a, o, i;
  const t = n.account ?? e.account, s = t ? Hc(t) : void 0;
  try {
    let F = function(E) {
      const { block: T, request: R, rpcStateOverride: P } = E;
      return e.request({
        method: "eth_estimateGas",
        params: P ? [R, T ?? "latest", P] : T ? [R, T] : [R]
      });
    };
    const { accessList: d, authorizationList: m, blobs: h, blobVersionedHashes: p, blockNumber: _, blockTag: y, data: w, gas: q, gasPrice: k, maxFeePerBlobGas: B, maxFeePerGas: v, maxPriorityFeePerGas: g, nonce: b, value: O, stateOverride: D, ...M } = await WA(e, {
      ...n,
      parameters: (
        // Some RPC Providers do not compute versioned hashes from blobs. We will need
        // to compute them.
        (s == null ? void 0 : s.type) === "local" ? void 0 : ["blobVersionedHashes"]
      )
    }), l = (_ ? Be(_) : void 0) || y, u = lie(D), f = await (async () => {
      if (M.to)
        return M.to;
      if (m && m.length > 0)
        return await rie({
          authorization: m[0]
        }).catch(() => {
          throw new ee("`to` is required. Could not infer from `authorizationList`");
        });
    })();
    ww(n);
    const S = (i = (o = (a = e.chain) == null ? void 0 : a.formatters) == null ? void 0 : o.transactionRequest) == null ? void 0 : i.format, C = (S || dw)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...LA(M, { format: S }),
      from: s == null ? void 0 : s.address,
      accessList: d,
      authorizationList: m,
      blobs: h,
      blobVersionedHashes: p,
      data: w,
      gas: q,
      gasPrice: k,
      maxFeePerBlobGas: B,
      maxFeePerGas: v,
      maxPriorityFeePerGas: g,
      nonce: b,
      to: f,
      value: O
    });
    let A = BigInt(await F({ block: l, request: C, rpcStateOverride: u }));
    if (m) {
      const E = await gie(e, { address: C.from }), T = await Promise.all(m.map(async (R) => {
        const { contractAddress: P } = R, V = await F({
          block: l,
          request: {
            authorizationList: void 0,
            data: w,
            from: s == null ? void 0 : s.address,
            to: P,
            value: Be(E)
          },
          rpcStateOverride: u
        }).catch(() => 100000n);
        return 2n * BigInt(V);
      }));
      A += T.reduce((R, P) => R + P, 0n);
    }
    return A;
  } catch (d) {
    throw cie(d, {
      ...n,
      account: s,
      chain: e.chain
    });
  }
}
async function _ie(e, { address: n, blockTag: t = "latest", blockNumber: s }) {
  const a = await e.request({
    method: "eth_getTransactionCount",
    params: [n, s ? Be(s) : t]
  }, { dedupe: !!s });
  return Sr(a);
}
async function yie(e) {
  const n = await e.request({
    method: "eth_chainId"
  }, { dedupe: !0 });
  return Sr(n);
}
const bie = [
  "blobVersionedHashes",
  "chainId",
  "fees",
  "gas",
  "nonce",
  "type"
];
async function WA(e, n) {
  const { account: t = e.account, blobs: s, chain: a, gas: o, kzg: i, nonce: d, nonceManager: m, parameters: h = bie, type: p } = n, _ = t ? Hc(t) : void 0, y = { ...n, ..._ ? { from: _ == null ? void 0 : _.address } : {} };
  let w;
  async function q() {
    return w || (w = await ro(e, Xd, "getBlock")({ blockTag: "latest" }), w);
  }
  let k;
  async function B() {
    return k || (a ? a.id : typeof n.chainId < "u" ? n.chainId : (k = await ro(e, yie, "getChainId")({}), k));
  }
  if ((h.includes("blobVersionedHashes") || h.includes("sidecars")) && s && i) {
    const v = hw({ blobs: s, kzg: i });
    if (h.includes("blobVersionedHashes")) {
      const g = EA({
        commitments: v,
        to: "hex"
      });
      y.blobVersionedHashes = g;
    }
    if (h.includes("sidecars")) {
      const g = pw({ blobs: s, commitments: v, kzg: i }), b = zA({
        blobs: s,
        commitments: v,
        proofs: g,
        to: "hex"
      });
      y.sidecars = b;
    }
  }
  if (h.includes("chainId") && (y.chainId = await B()), h.includes("nonce") && typeof d > "u" && _)
    if (m) {
      const v = await B();
      y.nonce = await m.consume({
        address: _.address,
        chainId: v,
        client: e
      });
    } else
      y.nonce = await ro(e, _ie, "getTransactionCount")({
        address: _.address,
        blockTag: "pending"
      });
  if ((h.includes("fees") || h.includes("type")) && typeof p > "u")
    try {
      y.type = MA(y);
    } catch {
      const v = await q();
      y.type = typeof (v == null ? void 0 : v.baseFeePerGas) == "bigint" ? "eip1559" : "legacy";
    }
  if (h.includes("fees"))
    if (y.type !== "legacy" && y.type !== "eip2930") {
      if (typeof y.maxFeePerGas > "u" || typeof y.maxPriorityFeePerGas > "u") {
        const v = await q(), { maxFeePerGas: g, maxPriorityFeePerGas: b } = await W6(e, {
          block: v,
          chain: a,
          request: y
        });
        if (typeof n.maxPriorityFeePerGas > "u" && n.maxFeePerGas && n.maxFeePerGas < b)
          throw new Qre({
            maxPriorityFeePerGas: b
          });
        y.maxPriorityFeePerGas = b, y.maxFeePerGas = g;
      }
    } else {
      if (typeof n.maxFeePerGas < "u" || typeof n.maxPriorityFeePerGas < "u")
        throw new fw();
      const v = await q(), { gasPrice: g } = await W6(e, {
        block: v,
        chain: a,
        request: y,
        type: "legacy"
      });
      y.gasPrice = g;
    }
  return h.includes("gas") && typeof o > "u" && (y.gas = await ro(e, uie, "estimateGas")({
    ...y,
    account: _ ? { address: _.address, type: "json-rpc" } : void 0
  })), ww(y), delete y.parameters, y;
}
class vie extends ee {
  constructor({ docsPath: n } = {}) {
    super([
      "Could not find an Account to execute with this Action.",
      "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the Client."
    ].join(`
`), {
      docsPath: n,
      docsSlug: "account",
      name: "AccountNotFoundError"
    });
  }
}
class fie extends ee {
  constructor(n, { account: t, docsPath: s, chain: a, data: o, gas: i, gasPrice: d, maxFeePerGas: m, maxPriorityFeePerGas: h, nonce: p, to: _, value: y, stateOverride: w }) {
    var B;
    const q = t ? Hc(t) : void 0;
    let k = mw({
      from: q == null ? void 0 : q.address,
      to: _,
      value: typeof y < "u" && `${kA(y)} ${((B = a == null ? void 0 : a.nativeCurrency) == null ? void 0 : B.symbol) || "ETH"}`,
      data: o,
      gas: i,
      gasPrice: typeof d < "u" && `${An(d)} gwei`,
      maxFeePerGas: typeof m < "u" && `${An(m)} gwei`,
      maxPriorityFeePerGas: typeof h < "u" && `${An(h)} gwei`,
      nonce: p
    });
    w && (k += `
${hie(w)}`), super(n.shortMessage, {
      cause: n,
      docsPath: s,
      metaMessages: [
        ...n.metaMessages ? [...n.metaMessages, " "] : [],
        "Raw Call Arguments:",
        k
      ].filter(Boolean),
      name: "CallExecutionError"
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.cause = n;
  }
}
function wie(e, { docsPath: n, ...t }) {
  const s = (() => {
    const a = HA(e, t);
    return a instanceof uw ? e : a;
  })();
  return new fie(s, {
    docsPath: n,
    ...t
  });
}
async function xie(e, n) {
  var a, o, i;
  const { account: t = e.account } = n;
  if (!t)
    throw new vie();
  const s = Hc(t);
  try {
    const { accessList: d, blockNumber: m, blockTag: h, data: p, gas: _, gasPrice: y, maxFeePerGas: w, maxPriorityFeePerGas: q, nonce: k, to: B, value: v, ...g } = (s == null ? void 0 : s.type) === "local" ? await WA(e, n) : n, O = (m ? Be(m) : void 0) || h;
    ww(n);
    const D = (i = (o = (a = e.chain) == null ? void 0 : a.formatters) == null ? void 0 : o.transactionRequest) == null ? void 0 : i.format, N = (D || dw)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...LA(g, { format: D }),
      from: s == null ? void 0 : s.address,
      accessList: d,
      data: p,
      gas: _,
      gasPrice: y,
      maxFeePerGas: w,
      maxPriorityFeePerGas: q,
      nonce: k,
      to: B,
      value: v
    }), { baseFeePerGas: l, gasLimit: u, priorityFeePerGas: f } = await e.request({
      method: "linea_estimateGas",
      params: O ? [N, O] : [N]
    });
    return {
      baseFeePerGas: BigInt(l),
      gasLimit: BigInt(u),
      priorityFeePerGas: BigInt(f)
    };
  } catch (d) {
    throw wie(d, {
      ...n,
      account: s,
      chain: e.chain
    });
  }
}
const kie = {
  fees: {
    estimateFeesPerGas: X6,
    async maxPriorityFeePerGas({ block: e, client: n, request: t }) {
      const s = await X6({
        block: e,
        client: n,
        multiply: (a) => a,
        request: t,
        type: "eip1559"
      });
      return s != null && s.maxPriorityFeePerGas ? s.maxPriorityFeePerGas : null;
    }
  }
};
async function X6({ client: e, multiply: n, request: t, type: s }) {
  try {
    const a = await xie(e, {
      ...t,
      account: t == null ? void 0 : t.account
    }), { priorityFeePerGas: o } = a, d = n(BigInt(a.baseFeePerGas)) + o;
    return s === "legacy" ? { gasPrice: d } : {
      maxFeePerGas: d,
      maxPriorityFeePerGas: o
    };
  } catch {
    return null;
  }
}
const Y6 = /* @__PURE__ */ Fe({
  ...kie,
  id: 59144,
  name: "Linea Mainnet",
  nativeCurrency: { name: "Linea Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.linea.build"],
      webSocket: ["wss://rpc.linea.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://lineascan.build",
      apiUrl: "https://api.lineascan.build/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 42
    }
  },
  testnet: !1
}), J6 = /* @__PURE__ */ Fe({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://cloudflare-eth.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), Z6 = /* @__PURE__ */ Fe({
  id: 169,
  name: "Manta Pacific Mainnet",
  network: "manta",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://pacific-rpc.manta.network/http"] }
  },
  blockExplorers: {
    default: {
      name: "Manta Explorer",
      url: "https://pacific-explorer.manta.network",
      apiUrl: "https://pacific-explorer.manta.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 332890
    }
  }
}), Q6 = /* @__PURE__ */ Fe({
  id: 1284,
  name: "Moonbeam",
  nativeCurrency: {
    decimals: 18,
    name: "GLMR",
    symbol: "GLMR"
  },
  rpcUrls: {
    default: {
      http: ["https://moonbeam.public.blastapi.io"],
      webSocket: ["wss://moonbeam.public.blastapi.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Moonscan",
      url: "https://moonscan.io",
      apiUrl: "https://api-moonbeam.moonscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 609002
    }
  },
  testnet: !1
}), Zc = 1, e8 = /* @__PURE__ */ Fe({
  ...Bo,
  id: 10,
  name: "OP Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.optimism.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Optimism Explorer",
      url: "https://optimistic.etherscan.io",
      apiUrl: "https://api-optimistic.etherscan.io/api"
    }
  },
  contracts: {
    ...Bo.contracts,
    disputeGameFactory: {
      [Zc]: {
        address: "0xe5965Ab5962eDc7477C8520243A95517CD252fA9"
      }
    },
    l2OutputOracle: {
      [Zc]: {
        address: "0xdfe97868233d1aa22e815a266982f2cf17685a27"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 4286263
    },
    portal: {
      [Zc]: {
        address: "0xbEb5Fc579115071764c7423A4f12eDde41f106Ed"
      }
    },
    l1StandardBridge: {
      [Zc]: {
        address: "0x99C9fc46f92E8a1c0deC1b1747d010903E884bE1"
      }
    }
  },
  sourceId: Zc
}), Qc = 11155111, n8 = /* @__PURE__ */ Fe({
  ...Bo,
  id: 11155420,
  name: "OP Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.optimism.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://optimism-sepolia.blockscout.com",
      apiUrl: "https://optimism-sepolia.blockscout.com/api"
    }
  },
  contracts: {
    ...Bo.contracts,
    disputeGameFactory: {
      [Qc]: {
        address: "0x05F9613aDB30026FFd634f38e5C4dFd30a197Fa1"
      }
    },
    l2OutputOracle: {
      [Qc]: {
        address: "0x90E9c4f8a994a250F6aEfd61CAFb4F2e895D458F"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1620204
    },
    portal: {
      [Qc]: {
        address: "0x16Fc5058F25648194471939df75CF27A2fdC48BC"
      }
    },
    l1StandardBridge: {
      [Qc]: {
        address: "0xFBb0621E0B23b5478B630BD55a5f21f67730B0F1"
      }
    }
  },
  testnet: !0,
  sourceId: Qc
}), t8 = /* @__PURE__ */ Fe({
  id: 137,
  name: "Polygon",
  nativeCurrency: { name: "POL", symbol: "POL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://polygon-rpc.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://polygonscan.com",
      apiUrl: "https://api.polygonscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  }
}), s8 = /* @__PURE__ */ Fe({
  id: 80001,
  name: "Polygon Mumbai",
  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.ankr.com/polygon_mumbai"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://mumbai.polygonscan.com",
      apiUrl: "https://api-testnet.polygonscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  },
  testnet: !0
}), Yd = /* @__PURE__ */ Fe({
  id: 1329,
  name: "Sei Network",
  nativeCurrency: { name: "Sei", symbol: "SEI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evm-rpc.sei-apis.com/"],
      webSocket: ["wss://evm-ws.sei-apis.com/"]
    }
  },
  blockExplorers: {
    default: {
      name: "Seitrace",
      url: "https://seitrace.com",
      apiUrl: "https://seitrace.com/pacific-1/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}), a8 = /* @__PURE__ */ Fe({
  id: 11155111,
  name: "Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc2.sepolia.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://sepolia.etherscan.io",
      apiUrl: "https://api-sepolia.etherscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 751532
    },
    ensRegistry: { address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e" },
    ensUniversalResolver: {
      address: "0xc8Af999e38273D658BE1b921b88A9Ddf005769cC",
      blockCreated: 5317080
    }
  },
  testnet: !0
}), o8 = q8({
  id: 984122,
  name: "Forma",
  nativeCurrency: {
    name: "TIA",
    symbol: "TIA",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.forma.art"]
    }
  },
  blockExplorers: {
    default: {
      name: "Forma Explorer",
      url: "https://explorer.forma.art"
    }
  },
  contracts: {
    multicall3: {
      address: "0xd53C6FFB123F7349A32980F87faeD8FfDc9ef079",
      blockCreated: 252705
    }
  },
  testnet: !1
}), r8 = q8({
  id: 984123,
  name: "Forma Testnet",
  nativeCurrency: {
    name: "TIA",
    symbol: "TIA",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.sketchpad-1.forma.art"]
    }
  },
  blockExplorers: {
    default: {
      name: "Forma Explorer",
      url: "https://explorer.sketchpad-1.forma.art"
    }
  },
  testnet: !0
}), VA = lD({
  chains: [
    z6,
    S6,
    R6,
    N6,
    P6,
    U6,
    H6,
    L6,
    Y6,
    J6,
    Z6,
    Q6,
    e8,
    t8,
    s8,
    a8,
    T6,
    O6,
    n8,
    q6,
    M6,
    I6,
    o8,
    r8,
    Yd
  ],
  transports: {
    [z6.id]: xe(),
    [S6.id]: xe(),
    [R6.id]: xe(),
    [N6.id]: xe(),
    [P6.id]: xe(),
    [U6.id]: xe(),
    [H6.id]: xe(),
    [L6.id]: xe(),
    [Y6.id]: xe(),
    [J6.id]: xe(),
    [Z6.id]: xe(),
    [Q6.id]: xe(),
    [e8.id]: xe(),
    [t8.id]: xe(),
    [s8.id]: xe(),
    [a8.id]: xe(),
    [T6.id]: xe(),
    [O6.id]: xe(),
    [n8.id]: xe(),
    [q6.id]: xe(),
    [M6.id]: xe(),
    [I6.id]: xe(),
    [o8.id]: xe(),
    [r8.id]: xe(),
    [Yd.id]: xe()
  },
  ssr: !1
}), Aie = ({
  children: e,
  wagmiConfig: n
}) => /* @__PURE__ */ c.jsx(
  gD,
  {
    config: n || VA,
    reconnectOnMount: !0,
    children: e
  },
  "skip-widget-wagmi-provider"
), jie = ({ children: e }) => /* @__PURE__ */ c.jsx(roe, { children: /* @__PURE__ */ c.jsx(Aie, { children: e }) }), Cie = "data:font/woff2;base64,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", Eie = `
  @font-face {
    font-family: ABCDiatype;
    src: url(${Cie}) format(woff2);
  }
`, Die = () => {
  on(() => {
    const e = document.createElement("style");
    return e.textContent = Eie, document.head.contains(e) || document.head.appendChild(e), () => {
      document.head.removeChild(e);
    };
  }, []);
}, Bie = new tD(), Fie = UB`
  * {
    font-family: 'ABCDiatype', sans-serif;
  }
  div {
    box-sizing: border-box;
  }
`;
function $ie(e, n) {
  return typeof n == "string" ? P8(e) : !0;
}
const GA = ({
  children: e,
  theme: n
}) => {
  Die();
  const [t, s] = qe(!1), [, a] = qe(), [o, i] = qe(), d = Ne((p) => {
    a(p);
  }, []), m = Ne(
    (p) => {
      i(p);
    },
    []
  );
  on(() => {
    s(!0);
  }, []);
  const h = Q(() => ({
    ...Nh,
    ...n
  }), [n]);
  return t ? /* @__PURE__ */ c.jsxs(nD, { ref: d, children: [
    /* @__PURE__ */ c.jsx("div", { ref: m }),
    /* @__PURE__ */ c.jsx(
      TB,
      {
        shouldForwardProp: $ie,
        target: o,
        children: /* @__PURE__ */ c.jsxs(IB, { theme: h, children: [
          /* @__PURE__ */ c.jsx(Fie, {}),
          /* @__PURE__ */ c.jsx(jie, { children: /* @__PURE__ */ c.jsx(sD, { client: Bie, children: e }, "skip-widget") })
        ] })
      }
    )
  ] }) : null;
}, xn = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
let zie = 0;
function bh(e, n) {
  const t = `atom${++zie}`, s = {
    toString() {
      return (xn ? "production" : void 0) !== "production" && this.debugLabel ? t + ":" + this.debugLabel : t;
    }
  };
  return typeof e == "function" ? s.read = e : (s.init = e, s.read = qie, s.write = Sie), n && (s.write = n), s;
}
function qie(e) {
  return e(this);
}
function Sie(e, n, t) {
  return n(
    this,
    typeof t == "function" ? t(e(this)) : t
  );
}
const i8 = (e, n) => e.unstable_is ? e.unstable_is(n) : n === e, Nm = (e) => "init" in e, Pm = (e) => !!e.write, Jd = /* @__PURE__ */ new WeakMap(), vh = (e) => {
  var n;
  return fh(e) && !((n = Jd.get(e)) != null && n[1]);
}, Tie = (e, n) => {
  const t = Jd.get(e);
  if (t)
    t[1] = !0, t[0].forEach((s) => s(n));
  else if ((xn ? "production" : void 0) !== "production")
    throw new Error("[Bug] cancelable promise not found");
}, Rie = (e) => {
  if (Jd.has(e))
    return;
  const n = [/* @__PURE__ */ new Set(), !1];
  Jd.set(e, n);
  const t = () => {
    n[1] = !0;
  };
  e.then(t, t), e.onCancel = (s) => {
    n[0].add(s);
  };
}, fh = (e) => typeof (e == null ? void 0 : e.then) == "function", c8 = (e) => "v" in e || "e" in e, Ed = (e) => {
  if ("e" in e)
    throw e.e;
  if ((xn ? "production" : void 0) !== "production" && !("v" in e))
    throw new Error("[Bug] atom state is not initialized");
  return e.v;
}, KA = (e, n, t) => {
  t.p.has(e) || (t.p.add(e), n.then(
    () => {
      t.p.delete(e);
    },
    () => {
      t.p.delete(e);
    }
  ));
}, d8 = (e, n, t, s, a) => {
  var o;
  if ((xn ? "production" : void 0) !== "production" && s === n)
    throw new Error("[Bug] atom cannot depend on itself");
  t.d.set(s, a.n), vh(t.v) && KA(n, t.v, a), (o = a.m) == null || o.t.add(n), e && Oie(e, s, n);
}, uc = () => [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map(), /* @__PURE__ */ new Set()], Um = (e, n, t) => {
  e[0].has(n) || e[0].set(n, /* @__PURE__ */ new Set()), e[1].set(n, t);
}, Oie = (e, n, t) => {
  const s = e[0].get(n);
  s && s.add(t);
}, Mie = (e, n) => e[0].get(n), m8 = (e, n) => {
  e[2].add(n);
}, qo = (e) => {
  for (; e[1].size || e[2].size; ) {
    e[0].clear();
    const n = new Set(e[1].values());
    e[1].clear();
    const t = new Set(e[2]);
    e[2].clear(), n.forEach((s) => {
      var a;
      return (a = s.m) == null ? void 0 : a.l.forEach((o) => o());
    }), t.forEach((s) => s());
  }
}, XA = (e) => {
  let n;
  (xn ? "production" : void 0) !== "production" && (n = /* @__PURE__ */ new Set());
  const t = (k, B, v) => {
    const g = "v" in B, b = B.v, O = vh(B.v) ? B.v : null;
    if (fh(v)) {
      Rie(v);
      for (const D of B.d.keys())
        KA(
          k,
          v,
          e(D, B)
        );
      B.v = v, delete B.e;
    } else
      B.v = v, delete B.e;
    (!g || !Object.is(b, B.v)) && (++B.n, O && Tie(O, v));
  }, s = (k, B, v, g) => {
    var b;
    if (!(g != null && g(B)) && c8(v) && (v.m || Array.from(v.d).every(
      ([u, f]) => (
        // Recursively, read the atom state of the dependency, and
        // check if the atom epoch number is unchanged
        s(k, u, e(u, v), g).n === f
      )
    )))
      return v;
    v.d.clear();
    let O = !0;
    const D = (u) => {
      if (i8(B, u)) {
        const S = e(u, v);
        if (!c8(S))
          if (Nm(u))
            t(u, S, u.init);
          else
            throw new Error("no atom init");
        return Ed(S);
      }
      const f = s(
        k,
        u,
        e(u, v),
        g
      );
      if (O)
        d8(k, B, v, u, f);
      else {
        const S = uc();
        d8(S, B, v, u, f), h(S, B, v), qo(S);
      }
      return Ed(f);
    };
    let M, N;
    const l = {
      get signal() {
        return M || (M = new AbortController()), M.signal;
      },
      get setSelf() {
        return (xn ? "production" : void 0) !== "production" && !Pm(B) && console.warn("setSelf function cannot be used with read-only atom"), !N && Pm(B) && (N = (...u) => {
          if ((xn ? "production" : void 0) !== "production" && O && console.warn("setSelf function cannot be called in sync"), !O)
            return m(B, ...u);
        }), N;
      }
    };
    try {
      const u = B.read(D, l);
      if (t(B, v, u), fh(u)) {
        (b = u.onCancel) == null || b.call(u, () => M == null ? void 0 : M.abort());
        const f = () => {
          if (v.m) {
            const S = uc();
            h(S, B, v), qo(S);
          }
        };
        u.then(f, f);
      }
      return v;
    } catch (u) {
      return delete v.v, v.e = u, ++v.n, v;
    } finally {
      O = !1;
    }
  }, a = (k) => Ed(s(void 0, k, e(k))), o = (k, B, v) => {
    var g, b;
    const O = /* @__PURE__ */ new Map();
    for (const D of ((g = v.m) == null ? void 0 : g.t) || [])
      O.set(D, e(D, v));
    for (const D of v.p)
      O.set(
        D,
        e(D, v)
      );
    return (b = Mie(k, B)) == null || b.forEach((D) => {
      O.set(D, e(D, v));
    }), O;
  }, i = (k, B, v) => {
    const g = [], b = /* @__PURE__ */ new Set(), O = (N, l) => {
      if (!b.has(N)) {
        b.add(N);
        for (const [u, f] of o(k, N, l))
          N !== u && O(u, f);
        g.push([N, l, l.n]);
      }
    };
    O(B, v);
    const D = /* @__PURE__ */ new Set([B]), M = (N) => b.has(N);
    for (let N = g.length - 1; N >= 0; --N) {
      const [l, u, f] = g[N];
      let S = !1;
      for (const x of u.d.keys())
        if (x !== l && D.has(x)) {
          S = !0;
          break;
        }
      S && (s(k, l, u, M), h(k, l, u), f !== u.n && (Um(k, l, u), D.add(l))), b.delete(l);
    }
  }, d = (k, B, v, ...g) => {
    const b = (M) => Ed(s(k, M, e(M, v))), O = (M, ...N) => {
      const l = e(M, v);
      let u;
      if (i8(B, M)) {
        if (!Nm(M))
          throw new Error("atom not writable");
        const f = "v" in l, S = l.v, x = N[0];
        t(M, l, x), h(k, M, l), (!f || !Object.is(S, l.v)) && (Um(k, M, l), i(k, M, l));
      } else
        u = d(k, M, l, ...N);
      return qo(k), u;
    };
    return B.write(b, O, ...g);
  }, m = (k, ...B) => {
    const v = uc(), g = d(v, k, e(k), ...B);
    return qo(v), g;
  }, h = (k, B, v) => {
    if (v.m && !vh(v.v)) {
      for (const g of v.d.keys())
        v.m.d.has(g) || (p(k, g, e(g, v)).t.add(B), v.m.d.add(g));
      for (const g of v.m.d || [])
        if (!v.d.has(g)) {
          v.m.d.delete(g);
          const b = _(k, g, e(g, v));
          b == null || b.t.delete(B);
        }
    }
  }, p = (k, B, v) => {
    if (!v.m) {
      s(k, B, v);
      for (const g of v.d.keys())
        p(k, g, e(g, v)).t.add(B);
      if (v.m = {
        l: /* @__PURE__ */ new Set(),
        d: new Set(v.d.keys()),
        t: /* @__PURE__ */ new Set()
      }, (xn ? "production" : void 0) !== "production" && n.add(B), Pm(B) && B.onMount) {
        const g = v.m, { onMount: b } = B;
        m8(k, () => {
          const O = b(
            (...D) => d(k, B, v, ...D)
          );
          O && (g.u = O);
        });
      }
    }
    return v.m;
  }, _ = (k, B, v) => {
    if (v.m && !v.m.l.size && !Array.from(v.m.t).some(
      (g) => {
        var b;
        return (b = e(g, v).m) == null ? void 0 : b.d.has(B);
      }
    )) {
      const g = v.m.u;
      g && m8(k, g), delete v.m, (xn ? "production" : void 0) !== "production" && n.delete(B);
      for (const b of v.d.keys()) {
        const O = _(k, b, e(b, v));
        O == null || O.t.delete(B);
      }
      return;
    }
    return v.m;
  }, q = {
    get: a,
    set: m,
    sub: (k, B) => {
      const v = uc(), g = e(k), b = p(v, k, g);
      qo(v);
      const O = b.l;
      return O.add(B), () => {
        O.delete(B);
        const D = uc();
        _(D, k, g), qo(D);
      };
    },
    unstable_derive: (k) => XA(...k(e))
  };
  return (xn ? "production" : void 0) !== "production" && Object.assign(q, {
    // store dev methods (these are tentative and subject to change without notice)
    dev4_get_internal_weak_map: () => ({
      get: (B) => {
        const v = e(B);
        if (v.n !== 0)
          return v;
      }
    }),
    dev4_get_mounted_atoms: () => n,
    dev4_restore_atoms: (B) => {
      const v = uc();
      for (const [g, b] of B)
        if (Nm(g)) {
          const O = e(g), D = "v" in O, M = O.v;
          t(g, O, b), h(v, g, O), (!D || !Object.is(M, O.v)) && (Um(v, g, O), i(v, g, O));
        }
      qo(v);
    }
  }), q;
}, Iie = () => {
  const e = /* @__PURE__ */ new WeakMap();
  return XA((t) => {
    let s = e.get(t);
    return s || (s = { d: /* @__PURE__ */ new Map(), p: /* @__PURE__ */ new Set(), n: 0 }, e.set(t, s)), s;
  });
};
let ed;
const Nie = () => (ed || (ed = Iie(), (xn ? "production" : void 0) !== "production" && (globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = ed), globalThis.__JOTAI_DEFAULT_STORE__ !== ed && console.warn(
  "Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044"
))), ed), xw = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, kw = Symbol(
  (xw ? "production" : void 0) !== "production" ? "RESET" : ""
);
function YA(e) {
  const n = bh(
    e,
    (t, s, a) => {
      const o = typeof a == "function" ? a(t(n)) : a;
      s(n, o === kw ? e : o);
    }
  );
  return n;
}
const Pie = (e) => typeof (e == null ? void 0 : e.then) == "function";
function Uie(e = () => {
  try {
    return window.localStorage;
  } catch (t) {
    (xw ? "production" : void 0) !== "production" && typeof window < "u" && console.warn(t);
    return;
  }
}, n) {
  var t;
  let s, a;
  const o = {
    getItem: (m, h) => {
      var p, _;
      const y = (q) => {
        if (q = q || "", s !== q) {
          try {
            a = JSON.parse(q, n == null ? void 0 : n.reviver);
          } catch {
            return h;
          }
          s = q;
        }
        return a;
      }, w = (_ = (p = e()) == null ? void 0 : p.getItem(m)) != null ? _ : null;
      return Pie(w) ? w.then(y) : y(w);
    },
    setItem: (m, h) => {
      var p;
      return (p = e()) == null ? void 0 : p.setItem(
        m,
        JSON.stringify(h, void 0)
      );
    },
    removeItem: (m) => {
      var h;
      return (h = e()) == null ? void 0 : h.removeItem(m);
    }
  }, i = (m) => (h, p, _) => m(h, (y) => {
    let w;
    try {
      w = JSON.parse(y || "");
    } catch {
      w = _;
    }
    p(w);
  });
  let d;
  try {
    d = (t = e()) == null ? void 0 : t.subscribe;
  } catch {
  }
  return !d && typeof window < "u" && typeof window.addEventListener == "function" && window.Storage && (d = (m, h) => {
    if (!(e() instanceof window.Storage))
      return () => {
      };
    const p = (_) => {
      _.storageArea === e() && _.key === m && h(_.newValue);
    };
    return window.addEventListener("storage", p), () => {
      window.removeEventListener("storage", p);
    };
  }), d && (o.subscribe = i(d)), o;
}
const Hie = Uie();
function JA(e, n, t = Hie, s) {
  const a = bh(
    n
  );
  return (xw ? "production" : void 0) !== "production" && (a.debugPrivate = !0), a.onMount = (i) => {
    i(t.getItem(e, n));
    let d;
    return t.subscribe && (d = t.subscribe(e, i, n)), d;
  }, bh(
    (i) => i(a),
    (i, d, m) => {
      const h = typeof m == "function" ? m(i(a)) : m;
      return h === kw ? (d(a, n), t.removeItem(e)) : h instanceof Promise ? h.then((p) => (d(a, p), t.setItem(e, p))) : (d(a, h), t.setItem(e, h));
    }
  );
}
const Lie = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, Wie = QE(
  void 0
), Vie = (e) => Eh(Wie) || Nie(), Gie = (e) => {
  e.status = "pending", e.then(
    (n) => {
      e.status = "fulfilled", e.value = n;
    },
    (n) => {
      e.status = "rejected", e.reason = n;
    }
  );
};
Ie.use;
function Kie(e, n) {
  const t = Vie();
  return Ne(
    (...a) => {
      if ((Lie ? "production" : void 0) !== "production" && !("write" in e))
        throw new Error("not writable atom");
      return t.set(e, ...a);
    },
    [t, e]
  );
}
function Xie(e, n) {
  const t = Kie(e);
  return Ne(() => t(kw), [t]);
}
const sn = YA(
  void 0
);
var Xe = /* @__PURE__ */ ((e) => (e[e.AuthFailed = 0] = "AuthFailed", e[e.Timeout = 1] = "Timeout", e[e.AdditionalSigningRequired = 2] = "AdditionalSigningRequired", e[e.TradeWarning = 3] = "TradeWarning", e[e.TransactionFailed = 4] = "TransactionFailed", e[e.TransactionReverted = 5] = "TransactionReverted", e[e.Unexpected = 6] = "Unexpected", e))(Xe || {});
const ZA = YA(0), wh = "https://go.skip.build", Yie = {
  getRpcEndpointForChain: async (e) => `${wh}/api/rpc/${e}`,
  getRestEndpointForChain: async (e) => `${wh}/api/rest/${e}`
}, Jie = `${wh}/api/widget/skip`, Aw = me(), jw = me(), Cw = me(), Ew = me((e) => ({
  evm: e(Aw),
  cosmos: e(jw),
  svm: e(Cw)
})), Zie = "2.13.7", Qie = () => `@wagmi/core@${Zie}`;
var QA = function(e, n, t, s) {
  if (t === "a" && !s) throw new TypeError("Private accessor was defined without a getter");
  if (typeof n == "function" ? e !== n || !s : !n.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t === "m" ? s : t === "a" ? s.call(e) : s ? s.value : n.get(e);
}, Zd, ej;
class Tr extends Error {
  get docsBaseUrl() {
    return "https://wagmi.sh/core";
  }
  get version() {
    return Qie();
  }
  constructor(n, t = {}) {
    var o;
    super(), Zd.add(this), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiCoreError"
    });
    const s = t.cause instanceof Tr ? t.cause.details : (o = t.cause) != null && o.message ? t.cause.message : t.details, a = t.cause instanceof Tr && t.cause.docsPath || t.docsPath;
    this.message = [
      n || "An error occurred.",
      "",
      ...t.metaMessages ? [...t.metaMessages, ""] : [],
      ...a ? [
        `Docs: ${this.docsBaseUrl}${a}.html${t.docsSlug ? `#${t.docsSlug}` : ""}`
      ] : [],
      ...s ? [`Details: ${s}`] : [],
      `Version: ${this.version}`
    ].join(`
`), t.cause && (this.cause = t.cause), this.details = s, this.docsPath = a, this.metaMessages = t.metaMessages, this.shortMessage = n;
  }
  walk(n) {
    return QA(this, Zd, "m", ej).call(this, this, n);
  }
}
Zd = /* @__PURE__ */ new WeakSet(), ej = function e(n, t) {
  return t != null && t(n) ? n : n.cause ? QA(this, Zd, "m", e).call(this, n.cause, t) : n;
};
class ece extends Tr {
  constructor() {
    super("Connector not connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorNotConnectedError"
    });
  }
}
class nce extends Tr {
  constructor({ address: n, connector: t }) {
    super(`Account "${n}" not found for connector "${t.name}".`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAccountNotFoundError"
    });
  }
}
class tce extends Tr {
  constructor({ connectionChainId: n, connectorChainId: t }) {
    super(`The current chain of the connector (id: ${t}) does not match the connection's chain (id: ${n}).`, {
      metaMessages: [
        `Current Chain ID:  ${t}`,
        `Expected Chain ID: ${n}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorChainMismatchError"
    });
  }
}
class sce extends Tr {
  constructor({ connector: n }) {
    super(`Connector "${n.name}" unavailable while reconnecting.`, {
      details: [
        "During the reconnection step, the only connector methods guaranteed to be available are: `id`, `name`, `type`, `uuid`.",
        "All other methods are not guaranteed to be available until reconnection completes and connectors are fully restored.",
        "This error commonly occurs for connectors that asynchronously inject after reconnection has already started."
      ].join(" ")
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorUnavailableReconnectingError"
    });
  }
}
async function ace(e, n = {}) {
  let t;
  if (n.connector) {
    const { connector: h } = n;
    if (e.state.status === "reconnecting" && !h.getAccounts && !h.getChainId)
      throw new sce({ connector: h });
    const [p, _] = await Promise.all([
      h.getAccounts(),
      h.getChainId()
    ]);
    t = {
      accounts: p,
      chainId: _,
      connector: h
    };
  } else
    t = e.state.connections.get(e.state.current);
  if (!t)
    throw new ece();
  const s = n.chainId ?? t.chainId, a = await t.connector.getChainId();
  if (a !== t.chainId)
    throw new tce({
      connectionChainId: t.chainId,
      connectorChainId: a
    });
  const o = t.connector;
  if (o.getClient)
    return o.getClient({ chainId: s });
  const i = Hc(n.account ?? t.accounts[0]);
  if (i.address = bre(i.address), n.account && !t.accounts.some((h) => h.toLowerCase() === i.address.toLowerCase()))
    throw new nce({
      address: i.address,
      connector: o
    });
  const d = e.chains.find((h) => h.id === s), m = await t.connector.getProvider({ chainId: s });
  return cD({
    account: i,
    chain: d,
    name: "Connector Client",
    transport: (h) => dD(m)({ ...h, retryCount: 0 })
  });
}
async function oce(e, n = {}) {
  return (await ace(e, n)).extend(mD);
}
const Dw = [
  new xD(),
  new vD(),
  new kD(),
  new fD(),
  new AD(),
  new wD()
], nj = me({
  apiURL: Jie,
  endpointOptions: Yie
}), tj = me(Nh), go = me((e) => {
  const n = e(nj), t = e(Ew);
  return new yD({
    ...n,
    getCosmosSigner: async (s) => {
      if (!t.cosmos)
        throw new Error("getCosmosSigner error: no cosmos wallet");
      const a = od(t.cosmos.walletName);
      if (!a)
        throw new Error("getCosmosSigner error: wallet not found");
      return (await a.getKey(s)).isNanoLedger ? a.getOfflineSignerOnlyAmino(s) : a.getOfflineSigner(s);
    },
    // @ts-expect-error having a different viem version
    getEVMSigner: async (s) => await oce(VA, {
      chainId: parseInt(s)
    }),
    // @ts-expect-error solanaWallet is not a merged Adapter
    getSVMSigner: async () => {
      var o;
      const s = (o = t.svm) == null ? void 0 : o.walletName;
      if (!s) throw new Error("getSVMSigner error: no svm wallet");
      const a = Dw.find((i) => i.name === s);
      if (!a)
        throw new Error("getSVMSigner error: wallet not found");
      return a;
    }
  });
}), rce = (e, n) => {
  const t = [];
  for (const s in e)
    e[s].forEach((a) => {
      const o = n == null ? void 0 : n.find((i) => i.chainID === a.chainID);
      t.push({
        ...a,
        chain_key: s,
        chainName: (o == null ? void 0 : o.prettyName) ?? (o == null ? void 0 : o.chainName) ?? a.chainID ?? "--"
      });
    });
  return t;
}, dc = ic((e) => {
  const n = e(go), t = e(We);
  return {
    queryKey: ["skipAssets"],
    queryFn: async () => n.assets({
      includeEvmAssets: !0,
      includeCW20Assets: !0,
      includeSvmAssets: !0
    }).then((s) => rce(s, t.data))
  };
}), We = ic((e) => {
  const n = e(go);
  return {
    queryKey: ["skipChains"],
    queryFn: async () => n.chains({
      includeEVM: !0,
      includeSVM: !0
    })
  };
}), ice = ic((e) => {
  const n = e(go);
  return {
    queryKey: ["skipBridges"],
    queryFn: async () => n.bridges()
  };
}), cce = ic((e) => {
  const n = e(go);
  return {
    queryKey: ["skipSwapVenue"],
    queryFn: async () => n.venues()
  };
}), dce = ({
  children: e,
  drawer: n,
  container: t,
  onOpenChange: s,
  stackedModal: a,
  theme: o
}) => {
  const i = Qe();
  on(() => (s == null || s(!0), () => {
    s == null || s(!1);
  }), [s]);
  const d = async (p) => new Promise((_) => setTimeout(_, p)), [m, h] = qe(!0);
  return /* @__PURE__ */ c.jsx(
    Nd.Root,
    {
      open: i.visible,
      onOpenChange: () => {
        h(!1), d(75).then(() => i.remove());
      },
      children: /* @__PURE__ */ c.jsx(Nd.Portal, { container: t, children: /* @__PURE__ */ c.jsx(GA, { theme: o, children: /* @__PURE__ */ c.jsx(gce, { drawer: n, open: m, invisible: a, children: /* @__PURE__ */ c.jsx(uce, { drawer: n, open: m, children: e }) }) }) })
    }
  );
}, Lc = (e) => {
  const n = e, t = (s) => {
    const [, a] = Ae(sn);
    return /* @__PURE__ */ c.jsx(dce, { ...s, children: /* @__PURE__ */ c.jsx(
      qd,
      {
        fallback: null,
        onError: (o) => a({ errorType: Xe.Unexpected, error: o }),
        children: /* @__PURE__ */ c.jsx(n, { ...s })
      }
    ) });
  };
  return T8.create(t);
}, Qe = (e, n) => {
  const [t] = Ae(tj), [s, a] = Ae(
    ZA
  ), o = _D(e, n);
  return Q(
    () => ({
      ...o,
      show: (i) => {
        o.show({
          ...i,
          theme: t
        }), a((d) => d + 1);
      },
      remove: () => {
        a((i) => Math.max(0, i - 1)), o.remove();
      },
      hide: () => {
        a((i) => Math.max(0, i - 1)), o.hide();
      }
    }),
    [o, t, a]
  );
}, h8 = Ic`
  from {
      opacity: 0;
    }
    to {
    opacity: 1;
    }
`, p8 = Ic`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`, mce = Ic`
  from {
      opacity: 0;
    transform: translateY(100%);
    }
    to {
    opacity: 1;
    transform: translateY(0);
    }
`, hce = Ic`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(100%);
  }
`, pce = Ic`
  from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
`, lce = Ic`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0);
  }
`, gce = W(Nd.Overlay)`
  ${({ invisible: e }) => e ? "" : "background: rgba(0 0 0 / 0.5);"}
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  place-items: center;
  overflow-y: auto;
  z-index: 10;
  animation: ${({ open: e }) => e ? h8 : p8} 150ms ease-in-out;
  /* For Chrome */
  &::-webkit-scrollbar {
    display: none;
  }
  /* For Firefox */
  scrollbar-width: none;
  /* For Internet Explorer and Edge */
  -ms-overflow-style: none;

  ${(e) => e.drawer && Ye`
      align-items: flex-end;
      position: absolute;
      background: rgba(255, 255, 255, 0);
      animation: ${e.open ? h8 : p8} 150ms ease-in-out;
      /* For Chrome */
      &::-webkit-scrollbar {
        display: none;
      }
      /* For Firefox */
      scrollbar-width: none;
      /* For Internet Explorer and Edge */
      -ms-overflow-style: none;
    `};
`, uce = W(Nd.Content)`
  min-width: 300px;
  border-radius: 4px;
  z-index: 100;
  animation: ${({ drawer: e, open: n }) => n ? e ? mce : pce : e ? hce : lce}
    150ms ease-in-out;
`, Bw = Ye`
  display: flex;
  ${({ align: e }) => e && `align-items: ${e}`};
  ${({ justify: e }) => e && `justify-content: ${e}`};
  ${({ gap: e }) => e && `gap: ${e}px`};
  ${({ padding: e }) => e && `padding: ${e}px`};
  ${({ borderRadius: e }) => e && `border-radius: ${e}px`};
`, Y = W.div`
  ${Bw};
  flex-direction: row;
`, be = W(Y)`
  flex-direction: column;
`, sj = W.div`
  ${({ width: e }) => e && `width: ${e}px`};
  ${({ height: e }) => e && `height: ${e}px`};
  flex-shrink: 0;
  flex-grow: 0;
`, aj = (e, n) => (t) => {
  const s = {
    ...n,
    ...t
  };
  return /* @__PURE__ */ c.jsx(e, { ...s });
}, Fw = (e) => {
  e && navigator.clipboard.writeText(e);
};
function _d(e, n) {
  return JA(
    e,
    n,
    {
      getItem: (s) => {
        const a = localStorage.getItem(s);
        if (!a) return n;
        try {
          return JSON.parse(a);
        } catch {
          return n;
        }
      },
      setItem: (s, a) => {
        localStorage.setItem(s, JSON.stringify(a));
      },
      removeItem: (s) => {
        localStorage.delete(s);
      }
    }
  );
}
const oj = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent",
  direction: t = "right",
  className: s
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    className: s,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: t === "down" ? "rotate(90)" : t === "left" ? "rotate(180)" : t === "up" ? "rotate(-90)" : "",
    children: [
      /* @__PURE__ */ c.jsx("rect", { width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M20.1203 18.2749L9.84088 18.2749L9.84088 21.7251L20.1203 21.7251C21.3854 21.7251 22.0202 23.2548 21.1255 24.1496L17.206 28.0691L19.6465 30.5096L30.1582 19.9977L19.6511 9.49043L17.2106 11.9309L21.1278 15.8459C22.0225 16.7406 21.39 18.2726 20.1226 18.2726",
          fill: e
        }
      )
    ]
  }
), $w = aj(oj, { direction: "right" }), zw = aj(oj, { direction: "left" }), _ce = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent"
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ c.jsx("rect", { width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M13.4052 17.915L11.8286 16.3384L8.58887 19.5182L17.5889 28.5164L19.7233 26.3819C19.725 26.3802 19.7267 26.3786 19.7283 26.377L31.4111 14.6941L29.8138 13.0968C29.8112 13.0941 29.8086 13.0916 29.806 13.0889C29.8034 13.0864 29.8008 13.0838 29.7982 13.0812L28.2006 11.4836L19.7285 19.9582C18.5469 21.1402 16.6307 21.1403 15.449 19.9585L13.4185 17.9281C13.4141 17.9237 13.4097 17.9194 13.4052 17.915Z",
          fill: e
        }
      )
    ]
  }
), yce = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent"
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ c.jsx("rect", { width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M18.4577 6.76448L18.3922 6.76448L18.3922 15.1648C18.3922 16.9436 16.9495 18.3863 15.1707 18.3863L6.76448 18.3863L6.76448 21.5423L6.76597 21.6093L15.1663 21.6093C16.9451 21.6093 18.3878 23.0519 18.3878 24.8308L18.3878 33.237L21.5438 33.237L21.6078 33.2355L21.6078 24.8352C21.6078 23.0564 23.0505 21.6137 24.8293 21.6137L33.2355 21.6137V18.4577L33.234 18.3907L24.8337 18.3907C23.0549 18.3907 21.6122 16.948 21.6122 15.1692L21.6122 6.763L18.4562 6.76299L18.4577 6.76448Z",
          fill: e
        }
      )
    ]
  }
), qw = ({
  backgroundColor: e = "currentColor",
  className: n,
  ...t
}) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M8.186 8.078c-.426.04-.66.274-.7.701a21.73 21.73 0 01-.854 6.46c-.06.183-.04.377.061.58.102.223.315.345.64.365.346-.02.58-.193.701-.518.203-.751.406-1.706.61-2.864.182-1.138.274-2.469.274-3.992-.04-.447-.285-.691-.732-.732zm-.03-2.499c-.955.02-1.717.325-2.286.914a3.065 3.065 0 00-.853 2.164 20.712 20.712 0 01-.396 4.358.76.76 0 00.091.548.667.667 0 00.457.305c.204.04.386.01.549-.091a.78.78 0 00.335-.457c.305-1.544.447-3.088.427-4.632 0-.427.142-.803.426-1.128.285-.325.701-.498 1.25-.518.488.02.894.193 1.219.518.325.325.498.721.518 1.189a26.355 26.355 0 01-.305 4.357.66.66 0 00.122.549.667.667 0 00.457.305c.305.02.518-.051.64-.214.142-.162.213-.294.213-.396.244-1.524.356-3.057.336-4.601-.04-.894-.356-1.636-.945-2.225-.61-.59-1.361-.904-2.255-.945zM4.804 5c-.386-.264-.732-.233-1.036.092a5.33 5.33 0 00-1.189 3.413 17.334 17.334 0 01-.274 3.413c-.04.183 0 .366.122.548a.667.667 0 00.457.305c.305.02.518-.05.64-.213.142-.163.203-.285.183-.366.223-1.24.325-2.478.304-3.718.02-.914.305-1.737.854-2.468.284-.366.264-.701-.061-1.006zm3.291-1.92c-.447 0-.904.051-1.371.153-.427.122-.61.416-.549.883.142.427.427.61.853.549a4.911 4.911 0 011.067-.122c1.178.04 2.174.447 2.986 1.22.793.771 1.21 1.736 1.25 2.894.02 1.138-.03 2.286-.152 3.444-.02.447.193.721.64.823.243 0 .436-.072.579-.214.142-.142.213-.284.213-.426.142-1.22.203-2.438.183-3.657-.061-1.544-.63-2.834-1.707-3.87C11.031 3.7 9.7 3.14 8.095 3.08zm7.71 3.718c-.142-.426-.437-.62-.884-.579a.779.779 0 00-.426.335c-.122.163-.163.346-.122.549.081.325.122.63.122.914.02.285.03.6.03.945.04.447.284.7.732.762.446-.04.69-.285.73-.732v-.03c.042-.63-.02-1.351-.182-2.164zm-1.25-2.773a7.78 7.78 0 00-2.833-2.499A7.896 7.896 0 008.065.581c-2.195 0-4.043.742-5.547 2.225C1.076 4.27.354 6.036.354 8.11v.64c.061.447.305.7.732.761h.03a.671.671 0 00.488-.213.61.61 0 00.213-.487v-.732c.02-1.645.6-3.057 1.737-4.236 1.24-1.198 2.743-1.798 4.51-1.798a6.515 6.515 0 012.987.762 6.656 6.656 0 012.347 2.042c.284.345.62.406 1.005.183.325-.285.376-.62.153-1.006z",
        fill: e
      }
    )
  }
), bce = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent"
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ c.jsx("rect", { width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M22.959 27.9526H17.5572C16.3875 27.9526 15.8005 26.5389 16.6294 25.71L21.5607 20.7787L19.2281 18.446L14.2967 23.3774C13.4701 24.204 12.0542 23.6192 12.0542 22.4496V17.0411H8.75635V31.2482H22.959V27.9504V27.9526Z",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M23.3702 14.2922L18.2146 19.4478L20.5472 21.7805L25.7028 16.6249C26.5295 15.7982 27.9454 16.383 27.9454 17.5526V22.9611H31.2432V8.75183H17.0405V12.0497H22.4424C23.612 12.0497 24.199 13.4633 23.3702 14.2922Z",
          fill: e
        }
      )
    ]
  }
), vce = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent"
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    width: "40",
    height: "41",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ c.jsx("rect", { y: "0.480713", width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M18.9042 24.141L17.4816 16.1506V11.6555C17.4816 10.5509 18.3771 9.65552 19.4816 9.65552H20.5182C21.6228 9.65552 22.5182 10.5509 22.5182 11.6555V16.1506L21.0957 24.141H18.9042ZM19.0972 31.3059C17.9926 31.3059 17.0972 30.4105 17.0972 29.3059V28.6975C17.0972 27.5929 17.9926 26.6975 19.0972 26.6975H20.9027C22.0073 26.6975 22.9027 27.5929 22.9027 28.6975V29.3059C22.9027 30.4105 22.0073 31.3059 20.9027 31.3059H19.0972Z",
          fill: e
        }
      )
    ]
  }
), fce = ({ backgroundColor: e }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "47",
    height: "41",
    viewBox: "0 0 47 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5686 1.76471C24.7988 0.431378 22.8743 0.431374 22.1045 1.76471L1.18402 38C0.414219 39.3333 1.37647 41 2.91607 41H44.757C46.2966 41 47.2588 39.3333 46.489 38L25.5686 1.76471ZM22.7622 27.766C22.8336 28.3044 23.2927 28.7066 23.8358 28.7066C24.3788 28.7066 24.8379 28.3044 24.9093 27.766L26.0164 19.418V14.6072C26.0164 13.4028 25.0401 12.4265 23.8358 12.4265C22.6314 12.4265 21.6551 13.4028 21.6551 14.6072V19.418L22.7622 27.766ZM21.3222 33.52C21.3222 34.7413 22.3122 35.7314 23.5335 35.7314H24.138C25.3593 35.7314 26.3494 34.7413 26.3494 33.52V32.9821C26.3494 31.7608 25.3593 30.7708 24.138 30.7708H23.5335C22.3122 30.7708 21.3222 31.7608 21.3222 32.9821V33.52Z",
        fill: e
      }
    )
  }
), Sw = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "13",
    viewBox: "0 0 11 12",
    fill: "none",
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M1.07754 9.22755H3.07909C3.14933 9.22755 3.21175 9.21584 3.26638 9.19243C3.321 9.16902 3.37562 9.13391 3.43025 9.08709L8.9199 3.58572C9.02135 3.48428 9.07207 3.36723 9.07207 3.23457C9.07207 3.10191 9.02135 2.98487 8.9199 2.88342L6.91834 0.893567C6.8169 0.792123 6.69985 0.741402 6.56719 0.741402C6.43454 0.741402 6.31749 0.792123 6.21604 0.893567L0.726384 6.38322C0.679564 6.43785 0.642498 6.49052 0.615186 6.54124C0.587875 6.59196 0.574219 6.65634 0.574219 6.73438V8.73594C0.574219 8.8842 0.621038 9.0032 0.714679 9.09294C0.80832 9.18268 0.929271 9.22755 1.07754 9.22755ZM1.58085 6.93336L6.56719 1.93531L7.86645 3.23457L2.88011 8.23262H1.58085V6.93336ZM10.067 10.7258H1.07754C0.929271 10.7258 0.80832 10.7726 0.714679 10.8663C0.621038 10.9599 0.574219 11.0808 0.574219 11.2291C0.574219 11.3774 0.621038 11.4983 0.714679 11.592C0.80832 11.6856 0.929271 11.7324 1.07754 11.7324H10.067C10.2153 11.7324 10.3362 11.6856 10.4299 11.592C10.5235 11.4983 10.5703 11.3774 10.5703 11.2291C10.5703 11.0808 10.5235 10.9599 10.4299 10.8663C10.3362 10.7726 10.2153 10.7258 10.067 10.7258Z",
        fill: e
      }
    )
  }
), rj = ({
  color: e = "currentColor",
  ...n
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    width: "14",
    height: "12",
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M8.10134 0.511659C5.13657 0.540327 2.7685 3.00041 2.7685 5.96584V8.51992C2.7685 8.90927 2.29781 9.10394 2.02247 8.8286L0.92977 7.73589L0.222412 8.44325L3.26918 11.4893L6.31461 8.44392L5.60726 7.73656L4.51455 8.82926C4.23921 9.10461 3.76853 8.90927 3.76853 8.52059V5.96317C3.76853 3.55642 5.67992 1.54836 8.086 1.51169C10.5354 1.47436 12.5395 3.45575 12.5395 5.8965C12.5395 8.33725 10.5721 10.282 8.154 10.282V11.282C11.1234 11.282 13.5395 8.86593 13.5395 5.8965C13.5395 2.92707 11.0948 0.482324 8.10067 0.510992",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M9.46906 8.01673L7.62567 6.17334V2.53589H8.6257V3.56659C8.6257 4.97063 9.18305 6.31668 10.1758 7.30938L9.4684 8.01673H9.46906Z",
          fill: e
        }
      )
    ]
  }
), wce = ({
  color: e = "currentColor",
  direction: n = "left"
}) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "13",
    viewBox: "0 0 12 12",
    fill: "none",
    transform: n === "right" ? "rotate(180)" : "",
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M1 5.99999L6.02752 0.972473M1 5.99999L6.02752 11.0275M1 5.99999L11.0469 5.99999",
        stroke: e
      }
    )
  }
), xce = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "11",
    viewBox: "0 0 10 10",
    fill: "none",
    children: [
      /* @__PURE__ */ c.jsx("line", { x1: "10", y1: "1.25903", x2: "-4.37114e-08", y2: "1.25903", stroke: e }),
      /* @__PURE__ */ c.jsx("line", { x1: "10", y1: "5.09158", x2: "-3.30781e-08", y2: "5.09158", stroke: e }),
      /* @__PURE__ */ c.jsx("line", { x1: "10", y1: "8.92412", x2: "-3.30781e-08", y2: "8.92412", stroke: e })
    ]
  }
), kce = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "2",
    viewBox: "0 0 10 2",
    fill: "none",
    children: /* @__PURE__ */ c.jsx("line", { x1: "10", y1: "1.09157", x2: "-3.30781e-08", y2: "1.09157", stroke: e })
  }
);
var ae = /* @__PURE__ */ ((e) => (e[e.none = 0] = "none", e[e.plus = 1] = "plus", e[e.checkmark = 2] = "checkmark", e[e.rightArrow = 3] = "rightArrow", e[e.leftArrow = 4] = "leftArrow", e[e.swap = 5] = "swap", e[e.warning = 6] = "warning", e[e.triangleWarning = 7] = "triangleWarning", e[e.signature = 8] = "signature", e[e.pen = 9] = "pen", e[e.history = 10] = "history", e[e.thinArrow = 11] = "thinArrow", e[e.hamburger = 12] = "hamburger", e[e.horizontalLine = 13] = "horizontalLine", e))(ae || {});
const hd = {
  0: () => null,
  1: yce,
  2: _ce,
  3: $w,
  4: zw,
  5: bce,
  6: vce,
  7: fce,
  8: qw,
  9: Sw,
  10: rj,
  11: wce,
  12: xce,
  13: kce
}, yd = Ye`
  background: none;
  border: none;
  padding: 0;
  outline: inherit;
`, ij = Ye`
  font-family: 'ABCDiatype', sans-serif;
  ${({ fontSize: e }) => e && `font-size: ${e}px`};
  ${({ fontWeight: e }) => e && `font-weight: ${e}`};
  ${({ textAlign: e }) => e && `text-align: ${e}`};
  ${({ normalTextColor: e, theme: n }) => e && `color: ${n.primary.text.normal}`};
  ${({ color: e }) => e && `color: ${e}`};
  ${({ opacity: e }) => e && `opacity: ${e}`};
  ${({ lineHeight: e }) => e && `line-height: ${e}`};
  ${({ textWrap: e }) => e && `text-wrap: ${e}`};
  ${({ monospace: e }) => e && "font-family: 'ABCDiatype', monospace;"};
  ${({ mainButtonColor: e }) => e && `color: ${Ih(e)}`};
  ${({ capitalize: e }) => e && Ye`
      &::first-letter {
        text-transform: capitalize;
      }
    `};
`, J = W.p`
  color: ${({ theme: e }) => e.primary.text.lowContrast};
  margin: 0;
  font-size: 13px;
  ${ij}
`, bd = W(J).attrs({ as: "button" })`
  line-height: 15px;
  ${yd}
  cursor: pointer;
`, Te = W(J)`
  color: ${(e) => e.theme.primary.text.normal};
  font-size: 20px;
  font-weight: 500;
  ${ij}
`, l8 = W(Te).attrs({ as: "button" })`
  ${yd}
  cursor: pointer;
`, mc = ({
  title: e,
  description: n,
  textColor: t,
  backgroundColor: s,
  icon: a = ae.none
}) => {
  const o = je();
  t ?? (t = o.primary.text.normal), s ?? (s = o.primary.background.normal);
  const i = hd[a];
  return /* @__PURE__ */ c.jsxs(
    Ace,
    {
      align: "center",
      justify: "center",
      backgroundColor: s,
      gap: 12,
      padding: 16,
      children: [
        /* @__PURE__ */ c.jsx(i, { backgroundColor: t, color: s, height: 40, width: 40 }),
        typeof e == "string" ? /* @__PURE__ */ c.jsx(Te, { fontSize: 20, color: t, children: e }) : e,
        typeof n == "string" ? /* @__PURE__ */ c.jsx(jce, { children: /* @__PURE__ */ c.jsx(J, { color: t, textAlign: "center", style: {
          wordWrap: "break-word"
        }, children: n }) }) : n
      ]
    }
  );
}, Ace = W(be)`
  width: 480px;
  height: 225px;
  border-radius: 25px;
  ${({ backgroundColor: e }) => e && `background-color: ${e}`};
`, jce = W(be)`
  padding: 8px;
  max-height: 100px;
  overflow-y: auto;
  width: 100%;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme: e }) => e.primary.text.ultraLowContrast};
    border-radius: 16px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 16px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`, De = ({
  label: e,
  icon: n = ae.none,
  leftIcon: t = ae.none,
  backgroundColor: s,
  disabled: a,
  loading: o,
  loadingTimeString: i,
  onClick: d
}) => {
  const m = je();
  s ?? (s = a ? m.secondary.background.normal : m.brandColor);
  const h = Ih(s), p = hd[n], _ = hd[t];
  return o ? /* @__PURE__ */ c.jsx(
    Cce,
    {
      label: e,
      backgroundColor: m.primary.background.normal,
      loadingTimeString: i
    }
  ) : /* @__PURE__ */ c.jsxs(
    cj,
    {
      align: "center",
      justify: "space-between",
      padding: 20,
      backgroundColor: s,
      disabled: a,
      onClick: d,
      children: [
        t ? /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 10, children: [
          /* @__PURE__ */ c.jsx(_, { backgroundColor: h, color: s }),
          /* @__PURE__ */ c.jsx(
            Te,
            {
              fontWeight: "bold",
              fontSize: 24,
              color: h,
              mainButtonColor: s,
              capitalize: !0,
              children: e
            }
          )
        ] }) : /* @__PURE__ */ c.jsx(Te, { fontWeight: "bold", capitalize: !0, fontSize: 24, color: h, mainButtonColor: s, children: e }),
        /* @__PURE__ */ c.jsx(p, { backgroundColor: h, color: s })
      ]
    }
  );
}, Cce = ({
  label: e,
  backgroundColor: n,
  loadingTimeString: t
}) => /* @__PURE__ */ c.jsx(
  Ece,
  {
    align: "center",
    justify: "center",
    backgroundColor: n,
    children: /* @__PURE__ */ c.jsxs(
      Bce,
      {
        className: "overlay",
        justify: "space-between",
        padding: 20,
        backgroundColor: n,
        children: [
          /* @__PURE__ */ c.jsx(Te, { fontWeight: "bold", fontSize: 24, style: { opacity: 0.5 }, children: e }),
          t && /* @__PURE__ */ c.jsx(Dce, { align: "center", justify: "center", children: /* @__PURE__ */ c.jsxs(J, { children: [
            t,
            "."
          ] }) })
        ]
      }
    )
  }
), cj = W(Y).attrs({
  as: "button"
})`
  position: relative;
  border: none;
  background-color: ${({ theme: e, backgroundColor: n }) => n ?? e.brandColor};
  height: 70px;
  width: 480px;
  border-radius: 25px;
  overflow: hidden;

  &:hover {
    cursor: pointer;
  }

  ${(e) => e.disabled && `
      opacity: 0.5;
      background-color: ${e.theme.secondary.background.normal};
      &:hover {
        cursor: not-allowed;
      }
    `};
`, Ece = W(cj)`
  background-color: ${(e) => e.theme.secondary.background.normal};
  &:hover {
    cursor: not-allowed;
  }

  &:before {
    content: '';
    position: absolute;
    height: 500px;
    width: 500px;
    opacity: 0.5;
    background-image: conic-gradient(
      transparent,
      transparent,
      transparent,
      ${(e) => e.theme.primary.text.normal}
    );
    animation: rotate 4s linear infinite;
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, Dce = W(Y)`
  background-color: ${(e) => e.theme.secondary.background.normal};
  padding: 16px;
  border-radius: 10px;
`, Bce = W(Y)`
  position: absolute;
  height: 66px;
  width: 476px;
  border-radius: 24px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
`, fo = (e, n = 6) => (typeof e == "string" && (e = parseFloat(e)), (e * Math.pow(10, n)).toString()), ho = (e, n = 6) => e === "" ? "" : (typeof e == "string" && (e = parseFloat(e)), (e / Math.pow(10, n)).toFixed(n).replace(/(\.\d*?[1-9])(?:0+|\.0*)$/, "$1")), $c = (e) => e ? `${e.slice(
  0,
  9
)}…${e.slice(-5)}` : "", an = ({
  assetDenom: e,
  amount: n,
  tokenAmount: t,
  chainId: s
}) => {
  const [{ data: a }] = Ae(dc), [{ data: o }] = Ae(We), i = a == null ? void 0 : a.find((y) => s ? y.denom === e && y.chainID === s : y.denom === e);
  !n && t ? n = ho(t, i == null ? void 0 : i.decimals) : !t && n && (t = fo(n, i == null ? void 0 : i.decimals));
  const d = i == null ? void 0 : i.logoURI, m = (i == null ? void 0 : i.recommendedSymbol) ?? (i == null ? void 0 : i.symbol), h = o == null ? void 0 : o.find((y) => s ? y.chainID === s : y.chainID === (i == null ? void 0 : i.chainID)), p = (h == null ? void 0 : h.prettyName) ?? (h == null ? void 0 : h.chainName), _ = h == null ? void 0 : h.logoURI;
  return s ? {
    asset: i,
    chain: h,
    assetImage: d,
    chainName: p,
    chainImage: _,
    symbol: m,
    amount: n,
    tokenAmount: t
  } : {
    asset: void 0,
    chain: void 0,
    assetImage: void 0,
    chainName: void 0,
    chainImage: void 0,
    symbol: void 0,
    amount: void 0,
    tokenAmount: void 0
  };
};
var Fce = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, Hm = Math.ceil, pn = Math.floor, tn = "[BigNumber Error] ", g8 = tn + "Number primitive has more than 15 significant digits: ", wn = 1e14, oe = 14, Lm = 9007199254740991, Wm = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], bo = 1e7, Ue = 1e9;
function dj(e) {
  var n, t, s, a = g.prototype = { constructor: g, toString: null, valueOf: null }, o = new g(1), i = 20, d = 4, m = -7, h = 21, p = -1e7, _ = 1e7, y = !1, w = 1, q = 0, k = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, B = "0123456789abcdefghijklmnopqrstuvwxyz", v = !0;
  function g(l, u) {
    var f, S, x, C, F, A, E, T, R = this;
    if (!(R instanceof g)) return new g(l, u);
    if (u == null) {
      if (l && l._isBigNumber === !0) {
        R.s = l.s, !l.c || l.e > _ ? R.c = R.e = null : l.e < p ? R.c = [R.e = 0] : (R.e = l.e, R.c = l.c.slice());
        return;
      }
      if ((A = typeof l == "number") && l * 0 == 0) {
        if (R.s = 1 / l < 0 ? (l = -l, -1) : 1, l === ~~l) {
          for (C = 0, F = l; F >= 10; F /= 10, C++) ;
          C > _ ? R.c = R.e = null : (R.e = C, R.c = [l]);
          return;
        }
        T = String(l);
      } else {
        if (!Fce.test(T = String(l))) return s(R, T, A);
        R.s = T.charCodeAt(0) == 45 ? (T = T.slice(1), -1) : 1;
      }
      (C = T.indexOf(".")) > -1 && (T = T.replace(".", "")), (F = T.search(/e/i)) > 0 ? (C < 0 && (C = F), C += +T.slice(F + 1), T = T.substring(0, F)) : C < 0 && (C = T.length);
    } else {
      if (Ee(u, 2, B.length, "Base"), u == 10 && v)
        return R = new g(l), M(R, i + R.e + 1, d);
      if (T = String(l), A = typeof l == "number") {
        if (l * 0 != 0) return s(R, T, A, u);
        if (R.s = 1 / l < 0 ? (T = T.slice(1), -1) : 1, g.DEBUG && T.replace(/^0\.0*|\./, "").length > 15)
          throw Error(g8 + l);
      } else
        R.s = T.charCodeAt(0) === 45 ? (T = T.slice(1), -1) : 1;
      for (f = B.slice(0, u), C = F = 0, E = T.length; F < E; F++)
        if (f.indexOf(S = T.charAt(F)) < 0) {
          if (S == ".") {
            if (F > C) {
              C = E;
              continue;
            }
          } else if (!x && (T == T.toUpperCase() && (T = T.toLowerCase()) || T == T.toLowerCase() && (T = T.toUpperCase()))) {
            x = !0, F = -1, C = 0;
            continue;
          }
          return s(R, String(l), A, u);
        }
      A = !1, T = t(T, u, 10, R.s), (C = T.indexOf(".")) > -1 ? T = T.replace(".", "") : C = T.length;
    }
    for (F = 0; T.charCodeAt(F) === 48; F++) ;
    for (E = T.length; T.charCodeAt(--E) === 48; ) ;
    if (T = T.slice(F, ++E)) {
      if (E -= F, A && g.DEBUG && E > 15 && (l > Lm || l !== pn(l)))
        throw Error(g8 + R.s * l);
      if ((C = C - F - 1) > _)
        R.c = R.e = null;
      else if (C < p)
        R.c = [R.e = 0];
      else {
        if (R.e = C, R.c = [], F = (C + 1) % oe, C < 0 && (F += oe), F < E) {
          for (F && R.c.push(+T.slice(0, F)), E -= oe; F < E; )
            R.c.push(+T.slice(F, F += oe));
          F = oe - (T = T.slice(F)).length;
        } else
          F -= E;
        for (; F--; T += "0") ;
        R.c.push(+T);
      }
    } else
      R.c = [R.e = 0];
  }
  g.clone = dj, g.ROUND_UP = 0, g.ROUND_DOWN = 1, g.ROUND_CEIL = 2, g.ROUND_FLOOR = 3, g.ROUND_HALF_UP = 4, g.ROUND_HALF_DOWN = 5, g.ROUND_HALF_EVEN = 6, g.ROUND_HALF_CEIL = 7, g.ROUND_HALF_FLOOR = 8, g.EUCLID = 9, g.config = g.set = function(l) {
    var u, f;
    if (l != null)
      if (typeof l == "object") {
        if (l.hasOwnProperty(u = "DECIMAL_PLACES") && (f = l[u], Ee(f, 0, Ue, u), i = f), l.hasOwnProperty(u = "ROUNDING_MODE") && (f = l[u], Ee(f, 0, 8, u), d = f), l.hasOwnProperty(u = "EXPONENTIAL_AT") && (f = l[u], f && f.pop ? (Ee(f[0], -Ue, 0, u), Ee(f[1], 0, Ue, u), m = f[0], h = f[1]) : (Ee(f, -Ue, Ue, u), m = -(h = f < 0 ? -f : f))), l.hasOwnProperty(u = "RANGE"))
          if (f = l[u], f && f.pop)
            Ee(f[0], -Ue, -1, u), Ee(f[1], 1, Ue, u), p = f[0], _ = f[1];
          else if (Ee(f, -Ue, Ue, u), f)
            p = -(_ = f < 0 ? -f : f);
          else
            throw Error(tn + u + " cannot be zero: " + f);
        if (l.hasOwnProperty(u = "CRYPTO"))
          if (f = l[u], f === !!f)
            if (f)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                y = f;
              else
                throw y = !f, Error(tn + "crypto unavailable");
            else
              y = f;
          else
            throw Error(tn + u + " not true or false: " + f);
        if (l.hasOwnProperty(u = "MODULO_MODE") && (f = l[u], Ee(f, 0, 9, u), w = f), l.hasOwnProperty(u = "POW_PRECISION") && (f = l[u], Ee(f, 0, Ue, u), q = f), l.hasOwnProperty(u = "FORMAT"))
          if (f = l[u], typeof f == "object") k = f;
          else throw Error(tn + u + " not an object: " + f);
        if (l.hasOwnProperty(u = "ALPHABET"))
          if (f = l[u], typeof f == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(f))
            v = f.slice(0, 10) == "0123456789", B = f;
          else
            throw Error(tn + u + " invalid: " + f);
      } else
        throw Error(tn + "Object expected: " + l);
    return {
      DECIMAL_PLACES: i,
      ROUNDING_MODE: d,
      EXPONENTIAL_AT: [m, h],
      RANGE: [p, _],
      CRYPTO: y,
      MODULO_MODE: w,
      POW_PRECISION: q,
      FORMAT: k,
      ALPHABET: B
    };
  }, g.isBigNumber = function(l) {
    if (!l || l._isBigNumber !== !0) return !1;
    if (!g.DEBUG) return !0;
    var u, f, S = l.c, x = l.e, C = l.s;
    e: if ({}.toString.call(S) == "[object Array]") {
      if ((C === 1 || C === -1) && x >= -Ue && x <= Ue && x === pn(x)) {
        if (S[0] === 0) {
          if (x === 0 && S.length === 1) return !0;
          break e;
        }
        if (u = (x + 1) % oe, u < 1 && (u += oe), String(S[0]).length == u) {
          for (u = 0; u < S.length; u++)
            if (f = S[u], f < 0 || f >= wn || f !== pn(f)) break e;
          if (f !== 0) return !0;
        }
      }
    } else if (S === null && x === null && (C === null || C === 1 || C === -1))
      return !0;
    throw Error(tn + "Invalid BigNumber: " + l);
  }, g.maximum = g.max = function() {
    return O(arguments, -1);
  }, g.minimum = g.min = function() {
    return O(arguments, 1);
  }, g.random = function() {
    var l = 9007199254740992, u = Math.random() * l & 2097151 ? function() {
      return pn(Math.random() * l);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(f) {
      var S, x, C, F, A, E = 0, T = [], R = new g(o);
      if (f == null ? f = i : Ee(f, 0, Ue), F = Hm(f / oe), y)
        if (crypto.getRandomValues) {
          for (S = crypto.getRandomValues(new Uint32Array(F *= 2)); E < F; )
            A = S[E] * 131072 + (S[E + 1] >>> 11), A >= 9e15 ? (x = crypto.getRandomValues(new Uint32Array(2)), S[E] = x[0], S[E + 1] = x[1]) : (T.push(A % 1e14), E += 2);
          E = F / 2;
        } else if (crypto.randomBytes) {
          for (S = crypto.randomBytes(F *= 7); E < F; )
            A = (S[E] & 31) * 281474976710656 + S[E + 1] * 1099511627776 + S[E + 2] * 4294967296 + S[E + 3] * 16777216 + (S[E + 4] << 16) + (S[E + 5] << 8) + S[E + 6], A >= 9e15 ? crypto.randomBytes(7).copy(S, E) : (T.push(A % 1e14), E += 7);
          E = F / 7;
        } else
          throw y = !1, Error(tn + "crypto unavailable");
      if (!y)
        for (; E < F; )
          A = u(), A < 9e15 && (T[E++] = A % 1e14);
      for (F = T[--E], f %= oe, F && f && (A = Wm[oe - f], T[E] = pn(F / A) * A); T[E] === 0; T.pop(), E--) ;
      if (E < 0)
        T = [C = 0];
      else {
        for (C = -1; T[0] === 0; T.splice(0, 1), C -= oe) ;
        for (E = 1, A = T[0]; A >= 10; A /= 10, E++) ;
        E < oe && (C -= oe - E);
      }
      return R.e = C, R.c = T, R;
    };
  }(), g.sum = function() {
    for (var l = 1, u = arguments, f = new g(u[0]); l < u.length; ) f = f.plus(u[l++]);
    return f;
  }, t = /* @__PURE__ */ function() {
    var l = "0123456789";
    function u(f, S, x, C) {
      for (var F, A = [0], E, T = 0, R = f.length; T < R; ) {
        for (E = A.length; E--; A[E] *= S) ;
        for (A[0] += C.indexOf(f.charAt(T++)), F = 0; F < A.length; F++)
          A[F] > x - 1 && (A[F + 1] == null && (A[F + 1] = 0), A[F + 1] += A[F] / x | 0, A[F] %= x);
      }
      return A.reverse();
    }
    return function(f, S, x, C, F) {
      var A, E, T, R, P, V, X, Z, ue = f.indexOf("."), ve = i, G = d;
      for (ue >= 0 && (R = q, q = 0, f = f.replace(".", ""), Z = new g(S), V = Z.pow(f.length - ue), q = R, Z.c = u(
        so(mn(V.c), V.e, "0"),
        10,
        x,
        l
      ), Z.e = Z.c.length), X = u(f, S, x, F ? (A = B, l) : (A = l, B)), T = R = X.length; X[--R] == 0; X.pop()) ;
      if (!X[0]) return A.charAt(0);
      if (ue < 0 ? --T : (V.c = X, V.e = T, V.s = C, V = n(V, Z, ve, G, x), X = V.c, P = V.r, T = V.e), E = T + ve + 1, ue = X[E], R = x / 2, P = P || E < 0 || X[E + 1] != null, P = G < 4 ? (ue != null || P) && (G == 0 || G == (V.s < 0 ? 3 : 2)) : ue > R || ue == R && (G == 4 || P || G == 6 && X[E - 1] & 1 || G == (V.s < 0 ? 8 : 7)), E < 1 || !X[0])
        f = P ? so(A.charAt(1), -ve, A.charAt(0)) : A.charAt(0);
      else {
        if (X.length = E, P)
          for (--x; ++X[--E] > x; )
            X[E] = 0, E || (++T, X = [1].concat(X));
        for (R = X.length; !X[--R]; ) ;
        for (ue = 0, f = ""; ue <= R; f += A.charAt(X[ue++])) ;
        f = so(f, T, A.charAt(0));
      }
      return f;
    };
  }(), n = /* @__PURE__ */ function() {
    function l(S, x, C) {
      var F, A, E, T, R = 0, P = S.length, V = x % bo, X = x / bo | 0;
      for (S = S.slice(); P--; )
        E = S[P] % bo, T = S[P] / bo | 0, F = X * E + T * V, A = V * E + F % bo * bo + R, R = (A / C | 0) + (F / bo | 0) + X * T, S[P] = A % C;
      return R && (S = [R].concat(S)), S;
    }
    function u(S, x, C, F) {
      var A, E;
      if (C != F)
        E = C > F ? 1 : -1;
      else
        for (A = E = 0; A < C; A++)
          if (S[A] != x[A]) {
            E = S[A] > x[A] ? 1 : -1;
            break;
          }
      return E;
    }
    function f(S, x, C, F) {
      for (var A = 0; C--; )
        S[C] -= A, A = S[C] < x[C] ? 1 : 0, S[C] = A * F + S[C] - x[C];
      for (; !S[0] && S.length > 1; S.splice(0, 1)) ;
    }
    return function(S, x, C, F, A) {
      var E, T, R, P, V, X, Z, ue, ve, G, ne, le, $e, Ce, cn, Ve, Ge, en = S.s == x.s ? 1 : -1, Ke = S.c, fe = x.c;
      if (!Ke || !Ke[0] || !fe || !fe[0])
        return new g(
          // Return NaN if either NaN, or both Infinity or 0.
          !S.s || !x.s || (Ke ? fe && Ke[0] == fe[0] : !fe) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            Ke && Ke[0] == 0 || !fe ? en * 0 : en / 0
          )
        );
      for (ue = new g(en), ve = ue.c = [], T = S.e - x.e, en = C + T + 1, A || (A = wn, T = ln(S.e / oe) - ln(x.e / oe), en = en / oe | 0), R = 0; fe[R] == (Ke[R] || 0); R++) ;
      if (fe[R] > (Ke[R] || 0) && T--, en < 0)
        ve.push(1), P = !0;
      else {
        for (Ce = Ke.length, Ve = fe.length, R = 0, en += 2, V = pn(A / (fe[0] + 1)), V > 1 && (fe = l(fe, V, A), Ke = l(Ke, V, A), Ve = fe.length, Ce = Ke.length), $e = Ve, G = Ke.slice(0, Ve), ne = G.length; ne < Ve; G[ne++] = 0) ;
        Ge = fe.slice(), Ge = [0].concat(Ge), cn = fe[0], fe[1] >= A / 2 && cn++;
        do {
          if (V = 0, E = u(fe, G, Ve, ne), E < 0) {
            if (le = G[0], Ve != ne && (le = le * A + (G[1] || 0)), V = pn(le / cn), V > 1)
              for (V >= A && (V = A - 1), X = l(fe, V, A), Z = X.length, ne = G.length; u(X, G, Z, ne) == 1; )
                V--, f(X, Ve < Z ? Ge : fe, Z, A), Z = X.length, E = 1;
            else
              V == 0 && (E = V = 1), X = fe.slice(), Z = X.length;
            if (Z < ne && (X = [0].concat(X)), f(G, X, ne, A), ne = G.length, E == -1)
              for (; u(fe, G, Ve, ne) < 1; )
                V++, f(G, Ve < ne ? Ge : fe, ne, A), ne = G.length;
          } else E === 0 && (V++, G = [0]);
          ve[R++] = V, G[0] ? G[ne++] = Ke[$e] || 0 : (G = [Ke[$e]], ne = 1);
        } while (($e++ < Ce || G[0] != null) && en--);
        P = G[0] != null, ve[0] || ve.splice(0, 1);
      }
      if (A == wn) {
        for (R = 1, en = ve[0]; en >= 10; en /= 10, R++) ;
        M(ue, C + (ue.e = R + T * oe - 1) + 1, F, P);
      } else
        ue.e = T, ue.r = +P;
      return ue;
    };
  }();
  function b(l, u, f, S) {
    var x, C, F, A, E;
    if (f == null ? f = d : Ee(f, 0, 8), !l.c) return l.toString();
    if (x = l.c[0], F = l.e, u == null)
      E = mn(l.c), E = S == 1 || S == 2 && (F <= m || F >= h) ? Bd(E, F) : so(E, F, "0");
    else if (l = M(new g(l), u, f), C = l.e, E = mn(l.c), A = E.length, S == 1 || S == 2 && (u <= C || C <= m)) {
      for (; A < u; E += "0", A++) ;
      E = Bd(E, C);
    } else if (u -= F, E = so(E, C, "0"), C + 1 > A) {
      if (--u > 0) for (E += "."; u--; E += "0") ;
    } else if (u += C - A, u > 0)
      for (C + 1 == A && (E += "."); u--; E += "0") ;
    return l.s < 0 && x ? "-" + E : E;
  }
  function O(l, u) {
    for (var f, S, x = 1, C = new g(l[0]); x < l.length; x++)
      S = new g(l[x]), (!S.s || (f = So(C, S)) === u || f === 0 && C.s === u) && (C = S);
    return C;
  }
  function D(l, u, f) {
    for (var S = 1, x = u.length; !u[--x]; u.pop()) ;
    for (x = u[0]; x >= 10; x /= 10, S++) ;
    return (f = S + f * oe - 1) > _ ? l.c = l.e = null : f < p ? l.c = [l.e = 0] : (l.e = f, l.c = u), l;
  }
  s = /* @__PURE__ */ function() {
    var l = /^(-?)0([xbo])(?=\w[\w.]*$)/i, u = /^([^.]+)\.$/, f = /^\.([^.]+)$/, S = /^-?(Infinity|NaN)$/, x = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(C, F, A, E) {
      var T, R = A ? F : F.replace(x, "");
      if (S.test(R))
        C.s = isNaN(R) ? null : R < 0 ? -1 : 1;
      else {
        if (!A && (R = R.replace(l, function(P, V, X) {
          return T = (X = X.toLowerCase()) == "x" ? 16 : X == "b" ? 2 : 8, !E || E == T ? V : P;
        }), E && (T = E, R = R.replace(u, "$1").replace(f, "0.$1")), F != R))
          return new g(R, T);
        if (g.DEBUG)
          throw Error(tn + "Not a" + (E ? " base " + E : "") + " number: " + F);
        C.s = null;
      }
      C.c = C.e = null;
    };
  }();
  function M(l, u, f, S) {
    var x, C, F, A, E, T, R, P = l.c, V = Wm;
    if (P) {
      e: {
        for (x = 1, A = P[0]; A >= 10; A /= 10, x++) ;
        if (C = u - x, C < 0)
          C += oe, F = u, E = P[T = 0], R = pn(E / V[x - F - 1] % 10);
        else if (T = Hm((C + 1) / oe), T >= P.length)
          if (S) {
            for (; P.length <= T; P.push(0)) ;
            E = R = 0, x = 1, C %= oe, F = C - oe + 1;
          } else
            break e;
        else {
          for (E = A = P[T], x = 1; A >= 10; A /= 10, x++) ;
          C %= oe, F = C - oe + x, R = F < 0 ? 0 : pn(E / V[x - F - 1] % 10);
        }
        if (S = S || u < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        P[T + 1] != null || (F < 0 ? E : E % V[x - F - 1]), S = f < 4 ? (R || S) && (f == 0 || f == (l.s < 0 ? 3 : 2)) : R > 5 || R == 5 && (f == 4 || S || f == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (C > 0 ? F > 0 ? E / V[x - F] : 0 : P[T - 1]) % 10 & 1 || f == (l.s < 0 ? 8 : 7)), u < 1 || !P[0])
          return P.length = 0, S ? (u -= l.e + 1, P[0] = V[(oe - u % oe) % oe], l.e = -u || 0) : P[0] = l.e = 0, l;
        if (C == 0 ? (P.length = T, A = 1, T--) : (P.length = T + 1, A = V[oe - C], P[T] = F > 0 ? pn(E / V[x - F] % V[F]) * A : 0), S)
          for (; ; )
            if (T == 0) {
              for (C = 1, F = P[0]; F >= 10; F /= 10, C++) ;
              for (F = P[0] += A, A = 1; F >= 10; F /= 10, A++) ;
              C != A && (l.e++, P[0] == wn && (P[0] = 1));
              break;
            } else {
              if (P[T] += A, P[T] != wn) break;
              P[T--] = 0, A = 1;
            }
        for (C = P.length; P[--C] === 0; P.pop()) ;
      }
      l.e > _ ? l.c = l.e = null : l.e < p && (l.c = [l.e = 0]);
    }
    return l;
  }
  function N(l) {
    var u, f = l.e;
    return f === null ? l.toString() : (u = mn(l.c), u = f <= m || f >= h ? Bd(u, f) : so(u, f, "0"), l.s < 0 ? "-" + u : u);
  }
  return a.absoluteValue = a.abs = function() {
    var l = new g(this);
    return l.s < 0 && (l.s = 1), l;
  }, a.comparedTo = function(l, u) {
    return So(this, new g(l, u));
  }, a.decimalPlaces = a.dp = function(l, u) {
    var f, S, x, C = this;
    if (l != null)
      return Ee(l, 0, Ue), u == null ? u = d : Ee(u, 0, 8), M(new g(C), l + C.e + 1, u);
    if (!(f = C.c)) return null;
    if (S = ((x = f.length - 1) - ln(this.e / oe)) * oe, x = f[x]) for (; x % 10 == 0; x /= 10, S--) ;
    return S < 0 && (S = 0), S;
  }, a.dividedBy = a.div = function(l, u) {
    return n(this, new g(l, u), i, d);
  }, a.dividedToIntegerBy = a.idiv = function(l, u) {
    return n(this, new g(l, u), 0, 1);
  }, a.exponentiatedBy = a.pow = function(l, u) {
    var f, S, x, C, F, A, E, T, R, P = this;
    if (l = new g(l), l.c && !l.isInteger())
      throw Error(tn + "Exponent not an integer: " + N(l));
    if (u != null && (u = new g(u)), A = l.e > 14, !P.c || !P.c[0] || P.c[0] == 1 && !P.e && P.c.length == 1 || !l.c || !l.c[0])
      return R = new g(Math.pow(+N(P), A ? l.s * (2 - Dd(l)) : +N(l))), u ? R.mod(u) : R;
    if (E = l.s < 0, u) {
      if (u.c ? !u.c[0] : !u.s) return new g(NaN);
      S = !E && P.isInteger() && u.isInteger(), S && (P = P.mod(u));
    } else {
      if (l.e > 9 && (P.e > 0 || P.e < -1 || (P.e == 0 ? P.c[0] > 1 || A && P.c[1] >= 24e7 : P.c[0] < 8e13 || A && P.c[0] <= 9999975e7)))
        return C = P.s < 0 && Dd(l) ? -0 : 0, P.e > -1 && (C = 1 / C), new g(E ? 1 / C : C);
      q && (C = Hm(q / oe + 2));
    }
    for (A ? (f = new g(0.5), E && (l.s = 1), T = Dd(l)) : (x = Math.abs(+N(l)), T = x % 2), R = new g(o); ; ) {
      if (T) {
        if (R = R.times(P), !R.c) break;
        C ? R.c.length > C && (R.c.length = C) : S && (R = R.mod(u));
      }
      if (x) {
        if (x = pn(x / 2), x === 0) break;
        T = x % 2;
      } else if (l = l.times(f), M(l, l.e + 1, 1), l.e > 14)
        T = Dd(l);
      else {
        if (x = +N(l), x === 0) break;
        T = x % 2;
      }
      P = P.times(P), C ? P.c && P.c.length > C && (P.c.length = C) : S && (P = P.mod(u));
    }
    return S ? R : (E && (R = o.div(R)), u ? R.mod(u) : C ? M(R, q, d, F) : R);
  }, a.integerValue = function(l) {
    var u = new g(this);
    return l == null ? l = d : Ee(l, 0, 8), M(u, u.e + 1, l);
  }, a.isEqualTo = a.eq = function(l, u) {
    return So(this, new g(l, u)) === 0;
  }, a.isFinite = function() {
    return !!this.c;
  }, a.isGreaterThan = a.gt = function(l, u) {
    return So(this, new g(l, u)) > 0;
  }, a.isGreaterThanOrEqualTo = a.gte = function(l, u) {
    return (u = So(this, new g(l, u))) === 1 || u === 0;
  }, a.isInteger = function() {
    return !!this.c && ln(this.e / oe) > this.c.length - 2;
  }, a.isLessThan = a.lt = function(l, u) {
    return So(this, new g(l, u)) < 0;
  }, a.isLessThanOrEqualTo = a.lte = function(l, u) {
    return (u = So(this, new g(l, u))) === -1 || u === 0;
  }, a.isNaN = function() {
    return !this.s;
  }, a.isNegative = function() {
    return this.s < 0;
  }, a.isPositive = function() {
    return this.s > 0;
  }, a.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, a.minus = function(l, u) {
    var f, S, x, C, F = this, A = F.s;
    if (l = new g(l, u), u = l.s, !A || !u) return new g(NaN);
    if (A != u)
      return l.s = -u, F.plus(l);
    var E = F.e / oe, T = l.e / oe, R = F.c, P = l.c;
    if (!E || !T) {
      if (!R || !P) return R ? (l.s = -u, l) : new g(P ? F : NaN);
      if (!R[0] || !P[0])
        return P[0] ? (l.s = -u, l) : new g(R[0] ? F : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          d == 3 ? -0 : 0
        ));
    }
    if (E = ln(E), T = ln(T), R = R.slice(), A = E - T) {
      for ((C = A < 0) ? (A = -A, x = R) : (T = E, x = P), x.reverse(), u = A; u--; x.push(0)) ;
      x.reverse();
    } else
      for (S = (C = (A = R.length) < (u = P.length)) ? A : u, A = u = 0; u < S; u++)
        if (R[u] != P[u]) {
          C = R[u] < P[u];
          break;
        }
    if (C && (x = R, R = P, P = x, l.s = -l.s), u = (S = P.length) - (f = R.length), u > 0) for (; u--; R[f++] = 0) ;
    for (u = wn - 1; S > A; ) {
      if (R[--S] < P[S]) {
        for (f = S; f && !R[--f]; R[f] = u) ;
        --R[f], R[S] += wn;
      }
      R[S] -= P[S];
    }
    for (; R[0] == 0; R.splice(0, 1), --T) ;
    return R[0] ? D(l, R, T) : (l.s = d == 3 ? -1 : 1, l.c = [l.e = 0], l);
  }, a.modulo = a.mod = function(l, u) {
    var f, S, x = this;
    return l = new g(l, u), !x.c || !l.s || l.c && !l.c[0] ? new g(NaN) : !l.c || x.c && !x.c[0] ? new g(x) : (w == 9 ? (S = l.s, l.s = 1, f = n(x, l, 0, 3), l.s = S, f.s *= S) : f = n(x, l, 0, w), l = x.minus(f.times(l)), !l.c[0] && w == 1 && (l.s = x.s), l);
  }, a.multipliedBy = a.times = function(l, u) {
    var f, S, x, C, F, A, E, T, R, P, V, X, Z, ue, ve, G = this, ne = G.c, le = (l = new g(l, u)).c;
    if (!ne || !le || !ne[0] || !le[0])
      return !G.s || !l.s || ne && !ne[0] && !le || le && !le[0] && !ne ? l.c = l.e = l.s = null : (l.s *= G.s, !ne || !le ? l.c = l.e = null : (l.c = [0], l.e = 0)), l;
    for (S = ln(G.e / oe) + ln(l.e / oe), l.s *= G.s, E = ne.length, P = le.length, E < P && (Z = ne, ne = le, le = Z, x = E, E = P, P = x), x = E + P, Z = []; x--; Z.push(0)) ;
    for (ue = wn, ve = bo, x = P; --x >= 0; ) {
      for (f = 0, V = le[x] % ve, X = le[x] / ve | 0, F = E, C = x + F; C > x; )
        T = ne[--F] % ve, R = ne[F] / ve | 0, A = X * T + R * V, T = V * T + A % ve * ve + Z[C] + f, f = (T / ue | 0) + (A / ve | 0) + X * R, Z[C--] = T % ue;
      Z[C] = f;
    }
    return f ? ++S : Z.splice(0, 1), D(l, Z, S);
  }, a.negated = function() {
    var l = new g(this);
    return l.s = -l.s || null, l;
  }, a.plus = function(l, u) {
    var f, S = this, x = S.s;
    if (l = new g(l, u), u = l.s, !x || !u) return new g(NaN);
    if (x != u)
      return l.s = -u, S.minus(l);
    var C = S.e / oe, F = l.e / oe, A = S.c, E = l.c;
    if (!C || !F) {
      if (!A || !E) return new g(x / 0);
      if (!A[0] || !E[0]) return E[0] ? l : new g(A[0] ? S : x * 0);
    }
    if (C = ln(C), F = ln(F), A = A.slice(), x = C - F) {
      for (x > 0 ? (F = C, f = E) : (x = -x, f = A), f.reverse(); x--; f.push(0)) ;
      f.reverse();
    }
    for (x = A.length, u = E.length, x - u < 0 && (f = E, E = A, A = f, u = x), x = 0; u; )
      x = (A[--u] = A[u] + E[u] + x) / wn | 0, A[u] = wn === A[u] ? 0 : A[u] % wn;
    return x && (A = [x].concat(A), ++F), D(l, A, F);
  }, a.precision = a.sd = function(l, u) {
    var f, S, x, C = this;
    if (l != null && l !== !!l)
      return Ee(l, 1, Ue), u == null ? u = d : Ee(u, 0, 8), M(new g(C), l, u);
    if (!(f = C.c)) return null;
    if (x = f.length - 1, S = x * oe + 1, x = f[x]) {
      for (; x % 10 == 0; x /= 10, S--) ;
      for (x = f[0]; x >= 10; x /= 10, S++) ;
    }
    return l && C.e + 1 > S && (S = C.e + 1), S;
  }, a.shiftedBy = function(l) {
    return Ee(l, -Lm, Lm), this.times("1e" + l);
  }, a.squareRoot = a.sqrt = function() {
    var l, u, f, S, x, C = this, F = C.c, A = C.s, E = C.e, T = i + 4, R = new g("0.5");
    if (A !== 1 || !F || !F[0])
      return new g(!A || A < 0 && (!F || F[0]) ? NaN : F ? C : 1 / 0);
    if (A = Math.sqrt(+N(C)), A == 0 || A == 1 / 0 ? (u = mn(F), (u.length + E) % 2 == 0 && (u += "0"), A = Math.sqrt(+u), E = ln((E + 1) / 2) - (E < 0 || E % 2), A == 1 / 0 ? u = "5e" + E : (u = A.toExponential(), u = u.slice(0, u.indexOf("e") + 1) + E), f = new g(u)) : f = new g(A + ""), f.c[0]) {
      for (E = f.e, A = E + T, A < 3 && (A = 0); ; )
        if (x = f, f = R.times(x.plus(n(C, x, T, 1))), mn(x.c).slice(0, A) === (u = mn(f.c)).slice(0, A))
          if (f.e < E && --A, u = u.slice(A - 3, A + 1), u == "9999" || !S && u == "4999") {
            if (!S && (M(x, x.e + i + 2, 0), x.times(x).eq(C))) {
              f = x;
              break;
            }
            T += 4, A += 4, S = 1;
          } else {
            (!+u || !+u.slice(1) && u.charAt(0) == "5") && (M(f, f.e + i + 2, 1), l = !f.times(f).eq(C));
            break;
          }
    }
    return M(f, f.e + i + 1, d, l);
  }, a.toExponential = function(l, u) {
    return l != null && (Ee(l, 0, Ue), l++), b(this, l, u, 1);
  }, a.toFixed = function(l, u) {
    return l != null && (Ee(l, 0, Ue), l = l + this.e + 1), b(this, l, u);
  }, a.toFormat = function(l, u, f) {
    var S, x = this;
    if (f == null)
      l != null && u && typeof u == "object" ? (f = u, u = null) : l && typeof l == "object" ? (f = l, l = u = null) : f = k;
    else if (typeof f != "object")
      throw Error(tn + "Argument not an object: " + f);
    if (S = x.toFixed(l, u), x.c) {
      var C, F = S.split("."), A = +f.groupSize, E = +f.secondaryGroupSize, T = f.groupSeparator || "", R = F[0], P = F[1], V = x.s < 0, X = V ? R.slice(1) : R, Z = X.length;
      if (E && (C = A, A = E, E = C, Z -= C), A > 0 && Z > 0) {
        for (C = Z % A || A, R = X.substr(0, C); C < Z; C += A) R += T + X.substr(C, A);
        E > 0 && (R += T + X.slice(C)), V && (R = "-" + R);
      }
      S = P ? R + (f.decimalSeparator || "") + ((E = +f.fractionGroupSize) ? P.replace(
        new RegExp("\\d{" + E + "}\\B", "g"),
        "$&" + (f.fractionGroupSeparator || "")
      ) : P) : R;
    }
    return (f.prefix || "") + S + (f.suffix || "");
  }, a.toFraction = function(l) {
    var u, f, S, x, C, F, A, E, T, R, P, V, X = this, Z = X.c;
    if (l != null && (A = new g(l), !A.isInteger() && (A.c || A.s !== 1) || A.lt(o)))
      throw Error(tn + "Argument " + (A.isInteger() ? "out of range: " : "not an integer: ") + N(A));
    if (!Z) return new g(X);
    for (u = new g(o), T = f = new g(o), S = E = new g(o), V = mn(Z), C = u.e = V.length - X.e - 1, u.c[0] = Wm[(F = C % oe) < 0 ? oe + F : F], l = !l || A.comparedTo(u) > 0 ? C > 0 ? u : T : A, F = _, _ = 1 / 0, A = new g(V), E.c[0] = 0; R = n(A, u, 0, 1), x = f.plus(R.times(S)), x.comparedTo(l) != 1; )
      f = S, S = x, T = E.plus(R.times(x = T)), E = x, u = A.minus(R.times(x = u)), A = x;
    return x = n(l.minus(f), S, 0, 1), E = E.plus(x.times(T)), f = f.plus(x.times(S)), E.s = T.s = X.s, C = C * 2, P = n(T, S, C, d).minus(X).abs().comparedTo(
      n(E, f, C, d).minus(X).abs()
    ) < 1 ? [T, S] : [E, f], _ = F, P;
  }, a.toNumber = function() {
    return +N(this);
  }, a.toPrecision = function(l, u) {
    return l != null && Ee(l, 1, Ue), b(this, l, u, 2);
  }, a.toString = function(l) {
    var u, f = this, S = f.s, x = f.e;
    return x === null ? S ? (u = "Infinity", S < 0 && (u = "-" + u)) : u = "NaN" : (l == null ? u = x <= m || x >= h ? Bd(mn(f.c), x) : so(mn(f.c), x, "0") : l === 10 && v ? (f = M(new g(f), i + x + 1, d), u = so(mn(f.c), f.e, "0")) : (Ee(l, 2, B.length, "Base"), u = t(so(mn(f.c), x, "0"), 10, l, S, !0)), S < 0 && f.c[0] && (u = "-" + u)), u;
  }, a.valueOf = a.toJSON = function() {
    return N(this);
  }, a._isBigNumber = !0, a[Symbol.toStringTag] = "BigNumber", a[Symbol.for("nodejs.util.inspect.custom")] = a.valueOf, e != null && g.set(e), g;
}
function ln(e) {
  var n = e | 0;
  return e > 0 || e === n ? n : n - 1;
}
function mn(e) {
  for (var n, t, s = 1, a = e.length, o = e[0] + ""; s < a; ) {
    for (n = e[s++] + "", t = oe - n.length; t--; n = "0" + n) ;
    o += n;
  }
  for (a = o.length; o.charCodeAt(--a) === 48; ) ;
  return o.slice(0, a + 1 || 1);
}
function So(e, n) {
  var t, s, a = e.c, o = n.c, i = e.s, d = n.s, m = e.e, h = n.e;
  if (!i || !d) return null;
  if (t = a && !a[0], s = o && !o[0], t || s) return t ? s ? 0 : -d : i;
  if (i != d) return i;
  if (t = i < 0, s = m == h, !a || !o) return s ? 0 : !a ^ t ? 1 : -1;
  if (!s) return m > h ^ t ? 1 : -1;
  for (d = (m = a.length) < (h = o.length) ? m : h, i = 0; i < d; i++) if (a[i] != o[i]) return a[i] > o[i] ^ t ? 1 : -1;
  return m == h ? 0 : m > h ^ t ? 1 : -1;
}
function Ee(e, n, t, s) {
  if (e < n || e > t || e !== pn(e))
    throw Error(tn + (s || "Argument") + (typeof e == "number" ? e < n || e > t ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
}
function Dd(e) {
  var n = e.c.length - 1;
  return ln(e.e / oe) == n && e.c[n] % 2 != 0;
}
function Bd(e, n) {
  return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (n < 0 ? "e" : "e+") + n;
}
function so(e, n, t) {
  var s, a;
  if (n < 0) {
    for (a = t + "."; ++n; a += t) ;
    e = a + e;
  } else if (s = e.length, ++n > s) {
    for (a = t, n -= s; --n; a += t) ;
    e += a;
  } else n < s && (e = e.slice(0, n) + "." + e.slice(n));
  return e;
}
var io = dj();
function $ce(e) {
  const n = e.toString().split(".");
  return n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), n.join(".");
}
function Vm(e) {
  return e.toString().replace(/,/g, "");
}
function Qd(e) {
  if (typeof e == "string") {
    const [a, o] = e.split(".");
    return o === void 0 || o.length <= 6 ? e : a + "." + o.slice(0, 6);
  }
  if (isNaN(e)) return "";
  const t = Math.pow(10, 6);
  return (Math.floor(e * t) / t).toString();
}
function mj(e, n, t) {
  const s = io(e), o = io(n).minus(s).dividedBy(s).multipliedBy(100);
  return t ? o.absoluteValue().toFixed(0) : o.toFixed(0);
}
const hj = (e) => {
  if (e)
    return e < 60 ? `${e} ${cd("sec", e)}` : e < 3600 ? `${Math.round(e / 60)} ${cd(
      "min",
      Math.round(e / 60)
    )}` : `${Math.round(e / 3600)} ${cd(
      "hr",
      Math.round(e / 3600)
    )}`;
}, Rr = W(J).attrs({
  as: "button"
})`
  ${yd};
  line-height: 13px;
  height: 30px;

  ${({ alwaysShowBackground: e, theme: n, secondary: t }) => {
  if (e)
    return Ye`
        background-color: ${t ? n.secondary.background.normal : n.primary.ghostButtonHover};
      `;
}}

  ${({ onClick: e, disabled: n, secondary: t, theme: s }) => {
  if (e && !n)
    return Ye`
          &:hover {
            background-color: ${t ? s.secondary.background.normal : s.primary.ghostButtonHover};
            color: ${s.primary.text.normal};
            cursor: pointer;
          }
        `;
}}
 
  padding: 8px 16px;
  border-radius: 90px;
  ${Bw};
`, jn = W.button`
  ${yd}
  line - height: initial;
  ${({ disabled: e }) => e ? Ye`
          &:hover {
            cursor: not-allowed;
          }
        ` : Ye`
          &:hover {
            cursor: pointer;
          }
        `}

  ${Bw};
`, em = W(jn).attrs({
  as: "a"
})`
  text-decoration: none;
`, no = ({
  leftButton: e,
  rightButton: n,
  rightContent: t
}) => {
  const s = hd[(e == null ? void 0 : e.icon) || ae.none], a = hd[(n == null ? void 0 : n.icon) || ae.none];
  return /* @__PURE__ */ c.jsxs(zce, { justify: "space-between", children: [
    /* @__PURE__ */ c.jsx(Y, { align: "center", gap: 10, children: e && /* @__PURE__ */ c.jsxs(Rr, { gap: 5, align: "center", onClick: e.onClick, children: [
      /* @__PURE__ */ c.jsx(s, {}),
      e.label
    ] }) }),
    /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 10, children: [
      t,
      n && /* @__PURE__ */ c.jsxs(Rr, { gap: 5, align: "center", onClick: n.onClick, children: [
        n.label,
        /* @__PURE__ */ c.jsx(a, {})
      ] })
    ] })
  ] });
}, zce = W(Y)`
  height: 30px;
`, qce = ({
  onClickContinue: e,
  onClickBack: n,
  route: t
}) => {
  const s = je(), {
    amountIn: a,
    amountOut: o,
    usdAmountIn: i,
    usdAmountOut: d,
    sourceAssetDenom: m,
    sourceAssetChainID: h,
    destAssetDenom: p,
    destAssetChainID: _
  } = t, y = `${mj(
    i ?? 0,
    d ?? 0,
    !0
  )}%`, w = an({
    assetDenom: m,
    chainId: h,
    tokenAmount: a
  }), q = an({
    assetDenom: p,
    chainId: _,
    tokenAmount: o
  });
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      no,
      {
        leftButton: {
          label: "Back",
          icon: ae.thinArrow,
          onClick: n
        }
      }
    ),
    /* @__PURE__ */ c.jsx(
      mc,
      {
        title: `Warning: Bad trade (-${y})`,
        description: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
          /* @__PURE__ */ c.jsxs(J, { color: s.error.text, textAlign: "center", textWrap: "balance", children: [
            "You will lose ~",
            y,
            " of your input value with this trade",
            /* @__PURE__ */ c.jsx("br", {}),
            "Input: ",
            w == null ? void 0 : w.amount,
            " ",
            w == null ? void 0 : w.symbol,
            " (",
            i,
            ")",
            /* @__PURE__ */ c.jsx("br", {}),
            "Estimated output: ~",
            q == null ? void 0 : q.amount,
            " ",
            q == null ? void 0 : q.symbol,
            " (",
            d,
            ")"
          ] }),
          /* @__PURE__ */ c.jsx(
            bd,
            {
              onClick: e,
              color: s.primary.text.lowContrast,
              children: "I know the risk, continue anyway"
            }
          )
        ] }),
        icon: ae.triangleWarning,
        backgroundColor: s.error.background,
        textColor: s.error.text
      }
    ),
    /* @__PURE__ */ c.jsx(
      De,
      {
        label: "Back",
        icon: ae.leftArrow,
        onClick: n,
        backgroundColor: s.error.text
      }
    )
  ] });
}, Sce = ({
  onClickBack: e
}) => {
  const n = pe(sn), t = je(), s = () => {
    n(void 0), e && e();
  };
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      no,
      {
        leftButton: {
          label: "Back",
          icon: ae.thinArrow,
          onClick: s
        }
      }
    ),
    /* @__PURE__ */ c.jsx(
      mc,
      {
        title: "Transaction failed",
        description: "User rejected authentication request",
        icon: ae.triangleWarning,
        backgroundColor: t.error.background,
        textColor: t.error.text
      }
    ),
    /* @__PURE__ */ c.jsx(
      De,
      {
        label: "Back",
        icon: ae.leftArrow,
        onClick: s,
        backgroundColor: t.error.text
      }
    )
  ] });
}, Or = ({
  color: e = "currentColor",
  ...n
}) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M3.28732 11.1042C3.1309 11.2606 2.93332 11.273 2.69458 11.1413C2.45584 11.0095 2.25826 10.8655 2.10184 10.7091C1.94542 10.5526 1.80136 10.3551 1.66963 10.1163C1.53791 9.87758 1.55026 9.68 1.70668 9.52359L5.36191 5.75722C5.09023 5.68313 4.79592 5.64814 4.47897 5.65226C4.16202 5.65637 3.89652 5.76134 3.68248 5.96715L0.916362 8.73327C0.603525 9.0461 0.459458 9.46596 0.484156 9.99284C0.508854 10.5197 0.677618 10.9396 0.990454 11.2524L1.5585 11.8081C1.87133 12.1209 2.29118 12.2918 2.81807 12.3206C3.34495 12.3494 3.7648 12.2074 4.07764 11.8945L6.84375 9.12843C7.0578 8.92261 7.16276 8.65712 7.15865 8.33193C7.15453 8.00675 7.11954 7.71244 7.05368 7.449L3.28732 11.1042ZM12.2895 1.07705L11.7339 0.509009C11.421 0.196173 11.0012 0.0274085 10.4743 0.00271077C9.9474 -0.0219869 9.52755 0.12208 9.21471 0.434916L6.4486 3.20103C6.24278 3.41508 6.13782 3.68057 6.1337 3.99753C6.12959 4.31448 6.16457 4.60467 6.23867 4.86811L10.005 1.22524C10.1614 1.06882 10.359 1.05647 10.5978 1.18819C10.8365 1.31991 11.0341 1.46398 11.1905 1.6204C11.3469 1.77681 11.491 1.97439 11.6227 2.21313C11.7544 2.45188 11.7421 2.64946 11.5857 2.80587L7.93044 6.57224C8.19388 6.6381 8.48819 6.67309 8.81338 6.6772C9.13856 6.68132 9.40406 6.57635 9.60987 6.36231L12.376 3.59619C12.6888 3.28336 12.8308 2.8635 12.802 2.33662C12.7732 1.80974 12.6024 1.38989 12.2895 1.07705ZM7.91809 4.89281C7.83577 4.81872 7.73904 4.78167 7.6279 4.78167C7.51676 4.78167 7.42415 4.81872 7.35005 4.89281L5.37425 6.86861C5.29193 6.95093 5.25077 7.04766 5.25077 7.1588C5.25077 7.26994 5.29193 7.36256 5.37425 7.43665C5.44835 7.51897 5.54096 7.56014 5.6521 7.56014C5.76324 7.56014 5.85585 7.51897 5.92995 7.43665L7.91809 5.46085C7.99219 5.38676 8.02923 5.29414 8.02923 5.18301C8.02923 5.07187 7.99219 4.97513 7.91809 4.89281Z",
        fill: e
      }
    )
  }
);
var Je = /* @__PURE__ */ ((e) => (e[e.SwapPage = 0] = "SwapPage", e[e.SwapExecutionPage = 1] = "SwapExecutionPage", e[e.TransactionHistoryPage = 2] = "TransactionHistoryPage", e))(Je || {});
const uo = me(
  0
  /* SwapPage */
), Tce = ({
  transactionHash: e,
  explorerLink: n,
  onClickContactSupport: t,
  onClickBack: s
}) => {
  const a = je(), o = pe(sn), i = pe(uo);
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      no,
      {
        leftButton: {
          label: "Back",
          icon: ae.thinArrow,
          onClick: () => {
            o(void 0), s && s(), i(Je.SwapPage);
          }
        }
      }
    ),
    /* @__PURE__ */ c.jsx(
      mc,
      {
        title: "Transaction failed",
        description: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
          /* @__PURE__ */ c.jsxs(J, { color: a.error.text, textAlign: "center", textWrap: "balance", children: [
            "This transaction encountered a critical error. ",
            /* @__PURE__ */ c.jsx("br", {}),
            "Please contact our support team below."
          ] }),
          /* @__PURE__ */ c.jsxs(
            Y,
            {
              as: bd,
              gap: 5,
              onClick: () => window.open(n, "_blank"),
              color: a.primary.text.lowContrast,
              children: [
                "Transaction: ",
                /* @__PURE__ */ c.jsx("u", { children: $c(e) }),
                /* @__PURE__ */ c.jsx(Or, { color: a.primary.text.lowContrast })
              ]
            }
          )
        ] }),
        icon: ae.triangleWarning,
        backgroundColor: a.error.background,
        textColor: a.error.text
      }
    ),
    /* @__PURE__ */ c.jsx(
      De,
      {
        label: "Contact support",
        icon: ae.rightArrow,
        onClick: t,
        backgroundColor: a.error.text
      }
    )
  ] });
}, Rce = ({ error: e, onClickBack: n }) => {
  const t = je(), s = pe(sn), a = pe(uo), o = () => {
    s(void 0), a(Je.SwapPage);
  };
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      no,
      {
        leftButton: {
          label: "Back",
          icon: ae.thinArrow,
          onClick: () => {
            s(void 0), n && n(), a(Je.SwapPage);
          }
        }
      }
    ),
    /* @__PURE__ */ c.jsx(
      mc,
      {
        title: "An unexpected error has occurred",
        description: e == null ? void 0 : e.message,
        icon: ae.triangleWarning,
        backgroundColor: t.error.background,
        textColor: t.error.text
      }
    ),
    /* @__PURE__ */ c.jsx(
      De,
      {
        label: "Retry",
        icon: ae.rightArrow,
        onClick: o,
        backgroundColor: t.error.text
      }
    )
  ] });
}, Oce = ({
  explorerLink: e,
  onClickBack: n
}) => {
  const t = je(), s = pe(sn), a = pe(uo);
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      no,
      {
        leftButton: {
          label: "Back",
          icon: ae.thinArrow,
          onClick: () => {
            s(void 0), n && n(), a(Je.SwapPage);
          }
        }
      }
    ),
    /* @__PURE__ */ c.jsx(
      mc,
      {
        title: "Sorry, your transaction is taking longer than usual.",
        description: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
          /* @__PURE__ */ c.jsxs(J, { color: t.warning.text, textAlign: "center", textWrap: "balance", children: [
            "Your funds are secure.",
            /* @__PURE__ */ c.jsx("br", {}),
            "You can close this window safely while you wait.",
            /* @__PURE__ */ c.jsx("br", {}),
            "Check the history page for status updates."
          ] }),
          /* @__PURE__ */ c.jsxs(
            Y,
            {
              gap: 5,
              align: "center",
              as: bd,
              onClick: () => window.open(e, "_blank"),
              color: t.primary.text.lowContrast,
              children: [
                /* @__PURE__ */ c.jsx(Or, { color: t.primary.text.lowContrast }),
                "View on mintscan"
              ]
            }
          )
        ] }),
        icon: ae.warning,
        backgroundColor: t.warning.background,
        textColor: t.warning.text
      }
    ),
    /* @__PURE__ */ c.jsx(De, { label: "Swap in progress...", loading: !0 })
  ] });
}, Mce = ({
  onClickSign: e,
  route: n,
  onClickBack: t
}) => {
  const { amountIn: s, amountOut: a, sourceAssetDenom: o, destAssetDenom: i } = n, d = an({
    assetDenom: o,
    tokenAmount: s
  }), m = an({
    assetDenom: i,
    tokenAmount: a
  });
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      no,
      {
        leftButton: {
          label: "Back",
          icon: ae.thinArrow,
          onClick: t
        }
      }
    ),
    /* @__PURE__ */ c.jsx(
      mc,
      {
        title: /* @__PURE__ */ c.jsxs(Te, { children: [
          "Transaction requires an",
          /* @__PURE__ */ c.jsx("br", {}),
          "additional signing step"
        ] }),
        description: /* @__PURE__ */ c.jsxs(J, { textWrap: "balance", children: [
          d.amount,
          " ",
          d.symbol,
          " ",
          " -> ",
          m.amount,
          " ",
          m.symbol
        ] }),
        icon: ae.signature
      }
    ),
    /* @__PURE__ */ c.jsx(
      De,
      {
        label: "Authorize in wallet",
        icon: ae.rightArrow,
        onClick: e
      }
    )
  ] });
}, Ice = ({
  explorerUrl: e,
  revertedOperation: n,
  recoveryAddress: t,
  onClickContinueTransaction: s,
  onClickBack: a
}) => {
  const o = pe(sn), i = pe(uo), d = je(), m = n.denomIn ?? n.denom, h = an({
    assetDenom: m,
    tokenAmount: n.amountIn,
    chainId: (n == null ? void 0 : n.fromChainID) ?? n.chainID
  });
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      no,
      {
        leftButton: {
          label: "Back",
          icon: ae.thinArrow,
          onClick: () => {
            o(void 0), a && a(), i(Je.SwapPage);
          }
        }
      }
    ),
    /* @__PURE__ */ c.jsx(
      mc,
      {
        title: "Action Required",
        description: /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
          /* @__PURE__ */ c.jsxs(J, { color: d.warning.text, textAlign: "center", textWrap: "balance", children: [
            "This transaction reverted while trying to execute.",
            /* @__PURE__ */ c.jsx("br", {}),
            "You can continue executing this transaction now."
          ] }),
          /* @__PURE__ */ c.jsxs(
            J,
            {
              color: d.primary.text.lowContrast,
              textAlign: "center",
              textWrap: "balance",
              children: [
                "Current asset location: ",
                h == null ? void 0 : h.amount,
                " ",
                h == null ? void 0 : h.symbol,
                " on ",
                h == null ? void 0 : h.chainName,
                " (",
                t,
                ")"
              ]
            }
          ),
          /* @__PURE__ */ c.jsx(Y, { gap: 25, justify: "center", children: /* @__PURE__ */ c.jsxs(
            Y,
            {
              gap: 5,
              align: "center",
              as: bd,
              onClick: () => window.open(e, "_blank"),
              color: d.primary.text.lowContrast,
              children: [
                /* @__PURE__ */ c.jsx(Or, { color: d.primary.text.lowContrast }),
                "View on mintscan"
              ]
            }
          ) })
        ] }),
        icon: ae.warning,
        backgroundColor: d.warning.background,
        textColor: d.warning.text
      }
    ),
    /* @__PURE__ */ c.jsx(
      De,
      {
        label: "Continue transaction",
        backgroundColor: d.warning.text,
        icon: ae.rightArrow,
        onClick: s
      }
    )
  ] });
}, Nce = () => {
  const [e] = Ae(sn), n = Q(() => {
    switch (e == null ? void 0 : e.errorType) {
      case Xe.AuthFailed:
        return /* @__PURE__ */ c.jsx(Sce, { ...e });
      case Xe.Timeout:
        return /* @__PURE__ */ c.jsx(Oce, { ...e });
      case Xe.AdditionalSigningRequired:
        return /* @__PURE__ */ c.jsx(Mce, { ...e });
      case Xe.TradeWarning:
        return /* @__PURE__ */ c.jsx(qce, { ...e });
      case Xe.TransactionFailed:
        return /* @__PURE__ */ c.jsx(Tce, { ...e });
      case Xe.TransactionReverted:
        return /* @__PURE__ */ c.jsx(Ice, { ...e });
      case Xe.Unexpected:
        return /* @__PURE__ */ c.jsx(Rce, { error: e.error });
      default:
        return;
    }
  }, [e]);
  if ((e == null ? void 0 : e.errorType) !== void 0)
    return /* @__PURE__ */ c.jsx(be, { gap: 5, children: n });
}, pj = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "16",
    viewBox: "0 0 50 16",
    fill: "none",
    children: [
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M45.6038 9.5579C46.3169 9.5579 46.855 9.01981 46.855 8.30673C46.855 7.59365 46.3169 7.05556 45.6038 7.05556C44.8907 7.05556 44.3526 7.59365 44.3526 8.30673C44.3526 9.01981 44.8907 9.5579 45.6038 9.5579ZM41.4609 8.30673L42.7524 4.51297H48.4561L49.7344 8.30673L48.4561 12.1005H42.7524L41.4609 8.30673Z",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M37.7754 8.52196C37.1699 8.52196 36.7263 8.07837 36.7263 7.4729C36.7263 6.86744 37.1699 6.43697 37.7754 6.43697C38.3809 6.43697 38.8253 6.88057 38.8253 7.4729C38.8253 8.06524 38.3817 8.52196 37.7754 8.52196ZM36.82 4.52696C34.9765 4.52696 33.874 5.77814 33.874 7.44666C33.874 9.11518 34.9773 10.3795 36.82 10.3795H38.1788C38.569 10.3795 38.8376 10.635 38.8376 10.9981V11.1477C38.8376 11.5108 38.569 11.7803 38.1788 11.7803H34.1164V14H41.1256V4.52784H36.8208L36.82 4.52696Z",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx("path", { d: "M18.6979 4.51384H15.5498V12.1022H18.6979V4.51384Z", fill: e }),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M7.50488 2.61609H10.5864V5.67052C10.5864 6.07387 10.8288 6.33023 11.219 6.33023C11.6093 6.33023 11.8516 6.07475 11.8516 5.67052V4.51385H14.9323V7.6759H10.4517C10.0615 7.6759 9.79199 7.93138 9.79199 8.29449C9.79199 8.65759 10.0615 8.91307 10.4517 8.91307H14.9323V12.1022H11.8516V10.9184C11.8516 10.5151 11.6093 10.2587 11.219 10.2587C10.8288 10.2587 10.5864 10.5142 10.5864 10.9184V12.1022H7.50488V2.61696V2.61609Z",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M0.00976562 11.4627H4.20775C4.59798 11.4627 4.86659 11.2072 4.86659 10.8441C4.86659 10.481 4.59798 10.2115 4.20775 10.2115L0.00976562 10.1844V4.51297H6.88509V7.04244H2.6871C2.29687 7.04244 2.02739 7.29792 2.02739 7.66102C2.02739 8.02412 2.29687 8.29361 2.6871 8.29361H6.88509V13.9983H0.00976562V11.4627Z",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M23.0044 9.51853C23.6904 9.51853 24.2153 8.99356 24.2153 8.3076C24.2153 7.62165 23.6904 7.09668 23.0044 7.09668C22.3184 7.09668 21.7935 7.62165 21.7935 8.3076C21.7935 8.99356 22.3184 9.51853 23.0044 9.51853ZM23.1383 4.51384C25.4525 4.51384 27.0396 6.06074 27.0396 8.30848C27.0396 10.5562 25.4516 12.1031 23.1383 12.1031H22.3447V14H19.3174V4.51471H23.1383V4.51384Z",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M20.9686 1.95988C20.9686 3.04218 20.091 3.91976 19.0087 3.91976C17.9264 3.91976 17.0488 3.04218 17.0488 1.95988C17.0488 0.87757 17.9264 0 19.0087 0C20.091 0 20.9686 0.87757 20.9686 1.95988Z",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M33.2752 6.27073C33.2752 7.35304 32.3977 8.23061 31.3153 8.23061C30.233 8.23061 29.3555 7.35304 29.3555 6.27073C29.3555 5.18842 30.233 4.31085 31.3153 4.31085C32.3977 4.31085 33.2752 5.18842 33.2752 6.27073Z",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M31.3905 10.3427C31.3905 11.425 30.5129 12.3026 29.4306 12.3026C28.3483 12.3026 27.4707 11.425 27.4707 10.3427C27.4707 9.26042 28.3483 8.38284 29.4306 8.38284C30.5129 8.38284 31.3905 9.26042 31.3905 10.3427Z",
          fill: e
        }
      )
    ]
  }
), Pce = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M2.85078 14.7961V13.0889H11.9561V14.7961H2.85078ZM8.2215 8.21613C8.00809 8.42953 7.73541 8.53624 7.40344 8.53624C7.07148 8.53624 6.79879 8.42953 6.58539 8.21613C6.37198 8.00272 6.26528 7.73004 6.26528 7.39807C6.26528 7.2558 6.27713 7.1491 6.30085 7.07796L4.55803 4.69493L4.7003 4.55266L7.08333 6.29547C7.15447 6.27176 7.26117 6.25991 7.40344 6.25991C7.73541 6.25991 8.00809 6.36661 8.2215 6.58002C8.43491 6.79342 8.54161 7.0661 8.54161 7.39807C8.54161 7.73004 8.43491 8.00272 8.2215 8.21613ZM2.175 2.16963C3.62142 0.723202 5.36422 0 7.40344 0C9.44266 0 11.1855 0.723202 12.6319 2.16963C14.0783 3.61605 14.8015 5.35885 14.8015 7.39807C14.8015 9.12904 14.2799 10.6466 13.2365 11.9507H11.138L10.9958 11.8085L10.2133 11.026L11.0313 10.2079L11.8138 10.9904C12.5252 10.1368 12.9401 9.12904 13.0587 7.96715H11.9561V6.82899H13.0587C12.9401 5.66711 12.5252 4.65937 11.8138 3.80574L11.0313 4.58823L10.2133 3.77017L10.9958 2.98768C10.1421 2.27633 9.13441 1.86137 7.97252 1.74281V2.84541H6.83436V1.74281C5.67248 1.86137 4.66474 2.27633 3.81111 2.98768L4.5936 3.77017L3.77554 4.58823L2.99305 3.80574C2.2817 4.65937 1.86675 5.66711 1.74819 6.82899H2.85078V7.96715H1.74819C1.86675 9.12904 2.2817 10.1368 2.99305 10.9904L3.77554 10.2079L4.5936 11.026L3.81111 11.8085L3.66884 11.9507H1.57035C0.527025 10.6466 0.00537109 9.12904 0.00537109 7.39807C0.00537109 5.35885 0.728573 3.61605 2.175 2.16963Z",
        fill: e
      }
    )
  }
);
function lj(e = 500) {
  const n = me(
    void 0
  ), t = me(), s = me(!1), a = me(!1), o = me(
    void 0,
    (d, m, h, p) => {
      clearTimeout(d(n));
      const _ = d(t), y = typeof h == "function" ? h(_) : h, w = () => {
        m(t, y), m(s, !0), m(a, !0);
      }, q = () => {
        m(o, y), m(s, !1), p == null || p();
      };
      w();
      const k = setTimeout(() => {
        q();
      }, e);
      k && m(n, k);
    }
  ), i = me(null, (d, m, h) => {
    clearTimeout(d(n)), m(s, !1);
  });
  return {
    currentValueAtom: me((d) => d(t)),
    isDebouncingAtom: s,
    clearTimeoutAtom: i,
    debouncedValueAtom: o,
    valueInitialized: a
  };
}
const {
  debouncedValueAtom: u8,
  valueInitialized: Uce
} = lj(), {
  debouncedValueAtom: _8,
  valueInitialized: Hce
} = lj(), Tw = me(
  (e) => {
    var s;
    const n = e(Uce), t = e(u8);
    return n === !1 && !t ? (s = e(Pe)) == null ? void 0 : s.amount : t;
  },
  (e, n, t) => {
    n(u8, t);
  }
), Rw = me(
  (e) => {
    var s;
    const n = e(Hce), t = e(_8);
    return n === !1 && !t ? (s = e(la)) == null ? void 0 : s.amount : t;
  },
  (e, n, t, s) => {
    n(_8, t, s);
  }
), Pe = _d(
  "sourceAsset",
  void 0
), fm = me(
  (e) => {
    var n;
    return (n = e(Pe)) == null ? void 0 : n.amount;
  },
  (e, n, t) => {
    const s = e(Pe);
    n(Pe, { ...s, amount: t }), n(Tw, t), n(Fo, "swap-in");
  }
), la = _d(
  "destinationAsset",
  void 0
), Ow = me(
  (e) => {
    var n;
    return (n = e(la)) == null ? void 0 : n.amount;
  },
  (e, n, t, s) => {
    const a = e(la);
    n(la, { ...a, amount: t }), n(Rw, t, s), n(Fo, "swap-out");
  }
), Lce = me((e) => {
  const n = e(fm), t = e(Ow), s = e(Tw), a = e(Rw), { isLoading: o } = e(Wc), i = e(Fo);
  if (i === "swap-in")
    return n !== s || o;
  if (i === "swap-out")
    return t !== a || o;
}), Fo = _d(
  "swapDirection",
  "swap-in"
), nm = me(!1), Wce = me(null, (e, n) => {
  const t = e(Pe), s = e(la), a = e(Fo);
  n(nm, !0), n(Pe, { ...s }), s != null && s.amount && n(fm, s == null ? void 0 : s.amount), n(la, { ...t }), t != null && t.amount && n(Ow, t == null ? void 0 : t.amount, () => {
    n(Fo, a === "swap-in" ? "swap-out" : "swap-in"), n(nm, !1);
  });
}), Vce = R8((e, n) => {
  const t = e(Wc), s = e(Fo), a = e(Pe), o = e(la);
  if (!t.data || !a || !o) return;
  const i = ho(
    t.data.amountOut,
    o.decimals
  ), d = ho(
    t.data.amountIn,
    a.decimals
  ), m = i !== o.amount, h = d !== a.amount;
  s === "swap-in" && m ? n(la, (p) => ({
    ...p,
    amount: Qd(i)
  })) : s === "swap-out" && h && n(Pe, (p) => ({
    ...p,
    amount: Qd(d)
  }));
}), Gce = _d("swapSettingsAtom", {
  slippage: 3
}), Kce = me((e) => {
  const n = e(Pe), t = e(la), s = e(Fo), a = e(Tw), o = e(Rw);
  return !(n != null && n.chainID) || !n.denom || !(t != null && t.chainID) || !t.denom ? void 0 : {
    ...s === "swap-in" ? {
      amountIn: fo(
        a ?? "0",
        n.decimals
      )
    } : {
      amountOut: fo(
        o ?? "0",
        t.decimals
      )
    },
    sourceAssetChainID: n.chainID,
    sourceAssetDenom: n.denom,
    destAssetChainID: t.chainID,
    destAssetDenom: t.denom
  };
}), Xce = ic((e) => {
  const n = e(go), t = e(Kce), s = e(uo), a = e(nm), o = e(sn);
  e(Vce);
  const i = t !== void 0 && (Number(t.amountIn) > 0 || Number(t.amountOut) > 0) && !a && s === Je.SwapPage && o === void 0;
  return {
    queryKey: ["skipRoute", t],
    queryFn: async () => {
      if (!t)
        throw new Error("No route request provided");
      try {
        return await n.route({
          ...t,
          smartRelay: !0,
          smartSwapOptions: {
            splitRoutes: !0,
            evmSwaps: !0
          },
          experimentalFeatures: ["hyperlane"],
          allowMultiTx: !0,
          allowUnsafe: !0
        });
      } catch (d) {
        return {
          isError: !0,
          error: d
        };
      }
    },
    retry: 1,
    enabled: i,
    refetchInterval: 1e3 * 30
  };
}), Wc = me((e) => {
  const { data: n, isError: t, error: s, isLoading: a } = e(Xce), o = n, i = n;
  return o != null && o.isError ? {
    data: void 0,
    isError: !0,
    error: o.error,
    isLoading: !1
  } : {
    data: i,
    isError: t,
    error: s,
    isLoading: a
  };
}), gj = ({
  rightContent: e = null,
  showRouteInfo: n,
  showEstimatedTime: t
}) => {
  const { data: s, isLoading: a } = re(Wc), o = hj(
    s == null ? void 0 : s.estimatedRouteDurationSeconds
  ), i = Q(() => {
    if (e) return e;
    if (!a && n && s)
      return /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 8, children: [
        (s == null ? void 0 : s.txsRequired) > 1 && /* @__PURE__ */ c.jsx(Y, { gap: 4, align: "center", children: /* @__PURE__ */ c.jsxs(uj, { gap: 5, align: "center", children: [
          /* @__PURE__ */ c.jsx(qw, {}),
          s == null ? void 0 : s.txsRequired,
          " ",
          cd("Signature", s == null ? void 0 : s.txsRequired),
          " required"
        ] }) }),
        t && o && /* @__PURE__ */ c.jsxs(Y, { gap: 4, align: "center", children: [
          /* @__PURE__ */ c.jsx(Pce, {}),
          o,
          "."
        ] })
      ] });
  }, [o, a, e, s, t, n]);
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 5, children: [
      "Powered by ",
      /* @__PURE__ */ c.jsx(pj, {})
    ] }),
    i
  ] });
}, Mw = ({
  onClick: e,
  rightContent: n,
  showRouteInfo: t,
  showEstimatedTime: s,
  ...a
}) => /* @__PURE__ */ c.jsx(
  Rr,
  {
    gap: 5,
    justify: "space-between",
    onClick: e,
    ...a,
    children: /* @__PURE__ */ c.jsx(
      gj,
      {
        rightContent: n,
        showRouteInfo: t,
        showEstimatedTime: s
      }
    )
  }
), uj = W(Y)`
  ${({ theme: e }) => `color: ${e.warning.text}`};
`, zc = ({
  leftContent: e,
  rightContent: n,
  onClick: t,
  style: s
}) => /* @__PURE__ */ c.jsxs(
  Yce,
  {
    as: "button",
    align: "center",
    justify: "space-between",
    onClick: t,
    gap: 16,
    style: s,
    children: [
      typeof e == "string" ? /* @__PURE__ */ c.jsx(Te, { fontSize: 20, children: e }) : e,
      typeof n == "string" ? /* @__PURE__ */ c.jsx(Te, { fontSize: 20, children: n }) : n
    ]
  }
), Yce = W(Y)`
  ${yd};
  width: 100%;
  height: 60px;
  border-radius: 12px;
  padding: 12px 15px;
  ${({ theme: e }) => `background-color: ${e.secondary.background.normal}`};

  ${({ onClick: e, theme: n }) => e && Ye`
      &:hover, &:focus {
        background-color: ${n.secondary.background.hover};
        cursor: pointer;
      }
    `};
`, Iw = ({
  listItems: e,
  height: n,
  itemHeight: t,
  renderItem: s,
  itemKey: a,
  className: o
}) => {
  const i = je(), [d, m] = qe(), h = Ch(null);
  return on(() => {
    var w, q, k;
    const p = (k = (q = (w = h.current) == null ? void 0 : w.nativeElement) == null ? void 0 : q.getElementsByClassName("rc-virtual-list-holder-inner")) == null ? void 0 : k[0], _ = p == null ? void 0 : p.firstChild, y = (B) => {
      if (B.key === "ArrowDown") {
        _ && (_.focus(), m(_)), B.preventDefault();
        const v = d == null ? void 0 : d.nextElementSibling;
        v && (v.focus(), m(v));
      } else if (B.key === "ArrowUp") {
        B.preventDefault();
        const v = d == null ? void 0 : d.previousElementSibling;
        v && (v.focus(), m(v));
      }
    };
    return document.addEventListener("keydown", y), () => {
      document.removeEventListener("keydown", y);
    };
  }, [d, e.length]), on(() => {
    setTimeout(() => {
      var p;
      (p = h.current) == null || p.scrollTo(0);
    }, 0);
  }, [e.length]), /* @__PURE__ */ c.jsx(
    jD,
    {
      ref: h,
      data: e,
      height: n,
      itemHeight: t,
      itemKey: a,
      virtual: !0,
      className: o,
      styles: {
        verticalScrollBar: {
          backgroundColor: "transparent",
          visibility: "visible"
        },
        verticalScrollBarThumb: {
          backgroundColor: Mh(i.primary.text.normal) + _n(50)
        }
      },
      children: (p, _) => s(p, _)
    }
  );
}, Mr = JA(
  "transactionHistory",
  []
), _j = me(
  null,
  (e, n, t, s) => {
    const a = e(Mr), o = (a == null ? void 0 : a[t]) ?? {}, i = a;
    i[t] = { ...o, ...s }, n(Mr, i);
  }
), Jce = me(
  null,
  (e, n, t) => {
    const s = e(Mr);
    if (!s || t < 0 || t >= s.length) return;
    const a = s;
    a.splice(t, 1), n(Mr, a);
  }
);
ic((e) => {
  const n = e(go), t = e(Mr), s = t.find(
    (a) => a.status !== "completed" && a.status !== "failed"
  );
  return {
    queryKey: ["skipPendingTxHistoryStatus", t],
    queryFn: async () => t.map(
      async (o) => await Promise.all(
        o.transactionDetails.map(
          async (d) => o.status !== "completed" && o.status !== "failed" ? await n.transactionStatus({
            chainID: d.chainID,
            txHash: d.txHash
          }) : new Promise((m) => m(null))
        )
      )
    ),
    enabled: !!s,
    refetchInterval: 1e3 * 2,
    keepPreviousData: !0
  };
});
function Zce(e) {
  return !!(e instanceof Error && // keplr | metamask
  (e.message.toLowerCase().includes("rejected") || // leap
  e.message.toLowerCase().includes("declined") || e.message.toLowerCase().includes("denied") || // @ts-expect-error common user rejected request error code
  e.code === 4001));
}
const $o = me({}), fn = _d(
  "swapExecutionState",
  {
    route: void 0,
    userAddresses: [],
    transactionDetailsArray: [],
    transactionHistoryIndex: 0,
    overallStatus: "unconfirmed",
    isValidatingGasBalance: void 0
  }
), md = me(null, (e, n, t) => {
  n(fn, (s) => ({ ...s, overallStatus: t }));
}), Qce = me(null, (e, n) => {
  const { data: t } = e(Wc), a = e(Mr).length;
  t && (n(fn, {
    userAddresses: [],
    transactionDetailsArray: [],
    route: t,
    transactionHistoryIndex: a,
    overallStatus: "unconfirmed",
    isValidatingGasBalance: void 0
  }), n(yj, {
    onTransactionUpdated: (o) => {
      n(y8, o, a);
    },
    onTransactionSigned: async (o) => {
      n(y8, { ...o, explorerLink: void 0, status: void 0 }, a);
    },
    onError: (o, i) => {
      const d = i == null ? void 0 : i[(i == null ? void 0 : i.length) - 1];
      Zce(o) ? n(sn, {
        errorType: Xe.AuthFailed,
        onClickBack: () => {
          n(md, "unconfirmed");
        }
      }) : d != null && d.explorerLink ? n(sn, {
        errorType: Xe.TransactionFailed,
        onClickBack: () => {
          n(md, "unconfirmed");
        },
        explorerLink: (d == null ? void 0 : d.explorerLink) ?? "",
        transactionHash: (d == null ? void 0 : d.txHash) ?? "",
        onClickContactSupport: () => {
          window.open("https://skip.build/discord", "_blank");
        }
      }) : n(sn, {
        errorType: Xe.Unexpected,
        error: o,
        onClickBack: () => {
          n(md, "unconfirmed");
        }
      });
    },
    onValidateGasBalance: async (o) => {
      n(ede, o);
    }
  }));
}), ede = me(null, (e, n, t) => {
  n(fn, (s) => ({ ...s, isValidatingGasBalance: t }));
}), y8 = me(
  null,
  (e, n, t, s) => {
    const a = e(fn), { transactionDetailsArray: o, route: i } = a, d = o, m = d.findIndex(
      (h) => h.txHash.toLowerCase() === t.txHash.toLowerCase()
    );
    m !== -1 ? d[m] = {
      ...d[m],
      ...t
    } : d.push(t), n(fn, {
      ...a,
      transactionDetailsArray: d
    }), n(_j, s, {
      route: i,
      transactionDetails: d,
      timestamp: Date.now(),
      status: "unconfirmed"
    });
  }
), nde = R8((e, n) => {
  const t = e($o);
  if (!Object.values(t).every(
    (a) => !!a.address
  ))
    return;
  const s = Object.values(t).map((a) => ({
    chainID: a.chainID,
    address: a.address
  }));
  n(fn, (a) => ({
    ...a,
    userAddresses: s
  }));
}), yj = me(), bj = bD((e) => {
  const n = e(go), { route: t, userAddresses: s, transactionDetailsArray: a } = e(fn), o = e(yj);
  return {
    gcTime: 1 / 0,
    mutationFn: async () => {
      var i;
      if (t && s.length) {
        try {
          await n.executeRoute({
            route: t,
            userAddresses: s,
            validateGasBalance: t.sourceAssetChainID !== "984122",
            // getFallbackGasAmount: async (chainID, chainType) => {
            //   if (chainType === "cosmos") {
            //     return Number(useSettingsStore.getState().customGasAmount);
            //   }
            // },
            onValidateGasBalance: async (d) => {
              var m;
              (m = o == null ? void 0 : o.onValidateGasBalance) == null || m.call(
                o,
                d
              );
            },
            onTransactionSigned: async (d) => {
              var m;
              (m = o == null ? void 0 : o.onTransactionSigned) == null || m.call(
                o,
                d
              );
            },
            onTransactionBroadcast: async (d) => {
              var m;
              (m = o == null ? void 0 : o.onTransactionUpdated) == null || m.call(
                o,
                d
              );
            },
            onTransactionTracked: async (d) => {
              var m;
              (m = o == null ? void 0 : o.onTransactionUpdated) == null || m.call(
                o,
                d
              );
            },
            onTransactionCompleted: async (d, m, h) => {
              var p;
              (p = o == null ? void 0 : o.onTransactionUpdated) == null || p.call(o, {
                chainID: d,
                txHash: m,
                status: h
              });
            }
          });
        } catch (d) {
          console.error(d), (i = o == null ? void 0 : o.onError) == null || i.call(o, d, a);
        }
        return null;
      }
    },
    onError: (i) => {
      var d;
      console.error(i), (d = o == null ? void 0 : o.onError) == null || d.call(o, i, a);
    }
  };
}), hc = () => {
  const e = re(Ew), [n, t] = Ae(Aw), [s, a] = Ae(jw), [o, i] = Ae(Cw), { data: d } = re(We), { data: m, walletType: h } = z8({
    multiChain: !0
  }), p = Dw.find(
    (q) => {
      var k;
      return q.name === ((k = e.svm) == null ? void 0 : k.walletName);
    }
  ), _ = im(), y = S8();
  return Ne(
    // if checkChainType is true, it only check wallet connected no chainId is dependent
    (q, k) => {
      var b, O;
      const B = (b = d == null ? void 0 : d.find((D) => D.chainID === q)) == null ? void 0 : b.chainType;
      switch (B) {
        case "cosmos":
          h && s === void 0 && a({
            walletName: h,
            chainType: "cosmos"
          });
          break;
        case "svm":
          p && o === void 0 && i({
            walletName: p.name,
            chainType: "svm"
          });
          break;
        case "evm":
          _.connector && n === void 0 && t({
            walletName: _.connector.id,
            chainType: "evm"
          });
          break;
      }
      const g = (() => {
        if (!(!m || !q))
          return m[q];
      })();
      switch (B) {
        case "cosmos": {
          if (!g || !e.cosmos) return;
          const D = dA(
            e.cosmos.walletName
          );
          return {
            address: g.bech32Address,
            chainType: B,
            wallet: {
              name: e.cosmos.walletName,
              prettyName: D.name,
              logo: D.imgSrc,
              isLedger: g.isNanoLedger
            }
          };
        }
        case "evm":
          return !e.evm || _.chainId !== Number(q) && !k || !_.address || !_.connector ? void 0 : {
            address: _.address,
            currentConnectedEVMChainId: String(_.chainId),
            chainType: B,
            wallet: {
              name: _.connector.id,
              prettyName: _.connector.name,
              logo: (O = y.find(
                (D) => {
                  var M;
                  return D.id === ((M = _.connector) == null ? void 0 : M.id);
                }
              )) == null ? void 0 : O.icon
            }
          };
        case "svm":
          return !e.svm || !(p != null && p.publicKey) ? void 0 : {
            address: p.publicKey.toBase58(),
            chainType: B,
            wallet: {
              name: p.name,
              prettyName: p.name,
              logo: p.icon
            }
          };
        default:
          return;
      }
    },
    [
      d,
      h,
      s,
      p,
      o,
      _.connector,
      _.chainId,
      _.address,
      n,
      a,
      i,
      t,
      m,
      e.evm,
      e.cosmos,
      e.svm,
      y
    ]
  );
}, b8 = ({
  denom: e,
  tokenAmount: n,
  chainId: t,
  status: s,
  onClickEditDestinationWallet: a,
  explorerLink: o,
  isSignRequired: i,
  index: d,
  context: m,
  ...h
}) => {
  var v;
  const p = je(), _ = an({
    assetDenom: e,
    chainId: t,
    tokenAmount: n
  }), y = re($o), q = hc()(t), k = Q(() => {
    const g = Object.values(y);
    switch (m) {
      case "source":
        return {
          address: q == null ? void 0 : q.address,
          image: q == null ? void 0 : q.wallet.logo
        };
      case "intermediary": {
        const b = Object.values(y).find(
          (O) => O.chainID === t
        );
        return {
          address: b == null ? void 0 : b.address,
          image: (b == null ? void 0 : b.source) === "wallet" && b.wallet.walletInfo.logo || void 0
        };
      }
      case "destination": {
        const b = g[g.length - 1];
        return {
          address: b == null ? void 0 : b.address,
          image: (b == null ? void 0 : b.source) === "wallet" && b.wallet.walletInfo.logo || void 0
        };
      }
    }
  }, [
    q == null ? void 0 : q.address,
    q == null ? void 0 : q.wallet.logo,
    y,
    t,
    m
  ]), B = Q(() => {
    const g = m === "destination" && a, b = g ? ({ children: O }) => /* @__PURE__ */ c.jsx(Y, { gap: 5, children: O }) : Ie.Fragment;
    if (k.address)
      return /* @__PURE__ */ c.jsxs(b, { children: [
        /* @__PURE__ */ c.jsxs(sde, { onClick: () => Fw(k.address), children: [
          k.image && /* @__PURE__ */ c.jsx(
            "img",
            {
              src: k.image,
              style: {
                height: "100%"
              }
            }
          ),
          /* @__PURE__ */ c.jsx(tde, { title: k.address, children: $c(k.address) })
        ] }),
        g && /* @__PURE__ */ c.jsx(jn, { align: "center", onClick: a, children: /* @__PURE__ */ c.jsx(Sw, { color: p.primary.text.lowContrast }) })
      ] });
  }, [
    m,
    a,
    k.address,
    k.image,
    p.primary.text.lowContrast
  ]);
  return /* @__PURE__ */ c.jsxs(Y, { gap: 15, align: "center", ...h, children: [
    (_ == null ? void 0 : _.assetImage) && /* @__PURE__ */ c.jsx(
      wm,
      {
        width: 30,
        height: 30,
        backgroundColor: p.success.text,
        status: s,
        children: /* @__PURE__ */ c.jsx(
          ade,
          {
            height: 30,
            width: 30,
            src: _.assetImage,
            title: (v = _ == null ? void 0 : _.asset) == null ? void 0 : v.name
          }
        )
      }
    ),
    /* @__PURE__ */ c.jsx(
      be,
      {
        style: {
          flex: 1
        },
        justify: "space-between",
        children: /* @__PURE__ */ c.jsxs(Y, { align: "center", justify: "space-between", children: [
          /* @__PURE__ */ c.jsxs(be, { children: [
            /* @__PURE__ */ c.jsxs(Y, { gap: 5, children: [
              /* @__PURE__ */ c.jsx(ide, { normalTextColor: !0, title: _ == null ? void 0 : _.amount, children: _ == null ? void 0 : _.amount }),
              /* @__PURE__ */ c.jsx(J, { normalTextColor: !0, children: _ == null ? void 0 : _.symbol }),
              /* @__PURE__ */ c.jsxs(cde, { title: _ == null ? void 0 : _.chainName, children: [
                " ",
                "on ",
                _ == null ? void 0 : _.chainName
              ] }),
              o && /* @__PURE__ */ c.jsx(em, { href: o, target: "_blank", children: /* @__PURE__ */ c.jsx(J, { children: /* @__PURE__ */ c.jsx(Or, {}) }) })
            ] }),
            " ",
            i && /* @__PURE__ */ c.jsx(J, { color: p.warning.text, children: "Signature required" })
          ] }),
          B
        ] })
      }
    )
  ] });
}, tde = W(J)`
  font-family: monospace;
  text-transform: lowercase;
`, sde = W(jn)`
  padding: 5px 8px;
  height: 28px;
  border-radius: 30px;
  box-sizing: border-box;
  background-color: ${({ theme: e }) => e.secondary.background.normal};
  gap: 4px;
  align-items: center;
`, ade = W.img`
  border-radius: 50%;
  box-sizing: content-box;
`, wm = ({
  backgroundColor: e,
  children: n,
  width: t,
  height: s,
  borderSize: a = 2,
  status: o
}) => /* @__PURE__ */ c.jsx(
  ode,
  {
    align: "center",
    justify: "center",
    width: t,
    height: s,
    borderSize: a,
    status: o,
    backgroundColor: e,
    children: /* @__PURE__ */ c.jsx(
      rde,
      {
        className: "overlay",
        justify: "space-between",
        width: t,
        height: s,
        backgroundColor: e,
        children: n
      }
    )
  }
), ode = W(Y)`
  position: relative;
  overflow: hidden;
  height: ${({ height: e, borderSize: n }) => e + n * 2}px;
  width: ${({ width: e, borderSize: n }) => e + n * 2}px;
  ${({ status: e, borderSize: n, theme: t }) => {
  switch (e) {
    case "completed":
      return `border: ${n}px solid ${t.success.text}`;
    case "failed":
      return `border: ${n}px solid ${t.error.text}`;
    default:
      return "";
  }
}};
  border-radius: 50%;

  &:before {
    content: '';
    position: absolute;
    height: ${({ height: e }) => `${e + 20}px;`};
    width: ${({ width: e }) => `${e + 20}px;`};
    ${({ status: e, backgroundColor: n, theme: t }) => e === "pending" && Ye`
        background-image: conic-gradient(
          transparent,
          transparent,
          transparent,
          ${n ?? t.success.text}
        );
        animation: rotate 4s linear infinite;
      `};
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, rde = W(Y)`
  width: ${({ width: e }) => e}px;
  height: ${({ height: e }) => e}px;
  position: absolute;
  border-radius: 50%;
  background-color: ${({ theme: e }) => e.primary.background.normal};
`, ide = W(J)`
  max-width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
`, cde = W(J)`
  max-width: 95px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, Nw = ({
  title: e,
  onClickBackButton: n,
  rightContent: t
}) => {
  const s = je();
  return /* @__PURE__ */ c.jsxs(dde, { align: "center", justify: "space-between", children: [
    /* @__PURE__ */ c.jsx(jn, { onClick: () => n(), children: /* @__PURE__ */ c.jsx(
      mde,
      {
        color: s == null ? void 0 : s.primary.background.normal,
        backgroundColor: s == null ? void 0 : s.primary.text.normal
      }
    ) }),
    /* @__PURE__ */ c.jsx(hde, { textAlign: "center", children: e }),
    t == null ? void 0 : t()
  ] });
}, vj = W(be)`
  position: relative;
  padding: 10px;
  gap: 10px;
  width: 580px;
  border-radius: 20px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  overflow: hidden;
`, fj = W(be)`
  height: ${({ height: e }) => e}px;
  width: 100%;
  align-items: center;
  justify-content: center;
`, dde = W(Y)`
  height: 40px;
  margin-top: 10px;
  padding: 0 12px;
`, mde = W(zw)`
  opacity: 0.2;
`, hde = W(Te)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
`, pde = (e) => e.onSelect !== void 0, nd = (e) => e.connect !== void 0, v8 = 60, Fd = 5, wj = ({
  title: e,
  walletList: n,
  onClickBackButton: t,
  isDestinationAddress: s,
  chainId: a,
  chainType: o,
  isConnectEco: i
}) => {
  var q, k;
  const d = je(), m = Qe(), h = pe($o), p = aD({
    mutationKey: ["connectWallet"],
    mutationFn: async (B) => {
      var v;
      if (s) {
        if (!a || !o) return;
        const g = await ((v = B.getAddress) == null ? void 0 : v.call(B, {}));
        return h((b) => {
          const O = Object.values(b).length - 1;
          return {
            ...b,
            [O]: {
              chainID: a,
              chainType: o,
              address: g,
              source: "input"
            }
          };
        }), null;
      }
      return i ? await B.connectEco() : await B.connect();
    },
    onSuccess: () => {
      m.remove();
    }
  }), _ = Ne(
    (B) => {
      const v = nd(B) ? B.walletPrettyName ?? B.walletName : B.walletName, g = nd(B) ? B.walletInfo.logo : void 0, b = pde(B) ? B.rightContent : void 0, O = nd(B) ? B.isAvailable : void 0;
      return B.walletName === "prax" ? /* @__PURE__ */ c.jsx(
        zc,
        {
          onClick: () => {
            nd(B) ? p.mutate(B) : B.onSelect();
          },
          style: { marginTop: Fd },
          leftContent: /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 10, children: [
            g && /* @__PURE__ */ c.jsx(
              "img",
              {
                height: 35,
                width: 35,
                style: { objectFit: "cover" },
                src: g,
                alt: `${v} logo`
              }
            ),
            /* @__PURE__ */ c.jsx(Te, { children: v })
          ] }),
          rightContent: b == null ? void 0 : b()
        },
        v
      ) : /* @__PURE__ */ c.jsx(
        zc,
        {
          onClick: () => {
            nd(B) ? p.mutate(B) : B.onSelect();
          },
          style: { marginTop: Fd },
          leftContent: /* @__PURE__ */ c.jsxs(Y, { style: { width: "100%" }, align: "center", justify: "space-between", children: [
            /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 10, children: [
              g && /* @__PURE__ */ c.jsx(
                "img",
                {
                  height: 35,
                  width: 35,
                  style: { objectFit: "cover" },
                  src: g,
                  alt: `${v} logo`
                }
              ),
              /* @__PURE__ */ c.jsx(Te, { children: v })
            ] }),
            O !== void 0 && /* @__PURE__ */ c.jsx(J, { children: O ? "Installed" : "Not Installed" })
          ] }),
          rightContent: b == null ? void 0 : b()
        },
        v
      );
    },
    [p]
  ), y = Q(() => Math.min(530, n.length * (v8 + Fd)), [n]), w = Q(() => {
    var B, v, g;
    if (p.isError || p.isPending) {
      const b = p.isError ? "Failed to connect" : "Connecting to";
      return /* @__PURE__ */ c.jsx(fj, { height: y, children: /* @__PURE__ */ c.jsxs(lde, { children: [
        /* @__PURE__ */ c.jsx(
          wm,
          {
            width: 80,
            height: 80,
            backgroundColor: d.primary.text.normal,
            status: p.isError ? "failed" : "pending",
            borderSize: 8,
            children: /* @__PURE__ */ c.jsx(
              "img",
              {
                style: { objectFit: "cover" },
                src: (B = p.variables) == null ? void 0 : B.walletInfo.logo,
                alt: `${(v = p.variables) == null ? void 0 : v.walletPrettyName} logo`
              }
            )
          }
        ),
        /* @__PURE__ */ c.jsxs(Te, { color: d.primary.text.lowContrast, children: [
          b,
          " ",
          (g = p.variables) == null ? void 0 : g.walletPrettyName
        ] }),
        p.error && /* @__PURE__ */ c.jsx(
          Te,
          {
            textAlign: "center",
            fontSize: 14,
            color: d.primary.text.lowContrast,
            children: p.error.message
          }
        )
      ] }) });
    }
    return /* @__PURE__ */ c.jsx(
      Iw,
      {
        listItems: n,
        height: y,
        itemHeight: v8 + Fd,
        renderItem: _,
        itemKey: (b) => b.walletName
      }
    );
  }, [
    p.error,
    p.isError,
    p.isPending,
    (q = p.variables) == null ? void 0 : q.walletInfo.logo,
    (k = p.variables) == null ? void 0 : k.walletPrettyName,
    y,
    _,
    d.primary.text.lowContrast,
    d.primary.text.normal,
    n
  ]);
  return /* @__PURE__ */ c.jsxs(vj, { gap: 15, children: [
    /* @__PURE__ */ c.jsx(
      Nw,
      {
        title: e,
        onClickBackButton: p.isPending || p.isError ? p.reset : t
      }
    ),
    w
  ] });
}, lde = W(be)`
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-bottom: 10px;
`;
var xj = {}, qc = {};
Object.defineProperty(qc, "__esModule", { value: !0 });
qc.fromAscii = qc.toAscii = void 0;
function gde(e) {
  const n = (t) => t.split("").map((s) => {
    const a = s.charCodeAt(0);
    if (a < 32 || a > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + a);
    return a;
  });
  return Uint8Array.from(n(e));
}
qc.toAscii = gde;
function ude(e) {
  return ((t) => t.map((s) => {
    if (s < 32 || s > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + s);
    return String.fromCharCode(s);
  }))(Array.from(e)).join("");
}
qc.fromAscii = ude;
var Sc = {}, xm = {};
xm.byteLength = bde;
xm.toByteArray = fde;
xm.fromByteArray = kde;
var Fn = [], gn = [], _de = typeof Uint8Array < "u" ? Uint8Array : Array, Gm = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var _c = 0, yde = Gm.length; _c < yde; ++_c)
  Fn[_c] = Gm[_c], gn[Gm.charCodeAt(_c)] = _c;
gn[45] = 62;
gn[95] = 63;
function kj(e) {
  var n = e.length;
  if (n % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var t = e.indexOf("=");
  t === -1 && (t = n);
  var s = t === n ? 0 : 4 - t % 4;
  return [t, s];
}
function bde(e) {
  var n = kj(e), t = n[0], s = n[1];
  return (t + s) * 3 / 4 - s;
}
function vde(e, n, t) {
  return (n + t) * 3 / 4 - t;
}
function fde(e) {
  var n, t = kj(e), s = t[0], a = t[1], o = new _de(vde(e, s, a)), i = 0, d = a > 0 ? s - 4 : s, m;
  for (m = 0; m < d; m += 4)
    n = gn[e.charCodeAt(m)] << 18 | gn[e.charCodeAt(m + 1)] << 12 | gn[e.charCodeAt(m + 2)] << 6 | gn[e.charCodeAt(m + 3)], o[i++] = n >> 16 & 255, o[i++] = n >> 8 & 255, o[i++] = n & 255;
  return a === 2 && (n = gn[e.charCodeAt(m)] << 2 | gn[e.charCodeAt(m + 1)] >> 4, o[i++] = n & 255), a === 1 && (n = gn[e.charCodeAt(m)] << 10 | gn[e.charCodeAt(m + 1)] << 4 | gn[e.charCodeAt(m + 2)] >> 2, o[i++] = n >> 8 & 255, o[i++] = n & 255), o;
}
function wde(e) {
  return Fn[e >> 18 & 63] + Fn[e >> 12 & 63] + Fn[e >> 6 & 63] + Fn[e & 63];
}
function xde(e, n, t) {
  for (var s, a = [], o = n; o < t; o += 3)
    s = (e[o] << 16 & 16711680) + (e[o + 1] << 8 & 65280) + (e[o + 2] & 255), a.push(wde(s));
  return a.join("");
}
function kde(e) {
  for (var n, t = e.length, s = t % 3, a = [], o = 16383, i = 0, d = t - s; i < d; i += o)
    a.push(xde(e, i, i + o > d ? d : i + o));
  return s === 1 ? (n = e[t - 1], a.push(
    Fn[n >> 2] + Fn[n << 4 & 63] + "=="
  )) : s === 2 && (n = (e[t - 2] << 8) + e[t - 1], a.push(
    Fn[n >> 10] + Fn[n >> 4 & 63] + Fn[n << 2 & 63] + "="
  )), a.join("");
}
var Ade = r && r.__createBinding || (Object.create ? function(e, n, t, s) {
  s === void 0 && (s = t);
  var a = Object.getOwnPropertyDescriptor(n, t);
  (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return n[t];
  } }), Object.defineProperty(e, s, a);
} : function(e, n, t, s) {
  s === void 0 && (s = t), e[s] = n[t];
}), jde = r && r.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), Cde = r && r.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var t in e) t !== "default" && Object.prototype.hasOwnProperty.call(e, t) && Ade(n, e, t);
  return jde(n, e), n;
};
Object.defineProperty(Sc, "__esModule", { value: !0 });
Sc.fromBase64 = Sc.toBase64 = void 0;
const Aj = Cde(xm);
function Ede(e) {
  return Aj.fromByteArray(e);
}
Sc.toBase64 = Ede;
function Dde(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return Aj.toByteArray(e);
}
Sc.fromBase64 = Dde;
var ko = {}, tm = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", xh = {};
for (var $d = 0; $d < tm.length; $d++) {
  var Km = tm.charAt($d);
  if (xh[Km] !== void 0) throw new TypeError(Km + " is ambiguous");
  xh[Km] = $d;
}
function wc(e) {
  var n = e >> 25;
  return (e & 33554431) << 5 ^ -(n >> 0 & 1) & 996825010 ^ -(n >> 1 & 1) & 642813549 ^ -(n >> 2 & 1) & 513874426 ^ -(n >> 3 & 1) & 1027748829 ^ -(n >> 4 & 1) & 705979059;
}
function jj(e) {
  for (var n = 1, t = 0; t < e.length; ++t) {
    var s = e.charCodeAt(t);
    if (s < 33 || s > 126) return "Invalid prefix (" + e + ")";
    n = wc(n) ^ s >> 5;
  }
  for (n = wc(n), t = 0; t < e.length; ++t) {
    var a = e.charCodeAt(t);
    n = wc(n) ^ a & 31;
  }
  return n;
}
function Bde(e, n, t) {
  if (t = t || 90, e.length + 7 + n.length > t) throw new TypeError("Exceeds length limit");
  e = e.toLowerCase();
  var s = jj(e);
  if (typeof s == "string") throw new Error(s);
  for (var a = e + "1", o = 0; o < n.length; ++o) {
    var i = n[o];
    if (i >> 5) throw new Error("Non 5-bit word");
    s = wc(s) ^ i, a += tm.charAt(i);
  }
  for (o = 0; o < 6; ++o)
    s = wc(s);
  for (s ^= 1, o = 0; o < 6; ++o) {
    var d = s >> (5 - o) * 5 & 31;
    a += tm.charAt(d);
  }
  return a;
}
function Cj(e, n) {
  if (n = n || 90, e.length < 8) return e + " too short";
  if (e.length > n) return "Exceeds length limit";
  var t = e.toLowerCase(), s = e.toUpperCase();
  if (e !== t && e !== s) return "Mixed-case string " + e;
  e = t;
  var a = e.lastIndexOf("1");
  if (a === -1) return "No separator character for " + e;
  if (a === 0) return "Missing prefix for " + e;
  var o = e.slice(0, a), i = e.slice(a + 1);
  if (i.length < 6) return "Data too short";
  var d = jj(o);
  if (typeof d == "string") return d;
  for (var m = [], h = 0; h < i.length; ++h) {
    var p = i.charAt(h), _ = xh[p];
    if (_ === void 0) return "Unknown character " + p;
    d = wc(d) ^ _, !(h + 6 >= i.length) && m.push(_);
  }
  return d !== 1 ? "Invalid checksum for " + e : { prefix: o, words: m };
}
function Fde() {
  var e = Cj.apply(null, arguments);
  if (typeof e == "object") return e;
}
function $de(e) {
  var n = Cj.apply(null, arguments);
  if (typeof n == "object") return n;
  throw new Error(n);
}
function km(e, n, t, s) {
  for (var a = 0, o = 0, i = (1 << t) - 1, d = [], m = 0; m < e.length; ++m)
    for (a = a << n | e[m], o += n; o >= t; )
      o -= t, d.push(a >> o & i);
  if (s)
    o > 0 && d.push(a << t - o & i);
  else {
    if (o >= n) return "Excess padding";
    if (a << t - o & i) return "Non-zero padding";
  }
  return d;
}
function zde(e) {
  var n = km(e, 8, 5, !0);
  if (Array.isArray(n)) return n;
}
function qde(e) {
  var n = km(e, 8, 5, !0);
  if (Array.isArray(n)) return n;
  throw new Error(n);
}
function Sde(e) {
  var n = km(e, 5, 8, !1);
  if (Array.isArray(n)) return n;
}
function Tde(e) {
  var n = km(e, 5, 8, !1);
  if (Array.isArray(n)) return n;
  throw new Error(n);
}
var Rde = {
  decodeUnsafe: Fde,
  decode: $de,
  encode: Bde,
  toWordsUnsafe: zde,
  toWords: qde,
  fromWordsUnsafe: Sde,
  fromWords: Tde
}, Ode = r && r.__createBinding || (Object.create ? function(e, n, t, s) {
  s === void 0 && (s = t);
  var a = Object.getOwnPropertyDescriptor(n, t);
  (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return n[t];
  } }), Object.defineProperty(e, s, a);
} : function(e, n, t, s) {
  s === void 0 && (s = t), e[s] = n[t];
}), Mde = r && r.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), Ide = r && r.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var t in e) t !== "default" && Object.prototype.hasOwnProperty.call(e, t) && Ode(n, e, t);
  return Mde(n, e), n;
};
Object.defineProperty(ko, "__esModule", { value: !0 });
ko.normalizeBech32 = ko.fromBech32 = ko.toBech32 = void 0;
const sm = Ide(Rde);
function Ej(e, n, t) {
  return sm.encode(e, sm.toWords(n), t);
}
ko.toBech32 = Ej;
function Dj(e, n = 1 / 0) {
  const t = sm.decode(e, n);
  return {
    prefix: t.prefix,
    data: new Uint8Array(sm.fromWords(t.words))
  };
}
ko.fromBech32 = Dj;
function Nde(e) {
  const { prefix: n, data: t } = Dj(e);
  return Ej(n, t);
}
ko.normalizeBech32 = Nde;
var Tc = {};
Object.defineProperty(Tc, "__esModule", { value: !0 });
Tc.fromHex = Tc.toHex = void 0;
function Pde(e) {
  let n = "";
  for (const t of e)
    n += ("0" + t.toString(16)).slice(-2);
  return n;
}
Tc.toHex = Pde;
function Ude(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const n = new Uint8Array(e.length / 2);
  for (let t = 0; t < n.length; t++) {
    const s = 2 * t, a = e.slice(s, s + 2);
    if (!a.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    n[t] = parseInt(a, 16);
  }
  return n;
}
Tc.fromHex = Ude;
var Rc = {};
Object.defineProperty(Rc, "__esModule", { value: !0 });
Rc.toRfc3339 = Rc.fromRfc3339 = void 0;
const Hde = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function yc(e, n = 2) {
  return e.toString().padStart(n, "0");
}
function Lde(e) {
  const n = Hde.exec(e);
  if (!n)
    throw new Error("Date string is not in RFC3339 format");
  const t = +n[1], s = +n[2], a = +n[3], o = +n[4], i = +n[5], d = +n[6], m = n[7] ? Math.floor(+n[7] * 1e3) : 0;
  let h, p, _;
  n[8] === "Z" ? (h = 1, p = 0, _ = 0) : (h = n[8].substring(0, 1) === "-" ? -1 : 1, p = +n[8].substring(1, 3), _ = +n[8].substring(4, 6));
  const y = h * (p * 60 + _) * 60, w = /* @__PURE__ */ new Date();
  return w.setUTCFullYear(t, s - 1, a), w.setUTCHours(o, i, d, m), new Date(w.getTime() - y * 1e3);
}
Rc.fromRfc3339 = Lde;
function Wde(e) {
  const n = e.getUTCFullYear(), t = yc(e.getUTCMonth() + 1), s = yc(e.getUTCDate()), a = yc(e.getUTCHours()), o = yc(e.getUTCMinutes()), i = yc(e.getUTCSeconds()), d = yc(e.getUTCMilliseconds(), 3);
  return `${n}-${t}-${s}T${a}:${o}:${i}.${d}Z`;
}
Rc.toRfc3339 = Wde;
var Oc = {};
Object.defineProperty(Oc, "__esModule", { value: !0 });
Oc.fromUtf8 = Oc.toUtf8 = void 0;
function Vde(e) {
  return new TextEncoder().encode(e);
}
Oc.toUtf8 = Vde;
function Gde(e, n = !1) {
  const t = !n;
  return new TextDecoder("utf-8", { fatal: t }).decode(e);
}
Oc.fromUtf8 = Gde;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var n = qc;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return n.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return n.toAscii;
  } });
  var t = Sc;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return t.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return t.toBase64;
  } });
  var s = ko;
  Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return s.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return s.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return s.toBech32;
  } });
  var a = Tc;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return a.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return a.toHex;
  } });
  var o = Rc;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return o.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return o.toRfc3339;
  } });
  var i = Oc;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return i.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return i.toUtf8;
  } });
})(xj);
const Kde = ({
  address: e,
  chainType: n,
  bech32Prefix: t
}) => {
  switch (n) {
    case "cosmos":
      try {
        const { prefix: s } = xj.fromBech32(e);
        return t === s;
      } catch {
        return !1;
      }
    case "evm":
      try {
        return hD(e);
      } catch {
        return !1;
      }
    case "svm":
      try {
        const s = new s6(e);
        return s6.isOnCurve(s);
      } catch {
        return !1;
      }
    default:
      return !1;
  }
};
var Ao = {}, Pw = {}, Ir = {}, Uw = {};
Object.defineProperty(Uw, "__esModule", { value: !0 });
const Xde = {
  $schema: "../../assetlist.schema.json",
  chain_name: "airchainstestnet",
  assets: [{
    description: "The native staking token of Airchains Testnet.",
    denom_units: [{
      denom: "amf",
      exponent: 0
    }, {
      denom: "AMF",
      exponent: 6
    }],
    base: "amf",
    name: "Airchains",
    display: "AMF",
    symbol: "AMF",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/airchainstestnet/images/airchains-logo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/airchainstestnet/images/airchains-logo.svg"
    }]
  }]
};
Uw.default = Xde;
var Hw = {};
Object.defineProperty(Hw, "__esModule", { value: !0 });
const Yde = {
  $schema: "../../chain.schema.json",
  chain_name: "airchainstestnet",
  status: "live",
  website: "https://airchains.io/",
  network_type: "testnet",
  pretty_name: "Airchains Switchyard Testnet",
  chain_type: "cosmos",
  chain_id: "junction",
  bech32_prefix: "air",
  daemon_name: "junctiond",
  node_home: "$HOME/.junctiond",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "amf",
      fixed_min_gas_price: 0,
      low_gas_price: 25e-5,
      average_gas_price: 5e-3,
      high_gas_price: 0.01
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "amf"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.50.3"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/airchainstestnet/images/airchains-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/airchainstestnet/images/airchains-logo.svg"
  }],
  description: "Airchains",
  apis: {
    rpc: [
      {
        address: "https://junction-rpc.validatorvn.com/",
        provider: "Validator VN"
      },
      {
        address: "https://airchains-testnet-rpc.cosmonautstakes.com/",
        provider: "Cosmonaut Stakes"
      },
      {
        address: "https://junction-testnet-rpc.synergynodes.com/",
        provider: "Synergy Nodes"
      },
      {
        address: "https://airchains-rpc.anonid.top/",
        provider: "Anonid Top"
      },
      {
        address: "https://airchains-test.rpc.moonbridge.team/",
        provider: "Moonbridge Team"
      },
      {
        address: "https://airchains-rpc.chainad.org/",
        provider: "Coin Hunterstr"
      },
      {
        address: "https://airchains.rpc.t.stavr.tech/",
        provider: "Stavr Tech"
      },
      {
        address: "https://rpc.nodejumper.io/airchainstestnet",
        provider: "Nodejumper"
      },
      {
        address: "https://t-airchains.rpc.utsa.tech/",
        provider: "UTSA"
      },
      {
        address: "https://junction-rpc.kzvn.xyz/",
        provider: "KZVN"
      },
      {
        address: "https://airchains-rpc.elessarnodes.xyz/",
        provider: "Elessar Nodes"
      },
      {
        address: "https://junction-rpc.apollo-sync.com/",
        provider: "Apollo Sync"
      },
      {
        address: "https://rpc-airchain.danggia.xyz/",
        provider: "DANGGIA"
      },
      {
        address: "https://airchains-rpc.stakeme.pro/",
        provider: "Stakeme"
      },
      {
        address: "https://airchains-testnet-rpc.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://airchains-testnet-rpc.crouton.digital/",
        provider: "Crouton Digital"
      },
      {
        address: "https://airchains-testnet-rpc.itrocket.net/",
        provider: "IT Rocket"
      },
      {
        address: "https://rpc1.airchains.t.cosmostaking.com/",
        provider: "Cosmostaking"
      }
    ],
    rest: [
      {
        address: "https://rest.nodejumper.io/airchainstestnet",
        provider: "Nodejumper"
      },
      {
        address: "https://t-airchains.api.utsa.tech/",
        provider: "UTSA"
      },
      {
        address: "https://airchains.api.t.stavr.tech/",
        provider: "Stavr Tech"
      },
      {
        address: "https://airchains-api.chainad.org/",
        provider: "Coin Hunterstr "
      },
      {
        address: "https://junction-api.kzvn.xyz/",
        provider: "KZVN"
      },
      {
        address: "https://airchains-api.elessarnodes.xyz/",
        provider: "Elessar Nodes"
      },
      {
        address: "https://junction-api.apollo-sync.com/",
        provider: "Apollo Sync"
      },
      {
        address: "https://api-airchain.danggia.xyz/",
        provider: "DANGGIA"
      },
      {
        address: "https://airchains-rest.stakeme.pro/",
        provider: "Stakeme"
      },
      {
        address: "https://airchains-testnet-rest.stakerhouse.com",
        provider: "StakerHouse"
      },
      {
        address: "https://airchains-testnet-api.crouton.digital/",
        provider: "Crouton Digital"
      },
      {
        address: "https://airchains-testnet-api.itrocket.net/",
        provider: "IT Rocket"
      },
      {
        address: "https://rest1.airchains.t.cosmostaking.com/",
        provider: "Cosmostaking"
      }
    ],
    grpc: [
      {
        address: "airchains.grpc.t.stavr.tech:152",
        provider: "Stavr Tech"
      },
      {
        address: "airchains-testnet-grpc.stakerhouse.com:443",
        provider: "StakerHouse"
      },
      {
        address: "airchains-testnet-grpc.crouton.digital:28190",
        provider: "Crouton Digital"
      },
      {
        address: "airchains-testnet-grpc.itrocket.net:443",
        provider: "IT Rocket"
      },
      {
        address: "http://grpc1.airchains.t.cosmostaking.com/",
        provider: "Cosmostaking"
      }
    ]
  },
  explorers: [
    {
      kind: "Airchains",
      url: "https://testnet.airchains.io",
      tx_page: "https://testnet.airchains.io/transaction/${txHash}",
      account_page: "https://testnet.airchains.io/address/${accountAddress}"
    },
    {
      kind: "NodesGuru",
      url: "https://testnet.junction.explorers.guru/",
      tx_page: "https://testnet.junction.explorers.guru/transaction/${txHash}",
      account_page: "https://testnet.junction.explorers.guru/account/${accountAddress}"
    },
    {
      kind: "Nodejumper",
      url: "https://app.nodejumper.io/airchains-testnet/"
    },
    {
      kind: "UTSA",
      url: "https://exp.utsa.tech/airchains-test/",
      tx_page: "https://exp.utsa.tech/airchains-test/tx/${txHash}",
      account_page: "https://exp.utsa.tech/airchains-test/account/${accountAddress}"
    },
    {
      kind: "Stavr Tech",
      url: "https://explorer.stavr.tech/Airchains-Testnet",
      tx_page: "https://explorer.stavr.tech/Airchains-Testnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Airchains-Testnet/${accountAddress}"
    },
    {
      kind: "CoinHunters",
      url: "https://explorer.coinhunterstr.com/Airchains",
      tx_page: "https://explorer.coinhunterstr.com/Airchains/tx/${txHash}",
      account_page: "https://explorer.coinhunterstr.com/Airchains/account/${accountAddress}"
    },
    {
      kind: "KZVN",
      url: "https://explorer.kzvn.xyz/airchains",
      tx_page: "https://explorer.kzvn.xyz/airchains/tx/${txHash}",
      account_page: "https://explorer.kzvn.xyz/airchains/account/${accountAddress}"
    },
    {
      kind: "Elessar Nodes",
      url: "https://explorer.elessarnodes.xyz/Airchains",
      tx_page: "https://explorer.elessarnodes.xyz/Airchains/tx/${txHash}",
      account_page: "https://explorer.elessarnodes.xyz/Airchains/account/${accountAddress}"
    },
    {
      kind: "Apollo Sync",
      url: "https://explorer.apollo-sync.com/",
      tx_page: "https://explorer.apollo-sync.com/tx/${txHash}",
      account_page: "https://explorer.apollo-sync.com/account/${accountAddress}"
    },
    {
      kind: "Stakeme",
      url: "https://airchains.exploreme.pro/",
      tx_page: "https://airchains.exploreme.pro/transaction/${txHash}"
    },
    {
      kind: "StakerHouse",
      url: "https://cosmotracker.com/airchains",
      tx_page: "https://cosmotracker.com/airchains/tx/${txHash}",
      account_page: "https://cosmotracker.com/airchains/account/${accountAddress}"
    },
    {
      kind: "IT Rocket",
      url: "https://testnet.itrocket.net/airchains/",
      tx_page: "https://testnet.itrocket.net/airchains//tx/${txHash}",
      account_page: "https://testnet.itrocket.net/airchains/account/${accountAddress}"
    },
    {
      kind: "Validator VN ",
      url: "https://explorer.validatorvn.com/Airchains-Testnet",
      tx_page: "https://explorer.validatorvn.com/Airchains-Testnet/tx/${txHash}",
      account_page: "https://explorer.validatorvn.com/Airchains-Testnet/account/${accountAddress}"
    }
  ]
};
Hw.default = Yde;
var Bj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ir, "__esModule", { value: !0 });
Ir.chain = Ir.assets = void 0;
const Jde = Bj(Uw), Zde = Bj(Hw);
Ir.assets = Jde.default;
Ir.chain = Zde.default;
var ga = {}, Lw = {};
Object.defineProperty(Lw, "__esModule", { value: !0 });
const Qde = {
  $schema: "../../assetlist.schema.json",
  chain_name: "akashtestnet",
  assets: [{
    description: "Akash Token (AKT) is the Akash Network's native utility token, used as the primary means to govern, secure the blockchain, incentivize participants, and provide a default mechanism to store and exchange value.",
    denom_units: [{
      denom: "uakt",
      exponent: 0
    }, {
      denom: "akt",
      exponent: 6
    }],
    base: "uakt",
    name: "Akash Network",
    display: "akt",
    symbol: "AKT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
    }]
  }]
};
Lw.default = Qde;
var Ww = {};
Object.defineProperty(Ww, "__esModule", { value: !0 });
const eme = {
  $schema: "../../chain.schema.json",
  chain_name: "akashtestnet",
  status: "live",
  network_type: "testnet",
  website: "https://akash.network/",
  pretty_name: "Sandbox",
  chain_type: "cosmos",
  chain_id: "sandbox-01",
  bech32_prefix: "akash",
  daemon_name: "akash",
  node_home: "$HOME/.akash",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uakt",
      fixed_min_gas_price: 0,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uakt"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.sandbox-01.aksh.pw:443",
      provider: "akash"
    }],
    rest: [{
      address: "https://api.sandbox-01.aksh.pw:443",
      provider: "akash"
    }],
    grpc: [{
      address: "grpc.sandbox-01.aksh.pw:9090",
      provider: "akash"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://explorer.sandbox-01.aksh.pw/akash",
    tx_page: "https://explorer.sandbox-01.aksh.pw/akash/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
  }]
};
Ww.default = eme;
var Vw = {};
Object.defineProperty(Vw, "__esModule", { value: !0 });
const nme = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "akashtestnet",
    client_id: "07-tendermint-4",
    connection_id: "connection-4"
  },
  chain_2: {
    chain_name: "archwaytestnet",
    client_id: "07-tendermint-45",
    connection_id: "connection-39"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-4",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-34",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live"
    }
  }]
}, {
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "akashtestnet",
    client_id: "07-tendermint-6",
    connection_id: "connection-6"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-1271",
    connection_id: "connection-1171"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-6",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-4171",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Vw.default = nme;
var Gw = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ga, "__esModule", { value: !0 });
ga.ibc = ga.chain = ga.assets = void 0;
const tme = Gw(Lw), sme = Gw(Ww), ame = Gw(Vw);
ga.assets = tme.default;
ga.chain = sme.default;
ga.ibc = ame.default;
var ua = {}, Kw = {};
Object.defineProperty(Kw, "__esModule", { value: !0 });
const ome = {
  $schema: "../../assetlist.schema.json",
  chain_name: "archwaytestnet",
  assets: [
    {
      description: "The native token of Archway Test Network.",
      denom_units: [
        {
          denom: "aconst",
          exponent: 0
        },
        {
          denom: "uconst",
          exponent: 12
        },
        {
          denom: "const",
          exponent: 18
        }
      ],
      base: "aconst",
      name: "Archway",
      display: "const",
      symbol: "CONST",
      traces: [{
        type: "test-mintage",
        counterparty: {
          chain_name: "archway",
          base_denom: "aarch"
        },
        provider: "Archway Testnet"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.svg"
      },
      images: [{
        image_sync: {
          chain_name: "archway",
          base_denom: "aarch"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/arch.svg",
        theme: {
          primary_color_hex: "#fc4c04"
        }
      }],
      socials: {
        website: "https://archway.io/",
        twitter: "https://twitter.com/archwayHQ"
      }
    },
    {
      description: "Wrapped CONST (Archway Testnet token)",
      type_asset: "cw20",
      address: "archway1dz6h2smr432gvzruklk3lps7ak2ca7cngdge4vym93wehkkypwpqgwr2q2",
      denom_units: [{
        denom: "cw20:archway1dz6h2smr432gvzruklk3lps7ak2ca7cngdge4vym93wehkkypwpqgwr2q2",
        exponent: 0
      }, {
        denom: "wARCH",
        exponent: 18
      }],
      base: "cw20:archway1dz6h2smr432gvzruklk3lps7ak2ca7cngdge4vym93wehkkypwpqgwr2q2",
      name: "Wrapped ARCH",
      display: "wARCH",
      symbol: "wARCH",
      traces: [{
        type: "wrapped",
        counterparty: {
          chain_name: "archwaytestnet",
          base_denom: "aconst"
        },
        provider: "Archway"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.svg"
      },
      images: [{
        image_sync: {
          chain_name: "archway",
          base_denom: "cw20:archway1msc3fa4e2mh73y760qmjd3wfkzr98nl26f36xgt2xnhuw6ay3scs42zeue"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wArch.svg",
        theme: {
          primary_color_hex: "#000000"
        }
      }]
    },
    {
      description: "Circle's USDC Noble Testnet (Grand) on Archway Testnet",
      denom_units: [{
        denom: "ibc/34F8D3402273FFA5278AE5757D81CE151ACFD4B19C494C0EE372A7229714824F",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/34F8D3402273FFA5278AE5757D81CE151ACFD4B19C494C0EE372A7229714824F",
      name: "USDC (Noble)",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nobletestnet",
          base_denom: "uusdc",
          channel_id: "channel-215"
        },
        chain: {
          channel_id: "channel-500",
          path: "transfer/channel-500/uusdc"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "Wrapped USDC (Noble Testnet Grand)",
      type_asset: "cw20",
      address: "archway172vetupqnkgdc7dp3gwqpvk5ljmgzyj2gs4ag2fdmp0s2rucxxsqh0nqeu",
      denom_units: [{
        denom: "cw20:archway172vetupqnkgdc7dp3gwqpvk5ljmgzyj2gs4ag2fdmp0s2rucxxsqh0nqeu",
        exponent: 0
      }, {
        denom: "wUSDC",
        exponent: 6
      }],
      base: "cw20:archway172vetupqnkgdc7dp3gwqpvk5ljmgzyj2gs4ag2fdmp0s2rucxxsqh0nqeu",
      name: "Wrapped USDC",
      display: "wUSDC",
      symbol: "wUSDC",
      traces: [{
        type: "wrapped",
        counterparty: {
          chain_name: "archwaytestnet",
          base_denom: "ibc/34F8D3402273FFA5278AE5757D81CE151ACFD4B19C494C0EE372A7229714824F"
        },
        provider: "Archway"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wUsdc-noble.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wUsdc-noble.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wUsdc-noble.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/archway/images/wUsdc-noble.svg",
        theme: {
          primary_color_hex: "#000000"
        }
      }]
    }
  ]
};
Kw.default = ome;
var Xw = {};
Object.defineProperty(Xw, "__esModule", { value: !0 });
const rme = {
  $schema: "../../chain.schema.json",
  chain_name: "archwaytestnet",
  chain_type: "cosmos",
  chain_id: "constantine-3",
  pretty_name: "Archway Testnet",
  status: "live",
  network_type: "testnet",
  website: "https://archway.io",
  bech32_prefix: "archway",
  daemon_name: "archwayd",
  node_home: "$HOME/.archway",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "aconst",
      low_gas_price: 1e12,
      average_gas_price: 15e11,
      high_gas_price: 2e12
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aconst"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/archwaytestnet/images/ArchwayBrandmark.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/archwaytestnet/images/ArchwayBrandmark.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.constantine.archway.io",
      provider: "Archway"
    }, {
      address: "https://archway-testnet-rpc.polkachu.com",
      provider: "Polkachu"
    }],
    rest: [{
      address: "https://api.constantine.archway.io",
      provider: "Archway"
    }]
  },
  explorers: [{
    kind: "archwayscan",
    url: "https://testnet.archway.explorers.guru",
    tx_page: "https://testnet.archway.explorers.guru/transaction/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/archwaytestnet/images/ArchwayBrandmark.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/archwaytestnet/images/ArchwayBrandmark.svg"
  }]
};
Xw.default = rme;
var Yw = {};
Object.defineProperty(Yw, "__esModule", { value: !0 });
const ime = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "akashtestnet",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    chain_2: {
      chain_name: "archwaytestnet",
      client_id: "07-tendermint-45",
      connection_id: "connection-39"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-34",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "archwaytestnet",
      client_id: "07-tendermint-70",
      connection_id: "connection-60"
    },
    chain_2: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-603",
      connection_id: "connection-418"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-305",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "archwaytestnet",
      client_id: "07-tendermint-0",
      connection_id: "connection-119"
    },
    chain_2: {
      chain_name: "jackaltestnet2",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-368",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "archwaytestnet",
      client_id: "07-tendermint-121",
      connection_id: "connection-120"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3459",
      connection_id: "connection-3027"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-225",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-7779",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live"
        }
      },
      {
        chain_1: {
          channel_id: "*",
          port_id: "wasm.*"
        },
        chain_2: {
          channel_id: "*",
          port_id: "icahost"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live"
        }
      },
      {
        chain_1: {
          channel_id: "*",
          port_id: "wasm.*"
        },
        chain_2: {
          channel_id: "*",
          port_id: "icqhost"
        },
        ordering: "unordered",
        version: "icq-1",
        tags: {
          status: "live"
        }
      }
    ]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "archwaytestnet",
      client_id: "07-tendermint-139",
      connection_id: "connection-144"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-25",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-495",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
Yw.default = ime;
var Jw = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ua, "__esModule", { value: !0 });
ua.ibc = ua.chain = ua.assets = void 0;
const cme = Jw(Kw), dme = Jw(Xw), mme = Jw(Yw);
ua.assets = cme.default;
ua.chain = dme.default;
ua.ibc = mme.default;
var Nr = {}, Zw = {};
Object.defineProperty(Zw, "__esModule", { value: !0 });
const hme = {
  $schema: "../../assetlist.schema.json",
  chain_name: "arkeonetworktestnet",
  assets: [{
    denom_units: [{
      denom: "uarkeo",
      exponent: 0
    }, {
      denom: "arkeo",
      exponent: 6
    }],
    base: "uarkeo",
    display: "arkeo",
    name: "Arkeo",
    symbol: "ARKEO",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/arkeonetworktestnet/images/arkeo.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/arkeonetworktestnet/images/arkeo.png"
    }]
  }]
};
Zw.default = hme;
var Qw = {};
Object.defineProperty(Qw, "__esModule", { value: !0 });
const pme = {
  $schema: "../../chain.schema.json",
  chain_name: "arkeonetworktestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Arkeo Network",
  chain_type: "cosmos",
  chain_id: "arkeo",
  bech32_prefix: "tarkeo",
  daemon_name: "arkeod",
  node_home: "$HOME/.arkeo",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uarkeo"
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uarkeo"
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://arkeonetwork-testnet.nodejumper.io:26657",
        provider: "NODEJUMPER"
      },
      {
        address: "https://test-arkeo-rpc.kynraze.com",
        provider: "kynraze"
      },
      {
        address: "https://testnet-arkeo-rpc.lavenderfive.com",
        provider: "lavenderfive"
      },
      {
        address: "https://arkeo-rpc.siriusnodes.uk",
        provider: "siriusnodes"
      },
      {
        address: "http://seed.arkeo.network:26657",
        provider: "arkeo"
      }
    ],
    rest: [
      {
        address: "https://arkeonetwork-testnet.nodejumper.io:1317",
        provider: "NODEJUMPER"
      },
      {
        address: "https://test-arkeo-api.kynraze.com",
        provider: "kynraze"
      },
      {
        address: "https://testnet-arkeo-api.lavenderfive.com",
        provider: "lavenderfive"
      },
      {
        address: "https://arkeo-api.siriusnodes.uk",
        provider: "siriusnodes"
      },
      {
        address: "http://seed.arkeo.network:1317",
        provider: "arkeo"
      }
    ],
    grpc: [{
      address: "https://arkeonetwork-testnet.nodejumper.io:9090/",
      provider: "NODEJUMPER"
    }]
  },
  explorers: [{
    url: "https://explorer.nodexcapital.com/arkeo",
    tx_page: "https://explorer.nodexcapital.com/arkeo/tx/${txHash}"
  }]
};
Qw.default = pme;
var Fj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Nr, "__esModule", { value: !0 });
Nr.chain = Nr.assets = void 0;
const lme = Fj(Zw), gme = Fj(Qw);
Nr.assets = lme.default;
Nr.chain = gme.default;
var Pr = {}, e4 = {};
Object.defineProperty(e4, "__esModule", { value: !0 });
const ume = {
  $schema: "../../assetlist.schema.json",
  chain_name: "artelatestnet",
  assets: [{
    description: "The native EVM, governance and staking token of the Artela Network",
    denom_units: [{
      denom: "uart",
      exponent: 0
    }, {
      denom: "art",
      exponent: 18
    }],
    base: "uart",
    name: "Artela Testnet",
    display: "art",
    symbol: "ART",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/artelatestnet/images/artela.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/artelatestnet/images/artela.png"
    }]
  }]
};
e4.default = ume;
var n4 = {};
Object.defineProperty(n4, "__esModule", { value: !0 });
const _me = {
  $schema: "../../chain.schema.json",
  chain_name: "artelatestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Artela Testnet",
  chain_type: "cosmos",
  chain_id: "artela_11820-1",
  bech32_prefix: "art",
  daemon_name: "artelad",
  node_home: "$HOME/.artelad",
  key_algos: ["ethsecp256k1"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "uart",
      low_gas_price: 2e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uart"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47"
  },
  apis: {
    rpc: [{
      address: "https://testnet-rpc1.artela.network",
      provider: "Artela Foundation"
    }, {
      address: "https://testnet-rpc2.artela.network",
      provider: "Artela Foundation"
    }],
    rest: [{
      address: "https://testnet-rpc1.artela.network",
      provider: "Artela Foundation"
    }, {
      address: "https://testnet-rpc2.artela.network",
      provider: "Artela Foundation"
    }],
    grpc: [{
      address: "https://testnet-rpc1.artela.network",
      provider: "Artela Foundation"
    }]
  },
  explorers: [{
    kind: "Artela Network",
    url: "https://testnet-scan.artela.network",
    tx_page: "https://testnet-scan.artela.network/tx/${txHash}"
  }]
};
n4.default = _me;
var $j = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Pr, "__esModule", { value: !0 });
Pr.chain = Pr.assets = void 0;
const yme = $j(e4), bme = $j(n4);
Pr.assets = yme.default;
Pr.chain = bme.default;
var Ur = {}, t4 = {};
Object.defineProperty(t4, "__esModule", { value: !0 });
const vme = {
  $schema: "../../assetlist.schema.json",
  chain_name: "auratestnet",
  assets: [{
    description: "The native token of Aura Test Network",
    denom_units: [{
      denom: "ueaura",
      exponent: 0
    }, {
      denom: "eaura",
      exponent: 6
    }],
    base: "ueaura",
    name: "EAura",
    display: "eaura",
    symbol: "EAURA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.svg"
    }]
  }]
};
t4.default = vme;
var s4 = {};
Object.defineProperty(s4, "__esModule", { value: !0 });
const fme = {
  $schema: "../../chain.schema.json",
  chain_name: "auratestnet",
  status: "live",
  network_type: "testnet",
  website: "https://aura.network/",
  pretty_name: "Aura Euphoria Network",
  chain_type: "cosmos",
  chain_id: "aura_6321-3",
  bech32_prefix: "aura",
  daemon_name: "aurad",
  node_home: "$HOME/.aura",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ueaura",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 1e-3,
      average_gas_price: 2e-3,
      high_gas_price: 25e-4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ueaura"
    }],
    lock_duration: {
      time: "172800s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.47.8",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.42.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.euphoria.aura.network/",
      provider: "Aura Network Foundation"
    }],
    rest: [{
      address: "https://lcd.euphoria.aura.network/",
      provider: "Aura Network Foundation"
    }],
    grpc: [{
      address: "http://grpc.euphoria.aura.network:9090",
      provider: "Aura Network Foundation"
    }]
  },
  explorers: [{
    kind: "aurascan",
    url: "https://euphoria.aurascan.io",
    tx_page: "https://euphoria.aurascan.io/tx/${txHash}",
    account_page: "https://euphoria.aurascan.io/address/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/aura/images/Aura-logo-2.2.svg"
  }]
};
s4.default = fme;
var zj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ur, "__esModule", { value: !0 });
Ur.chain = Ur.assets = void 0;
const wme = zj(t4), xme = zj(s4);
Ur.assets = wme.default;
Ur.chain = xme.default;
var _a = {}, a4 = {};
Object.defineProperty(a4, "__esModule", { value: !0 });
const kme = {
  $schema: "../../assetlist.schema.json",
  chain_name: "axelartestnet",
  assets: [
    {
      description: "The native token of Axelar",
      denom_units: [{
        denom: "uaxl",
        exponent: 0
      }, {
        denom: "axl",
        exponent: 6
      }],
      base: "uaxl",
      name: "Axelar",
      display: "axl",
      symbol: "AXL",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg"
      },
      coingecko_id: "axelar",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg"
      }]
    },
    {
      description: "Circle's stablecoin on Axelar",
      denom_units: [{
        denom: "uausdc",
        exponent: 0
      }, {
        denom: "ausdc",
        exponent: 6
      }],
      base: "uausdc",
      name: "USD Coin",
      display: "ausdc",
      symbol: "aUSDC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereumtestnet",
          base_denom: "0x254d06f33bDc5b8ee05b2ea472107E300226659A"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereumtestnet",
          base_denom: "0x254d06f33bDc5b8ee05b2ea472107E300226659A"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }
    },
    {
      description: "Wrapped Ether on Axelar",
      denom_units: [{
        denom: "eth-wei",
        exponent: 0
      }, {
        denom: "weth",
        exponent: 18
      }],
      base: "eth-wei",
      name: "Wrapped Ether",
      display: "weth",
      symbol: "axlWETH",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "ethereumtestnet",
          base_denom: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "ethereumtestnet",
          base_denom: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }
    },
    {
      description: "Wrapped Moonbeam on Axelar",
      denom_units: [{
        denom: "wglmr-wei",
        exponent: 0
      }, {
        denom: "wglmr",
        exponent: 18
      }],
      base: "wglmr-wei",
      name: "Wrapped Moonbeam",
      display: "wglmr",
      symbol: "WDEV",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "moonbeamtestnet",
          base_denom: "0x1436aE0dF0A8663F18c0Ec51d7e2E46591730715"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "moonbeamtestnet",
          base_denom: "0x1436aE0dF0A8663F18c0Ec51d7e2E46591730715"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/moonbeam/images/glmr.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/moonbeam/images/glmr.svg"
      }
    },
    {
      description: "Wrapped Matic on Axelar",
      denom_units: [{
        denom: "wmatic-wei",
        exponent: 0
      }, {
        denom: "wmatic",
        exponent: 18
      }],
      base: "wmatic-wei",
      name: "Wrapped Matic",
      display: "wmatic",
      symbol: "WMATIC",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "polygontestnet",
          base_denom: "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "polygontestnet",
          base_denom: "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polygon/images/wmatic.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polygon/images/wmatic.svg"
      }
    },
    {
      description: "Wrapped BNB on Axelar",
      denom_units: [{
        denom: "wbnb-wei",
        exponent: 0
      }, {
        denom: "wbnb",
        exponent: 18
      }],
      base: "wbnb-wei",
      name: "Wrapped BNB",
      display: "wbnb",
      symbol: "WBNB",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "binancesmartchaintestnet",
          base_denom: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "binancesmartchaintestnet",
          base_denom: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/wbnb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/wbnb.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/wbnb.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/binancesmartchain/images/wbnb.svg"
      }
    },
    {
      description: "Wrapped AVAX on Axelar.",
      denom_units: [{
        denom: "wavax-wei",
        exponent: 0
      }, {
        denom: "avax",
        exponent: 18
      }],
      base: "wavax-wei",
      name: "Wrapped AVAX",
      display: "avax",
      symbol: "WAVAX",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "avalanchetestnet",
          base_denom: "0xd00ae08403B9bbb9124bB305C09058E32C39A48c"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "avalanchetestnet",
          base_denom: "0xd00ae08403B9bbb9124bB305C09058E32C39A48c"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/wavax.svg"
      }],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/avalanche/images/wavax.svg"
      }
    },
    {
      description: "Wrapped FTM on Axelar.",
      denom_units: [{
        denom: "wftm-wei",
        exponent: 0
      }, {
        denom: "ftm",
        exponent: 18
      }],
      base: "wftm-wei",
      name: "Wrapped FTM",
      display: "ftm",
      symbol: "WFTM",
      traces: [{
        type: "bridge",
        counterparty: {
          chain_name: "fantomtestnet",
          base_denom: "0x812666209b90344Ec8e528375298ab9045c2Bd08"
        },
        provider: "Axelar"
      }],
      images: [{
        image_sync: {
          chain_name: "fantomtestnet",
          base_denom: "0x812666209b90344Ec8e528375298ab9045c2Bd08"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/fantom/images/ftm.png"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/fantom/images/ftm.png"
      }
    }
  ]
};
a4.default = kme;
var o4 = {};
Object.defineProperty(o4, "__esModule", { value: !0 });
const Ame = {
  $schema: "../../chain.schema.json",
  chain_name: "axelartestnet",
  chain_type: "cosmos",
  chain_id: "axelar-testnet-lisbon-3",
  pretty_name: "Axelar Testnet",
  status: "live",
  network_type: "testnet",
  website: "https://axelar.network/",
  bech32_prefix: "axelar",
  daemon_name: "axelard",
  node_home: "$HOME/.axelard",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uaxl",
      low_gas_price: 7e-3,
      average_gas_price: 7e-3,
      high_gas_price: 0.01
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uaxl"
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://rpc-axelar-testnet.imperator.co:443",
        provider: "Imperator.co"
      },
      {
        address: "https://axelartest-rpc.quickapi.com/",
        provider: "Quickapi"
      },
      {
        address: "https://axelar-testnet-rpc.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ],
    rest: [
      {
        address: "https://lcd-axelar-testnet.imperator.co:443",
        provider: "Imperator.co"
      },
      {
        address: "https://axelartest-lcd.quickapi.com/",
        provider: "Quickapi"
      },
      {
        address: "https://axelar-testnet-api.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ]
  },
  explorers: [{
    kind: "axelarscan",
    url: "https://testnet.axelarscan.io",
    tx_page: "https://testnet.axelarscan.io/tx/${txHash}"
  }, {
    kind: "mintscan",
    url: "https://mintscan.io/axelar-testnet",
    tx_page: "https://mintscan.io/axelar-testnet/txs/${txHash}",
    account_page: "https://mintscan.io/axelar-testnet/account/${accountAddress}"
  }]
};
o4.default = Ame;
var r4 = {};
Object.defineProperty(r4, "__esModule", { value: !0 });
const jme = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "archwaytestnet",
      client_id: "07-tendermint-70",
      connection_id: "connection-60"
    },
    chain_2: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-603",
      connection_id: "connection-418"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-50",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-305",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-594",
      connection_id: "connection-410"
    },
    chain_2: {
      chain_name: "dydxtestnet",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-297",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-855",
      connection_id: "connection-659"
    },
    chain_2: {
      chain_name: "lavatestnet",
      client_id: "07-tendermint-10",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-444",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-1009",
      connection_id: "connection-783"
    },
    chain_2: {
      chain_name: "mantrachaintestnet",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-540",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-685",
      connection_id: "connection-538"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1270",
      connection_id: "connection-1169"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-339",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4170",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-213",
      connection_id: "connection-151"
    },
    chain_2: {
      chain_name: "osmosistestnet4",
      client_id: "07-tendermint-3319",
      connection_id: "connection-2807"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-135",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1946",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-522",
      connection_id: "connection-372"
    },
    chain_2: {
      chain_name: "persistencetestnet2",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-261",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-767",
      connection_id: "connection-581"
    },
    chain_2: {
      chain_name: "sagatestnet",
      client_id: "07-tendermint-11",
      connection_id: "connection-10"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-370",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-9",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-1001",
      connection_id: "connection-780"
    },
    chain_2: {
      chain_name: "titantestnet",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-537",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-970",
      connection_id: "connection-752"
    },
    chain_2: {
      chain_name: "xiontestnet",
      client_id: "07-tendermint-127",
      connection_id: "connection-64"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-521",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-225057",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
r4.default = jme;
var i4 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(_a, "__esModule", { value: !0 });
_a.ibc = _a.chain = _a.assets = void 0;
const Cme = i4(a4), Eme = i4(o4), Dme = i4(r4);
_a.assets = Cme.default;
_a.chain = Eme.default;
_a.ibc = Dme.default;
var Hr = {}, c4 = {};
Object.defineProperty(c4, "__esModule", { value: !0 });
const Bme = {
  $schema: "../../assetlist.schema.json",
  chain_name: "babylontestnet",
  assets: [{
    description: "The native staking token of Babylon.",
    denom_units: [{
      denom: "ubbn",
      exponent: 0
    }, {
      denom: "bbn",
      exponent: 6
    }],
    base: "ubbn",
    name: "Babylon BBN",
    display: "bbn",
    symbol: "BBN",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/babylon/images/logo.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/babylon/images/logo.svg"
    }]
  }]
};
c4.default = Bme;
var d4 = {};
Object.defineProperty(d4, "__esModule", { value: !0 });
const Fme = {
  $schema: "../../chain.schema.json",
  chain_name: "babylontestnet",
  status: "live",
  website: "https://www.babylonchain.io",
  network_type: "testnet",
  pretty_name: "Babylon Testnet 3",
  chain_type: "cosmos",
  chain_id: "bbn-test3",
  pre_fork_chain_name: "babylontestnet1",
  bech32_prefix: "bbn",
  daemon_name: "babylond",
  node_home: "$HOME/.babylond",
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "ubbn"
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ubbn"
    }]
  },
  codebase: {},
  logo_URIs: {
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/babylontestnet/images/logo.svg"
  },
  apis: {
    rpc: [{
      address: "rpc.testnet3.babylonchain.io:443",
      provider: "Babylon foundation"
    }],
    rest: [{
      address: "lcd.testnet3.babylonchain.io:443",
      provider: "Babylon foundation"
    }],
    grpc: []
  },
  explorers: [{
    kind: "babylonscan",
    url: "https://babylonscan.io"
  }, {
    kind: "explorers.guru",
    url: "https://testnet.babylon.explorers.guru",
    tx_page: "https://testnet.babylon.explorers.guru/transaction/${txHash}"
  }],
  images: [{
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/babylontestnet/images/logo.svg"
  }],
  slip44: 118
};
d4.default = Fme;
var qj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Hr, "__esModule", { value: !0 });
Hr.chain = Hr.assets = void 0;
const $me = qj(c4), zme = qj(d4);
Hr.assets = $me.default;
Hr.chain = zme.default;
var Lr = {}, m4 = {};
Object.defineProperty(m4, "__esModule", { value: !0 });
const qme = {
  $schema: "../../assetlist.schema.json",
  chain_name: "babylontestnet1",
  assets: [{
    description: "The native staking token of Babylon.",
    denom_units: [{
      denom: "ubbn",
      exponent: 0
    }, {
      denom: "bbn",
      exponent: 6
    }],
    base: "ubbn",
    name: "Babylon BBN",
    display: "bbn",
    symbol: "BBN",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/babylon/images/logo.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/babylon/images/logo.svg"
    }]
  }]
};
m4.default = qme;
var h4 = {};
Object.defineProperty(h4, "__esModule", { value: !0 });
const Sme = {
  $schema: "../../chain.schema.json",
  chain_name: "babylontestnet1",
  status: "killed",
  website: "https://www.babylonchain.io",
  network_type: "testnet",
  pretty_name: "Babylon Testnet",
  chain_type: "cosmos",
  chain_id: "bbn-test1",
  bech32_prefix: "bbn",
  daemon_name: "babylond",
  node_home: "$HOME/.babylond",
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "ubbn"
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ubbn"
    }]
  },
  codebase: {},
  logo_URIs: {
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/babylontestnet/images/logo.svg"
  },
  apis: {
    rpc: [{
      address: "rpc.testnet.babylonchain.io:26657",
      provider: "Babylon foundation"
    }],
    rest: [{
      address: "rpc.testnet.babylonchain.io:1317",
      provider: "Babylon foundation"
    }],
    grpc: []
  },
  explorers: [{
    kind: "babylonscan",
    url: "https://babylonscan.io"
  }, {
    kind: "explorers.guru",
    url: "https://babylon.explorers.guru",
    tx_page: "https://babylon.explorers.guru/transaction/${txHash}"
  }],
  images: [{
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/babylontestnet/images/logo.svg"
  }],
  slip44: 118
};
h4.default = Sme;
var Sj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Lr, "__esModule", { value: !0 });
Lr.chain = Lr.assets = void 0;
const Tme = Sj(m4), Rme = Sj(h4);
Lr.assets = Tme.default;
Lr.chain = Rme.default;
var Wr = {}, p4 = {};
Object.defineProperty(p4, "__esModule", { value: !0 });
const Ome = {
  $schema: "../../assetlist.schema.json",
  chain_name: "bitcannadevnet",
  assets: [{
    description: "The BCNA coin is the transactional token within the BitCanna network, serving the legal cannabis industry through its payment network, supply chain and trust network.",
    denom_units: [{
      denom: "ubcna",
      exponent: 0
    }, {
      denom: "bcna",
      exponent: 6
    }],
    base: "ubcna",
    display: "bcna",
    name: "BitCanna",
    symbol: "BCNA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/bitcannadevnet/images/bcna.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/bitcannadevnet/images/bcna.svg"
    },
    coingecko_id: "bitcanna",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/bitcannadevnet/images/bcna.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/bitcannadevnet/images/bcna.svg"
    }]
  }]
};
p4.default = Ome;
var l4 = {};
Object.defineProperty(l4, "__esModule", { value: !0 });
const Mme = {
  $schema: "../../chain.schema.json",
  chain_name: "bitcannadevnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "BitCanna Devnet-1",
  chain_type: "cosmos",
  chain_id: "bitcanna-dev-1",
  bech32_prefix: "bcna",
  daemon_name: "bcnad",
  node_home: "$HOME/.bcna",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ubcna",
      fixed_min_gas_price: 1e-3
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://rpc-testnet.bitcanna.io",
        provider: "bitcanna"
      },
      {
        address: "https://bitcanna-testnet.rpc.kjnodes.com/",
        provider: "kjnodes.com"
      },
      {
        address: "https://testnet-bitcanna-rpc.konsortech.xyz/",
        provider: "konsortech.xyz"
      },
      {
        address: "https://rpc.bitcanna-dev-1.bitcanna.aviaone.com/",
        provider: "aviaone.com"
      },
      {
        address: "https://bitcanna-testnet.nodejumper.io:443",
        provider: "NODEJUMPER"
      },
      {
        address: "https://bcna-testnet-rpc.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ],
    rest: [
      {
        address: "https://lcd-testnet.bitcanna.io",
        provider: "bitcanna"
      },
      {
        address: "https://testnet-bitcanna-api.konsortech.xyz/",
        provider: "konsortech.xyz"
      },
      {
        address: "https://bitcanna.api.dev.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api.bitcanna-dev-1.bitcanna.aviaone.com/",
        provider: "aviaone.com"
      },
      {
        address: "https://bitcanna-testnet.api.kjnodes.com/",
        provider: "kjnodes.com"
      },
      {
        address: "https://bitcanna-testnet.nodejumper.io:1317",
        provider: "NODEJUMPER"
      },
      {
        address: "https://bcna-testnet-api.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ],
    grpc: [
      {
        address: "http://devnet-1.bitcanna.io:9090/",
        provider: "bitcanna"
      },
      {
        address: "http://bitcanna-testnet.grpc.kjnodes.com:42090/",
        provider: "kjnodes.com"
      },
      {
        address: "http://bitcanna.grpc.dev.stavr.tech:2901",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://bitcanna-testnet.nodejumper.io:9090",
        provider: "NODEJUMPER"
      }
    ]
  },
  explorers: [
    {
      url: "https://explorer.thesilverfox.pro/bitcanna",
      tx_page: "https://explorer.thesilverfox.pro/bitcanna/tx/${txHash}"
    },
    {
      url: "https://testnets-cosmos.mintthemoon.xyz/bitcanna",
      tx_page: "https://testnets-cosmos.mintthemoon.xyz/bitcanna/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Bitcanna-DEV",
      tx_page: "https://explorer.stavr.tech/Bitcanna-DEV/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Bitcanna-DEV/account/${accountAddress}"
    },
    {
      url: "https://explorer.kjnodes.com/bitcanna-testnet",
      tx_page: "https://explorer.kjnodes.com/bitcanna-testnet/tx/${txHash}"
    },
    {
      url: "https://explorer.stavr.tech/bitcanna-dev",
      tx_page: "https://explorer.stavr.tech/bitcanna-dev/tx/${txHash}"
    }
  ]
};
l4.default = Mme;
var Tj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Wr, "__esModule", { value: !0 });
Wr.chain = Wr.assets = void 0;
const Ime = Tj(p4), Nme = Tj(l4);
Wr.assets = Ime.default;
Wr.chain = Nme.default;
var Vr = {}, g4 = {};
Object.defineProperty(g4, "__esModule", { value: !0 });
const Pme = {
  $schema: "../../assetlist.schema.json",
  chain_name: "blockxtestnet",
  assets: [{
    description: "BlockX Native Token",
    denom_units: [{
      denom: "abcx",
      exponent: 0
    }, {
      denom: "bcx",
      exponent: 18
    }],
    base: "abcx",
    name: "BCX",
    display: "bcx",
    symbol: "BCX",
    type_asset: "sdk.coin",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/blockx/images/blockx.png"
    }],
    socials: {
      website: "https://www.blockxnet.com/"
    }
  }]
};
g4.default = Pme;
var u4 = {};
Object.defineProperty(u4, "__esModule", { value: !0 });
const Ume = {
  $schema: "../../chain.schema.json",
  chain_name: "blockxtestnet",
  chain_type: "cosmos",
  chain_id: "blockx_19077-1",
  pretty_name: "BlockX-Atlantis-Testnet",
  website: "https://www.blockxnet.com/",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "blockx",
  daemon_name: "blockxd",
  node_home: "$HOME/.blockxd",
  key_algos: ["ethsecp256k1"],
  staking: {
    staking_tokens: [{
      denom: "abcx"
    }]
  },
  slip44: 118
};
u4.default = Ume;
var Rj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Vr, "__esModule", { value: !0 });
Vr.chain = Vr.assets = void 0;
const Hme = Rj(g4), Lme = Rj(u4);
Vr.assets = Hme.default;
Vr.chain = Lme.default;
var Gr = {}, _4 = {};
Object.defineProperty(_4, "__esModule", { value: !0 });
const Wme = {
  $schema: "../../assetlist.schema.json",
  chain_name: "cascadiatestnet",
  assets: [{
    description: "The World's First  Neocybernetic  Blockchain",
    denom_units: [{
      denom: "aCC",
      exponent: 0
    }, {
      denom: "tCC",
      exponent: 18
    }],
    base: "aCC",
    name: "Сascadia Testnet",
    display: "tCC",
    symbol: "TCC",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cascadiatestnet/images/cascadia.png"
    },
    keywords: ["cascadia", "neocybernetic"],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cascadiatestnet/images/cascadia.png"
    }]
  }]
};
_4.default = Wme;
var y4 = {};
Object.defineProperty(y4, "__esModule", { value: !0 });
const Vme = {
  $schema: "../../chain.schema.json",
  chain_name: "cascadiatestnet",
  status: "live",
  network_type: "testnet",
  website: "https://cascadia.foundation/",
  pretty_name: "Cascadia",
  chain_type: "cosmos",
  chain_id: "cascadia_6102-1",
  bech32_prefix: "cascadia",
  daemon_name: "cascadiad",
  node_home: "$HOME/.cascadiad",
  key_algos: ["ethsecp256k1"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aCC",
      fixed_min_gas_price: 0,
      low_gas_price: 7,
      average_gas_price: 10,
      high_gas_price: 15
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aCC"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.46.10",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cascadiatestnet/images/cascadia.png",
    theme: {
      primary_color_hex: "#004A96"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cascadiatestnet/images/cascadia.png"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.cascadia.foundation:443",
        provider: "cascadia"
      },
      {
        address: "https://cscd-rpc.systemd.run:443",
        provider: "systemd"
      },
      {
        address: "https://api.cascadia-t.indonode.net:443",
        provider: "Indonode"
      },
      {
        address: "https://rpc-test.cascadia.hexnodes.co:443",
        provider: "Hexnodes"
      }
    ],
    grpc: [
      {
        address: "grpc.cascadia.foundation:443",
        provider: "cascadia"
      },
      {
        address: "cscd-grpc.systemd.run:443",
        provider: "systemd"
      },
      {
        address: "grpc.cascadia-t.indonode.net:43090",
        provider: "Indonode"
      },
      {
        address: "grpc-test.cascadia.hexnodes.co:19090",
        provider: "Hexnodes"
      }
    ],
    rest: [
      {
        address: "https://lcd.cascadia.foundation",
        provider: "cascadia"
      },
      {
        address: "https://cscd-api.systemd.run",
        provider: "systemd"
      },
      {
        address: "https://api.cascadia-t.indonode.net/",
        provider: "Indonode"
      },
      {
        address: "https://lcd-test.cascadia.hexnodes.co",
        provider: "Hexnodes"
      }
    ]
  },
  explorers: [{
    kind: "validator_explorer",
    url: "https://validator.cascadia.foundation/",
    tx_page: "https://validator.cascadia.foundation/transactions/${txHash}",
    account_page: "https://validator.cascadia.foundation/accounts/${accountAddress}"
  }, {
    kind: "block_explorer",
    url: "https://explorer.cascadia.foundation/",
    tx_page: "https://explorer.cascadia.foundation/tx/${txHash}",
    account_page: "https://explorer.cascadia.foundation/address/${accountAddress}"
  }],
  keywords: [
    "cascadia",
    "cosmos",
    "evm",
    "cybernetic"
  ]
};
y4.default = Vme;
var Oj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Gr, "__esModule", { value: !0 });
Gr.chain = Gr.assets = void 0;
const Gme = Oj(_4), Kme = Oj(y4);
Gr.assets = Gme.default;
Gr.chain = Kme.default;
var Kr = {}, b4 = {};
Object.defineProperty(b4, "__esModule", { value: !0 });
const Xme = {
  $schema: "../../assetlist.schema.json",
  chain_name: "celestiatestnet",
  assets: [{
    denom_units: [{
      denom: "utia",
      exponent: 0
    }, {
      denom: "tia",
      exponent: 6
    }],
    base: "utia",
    name: "Celestia",
    display: "tia",
    symbol: "TIA",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/celestiatestnet/images/celestia.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/celestiatestnet/images/celestia.svg"
    }]
  }]
};
b4.default = Xme;
var v4 = {};
Object.defineProperty(v4, "__esModule", { value: !0 });
const Yme = {
  $schema: "../../chain.schema.json",
  chain_name: "celestiatestnet",
  chain_type: "cosmos",
  chain_id: "blockspacerace-0",
  pretty_name: "Blockspace Race Testnet",
  status: "killed",
  network_type: "testnet",
  bech32_prefix: "celestia",
  daemon_name: "celestia-appd",
  node_home: "$HOME/.celestia-app",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utia",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc-blockspacerace.pops.one/",
      provider: "P-OPs"
    }],
    rest: [{
      address: "https://celestia-blockspacerace-rest.brocha.in",
      provider: "Brochain"
    }]
  },
  explorers: [{
    kind: "Mintscan",
    url: "https://mintscan.io/celestia-incentivized-testnet",
    tx_page: "https://mintscan.io/celestia-incentivized-testnet/txs/${txHash}"
  }]
};
v4.default = Yme;
var Mj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Kr, "__esModule", { value: !0 });
Kr.chain = Kr.assets = void 0;
const Jme = Mj(b4), Zme = Mj(v4);
Kr.assets = Jme.default;
Kr.chain = Zme.default;
var ya = {}, f4 = {};
Object.defineProperty(f4, "__esModule", { value: !0 });
const Qme = {
  $schema: "../../assetlist.schema.json",
  chain_name: "celestiatestnet3",
  assets: [{
    denom_units: [{
      denom: "utia",
      exponent: 0
    }, {
      denom: "tia",
      exponent: 6
    }],
    base: "utia",
    name: "Celestia",
    display: "tia",
    symbol: "TIA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/celestiatestnet3/images/celestia.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/celestiatestnet3/images/celestia.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/celestiatestnet3/images/celestia.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/celestiatestnet3/images/celestia.png"
    }]
  }]
};
f4.default = Qme;
var w4 = {};
Object.defineProperty(w4, "__esModule", { value: !0 });
const ehe = {
  $schema: "../../chain.schema.json",
  chain_name: "celestiatestnet3",
  chain_type: "cosmos",
  chain_id: "mocha-4",
  pretty_name: "Mocha Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "celestia",
  daemon_name: "celestia-appd",
  node_home: "$HOME/.celestia-app",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utia",
      fixed_min_gas_price: 0,
      low_gas_price: 0.01,
      average_gas_price: 0.02,
      high_gas_price: 0.1
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://rpc-mocha.pops.one",
        provider: "P-OPs"
      },
      {
        address: "https://celestia-testnet-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://rpc-mocha-full.avril14th.org",
        provider: "Avril 14th"
      },
      {
        address: "https://celestia-testnet-rpc.itrocket.net",
        provider: "🚀ITRocket🚀"
      },
      {
        address: "https://rpc-celestia-testnet.cryptech.com.ua",
        provider: "CrypTech"
      },
      {
        address: "https://rpc.celestia.testnet.dteam.tech:443",
        provider: "DTEAM"
      }
    ],
    rest: [
      {
        address: "https://api-mocha.pops.one",
        provider: "P-OPs"
      },
      {
        address: "https://celestia-testnet-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "https://api-mocha-full.avril14th.org",
        provider: "Avril 14th"
      },
      {
        address: "https://celestia-testnet-api.itrocket.net",
        provider: "🚀ITRocket🚀"
      },
      {
        address: "https://api-celestia-testnet.cryptech.com.ua",
        provider: "CrypTech"
      },
      {
        address: "https://api.celestia.testnet.dteam.tech:443",
        provider: "DTEAM"
      }
    ],
    grpc: [
      {
        address: "celestia-testnet-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      },
      {
        address: "grpc-mocha-full.avril14th.org",
        provider: "Avril 14th"
      },
      {
        address: "celestia-testnet-grpc.itrocket.net:11090",
        provider: "🚀ITRocket🚀"
      },
      {
        address: "https://grpc-celestia-testnet.cryptech.com.ua",
        provider: "CrypTech"
      },
      {
        address: "grpc.celestia.testnet.dteam.tech:27090",
        provider: "DTEAM"
      }
    ]
  },
  explorers: [
    {
      kind: "Mintscan",
      url: "https://mintscan.io/celestia-testnet",
      tx_page: "https://mintscan.io/celestia-testnet/txs/${txHash}"
    },
    {
      kind: "🚀ITRocket🚀",
      url: "https://testnet.itrocket.net/celestia",
      tx_page: "https://testnet.itrocket.net/celestia/tx/${txHash}",
      account_page: "https://testnet.itrocket.net/celestia/account/${accountAddress}"
    },
    {
      kind: "CrypTech",
      url: "https://explorers.cryptech.com.ua/Celestia-Testnet",
      tx_page: "https://explorers.cryptech.com.ua/Celestia-Testnet/tx/${txHash}",
      account_page: "https://explorers.cryptech.com.ua/Celestia-Testnet/account/${accountAddress}"
    },
    {
      kind: "DTEAM | Explorer",
      url: "https://explorer.testnet.dteam.tech/celestia",
      tx_page: "https://explorer.testnet.dteam.tech/celestia/tx/${txHash}",
      account_page: "https://explorer.testnet.dteam.tech/celestia/account/${accountAddress}"
    }
  ]
};
w4.default = ehe;
var x4 = {};
Object.defineProperty(x4, "__esModule", { value: !0 });
const nhe = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "celestiatestnet3",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "cosmoshubtestnet",
    client_id: "07-tendermint-2382",
    connection_id: "connection-2727"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-3152",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "celestiatestnet3",
    client_id: "07-tendermint-118",
    connection_id: "connection-98"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-1445",
    connection_id: "connection-1350"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-25",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-4370",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
x4.default = nhe;
var k4 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ya, "__esModule", { value: !0 });
ya.ibc = ya.chain = ya.assets = void 0;
const the = k4(f4), she = k4(w4), ahe = k4(x4);
ya.assets = the.default;
ya.chain = she.default;
ya.ibc = ahe.default;
var ba = {}, A4 = {};
Object.defineProperty(A4, "__esModule", { value: !0 });
const ohe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "chain4energytestnet",
  assets: [{
    description: "The native token of Chain4Energy",
    denom_units: [{
      denom: "uc4e",
      exponent: 0
    }, {
      denom: "c4e",
      exponent: 6
    }],
    base: "uc4e",
    name: "Chain4Energy",
    display: "c4e",
    symbol: "C4E",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/chain4energytestnet/images/c4e.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/chain4energytestnet/images/c4e.png"
    }]
  }]
};
A4.default = ohe;
var j4 = {};
Object.defineProperty(j4, "__esModule", { value: !0 });
const rhe = {
  $schema: "../../chain.schema.json",
  chain_name: "chain4energytestnet",
  status: "live",
  network_type: "testnet",
  website: "https://c4e.io/",
  pretty_name: "Chain4Energy Testnet",
  chain_type: "cosmos",
  chain_id: "babajaga-1",
  bech32_prefix: "c4e",
  daemon_name: "c4ed",
  node_home: "$HOME/.c4e-chain",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uc4e",
      fixed_min_gas_price: 0,
      low_gas_price: 0.02,
      average_gas_price: 0.03,
      high_gas_price: 0.06
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uc4e"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/chain4energytestnet/images/c4e.png"
  },
  apis: {
    rpc: [{
      address: "https://rpc-testnet.c4e.io",
      provider: "C4E"
    }],
    rest: [{
      address: "https://c4e.api.t.stavr.tech",
      provider: "🔥STAVR🔥"
    }, {
      address: "https://lcd-testnet.c4e.io",
      provider: "C4E"
    }],
    grpc: [{
      address: "grpc-testnet.c4e.io:8443",
      provider: "C4E"
    }]
  },
  explorers: [{
    kind: "🔥STAVR🔥",
    url: "https://explorer.stavr.tech/C4E-Testnet",
    tx_page: "https://explorer.stavr.tech/C4E-Testnet/transactions/${txHash}"
  }, {
    kind: "explorer",
    url: "https://explorer-testnet.c4e.io/",
    tx_page: "https://explorer-testnet.c4e.io/transactions/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/chain4energytestnet/images/c4e.png"
  }]
};
j4.default = rhe;
var C4 = {};
Object.defineProperty(C4, "__esModule", { value: !0 });
const ihe = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "chain4energytestnet",
    client_id: "07-tendermint-18",
    connection_id: "connection-5"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-3393",
    connection_id: "connection-2989"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-5",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-7735",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
C4.default = ihe;
var E4 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ba, "__esModule", { value: !0 });
ba.ibc = ba.chain = ba.assets = void 0;
const che = E4(A4), dhe = E4(j4), mhe = E4(C4);
ba.assets = che.default;
ba.chain = dhe.default;
ba.ibc = mhe.default;
var Xr = {}, D4 = {};
Object.defineProperty(D4, "__esModule", { value: !0 });
const hhe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "cheqdtestnet",
  assets: [{
    description: "Native token for the cheqd network",
    denom_units: [{
      denom: "ncheq",
      exponent: 0
    }, {
      denom: "cheq",
      exponent: 9
    }],
    base: "ncheq",
    display: "cheq",
    name: "cheqd",
    symbol: "CHEQ",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cheqdtestnet/images/cheq.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cheqdtestnet/images/cheq.svg"
    },
    coingecko_id: "cheqd-network",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cheqdtestnet/images/cheq.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cheqdtestnet/images/cheq.svg"
    }]
  }]
};
D4.default = hhe;
var B4 = {};
Object.defineProperty(B4, "__esModule", { value: !0 });
const phe = {
  $schema: "../../chain.schema.json",
  chain_name: "cheqdtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "cheqd",
  chain_type: "cosmos",
  chain_id: "cheqd-testnet-6",
  bech32_prefix: "cheqd",
  daemon_name: "cheqd-noded",
  node_home: "$HOME/.cheqdnode",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ncheq",
      fixed_min_gas_price: 25,
      low_gas_price: 50,
      average_gas_price: 75,
      high_gas_price: 100
    }]
  },
  codebase: {
    cosmos_sdk_version: "cheqd/cosmos-sdk v0.47.10-height-mismatch"
  },
  apis: {
    rpc: [{
      address: "https://rpc.cheqd.network",
      provider: "cheqd"
    }],
    rest: [{
      address: "https://api.cheqd.network",
      provider: "cheqd"
    }],
    grpc: [{
      address: "grpc.cheqd.network:443",
      provider: "cheqd"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://testnet-explorer.cheqd.io/",
    tx_page: "https://testnet-explorer.cheqd.io/transactions/${txHash}"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.svg"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cheqd/images/cheq.svg"
  }]
};
B4.default = phe;
var Ij = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Xr, "__esModule", { value: !0 });
Xr.chain = Xr.assets = void 0;
const lhe = Ij(D4), ghe = Ij(B4);
Xr.assets = lhe.default;
Xr.chain = ghe.default;
var Yr = {}, F4 = {};
Object.defineProperty(F4, "__esModule", { value: !0 });
const uhe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "chimbatestnet",
  assets: [{
    description: "The first blokchain in colombia",
    denom_units: [{
      denom: "ucmba",
      exponent: 0
    }, {
      denom: "chimba",
      exponent: 6
    }],
    base: "ucmba",
    name: "Chimba",
    display: "chimba",
    symbol: "CMBA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/chimba/images/chimba-blue.svg"
    }]
  }]
};
F4.default = uhe;
var $4 = {};
Object.defineProperty($4, "__esModule", { value: !0 });
const _he = {
  $schema: "../../chain.schema.json",
  chain_name: "chimbatestnet",
  status: "live",
  network_type: "testnet",
  website: "https://chimba.ooo/",
  pretty_name: "Chimba",
  chain_type: "cosmos",
  chain_id: "chimba-testnet",
  bech32_prefix: "chimba",
  daemon_name: "chimbad",
  node_home: "$HOME/.chimbad",
  fees: {
    fee_tokens: [{
      denom: "ucmba",
      fixed_min_gas_price: 0.25,
      low_gas_price: 1,
      average_gas_price: 5,
      high_gas_price: 10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ucmba"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc.testnet.chimba.ooo",
      provider: "chimba"
    }],
    rest: [{
      address: "https://testnet.chimba.ooo",
      provider: "chimba"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://explorer.testnet.chimba.ooo/",
    tx_page: "https://explorer.testnet.chimba.ooo/transactions/${txHash}"
  }],
  slip44: 118
};
$4.default = _he;
var Nj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Yr, "__esModule", { value: !0 });
Yr.chain = Yr.assets = void 0;
const yhe = Nj(F4), bhe = Nj($4);
Yr.assets = yhe.default;
Yr.chain = bhe.default;
var va = {}, z4 = {};
Object.defineProperty(z4, "__esModule", { value: !0 });
const vhe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "composabletestnet",
  assets: [{
    description: "The native staking and governance token of the Composable testnet.",
    denom_units: [{
      denom: "ppica",
      exponent: 0
    }, {
      denom: "pica",
      exponent: 12
    }],
    base: "ppica",
    name: "Pica",
    display: "pica",
    symbol: "PICA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/composable/images/composable.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/composable/images/composable.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/composable/images/composable.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/composable/images/composable.svg"
    }]
  }]
};
z4.default = vhe;
var q4 = {};
Object.defineProperty(q4, "__esModule", { value: !0 });
const fhe = {
  $schema: "../../chain.schema.json",
  chain_name: "composabletestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Composable Testnet",
  chain_type: "cosmos",
  chain_id: "banksy-testnet-3",
  bech32_prefix: "centauri",
  daemon_name: "centaurid",
  node_home: "$HOME/.banksy",
  key_algos: ["secp256k1"],
  slip44: 118,
  staking: {
    staking_tokens: [{
      denom: "ppica"
    }]
  },
  fees: {
    fee_tokens: [{
      denom: "ppica",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc.composable-t.indonode.net:443",
      provider: "Indonode"
    }, {
      address: "https://rpc-composable-testnet.sr20de.xyz:443",
      provider: "Sr20de"
    }],
    rest: [
      {
        address: "https://api.composable-t.indonode.net",
        provider: "Indonode"
      },
      {
        address: "https://composable.api.t4.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-composable-testnet.sr20de.xyz",
        provider: "Sr20de"
      }
    ],
    grpc: [{
      address: "https://grpc.composable-t.indonode.net:47090",
      provider: "Indonode"
    }, {
      address: "https://grpc-composable-testnet.sr20de.xyz",
      provider: "Sr20de"
    }]
  },
  explorers: [
    {
      url: "https://explorer.nodexcapital.com/composable-3",
      tx_page: "https://explorer.nodexcapital.com/composable-3/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Composable-Testnet4",
      tx_page: "https://explorer.stavr.tech/Composable-Testnet4/tx/${txHash}"
    },
    {
      url: "https://explorer.indonode.net/composable-testnet-3",
      tx_page: "https://explorer.indonode.net/composable-testnet-3/tx/${txHash}"
    },
    {
      url: "https://explorer.sr20de.xyz/Composible-3",
      tx_page: "https://explorer.sr20de.xyz/Composible-3/tx/${txHash}"
    }
  ]
};
q4.default = fhe;
var S4 = {};
Object.defineProperty(S4, "__esModule", { value: !0 });
const whe = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "composabletestnet",
    client_id: "07-tendermint-23",
    connection_id: "connection-18"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-273",
    connection_id: "connection-237"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-11",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-329",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
S4.default = whe;
var T4 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(va, "__esModule", { value: !0 });
va.ibc = va.chain = va.assets = void 0;
const xhe = T4(z4), khe = T4(q4), Ahe = T4(S4);
va.assets = xhe.default;
va.chain = khe.default;
va.ibc = Ahe.default;
var Jr = {}, R4 = {};
Object.defineProperty(R4, "__esModule", { value: !0 });
const jhe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "coolcattestnet",
  assets: [{
    description: "CoolCat - The Interchain Gaming Hub. $CCAT is the native token for use in the CoolCat Network.",
    denom_units: [{
      denom: "uccat",
      exponent: 0
    }, {
      denom: "ccat",
      exponent: 6
    }],
    base: "uccat",
    name: "CoolCat",
    display: "ccat",
    symbol: "CCAT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/coolcattestnet/images/coolcat.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/coolcattestnet/images/coolcat.svg"
    },
    keywords: [
      "nft",
      "staking",
      "games"
    ],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/coolcattestnet/images/coolcat.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/coolcattestnet/images/coolcat.svg"
    }]
  }]
};
R4.default = jhe;
var O4 = {};
Object.defineProperty(O4, "__esModule", { value: !0 });
const Che = {
  $schema: "../../chain.schema.json",
  chain_name: "coolcattestnet",
  status: "live",
  network_type: "testnet",
  website: "https://app.coolcat.space/",
  pretty_name: "CoolCat",
  chain_type: "cosmos",
  chain_id: "kitten-04",
  bech32_prefix: "ccat",
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "uccat",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 1,
      high_gas_price: 2
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uccat"
    }]
  },
  daemon_name: "coolcat",
  node_home: "$HOME/.coolcat",
  slip44: 118,
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc.coolcat.space",
      provider: "Digital Kitchen"
    }],
    rest: [{
      address: "https://lcd.coolcat.space",
      provider: "Digital Kitchen"
    }],
    grpc: []
  },
  explorers: []
};
O4.default = Che;
var Pj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Jr, "__esModule", { value: !0 });
Jr.chain = Jr.assets = void 0;
const Ehe = Pj(R4), Dhe = Pj(O4);
Jr.assets = Ehe.default;
Jr.chain = Dhe.default;
var fa = {}, M4 = {};
Object.defineProperty(M4, "__esModule", { value: !0 });
const Bhe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "coreumtestnet",
  assets: [{
    description: "The native token of Coreum",
    denom_units: [{
      denom: "utestcore",
      exponent: 0
    }, {
      denom: "testcore",
      exponent: 6
    }],
    base: "utestcore",
    name: "Coreum",
    display: "testcore",
    symbol: "TESTCORE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.svg"
    },
    coingecko_id: "coreum",
    keywords: [
      "dex",
      "staking",
      "wasm",
      "assets",
      "nft",
      "XRPL"
    ],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.svg"
    }]
  }]
};
M4.default = Bhe;
var I4 = {};
Object.defineProperty(I4, "__esModule", { value: !0 });
const Fhe = {
  $schema: "../../chain.schema.json",
  chain_name: "coreumtestnet",
  status: "live",
  network_type: "testnet",
  website: "https://www.coreum.com",
  pretty_name: "Coreum",
  chain_type: "cosmos",
  chain_id: "coreum-testnet-1",
  bech32_prefix: "testcore",
  daemon_name: "cored",
  node_home: "$HOME/.core/coreum-testnet-1",
  key_algos: ["secp256k1"],
  slip44: 990,
  fees: {
    fee_tokens: [{
      denom: "utestcore",
      fixed_min_gas_price: 0.03125,
      low_gas_price: 0.0625,
      average_gas_price: 0.0625,
      high_gas_price: 62.5
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "utestcore"
    }],
    lock_duration: {
      time: "168h"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png",
    theme: {
      primary_color_hex: "#25d695"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/coreum/images/coreum.png"
  },
  apis: {
    rpc: [
      {
        address: "https://full-node.testnet-1.coreum.dev:26657",
        provider: "Coreum Foundation"
      },
      {
        address: "https://full-node-eris.testnet-1.coreum.dev:26657",
        provider: "Coreum Foundation"
      },
      {
        address: "https://coreum-testnet-rpc.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ],
    grpc: [{
      address: "https://full-node.testnet-1.coreum.dev:9090",
      provider: "Coreum Foundation"
    }, {
      address: "https://full-node-eris.testnet-1.coreum.dev:9090",
      provider: "Coreum Foundation"
    }],
    rest: [{
      address: "https://full-node.testnet-1.coreum.dev:1317",
      provider: "Coreum"
    }, {
      address: "https://coreum-testnet-api.ibs.team:443",
      provider: "Inter Blockchain Services"
    }]
  },
  explorers: [{
    kind: "Coreum",
    url: "https://explorer.testnet-1.coreum.dev/coreum",
    tx_page: "https://explorer.testnet-1.coreum.dev/coreum/transactions/${txHash}",
    account_page: "https://explorer.testnet-1.coreum.dev/coreum/account/${accountAddress}"
  }, {
    kind: "mintscan",
    url: "https://www.mintscan.io/coreum-testnet",
    tx_page: "https://www.mintscan.io/coreum-testnet/transactions/${txHash}",
    account_page: "https://www.mintscan.io/coreum-testnet/accounts/${accountAddress}"
  }],
  keywords: [
    "dex",
    "staking",
    "wasm",
    "assets",
    "nft"
  ]
};
I4.default = Fhe;
var N4 = {};
Object.defineProperty(N4, "__esModule", { value: !0 });
const $he = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "coreumtestnet",
    client_id: "07-tendermint-104",
    connection_id: "connection-69"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-3529",
    connection_id: "connection-3094"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-47",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-7894",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
N4.default = $he;
var P4 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(fa, "__esModule", { value: !0 });
fa.ibc = fa.chain = fa.assets = void 0;
const zhe = P4(M4), qhe = P4(I4), She = P4(N4);
fa.assets = zhe.default;
fa.chain = qhe.default;
fa.ibc = She.default;
var wa = {}, U4 = {};
Object.defineProperty(U4, "__esModule", { value: !0 });
const The = {
  $schema: "../../assetlist.schema.json",
  chain_name: "cosmoshubtestnet",
  assets: [{
    description: "The native staking and governance token of the Theta testnet version of the Cosmos Hub.",
    denom_units: [{
      denom: "uatom",
      exponent: 0
    }, {
      denom: "atom",
      exponent: 6
    }],
    base: "uatom",
    name: "Cosmos",
    display: "atom",
    symbol: "ATOM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
    }]
  }]
};
U4.default = The;
var H4 = {};
Object.defineProperty(H4, "__esModule", { value: !0 });
const Rhe = {
  $schema: "../../chain.schema.json",
  chain_name: "cosmoshubtestnet",
  chain_type: "cosmos",
  chain_id: "theta-testnet-001",
  pretty_name: "[DEPRECATED] Cosmos Hub Public Testnet, will be sunset 2024-12-01",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "cosmos",
  daemon_name: "gaiad",
  node_home: "$HOME/.gaia",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uatom",
      fixed_min_gas_price: 5e-3,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uatom"
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://cosmoshubt.tendermintrpc.lava.build:443",
        provider: "Lava"
      },
      {
        address: "https://rpc.sentry-01.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rpc.sentry-02.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rpc.state-sync-01.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rpc.state-sync-02.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://public-cosmos-theta.w3node.com",
        provider: "Interchain.FM"
      },
      {
        address: "https://rpc-theta.osmotest5.osmosis.zone/",
        provider: "Osmosis"
      }
    ],
    rest: [
      {
        address: "https://cosmoshubt.lava.build",
        provider: "Lava"
      },
      {
        address: "https://rest.sentry-01.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rest.sentry-02.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rest.state-sync-01.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rest.state-sync-02.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://public-cosmos-theta.w3node.com/rest/",
        provider: "Interchain.FM"
      },
      {
        address: "https://lcd-theta.osmotest5.osmosis.zone/",
        provider: "Osmosis"
      }
    ],
    grpc: [
      {
        address: "cosmoshubt.grpc.lava.build",
        provider: "Lava"
      },
      {
        address: "https://grpc.sentry-01.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://grpc.sentry-02.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://grpc.state-sync-01.theta-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://grpc.state-sync-02.theta-testnet.polypore.xyz",
        provider: "Hypha"
      }
    ]
  },
  explorers: [{
    kind: "Mintscan",
    url: "https://mintscan.io/cosmoshub-testnet",
    tx_page: "https://mintscan.io/cosmoshub-testnet/txs/${txHash}"
  }, {
    kind: "Big Dipper",
    url: "https://explorer.theta-testnet.polypore.xyz/",
    tx_page: "https://explorer.theta-testnet.polypore.xyz/transactions/${txHash}"
  }]
};
H4.default = Rhe;
var L4 = {};
Object.defineProperty(L4, "__esModule", { value: !0 });
const Ohe = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-2522",
      connection_id: "connection-2881"
    },
    chain_2: {
      chain_name: "elystestnet",
      client_id: "07-tendermint-19",
      connection_id: "connection-17"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3302",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-16",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-3748",
      connection_id: "connection-3798"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-29",
      connection_id: "connection-14"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4320",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestiatestnet3",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-2382",
      connection_id: "connection-2727"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3152",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-2073",
      connection_id: "connection-2418"
    },
    chain_2: {
      chain_name: "empowertestnet",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2765",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "7-tendermint-3407",
      connection_id: "connection-3519"
    },
    chain_2: {
      chain_name: "kujiratestnet",
      client_id: "07-tendermint-72",
      connection_id: "connection-47"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4004",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-51",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-2528",
      connection_id: "connection-2886"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1262",
      connection_id: "connection-1157"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3306",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4156",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-2100",
      connection_id: "connection-2447"
    },
    chain_2: {
      chain_name: "persistencetestnet2",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2777",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-3730",
      connection_id: "connection-3782"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-10",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4300",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-3237",
      connection_id: "connection-3407"
    },
    chain_2: {
      chain_name: "titantestnet",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3910",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "killed",
        preferred: !0
      }
    }]
  }
];
L4.default = Ohe;
var W4 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(wa, "__esModule", { value: !0 });
wa.ibc = wa.chain = wa.assets = void 0;
const Mhe = W4(U4), Ihe = W4(H4), Nhe = W4(L4);
wa.assets = Mhe.default;
wa.chain = Ihe.default;
wa.ibc = Nhe.default;
var Zr = {}, V4 = {};
Object.defineProperty(V4, "__esModule", { value: !0 });
const Phe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "cosmosicsprovidertestnet",
  assets: [{
    description: "The native staking and governance token for the Cosmos ICS Provider Testnet.",
    denom_units: [{
      denom: "uatom",
      exponent: 0
    }, {
      denom: "atom",
      exponent: 6
    }],
    base: "uatom",
    name: "Cosmos",
    display: "atom",
    symbol: "ATOM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
    }]
  }]
};
V4.default = Phe;
var G4 = {};
Object.defineProperty(G4, "__esModule", { value: !0 });
const Uhe = {
  $schema: "../../chain.schema.json",
  chain_name: "cosmosicsprovidertestnet",
  chain_type: "cosmos",
  chain_id: "provider",
  pretty_name: "Cosmos ICS Provider Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "cosmos",
  daemon_name: "gaiad",
  node_home: "$HOME/.gaia",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uatom",
      fixed_min_gas_price: 5e-3,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uatom"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.50.9-lsm"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.provider-sentry-01.rs-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rpc.provider-sentry-02.rs-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rpc.provider-state-sync-01.rs-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rpc.provider-state-sync-02.rs-testnet.polypore.xyz",
        provider: "Hypha"
      }
    ],
    rest: [
      {
        address: "https://rest.provider-sentry-01.rs-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rest.provider-sentry-02.rs-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rest.provider-state-sync-01.rs-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://rest.provider-state-sync-02.rs-testnet.polypore.xyz",
        provider: "Hypha"
      }
    ],
    grpc: [
      {
        address: "https://grpc.provider-sentry-01.rs-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://grpc.provider-sentry-02.rs-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://grpc.provider-state-sync-01.rs-testnet.polypore.xyz",
        provider: "Hypha"
      },
      {
        address: "https://grpc.provider-state-sync-02.rs-testnet.polypore.xyz",
        provider: "Hypha"
      }
    ]
  },
  explorers: [{
    kind: "Mintscan",
    url: "https://mintscan.io/ics-testnet-provider",
    tx_page: "https://mintscan.io/ics-testnet-provider/tx/${txHash}"
  }, {
    kind: "Ping.pub",
    url: "https://explorer.rs-testnet.polypore.xyz/provider",
    tx_page: "https://explorer.rs-testnet.polypore.xyz/provider/tx/${txHash}"
  }]
};
G4.default = Uhe;
var Uj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Zr, "__esModule", { value: !0 });
Zr.chain = Zr.assets = void 0;
const Hhe = Uj(V4), Lhe = Uj(G4);
Zr.assets = Hhe.default;
Zr.chain = Lhe.default;
var Qr = {}, K4 = {};
Object.defineProperty(K4, "__esModule", { value: !0 });
const Whe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "cosmwasmtestnet",
  assets: [{
    description: "Fee Token",
    denom_units: [{
      denom: "umlg",
      exponent: 0
    }, {
      denom: "MLG",
      exponent: 6
    }],
    base: "umlg",
    name: "Malaga",
    display: "umlg",
    symbol: "MLG",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cosmwasmtestnet/images/cosmwasm.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cosmwasmtestnet/images/cosmwasm.svg"
    }]
  }, {
    description: "Staking Token",
    denom_units: [{
      denom: "uand",
      exponent: 0
    }, {
      denom: "AND",
      exponent: 6
    }],
    base: "uand",
    name: "Malaga Stake",
    display: "uand",
    symbol: "AND",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cosmwasmtestnet/images/cosmwasm.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cosmwasmtestnet/images/cosmwasm.svg"
    }]
  }]
};
K4.default = Whe;
var X4 = {};
Object.defineProperty(X4, "__esModule", { value: !0 });
const Vhe = {
  $schema: "../../chain.schema.json",
  chain_name: "cosmwasmtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "CosmWasm Testnet",
  chain_type: "cosmos",
  chain_id: "malaga-420",
  bech32_prefix: "wasm",
  daemon_name: "wasmd",
  node_home: "$HOME/.wasmd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "umlg",
      low_gas_price: 0.03,
      average_gas_price: 0.04,
      high_gas_price: 0.05
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uand"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.27"
  },
  apis: {
    rpc: [{
      address: "https://rpc.malaga-420.cosmwasm.com:443",
      provider: "Confio"
    }],
    rest: [{
      address: "https://api.malaga-420.cosmwasm.com",
      provider: "Confio"
    }]
  },
  explorers: [{
    kind: "BIG DIPPER",
    url: "https://block-explorer.malaga-420.cosmwasm.com/",
    tx_page: "https://block-explorer.malaga-420.cosmwasm.com/transactions/${txHash}"
  }]
};
X4.default = Vhe;
var Hj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qr, "__esModule", { value: !0 });
Qr.chain = Qr.assets = void 0;
const Ghe = Hj(K4), Khe = Hj(X4);
Qr.assets = Ghe.default;
Qr.chain = Khe.default;
var ei = {}, Y4 = {};
Object.defineProperty(Y4, "__esModule", { value: !0 });
const Xhe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "cosstestnet",
  assets: [{
    description: "The native token of COSS",
    denom_units: [{
      denom: "ucgas",
      exponent: 0,
      aliases: []
    }, {
      denom: "cgas",
      exponent: 6,
      aliases: []
    }],
    base: "ucgas",
    name: "cgas",
    display: "cgas",
    symbol: "cgas"
  }]
};
Y4.default = Xhe;
var J4 = {};
Object.defineProperty(J4, "__esModule", { value: !0 });
const Yhe = {
  $schema: "../../chain.schema.json",
  chain_name: "cosstestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "COSS Testnet",
  chain_type: "cosmos",
  chain_id: "coss-testnet-1",
  bech32_prefix: "coss",
  daemon_name: "cossd",
  node_home: "$HOME/.cossd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ucgas",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ucgas"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.50.2",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [{
      address: "https://coss-testnet-rpc.coss.ink",
      provider: "COSS"
    }],
    rest: [{
      address: "https://coss-testnet-rest.coss.ink",
      provider: "COSS"
    }]
  }
};
J4.default = Yhe;
var Lj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ei, "__esModule", { value: !0 });
ei.chain = ei.assets = void 0;
const Jhe = Lj(Y4), Zhe = Lj(J4);
ei.assets = Jhe.default;
ei.chain = Zhe.default;
var ni = {}, Z4 = {};
Object.defineProperty(Z4, "__esModule", { value: !0 });
const Qhe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "cudostestnet",
  assets: [{
    description: "The native token of the Cudos blockchain",
    denom_units: [{
      denom: "acudos",
      exponent: 0,
      aliases: ["attocudos"]
    }, {
      denom: "cudos",
      exponent: 18,
      aliases: []
    }],
    base: "acudos",
    name: "Cudos",
    display: "cudos",
    symbol: "CUDOS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cudostestnet/images/cudos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cudostestnet/images/cudos.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cudostestnet/images/cudos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/cudostestnet/images/cudos.svg"
    }]
  }]
};
Z4.default = Qhe;
var Q4 = {};
Object.defineProperty(Q4, "__esModule", { value: !0 });
const epe = {
  $schema: "../../chain.schema.json",
  chain_name: "cudostestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Cudos Testnet",
  chain_type: "cosmos",
  chain_id: "cudos-testnet-public-3",
  bech32_prefix: "cudos",
  key_algos: ["secp256k1"],
  slip44: 118,
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://rpc.testnet.cudos.org:443/",
        provider: "cudo"
      },
      {
        address: "http://sentry-01.hosts.testnet.cudos.org:26657",
        provider: "cudo"
      },
      {
        address: "http://sentry-02.hosts.testnet.cudos.org:26657",
        provider: "cudo"
      },
      {
        address: "http://sentry-03.hosts.testnet.cudos.org:26657",
        provider: "cudo"
      }
    ],
    rest: [
      {
        address: "https://rest.testnet.cudos.org:443",
        provider: "cudo"
      },
      {
        address: "http://sentry-01.hosts.testnet.cudos.org:1317/",
        provider: "cudo"
      },
      {
        address: "http://sentry-02.hosts.testnet.cudos.org:1317/",
        provider: "cudo"
      },
      {
        address: "http://sentry-03.hosts.testnet.cudos.org:1317/",
        provider: "cudo"
      }
    ],
    grpc: [
      {
        address: "https://grpc.testnet.cudos.org:433",
        provider: "cudo"
      },
      {
        address: "http://sentry-01.hosts.testnet.cudos.org:9090",
        provider: "cudo"
      },
      {
        address: "http://sentry-02.hosts.testnet.cudos.org:9090",
        provider: "cudo"
      },
      {
        address: "http://sentry-03.hosts.testnet.cudos.org:9090",
        provider: "cudo"
      }
    ]
  },
  explorers: [{
    kind: "bigdipper-testnet",
    url: "https://explorer.testnet.cudos.org/",
    tx_page: "https://explorer.testnet.cudos.org/transactions/${txHash}",
    account_page: "https://explorer.testnet.cudos.org/accounts/${accountAddress}"
  }]
};
Q4.default = epe;
var Wj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ni, "__esModule", { value: !0 });
ni.chain = ni.assets = void 0;
const npe = Wj(Z4), tpe = Wj(Q4);
ni.assets = npe.default;
ni.chain = tpe.default;
var ti = {}, ex = {};
Object.defineProperty(ex, "__esModule", { value: !0 });
const spe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "deardogetestnet",
  assets: [{
    description: "The native staking and governance token of the Theta testnet version of the Dear Doge Testnet.",
    denom_units: [{
      denom: "udear",
      exponent: 0
    }, {
      denom: "dear",
      exponent: 6
    }],
    base: "udear",
    name: "Dear Doge Testnet",
    display: "dear",
    symbol: "DEAR",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/deardogetestnet/images/deardoge.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/deardogetestnet/images/deardoge.png"
    }]
  }]
};
ex.default = spe;
var nx = {};
Object.defineProperty(nx, "__esModule", { value: !0 });
const ape = {
  $schema: "../../chain.schema.json",
  chain_name: "deardogetestnet",
  chain_type: "cosmos",
  chain_id: "deardoge-testnet",
  pretty_name: "Dear Doge Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "deardoge",
  daemon_name: "dogd",
  node_home: "$HOME/.deardoge",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "udear",
      fixed_min_gas_price: 0.25
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "udear"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://testnet-rpc.deardoge.org",
      provider: "dorafactory"
    }],
    rest: [{
      address: "https://testnet-rest.deardoge.org",
      provider: "dorafactory"
    }],
    grpc: [{
      address: "testnet-grpc.deardoge.org:443",
      provider: "dorafactory"
    }]
  },
  explorers: [{
    kind: "Dear Doge Ping Pub",
    url: "https://testnet-explorer.deardoge.org/deardoge",
    tx_page: "https://testnet-explorer.deardoge.org/deardoge/tx/${txHash}"
  }]
};
nx.default = ape;
var Vj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ti, "__esModule", { value: !0 });
ti.chain = ti.assets = void 0;
const ope = Vj(ex), rpe = Vj(nx);
ti.assets = ope.default;
ti.chain = rpe.default;
var si = {}, tx = {};
Object.defineProperty(tx, "__esModule", { value: !0 });
const ipe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "desmostestnet",
  assets: [{
    description: "The native token of Desmos",
    denom_units: [{
      denom: "udaric",
      exponent: 0
    }, {
      denom: "daric",
      exponent: 6
    }],
    base: "udaric",
    name: "Desmos Testnet",
    display: "daric",
    symbol: "DARIC",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/desmos/images/dsm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/desmos/images/dsm.svg"
    },
    coingecko_id: "desmos",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/desmos/images/dsm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/desmos/images/dsm.svg"
    }]
  }]
};
tx.default = ipe;
var sx = {};
Object.defineProperty(sx, "__esModule", { value: !0 });
const cpe = {
  $schema: "../../chain.schema.json",
  chain_name: "desmostestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Desmos Testnet",
  chain_type: "cosmos",
  chain_id: "morpheus-apollo-3",
  bech32_prefix: "desmos",
  daemon_name: "desmos",
  node_home: "$HOME/.desmos",
  key_algos: ["secp256k1"],
  slip44: 852,
  fees: {
    fee_tokens: [{
      denom: "udaric",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 0.01,
      average_gas_price: 0.03,
      high_gas_price: 0.05
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "udaric"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.morpheus.desmos.network",
      provider: "desmos"
    }],
    rest: [{
      address: "https://lcd.morpheus.desmos.network",
      provider: "desmos"
    }],
    grpc: [{
      address: "https://grpc.morpheus.desmos.network:443",
      provider: "desmos"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://testnet.bigdipper.live/desmos",
    tx_page: "https://testnet.live/desmos/transactions/${txHash}",
    account_page: "https://testnet.bigdipper.live/desmos/accounts/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/desmos/images/dsm.svg"
  }]
};
sx.default = cpe;
var Gj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(si, "__esModule", { value: !0 });
si.chain = si.assets = void 0;
const dpe = Gj(tx), mpe = Gj(sx);
si.assets = dpe.default;
si.chain = mpe.default;
var ai = {}, ax = {};
Object.defineProperty(ax, "__esModule", { value: !0 });
const hpe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "dhealthtestnet",
  assets: [{
    description: "The native token of dHealth testnet.",
    denom_units: [{
      denom: "utdhp",
      exponent: 0
    }, {
      denom: "tdhp",
      exponent: 6
    }],
    base: "utdhp",
    name: "Digital Health Point Testnet",
    display: "tdhp",
    symbol: "tDHP",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/dhealthtestnet/images/dhp.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/dhealthtestnet/images/dhp.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/dhealthtestnet/images/dhp.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/dhealthtestnet/images/dhp.svg",
      theme: {
        primary_color_hex: "#140c7c"
      }
    }]
  }]
};
ax.default = hpe;
var ox = {};
Object.defineProperty(ox, "__esModule", { value: !0 });
const ppe = {
  $schema: "../../chain.schema.json",
  chain_name: "dhealthtestnet",
  chain_type: "cosmos",
  chain_id: "dhealth-testnet-2",
  pretty_name: "dHealth Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "tdh02",
  daemon_name: "dhealth-testnetd",
  node_home: "$HOME/.dhealth-testnet",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utdhp",
      fixed_min_gas_price: 0.01,
      low_gas_price: 0.025,
      average_gas_price: 0.03,
      high_gas_price: 0.035
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "utdhp"
    }]
  },
  codebase: {
    cosmos_sdk_version: "cosmos/cosmos-sdk v0.47.4",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.41.0"
  },
  apis: {
    rpc: [{
      address: "https://rpc-testnet.dhealth.dev",
      provider: "dHealth"
    }],
    rest: [{
      address: "https://lcd-testnet.dhealth.dev",
      provider: "dHealth"
    }],
    grpc: [{
      address: "rpc-testnet.dhealth.dev:9090",
      provider: "dHealth"
    }]
  },
  explorers: []
};
ox.default = ppe;
var Kj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ai, "__esModule", { value: !0 });
ai.chain = ai.assets = void 0;
const lpe = Kj(ax), gpe = Kj(ox);
ai.assets = lpe.default;
ai.chain = gpe.default;
var xa = {}, rx = {};
Object.defineProperty(rx, "__esModule", { value: !0 });
const upe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "doravotatestnet",
  assets: [{
    description: "The native staking and governance token of the Theta testnet version of the Dora Vota Testnet.",
    denom_units: [{
      denom: "peaka",
      exponent: 0
    }, {
      denom: "DORA",
      exponent: 18
    }],
    base: "peaka",
    name: "Dora Vota Testnet",
    display: "DORA",
    symbol: "DORA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/doravotatestnet/images/doravota.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/doravotatestnet/images/doravota.png"
    }]
  }]
};
rx.default = upe;
var ix = {};
Object.defineProperty(ix, "__esModule", { value: !0 });
const _pe = {
  $schema: "../../chain.schema.json",
  chain_name: "doravotatestnet",
  chain_type: "cosmos",
  chain_id: "vota-testnet",
  pretty_name: "Dora Vota Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "dora",
  daemon_name: "dorad",
  node_home: "$HOME/.dora",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "peaka",
      fixed_min_gas_price: 1e11
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "peaka"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://vota-testnet-rpc.dorafactory.org/",
      provider: "dorafactory"
    }],
    rest: [{
      address: "https://vota-testnet-rest.dorafactory.org",
      provider: "dorafactory"
    }],
    grpc: [{
      address: "vota-testnet-grpc.dorafactory.org:443",
      provider: "dorafactory"
    }]
  },
  explorers: [{
    kind: "Dora Vota Ping Pub",
    url: "https://maci-explorer-test.dorafactory.org",
    tx_page: "https://maci-explorer-test.dorafactory.org/dora/tx/${txHash}"
  }]
};
ix.default = _pe;
var cx = {};
Object.defineProperty(cx, "__esModule", { value: !0 });
const ype = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "doravotatestnet",
    client_id: "07-tendermint-2",
    connection_id: "connection-3"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-2",
    connection_id: "connection-611"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1260",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
cx.default = ype;
var dx = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(xa, "__esModule", { value: !0 });
xa.ibc = xa.chain = xa.assets = void 0;
const bpe = dx(rx), vpe = dx(ix), fpe = dx(cx);
xa.assets = bpe.default;
xa.chain = vpe.default;
xa.ibc = fpe.default;
var oi = {}, mx = {};
Object.defineProperty(mx, "__esModule", { value: !0 });
const wpe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "doravotatestnet2",
  assets: [{
    description: "The native staking and governance token of the Theta incentive version of the Dora Vota Testnet.",
    denom_units: [{
      denom: "peaka",
      exponent: 0
    }, {
      denom: "DORA",
      exponent: 18
    }],
    base: "peaka",
    name: "Dora Vota Incentive Testnet",
    display: "DORA",
    symbol: "DORA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/doravotatestnet/images/doravota.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/doravotatestnet/images/doravota.png"
    }]
  }]
};
mx.default = wpe;
var hx = {};
Object.defineProperty(hx, "__esModule", { value: !0 });
const xpe = {
  $schema: "../../chain.schema.json",
  chain_name: "doravotatestnet2",
  chain_type: "cosmos",
  chain_id: "vota-vk",
  pretty_name: "Dora Vota Incentive Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "dora",
  daemon_name: "dorad",
  node_home: "$HOME/.dora",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "peaka",
      fixed_min_gas_price: 1e11
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "peaka"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://vota-vk-rpc.dorafactory.org/",
      provider: "dorafactory"
    }],
    rest: [{
      address: "https://vota-vk-rest.dorafactory.org",
      provider: "dorafactory"
    }],
    grpc: [{
      address: "vota-vk-grpc.dorafactory.org:443",
      provider: "dorafactory"
    }]
  },
  explorers: [{
    kind: "Dora Vota Ping Pub",
    url: "https://vota-vk-explorer.dorafactory.org",
    tx_page: "https://vota-vk-explorer.dorafactory.org/doravotaincentive/tx/${txHash}"
  }]
};
hx.default = xpe;
var Xj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(oi, "__esModule", { value: !0 });
oi.chain = oi.assets = void 0;
const kpe = Xj(mx), Ape = Xj(hx);
oi.assets = kpe.default;
oi.chain = Ape.default;
var ka = {}, px = {};
Object.defineProperty(px, "__esModule", { value: !0 });
const jpe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "dydxtestnet",
  assets: [{
    description: "The native staking token of dYdX Protocol.",
    denom_units: [{
      denom: "adv4tnt",
      exponent: 0
    }, {
      denom: "dv4tnt",
      exponent: 18
    }],
    base: "adv4tnt",
    name: "dYdX",
    display: "dv4tnt",
    symbol: "DV4TNT",
    traces: [{
      type: "test-mintage",
      counterparty: {
        chain_name: "dydx",
        base_denom: "adydx"
      },
      provider: "Dydx"
    }],
    images: [{
      image_sync: {
        chain_name: "dydx",
        base_denom: "adydx"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
      theme: {
        primary_color_hex: "#21212f"
      }
    }, {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx-circle.svg",
      theme: {
        circle: !0
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg"
    }
  }]
};
px.default = jpe;
var lx = {};
Object.defineProperty(lx, "__esModule", { value: !0 });
const Cpe = {
  $schema: "../../chain.schema.json",
  chain_name: "dydxtestnet",
  status: "live",
  website: "https://dydx.trade/",
  network_type: "testnet",
  pretty_name: "dYdX Protocol",
  chain_type: "cosmos",
  chain_id: "dydx-testnet-4",
  bech32_prefix: "dydx",
  daemon_name: "dydxprotocold",
  node_home: "$HOME/.dydxprotocol",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "adv4tnt",
      fixed_min_gas_price: 125e8,
      low_gas_price: 125e8,
      average_gas_price: 125e8,
      high_gas_price: 2e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "adv4tnt"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.47.4",
    cosmwasm_enabled: !1
  },
  description: "Our goal is to build open source code that can power a first class product and trading experience.",
  apis: {
    rpc: [
      {
        address: "https://dydx-rpc-testnet.enigma-validator.com",
        provider: "Enigma"
      },
      {
        address: "https://testnet-dydx-rpc.lavenderfive.com",
        provider: "Lavender Five"
      },
      {
        address: "https://test-dydx-rpc.kingnodes.com",
        provider: "kingnodes 👑"
      },
      {
        address: "https://dydx-testnet-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://dydx-testnet-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://dydx-lcd-testnet.enigma-validator.com",
        provider: "Enigma"
      },
      {
        address: "https://testnet-dydx-api.lavenderfive.com",
        provider: "Lavender Five"
      },
      {
        address: "https://dydx-testnet-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://dydx-testnet-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "https://testnet-dydx-rpc.lavenderfive.com",
        provider: "Lavender Five"
      },
      {
        address: "https://dydx-testnet-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "dydx-testnet-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [{
    kind: "mintscan",
    url: "https://www.mintscan.io/dydx-testnet",
    tx_page: "https://www.mintscan.io/dydx-testnet/txs/${txHash}",
    account_page: "https://www.mintscan.io/dydx-testnet/account/${accountAddress}"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg"
  },
  images: [{
    image_sync: {
      chain_name: "dydx"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg",
    theme: {
      primary_color_hex: "#21212f"
    }
  }]
};
lx.default = Cpe;
var gx = {};
Object.defineProperty(gx, "__esModule", { value: !0 });
const Epe = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "axelartestnet",
    client_id: "07-tendermint-594",
    connection_id: "connection-410"
  },
  chain_2: {
    chain_name: "dydxtestnet",
    client_id: "07-tendermint-6",
    connection_id: "connection-4"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-297",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-4",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
gx.default = Epe;
var ux = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ka, "__esModule", { value: !0 });
ka.ibc = ka.chain = ka.assets = void 0;
const Dpe = ux(px), Bpe = ux(lx), Fpe = ux(gx);
ka.assets = Dpe.default;
ka.chain = Bpe.default;
ka.ibc = Fpe.default;
var Aa = {}, _x = {};
Object.defineProperty(_x, "__esModule", { value: !0 });
const $pe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "elystestnet",
  assets: [
    {
      description: "The native token of Elys Network",
      denom_units: [
        {
          denom: "uelys",
          exponent: 0,
          aliases: ["microelys"]
        },
        {
          denom: "melys",
          exponent: 3,
          aliases: ["millielys"]
        },
        {
          denom: "elys",
          exponent: 6,
          aliases: []
        }
      ],
      base: "uelys",
      name: "Elys Network",
      display: "elys",
      symbol: "ELYS",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/elystestnet/images/elys.png"
      },
      coingecko_id: "elys",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/elystestnet/images/elys.png"
      }]
    },
    {
      description: "Eden token definition",
      denom_units: [
        {
          denom: "ueden",
          exponent: 0,
          aliases: ["microeden"]
        },
        {
          denom: "meden",
          exponent: 3,
          aliases: ["millieden"]
        },
        {
          denom: "eden",
          exponent: 6,
          aliases: []
        }
      ],
      base: "ueden",
      name: "Eden",
      display: "eden",
      symbol: "EDEN",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/elystestnet/images/eden.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/elystestnet/images/eden.png"
      }]
    },
    {
      description: "USDC from Noble",
      denom_units: [{
        denom: "ibc/2180E84E20F5679FCC760D8C165B60F42065DEF7F46A72B447CFF1B7DC6C0A65",
        exponent: 0
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2180E84E20F5679FCC760D8C165B60F42065DEF7F46A72B447CFF1B7DC6C0A65",
      name: "Noble USD Coin",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nobletestnet",
          base_denom: "uusdc",
          channel_id: "channel-19"
        },
        chain: {
          channel_id: "channel-12",
          path: "transfer/channel-12/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/E2D2F6ADCC68AA3384B2F5DFACCA437923D137C14E86FB8A10207CF3BED0C8D4",
        exponent: 0
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E2D2F6ADCC68AA3384B2F5DFACCA437923D137C14E86FB8A10207CF3BED0C8D4",
      name: "ATOM on Elys",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshubtestnet",
          base_denom: "uatom",
          channel_id: "channel-3302"
        },
        chain: {
          channel_id: "channel-16",
          path: "transfer/channel-16/uatom"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "cosmoshub",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg",
        theme: {
          primary_color_hex: "#272d45"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      }
    }
  ]
};
_x.default = $pe;
var yx = {};
Object.defineProperty(yx, "__esModule", { value: !0 });
const zpe = {
  $schema: "../../chain.schema.json",
  chain_name: "elystestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Elys Network",
  chain_type: "cosmos",
  chain_id: "elystestnet-1",
  bech32_prefix: "elys",
  daemon_name: "elysd",
  node_home: "$HOME/.elys",
  key_algos: ["secp256k1"],
  slip44: 118,
  staking: {
    staking_tokens: [{
      denom: "uelys"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  fees: {
    fee_tokens: [
      {
        denom: "uelys",
        fixed_min_gas_price: 0.01,
        low_gas_price: 0.01,
        average_gas_price: 0.025,
        high_gas_price: 0.03
      },
      {
        denom: "ibc/2180E84E20F5679FCC760D8C165B60F42065DEF7F46A72B447CFF1B7DC6C0A65",
        fixed_min_gas_price: 0.01,
        low_gas_price: 0.01,
        average_gas_price: 0.025,
        high_gas_price: 0.03
      },
      {
        denom: "ibc/E2D2F6ADCC68AA3384B2F5DFACCA437923D137C14E86FB8A10207CF3BED0C8D4",
        fixed_min_gas_price: 0.01,
        low_gas_price: 0.01,
        average_gas_price: 0.025,
        high_gas_price: 0.03
      }
    ]
  },
  codebase: {
    cosmos_sdk_version: "v0.47",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.testnet.elys.network",
        provider: "Elys Network"
      },
      {
        address: "https://elys-testnet-rpc.staketab.org:443",
        provider: "Staketab"
      },
      {
        address: "https://elys-testnet-rpc.itrocket.net:443",
        provider: "itrocket"
      },
      {
        address: "https://elys-rpc.kleomedes.network:443",
        provider: "Kleomedes"
      },
      {
        address: "https://elys-testnet-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://api.testnet.elys.network",
        provider: "Elys Network"
      },
      {
        address: "https://elys.api.t.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://elys-testnet-rest.staketab.org",
        provider: "Staketab"
      },
      {
        address: "https://elys-testnet-api.itrocket.net",
        provider: "itrocket"
      },
      {
        address: "https://elys-api.kleomedes.network:443",
        provider: "Kleomedes"
      },
      {
        address: "https://elys-testnet-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "services.staketab.com:9390",
        provider: "Staketab"
      },
      {
        address: "elys-testnet-grpc.itrocket.net:38090",
        provider: "itrocket"
      },
      {
        address: "elys-testnet-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Elys-Testnet",
      tx_page: "https://explorer.stavr.tech/Elys-Testnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Elys-Testnet/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://testnet.elys.network/elys",
      tx_page: "https://testnet.elys.network/elys/tx/${txHash}"
    },
    {
      kind: "itrocket",
      url: "https://testnet.itrocket.net/elys",
      tx_page: "https://testnet.itrocket.net/elys/staking/tx/${txHash}",
      account_page: "https://testnet.itrocket.net/elys/account/${accountAddress}"
    }
  ]
};
yx.default = zpe;
var bx = {};
Object.defineProperty(bx, "__esModule", { value: !0 });
const qpe = [{
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "cosmoshubtestnet",
    client_id: "07-tendermint-2522",
    connection_id: "connection-2881"
  },
  chain_2: {
    chain_name: "elystestnet",
    client_id: "07-tendermint-19",
    connection_id: "connection-17"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-3302",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-16",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live"
    }
  }]
}, {
  $schema: "../ibc_data.schema.json",
  chain_1: {
    chain_name: "elystestnet",
    client_id: "07-tendermint-9",
    connection_id: "connection-12"
  },
  chain_2: {
    chain_name: "nobletestnet",
    client_id: "07-tendermint-28",
    connection_id: "connection-26"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-12",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-19",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live"
    }
  }]
}];
bx.default = qpe;
var vx = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Aa, "__esModule", { value: !0 });
Aa.ibc = Aa.chain = Aa.assets = void 0;
const Spe = vx(_x), Tpe = vx(yx), Rpe = vx(bx);
Aa.assets = Spe.default;
Aa.chain = Tpe.default;
Aa.ibc = Rpe.default;
var ri = {}, fx = {};
Object.defineProperty(fx, "__esModule", { value: !0 });
const Ope = {
  $schema: "../../assetlist.schema.json",
  chain_name: "empetestnet",
  assets: [{
    description: "Empe End-to-End Verifiable Data Infrastructure",
    extended_description: "Empeiria is the first End-to-End Verifiable Data Infrastructure (EVDI). It enables seamless web3 adoption through one-click deployment, empowering organizations with the data of the future",
    denom_units: [{
      denom: "uempe",
      exponent: 0
    }, {
      denom: "empe",
      exponent: 6
    }],
    base: "uempe",
    display: "empe",
    name: "EMPE",
    symbol: "EMPE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/empetestnet/images/empe.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/empetestnet/images/empe.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/empetestnet/images/empe.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/empetestnet/images/empe.svg"
    }]
  }]
};
fx.default = Ope;
var wx = {};
Object.defineProperty(wx, "__esModule", { value: !0 });
const Mpe = {
  $schema: "../../chain.schema.json",
  chain_name: "empetestnet",
  chain_type: "cosmos",
  chain_id: "empe-testnet-2",
  website: "https://empe.io",
  pretty_name: "Empe",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "empe",
  daemon_name: "emped",
  node_home: "$HOME/.emped",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uempe",
      fixed_min_gas_price: 0,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uempe"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.47",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [{
      address: "https://rpc-testnet.empe.io/",
      provider: "empe"
    }, {
      address: "https://rpc-archive-testnet.empe.io/",
      provider: "empe-archive"
    }],
    rest: [{
      address: "https://lcd-testnet.empe.io/",
      provider: "empe"
    }],
    grpc: [{
      address: "grpc-testnet.empe.io:8443",
      provider: "empe"
    }]
  },
  explorers: [{
    kind: "empe",
    url: "https://explorer-testnet.empe.io",
    tx_page: "https://explorer-testnet.empe.io/transactions/${txHash}"
  }]
};
wx.default = Mpe;
var Yj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ri, "__esModule", { value: !0 });
ri.chain = ri.assets = void 0;
const Ipe = Yj(fx), Npe = Yj(wx);
ri.assets = Ipe.default;
ri.chain = Npe.default;
var ja = {}, xx = {};
Object.defineProperty(xx, "__esModule", { value: !0 });
const Ppe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "empowertestnet",
  assets: [{
    description: "The native staking and governance token of the testnet version of Empower.",
    denom_units: [{
      denom: "umpwr",
      exponent: 0
    }, {
      denom: "mpwr",
      exponent: 6
    }],
    base: "umpwr",
    name: "MPWR",
    display: "mpwr",
    symbol: "MPWR",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/empowertestnet/images/mpwr.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/empowertestnet/images/mpwr.png"
    }]
  }]
};
xx.default = Ppe;
var kx = {};
Object.defineProperty(kx, "__esModule", { value: !0 });
const Upe = {
  $schema: "../../chain.schema.json",
  chain_name: "empowertestnet",
  chain_type: "cosmos",
  chain_id: "circulus-1",
  pretty_name: "Empower Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "empower",
  daemon_name: "empowerd",
  node_home: "$HOME/.empowerchain",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "umpwr",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://empower-testnet-rpc.polkachu.com:443",
        provider: "Polkachu"
      },
      {
        address: "https://empower.rpc.cumulo.com.es:443",
        provider: "Cumulo"
      },
      {
        address: "https://rpc-t.empower.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "https://rpc-empower.nodeist.net:443",
        provider: "Nodeist"
      },
      {
        address: "https://empower-testnet.nodejumper.io:443",
        provider: "NODEJUMPER"
      },
      {
        address: "https://empower-testnet-rpc.itrocket.net:443",
        provider: "ITRocket"
      },
      {
        address: "https://rpc.circulus-1.empower.aviaone.com:443",
        provider: "AviaOne"
      }
    ],
    rest: [
      {
        address: "https://empower-testnet-api.polkachu.com:443",
        provider: "Polkachu"
      },
      {
        address: "https://empower.api.cumulo.com.es:443",
        provider: "Cumulo"
      },
      {
        address: "https://empw.api.t.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://api-t.empower.nodestake.top:443",
        provider: "NodeStake"
      },
      {
        address: "https://api-empower.nodeist.net:443",
        provider: "Nodeist"
      },
      {
        address: "https://empower-testnet.nodejumper.io:1317",
        provider: "NODEJUMPER"
      },
      {
        address: "https://empower-testnet-api.itrocket.net:443",
        provider: "ITRocket"
      },
      {
        address: "https://api.circulus-1.empower.aviaone.com",
        provider: "AviaOne"
      }
    ],
    grpc: [
      {
        address: "empower-testnet-grpc.polkachu.com:17490",
        provider: "Polkachu"
      },
      {
        address: "empower.grpc.cumulo.com.es:443",
        provider: "Cumulo"
      },
      {
        address: "grpc-t.empower.nodestake.top:9090",
        provider: "NodeStake"
      },
      {
        address: "empower-testnet.nodejumper.io:9090",
        provider: "NODEJUMPER"
      },
      {
        address: "empower-testnet-grpc.itrocket.net:16090",
        provider: "ITRocket"
      },
      {
        address: "grpc.circulus-1.empower.aviaone.com:443",
        provider: "AviaOne"
      }
    ]
  },
  explorers: [
    {
      kind: "exploreme",
      url: "https://empowerchain.exploreme.pro",
      tx_page: "https://empowerchain.exploreme.pro/transaction/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://exp.nodeist.net/Empower",
      tx_page: "https://exp.nodeist.net/Empower/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Empower",
      tx_page: "https://explorer.stavr.tech/Empower/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.nodestake.top/empower-testnet",
      tx_page: "https://explorer.nodestake.top/empower-testnet/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://testnet.itrocket.net/empower/staking",
      tx_page: "https://testnet.itrocket.net/empower/staking/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://explorer.stavr.tech/empower",
      tx_page: "https://explorer.stavr.tech/empower/tx/${txHash}"
    }
  ]
};
kx.default = Upe;
var Ax = {};
Object.defineProperty(Ax, "__esModule", { value: !0 });
const Hpe = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-2073",
      connection_id: "connection-2418"
    },
    chain_2: {
      chain_name: "empowertestnet",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2765",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "empowertestnet",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-146",
      connection_id: "connection-157"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-155",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "empowertestnet",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "stargazetestnet",
      client_id: "07-tendermint-450",
      connection_id: "connection-469"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-459",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Ax.default = Hpe;
var jx = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ja, "__esModule", { value: !0 });
ja.ibc = ja.chain = ja.assets = void 0;
const Lpe = jx(xx), Wpe = jx(kx), Vpe = jx(Ax);
ja.assets = Lpe.default;
ja.chain = Wpe.default;
ja.ibc = Vpe.default;
var Ca = {}, Cx = {};
Object.defineProperty(Cx, "__esModule", { value: !0 });
const Gpe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "entrypointtestnet",
  assets: [{
    description: "The native token of EntryPoint",
    denom_units: [{
      denom: "uentry",
      exponent: 0,
      aliases: []
    }, {
      denom: "entry",
      exponent: 6,
      aliases: []
    }],
    base: "uentry",
    name: "EntryPoint",
    display: "entry",
    symbol: "ENTRY",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/entrypointtestnet/images/entry.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/entrypointtestnet/images/entry.svg"
    },
    keywords: [
      "staking",
      "governance",
      "vaults"
    ],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/entrypointtestnet/images/entry.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/entrypointtestnet/images/entry.svg"
    }]
  }, {
    description: "The native staking and governance token of the Theta testnet version of the Cosmos Hub, via Osmosis.",
    denom_units: [{
      denom: "ibc/8A138BC76D0FB2665F8937EC2BF01B9F6A714F6127221A0E155106A45E09BCC5",
      exponent: 0
    }, {
      denom: "atom",
      exponent: 6
    }],
    base: "ibc/8A138BC76D0FB2665F8937EC2BF01B9F6A714F6127221A0E155106A45E09BCC5",
    name: "Cosmos",
    display: "atom",
    symbol: "ATOM",
    traces: [{
      type: "ibc",
      counterparty: {
        chain_name: "osmosistestnet",
        base_denom: "ibc/9FF2B7A5F55038A7EE61F4FD6749D9A648B48E89830F2682B67B5DC158E2753C",
        channel_id: "channel-4156"
      },
      chain: {
        channel_id: "channel-0",
        path: "transfer/channel-0/transfer/channel-4156/uatom"
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
    },
    images: [{
      image_sync: {
        chain_name: "osmosistestnet",
        base_denom: "ibc/9FF2B7A5F55038A7EE61F4FD6749D9A648B48E89830F2682B67B5DC158E2753C"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
    }]
  }]
};
Cx.default = Gpe;
var Ex = {};
Object.defineProperty(Ex, "__esModule", { value: !0 });
const Kpe = {
  $schema: "../../chain.schema.json",
  chain_name: "entrypointtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "EntryPoint Testnet",
  chain_type: "cosmos",
  chain_id: "entrypoint-pubtest-2",
  bech32_prefix: "entrypoint",
  daemon_name: "entrypointd",
  node_home: "$HOME/.entrypointd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ibc/8A138BC76D0FB2665F8937EC2BF01B9F6A714F6127221A0E155106A45E09BCC5",
      low_gas_price: 0.01,
      average_gas_price: 0.01,
      high_gas_price: 0.02
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uentry"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47.4"
  },
  apis: {
    rpc: [{
      address: "https://testnet-rpc.entrypoint.zone",
      provider: "Simply Staking"
    }],
    rest: [{
      address: "https://entry.api.t.stavr.tech",
      provider: "🔥STAVR🔥"
    }, {
      address: "https://testnet-rest.entrypoint.zone",
      provider: "Simply Staking"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/entrypointtestnet/images/entrypoint-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/entrypointtestnet/images/entrypoint-chain-logo.svg"
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://explorer.entrypoint.zone/entrypoint",
      tx_page: "https://explorer.entrypoint.zone/entrypoint/tx/${txHash}",
      account_page: "https://explorer.entrypoint.zone/entrypoint/account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Entrypoint-Testnet",
      tx_page: "https://explorer.stavr.tech/Entrypoint-Testnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Entrypoint-Testnet/account/${accountAddress}"
    },
    {
      kind: "ping.pub",
      url: "https://testnet.ping.pub/entrypoint",
      tx_page: "https://testnet.ping.pub/entrypoint/tx/${txHash}",
      account_page: "https://testnet.ping.pub/entrypoint/account/${accountAddress}"
    }
  ],
  keywords: ["testnet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/entrypointtestnet/images/entrypoint-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/entrypointtestnet/images/entrypoint-chain-logo.svg"
  }]
};
Ex.default = Kpe;
var Dx = {};
Object.defineProperty(Dx, "__esModule", { value: !0 });
const Xpe = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "entrypointtestnet",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-930",
    connection_id: "connection-840"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1543",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Dx.default = Xpe;
var Bx = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ca, "__esModule", { value: !0 });
Ca.ibc = Ca.chain = Ca.assets = void 0;
const Ype = Bx(Cx), Jpe = Bx(Ex), Zpe = Bx(Dx);
Ca.assets = Ype.default;
Ca.chain = Jpe.default;
Ca.ibc = Zpe.default;
var ii = {}, Fx = {};
Object.defineProperty(Fx, "__esModule", { value: !0 });
const Qpe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "evmostestnet",
  assets: [{
    description: "The native EVM, governance and staking token of the Evmos Hub",
    denom_units: [{
      denom: "atevmos",
      exponent: 0
    }, {
      denom: "tevmos",
      exponent: 18
    }],
    base: "atevmos",
    name: "Evmos Testnet",
    display: "tevmos",
    symbol: "TEVMOS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/evmostestnet/images/evmos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/evmostestnet/images/evmos.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/evmostestnet/images/evmos.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/evmostestnet/images/evmos.svg"
    }]
  }]
};
Fx.default = Qpe;
var $x = {};
Object.defineProperty($x, "__esModule", { value: !0 });
const ele = {
  $schema: "../../chain.schema.json",
  chain_name: "evmostestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Evmos Testnet",
  chain_type: "cosmos",
  chain_id: "evmos_9000-4",
  bech32_prefix: "evmos",
  daemon_name: "evmosd",
  node_home: "$HOME/.evmosd",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "atevmos",
      low_gas_price: 2e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "atevmos"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46"
  },
  apis: {
    rpc: [
      {
        address: "https://evmos.test.rpc.coldyvalidator.net",
        provider: "coldy"
      },
      {
        address: "https://evmos-testnet-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://evmos-testnet-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://evmos.test.api.coldyvalidator.net",
        provider: "coldy"
      },
      {
        address: "https://evmos-testnet-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://evmos-testnet-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [{
      address: "https://evmos.test.grpc.coldyvalidator.net",
      provider: "coldy"
    }, {
      address: "evmos-testnet-grpc.publicnode.com:443",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }]
  },
  explorers: [{
    kind: "Mintscan",
    url: "https://mintscan.io/evmos-testnet",
    tx_page: "https://mintscan.io/evmos-testnet/txs/${txHash}"
  }, {
    kind: "NodesGuru",
    url: "https://testnet.evmos.explorers.guru/",
    tx_page: "https://testnet.evmos.explorers.guru/transaction/${txHash}"
  }]
};
$x.default = ele;
var Jj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ii, "__esModule", { value: !0 });
ii.chain = ii.assets = void 0;
const nle = Jj(Fx), tle = Jj($x);
ii.assets = nle.default;
ii.chain = tle.default;
var ci = {}, zx = {};
Object.defineProperty(zx, "__esModule", { value: !0 });
const sle = {
  $schema: "../../assetlist.schema.json",
  chain_name: "fetchhubtestnet",
  assets: [{
    description: "The native staking and governance token of the Fetch Hub.",
    denom_units: [{
      denom: "atestfet",
      exponent: 0
    }, {
      denom: "testfet",
      exponent: 18
    }],
    base: "atestfet",
    name: "fetch-ai",
    display: "testfet",
    symbol: "FET",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.svg"
    },
    coingecko_id: "fetch-ai",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/fetchhub/images/fet.svg"
    }]
  }]
};
zx.default = sle;
var qx = {};
Object.defineProperty(qx, "__esModule", { value: !0 });
const ale = {
  $schema: "../../chain.schema.json",
  chain_name: "fetchhubtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Fetch.ai Testnet",
  chain_type: "cosmos",
  chain_id: "dorado-1",
  bech32_prefix: "fetch",
  daemon_name: "fetchd",
  node_home: "$HOME/.fetchd",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "atestfet",
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.035
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "atestfet"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc-dorado.fetch.ai:443",
      provider: "fetch.ai"
    }],
    rest: [{
      address: "https://rest-dorado.fetch.ai",
      provider: "fetch.ai"
    }],
    grpc: [{
      address: "grpc-dorado.fetch.ai:443",
      provider: "fetch.ai"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://explore-dorado.fetch.ai",
    tx_page: "https://explore-dorado.fetch.ai/transactions/${txHash}"
  }, {
    kind: "azoyalabs",
    url: "https://fetchstation.azoyalabs.com/testnet",
    tx_page: "https://fetchstation.azoyalabs.com/testnet/explorer/transactions/${txHash}",
    account_page: "https://fetchstation.azoyalabs.com/testnet/explorer/address/${accountAddress}"
  }]
};
qx.default = ale;
var Zj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ci, "__esModule", { value: !0 });
ci.chain = ci.assets = void 0;
const ole = Zj(zx), rle = Zj(qx);
ci.assets = ole.default;
ci.chain = rle.default;
var di = {}, Sx = {};
Object.defineProperty(Sx, "__esModule", { value: !0 });
const ile = {
  $schema: "../../assetlist.schema.json",
  chain_name: "fiammatestnet",
  assets: [{
    description: "The native staking token of fiamma.",
    denom_units: [{
      denom: "ufia",
      exponent: 0
    }, {
      denom: "fia",
      exponent: 6
    }],
    base: "ufia",
    name: "Fiamma",
    display: "fia",
    symbol: "FIA",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/fiammatestnet/images/fiamma.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/fiammatestnet/images/fiamma.svg"
    }]
  }]
};
Sx.default = ile;
var Tx = {};
Object.defineProperty(Tx, "__esModule", { value: !0 });
const cle = {
  $schema: "../../chain.schema.json",
  chain_name: "fiammatestnet",
  status: "live",
  website: "https://www.fiammachain.io",
  network_type: "testnet",
  pretty_name: "Fiamma Testnet",
  chain_type: "cosmos",
  chain_id: "fiamma-testnet-1",
  bech32_prefix: "fiamma",
  daemon_name: "fiammad",
  node_home: "$HOME/.fiamma",
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "ufia"
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ufia"
    }]
  },
  codebase: {},
  logo_URIs: {
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/fiammatestnet/images/fiamma.svg"
  },
  apis: {
    rpc: [{
      address: "https://testnet-rpc.fiammachain.io",
      provider: "Fiamma"
    }],
    rest: [{
      address: "https://testnet-api.fiammachain.io",
      provider: "Fiamma"
    }],
    grpc: []
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://testnet-explorer.fiammachain.io/"
  }],
  images: [{
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/fiammatestnet/images/fiamma.svg"
  }],
  slip44: 118
};
Tx.default = cle;
var Qj = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(di, "__esModule", { value: !0 });
di.chain = di.assets = void 0;
const dle = Qj(Sx), mle = Qj(Tx);
di.assets = dle.default;
di.chain = mle.default;
var mi = {}, Rx = {};
Object.defineProperty(Rx, "__esModule", { value: !0 });
const hle = {
  $schema: "../../assetlist.schema.json",
  chain_name: "finschiatestnet",
  assets: [{
    description: "The native token of Ebony",
    denom_units: [{
      denom: "tcony",
      exponent: 0
    }, {
      denom: "tfnsa",
      exponent: 6
    }],
    type_asset: "sdk.coin",
    base: "tcony",
    name: "Test FINSCHIA",
    display: "tfnsa",
    symbol: "TFNSA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.svg"
    }],
    keywords: ["staking"]
  }]
};
Rx.default = hle;
var Ox = {};
Object.defineProperty(Ox, "__esModule", { value: !0 });
const ple = {
  $schema: "../../chain.schema.json",
  chain_name: "finschiatestnet",
  chain_type: "cosmos",
  chain_id: "ebony-2",
  website: "https://www.finschia.io/",
  pretty_name: "Ebony",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "tlink",
  daemon_name: "fnsad",
  node_home: "$HOME/.finschia",
  key_algos: ["secp256k1"],
  slip44: 438,
  fees: {
    fee_tokens: [{
      denom: "tcony",
      fixed_min_gas_price: 0.015,
      low_gas_price: 0.015,
      average_gas_price: 0.015,
      high_gas_price: 0.015
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "tcony"
    }],
    lock_duration: {
      time: "86400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "github.com/Finschia/finschia-sdk@v0.48.1",
    cosmwasm_enabled: !0,
    cosmwasm_version: "github.com/Finschia/wasmd@v0.2.0"
  },
  apis: {
    rpc: [{
      address: "https://ebony-rpc.finschia.io"
    }],
    rest: [{
      address: "https://ebony-api.finschia.io"
    }],
    grpc: [{
      address: "ebony-grpc.finschia.io:443"
    }]
  },
  explorers: [{
    kind: "mintscan",
    url: "https://www.mintscan.io/finschia-testnet",
    tx_page: "https://www.mintscan.io/finschia-testnet/tx/${txHash}",
    account_page: "https://www.mintscan.io/finschia-testnet/address/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.svg"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/finschia/images/fnsa.svg"
  }
};
Ox.default = ple;
var eC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(mi, "__esModule", { value: !0 });
mi.chain = mi.assets = void 0;
const lle = eC(Rx), gle = eC(Ox);
mi.assets = lle.default;
mi.chain = gle.default;
var hi = {}, Mx = {};
Object.defineProperty(Mx, "__esModule", { value: !0 });
const ule = {
  $schema: "../../assetlist.schema.json",
  chain_name: "galacticatestnet",
  assets: [{
    description: "The native token of Galactica Protocol Testnet",
    denom_units: [{
      denom: "agnet",
      exponent: 0
    }, {
      denom: "gnet",
      exponent: 18
    }],
    base: "agnet",
    name: "Gnet",
    display: "gnet",
    symbol: "GNET",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galactica/images/galactica.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galactica/images/galactica.png"
    }, {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galactica/images/galactica.svg"
    }]
  }]
};
Mx.default = ule;
var Ix = {};
Object.defineProperty(Ix, "__esModule", { value: !0 });
const _le = {
  $schema: "../../chain.schema.json",
  chain_name: "galacticatestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Galactica Protocol Testnet",
  chain_type: "cosmos",
  chain_id: "galactica_9302-1",
  bech32_prefix: "gala",
  daemon_name: "galacticad",
  node_home: "$HOME/.galactica",
  key_algos: ["ethsecp256k1"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "agnet",
      fixed_min_gas_price: 10,
      low_gas_price: 10,
      average_gas_price: 10,
      high_gas_price: 20
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "agnet"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [{
      address: "https://rpc.galactica.test.pfc.zone/",
      provider: "PFC"
    }, {
      address: "https://galactica-testnet-rpc.ibs.team:443",
      provider: "Inter Blockchain Services"
    }],
    rest: [{
      address: "https://api.galactica.test.pfc.zone/",
      provider: "PFC"
    }, {
      address: "https://galactica-testnet-api.ibs.team:443",
      provider: "Inter Blockchain Services"
    }],
    grpc: [{
      address: "https://grpc.galactica.test.pfc.zone/",
      provider: "PFC"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galactica/images/galactica.png"
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://ping.pfc.zone/galactica-testnet",
    tx_page: "https://ping.pfc.zone/galactica-testnet/tx/${txHash}",
    account_page: "https://ping.pfc.zone/galactica-testnet/account/${accountAddress}"
  }],
  keywords: ["testnet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/galactica/images/galactica.png"
  }]
};
Ix.default = _le;
var nC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(hi, "__esModule", { value: !0 });
hi.chain = hi.assets = void 0;
const yle = nC(Mx), ble = nC(Ix);
hi.assets = yle.default;
hi.chain = ble.default;
var pi = {}, Nx = {};
Object.defineProperty(Nx, "__esModule", { value: !0 });
const vle = {
  $schema: "../../assetlist.schema.json",
  chain_name: "gitopiatestnet",
  assets: [{
    description: "The native staking and governance token of the testnet version of Gitopia.",
    denom_units: [{
      denom: "utlore",
      exponent: 0
    }, {
      denom: "tlore",
      exponent: 6
    }],
    base: "utlore",
    name: "TLORE",
    display: "tlore",
    symbol: "TLORE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/gitopiatestnet/images/gitopia.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/gitopiatestnet/images/gitopia.png"
    }]
  }]
};
Nx.default = vle;
var Px = {};
Object.defineProperty(Px, "__esModule", { value: !0 });
const fle = {
  $schema: "../../chain.schema.json",
  chain_name: "gitopiatestnet",
  chain_type: "cosmos",
  chain_id: "gitopia-janus-testnet-2",
  pretty_name: "Gitopia Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "gitopia",
  daemon_name: "gitopiad",
  node_home: "$HOME/.gitopia",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utlore",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://gitopia-testnet.nodejumper.io",
      provider: "NODEJUMPER"
    }],
    rest: [{
      address: "https://gitopia-testnet.nodejumper.io:1317",
      provider: "NODEJUMPER"
    }],
    grpc: [{
      address: "https://gitopia-testnet.nodejumper.io:9090",
      provider: "NODEJUMPER"
    }]
  },
  explorers: [{
    kind: "explorer.humans.zone",
    url: "https://gitopia.explorers.guru/",
    tx_page: "https://gitopia.explorers.guru/transaction/${txHash}"
  }]
};
Px.default = fle;
var tC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(pi, "__esModule", { value: !0 });
pi.chain = pi.assets = void 0;
const wle = tC(Nx), xle = tC(Px);
pi.assets = wle.default;
pi.chain = xle.default;
var li = {}, Ux = {};
Object.defineProperty(Ux, "__esModule", { value: !0 });
const kle = {
  $schema: "../../assetlist.schema.json",
  chain_name: "hedgetestnet",
  assets: [{
    description: "The native staking token of the Hedge blockchain.",
    denom_units: [{
      denom: "uhedge",
      exponent: 0
    }, {
      denom: "hedge",
      exponent: 6
    }],
    base: "uhedge",
    name: "Berberis HEDGE",
    display: "hedge",
    symbol: "HEDGE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/hedgetestnet/images/hedge.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/hedgetestnet/images/hedge.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/hedgetestnet/images/hedge.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/hedgetestnet/images/hedge.svg"
    }]
  }]
};
Ux.default = kle;
var Hx = {};
Object.defineProperty(Hx, "__esModule", { value: !0 });
const Ale = {
  $schema: "../../chain.schema.json",
  chain_name: "hedgetestnet",
  chain_type: "cosmos",
  chain_id: "berberis-1",
  pretty_name: "Hedge Testnet",
  status: "live",
  network_type: "testnet",
  website: "https://hedgeblock.io",
  bech32_prefix: "hedge",
  daemon_name: "hedged",
  node_home: "$HOME/.hedge",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uhedge",
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uhedge"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/hedgetestnet/images/hedge.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/hedgetestnet/images/hedge.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc-berberis.hedgeblock.io",
      provider: "Hedge"
    }],
    rest: [{
      address: "https://lcd-berberis.hedgeblock.io",
      provider: "Hedge"
    }]
  },
  explorers: [{
    kind: "hedgescan",
    url: "https://berberis.hedgescan.io",
    tx_page: "https://berberis.hedgescan.io/txs/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/hedgetestnet/images/hedge.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/hedgetestnet/images/hedge.svg"
  }]
};
Hx.default = Ale;
var sC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(li, "__esModule", { value: !0 });
li.chain = li.assets = void 0;
const jle = sC(Ux), Cle = sC(Hx);
li.assets = jle.default;
li.chain = Cle.default;
var gi = {}, Lx = {};
Object.defineProperty(Lx, "__esModule", { value: !0 });
const Ele = {
  $schema: "../../assetlist.schema.json",
  chain_name: "humanstestnet",
  assets: [{
    description: "The native staking and governance token of the testnet version of Humans AI.",
    denom_units: [{
      denom: "uheart",
      exponent: 0
    }, {
      denom: "heart",
      exponent: 6
    }],
    base: "uheart",
    name: "HEART",
    display: "heart",
    symbol: "HEART",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/humanstestnet/images/humans.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/humanstestnet/images/humans.png"
    }]
  }]
};
Lx.default = Ele;
var Wx = {};
Object.defineProperty(Wx, "__esModule", { value: !0 });
const Dle = {
  $schema: "../../chain.schema.json",
  chain_name: "humanstestnet",
  chain_type: "cosmos",
  chain_id: "testnet-1",
  pretty_name: "Humans AI Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "humans",
  daemon_name: "humansd",
  node_home: "$HOME/.humans",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uheart",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://humans-testnet.nodejumper.io",
      provider: "NODEJUMPER"
    }],
    rest: [{
      address: "https://humans-testnet.nodejumper.io:1317",
      provider: "NODEJUMPER"
    }],
    grpc: [{
      address: "https://humans-testnet.nodejumper.io:9090",
      provider: "NODEJUMPER"
    }]
  },
  explorers: [{
    kind: "explorer.humans.zone",
    url: "https://explorer.humans.zone/",
    tx_page: "https://explorer.humans.zone/humans-testnet/tx/${txHash}"
  }]
};
Wx.default = Dle;
var aC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(gi, "__esModule", { value: !0 });
gi.chain = gi.assets = void 0;
const Ble = aC(Lx), Fle = aC(Wx);
gi.assets = Ble.default;
gi.chain = Fle.default;
var ui = {}, Vx = {};
Object.defineProperty(Vx, "__esModule", { value: !0 });
const $le = {
  $schema: "../../assetlist.schema.json",
  chain_name: "hypersigntestnet",
  assets: [{
    description: "Native token for Hypersign Identity Network",
    denom_units: [{
      denom: "uhid",
      exponent: 0
    }, {
      denom: "hid",
      exponent: 6
    }],
    base: "uhid",
    display: "hid",
    name: "Hypersign",
    symbol: "HID",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/hypersigntestnet/images/hypersign.png"
    },
    coingecko_id: "hypersign-identity-token",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/hypersigntestnet/images/hypersign.png"
    }]
  }]
};
Vx.default = $le;
var Gx = {};
Object.defineProperty(Gx, "__esModule", { value: !0 });
const zle = {
  $schema: "../../chain.schema.json",
  chain_name: "hypersigntestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Hypersign Testnet",
  chain_type: "cosmos",
  chain_id: "prajna-1",
  bech32_prefix: "hid",
  daemon_name: "hid-noded",
  node_home: "$HOME/.hid-node",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uhid",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc.prajna.hypersign.id",
      provider: "Hypersign"
    }],
    rest: [{
      address: "https://api.prajna.hypersign.id",
      provider: "Hypersign"
    }],
    grpc: []
  },
  explorers: [{
    kind: "Hypersign",
    url: "https://explorer.hypersign.id/hypersign-prajna-testnet",
    tx_page: "https://explorer.hypersign.id/hypersign-prajna-testnet/tx/${txHash}"
  }]
};
Gx.default = zle;
var oC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ui, "__esModule", { value: !0 });
ui.chain = ui.assets = void 0;
const qle = oC(Vx), Sle = oC(Gx);
ui.assets = qle.default;
ui.chain = Sle.default;
var Ea = {}, Kx = {};
Object.defineProperty(Kx, "__esModule", { value: !0 });
const Tle = {
  $schema: "../../assetlist.schema.json",
  chain_name: "impacthubtestnet",
  assets: [{
    description: "The native token of IXO Chain",
    denom_units: [{
      denom: "uixo",
      exponent: 0
    }, {
      denom: "ixo",
      exponent: 6
    }],
    base: "uixo",
    name: "IXO",
    display: "ixo",
    symbol: "IXO",
    traces: [{
      type: "test-mintage",
      counterparty: {
        chain_name: "impacthub",
        base_denom: "uixo"
      },
      provider: "impacthub"
    }],
    images: [{
      image_sync: {
        chain_name: "impacthub",
        base_denom: "uixo"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg",
      theme: {
        primary_color_hex: "#2c4484"
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg"
    }
  }]
};
Kx.default = Tle;
var Xx = {};
Object.defineProperty(Xx, "__esModule", { value: !0 });
const Rle = {
  $schema: "../../chain.schema.json",
  chain_name: "impacthubtestnet",
  status: "live",
  network_type: "testnet",
  website: "https://www.ixo.world/",
  pretty_name: "ixo",
  chain_type: "cosmos",
  chain_id: "pandora-8",
  bech32_prefix: "ixo",
  daemon_name: "ixod",
  node_home: "$HOME/.ixod",
  key_algos: ["secp256k1", "ed25519"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uixo",
      fixed_min_gas_price: 0.015,
      low_gas_price: 0.015,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uixo"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.testnet.ixo.earth/",
      provider: "ixoworld"
    }],
    rest: [{
      address: "https://testnet.ixo.earth/rest/",
      provider: "ixoworld"
    }],
    grpc: []
  },
  explorers: [{
    kind: "ixoworld",
    url: "https://blockscan.testnet.ixo.earth/ixo",
    tx_page: "https://blockscan.testnet.ixo.earth/ixo/transactions/${txHash}",
    account_page: "https://blockscan.testnet.ixo.earth/ixo/accounts/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg"
  }]
};
Xx.default = Rle;
var Yx = {};
Object.defineProperty(Yx, "__esModule", { value: !0 });
const Ole = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "impacthubtestnet",
    client_id: "07-tendermint-53",
    connection_id: "connection-23"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-1010",
    connection_id: "connection-911"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-10",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1637",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Yx.default = Ole;
var Jx = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ea, "__esModule", { value: !0 });
Ea.ibc = Ea.chain = Ea.assets = void 0;
const Mle = Jx(Kx), Ile = Jx(Xx), Nle = Jx(Yx);
Ea.assets = Mle.default;
Ea.chain = Ile.default;
Ea.ibc = Nle.default;
var _i = {}, Zx = {};
Object.defineProperty(Zx, "__esModule", { value: !0 });
const Ple = {
  $schema: "../../assetlist.schema.json",
  chain_name: "imversedtestnet",
  assets: [{
    description: "The native staking and governance token of the Imversed testnet.",
    denom_units: [{
      denom: "nimv",
      exponent: 0,
      aliases: []
    }, {
      denom: "imv",
      exponent: 6,
      aliases: []
    }],
    base: "nimv",
    name: "Imv",
    display: "imv",
    symbol: "IMV",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/imversedtestnet/images/imversed.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/imversedtestnet/images/imversed.svg"
    }]
  }, {
    description: "The native staking and governance token of the Imversed testnet.",
    denom_units: [{
      denom: "ibc/C6438A7D613196373D939891C99CA7EEF4F78F4A78DC8590E51E62F8ED16E72B",
      exponent: 0,
      aliases: ["usaage"]
    }, {
      denom: "imv",
      exponent: 6
    }],
    base: "ibc/C6438A7D613196373D939891C99CA7EEF4F78F4A78DC8590E51E62F8ED16E72B",
    name: "Imv",
    display: "imv",
    symbol: "IMV",
    ibc: {
      source_channel: "channel-1",
      dst_channel: "channel-221",
      source_denom: "nimv"
    },
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/imversedtestnet/images/imversed.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/imversedtestnet/images/imversed.svg"
    }]
  }]
};
Zx.default = Ple;
var Qx = {};
Object.defineProperty(Qx, "__esModule", { value: !0 });
const Ule = {
  $schema: "../../chain.schema.json",
  chain_name: "imversedtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Imversed Testnet",
  chain_type: "cosmos",
  chain_id: "imversed-test-1",
  bech32_prefix: "imv",
  daemon_name: "imversed",
  node_home: "$HOME/.imversed",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "nimv",
      fixed_min_gas_price: 1e-3
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://tx-endpoint-test.imversed.com/",
      provider: "imversed"
    }],
    rest: [{
      address: "https://query-endpoint-test.imversed.com/",
      provider: "imversed"
    }],
    grpc: [{
      address: "http://qs.imversed.com:9090",
      provider: "imversed"
    }]
  },
  explorers: [{
    kind: "Big Dipper",
    url: "https://tex-s.imversed.com",
    tx_page: "https://tex-s.imversed.com/transactions/${txHash}"
  }]
};
Qx.default = Ule;
var rC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(_i, "__esModule", { value: !0 });
_i.chain = _i.assets = void 0;
const Hle = rC(Zx), Lle = rC(Qx);
_i.assets = Hle.default;
_i.chain = Lle.default;
var Da = {}, ek = {};
Object.defineProperty(ek, "__esModule", { value: !0 });
const Wle = {
  $schema: "../../assetlist.schema.json",
  chain_name: "injectivetestnet",
  assets: [{
    description: "The INJ token is the native governance token for the Injective chain.",
    denom_units: [{
      denom: "inj",
      exponent: 0
    }, {
      denom: "INJ",
      exponent: 18
    }],
    base: "inj",
    name: "Injective",
    display: "INJ",
    symbol: "INJ",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg"
    },
    coingecko_id: "injective-protocol",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg"
    }]
  }]
};
ek.default = Wle;
var nk = {};
Object.defineProperty(nk, "__esModule", { value: !0 });
const Vle = {
  $schema: "../../chain.schema.json",
  chain_name: "injectivetestnet",
  status: "live",
  network_type: "testnet",
  website: "https://injective.com",
  pretty_name: "Injective",
  chain_type: "cosmos",
  chain_id: "injective-888",
  bech32_prefix: "inj",
  extra_codecs: ["injective"],
  slip44: 60,
  daemon_name: "injectived",
  node_home: "$HOME/.injectived",
  fees: {
    fee_tokens: [{
      denom: "inj",
      fixed_min_gas_price: 16e7,
      low_gas_price: 5e8,
      average_gas_price: 7e8,
      high_gas_price: 9e8
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "inj"
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://injective-testnet-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://testnet.sentry.tm.injective.network:443",
        provider: "injectiveLabs"
      },
      {
        address: "https://testnet.tm.injective.network",
        provider: "injectiveLabs"
      },
      {
        address: "https://injective-testnet-rpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    rest: [
      {
        address: "https://injective-testnet-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://testnet.sentry.lcd.injective.network:443",
        provider: "injectiveLabs"
      },
      {
        address: "https://testnet.lcd.injective.network",
        provider: "injectiveLabs"
      },
      {
        address: "https://injective-testnet-rest.publicnode.com",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ],
    grpc: [
      {
        address: "injective-testnet-grpc.polkachu.com:14390",
        provider: "Polkachu"
      },
      {
        address: "testnet.sentry.chain.grpc.injective.network:443",
        provider: "injectiveLabs"
      },
      {
        address: "https://testnet.grpc.injective.network",
        provider: "injectiveLabs"
      },
      {
        address: "injective-testnet-grpc.publicnode.com:443",
        provider: "Allnodes ⚡️ Nodes & Staking"
      }
    ]
  },
  explorers: [{
    kind: "injectiveprotocol",
    url: "https://testnet.explorer.injective.network/",
    tx_page: "https://testnet.explorer.injective.network/transaction/${txHash}"
  }]
};
nk.default = Vle;
var tk = {};
Object.defineProperty(tk, "__esModule", { value: !0 });
const Gle = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "injectivetestnet",
      client_id: "07-tendermint-123",
      connection_id: "connection-98"
    },
    chain_2: {
      chain_name: "noistestnet",
      client_id: "07-tendermint-26",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-74",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-77",
        port_id: "wasm.inj14nendtsz0c40n7xtzwkjmdc8dkuz835jdydxhn"
      },
      chain_2: {
        channel_id: "channel-36",
        port_id: "wasm.nois1xwde9rzqk5u36fke0r9ddmtwvh43n4fv53c5vc462wz8xlnqjhls6d90xc"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "injectivetestnet",
      client_id: "07-tendermint-189",
      connection_id: "connection-180"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1273",
      connection_id: "connection-1173"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-129",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4174",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "injectivetestnet",
      client_id: "07-tendermint-239",
      connection_id: "connection-220"
    },
    chain_2: {
      chain_name: "xiontestnet",
      client_id: "07-tendermint-119",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-489",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-487",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
tk.default = Gle;
var sk = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Da, "__esModule", { value: !0 });
Da.ibc = Da.chain = Da.assets = void 0;
const Kle = sk(ek), Xle = sk(nk), Yle = sk(tk);
Da.assets = Kle.default;
Da.chain = Xle.default;
Da.ibc = Yle.default;
var yi = {}, ak = {};
Object.defineProperty(ak, "__esModule", { value: !0 });
const Jle = {
  $schema: "../../assetlist.schema.json",
  chain_name: "jackaltestnet",
  assets: [{
    description: "The native staking and governance token of Jackal.",
    denom_units: [{
      denom: "ujkl",
      exponent: 0
    }, {
      denom: "jkl",
      exponent: 6
    }],
    base: "ujkl",
    name: "Jackal",
    display: "jkl",
    symbol: "JKL",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/jackaltestnet/images/jkl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/jackaltestnet/images/jkl.svg"
    },
    coingecko_id: "jackal",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/jackaltestnet/images/jkl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/jackaltestnet/images/jkl.svg"
    }]
  }]
};
ak.default = Jle;
var ok = {};
Object.defineProperty(ok, "__esModule", { value: !0 });
const Zle = {
  $schema: "../../chain.schema.json",
  chain_name: "jackaltestnet",
  chain_type: "cosmos",
  chain_id: "canine-1",
  website: "https://jackalprotocol.com",
  pretty_name: "Jackal",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "jkl",
  daemon_name: "canined",
  node_home: "$HOME/.canine",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ujkl",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "http://jkl.rpc.t.stavr.tech:19127",
      provider: "🔥STAVR🔥"
    }, {
      address: "https://testnet-rpc.jackalprotocol.com",
      provider: "Jackal Labs"
    }],
    rest: [{
      address: "https://jkl.api.t.stavr.tech",
      provider: "🔥STAVR🔥"
    }, {
      address: "https://testnet-api.jackalprotocol.com",
      provider: "Jackal Labs"
    }],
    grpc: [{
      address: "http://jkl.grpc.t.stavr.tech:5913",
      provider: "🔥STAVR🔥"
    }, {
      address: "https://testnet-grpc.jackalprotocol.com",
      provider: "Jackal Labs"
    }]
  },
  explorers: [{
    kind: "🔥STAVR🔥",
    url: "https://explorer.stavr.tech/Jackal-Testnet",
    tx_page: "https://explorer.stavr.tech/Jackal-Testnet/tx/${txHash}",
    account_page: "https://explorer.stavr.tech/Jackal-Testnet/account/${accountAddress}"
  }, {
    kind: "ping.pub",
    url: "https://ping.pub/jackal",
    tx_page: "https://ping.pub/jackal/tx/${txHash}"
  }]
};
ok.default = Zle;
var iC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(yi, "__esModule", { value: !0 });
yi.chain = yi.assets = void 0;
const Qle = iC(ak), ege = iC(ok);
yi.assets = Qle.default;
yi.chain = ege.default;
var Ba = {}, rk = {};
Object.defineProperty(rk, "__esModule", { value: !0 });
const nge = {
  $schema: "../../assetlist.schema.json",
  chain_name: "jackaltestnet2",
  assets: [{
    description: "The native staking and governance token of Jackal.",
    denom_units: [{
      denom: "ujkl",
      exponent: 0
    }, {
      denom: "jkl",
      exponent: 6
    }],
    base: "ujkl",
    name: "Jackal",
    display: "jkl",
    symbol: "JKL",
    traces: [{
      type: "test-mintage",
      counterparty: {
        chain_name: "jackal",
        base_denom: "ujkl"
      },
      provider: "Jackal"
    }],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/jackal/images/jkl.svg",
      image_sync: {
        chain_name: "jackal",
        base_denom: "ujkl"
      },
      theme: {
        primary_color_hex: "#dbdbcb"
      }
    }]
  }]
};
rk.default = nge;
var ik = {};
Object.defineProperty(ik, "__esModule", { value: !0 });
const tge = {
  $schema: "../../chain.schema.json",
  chain_name: "jackaltestnet2",
  chain_type: "cosmos",
  chain_id: "mesomelas-1",
  website: "https://jackalprotocol.com",
  pretty_name: "Jackal v4",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "jkl",
  daemon_name: "canined",
  node_home: "$HOME/.canine",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ujkl",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://jackal-testnet-v4-rpc.brocha.in",
      provider: "Brochain"
    }],
    rest: [{
      address: "https://jackal-testnet-v4-rest.brocha.in",
      provider: "Brochain"
    }],
    grpc: []
  },
  explorers: [{
    kind: "PingPub",
    url: "https://testnet-explorer.brocha.in/Jackal%20v4",
    tx_page: "https://testnet-explorer.brocha.in/Jackal%20v4/tx/${txHash}",
    account_page: "https://testnet-explorer.brocha.in/Jackal%20v4/account/${accountAddress}"
  }]
};
ik.default = tge;
var ck = {};
Object.defineProperty(ck, "__esModule", { value: !0 });
const sge = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "archwaytestnet",
    client_id: "07-tendermint-0",
    connection_id: "connection-119"
  },
  chain_2: {
    chain_name: "jackaltestnet2",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-368",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live"
    }
  }]
}];
ck.default = sge;
var dk = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ba, "__esModule", { value: !0 });
Ba.ibc = Ba.chain = Ba.assets = void 0;
const age = dk(rk), oge = dk(ik), rge = dk(ck);
Ba.assets = age.default;
Ba.chain = oge.default;
Ba.ibc = rge.default;
var Fa = {}, mk = {};
Object.defineProperty(mk, "__esModule", { value: !0 });
const ige = {
  $schema: "../../assetlist.schema.json",
  chain_name: "junotestnet",
  assets: [
    {
      description: "The native token of JUNO Chain",
      denom_units: [{
        denom: "ujunox",
        exponent: 0
      }, {
        denom: "junox",
        exponent: 6
      }],
      base: "ujunox",
      name: "Juno Testnet",
      display: "junox",
      symbol: "JUNOX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/junotestnet/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/junotestnet/images/juno.svg"
      },
      coingecko_id: "juno-network",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/junotestnet/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/junotestnet/images/juno.svg"
      }]
    },
    {
      description: "The native token of NEXX GEN AI",
      denom_units: [{
        denom: "factory/juno12klaltyqvg2j6v034jwdxrk5n4242ttse4sdpt/NEXX",
        exponent: 0
      }, {
        denom: "nexx",
        exponent: 6
      }],
      base: "factory/juno12klaltyqvg2j6v034jwdxrk5n4242ttse4sdpt/NEXX",
      name: "NEXX GEN AI",
      display: "nexx",
      symbol: "NEXX",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/junotestnet/images/nexx.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/junotestnet/images/nexx.png"
      }]
    },
    {
      type_asset: "sdk.coin",
      denom_units: [{
        denom: "factory/juno12dgadj3wwv5jn0ec7tw5cgvq526nn4gnt2tujlmd57p2ra6k87esl36r9k/ARENA",
        exponent: 0
      }, {
        denom: "arena",
        exponent: 6
      }],
      address: "juno12dgadj3wwv5jn0ec7tw5cgvq526nn4gnt2tujlmd57p2ra6k87esl36r9k",
      base: "factory/juno12dgadj3wwv5jn0ec7tw5cgvq526nn4gnt2tujlmd57p2ra6k87esl36r9k/ARENA",
      name: "Arena Token",
      description: "The token for the Arena DAO",
      display: "arena",
      symbol: "ARENA",
      traces: [{
        type: "test-mintage",
        counterparty: {
          chain_name: "juno",
          base_denom: "factory/juno1vwmnqk0vyxc96qgffrure4nqxupjrql0zut8s02hadgp0n79r8xq5xdsxy/ARENA"
        },
        provider: "Arena DAO"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/arena.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/arena.svg"
      },
      images: [{
        image_sync: {
          chain_name: "juno",
          base_denom: "factory/juno1vwmnqk0vyxc96qgffrure4nqxupjrql0zut8s02hadgp0n79r8xq5xdsxy/ARENA"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/arena.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/arena.png",
        theme: {
          primary_color_hex: "#dc6c24"
        }
      }]
    }
  ]
};
mk.default = ige;
var hk = {};
Object.defineProperty(hk, "__esModule", { value: !0 });
const cge = {
  $schema: "../../chain.schema.json",
  chain_name: "junotestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Juno Testnet",
  chain_type: "cosmos",
  chain_id: "uni-6",
  bech32_prefix: "juno",
  daemon_name: "junod",
  node_home: "$HOME/.juno",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ujunox",
      low_gas_price: 3e-3,
      average_gas_price: 45e-4,
      high_gas_price: 6e-3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ujunox"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.31"
  },
  apis: {
    rpc: [{
      address: "https://juno-testnet-rpc.polkachu.com",
      provider: "Polkachu"
    }],
    rest: [{
      address: "https://juno-testnet-api.polkachu.com",
      provider: "Polkachu"
    }, {
      address: "https://juno.api.t.stavr.tech",
      provider: "🔥STAVR🔥"
    }],
    grpc: [{
      address: "juno-testnet-grpc.polkachu.com:12690",
      provider: "Polkachu"
    }]
  },
  explorers: [{
    kind: "🔥STAVR🔥",
    url: "https://explorer.stavr.tech/Juno-Testnet",
    tx_page: "https://explorer.stavr.tech/Juno-Testnet/txs/${txHash}",
    account_page: "https://explorer.stavr.tech/Juno-Testnet/account/${accountAddress}"
  }]
};
hk.default = cge;
var pk = {};
Object.defineProperty(pk, "__esModule", { value: !0 });
const dge = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "junotestnet",
      client_id: "07-tendermint-170",
      connection_id: "connection-178"
    },
    chain_2: {
      chain_name: "noistestnet",
      client_id: "07-tendermint-16",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-877",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-69",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-198",
        port_id: "wasm.juno1pjpntyvkxeuxd709jlupuea3xzxlzsfq574kqefv77fr2kcg4mcqvwqedq"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "wasm.nois1xwde9rzqk5u36fke0r9ddmtwvh43n4fv53c5vc462wz8xlnqjhls6d90xc"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "junotestnet",
      client_id: "07-tendermint-743",
      connection_id: "connection-827"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1932",
      connection_id: "connection-1889"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-889",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5498",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "junotestnet",
      client_id: "07-tendermint-135",
      connection_id: "connection-151"
    },
    chain_2: {
      chain_name: "osmosistestnet4",
      client_id: "07-tendermint-4413",
      connection_id: "connection-3814"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-140",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3316",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "junotestnet",
      client_id: "07-tendermint-789",
      connection_id: "connection-868"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-28",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-943",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
pk.default = dge;
var lk = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Fa, "__esModule", { value: !0 });
Fa.ibc = Fa.chain = Fa.assets = void 0;
const mge = lk(mk), hge = lk(hk), pge = lk(pk);
Fa.assets = mge.default;
Fa.chain = hge.default;
Fa.ibc = pge.default;
var bi = {}, gk = {};
Object.defineProperty(gk, "__esModule", { value: !0 });
const lge = {
  $schema: "../../assetlist.schema.json",
  chain_name: "kichaintestnet",
  assets: [{
    description: "The native token of Ki Chain",
    denom_units: [{
      denom: "utki",
      exponent: 0
    }, {
      denom: "tki",
      exponent: 6
    }],
    base: "utki",
    name: "Ki",
    display: "tki",
    symbol: "TKI",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.svg"
    },
    coingecko_id: "ki",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kichain/images/xki.svg"
    }]
  }]
};
gk.default = lge;
var uk = {};
Object.defineProperty(uk, "__esModule", { value: !0 });
const gge = {
  $schema: "../../chain.schema.json",
  chain_name: "kichaintestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Ki",
  chain_type: "cosmos",
  chain_id: "kichain-t-4",
  bech32_prefix: "tki",
  daemon_name: "kid",
  node_home: "$HOME/.kid",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utki",
      fixed_min_gas_price: 0.025
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc-challenge.blockchain.ki/",
      provider: "kifoundation"
    }],
    rest: [{
      address: "https://api-challenge.blockchain.ki/",
      provider: "kifoundation"
    }]
  },
  explorers: [{
    kind: "kifoundation",
    url: "https://kichain-t-4.blockchain.ki/",
    tx_page: "https://kichain-t-4.blockchain.ki/transactions/${txHash}"
  }]
};
uk.default = gge;
var cC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(bi, "__esModule", { value: !0 });
bi.chain = bi.assets = void 0;
const uge = cC(gk), _ge = cC(uk);
bi.assets = uge.default;
bi.chain = _ge.default;
var $a = {}, _k = {};
Object.defineProperty(_k, "__esModule", { value: !0 });
const yge = {
  $schema: "../../assetlist.schema.json",
  chain_name: "kimatestnet",
  assets: [{
    description: "The native token of Kima Chain",
    denom_units: [{
      denom: "uKIMA",
      exponent: 0
    }, {
      denom: "KIMA",
      exponent: 6
    }],
    base: "uKIMA",
    name: "KIMA",
    display: "KIMA",
    symbol: "KIMA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/kimatestnet/images/kima.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/kimatestnet/images/kima.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/kimatestnet/images/kima.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/kimatestnet/images/kima.svg"
    }]
  }]
};
_k.default = yge;
var yk = {};
Object.defineProperty(yk, "__esModule", { value: !0 });
const bge = {
  $schema: "../../chain.schema.json",
  chain_name: "kimatestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Kima",
  chain_type: "cosmos",
  chain_id: "kima_testnet",
  bech32_prefix: "kima",
  daemon_name: "uKIMA",
  node_home: "$HOME/.kima",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uKIMA",
      fixed_min_gas_price: 0,
      low_gas_price: 25e-4,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc-testnet.kima.finance/",
      provider: "kima"
    }],
    rest: [{
      address: "https://api-testnet.kima.finance",
      provider: "kima"
    }]
  },
  explorers: [{
    kind: "kima",
    url: "https://explorer-testnet.kima.finance/",
    tx_page: "https://explorer-testnet.kima.finance/transactions/${txHash}"
  }]
};
yk.default = bge;
var bk = {};
Object.defineProperty(bk, "__esModule", { value: !0 });
const vge = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "kimatestnet",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-1",
    connection_id: "connection-3450"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-8867",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
bk.default = vge;
var vk = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty($a, "__esModule", { value: !0 });
$a.ibc = $a.chain = $a.assets = void 0;
const fge = vk(_k), wge = vk(yk), xge = vk(bk);
$a.assets = fge.default;
$a.chain = wge.default;
$a.ibc = xge.default;
var za = {}, fk = {};
Object.defineProperty(fk, "__esModule", { value: !0 });
const kge = {
  $schema: "../../assetlist.schema.json",
  chain_name: "kujiratestnet",
  assets: [{
    description: "The native staking and governance token of the Harpoon testnet version of Kujira.",
    denom_units: [{
      denom: "ukuji",
      exponent: 0
    }, {
      denom: "kuji",
      exponent: 6
    }],
    base: "ukuji",
    name: "Kuji",
    display: "kuji",
    symbol: "KUJI",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/kujiratestnet/images/kuji.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/kujiratestnet/images/kuji.png"
    }]
  }, {
    description: "The testnet token of Fuzion",
    denom_units: [{
      denom: "factory/kujira16qpvzhmawvsm8mcj4hdvtz25dadatdhhgw79xa/FUZN",
      exponent: 0
    }, {
      denom: "fuzn",
      exponent: 6
    }],
    base: "factory/kujira16qpvzhmawvsm8mcj4hdvtz25dadatdhhgw79xa/FUZN",
    name: "Fuzion",
    display: "fuzn",
    symbol: "FUZN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/kujiratestnet/images/fuzn.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/kujiratestnet/images/fuzn.png"
    }]
  }]
};
fk.default = kge;
var wk = {};
Object.defineProperty(wk, "__esModule", { value: !0 });
const Age = {
  $schema: "../../chain.schema.json",
  chain_name: "kujiratestnet",
  chain_type: "cosmos",
  chain_id: "harpoon-4",
  pretty_name: "Kujira Harpoon",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "kujira",
  daemon_name: "kujirad",
  node_home: "$HOME/.kujira",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ukuji",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://kujira-testnet-rpc.polkachu.com",
      provider: "polkachu"
    }],
    rest: [{
      address: "https://kujira-testnet-api.polkachu.com/",
      provider: "polkachu"
    }]
  },
  explorers: [{
    kind: "explorers.guru",
    url: "https://kujira.explorers.guru",
    tx_page: "https://kujira.explorers.guru/transaction/${txHash}"
  }]
};
wk.default = Age;
var xk = {};
Object.defineProperty(xk, "__esModule", { value: !0 });
const jge = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "cosmoshubtestnet",
    client_id: "7-tendermint-3407",
    connection_id: "connection-3519"
  },
  chain_2: {
    chain_name: "kujiratestnet",
    client_id: "07-tendermint-72",
    connection_id: "connection-47"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-4004",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-51",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "kujiratestnet",
    client_id: "07-tendermint-73",
    connection_id: "connection-48"
  },
  chain_2: {
    chain_name: "terra2testnet",
    client_id: "7-tendermint-568",
    connection_id: "connection-508"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-73",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-541",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
xk.default = jge;
var kk = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(za, "__esModule", { value: !0 });
za.ibc = za.chain = za.assets = void 0;
const Cge = kk(fk), Ege = kk(wk), Dge = kk(xk);
za.assets = Cge.default;
za.chain = Ege.default;
za.ibc = Dge.default;
var qa = {}, Ak = {};
Object.defineProperty(Ak, "__esModule", { value: !0 });
const Bge = {
  $schema: "../../assetlist.schema.json",
  chain_name: "kyvetestnet",
  assets: [{
    description: "The native utility token of the Kaon testnet version of KYVE.",
    denom_units: [{
      denom: "tkyve",
      exponent: 0
    }, {
      denom: "kyve",
      exponent: 6
    }],
    base: "tkyve",
    name: "KYVE",
    display: "kyve",
    symbol: "KYVE",
    traces: [{
      type: "test-mintage",
      counterparty: {
        chain_name: "kyve",
        base_denom: "ukyve"
      },
      provider: "Kyve"
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.svg",
      image_sync: {
        chain_name: "kyve",
        base_denom: "ukyve"
      },
      theme: {
        primary_color_hex: "#335350"
      }
    }]
  }]
};
Ak.default = Bge;
var jk = {};
Object.defineProperty(jk, "__esModule", { value: !0 });
const Fge = {
  $schema: "../../chain.schema.json",
  chain_name: "kyvetestnet",
  chain_type: "cosmos",
  chain_id: "kaon-1",
  pretty_name: "KYVE Kaon",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "kyve",
  daemon_name: "kyved",
  node_home: "$HOME/.kyve",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "tkyve",
      fixed_min_gas_price: 0.02,
      low_gas_price: 0.02,
      average_gas_price: 0.03,
      high_gas_price: 0.06
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "tkyve"
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://rpc-eu-1.kaon.kyve.network",
        provider: "kyve"
      },
      {
        address: "https://rpc-kyve-test.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://kyve-testnet-rpc.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ],
    rest: [
      {
        address: "https://api-eu-1.kaon.kyve.network",
        provider: "kyve"
      },
      {
        address: "https://rest-kyve-test.ecostake.com",
        provider: "ecostake"
      },
      {
        address: "https://kyve-testnet-api.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ]
  },
  explorers: [{
    kind: "mintscan",
    url: "https://mintscan.io/kyve-testnet",
    tx_page: "https://mintscan.io/kyve-testnet/txs/${txHash}",
    account_page: "https://mintscan.io/kyve-testnet/account/${accountAddress}"
  }]
};
jk.default = Fge;
var Ck = {};
Object.defineProperty(Ck, "__esModule", { value: !0 });
const $ge = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "kyvetestnet",
    client_id: "07-tendermint-2",
    connection_id: "connection-2"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-11",
    connection_id: "connection-11"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-10",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Ck.default = $ge;
var Ek = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(qa, "__esModule", { value: !0 });
qa.ibc = qa.chain = qa.assets = void 0;
const zge = Ek(Ak), qge = Ek(jk), Sge = Ek(Ck);
qa.assets = zge.default;
qa.chain = qge.default;
qa.ibc = Sge.default;
var Sa = {}, Dk = {};
Object.defineProperty(Dk, "__esModule", { value: !0 });
const Tge = {
  $schema: "../../assetlist.schema.json",
  chain_name: "lavatestnet",
  assets: [{
    description: "The native token of Lava",
    denom_units: [{
      denom: "ulava",
      exponent: 0
    }, {
      denom: "lava",
      exponent: 6
    }],
    base: "ulava",
    name: "LAVA",
    display: "lava",
    symbol: "LAVA",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.svg"
    },
    keywords: ["rpc", "api"],
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.svg"
    }]
  }]
};
Dk.default = Tge;
var Bk = {};
Object.defineProperty(Bk, "__esModule", { value: !0 });
const Rge = {
  $schema: "../../chain.schema.json",
  chain_name: "lavatestnet",
  status: "live",
  pre_fork_chain_name: "lavatestnet1",
  network_type: "testnet",
  website: "https://www.lavanet.xyz/",
  pretty_name: "Lava Testnet",
  chain_type: "cosmos",
  chain_id: "lava-testnet-2",
  bech32_prefix: "lava@",
  daemon_name: "lavad",
  node_home: "$HOME/.lava",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ulava",
      fixed_min_gas_price: 1e-6,
      low_gas_price: 1e-6,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ulava"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.47.7",
    cosmwasm_enabled: !1,
    cosmwasm_version: "0.30"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.png",
    theme: {
      primary_color_hex: "#D7001F"
    }
  }, {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.svg"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.png"
  },
  apis: {
    rpc: [
      {
        address: "https://lav1.tendermintrpc.lava.build:443",
        provider: "Lava"
      },
      {
        address: "http://lava.rpc.t.stavr.tech:198",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://lava-testnet-rpc.itrocket.net:443",
        provider: "🚀ITRocket🚀"
      },
      {
        address: "https://lava-testnet-rpc.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ],
    rest: [
      {
        address: "https://lav1.lava.build/",
        provider: "Lava"
      },
      {
        address: "https://lava.api.t.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://lava-testnet-api.itrocket.net",
        provider: "🚀ITRocket🚀"
      },
      {
        address: "https://lava-testnet-api.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ]
  },
  explorers: [
    {
      kind: "explorers.guru",
      url: "https://lava.explorers.guru/",
      tx_page: "https://lava.explorers.guru//transaction/${txHash}",
      account_page: "https://lava.explorers.guru//account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Lava-Testnet",
      tx_page: "https://explorer.stavr.tech/Lava-Testnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Lava-Testnet/account/${accountAddress}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.org/lava-testnet",
      tx_page: "https://explorer.nodestake.org/lava-testnet/tx/${txHash}",
      account_page: "https://explorer.nodestake.org/lava-testnet/account/${accountAddress}"
    },
    {
      kind: "🚀ITRocket🚀",
      url: "https://testnet.itrocket.net/lava",
      tx_page: "https://testnet.itrocket.net/lava/tx/${txHash}",
      account_page: "https://testnet.itrocket.net/lava/account/${accountAddress}"
    }
  ],
  keywords: [
    "rpc",
    "api",
    "modular",
    "data"
  ]
};
Bk.default = Rge;
var Fk = {};
Object.defineProperty(Fk, "__esModule", { value: !0 });
const Oge = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "axelartestnet",
    client_id: "07-tendermint-855",
    connection_id: "connection-659"
  },
  chain_2: {
    chain_name: "lavatestnet",
    client_id: "07-tendermint-10",
    connection_id: "connection-10"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-444",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-4",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "lavatestnet",
    client_id: "07-tendermint-11",
    connection_id: "connection-11"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-2554",
    connection_id: "connection-2401"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-5",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-6092",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
Fk.default = Oge;
var $k = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Sa, "__esModule", { value: !0 });
Sa.ibc = Sa.chain = Sa.assets = void 0;
const Mge = $k(Dk), Ige = $k(Bk), Nge = $k(Fk);
Sa.assets = Mge.default;
Sa.chain = Ige.default;
Sa.ibc = Nge.default;
var vi = {}, zk = {};
Object.defineProperty(zk, "__esModule", { value: !0 });
const Pge = {
  $schema: "../../assetlist.schema.json",
  chain_name: "lavatestnet1",
  assets: [{
    description: "The native token of Lava",
    denom_units: [{
      denom: "ulava",
      exponent: 0
    }, {
      denom: "lava",
      exponent: 6
    }],
    base: "ulava",
    name: "LAVA",
    display: "lava",
    symbol: "LAVA",
    logo_URIs: {
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.svg"
    },
    keywords: ["rpc", "api"],
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.svg"
    }]
  }]
};
zk.default = Pge;
var qk = {};
Object.defineProperty(qk, "__esModule", { value: !0 });
const Uge = {
  $schema: "../../chain.schema.json",
  chain_name: "lavatestnet1",
  status: "killed",
  network_type: "testnet",
  website: "https://www.lavanet.xyz/",
  pretty_name: "Lava",
  chain_type: "cosmos",
  chain_id: "lava-testnet-1",
  bech32_prefix: "lava@",
  daemon_name: "lavad",
  node_home: "$HOME/.lava",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ulava",
      fixed_min_gas_price: 25e-4,
      low_gas_price: 25e-4,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ulava"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !1,
    cosmwasm_version: "0.30"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.png",
    theme: {
      primary_color_hex: "#D7001F"
    }
  }, {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.svg"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lavatestnet/images/lava-icon.png"
  },
  apis: {
    rpc: [{
      address: "https://public-rpc-testnet2.lavanet.xyz/",
      provider: "Lava"
    }, {
      address: "http://lava.rpc.t.stavr.tech:198",
      provider: "🔥STAVR🔥"
    }],
    rest: [{
      address: "https://public-rpc-testnet2.lavanet.xyz/rest/",
      provider: "Lava"
    }, {
      address: "https://lava.api.t.stavr.tech",
      provider: "🔥STAVR🔥"
    }]
  },
  explorers: [
    {
      kind: "explorers.guru",
      url: "https://lava.explorers.guru/",
      tx_page: "https://lava.explorers.guru//transaction/${txHash}",
      account_page: "https://lava.explorers.guru//account/${accountAddress}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Lava-Testnet",
      tx_page: "https://explorer.stavr.tech/Lava-Testnet/tx/${txHash}",
      account_page: "https://explorer.stavr.tech/Lava-Testnet/account/${accountAddress}"
    },
    {
      kind: "NodeStake Explorer",
      url: "https://explorer.nodestake.org/lava-testnet",
      tx_page: "https://explorer.nodestake.org/lava-testnet/tx/${txHash}",
      account_page: "https://explorer.nodestake.org/lava-testnet/account/${accountAddress}"
    }
  ],
  keywords: ["rpc", "api"]
};
qk.default = Uge;
var dC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(vi, "__esModule", { value: !0 });
vi.chain = vi.assets = void 0;
const Hge = dC(zk), Lge = dC(qk);
vi.assets = Hge.default;
vi.chain = Lge.default;
var Ta = {}, Sk = {};
Object.defineProperty(Sk, "__esModule", { value: !0 });
const Wge = {
  $schema: "../../assetlist.schema.json",
  chain_name: "likecointestnet",
  assets: [{
    description: "EKIL is the native token for LikeCoin Testnet",
    denom_units: [{
      denom: "nanoekil",
      exponent: 0
    }, {
      denom: "ekil",
      exponent: 9
    }],
    base: "nanoekil",
    name: "LikeCoin",
    display: "ekil",
    symbol: "EKIL",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/like.svg"
    }]
  }]
};
Sk.default = Wge;
var Tk = {};
Object.defineProperty(Tk, "__esModule", { value: !0 });
const Vge = {
  $schema: "../../chain.schema.json",
  chain_name: "likecointestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "LikeCoin Testnet",
  chain_type: "cosmos",
  chain_id: "likecoin-public-testnet-5",
  bech32_prefix: "like",
  daemon_name: "liked",
  node_home: "$HOME/.liked",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "nanoekil",
      fixed_min_gas_price: 1e3,
      low_gas_price: 1e3,
      average_gas_price: 1e4,
      high_gas_price: 1e6
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "nanoekil"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.46",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [{
      address: "https://node.testnet.like.co/rpc/",
      provider: "like.co"
    }],
    rest: [{
      address: "https://node.testnet.like.co/",
      provider: "like.co"
    }],
    grpc: [{
      address: "https://node.testnet-grpc.like.co/",
      provider: "like.co"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://testnet.bigdipper.live/likecoin",
    tx_page: "https://testnet.bigdipper.live/likecoin/transactions/${txHash}",
    account_page: "https://testnet.bigdipper.live/likecoin/accounts/${accountAddress}"
  }, {
    kind: "lunie-ng",
    url: "https://likecoin-public-testnet-5.netlify.app/"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/likecoin-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/likecoin-chain-logo.svg"
  },
  keywords: [],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/likecoin-chain-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/likecoin/images/likecoin-chain-logo.svg"
  }]
};
Tk.default = Vge;
var Rk = {};
Object.defineProperty(Rk, "__esModule", { value: !0 });
const Gge = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "likecointestnet",
    client_id: "07-tendermint-5",
    connection_id: "connection-2"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-1431",
    connection_id: "connection-1336"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-4357",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Rk.default = Gge;
var Ok = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ta, "__esModule", { value: !0 });
Ta.ibc = Ta.chain = Ta.assets = void 0;
const Kge = Ok(Sk), Xge = Ok(Tk), Yge = Ok(Rk);
Ta.assets = Kge.default;
Ta.chain = Xge.default;
Ta.ibc = Yge.default;
var fi = {}, Mk = {};
Object.defineProperty(Mk, "__esModule", { value: !0 });
const Jge = {
  $schema: "../../assetlist.schema.json",
  chain_name: "lumenxtestnet",
  assets: [{
    description: "The native token of Lumen Network",
    denom_units: [{
      denom: "ulumen",
      exponent: 0
    }, {
      denom: "lumen",
      exponent: 6
    }],
    base: "ulumen",
    name: "LUMEN",
    display: "lumen",
    symbol: "LUMEN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lumenxtestnet/images/lumen.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lumenxtestnet/images/lumen.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lumenxtestnet/images/lumen.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/lumenxtestnet/images/lumen.svg"
    }]
  }]
};
Mk.default = Jge;
var Ik = {};
Object.defineProperty(Ik, "__esModule", { value: !0 });
const Zge = {
  $schema: "../../chain.schema.json",
  chain_name: "lumenxtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "LumenX-Test",
  chain_type: "cosmos",
  chain_id: "lumenx-test",
  bech32_prefix: "lumen",
  daemon_name: "lumenxd",
  node_home: "$HOME/.lumenx",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ulumen",
      fixed_min_gas_price: 25e-4,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ulumen"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://testnet-rpc.lumenx.chaintools.tech/",
      provider: "ChainTools"
    }, {
      address: "https://testrpc-lumenx.cryptonet.pl/",
      provider: "CryptoNet"
    }],
    rest: [{
      address: "https://testnet-api.lumenx.chaintools.tech/",
      provider: "ChainTools"
    }, {
      address: "https://testapi-lumenx.cryptonet.pl/",
      provider: "CryptoNet"
    }],
    grpc: []
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://testnet.explorer.chaintools.tech/lumenx",
    tx_page: "https://testnet.explorer.chaintools.tech/lumenx/tx/${txHash}"
  }]
};
Ik.default = Zge;
var mC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(fi, "__esModule", { value: !0 });
fi.chain = fi.assets = void 0;
const Qge = mC(Mk), eue = mC(Ik);
fi.assets = Qge.default;
fi.chain = eue.default;
var wi = {}, Nk = {};
Object.defineProperty(Nk, "__esModule", { value: !0 });
const nue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "manifesttestnet",
  assets: [{
    description: "Manifest testnet native token",
    denom_units: [{
      denom: "umfx",
      exponent: 0
    }, {
      denom: "mfx",
      exponent: 6
    }],
    base: "umfx",
    name: "Manifest Testnet Token",
    display: "mfx",
    symbol: "MFX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/manifest/images/manifest.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/manifest/images/manifest.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/manifest/images/manifest.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/manifest/images/manifest.svg"
    }]
  }, {
    description: "Proof of Authority token for the Manifest testnet",
    denom_units: [{
      denom: "upoa",
      exponent: 0
    }, {
      denom: "poa",
      exponent: 6
    }],
    base: "upoa",
    name: "Manifest Testnet Token",
    display: "poa",
    symbol: "POA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/manifest/images/manifest.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/manifest/images/manifest.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/manifest/images/manifest.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/manifest/images/manifest.svg"
    }]
  }]
};
Nk.default = nue;
var Pk = {};
Object.defineProperty(Pk, "__esModule", { value: !0 });
const tue = {
  $schema: "../../chain.schema.json",
  chain_name: "manifesttestnet",
  status: "live",
  network_type: "testnet",
  website: "https://liftedinit.org/",
  pretty_name: "Manifest Testnet",
  chain_id: "manifest-ledger-beta",
  chain_type: "cosmos",
  bech32_prefix: "manifest",
  daemon_name: "manifest",
  node_home: "$HOME/.manifest",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "umfx",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 0.01,
      average_gas_price: 7e-3,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "upoa"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://nodes.chandrastation.com/rpc/manifest/",
      provider: "Chandra Station"
    }, {
      address: "https://manifest-beta-rpc.liftedinit.tech/",
      provider: "Lifted Initiative"
    }],
    rest: [{
      address: "https://nodes.chandrastation.com/api/manifest/",
      provider: "Chandra Station"
    }, {
      address: "https://manifest-beta-rest.liftedinit.tech/",
      provider: "Lifted Initiative"
    }],
    grpc: [{
      address: "https://manifest-beta-grpc.liftedinit.tech/",
      provider: "Lifted Initiative"
    }]
  },
  explorers: [{
    kind: "Default Explorer",
    url: "https://manifest-explorer.vercel.app/",
    tx_page: "https://manifest-explorer.vercel.app/manifest/tx"
  }]
};
Pk.default = tue;
var hC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(wi, "__esModule", { value: !0 });
wi.chain = wi.assets = void 0;
const sue = hC(Nk), aue = hC(Pk);
wi.assets = sue.default;
wi.chain = aue.default;
var Ra = {}, Uk = {};
Object.defineProperty(Uk, "__esModule", { value: !0 });
const oue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "mantrachaintestnet",
  assets: [{
    description: "The native token of MANTRA",
    denom_units: [{
      denom: "uom",
      exponent: 0
    }, {
      denom: "om",
      exponent: 6
    }],
    base: "uom",
    name: "MANTRA Chain",
    display: "om",
    symbol: "OM",
    keywords: [
      "mantra",
      "staking",
      "delegating",
      "governance",
      "regulation",
      "defi"
    ],
    traces: [{
      type: "test-mintage",
      counterparty: {
        chain_name: "mantrachain",
        base_denom: "uom"
      },
      provider: "MANTRA Chain"
    }],
    images: [{
      image_sync: {
        chain_name: "mantrachain",
        base_denom: "uom"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-Prim-Col.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-Prim-Col.svg",
      theme: {
        circle: !0,
        primary_color_hex: "#fba0c1"
      }
    }]
  }]
};
Uk.default = oue;
var Hk = {};
Object.defineProperty(Hk, "__esModule", { value: !0 });
const rue = {
  $schema: "../../chain.schema.json",
  chain_name: "mantrachaintestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "MANTRA Hongbai Testnet",
  chain_type: "cosmos",
  chain_id: "mantra-hongbai-1",
  bech32_prefix: "mantra",
  daemon_name: "mantrachaind",
  node_home: "$HOME/.mantrachain",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uom",
      fixed_min_gas_price: 0,
      low_gas_price: 1e-3,
      average_gas_price: 2e-3,
      high_gas_price: 3e-3
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uom"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47.3",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.41"
  },
  apis: {
    rpc: [{
      address: "https://rpc.hongbai.mantrachain.io",
      provider: "MANTRACHAIN"
    }, {
      address: "https://mantra-testnet-rpc.publicnode.com:443",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }],
    rest: [{
      address: "https://api.hongbai.mantrachain.io",
      provider: "MANTRACHAIN"
    }, {
      address: "https://mantra-testnet-rest.publicnode.com",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }],
    grpc: [{
      address: "https://grpc.hongbai.mantrachain.io",
      provider: "MANTRACHAIN"
    }, {
      address: "mantra-testnet-grpc.publicnode.com:443",
      provider: "Allnodes ⚡️ Nodes & Staking"
    }]
  },
  keywords: ["dex", "testnet"],
  images: [{
    image_sync: {
      chain_name: "mantrachain",
      base_denom: "uom"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-Prim-Col.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-Prim-Col.svg",
    theme: {
      circle: !0,
      primary_color_hex: "#fba0c1"
    }
  }]
};
Hk.default = rue;
var Lk = {};
Object.defineProperty(Lk, "__esModule", { value: !0 });
const iue = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-1009",
      connection_id: "connection-783"
    },
    chain_2: {
      chain_name: "mantrachaintestnet",
      client_id: "07-tendermint-7",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-540",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "mantrachaintestnet",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-294",
      connection_id: "connection-247"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-209",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "mantrachaintestnet",
      client_id: "07-tendermint-5",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3930",
      connection_id: "connection-3411"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8734",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
Lk.default = iue;
var Wk = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ra, "__esModule", { value: !0 });
Ra.ibc = Ra.chain = Ra.assets = void 0;
const cue = Wk(Uk), due = Wk(Hk), mue = Wk(Lk);
Ra.assets = cue.default;
Ra.chain = due.default;
Ra.ibc = mue.default;
var Oa = {}, Vk = {};
Object.defineProperty(Vk, "__esModule", { value: !0 });
const hue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "marstestnet",
  assets: [{
    description: "The native token of Mars Protocol",
    denom_units: [{
      denom: "umars",
      exponent: 0
    }, {
      denom: "mars",
      exponent: 6
    }],
    base: "umars",
    name: "Mars",
    display: "mars",
    symbol: "MARS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.svg"
    }]
  }]
};
Vk.default = hue;
var Gk = {};
Object.defineProperty(Gk, "__esModule", { value: !0 });
const pue = {
  $schema: "../../chain.schema.json",
  chain_name: "marstestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Mars Hub Testnet",
  chain_type: "cosmos",
  chain_id: "ares-1",
  bech32_prefix: "mars",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "umars",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0.025
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "umars"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://testnet-rpc.marsprotocol.io/",
      provider: "Mars Protocol"
    }, {
      address: "https://rpc-mars.nodeist.net/",
      provider: "Nodeist"
    }],
    rest: [{
      address: "https://testnet-rest.marsprotocol.io/",
      provider: "Mars Protocol"
    }, {
      address: "https://api-mars.nodeist.net/",
      provider: "Nodeist"
    }]
  },
  explorers: [{
    kind: "Mars Protocol",
    url: "https://testnet-explorer.marsprotocol.io",
    tx_page: "https://testnet-explorer.marsprotocol.io/transactions/${txHash}"
  }, {
    kind: "Nodeist Explorer",
    url: "https://exp.nodeist.net/t-mars/",
    tx_page: "https://exp.nodeist.net/t-mars/transactions/${txHash}"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-icon.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-icon.svg"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-icon.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/mars/images/mars-icon.svg"
  }]
};
Gk.default = pue;
var Kk = {};
Object.defineProperty(Kk, "__esModule", { value: !0 });
const lue = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "marstestnet",
    client_id: "07-tendermint-33",
    connection_id: "connection-30"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-1933",
    connection_id: "connection-1890"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-28",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-5499",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}, {
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "marstestnet",
    client_id: "07-tendermint-3",
    connection_id: "connection-2"
  },
  chain_2: {
    chain_name: "osmosistestnet4",
    client_id: "07-tendermint-3419",
    connection_id: "connection-2887"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-2083",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
Kk.default = lue;
var Xk = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Oa, "__esModule", { value: !0 });
Oa.ibc = Oa.chain = Oa.assets = void 0;
const gue = Xk(Vk), uue = Xk(Gk), _ue = Xk(Kk);
Oa.assets = gue.default;
Oa.chain = uue.default;
Oa.ibc = _ue.default;
var xi = {}, Yk = {};
Object.defineProperty(Yk, "__esModule", { value: !0 });
const yue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "metanovaversetestnet",
  assets: [{
    description: "MetaNova Verse Native Token",
    denom_units: [{
      denom: "amnv",
      exponent: 0
    }, {
      denom: "mnv",
      exponent: 18
    }],
    base: "amnv",
    name: "MNV",
    display: "mnv",
    symbol: "MNV",
    type_asset: "sdk.coin",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/metanovaversetestnet/images/mnova.png"
    }],
    socials: {
      website: "https://metanovaverse.com/"
    }
  }]
};
Yk.default = yue;
var Jk = {};
Object.defineProperty(Jk, "__esModule", { value: !0 });
const bue = {
  $schema: "../../chain.schema.json",
  chain_name: "metanovaversetestnet",
  status: "live",
  network_type: "testnet",
  website: "https://metanovaverse.com/",
  pretty_name: "Mnova",
  chain_type: "cosmos",
  chain_id: "mnova_10096-1",
  bech32_prefix: "mnova",
  node_home: "$HOME/.mnovad",
  daemon_name: "mnovad",
  key_algos: ["ethsecp256k1"],
  staking: {
    staking_tokens: [{
      denom: "amnv"
    }]
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/metanovaversetestnet/images/mnova.png"
  }],
  slip44: 118
};
Jk.default = bue;
var pC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(xi, "__esModule", { value: !0 });
xi.chain = xi.assets = void 0;
const vue = pC(Yk), fue = pC(Jk);
xi.assets = vue.default;
xi.chain = fue.default;
var ki = {}, Zk = {};
Object.defineProperty(Zk, "__esModule", { value: !0 });
const wue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "migalootestnet",
  assets: [{
    description: "The native token of Migaloo Chain",
    denom_units: [{
      denom: "uwhale",
      exponent: 0
    }, {
      denom: "whale",
      exponent: 6
    }],
    base: "uwhale",
    name: "Whale",
    display: "whale",
    symbol: "WHALE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/white-whale.svg"
    }]
  }]
};
Zk.default = wue;
var Qk = {};
Object.defineProperty(Qk, "__esModule", { value: !0 });
const xue = {
  $schema: "../../chain.schema.json",
  chain_name: "migalootestnet",
  status: "live",
  network_type: "testnet",
  website: "https://www.whitewhale.money/",
  pretty_name: "Migaloo Testnet",
  chain_type: "cosmos",
  chain_id: "narwhal-2",
  bech32_prefix: "migaloo",
  daemon_name: "migalood",
  node_home: "$HOME/.migalood",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uwhale",
      fixed_min_gas_price: 0.25,
      low_gas_price: 0.25,
      average_gas_price: 0.5,
      high_gas_price: 0.75
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uwhale"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/migaloo-light.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/migaloo-light.svg"
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.28"
  },
  apis: {
    rpc: [{
      address: "https://migaloo-testnet-rpc.polkachu.com",
      provider: "Polkachu"
    }],
    rest: [{
      address: "https://migaloo-testnet-api.polkachu.com",
      provider: "Polkachu"
    }],
    grpc: []
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://ping.pfc.zone/narwhal-testnet",
    tx_page: "https://ping.pfc.zone/narwhal-testnet/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/migaloo-light.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/migaloo/images/migaloo-light.svg"
  }]
};
Qk.default = xue;
var lC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ki, "__esModule", { value: !0 });
ki.chain = ki.assets = void 0;
const kue = lC(Zk), Aue = lC(Qk);
ki.assets = kue.default;
ki.chain = Aue.default;
var Ai = {}, e3 = {};
Object.defineProperty(e3, "__esModule", { value: !0 });
const jue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "neuratestnet",
  assets: [{
    description: "ANKR: The native EVM, governance, and staking token for Neura, enabling secure transactions, and seamless GPU resourcing within the ecosystem.",
    denom_units: [{
      denom: "atankr",
      exponent: 0
    }, {
      denom: "ankr",
      exponent: 18
    }],
    base: "atankr",
    name: "Neura Testnet",
    display: "ankr",
    symbol: "ANKR",
    traces: [{
      type: "test-mintage",
      counterparty: {
        chain_name: "neura",
        base_denom: "atankr"
      },
      provider: "Neura"
    }],
    images: [{
      image_sync: {
        chain_name: "neura",
        base_denom: "atankr"
      },
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/ankr.svg"
    }]
  }]
};
e3.default = jue;
var n3 = {};
Object.defineProperty(n3, "__esModule", { value: !0 });
const Cue = {
  $schema: "../../chain.schema.json",
  chain_name: "neuratestnet",
  chain_type: "cosmos",
  chain_id: "neura_267-1",
  bech32_prefix: "neura",
  pretty_name: "Neura Testnet",
  website: "https://www.neuraprotocol.io/",
  description: "Neura is an AI-centric, EVM-compatible Layer 1 blockchain built on the Cosmos SDK. We democratize GPU access and revolutionize AI project funding with IMO’s to advance AI development.",
  status: "live",
  network_type: "testnet",
  node_home: "$HOME/.neurad",
  daemon_name: "neurad",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 1,
  fees: {
    fee_tokens: [{
      denom: "atankr"
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "atankr"
    }]
  },
  apis: {
    rpc: [{
      address: "https://rpc.ankr.com/neura_testnet",
      provider: "ankr"
    }]
  },
  explorers: [{
    kind: "ankrscan-neura",
    url: "https://testnet.explorer.neuraprotocol.io",
    tx_page: "https://testnet.explorer.neuraprotocol.io/tx/${txHash}"
  }, {
    kind: "blockscout",
    url: "https://explorer.neura-testnet.ankr.com",
    tx_page: "https://explorer.neura-testnet.ankr.com/tx/${txHash}"
  }],
  codebase: {},
  images: [{
    image_sync: {
      chain_name: "neura"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neura/images/neura.png",
    theme: {
      primary_color_hex: "#4e5afc"
    }
  }]
};
n3.default = Cue;
var gC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ai, "__esModule", { value: !0 });
Ai.chain = Ai.assets = void 0;
const Eue = gC(e3), Due = gC(n3);
Ai.assets = Eue.default;
Ai.chain = Due.default;
var Ma = {}, t3 = {};
Object.defineProperty(t3, "__esModule", { value: !0 });
const Bue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "neutrontestnet",
  assets: [{
    description: "The native token of Neutron chain",
    denom_units: [{
      denom: "untrn",
      exponent: 0
    }, {
      denom: "ntrn",
      exponent: 6
    }],
    base: "untrn",
    name: "Neutron Testnet",
    display: "ntrn",
    symbol: "NTRN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/ntrn.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/ntrn.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/ntrn.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/ntrn.svg"
    }]
  }, {
    description: "The yield token for ATOM denominated vaults on Amulet Protocol",
    denom_units: [{
      denom: "factory/neutron15lku24mqhvy4v4gryrqs4662n9v9q4ux9tayn89cmdzldjcgawushxvm76/amatom",
      exponent: 0
    }, {
      denom: "amATOM",
      exponent: 6
    }],
    base: "factory/neutron15lku24mqhvy4v4gryrqs4662n9v9q4ux9tayn89cmdzldjcgawushxvm76/amatom",
    name: "amATOM (Testnet)",
    display: "amATOM",
    symbol: "amATOM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/amATOM.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/amATOM.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/amATOM.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/amATOM.svg"
    }]
  }]
};
t3.default = Bue;
var s3 = {};
Object.defineProperty(s3, "__esModule", { value: !0 });
const Fue = {
  $schema: "../../chain.schema.json",
  chain_name: "neutrontestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Neutron Testnet",
  chain_type: "cosmos",
  chain_id: "pion-1",
  bech32_prefix: "neutron",
  daemon_name: "neutrond",
  node_home: "$HOME/.neutrond",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "untrn",
      low_gas_price: 53e-4,
      average_gas_price: 53e-4,
      high_gas_price: 53e-4
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.50",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.51"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/neutron-black-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/neutron-black-logo.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc-falcron.pion-1.ntrn.tech",
      provider: "Neutron"
    }, {
      address: "https://neutron-testnet-rpc.polkachu.com/",
      provider: "Polkachu"
    }],
    rest: [
      {
        address: "https://rest-falcron.pion-1.ntrn.tech",
        provider: "Neutron"
      },
      {
        address: "https://api.pion.remedy.tm.p2p.org",
        provider: "P2P.ORG"
      },
      {
        address: "https://rest.baryon-sentry-01.rs-testnet.polypore.xyz",
        provider: "Hypha"
      }
    ],
    grpc: [{
      address: "grpc-falcron.pion-1.ntrn.tech:80",
      provider: "Neutron"
    }, {
      address: "grpc.baryon.remedy.tm.p2p.org:443",
      provider: "P2P.ORG"
    }]
  },
  explorers: [{
    kind: "Ping.pub Explorer from Hypha",
    url: "https://explorer.rs-testnet.polypore.xyz/pion-1",
    tx_page: "https://explorer.rs-testnet.polypore.xyz/pion-1/tx/${txHash}",
    account_page: "https://explorer.rs-testnet.polypore.xyz/baryon-1/account/${accountAddress}"
  }, {
    kind: "Mintscan",
    url: "https://mintscan.io/neutron-testnet",
    tx_page: "https://mintscan.io/neutron-testnet/txs/${txHash}",
    account_page: "https://mintscan.io/neutron-testnet/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/neutron-black-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/neutron-black-logo.svg"
  }]
};
s3.default = Fue;
var a3 = {};
Object.defineProperty(a3, "__esModule", { value: !0 });
const $ue = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutrontestnet",
      client_id: "07-tendermint-102",
      connection_id: "connection-93"
    },
    chain_2: {
      chain_name: "noistestnet",
      client_id: "07-tendermint-30",
      connection_id: "connection-17"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-133",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-40",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-135",
        port_id: "wasm.neutron1tw9sg9e4l09l5rjglf4qfvcft470ljk5grdq3luagysyk83nzfusw2sxgq"
      },
      chain_2: {
        channel_id: "channel-42",
        port_id: "wasm.nois1xwde9rzqk5u36fke0r9ddmtwvh43n4fv53c5vc462wz8xlnqjhls6d90xc"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutrontestnet",
      client_id: "07-tendermint-143",
      connection_id: "connection-130"
    },
    chain_2: {
      chain_name: "nolustestnet",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-208",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1990",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutrontestnet",
      client_id: "07-tendermint-133",
      connection_id: "connection-123"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1272",
      connection_id: "connection-1172"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-196",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4172",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
a3.default = $ue;
var o3 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ma, "__esModule", { value: !0 });
Ma.ibc = Ma.chain = Ma.assets = void 0;
const zue = o3(t3), que = o3(s3), Sue = o3(a3);
Ma.assets = zue.default;
Ma.chain = que.default;
Ma.ibc = Sue.default;
var ji = {}, r3 = {};
Object.defineProperty(r3, "__esModule", { value: !0 });
const Tue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "nibirutestnet",
  assets: [{
    description: "The native token of Nibiru network",
    extended_description: "Nibiru hosts a variety of ecosystem partners in a wide variety of consumer sectors. From RWAs (Coded Estate) to DeFi (Constella, NOM) to Gaming (Blockchain Game Alliance, IntoTheVerse), Nibiru is advancing multiple emerging blockchain narratives that will onboard the next billion users.",
    socials: {
      website: "https://nibiru.fi",
      twitter: "https://twitter.com/nibiruchain"
    },
    denom_units: [
      {
        denom: "unibi",
        exponent: 0
      },
      {
        denom: "nibi",
        exponent: 6
      },
      {
        denom: "attonibi",
        exponent: 18
      }
    ],
    base: "unibi",
    name: "Nibiru",
    display: "nibi",
    symbol: "NIBI",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg",
      theme: {
        primary_color_hex: "#14c0ce"
      }
    }]
  }]
};
r3.default = Tue;
var i3 = {};
Object.defineProperty(i3, "__esModule", { value: !0 });
const Rue = {
  $schema: "../../chain.schema.json",
  chain_name: "nibirutestnet",
  status: "live",
  network_type: "testnet",
  website: "https://nibiru.fi/",
  pretty_name: "Nibiru",
  chain_type: "cosmos",
  chain_id: "nibiru-testnet-1",
  bech32_prefix: "nibi",
  daemon_name: "nibid",
  node_home: "$HOME/.nibid",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "unibi",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.05,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unibi"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.47.7",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.44.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg"
  },
  description: "A Web3 hub ushering in the next era of money",
  apis: {
    wss: [{
      address: "wss://rpc.testnet-1.nibiru.fi/websocket",
      provider: "Nibiru Foundation"
    }],
    rpc: [{
      address: "https://rpc.testnet-1.nibiru.fi",
      provider: "Nibiru Foundation"
    }],
    rest: [{
      address: "https://lcd.testnet-1.nibiru.fi",
      provider: "Nibiru Foundation"
    }],
    grpc: [{
      address: "grpc.testnet-1.nibiru.fi:443",
      provider: "Nibiru Foundation"
    }]
  },
  explorers: [{
    kind: "Nibiru Foundation",
    url: "https://explorer.nibiru.fi/nibiru-testnet-1",
    tx_page: "https://explorer.nibiru.fi/nibiru-tesnet-1/tx/${txHash}",
    account_page: "https://explorer.nibiru.fi/nibiru-testnet-1/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg"
  }]
};
i3.default = Rue;
var uC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ji, "__esModule", { value: !0 });
ji.chain = ji.assets = void 0;
const Oue = uC(r3), Mue = uC(i3);
ji.assets = Oue.default;
ji.chain = Mue.default;
var Ci = {}, c3 = {};
Object.defineProperty(c3, "__esModule", { value: !0 });
const Iue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "nibirutestnet2",
  assets: [{
    description: "The native token of Nibiru network",
    extended_description: "Nibiru hosts a variety of ecosystem partners in a wide variety of consumer sectors. From RWAs (Coded Estate) to DeFi (Constella, NOM) to Gaming (Blockchain Game Alliance, IntoTheVerse), Nibiru is advancing multiple emerging blockchain narratives that will onboard the next billion users.",
    socials: {
      website: "https://nibiru.fi",
      twitter: "https://twitter.com/nibiruchain"
    },
    denom_units: [
      {
        denom: "unibi",
        exponent: 0
      },
      {
        denom: "nibi",
        exponent: 6
      },
      {
        denom: "attonibi",
        exponent: 18
      }
    ],
    base: "unibi",
    name: "Nibiru",
    display: "nibi",
    symbol: "NIBI",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg",
      theme: {
        primary_color_hex: "#14c0ce"
      }
    }]
  }]
};
c3.default = Iue;
var d3 = {};
Object.defineProperty(d3, "__esModule", { value: !0 });
const Nue = {
  $schema: "../../chain.schema.json",
  chain_name: "nibirutestnet2",
  status: "live",
  network_type: "testnet",
  website: "https://nibiru.fi/",
  pretty_name: "Nibiru",
  chain_type: "cosmos",
  chain_id: "nibiru-testnet-2",
  bech32_prefix: "nibi",
  daemon_name: "nibid",
  node_home: "$HOME/.nibid",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "unibi",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.05,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unibi"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.47.7",
    cosmwasm_enabled: !0,
    cosmwasm_version: "v0.44.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg"
  },
  description: "A Web3 hub ushering in the next era of money",
  apis: {
    wss: [{
      address: "wss://rpc.testnet-2.nibiru.fi/websocket",
      provider: "Nibiru Foundation"
    }],
    rpc: [{
      address: "https://rpc.testnet-2.nibiru.fi",
      provider: "Nibiru Foundation"
    }],
    rest: [{
      address: "https://lcd.testnet-2.nibiru.fi",
      provider: "Nibiru Foundation"
    }],
    grpc: [{
      address: "grpc.testnet-2.nibiru.fi:443",
      provider: "Nibiru Foundation"
    }]
  },
  explorers: [{
    kind: "Nibiru Foundation",
    url: "https://explorer.nibiru.fi/nibiru-testnet-2",
    tx_page: "https://explorer.nibiru.fi/nibiru-tesnet-2/tx/${txHash}",
    account_page: "https://explorer.nibiru.fi/nibiru-testnet-2/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nibiru/images/nibiru.svg"
  }]
};
d3.default = Nue;
var _C = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ci, "__esModule", { value: !0 });
Ci.chain = Ci.assets = void 0;
const Pue = _C(c3), Uue = _C(d3);
Ci.assets = Pue.default;
Ci.chain = Uue.default;
var Ei = {}, m3 = {};
Object.defineProperty(m3, "__esModule", { value: !0 });
const Hue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "nilliontestnet",
  assets: [{
    description: "NIL - the native token of Nillion",
    denom_units: [{
      denom: "unil",
      exponent: 0
    }, {
      denom: "nil",
      exponent: 6
    }],
    base: "unil",
    name: "Nillion",
    display: "nil",
    symbol: "NIL",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nilliontestnet/images/nil.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nilliontestnet/images/nil.svg"
    }]
  }]
};
m3.default = Hue;
var h3 = {};
Object.defineProperty(h3, "__esModule", { value: !0 });
const Lue = {
  $schema: "../../chain.schema.json",
  chain_name: "nilliontestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Nillion Testnet",
  chain_type: "cosmos",
  chain_id: "nillion-chain-testnet-1",
  bech32_prefix: "nillion",
  daemon_name: "nilchaind",
  node_home: "$HOME/.nillionapp",
  key_algos: ["ed25519"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "unil",
      low_gas_price: 1e-4,
      average_gas_price: 1e-4,
      high_gas_price: 25e-5
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unil"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.50.6",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [{
      address: "https://nillion-testnet-rpc.polkachu.com/",
      provider: "polkachu"
    }, {
      address: "https://testnet-nillion-rpc.lavenderfive.com",
      provider: "lavenderfive"
    }],
    rest: [{
      address: "https://nillion-testnet-api.polkachu.com/",
      provider: "polkachu"
    }, {
      address: "https://testnet-nillion-api.lavenderfive.com",
      provider: "lavenderfive"
    }],
    grpc: [{
      address: "https://testnet-nillion-grpc.lavenderfive.com",
      provider: "lavenderfive"
    }]
  },
  explorers: [{
    url: "https://testnet.nillion.explorers.guru",
    tx_page: "https://testnet.nillion.explorers.guru/transaction/${txHash}",
    account_page: "https://testnet.nillion.explorers.guru/account/${accountAddress}"
  }],
  images: [{
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nilliontestnet/images/nil.svg",
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nilliontestnet/images/nil.png"
  }]
};
h3.default = Lue;
var yC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ei, "__esModule", { value: !0 });
Ei.chain = Ei.assets = void 0;
const Wue = yC(m3), Vue = yC(h3);
Ei.assets = Wue.default;
Ei.chain = Vue.default;
var Ia = {}, p3 = {};
Object.defineProperty(p3, "__esModule", { value: !0 });
const Gue = {
  $schema: "../../assetlist.schema.json",
  chain_name: "nobletestnet",
  assets: [
    {
      description: "The controlled staking asset for Noble Chain",
      denom_units: [{
        denom: "ustake",
        exponent: 0,
        aliases: ["microstake"]
      }, {
        denom: "stake",
        exponent: 6
      }],
      base: "ustake",
      name: "Stake",
      display: "stake",
      symbol: "STAKE"
    },
    {
      description: "Love is a test tokenfactory asset controlled by the Strangelove Team",
      denom_units: [{
        denom: "ulove",
        exponent: 0,
        aliases: ["microlove"]
      }, {
        denom: "love",
        exponent: 6
      }],
      base: "ulove",
      display: "love",
      name: "Love",
      symbol: "LOVE"
    },
    {
      description: "USD Coin",
      denom_units: [{
        denom: "uusdc",
        exponent: 0,
        aliases: ["microusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      base: "uusdc",
      display: "usdc",
      name: "USD Coin",
      symbol: "USDC",
      traces: [{
        type: "test-mintage",
        counterparty: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        provider: "Circle"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "noble",
          base_denom: "uusdc"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "Ondo US Dollar Yield",
      denom_units: [{
        denom: "ausdy",
        exponent: 0,
        aliases: ["attousdy"]
      }, {
        denom: "usdy",
        exponent: 18
      }],
      base: "ausdy",
      display: "usdy",
      name: "Ondo US Dollar Yield",
      symbol: "USDY",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nobletestnet/images/usdy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nobletestnet/images/usdy.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nobletestnet/images/usdy.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nobletestnet/images/usdy.svg"
      }]
    }
  ]
};
p3.default = Gue;
var l3 = {};
Object.defineProperty(l3, "__esModule", { value: !0 });
const Kue = {
  $schema: "../../chain.schema.json",
  chain_name: "nobletestnet",
  chain_type: "cosmos",
  chain_id: "grand-1",
  website: "https://nobleassets.xyz/",
  pretty_name: "Noble",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "noble",
  daemon_name: "nobled",
  node_home: "$HOME/.nobled",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uusdc",
      fixed_min_gas_price: 0,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ustake"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "v0.45",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [{
      address: "https://noble-testnet-rpc.polkachu.com",
      provider: "polkachu"
    }, {
      address: "https://rpc.testnet.noble.strange.love:443",
      provider: "strangelove"
    }],
    rest: [{
      address: "https://noble-testnet-api.polkachu.com",
      provider: "polkachu"
    }, {
      address: "https://api.testnet.noble.strange.love",
      provider: "strangelove"
    }],
    grpc: [{
      address: "noble-testnet-grpc.polkachu.com:21590",
      provider: "polkachu"
    }]
  },
  explorers: [{
    kind: "mintscan",
    url: "https://mintscan.io/noble-testnet",
    tx_page: "https://mintscan.io/noble-testnet/txs/${txHash}"
  }, {
    kind: "ping.pub",
    url: "https://explore.strange.love/grand-1",
    tx_page: "https://explore.strange.love/grand-1/tx/${txHash}"
  }]
};
l3.default = Kue;
var g3 = {};
Object.defineProperty(g3, "__esModule", { value: !0 });
const Xue = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "elystestnet",
      client_id: "07-tendermint-9",
      connection_id: "connection-12"
    },
    chain_2: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-28",
      connection_id: "connection-26"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-19",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "mantrachaintestnet",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-294",
      connection_id: "connection-247"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-209",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-42",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1374",
      connection_id: "connection-1275"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4280",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "osmosistestnet4",
      client_id: "07-tendermint-4504",
      connection_id: "connection-3905"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3651",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-44",
      connection_id: "connection-32"
    },
    chain_2: {
      chain_name: "seitestnet2",
      client_id: "07-tendermint-127",
      connection_id: "connection-107"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-23",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-75",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-293",
      connection_id: "connection-246"
    },
    chain_2: {
      chain_name: "titantestnet",
      client_id: "07-tendermint-9",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-208",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-224",
      connection_id: "connection-176"
    },
    chain_2: {
      chain_name: "xiontestnet",
      client_id: "07-tendermint-120",
      connection_id: "connection-56"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-147",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-489",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
g3.default = Xue;
var u3 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ia, "__esModule", { value: !0 });
Ia.ibc = Ia.chain = Ia.assets = void 0;
const Yue = u3(p3), Jue = u3(l3), Zue = u3(g3);
Ia.assets = Yue.default;
Ia.chain = Jue.default;
Ia.ibc = Zue.default;
var Na = {}, _3 = {};
Object.defineProperty(_3, "__esModule", { value: !0 });
const Que = {
  $schema: "../../assetlist.schema.json",
  chain_name: "noistestnet",
  assets: [{
    description: "The native token of Nois",
    denom_units: [{
      denom: "unois",
      exponent: 0
    }, {
      denom: "nois",
      exponent: 6
    }],
    base: "unois",
    name: "Nois",
    display: "nois",
    symbol: "NOIS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.svg"
    },
    keywords: [
      "nois",
      "randomness",
      "drand",
      "wasm"
    ],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.svg"
    }]
  }]
};
_3.default = Que;
var y3 = {};
Object.defineProperty(y3, "__esModule", { value: !0 });
const e_e = {
  $schema: "../../chain.schema.json",
  chain_name: "noistestnet",
  status: "live",
  network_type: "testnet",
  website: "https://nois.network",
  pretty_name: "Nois",
  chain_type: "cosmos",
  chain_id: "nois-testnet-005",
  bech32_prefix: "nois",
  daemon_name: "noisd",
  node_home: "$HOME/.noisd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "unois",
      fixed_min_gas_price: 0,
      low_gas_price: 0.05,
      average_gas_price: 0.05,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unois"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png",
    theme: {
      primary_color_hex: "#0C0914"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nois/images/nois.png"
  },
  apis: {
    rpc: [
      {
        address: "https://nois-testnet-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://nois-testnet-rpc.itrocket.net:443",
        provider: "itrocket"
      },
      {
        address: "https://rpc.nois.mcbnode.online:443",
        provider: "mcbnode"
      },
      {
        address: "https://nois-testnet.rpc.kjnodes.com:443",
        provider: "kjnodes"
      },
      {
        address: "https://tnois-rpc.systemd.run:443",
        provider: "systemd"
      }
    ],
    grpc: [
      {
        address: "tnois-grpc.systemd.run:443",
        provider: "systemd"
      },
      {
        address: "http://nois.grpc.t.stavr.tech:191",
        provider: "🔥STAVR🔥"
      },
      {
        address: "nois-testnet-grpc.itrocket.net:21090",
        provider: "itrocket"
      }
    ],
    rest: [
      {
        address: "https://api.nois.mcbnode.online",
        provider: "mcbnode"
      },
      {
        address: "https://nois3.api.t.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://tnois-api.systemd.run:443",
        provider: "systemd"
      }
    ]
  },
  explorers: [{
    kind: "🔥STAVR🔥",
    url: "https://explorer.stavr.tech/Nois-Testnet",
    tx_page: "https://explorer.stavr.tech/Nois-Testnet/tx/${txHash}",
    account_page: "https://explorer.stavr.tech/Nois-Testnet/account/${accountAddress}"
  }, {
    kind: "explorers.guru",
    url: "https://testnet.nois.explorers.guru",
    tx_page: "https://testnet.nois.explorers.guru/transaction/${txHash}",
    account_page: "https://testnet.nois.explorers.guru/account/${accountAddress}"
  }],
  keywords: [
    "nois",
    "randomness",
    "drand",
    "wasm"
  ]
};
y3.default = e_e;
var b3 = {};
Object.defineProperty(b3, "__esModule", { value: !0 });
const n_e = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "injectivetestnet",
      client_id: "07-tendermint-123",
      connection_id: "connection-98"
    },
    chain_2: {
      chain_name: "noistestnet",
      client_id: "07-tendermint-26",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-74",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-33",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-77",
        port_id: "wasm.inj14nendtsz0c40n7xtzwkjmdc8dkuz835jdydxhn"
      },
      chain_2: {
        channel_id: "channel-36",
        port_id: "wasm.nois1xwde9rzqk5u36fke0r9ddmtwvh43n4fv53c5vc462wz8xlnqjhls6d90xc"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "junotestnet",
      client_id: "07-tendermint-170",
      connection_id: "connection-178"
    },
    chain_2: {
      chain_name: "noistestnet",
      client_id: "07-tendermint-16",
      connection_id: "connection-5"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-877",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-69",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-198",
        port_id: "wasm.juno1pjpntyvkxeuxd709jlupuea3xzxlzsfq574kqefv77fr2kcg4mcqvwqedq"
      },
      chain_2: {
        channel_id: "channel-17",
        port_id: "wasm.nois1xwde9rzqk5u36fke0r9ddmtwvh43n4fv53c5vc462wz8xlnqjhls6d90xc"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutrontestnet",
      client_id: "07-tendermint-102",
      connection_id: "connection-93"
    },
    chain_2: {
      chain_name: "noistestnet",
      client_id: "07-tendermint-30",
      connection_id: "connection-17"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-133",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-40",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-135",
        port_id: "wasm.neutron1tw9sg9e4l09l5rjglf4qfvcft470ljk5grdq3luagysyk83nzfusw2sxgq"
      },
      chain_2: {
        channel_id: "channel-42",
        port_id: "wasm.nois1xwde9rzqk5u36fke0r9ddmtwvh43n4fv53c5vc462wz8xlnqjhls6d90xc"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "noistestnet",
      client_id: "07-tendermint-39",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "stargazetestnet",
      client_id: "07-tendermint-483",
      connection_id: "connection-500"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-48",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-485",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-49",
        port_id: "wasm.nois1xwde9rzqk5u36fke0r9ddmtwvh43n4fv53c5vc462wz8xlnqjhls6d90xc"
      },
      chain_2: {
        channel_id: "channel-486",
        port_id: "wasm.stars1h99p7u2tvz79jppjwdddmkplvcpnsh0pmatl7dqkmdhnkgx59y2q6s0x9s"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  }
];
b3.default = n_e;
var v3 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Na, "__esModule", { value: !0 });
Na.ibc = Na.chain = Na.assets = void 0;
const t_e = v3(_3), s_e = v3(y3), a_e = v3(b3);
Na.assets = t_e.default;
Na.chain = s_e.default;
Na.ibc = a_e.default;
var Pa = {}, f3 = {};
Object.defineProperty(f3, "__esModule", { value: !0 });
const o_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "nolustestnet",
  assets: [{
    description: "The native token of Nolus chain",
    denom_units: [{
      denom: "unls",
      exponent: 0
    }, {
      denom: "nls",
      exponent: 6
    }],
    base: "unls",
    name: "Nolus",
    display: "nls",
    symbol: "NLS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nolustestnet/images/nolus.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nolustestnet/images/nolus.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nolustestnet/images/nolus.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nolustestnet/images/nolus.svg"
    }]
  }]
};
f3.default = o_e;
var w3 = {};
Object.defineProperty(w3, "__esModule", { value: !0 });
const r_e = {
  $schema: "../../chain.schema.json",
  chain_name: "nolustestnet",
  status: "live",
  website: "https://nolus.io/",
  network_type: "testnet",
  pretty_name: "Nolus Testnet",
  chain_type: "cosmos",
  chain_id: "rila-1",
  bech32_prefix: "nolus",
  daemon_name: "nolusd",
  node_home: "$HOME/.nolusd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "unls",
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.05
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unls"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.31"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nolustestnet/images/nolus.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nolustestnet/images/nolus.svg"
  },
  apis: {
    rpc: [{
      address: "https://rila-cl.nolus.network:26657",
      provider: "NolusProtocol"
    }],
    rest: [{
      address: "https://rila-cl.nolus.network:1317",
      provider: "NolusProtocol"
    }],
    grpc: [{
      address: "https://rila-cl.nolus.network:9090",
      provider: "NolusProtocol"
    }]
  },
  explorers: [{
    kind: "Nolus Explorer",
    url: "https://explorer-rila.nolus.io/rila-1/",
    tx_page: "https://explorer-rila.nolus.io/rila-1/tx/${txHash}",
    account_page: "https://explorer-rila.nolus.io/rila-1/account/${accountAddress}"
  }],
  keywords: ["testnet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nolustestnet/images/nolus.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/nolustestnet/images/nolus.svg"
  }]
};
w3.default = r_e;
var x3 = {};
Object.defineProperty(x3, "__esModule", { value: !0 });
const i_e = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "neutrontestnet",
    client_id: "07-tendermint-143",
    connection_id: "connection-130"
  },
  chain_2: {
    chain_name: "nolustestnet",
    client_id: "07-tendermint-2",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-208",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1990",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live"
    }
  }]
}, {
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "nolustestnet",
    client_id: "07-tendermint-0",
    connection_id: "connection-0"
  },
  chain_2: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-102",
    connection_id: "connection-120"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-0",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-110",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
x3.default = i_e;
var k3 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Pa, "__esModule", { value: !0 });
Pa.ibc = Pa.chain = Pa.assets = void 0;
const c_e = k3(f3), d_e = k3(w3), m_e = k3(x3);
Pa.assets = c_e.default;
Pa.chain = d_e.default;
Pa.ibc = m_e.default;
var Di = {}, A3 = {};
Object.defineProperty(A3, "__esModule", { value: !0 });
const h_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "nomictestnet",
  assets: [{
    description: "Nomic's native token.",
    denom_units: [{
      denom: "unom",
      exponent: 0
    }, {
      denom: "nom",
      exponent: 6
    }],
    base: "unom",
    name: "Nomic",
    display: "nom",
    symbol: "NOM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg"
    },
    traces: [{
      type: "test-mintage",
      counterparty: {
        chain_name: "nomic",
        base_denom: "unom"
      },
      provider: "Nomic"
    }],
    images: [{
      image_sync: {
        chain_name: "nomic",
        base_denom: "unom"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg",
      theme: {
        primary_color_hex: "#6404fc"
      }
    }]
  }, {
    description: "Bitcoin. On Cosmos.",
    denom_units: [{
      denom: "usat",
      exponent: 0
    }, {
      denom: "nbtc",
      exponent: 14
    }],
    base: "usat",
    name: "Nomic Bitcoin",
    display: "nbtc",
    symbol: "nBTC",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg"
    },
    traces: [{
      type: "bridge",
      counterparty: {
        chain_name: "bitcointestnet",
        base_denom: "sat"
      },
      provider: "Nomic"
    }],
    images: [{
      image_sync: {
        chain_name: "nomic",
        base_denom: "usat"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nbtc.svg",
      theme: {
        primary_color_hex: "#8436e6"
      }
    }]
  }]
};
A3.default = h_e;
var j3 = {};
Object.defineProperty(j3, "__esModule", { value: !0 });
const p_e = {
  $schema: "../../chain.schema.json",
  chain_name: "nomictestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Nomic Testnet",
  website: "https://nomic.io/",
  chain_type: "cosmos",
  chain_id: "nomic-testnet-6",
  bech32_prefix: "nomic",
  daemon_name: "nomic",
  node_home: "$HOME/.nomic-testnet-6",
  slip44: 118,
  key_algos: ["secp256k1"],
  fees: {
    fee_tokens: [{
      denom: "unom",
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0
    }, {
      denom: "usat",
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unom"
    }],
    lock_duration: {
      time: "1209600s"
    }
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg"
  },
  description: "The superior way to use Bitcoin in Cosmos DeFi. Use IBC to securely and efficiently bridge your BTC to Osmosis and more.",
  apis: {
    rpc: [{
      address: "https://testnet-rpc.nomic.io:2096",
      provider: "nomic"
    }],
    rest: [{
      address: "https://testnet-api.nomic.io:8443",
      provider: "nomic"
    }]
  },
  explorers: [],
  images: [{
    image_sync: {
      chain_name: "nomic",
      base_denom: "unom"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nomic/images/nom.svg",
    theme: {
      primary_color_hex: "#6404fc"
    }
  }],
  bech32_config: {
    bech32PrefixAccAddr: "nomic",
    bech32PrefixAccPub: "nomic",
    bech32PrefixConsAddr: "nomic",
    bech32PrefixConsPub: "nomic",
    bech32PrefixValAddr: "nomic",
    bech32PrefixValPub: "nomic"
  }
};
j3.default = p_e;
var bC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Di, "__esModule", { value: !0 });
Di.chain = Di.assets = void 0;
const l_e = bC(A3), g_e = bC(j3);
Di.assets = l_e.default;
Di.chain = g_e.default;
var Bi = {}, C3 = {};
Object.defineProperty(C3, "__esModule", { value: !0 });
const u_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "nyxtestnet",
  assets: [{
    description: "NYX Token (NYX) is the Nym Network's native staking and governance token.",
    denom_units: [{
      denom: "unyx",
      exponent: 0
    }, {
      denom: "nyx",
      exponent: 6
    }],
    base: "unyx",
    name: "NYX",
    display: "nyx",
    symbol: "NYX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nyx.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nyx.png"
    }]
  }, {
    description: "NYM Token (NYM) is the Nym Network's native utility token, used as the primary means to incentivize mixnet node operators.",
    denom_units: [{
      denom: "unym",
      exponent: 0
    }, {
      denom: "nym",
      exponent: 6
    }],
    base: "unym",
    name: "NYM",
    display: "nym",
    symbol: "NYM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_light.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_light.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_light.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_light.svg",
      theme: {
        dark_mode: !1,
        circle: !0
      }
    }, {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_dark.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_dark.svg",
      theme: {
        dark_mode: !0,
        circle: !0
      }
    }]
  }]
};
C3.default = u_e;
var E3 = {};
Object.defineProperty(E3, "__esModule", { value: !0 });
const __e = {
  $schema: "../../chain.schema.json",
  chain_name: "nyxtestnet",
  status: "live",
  network_type: "testnet",
  website: "https://nymtech.net/",
  pretty_name: "Nym",
  chain_type: "cosmos",
  chain_id: "sandbox",
  bech32_prefix: "n",
  daemon_name: "nyxd",
  node_home: "$HOME/.nyxd",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "unym",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }, {
      denom: "unyx",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "unyx"
    }],
    lock_duration: {
      time: "432000s"
    }
  },
  codebase: {
    cosmwasm_enabled: !0
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_light.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_light.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc.sandbox.nymtech.net",
      provider: "Nym"
    }],
    rest: [{
      address: "https://api.sandbox.nymtech.net",
      provider: "Nym"
    }],
    grpc: [{
      address: "grpc.sandbox.nymtech.net:443",
      provider: "Nym"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://sandbox-blocks.nymtech.net/sandbox",
    tx_page: "https://sandbox-blocks.nymtech.net/sandbox/tx/${txHash}"
  }],
  images: [
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_light.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_light.svg",
      theme: {
        dark_mode: !1,
        circle: !0
      }
    },
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_dark.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_dark.svg",
      theme: {
        dark_mode: !0,
        circle: !0
      }
    },
    {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/nyxtestnet/images/nym_token_light.png"
    }
  ]
};
E3.default = __e;
var vC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Bi, "__esModule", { value: !0 });
Bi.chain = Bi.assets = void 0;
const y_e = vC(C3), b_e = vC(E3);
Bi.assets = y_e.default;
Bi.chain = b_e.default;
var Fi = {}, D3 = {};
Object.defineProperty(D3, "__esModule", { value: !0 });
const v_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "okp4testnet",
  assets: [{
    description: "The native token of ØKP4.",
    denom_units: [{
      denom: "uknow",
      exponent: 0
    }, {
      denom: "know",
      exponent: 6
    }],
    base: "uknow",
    name: "OKP4 Network",
    display: "know",
    symbol: "KNOW",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/okp4testnet/images/okp4.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/okp4testnet/images/okp4.png"
    }]
  }]
};
D3.default = v_e;
var B3 = {};
Object.defineProperty(B3, "__esModule", { value: !0 });
const f_e = {
  $schema: "../../chain.schema.json",
  chain_name: "okp4testnet",
  chain_type: "cosmos",
  chain_id: "okp4-nemeton-1",
  website: "https://okp4.network/",
  pretty_name: "OKP4 Nemeton",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "okp4",
  daemon_name: "okp4d",
  node_home: "$HOME/.okp4",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uknow",
      fixed_min_gas_price: 0,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uknow"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/okp4testnet/images/okp4.png"
  },
  apis: {
    rpc: [
      {
        address: "https://api.testnet.okp4.network/rpc",
        provider: "OKP4"
      },
      {
        address: "https://okptest-rpc.quickapi.com",
        provider: "Chainlayer"
      },
      {
        address: "http://okp.rpc.t.stavr.tech:10097",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://okp4-testnet-rpc.polkachu.com",
        provider: "Polkachu"
      }
    ],
    rest: [
      {
        address: "https://okptest-lcd.quickapi.com",
        provider: "Chainlayer"
      },
      {
        address: "https://okp4.api.t.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://okp4-testnet-api.polkachu.com/",
        provider: "Polkachu"
      }
    ],
    grpc: [
      {
        address: "okp4-testnet-grpc.polkachu.com:17690",
        provider: "Polkachu"
      },
      {
        address: "http://okp.grpc.t.stavr.tech:8029",
        provider: "🔥STAVR🔥"
      },
      {
        address: "grpc.testnet.okp4.network:443",
        provider: "OKP4"
      }
    ]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://testnet.ping.pub/OKP4%20testnet",
      tx_page: "https://testnet.ping.pub/OKP4%20testnet/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/OKP4-Testnet",
      tx_page: "https://explorer.stavr.tech/OKP4-Testnet/tx/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://explore.okp4.network/OKP4%20testnet",
      tx_page: "https://explore.okp4.network/OKP4%20testnet/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/okp4testnet/images/okp4.png"
  }]
};
B3.default = f_e;
var fC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Fi, "__esModule", { value: !0 });
Fi.chain = Fi.assets = void 0;
const w_e = fC(D3), x_e = fC(B3);
Fi.assets = w_e.default;
Fi.chain = x_e.default;
var Ua = {}, F3 = {};
Object.defineProperty(F3, "__esModule", { value: !0 });
const k_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "osmosistestnet",
  assets: [
    {
      description: "The native token of Osmosis",
      denom_units: [{
        denom: "uosmo",
        exponent: 0,
        aliases: []
      }, {
        denom: "osmo",
        exponent: 6,
        aliases: []
      }],
      type_asset: "sdk.coin",
      base: "uosmo",
      name: "Osmosis Testnet",
      display: "osmo",
      symbol: "OSMO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      }],
      coingecko_id: "osmosis",
      keywords: ["dex", "staking"]
    },
    {
      denom_units: [{
        denom: "uion",
        exponent: 0
      }, {
        denom: "ion",
        exponent: 6
      }],
      type_asset: "sdk.coin",
      base: "uion",
      name: "Ion",
      display: "ion",
      symbol: "ION",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.svg"
      }],
      coingecko_id: "ion",
      keywords: ["memecoin"]
    },
    {
      description: "The native staking and governance token of the Theta testnet version of the Cosmos Hub.",
      denom_units: [{
        denom: "ibc/9FF2B7A5F55038A7EE61F4FD6749D9A648B48E89830F2682B67B5DC158E2753C",
        exponent: 0,
        aliases: ["uatom"]
      }, {
        denom: "atom",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/9FF2B7A5F55038A7EE61F4FD6749D9A648B48E89830F2682B67B5DC158E2753C",
      name: "Cosmos Hub Public Testnet",
      display: "atom",
      symbol: "ATOM",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "cosmoshubtestnet",
          base_denom: "uatom",
          channel_id: "channel-3306"
        },
        chain: {
          channel_id: "channel-4156",
          path: "transfer/channel-4156/uatom"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      },
      images: [{
        image_sync: {
          chain_name: "cosmoshubtestnet",
          base_denom: "uatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/cosmoshub/images/atom.svg"
      }]
    },
    {
      description: "Circle's stablecoin on Axelar",
      denom_units: [{
        denom: "ibc/2164BDB48DE5501430E71286448D87C6D2240EC0E078CF113CAB85E21A352BB0",
        exponent: 0
      }, {
        denom: "ausdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/2164BDB48DE5501430E71286448D87C6D2240EC0E078CF113CAB85E21A352BB0",
      name: "USD Coin (Axelar)",
      display: "ausdc",
      symbol: "aUSDC.axl",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereumtestnet",
            base_denom: "0x254d06f33bDc5b8ee05b2ea472107E300226659A"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelartestnet",
            base_denom: "uausdc",
            channel_id: "channel-339"
          },
          chain: {
            channel_id: "channel-4170",
            path: "transfer/channel-4170/uausdc"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereumtestnet",
          base_denom: "0x254d06f33bDc5b8ee05b2ea472107E300226659A"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }]
    },
    {
      description: "Wrapped Ether on Axelar",
      denom_units: [{
        denom: "ibc/1F42AC9631DBE03009219ECCFE151786F53A038DE9F7A07C709158514F1D5942",
        exponent: 0,
        aliases: ["eth-wei"]
      }, {
        denom: "weth",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/1F42AC9631DBE03009219ECCFE151786F53A038DE9F7A07C709158514F1D5942",
      name: "Wrapped Ether (Axelar)",
      display: "weth",
      symbol: "ETH",
      traces: [
        {
          type: "wrapped",
          counterparty: {
            chain_name: "ethereumtestnet",
            base_denom: "wei"
          },
          provider: "Ethereum"
        },
        {
          type: "bridge",
          counterparty: {
            chain_name: "ethereumtestnet",
            base_denom: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6"
          },
          provider: "Axelar"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "axelartestnet",
            base_denom: "eth-wei",
            channel_id: "channel-339"
          },
          chain: {
            channel_id: "channel-4170",
            path: "transfer/channel-4170/eth-wei"
          }
        }
      ],
      logo_URIs: {
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      },
      images: [{
        image_sync: {
          chain_name: "ethereumtestnet",
          base_denom: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/weth.svg"
      }]
    },
    {
      description: "The native token of JUNO Chain",
      denom_units: [{
        denom: "ibc/31D220286E6C224C0F72D890D0EB75A228D388089EF5C4D77212344F9EAF0183",
        exponent: 0,
        aliases: ["ujunox"]
      }, {
        denom: "junox",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/31D220286E6C224C0F72D890D0EB75A228D388089EF5C4D77212344F9EAF0183",
      name: "Juno Testnet",
      display: "junox",
      symbol: "JUNOX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "junotestnet",
          base_denom: "ujunox",
          channel_id: "channel-889"
        },
        chain: {
          channel_id: "channel-5498",
          path: "transfer/channel-5498/ujunox"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/junotestnet/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/junotestnet/images/juno.svg"
      },
      images: [{
        image_sync: {
          chain_name: "junotestnet",
          base_denom: "ujunox"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/junotestnet/images/juno.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/junotestnet/images/juno.svg"
      }]
    },
    {
      description: "The native token of Mars Protocol",
      denom_units: [{
        denom: "ibc/66A7ADA623D33D0B66C6890FE3E1AF3D638D56CE2B56F8BDA210B2AA62016216",
        exponent: 0,
        aliases: ["umars"]
      }, {
        denom: "mars",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/66A7ADA623D33D0B66C6890FE3E1AF3D638D56CE2B56F8BDA210B2AA62016216",
      name: "Mars Hub Testnet",
      display: "mars",
      symbol: "MARS",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "marstestnet",
          base_denom: "umars",
          channel_id: "channel-28"
        },
        chain: {
          channel_id: "channel-5499",
          path: "transfer/channel-5499/umars"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.svg"
      },
      images: [{
        image_sync: {
          chain_name: "marstestnet",
          base_denom: "umars"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/mars-token.svg"
      }]
    },
    {
      description: "USD Coin",
      denom_units: [{
        denom: "ibc/DE6792CF9E521F6AD6E9A4BDF6225C9571A3B74ACC0A529F92BC5122A39D2E58",
        exponent: 0,
        aliases: ["microusdc", "uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/DE6792CF9E521F6AD6E9A4BDF6225C9571A3B74ACC0A529F92BC5122A39D2E58",
      name: "USD Coin",
      display: "usdc",
      symbol: "USDC",
      traces: [
        {
          type: "synthetic",
          counterparty: {
            chain_name: "forex",
            base_denom: "USD"
          },
          provider: "Circle"
        },
        {
          type: "additional-mintage",
          counterparty: {
            chain_name: "ethereum",
            base_denom: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
          },
          provider: "Circle"
        },
        {
          type: "test-mintage",
          counterparty: {
            chain_name: "noble",
            base_denom: "uusdc"
          },
          provider: "Circle"
        },
        {
          type: "ibc",
          counterparty: {
            chain_name: "nobletestnet",
            base_denom: "uusdc",
            channel_id: "channel-22"
          },
          chain: {
            channel_id: "channel-4280",
            path: "transfer/channel-4280/uusdc"
          }
        }
      ],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      },
      images: [{
        image_sync: {
          chain_name: "nobletestnet",
          base_denom: "uusdc"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }]
    },
    {
      description: "Akash Token (AKT) is the Akash Network's native utility token, used as the primary means to govern, secure the blockchain, incentivize participants, and provide a default mechanism to store and exchange value.",
      denom_units: [{
        denom: "ibc/AD59D59CFB0E628E73C798415F823AB5B6257C2FE4BF67DBB5D6A677B2686E82",
        exponent: 0,
        aliases: ["uakt"]
      }, {
        denom: "akt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/AD59D59CFB0E628E73C798415F823AB5B6257C2FE4BF67DBB5D6A677B2686E82",
      name: "Sandbox",
      display: "akt",
      symbol: "AKT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "akashtestnet",
          base_denom: "uakt",
          channel_id: "channel-6"
        },
        chain: {
          channel_id: "channel-4171",
          path: "transfer/channel-4171/uakt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "akashtestnet",
          base_denom: "uakt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/akash/images/akt.svg"
      }]
    },
    {
      description: "The native utility token of the Kaon testnet version of KYVE.",
      denom_units: [{
        denom: "ibc/AB8AF05799E299FB5C5C80781DA35887F53E029745D20E5641233DB4E6B28515",
        exponent: 0,
        aliases: ["tkyve"]
      }, {
        denom: "kyve",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/AB8AF05799E299FB5C5C80781DA35887F53E029745D20E5641233DB4E6B28515",
      name: "KYVE Kaon",
      display: "kyve",
      symbol: "KYVE",
      traces: [{
        type: "test-mintage",
        counterparty: {
          chain_name: "kyve",
          base_denom: "ukyve"
        },
        provider: "Kyve"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "kyvetestnet",
          base_denom: "tkyve",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-10",
          path: "transfer/channel-10/tkyve"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/kyve/images/kyve-token.svg",
        image_sync: {
          chain_name: "kyve",
          base_denom: "ukyve"
        },
        theme: {
          primary_color_hex: "#335350"
        }
      }]
    },
    {
      description: "QCK - native token of Quicksilver",
      denom_units: [{
        denom: "ibc/F37CF69589DE12342758382F8770C0852CD8D2E4519F55166EBDAF472AD667C9",
        exponent: 0,
        aliases: ["uqck"]
      }, {
        denom: "qck",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/F37CF69589DE12342758382F8770C0852CD8D2E4519F55166EBDAF472AD667C9",
      name: "Quicksilver Testnet",
      display: "qck",
      symbol: "QCK",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "quicksilvertestnet",
          base_denom: "uqck",
          channel_id: "channel-20"
        },
        chain: {
          channel_id: "channel-13",
          path: "transfer/channel-13/uqck"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.png"
      },
      images: [{
        image_sync: {
          chain_name: "quicksilvertestnet",
          base_denom: "uqck"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.png"
      }]
    },
    {
      description: "The native token of Chain4Energy",
      denom_units: [{
        denom: "ibc/E3D323CB6F427C49E56F913C853A416F6B71BAA9B0164625AD0203266F92B3ED",
        exponent: 0,
        aliases: ["uc4e"]
      }, {
        denom: "c4e",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/E3D323CB6F427C49E56F913C853A416F6B71BAA9B0164625AD0203266F92B3ED",
      name: "Chain4Energy Testnet",
      display: "c4e",
      symbol: "C4E",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "chain4energytestnet",
          base_denom: "uc4e",
          channel_id: "channel-0"
        },
        chain: {
          channel_id: "channel-111",
          path: "transfer/channel-111/uc4e"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/chain4energytestnet/images/c4e.png"
      },
      images: [{
        image_sync: {
          chain_name: "chain4energytestnet",
          base_denom: "uc4e"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/chain4energytestnet/images/c4e.png"
      }]
    },
    {
      description: "The XPRT token is primarily a governance token for the Persistence chain.",
      denom_units: [{
        denom: "ibc/754C8533F8A418B03AD5F2C6AA19D4703CF78BBAB9E2E4DDD6212AAC2E502CA6",
        exponent: 0,
        aliases: ["uxprt"]
      }, {
        denom: "xprt",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/754C8533F8A418B03AD5F2C6AA19D4703CF78BBAB9E2E4DDD6212AAC2E502CA6",
      name: "Persistence Testnet",
      display: "xprt",
      symbol: "XPRT",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "persistencetestnet2",
          base_denom: "uxprt",
          channel_id: "channel-7"
        },
        chain: {
          channel_id: "channel-1037",
          path: "transfer/channel-1037/uxprt"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg"
      },
      images: [{
        image_sync: {
          chain_name: "persistencetestnet2",
          base_denom: "uxprt"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg"
      }]
    },
    {
      description: "The native staking token of the Xion network.",
      denom_units: [{
        denom: "ibc/3642669AD14386D3E38F43F30CFCA859B3E8A05BF6BD6A23DEBD2115AD1325E9",
        exponent: 0,
        aliases: ["microxion", "uxion"]
      }, {
        denom: "XION",
        exponent: 6,
        aliases: ["xion"]
      }],
      type_asset: "ics20",
      base: "ibc/3642669AD14386D3E38F43F30CFCA859B3E8A05BF6BD6A23DEBD2115AD1325E9",
      name: "Xion Testnet",
      display: "XION",
      symbol: "XION",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "xiontestnet",
          base_denom: "uxion",
          channel_id: "channel-12"
        },
        chain: {
          channel_id: "channel-4410",
          path: "transfer/channel-4410/uxion"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xion/images/burnt-round.png"
      },
      images: [{
        image_sync: {
          chain_name: "xiontestnet",
          base_denom: "uxion"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xion/images/burnt-round.png"
      }]
    },
    {
      description: "The native token of Saga Testnet",
      denom_units: [{
        denom: "ibc/48384130079A5987378F5776775F8C29A02505273E777BBB99361F2BB5B577C9",
        exponent: 0,
        aliases: ["utsaga"]
      }, {
        denom: "tsaga",
        exponent: 6,
        aliases: []
      }],
      type_asset: "ics20",
      base: "ibc/48384130079A5987378F5776775F8C29A02505273E777BBB99361F2BB5B577C9",
      name: "Saga Testnet",
      display: "tsaga",
      symbol: "TSAGA",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "sagatestnet",
          base_denom: "utsaga",
          channel_id: "channel-20"
        },
        chain: {
          channel_id: "channel-4946",
          path: "transfer/channel-4946/utsaga"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.svg"
      },
      images: [{
        image_sync: {
          chain_name: "sagatestnet",
          base_denom: "utsaga"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.svg"
      }]
    },
    {
      description: "The native token of IXO Chain",
      denom_units: [{
        denom: "ibc/88C815D69587CF0F05E96E5E2731EA56194D73C9A02A500095294D3A5DE68F16",
        exponent: 0,
        aliases: ["uixo"]
      }, {
        denom: "ixo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/88C815D69587CF0F05E96E5E2731EA56194D73C9A02A500095294D3A5DE68F16",
      name: "ixo",
      display: "ixo",
      symbol: "IXO",
      traces: [{
        type: "test-mintage",
        counterparty: {
          chain_name: "impacthub",
          base_denom: "uixo"
        },
        provider: "impacthub"
      }, {
        type: "ibc",
        counterparty: {
          chain_name: "impacthubtestnet",
          base_denom: "uixo",
          channel_id: "channel-10"
        },
        chain: {
          channel_id: "channel-1637",
          path: "transfer/channel-1637/uixo"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg"
      },
      images: [{
        image_sync: {
          chain_name: "impacthub",
          base_denom: "uixo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/impacthub/images/ixo.svg",
        theme: {
          primary_color_hex: "#2c4484"
        }
      }]
    },
    {
      denom_units: [{
        denom: "factory/osmo1zlkzu72774ynac53necz46u4ycqtp36wedrar0/willyz",
        exponent: 0
      }, {
        denom: "willyz",
        exponent: 6
      }],
      base: "factory/osmo1zlkzu72774ynac53necz46u4ycqtp36wedrar0/willyz",
      name: "Willyz",
      display: "willyz",
      symbol: "WILLYZ",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/osmosistestnet/images/willyz.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/osmosistestnet/images/willyz.svg"
      },
      keywords: ["memecoin"],
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/osmosistestnet/images/willyz.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/osmosistestnet/images/willyz.svg"
      }]
    },
    {
      description: "The yield token for ATOM denominated vaults on Amulet Protocol",
      denom_units: [{
        denom: "ibc/C86B92F7FCFC1993DAC4AB0D78D9BC080300354B823A57F12CD6E2FBB667214E",
        exponent: 0
      }, {
        denom: "amATOM",
        exponent: 6
      }],
      base: "ibc/C86B92F7FCFC1993DAC4AB0D78D9BC080300354B823A57F12CD6E2FBB667214E",
      name: "amATOM (Testnet)",
      display: "amATOM",
      symbol: "amATOM",
      type_asset: "ics20",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/amATOM.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/amATOM.svg"
      },
      images: [{
        image_sync: {
          chain_name: "neutrontestnet",
          base_denom: "factory/neutron15lku24mqhvy4v4gryrqs4662n9v9q4ux9tayn89cmdzldjcgawushxvm76/amatom"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/amATOM.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/neutrontestnet/images/amATOM.svg"
      }],
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "neutrontestnet",
          base_denom: "factory/neutron15lku24mqhvy4v4gryrqs4662n9v9q4ux9tayn89cmdzldjcgawushxvm76/amatom",
          channel_id: "channel-787"
        },
        chain: {
          channel_id: "channel-7884",
          path: "transfer/channel-7884/factory/neutron15lku24mqhvy4v4gryrqs4662n9v9q4ux9tayn89cmdzldjcgawushxvm76/amatom"
        }
      }]
    },
    {
      description: "The native EVM, governance and staking token of the Titan Chain",
      denom_units: [
        {
          denom: "ibc/28EEF762052DB8C3D27A7BF625E9F86A1B3B689CC8D80C818CEDF2EB6CBA02A6",
          exponent: 0,
          aliases: ["atkx"]
        },
        {
          denom: "utkx",
          exponent: 12,
          aliases: ["microtkx"]
        },
        {
          denom: "mtkx",
          exponent: 15,
          aliases: ["millitkx"]
        },
        {
          denom: "tkx",
          exponent: 18
        }
      ],
      type_asset: "ics20",
      base: "ibc/28EEF762052DB8C3D27A7BF625E9F86A1B3B689CC8D80C818CEDF2EB6CBA02A6",
      name: "tkx",
      display: "tkx",
      symbol: "TKX",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "titan",
          base_denom: "atkx",
          channel_id: "channel-2"
        },
        chain: {
          channel_id: "channel-5969",
          path: "transfer/channel-5969/atkx"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/titantestnet/images/tkx.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/titantestnet/images/tkx.png"
      }]
    }
  ]
};
F3.default = k_e;
var $3 = {};
Object.defineProperty($3, "__esModule", { value: !0 });
const A_e = {
  $schema: "../../chain.schema.json",
  chain_name: "osmosistestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Osmosis Testnet",
  chain_type: "cosmos",
  chain_id: "osmo-test-5",
  bech32_prefix: "osmo",
  daemon_name: "osmosisd",
  node_home: "$HOME/.osmosisd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uosmo",
      fixed_min_gas_price: 0,
      low_gas_price: 25e-4,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uosmo"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30"
  },
  apis: {
    rpc: [{
      address: "https://rpc.osmotest5.osmosis.zone/",
      provider: "Osmosis"
    }],
    rest: [{
      address: "https://lcd.osmotest5.osmosis.zone/",
      provider: "Osmosis"
    }],
    grpc: [{
      address: "https://grpc.osmotest5.osmosis.zone/",
      provider: "Osmosis"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmosis-chain-logo.png"
  },
  explorers: [{
    kind: "mintscan",
    url: "https://mintscan.io/osmosis-testnet",
    tx_page: "https://mintscan.io/osmosis-testnet/txs/${txHash}",
    account_page: "https://mintscan.io/osmosis-testnet/account/${accountAddress}"
  }, {
    kind: "ping.pub",
    url: "https://explorer.osmotest5.osmosis.zone",
    tx_page: "https://explorer.osmotest5.osmosis.zone/osmo-test-5/tx/${txHash}",
    account_page: "https://explorer.osmotest5.osmosis.zone/osmo-test-5/account/${accountAddress}"
  }],
  keywords: ["dex", "testnet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmosis-chain-logo.png"
  }]
};
$3.default = A_e;
var z3 = {};
Object.defineProperty(z3, "__esModule", { value: !0 });
const j_e = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "akashtestnet",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1271",
      connection_id: "connection-1171"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4171",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "archwaytestnet",
      client_id: "07-tendermint-121",
      connection_id: "connection-120"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3459",
      connection_id: "connection-3027"
    },
    channels: [
      {
        chain_1: {
          channel_id: "channel-225",
          port_id: "transfer"
        },
        chain_2: {
          channel_id: "channel-7779",
          port_id: "transfer"
        },
        ordering: "unordered",
        version: "ics20-1",
        tags: {
          status: "live"
        }
      },
      {
        chain_1: {
          channel_id: "*",
          port_id: "wasm.*"
        },
        chain_2: {
          channel_id: "*",
          port_id: "icahost"
        },
        ordering: "ordered",
        version: "ics27-1",
        tags: {
          status: "live"
        }
      },
      {
        chain_1: {
          channel_id: "*",
          port_id: "wasm.*"
        },
        chain_2: {
          channel_id: "*",
          port_id: "icqhost"
        },
        ordering: "unordered",
        version: "icq-1",
        tags: {
          status: "live"
        }
      }
    ]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-685",
      connection_id: "connection-538"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1270",
      connection_id: "connection-1169"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-339",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4170",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "celestiatestnet3",
      client_id: "07-tendermint-118",
      connection_id: "connection-98"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1445",
      connection_id: "connection-1350"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-25",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4370",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "chain4energytestnet",
      client_id: "07-tendermint-18",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3393",
      connection_id: "connection-2989"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7735",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "composabletestnet",
      client_id: "07-tendermint-23",
      connection_id: "connection-18"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-273",
      connection_id: "connection-237"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-329",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "coreumtestnet",
      client_id: "07-tendermint-104",
      connection_id: "connection-69"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3529",
      connection_id: "connection-3094"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-47",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7894",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-2528",
      connection_id: "connection-2886"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1262",
      connection_id: "connection-1157"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3306",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4156",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "doravotatestnet",
      client_id: "07-tendermint-2",
      connection_id: "connection-3"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-2",
      connection_id: "connection-611"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1260",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "empowertestnet",
      client_id: "07-tendermint-1",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-146",
      connection_id: "connection-157"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-155",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "entrypointtestnet",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-930",
      connection_id: "connection-840"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1543",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "impacthubtestnet",
      client_id: "07-tendermint-53",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1010",
      connection_id: "connection-911"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1637",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "injectivetestnet",
      client_id: "07-tendermint-189",
      connection_id: "connection-180"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1273",
      connection_id: "connection-1173"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-129",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4174",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "junotestnet",
      client_id: "07-tendermint-743",
      connection_id: "connection-827"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1932",
      connection_id: "connection-1889"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-889",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5498",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "kimatestnet",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1",
      connection_id: "connection-3450"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8867",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "kyvetestnet",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-11",
      connection_id: "connection-11"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "lavatestnet",
      client_id: "07-tendermint-11",
      connection_id: "connection-11"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-2554",
      connection_id: "connection-2401"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-6092",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "likecointestnet",
      client_id: "07-tendermint-5",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1431",
      connection_id: "connection-1336"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4357",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "mantrachaintestnet",
      client_id: "07-tendermint-5",
      connection_id: "connection-5"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3930",
      connection_id: "connection-3411"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-8734",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "marstestnet",
      client_id: "07-tendermint-33",
      connection_id: "connection-30"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1933",
      connection_id: "connection-1890"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-28",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5499",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "neutrontestnet",
      client_id: "07-tendermint-133",
      connection_id: "connection-123"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1272",
      connection_id: "connection-1172"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-196",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4172",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-42",
      connection_id: "connection-31"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1374",
      connection_id: "connection-1275"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-22",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4280",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "nolustestnet",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    chain_2: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-102",
      connection_id: "connection-120"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-110",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-595",
      connection_id: "connection-529"
    },
    chain_2: {
      chain_name: "persistencetestnet2",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1037",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-19",
      connection_id: "connection-14"
    },
    chain_2: {
      chain_name: "quicksilvertestnet",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-13",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1448",
      connection_id: "connection-1552"
    },
    chain_2: {
      chain_name: "sagatestnet",
      client_id: "07-tendermint-26",
      connection_id: "connection-21"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4946",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-20",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-965",
      connection_id: "connection-865"
    },
    chain_2: {
      chain_name: "sgetestnet",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1568",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1274",
      connection_id: "connection-1175"
    },
    chain_2: {
      chain_name: "stargazetestnet",
      client_id: "07-tendermint-621",
      connection_id: "connection-633"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4175",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-638",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3714",
      connection_id: "connection-3238"
    },
    chain_2: {
      chain_name: "swisstroniktestnet",
      client_id: "07-tendermint-31",
      connection_id: "connection-18"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8295",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3946",
      connection_id: "connection-3419"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8743",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-2436",
      connection_id: "connection-2267"
    },
    chain_2: {
      chain_name: "titantestnet",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5969",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "killed",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3125",
      connection_id: "connection-2826"
    },
    chain_2: {
      chain_name: "xiontestnet",
      client_id: "07-tendermint-121",
      connection_id: "connection-57"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6668",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-490",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
z3.default = j_e;
var q3 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ua, "__esModule", { value: !0 });
Ua.ibc = Ua.chain = Ua.assets = void 0;
const C_e = q3(F3), E_e = q3($3), D_e = q3(z3);
Ua.assets = C_e.default;
Ua.chain = E_e.default;
Ua.ibc = D_e.default;
var Ha = {}, S3 = {};
Object.defineProperty(S3, "__esModule", { value: !0 });
const B_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "osmosistestnet4",
  assets: [{
    description: "The native token of Osmosis",
    denom_units: [{
      denom: "uosmo",
      exponent: 0,
      aliases: []
    }, {
      denom: "osmo",
      exponent: 6,
      aliases: []
    }],
    base: "uosmo",
    name: "Osmosis",
    display: "osmo",
    symbol: "OSMO",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
    },
    coingecko_id: "osmosis",
    keywords: ["dex", "staking"],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
    }]
  }, {
    denom_units: [{
      denom: "uion",
      exponent: 0
    }, {
      denom: "ion",
      exponent: 6
    }],
    base: "uion",
    name: "Ion",
    display: "ion",
    symbol: "ION",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.svg"
    },
    coingecko_id: "ion",
    keywords: ["memecoin"],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/ion.svg"
    }]
  }]
};
S3.default = B_e;
var T3 = {};
Object.defineProperty(T3, "__esModule", { value: !0 });
const F_e = {
  $schema: "../../chain.schema.json",
  chain_name: "osmosistestnet4",
  status: "live",
  network_type: "testnet",
  pretty_name: "Osmosis Testnet",
  chain_type: "cosmos",
  chain_id: "osmo-test-4",
  bech32_prefix: "osmo",
  daemon_name: "osmosisd",
  node_home: "$HOME/.osmosisd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uosmo",
      fixed_min_gas_price: 0,
      low_gas_price: 0,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uosmo"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.29"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.osmo-test.ccvalidators.com/",
        provider: "CryptoCrew"
      },
      {
        address: "https://osmosistest-rpc.quickapi.com/",
        provider: "ChainLayer"
      },
      {
        address: "https://rpc.testnet.osmosis.zone/",
        provider: "Osmosis"
      }
    ],
    rest: [
      {
        address: "https://osmosistest-lcd.quickapi.com/",
        provider: "CryptoCrew"
      },
      {
        address: "https://lcd.osmo-test.ccvalidators.com/",
        provider: "ChainLayer"
      },
      {
        address: "https://testnet-rest.osmosis.zone/"
      }
    ],
    grpc: [{
      address: "https://grpc-test.osmosis.zone:443",
      provider: "Osmosis"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmosis-chain-logo.png"
  },
  keywords: ["dex", "testnet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmosis-chain-logo.png"
  }]
};
T3.default = F_e;
var R3 = {};
Object.defineProperty(R3, "__esModule", { value: !0 });
const $_e = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-213",
      connection_id: "connection-151"
    },
    chain_2: {
      chain_name: "osmosistestnet4",
      client_id: "07-tendermint-3319",
      connection_id: "connection-2807"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-135",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1946",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "junotestnet",
      client_id: "07-tendermint-135",
      connection_id: "connection-151"
    },
    chain_2: {
      chain_name: "osmosistestnet4",
      client_id: "07-tendermint-4413",
      connection_id: "connection-3814"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-140",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3316",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "marstestnet",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    chain_2: {
      chain_name: "osmosistestnet4",
      client_id: "07-tendermint-3419",
      connection_id: "connection-2887"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2083",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-6",
      connection_id: "connection-6"
    },
    chain_2: {
      chain_name: "osmosistestnet4",
      client_id: "07-tendermint-4504",
      connection_id: "connection-3905"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3651",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
R3.default = $_e;
var O3 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ha, "__esModule", { value: !0 });
Ha.ibc = Ha.chain = Ha.assets = void 0;
const z_e = O3(S3), q_e = O3(T3), S_e = O3(R3);
Ha.assets = z_e.default;
Ha.chain = q_e.default;
Ha.ibc = S_e.default;
var $i = {}, M3 = {};
Object.defineProperty(M3, "__esModule", { value: !0 });
const T_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "permtestnet",
  assets: [{
    description: "Perm A Permissioned Blockchain",
    denom_units: [{
      denom: "uperm",
      exponent: 0
    }, {
      denom: "perm",
      exponent: 6
    }],
    base: "uperm",
    name: "Perm",
    display: "perm",
    symbol: "PERM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/permtestnet/images/Perm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/permtestnet/images/Perm.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/permtestnet/images/Perm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/permtestnet/images/Perm.svg"
    }]
  }]
};
M3.default = T_e;
var I3 = {};
Object.defineProperty(I3, "__esModule", { value: !0 });
const R_e = {
  $schema: "../../chain.schema.json",
  chain_name: "permtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Perm Testnet",
  chain_type: "cosmos",
  chain_id: "INVALID-ID-permtestnet-testnet-1",
  bech32_prefix: "perm",
  daemon_name: "permd",
  node_home: "$HOME/.perm",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uperm",
      low_gas_price: 25e-4,
      average_gas_price: 25e-4,
      high_gas_price: 24e-4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uperm"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30"
  },
  apis: {
    rpc: [{
      address: "https://rpc.3.finance/",
      provider: "Perm Network"
    }],
    rest: [{
      address: "https://rest.3.finance/",
      provider: "Perm Network"
    }],
    grpc: [{
      address: "https://grpc.3.finance/",
      provider: "Perm Network"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://explorer.testnet.perm.ooo/",
    tx_page: "https://explorer.testnet.perm.ooo/transactions/${txHash}"
  }]
};
I3.default = R_e;
var wC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty($i, "__esModule", { value: !0 });
$i.chain = $i.assets = void 0;
const O_e = wC(M3), M_e = wC(I3);
$i.assets = O_e.default;
$i.chain = M_e.default;
var zi = {}, N3 = {};
Object.defineProperty(N3, "__esModule", { value: !0 });
const I_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "persistencetestnet",
  assets: [{
    description: "The XPRT token is primarily a governance token for the Persistence chain.",
    denom_units: [{
      denom: "uxprt",
      exponent: 0
    }, {
      denom: "xprt",
      exponent: 6
    }],
    base: "uxprt",
    name: "Persistence",
    display: "xprt",
    symbol: "XPRT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg"
    },
    coingecko_id: "persistence",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg"
    }]
  }, {
    description: "PSTAKE Liquid-Staked ATOM",
    denom_units: [{
      denom: "stk/uatom",
      exponent: 0,
      aliases: []
    }, {
      denom: "stkatom",
      exponent: 6,
      aliases: ["stk/atom"]
    }],
    base: "stk/uatom",
    name: "PSTAKE staked ATOM",
    display: "stkatom",
    symbol: "stkATOM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg"
    }]
  }]
};
N3.default = I_e;
var P3 = {};
Object.defineProperty(P3, "__esModule", { value: !0 });
const N_e = {
  $schema: "../../chain.schema.json",
  chain_name: "persistencetestnet",
  chain_type: "cosmos",
  chain_id: "test-core-1",
  pretty_name: "Persistence Testnet",
  status: "live",
  network_type: "testnet",
  website: "https://persistence.one/",
  bech32_prefix: "persistence",
  daemon_name: "persistenceCore",
  node_home: "$HOME/.persistenceCore",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uxprt",
      fixed_min_gas_price: 0,
      low_gas_price: 0.05,
      average_gas_price: 0.125,
      high_gas_price: 0.2
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uxprt"
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://rpc-testnet-persistence.architectnodes.com/",
        provider: "Architect Nodes"
      },
      {
        address: "https://persistence-testnet-rpc.baryon.dev/",
        provider: "Baryon"
      },
      {
        address: "https://persistence-testnet-rpc.cosmonautstakes.com/",
        provider: "Cosmonaut Stakes"
      },
      {
        address: "https://rpc.testnet.persistence.one/",
        provider: "Persistence"
      },
      {
        address: "https://persistence-testnet-rpc.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://xprt-trpc.antrixy.org/",
        provider: "Antrix Validators"
      }
    ],
    rest: [
      {
        address: "https://rest-testnet-persistence.architectnodes.com/",
        provider: "Architect Nodes"
      },
      {
        address: "https://persistence-testnet-api.baryon.dev/",
        provider: "Baryon"
      },
      {
        address: "https://persistence-testnet-rest.cosmonautstakes.com/",
        provider: "Cosmonaut Stakes"
      },
      {
        address: "https://rest.testnet.persistence.one/",
        provider: "Persistence"
      },
      {
        address: "https://persistence-testnet-api.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://xprt-trest.antrixy.org/",
        provider: "Antrix Validators"
      }
    ],
    grpc: [{
      address: "persistence-testnet-grpc.polkachu.com:15490",
      provider: "Polkachu"
    }, {
      address: "https://xprt-tgrpc.antrixy.org/",
      provider: "Antrix Validators"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://testnet.ping.pub/test-core-1/",
    tx_page: "https://testnet.ping.pub/test-core-1/tx/${txHash}"
  }, {
    kind: "mintscan",
    url: "https://mintscan.io/persistence-testnet",
    tx_page: "https://mintscan.io/persistence-testnet/txs/${txHash}",
    account_page: "https://mintscan.io/persistence-testnet/account/${accountAddress}"
  }]
};
P3.default = N_e;
var xC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(zi, "__esModule", { value: !0 });
zi.chain = zi.assets = void 0;
const P_e = xC(N3), U_e = xC(P3);
zi.assets = P_e.default;
zi.chain = U_e.default;
var La = {}, U3 = {};
Object.defineProperty(U3, "__esModule", { value: !0 });
const H_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "persistencetestnet2",
  assets: [
    {
      description: "The XPRT token is primarily a governance token for the Persistence chain.",
      denom_units: [{
        denom: "uxprt",
        exponent: 0
      }, {
        denom: "xprt",
        exponent: 6
      }],
      base: "uxprt",
      name: "Persistence",
      display: "xprt",
      symbol: "XPRT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg"
      },
      coingecko_id: "persistence",
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/xprt.svg"
      }]
    },
    {
      description: "PSTAKE Liquid-Staked ATOM",
      denom_units: [{
        denom: "stk/uatom",
        exponent: 0,
        aliases: []
      }, {
        denom: "stkatom",
        exponent: 6,
        aliases: ["stk/atom"]
      }],
      base: "stk/uatom",
      name: "PSTAKE staked ATOM",
      display: "stkatom",
      symbol: "stkATOM",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkatom.svg"
      }]
    },
    {
      description: "PSTAKE Liquid-Staked OSMO",
      denom_units: [{
        denom: "stk/uosmo",
        exponent: 0,
        aliases: []
      }, {
        denom: "stkosmo",
        exponent: 6,
        aliases: ["stk/osmo"]
      }],
      base: "stk/uosmo",
      name: "PSTAKE staked OSMO",
      display: "stkosmo",
      symbol: "stkOSMO",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkosmo.svg"
      }]
    },
    {
      description: "PSTAKE Liquid-Staked DV4TNT",
      denom_units: [{
        denom: "stk/adv4tnt",
        exponent: 0,
        aliases: []
      }, {
        denom: "stkdv4tnt",
        exponent: 18,
        aliases: ["stk/dv4tnt"]
      }],
      base: "stk/adv4tnt",
      name: "PSTAKE staked DV4TNT",
      display: "stkdv4tnt",
      symbol: "stkDV4TNT",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkdv4tnt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkdv4tnt.svg"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkdv4tnt.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/persistence/images/stkdv4tnt.svg"
      }]
    }
  ]
};
U3.default = H_e;
var H3 = {};
Object.defineProperty(H3, "__esModule", { value: !0 });
const L_e = {
  $schema: "../../chain.schema.json",
  chain_name: "persistencetestnet2",
  chain_type: "cosmos",
  chain_id: "test-core-2",
  pretty_name: "Persistence Testnet",
  status: "live",
  network_type: "testnet",
  website: "https://persistence.one/",
  bech32_prefix: "persistence",
  daemon_name: "persistenceCore",
  node_home: "$HOME/.persistenceCore",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uxprt",
      fixed_min_gas_price: 0,
      low_gas_price: 0.05,
      average_gas_price: 0.125,
      high_gas_price: 0.2
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uxprt"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://rpc-persistence-testnet-01.stakeflow.io/",
        provider: "StakeFlow"
      },
      {
        address: "https://persistence-testnet-rpc.baryon.dev/",
        provider: "Baryon"
      },
      {
        address: "https://persistence-testnet-rpc.cosmonautstakes.com/",
        provider: "Cosmonaut Stakes"
      },
      {
        address: "https://rpc.testnet2.persistence.one/",
        provider: "Persistence"
      },
      {
        address: "https://persistence-testnet-rpc.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://persistencecoretest-rpc.ytwofund.pro/",
        provider: "YTWOFUND"
      },
      {
        address: "http://persistence-testnet.paranorm.pro:24657/",
        provider: "Paranorm"
      }
    ],
    rest: [
      {
        address: "https://api-persistence-testnet-01.stakeflow.io/",
        provider: "StakeFlow"
      },
      {
        address: "https://persistence-testnet-api.baryon.dev/",
        provider: "Baryon"
      },
      {
        address: "https://persistence-testnet-rest.cosmonautstakes.com/",
        provider: "Cosmonaut Stakes"
      },
      {
        address: "https://rest.testnet2.persistence.one/",
        provider: "Persistence"
      },
      {
        address: "https://persistence-testnet-api.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://persistenceCoreTest-rest.ytwofund.pro",
        provider: "YTWOFUND"
      }
    ],
    grpc: [{
      address: "persistence-testnet-grpc.polkachu.com:15490",
      provider: "Polkachu"
    }, {
      address: "persistenceCoreTest-grpc.ytwofund.pro:9090",
      provider: "YTWOFUND"
    }]
  },
  explorers: [
    {
      kind: "mintscan",
      url: "https://mintscan.io/persistence-testnet",
      tx_page: "https://mintscan.io/persistence-testnet/txs/${txHash}",
      account_page: "https://mintscan.io/persistence-testnet/account/${accountAddress}"
    },
    {
      kind: "StakeFlow",
      url: "https://stakeflow.io/persistence-testnet",
      tx_page: "https://stakeflow.io/persistence-testnet/transactions/${txHash}",
      account_page: "https://stakeflow.io/persistence-testnet/accounts/${accountAddress}"
    },
    {
      kind: "baryon",
      url: "https://testnet-explorer.baryon.dev/test-core-2",
      tx_page: "https://testnet-explorer.baryon.dev/test-core-2/tx/{txHash}",
      account_page: "https://testnet-explorer.baryon.dev/test-core-2/account/${accountAddress}"
    }
  ]
};
H3.default = L_e;
var L3 = {};
Object.defineProperty(L3, "__esModule", { value: !0 });
const W_e = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-522",
      connection_id: "connection-372"
    },
    chain_2: {
      chain_name: "persistencetestnet2",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-261",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-2100",
      connection_id: "connection-2447"
    },
    chain_2: {
      chain_name: "persistencetestnet2",
      client_id: "07-tendermint-1",
      connection_id: "connection-1"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-2777",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-595",
      connection_id: "connection-529"
    },
    chain_2: {
      chain_name: "persistencetestnet2",
      client_id: "07-tendermint-3",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1037",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  }
];
L3.default = W_e;
var W3 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(La, "__esModule", { value: !0 });
La.ibc = La.chain = La.assets = void 0;
const V_e = W3(U3), G_e = W3(H3), K_e = W3(L3);
La.assets = V_e.default;
La.chain = G_e.default;
La.ibc = K_e.default;
var qi = {}, V3 = {};
Object.defineProperty(V3, "__esModule", { value: !0 });
const X_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "planqtestnet",
  assets: [{
    description: "The native EVM, governance and staking token of the Planq Network",
    denom_units: [{
      denom: "atplanq",
      exponent: 0
    }, {
      denom: "tplanq",
      exponent: 18
    }],
    base: "atplanq",
    name: "Planq Atlas Testnet",
    display: "tplanq",
    symbol: "tPLQ",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/planqtestnet/images/planq.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/planqtestnet/images/planq.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/planqtestnet/images/planq.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/planqtestnet/images/planq.svg"
    }]
  }]
};
V3.default = X_e;
var G3 = {};
Object.defineProperty(G3, "__esModule", { value: !0 });
const Y_e = {
  $schema: "../../chain.schema.json",
  chain_name: "planqtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Planq Atlas Testnet",
  chain_type: "cosmos",
  chain_id: "planq_7077-1",
  bech32_prefix: "plq",
  daemon_name: "planqd",
  node_home: "$HOME/.planqd",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "atplanq",
      fixed_min_gas_price: 2e10,
      low_gas_price: 3e10,
      average_gas_price: 35e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "atplanq"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.46.3"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/planqtestnet/images/planq.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/planqtestnet/images/planq.svg"
  },
  apis: {
    rpc: [{
      address: "https://rpc-atlas.planq.network",
      provider: "Planq Network"
    }, {
      address: "https://planq_testnet_rpc.chain.whenmoonwhenlambo.money",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }],
    rest: [{
      address: "https://rest-atlas.planq.network",
      provider: "Planq Network"
    }, {
      address: "https://planq_testnet_api.chain.whenmoonwhenlambo.money",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }],
    grpc: [{
      address: "https://grpc-atlas.planq.network",
      provider: "Planq Network"
    }],
    "evm-http-jsonrpc": [{
      address: "https://evm-rpc-atlas.planq.network",
      provider: "Planq Network"
    }, {
      address: "https://planq_testnet_evm.chain.whenmoonwhenlambo.money",
      provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
    }]
  },
  explorers: [
    {
      kind: "EVM",
      url: "https://evm-atlas.planq.network",
      tx_page: "https://evm-atlas.planq.network/tx/${txHash}"
    },
    {
      kind: "Konsortech",
      url: "https://testnet-explorer.konsortech.xyz/planq",
      tx_page: "https://testnet-explorer.konsortech.xyz/planq/tx/${txHash}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/planq-testnet",
      tx_page: "https://explorer.whenmoonwhenlambo.money/planq-testnet/tx/${txHash}"
    }
  ],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/planqtestnet/images/planq.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/planqtestnet/images/planq.svg"
  }]
};
G3.default = Y_e;
var kC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(qi, "__esModule", { value: !0 });
qi.chain = qi.assets = void 0;
const J_e = kC(V3), Z_e = kC(G3);
qi.assets = J_e.default;
qi.chain = Z_e.default;
var Si = {}, K3 = {};
Object.defineProperty(K3, "__esModule", { value: !0 });
const Q_e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "pryzmtestnet",
  assets: [{
    description: "The native token of PRYZM",
    denom_units: [{
      denom: "upryzm",
      exponent: 0
    }, {
      denom: "pryzm",
      exponent: 6
    }],
    base: "upryzm",
    name: "Pryzm",
    display: "pryzm",
    symbol: "PRYZM",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/pryzmtestnet/images/pryzm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/pryzmtestnet/images/pryzm.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/pryzmtestnet/images/pryzm.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/pryzmtestnet/images/pryzm.svg"
    }]
  }]
};
K3.default = Q_e;
var X3 = {};
Object.defineProperty(X3, "__esModule", { value: !0 });
const e0e = {
  $schema: "../../chain.schema.json",
  chain_name: "pryzmtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Pryzm Testnet",
  chain_type: "cosmos",
  chain_id: "indigo-1",
  bech32_prefix: "pryzm",
  daemon_name: "pryzmd",
  node_home: "$HOME/.pryzm",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "upryzm",
      fixed_min_gas_price: 0,
      low_gas_price: 0.015,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "upryzm"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47"
  },
  apis: {
    rpc: [{
      address: "https://testnet-rpc.pryzm.zone",
      provider: "PRYZM"
    }, {
      address: "https://pryzm-testnet-rpc.itrocket.net",
      provider: "ITRocket"
    }],
    rest: [{
      address: "https://testnet-api.pryzm.zone",
      provider: "PRYZM"
    }, {
      address: "https://pryzm-testnet-api.itrocket.net",
      provider: "ITRocket"
    }],
    grpc: [{
      address: "https://testnet-grpc.pryzm.zone",
      provider: "PRYZM"
    }, {
      address: "http://pryzm-testnet-grpc.itrocket.net:41090",
      provider: "ITRocket"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/pryzmtestnet/images/pryzm-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/pryzmtestnet/images/pryzm-logo.svg"
  },
  explorers: [{
    kind: "PingPub",
    url: "https://testnets.cosmosrun.info/pryzm-indigo-1",
    tx_page: "https://testnets.cosmosrun.info/pryzm-indigo-1/tx/${txHash}",
    account_page: "https://testnets.cosmosrun.info/pryzm-indigo-1/account/${accountAddress}"
  }, {
    kind: "ITRocket",
    url: "https://testnet.itrocket.net/pryzm",
    tx_page: "https://testnet.itrocket.net/pryzm/tx/${txHash}",
    account_page: "https://testnet.itrocket.net/pryzm/account/${accountAddress}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/pryzmtestnet/images/pryzm-logo.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/pryzmtestnet/images/pryzm-logo.svg"
  }]
};
X3.default = e0e;
var AC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Si, "__esModule", { value: !0 });
Si.chain = Si.assets = void 0;
const n0e = AC(K3), t0e = AC(X3);
Si.assets = n0e.default;
Si.chain = t0e.default;
var Ti = {}, Y3 = {};
Object.defineProperty(Y3, "__esModule", { value: !0 });
const s0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "quasartestnet",
  assets: [
    {
      description: "The native token of Quasar",
      denom_units: [{
        denom: "uqsr",
        exponent: 0,
        aliases: []
      }, {
        denom: "qsr",
        exponent: 6,
        aliases: []
      }],
      base: "uqsr",
      name: "Quasar",
      display: "qsr",
      symbol: "QSR"
    },
    {
      denom_units: [{
        denom: "uayy",
        exponent: 0
      }, {
        denom: "ayy",
        exponent: 6
      }],
      base: "uayy",
      name: "AYY",
      display: "ayy",
      symbol: "AYY"
    },
    {
      denom_units: [{
        denom: "uoro",
        exponent: 0
      }, {
        denom: "oro",
        exponent: 6
      }],
      base: "uoro",
      name: "oro",
      display: "oro",
      symbol: "ORO"
    }
  ]
};
Y3.default = s0e;
var J3 = {};
Object.defineProperty(J3, "__esModule", { value: !0 });
const a0e = {
  $schema: "../../chain.schema.json",
  chain_name: "quasartestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Quasar Testnet",
  chain_type: "cosmos",
  chain_id: "quasar-test-1",
  bech32_prefix: "quasar",
  daemon_name: "quasarnoded",
  node_home: "$HOME/.quasarnoded",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uqsr",
      fixed_min_gas_price: 0,
      low_gas_price: 25e-4,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uqsr"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47.12",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.45.0"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.svg"
  },
  apis: {
    rpc: [
      {
        address: "https://quasar-testnet-rpc.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://quasar-testnet-rpc.stakeandrelax.net/",
        provider: "Stake and Relax"
      },
      {
        address: "https://quasar-testnet.rpc.kjnodes.com",
        provider: "KJNodes.com"
      }
    ],
    rest: [
      {
        address: "https://quasar-testnet-api.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://quasar-testnet-api.stakeandrelax.net/",
        provider: "Stake and Relax"
      },
      {
        address: "https://quasar-testnet.api.kjnodes.com/",
        provider: "KJNodes.com"
      }
    ],
    grpc: [
      {
        address: "quasar-testnet-grpc.polkachu.com:18290",
        provider: "Polkachu"
      },
      {
        address: "http://quasar-testnet-grpc.stakeandrelax.net:18290/",
        provider: "Stake and Relax"
      },
      {
        address: "quasar-testnet.grpc.kjnodes.com:443",
        provider: "KJNodes.com"
      }
    ]
  },
  keywords: ["testnet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quasar/images/quasar.svg"
  }]
};
J3.default = a0e;
var jC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ti, "__esModule", { value: !0 });
Ti.chain = Ti.assets = void 0;
const o0e = jC(Y3), r0e = jC(J3);
Ti.assets = o0e.default;
Ti.chain = r0e.default;
var Wa = {}, Z3 = {};
Object.defineProperty(Z3, "__esModule", { value: !0 });
const i0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "quicksilvertestnet",
  assets: [{
    description: "QCK - native token of Quicksilver",
    denom_units: [{
      denom: "uqck",
      exponent: 0,
      aliases: []
    }, {
      denom: "qck",
      exponent: 6,
      aliases: []
    }],
    base: "uqck",
    name: "Quicksilver",
    display: "qck",
    symbol: "QCK",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.png"
    },
    coingecko_id: "quicksilver",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.png"
    }]
  }]
};
Z3.default = i0e;
var Q3 = {};
Object.defineProperty(Q3, "__esModule", { value: !0 });
const c0e = {
  $schema: "../../chain.schema.json",
  chain_name: "quicksilvertestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Quicksilver Testnet",
  chain_type: "cosmos",
  chain_id: "rhye-2",
  bech32_prefix: "quick",
  daemon_name: "quicksilverd",
  node_home: "$HOME/.quicksilverd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uqck",
      low_gas_price: 1e-4,
      average_gas_price: 1e-4,
      high_gas_price: 25e-5
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uqck"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.29"
  },
  logo_URIs: {
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.svg"
  },
  apis: {
    rpc: [
      {
        address: "http://quick.rpc.t.stavr.tech:20027",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://quicksilver-testnet-rpc.polkachu.com/",
        provider: "polkachu"
      },
      {
        address: "https://quicksilver-testnet-rpc.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ],
    rest: [
      {
        address: "https://quick.api.t.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://quicksilver-testnet-api.polkachu.com/",
        provider: "polkachu"
      },
      {
        address: "https://quicksilver-testnet-api.ibs.team:443",
        provider: "Inter Blockchain Services"
      }
    ],
    grpc: [{
      address: "http://quick.grpc.t.stavr.tech:9112",
      provider: "🔥STAVR🔥"
    }, {
      address: "quicksilver-testnet-grpc.polkachu.com:11190",
      provider: "polkachu"
    }]
  },
  explorers: [{
    kind: "🔥STAVR🔥",
    url: "https://explorer.stavr.tech/Quicksilver",
    tx_page: "https://explorer.stavr.tech/Quicksilver/tx/${txHash}",
    account_page: "https://explorer.stavr.tech/Quicksilver/account/${accountAddress}"
  }, {
    url: "https://testnet.quicksilver.explorers.guru",
    tx_page: "https://testnet.quicksilver.explorers.guru/transaction/${txHash}",
    account_page: "https://testnet.quicksilver.explorers.guru/account/${accountAddress}"
  }],
  images: [{
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/quicksilver/images/qck.svg"
  }]
};
Q3.default = c0e;
var e7 = {};
Object.defineProperty(e7, "__esModule", { value: !0 });
const d0e = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-19",
    connection_id: "connection-14"
  },
  chain_2: {
    chain_name: "quicksilvertestnet",
    client_id: "07-tendermint-6",
    connection_id: "connection-4"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-13",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-20",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
e7.default = d0e;
var n7 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Wa, "__esModule", { value: !0 });
Wa.ibc = Wa.chain = Wa.assets = void 0;
const m0e = n7(Z3), h0e = n7(Q3), p0e = n7(e7);
Wa.assets = m0e.default;
Wa.chain = h0e.default;
Wa.ibc = p0e.default;
var Ri = {}, t7 = {};
Object.defineProperty(t7, "__esModule", { value: !0 });
const l0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "qwoyntestnet",
  assets: [{
    description: "QWOYN is the native governance token for the Qwoyn Studios Platform",
    denom_units: [{
      denom: "uqwoyn",
      exponent: 0
    }, {
      denom: "qwoyn",
      exponent: 6
    }],
    base: "uqwoyn",
    name: "Qwoyn Blockchain",
    display: "qwoyn",
    symbol: "QWOYN",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/qwoyntestnet/images/qwoyn.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/qwoyntestnet/images/qwoyn.png"
    }]
  }]
};
t7.default = l0e;
var s7 = {};
Object.defineProperty(s7, "__esModule", { value: !0 });
const g0e = {
  $schema: "../../chain.schema.json",
  chain_name: "qwoyntestnet",
  status: "live",
  network_type: "testnet",
  website: "https://qwoyn.studio/",
  pretty_name: "Qwoyn",
  chain_type: "cosmos",
  chain_id: "earendel-1",
  bech32_prefix: "qwoyn",
  daemon_name: "qwoynd",
  node_home: "$HOME/.qwoynd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uqwoyn"
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uqwoyn"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47.3"
  },
  apis: {
    rpc: [{
      address: "https://testnet-rpc.qwoyn.studio",
      provider: "Qwoyn Studios"
    }],
    grpc: [{
      address: "http://66.42.74.12:9090",
      provider: "Qwoyn Studios"
    }],
    rest: [{
      address: "https://testnet-api.qwoyn.studio",
      provider: "Qwoyn Studios"
    }]
  },
  explorers: [{
    kind: "pingfork",
    url: "https://explorer.theamsolutions.info/qwoyn-testnet/",
    tx_page: "https://explorer.theamsolutions.info/qwoyn-testnet/tx/${txHash}",
    account_page: "https://explorer.theamsolutions.info/qwoyn-testnet/account/${accountAddress}"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/qwoyntestnet/images/qwoyn.png"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/qwoyntestnet/images/qwoyn.png"
  }]
};
s7.default = g0e;
var CC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ri, "__esModule", { value: !0 });
Ri.chain = Ri.assets = void 0;
const u0e = CC(t7), _0e = CC(s7);
Ri.assets = u0e.default;
Ri.chain = _0e.default;
var Va = {}, a7 = {};
Object.defineProperty(a7, "__esModule", { value: !0 });
const y0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "sagatestnet",
  assets: [{
    description: "The native token of Saga Testnet",
    denom_units: [{
      denom: "utsaga",
      exponent: 0,
      aliases: []
    }, {
      denom: "tsaga",
      exponent: 6,
      aliases: []
    }],
    base: "utsaga",
    name: "Saga",
    display: "tsaga",
    symbol: "TSAGA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.svg"
    }]
  }]
};
a7.default = y0e;
var o7 = {};
Object.defineProperty(o7, "__esModule", { value: !0 });
const b0e = {
  $schema: "../../chain.schema.json",
  chain_name: "sagatestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Saga Testnet",
  chain_type: "cosmos",
  chain_id: "ssc-testnet-1",
  bech32_prefix: "saga",
  daemon_name: "sscd",
  node_home: "$HOME/.ssc",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utsaga",
      fixed_min_gas_price: 0,
      low_gas_price: 25e-4,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "utsaga"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [{
      address: "https://testnet-ssc.sagarpc.io/",
      provider: "Saga"
    }],
    rest: [{
      address: "https://testnet-ssc-lcd.sagarpc.io/",
      provider: "Saga"
    }],
    grpc: [{
      address: "testnet-ssc-grpc.sagarpc.io:443",
      provider: "Saga"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png"
  },
  explorers: [{
    kind: "mintscan",
    url: "https://mintscan.io/saga-testnet",
    tx_page: "https://www.mintscan.io/saga-testnet/tx/${txHash}",
    account_page: "https://mintscan.io/saga-testnet/address/${accountAddress}"
  }],
  keywords: ["testnet", "chainlet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/saga/images/saga.png"
  }]
};
o7.default = b0e;
var r7 = {};
Object.defineProperty(r7, "__esModule", { value: !0 });
const v0e = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "axelartestnet",
    client_id: "07-tendermint-767",
    connection_id: "connection-581"
  },
  chain_2: {
    chain_name: "sagatestnet",
    client_id: "07-tendermint-11",
    connection_id: "connection-10"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-370",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-9",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}, {
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-1448",
    connection_id: "connection-1552"
  },
  chain_2: {
    chain_name: "sagatestnet",
    client_id: "07-tendermint-26",
    connection_id: "connection-21"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-4946",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-20",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
r7.default = v0e;
var i7 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Va, "__esModule", { value: !0 });
Va.ibc = Va.chain = Va.assets = void 0;
const f0e = i7(a7), w0e = i7(o7), x0e = i7(r7);
Va.assets = f0e.default;
Va.chain = w0e.default;
Va.ibc = x0e.default;
var Oi = {}, c7 = {};
Object.defineProperty(c7, "__esModule", { value: !0 });
const k0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "secretnetworktestnet",
  assets: [{
    description: "The native token of Secret Network",
    denom_units: [{
      denom: "uscrt",
      exponent: 0
    }, {
      denom: "scrt",
      exponent: 6
    }],
    base: "uscrt",
    name: "Secret Network",
    display: "scrt",
    symbol: "SCRT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg"
    },
    coingecko_id: "secret",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg"
    }]
  }]
};
c7.default = k0e;
var d7 = {};
Object.defineProperty(d7, "__esModule", { value: !0 });
const A0e = {
  $schema: "../../chain.schema.json",
  chain_name: "secretnetworktestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Secret Network",
  chain_type: "cosmos",
  chain_id: "pulsar-3",
  pre_fork_chain_name: "secretnetworktestnet2",
  bech32_prefix: "secret",
  daemon_name: "secretd",
  node_home: "$HOME/.secretd",
  key_algos: ["secp256k1"],
  slip44: 529,
  fees: {
    fee_tokens: [{
      denom: "uscrt",
      fixed_min_gas_price: 0.1
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc.testnet.secretsaturn.net",
      provider: "𝕊ecret 𝕊aturn"
    }, {
      address: "https://rpc.pulsar.scrttestnet.com",
      provider: "SCRT Testnet Committee"
    }],
    rest: [{
      address: "https://lcd.testnet.secretsaturn.net",
      provider: "𝕊ecret 𝕊aturn"
    }, {
      address: "https://api.pulsar.scrttestnet.com",
      provider: "SCRT Testnet Committee"
    }],
    "grpc-web": [{
      address: "https://grpc.testnet.secretsaturn.net",
      provider: "𝕊ecret 𝕊aturn"
    }, {
      address: "https://grpc.pulsar.scrttestnet.com",
      provider: "SCRT Testnet Committee"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://testnet.ping.pub/secret",
    tx_page: "https://testnet.ping.pub/secret/tx/${txHash}"
  }]
};
d7.default = A0e;
var EC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Oi, "__esModule", { value: !0 });
Oi.chain = Oi.assets = void 0;
const j0e = EC(c7), C0e = EC(d7);
Oi.assets = j0e.default;
Oi.chain = C0e.default;
var Mi = {}, m7 = {};
Object.defineProperty(m7, "__esModule", { value: !0 });
const E0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "secretnetworktestnet2",
  assets: [{
    description: "The native token of Secret Network",
    denom_units: [{
      denom: "uscrt",
      exponent: 0
    }, {
      denom: "scrt",
      exponent: 6
    }],
    base: "uscrt",
    name: "Secret Network",
    display: "scrt",
    symbol: "SCRT",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/secretnetwork/images/scrt.svg"
    }]
  }]
};
m7.default = E0e;
var h7 = {};
Object.defineProperty(h7, "__esModule", { value: !0 });
const D0e = {
  $schema: "../../chain.schema.json",
  chain_name: "secretnetworktestnet2",
  status: "killed",
  network_type: "testnet",
  pretty_name: "Secret Network Testnet",
  chain_type: "cosmos",
  chain_id: "pulsar-2",
  bech32_prefix: "secret",
  daemon_name: "secretd",
  node_home: "$HOME/.secretd",
  key_algos: ["secp256k1"],
  slip44: 529,
  fees: {
    fee_tokens: [{
      denom: "uscrt",
      fixed_min_gas_price: 0.1
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc.testnet.secretsaturn.net",
      provider: "𝕊ecret 𝕊aturn"
    }, {
      address: "https://rpc.pulsar.scrttestnet.com",
      provider: "SCRT Testnet Committee"
    }],
    rest: [
      {
        address: "http://testnet.securesecrets.org:1317",
        provider: "Trivium | Trivium.Network"
      },
      {
        address: "https://lcd.testnet.secretsaturn.net",
        provider: "𝕊ecret 𝕊aturn"
      },
      {
        address: "https://api.pulsar.scrttestnet.com",
        provider: "SCRT Testnet Committee"
      }
    ],
    "grpc-web": [{
      address: "https://grpc.testnet.secretsaturn.net",
      provider: "𝕊ecret 𝕊aturn"
    }, {
      address: "https://grpc.pulsar.scrttestnet.com",
      provider: "SCRT Testnet Committee"
    }]
  },
  explorers: [{
    kind: "secret nodes",
    url: "https://secretnodes.com/secret/chains/pulsar-2",
    tx_page: "https://secretnodes.com/secret/chains/pulsar-2/transactions/${txHash}"
  }, {
    kind: "ping.pub",
    url: "https://testnet.ping.pub/secret",
    tx_page: "https://testnet.ping.pub/secret/tx/${txHash}"
  }]
};
h7.default = D0e;
var DC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Mi, "__esModule", { value: !0 });
Mi.chain = Mi.assets = void 0;
const B0e = DC(m7), F0e = DC(h7);
Mi.assets = B0e.default;
Mi.chain = F0e.default;
var Ii = {}, p7 = {};
Object.defineProperty(p7, "__esModule", { value: !0 });
const $0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "seitestnet",
  assets: [{
    description: "The native staking and governance token of the Atlantic testnet version of Sei.",
    denom_units: [{
      denom: "usei",
      exponent: 0
    }, {
      denom: "sei",
      exponent: 6
    }],
    base: "usei",
    name: "Sei",
    display: "sei",
    symbol: "SEI",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/seitestnet/images/sei.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/seitestnet/images/sei.png"
    }]
  }]
};
p7.default = $0e;
var l7 = {};
Object.defineProperty(l7, "__esModule", { value: !0 });
const z0e = {
  $schema: "../../chain.schema.json",
  chain_name: "seitestnet",
  chain_type: "cosmos",
  chain_id: "atlantic-1",
  pretty_name: "Sei Atlantic",
  status: "live",
  network_type: "testnet",
  website: "https://www.sei.io/",
  bech32_prefix: "sei",
  daemon_name: "seid",
  node_home: "$HOME/.sei",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usei",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.svg"
  },
  description: "Sei is the fastest Layer 1 blockchain, designed to scale with the industry.",
  apis: {
    rpc: [{
      address: "https://sei-testnet-rpc.brocha.in",
      provider: "Brochain"
    }],
    rest: [{
      address: "https://sei-testnet-rest.brocha.in",
      provider: "Brochain"
    }]
  },
  explorers: [{
    kind: "explorers.guru",
    url: "https://sei.explorers.guru",
    tx_page: "https://sei.explorers.guru/transaction/${txHash}"
  }, {
    kind: "Brochain",
    url: "https://testnet-explorer.brocha.in/sei",
    tx_page: "https://testnet-explorer.brocha.in/sei/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sei/images/sei.svg"
  }]
};
l7.default = z0e;
var BC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ii, "__esModule", { value: !0 });
Ii.chain = Ii.assets = void 0;
const q0e = BC(p7), S0e = BC(l7);
Ii.assets = q0e.default;
Ii.chain = S0e.default;
var Ga = {}, g7 = {};
Object.defineProperty(g7, "__esModule", { value: !0 });
const T0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "seitestnet2",
  assets: [{
    description: "The native staking and governance token of the Atlantic testnet version of Sei.",
    denom_units: [{
      denom: "usei",
      exponent: 0
    }, {
      denom: "sei",
      exponent: 6
    }],
    base: "usei",
    name: "Sei",
    display: "sei",
    symbol: "SEI",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/seitestnet2/images/sei.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/seitestnet2/images/sei.png"
    }]
  }]
};
g7.default = T0e;
var u7 = {};
Object.defineProperty(u7, "__esModule", { value: !0 });
const R0e = {
  $schema: "../../chain.schema.json",
  chain_name: "seitestnet2",
  chain_type: "cosmos",
  chain_id: "atlantic-2",
  pretty_name: "Sei Atlantic 2",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "sei",
  daemon_name: "seid",
  node_home: "$HOME/.sei",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usei",
      fixed_min_gas_price: 0.08
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://sei-testnet-2-rpc.brocha.in",
      provider: "Brochain"
    }, {
      address: "https://rpc-testnet-sei.stingray.plus",
      provider: "StingRay"
    }],
    rest: [{
      address: "https://sei-testnet-2-rest.brocha.in",
      provider: "Brochain"
    }, {
      address: "https://api-testnet-sei.stingray.plus",
      provider: "StingRay"
    }],
    grpc: [{
      address: "https://grpc-testnet-sei.stingray.plus",
      provider: "StingRay"
    }],
    "evm-http-jsonrpc": [{
      address: "https://evm-rpc-testnet-sei.stingray.plus",
      provider: "StingRay"
    }]
  },
  explorers: [
    {
      kind: "blockscout",
      url: "https://seitrace.com/?chain=atlantic-2",
      tx_page: "https://seitrace.com/tx/${txHash}?chain=atlantic-2"
    },
    {
      kind: "celatone",
      url: "https://www.seiscan.app/atlantic-2",
      tx_page: "https://www.seiscan.app/atlantic-2/txs/${txHash}"
    },
    {
      kind: "explorers.guru",
      url: "https://testnet.sei.explorers.guru",
      tx_page: "https://testnet.sei.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "Brochain",
      url: "https://testnet-explorer.brocha.in/sei%20atlantic%202",
      tx_page: "https://testnet-explorer.brocha.in/sei%20atlantic%202/tx/${txHash}"
    }
  ]
};
u7.default = R0e;
var _7 = {};
Object.defineProperty(_7, "__esModule", { value: !0 });
const O0e = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "nobletestnet",
    client_id: "07-tendermint-44",
    connection_id: "connection-32"
  },
  chain_2: {
    chain_name: "seitestnet2",
    client_id: "07-tendermint-127",
    connection_id: "connection-107"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-23",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-75",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
_7.default = O0e;
var y7 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ga, "__esModule", { value: !0 });
Ga.ibc = Ga.chain = Ga.assets = void 0;
const M0e = y7(g7), I0e = y7(u7), N0e = y7(_7);
Ga.assets = M0e.default;
Ga.chain = I0e.default;
Ga.ibc = N0e.default;
var Ni = {}, b7 = {};
Object.defineProperty(b7, "__esModule", { value: !0 });
const P0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "selfchaindevnet",
  assets: [{
    description: "Self Chain Is the First Modular Intent-Centric Access Layer L1 Blockchain and Keyless Wallet Infrastructure Service That Uses MPC-TSS/AA for Multi-Chain Web3 Access.",
    denom_units: [{
      denom: "uself",
      exponent: 0
    }, {
      denom: "self",
      exponent: 6
    }],
    base: "uself",
    name: "self",
    display: "self",
    symbol: "SELF",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/selfchaindevnet/images/selfchain.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/selfchaindevnet/images/selfchain.png"
    }]
  }]
};
b7.default = P0e;
var v7 = {};
Object.defineProperty(v7, "__esModule", { value: !0 });
const U0e = {
  $schema: "../../chain.schema.json",
  chain_name: "selfchaindevnet",
  chain_type: "cosmos",
  chain_id: "self-dev-1",
  pretty_name: "Devnet 1",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "self",
  daemon_name: "selfchaind",
  node_home: "$HOME/.selfchain",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uself",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc-devnet.selfchain.xyz",
      provider: "Selfchain"
    }],
    rest: [{
      address: "https://api-devnet.selfchain.xyz/",
      provider: "Selfchain"
    }]
  },
  explorers: [{
    kind: "Selfchain",
    url: "https://explorer-devnet.selfchain.xyz",
    tx_page: "https://explorer-devnet.selfchain.xyz/self/transactions/${txHash}"
  }]
};
v7.default = U0e;
var FC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ni, "__esModule", { value: !0 });
Ni.chain = Ni.assets = void 0;
const H0e = FC(b7), L0e = FC(v7);
Ni.assets = H0e.default;
Ni.chain = L0e.default;
var Ka = {}, f7 = {};
Object.defineProperty(f7, "__esModule", { value: !0 });
const W0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "sgetestnet",
  assets: [{
    description: "The SGE token is primarily a governance token for the SGE Network blockchain.",
    denom_units: [{
      denom: "usge",
      exponent: 0,
      aliases: []
    }, {
      denom: "sge",
      exponent: 6,
      aliases: []
    }],
    base: "usge",
    name: "SGE Testnet",
    display: "sge",
    symbol: "SGE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sgetestnet/images/sge.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sgetestnet/images/sge.png"
    }]
  }]
};
f7.default = W0e;
var w7 = {};
Object.defineProperty(w7, "__esModule", { value: !0 });
const V0e = {
  $schema: "../../chain.schema.json",
  chain_name: "sgetestnet",
  chain_type: "cosmos",
  chain_id: "sge-network-3",
  pretty_name: "SGE Testnet",
  status: "live",
  network_type: "testnet",
  website: "https://sgenetwork.io",
  bech32_prefix: "sge",
  daemon_name: "usge",
  node_home: "$HOME/.sged",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usge",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://rpc.testnet.sgenetwork.io",
        provider: "Sge Network"
      },
      {
        address: "https://testnet-saage-rpc.lavenderfive.com/ ",
        provider: "Lavender.Five"
      },
      {
        address: "https://saage-testnet-rpc.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-t.sge.nodestake.top/",
        provider: "Nodestake.top"
      },
      {
        address: "https://sge.rpc.t.stavr.tech:443",
        provider: "🔥STAVR🔥"
      }
    ],
    rest: [
      {
        address: "https://api.testnet.sgenetwork.io",
        provider: "Sge Network"
      },
      {
        address: "https://api-t.sge.nodestake.top/",
        provider: "Nodestake.top"
      },
      {
        address: "https://saage-testnet-api.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://sge.api.t.stavr.tech",
        provider: "🔥STAVR🔥"
      }
    ]
  },
  explorers: [{
    kind: "Sge BlockExplorer",
    url: "https://blockexplorer.testnet.sgenetwork.io/",
    tx_page: "https://blockexplorer.testnet.sgenetwork.io/sge-network/tx/${txHash}"
  }, {
    kind: "🔥STAVR🔥",
    url: "https://explorer.stavr.tech/Sge-Testnet",
    tx_page: "https://explorer.stavr.tech/Sge-Testnet/tx/${txHash}",
    account_page: "https://explorer.stavr.tech/Sge-Testnet/account/${accountAddress}"
  }],
  images: [{
    image_sync: {
      chain_name: "sge"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg",
    theme: {
      primary_color_hex: "#b99952"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg"
  }
};
w7.default = V0e;
var x7 = {};
Object.defineProperty(x7, "__esModule", { value: !0 });
const G0e = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-965",
    connection_id: "connection-865"
  },
  chain_2: {
    chain_name: "sgetestnet",
    client_id: "07-tendermint-1",
    connection_id: "connection-1"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-1568",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-1",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
x7.default = G0e;
var k7 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ka, "__esModule", { value: !0 });
Ka.ibc = Ka.chain = Ka.assets = void 0;
const K0e = k7(f7), X0e = k7(w7), Y0e = k7(x7);
Ka.assets = K0e.default;
Ka.chain = X0e.default;
Ka.ibc = Y0e.default;
var Pi = {}, A7 = {};
Object.defineProperty(A7, "__esModule", { value: !0 });
const J0e = {
  $schema: "../../assetlist.schema.json",
  chain_name: "sgetestnet4",
  assets: [{
    description: "The SGE token is primarily a governance token for the SGE Network blockchain.",
    denom_units: [{
      denom: "usge",
      exponent: 0
    }, {
      denom: "sge",
      exponent: 6
    }],
    base: "usge",
    name: "SGE Testnet4",
    display: "sge",
    symbol: "SGE",
    traces: [{
      type: "additional-mintage",
      counterparty: {
        chain_name: "sgetestnet",
        base_denom: "usge"
      },
      provider: "SGE"
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg"
    },
    images: [{
      image_sync: {
        chain_name: "sge",
        base_denom: "usge"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg",
      theme: {
        primary_color_hex: "#C0A15B",
        background_color_hex: "#00000000",
        circle: !1
      }
    }]
  }]
};
A7.default = J0e;
var j7 = {};
Object.defineProperty(j7, "__esModule", { value: !0 });
const Z0e = {
  $schema: "../../chain.schema.json",
  chain_name: "sgetestnet4",
  chain_type: "cosmos",
  chain_id: "sge-network-4",
  pretty_name: "SGE Testnet4",
  status: "live",
  network_type: "testnet",
  website: "https://sgenetwork.io",
  bech32_prefix: "sge",
  daemon_name: "usge",
  node_home: "$HOME/.sged",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usge",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://rpc.testnet.sgenetwork.io",
        provider: "Sge Network"
      },
      {
        address: "https://testnet-saage-rpc.lavenderfive.com/ ",
        provider: "Lavender.Five"
      },
      {
        address: "https://saage-testnet-rpc.polkachu.com/",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-t.sge.nodestake.top/",
        provider: "Nodestake.top"
      }
    ],
    rest: [
      {
        address: "https://api.testnet.sgenetwork.io",
        provider: "Sge Network"
      },
      {
        address: "https://api-t.sge.nodestake.top/",
        provider: "Nodestake.top"
      },
      {
        address: "https://saage-testnet-api.polkachu.com/",
        provider: "Polkachu"
      }
    ]
  },
  explorers: [{
    kind: "Sge BlockExplorer",
    url: "https://blockexplorer.testnet.sgenetwork.io/",
    tx_page: "https://blockexplorer.testnet.sgenetwork.io/sge-network/tx/${txHash}"
  }],
  images: [{
    image_sync: {
      chain_name: "sge"
    },
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg",
    theme: {
      primary_color_hex: "#b99952"
    }
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sge/images/sge.svg"
  }
};
j7.default = Z0e;
var $C = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Pi, "__esModule", { value: !0 });
Pi.chain = Pi.assets = void 0;
const Q0e = $C(A7), eye = $C(j7);
Pi.assets = Q0e.default;
Pi.chain = eye.default;
var Ui = {}, C7 = {};
Object.defineProperty(C7, "__esModule", { value: !0 });
const nye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "sixtestnet",
  assets: [{
    description: "The native staking token of the SIX Protocol.",
    denom_units: [{
      denom: "usix",
      exponent: 0
    }, {
      denom: "six",
      exponent: 6
    }],
    base: "usix",
    name: "Six token",
    display: "six",
    symbol: "six",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/sixtestnet/images/six.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/sixtestnet/images/six.png"
    }]
  }]
};
C7.default = nye;
var E7 = {};
Object.defineProperty(E7, "__esModule", { value: !0 });
const tye = {
  $schema: "../../chain.schema.json",
  chain_name: "sixtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "SIX Fivenet",
  chain_type: "cosmos",
  chain_id: "fivenet",
  bech32_prefix: "6x",
  daemon_name: "sixd",
  node_home: "$HOME/.six",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usix",
      fixed_min_gas_price: 1.25,
      low_gas_price: 1.25,
      average_gas_price: 1.5,
      high_gas_price: 1.75
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "usix"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45"
  },
  apis: {
    rpc: [{
      address: "https://rpc1.fivenet.sixprotocol.net:443"
    }],
    rest: [{
      address: "https://api1.fivenet.sixprotocol.net:443"
    }]
  },
  explorers: [{
    kind: "sixscan",
    url: "https://sixscan.io/fivenet",
    tx_page: "https://sixscan.io/fivenet/tx/${txHash}"
  }],
  keywords: ["sixprotocol", "testnet"]
};
E7.default = tye;
var zC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ui, "__esModule", { value: !0 });
Ui.chain = Ui.assets = void 0;
const sye = zC(C7), aye = zC(E7);
Ui.assets = sye.default;
Ui.chain = aye.default;
var Hi = {}, D7 = {};
Object.defineProperty(D7, "__esModule", { value: !0 });
const oye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "soarchaintestnet",
  assets: [{
    description: "The native staking coin of the Soarchain-core.",
    denom_units: [{
      denom: "utsoar",
      exponent: 0,
      aliases: ["microtsoar"]
    }, {
      denom: "tsoar",
      exponent: 6
    }],
    base: "utsoar",
    display: "tsoar",
    name: "tsoar",
    symbol: "tsoar",
    keywords: ["DePin"],
    socials: {
      website: "https://www.soarchain.com",
      twitter: "https://x.com/soar_chain"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/soarchaintestnet/images/soarchain.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/soarchaintestnet/images/soarchain.svg"
    }]
  }]
};
D7.default = oye;
var B7 = {};
Object.defineProperty(B7, "__esModule", { value: !0 });
const rye = {
  $schema: "../../chain.schema.json",
  chain_name: "soarchaintestnet",
  chain_type: "cosmos",
  chain_id: "soarchaintestnet",
  pretty_name: "Soarchain Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "soar",
  daemon_name: "soarchaind",
  node_home: "$HOME/.soarchaind",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utsoar",
      fixed_min_gas_price: 1e-3,
      low_gas_price: 0.01,
      average_gas_price: 0.02,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "utsoar"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45.5",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.27"
  },
  keywords: ["DePin"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/soarchaintestnet/images/soarchain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/soarchaintestnet/images/soarchain.svg"
  }],
  apis: {
    rpc: [
      {
        address: "https://rpc1.testnet.soarchain.com",
        provider: "soarchain"
      },
      {
        address: "https://rpc2.testnet.soarchain.com/",
        provider: "soarchain"
      },
      {
        address: "https://soarchain-testnet-rpc.tienthuattoan.com",
        provider: "tienthuattoan"
      },
      {
        address: "https://soarchain-testnet.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://rpc-t.soarchain.nodestake.org",
        provider: "nodeStake"
      },
      {
        address: "https://soarchain-testnet-rpc.stakerhouse.com",
        provider: "stakerHouse"
      }
    ],
    rest: [
      {
        address: "https://api.testnet.soarchain.com/",
        provider: "soarchain"
      },
      {
        address: "https://soarchain-testnet-api.tienthuattoan.com",
        provider: "tienthuattoan"
      },
      {
        address: "https://soarchain-testnet-rest.stakerhouse.com",
        provider: "stakerHouse"
      },
      {
        address: "https://api-t.soarchain.nodestake.org",
        provider: "nodeStake"
      }
    ],
    grpc: [
      {
        address: "soarchain-testnet-grpc.polkachu.com:25290",
        provider: "Polkachu"
      },
      {
        address: "https://grpc-t.soarchain.nodestake.org:443",
        provider: "nodeStake"
      },
      {
        address: "soarchain-testnet-grpc.stakerhouse.com:443",
        provider: "stakerHouse"
      }
    ]
  },
  explorers: [{
    kind: "Soarchain Explorer",
    url: "https://explorer.soarchain.com/soarchain",
    tx_page: "https://explorer.soarchain.com/soarchain/tx/${txHash}"
  }, {
    kind: "Kjnodes Explorer",
    url: "https://explorer.kjnodes.com/soarchain-testnet",
    tx_page: "https://explorer.kjnodes.com/soarchain-testnet/tx/${txHash}"
  }]
};
B7.default = rye;
var qC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Hi, "__esModule", { value: !0 });
Hi.chain = Hi.assets = void 0;
const iye = qC(D7), cye = qC(B7);
Hi.assets = iye.default;
Hi.chain = cye.default;
var Li = {}, F7 = {};
Object.defineProperty(F7, "__esModule", { value: !0 });
const dye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "sourcetestnet",
  assets: [{
    description: "The native token of SOURCE Chain",
    denom_units: [{
      denom: "usource",
      exponent: 0
    }, {
      denom: "source",
      exponent: 6
    }],
    base: "usource",
    name: "Source Testnet",
    display: "source",
    symbol: "SOURCE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/sourcetestnet/images/source.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/sourcetestnet/images/source.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/sourcetestnet/images/source.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/sourcetestnet/images/source.svg"
    }]
  }]
};
F7.default = dye;
var $7 = {};
Object.defineProperty($7, "__esModule", { value: !0 });
const mye = {
  $schema: "../../chain.schema.json",
  chain_name: "sourcetestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Source Testnet",
  chain_type: "cosmos",
  chain_id: "sourcetest-1",
  bech32_prefix: "source",
  daemon_name: "sourced",
  node_home: "$HOME/.source",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "usource",
      fixed_min_gas_price: 0.05,
      low_gas_price: 0.05,
      average_gas_price: 0.075,
      high_gas_price: 0.1
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "usource"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30"
  },
  apis: {
    rpc: [
      {
        address: "https://source-testnet-rpc.itrocket.net/",
        provider: "ITRocket"
      },
      {
        address: "https://source-test.rpc.moonbridge.team/",
        provider: "MoonBridge"
      },
      {
        address: "https://source-testnet-rpc.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "https://rpc-testnet-source.sr20de.xyz",
        provider: "SR20DE"
      },
      {
        address: "https://source-testnet.rpc.kjnodes.com",
        provider: "kjnodes"
      },
      {
        address: "https://source_testnet_rpc.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    rest: [
      {
        address: "https://source-testnet-api.itrocket.net/",
        provider: "ITRocket"
      },
      {
        address: "https://source-test.api.moonbridge.team/",
        provider: "MoonBridge"
      },
      {
        address: "https://source-testnet-api.stake-town.com:443",
        provider: "StakeTown"
      },
      {
        address: "https://api-testnet-source.sr20de.xyz",
        provider: "SR20DE"
      },
      {
        address: "https://source.api.t.stavr.tech",
        provider: "🔥STAVR🔥"
      },
      {
        address: "https://source_testnet_api.chain.whenmoonwhenlambo.money",
        provider: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥"
      }
    ],
    grpc: [{
      address: "source-testnet-grpc.stake-town.com:443",
      provider: "StakeTown"
    }, {
      address: "grpc-testnet-source.sr20de.xyz/",
      provider: "SR20DE"
    }]
  },
  explorers: [
    {
      kind: "Nodestake",
      url: "https://explorer.nodestake.top/source-testnet",
      tx_page: "https://explorer.nodestake.top/source-testnet/tx/${txHash}"
    },
    {
      kind: "🔥STAVR🔥",
      url: "https://explorer.stavr.tech/Source",
      tx_page: "https://explorer.stavr.tech/Source/tx/${txHash}"
    },
    {
      kind: "SR20DE",
      url: "https://explorer.sr20de.xyz/Source-testnet",
      tx_page: "https://explorer.sr20de.xyz/Source-testnet/txs/${txHash}"
    },
    {
      kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
      url: "https://explorer.whenmoonwhenlambo.money/source-testnet",
      tx_page: "https://explorer.whenmoonwhenlambo.money/source-testnet/tx/${txHash}",
      account_page: "https://explorer.whenmoonwhenlambo.money/source-testnet/account/${accountAddress}"
    }
  ]
};
$7.default = mye;
var SC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Li, "__esModule", { value: !0 });
Li.chain = Li.assets = void 0;
const hye = SC(F7), pye = SC($7);
Li.assets = hye.default;
Li.chain = pye.default;
var Xa = {}, z7 = {};
Object.defineProperty(z7, "__esModule", { value: !0 });
const lye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "stargazetestnet",
  assets: [{
    description: "The native token of Stargaze",
    denom_units: [{
      denom: "ustars",
      exponent: 0
    }, {
      denom: "stars",
      exponent: 6
    }],
    base: "ustars",
    name: "Stargaze",
    display: "stars",
    symbol: "STARS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png"
    },
    coingecko_id: "stargaze",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png"
    }]
  }]
};
z7.default = lye;
var q7 = {};
Object.defineProperty(q7, "__esModule", { value: !0 });
const gye = {
  $schema: "../../chain.schema.json",
  chain_name: "stargazetestnet",
  status: "live",
  network_type: "testnet",
  website: "https://stargaze.zone/",
  pretty_name: "Stargaze Testnet",
  chain_type: "cosmos",
  chain_id: "elgafar-1",
  bech32_prefix: "stars",
  daemon_name: "starsd",
  node_home: "$HOME/.starsd",
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ustars",
      low_gas_price: 0.03,
      average_gas_price: 0.04,
      high_gas_price: 0.05
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.28"
  },
  apis: {
    rpc: [{
      address: "https://rpc.elgafar-1.stargaze-apis.com",
      provider: "Stargaze Foundation"
    }, {
      address: "https://stargaze-testnet-rpc.ibs.team:443",
      provider: "Inter Blockchain Services"
    }],
    rest: [{
      address: "https://rest.elgafar-1.stargaze-apis.com",
      provider: "Stargaze Foundation"
    }, {
      address: "https://stargaze-testnet-api.ibs.team:443",
      provider: "Inter Blockchain Services"
    }],
    grpc: [{
      address: "http://grpc-1.elgafar-1.stargaze-apis.com:26660",
      provider: "Stargaze Foundation"
    }, {
      address: "http://grpc-2.elgafar-1.stargaze-apis.com:26660",
      provider: "Stargaze Foundation"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://testnet-explorer.publicawesome.dev/stargaze",
    tx_page: "https://testnet-explorer.publicawesome.dev/stargaze/tx/${txHash}"
  }]
};
q7.default = gye;
var S7 = {};
Object.defineProperty(S7, "__esModule", { value: !0 });
const uye = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "empowertestnet",
      client_id: "07-tendermint-2",
      connection_id: "connection-1"
    },
    chain_2: {
      chain_name: "stargazetestnet",
      client_id: "07-tendermint-450",
      connection_id: "connection-469"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-1",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-459",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "noistestnet",
      client_id: "07-tendermint-39",
      connection_id: "connection-23"
    },
    chain_2: {
      chain_name: "stargazetestnet",
      client_id: "07-tendermint-483",
      connection_id: "connection-500"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-48",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-485",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }, {
      chain_1: {
        channel_id: "channel-49",
        port_id: "wasm.nois1xwde9rzqk5u36fke0r9ddmtwvh43n4fv53c5vc462wz8xlnqjhls6d90xc"
      },
      chain_2: {
        channel_id: "channel-486",
        port_id: "wasm.stars1h99p7u2tvz79jppjwdddmkplvcpnsh0pmatl7dqkmdhnkgx59y2q6s0x9s"
      },
      ordering: "unordered",
      version: "nois-v7",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-1274",
      connection_id: "connection-1175"
    },
    chain_2: {
      chain_name: "stargazetestnet",
      client_id: "07-tendermint-621",
      connection_id: "connection-633"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4175",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-638",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "stargazetestnet",
      client_id: "07-tendermint-952",
      connection_id: "connection-947"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-998",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "stargazetestnet",
      client_id: "07-tendermint-764",
      connection_id: "connection-753"
    },
    chain_2: {
      chain_name: "titantestnet",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-807",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "killed",
        preferred: !0
      }
    }]
  }
];
S7.default = uye;
var T7 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Xa, "__esModule", { value: !0 });
Xa.ibc = Xa.chain = Xa.assets = void 0;
const _ye = T7(z7), yye = T7(q7), bye = T7(S7);
Xa.assets = _ye.default;
Xa.chain = yye.default;
Xa.ibc = bye.default;
var Wi = {}, R7 = {};
Object.defineProperty(R7, "__esModule", { value: !0 });
const vye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "statesettestnet",
  assets: [{
    description: "The native token of the Stateset Network",
    denom_units: [{
      denom: "ustate",
      exponent: 0,
      aliases: []
    }, {
      denom: "state",
      exponent: 6,
      aliases: []
    }],
    base: "ustate",
    name: "Stateset",
    display: "state",
    symbol: "STATE"
  }]
};
R7.default = vye;
var O7 = {};
Object.defineProperty(O7, "__esModule", { value: !0 });
const fye = {
  $schema: "../../chain.schema.json",
  chain_name: "statesettestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Stateset Testnet",
  chain_type: "cosmos",
  chain_id: "stateset-1-testnet",
  bech32_prefix: "stateset",
  daemon_name: "statesetd",
  node_home: "$HOME/.statesetd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ustate",
      fixed_min_gas_price: 0
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc.stateset.zone/",
      provider: "stateset"
    }],
    rest: [{
      address: "https://rest-api.stateset.zone",
      provider: "stateset"
    }]
  },
  explorers: [{
    kind: "bigdipper",
    url: "https://explore.stateset.zone",
    tx_page: "https://explore.stateset.zone/transactions/${txHash}"
  }]
};
O7.default = fye;
var TC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Wi, "__esModule", { value: !0 });
Wi.chain = Wi.assets = void 0;
const wye = TC(R7), xye = TC(O7);
Wi.assets = wye.default;
Wi.chain = xye.default;
var Vi = {}, M7 = {};
Object.defineProperty(M7, "__esModule", { value: !0 });
const kye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "stridetestnet",
  assets: [{
    description: "The native token of Stride",
    denom_units: [{
      denom: "ustrd",
      exponent: 0
    }, {
      denom: "strd",
      exponent: 6
    }],
    base: "ustrd",
    name: "Stride",
    display: "strd",
    symbol: "STRD",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/stride/images/strd.svg"
    }]
  }]
};
M7.default = kye;
var I7 = {};
Object.defineProperty(I7, "__esModule", { value: !0 });
const Aye = {
  $schema: "../../chain.schema.json",
  chain_name: "stridetestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Stride Testnet",
  chain_type: "cosmos",
  chain_id: "stride-internal-1",
  bech32_prefix: "stride",
  daemon_name: "strided",
  node_home: "$HOME/.stride",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "ustrd",
      fixed_min_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "ustrd"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46"
  },
  apis: {
    rpc: [{
      address: "https://stride.testnet-1.stridenet.co",
      provider: "Stride"
    }],
    rest: [{
      address: "https://stride.testnet-1.stridenet.co/api",
      provider: "Stride"
    }],
    grpc: []
  },
  explorers: [{
    kind: "PingPub",
    url: "https://testnet.ping.pub/stride",
    tx_page: "https://testnet.ping.pub/stride/tx/${txHash}"
  }]
};
I7.default = Aye;
var RC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Vi, "__esModule", { value: !0 });
Vi.chain = Vi.assets = void 0;
const jye = RC(M7), Cye = RC(I7);
Vi.assets = jye.default;
Vi.chain = Cye.default;
var Gi = {}, N7 = {};
Object.defineProperty(N7, "__esModule", { value: !0 });
const Eye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "sunrisetestnet",
  assets: [{
    description: "The native token of the Sunrise network for staking. This token is non transferrable. This token can be retrieved by providing liquidity.",
    denom_units: [{
      denom: "uvrise",
      exponent: 0,
      aliases: ["microvRISE", "microvrise"]
    }, {
      denom: "vrise",
      exponent: 6
    }],
    base: "uvrise",
    name: "Sunrise vRISE",
    display: "vrise",
    symbol: "vRISE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/vrise.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/vrise.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/vrise.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/vrise.png"
    }],
    socials: {
      website: "https://sunriselayer.io/",
      twitter: "https://twitter.com/SunriseLayer"
    }
  }, {
    description: "The native token of the Sunrise network for fees.",
    denom_units: [{
      denom: "urise",
      exponent: 0,
      aliases: ["microRISE", "microrise"]
    }, {
      denom: "rise",
      exponent: 6
    }],
    base: "urise",
    name: "Sunrise RISE",
    display: "rise",
    symbol: "RISE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.svg"
    },
    images: [{
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.png"
    }],
    socials: {
      website: "https://sunriselayer.io/",
      twitter: "https://twitter.com/SunriseLayer"
    }
  }]
};
N7.default = Eye;
var P7 = {};
Object.defineProperty(P7, "__esModule", { value: !0 });
const Dye = {
  $schema: "../../chain.schema.json",
  chain_name: "sunrisetestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Sunrise Testnet",
  chain_type: "cosmos",
  chain_id: "sunrise-test-0.1",
  bech32_prefix: "sunrise",
  daemon_name: "sunrised",
  node_home: "$HOME/.sunrise",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "urise",
      fixed_min_gas_price: 0,
      low_gas_price: 25e-4,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uvrise"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.50.2"
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.svg"
  },
  apis: {
    rpc: [{
      address: "https://a-node.sunrise-test-1.cauchye.net/",
      provider: "CauchyE"
    }, {
      address: "https://b-node.sunrise-test-1.cauchye.net/",
      provider: "CauchyE"
    }],
    rest: [{
      address: "https://a-node.sunrise-test-1.cauchye.net:1318",
      provider: "CauchyE"
    }, {
      address: "https://b-node.sunrise-test-1.cauchye.net:1318",
      provider: "CauchyE"
    }],
    grpc: [{
      address: "https://a.sunrise-test-1.cauchye.net:9092",
      provider: "CauchyE"
    }, {
      address: "https://b.sunrise-test-1.cauchye.net:9092",
      provider: "CauchyE"
    }]
  },
  explorers: [],
  images: [{
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.svg",
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/sunrise/images/sunrise.png"
  }]
};
P7.default = Dye;
var OC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Gi, "__esModule", { value: !0 });
Gi.chain = Gi.assets = void 0;
const Bye = OC(N7), Fye = OC(P7);
Gi.assets = Bye.default;
Gi.chain = Fye.default;
var Ya = {}, U7 = {};
Object.defineProperty(U7, "__esModule", { value: !0 });
const $ye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "swisstroniktestnet",
  assets: [{
    description: "The native currency of Swisstronik.",
    denom_units: [{
      denom: "aswtr",
      exponent: 0
    }, {
      denom: "swtr",
      exponent: 18
    }],
    base: "aswtr",
    name: "Swisstronik Testnet",
    display: "swtr",
    symbol: "SWTR",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/swisstroniktestnet/images/swisstronik.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/swisstroniktestnet/images/swisstronik.png"
    }]
  }]
};
U7.default = $ye;
var H7 = {};
Object.defineProperty(H7, "__esModule", { value: !0 });
const zye = {
  $schema: "../../chain.schema.json",
  chain_name: "swisstroniktestnet",
  chain_type: "cosmos",
  chain_id: "swisstronik_1291-1",
  pretty_name: "Swisstronik Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "swtr",
  daemon_name: "swisstronikd",
  node_home: "$HOME/.swisstronik",
  key_algos: ["secp256k1"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "aswtr",
      fixed_min_gas_price: 7
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "aswtr"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47"
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.testnet.swisstronik.com",
        provider: "Swisstronik"
      },
      {
        address: "https://testnet-swisstronik-rpc.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://rpc.swisstronik.comunitynode.my.id",
        provider: "ComunityNode"
      }
    ],
    rest: [
      {
        address: "https://api.testnet.swisstronik.com",
        provider: "Swisstronik"
      },
      {
        address: "https://testnet-swisstronik-api.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://rest.swisstronik.comunitynode.my.id/",
        provider: "Comunitynode"
      }
    ],
    grpc: [{
      address: "testnet-swisstronik-grpc.genznodes.dev:20090",
      provider: "genznodes"
    }],
    "evm-http-jsonrpc": [
      {
        address: "https://json-rpc.testnet.swisstronik.com",
        provider: "Swisstronik"
      },
      {
        address: "https://testnet-swisstronik-rpc-evm.genznodes.dev",
        provider: "genznodes"
      },
      {
        address: "https://evm.swisstronik.comunitynode.my.id",
        provider: "comunitynode"
      }
    ]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://explorer-cosmos.testnet.swisstronik.com/swisstronik",
    tx_page: "https://explorer-cosmos.testnet.swisstronik.com/swisstronik/tx/${txHash}"
  }]
};
H7.default = zye;
var L7 = {};
Object.defineProperty(L7, "__esModule", { value: !0 });
const qye = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "osmosistestnet",
    client_id: "07-tendermint-3714",
    connection_id: "connection-3238"
  },
  chain_2: {
    chain_name: "swisstroniktestnet",
    client_id: "07-tendermint-31",
    connection_id: "connection-18"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-8295",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-2",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0,
      dex: "osmosis"
    }
  }]
}];
L7.default = qye;
var W7 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ya, "__esModule", { value: !0 });
Ya.ibc = Ya.chain = Ya.assets = void 0;
const Sye = W7(U7), Tye = W7(H7), Rye = W7(L7);
Ya.assets = Sye.default;
Ya.chain = Tye.default;
Ya.ibc = Rye.default;
var Ja = {}, V7 = {};
Object.defineProperty(V7, "__esModule", { value: !0 });
const Oye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "symphonytestnet",
  assets: [
    {
      description: "The native token of Symphony",
      denom_units: [{
        denom: "note",
        exponent: 0,
        aliases: []
      }, {
        denom: "mld",
        exponent: 6,
        aliases: ["melody"]
      }],
      type_asset: "sdk.coin",
      base: "note",
      name: "Melody",
      display: "mld",
      symbol: "MLD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/symphonytestnet/images/mld.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/symphonytestnet/images/mld.png"
      }]
    },
    {
      description: "Harmonized USD",
      denom_units: [{
        denom: "uusd",
        exponent: 0,
        aliases: []
      }, {
        denom: "husd",
        exponent: 6,
        aliases: ["harmony USD"]
      }],
      type_asset: "sdk.coin",
      base: "uusd",
      name: "Harmony USD",
      display: "husd",
      symbol: "HUSD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/symphonytestnet/images/husd.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/symphonytestnet/images/husd.png"
      }]
    },
    {
      description: "Harmonized HKD",
      denom_units: [{
        denom: "ukhd",
        exponent: 0,
        aliases: []
      }, {
        denom: "hkhd",
        exponent: 6,
        aliases: ["harmony HKD"]
      }],
      type_asset: "sdk.coin",
      base: "ukhd",
      name: "Harmony HKD",
      display: "hkhd",
      symbol: "HKHD",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/symphonytestnet/images/hhkd.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/symphonytestnet/images/hhkd.png"
      }]
    },
    {
      description: "Harmonized VND",
      denom_units: [{
        denom: "uvnd",
        exponent: 0,
        aliases: []
      }, {
        denom: "hvnd",
        exponent: 6,
        aliases: ["harmony VND"]
      }],
      type_asset: "sdk.coin",
      base: "uvnd",
      name: "Harmony VND",
      display: "hvnd",
      symbol: "HVND",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/symphonytestnet/images/hvnd.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/symphonytestnet/images/hvnd.png"
      }]
    }
  ]
};
V7.default = Oye;
var G7 = {};
Object.defineProperty(G7, "__esModule", { value: !0 });
const Mye = {
  $schema: "../../chain.schema.json",
  chain_name: "symphonytestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Symphony Testnet",
  chain_type: "cosmos",
  chain_id: "symphony-testnet-3",
  bech32_prefix: "symphony",
  daemon_name: "symphonyd",
  node_home: "$HOME/.symphonyd",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "note",
      fixed_min_gas_price: 0,
      low_gas_price: 25e-4,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "note"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47.8",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30"
  },
  apis: {
    rpc: [{
      address: "https://symphony.test.rpc.nodeshub.online/",
      provider: "Nodes Hub"
    }, {
      address: "https://symphony-testnet-rpc.cogwheel.zone/",
      provider: "Cogwheel ⚙️"
    }],
    rest: [{
      address: "https://symphony.test.api.nodeshub.online/",
      provider: "Nodes Hub"
    }, {
      address: "https://symphony-testnet-api.cogwheel.zone/",
      provider: "Cogwheel ⚙️"
    }],
    grpc: [{
      address: "https://symphony.test.grpc.nodeshub.online/",
      provider: "Nodes Hub"
    }, {
      address: "https://symphony-testnet-grpc.cogwheel.zone:443",
      provider: "Cogwheel ⚙️"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/symphonytestnet/images/symphony_logo.png"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/symphonytestnet/images/symphony_logo.png"
  }]
};
G7.default = Mye;
var K7 = {};
Object.defineProperty(K7, "__esModule", { value: !0 });
const Iye = [
  {
    $schema: "../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-3748",
      connection_id: "connection-3798"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-29",
      connection_id: "connection-14"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4320",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-12",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "archwaytestnet",
      client_id: "07-tendermint-139",
      connection_id: "connection-144"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-25",
      connection_id: "connection-12"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-495",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-10",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-3730",
      connection_id: "connection-3782"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-10",
      connection_id: "connection-9"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-4300",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "junotestnet",
      client_id: "07-tendermint-789",
      connection_id: "connection-868"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-28",
      connection_id: "connection-13"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-943",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-11",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3946",
      connection_id: "connection-3419"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-8743",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0,
        dex: "osmosis"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "stargazetestnet",
      client_id: "07-tendermint-952",
      connection_id: "connection-947"
    },
    chain_2: {
      chain_name: "symphonytestnet",
      client_id: "07-tendermint-4",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-998",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-4",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
K7.default = Iye;
var X7 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ja, "__esModule", { value: !0 });
Ja.ibc = Ja.chain = Ja.assets = void 0;
const Nye = X7(V7), Pye = X7(G7), Uye = X7(K7);
Ja.assets = Nye.default;
Ja.chain = Pye.default;
Ja.ibc = Uye.default;
var Ki = {}, Y7 = {};
Object.defineProperty(Y7, "__esModule", { value: !0 });
const Hye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "synternettestnet",
  assets: [{
    description: "The native staking and governance token of the testnet version of Synternet chain.",
    denom_units: [{
      denom: "uamber",
      exponent: 0
    }, {
      denom: "AMBER",
      exponent: 6
    }],
    base: "uamber",
    name: "Synternet",
    display: "AMBER",
    symbol: "AMBER",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.svg"
    },
    images: [{
      image_sync: {
        chain_name: "synternet",
        base_denom: "usynt"
      },
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/synternet/images/synt.svg",
      theme: {
        primary_color_hex: "#272d45"
      }
    }]
  }]
};
Y7.default = Hye;
var J7 = {};
Object.defineProperty(J7, "__esModule", { value: !0 });
const Lye = {
  $schema: "../../chain.schema.json",
  chain_name: "synternettestnet",
  chain_type: "cosmos",
  chain_id: "amber-2",
  pretty_name: "Amber Public Testnet",
  status: "live",
  network_type: "testnet",
  bech32_prefix: "amber",
  daemon_name: "amberd",
  node_home: "$HOME/.amber",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uamber",
      fixed_min_gas_price: 0.01,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uamber"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc-testnet.synternet.com/",
      provider: "Synternet"
    }],
    rest: [{
      address: "https://api-testnet.synternet.com/",
      provider: "Synternet"
    }]
  },
  explorers: [{
    kind: "Big Dipper",
    url: "https://explorer-testnet.synternet.com/",
    tx_page: "https://explorer-testnet.synternet.com/transactions/${txHash}"
  }]
};
J7.default = Lye;
var MC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ki, "__esModule", { value: !0 });
Ki.chain = Ki.assets = void 0;
const Wye = MC(Y7), Vye = MC(J7);
Ki.assets = Wye.default;
Ki.chain = Vye.default;
var Xi = {}, Z7 = {};
Object.defineProperty(Z7, "__esModule", { value: !0 });
const Gye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "temporaltestnet",
  assets: [{
    description: "The native staking and governance token of the testnet version of Temporal.",
    denom_units: [{
      denom: "utprl",
      exponent: 0
    }, {
      denom: "tprl",
      exponent: 6
    }],
    base: "utprl",
    name: "TPRL",
    display: "tprl",
    symbol: "TPRL",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/temporaltestnet/images/temporal.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/temporaltestnet/images/temporal.png"
    }]
  }]
};
Z7.default = Gye;
var Q7 = {};
Object.defineProperty(Q7, "__esModule", { value: !0 });
const Kye = {
  $schema: "../../chain.schema.json",
  chain_name: "temporaltestnet",
  chain_type: "cosmos",
  chain_id: "temporal-test-2",
  pretty_name: "Temporal Testnet",
  status: "killed",
  network_type: "testnet",
  bech32_prefix: "temporal",
  daemon_name: "temporald",
  node_home: "$HOME/.temporal",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "utprl",
      fixed_min_gas_price: 0
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "utprl"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://rpc.yieldmos.com/temporal-test-2",
      provider: "Yieldmos"
    }, {
      address: "https://testnet-temporal-rpc.lavenderfive.com:443",
      provider: "Lavender.Five"
    }],
    rest: [{
      address: "https://lcd.yieldmos.com/temporal-test-2",
      provider: "Yieldmos"
    }, {
      address: "https://testnet-temporal-api.lavenderfive.com:443",
      provider: "Lavender.Five"
    }],
    grpc: [{
      address: "142.132.157.153:24190",
      provider: "Yieldmos"
    }]
  },
  explorers: [
    {
      kind: "ping.pub",
      url: "https://testnet.explorer.thesilverfox.pro/temporal",
      tx_page: "https://testnet.explorer.thesilverfox.pro/temporal/tx/${txHash}"
    },
    {
      kind: "Nodes.Guru",
      url: "https://testnet.temporal.explorers.guru",
      tx_page: "https://testnet.temporal.explorers.guru/transaction/${txHash}"
    },
    {
      kind: "ping.pub",
      url: "https://testnet.ping.pub/temporal",
      tx_page: "https://testnet.ping.pub/temporal/tx/${txHash}"
    }
  ]
};
Q7.default = Kye;
var IC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Xi, "__esModule", { value: !0 });
Xi.chain = Xi.assets = void 0;
const Xye = IC(Z7), Yye = IC(Q7);
Xi.assets = Xye.default;
Xi.chain = Yye.default;
var Yi = {}, e5 = {};
Object.defineProperty(e5, "__esModule", { value: !0 });
const Jye = {
  $schema: "../../assetlist.schema.json",
  chain_name: "terpnettestnet",
  assets: [{
    description: "Terp Token (TERP) is the Terp Network's native utility token, used as the primary means to govern, secure the blockchain, incentivize participants, and provide a default mechanism to store and exchange value.",
    denom_units: [{
      denom: "uterpx",
      exponent: 0
    }, {
      denom: "terpx",
      exponent: 6
    }],
    base: "uterpx",
    name: "Terp Testnet Token",
    display: "terpx",
    symbol: "TERPX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/terp.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/terp.png"
    }]
  }, {
    description: "Persy Gas Token (Persy) is the Terp Network's native utility token, used as the primary means to govern, secure the blockchain, incentivize participants, and provide a default mechanism to store and exchange value.",
    denom_units: [{
      denom: "uthiolx",
      exponent: 0
    }, {
      denom: "thiolx",
      exponent: 6
    }],
    base: "uthiolx",
    name: "Thiol Testnet Gas Token",
    display: "thiolx",
    symbol: "THIOLX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/thiol.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/thiol.png"
    }]
  }]
};
e5.default = Jye;
var n5 = {};
Object.defineProperty(n5, "__esModule", { value: !0 });
const Zye = {
  $schema: "../../chain.schema.json",
  chain_name: "terpnettestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Terp-Network",
  chain_type: "cosmos",
  chain_id: "90u-4",
  bech32_prefix: "terp",
  daemon_name: "terpd",
  node_home: "$HOME/.terp",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uthiolx",
      fixed_min_gas_price: 0.5,
      low_gas_price: 0.75,
      average_gas_price: 1,
      high_gas_price: 1.25
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uterpx"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://testnet-rpc.terp.network:443/",
      provider: "Terpnet Foundation"
    }, {
      address: "https://terp-testnet-rpc.itrocket.net:443/",
      provider: "itrocket"
    }],
    rest: [{
      address: "https://testnet-api.terp.network:443/",
      provider: "Terpnet Foundation"
    }, {
      address: "https://terp-testnet-api.itrocket.net:443/",
      provider: "itrocket"
    }],
    grpc: [{
      address: "terp-testnet-grpc.itrocket.net/",
      provider: "itrocket"
    }]
  },
  explorers: [{
    kind: "Ping Pub",
    url: "https://explorer.nodestake.top/terp-testnet",
    tx_page: "https://explorer.nodestake.top/terp-testnet/tx/${txHash}"
  }, {
    kind: "NODEXPLORER",
    url: "https://explorer.nodexcapital.com",
    tx_page: "https://explorer.nodexcapital.com/terp/tx/${txHash}",
    account_page: "https://explorer.nodexcapital.com/terp/account/{$accountAddress}"
  }]
};
n5.default = Zye;
var NC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Yi, "__esModule", { value: !0 });
Yi.chain = Yi.assets = void 0;
const Qye = NC(e5), ebe = NC(n5);
Yi.assets = Qye.default;
Yi.chain = ebe.default;
var Ji = {}, t5 = {};
Object.defineProperty(t5, "__esModule", { value: !0 });
const nbe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "terpnettestnet2",
  assets: [{
    description: "Terp Token (TERP) is the Terp Network's native utility token, used as the primary means to govern, secure the blockchain, incentivize participants, and provide a default mechanism to store and exchange value.",
    denom_units: [{
      denom: "uterpx",
      exponent: 0
    }, {
      denom: "terpx",
      exponent: 6
    }],
    base: "uterpx",
    name: "Terp Testnet Token",
    display: "terpx",
    symbol: "TERPX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/terp.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/terp.png"
    }]
  }, {
    description: "Persy Gas Token (Persy) is the Terp Network's native utility token, used as the primary means to govern, secure the blockchain, incentivize participants, and provide a default mechanism to store and exchange value.",
    denom_units: [{
      denom: "uthiolx",
      exponent: 0
    }, {
      denom: "thiolx",
      exponent: 6
    }],
    base: "uthiolx",
    name: "Thiol Testnet Gas Token",
    display: "thiolx",
    symbol: "THIOLX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/thiol.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terpnetwork/images/thiol.png"
    }]
  }]
};
t5.default = nbe;
var s5 = {};
Object.defineProperty(s5, "__esModule", { value: !0 });
const tbe = {
  $schema: "../../chain.schema.json",
  chain_name: "terpnettestnet2",
  status: "live",
  network_type: "testnet",
  pretty_name: "Terp-Network",
  chain_type: "cosmos",
  chain_id: "90u-2",
  bech32_prefix: "terp",
  daemon_name: "terpd",
  node_home: "$HOME/.terp",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uthiolx",
      fixed_min_gas_price: 0.5,
      low_gas_price: 0.75,
      average_gas_price: 1,
      high_gas_price: 1.25
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uterpx"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://terp-testnet-rpc.itrocket.net:443/",
      provider: "itrocket"
    }],
    rest: [{
      address: "https://terp-testnet-api.itrocket.net:443/",
      provider: "itrocket"
    }],
    grpc: [{
      address: "terp-testnet-grpc.itrocket.net/",
      provider: "itrocket"
    }]
  },
  explorers: [{
    kind: "Ping Pub",
    url: "https://explorer.nodestake.top/terp-testnet",
    tx_page: "https://explorer.nodestake.top/terp-testnet/tx/${txHash}"
  }, {
    kind: "NODEXPLORER",
    url: "https://explorer.nodexcapital.com",
    tx_page: "https://explorer.nodexcapital.com/terp/tx/${txHash}",
    account_page: "https://explorer.nodexcapital.com/terp/account/{$accountAddress}"
  }]
};
s5.default = tbe;
var PC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ji, "__esModule", { value: !0 });
Ji.chain = Ji.assets = void 0;
const sbe = PC(t5), abe = PC(s5);
Ji.assets = sbe.default;
Ji.chain = abe.default;
var Za = {}, a5 = {};
Object.defineProperty(a5, "__esModule", { value: !0 });
const obe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "terra2testnet",
  assets: [{
    description: "The native staking token of Terra.",
    denom_units: [{
      denom: "uluna",
      exponent: 0
    }, {
      denom: "luna",
      exponent: 6
    }],
    base: "uluna",
    name: "Luna",
    display: "luna",
    symbol: "LUNA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg"
    },
    coingecko_id: "terra-luna-2",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg"
    }]
  }]
};
a5.default = obe;
var o5 = {};
Object.defineProperty(o5, "__esModule", { value: !0 });
const rbe = {
  $schema: "../../chain.schema.json",
  chain_name: "terra2testnet",
  status: "live",
  network_type: "testnet",
  website: "https://www.terra.money/",
  pretty_name: "Terra 2.0",
  chain_type: "cosmos",
  chain_id: "pisco-1",
  daemon_name: "terrad",
  node_home: "$HOME/.terra",
  bech32_prefix: "terra",
  slip44: 330,
  fees: {
    fee_tokens: [{
      denom: "uluna",
      fixed_min_gas_price: 0.0125,
      low_gas_price: 0.0125,
      average_gas_price: 0.015,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uluna"
    }]
  },
  codebase: {},
  apis: {
    rpc: [{
      address: "https://pisco-rpc.terra.dev:443",
      provider: "Terraform Labs"
    }, {
      address: "https://terra-testnet-rpc.polkachu.com:443",
      provider: "Polkachu"
    }],
    rest: [{
      address: "https://pisco-lcd.terra.dev:443",
      provider: "Terraform Labs"
    }, {
      address: "https://terra-testnet-api.polkachu.com:443",
      provider: "Polkachu"
    }],
    grpc: [{
      address: "terra-testnet-grpc.polkachu.com:11790",
      provider: "Polkachu"
    }]
  },
  explorers: [{
    kind: "finder",
    url: "http://finder.terra.money/testnet/",
    tx_page: "https://finder.terra.money/testnet/tx/${txHash}"
  }]
};
o5.default = rbe;
var r5 = {};
Object.defineProperty(r5, "__esModule", { value: !0 });
const ibe = [{
  $schema: "../../ibc_data.schema.json",
  chain_1: {
    chain_name: "kujiratestnet",
    client_id: "07-tendermint-73",
    connection_id: "connection-48"
  },
  chain_2: {
    chain_name: "terra2testnet",
    client_id: "7-tendermint-568",
    connection_id: "connection-508"
  },
  channels: [{
    chain_1: {
      channel_id: "channel-73",
      port_id: "transfer"
    },
    chain_2: {
      channel_id: "channel-541",
      port_id: "transfer"
    },
    ordering: "unordered",
    version: "ics20-1",
    tags: {
      status: "live",
      preferred: !0
    }
  }]
}];
r5.default = ibe;
var i5 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Za, "__esModule", { value: !0 });
Za.ibc = Za.chain = Za.assets = void 0;
const cbe = i5(a5), dbe = i5(o5), mbe = i5(r5);
Za.assets = cbe.default;
Za.chain = dbe.default;
Za.ibc = mbe.default;
var Qa = {}, c5 = {};
Object.defineProperty(c5, "__esModule", { value: !0 });
const hbe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "titantestnet",
  assets: [{
    description: "The native token of the Titan network.",
    denom_units: [
      {
        denom: "atkx",
        exponent: 0,
        aliases: ["attotkx"]
      },
      {
        denom: "utkx",
        exponent: 12,
        aliases: ["microtkx"]
      },
      {
        denom: "mtkx",
        exponent: 15,
        aliases: ["millitkx"]
      },
      {
        denom: "tkx",
        exponent: 18,
        aliases: []
      }
    ],
    base: "atkx",
    display: "tkx",
    name: "titan tkx",
    symbol: "TKX",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/titantestnet/images/tkx.png"
    }],
    keywords: ["staking"],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/titantestnet/images/tkx.png"
    }
  }]
};
c5.default = hbe;
var d5 = {};
Object.defineProperty(d5, "__esModule", { value: !0 });
const pbe = {
  $schema: "../../chain.schema.json",
  chain_name: "titantestnet",
  status: "live",
  network_type: "testnet",
  website: "https://titanlab.io/",
  pretty_name: "Titan Testnet",
  chain_type: "cosmos",
  chain_id: "titan_18889-1",
  bech32_prefix: "titan",
  node_home: "$HOME/.titand",
  daemon_name: "titand",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "atkx",
      fixed_min_gas_price: 1e11,
      low_gas_price: 1e11,
      average_gas_price: 11e10,
      high_gas_price: 2e11
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "atkx"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.47.6-titan.4",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.45.0"
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/titantestnet/images/chain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/titantestnet/images/chain.svg"
  }],
  apis: {
    rpc: [
      {
        address: "https://titan-testnet-rpc.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-testnet-rpc-1.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-testnet-rpc-2.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-testnet-rpc-3.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-testnet-rpc-4.titanlab.io:443",
        provider: "Titanlab.io"
      }
    ],
    rest: [
      {
        address: "https://titan-testnet-lcd.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-testnet-lcd-1.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-testnet-lcd-2.titanlab.io:443",
        provider: "Titanlab.io"
      }
    ],
    grpc: [],
    "evm-http-jsonrpc": [
      {
        address: "https://titan-testnet-json-rpc.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-testnet-json-rpc-1.titanlab.io:443",
        provider: "Titanlab.io"
      },
      {
        address: "https://titan-testnet-json-rpc-2.titanlab.io:443",
        provider: "Titanlab.io"
      }
    ]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://titan-testnet-explorer-light.titanlab.io",
    tx_page: "https://titan-testnet-explorer-light.titanlab.io/Titan%20Testnet/tx/${txHash}",
    account_page: "https://titan-testnet-explorer-light.titanlab.io/Titan%20Testnet/account/${accountAddress}"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/titantestnet/images/chain.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/titantestnet/images/chain.svg"
  }
};
d5.default = pbe;
var m5 = {};
Object.defineProperty(m5, "__esModule", { value: !0 });
const lbe = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-1001",
      connection_id: "connection-780"
    },
    chain_2: {
      chain_name: "titantestnet",
      client_id: "07-tendermint-6",
      connection_id: "connection-4"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-537",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-5",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "cosmoshubtestnet",
      client_id: "07-tendermint-3237",
      connection_id: "connection-3407"
    },
    chain_2: {
      chain_name: "titantestnet",
      client_id: "07-tendermint-0",
      connection_id: "connection-0"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-3910",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-0",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "killed",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-293",
      connection_id: "connection-246"
    },
    chain_2: {
      chain_name: "titantestnet",
      client_id: "07-tendermint-9",
      connection_id: "connection-7"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-208",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-7",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-2436",
      connection_id: "connection-2267"
    },
    chain_2: {
      chain_name: "titantestnet",
      client_id: "07-tendermint-2",
      connection_id: "connection-2"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-5969",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-2",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "killed",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "stargazetestnet",
      client_id: "07-tendermint-764",
      connection_id: "connection-753"
    },
    chain_2: {
      chain_name: "titantestnet",
      client_id: "07-tendermint-3",
      connection_id: "connection-3"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-807",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-3",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "killed",
        preferred: !0
      }
    }]
  }
];
m5.default = lbe;
var h5 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qa, "__esModule", { value: !0 });
Qa.ibc = Qa.chain = Qa.assets = void 0;
const gbe = h5(c5), ube = h5(d5), _be = h5(m5);
Qa.assets = gbe.default;
Qa.chain = ube.default;
Qa.ibc = _be.default;
var Zi = {}, p5 = {};
Object.defineProperty(p5, "__esModule", { value: !0 });
const ybe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "tucanatestnet",
  assets: [{
    description: "The native EVM, governance and staking token of the Tucana",
    denom_units: [{
      denom: "atuc",
      exponent: 0
    }, {
      denom: "tuc",
      exponent: 18
    }],
    base: "atuc",
    name: "Tucana",
    display: "tuc",
    symbol: "TUC",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/tucanatestnet/images/tucana.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/tucanatestnet/images/tucana.png"
    }]
  }]
};
p5.default = ybe;
var l5 = {};
Object.defineProperty(l5, "__esModule", { value: !0 });
const bbe = {
  $schema: "../../chain.schema.json",
  chain_name: "tucanatestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Tucana Testnet",
  chain_type: "cosmos",
  chain_id: "tucana_712-1",
  bech32_prefix: "tuc",
  daemon_name: "tucanad",
  node_home: "$HOME/.tucanad",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "atuc",
      fixed_min_gas_price: 5e9,
      low_gas_price: 1e10,
      average_gas_price: 25e9,
      high_gas_price: 3e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "atuc"
    }]
  },
  codebase: {
    cosmos_sdk_version: "v0.50.8"
  },
  apis: {
    rpc: [{
      address: "https://rpc.birdee-2.tucana.zone/",
      provider: "Tucana"
    }],
    rest: [{
      address: "https://lcd.birdee-2.tucana.zone/",
      provider: "Tucana"
    }],
    grpc: []
  },
  explorers: [{
    kind: "Blockscout",
    url: "https://explorer.birdee-2.tucana.zone/",
    tx_page: "https://explorer.birdee-2.tucana.zone/tx/${txHash}"
  }]
};
l5.default = bbe;
var UC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Zi, "__esModule", { value: !0 });
Zi.chain = Zi.assets = void 0;
const vbe = UC(p5), fbe = UC(l5);
Zi.assets = vbe.default;
Zi.chain = fbe.default;
var Qi = {}, g5 = {};
Object.defineProperty(g5, "__esModule", { value: !0 });
const wbe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "ulastestnet",
  assets: [{
    description: "WEB3 twitter",
    denom_units: [{
      denom: "uulas",
      exponent: 0
    }, {
      denom: "ulas",
      exponent: 6
    }],
    base: "uulas",
    name: "ULAS Network",
    display: "ulas",
    symbol: "ULAS",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/ulastestnet/images/logo.png"
    },
    coingecko_id: "ulas",
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/ulastestnet/images/logo.png"
    }]
  }]
};
g5.default = wbe;
var u5 = {};
Object.defineProperty(u5, "__esModule", { value: !0 });
const xbe = {
  $schema: "../../chain.schema.json",
  chain_name: "ulastestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "ULAS",
  chain_type: "cosmos",
  chain_id: "ulas",
  bech32_prefix: "ulas",
  daemon_name: "ulasd",
  node_home: "$HOME/.ulas",
  codebase: {},
  apis: {
    rpc: [{
      address: "http://65.49.204.199:26657",
      provider: "UlasNetwork"
    }],
    rest: [{
      address: "http://65.49.204.199:1317",
      provider: "UlasNetwork"
    }],
    grpc: [{
      address: "http://65.49.204.199:9090",
      provider: "UlasNetwork"
    }]
  },
  explorers: [{
    kind: "ulas-scan",
    url: "https://testnet-explorer.ulas.network",
    tx_page: "https://testnet-explorer.ulas.network/ulas/tx/${txHash}"
  }],
  slip44: 118
};
u5.default = xbe;
var HC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qi, "__esModule", { value: !0 });
Qi.chain = Qi.assets = void 0;
const kbe = HC(g5), Abe = HC(u5);
Qi.assets = kbe.default;
Qi.chain = Abe.default;
var ec = {}, _5 = {};
Object.defineProperty(_5, "__esModule", { value: !0 });
const jbe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "unificationtestnet",
  assets: [{
    description: "Staking and governance coin for the Unification Testnet",
    denom_units: [{
      denom: "nund",
      exponent: 0
    }, {
      denom: "FUND",
      exponent: 9
    }],
    base: "nund",
    name: "Unification Network",
    display: "FUND",
    symbol: "FUND",
    traces: [{
      type: "test-mintage",
      counterparty: {
        chain_name: "unification",
        base_denom: "nund"
      },
      provider: "Unification"
    }],
    images: [{
      image_sync: {
        chain_name: "unification",
        base_denom: "nund"
      },
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg",
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png",
      theme: {
        primary_color_hex: "#2279c0"
      }
    }],
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg"
    }
  }]
};
_5.default = jbe;
var y5 = {};
Object.defineProperty(y5, "__esModule", { value: !0 });
const Cbe = {
  $schema: "../../chain.schema.json",
  chain_name: "unificationtestnet",
  status: "live",
  network_type: "testnet",
  website: "https://unification.com/",
  pretty_name: "Unification Testnet",
  chain_type: "cosmos",
  chain_id: "FUND-TestNet-2",
  bech32_prefix: "und",
  daemon_name: "und",
  node_home: "$HOME/.und_mainchain",
  key_algos: ["secp256k1"],
  slip44: 5555,
  fees: {
    fee_tokens: [{
      denom: "nund",
      fixed_min_gas_price: 25,
      low_gas_price: 100,
      average_gas_price: 200,
      high_gas_price: 300
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "nund"
    }],
    lock_duration: {
      time: "1814400s"
    }
  },
  codebase: {
    cosmos_sdk_version: "0.47.13",
    cosmwasm_enabled: !1
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg",
    theme: {
      primary_color_hex: "#2279c0"
    }
  }],
  apis: {
    rpc: [{
      address: "https://rpc-testnet.unification.io:443",
      provider: "Unification"
    }],
    rest: [{
      address: "https://rest-testnet.unification.io",
      provider: "Unification"
    }],
    wss: [{
      address: "wss://wss-testnet.unification.io",
      provider: "Unification"
    }],
    grpc: [{
      address: "grpc-testnet.unification.io:443",
      provider: "Unification"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://explorer-testnet.unification.io/u",
    tx_page: "https://explorer-testnet.unification.io/u/tx/${txHash}",
    account_page: "https://explorer-testnet.unification.io/u/account/${accountAddress}"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png",
    svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg"
  }
};
y5.default = Cbe;
var LC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ec, "__esModule", { value: !0 });
ec.chain = ec.assets = void 0;
const Ebe = LC(_5), Dbe = LC(y5);
ec.assets = Ebe.default;
ec.chain = Dbe.default;
var nc = {}, b5 = {};
Object.defineProperty(b5, "__esModule", { value: !0 });
const Bbe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "uniontestnet",
  assets: [{
    description: "Union native token",
    denom_units: [{
      denom: "muno",
      exponent: 0
    }, {
      denom: "uno",
      exponent: 6
    }],
    base: "muno",
    name: "Union",
    display: "uno",
    symbol: "UNO",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/uniontestnet/images/union.png"
    },
    keywords: ["staking"],
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/uniontestnet/images/union.png"
    }]
  }]
};
b5.default = Bbe;
var v5 = {};
Object.defineProperty(v5, "__esModule", { value: !0 });
const Fbe = {
  $schema: "../../chain.schema.json",
  chain_name: "uniontestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Union Testnet",
  chain_type: "cosmos",
  chain_id: "union-testnet-8",
  bech32_prefix: "union",
  daemon_name: "uniond",
  node_home: "$HOME/.uniond",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "muno",
      fixed_min_gas_price: 0,
      low_gas_price: 25e-4,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "muno"
    }]
  },
  apis: {
    rpc: [
      {
        address: "https://rpc.testnet-8.union.build",
        provider: "union"
      },
      {
        address: "https://union-testnet-rpc.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://rpc-testnet-union.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "https://union-testnet-rpc.itrocket.net",
        provider: "ITRocket"
      }
    ],
    rest: [
      {
        address: "https://rest.testnet-8.union.build",
        provider: "union"
      },
      {
        address: "https://union-testnet-api.polkachu.com",
        provider: "Polkachu"
      },
      {
        address: "https://api-testnet-union.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "https://union-testnet-api.itrocket.net",
        provider: "ITRocket"
      }
    ],
    grpc: [
      {
        address: "grpc.testnet-8.union.build",
        provider: "union"
      },
      {
        address: "http://union-testnet-grpc.polkachu.com:24690",
        provider: "Polkachu"
      },
      {
        address: "https://grpc-testnet-union.nodeist.net",
        provider: "Nodeist"
      },
      {
        address: "http://union-testnet-grpc.itrocket.net:23090",
        provider: "ITRocket"
      }
    ]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/uniontestnet/images/union.png"
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://explorer.testnet-8.union.build/union",
    tx_page: "https://explorer.testnet-8.union.build/union/tx/${txHash}",
    account_page: "https://explorer.testnet-8.union.build/union/account/${accountAddress}"
  }, {
    kind: "explorers.guru",
    url: "https://testnet.union.explorers.guru",
    tx_page: "https://testnet.union.explorers.guru/transaction/${txHash}",
    account_page: "https://testnet.union.explorers.guru/account/${accountAddress}"
  }],
  keywords: ["testnet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/uniontestnet/images/union.png"
  }]
};
v5.default = Fbe;
var WC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(nc, "__esModule", { value: !0 });
nc.chain = nc.assets = void 0;
const $be = WC(b5), zbe = WC(v5);
nc.assets = $be.default;
nc.chain = zbe.default;
var tc = {}, f5 = {};
Object.defineProperty(f5, "__esModule", { value: !0 });
const qbe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "upticktestnet",
  assets: [{
    description: "The native token of Uptick",
    denom_units: [{
      denom: "auptick",
      exponent: 0
    }, {
      denom: "uptick",
      exponent: 18
    }],
    base: "auptick",
    name: "Uptick",
    display: "uptick",
    symbol: "UPTICK",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/upticktestnet/images/uptick.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/upticktestnet/images/uptick.png"
    }]
  }]
};
f5.default = qbe;
var w5 = {};
Object.defineProperty(w5, "__esModule", { value: !0 });
const Sbe = {
  $schema: "../../chain.schema.json",
  chain_name: "upticktestnet",
  status: "live",
  network_type: "testnet",
  website: "https://www.uptickproject.com/",
  pretty_name: "Uptick",
  chain_type: "cosmos",
  chain_id: "uptick_7000-2",
  bech32_prefix: "uptick",
  daemon_name: "uptickd",
  node_home: "$HOME/.uptickd",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "auptick",
      low_gas_price: 0,
      average_gas_price: 0,
      high_gas_price: 0
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46.5"
  },
  apis: {
    rpc: [{
      address: "https://uptick-7000-2-rpc.staketab.org:443",
      provider: "Staketab"
    }],
    rest: [{
      address: "https://uptick-7000-2-rest.staketab.org",
      provider: "Staketab"
    }],
    grpc: [{
      address: "services.staketab.com:9004",
      provider: "Staketab"
    }]
  },
  explorers: [{
    kind: "ping.pub",
    url: "https://explorer.testnet.uptick.network/uptick-network-testnet",
    tx_page: "https://explorer.testnet.uptick.network/uptick-network-testnet/tx/${txHash}"
  }, {
    kind: "Nodes.Guru",
    url: "https://uptick.explorers.guru/",
    tx_page: "https://uptick.explorers.guru/transaction/${txHash}"
  }]
};
w5.default = Sbe;
var VC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(tc, "__esModule", { value: !0 });
tc.chain = tc.assets = void 0;
const Tbe = VC(f5), Rbe = VC(w5);
tc.assets = Tbe.default;
tc.chain = Rbe.default;
var sc = {}, x5 = {};
Object.defineProperty(x5, "__esModule", { value: !0 });
const Obe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "vincechaintestnet",
  assets: [{
    description: "Vince Chain is an Industry-Grade Blockchain For DeFi, Remote work, Gaming, Web3 and will power the new internet.",
    denom_units: [{
      denom: "avce",
      exponent: 0
    }, {
      denom: "vce",
      exponent: 18
    }],
    base: "avce",
    name: "VinceChain",
    display: "vce",
    symbol: "VCE",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/vincechaintestnet/images/vince.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/vincechaintestnet/images/vince.png"
    }]
  }]
};
x5.default = Obe;
var k5 = {};
Object.defineProperty(k5, "__esModule", { value: !0 });
const Mbe = {
  $schema: "../../chain.schema.json",
  chain_name: "vincechaintestnet",
  status: "killed",
  network_type: "testnet",
  pretty_name: "VinceChain Testnet",
  chain_type: "cosmos",
  chain_id: "vince_1903-1",
  bech32_prefix: "vce",
  node_home: "$HOME/.vinced",
  slip44: 60,
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  fees: {
    fee_tokens: [{
      denom: "avce",
      fixed_min_gas_price: 25e7,
      low_gas_price: 1e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "avce"
    }]
  },
  codebase: {},
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/vincechaintestnet/images/vince.png"
  },
  apis: {
    rpc: [{
      address: "http://api-testnet.vincechain.com/:26657/",
      provider: "vincescan.com"
    }],
    rest: [{
      address: "http://lcd-testnet.vincechain.com/:1317/",
      provider: "vincescan.com"
    }],
    grpc: [],
    "evm-http-jsonrpc": [{
      address: "http://rpc-testnet.vincechain.com",
      provider: "vincescan.com"
    }]
  },
  explorers: [{
    kind: "blockscout",
    url: "https://scan-testnet.vincechain.com",
    tx_page: "https://scan-testnet.vincechain.com/tx/${txHash}"
  }],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/vincechaintestnet/images/vince.png"
  }]
};
k5.default = Mbe;
var GC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(sc, "__esModule", { value: !0 });
sc.chain = sc.assets = void 0;
const Ibe = GC(x5), Nbe = GC(k5);
sc.assets = Ibe.default;
sc.chain = Nbe.default;
var ac = {}, A5 = {};
Object.defineProperty(A5, "__esModule", { value: !0 });
const Pbe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "wardenprotocoltestnet",
  assets: [{
    description: "The native token of Warden Protocol Testnet",
    denom_units: [{
      denom: "uward",
      exponent: 0
    }, {
      denom: "ward",
      exponent: 6
    }],
    base: "uward",
    name: "Ward",
    display: "ward",
    symbol: "WARD",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/wardenprotocol/images/ward.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/wardenprotocol/images/ward.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/wardenprotocol/images/ward.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/wardenprotocol/images/ward.svg"
    }]
  }]
};
A5.default = Pbe;
var j5 = {};
Object.defineProperty(j5, "__esModule", { value: !0 });
const Ube = {
  $schema: "../../chain.schema.json",
  chain_name: "wardenprotocoltestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "Warden Protocol Buenavista",
  chain_type: "cosmos",
  chain_id: "buenavista-1",
  bech32_prefix: "warden",
  daemon_name: "wardend",
  node_home: "$HOME/.warden",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uward",
      fixed_min_gas_price: 5e-3,
      low_gas_price: 0.01,
      average_gas_price: 0.025,
      high_gas_price: 0.03
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uward"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.50",
    cosmwasm_enabled: !1
  },
  apis: {
    rpc: [{
      address: "https://rpc.buenavista.wardenprotocol.org/",
      provider: "Warden Protocol"
    }],
    rest: [{
      address: "https://api.buenavista.wardenprotocol.org/",
      provider: "Warden Protocol"
    }],
    grpc: [{
      address: "https://grpc.buenavista.wardenprotocol.org/",
      provider: "Warden Protocol"
    }]
  },
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/wardenprotocol/images/ward.png"
  },
  explorers: [],
  keywords: ["testnet"],
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/wardenprotocol/images/ward.png"
  }]
};
j5.default = Ube;
var KC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ac, "__esModule", { value: !0 });
ac.chain = ac.assets = void 0;
const Hbe = KC(A5), Lbe = KC(j5);
ac.assets = Hbe.default;
ac.chain = Lbe.default;
var oc = {}, C5 = {};
Object.defineProperty(C5, "__esModule", { value: !0 });
const Wbe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "wavehashtestnet",
  assets: [{
    description: "WaveHash A Permissioned Blockchain",
    denom_units: [{
      denom: "uwahax",
      exponent: 0
    }, {
      denom: "wahax",
      exponent: 6
    }],
    base: "uwahax",
    name: "WaveHash",
    display: "wahax",
    symbol: "WAHAX",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/wavehashtestnet/images/WaveHash.png"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/wavehashtestnet/images/WaveHash.png"
    }]
  }]
};
C5.default = Wbe;
var E5 = {};
Object.defineProperty(E5, "__esModule", { value: !0 });
const Vbe = {
  $schema: "../../chain.schema.json",
  chain_name: "wavehashtestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "wavehash Testnet",
  chain_type: "cosmos",
  chain_id: "INVALID-ID-wavehashtestnet-testnet-1",
  bech32_prefix: "wavehash",
  daemon_name: "wavehashd",
  node_home: "$HOME/.wavehash",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uwahax",
      low_gas_price: 25e-4,
      average_gas_price: 25e-4,
      high_gas_price: 24e-4
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uwahax"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.45",
    cosmwasm_enabled: !0,
    cosmwasm_version: "0.30"
  },
  apis: {
    rpc: [{
      address: "https://rpc.wavehash.online/",
      provider: "WaveHash Network"
    }],
    rest: [{
      address: "https://lcd.wavehash.online/",
      provider: "WaveHash Network"
    }],
    grpc: [{
      address: "https://grpc.wavehash.online/",
      provider: "WaveHash Network"
    }]
  },
  explorers: [{
    kind: "atomscan",
    url: "https://atomscan.com/directory/testnet/wavehashtestnet",
    tx_page: "https://atomscan.com/directory/testnet/wavehashtestnet/transactions/${txHash}"
  }]
};
E5.default = Vbe;
var XC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(oc, "__esModule", { value: !0 });
oc.chain = oc.assets = void 0;
const Gbe = XC(C5), Kbe = XC(E5);
oc.assets = Gbe.default;
oc.chain = Kbe.default;
var eo = {}, D5 = {};
Object.defineProperty(D5, "__esModule", { value: !0 });
const Xbe = {
  $schema: "../../assetlist.schema.json",
  chain_name: "xiontestnet",
  assets: [
    {
      description: "The native staking token of the Xion network.",
      denom_units: [{
        denom: "uxion",
        exponent: 0,
        aliases: ["microxion"]
      }, {
        denom: "XION",
        exponent: 6,
        aliases: ["xion"]
      }],
      base: "uxion",
      display: "XION",
      name: "xion",
      symbol: "XION",
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xion/images/burnt-round.png"
      },
      images: [{
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xion/images/burnt-round.png"
      }]
    },
    {
      denom_units: [{
        denom: "ibc/33517D439F5E545A1AAB148FAE43AAE17CF68FFB9BC97AE0048A3E3B64518C58",
        exponent: 0,
        aliases: ["uaxl"]
      }, {
        denom: "axl",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/33517D439F5E545A1AAB148FAE43AAE17CF68FFB9BC97AE0048A3E3B64518C58",
      name: "Axelar AXL Token",
      display: "axl",
      symbol: "AXL",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "axelartestnet",
          base_denom: "uaxl",
          channel_id: "channel-521"
        },
        chain: {
          channel_id: "channel-225057",
          path: "transfer/channel-225057/uaxl"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "axelartestnet",
          base_denom: "uaxl"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/axl.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/484532EB74866F3FB8A71F909F7B1B470FE2E66313DA0A1F9EE5B7C5C046D195",
        exponent: 0,
        aliases: ["uosmo"]
      }, {
        denom: "osmo",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/484532EB74866F3FB8A71F909F7B1B470FE2E66313DA0A1F9EE5B7C5C046D195",
      name: "Osmosis OSMO Token",
      display: "osmo",
      symbol: "OSMO",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "osmosistestnet",
          base_denom: "uosmo",
          channel_id: "channel-6668"
        },
        chain: {
          channel_id: "channel-490",
          path: "transfer/channel-490/uosmo"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "osmosistestnet",
          base_denom: "uosmo"
        },
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/57097251ED81A232CE3C9D899E7C8096D6D87EF84BA203E12E424AA4C9B57A64",
        exponent: 0,
        aliases: ["uusdc"]
      }, {
        denom: "usdc",
        exponent: 6
      }],
      type_asset: "ics20",
      base: "ibc/57097251ED81A232CE3C9D899E7C8096D6D87EF84BA203E12E424AA4C9B57A64",
      name: "Noble USDC Token",
      display: "usdc",
      symbol: "USDC",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "nobletestnet",
          base_denom: "uusdc",
          channel_id: "channel-147"
        },
        chain: {
          channel_id: "channel-489",
          path: "transfer/channel-489/uusdc"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "nobletestnet",
          base_denom: "uusdc"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        theme: {
          circle: !0,
          primary_color_hex: "#2775CA"
        }
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg"
      }
    },
    {
      denom_units: [{
        denom: "ibc/05314A48723E06A1B1B666066B6BEC89F3708E8854DF2E5E9193387AA9653036",
        exponent: 0,
        aliases: ["inj"]
      }, {
        denom: "INJ",
        exponent: 18
      }],
      type_asset: "ics20",
      base: "ibc/05314A48723E06A1B1B666066B6BEC89F3708E8854DF2E5E9193387AA9653036",
      name: "Injective INJ token",
      display: "INJ",
      symbol: "INJ",
      traces: [{
        type: "ibc",
        counterparty: {
          chain_name: "injectivetestnet",
          base_denom: "inj",
          channel_id: "channel-489"
        },
        chain: {
          channel_id: "channel-487",
          path: "transfer/channel-487/inj"
        }
      }],
      images: [{
        image_sync: {
          chain_name: "injectivetestnet",
          base_denom: "inj"
        },
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg",
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png"
      }],
      logo_URIs: {
        png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.png",
        svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/injective/images/inj.svg"
      }
    }
  ]
};
D5.default = Xbe;
var B5 = {};
Object.defineProperty(B5, "__esModule", { value: !0 });
const Ybe = {
  $schema: "../../chain.schema.json",
  chain_name: "xiontestnet",
  chain_id: "xion-testnet-1",
  pretty_name: "Xion Testnet",
  website: "https://burnt.com",
  status: "live",
  network_type: "testnet",
  chain_type: "cosmos",
  bech32_prefix: "xion",
  daemon_name: "xiond",
  node_home: "$HOME/.xiond",
  key_algos: ["secp256k1"],
  slip44: 118,
  fees: {
    fee_tokens: [{
      denom: "uxion",
      fixed_min_gas_price: 0.025,
      low_gas_price: 0.025,
      average_gas_price: 0.025,
      high_gas_price: 0.04
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "uxion"
    }]
  },
  codebase: {},
  apis: {
    rpc: [
      {
        address: "https://testnet-burnt-rpc.lavenderfive.com",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://xion-testnet-rpc.polkachu.com",
        provider: "polkachu"
      },
      {
        address: "https://burnt-testnet-rpc.itrocket.net",
        provider: "ITRocket"
      }
    ],
    rest: [
      {
        address: "https://testnet-burnt-api.lavenderfive.com",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "https://xion-testnet-api.polkachu.com",
        provider: "polkachu"
      },
      {
        address: "https://burnt-testnet-api.itrocket.net",
        provider: "ITRocket"
      }
    ],
    grpc: [
      {
        address: "https://testnet-burnt-grpc.lavenderfive.com",
        provider: "Lavender.Five Nodes 🐝"
      },
      {
        address: "xion-testnet-grpc.polkachu.com:22390",
        provider: "polkachu"
      },
      {
        address: "burnt-testnet-grpc.itrocket.net:443",
        provider: "ITRocket"
      }
    ]
  },
  images: [{
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xion/images/burnt.png"
  }],
  logo_URIs: {
    png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/xion/images/burnt.png"
  },
  keywords: [
    "xion",
    "burnt",
    "testnet"
  ],
  explorers: [{
    kind: "ITRocket",
    url: "https://testnet.itrocket.net/burnt",
    tx_page: "https://testnet.itrocket.net/burnt/tx/${txHash}",
    account_page: "https://testnet.itrocket.net/burnt/account/${accountAddress}"
  }]
};
B5.default = Ybe;
var F5 = {};
Object.defineProperty(F5, "__esModule", { value: !0 });
const Jbe = [
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "axelartestnet",
      client_id: "07-tendermint-970",
      connection_id: "connection-752"
    },
    chain_2: {
      chain_name: "xiontestnet",
      client_id: "07-tendermint-127",
      connection_id: "connection-64"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-521",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-225057",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "injectivetestnet",
      client_id: "07-tendermint-239",
      connection_id: "connection-220"
    },
    chain_2: {
      chain_name: "xiontestnet",
      client_id: "07-tendermint-119",
      connection_id: "connection-55"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-489",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-487",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live",
        preferred: !0
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "nobletestnet",
      client_id: "07-tendermint-224",
      connection_id: "connection-176"
    },
    chain_2: {
      chain_name: "xiontestnet",
      client_id: "07-tendermint-120",
      connection_id: "connection-56"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-147",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-489",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  },
  {
    $schema: "../../ibc_data.schema.json",
    chain_1: {
      chain_name: "osmosistestnet",
      client_id: "07-tendermint-3125",
      connection_id: "connection-2826"
    },
    chain_2: {
      chain_name: "xiontestnet",
      client_id: "07-tendermint-121",
      connection_id: "connection-57"
    },
    channels: [{
      chain_1: {
        channel_id: "channel-6668",
        port_id: "transfer"
      },
      chain_2: {
        channel_id: "channel-490",
        port_id: "transfer"
      },
      ordering: "unordered",
      version: "ics20-1",
      tags: {
        status: "live"
      }
    }]
  }
];
F5.default = Jbe;
var $5 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(eo, "__esModule", { value: !0 });
eo.ibc = eo.chain = eo.assets = void 0;
const Zbe = $5(D5), Qbe = $5(B5), eve = $5(F5);
eo.assets = Zbe.default;
eo.chain = Qbe.default;
eo.ibc = eve.default;
var rc = {}, z5 = {};
Object.defineProperty(z5, "__esModule", { value: !0 });
const nve = {
  $schema: "../../assetlist.schema.json",
  chain_name: "zetachaintestnet",
  assets: [{
    description: "The native token of ZetaChain",
    denom_units: [{
      denom: "azeta",
      exponent: 0
    }, {
      denom: "tzeta",
      exponent: 18
    }],
    base: "azeta",
    name: "ZetaChain Testnet",
    display: "tzeta",
    symbol: "tZETA",
    logo_URIs: {
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/zetachaintestnet/images/zetachaintestnet.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/zetachaintestnet/images/zetachaintestnet.svg"
    },
    images: [{
      png: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/zetachaintestnet/images/zetachaintestnet.png",
      svg: "https://raw.githubusercontent.com/cosmos/chain-registry/master/testnets/zetachaintestnet/images/zetachaintestnet.svg"
    }]
  }]
};
z5.default = nve;
var q5 = {};
Object.defineProperty(q5, "__esModule", { value: !0 });
const tve = {
  $schema: "../../chain.schema.json",
  chain_name: "zetachaintestnet",
  status: "live",
  network_type: "testnet",
  pretty_name: "ZetaChain Testnet",
  chain_type: "cosmos",
  chain_id: "athens_7001-1",
  bech32_prefix: "zeta",
  daemon_name: "zetacored",
  node_home: "$HOME/.zetacored",
  key_algos: ["ethsecp256k1"],
  extra_codecs: ["ethermint"],
  slip44: 60,
  fees: {
    fee_tokens: [{
      denom: "azeta",
      low_gas_price: 2e10,
      average_gas_price: 25e9,
      high_gas_price: 4e10
    }]
  },
  staking: {
    staking_tokens: [{
      denom: "azeta"
    }]
  },
  codebase: {
    cosmos_sdk_version: "0.46"
  },
  apis: {
    rpc: [{
      address: "https://zetachain-athens.blockpi.network/rpc/v1/public",
      provider: "BlockPI"
    }, {
      address: "https://zetachain-testnet-archive.allthatnode.com:26657",
      provider: "All That Node"
    }],
    rest: [{
      address: "https://zetachain-athens.blockpi.network/lcd/v1/public",
      provider: "BlockPI"
    }, {
      address: "https://zetachain-testnet-archive.allthatnode.com:1317",
      provider: "All That Node"
    }]
  },
  explorers: [{
    kind: "ZetaScan",
    url: "https://athens.explorer.zetachain.com/",
    tx_page: "https://athens.explorer.zetachain.com/cc/tx/${txHash}"
  }, {
    kind: "BlockScout",
    url: "https://zetachain-athens-3.blockscout.com/",
    tx_page: "https://zetachain-athens-3.blockscout.com/tx/${txHash}"
  }]
};
q5.default = tve;
var YC = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(rc, "__esModule", { value: !0 });
rc.chain = rc.assets = void 0;
const sve = YC(z5), ave = YC(q5);
rc.assets = sve.default;
rc.chain = ave.default;
var ove = r && r.__createBinding || (Object.create ? function(e, n, t, s) {
  s === void 0 && (s = t);
  var a = Object.getOwnPropertyDescriptor(n, t);
  (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return n[t];
  } }), Object.defineProperty(e, s, a);
} : function(e, n, t, s) {
  s === void 0 && (s = t), e[s] = n[t];
}), rve = r && r.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), U = r && r.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var t in e) t !== "default" && Object.prototype.hasOwnProperty.call(e, t) && ove(n, e, t);
  return rve(n, e), n;
};
Object.defineProperty(Pw, "__esModule", { value: !0 });
const ive = U(Ir), cve = U(ga), dve = U(ua), mve = U(Nr), hve = U(Pr), pve = U(Ur), lve = U(_a), gve = U(Hr), uve = U(Lr), _ve = U(Wr), yve = U(Vr), bve = U(Gr), vve = U(Kr), fve = U(ya), wve = U(ba), xve = U(Xr), kve = U(Yr), Ave = U(va), jve = U(Jr), Cve = U(fa), Eve = U(wa), Dve = U(Zr), Bve = U(Qr), Fve = U(ei), $ve = U(ni), zve = U(ti), qve = U(si), Sve = U(ai), Tve = U(xa), Rve = U(oi), Ove = U(ka), Mve = U(Aa), Ive = U(ri), Nve = U(ja), Pve = U(Ca), Uve = U(ii), Hve = U(ci), Lve = U(di), Wve = U(mi), Vve = U(hi), Gve = U(pi), Kve = U(li), Xve = U(gi), Yve = U(ui), Jve = U(Ea), Zve = U(_i), Qve = U(Da), e1e = U(yi), n1e = U(Ba), t1e = U(Fa), s1e = U(bi), a1e = U($a), o1e = U(za), r1e = U(qa), i1e = U(Sa), c1e = U(vi), d1e = U(Ta), m1e = U(fi), h1e = U(wi), p1e = U(Ra), l1e = U(Oa), g1e = U(xi), u1e = U(ki), _1e = U(Ai), y1e = U(Ma), b1e = U(ji), v1e = U(Ci), f1e = U(Ei), w1e = U(Ia), x1e = U(Na), k1e = U(Pa), A1e = U(Di), j1e = U(Bi), C1e = U(Fi), E1e = U(Ua), D1e = U(Ha), B1e = U($i), F1e = U(zi), $1e = U(La), z1e = U(qi), q1e = U(Si), S1e = U(Ti), T1e = U(Wa), R1e = U(Ri), O1e = U(Va), M1e = U(Oi), I1e = U(Mi), N1e = U(Ii), P1e = U(Ga), U1e = U(Ni), H1e = U(Ka), L1e = U(Pi), W1e = U(Ui), V1e = U(Hi), G1e = U(Li), K1e = U(Xa), X1e = U(Wi), Y1e = U(Vi), J1e = U(Gi), Z1e = U(Ya), Q1e = U(Ja), e2e = U(Ki), n2e = U(Xi), t2e = U(Yi), s2e = U(Ji), a2e = U(Za), o2e = U(Qa), r2e = U(Zi), i2e = U(Qi), c2e = U(ec), d2e = U(nc), m2e = U(tc), h2e = U(sc), p2e = U(ac), l2e = U(oc), g2e = U(eo), u2e = U(rc), _2e = [
  ive.assets,
  cve.assets,
  dve.assets,
  mve.assets,
  hve.assets,
  pve.assets,
  lve.assets,
  gve.assets,
  uve.assets,
  _ve.assets,
  yve.assets,
  bve.assets,
  vve.assets,
  fve.assets,
  wve.assets,
  xve.assets,
  kve.assets,
  Ave.assets,
  jve.assets,
  Cve.assets,
  Eve.assets,
  Dve.assets,
  Bve.assets,
  Fve.assets,
  $ve.assets,
  zve.assets,
  qve.assets,
  Sve.assets,
  Tve.assets,
  Rve.assets,
  Ove.assets,
  Mve.assets,
  Ive.assets,
  Nve.assets,
  Pve.assets,
  Uve.assets,
  Hve.assets,
  Lve.assets,
  Wve.assets,
  Vve.assets,
  Gve.assets,
  Kve.assets,
  Xve.assets,
  Yve.assets,
  Jve.assets,
  Zve.assets,
  Qve.assets,
  e1e.assets,
  n1e.assets,
  t1e.assets,
  s1e.assets,
  a1e.assets,
  o1e.assets,
  r1e.assets,
  i1e.assets,
  c1e.assets,
  d1e.assets,
  m1e.assets,
  h1e.assets,
  p1e.assets,
  l1e.assets,
  g1e.assets,
  u1e.assets,
  _1e.assets,
  y1e.assets,
  b1e.assets,
  v1e.assets,
  f1e.assets,
  w1e.assets,
  x1e.assets,
  k1e.assets,
  A1e.assets,
  j1e.assets,
  C1e.assets,
  E1e.assets,
  D1e.assets,
  B1e.assets,
  F1e.assets,
  $1e.assets,
  z1e.assets,
  q1e.assets,
  S1e.assets,
  T1e.assets,
  R1e.assets,
  O1e.assets,
  M1e.assets,
  I1e.assets,
  N1e.assets,
  P1e.assets,
  U1e.assets,
  H1e.assets,
  L1e.assets,
  W1e.assets,
  V1e.assets,
  G1e.assets,
  K1e.assets,
  X1e.assets,
  Y1e.assets,
  J1e.assets,
  Z1e.assets,
  Q1e.assets,
  e2e.assets,
  n2e.assets,
  t2e.assets,
  s2e.assets,
  a2e.assets,
  o2e.assets,
  r2e.assets,
  i2e.assets,
  c2e.assets,
  d2e.assets,
  m2e.assets,
  h2e.assets,
  p2e.assets,
  l2e.assets,
  g2e.assets,
  u2e.assets
];
Pw.default = _2e;
var S5 = {}, y2e = r && r.__createBinding || (Object.create ? function(e, n, t, s) {
  s === void 0 && (s = t);
  var a = Object.getOwnPropertyDescriptor(n, t);
  (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return n[t];
  } }), Object.defineProperty(e, s, a);
} : function(e, n, t, s) {
  s === void 0 && (s = t), e[s] = n[t];
}), b2e = r && r.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), H = r && r.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var t in e) t !== "default" && Object.prototype.hasOwnProperty.call(e, t) && y2e(n, e, t);
  return b2e(n, e), n;
};
Object.defineProperty(S5, "__esModule", { value: !0 });
const v2e = H(Ir), f2e = H(ga), w2e = H(ua), x2e = H(Nr), k2e = H(Pr), A2e = H(Ur), j2e = H(_a), C2e = H(Hr), E2e = H(Lr), D2e = H(Wr), B2e = H(Vr), F2e = H(Gr), $2e = H(Kr), z2e = H(ya), q2e = H(ba), S2e = H(Xr), T2e = H(Yr), R2e = H(va), O2e = H(Jr), M2e = H(fa), I2e = H(wa), N2e = H(Zr), P2e = H(Qr), U2e = H(ei), H2e = H(ni), L2e = H(ti), W2e = H(si), V2e = H(ai), G2e = H(xa), K2e = H(oi), X2e = H(ka), Y2e = H(Aa), J2e = H(ri), Z2e = H(ja), Q2e = H(Ca), efe = H(ii), nfe = H(ci), tfe = H(di), sfe = H(mi), afe = H(hi), ofe = H(pi), rfe = H(li), ife = H(gi), cfe = H(ui), dfe = H(Ea), mfe = H(_i), hfe = H(Da), pfe = H(yi), lfe = H(Ba), gfe = H(Fa), ufe = H(bi), _fe = H($a), yfe = H(za), bfe = H(qa), vfe = H(Sa), ffe = H(vi), wfe = H(Ta), xfe = H(fi), kfe = H(wi), Afe = H(Ra), jfe = H(Oa), Cfe = H(xi), Efe = H(ki), Dfe = H(Ai), Bfe = H(Ma), Ffe = H(ji), $fe = H(Ci), zfe = H(Ei), qfe = H(Ia), Sfe = H(Na), Tfe = H(Pa), Rfe = H(Di), Ofe = H(Bi), Mfe = H(Fi), Ife = H(Ua), Nfe = H(Ha), Pfe = H($i), Ufe = H(zi), Hfe = H(La), Lfe = H(qi), Wfe = H(Si), Vfe = H(Ti), Gfe = H(Wa), Kfe = H(Ri), Xfe = H(Va), Yfe = H(Oi), Jfe = H(Mi), Zfe = H(Ii), Qfe = H(Ga), ewe = H(Ni), nwe = H(Ka), twe = H(Pi), swe = H(Ui), awe = H(Hi), owe = H(Li), rwe = H(Xa), iwe = H(Wi), cwe = H(Vi), dwe = H(Gi), mwe = H(Ya), hwe = H(Ja), pwe = H(Ki), lwe = H(Xi), gwe = H(Yi), uwe = H(Ji), _we = H(Za), ywe = H(Qa), bwe = H(Zi), vwe = H(Qi), fwe = H(ec), wwe = H(nc), xwe = H(tc), kwe = H(sc), Awe = H(ac), jwe = H(oc), Cwe = H(eo), Ewe = H(rc), Dwe = [
  v2e.chain,
  f2e.chain,
  w2e.chain,
  x2e.chain,
  k2e.chain,
  A2e.chain,
  j2e.chain,
  C2e.chain,
  E2e.chain,
  D2e.chain,
  B2e.chain,
  F2e.chain,
  $2e.chain,
  z2e.chain,
  q2e.chain,
  S2e.chain,
  T2e.chain,
  R2e.chain,
  O2e.chain,
  M2e.chain,
  I2e.chain,
  N2e.chain,
  P2e.chain,
  U2e.chain,
  H2e.chain,
  L2e.chain,
  W2e.chain,
  V2e.chain,
  G2e.chain,
  K2e.chain,
  X2e.chain,
  Y2e.chain,
  J2e.chain,
  Z2e.chain,
  Q2e.chain,
  efe.chain,
  nfe.chain,
  tfe.chain,
  sfe.chain,
  afe.chain,
  ofe.chain,
  rfe.chain,
  ife.chain,
  cfe.chain,
  dfe.chain,
  mfe.chain,
  hfe.chain,
  pfe.chain,
  lfe.chain,
  gfe.chain,
  ufe.chain,
  _fe.chain,
  yfe.chain,
  bfe.chain,
  vfe.chain,
  ffe.chain,
  wfe.chain,
  xfe.chain,
  kfe.chain,
  Afe.chain,
  jfe.chain,
  Cfe.chain,
  Efe.chain,
  Dfe.chain,
  Bfe.chain,
  Ffe.chain,
  $fe.chain,
  zfe.chain,
  qfe.chain,
  Sfe.chain,
  Tfe.chain,
  Rfe.chain,
  Ofe.chain,
  Mfe.chain,
  Ife.chain,
  Nfe.chain,
  Pfe.chain,
  Ufe.chain,
  Hfe.chain,
  Lfe.chain,
  Wfe.chain,
  Vfe.chain,
  Gfe.chain,
  Kfe.chain,
  Xfe.chain,
  Yfe.chain,
  Jfe.chain,
  Zfe.chain,
  Qfe.chain,
  ewe.chain,
  nwe.chain,
  twe.chain,
  swe.chain,
  awe.chain,
  owe.chain,
  rwe.chain,
  iwe.chain,
  cwe.chain,
  dwe.chain,
  mwe.chain,
  hwe.chain,
  pwe.chain,
  lwe.chain,
  gwe.chain,
  uwe.chain,
  _we.chain,
  ywe.chain,
  bwe.chain,
  vwe.chain,
  fwe.chain,
  wwe.chain,
  xwe.chain,
  kwe.chain,
  Awe.chain,
  jwe.chain,
  Cwe.chain,
  Ewe.chain
];
S5.default = Dwe;
var T5 = {}, Bwe = r && r.__createBinding || (Object.create ? function(e, n, t, s) {
  s === void 0 && (s = t);
  var a = Object.getOwnPropertyDescriptor(n, t);
  (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return n[t];
  } }), Object.defineProperty(e, s, a);
} : function(e, n, t, s) {
  s === void 0 && (s = t), e[s] = n[t];
}), Fwe = r && r.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), ce = r && r.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var t in e) t !== "default" && Object.prototype.hasOwnProperty.call(e, t) && Bwe(n, e, t);
  return Fwe(n, e), n;
};
Object.defineProperty(T5, "__esModule", { value: !0 });
const $we = ce(ga), zwe = ce(ua), qwe = ce(_a), Swe = ce(ya), Twe = ce(ba), Rwe = ce(va), Owe = ce(fa), Mwe = ce(wa), Iwe = ce(xa), Nwe = ce(ka), Pwe = ce(Aa), Uwe = ce(ja), Hwe = ce(Ca), Lwe = ce(Ea), Wwe = ce(Da), Vwe = ce(Ba), Gwe = ce(Fa), Kwe = ce($a), Xwe = ce(za), Ywe = ce(qa), Jwe = ce(Sa), Zwe = ce(Ta), Qwe = ce(Ra), e4e = ce(Oa), n4e = ce(Ma), t4e = ce(Ia), s4e = ce(Na), a4e = ce(Pa), o4e = ce(Ua), r4e = ce(Ha), i4e = ce(La), c4e = ce(Wa), d4e = ce(Va), m4e = ce(Ga), h4e = ce(Ka), p4e = ce(Xa), l4e = ce(Ya), g4e = ce(Ja), u4e = ce(Za), _4e = ce(Qa), y4e = ce(eo), b4e = [
  ...$we.ibc,
  ...zwe.ibc,
  ...qwe.ibc,
  ...Swe.ibc,
  ...Twe.ibc,
  ...Rwe.ibc,
  ...Owe.ibc,
  ...Mwe.ibc,
  ...Iwe.ibc,
  ...Nwe.ibc,
  ...Pwe.ibc,
  ...Uwe.ibc,
  ...Hwe.ibc,
  ...Lwe.ibc,
  ...Wwe.ibc,
  ...Vwe.ibc,
  ...Gwe.ibc,
  ...Kwe.ibc,
  ...Xwe.ibc,
  ...Ywe.ibc,
  ...Jwe.ibc,
  ...Zwe.ibc,
  ...Qwe.ibc,
  ...e4e.ibc,
  ...n4e.ibc,
  ...t4e.ibc,
  ...s4e.ibc,
  ...a4e.ibc,
  ...o4e.ibc,
  ...r4e.ibc,
  ...i4e.ibc,
  ...c4e.ibc,
  ...d4e.ibc,
  ...m4e.ibc,
  ...h4e.ibc,
  ...p4e.ibc,
  ...l4e.ibc,
  ...g4e.ibc,
  ...u4e.ibc,
  ..._4e.ibc,
  ...y4e.ibc
];
T5.default = b4e;
var R5 = r && r.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ao, "__esModule", { value: !0 });
Ao.ibc = eE = Ao.chains = ZC = Ao.assets = void 0;
const JC = R5(Pw);
var ZC = Ao.assets = JC.default;
const QC = R5(S5);
var eE = Ao.chains = QC.default;
const nE = R5(T5);
Ao.ibc = nE.default;
Ao.default = {
  assets: JC.default,
  chains: QC.default,
  ibc: nE.default
};
const tE = [
  ..._m,
  ...eE,
  ...Bh
], sE = [
  ...um,
  ...ZC,
  ...Fh
];
tE.map((e) => {
  try {
    return rm(e, sE);
  } catch {
    return;
  }
}).filter((e) => e);
const f8 = (e) => {
  const n = tE.find((t) => t.chain_id === e);
  if (n)
    try {
      return rm(n, sE);
    } catch {
      return;
    }
};
var pd = {};
Object.defineProperty(pd, "__esModule", { value: !0 });
var aE = pd.bech32m = iE = pd.bech32 = void 0;
const am = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", oE = {};
for (let e = 0; e < am.length; e++) {
  const n = am.charAt(e);
  oE[n] = e;
}
function xc(e) {
  const n = e >> 25;
  return (e & 33554431) << 5 ^ -(n >> 0 & 1) & 996825010 ^ -(n >> 1 & 1) & 642813549 ^ -(n >> 2 & 1) & 513874426 ^ -(n >> 3 & 1) & 1027748829 ^ -(n >> 4 & 1) & 705979059;
}
function w8(e) {
  let n = 1;
  for (let t = 0; t < e.length; ++t) {
    const s = e.charCodeAt(t);
    if (s < 33 || s > 126)
      return "Invalid prefix (" + e + ")";
    n = xc(n) ^ s >> 5;
  }
  n = xc(n);
  for (let t = 0; t < e.length; ++t) {
    const s = e.charCodeAt(t);
    n = xc(n) ^ s & 31;
  }
  return n;
}
function O5(e, n, t, s) {
  let a = 0, o = 0;
  const i = (1 << t) - 1, d = [];
  for (let m = 0; m < e.length; ++m)
    for (a = a << n | e[m], o += n; o >= t; )
      o -= t, d.push(a >> o & i);
  if (s)
    o > 0 && d.push(a << t - o & i);
  else {
    if (o >= n)
      return "Excess padding";
    if (a << t - o & i)
      return "Non-zero padding";
  }
  return d;
}
function v4e(e) {
  return O5(e, 8, 5, !0);
}
function f4e(e) {
  const n = O5(e, 5, 8, !1);
  if (Array.isArray(n))
    return n;
}
function w4e(e) {
  const n = O5(e, 5, 8, !1);
  if (Array.isArray(n))
    return n;
  throw new Error(n);
}
function rE(e) {
  let n;
  e === "bech32" ? n = 1 : n = 734539939;
  function t(i, d, m) {
    if (m = m || 90, i.length + 7 + d.length > m)
      throw new TypeError("Exceeds length limit");
    i = i.toLowerCase();
    let h = w8(i);
    if (typeof h == "string")
      throw new Error(h);
    let p = i + "1";
    for (let _ = 0; _ < d.length; ++_) {
      const y = d[_];
      if (y >> 5)
        throw new Error("Non 5-bit word");
      h = xc(h) ^ y, p += am.charAt(y);
    }
    for (let _ = 0; _ < 6; ++_)
      h = xc(h);
    h ^= n;
    for (let _ = 0; _ < 6; ++_) {
      const y = h >> (5 - _) * 5 & 31;
      p += am.charAt(y);
    }
    return p;
  }
  function s(i, d) {
    if (d = d || 90, i.length < 8)
      return i + " too short";
    if (i.length > d)
      return "Exceeds length limit";
    const m = i.toLowerCase(), h = i.toUpperCase();
    if (i !== m && i !== h)
      return "Mixed-case string " + i;
    i = m;
    const p = i.lastIndexOf("1");
    if (p === -1)
      return "No separator character for " + i;
    if (p === 0)
      return "Missing prefix for " + i;
    const _ = i.slice(0, p), y = i.slice(p + 1);
    if (y.length < 6)
      return "Data too short";
    let w = w8(_);
    if (typeof w == "string")
      return w;
    const q = [];
    for (let k = 0; k < y.length; ++k) {
      const B = y.charAt(k), v = oE[B];
      if (v === void 0)
        return "Unknown character " + B;
      w = xc(w) ^ v, !(k + 6 >= y.length) && q.push(v);
    }
    return w !== n ? "Invalid checksum for " + i : { prefix: _, words: q };
  }
  function a(i, d) {
    const m = s(i, d);
    if (typeof m == "object")
      return m;
  }
  function o(i, d) {
    const m = s(i, d);
    if (typeof m == "object")
      return m;
    throw new Error(m);
  }
  return {
    decodeUnsafe: a,
    decode: o,
    encode: t,
    toWords: v4e,
    fromWordsUnsafe: f4e,
    fromWords: w4e
  };
}
var iE = pd.bech32 = rE("bech32");
aE = pd.bech32m = rE("bech32m");
const cE = {
  passet: 65,
  pauctid: 66,
  penumbra: 143,
  penumbracompat1: 150,
  penumbrafullviewingkey: 132,
  penumbragovern: 73,
  penumbraspendkey: 75,
  penumbravalid: 72,
  penumbrawalletid: 75,
  plpid: 64
}, dE = {
  passet: 32,
  pauctid: 32,
  penumbra: 80,
  penumbracompat1: 80,
  penumbrafullviewingkey: 64,
  penumbragovern: 32,
  penumbraspendkey: 32,
  penumbravalid: 32,
  penumbrawalletid: 32,
  plpid: 32
}, x4e = (e, n) => mE({
  bechLib: aE,
  bData: e,
  prefix: n,
  expectLength: cE[n],
  expectBytes: dE[n]
}), k4e = (e, n) => mE({
  bechLib: iE,
  bData: e,
  prefix: n,
  expectLength: cE[n],
  expectBytes: dE[n]
}), mE = ({ bechLib: e, bData: n, prefix: t, expectLength: s, expectBytes: a }) => {
  if (n.length !== a)
    throw new TypeError(`Invalid data length: expected ${a}, got ${n.length}`);
  const o = e.encode(t, e.toWords(n), s);
  if (o.length !== s)
    throw new TypeError("Unexpected string length");
  return o;
}, hE = {
  passet: "inner",
  pauctid: "inner",
  penumbra: "inner",
  penumbracompat1: "inner",
  penumbrafullviewingkey: "inner",
  penumbragovern: "gk",
  penumbraspendkey: "inner",
  penumbravalid: "ik",
  penumbrawalletid: "inner",
  plpid: "inner"
}, pE = {
  passet: "passet",
  pauctid: "pauctid",
  penumbra: "penumbra",
  penumbracompat1: "penumbracompat1",
  penumbrafullviewingkey: "penumbrafullviewingkey",
  penumbragovern: "penumbragovern",
  penumbraspendkey: "penumbraspendkey",
  penumbravalid: "penumbravalid",
  penumbrawalletid: "penumbrawalletid",
  plpid: "plpid"
}, A4e = hE.penumbra, j4e = pE.penumbra, x8 = ({ [A4e]: e }) => x4e(e, j4e), C4e = hE.penumbracompat1, E4e = pE.penumbracompat1, D4e = ({ [C4e]: e }) => k4e(e, E4e), lE = () => {
  const { data: e } = re(We), { data: n } = re(dc), t = pe(jw), s = pe(Pe), { walletType: a } = rD(), { data: o, isConnected: i } = z8({
    multiChain: !0
  }), { disconnectAsync: d } = iD();
  return { createCosmosWallets: Ne(
    (h) => {
      const p = [ze.KEPLR, ze.LEAP, ze.COSMOSTATION, ze.XDEFI, ze.STATION, ze.VECTIS];
      if (h == null ? void 0 : h.includes("penumbra"))
        return [{
          walletName: "prax",
          walletPrettyName: "Prax Wallet",
          walletChainType: "cosmos",
          walletInfo: {
            logo: "https://raw.githubusercontent.com/prax-wallet/web/e8b18f9b997708eab04f57e7a6c44f18b3cf13a8/apps/extension/public/prax-white-vertical.svg"
          },
          connectEco: async () => {
            console.error("Prax wallet is not supported for connectEco");
          },
          connect: async () => {
            console.error("Prax wallet is not supported for connect");
          },
          getAddress: async ({ praxWallet: q }) => {
            const k = q == null ? void 0 : q.index, B = q == null ? void 0 : q.sourceChainID, b = CD("chrome-extension://lkpmkhpnhknhmibgnmmhdhgdilepfghe");
            try {
              await b.connect();
              const D = await b.service(ED).ephemeralAddress({
                addressIndex: {
                  account: k || 0
                }
              });
              if (!D.address) throw new Error("No address found");
              return F4e({
                address: D.address,
                chainID: B
              });
            } catch (O) {
              throw console.error(O), O;
            }
          },
          disconnect: async () => {
            console.error("Prax wallet is not supported");
          },
          isWalletConnected: !1
        }];
      const y = [];
      for (const w of p) {
        const q = async ({
          signRequired: b
        }) => {
          var N;
          if (!h) throw new Error("Chain ID is required");
          const O = f8(h), D = (N = o == null ? void 0 : o[h]) == null ? void 0 : N.bech32Address;
          if (w !== a || !D) {
            if (!O)
              throw new Error(
                `getAddress: Chain info not found for chainID: ${h}`
              );
            await od(w).experimentalSuggestChain(O), await $m({
              chainId: h,
              walletType: w
            }), t({ walletName: w, chainType: "cosmos" });
          } else D && i && b && t({ walletName: w, chainType: "cosmos" });
          return (await od(w).getKey(h)).bech32Address;
        }, k = dA(w), B = (w === ze.KEPLR ? soe : aoe).filter(
          (b) => (e == null ? void 0 : e.filter((O) => O.chainType === "cosmos").map((O) => O.chainID).includes(b)) && cA.map((O) => O.chainId).includes(b)
        ), v = async () => {
          const b = B.map(
            async (O) => await $m({
              chainId: O,
              walletType: w
            })
          );
          return await Promise.all(b), Promise.resolve();
        }, g = {
          walletName: w,
          walletPrettyName: k == null ? void 0 : k.name,
          walletChainType: "cosmos",
          walletInfo: {
            logo: k == null ? void 0 : k.imgSrc
          },
          connectEco: async () => {
            await v(), t({ walletName: w, chainType: "cosmos" });
            const b = e == null ? void 0 : e.find((D) => D.chainID === "cosmoshub-4"), O = n == null ? void 0 : n.find((D) => D.denom === "uatom");
            return s({
              chainID: b == null ? void 0 : b.chainID,
              chainName: b == null ? void 0 : b.chainName,
              ...O
            }), Promise.resolve();
          },
          connect: async () => {
            try {
              if (!h) throw new Error("Chain ID is required");
              const b = f8(h);
              if (!b)
                throw new Error(
                  `connect: Chain info not found for chainID: ${h}`
                );
              await od(w).experimentalSuggestChain(b), B.includes(h) ? await v() : await $m({
                chainId: h,
                walletType: w
              }), t({ walletName: w, chainType: "cosmos" }), v();
            } catch (b) {
              throw console.error(b), b;
            }
          },
          getAddress: q,
          disconnect: async () => {
            await d(), t(void 0);
          },
          isWalletConnected: a === w,
          isAvailable: (() => {
            try {
              return !!od(w);
            } catch {
              return !1;
            }
          })()
        };
        y.push(g);
      }
      return y;
    },
    [o, n, e, a, d, i, t, s]
  ) };
}, B4e = ["noble-1", "grand-1"], F4e = ({
  chainID: e,
  address: n
}) => e && B4e.includes(e) ? D4e(n) : x8(n), $4e = [
  {
    inputs: [
      { internalType: "string", name: "v", type: "string" },
      { internalType: "string", name: "r", type: "string" },
      { internalType: "string", name: "s", type: "string" },
      { internalType: "string", name: "customMessage", type: "string" }
    ],
    name: "associate",
    outputs: [
      { internalType: "string", name: "seiAddr", type: "string" },
      { internalType: "address", name: "evmAddr", type: "address" }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "getSeiAddr",
    outputs: [{ internalType: "string", name: "response", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "string", name: "addr", type: "string" }],
    name: "getEvmAddr",
    outputs: [{ internalType: "address", name: "response", type: "address" }],
    stateMutability: "view",
    type: "function"
  }
], gE = () => {
  const { data: e } = re(We), { data: n } = re(dc), t = pe(Pe), s = pe(Aw), {
    connector: a,
    address: o,
    isConnected: i,
    chainId: d
  } = im(), { connectAsync: m } = uD(), h = S8(), p = h.find(
    (y) => y.id === (a == null ? void 0 : a.id)
  );
  return { createEvmWallets: Ne(
    (y) => {
      const w = y === "pacific-1";
      w && (y = Yd.id.toString());
      const q = [];
      for (const k of h) {
        if (q.findIndex((b) => b.walletName === k.id) !== -1)
          continue;
        const v = async ({
          signRequired: b
        }) => {
          var O;
          if (b && i && d !== Number(y) && k.id === (a == null ? void 0 : a.id))
            return await ((O = k == null ? void 0 : k.switchChain) == null ? void 0 : O.call(k, {
              chainId: Number(y)
            })), o;
          if (k.id !== (a == null ? void 0 : a.id) || !i) {
            const D = await m({
              connector: k,
              chainId: Number(y)
            });
            return s({ walletName: k.id, chainType: "evm" }), D.accounts[0];
          } else o && i && b && s({ walletName: k.id, chainType: "evm" });
          return o;
        }, g = {
          walletName: k.id,
          walletPrettyName: k.name,
          walletChainType: "evm",
          walletInfo: {
            logo: k.icon
          },
          connectEco: async () => {
            var b;
            if (i && d !== 1 && k.id === (a == null ? void 0 : a.id)) {
              await ((b = k == null ? void 0 : k.switchChain) == null ? void 0 : b.call(k, {
                chainId: 1
              }));
              return;
            }
            i && k.id !== (a == null ? void 0 : a.id) && await (p == null ? void 0 : p.disconnect());
            try {
              await m({ connector: k, chainId: 1 }), s({ walletName: k.id, chainType: "evm" });
              const O = e == null ? void 0 : e.find((M) => M.chainID === "1"), D = n == null ? void 0 : n.find((M) => M.denom === "ethereum-native");
              t({
                chainID: O == null ? void 0 : O.chainID,
                chainName: O == null ? void 0 : O.chainName,
                ...D
              });
            } catch (O) {
              throw console.error(O), O;
            }
          },
          connect: async () => {
            var b;
            if (i && d !== Number(y) && k.id === (a == null ? void 0 : a.id)) {
              await ((b = k == null ? void 0 : k.switchChain) == null ? void 0 : b.call(k, {
                chainId: Number(y)
              }));
              return;
            }
            i && k.id !== (a == null ? void 0 : a.id) && await (p == null ? void 0 : p.disconnect());
            try {
              await m({ connector: k, chainId: Number(y) }), s({ walletName: k.id, chainType: "evm" });
            } catch (O) {
              throw console.error(O), O;
            }
          },
          getAddress: async ({ signRequired: b, context: O }) => {
            try {
              return await v({ signRequired: b, context: O });
            } catch (D) {
              throw console.error(D), D;
            }
          },
          disconnect: async () => {
            await (p == null ? void 0 : p.disconnect()), s(void 0);
          },
          isWalletConnected: k.id === (a == null ? void 0 : a.id)
        };
        w && (g.getAddress = async ({ signRequired: b, context: O }) => {
          const D = await v({ signRequired: b, context: O }), M = pD({
            chain: Yd,
            transport: xe()
          });
          try {
            return await M.readContract({
              args: [D],
              address: "0x0000000000000000000000000000000000001004",
              abi: $4e,
              functionName: "getSeiAddr"
            });
          } catch (N) {
            throw console.error(N), N;
          }
        }), q.push(g);
      }
      return q;
    },
    [
      n,
      d,
      e,
      m,
      h,
      p,
      a == null ? void 0 : a.id,
      o,
      i,
      s,
      t
    ]
  ) };
}, uE = () => {
  const { data: e } = re(We), { data: n } = re(dc), t = pe(Pe), s = pe(Cw);
  return { createSolanaWallets: Ne(() => {
    const o = [];
    for (const i of Dw) {
      const d = {
        walletName: i.name,
        walletPrettyName: i.name,
        walletChainType: "svm",
        walletInfo: {
          logo: i.icon
        },
        connect: async () => {
          try {
            await i.connect(), s({ walletName: i.name, chainType: "svm" });
          } catch (m) {
            throw console.error(m), m;
          }
        },
        connectEco: async () => {
          try {
            await i.connect(), s({ walletName: i.name, chainType: "svm" });
            const m = e == null ? void 0 : e.find((p) => p.chainID === "solana"), h = n == null ? void 0 : n.find((p) => p.denom.toLowerCase() === "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v".toLowerCase());
            t({
              chainID: m == null ? void 0 : m.chainID,
              chainName: m == null ? void 0 : m.chainName,
              ...h
            });
          } catch (m) {
            throw console.error(m), m;
          }
        },
        getAddress: async ({ signRequired: m }) => {
          try {
            i.connected || (await i.connect(), s({ walletName: i.name, chainType: "svm" }));
            const p = i.publicKey;
            if (!p) throw new Error("No address found");
            return m && s({ walletName: i.name, chainType: "svm" }), p.toBase58();
          } catch (h) {
            console.error(h);
          }
        },
        disconnect: async () => {
          await i.disconnect(), s(void 0);
        },
        isWalletConnected: i.connected,
        isAvailable: i.readyState === "Installed"
      };
      o.push(d);
    }
    return o;
  }, [n, e, t, s]) };
}, M5 = ({ chainID: e, destinationWalletList: n, chainType: t }) => {
  var p;
  const { createCosmosWallets: s } = lE(), { createEvmWallets: a } = gE(), { createSolanaWallets: o } = uE(), { data: i } = re(We), d = e ? (p = i == null ? void 0 : i.find((_) => _.chainID === e)) == null ? void 0 : p.chainType : t, m = n && e === "pacific-1" ? "sei" : d;
  return Q(() => {
    switch (m) {
      case "sei": {
        const _ = s(e), y = a(e);
        return [..._, ...y];
      }
      case "cosmos":
        return s(e);
      case "evm":
        return a(e);
      case "svm":
        return o();
      default:
        return [];
    }
  }, [e, s, a, o, m]);
}, _E = Lc((e) => {
  var O;
  const { theme: n, signRequired: t, chainId: s } = e, a = Qe(), { data: o } = re(We), i = o == null ? void 0 : o.find((D) => D.chainID === s), d = i == null ? void 0 : i.prettyName, m = i == null ? void 0 : i.logoURI, [h, p] = qe(!1), [_, y] = qe(""), w = M5({ chainID: s, destinationWalletList: !0 }), q = pe($o), k = [
    ...w,
    {
      onSelect: () => p(!0),
      walletName: "Enter address manually",
      rightContent: () => {
        var D, M;
        return /* @__PURE__ */ c.jsx(
          $w,
          {
            color: (D = n == null ? void 0 : n.primary) == null ? void 0 : D.background.normal,
            backgroundColor: (M = n == null ? void 0 : n.primary) == null ? void 0 : M.text.normal
          }
        );
      }
    }
  ], B = Ne(
    (D) => {
      y(D.target.value);
    },
    []
  ), v = Q(() => {
    if (!i || _.length === 0) return;
    const { chainType: D, bech32Prefix: M } = i;
    return Kde({
      address: _,
      bech32Prefix: M,
      chainType: D
    });
  }, [i, _]), g = Q(() => {
    if (!i) return "Enter address...";
    const { chainType: D, bech32Prefix: M } = i;
    switch (D) {
      case "cosmos":
        return `${M}1...`;
      case "evm":
        return "0x...";
      case "svm":
        return "Enter solana address...";
      default:
        return "Enter address...";
    }
  }, [i]), b = () => {
    const D = i == null ? void 0 : i.chainType;
    !s || !D || (q((M) => {
      const N = Object.values(M).length - 1;
      return {
        ...M,
        [N]: {
          chainID: s,
          chainType: D,
          address: _,
          source: "input"
        }
      };
    }), a.remove());
  };
  return /* @__PURE__ */ c.jsx(c.Fragment, { children: h ? /* @__PURE__ */ c.jsxs(z4e, { gap: 15, children: [
    /* @__PURE__ */ c.jsx(
      Nw,
      {
        title: `Enter a ${d} address`,
        onClickBackButton: () => p(!1),
        rightContent: () => /* @__PURE__ */ c.jsx(S4e, { align: "center", justify: "center", children: /* @__PURE__ */ c.jsx("img", { width: "25px", height: "25px", src: m }) })
      }
    ),
    /* @__PURE__ */ c.jsxs(q4e, { children: [
      /* @__PURE__ */ c.jsx(
        R4e,
        {
          placeholder: g,
          value: _,
          onChange: B,
          validAddress: v
        }
      ),
      /* @__PURE__ */ c.jsx(T4e, { validAddress: v })
    ] }),
    v === !1 && /* @__PURE__ */ c.jsxs(J, { color: (O = n == null ? void 0 : n.error) == null ? void 0 : O.text, textAlign: "center", children: [
      "Please enter a valid wallet address for ",
      d
    ] }),
    /* @__PURE__ */ c.jsx(
      O4e,
      {
        align: "center",
        justify: "center",
        disabled: !v,
        onClick: b,
        children: /* @__PURE__ */ c.jsx(
          Te,
          {
            mainButtonColor: v === !0 ? n == null ? void 0 : n.brandColor : void 0,
            opacity: v ? 1 : 0.5,
            fontSize: 24,
            children: "Confirm"
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ c.jsx(
    wj,
    {
      title: "Destination wallet",
      walletList: t ? w : k,
      onClickBackButton: () => a.remove(),
      chainId: s,
      chainType: i == null ? void 0 : i.chainType,
      isDestinationAddress: !0
    }
  ) });
}), z4e = W(be)`
  position: relative;
  padding: 10px;
  gap: 15px;
  width: 580px;
  border-radius: 20px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  overflow: hidden;
`, q4e = W.div`
  position: relative;
`, S4e = W(Y)`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: ${({ theme: e }) => e.secondary.background.normal};
`, T4e = W.div`
  position: absolute;
  height: 11px;
  width: 11px;
  border-radius: 50%;
  background-color: ${({ theme: e }) => e.primary.text.lowContrast};

  ${({ validAddress: e, theme: n }) => e === !0 ? `background-color: ${n.success.text}` : e === !1 ? `background-color: ${n.error.text}` : ""};

  top: calc(50% - 11px / 2);
  right: 20px;
`, R4e = W.input`
  height: 60px;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  padding: 8px 40px 8px 15px;
  border: 1px solid ${({ theme: e }) => e.primary.text.ultraLowContrast};
  background-color: ${({ theme: e }) => e.secondary.background.normal};
  color: ${({ theme: e }) => e.primary.text.normal};
  border-radius: 12px;

  ${({ validAddress: e, theme: n }) => e === !1 && Ye`
      border-color: ${n.error.text};
      background-color: ${n.error.background};
    `}
`, O4e = W(jn)`
  background-color: ${({ theme: e }) => e.brandColor};
  height: 60px;
  border-radius: 12px;
  ${({ disabled: e, theme: n }) => e && `background-color: ${n.secondary.background.normal}`};
`;
function jo(e) {
  const n = typeof e == "string" ? parseFloat(e) : e;
  return M4e.format(n);
}
const M4e = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2
}), k8 = ({
  denom: e,
  tokenAmount: n,
  usdValue: t,
  chainId: s,
  status: a,
  onClickEditDestinationWallet: o,
  explorerLink: i,
  context: d
}) => {
  var q;
  const m = je(), h = an({
    assetDenom: e,
    chainId: s,
    tokenAmount: n
  }), p = re($o), y = hc()(s), w = Q(() => {
    const k = Object.values(p);
    switch (d) {
      case "source":
        return {
          address: y == null ? void 0 : y.address,
          image: y == null ? void 0 : y.wallet.logo
        };
      case "destination": {
        const B = k[k.length - 1];
        return {
          address: B == null ? void 0 : B.address,
          image: (B == null ? void 0 : B.source) === "wallet" && B.wallet.walletInfo.logo || void 0
        };
      }
    }
  }, [y == null ? void 0 : y.address, y == null ? void 0 : y.wallet.logo, p, d]);
  return /* @__PURE__ */ c.jsxs(Y, { gap: 25, align: "center", children: [
    h.assetImage && /* @__PURE__ */ c.jsx(
      wm,
      {
        width: 50,
        height: 50,
        backgroundColor: m.success.text,
        status: a,
        children: /* @__PURE__ */ c.jsx(
          "img",
          {
            height: 50,
            width: 50,
            style: { borderRadius: 50 },
            src: h.assetImage,
            title: (q = h == null ? void 0 : h.asset) == null ? void 0 : q.name
          }
        )
      }
    ),
    /* @__PURE__ */ c.jsxs(be, { gap: 5, children: [
      /* @__PURE__ */ c.jsxs(Te, { fontSize: 24, children: [
        h.amount,
        " ",
        h == null ? void 0 : h.symbol
      ] }),
      t && /* @__PURE__ */ c.jsx(J, { children: jo(t) }),
      /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 5, children: [
        /* @__PURE__ */ c.jsxs(J, { normalTextColor: !0, children: [
          "on ",
          h.chainName
        ] }),
        /* @__PURE__ */ c.jsxs(
          jn,
          {
            align: "center",
            gap: 3,
            onClick: () => Fw(w.address),
            children: [
              w.image && /* @__PURE__ */ c.jsx("img", { height: 10, width: 10, src: w.image }),
              w.address && /* @__PURE__ */ c.jsx(J, { monospace: !0, title: w.address, children: $c(w.address) })
            ]
          }
        ),
        i ? /* @__PURE__ */ c.jsx(em, { href: i, target: "_blank", children: /* @__PURE__ */ c.jsx(J, { children: /* @__PURE__ */ c.jsx(Or, {}) }) }) : o ? /* @__PURE__ */ c.jsx(jn, { align: "center", onClick: o, children: /* @__PURE__ */ c.jsx(
          Sw,
          {
            color: m.primary.text.lowContrast
          }
        ) }) : null
      ] })
    ] })
  ] });
}, yE = ({
  color: e = "currentColor",
  className: n
}) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: n,
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M7.48395 6.5705L7.48395 0.568512H5.46938L5.46938 6.5705C5.46938 7.30917 4.57625 7.67985 4.05381 7.15741L1.76526 4.86889L0.34029 6.29384L6.478 12.4315L12.613 6.29653L11.1881 4.87157L8.9022 7.15875C8.37976 7.68119 7.48528 7.31186 7.48528 6.57185",
        fill: e
      }
    )
  }
), I4e = ({
  operations: e,
  statusData: n,
  onClickEditDestinationWallet: t,
  swapExecutionState: s
}) => {
  var b, O, D, M;
  const a = je(), { route: o } = re(fn), i = e[0], d = e[e.length - 1], m = n == null ? void 0 : n.transferEvents, h = s === co.confirmed ? "completed" : (b = m == null ? void 0 : m[i.transferIndex]) == null ? void 0 : b.status, p = s === co.confirmed ? "completed" : (O = m == null ? void 0 : m[d.transferIndex]) == null ? void 0 : O.status, _ = i.denomIn, y = d.denomOut, w = {
    denom: _,
    tokenAmount: i.amountIn,
    chainId: i.fromChainID ?? i.chainID,
    usdValue: o == null ? void 0 : o.usdAmountIn
  }, q = {
    denom: y,
    tokenAmount: d.amountOut,
    chainId: d.toChainID ?? d.chainID,
    usdValue: o == null ? void 0 : o.usdAmountOut
  }, k = d.signRequired, B = (D = m == null ? void 0 : m[i.transferIndex]) == null ? void 0 : D.fromExplorerLink, v = (M = m == null ? void 0 : m[d.transferIndex]) == null ? void 0 : M.toExplorerLink, g = Q(() => {
    if (!k && s === co.ready)
      return t;
  }, [k, s, t]);
  return /* @__PURE__ */ c.jsxs(P4e, { justify: "space-between", children: [
    /* @__PURE__ */ c.jsx(
      k8,
      {
        ...w,
        status: h,
        context: "source",
        explorerLink: B
      }
    ),
    /* @__PURE__ */ c.jsx(N4e, { color: a.primary.text.normal }),
    /* @__PURE__ */ c.jsx(
      k8,
      {
        ...q,
        icon: ae.pen,
        status: p,
        onClickEditDestinationWallet: g,
        explorerLink: v,
        context: "destination"
      }
    )
  ] });
}, N4e = W(yE)`
  height: 18px;
  width: 54px;
`, P4e = W(be)`
  padding: 35px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  border-radius: 25px;
  min-height: 225px;
`, td = ({
  color: e = "currentColor",
  ...n
}) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "9",
    height: "10",
    viewBox: "0 0 9 10",
    fill: "none",
    ...n,
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M4.14243 9.26414L0.0367859 5.19958L3.11603 5.19958L3.11603 0.644653L5.12779 0.644653L5.12779 5.19958L8.20703 5.19958L4.14243 9.26414Z",
        fill: e
      }
    )
  }
), U4e = ({
  color: e = "currentColor",
  ...n
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "9",
    height: "11",
    viewBox: "0 0 9 11",
    fill: "none",
    ...n,
    children: [
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M4.36704 7.83984L0.261395 3.77528L3.34064 3.77528L3.34064 0.4544L5.3524 0.4544L5.3524 1.49781L5.3524 3.77528L8.43164 3.77528L4.36704 7.83984Z",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.43164 8.83984V8.97095V10.5L6.77148 10.5L1.91992 10.5L0.259766 10.5V8.97095H0.261475L0.261475 8.83984H8.43164Z",
          fill: e
        }
      )
    ]
  }
), A8 = ({
  color: e = "currentColor",
  ...n
}) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "15",
    viewBox: "0 0 9 15",
    fill: "none",
    ...n,
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M8.20703 4.86573L5.12779 4.86573L5.12779 7.94459L3.11602 7.94459L3.11602 4.86573L0.0367735 4.86573L4.10137 0.801147L8.20703 4.86573ZM4.14243 14.2781L0.0367857 10.2135L3.11603 10.2135L3.11603 5.65862L5.12779 5.65862L5.12779 10.2135L8.20703 10.2135L4.14243 14.2781Z",
        fill: e
      }
    )
  }
);
var un = /* @__PURE__ */ ((e) => (e.swap = "swap", e.evmSwap = "evmSwap", e.transfer = "transfer", e.axelarTransfer = "axelarTransfer", e.cctpTransfer = "cctpTransfer", e.hyperlaneTransfer = "hyperlaneTransfer", e.opInitTransfer = "opInitTransfer", e.bankSend = "bankSend", e))(un || {});
function H4e(e) {
  const n = e;
  let t = {
    details: {},
    type: void 0
  };
  return Object.values(un).find((s) => {
    const a = n == null ? void 0 : n[s];
    if (a) {
      switch (s) {
        case "swap":
        case "evmSwap":
          a.toChainID = a.fromChainID;
          break;
        case "bankSend":
          a.denomIn = a.denom, a.denomOut = a.denom, a.fromChainID = a.chainID, a.toChainID = a.chainID;
          break;
      }
      t = {
        details: a,
        type: s
      };
    }
  }), t;
}
function L4e(e) {
  const { details: n, type: t } = H4e(e);
  return {
    type: t,
    ...n,
    txIndex: e.txIndex,
    amountIn: e.amountIn,
    amountOut: e.amountOut,
    swapVenues: [
      ...n.swapVenues ?? [],
      ...n != null && n.swapIn ? [n == null ? void 0 : n.swapIn.swapVenue] : [],
      ...n != null && n.swapOut ? [n == null ? void 0 : n.swapOut.swapVenue] : []
    ]
  };
}
function Am(e) {
  let n = 0;
  return e.map((t, s, a) => {
    const o = a[s - 1], i = s === 0 ? !1 : t.txIndex > o.txIndex, d = L4e(t), m = d.type === "swap" || d.type === "evmSwap", h = {
      ...d,
      transferIndex: n,
      signRequired: i,
      isSwap: m
    };
    return m || n++, h;
  });
}
function W4e(e) {
  const n = e, t = n == null ? void 0 : n.axelarTransfer, s = n == null ? void 0 : n.ibcTransfer, a = n == null ? void 0 : n.cctpTransfer, o = n == null ? void 0 : n.hyperlaneTransfer, i = n == null ? void 0 : n.opInitTransfer;
  let d = "";
  t ? d = "axelarTransfer" : s ? d = "ibcTransfer" : a ? d = "cctpTransfer" : o ? d = "hyperlaneTransfer" : i && (d = "opInitTransfer");
  const m = (y) => {
    var w, q, k, B, v, g;
    switch (d) {
      case "ibcTransfer":
        return y === "send" ? (w = s.packetTXs.sendTx) == null ? void 0 : w.explorerLink : (q = s.packetTXs.receiveTx) == null ? void 0 : q.explorerLink;
      case "axelarTransfer":
        return t.axelarScanLink;
      default:
        return y === "send" ? (B = (k = n[d]) == null ? void 0 : k.txs.sendTx) == null ? void 0 : B.explorerLink : (g = (v = n[d]) == null ? void 0 : v.txs.receiveTx) == null ? void 0 : g.explorerLink;
    }
  }, h = {
    ...s,
    ...t,
    ...a,
    ...o,
    ...i,
    fromExplorerLink: m("send"),
    toExplorerLink: m("receive")
  }, p = G4e(h.state);
  return {
    ...h,
    status: p
  };
}
function V4e(e) {
  return e ? e == null ? void 0 : e.flatMap((n) => n.transferSequence.map((t) => W4e(t))) : [];
}
function G4e(e) {
  switch (e) {
    case "TRANSFER_PENDING":
    case "TRANSFER_RECEIVED":
    case "AXELAR_TRANSFER_PENDING_CONFIRMATION":
    case "AXELAR_TRANSFER_PENDING_RECEIPT":
    case "CCTP_TRANSFER_SENT":
    case "CCTP_TRANSFER_PENDING_CONFIRMATION":
    case "CCTP_TRANSFER_CONFIRMED":
    case "HYPERLANE_TRANSFER_SENT":
    case "OPINIT_TRANSFER_SENT":
      return "pending";
    case "TRANSFER_SUCCESS":
    case "AXELAR_TRANSFER_SUCCESS":
    case "CCTP_TRANSFER_RECEIVED":
    case "HYPERLANE_TRANSFER_RECEIVED":
    case "OPINIT_TRANSFER_RECEIVED":
      return "completed";
    default:
      return "failed";
  }
}
const K4e = {
  // swap icon
  [un.swap]: /* @__PURE__ */ c.jsx(A8, { width: 34 }),
  [un.evmSwap]: /* @__PURE__ */ c.jsx(A8, { width: 34 }),
  // bridge icon
  [un.transfer]: /* @__PURE__ */ c.jsx(td, { width: 34 }),
  [un.axelarTransfer]: /* @__PURE__ */ c.jsx(td, { width: 34 }),
  [un.cctpTransfer]: /* @__PURE__ */ c.jsx(td, { width: 34 }),
  [un.hyperlaneTransfer]: /* @__PURE__ */ c.jsx(td, { width: 34 }),
  [un.opInitTransfer]: /* @__PURE__ */ c.jsx(td, { width: 34 }),
  // send icon
  [un.bankSend]: /* @__PURE__ */ c.jsx(U4e, { width: 34 })
}, X4e = {
  swap: "Swapped",
  evmSwap: "Swapped",
  transfer: "Bridged",
  axelarTransfer: "Bridged",
  cctpTransfer: "Bridged",
  hyperlaneTransfer: "Bridged",
  opInitTransfer: "Bridged",
  bankSend: "Sent"
}, Y4e = ({
  operations: e,
  statusData: n,
  onClickEditDestinationWallet: t,
  swapExecutionState: s
}) => {
  var B, v;
  const [{ data: a }] = Ae(cce), [{ data: o }] = Ae(ice), [i, d] = qe({}), m = (g) => {
    d((b) => ({
      ...b,
      [g]: !0
    }));
  }, h = (g) => {
    d((b) => ({
      ...b,
      [g]: !1
    }));
  }, p = e[0], y = e[e.length - 1].signRequired, w = n == null ? void 0 : n.transferEvents, q = s === co.confirmed ? "completed" : (B = w == null ? void 0 : w[0]) == null ? void 0 : B.status, k = Q(() => {
    if (!y && s === co.ready)
      return t;
  }, [y, s, t]);
  return /* @__PURE__ */ c.jsxs(Q4e, { children: [
    /* @__PURE__ */ c.jsx(
      b8,
      {
        tokenAmount: p.amountIn,
        denom: p.denomIn,
        chainId: p.fromChainID,
        explorerLink: (v = w == null ? void 0 : w[0]) == null ? void 0 : v.fromExplorerLink,
        status: q,
        context: "source",
        index: 0
      }
    ),
    e.map((g, b) => {
      var S, x, C;
      const O = X4e[g.type], M = (() => {
        var P, V;
        const F = (V = (P = g.swapVenues) == null ? void 0 : P[0]) == null ? void 0 : V.chainID, A = g.bridgeID, E = o == null ? void 0 : o.find((X) => X.id === A), T = a == null ? void 0 : a.find((X) => X.chainID === F);
        return {
          name: (E == null ? void 0 : E.name) ?? (T == null ? void 0 : T.name),
          image: (E == null ? void 0 : E.logoURI) ?? (T == null ? void 0 : T.logoUri)
        };
      })(), N = e[b + 1], l = {
        tokenAmount: g.amountOut,
        denom: g.denomOut,
        chainId: g.toChainID ?? g.chainID
      }, u = g.isSwap ? (S = w == null ? void 0 : w[g.transferIndex]) == null ? void 0 : S.fromExplorerLink : (x = w == null ? void 0 : w[g.transferIndex]) == null ? void 0 : x.toExplorerLink, f = s === co.confirmed ? "completed" : (C = w == null ? void 0 : w[g.transferIndex]) == null ? void 0 : C.status;
      return /* @__PURE__ */ c.jsxs(Ie.Fragment, { children: [
        /* @__PURE__ */ c.jsxs(nxe, { style: { height: "25px", position: "relative" }, align: "center", children: [
          /* @__PURE__ */ c.jsx(
            Z4e,
            {
              onMouseEnter: () => m(b),
              onMouseLeave: () => h(b),
              justify: "center",
              children: K4e[g.type]
            }
          ),
          (i == null ? void 0 : i[b]) && /* @__PURE__ */ c.jsxs(J4e, { children: [
            O,
            " with ",
            M.name,
            /* @__PURE__ */ c.jsx(exe, { width: "10", height: "10", src: M.image })
          ] })
        ] }),
        /* @__PURE__ */ c.jsx(
          b8,
          {
            ...l,
            index: b,
            onClickEditDestinationWallet: k,
            context: b === e.length - 1 ? "destination" : "intermediary",
            isSignRequired: N == null ? void 0 : N.signRequired,
            status: f,
            explorerLink: u
          }
        )
      ] }, `row-${g.fromChain}-${g.toChainID}-${b}`);
    })
  ] });
}, J4e = W(J).attrs({
  normalTextColor: !0
})`
  position: absolute;
  left: 30px;
  padding: 10px;
  border-radius: 13px;
  border: 1px solid ${({ theme: e }) => e.primary.text.ultraLowContrast};
  background-color: ${({ theme: e }) => e.secondary.background.normal};
  box-sizing: border-box;
  z-index: 1;
`, Z4e = W(be).attrs({
  as: be
})`
  color: ${({ theme: e }) => e.primary.text.lowContrast};
  &:hover {
    color: ${({ theme: e }) => e.primary.text.normal};
  }
`, Q4e = W(be)`
  padding: 25px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  border-radius: 25px;
  min-height: 225px;
`, exe = W.img`
  margin-left: 5px;
  object-fit: contain;
  width: 10px;
  height: 10px;
`, nxe = W(Y)`
  position: relative;
  height: 25px;
`, txe = () => {
  const e = pe($o), { route: n } = re(fn), t = n == null ? void 0 : n.requiredChainAddresses, { data: s } = re(We), a = re(Ew);
  Ae(nde);
  const { createCosmosWallets: o } = lE(), { createEvmWallets: i } = gE(), { createSolanaWallets: d } = uE(), m = Qe(_E), h = Q(() => n != null && n.operations ? Am(n.operations).filter((w) => w.signRequired).map((w) => w.fromChainID) : void 0, [n == null ? void 0 : n.operations]);
  on(() => {
    var y;
    const _ = {};
    n != null && n.operations && ((y = n == null ? void 0 : n.requiredChainAddresses) == null || y.forEach((w, q) => {
      _[q] = {
        chainID: w
      };
    }), e(_));
  }, []);
  const p = async (_) => {
    t && t.forEach(async (y, w) => {
      var v, g, b;
      const q = s == null ? void 0 : s.find((O) => O.chainID === y);
      if (!q)
        return;
      const k = h == null ? void 0 : h.includes(y);
      switch (q.chainType) {
        case "cosmos": {
          const D = o(y).find((M) => {
            var N;
            return M.walletName === ((N = a.cosmos) == null ? void 0 : N.walletName);
          });
          if (!D) {
            if (!_) return;
            m.show({
              signRequired: k,
              chainId: y
            });
            return;
          }
          try {
            const M = await ((v = D == null ? void 0 : D.getAddress) == null ? void 0 : v.call(D, {
              signRequired: k
            }));
            if (!M)
              return;
            e((N) => ({
              ...N,
              [w]: {
                chainID: y,
                address: M,
                chainType: "cosmos",
                source: "wallet",
                wallet: {
                  walletName: D == null ? void 0 : D.walletName,
                  walletPrettyName: D == null ? void 0 : D.walletPrettyName,
                  walletChainType: D == null ? void 0 : D.walletChainType,
                  walletInfo: D == null ? void 0 : D.walletInfo
                }
              }
            }));
          } catch {
            return;
          }
          break;
        }
        case "svm": {
          const D = d().find((M) => {
            var N;
            return M.walletName === ((N = a.svm) == null ? void 0 : N.walletName);
          });
          if (!D) {
            if (!_) return;
            m.show({
              signRequired: k,
              chainId: y
            });
            return;
          }
          try {
            const M = await ((g = D == null ? void 0 : D.getAddress) == null ? void 0 : g.call(D, {
              signRequired: k
            }));
            if (!M)
              return;
            e((N) => ({
              ...N,
              [w]: {
                chainID: y,
                address: M,
                chainType: "svm",
                source: "wallet",
                wallet: {
                  walletName: D == null ? void 0 : D.walletName,
                  walletPrettyName: D == null ? void 0 : D.walletPrettyName,
                  walletChainType: D == null ? void 0 : D.walletChainType,
                  walletInfo: D == null ? void 0 : D.walletInfo
                }
              }
            }));
          } catch {
            return;
          }
          break;
        }
        case "evm": {
          const D = i(y).find((M) => {
            var N;
            return M.walletName === ((N = a.evm) == null ? void 0 : N.walletName);
          });
          if (!D) {
            if (!_) return;
            m.show({
              signRequired: k,
              chainId: y
            });
            return;
          }
          try {
            const M = await ((b = D == null ? void 0 : D.getAddress) == null ? void 0 : b.call(D, {
              signRequired: k
            }));
            if (!M)
              return;
            e((N) => ({
              ...N,
              [w]: {
                chainID: y,
                address: M,
                chainType: "evm",
                source: "wallet",
                wallet: {
                  walletName: D == null ? void 0 : D.walletName,
                  walletPrettyName: D == null ? void 0 : D.walletPrettyName,
                  walletChainType: D == null ? void 0 : D.walletChainType,
                  walletInfo: D == null ? void 0 : D.walletInfo
                }
              }
            }));
          } catch {
            return;
          }
          break;
        }
      }
    });
  };
  return Dh({
    queryKey: ["auto-set-address", { requiredChainAddresses: t, chains: s, sourceWallet: a, signRequiredChains: h }],
    enabled: !!t && !!s && (!!a.cosmos || !!a.evm || !!a.svm),
    queryFn: async () => {
      if (t)
        return await p(), null;
    }
  }), { connectRequiredChains: p };
}, bE = ({
  txs: e,
  txsRequired: n,
  enabled: t
}) => {
  const s = re(go), [a, o] = qe(!1), [i, d] = qe(void 0), m = Q(
    () => ["txs-status", n, e],
    [e, n]
  );
  return Dh({
    queryKey: m,
    queryFn: async ({ queryKey: [, h, p] }) => {
      if (!p) return;
      const _ = await Promise.all(
        p.map(async (v) => await s.transactionStatus({
          chainID: v.chainID,
          txHash: v.txHash
        }))
      ), y = V4e(_), w = _.every((v) => v.state === "STATE_COMPLETED_SUCCESS" || v.state === "STATE_COMPLETED_ERROR" || v.state === "STATE_ABANDONED"), q = y.every((v) => v.status === "completed"), k = y.length > 0 && h === _.length && w;
      k && o(!0);
      const B = {
        isSuccess: q && k,
        isSettled: k,
        transferEvents: y
      };
      return d(B), B;
    },
    enabled: !a && (e && e.length > 0 && t !== void 0 ? t : !0),
    refetchInterval: 500,
    // to make the data persist when query key changed
    initialData: i
  });
}, sxe = (e) => {
  const { route: n, transactionDetailsArray: t } = re(
    fn
  ), s = pe(sn), a = pe(md), [o, i] = qe();
  on(() => {
    if (!(!(n != null && n.estimatedRouteDurationSeconds) || !(n != null && n.txsRequired))) {
      if (e === co.pending && o === void 0 && n.txsRequired === t.length) {
        const d = t[t.length - 1], m = setTimeout(() => {
          s({
            errorType: Xe.Timeout,
            onClickBack: () => {
              a("unconfirmed");
            },
            explorerLink: (d == null ? void 0 : d.explorerLink) ?? ""
          });
        }, n.estimatedRouteDurationSeconds * 1e3 * 2);
        i(m);
      }
      return e === co.confirmed && o !== void 0 && clearTimeout(o), () => {
        clearTimeout(o);
      };
    }
  }, [
    n,
    s,
    a,
    e,
    t,
    o
  ]);
}, vE = ({
  statusData: e,
  historyIndex: n
}) => {
  const t = e == null ? void 0 : e.transferEvents, s = pe(md), {
    route: a,
    transactionDetailsArray: o,
    overallStatus: i,
    transactionHistoryIndex: d
  } = re(fn), m = pe(_j), { isPending: h } = re(bj), p = Q(() => a != null && a.operations ? Am(a.operations) : [], [a == null ? void 0 : a.operations]), _ = Q(() => {
    if (!(!(a != null && a.operations) || !(a != null && a.txsRequired))) {
      if ((t == null ? void 0 : t.length) === 0) {
        h && s("signing");
        return;
      }
      if (t) {
        if (e.isSuccess)
          return "completed";
        if (!e.isSuccess && e.isSettled)
          return "failed";
        if (t != null && t.find(({ status: y }) => y === "pending"))
          return "pending";
        if (t != null && t.every(
          ({ status: y }) => y === "unconfirmed"
        ))
          return "unconfirmed";
      }
    }
  }, [h, a == null ? void 0 : a.operations, a == null ? void 0 : a.txsRequired, s, e == null ? void 0 : e.isSettled, e == null ? void 0 : e.isSuccess, t]);
  on(() => {
    _ && (m(n ?? d, {
      status: _
    }), n || s(_));
  }, [p, i, _, s, o.length, m, d, n]);
};
var co = /* @__PURE__ */ ((e) => (e[e.recoveryAddressUnset = 0] = "recoveryAddressUnset", e[e.destinationAddressUnset = 1] = "destinationAddressUnset", e[e.ready = 2] = "ready", e[e.pending = 3] = "pending", e[e.waitingForSigning = 4] = "waitingForSigning", e[e.confirmed = 5] = "confirmed", e[e.validatingGasBalance = 6] = "validatingGasBalance", e))(co || {});
const axe = () => {
  const e = je(), n = pe(uo), { route: t, overallStatus: s, transactionDetailsArray: a, isValidatingGasBalance: o } = re(
    fn
  ), i = re($o), { connectRequiredChains: d } = txe(), [m, h] = qe(!0), p = Qe(_E), { mutate: _ } = re(bj), { data: y } = bE({
    txsRequired: t == null ? void 0 : t.txsRequired,
    txs: a
  });
  vE({
    statusData: y
  });
  const w = Q(() => t != null && t.operations ? Am(t.operations) : [], [t == null ? void 0 : t.operations]), q = w[w.length - 1], k = Q(() => {
    var M;
    if (!i) return;
    const b = t == null ? void 0 : t.requiredChainAddresses;
    if (!b) return;
    const O = b.every(
      (N, l) => {
        var u;
        return (u = i[l]) == null ? void 0 : u.address;
      }
    ), D = (M = i[b.length - 1]) == null ? void 0 : M.address;
    return s === "completed" ? 5 : s === "pending" ? 3 : (o == null ? void 0 : o.status) !== "completed" && o ? 6 : s === "signing" ? 4 : D ? O ? 2 : 0 : 1;
  }, [i, o, s, t == null ? void 0 : t.requiredChainAddresses]);
  sxe(k);
  const B = Q(() => {
    const b = ((t == null ? void 0 : t.txsRequired) ?? 0) - (a == null ? void 0 : a.length);
    if (b > 1)
      return /* @__PURE__ */ c.jsxs(uj, { gap: 5, align: "center", children: [
        /* @__PURE__ */ c.jsx(qw, {}),
        b,
        " ",
        cd("Signature", b),
        " ",
        "still required"
      ] });
  }, [t == null ? void 0 : t.txsRequired, a == null ? void 0 : a.length]), v = Q(() => {
    switch (k) {
      case 0:
        return /* @__PURE__ */ c.jsx(
          De,
          {
            label: "Set recovery address",
            icon: ae.rightArrow,
            onClick: () => {
              d(!0);
            }
          }
        );
      case 1:
        return /* @__PURE__ */ c.jsx(
          De,
          {
            label: "Set destination address",
            icon: ae.rightArrow,
            onClick: () => {
              const b = t == null ? void 0 : t.destAssetChainID;
              b && p.show({
                signRequired: q.signRequired,
                chainId: b
              });
            }
          }
        );
      case 2:
        return /* @__PURE__ */ c.jsx(
          De,
          {
            label: "Confirm swap",
            icon: ae.rightArrow,
            onClick: _
          }
        );
      case 6:
        return /* @__PURE__ */ c.jsx(De, { label: "Validating gas and balance", icon: ae.rightArrow, loading: !0 });
      case 4:
        return /* @__PURE__ */ c.jsx(De, { label: "Confirm swap", icon: ae.rightArrow, loading: !0 });
      case 3:
        return /* @__PURE__ */ c.jsx(
          De,
          {
            label: "Swap in progress",
            loading: !0,
            loadingTimeString: hj(
              t == null ? void 0 : t.estimatedRouteDurationSeconds
            )
          }
        );
      case 5:
        return /* @__PURE__ */ c.jsx(
          De,
          {
            label: "Swap Complete",
            icon: ae.checkmark,
            backgroundColor: e.success.text,
            onClick: () => n(Je.SwapPage)
          }
        );
    }
  }, [d, q.signRequired, _, t == null ? void 0 : t.destAssetChainID, t == null ? void 0 : t.estimatedRouteDurationSeconds, n, p, k, e.success.text]), g = m ? I4e : Y4e;
  return /* @__PURE__ */ c.jsxs(be, { gap: 5, children: [
    /* @__PURE__ */ c.jsx(
      no,
      {
        leftButton: m ? {
          label: "Back",
          icon: ae.thinArrow,
          onClick: () => n(Je.SwapPage)
        } : void 0,
        rightButton: {
          label: m ? "Details" : "Hide details",
          icon: m ? ae.hamburger : ae.horizontalLine,
          onClick: () => h(!m)
        }
      }
    ),
    /* @__PURE__ */ c.jsx(
      g,
      {
        onClickEditDestinationWallet: () => p.show({
          chainId: t == null ? void 0 : t.destAssetChainID
        }),
        operations: w,
        statusData: y,
        swapExecutionState: k
      }
    ),
    v,
    /* @__PURE__ */ c.jsx(
      Mw,
      {
        showRouteInfo: s === void 0,
        rightContent: B
      }
    )
  ] });
}, kh = W.div`
  ${({ width: e, height: n, theme: t }) => Ye`
      width: ${e}px;
      height: ${n}px;
      background-color: ${Mh(t.primary.text.normal ?? "") + _n(10)};
    `};
`, oxe = W(kh)`
  border-radius: 50%;
`;
function rxe(e, n = 500, t = !1) {
  const s = me(
    void 0
  ), a = me(e), o = me(!1), i = me(
    e,
    (m, h, p) => {
      clearTimeout(m(s));
      const _ = m(a), y = typeof p == "function" ? p(_) : p, w = () => {
        h(a, y), h(o, !0);
      }, q = () => {
        h(i, y), h(o, !1);
      };
      if (w(), !t && y === e) {
        q();
        return;
      }
      const k = setTimeout(() => {
        q();
      }, n);
      h(s, k);
    }
  ), d = me(null, (m, h, p) => {
    clearTimeout(m(s)), h(o, !1);
  });
  return {
    currentValueAtom: me((m) => m(a)),
    isDebouncingAtom: o,
    clearTimeoutAtom: d,
    debouncedValueAtom: i
  };
}
const fE = rxe(void 0), I5 = ic((e) => {
  const n = e(go), t = e(fE.debouncedValueAtom), s = e(nm), a = Object.values(t ?? {}).length > 0 && !s;
  return {
    queryKey: ["skipBalances", t],
    queryFn: async () => {
      if (!t)
        throw new Error("No balance request provided");
      return n.balances(t);
    },
    enabled: a,
    refetchInterval: 1e3 * 60,
    retry: 1,
    gcTime: 0
  };
}), wE = () => {
  const { data: e } = re(I5);
  return Ne((t, s) => {
    var a, o, i;
    return (i = (o = (a = e == null ? void 0 : e.chains) == null ? void 0 : a[t]) == null ? void 0 : o.denoms) == null ? void 0 : i[s];
  }, [e]);
}, Ah = (e) => e.chains !== void 0, ixe = ({
  item: e,
  index: n,
  skeleton: t,
  onSelect: s,
  context: a
}) => {
  const { isLoading: o } = re(We), i = wE();
  if (!e || o) return t;
  if (Ah(e))
    return /* @__PURE__ */ c.jsx(
      zc,
      {
        onClick: () => s(e),
        style: { margin: "5px 0" },
        leftContent: /* @__PURE__ */ c.jsx(cxe, { item: e, context: a }),
        rightContent: Number(e.totalAmount) > 0 && /* @__PURE__ */ c.jsxs(be, { align: "flex-end", children: [
          /* @__PURE__ */ c.jsx(J, { normalTextColor: !0, children: parseFloat(e.totalAmount.toFixed(8)) }),
          Number(e.totalUsd) > 0 && /* @__PURE__ */ c.jsx(J, { children: jo(e.totalUsd) })
        ] })
      },
      `${n}${e.id}`
    );
  const d = i(e.asset.chainID, e.asset.denom);
  return /* @__PURE__ */ c.jsx(
    zc,
    {
      onClick: () => s(e.asset),
      style: { margin: "5px 0" },
      leftContent: /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 8, children: [
        /* @__PURE__ */ c.jsx(
          xE,
          {
            height: 35,
            width: 35,
            src: e == null ? void 0 : e.logoURI,
            alt: `${e.chainID} logo`
          }
        ),
        /* @__PURE__ */ c.jsxs(Y, { align: "end", gap: 8, children: [
          /* @__PURE__ */ c.jsx(Te, { children: e.prettyName }),
          /* @__PURE__ */ c.jsx(J, { children: e.chainID })
        ] })
      ] }),
      rightContent: d && Number(d.amount) > 0 && /* @__PURE__ */ c.jsxs(be, { align: "flex-end", children: [
        /* @__PURE__ */ c.jsx(J, { normalTextColor: !0, children: ho(
          d.amount,
          d.decimals
        ) }),
        d.valueUSD && /* @__PURE__ */ c.jsx(J, { children: jo(d.valueUSD) })
      ] })
    },
    e.chainID
  );
}, cxe = ({
  item: e,
  context: n
}) => {
  const { data: t } = re(We), s = e.chains.map((o) => {
    const i = t == null ? void 0 : t.find((d) => d.chainID === o.chainID);
    return {
      chainName: (i == null ? void 0 : i.prettyName) || o.chainID
    };
  }).sort((o, i) => o.chainName.localeCompare(i.chainName)), a = n === "source" ? s.filter((o) => !o.chainName.toLowerCase().includes("penumbra")) : s;
  return /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 8, children: [
    /* @__PURE__ */ c.jsx(
      xE,
      {
        height: 35,
        width: 35,
        src: e.assets[0].logoURI,
        alt: `${e.assets[0].recommendedSymbol} logo`
      }
    ),
    /* @__PURE__ */ c.jsxs(Y, { align: "end", gap: 8, children: [
      /* @__PURE__ */ c.jsx(Te, { children: e.assets[0].recommendedSymbol }),
      a.length > 1 ? /* @__PURE__ */ c.jsx(J, { children: `${a.length} networks` }) : a.map((o, i) => /* @__PURE__ */ c.jsx(Y, { align: "center", gap: 6, children: /* @__PURE__ */ c.jsx(J, { children: o.chainName }) }, i))
    ] })
  ] });
}, xE = W.img`
  border-radius: 50%;
  object-fit: cover;
  ${({ theme: e }) => `background-color: ${e.secondary.background.hover};`};
`, j8 = () => /* @__PURE__ */ c.jsx(
  zc,
  {
    style: { margin: "5px 0" },
    leftContent: /* @__PURE__ */ c.jsxs(dxe, { align: "center", gap: 10, children: [
      /* @__PURE__ */ c.jsx(oxe, { width: 35, height: 35 }),
      /* @__PURE__ */ c.jsx(kh, { width: 80, height: 20 }),
      /* @__PURE__ */ c.jsx(kh, { width: 60, height: 16 })
    ] })
  }
), dxe = W(Y)`
  filter: blur(4px);
`, mxe = ({
  color: e = "currentColor",
  className: n
}) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "21",
    height: "20",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: n,
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M15.347 9.01315C15.347 10.6201 14.7218 12.132 13.5847 13.2673C12.4475 14.4045 10.9374 15.0297 9.33047 15.0297C7.7235 15.0297 6.21159 14.4045 5.07629 13.2673C3.93916 12.1302 3.31392 10.6201 3.31392 9.01315C3.31392 7.40618 3.93916 5.89427 5.07629 4.75897C6.21342 3.62184 7.7235 2.9966 9.33047 2.9966C10.9374 2.9966 12.4494 3.62184 13.5847 4.75897C14.7218 5.8961 15.347 7.40618 15.347 9.01315ZM15.5244 2.81927C13.7912 1.08615 11.4585 0.168405 8.99408 0.259814C4.50407 0.426178 0.820279 4.04964 0.584443 8.536C0.430876 11.441 1.67953 14.1741 4.01412 15.9767C5.14759 16.8524 6.49313 17.4338 7.90997 17.6586C9.69976 17.942 11.4091 17.6787 12.8991 17.0096C13.9448 16.5398 15.177 16.7957 15.9869 17.6056L18.1277 19.7464L20.0674 17.8067L17.901 15.6403C17.0948 14.8341 16.8681 13.6147 17.3324 12.5745C17.8206 11.4849 18.0911 10.2801 18.0911 9.01132C18.0911 6.67125 17.1807 4.47195 15.5262 2.81744",
        fill: e
      }
    )
  }
), hxe = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent"
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ c.jsx("rect", { width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M11.9383 15.031L9.5 17.4693L17.0773 25.0449C17.0785 25.0461 17.0798 25.0474 17.081 25.0486L20.0023 27.9692L29.281 18.6907C29.2832 18.6884 29.2855 18.6861 29.2878 18.6838L30.5 17.4716L28.0617 15.0333L22.9273 20.1692C22.9246 20.1719 22.922 20.1745 22.9193 20.1771C21.3072 21.7811 18.7025 21.7826 17.0887 20.1813C17.0847 20.1774 17.0808 20.1736 17.0769 20.1696L11.9383 15.031Z",
          fill: e
        }
      )
    ]
  }
), pxe = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ c.jsxs("g", { opacity: "0.5", children: [
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M4.96253 7.13619C3.78268 7.13619 2.82646 6.17997 2.82646 5.00012C2.82646 3.82027 3.78268 2.86405 4.96253 2.86405C6.14238 2.86405 7.0986 3.82027 7.0986 5.00012C7.0986 6.17997 6.14238 7.13619 4.96253 7.13619ZM7.67865 5.79097C7.74234 5.5703 7.97633 5.44639 8.19404 5.52044L8.91626 5.7653V4.23495L8.18811 4.48178C7.97189 4.55534 7.73789 4.4334 7.67322 4.21422C7.61448 4.01478 7.53401 3.82422 7.43429 3.64552C7.32223 3.44361 7.39924 3.18937 7.60608 3.08719L8.29869 2.74508L7.21659 1.66297L6.8725 2.36002C6.77081 2.56637 6.51756 2.64388 6.31615 2.5333C6.13744 2.43506 5.9464 2.35558 5.74696 2.29782C5.52679 2.23414 5.40386 1.99965 5.47742 1.78244L5.72721 1.0459H4.19686L4.44665 1.78244C4.52021 2.00015 4.3968 2.23365 4.17662 2.29782C3.98015 2.35509 3.79255 2.43259 3.61582 2.52886C3.41638 2.63746 3.16659 2.56242 3.06341 2.36002L2.70699 1.66297L1.62489 2.74508L2.31749 3.09903C2.52039 3.2027 2.59543 3.45348 2.48534 3.65292C2.38759 3.83064 2.30811 4.01971 2.24986 4.21767C2.18519 4.43834 1.94972 4.56077 1.73251 4.48573L1.00781 4.23495V5.7653L1.72708 5.51649C1.94528 5.44096 2.18174 5.56487 2.24542 5.78702C2.30367 5.99041 2.38364 6.18442 2.48336 6.36658C2.59444 6.56898 2.51545 6.82272 2.30811 6.92392L1.62489 7.25566L2.70699 8.33777L3.03676 7.65898C3.13796 7.45066 3.39318 7.37217 3.59608 7.48472C3.77774 7.58543 3.97175 7.66688 4.17514 7.72612C4.3963 7.7903 4.51823 8.02627 4.4432 8.24348L4.19686 8.95484H5.72721L5.48087 8.24348C5.40534 8.02577 5.52827 7.7903 5.74943 7.72612C5.95133 7.66737 6.14386 7.58641 6.32454 7.48669C6.52645 7.37513 6.7797 7.45263 6.88188 7.65898L7.21708 8.33777L8.29918 7.25566L7.61695 6.91898C7.41109 6.81729 7.33309 6.56503 7.44367 6.36312C7.54191 6.18343 7.62139 5.99238 7.67865 5.79146",
          fill: e
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M7.67865 5.79097C7.74234 5.5703 7.97633 5.44639 8.19404 5.52044L8.91626 5.7653V4.23495L8.18811 4.48178C7.97189 4.55534 7.73789 4.4334 7.67322 4.21422C7.61448 4.01478 7.53401 3.82422 7.43429 3.64552C7.32223 3.44361 7.39924 3.18938 7.60608 3.08719L8.29869 2.74508L7.21659 1.66297L6.8725 2.36002C6.77081 2.56637 6.51756 2.64388 6.31615 2.5333C6.13744 2.43506 5.9464 2.35558 5.74696 2.29782C5.52679 2.23414 5.40386 1.99965 5.47742 1.78244L5.72721 1.0459H4.19686L4.44665 1.78244C4.52021 2.00015 4.3968 2.23365 4.17662 2.29782C3.98015 2.35509 3.79255 2.43259 3.61582 2.52886C3.41638 2.63746 3.16659 2.56242 3.06341 2.36002L2.70699 1.66297L1.62489 2.74508L2.31749 3.09903C2.52039 3.2027 2.59543 3.45348 2.48534 3.65292C2.38759 3.83064 2.30811 4.01971 2.24986 4.21767C2.18519 4.43834 1.94972 4.56077 1.73251 4.48573L1.00781 4.23495V5.7653L1.72708 5.51649C1.94528 5.44096 2.18174 5.56487 2.24542 5.78702C2.30367 5.99041 2.38364 6.18442 2.48336 6.36658C2.59444 6.56898 2.51545 6.82272 2.30811 6.92392L1.62489 7.25566L2.70699 8.33777L3.03676 7.65898C3.13796 7.45066 3.39318 7.37217 3.59608 7.48472C3.77774 7.58543 3.97175 7.66688 4.17514 7.72612C4.3963 7.7903 4.51823 8.02627 4.4432 8.24348L4.19686 8.95484H5.72721L5.48087 8.24348C5.40534 8.02577 5.52827 7.7903 5.74943 7.72612C5.95133 7.66737 6.14386 7.58641 6.32454 7.48669C6.52645 7.37513 6.7797 7.45263 6.88188 7.65898L7.21708 8.33777L8.29918 7.25566L7.61695 6.91898C7.41109 6.81729 7.33309 6.56503 7.44367 6.36312C7.54191 6.18343 7.62139 5.99238 7.67865 5.79146M4.96253 7.13619C3.78268 7.13619 2.82646 6.17997 2.82646 5.00012C2.82646 3.82027 3.78268 2.86405 4.96253 2.86405C6.14238 2.86405 7.0986 3.82027 7.0986 5.00012C7.0986 6.17997 6.14238 7.13619 4.96253 7.13619Z",
          stroke: e,
          strokeWidth: "0.3"
        }
      )
    ] })
  }
), lxe = ({
  color: e = "currentColor",
  direction: n,
  ...t
}) => /* @__PURE__ */ c.jsx("svg", { width: "9", height: "7", viewBox: "0 0 9 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", transform: n === "up" ? "rotate(180)" : "", ...t, children: /* @__PURE__ */ c.jsx("path", { d: "M4.44881 6.98877L0.420326 0.0112305L8.47729 0.0112305L4.44881 6.98877Z", fill: e }) }), C8 = ({
  value: e,
  usdValue: n,
  onChangeValue: t,
  selectedAsset: s,
  handleChangeAsset: a,
  handleChangeChain: o,
  priceChangePercentage: i,
  isWaitingToUpdateInputValue: d,
  badPriceWarning: m
}) => {
  const h = je(), [p, _] = qe(!1), y = p || m, w = an({
    assetDenom: s == null ? void 0 : s.denom,
    amount: e,
    chainId: s == null ? void 0 : s.chainID
  }), q = (v) => {
    if (!t) return;
    let g = v.target.value;
    g.match(/^[.,]/) && (g = `0.${g}`), g = g.replace(/^[0]{2,}/, "0"), g = g.replace(/[^\d.,]/g, ""), g = g.replace(/[.]{2,}/g, "."), g = g.replace(/[,]{2,}/g, ","), t == null || t(Qd(Vm(g)));
  }, k = (v) => {
    if (!t) return;
    let g;
    switch (v.key) {
      case "Escape":
        v.currentTarget.selectionStart === v.currentTarget.selectionEnd && v.currentTarget.select();
        return;
      case "ArrowUp":
        v.preventDefault(), g = new io(
          Vm(v.currentTarget.value) || "0"
        ), v.shiftKey ? g = g.plus(10) : v.altKey || v.ctrlKey || v.metaKey ? g = g.plus(0.1) : g = g.plus(1), g.isNegative() && (g = new io(0)), t(g.toString());
        break;
      case "ArrowDown":
        v.preventDefault(), g = new io(
          Vm(v.currentTarget.value) || "0"
        ), v.shiftKey ? g = g.minus(10) : v.altKey || v.ctrlKey || v.metaKey ? g = g.minus(0.1) : g = g.minus(1), g.isNegative() && (g = new io(0)), t(g.toString());
        break;
      default:
        return;
    }
  }, B = Q(() => i ? i > 0 ? h.success.text : h.error.text : h.primary.text.normal, [
    i,
    h.error.text,
    h.primary.text.normal,
    h.success.text
  ]);
  return /* @__PURE__ */ c.jsxs(
    gxe,
    {
      justify: "space-between",
      padding: 20,
      borderRadius: 25,
      children: [
        /* @__PURE__ */ c.jsxs(Y, { justify: "space-between", children: [
          /* @__PURE__ */ c.jsx(
            uxe,
            {
              type: "text",
              value: $ce(e || ""),
              placeholder: "0",
              inputMode: "numeric",
              onChange: q,
              onKeyDown: k,
              isWaitingToUpdateInputValue: d
            }
          ),
          /* @__PURE__ */ c.jsxs(jn, { onClick: a, gap: 5, children: [
            w != null && w.assetImage && w.symbol ? /* @__PURE__ */ c.jsxs(N5, { align: "center", justify: "center", gap: 7, children: [
              /* @__PURE__ */ c.jsx(yxe, { src: w.assetImage }),
              /* @__PURE__ */ c.jsx(Te, { children: w.symbol })
            ] }) : /* @__PURE__ */ c.jsx(_xe, { children: /* @__PURE__ */ c.jsx(Te, { mainButtonColor: h.brandColor, children: "Select asset" }) }),
            /* @__PURE__ */ c.jsx(
              hxe,
              {
                color: h.primary.background.normal,
                backgroundColor: h.primary.text.normal
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs(Y, { justify: "space-between", align: "center", children: [
          i ? /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 6, children: [
            /* @__PURE__ */ c.jsx(
              bd,
              {
                color: m ? h.error.text : void 0,
                onMouseEnter: () => _(!0),
                onMouseLeave: () => _(!1),
                children: n && jo(n)
              }
            ),
            /* @__PURE__ */ c.jsx(
              lxe,
              {
                color: B,
                direction: (i ?? 0) > 0 ? "up" : "down",
                style: { scale: y ? "1" : "0.7" }
              }
            ),
            y && /* @__PURE__ */ c.jsxs(J, { color: B, children: [
              i,
              "%"
            ] })
          ] }) : /* @__PURE__ */ c.jsx(J, { children: n && jo(n) }),
          w != null && w.chainName ? /* @__PURE__ */ c.jsxs(
            Rr,
            {
              onClick: o,
              align: "center",
              secondary: !0,
              gap: 4,
              children: [
                /* @__PURE__ */ c.jsxs(J, { children: [
                  "on ",
                  w == null ? void 0 : w.chainName
                ] }),
                /* @__PURE__ */ c.jsx(pxe, { color: h.primary.text.normal })
              ]
            }
          ) : /* @__PURE__ */ c.jsx(sj, {})
        ] })
      ]
    }
  );
}, gxe = W(be)`
  height: 110px;
  width: 480px;
  background-color: ${(e) => e.theme.primary.background.normal};
`, uxe = W.input`
  all: unset;
  font-size: 38px;
  font-weight: 300;
  width: 100%;
  color: ${(e) => e.theme.primary.text.normal};
  background-color: ${(e) => e.theme.primary.background.normal};

  ${(e) => e.isWaitingToUpdateInputValue && "animation: pulse 2s cubic-bezier(.4,0,.6,1) infinite;"}
  @keyframes pulse {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.5;
    }
  }
`, N5 = W(Y).attrs({
  padding: 8
})`
  height: 40px;
  border-radius: 10px;
  white-space: nowrap;
  color: ${(e) => e.theme.primary.text.normal};
  background-color: ${(e) => e.theme.secondary.background.normal};
`, _xe = W(N5)`
  background-color: ${(e) => e.theme.brandColor};
`, yxe = W.img`
  border-radius: 50%;
  width: 23px;
  height: 23px;
  object-fit: cover;
`, bxe = ({
  asset: e,
  onSearch: n,
  onClickBack: t,
  searchTerm: s,
  setSearchTerm: a,
  onKeyDown: o
}) => {
  const i = je(), d = Ch(null), m = Ne(
    (h) => {
      const p = h.target.value;
      a(p), n(p);
    },
    [n, a]
  );
  return on(() => {
    setTimeout(() => {
      var h;
      (h = d.current) == null || h.focus();
    }, 0);
  }, [e]), /* @__PURE__ */ c.jsxs(xxe, { align: "center", gap: 5, children: [
    e ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx(jn, { onClick: t, children: /* @__PURE__ */ c.jsx(vxe, { color: i.primary.text.normal }) }),
      /* @__PURE__ */ c.jsxs(fxe, { gap: 5, align: "center", justify: "center", children: [
        /* @__PURE__ */ c.jsx("img", { src: e.logoURI, width: 20, height: 20 }),
        /* @__PURE__ */ c.jsx(Te, { children: e == null ? void 0 : e.symbol })
      ] })
    ] }) : /* @__PURE__ */ c.jsx(wxe, { color: i.primary.text.normal }),
    /* @__PURE__ */ c.jsx(
      kxe,
      {
        ref: d,
        style: { paddingLeft: e ? void 0 : 30 },
        type: "text",
        placeholder: e ? "Search network" : "Search asset",
        value: s,
        onChange: m,
        onKeyDown: o
      }
    ),
    /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 5, children: [
      /* @__PURE__ */ c.jsx(J, { style: { textWrap: "nowrap" }, children: " Powered by " }),
      /* @__PURE__ */ c.jsx(pj, { color: i.primary.text.lowContrast })
    ] })
  ] });
}, vxe = W(zw)`
  width: 25px;
  opacity: 0.5;
`, fxe = W(N5)`
  height: auto;
`, wxe = W(mxe)`
  position: absolute;
  width: 20px;
  height: 20px;
`, xxe = W(Y)`
  padding: 6px 10px;
  height: 50px;
  position: relative;
`, kxe = W.input`
  height: 40px;
  box-sizing: border-box;
  width: 100%;
  border: none;
  outline: none;
  color: ${({ theme: e }) => e.primary.text.normal};
  background-color: ${({ theme: e }) => e.primary.background.normal};
`, Axe = Lc(
  (e) => {
    const n = Qe(), { onSelect: t, selectedAsset: s, networkSelection: a } = e, { data: o, isLoading: i } = re(dc), { data: d } = re(We), { isLoading: m } = re(We), h = i || m, p = wE(), [_, y] = qe(!0), [w, q] = qe(""), [k, B] = qe(null), v = () => {
      q("");
    }, g = Ne(
      (x) => {
        if (x) {
          if (Ah(x)) {
            x.assets.length === 1 ? t(x.assets[0]) : B(x), v();
            return;
          }
          t(x), v();
        }
      },
      [t]
    ), b = Q(() => {
      if (!o) return;
      const x = [], C = (F) => F.reduce(
        (A, E) => {
          const T = p(E.chainID, E.denom);
          return T && (A.totalAmount += Number(
            ho(
              T.amount,
              T.decimals
            )
          ), Number(T.valueUSD) && (A.totalUsd += Number(T.valueUSD))), A;
        },
        { totalAmount: 0, totalUsd: 0 }
      );
      return o.forEach((F) => {
        const A = x.find(
          (E) => E.id === F.recommendedSymbol
        );
        A ? (A.assets.push(F), A.chains.push({
          chainID: F.chainID,
          chainName: F.chainName,
          originChainID: F.originChainID
        })) : x.push({
          id: F.recommendedSymbol || F.symbol || F.denom,
          chains: [
            {
              chainID: F.chainID,
              chainName: F.chainName,
              originChainID: F.originChainID
            }
          ],
          assets: [F],
          totalAmount: 0,
          totalUsd: 0
        });
      }), x.forEach((F) => {
        const A = C(F.assets);
        F.totalAmount = A.totalAmount, F.totalUsd = A.totalUsd;
      }), x;
    }, [o, p]), O = Q(() => {
      const x = (k == null ? void 0 : k.assets[0]) || s;
      if (x)
        return b == null ? void 0 : b.find(
          (C) => C.id === x.recommendedSymbol
        );
    }, [
      k == null ? void 0 : k.assets,
      s,
      b
    ]), D = Q(() => {
      if (b)
        return a6(b, w, {
          keys: ["id"]
        }).sort((x, C) => {
          const F = ["ATOM", "USDC", "USDT", "ETH", "TIA", "OSMO", "NTRN", "INJ"];
          if (x.totalUsd === 0 && C.totalUsd === 0) {
            const A = F.indexOf(x.id), E = F.indexOf(C.id);
            if (A !== -1 && E !== -1)
              return A - E;
            if (A !== -1) return -1;
            if (E !== -1) return 1;
          }
          return x.totalUsd < C.totalUsd ? 1 : x.totalUsd > C.totalUsd ? -1 : 0;
        });
    }, [b, w]), M = Q(() => {
      if (!O || !d) return;
      const x = O.assets.map((C) => ({
        ...d.find((A) => A.chainID === C.chainID),
        asset: C
      })).filter((C) => C);
      return a6(x, w, {
        keys: ["prettyName", "chainName", "chainID"]
      }).sort((C, F) => {
        const A = p(
          C.chainID,
          C.asset.denom
        ), E = p(
          F.chainID,
          F.asset.denom
        );
        return Number((A == null ? void 0 : A.valueUSD) ?? 0) < Number((E == null ? void 0 : E.valueUSD) ?? 0) ? 1 : Number((A == null ? void 0 : A.valueUSD) ?? 0) > Number((E == null ? void 0 : E.valueUSD) ?? 0) ? -1 : F.asset.originChainID === F.chainID ? 1 : C.asset.originChainID === C.chainID ? -1 : 0;
      });
    }, [d, p, w, O]);
    on(() => {
      if (!h && o) {
        const x = setTimeout(() => {
          y(!1);
        }, 100);
        return () => clearTimeout(x);
      }
    }, [h, o]), on(() => {
      q("");
    }, [n.visible]);
    const N = (x) => {
      q(x);
    }, l = Ne(
      (x, C) => /* @__PURE__ */ c.jsx(
        ixe,
        {
          item: x,
          index: C,
          onSelect: g,
          skeleton: /* @__PURE__ */ c.jsx(j8, {}),
          context: e.context
        }
      ),
      [e.context, g]
    ), u = Q(() => a ? e.context === "source" ? M == null ? void 0 : M.filter((x) => !x.chainID.includes("penumbra")) : M : k ? e.context === "source" ? M == null ? void 0 : M.filter((x) => !x.chainID.includes("penumbra")) : M : D, [D, M, k, e.context, a]), f = () => {
      k === null ? n.remove() : B(null);
    }, S = (x) => {
      x.key === "Backspace" && k !== null && w === "" && B(null);
    };
    return /* @__PURE__ */ c.jsxs(jxe, { children: [
      /* @__PURE__ */ c.jsx(
        bxe,
        {
          onSearch: N,
          onClickBack: f,
          asset: (k == null ? void 0 : k.assets[0]) || s,
          searchTerm: w,
          setSearchTerm: q,
          onKeyDown: S
        }
      ),
      _ || !D && !M ? /* @__PURE__ */ c.jsx(be, { children: Array.from({ length: 10 }, (x, C) => /* @__PURE__ */ c.jsx(j8, {}, C)) }) : /* @__PURE__ */ c.jsx(
        Iw,
        {
          listItems: u ?? [],
          height: 530,
          itemHeight: 70,
          itemKey: (x) => Ah(x) ? `${x.id}` : `${x.chainID}-${x.asset.denom}`,
          renderItem: l
        }
      )
    ] });
  }
), jxe = W(be)`
  padding: 10px;
  gap: 10px;
  width: 580px;
  height: 600px;
  border-radius: 20px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  overflow: hidden;
`, Cxe = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "9",
    height: "11",
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M2.8108 1.87099L4.62035 3.73224C5.01216 4.13524 4.73524 4.82459 4.17993 4.82459L0.876057 4.82459L0.876056 6.43207L4.18067 6.43282C4.7345 6.43282 5.01289 7.12217 4.62108 7.52518L2.80933 9.3887L3.91406 10.525L8.67323 5.62984L3.91553 0.736215L2.8108 1.87251L2.8108 1.87099Z",
        fill: e
      }
    )
  }
), Exe = [0.5, 3, 5, 10], Dxe = ({ color: e = "currentColor", ...n }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.06616 14.199C10.9322 14.199 14.0662 11.065 14.0662 7.19897C14.0662 3.33298 10.9322 0.198975 7.06616 0.198975C3.20017 0.198975 0.0661621 3.33298 0.0661621 7.19897C0.0661621 11.065 3.20017 14.199 7.06616 14.199ZM7.22184 6.66477C6.5255 7.20041 6.2791 7.66107 6.2791 8.71094H7.54323C7.54323 8.07887 7.6825 7.78962 8.15387 7.42538L8.56096 7.12542C9.02162 6.78261 9.5037 6.11841 9.5037 5.34707C9.5037 4.07224 8.49668 3.27948 7.15757 3.27948C5.53991 3.27948 4.51147 4.26507 4.51147 5.83987H5.93629C5.93629 4.88642 6.38623 4.42576 7.13614 4.42576C7.75749 4.42576 8.14316 4.79 8.14316 5.38993C8.14316 5.74345 7.98246 6.07555 7.5968 6.37552L7.22184 6.66477ZM6.1077 9.37514V10.9714H7.72535V9.37514H6.1077Z",
        fill: e
      }
    )
  }
), Bxe = Lc((e) => {
  var v;
  const n = je(), { data: t } = re(Wc), { data: s } = re(We), [a, o] = Ae(Gce), [i, d] = qe(!1), m = Q(() => t == null ? void 0 : t.chainIDs.map(
    (g) => s == null ? void 0 : s.find((b) => b.chainID === g)
  ), [t, s]), h = t && Am(t.operations), p = Q(() => h == null ? void 0 : h.find((g) => g.toChainID === "1"), [h]), _ = Q(() => {
    if (h)
      return h == null ? void 0 : h.find(
        (g) => g.type === un.axelarTransfer
      );
  }, [h]), y = Q(() => {
    if (h)
      return h == null ? void 0 : h.find(
        (g) => g.type === un.hyperlaneTransfer
      );
  }, [h]), w = Q(() => {
    if (_) {
      const { feeAmount: g, feeAsset: b, usdFeeAmount: O } = _;
      if (!g || !b || !b.decimals) return;
      const D = ho(
        g,
        b.decimals
      );
      return {
        assetAmount: Number(D),
        formattedAssetAmount: `${D} ${b.symbol}`,
        formattedUsdAmount: O ? `${jo(O)}` : void 0
      };
    }
  }, [_]), q = Q(() => {
    if (y) {
      const { feeAmount: g, feeAsset: b, usdFeeAmount: O } = y;
      if (!g || !b || !b.decimals) return;
      const D = ho(
        g,
        b.decimals
      );
      return {
        assetAmount: Number(D),
        formattedAssetAmount: `${D} ${b.symbol}`,
        formattedUsdAmount: O ? `${jo(O)}` : void 0
      };
    }
  }, [y]), k = (v = t == null ? void 0 : t.estimatedFees) == null ? void 0 : v.some(
    (g) => g.feeType === "SMART_RELAY"
  ), B = Q(() => {
    if (!k) return;
    const g = t == null ? void 0 : t.estimatedFees.filter(
      (N) => N.feeType === "SMART_RELAY"
    );
    if (!(g == null ? void 0 : g.every(
      (N, l, u) => N.originAsset.symbol === u[0].originAsset.symbol
    ))) return;
    const O = g == null ? void 0 : g.reduce(
      (N, l) => N + Number(l.amount),
      0
    ), D = g == null ? void 0 : g.reduce(
      (N, l) => N + Number(l.usdAmount),
      0
    );
    if (!O || !g || !D) return;
    const M = (O / Math.pow(10, g[0].originAsset.decimals || 6)).toLocaleString("en-US", {
      maximumFractionDigits: 6
    });
    return {
      assetAmount: Number(M),
      formattedAssetAmount: `${M} ${g[0].originAsset.symbol}`,
      formattedUsdAmount: `${jo(D)}`
    };
  }, [k, t == null ? void 0 : t.estimatedFees]);
  return /* @__PURE__ */ c.jsxs(Fxe, { gap: 20, children: [
    /* @__PURE__ */ c.jsxs(be, { gap: 10, children: [
      /* @__PURE__ */ c.jsxs(Y, { justify: "space-between", children: [
        /* @__PURE__ */ c.jsx(hn, { children: "Route" }),
        /* @__PURE__ */ c.jsx(Y, { align: "center", gap: 5, children: m == null ? void 0 : m.map((g, b) => {
          var O, D;
          return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            /* @__PURE__ */ c.jsx("img", { width: "20", height: "20", src: g == null ? void 0 : g.logoURI, alt: g == null ? void 0 : g.prettyName, title: g == null ? void 0 : g.prettyName }),
            b !== m.length - 1 && /* @__PURE__ */ c.jsx(Cxe, { color: (D = (O = e.theme) == null ? void 0 : O.primary) == null ? void 0 : D.text.normal })
          ] });
        }) })
      ] }),
      !!(t != null && t.swapPriceImpactPercent) && /* @__PURE__ */ c.jsxs(Y, { justify: "space-between", children: [
        /* @__PURE__ */ c.jsx(hn, { children: "Price Impact" }),
        /* @__PURE__ */ c.jsx(Y, { align: "center", gap: 5, children: /* @__PURE__ */ c.jsxs(hn, { monospace: !0, children: [
          t == null ? void 0 : t.swapPriceImpactPercent,
          "%"
        ] }) })
      ] }),
      /* @__PURE__ */ c.jsxs(Y, { justify: "space-between", children: [
        /* @__PURE__ */ c.jsxs(hn, { children: [
          "Max Slippage",
          /* @__PURE__ */ c.jsx(sj, { width: 5 }),
          /* @__PURE__ */ c.jsx(
            Dxe,
            {
              onMouseEnter: () => d(!0),
              onMouseLeave: () => d(!1)
            }
          ),
          i && /* @__PURE__ */ c.jsx(qxe, { children: "If price changes unfavorably during the transaction by more than this amount, the transaction will revert" })
        ] }),
        /* @__PURE__ */ c.jsx(Y, { gap: 4, children: Exe.map((g) => /* @__PURE__ */ c.jsxs(
          $xe,
          {
            monospace: !0,
            selected: g === a.slippage,
            onClick: () => o({ slippage: g }),
            children: [
              g,
              "%"
            ]
          }
        )) })
      ] })
    ] }),
    (w || q || B) && /* @__PURE__ */ c.jsxs(be, { gap: 10, children: [
      w && /* @__PURE__ */ c.jsxs(Y, { justify: "space-between", children: [
        /* @__PURE__ */ c.jsx(hn, { children: "Axelar Bridging Fee" }),
        /* @__PURE__ */ c.jsxs(hn, { monospace: !0, children: [
          w.formattedAssetAmount,
          " (",
          w.formattedUsdAmount,
          ")"
        ] })
      ] }),
      q && /* @__PURE__ */ c.jsxs(Y, { justify: "space-between", children: [
        /* @__PURE__ */ c.jsx(hn, { children: "Hyperlane Bridging Fee" }),
        /* @__PURE__ */ c.jsxs(hn, { monospace: !0, children: [
          q.formattedAssetAmount,
          " (",
          q.formattedUsdAmount,
          ")"
        ] })
      ] }),
      B && /* @__PURE__ */ c.jsxs(Y, { justify: "space-between", children: [
        /* @__PURE__ */ c.jsx(hn, { children: "Relayer Fee" }),
        /* @__PURE__ */ c.jsxs(hn, { monospace: !0, children: [
          B.formattedAssetAmount,
          " (",
          B.formattedUsdAmount,
          ")"
        ] })
      ] })
    ] }),
    p && /* @__PURE__ */ c.jsx(zxe, { children: /* @__PURE__ */ c.jsxs(hn, { color: n.warning.text, children: [
      "This swap contains at least one EVM chain, so it might take longer.",
      /* @__PURE__ */ c.jsx("br", {}),
      " Read more about common finality times."
    ] }) }),
    /* @__PURE__ */ c.jsx(hn, { justify: "space-between", children: /* @__PURE__ */ c.jsx(gj, { showRouteInfo: !0 }) })
  ] });
}), Fxe = W(be)`
  width: 480px;
  padding: 20px;
  border-radius: 20px;
  background-color: ${(e) => e.theme.primary.background.normal};
`, $xe = W(J)`
  border-radius: 7px;
  padding: 4px 7px;
  white-space: nowrap;
  color: ${({ selected: e, theme: n }) => e ? Ih(n.brandColor) : n.primary.text.normal};
  &:hover {
    box-shadow: inset 0px 0px 0px 1px ${(e) => e.theme.brandColor};
    opacity: 1;
    cursor: pointer;
  }
  ${({ selected: e, theme: n }) => e && Ye`
      background-color: ${n.brandColor};
      opacity: 1;
    `}
`, hn = W(Y).attrs({
  as: J,
  normalTextColor: !0
})`
  position: relative;
  letter-spacing: 0.26px;
`, zxe = W.div`
  padding: 12px;
  border-radius: 5px;
  background-color: ${({ theme: e }) => e.warning.background};
`, qxe = W(J).attrs({
  normalTextColor: !0
})`
  position: absolute;
  padding: 13px;
  border-radius: 13px;
  border: 1px solid ${({ theme: e }) => e.primary.text.ultraLowContrast};
  background-color: ${({ theme: e }) => e.secondary.background.normal};
  top: -30px;
  left: 110px;
  width: 250px;
  z-index: 1;
`, Sxe = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "47",
    height: "7",
    viewBox: "0 0 47 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { display: "flex", alignItems: "center", justifyContent: "center" },
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.477783 0.000183105H46.4778V1.00416C45.1089 1.01674 44.0032 2.13029 44.0032 3.5021C44.0032 4.87391 45.1089 5.98746 46.4778 6.00004V7.00018H0.477783V5.99322C1.76984 5.89734 2.78833 4.81866 2.78833 3.5021C2.78833 2.18554 1.76984 1.10686 0.477783 1.01098V0.000183105Z",
        fill: e
      }
    )
  }
), Txe = () => {
  const e = je(), [n, t] = qe(!1), s = pe(Wce), a = () => {
    s();
    let o;
    clearTimeout(o), t(!0), o = setTimeout(() => t(!1), 500);
  };
  return /* @__PURE__ */ c.jsxs(
    jn,
    {
      style: { position: "relative", cursor: "pointer", height: 5 },
      align: "center",
      onClick: a,
      disabled: n,
      children: [
        /* @__PURE__ */ c.jsx(Sxe, { color: e.primary.background.normal }),
        /* @__PURE__ */ c.jsx(Rxe, { spin: n, color: e.primary.text.normal })
      ]
    }
  );
}, Rxe = W(yE)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  @keyframes spin {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  ${({ spin: e }) => e && "animation: spin 0.5s cubic-bezier(.18,.89,.32,1.27);"};
`, kE = Lc(
  (e) => {
    const { chainId: n, chainType: t, connectEco: s } = e, a = Qe(), o = M5({ chainID: n, chainType: t });
    return /* @__PURE__ */ c.jsx(
      wj,
      {
        title: "Connect wallet",
        walletList: o,
        onClickBackButton: () => a.remove(),
        isConnectEco: s
      }
    );
  }
), AE = () => {
  const [e] = Ae(Pe), t = hc()(e == null ? void 0 : e.chainID), { data: s, isLoading: a, refetch: o } = re(I5);
  return {
    data: Q(() => {
      var h, p, _;
      if (!e || !t || !s) return;
      const { chainID: d, denom: m } = e;
      if (!(!m || !d))
        return (_ = (p = (h = s == null ? void 0 : s.chains) == null ? void 0 : h[d]) == null ? void 0 : p.denoms) == null ? void 0 : _[m];
    }, [e, t, s]),
    isLoading: a,
    refetch: o
  };
}, Oxe = 2e6, Mxe = () => {
  var o, i, d, m, h, p, _, y, w, q;
  const [e] = Ae(Pe), [{ data: n }] = Ae(We), t = an({
    assetDenom: e == null ? void 0 : e.denom,
    amount: e == null ? void 0 : e.amount,
    chainId: e == null ? void 0 : e.chainID
  }), s = (i = (o = n == null ? void 0 : n.find((k) => k.chainID === (e == null ? void 0 : e.chainID))) == null ? void 0 : o.feeAssets) == null ? void 0 : i[0];
  switch ((d = t == null ? void 0 : t.chain) == null ? void 0 : d.chainType) {
    case "evm": {
      if (((m = e == null ? void 0 : e.denom) == null ? void 0 : m.includes("-native")) && (e == null ? void 0 : e.originChainID) === (e == null ? void 0 : e.chainID))
        switch (e == null ? void 0 : e.chainID) {
          case "1":
            return Number(fo(0.015, (h = t.asset) == null ? void 0 : h.decimals));
          case "137":
            return Number(fo(0.06, (p = t.asset) == null ? void 0 : p.decimals));
          case "43114":
            return Number(fo(0.02, (_ = t.asset) == null ? void 0 : _.decimals));
          case "42220":
            return Number(fo(0.01, (y = t.asset) == null ? void 0 : y.decimals));
          default:
            return Number(fo(8e-4, (w = t.asset) == null ? void 0 : w.decimals));
        }
      return 0;
    }
    case "cosmos":
      return !((q = s == null ? void 0 : s.gasPrice) != null && q.average) || s.denom !== (e == null ? void 0 : e.denom) ? 0 : Number(s.gasPrice.average) * Oxe;
    case "svm":
    default:
      return 0;
  }
}, P5 = () => {
  const { data: e } = AE(), n = Mxe(), t = e == null ? void 0 : e.amount;
  if (n && t) {
    const s = io(t).minus(n).toString(), a = ho(s, e == null ? void 0 : e.decimals);
    return Number(a) > 0 ? a : "0";
  }
  return t && ho(String(t), e == null ? void 0 : e.decimals);
}, Ixe = () => {
  const e = P5(), n = pe(fm);
  return () => {
    e && n(e);
  };
}, Nxe = () => {
  const e = P5(), [n] = Ae(Pe);
  return n != null && n.amount ? e ? !io(e).isGreaterThanOrEqualTo(io(n == null ? void 0 : n.amount)) : !0 : !1;
}, Pxe = 60, jE = 5, CE = Lc((e) => {
  const n = Qe(), t = re(Pe), { chainImage: s, chainName: a } = an({
    assetDenom: t == null ? void 0 : t.denom,
    chainId: t == null ? void 0 : t.chainID
  });
  return /* @__PURE__ */ c.jsxs(vj, { gap: 15, children: [
    /* @__PURE__ */ c.jsx(
      Nw,
      {
        title: "Wallets",
        onClickBackButton: n.remove,
        rightContent: () => t != null && t.chainID ? /* @__PURE__ */ c.jsx("img", { src: s, height: 36, width: 36, title: a }) : null
      }
    ),
    /* @__PURE__ */ c.jsxs(fj, { height: (Pxe + jE) * 3, children: [
      /* @__PURE__ */ c.jsx(Xm, { chainID: "cosmoshub-4", chainType: "cosmos" }, "cosmos"),
      /* @__PURE__ */ c.jsx(Xm, { chainID: "1", chainType: "evm" }, "evm"),
      /* @__PURE__ */ c.jsx(Xm, { chainID: "solana", chainType: "svm" }, "svm")
    ] })
  ] });
}), Xm = ({
  chainType: e,
  chainID: n
}) => {
  var _;
  const t = je(), s = hc(), a = re(Pe), { chain: o } = an({
    assetDenom: a == null ? void 0 : a.denom,
    chainId: a == null ? void 0 : a.chainID
  }), i = Q(() => {
    const y = e === "cosmos" && (o == null ? void 0 : o.chainType) === "cosmos" || e === "evm" && (o == null ? void 0 : o.chainType) === "evm" || e === "svm" && (o == null ? void 0 : o.chainType) === "svm" ? a == null ? void 0 : a.chainID : n;
    return s(y, !0);
  }, [o == null ? void 0 : o.chainType, n, e, s, a == null ? void 0 : a.chainID]), d = $c(i == null ? void 0 : i.address), h = M5({ chainType: e }).find(
    (y) => y.walletName === (i == null ? void 0 : i.wallet.name)
  ), p = Qe(kE);
  return /* @__PURE__ */ c.jsx(
    zc,
    {
      style: { marginTop: jE },
      onClick: () => {
        p.show({
          chainType: e,
          connectEco: !0
        });
      },
      leftContent: i ? /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 10, children: [
        /* @__PURE__ */ c.jsx(
          "img",
          {
            height: 35,
            width: 35,
            style: { objectFit: "cover" },
            src: i == null ? void 0 : i.wallet.logo,
            alt: `${i == null ? void 0 : i.wallet.prettyName} logo`,
            title: i == null ? void 0 : i.wallet.prettyName
          }
        ),
        /* @__PURE__ */ c.jsxs(Y, { align: "end", gap: 8, children: [
          /* @__PURE__ */ c.jsx(
            l8,
            {
              title: i == null ? void 0 : i.address,
              onClick: (y) => {
                y.stopPropagation(), Fw(i == null ? void 0 : i.address);
              },
              children: d
            }
          ),
          e === "evm" && /* @__PURE__ */ c.jsx(Uxe, { chainId: i == null ? void 0 : i.currentConnectedEVMChainId })
        ] })
      ] }) : /* @__PURE__ */ c.jsxs(l8, { children: [
        "Connect to",
        " ",
        e === "cosmos" ? "Cosmos" : e === "evm" ? "Ethereum" : "Solana"
      ] }),
      rightContent: i ? /* @__PURE__ */ c.jsx(
        Rr,
        {
          onClick: (y) => {
            y.stopPropagation(), h == null || h.disconnect();
          },
          children: "Disconnect"
        }
      ) : /* @__PURE__ */ c.jsx(
        $w,
        {
          color: (_ = t == null ? void 0 : t.primary) == null ? void 0 : _.background.normal,
          backgroundColor: t.primary.text.normal
        }
      )
    }
  );
}, Uxe = ({ chainId: e }) => {
  const n = je(), { data: t } = re(We), s = t == null ? void 0 : t.find((a) => a.chainID === e);
  return /* @__PURE__ */ c.jsx(Te, { fontSize: 12, color: n.primary.text.lowContrast, children: s == null ? void 0 : s.prettyName });
}, Hxe = (e) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ c.jsx(
        "circle",
        {
          cx: "12",
          cy: "12",
          opacity: ".25",
          r: "10",
          stroke: "currentColor",
          strokeWidth: "4"
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
          fill: "currentColor",
          opacity: ".75"
        }
      )
    ]
  }
), Lxe = () => {
  const e = re(Pe), t = hc()(e == null ? void 0 : e.chainID), s = an({
    assetDenom: e == null ? void 0 : e.denom,
    amount: e == null ? void 0 : e.amount,
    chainId: e == null ? void 0 : e.chainID
  }), { data: a, isLoading: o } = AE(), i = Ixe(), d = P5(), m = Qe(CE), h = Q(() => {
    var y;
    if ((y = a == null ? void 0 : a.error) != null && y.message) return "--";
    if (a === void 0) return `0 ${s == null ? void 0 : s.symbol}`;
    const p = a == null ? void 0 : a.amount;
    let _ = a == null ? void 0 : a.formattedAmount;
    return p === "0" && (_ = p), `${Qd(_)} ${s == null ? void 0 : s.symbol}`;
  }, [a, s == null ? void 0 : s.symbol]);
  return t ? /* @__PURE__ */ c.jsxs(
    Y,
    {
      gap: 6,
      style: {
        paddingRight: 13
      },
      children: [
        /* @__PURE__ */ c.jsxs(
          Rr,
          {
            onClick: () => {
              m.show();
            },
            align: "center",
            gap: 8,
            alwaysShowBackground: !0,
            children: [
              t && /* @__PURE__ */ c.jsx(
                "img",
                {
                  style: { objectFit: "cover" },
                  src: t == null ? void 0 : t.wallet.logo,
                  height: 16,
                  width: 16
                }
              ),
              o ? /* @__PURE__ */ c.jsx(
                "div",
                {
                  style: {
                    marginLeft: "8px",
                    marginRight: "8px",
                    position: "relative"
                  },
                  children: /* @__PURE__ */ c.jsx(
                    Hxe,
                    {
                      style: {
                        animation: "spin 1s linear infinite",
                        position: "absolute",
                        height: 14,
                        width: 14
                      }
                    }
                  )
                }
              ) : h
            ]
          }
        ),
        /* @__PURE__ */ c.jsx(
          Rr,
          {
            disabled: !a || (a == null ? void 0 : a.amount) === "0" || d === "0",
            onClick: i,
            align: "center",
            alwaysShowBackground: !0,
            children: "Max"
          }
        )
      ]
    }
  ) : null;
}, Wxe = () => {
  const e = hc(), { data: n } = re(dc), t = pe(fE.debouncedValueAtom), { data: s } = re(We), { chainId: a } = im(), o = Q(() => n == null ? void 0 : n.reduce((i, d) => {
    var y, w;
    const m = (y = e(d.chainID)) == null ? void 0 : y.address, h = s == null ? void 0 : s.find((q) => q.chainID === d.chainID), p = (h == null ? void 0 : h.chainType) === "evm", _ = p && a ? (w = e(String(a))) == null ? void 0 : w.address : void 0;
    return p && _ ? i[d.chainID] || (i[d.chainID] = {
      address: _
    }) : m && (i[d.chainID] || (i[d.chainID] = {
      address: m
    })), i;
  }, {}), [n, e, s, a]);
  Dh({
    queryKey: ["all-balances-request", o],
    queryFn: () => (o && t({
      chains: o || {}
    }), null)
  });
}, Vxe = () => {
  var ue, ve;
  const [e, n] = qe(), [t, s] = qe(!1), { data: a } = re(We), [o, i] = Ae(Pe), d = pe(fm), m = pe(Ow), [h] = Ae(Lce), [p, _] = Ae(la), [y] = Ae(Fo), [{ data: w }] = Ae(dc), q = pe(uo), k = Nxe(), B = pe(Qce), v = pe(sn), { isLoading: g } = re(I5), {
    data: b,
    isError: O,
    error: D
  } = re(Wc), M = Qe(Bxe), N = Qe(Axe), l = Qe(kE), u = Qe(CE), f = pe($o);
  Wxe();
  const S = hc(), x = S(o == null ? void 0 : o.chainID), { chainId: C, connector: F } = im(), A = C ? (ue = S(String(C))) == null ? void 0 : ue.address : void 0, E = Ne(
    (G, ne) => {
      if (!(!G || !ne) && w)
        return w.find((le) => le.denom === G && le.chainID === ne);
    },
    [w]
  ), T = Ne(() => {
    N.show({
      context: "source",
      onSelect: (G) => {
        var le, $e;
        ((le = a == null ? void 0 : a.find((Ce) => Ce.chainID === (G == null ? void 0 : G.chainID))) == null ? void 0 : le.chainType) === "evm" && A && G && G.chainID !== String(C) && F && (($e = F.switchChain) == null || $e.call(F, {
          chainId: Number(G.chainID)
        })), i((Ce) => ({
          ...Ce,
          ...G
        })), d(""), m(""), N.hide();
      }
    });
  }, [a, F, A, C, m, i, d, N]), R = Ne(() => {
    N.show({
      context: "source",
      onSelect: (G) => {
        var le, $e;
        ((le = a == null ? void 0 : a.find((Ce) => Ce.chainID === (G == null ? void 0 : G.chainID))) == null ? void 0 : le.chainType) === "evm" && A && G && G.chainID !== String(C) && F && (($e = F.switchChain) == null || $e.call(F, {
          chainId: Number(G.chainID)
        })), i((Ce) => ({
          ...Ce,
          ...G
        })), N.hide();
      },
      selectedAsset: E(o == null ? void 0 : o.denom, o == null ? void 0 : o.chainID),
      networkSelection: !0
    });
  }, [a, F, A, C, E, i, o == null ? void 0 : o.chainID, o == null ? void 0 : o.denom, N]), P = Ne(() => {
    N.show({
      onSelect: (G) => {
        _((ne) => ({
          ...ne,
          ...G
        })), N.hide();
      }
    });
  }, [_, N]), V = Ne(() => {
    N.show({
      onSelect: (G) => {
        _((ne) => ({
          ...ne,
          ...G
        })), N.hide();
      },
      selectedAsset: E(
        p == null ? void 0 : p.denom,
        p == null ? void 0 : p.chainID
      ),
      networkSelection: !0
    });
  }, [
    p == null ? void 0 : p.chainID,
    p == null ? void 0 : p.denom,
    E,
    _,
    N
  ]), X = Q(() => x != null && x.address ? o != null && o.chainID ? p != null && p.chainID ? !(o != null && o.amount) && !(p != null && p.amount) ? /* @__PURE__ */ c.jsx(
    De,
    {
      label: "Please enter a valid amount",
      icon: ae.swap,
      disabled: !0
    }
  ) : h ? /* @__PURE__ */ c.jsx(De, { label: "Finding best route...", loading: !0 }) : O ? /* @__PURE__ */ c.jsx(De, { label: (D == null ? void 0 : D.message) ?? "No routes found", disabled: !0 }) : g ? /* @__PURE__ */ c.jsx(De, { label: "Fetching balances", loading: !0, icon: ae.swap }) : k ? /* @__PURE__ */ c.jsx(De, { label: "Insufficient balance", disabled: !0, icon: ae.swap }) : /* @__PURE__ */ c.jsx(
    De,
    {
      label: "Swap",
      icon: ae.swap,
      disabled: !b,
      onClick: () => {
        var G;
        if (((G = b == null ? void 0 : b.warning) == null ? void 0 : G.type) === "BAD_PRICE_WARNING") {
          v({
            errorType: Xe.TradeWarning,
            onClickContinue: () => {
              v(void 0), f({}), q(Je.SwapExecutionPage), B();
            },
            onClickBack: () => {
              v(void 0);
            },
            route: { ...b }
          });
          return;
        }
        f({}), q(Je.SwapExecutionPage), B();
      }
    }
  ) : /* @__PURE__ */ c.jsx(
    De,
    {
      label: "Please select a destination asset",
      icon: ae.swap,
      disabled: !0
    }
  ) : /* @__PURE__ */ c.jsx(
    De,
    {
      label: "Please select a source asset",
      icon: ae.swap,
      disabled: !0
    }
  ) : /* @__PURE__ */ c.jsx(
    De,
    {
      label: "Connect Wallet",
      icon: ae.plus,
      onClick: () => {
        o != null && o.chainID ? l.show({
          chainId: o == null ? void 0 : o.chainID
        }) : u.show();
      }
    }
  ), [
    o == null ? void 0 : o.chainID,
    o == null ? void 0 : o.amount,
    p == null ? void 0 : p.chainID,
    p == null ? void 0 : p.amount,
    h,
    x == null ? void 0 : x.address,
    O,
    g,
    k,
    b,
    u,
    l,
    D == null ? void 0 : D.message,
    f,
    q,
    B,
    v
  ]), Z = Q(() => {
    if (!(!(b != null && b.usdAmountIn) || !(b != null && b.usdAmountOut) || h))
      return mj(b.usdAmountIn, b.usdAmountOut);
  }, [h, b == null ? void 0 : b.usdAmountIn, b == null ? void 0 : b.usdAmountOut]);
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsxs(
      be,
      {
        gap: 5,
        style: {
          opacity: t ? 0.3 : 1
        },
        children: [
          /* @__PURE__ */ c.jsx(
            no,
            {
              leftButton: {
                label: "History",
                icon: ae.history,
                onClick: () => q(Je.TransactionHistoryPage)
              },
              rightContent: /* @__PURE__ */ c.jsx(Lxe, {})
            }
          ),
          /* @__PURE__ */ c.jsxs(be, { align: "center", children: [
            /* @__PURE__ */ c.jsx(
              C8,
              {
                selectedAsset: o,
                handleChangeAsset: T,
                handleChangeChain: R,
                isWaitingToUpdateInputValue: y === "swap-out" && h,
                value: o == null ? void 0 : o.amount,
                usdValue: b == null ? void 0 : b.usdAmountIn,
                onChangeValue: d
              }
            ),
            /* @__PURE__ */ c.jsx(Txe, {}),
            /* @__PURE__ */ c.jsx(
              C8,
              {
                selectedAsset: p,
                handleChangeAsset: P,
                handleChangeChain: V,
                isWaitingToUpdateInputValue: y === "swap-in" && h,
                usdValue: b == null ? void 0 : b.usdAmountOut,
                value: p == null ? void 0 : p.amount,
                priceChangePercentage: Z,
                badPriceWarning: ((ve = b == null ? void 0 : b.warning) == null ? void 0 : ve.type) === "BAD_PRICE_WARNING",
                onChangeValue: m
              }
            )
          ] }),
          X,
          /* @__PURE__ */ c.jsx(
            Mw,
            {
              showRouteInfo: !0,
              disabled: O || h,
              showEstimatedTime: !0,
              onClick: () => M.show({
                drawer: !0,
                container: e,
                onOpenChange: (G) => s(!!G)
              })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ c.jsx(
      "div",
      {
        id: "swap-flow-settings-container",
        ref: (G) => {
          G && e === void 0 && n(G);
        }
      }
    )
  ] });
}, Gxe = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M8.29234 0.740229L8.27336 0.721238L5.83563 3.15897C5.31942 3.67517 4.4821 3.67517 3.96589 3.15897L1.52643 0.719513L0.61056 1.63539L0.591572 1.65524L3.0293 4.09297C3.54551 4.60918 3.54551 5.4465 3.0293 5.9627L0.589844 8.40216L1.50572 9.31804L1.52471 9.33616L3.96244 6.89843C4.47865 6.38223 5.31597 6.38223 5.83217 6.89843L8.27163 9.33789L9.1875 8.42201L9.20649 8.40216L6.76877 5.96443C6.25256 5.44823 6.25256 4.6109 6.76877 4.0947L9.20822 1.65524L8.29234 0.739367V0.740229Z",
        fill: e
      }
    )
  }
), Kxe = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        opacity: "0.8",
        d: "M4.7998 9.59766V4.18359C4.7998 4.11182 4.77673 4.05286 4.73059 4.00671C4.68445 3.96057 4.62549 3.9375 4.55371 3.9375H4.06152C3.98975 3.9375 3.93079 3.96057 3.88464 4.00671C3.8385 4.05286 3.81543 4.11182 3.81543 4.18359V9.59766C3.81543 9.66943 3.8385 9.72839 3.88464 9.77454C3.93079 9.82068 3.98975 9.84375 4.06152 9.84375H4.55371C4.62549 9.84375 4.68445 9.82068 4.73059 9.77454C4.77673 9.72839 4.7998 9.66943 4.7998 9.59766ZM6.76855 9.59766V4.18359C6.76855 4.11182 6.74548 4.05286 6.69934 4.00671C6.6532 3.96057 6.59424 3.9375 6.52246 3.9375H6.03027C5.9585 3.9375 5.89954 3.96057 5.85339 4.00671C5.80725 4.05286 5.78418 4.11182 5.78418 4.18359V9.59766C5.78418 9.66943 5.80725 9.72839 5.85339 9.77454C5.89954 9.82068 5.9585 9.84375 6.03027 9.84375H6.52246C6.59424 9.84375 6.6532 9.82068 6.69934 9.77454C6.74548 9.72839 6.76855 9.66943 6.76855 9.59766ZM8.7373 9.59766V4.18359C8.7373 4.11182 8.71423 4.05286 8.66809 4.00671C8.62195 3.96057 8.56299 3.9375 8.49121 3.9375H7.99902C7.92725 3.9375 7.86829 3.96057 7.82214 4.00671C7.776 4.05286 7.75293 4.11182 7.75293 4.18359V9.59766C7.75293 9.66943 7.776 9.72839 7.82214 9.77454C7.86829 9.82068 7.92725 9.84375 7.99902 9.84375H8.49121C8.56299 9.84375 8.62195 9.82068 8.66809 9.77454C8.71423 9.72839 8.7373 9.66943 8.7373 9.59766ZM4.55371 1.96875H7.99902L7.62988 1.06897C7.59399 1.02283 7.55042 0.994629 7.49915 0.984375H5.06128C5.01001 0.994629 4.96643 1.02283 4.93054 1.06897L4.55371 1.96875ZM11.6904 2.21484V2.70703C11.6904 2.77881 11.6674 2.83777 11.6212 2.88391C11.5751 2.93005 11.5161 2.95312 11.4443 2.95312H10.7061V10.2437C10.7061 10.6692 10.5856 11.037 10.3446 11.3472C10.1036 11.6574 9.81397 11.8125 9.47559 11.8125H3.07715C2.73877 11.8125 2.4491 11.6625 2.20813 11.3626C1.96716 11.0627 1.84668 10.7 1.84668 10.2744V2.95312H1.1084C1.03662 2.95312 0.977661 2.93005 0.931518 2.88391C0.885376 2.83777 0.862305 2.77881 0.862305 2.70703V2.21484C0.862305 2.14307 0.885376 2.08411 0.931518 2.03796C0.977661 1.99182 1.03662 1.96875 1.1084 1.96875H3.48474L4.02307 0.684448C4.09998 0.49475 4.2384 0.333253 4.43835 0.199951C4.63831 0.0666497 4.84082 0 5.0459 0H7.50684C7.71192 0 7.91443 0.0666497 8.11438 0.199951C8.31433 0.333253 8.45276 0.49475 8.52966 0.684448L9.06799 1.96875H11.4443C11.5161 1.96875 11.5751 1.99182 11.6212 2.03796C11.6674 2.08411 11.6904 2.14307 11.6904 2.21484Z",
        fill: e
      }
    )
  }
), EE = ({ color: e = "currentColor" }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "10",
    height: "9",
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ c.jsx(
      "path",
      {
        d: "M3.99905 8.941L7.36606 5.574H0.463055V4.196H7.36606L3.99905 0.828999H5.72806L9.78406 4.885L5.72806 8.941H3.99905Z",
        fill: e
      }
    )
  }
), Xxe = {
  unconfirmed: "Unconfirmed",
  signing: "In Progress",
  broadcasted: "In Progress",
  pending: "In Progress",
  completed: "Completed",
  failed: "Failed"
}, Yxe = ({
  status: e,
  sourceChainName: n,
  destinationChainName: t,
  absoluteTimeString: s,
  transactionDetails: a,
  onClickDelete: o
}) => {
  var m, h;
  const i = je(), d = Q(() => {
    if (e === "failed")
      return i.error.text;
    if (e === "completed")
      return i.success.text;
  }, [e, i]);
  return /* @__PURE__ */ c.jsxs(be, { padding: 10, gap: 10, children: [
    /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 10, children: [
      /* @__PURE__ */ c.jsx(zd, { children: "Status" }),
      /* @__PURE__ */ c.jsxs(Y, { gap: 5, align: "center", children: [
        /* @__PURE__ */ c.jsx(J, { normalTextColor: !0, color: d, children: Xxe[e] }),
        /* @__PURE__ */ c.jsxs(J, { children: [
          "at ",
          s
        ] })
      ] })
    ] }),
    /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 10, children: [
      /* @__PURE__ */ c.jsx(zd, { children: "Chain route" }),
      /* @__PURE__ */ c.jsxs(Y, { gap: 5, align: "center", children: [
        /* @__PURE__ */ c.jsx(J, { normalTextColor: !0, children: n }),
        /* @__PURE__ */ c.jsx(EE, { color: i.primary.text.normal }),
        /* @__PURE__ */ c.jsx(J, { normalTextColor: !0, children: t })
      ] })
    ] }),
    a.length === 1 ? /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 10, children: [
      /* @__PURE__ */ c.jsx(zd, { children: "Transaction ID" }),
      /* @__PURE__ */ c.jsxs(em, { href: (m = a == null ? void 0 : a[0]) == null ? void 0 : m.explorerLink, target: "_blank", gap: 5, children: [
        /* @__PURE__ */ c.jsx(J, { normalTextColor: !0, children: $c((h = a == null ? void 0 : a[0]) == null ? void 0 : h.txHash) }),
        /* @__PURE__ */ c.jsx(J, { children: /* @__PURE__ */ c.jsx(Or, {}) })
      ] })
    ] }) : a.map((p, _) => {
      const y = () => _ === 0 ? "Initial transaction" : _ === a.length - 1 ? "Final transaction" : "Transaction";
      return /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 10, children: [
        /* @__PURE__ */ c.jsx(zd, { children: y() }, `${_}-${p.txHash}`),
        /* @__PURE__ */ c.jsxs(em, { href: p.explorerLink, target: "_blank", gap: 5, children: [
          /* @__PURE__ */ c.jsx(J, { normalTextColor: !0, children: $c(p.txHash) }),
          /* @__PURE__ */ c.jsx(J, { children: /* @__PURE__ */ c.jsx(Or, {}) })
        ] }, `${_}-${p.txHash}`)
      ] }, `${_}-${p.txHash}`);
    }),
    /* @__PURE__ */ c.jsx(Y, { align: "center", style: { marginTop: 10 }, children: /* @__PURE__ */ c.jsxs(jn, { onClick: o, gap: 5, align: "center", children: [
      /* @__PURE__ */ c.jsx(J, { color: i.error.text, children: "Delete" }),
      /* @__PURE__ */ c.jsx(Kxe, { color: i.error.text })
    ] }) })
  ] });
}, zd = W(J)`
  width: 100px;
`;
function jh(e) {
  "@babel/helpers - typeof";
  return jh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, jh(e);
}
function U5(e, n) {
  if (n.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + n.length + " present");
}
function vc(e) {
  U5(1, arguments);
  var n = Object.prototype.toString.call(e);
  return e instanceof Date || jh(e) === "object" && n === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || n === "[object Number]" ? new Date(e) : ((typeof e == "string" || n === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
var Jxe = {};
function Zxe() {
  return Jxe;
}
function E8(e) {
  var n = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return n.setUTCFullYear(e.getFullYear()), e.getTime() - n.getTime();
}
function Qxe(e, n) {
  U5(2, arguments);
  var t = vc(e), s = vc(n), a = t.getTime() - s.getTime();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
var eke = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, nke = function(n, t, s) {
  var a, o = eke[n];
  return typeof o == "string" ? a = o : t === 1 ? a = o.one : a = o.other.replace("{{count}}", t.toString()), s != null && s.addSuffix ? s.comparison && s.comparison > 0 ? "in " + a : a + " ago" : a;
};
function Ym(e) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = n.width ? String(n.width) : e.defaultWidth, s = e.formats[t] || e.formats[e.defaultWidth];
    return s;
  };
}
var tke = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ske = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ake = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, oke = {
  date: Ym({
    formats: tke,
    defaultWidth: "full"
  }),
  time: Ym({
    formats: ske,
    defaultWidth: "full"
  }),
  dateTime: Ym({
    formats: ake,
    defaultWidth: "full"
  })
}, rke = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ike = function(n, t, s, a) {
  return rke[n];
};
function sd(e) {
  return function(n, t) {
    var s = t != null && t.context ? String(t.context) : "standalone", a;
    if (s === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : o;
      a = e.formattingValues[i] || e.formattingValues[o];
    } else {
      var d = e.defaultWidth, m = t != null && t.width ? String(t.width) : e.defaultWidth;
      a = e.values[m] || e.values[d];
    }
    var h = e.argumentCallback ? e.argumentCallback(n) : n;
    return a[h];
  };
}
var cke = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, dke = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, mke = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, hke = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, pke = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, lke = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, gke = function(n, t) {
  var s = Number(n), a = s % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return s + "st";
      case 2:
        return s + "nd";
      case 3:
        return s + "rd";
    }
  return s + "th";
}, uke = {
  ordinalNumber: gke,
  era: sd({
    values: cke,
    defaultWidth: "wide"
  }),
  quarter: sd({
    values: dke,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: sd({
    values: mke,
    defaultWidth: "wide"
  }),
  day: sd({
    values: hke,
    defaultWidth: "wide"
  }),
  dayPeriod: sd({
    values: pke,
    defaultWidth: "wide",
    formattingValues: lke,
    defaultFormattingWidth: "wide"
  })
};
function ad(e) {
  return function(n) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = t.width, a = s && e.matchPatterns[s] || e.matchPatterns[e.defaultMatchWidth], o = n.match(a);
    if (!o)
      return null;
    var i = o[0], d = s && e.parsePatterns[s] || e.parsePatterns[e.defaultParseWidth], m = Array.isArray(d) ? yke(d, function(_) {
      return _.test(i);
    }) : _ke(d, function(_) {
      return _.test(i);
    }), h;
    h = e.valueCallback ? e.valueCallback(m) : m, h = t.valueCallback ? t.valueCallback(h) : h;
    var p = n.slice(i.length);
    return {
      value: h,
      rest: p
    };
  };
}
function _ke(e, n) {
  for (var t in e)
    if (e.hasOwnProperty(t) && n(e[t]))
      return t;
}
function yke(e, n) {
  for (var t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function bke(e) {
  return function(n) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = n.match(e.matchPattern);
    if (!s) return null;
    var a = s[0], o = n.match(e.parsePattern);
    if (!o) return null;
    var i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    var d = n.slice(a.length);
    return {
      value: i,
      rest: d
    };
  };
}
var vke = /^(\d+)(th|st|nd|rd)?/i, fke = /\d+/i, wke = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, xke = {
  any: [/^b/i, /^(a|c)/i]
}, kke = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ake = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jke = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Cke = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Eke = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Dke = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Bke = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Fke = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, $ke = {
  ordinalNumber: bke({
    matchPattern: vke,
    parsePattern: fke,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: ad({
    matchPatterns: wke,
    defaultMatchWidth: "wide",
    parsePatterns: xke,
    defaultParseWidth: "any"
  }),
  quarter: ad({
    matchPatterns: kke,
    defaultMatchWidth: "wide",
    parsePatterns: Ake,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: ad({
    matchPatterns: jke,
    defaultMatchWidth: "wide",
    parsePatterns: Cke,
    defaultParseWidth: "any"
  }),
  day: ad({
    matchPatterns: Eke,
    defaultMatchWidth: "wide",
    parsePatterns: Dke,
    defaultParseWidth: "any"
  }),
  dayPeriod: ad({
    matchPatterns: Bke,
    defaultMatchWidth: "any",
    parsePatterns: Fke,
    defaultParseWidth: "any"
  })
}, zke = {
  code: "en-US",
  formatDistance: nke,
  formatLong: oke,
  formatRelative: ike,
  localize: uke,
  match: $ke,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function DE(e, n) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var t in n)
    Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
  return e;
}
function qke(e) {
  return DE({}, e);
}
var D8 = 1e3 * 60, om = 60 * 24, B8 = om * 30, F8 = om * 365;
function Ske(e, n, t) {
  var s, a, o;
  U5(2, arguments);
  var i = Zxe(), d = (s = (a = t == null ? void 0 : t.locale) !== null && a !== void 0 ? a : i.locale) !== null && s !== void 0 ? s : zke;
  if (!d.formatDistance)
    throw new RangeError("locale must contain localize.formatDistance property");
  var m = Qxe(e, n);
  if (isNaN(m))
    throw new RangeError("Invalid time value");
  var h = DE(qke(t), {
    addSuffix: !!(t != null && t.addSuffix),
    comparison: m
  }), p, _;
  m > 0 ? (p = vc(n), _ = vc(e)) : (p = vc(e), _ = vc(n));
  var y = String((o = t == null ? void 0 : t.roundingMethod) !== null && o !== void 0 ? o : "round"), w;
  if (y === "floor")
    w = Math.floor;
  else if (y === "ceil")
    w = Math.ceil;
  else if (y === "round")
    w = Math.round;
  else
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
  var q = _.getTime() - p.getTime(), k = q / D8, B = E8(_) - E8(p), v = (q - B) / D8, g = t == null ? void 0 : t.unit, b;
  if (g ? b = String(g) : k < 1 ? b = "second" : k < 60 ? b = "minute" : k < om ? b = "hour" : v < B8 ? b = "day" : v < F8 ? b = "month" : b = "year", b === "second") {
    var O = w(q / 1e3);
    return d.formatDistance("xSeconds", O, h);
  } else if (b === "minute") {
    var D = w(k);
    return d.formatDistance("xMinutes", D, h);
  } else if (b === "hour") {
    var M = w(k / 60);
    return d.formatDistance("xHours", M, h);
  } else if (b === "day") {
    var N = w(v / om);
    return d.formatDistance("xDays", N, h);
  } else if (b === "month") {
    var l = w(v / B8);
    return l === 12 && g !== "month" ? d.formatDistance("xYears", 1, h) : d.formatDistance("xMonths", l, h);
  } else if (b === "year") {
    var u = w(v / F8);
    return d.formatDistance("xYears", u, h);
  }
  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}
const Tke = ({
  index: e,
  txHistoryItem: n,
  showDetails: t,
  onClickRow: s
}) => {
  const a = je(), { data: o } = bE({
    txsRequired: n == null ? void 0 : n.route.txsRequired,
    txs: n.transactionDetails.map((N) => ({
      chainID: N.chainID,
      txHash: N.txHash
    }))
  });
  vE({
    statusData: o,
    historyIndex: e
  });
  const i = pe(Jce), {
    route: {
      amountIn: d,
      amountOut: m,
      sourceAssetDenom: h,
      sourceAssetChainID: p,
      destAssetDenom: _,
      destAssetChainID: y
    },
    timestamp: w,
    status: q,
    transactionDetails: k
  } = n, B = an({
    assetDenom: h,
    chainId: p,
    tokenAmount: d
  }), v = an({
    assetDenom: _,
    chainId: y,
    tokenAmount: m
  }), g = {
    amount: B.amount,
    asset: B.asset,
    assetImage: B.assetImage ?? ""
  }, b = {
    amount: v.amount,
    asset: v.asset,
    assetImage: v.assetImage ?? ""
  }, O = Q(() => {
    switch (q) {
      case "unconfirmed":
      case "pending":
        return /* @__PURE__ */ c.jsx(
          wm,
          {
            width: 10,
            height: 10,
            backgroundColor: a.primary.text.normal,
            status: "pending"
          }
        );
      case "completed":
        return /* @__PURE__ */ c.jsx(Mke, {});
      case "failed":
        return /* @__PURE__ */ c.jsx(Gxe, { color: a.error.text });
    }
  }, [q, a.error.text, a.primary.text.normal]), D = Q(() => new Date(w).toLocaleString(), [w]), M = Q(() => q === "pending" ? "In Progress" : Ske(new Date(w), /* @__PURE__ */ new Date(), { addSuffix: !0 }), [q, w]);
  return /* @__PURE__ */ c.jsxs(Rke, { showDetails: t, children: [
    /* @__PURE__ */ c.jsxs(
      Oke,
      {
        align: "center",
        justify: "space-between",
        onClick: s,
        children: [
          /* @__PURE__ */ c.jsxs(Y, { gap: 5, align: "center", children: [
            /* @__PURE__ */ c.jsx($8, { ...g }),
            /* @__PURE__ */ c.jsx(EE, { color: a.primary.text.lowContrast }),
            /* @__PURE__ */ c.jsx($8, { ...b }),
            /* @__PURE__ */ c.jsxs(Nke, { normalTextColor: !0, title: v.chainName, children: [
              "on ",
              v.chainName
            ] })
          ] }),
          /* @__PURE__ */ c.jsxs(Y, { align: "center", gap: 10, children: [
            /* @__PURE__ */ c.jsx(J, { children: M }),
            O
          ] })
        ]
      }
    ),
    t && /* @__PURE__ */ c.jsx(
      Yxe,
      {
        status: q,
        sourceChainName: B.chainName ?? "--",
        destinationChainName: v.chainName ?? "--",
        absoluteTimeString: D,
        transactionDetails: k,
        onClickDelete: () => i(e)
      }
    )
  ] });
}, Rke = W(be)`
  background-color: ${({ theme: e, showDetails: n }) => n && e.secondary.background.normal};
  &:hover {
    background-color: ${({ theme: e }) => e.secondary.background.normal};
  }
  border-radius: 6px;
`, Oke = W(Y)`
  padding: 0 10px;
  height: 40px;
  &:hover {
    cursor: pointer;
  }
`, Mke = W.div`
  width: 10px;
  height: 10px;
  background-color: ${({ theme: e }) => e.success.text};
  border-radius: 50%;
`, $8 = ({
  amount: e,
  asset: n,
  assetImage: t
}) => /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
  /* @__PURE__ */ c.jsx("img", { height: 20, width: 20, src: t }),
  /* @__PURE__ */ c.jsx(Ike, { normalTextColor: !0, title: e, children: e }),
  /* @__PURE__ */ c.jsx(J, { normalTextColor: !0, children: (n == null ? void 0 : n.recommendedSymbol) ?? (n == null ? void 0 : n.symbol) })
] }), Ike = W(J)`
  max-width: 40px;
  text-overflow: ellipsis;
  overflow: hidden;
`, Nke = W(J)`
  max-width: 95px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, Pke = () => {
  var i;
  const e = je(), n = pe(uo), [t, s] = qe(), a = re(Mr), o = Q(() => a.sort((d, m) => m.timestamp - d.timestamp), [a]);
  return /* @__PURE__ */ c.jsxs(be, { gap: 5, children: [
    /* @__PURE__ */ c.jsx(
      no,
      {
        leftButton: {
          label: "Back",
          icon: ae.thinArrow,
          onClick: () => n(Je.SwapPage)
        }
      }
    ),
    /* @__PURE__ */ c.jsx(Hke, { gap: 5, justify: "center", children: a.length === 0 ? /* @__PURE__ */ c.jsxs(
      Uke,
      {
        align: "center",
        justify: "center",
        gap: 15,
        children: [
          /* @__PURE__ */ c.jsx(
            rj,
            {
              width: 30,
              height: 30,
              color: (i = e == null ? void 0 : e.primary) == null ? void 0 : i.text.lowContrast
            }
          ),
          /* @__PURE__ */ c.jsx(J, { children: "No transactions yet" })
        ]
      }
    ) : /* @__PURE__ */ c.jsx(
      Iw,
      {
        listItems: o,
        height: 262,
        itemHeight: 1,
        renderItem: (d, m) => /* @__PURE__ */ c.jsx(
          Tke,
          {
            index: m,
            txHistoryItem: d,
            showDetails: m === t,
            onClickRow: () => {
              s(m !== t ? m : void 0);
            }
          }
        ),
        itemKey: (d) => d.transactionDetails[0].txHash
      },
      a.length
    ) }),
    /* @__PURE__ */ c.jsx(Mw, {})
  ] });
}, Uke = W(be)`
  height: 100%;
  width: 100%;
`, Hke = W(be)`
  position: relative;
  padding: 20px;
  width: 480px;
  min-height: 302px;
  border-radius: 25px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
`, Lke = () => {
  const [e] = Ae(uo), [n, t] = Ae(sn);
  if (n)
    return /* @__PURE__ */ c.jsx(Nce, {});
  switch (e) {
    case Je.SwapPage:
      return /* @__PURE__ */ c.jsx(
        qd,
        {
          fallback: null,
          onError: (s) => t({ errorType: Xe.Unexpected, error: s }),
          children: /* @__PURE__ */ c.jsx(Vxe, {})
        }
      );
    case Je.SwapExecutionPage:
      return /* @__PURE__ */ c.jsx(
        qd,
        {
          fallback: null,
          onError: (s) => t({ errorType: Xe.Unexpected, error: s }),
          children: /* @__PURE__ */ c.jsx(axe, {})
        }
      );
    case Je.TransactionHistoryPage:
      return /* @__PURE__ */ c.jsx(
        qd,
        {
          fallback: null,
          onError: (s) => t({ errorType: Xe.Unexpected, error: s }),
          children: /* @__PURE__ */ c.jsx(Pke, {})
        }
      );
  }
}, x3e = (e) => /* @__PURE__ */ c.jsx(T8.Provider, { children: /* @__PURE__ */ c.jsx(BE, { ...e }) }), BE = ({ theme: e, ...n }) => {
  const [t, s] = Ae(nj), a = pe(tj);
  return on(() => {
    s({
      ...t,
      ...n
    }), a({ ...Nh, ...e });
  }, [t, s, a, n, e]), /* @__PURE__ */ c.jsx(GA, { theme: e, children: /* @__PURE__ */ c.jsx(Wke, { children: /* @__PURE__ */ c.jsx(Lke, {}) }) });
}, k3e = ({
  button: e = /* @__PURE__ */ c.jsx("button", { children: "show widget" }),
  ...n
}) => {
  const t = Qe(
    Lc(() => /* @__PURE__ */ c.jsx(BE, { ...n }))
  ), s = Xie(ZA), o = eD(e, { onClick: () => {
    s(), t.show({
      stackedModal: !1
    });
  } });
  return /* @__PURE__ */ c.jsx(c.Fragment, { children: o });
}, Wke = W.div`
  width: 480px;
  position: relative;
`;
export {
  jA as H,
  k3e as S,
  x3e as W,
  vm as b,
  f3e as c,
  Nh as d,
  Kd as e,
  v3e as h,
  b3e as l,
  w3e as r,
  Koe as s,
  lw as t
};
//# sourceMappingURL=index-ftNvwl_h.js.map
